    (async function(){
      var REPORT_PROXY_URL = 'https://cxnxfkaxlgisnxudpjgn.supabase.co/functions/v1/boulevard-booking-proxy';
      var RETAIL_PROXY_URL = 'https://cxnxfkaxlgisnxudpjgn.supabase.co/functions/v1/boulevard-hair-story-checkin';
      var MODEL_INTAKE_LIST_ENDPOINT = 'https://ggaqblzhmxiyjnabijmz.supabase.co/functions/v1/list-intakes';
      var MODEL_INTAKE_GET_ENDPOINT = 'https://ggaqblzhmxiyjnabijmz.supabase.co/functions/v1/get-intake';
      var MODEL_INTAKE_SECRET = 'hair-intake-9f2c8b7e4a';
      var MODEL_INTAKE_VIEW_PAGE_BASE = '/pages/intake-view?id=';
      var STAFF_OPERATIONS_PIN = '2600';
      var STAFF_OPERATIONS_PIN_STORAGE_KEY = 'hairstoriesManagerPortalUnlockedV1';
      var HAIRSTORIES_SHARED_ACCESS_SESSION_STORAGE_KEY = 'hairstoriesSharedAccessSessionV1';
      var LEGACY_SHARED_UNLOCKED_STORAGE_KEY = 'staffOperationsPinUnlocked';
      var STAFF_OPERATIONS_LAST_TAB_STORAGE_KEY = 'hairstoriesStaffOpsLastTabV1';
      var STAFF_OPERATIONS_REQUEST_QUEUE_FILTER_STORAGE_KEY = 'hairstoriesStaffOpsRequestQueueFilterV1';
      var STAFF_OPERATIONS_OPEN_SHIFT_FILTER_STORAGE_KEY = 'hairstoriesStaffOpsOpenShiftFilterV1';
      var STAFF_OPERATIONS_IDLE_TIMEOUT_MS = 15 * 60 * 1000;
      var REQUEST_OFF_NOTIFY_PHONES = ['+16314875700', '+16318347937'];
      var KPI_REPORT_ID = 'urn:blvd:Report:6f402905-5d1b-41e1-b5a0-b90ed0ca3311';
      var GLOBAL_KPI_REPORT_ID = 'urn:blvd:Report:1fece73f-bfe2-4767-a22f-e8090c857710';
      var STAFF_GROWTH_REPORT_ID = 'urn:blvd:Report:f0b7a373-59f0-4c7d-95f1-9b6f0595b630';
      var RETAIL_QUARTER_DATA_START = '2021-01-01';
      var STAFF_GROWTH_YEARS = Array.from({ length: startOfLocalDay(new Date()).getFullYear() - 2016 + 1 }, function(_value, index){
        return 2016 + index;
      });
      var LEVEL7_COMPARISON_PERIOD_OPTIONS = [
        { key: 'all', label: 'All Years', summaryLabel: 'All years + 2026 YTD', description: 'Combined annual KPI totals from 2021 through 2025 plus current 2026 year-to-date actuals.' },
        { key: '2021', label: '2021', summaryLabel: '2021', description: 'Full calendar-year KPI view for staff included in the Staff Level KPI board.' },
        { key: '2022', label: '2022', summaryLabel: '2022', description: 'Full calendar-year KPI view for staff included in the Staff Level KPI board.' },
        { key: '2023', label: '2023', summaryLabel: '2023', description: 'Full calendar-year KPI view for staff included in the Staff Level KPI board.' },
        { key: '2024', label: '2024', summaryLabel: '2024', description: 'Full calendar-year KPI view for staff included in the Staff Level KPI board.' },
        { key: '2025', label: '2025', summaryLabel: '2025', description: 'Full calendar-year KPI view for staff included in the Staff Level KPI board.' },
        { key: '2026_ytd', label: '2026 YTD', summaryLabel: '2026 YTD', description: 'KPI metrics are current year-to-date actuals. Attendance facts and reliability use the trailing 365-day window.' }
      ];
      var LEVEL7_COMPARISON_FALLBACK_NAMES = [
        'Andrea Albaneze',
        'Cali Sampollo',
        'Cher Guthenberg',
        'Daniella Sipala',
        'Dayna Ognibene',
        'Gina Brady',
        'Jamie Damm',
        'Kristen Cappa',
        'Mary Moran',
        'Samantha Sabatella',
        'Thomas Suhrland',
        'Trevor Palmieri'
      ];
      var LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR = {
        '2021': {},
        '2022': {
          'Cali Sampollo': { reliability_score: 97, requests_off: 0, call_outs: 2, late_arrivals: 0 },
          'Trevor Palmieri': { reliability_score: 97, requests_off: 0, call_outs: 2, late_arrivals: 0 },
          'Jamie Damm': { reliability_score: 96, requests_off: 0, call_outs: 3, late_arrivals: 0 },
          'Daniella Sipala': { reliability_score: 93, requests_off: 0, call_outs: 5, late_arrivals: 0 },
          'Dayna Ognibene': { reliability_score: 93, requests_off: 0, call_outs: 5, late_arrivals: 0 },
          'Kristen Cappa': { reliability_score: 88, requests_off: 0, call_outs: 9, late_arrivals: 0 }
        },
        '2023': {
          'Thomas Suhrland': { reliability_score: 99, requests_off: 5, call_outs: 0, late_arrivals: 0 },
          'Andrea Albaneze': { reliability_score: 99, requests_off: 2, call_outs: 0, late_arrivals: 1 },
          'Dayna Ognibene': { reliability_score: 98, requests_off: 7, call_outs: 0, late_arrivals: 0 },
          'Samantha Sabatella': { reliability_score: 98, requests_off: 4, call_outs: 0, late_arrivals: 1 },
          'Trevor Palmieri': { reliability_score: 95, requests_off: 7, call_outs: 2, late_arrivals: 0 },
          'Jamie Damm': { reliability_score: 94, requests_off: 11, call_outs: 2, late_arrivals: 0 },
          'Mary Moran': { reliability_score: 94, requests_off: 6, call_outs: 3, late_arrivals: 0 },
          'Cher Guthenberg': { reliability_score: 94, requests_off: 8, call_outs: 3, late_arrivals: 0 },
          'Cali Sampollo': { reliability_score: 89, requests_off: 20, call_outs: 4, late_arrivals: 0 },
          'Daniella Sipala': { reliability_score: 89, requests_off: 3, call_outs: 7, late_arrivals: 1 },
          'Kristen Cappa': { reliability_score: 85, requests_off: 11, call_outs: 9, late_arrivals: 0 }
        },
        '2024': {
          'Dayna Ognibene': { reliability_score: 98, requests_off: 4, call_outs: 0, late_arrivals: 1 },
          'Mary Moran': { reliability_score: 98, requests_off: 3, call_outs: 0, late_arrivals: 2 },
          'Andrea Albaneze': { reliability_score: 98, requests_off: 0, call_outs: 1, late_arrivals: 1 },
          'Cher Guthenberg': { reliability_score: 96, requests_off: 10, call_outs: 1, late_arrivals: 0 },
          'Thomas Suhrland': { reliability_score: 95, requests_off: 10, call_outs: 1, late_arrivals: 1 },
          'Cali Sampollo': { reliability_score: 95, requests_off: 3, call_outs: 2, late_arrivals: 2 },
          'Samantha Sabatella': { reliability_score: 94, requests_off: 13, call_outs: 2, late_arrivals: 0 },
          'Jamie Damm': { reliability_score: 94, requests_off: 8, call_outs: 2, late_arrivals: 2 },
          'Trevor Palmieri': { reliability_score: 92, requests_off: 18, call_outs: 2, late_arrivals: 1 },
          'Daniella Sipala': { reliability_score: 92, requests_off: 7, call_outs: 4, late_arrivals: 1 },
          'Kristen Cappa': { reliability_score: 88, requests_off: 5, call_outs: 7, late_arrivals: 2 }
        },
        '2025': {
          'Mary Moran': { reliability_score: 98, requests_off: 4, call_outs: 0, late_arrivals: 2 },
          'Andrea Albaneze': { reliability_score: 98, requests_off: 0, call_outs: 1, late_arrivals: 1 },
          'Thomas Suhrland': { reliability_score: 97, requests_off: 12, call_outs: 0, late_arrivals: 0 },
          'Cher Guthenberg': { reliability_score: 96, requests_off: 15, call_outs: 0, late_arrivals: 0 },
          'Dayna Ognibene': { reliability_score: 95, requests_off: 2, call_outs: 3, late_arrivals: 0 },
          'Samantha Sabatella': { reliability_score: 94, requests_off: 5, call_outs: 1, late_arrivals: 6 },
          'Daniella Sipala': { reliability_score: 92, requests_off: 2, call_outs: 4, late_arrivals: 4 },
          'Trevor Palmieri': { reliability_score: 91, requests_off: 14, call_outs: 2, late_arrivals: 4 },
          'Jamie Damm': { reliability_score: 91, requests_off: 12, call_outs: 4, late_arrivals: 0 },
          'Cali Sampollo': { reliability_score: 89, requests_off: 11, call_outs: 4, late_arrivals: 4 },
          'Kristen Cappa': { reliability_score: 87, requests_off: 16, call_outs: 6, late_arrivals: 1 }
        }
      };
      var longStoryShadeMap = loadLongStoryShadeMap();
      var longStoryShadeByHandle = indexLongStoryShadesByHandle(longStoryShadeMap);
      var longStoryShadeByDisplayName = indexLongStoryShadesByDisplayName(longStoryShadeMap);
      var pinGate = document.getElementById('pinGate');
      var pinCard = pinGate ? pinGate.querySelector('.pin-card') : null;
      var appPage = document.getElementById('appPage');
      var pinInput = document.getElementById('pinInput');
      var pinSubmitBtn = document.getElementById('pinSubmitBtn');
      var pinStatus = document.getElementById('pinStatus');
      var sessionSwitchLink = document.getElementById('sessionSwitchLink');
      var logoutBtn = document.getElementById('logoutBtn');
      var tabButtons = Array.prototype.slice.call(document.querySelectorAll('[data-tab-target]'));
      var tabPanels = Array.prototype.slice.call(document.querySelectorAll('[data-tab-panel]'));
      var dateFrom = document.getElementById('dateFrom');
      var dateTo = document.getElementById('dateTo');
      var quickRangeButtons = Array.prototype.slice.call(document.querySelectorAll('[data-range]'));
      var copyDebugBtn = document.getElementById('copyDebugBtn');
      var requestOffStaff = document.getElementById('requestOffStaff');
      var requestOffDate = document.getElementById('requestOffDate');
      var requestOffScope = document.getElementById('requestOffScope');
      var requestOffPhoneLast4 = document.getElementById('requestOffPhoneLast4');
      var requestOffNote = document.getElementById('requestOffNote');
      var requestOffMeta = document.getElementById('requestOffMeta');
      var requestOffStatus = document.getElementById('requestOffStatus');
      var requestOffSubmitBtn = document.getElementById('requestOffSubmitBtn');
      var manualOpenShiftDate = document.getElementById('manualOpenShiftDate');
      var manualOpenShiftShift = document.getElementById('manualOpenShiftShift');

      function loadLongStoryShadeMap(){
        var node = document.getElementById('longStoryShadeMap');
        if (!node) return [];
        try {
          var parsed = JSON.parse(node.textContent || '[]');
          return Array.isArray(parsed) ? parsed : [];
        } catch (_error) {
          return [];
        }
      }

      function indexLongStoryShadesByHandle(shades){
        return (Array.isArray(shades) ? shades : []).reduce(function(map, shade){
          var key = normalizeInventoryText(shade && shade.handle);
          if (key) map[key] = shade;
          return map;
        }, {});
      }

      function indexLongStoryShadesByDisplayName(shades){
        return (Array.isArray(shades) ? shades : []).reduce(function(map, shade){
          var label = String(shade && shade.label || '').trim();
          var category = String(shade && shade.category || '').trim();
          var key = normalizeInventoryText([label, category].filter(Boolean).join(' '));
          if (key) map[key] = shade;
          return map;
        }, {});
      }
      var manualOpenShiftCustomWrap = document.getElementById('manualOpenShiftCustomWrap');
      var manualOpenShiftCustom = document.getElementById('manualOpenShiftCustom');
      var manualOpenShiftType = document.getElementById('manualOpenShiftType');
      var manualOpenShiftRoleChecklist = document.getElementById('manualOpenShiftRoleChecklist');
      var manualOpenShiftNote = document.getElementById('manualOpenShiftNote');
      var manualOpenShiftSubmitBtn = document.getElementById('manualOpenShiftSubmitBtn');
      var requestReviewStatus = document.getElementById('requestReviewStatus');
      var requestReviewList = document.getElementById('requestReviewList');
      var requestQueueTabs = document.getElementById('requestQueueTabs');
      var requestQueueSearch = document.getElementById('requestQueueSearch');
      var requestQueueCountAll = document.getElementById('requestQueueCountAll');
      var requestQueueCountPending = document.getElementById('requestQueueCountPending');
      var requestQueueCountApproved = document.getElementById('requestQueueCountApproved');
      var requestQueueCountDenied = document.getElementById('requestQueueCountDenied');
      var requestsTabCount = document.getElementById('requestsTabCount');
      var openShiftsManagerTabCount = document.getElementById('openShiftsManagerTabCount');
      var dueQueueManagerTabCount = document.getElementById('dueQueueManagerTabCount');
      var openShiftViewTabs = document.getElementById('openShiftViewTabs');
      var openShiftViewCountAvailable = document.getElementById('openShiftViewCountAvailable');
      var openShiftViewCountPending = document.getElementById('openShiftViewCountPending');
      var openShiftViewCountPickedUp = document.getElementById('openShiftViewCountPickedUp');
      var openShiftStatus = document.getElementById('openShiftStatus');
      var openShiftResultsList = document.getElementById('openShiftResultsList');
      var pickupQueueStatus = document.getElementById('pickupQueueStatus');
      var retailWeekTabs = document.getElementById('retailWeekTabs');
      var colorDisciplineWeekTabs = document.getElementById('colorDisciplineWeekTabs');
      var retailOpportunityFilter = document.getElementById('retailOpportunityFilter');
      var retailQueueStatusFilter = document.getElementById('retailQueueStatusFilter');
      var retailFollowupReadyOnly = document.getElementById('retailFollowupReadyOnly');
      var retailStatus = document.getElementById('retailStatus');
      var retailSalesLeaderboardMount = document.getElementById('retailSalesLeaderboardMount');
      var retailOpportunityList = document.getElementById('retailOpportunityList');
      var retailQueuedList = document.getElementById('retailQueuedList');
      var postAppointmentSmsTabCount = document.getElementById('postAppointmentSmsTabCount');
      var postAppointmentSmsSettingsFamily = document.getElementById('postAppointmentSmsSettingsFamily');
      var postAppointmentSmsQueueEnabled = document.getElementById('postAppointmentSmsQueueEnabled');
      var postAppointmentSmsDelayMinutes = document.getElementById('postAppointmentSmsDelayMinutes');
      var postAppointmentSmsSuppressFutureBooking = document.getElementById('postAppointmentSmsSuppressFutureBooking');
      var postAppointmentSmsDailyCap = document.getElementById('postAppointmentSmsDailyCap');
      var postAppointmentSmsDuplicateGuardHours = document.getElementById('postAppointmentSmsDuplicateGuardHours');
      var postAppointmentSmsQuietHoursEnabled = document.getElementById('postAppointmentSmsQuietHoursEnabled');
      var postAppointmentSmsQuietStart = document.getElementById('postAppointmentSmsQuietStart');
      var postAppointmentSmsQuietEnd = document.getElementById('postAppointmentSmsQuietEnd');
      var postAppointmentSmsSaveSettingsBtn = document.getElementById('postAppointmentSmsSaveSettingsBtn');
      var postAppointmentSmsFamilyFilter = document.getElementById('postAppointmentSmsFamilyFilter');
      var postAppointmentSmsStatusFilter = document.getElementById('postAppointmentSmsStatusFilter');
      var postAppointmentSmsSearch = document.getElementById('postAppointmentSmsSearch');
      var postAppointmentSmsRefreshBtn = document.getElementById('postAppointmentSmsRefreshBtn');
      var postAppointmentSmsProcessBtn = document.getElementById('postAppointmentSmsProcessBtn');
      var postAppointmentSmsStatus = document.getElementById('postAppointmentSmsStatus');
      var postAppointmentSmsList = document.getElementById('postAppointmentSmsList');
      var modelsTabCount = document.getElementById('modelsTabCount');
      var modelsSummaryMount = document.getElementById('modelsSummaryMount');
      var modelsSearch = document.getElementById('modelsSearch');
      var modelsPhotoFilter = document.getElementById('modelsPhotoFilter');
      var modelsSort = document.getElementById('modelsSort');
      var modelsQuickFilters = document.getElementById('modelsQuickFilters');
      var modelsHideDuplicates = document.getElementById('modelsHideDuplicates');
      var modelsRefreshBtn = document.getElementById('modelsRefreshBtn');
      var modelsStatus = document.getElementById('modelsStatus');
      var modelsList = document.getElementById('modelsList');
      var modelsDetailTitle = document.getElementById('modelsDetailTitle');
      var modelsDetailMeta = document.getElementById('modelsDetailMeta');
      var modelsDetailActions = document.getElementById('modelsDetailActions');
      var modelsDetailTextLink = document.getElementById('modelsDetailTextLink');
      var modelsDetailDeleteBtn = document.getElementById('modelsDetailDeleteBtn');
      var modelsDetailStatusCard = document.getElementById('modelsDetailStatusCard');
      var modelsDetailHistoryCard = document.getElementById('modelsDetailHistoryCard');
      var modelsDetailPreferenceTags = document.getElementById('modelsDetailPreferenceTags');
      var modelsDetailPhotoTags = document.getElementById('modelsDetailPhotoTags');
      var modelsDetailNotes = document.getElementById('modelsDetailNotes');
      var modelsDetailInspo = document.getElementById('modelsDetailInspo');
      var modelsDetailCurrent = document.getElementById('modelsDetailCurrent');
      var dueStaffFilter = document.getElementById('dueStaffFilter');
      var dueSearchFilter = document.getElementById('dueSearchFilter');
      var dueCategoryFilter = document.getElementById('dueCategoryFilter');
      var dueCadenceSourceFilter = document.getElementById('dueCadenceSourceFilter');
      var dueSortSelect = document.getElementById('dueSortSelect');
      var dueDuplicatesOnly = document.getElementById('dueDuplicatesOnly');
      var dueHasPhoneOnly = document.getElementById('dueHasPhoneOnly');
      var dueHasEmailOnly = document.getElementById('dueHasEmailOnly');
      var dueStageTabs = document.getElementById('dueStageTabs');
      var dueWorkspaceTabs = document.getElementById('dueWorkspaceTabs');
      var dueWorkspaceRetailCount = document.getElementById('dueWorkspaceRetailCount');
      var dueWorkspaceReferralCount = document.getElementById('dueWorkspaceReferralCount');
      var dueWorkspaceReviewCount = document.getElementById('dueWorkspaceReviewCount');
      var dueWorkspaceOverlapNote = document.getElementById('dueWorkspaceOverlapNote');
      var dueSubTabs = document.getElementById('dueSubTabs');
      var dueOpportunityTabs = document.getElementById('dueOpportunityTabs');
      var dueWorkflowTabs = document.getElementById('dueWorkflowTabs');
      var dueOwnerTabs = document.getElementById('dueOwnerTabs');
      var dueScorecardRangeTabs = document.getElementById('dueScorecardRangeTabs');
      var dueScorecardAudienceTabs = document.getElementById('dueScorecardAudienceTabs');
      var dueSortTabs = document.getElementById('dueSortTabs');
      var dueQueueTabs = document.getElementById('dueQueueTabs');
      var dueClientTypeTabs = document.getElementById('dueClientTypeTabs');
      var dueCriteriaNote = document.getElementById('dueCriteriaNote');
      var dueRangeNote = document.getElementById('dueRangeNote');
      var dueRefreshBtn = document.getElementById('dueRefreshBtn');
      var dueFreshRefreshBtn = document.getElementById('dueFreshRefreshBtn');
      var dueBackfillBtn = document.getElementById('dueBackfillBtn');
      var dueResetHistoryBtn = document.getElementById('dueResetHistoryBtn');
      var dueResetBtn = document.getElementById('dueResetBtn');
      var dueStatus = document.getElementById('dueStatus');
      var dueShell = document.getElementById('dueShell');
      var dueQueueHealth = document.getElementById('dueQueueHealth');
      var dueQueueHealthLabel = document.getElementById('dueQueueHealthLabel');
      var dueQueueHealthState = document.getElementById('dueQueueHealthState');
      var dueSyncRail = document.getElementById('dueSyncRail');
      var dueSyncRailFill = document.getElementById('dueSyncRailFill');
      var dueSyncStageLabel = document.getElementById('dueSyncStageLabel');
      var dueSyncStageHint = document.getElementById('dueSyncStageHint');
      var dueLiveStatusValue = document.getElementById('dueLiveStatusValue');
      var dueLiveGuestsValue = document.getElementById('dueLiveGuestsValue');
      var dueLiveAppointmentsValue = document.getElementById('dueLiveAppointmentsValue');
      var dueLiveUpdatedValue = document.getElementById('dueLiveUpdatedValue');
      var dueRefreshImpact = document.getElementById('dueRefreshImpact');
      var dueRefreshImpactMeta = document.getElementById('dueRefreshImpactMeta');
      var dueRefreshImpactList = document.getElementById('dueRefreshImpactList');
      var dueRefreshAddedCount = document.getElementById('dueRefreshAddedCount');
      var dueRefreshUpdatedCount = document.getElementById('dueRefreshUpdatedCount');
      var dueRefreshRemovedCount = document.getElementById('dueRefreshRemovedCount');
      var dueRefreshStatusValue = document.getElementById('dueRefreshStatusValue');
      var dueRefreshTypeValue = document.getElementById('dueRefreshTypeValue');
      var dueRefreshStepValue = document.getElementById('dueRefreshStepValue');
      var dueRefreshPercentValue = document.getElementById('dueRefreshPercentValue');
      var dueRefreshAppointmentsProcessed = document.getElementById('dueRefreshAppointmentsProcessed');
      var dueRefreshAppointmentsRemaining = document.getElementById('dueRefreshAppointmentsRemaining');
      var dueRefreshAppointmentsTotal = document.getElementById('dueRefreshAppointmentsTotal');
      var dueRefreshReplayRows = document.getElementById('dueRefreshReplayRows');
      var dueRefreshClientsProcessed = document.getElementById('dueRefreshClientsProcessed');
      var dueRefreshClientsRemaining = document.getElementById('dueRefreshClientsRemaining');
      var dueRefreshClientsTotal = document.getElementById('dueRefreshClientsTotal');
      var dueRefreshChangedGuestsTotal = document.getElementById('dueRefreshChangedGuestsTotal');
      var dueRefreshQueueDelta = document.getElementById('dueRefreshQueueDelta');
      var dueRefreshStartedAt = document.getElementById('dueRefreshStartedAt');
      var dueRefreshUpdatedAt = document.getElementById('dueRefreshUpdatedAt');
      var dueRefreshLastSuccessAt = document.getElementById('dueRefreshLastSuccessAt');
      var dueRefreshSafeValue = document.getElementById('dueRefreshSafeValue');
      var dueDirtyAlert = document.getElementById('dueDirtyAlert');
      var dueStageDescription = document.getElementById('dueStageDescription');
      var dueHealthSummaryMount = document.getElementById('dueHealthSummaryMount');
      var dueRecommendedFocusMount = document.getElementById('dueRecommendedFocusMount');
      var dueMetricsMount = document.getElementById('dueMetricsMount');
      var dueScorecardMount = document.getElementById('dueScorecardMount');
      var dueQueueList = document.getElementById('dueQueueList');
      var dueQueueLoadMoreSentinel = document.getElementById('dueQueueLoadMoreSentinel');
      var dueQueuePagerSummary = document.getElementById('dueQueuePagerSummary');
      var duePrevPageBtn = document.getElementById('duePrevPageBtn');
      var dueNextPageBtn = document.getElementById('dueNextPageBtn');
      var dueBottomPager = document.getElementById('dueBottomPager');
      var dueBottomLoadMoreBtn = document.getElementById('dueBottomLoadMoreBtn');
      var bdFastShell = document.getElementById('bdFastShell');
      var bdFastRefreshV4Btn = document.getElementById('bdFastRefreshV4Btn');
      var bdFastHistoryBtn = document.getElementById('bdFastHistoryBtn');
      var bdFastSearch = document.getElementById('bdFastSearch');
      var bdFastMode = document.getElementById('bdFastMode');
      var bdFastModeTabs = document.getElementById('bdFastModeTabs');
      var bdFastSort = document.getElementById('bdFastSort');
      var bdFastStatus = document.getElementById('bdFastStatus');
      var bdFastSummary = document.getElementById('bdFastSummary');
      var bdFastScorecardRangeTabs = document.getElementById('bdFastScorecardRangeTabs');
      var bdFastScorecardAudienceTabs = document.getElementById('bdFastScorecardAudienceTabs');
      var bdFastScorecardMount = document.getElementById('bdFastScorecardMount');
      var bdFastCount = document.getElementById('bdFastCount');
      var bdFastCountHint = document.getElementById('bdFastCountHint');
      var bdFastLaneTitle = document.getElementById('bdFastLaneTitle');
      var bdFastLaneDescription = document.getElementById('bdFastLaneDescription');
      var bdFastLaneCountPill = document.getElementById('bdFastLaneCountPill');
      var bdFastQueueSelectedBtn = document.getElementById('bdFastQueueSelectedBtn');
      var bdFastList = document.getElementById('bdFastList');
      var bdFastDetailRail = document.getElementById('bdFastDetailRail');
      var bdFastDetailTitle = document.getElementById('bdFastDetailTitle');
      var bdFastDetailSummary = document.getElementById('bdFastDetailSummary');
      var bdFastDetailPanel = document.getElementById('bdFastDetailPanel');
      var bdFastLastRefreshValue = document.getElementById('bdFastLastRefreshValue');
      var bdFastResultsPeriod = document.getElementById('bdFastResultsPeriod');
      var bdFastRefreshPreviewDialog = document.getElementById('bdFastRefreshPreviewDialog');
      var bdFastRefreshPreviewSummary = document.getElementById('bdFastRefreshPreviewSummary');
      var bdFastRefreshPreviewList = document.getElementById('bdFastRefreshPreviewList');
      var bdFastRefreshPreviewCancelBtn = document.getElementById('bdFastRefreshPreviewCancelBtn');
      var bdFastRefreshPreviewConfirmBtn = document.getElementById('bdFastRefreshPreviewConfirmBtn');
      var bdFastClaimedList = null;
      var bdFastClaimedCount = null;
      var bdFastPrevBtn = document.getElementById('bdFastPrevBtn');
      var bdFastNextBtn = document.getElementById('bdFastNextBtn');
      var bdFastPageLabel = document.getElementById('bdFastPageLabel');
      var dueQueueScrollHandlerBound = false;
      var masterScheduleStatus = document.getElementById('masterScheduleStatus');
      var masterScheduleWeekMount = document.getElementById('masterScheduleWeekMount');
      var managerCalendarStatus = document.getElementById('managerCalendarStatus');
      var managerCalendarMount = document.getElementById('managerCalendarMount');
      var managerCalendarRangeLabel = document.getElementById('managerCalendarRangeLabel');
      var managerCalendarTodayBtn = document.getElementById('managerCalendarTodayBtn');
      var managerCalendarPrevBtn = document.getElementById('managerCalendarPrevBtn');
      var managerCalendarNextBtn = document.getElementById('managerCalendarNextBtn');
      var managerCalendarViewToggle = document.getElementById('managerCalendarViewToggle');
      var managerCalendarModalBackdrop = document.getElementById('managerCalendarModalBackdrop');
      var managerCalendarModalEyebrow = document.getElementById('managerCalendarModalEyebrow');
      var managerCalendarModalTitle = document.getElementById('managerCalendarModalTitle');
      var managerCalendarModalDate = document.getElementById('managerCalendarModalDate');
      var managerCalendarAudienceChips = document.getElementById('managerCalendarAudienceChips');
      var managerCalendarModalItemTitle = document.getElementById('managerCalendarModalItemTitle');
      var managerCalendarModalAudienceSearch = document.getElementById('managerCalendarModalAudienceSearch');
      var managerCalendarModalAudienceChecklist = document.getElementById('managerCalendarModalAudienceChecklist');
      var managerCalendarModalSmsWrap = document.getElementById('managerCalendarModalSmsWrap');
      var managerCalendarModalSendSms = document.getElementById('managerCalendarModalSendSms');
      var managerCalendarModalSmsHint = document.getElementById('managerCalendarModalSmsHint');
      var managerCalendarModalClose = document.getElementById('managerCalendarModalClose');
      var managerCalendarModalCancel = document.getElementById('managerCalendarModalCancel');
      var managerCalendarModalSave = document.getElementById('managerCalendarModalSave');
      var coverageCalendarStatus = document.getElementById('coverageCalendarStatus');
      var coverageCalendarMount = document.getElementById('coverageCalendarMount');
      var coverageWeekRange = document.getElementById('coverageWeekRange');
      var coveragePrevWeekBtn = document.getElementById('coveragePrevWeekBtn');
      var coverageNextWeekBtn = document.getElementById('coverageNextWeekBtn');
      var todoTabs = document.getElementById('todoTabs');
      var todoTabPending = document.getElementById('todoTabPending');
      var todoTabCompleted = document.getElementById('todoTabCompleted');
      var todoManagerTabCount = document.getElementById('todoManagerTabCount');
      var todoCountPending = document.getElementById('todoCountPending');
      var todoCountCompleted = document.getElementById('todoCountCompleted');
      var todoSearch = document.getElementById('todoSearch');
      var todoRefreshBtn = document.getElementById('todoRefreshBtn');
      var todoAdminStatus = document.getElementById('todoAdminStatus');
      var todoAdminList = document.getElementById('todoAdminList');
      var inventoryTabs = document.getElementById('inventoryTabs');
      var inventoryTabNeeded = document.getElementById('inventoryTabNeeded');
      var inventoryTabOrdered = document.getElementById('inventoryTabOrdered');
      var inventoryManagerTabCount = document.getElementById('inventoryManagerTabCount');
      var fullStoryManagerTabCount = document.getElementById('fullStoryManagerTabCount');
      var inventoryCountNeeded = document.getElementById('inventoryCountNeeded');
      var inventoryCountOrdered = document.getElementById('inventoryCountOrdered');
      var inventorySearch = document.getElementById('inventorySearch');
      var inventoryRefreshBtn = document.getElementById('inventoryRefreshBtn');
      var inventoryStatus = document.getElementById('inventoryStatus');
      var inventoryList = document.getElementById('inventoryList');
      var fullStoryTabs = document.getElementById('fullStoryTabs');
      var fullStoryTabInventory = document.getElementById('fullStoryTabInventory');
      var fullStoryTabOrders = document.getElementById('fullStoryTabOrders');
      var fullStoryCountInventory = document.getElementById('fullStoryCountInventory');
      var fullStoryCountOrders = document.getElementById('fullStoryCountOrders');
      var fullStorySearch = document.getElementById('fullStorySearch');
      var fullStoryRefreshBtn = document.getElementById('fullStoryRefreshBtn');
      var fullStoryStatus = document.getElementById('fullStoryStatus');
      var fullStoryList = document.getElementById('fullStoryList');
      var statusLine = document.getElementById('statusLine');
      var tableMount = document.getElementById('tableMount');
      var kpiTableMount = document.getElementById('kpiTableMount');
      var globalKpiQuarter = document.getElementById('globalKpiQuarter');
      var globalKpiRefreshYtdBtn = document.getElementById('globalKpiRefreshYtdBtn');
      var globalKpiStatus = document.getElementById('globalKpiStatus');
      var globalKpiTableMount = document.getElementById('globalKpiTableMount');
      var snapshotHealthReloadBtn = document.getElementById('snapshotHealthReloadBtn');
      var snapshotHealthStatus = document.getElementById('snapshotHealthStatus');
      var snapshotHealthMount = document.getElementById('snapshotHealthMount');
      var colorDisciplineReportStart = document.getElementById('colorDisciplineReportStart');
      var colorDisciplineReportEnd = document.getElementById('colorDisciplineReportEnd');
      var colorDisciplineImportFile = document.getElementById('colorDisciplineImportFile');
      var colorDisciplineUploadZone = document.getElementById('colorDisciplineUploadZone');
      var colorDisciplineUploadTitle = document.getElementById('colorDisciplineUploadTitle');
      var colorDisciplineUploadMeta = document.getElementById('colorDisciplineUploadMeta');
      var colorDisciplineImportBtn = document.getElementById('colorDisciplineImportBtn');
      var colorDisciplineRefreshBtn = document.getElementById('colorDisciplineRefreshBtn');
      var colorDisciplineStatus = document.getElementById('colorDisciplineStatus');
      var colorDisciplineCoverageHint = document.getElementById('colorDisciplineCoverageHint');
      var colorDisciplineSummaryMount = document.getElementById('colorDisciplineSummaryMount');
      var colorDisciplineLeaderboardMount = document.getElementById('colorDisciplineLeaderboardMount');
      var colorDisciplineImportPayload = '';
      var activeColorDisciplineImportId = '';
      var staffGrowthStaff = document.getElementById('staffGrowthStaff');
      var staffGrowthStatus = document.getElementById('staffGrowthStatus');
      var staffGrowthMount = document.getElementById('staffGrowthMount');
      var level7ComparisonStatus = document.getElementById('level7ComparisonStatus');
      var level7ComparisonMount = document.getElementById('level7ComparisonMount');
      var level7StaffAnalysisOverlay = null;
      var bonusRangeKind = document.getElementById('bonusRangeKind');
      var bonusPlanYear = document.getElementById('bonusPlanYear');
      var bonusPlanQuarter = document.getElementById('bonusPlanQuarter');
      var bonusPlanQuarterLabel = document.querySelector('label[for="bonusPlanQuarter"]');
      var bonusPlanYearLabel = document.querySelector('label[for="bonusPlanYear"]');
      var bonusCustomDateFrom = document.getElementById('bonusCustomDateFrom');
      var bonusCustomDateTo = document.getElementById('bonusCustomDateTo');
      var bonusCustomDateFromField = document.getElementById('bonusCustomDateFromField');
      var bonusCustomDateToField = document.getElementById('bonusCustomDateToField');
      var bonusBudget = document.getElementById('bonusBudget');
      var bonusNotes = document.getElementById('bonusNotes');
      var bonusLevelCurve = document.getElementById('bonusLevelCurve');
      var bonusLevelCurveHint = document.getElementById('bonusLevelCurveHint');
      var bonusMetricList = document.getElementById('bonusMetricList');
      var bonusMetricAvailableList = document.getElementById('bonusMetricAvailableList');
      var bonusIncludedStaff = document.getElementById('bonusIncludedStaff');
      var bonusTeamSummary = document.getElementById('bonusTeamSummary');
      var bonusStaffSearch = document.getElementById('bonusStaffSearch');
      var bonusStaffRoleFilter = document.getElementById('bonusStaffRoleFilter');
      var bonusStaffLevelFilter = document.getElementById('bonusStaffLevelFilter');
      var bonusSelectAllStaffBtn = document.getElementById('bonusSelectAllStaffBtn');
      var bonusClearStaffBtn = document.getElementById('bonusClearStaffBtn');
      var bonusActiveMetricsSummary = document.getElementById('bonusActiveMetricsSummary');
      var bonusPublishedToStaff = document.getElementById('bonusPublishedToStaff');
      var bonusRefreshBtn = document.getElementById('bonusRefreshBtn');
      var bonusSaveBtn = document.getElementById('bonusSaveBtn');
      var bonusStatus = document.getElementById('bonusStatus');
      var bonusStickyStatus = document.getElementById('bonusStickyStatus');
      var bonusReadinessMount = document.getElementById('bonusReadinessMount');
      var bonusRailMount = document.getElementById('bonusRailMount');
      var bonusSummaryMount = document.getElementById('bonusSummaryMount');
      var bonusTableMount = document.getElementById('bonusTableMount');
      var bonusRequestVersion = 0;
      var bonusAvailabilityRequestVersion = 0;
      var bonusAvailabilityTimer = null;
      var bonusUiBusy = false;
      var progressionStaff = document.getElementById('progressionStaff');
      var progressionRole = document.getElementById('progressionRole');
      var progressionStatus = document.getElementById('progressionStatus');
      var progressionEditorPin = document.getElementById('progressionEditorPin');
      var progressionEditorUnlockBtn = document.getElementById('progressionEditorUnlockBtn');
      var progressionEditorStatus = document.getElementById('progressionEditorStatus');
      var progressionEditorAuthField = document.getElementById('progressionEditorAuthField');
      var progressionAuditTabCount = document.getElementById('progressionAuditTabCount');
      var progressionAuditRefreshBtn = document.getElementById('progressionAuditRefreshBtn');
      var progressionAuditQueueStatus = document.getElementById('progressionAuditQueueStatus');
      var progressionAuditQueueList = document.getElementById('progressionAuditQueueList');
      var progressionEditorMount = document.getElementById('progressionEditorMount');
      var progressionSaveBtn = document.getElementById('progressionSaveBtn');
      var progressionBioPreview = document.getElementById('progressionBioPreview');
      var permissionsStaff = document.getElementById('permissionsStaff');
      var permissionsNotes = document.getElementById('permissionsNotes');
      var permissionsStatus = document.getElementById('permissionsStatus');
      var permissionsGrid = document.getElementById('permissionsGrid');
      var permissionsSaveBtn = document.getElementById('permissionsSaveBtn');
      var permissionsSummaryName = document.getElementById('permissionsSummaryName');
      var permissionsSummaryRole = document.getElementById('permissionsSummaryRole');
      var permissionsActive = document.getElementById('permissionsActive');
      var permissionsAccess = document.getElementById('permissionsAccess');
      var permissionsKpis = document.getElementById('permissionsKpis');
      var permissionsGlobalKpis = document.getElementById('permissionsGlobalKpis');
      var permissionsColorDiscipline = document.getElementById('permissionsColorDiscipline');
      var permissionsStaffGrowth = document.getElementById('permissionsStaffGrowth');
      var permissionsLevel7 = document.getElementById('permissionsLevel7');
      var permissionsBonus = document.getElementById('permissionsBonus');
      var permissionsRequests = document.getElementById('permissionsRequests');
      var permissionsOpenShifts = document.getElementById('permissionsOpenShifts');
      var permissionsRetail = document.getElementById('permissionsRetail');
      var permissionsModels = document.getElementById('permissionsModels');
      var permissionsDueQueue = document.getElementById('permissionsDueQueue');
      var permissionsSchedule = document.getElementById('permissionsSchedule');
      var permissionsCoverage = document.getElementById('permissionsCoverage');
      var permissionsTodo = document.getElementById('permissionsTodo');
      var permissionsInventory = document.getElementById('permissionsInventory');
      var permissionsProgression = document.getElementById('permissionsProgression');
      var permissionsAdmin = document.getElementById('permissionsAdmin');
      var permissionsCheckpointAdmin = document.getElementById('permissionsCheckpointAdmin');
      var permissionsProgressionManage = document.getElementById('permissionsProgressionManage');
      var permissionsProgressionLevel = document.getElementById('permissionsProgressionLevel');
      var checkpointAdminRoleTrackFilter = document.getElementById('checkpointAdminRoleTrackFilter');
      var checkpointAdminLevelMoveFilter = document.getElementById('checkpointAdminLevelMoveFilter');
      var checkpointAdminSearch = document.getElementById('checkpointAdminSearch');
      var checkpointAdminStatus = document.getElementById('checkpointAdminStatus');
      var checkpointAdminList = document.getElementById('checkpointAdminList');
      var checkpointAdminRefreshBtn = document.getElementById('checkpointAdminRefreshBtn');
      var checkpointAdminNewBtn = document.getElementById('checkpointAdminNewBtn');
      var checkpointAdminEditorTitle = document.getElementById('checkpointAdminEditorTitle');
      var checkpointAdminEditorHint = document.getElementById('checkpointAdminEditorHint');
      var checkpointAdminModeBadge = document.getElementById('checkpointAdminModeBadge');
      var checkpointAdminEditorPanel = document.getElementById('checkpointAdminEditorPanel');
      var checkpointAdminDeleteBtn = document.getElementById('checkpointAdminDeleteBtn');
      var checkpointAdminSaveBtn = document.getElementById('checkpointAdminSaveBtn');
      var checkpointAdminAdvanced = document.getElementById('checkpointAdminAdvanced');
      var checkpointAdminRoleTrack = document.getElementById('checkpointAdminRoleTrack');
      var checkpointAdminSourceLevel = document.getElementById('checkpointAdminSourceLevel');
      var checkpointAdminTargetLevel = document.getElementById('checkpointAdminTargetLevel');
      var checkpointAdminCategory = document.getElementById('checkpointAdminCategory');
      var checkpointAdminFocusArea = document.getElementById('checkpointAdminFocusArea');
      var checkpointAdminCategoryOptions = document.getElementById('checkpointAdminCategoryOptions');
      var checkpointAdminFocusAreaOptions = document.getElementById('checkpointAdminFocusAreaOptions');
      var checkpointAdminRequirementKey = document.getElementById('checkpointAdminRequirementKey');
      var checkpointAdminLabel = document.getElementById('checkpointAdminLabel');
      var checkpointAdminRequirementType = document.getElementById('checkpointAdminRequirementType');
      var checkpointAdminMetricName = document.getElementById('checkpointAdminMetricName');
      var checkpointAdminBenchmarkSummary = document.getElementById('checkpointAdminBenchmarkSummary');
      var checkpointAdminThresholdNumeric = document.getElementById('checkpointAdminThresholdNumeric');
      var checkpointAdminThresholdUnit = document.getElementById('checkpointAdminThresholdUnit');
      var checkpointAdminWindowDays = document.getElementById('checkpointAdminWindowDays');
      var checkpointAdminSortOrder = document.getElementById('checkpointAdminSortOrder');
      var checkpointAdminFocusAreaSort = document.getElementById('checkpointAdminFocusAreaSort');
      var checkpointAdminRequirementSort = document.getElementById('checkpointAdminRequirementSort');
      var checkpointAdminEvaluationMode = document.getElementById('checkpointAdminEvaluationMode');
      var checkpointAdminEvidenceSource = document.getElementById('checkpointAdminEvidenceSource');
      var checkpointAdminRequired = document.getElementById('checkpointAdminRequired');
      var checkpointAdminSignoffRequired = document.getElementById('checkpointAdminSignoffRequired');
      var checkpointAdminDescription = document.getElementById('checkpointAdminDescription');
      var checkpointAdminManagerGuidance = document.getElementById('checkpointAdminManagerGuidance');
      var checkpointAdminStaffGuidance = document.getElementById('checkpointAdminStaffGuidance');
      var debugMount = document.getElementById('debugMount');
      var lastDebugPayload = null;
      var reliabilityScoreByStaff = {};
      var requestsOffByStaff = {};
      var callOutsByStaff = {};
      var lateArrivalsByStaff = {};
      var requestQueueReliabilityScoreByStaff = {};
      var requestQueueRequestsOffByStaff = {};
      var requestQueueCallOutsByStaff = {};
      var requestQueueLateArrivalsByStaff = {};
      var requestQueueApprovedFutureDaysByStaff = {};
      var levelByStaff = {};
      var avatarByStaff = {};
      var appStarted = false;
      var idleTimer = null;
      var progressionAuditQueueTimer = null;
      var fullStoryPollTimer = null;
      var fullStoryPollInFlight = false;
      var hasLoadedGlobalKpis = false;
      var hasLoadedSnapshotHealth = false;
      var activeGlobalKpiLoadToken = 0;
      var globalKpiRefreshInFlight = false;
      var globalKpiAnnualRefreshPollTimer = null;
      var hasLoadedColorDiscipline = false;
      var hasLoadedStaffGrowth = false;
      var hasLoadedBonus = false;
      var hasLoadedProgressionControls = false;
      var hasLoadedPermissionsControls = false;
      var hasLoadedCheckpointAdminControls = false;
      var hasLoadedRetail = false;
      var hasLoadedPostAppointmentSms = false;
      var hasLoadedManagerCalendar = false;
      var postAppointmentSmsPollTimer = null;
      var postAppointmentSmsPollInFlight = false;
      var hasLoadedModels = false;
      var snapshotHealthGroups = [];
      var snapshotHealthRefreshInFlight = {};
      var snapshotHealthPollTimerById = {};
      var retailLoadPromise = null;
      var RETAIL_AUTO_RETRY_MAX_MS = 15000;
      var PAYROLL_PERIOD_ANCHOR_START = '2026-06-21';
      var activeRetailPayrollStart = '';
      var retailPeriodSnapshots = {};
      var retailSnapshotsHydrated = false;
      var retailQuarterPrefetchPromiseByPeriod = {};
      var retailAvailableQuarterOptions = null;
      var retailAvailableQuarterOptionsPromise = null;
      var hasLoadedDueQueue = false;
      var hasLoadedDueQueueFast = false;
      var hasLoadedTodo = false;
      var hasLoadedInventory = false;
      var hasLoadedFullStory = false;
      var colorDisciplineBoard = null;
      var requestOffStaffOptions = [];
      var requestOffRoleOptions = [];
      var progressionStaffOptions = [];
      var progressionRoleOptions = [];
      var progressionSelectedStaff = null;
      var progressionSelectedRoleId = '';
      var progressionOriginalRoleId = '';
      var progressionDraft = null;
      var progressionProfile = null;
      var progressionOriginalBio = '';
      var progressionAuditQueue = [];
      var progressionLoadRequestId = 0;
      var permissionsStaffOptions = [];
      var permissionsSelectedStaff = null;
      var bonusPlanState = null;
      var bonusMetricCatalog = [];
      var bonusIncludedStaffOptions = [];
      var bonusMetricDraftState = {};
      var checkpointAdminRows = [];
      var checkpointAdminSelectedId = '';
      var checkpointAdminKeyDirty = false;
      var currentStaffOpsPermission = null;
      var currentProgressionEditor = null;
      var currentProgressionEditorPermission = null;
      var PROGRESSION_EDITOR_SESSION_STORAGE_KEY = 'hairstoriesProgressionEditorSessionV1';
      var STAFF_OPERATIONS_ACCESS_SESSION_STORAGE_KEY = 'hairstoriesStaffOpsAccessSessionV1';
      var MODELS_HIDDEN_IDS_STORAGE_KEY = 'hairstoriesModelsHiddenIdsV1';
      var RETAIL_PERIOD_SNAPSHOTS_STORAGE_KEY = 'hairstoriesRetailPeriodSnapshotsV1';
      var requestOffQueue = [];
      var requestQueueFilter = 'all';
      var requestQueueSearchTerm = '';
      var openShiftViewFilter = 'available';
      var shiftChangeQueue = [];
      var lastManagerFillResult = null;
      var retailAnalyticsRows = [];
      var retailQueuedRows = [];
      var postAppointmentSmsRows = [];
      var postAppointmentSmsSettings = null;
      var retailAnalyticsSummary = null;
      var retailSalesLeaderboard = null;
      var retailActivitySummary = null;
      var retailActivityRows = [];
      var retailActivityByAppointment = {};
      var modelIntakeRows = [];
      var modelIntakeActiveFilter = 'all';
      var modelIntakeSelectedId = '';
      var modelIntakeDetailCache = {};
      var modelFutureAppointmentByPhone = {};
      var modelHiddenIds = {};
      var modelIntakeRequestVersion = 0;
      var dueQueueRows = [];
      var dueQueueSummary = null;
      var bdFastAllRows = [];
      var bdFastFilteredRows = [];
      var bdFastOutreachState = {};
      var bdFastSelectedOpportunityKey = '';
      var bdFastPage = 0;
      var bdFastPageSize = 40;
      var bdFastSearchTimer = null;
      var bdFastRefreshPollTimer = null;
      var bdFastRefreshPollRequestId = 0;
      var bdFastAllRowsLoaded = false;
      var bdFastLoadedRowCount = 0;
      var bdFastTotalRowEstimate = 0;
      var bdFastModeStateByMode = {};
      var bdFastDetailStateByKey = {};
      var bdFastDetailLoadingKey = '';
      var bdFastRetailProductPickerByKey = {};
      var bdFastRetailProductPickerTimerByKey = {};
      var bdFastRetailImageByUrl = {};
      var bdFastRetailImageLoadingByUrl = {};
      var bdFastSelectedRows = {};
      var bdFastSmsQueueOrder = [];
      var bdFastRefreshPreviewState = null;
      var bdFastBootstrapPromise = null;
      var bdFastScorecard = null;
      var bdFastScorecardLookbackDays = 30;
      var bdFastScorecardFocus = 'team';
      var dueQueueOverviewSummary = null;
      var dueQueueScorecard = null;
      var dueQueueRefreshProgress = null;
      var dueRefreshProgressPollTimer = null;
      var dueRefreshAutoContinueInFlight = false;
      var dueRefreshAutoResumeLastAttemptAt = 0;
      var DUE_REFRESH_AUTO_RESUME_COOLDOWN_MS = 2500;
      var dueQueueBootLoadPromise = null;
      var dueQueueHydrationPromise = null;
      var dueLastRefreshImpact = null;
      var dueQueueOffset = 0;
      var dueQueuePageSize = 50;
      var dueQueueVisibleCount = 50;
      var dueQueueTotalRows = 0;
      var dueQueueRenderableRowCount = 0;
      var dueQueueInfiniteObserver = null;
      var dueQueueLoadMoreInFlight = false;
      var dueQueueRenderSignature = '';
      var dueQueueListRenderSignature = '';
      var dueQueueListRenderedCount = 0;
      var dueQueuePreserveVisibleCountOnNextRender = false;
      var dueQueueWorkspace = 'all';
      var dueQueueWorkspaceCache = {};
      var dueQueueActiveStage = 'all';
      var dueQueueOpportunityFilter = 'all';
      var dueQueueWorkflowFilter = 'all';
      var dueQueueOwnerFilter = 'all';
      var dueScorecardLookbackDays = 30;
      var dueScorecardFocus = 'team';
      var dueQueueActiveFilter = 'all';
      var dueQueueActiveClientType = 'all';
      var dueQueueSortMode = 'priority_score';
      var dueQueueOfferOptions = [];
      var dueHistoryCursor = null;
      var dueHistoryHasMore = true;
      var DUE_HISTORY_CURSOR_KEY = 'hairstories_due_history_cursor_v1';
      var DUE_HISTORY_HAS_MORE_KEY = 'hairstories_due_history_has_more_v1';
      var masterScheduleAssignments = {};
      var managerCalendarItems = [];
      var managerCalendarAnchorDate = startOfLocalDay(new Date());
      var managerCalendarView = 'month';
      var managerCalendarLoadedRangeKey = '';
      var managerCalendarSaveInFlightByDate = {};
      var managerCalendarDeleteInFlightById = {};
      var managerCalendarActiveModalDate = '';
      var managerCalendarActiveModalItemId = '';
      var managerCalendarActiveModalIsEdit = false;
      var managerCalendarAudienceSearchValue = '';
      var managerCalendarAudienceSelectedValues = ['all_staff'];
      var managerCalendarAudienceLoading = false;
      var coverageWeekOffset = 0;
      var todoAdminRows = [];
      var inventoryGroups = [];
      var inventoryOrderedGroups = [];
      var inventoryTransferSummaries = [];
      var inventoryShopifyProducts = [];
      var fullStoryShopifyOrders = [];
      var activeTodoView = 'pending';
      var activeInventoryView = 'needed';
      var activeFullStoryView = 'inventory';
      var staffGrowthDataset = null;
      var latestStaffKpiHeaders = [];
      var latestStaffKpiRows = [];
      var level7AttendanceComparison = {
        '2021': LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR['2021'],
        '2022': LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR['2022'],
        '2023': LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR['2023'],
        '2024': LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR['2024'],
        '2025': LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR['2025'],
        '2026_ytd': null
      };
      var level7SupplementalMetricsByPeriod = {};
      var level7SupplementalMetricsLoading = {};
      var level7ComparisonActivePeriod = '2026_ytd';
      var level7ComparisonActiveLevel = 'all';
      var activeController = null;
      var REQUEST_TIMEOUT_MS = 180000;
      var MASTER_SCHEDULE_DAYS = [
        { key: 'monday', label: 'Monday', options: ['OFF', '12-9:30p', 'CUSTOM'] },
        { key: 'tuesday', label: 'Tuesday', options: ['OFF', '8-3pm', '12-9:30p', '3-9:30p', 'CUSTOM'] },
        { key: 'wednesday', label: 'Wednesday', options: ['OFF', '12-9:30p', 'CUSTOM'] },
        { key: 'thursday', label: 'Thursday', options: ['OFF', '8-3pm', '12-9:30p', '3-9:30p', 'CUSTOM'] },
        { key: 'friday', label: 'Friday', options: ['OFF', '11-6p', 'CUSTOM'] },
        { key: 'saturday', label: 'Saturday', options: ['OFF', '8-3pm', '11-6p', '12-9:30p', '3-9:30p', 'CUSTOM'] },
        { key: 'sunday', label: 'Sunday', options: ['OFF', '8-3pm', '11-6p', '12-9:30p', '3-9:30p', 'CUSTOM'] }
      ];
      var COVERAGE_WEEK_DAYS = [
        { key: 'monday', label: 'Monday' },
        { key: 'tuesday', label: 'Tuesday' },
        { key: 'wednesday', label: 'Wednesday' },
        { key: 'thursday', label: 'Thursday' },
        { key: 'friday', label: 'Friday' },
        { key: 'saturday', label: 'Saturday' },
        { key: 'sunday', label: 'Sunday' }
      ];
      var MANUAL_OPEN_SHIFT_WEEKEND_OPTIONS = ['8-3pm', '11-6p', '12-9:30p', '3-9:30p', 'CUSTOM'];
      var MASTER_SCHEDULE_SHIFT_TYPES = [
        { value: 'manager', label: 'Manager' },
        { value: 'floor', label: 'Floor' },
        { value: 'assisting', label: 'Assisting' }
      ];
      var CHECKPOINT_ADMIN_KPI_METRICS = [
        {
          group: 'Attendance',
          value: 'reliability_score',
          label: 'Reliability',
          threshold_unit: 'percent',
          window_days: '90'
        },
        {
          group: 'Attendance',
          value: 'requests_off',
          label: 'Requests Off',
          threshold_unit: 'count',
          window_days: '90'
        },
        {
          group: 'Attendance',
          value: 'call_outs',
          label: 'Call Outs',
          threshold_unit: 'count',
          window_days: '90'
        },
        {
          group: 'Attendance',
          value: 'late_arrivals',
          label: 'Late / Left Early',
          threshold_unit: 'count',
          window_days: '90'
        },
        {
          group: 'Sales',
          value: 'service_sales',
          label: 'Service Sales',
          threshold_unit: 'currency',
          window_days: '90'
        },
        {
          group: 'Sales',
          value: 'product_sales',
          label: 'Product Sales',
          threshold_unit: 'currency',
          window_days: '90'
        },
        {
          group: 'Sales',
          value: 'retail_to_service_percent',
          label: 'Retail to Service %',
          threshold_unit: 'percent',
          window_days: '90'
        },
        {
          group: 'Sales',
          value: 'utilization_percent',
          label: 'Utilization %',
          threshold_unit: 'percent',
          window_days: '90'
        },
        {
          group: 'Sales',
          value: 'production_rate',
          label: 'Production Rate',
          threshold_unit: 'currency_per_hour',
          window_days: '90'
        },
        {
          group: 'Sales',
          value: 'appointment_count',
          label: 'Appointments',
          threshold_unit: 'count',
          window_days: '90'
        },
        {
          group: 'Sales',
          value: 'hours_booked',
          label: 'Booked Hours',
          threshold_unit: 'hours',
          window_days: '90'
        },
        {
          group: 'Sales',
          value: 'hours_scheduled',
          label: 'Scheduled Hours',
          threshold_unit: 'hours',
          window_days: '90'
        },
        {
          group: 'Sales',
          value: 'prebooked_percent',
          label: 'Prebooked %',
          threshold_unit: 'percent',
          window_days: '90'
        },
        {
          group: 'Sales',
          value: 'self_booked_percent',
          label: 'Self-booked %',
          threshold_unit: 'percent',
          window_days: '90'
        }
      ];
      var CHECKPOINT_ADMIN_REQUIREMENT_TYPES = [
        { value: 'boolean_pass', label: 'Yes / No' },
        { value: 'count_min', label: 'Count Minimum' },
        { value: 'percent_min', label: 'Percent Minimum' }
      ];
      var STAFF_OPS_TAB_PERMISSION_MAP = {
        'kpis': 'can_view_kpis',
        'global-kpis': 'can_view_global_kpis',
        'snapshot-health': 'can_view_global_kpis',
        'color-discipline': 'can_view_color_discipline',
        'staff-growth': 'can_view_staff_growth',
        'level-7': 'can_view_level7',
        'bonus': 'can_manage_bonus',
        'requests': 'can_manage_requests_off',
        'open-shifts': 'can_manage_open_shifts',
        'retail': 'can_manage_retail_followup',
        'post-appointment-sms': 'can_manage_rebook_queue',
        'models': 'can_manage_models',
        'due-queue': 'can_manage_rebook_queue',
        'due-queue-fast': 'can_manage_rebook_queue',
        'schedule': 'can_manage_schedule',
        'calendar': 'can_manage_schedule',
        'coverage': 'can_view_weekly_calendar',
        'todo': 'can_manage_todo',
        'inventory': 'can_manage_inventory',
        'full-story': 'can_manage_inventory',
        'progression': 'can_view_progression',
        'permissions': 'can_manage_access_permissions',
        'checkpoint-admin': 'can_manage_checkpoint_admin'
      };

      function setStatus(text){
        statusLine.textContent = text;
      }

      function setGlobalKpiStatus(text, tone){
        if (!globalKpiStatus) return;
        globalKpiStatus.textContent = String(text || '');
        globalKpiStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setSnapshotHealthStatus(text, tone){
        if (!snapshotHealthStatus) return;
        snapshotHealthStatus.textContent = String(text || '');
        snapshotHealthStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function buildSnapshotHealthRefreshId(action, body){
        return String(action || '') + '|' + JSON.stringify(body || {});
      }

      function syncGlobalKpiRefreshVisualState(){
        if (!globalKpiTableMount) return;
        if (globalKpiTableMount.classList) {
          globalKpiTableMount.classList.toggle('global-kpi-dashboard--refreshing', !!globalKpiRefreshInFlight);
        }
        globalKpiTableMount.setAttribute('aria-busy', globalKpiRefreshInFlight ? 'true' : 'false');
      }

      function clearGlobalKpiAnnualRefreshPoll(){
        if (globalKpiAnnualRefreshPollTimer) {
          window.clearTimeout(globalKpiAnnualRefreshPollTimer);
          globalKpiAnnualRefreshPollTimer = null;
        }
      }

      function setStaffGrowthStatus(text, tone){
        if (!staffGrowthStatus) return;
        staffGrowthStatus.textContent = String(text || '');
        staffGrowthStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setLevel7ComparisonStatus(text, tone){
        if (!level7ComparisonStatus) return;
        level7ComparisonStatus.textContent = String(text || '');
        level7ComparisonStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setColorDisciplineStatus(text, tone){
        if (!colorDisciplineStatus) return;
        colorDisciplineStatus.textContent = String(text || '');
        colorDisciplineStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setColorDisciplineCoverageHint(text, tone){
        if (!colorDisciplineCoverageHint) return;
        colorDisciplineCoverageHint.textContent = String(text || '');
        colorDisciplineCoverageHint.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setModelsStatus(text, tone){
        if (!modelsStatus) return;
        modelsStatus.textContent = String(text || '');
        modelsStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setPostAppointmentSmsStatus(text, tone){
        if (!postAppointmentSmsStatus) return;
        postAppointmentSmsStatus.textContent = String(text || '');
        postAppointmentSmsStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setManagerCalendarStatus(text, tone){
        if (!managerCalendarStatus) return;
        managerCalendarStatus.textContent = String(text || '');
        managerCalendarStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setProgressionEditorStatus(text, tone){
        if (!progressionEditorStatus) return;
        progressionEditorStatus.textContent = String(text || '');
        progressionEditorStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setPermissionsStatus(text, tone){
        if (!permissionsStatus) return;
        permissionsStatus.textContent = String(text || '');
        permissionsStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setInventoryStatus(text, tone){
        if (!inventoryStatus) return;
        inventoryStatus.textContent = String(text || '');
        inventoryStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setFullStoryStatus(text, tone){
        if (!fullStoryStatus) return;
        fullStoryStatus.textContent = String(text || '');
        fullStoryStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setTodoAdminStatus(text, tone){
        if (!todoAdminStatus) return;
        todoAdminStatus.textContent = String(text || '');
        todoAdminStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setBonusStatus(text, tone){
        if (!bonusStatus) return;
        bonusStatus.textContent = String(text || '');
        bonusStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function stopPostAppointmentSmsPolling(){
        if (postAppointmentSmsPollTimer) {
          clearInterval(postAppointmentSmsPollTimer);
          postAppointmentSmsPollTimer = null;
        }
      }

      function refreshPostAppointmentSmsQueueSilently(){
        if (postAppointmentSmsPollInFlight) return Promise.resolve();
        postAppointmentSmsPollInFlight = true;
        return Promise.all([
          fetchPostAppointmentSmsQueue(false),
          fetchPostAppointmentSmsSettings()
        ]).then(function(results){
          var data = results[0] || {};
          postAppointmentSmsSettings = results[1] || null;
          applyPostAppointmentSmsSettingsToForm();
          postAppointmentSmsRows = Array.isArray(data.rows) ? data.rows : [];
          renderPostAppointmentSmsQueue();
        }).catch(function(error){
          setPostAppointmentSmsStatus(humanizeClientFetchErrorMessage(error, 'Could not refresh post-visit text queue.'), 'error');
        }).finally(function(){
          postAppointmentSmsPollInFlight = false;
        });
      }

      function syncPostAppointmentSmsPolling(activeTabKey){
        stopPostAppointmentSmsPolling();
        if (
          String(activeTabKey || '').trim() !== 'post-appointment-sms'
          || document.hidden
        ) {
          return;
        }
        if (hasLoadedPostAppointmentSms) {
          refreshPostAppointmentSmsQueueSilently();
        }
        postAppointmentSmsPollTimer = setInterval(function(){
          refreshPostAppointmentSmsQueueSilently();
        }, 15000);
      }

      function stopFullStoryPolling(){
        if (fullStoryPollTimer) {
          clearInterval(fullStoryPollTimer);
          fullStoryPollTimer = null;
        }
      }

      async function refreshFullStorySilently(){
        if (
          fullStoryPollInFlight
          || !hasLoadedFullStory
          || !canManageInventory()
        ) {
          return;
        }
        fullStoryPollInFlight = true;
        try {
          await ensureFullStoryLoaded(true);
        } catch (_error) {
        } finally {
          fullStoryPollInFlight = false;
        }
      }

      function syncFullStoryPolling(activeTabKey){
        stopFullStoryPolling();
        if (
          String(activeTabKey || '').trim() !== 'full-story'
          || document.hidden
          || !canManageInventory()
        ) {
          return;
        }
        if (hasLoadedFullStory) {
          refreshFullStorySilently();
        }
        fullStoryPollTimer = setInterval(function(){
          refreshFullStorySilently();
        }, 60000);
      }

      function setActiveTab(tabKey){
        var targetKey = String(tabKey || 'kpis').trim() || 'kpis';
        if (!canAccessStaffOpsTab(targetKey)) {
          targetKey = getFirstAccessibleStaffOpsTab() || 'kpis';
        }
        tabButtons.forEach(function(button){
          var isActive = String(button.getAttribute('data-tab-target') || '') === targetKey;
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        tabPanels.forEach(function(panel){
          var isActive = String(panel.getAttribute('data-tab-panel') || '') === targetKey;
          panel.hidden = !isActive;
        });
        if (targetKey === 'global-kpis' && !hasLoadedGlobalKpis) {
          ensureGlobalKpiLoaded();
        }
        if (targetKey === 'snapshot-health' && !hasLoadedSnapshotHealth) {
          ensureSnapshotHealthLoaded();
        }
        if (targetKey === 'color-discipline' && !hasLoadedColorDiscipline) {
          ensureColorDisciplineLoaded();
        }
        if (targetKey === 'staff-growth' && !hasLoadedStaffGrowth) {
          ensureStaffGrowthLoaded();
        }
        if (targetKey === 'level-7') {
          if (!hasLoadedStaffGrowth) {
            ensureStaffGrowthLoaded();
          } else {
            renderLevel7ComparisonView();
          }
        }
        if (targetKey === 'bonus' && !hasLoadedBonus) {
          ensureBonusLoaded();
        }
        if (targetKey === 'retail' && !hasLoadedRetail) {
          ensureRetailLoaded();
        }
        if (targetKey === 'post-appointment-sms' && !hasLoadedPostAppointmentSms) {
          ensurePostAppointmentSmsLoaded();
        }
        if (targetKey === 'calendar' && !hasLoadedManagerCalendar) {
          ensureManagerCalendarLoaded();
        }
        if (targetKey === 'models' && !hasLoadedModels) {
          ensureModelsLoaded();
        }
        if (targetKey === 'due-queue') {
          ensureDueQueueLoaded();
        }
        if (targetKey === 'due-queue-fast' && !hasLoadedDueQueueFast) {
          ensureDueQueueFastLoaded();
        }
        if (targetKey === 'todo' && !hasLoadedTodo) {
          ensureTodoLoaded();
        }
        if (targetKey === 'inventory' && !hasLoadedInventory) {
          ensureInventoryLoaded();
        }
        if (targetKey === 'full-story' && !hasLoadedFullStory) {
          ensureFullStoryLoaded();
        }
        if (targetKey === 'progression' && !hasLoadedProgressionControls) {
          ensureProgressionControlsLoaded();
        } else if (
          targetKey === 'progression'
          && currentProgressionEditor
          && currentProgressionEditor.staff_id
          && currentProgressionEditorPermission
          && currentProgressionEditorPermission.can_sign_off === true
        ) {
          refreshProgressionAuditQueue();
        }
        if (targetKey === 'permissions' && !hasLoadedPermissionsControls) {
          ensurePermissionsControlsLoaded();
        }
        if (targetKey === 'checkpoint-admin' && !hasLoadedCheckpointAdminControls) {
          ensureCheckpointAdminControlsLoaded();
        }
        syncProgressionAuditQueuePolling(targetKey);
        syncPostAppointmentSmsPolling(targetKey);
        syncFullStoryPolling(targetKey);
        setStoredStaffOpsValue(STAFF_OPERATIONS_LAST_TAB_STORAGE_KEY, targetKey);
      }

      function warmRetailDashboardInBackground(){
        if (!canAccessStaffOpsTab('retail') || hasLoadedRetail || retailLoadPromise) return;
        window.setTimeout(function(){
          if (!canAccessStaffOpsTab('retail') || hasLoadedRetail || retailLoadPromise) return;
          ensureRetailLoaded().catch(function(){
          });
        }, 250);
      }

      function setPinStatus(text, tone){
        if (!pinStatus) return;
        pinStatus.textContent = String(text || '');
        if (tone) {
          pinStatus.setAttribute('data-tone', tone);
        } else {
          pinStatus.removeAttribute('data-tone');
        }
      }

      function setPinValidationState(isValidating, message){
        var active = isValidating === true;
        if (pinCard) {
          pinCard.classList.toggle('is-validating', active);
        }
        if (pinInput) {
          pinInput.disabled = active;
          pinInput.setAttribute('aria-busy', active ? 'true' : 'false');
        }
        if (pinSubmitBtn) {
          pinSubmitBtn.disabled = active;
          if (active) {
            pinSubmitBtn.setAttribute('data-loading', 'true');
            pinSubmitBtn.textContent = 'Validating';
          } else {
            pinSubmitBtn.removeAttribute('data-loading');
            pinSubmitBtn.textContent = 'Continue';
          }
        }
        if (message) {
          setPinStatus(message, active ? 'loading' : '');
        }
      }

      function updateSessionIdentityDisplay(){
        if (!logoutBtn) return;
        if (currentProgressionEditor && currentProgressionEditor.staff_name) {
          logoutBtn.textContent = 'Log out ' + String(currentProgressionEditor.staff_name);
          return;
        }
        logoutBtn.textContent = 'Log out Manager';
      }

      function canShowManagerSwitch(){
        if (
          !currentStaffOpsPermission
          || currentStaffOpsPermission.active === false
          || currentStaffOpsPermission.can_access_staff_ops !== true
        ) {
          return false;
        }
        return currentStaffOpsPermission.can_view_kpis === true
          || currentStaffOpsPermission.can_view_global_kpis === true
          || currentStaffOpsPermission.can_view_color_discipline === true
          || currentStaffOpsPermission.can_view_staff_growth === true
          || currentStaffOpsPermission.can_manage_bonus === true
          || currentStaffOpsPermission.can_manage_requests_off === true
          || currentStaffOpsPermission.can_manage_open_shifts === true
          || currentStaffOpsPermission.can_manage_retail_followup === true
          || currentStaffOpsPermission.can_manage_rebook_queue === true
          || currentStaffOpsPermission.can_manage_schedule === true
          || currentStaffOpsPermission.can_view_weekly_calendar === true
          || currentStaffOpsPermission.can_manage_todo === true
          || currentStaffOpsPermission.can_manage_inventory === true
          || currentStaffOpsPermission.can_view_progression === true
          || currentStaffOpsPermission.can_manage_access_permissions === true
          || currentStaffOpsPermission.can_manage_checkpoint_admin === true;
      }

      function updateSessionSwitchLink(){
        if (!sessionSwitchLink || typeof window === 'undefined') return;
        var path = String((window.location && window.location.pathname) || '').toLowerCase();
        var isManagerPage = path.indexOf('/pages/manager') >= 0;
        sessionSwitchLink.hidden = !isManagerPage && !canShowManagerSwitch();
        sessionSwitchLink.textContent = isManagerPage ? 'Staff' : 'Manager';
        sessionSwitchLink.setAttribute('href', isManagerPage ? '/pages/staff' : '/pages/manager');
      }

      function showAppPage(){
        document.body.classList.remove('pin-locked');
        if (pinGate) {
          pinGate.hidden = true;
        }
        if (appPage) {
          appPage.hidden = false;
        }
        updateSessionSwitchLink();
        updateSessionIdentityDisplay();
      }

      function finishStaffOpsUnlock(options){
        var safeOptions = options && typeof options === 'object' ? options : {};
        var firstTab = safeOptions.firstTab || getStoredStaffOpsLastTab() || getFirstAccessibleStaffOpsTab() || 'kpis';
        showAppPage();
        window.setTimeout(function(){
          startApp();
          applyStaffOpsAccess();
          updateProgressionEditorStatusDisplay();
          setActiveTab(firstTab);
          resetIdleTimer();
        }, 0);
      }

      function showPinGate(message, tone){
        setPinValidationState(false);
        document.body.classList.add('pin-locked');
        if (appPage) {
          appPage.hidden = true;
        }
        if (pinGate) {
          pinGate.hidden = false;
        }
        if (pinInput) {
          pinInput.value = '';
        }
        setPinStatus(message || 'PIN required.', tone || '');
        if (pinInput) {
          pinInput.focus();
        }
      }

      function clearUnlockedSession(){
        try {
          window.localStorage.removeItem(STAFF_OPERATIONS_PIN_STORAGE_KEY);
          window.localStorage.removeItem(LEGACY_SHARED_UNLOCKED_STORAGE_KEY);
        } catch (_error) {
        }
        clearStaffOpsAccessSession();
        clearProgressionEditorSession();
        persistSharedAccessSession(null);
        updateSessionIdentityDisplay();
      }

      function setStoredStaffOpsValue(storageKey, value){
        try {
          if (!window.localStorage) return;
          if (!storageKey) return;
          if (value == null || value === '') {
            window.localStorage.removeItem(storageKey);
            return;
          }
          window.localStorage.setItem(storageKey, String(value));
        } catch (_error) {
        }
      }

      function getStoredStaffOpsValue(storageKey){
        try {
          if (!window.localStorage || !storageKey) return '';
          return String(window.localStorage.getItem(storageKey) || '').trim();
        } catch (_error) {
          return '';
        }
      }

      function getStoredStaffOpsLastTab(){
        return String(getStoredStaffOpsValue(STAFF_OPERATIONS_LAST_TAB_STORAGE_KEY) || '').trim();
      }

      function restoreStaffOpsViewPreferences(){
        requestQueueFilter = normalizeRequestQueueFilter(getStoredStaffOpsValue(STAFF_OPERATIONS_REQUEST_QUEUE_FILTER_STORAGE_KEY) || requestQueueFilter);
        openShiftViewFilter = normalizeOpenShiftViewFilter(getStoredStaffOpsValue(STAFF_OPERATIONS_OPEN_SHIFT_FILTER_STORAGE_KEY) || openShiftViewFilter);
      }

      function persistSharedAccessSession(payload){
        try {
          if (!payload || typeof payload !== 'object') {
            window.localStorage.removeItem(HAIRSTORIES_SHARED_ACCESS_SESSION_STORAGE_KEY);
            return;
          }
          window.localStorage.setItem(HAIRSTORIES_SHARED_ACCESS_SESSION_STORAGE_KEY, JSON.stringify(payload));
        } catch (_error) {
        }
      }

      function syncSharedManagerAccessSession(){
        if (currentProgressionEditor && currentStaffOpsPermission) {
          persistSharedAccessSession({
            mode: 'manager',
            editor: currentProgressionEditor,
            permission: currentStaffOpsPermission,
            editor_permission: currentProgressionEditorPermission || null
          });
          return;
        }
        if (!currentProgressionEditor && !currentStaffOpsPermission) {
          persistSharedAccessSession(null);
        }
      }

      function persistStaffOpsAccessSession(){
        try {
          if (!currentStaffOpsPermission) {
            window.localStorage.removeItem(STAFF_OPERATIONS_ACCESS_SESSION_STORAGE_KEY);
            syncSharedManagerAccessSession();
            return;
          }
          window.localStorage.setItem(STAFF_OPERATIONS_ACCESS_SESSION_STORAGE_KEY, JSON.stringify({
            permission: currentStaffOpsPermission
          }));
        } catch (_error) {
        }
        syncSharedManagerAccessSession();
      }

      function clearStaffOpsAccessSession(){
        currentStaffOpsPermission = null;
        try {
          window.localStorage.removeItem(STAFF_OPERATIONS_ACCESS_SESSION_STORAGE_KEY);
        } catch (_error) {
        }
        syncSharedManagerAccessSession();
      }

      function restoreStaffOpsAccessSession(){
        try {
          var raw = window.localStorage.getItem(STAFF_OPERATIONS_ACCESS_SESSION_STORAGE_KEY);
          if (!raw) return;
          var parsed = JSON.parse(raw);
          if (!parsed || !parsed.permission) return;
          currentStaffOpsPermission = parsed.permission;
        } catch (_error) {
          clearStaffOpsAccessSession();
        }
      }

      function persistProgressionEditorSession(){
        try {
          if (!currentProgressionEditor || !currentProgressionEditorPermission) {
            window.localStorage.removeItem(PROGRESSION_EDITOR_SESSION_STORAGE_KEY);
            syncSharedManagerAccessSession();
            return;
          }
          window.localStorage.setItem(PROGRESSION_EDITOR_SESSION_STORAGE_KEY, JSON.stringify({
            editor: currentProgressionEditor,
            permission: currentProgressionEditorPermission
          }));
        } catch (_error) {
        }
        syncSharedManagerAccessSession();
      }

      function clearProgressionEditorSession(){
        currentProgressionEditor = null;
        currentProgressionEditorPermission = null;
        try {
          window.localStorage.removeItem(PROGRESSION_EDITOR_SESSION_STORAGE_KEY);
        } catch (_error) {
        }
        syncSharedManagerAccessSession();
      }

      function restoreProgressionEditorSession(){
        try {
          var raw = window.localStorage.getItem(PROGRESSION_EDITOR_SESSION_STORAGE_KEY);
          if (!raw) return;
          var parsed = JSON.parse(raw);
          if (!parsed || !parsed.editor || !parsed.permission) return;
          currentProgressionEditor = parsed.editor;
          currentProgressionEditorPermission = parsed.permission;
        } catch (_error) {
          clearProgressionEditorSession();
        }
      }

      function restoreSharedManagerAccessSession(){
        try {
          var raw = window.localStorage.getItem(HAIRSTORIES_SHARED_ACCESS_SESSION_STORAGE_KEY);
          if (!raw) return false;
          var parsed = JSON.parse(raw);
          if (!parsed || parsed.mode !== 'manager' || !parsed.editor || !parsed.permission) return false;
          currentStaffOpsPermission = parsed.permission;
          currentProgressionEditor = parsed.editor;
          currentProgressionEditorPermission = parsed.editor_permission || currentProgressionEditorPermission || null;
          return true;
        } catch (_error) {
          return false;
        }
      }

      async function validateRestoredStaffOpsSession(){
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) return false;
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'staff-ops-session-validate',
              staff_id: currentProgressionEditor.staff_id
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !data.editor || !data.staff_ops_permission) {
            clearUnlockedSession();
            return false;
          }
          currentStaffOpsPermission = data.staff_ops_permission;
          currentProgressionEditor = data.editor;
          currentProgressionEditorPermission = data.editor_permission || null;
          persistStaffOpsAccessSession();
          if (currentProgressionEditor && currentProgressionEditorPermission) {
            persistProgressionEditorSession();
          } else {
            clearProgressionEditorSession();
          }
          return true;
        } catch (_error) {
          clearUnlockedSession();
          return false;
        }
      }

      function canAccessStaffOpsTab(tabKey){
        var normalizedKey = String(tabKey || '').trim();
        if (!normalizedKey) return false;
        if (!currentStaffOpsPermission) return true;
        if (currentStaffOpsPermission.active === false || currentStaffOpsPermission.can_access_staff_ops !== true) return false;
        var permissionKey = STAFF_OPS_TAB_PERMISSION_MAP[normalizedKey];
        if (!permissionKey) return false;
        if (permissionKey === 'can_view_weekly_calendar') {
          return currentStaffOpsPermission.can_view_weekly_calendar === true
            || currentStaffOpsPermission.can_manage_schedule === true;
        }
        return currentStaffOpsPermission[permissionKey] === true;
      }

      function canManageStaffOpsPermissions(){
        if (!currentStaffOpsPermission) return true;
        return currentStaffOpsPermission.active !== false
          && currentStaffOpsPermission.can_access_staff_ops === true
          && currentStaffOpsPermission.can_manage_access_permissions === true;
      }

      function getFirstAccessibleStaffOpsTab(){
        var ordered = ['kpis', 'global-kpis', 'snapshot-health', 'color-discipline', 'staff-growth', 'level-7', 'bonus', 'requests', 'open-shifts', 'retail', 'post-appointment-sms', 'models', 'due-queue-fast', 'schedule', 'coverage', 'todo', 'inventory', 'full-story', 'progression', 'permissions', 'checkpoint-admin'];
        for (var index = 0; index < ordered.length; index += 1) {
          if (canAccessStaffOpsTab(ordered[index])) return ordered[index];
        }
        return '';
      }

      function applyStaffOpsAccess(){
        var firstAccessibleTab = getFirstAccessibleStaffOpsTab() || 'kpis';
        tabButtons.forEach(function(button){
          var key = String(button.getAttribute('data-tab-target') || '').trim();
          var canAccess = canAccessStaffOpsTab(key);
          button.disabled = !canAccess;
          button.hidden = !canAccess;
          button.style.display = canAccess ? '' : 'none';
          button.setAttribute('data-locked', canAccess ? 'false' : 'true');
          button.setAttribute('aria-disabled', canAccess ? 'false' : 'true');
        });
        tabPanels.forEach(function(panel){
          var key = String(panel.getAttribute('data-tab-panel') || '').trim();
          var canAccess = canAccessStaffOpsTab(key);
          panel.hidden = !canAccess;
          panel.style.display = canAccess ? '' : 'none';
        });
        var selectedButton = tabButtons.find(function(button){
          return button && button.getAttribute && button.getAttribute('aria-selected') === 'true';
        });
        var selectedKey = selectedButton && selectedButton.getAttribute
          ? String(selectedButton.getAttribute('data-tab-target') || '').trim()
          : '';
        if (!selectedKey || !canAccessStaffOpsTab(selectedKey)) {
          setActiveTab(firstAccessibleTab);
        }
      }

      function setPermissionsFormDisabled(disabled){
        [permissionsNotes, permissionsSaveBtn, permissionsActive, permissionsAccess, permissionsKpis, permissionsGlobalKpis, permissionsColorDiscipline, permissionsStaffGrowth, permissionsLevel7, permissionsBonus, permissionsRequests, permissionsOpenShifts, permissionsRetail, permissionsModels, permissionsDueQueue, permissionsSchedule, permissionsCoverage, permissionsTodo, permissionsInventory, permissionsProgression, permissionsAdmin, permissionsCheckpointAdmin, permissionsProgressionManage, permissionsProgressionLevel]
          .forEach(function(node){
            if (!node) return;
            node.disabled = !!disabled;
          });
      }

      function getProgressionPermissionMaxLevel(permission, fieldName){
        var value = Number(permission && permission[fieldName]);
        return Number.isFinite(value) ? value : -1;
      }

      function getProgressionSectionTargetLevel(sectionKey){
        var match = String(sectionKey || '').trim().match(/to_level_(\d+)/i);
        return match ? Number(match[1]) : NaN;
      }

      function hasProgressionEditorAccess(){
        return !!(currentProgressionEditor && currentProgressionEditorPermission && currentProgressionEditorPermission.can_edit_progression);
      }

      function canEditProgressionSection(sectionKey){
        if (!hasProgressionEditorAccess()) return false;
        var sectionLevel = getProgressionSectionTargetLevel(sectionKey);
        if (!Number.isFinite(sectionLevel)) return false;
        return sectionLevel <= getProgressionPermissionMaxLevel(currentProgressionEditorPermission, 'max_edit_level');
      }

      function canManageProgressionRoles(){
        return hasProgressionEditorAccess() && getProgressionPermissionMaxLevel(currentProgressionEditorPermission, 'max_edit_level') >= 7;
      }

      function updateProgressionEditorStatusDisplay(){
        if (hasProgressionEditorAccess()) {
          var maxEditLevel = getProgressionPermissionMaxLevel(currentProgressionEditorPermission, 'max_edit_level');
          setProgressionEditorStatus(
            String((currentProgressionEditor && currentProgressionEditor.staff_name) || 'Authorized editor')
            + ' can manage progression through Level '
            + String(maxEditLevel)
            + '.',
            'success'
          );
        } else if (currentProgressionEditor) {
          setProgressionEditorStatus(
            String((currentProgressionEditor && currentProgressionEditor.staff_name) || 'Signed in')
            + ' is logged in, but does not have progression access.',
            'error'
          );
        } else {
          setProgressionEditorStatus('Log in with your staff PIN at page entry to manage progression.', 'error');
        }
      }

      function stopIdleTimer(){
        if (idleTimer) {
          clearTimeout(idleTimer);
          idleTimer = null;
        }
      }

      function stopProgressionAuditQueuePolling(){
        if (progressionAuditQueueTimer) {
          clearInterval(progressionAuditQueueTimer);
          progressionAuditQueueTimer = null;
        }
      }

      function syncProgressionAuditQueuePolling(activeTabKey){
        stopProgressionAuditQueuePolling();
        if (
          String(activeTabKey || '').trim() !== 'progression'
          || !currentProgressionEditor
          || !currentProgressionEditor.staff_id
          || !currentProgressionEditorPermission
          || currentProgressionEditorPermission.can_sign_off !== true
        ) {
          return;
        }
        progressionAuditQueueTimer = setInterval(function(){
          refreshProgressionAuditQueue();
        }, 15000);
      }

      function relockForInactivity(){
        stopIdleTimer();
        stopProgressionAuditQueuePolling();
        stopPostAppointmentSmsPolling();
        clearUnlockedSession();
        showPinGate('Session expired. Enter PIN again.', 'error');
      }

      function logoutStaffOps(){
        stopIdleTimer();
        stopProgressionAuditQueuePolling();
        stopPostAppointmentSmsPolling();
        clearUnlockedSession();
        showPinGate('Signed out.', 'success');
      }

      function resetIdleTimer(){
        stopIdleTimer();
      }

      function bindIdleTracking(){
        ['pointerdown', 'keydown', 'mousemove', 'touchstart', 'scroll'].forEach(function(eventName){
          window.addEventListener(eventName, function(){
            if (appPage && appPage.hidden) return;
            resetIdleTimer();
          }, { passive: true });
        });
      }

      function startApp(){
        if (appStarted) return;
        appStarted = true;
        restoreDueHistorySyncState();
        restoreStaffOpsViewPreferences();
        restoreStaffOpsAccessSession();
        restoreProgressionEditorSession();
        updateProgressionEditorStatusDisplay();
        applyStaffOpsAccess();

        quickRangeButtons.forEach(function(button){
          button.addEventListener('click', function(){
            applyQuickRange(button.getAttribute('data-range'));
            run();
          });
        });
        tabButtons.forEach(function(button){
          button.addEventListener('click', function(){
            setActiveTab(button.getAttribute('data-tab-target') || 'kpis');
          });
        });
        if (globalKpiQuarter) {
          globalKpiQuarter.addEventListener('change', function(){
            syncGlobalKpiRefreshYtdButton();
            loadGlobalKpis();
          });
        }
        if (globalKpiRefreshYtdBtn) {
          globalKpiRefreshYtdBtn.addEventListener('click', async function(){
            await refreshCurrentYearGlobalKpiYtd();
          });
        }
        if (snapshotHealthReloadBtn) {
          snapshotHealthReloadBtn.addEventListener('click', function(){
            hasLoadedSnapshotHealth = false;
            ensureSnapshotHealthLoaded();
          });
        }
        if (snapshotHealthMount) {
          snapshotHealthMount.addEventListener('click', function(event){
            var target = event && event.target;
            var button = target && target.closest ? target.closest('[data-snapshot-refresh-id]') : null;
            if (!button) return;
            var refreshId = String(button.getAttribute('data-snapshot-refresh-id') || '').trim();
            if (!refreshId) return;
            var entry = findSnapshotHealthEntryByRefreshId(refreshId);
            if (!entry) return;
            refreshSnapshotHealthEntry(entry);
          });
        }
        if (colorDisciplineReportStart && !colorDisciplineReportStart.value) {
          colorDisciplineReportStart.value = colorDisciplineDefaultReportStart();
        }
        if (colorDisciplineReportEnd && !colorDisciplineReportEnd.value) {
          colorDisciplineReportEnd.value = colorDisciplineDefaultWeekEnding();
        }
        if (colorDisciplineImportFile) {
          colorDisciplineImportFile.addEventListener('change', async function(){
            var file = colorDisciplineImportFile.files && colorDisciplineImportFile.files[0]
              ? colorDisciplineImportFile.files[0]
              : null;
            if (!file) return;
            try {
              setColorDisciplineStatus('Reading export file...');
              var text = await readColorDisciplineFile(file);
              colorDisciplineImportPayload = text;
              setColorDisciplineUploadState(file.name || 'Selected file');
              setColorDisciplineStatus('File loaded. Click Upload report to save it.', 'success');
            } catch (error) {
              setColorDisciplineUploadState('');
              setColorDisciplineStatus(humanizeDashboardErrorMessage(error && error.message ? error.message : 'Could not read that export file.'), 'error');
            }
          });
        }
        if (colorDisciplineUploadZone) {
          ['dragenter', 'dragover'].forEach(function(eventName){
            colorDisciplineUploadZone.addEventListener(eventName, function(event){
              if (event) {
                event.preventDefault();
                event.stopPropagation();
              }
              colorDisciplineUploadZone.classList.add('is-dragover');
            });
          });
          ['dragleave', 'dragend', 'drop'].forEach(function(eventName){
            colorDisciplineUploadZone.addEventListener(eventName, function(event){
              if (event) {
                event.preventDefault();
                event.stopPropagation();
              }
              colorDisciplineUploadZone.classList.remove('is-dragover');
            });
          });
          colorDisciplineUploadZone.addEventListener('drop', async function(event){
            var file = event && event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]
              ? event.dataTransfer.files[0]
              : null;
            if (!file) return;
            try {
              setColorDisciplineStatus('Reading export file...');
              var text = await readColorDisciplineFile(file);
              colorDisciplineImportPayload = text;
              if (colorDisciplineImportFile) {
                colorDisciplineImportFile.value = '';
              }
              setColorDisciplineUploadState(file.name || 'Dropped file');
              setColorDisciplineStatus('File loaded. Click Upload report to save it.', 'success');
            } catch (error) {
              setColorDisciplineUploadState('');
              setColorDisciplineStatus(humanizeDashboardErrorMessage(error && error.message ? error.message : 'Could not read that export file.'), 'error');
            }
          });
        }
        if (colorDisciplineRefreshBtn) {
          colorDisciplineRefreshBtn.addEventListener('click', async function(){
            hasLoadedColorDiscipline = false;
            await ensureColorDisciplineLoaded(true);
          });
        }
        if (colorDisciplineImportBtn) {
          colorDisciplineImportBtn.addEventListener('click', async function(){
            await importColorDisciplineSnapshot();
          });
        }
        if (staffGrowthStaff) {
          staffGrowthStaff.addEventListener('change', function(){
            renderStaffGrowthView();
          });
        }
        if (progressionStaff) {
          progressionStaff.addEventListener('change', function(){
            selectProgressionStaff(String(progressionStaff.value || ''));
          });
        }
        if (progressionEditorUnlockBtn) {
          progressionEditorUnlockBtn.addEventListener('click', async function(){
            await authenticateProgressionEditor();
          });
        }
        if (logoutBtn) {
          logoutBtn.addEventListener('click', function(){
            logoutStaffOps();
          });
        }
        if (progressionEditorPin) {
          progressionEditorPin.addEventListener('keydown', function(event){
            if (event && event.key === 'Enter') {
              event.preventDefault();
              authenticateProgressionEditor();
            }
          });
        }
        if (progressionRole) {
          progressionRole.addEventListener('change', function(){
            progressionSelectedRoleId = String(progressionRole.value || '').trim();
            updateProgressionSaveButton();
          });
        }
        if (progressionEditorMount) {
          progressionEditorMount.addEventListener('click', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var bulkValue = String(target.getAttribute('data-progression-bulk-value') || '').trim().toUpperCase();
            var bulkSection = String(target.getAttribute('data-progression-bulk-section') || '').trim();
            if (!bulkSection || !isProgressionToggleValue(bulkValue)) return;
            updateProgressionSectionToggles(bulkSection, bulkValue);
          });
          progressionEditorMount.addEventListener('change', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var sectionKey = String(target.getAttribute('data-progression-section') || '').trim();
            var itemKey = String(target.getAttribute('data-progression-key') || '').trim();
            if (!sectionKey || !itemKey) return;
            if (target.classList && target.classList.contains('progression-switchInput')) {
              var itemValue = target.checked ? 'YES' : 'NO';
              updateProgressionToggle(sectionKey, itemKey, itemValue);
              return;
            }
            if (target.classList && target.classList.contains('progression-valueEditor')) {
              updateProgressionValue(sectionKey, itemKey, target.value);
              return;
            }
          });
        }
        if (progressionSaveBtn) {
          progressionSaveBtn.addEventListener('click', async function(){
            await saveProgressionDraft();
          });
        }
        if (progressionAuditRefreshBtn) {
          progressionAuditRefreshBtn.addEventListener('click', async function(){
            await refreshProgressionAuditQueue();
          });
        }
      if (progressionAuditQueueList) {
        progressionAuditQueueList.addEventListener('click', async function(event){
          var target = event && event.target && event.target.closest
            ? event.target.closest('[data-progression-audit-review]')
            : null;
          if (!target || !target.getAttribute) return;
          var decision = String(target.getAttribute('data-progression-audit-review') || '').trim().toLowerCase();
          var progressId = String(target.getAttribute('data-progress-id') || '').trim();
          if (!decision || !progressId) return;
          var card = target.closest ? target.closest('.request-review-card') : null;
          var noteField = card && card.querySelector
            ? card.querySelector('[data-progression-audit-note="' + progressId + '"]')
            : null;
          var reviewNote = String(noteField && noteField.value || '').trim();
          if (decision === 'deny' && !reviewNote) {
            setProgressionAuditQueueStatus('Add feedback before denying this audit request.', 'error');
            if (noteField && typeof noteField.focus === 'function') noteField.focus();
            return;
          }
          var actionButtons = card && card.querySelectorAll
            ? Array.prototype.slice.call(card.querySelectorAll('[data-progression-audit-review]'))
            : [target];
          if (noteField) noteField.disabled = true;
          actionButtons.forEach(function(button){
            if (button) button.disabled = true;
          });
          if (card) {
            card.setAttribute('aria-busy', 'true');
            card.setAttribute('data-status', 'loading');
          }
          try {
            setProgressionAuditQueueStatus(decision === 'approve' ? 'Approving audit request...' : 'Denying audit request...');
            await reviewProgressionAuditRequest(progressId, decision, reviewNote);
            setProgressionAuditQueueStatus(decision === 'approve' ? 'Audit request approved.' : 'Audit request denied.', 'success');
          } catch (error) {
            if (noteField) noteField.disabled = false;
            actionButtons.forEach(function(button){
              if (button) button.disabled = false;
            });
            if (card) {
              card.setAttribute('aria-busy', 'false');
              card.setAttribute('data-status', 'pending');
            }
            setProgressionAuditQueueStatus(humanizeClientFetchErrorMessage(error, 'Could not review audit request.'), 'error');
          }
        });
      }
        if (permissionsStaff) {
          permissionsStaff.addEventListener('change', function(){
            selectPermissionsStaff(String(permissionsStaff.value || ''));
          });
        }
        if (permissionsSaveBtn) {
          permissionsSaveBtn.addEventListener('click', async function(){
            await saveStaffOpsPermissions();
          });
        }
        if (permissionsProgressionManage) {
          permissionsProgressionManage.addEventListener('change', function(){
            if (!permissionsProgressionLevel) return;
            var enabled = !!permissionsProgressionManage.checked;
            permissionsProgressionLevel.disabled = !enabled;
            if (!enabled) {
              permissionsProgressionLevel.value = '';
            }
          });
        }
        if (bonusRangeKind) {
          bonusRangeKind.addEventListener('change', async function(){
            syncBonusWindowModeUi();
            hasLoadedBonus = false;
            await reloadBonusWindowDraft();
          });
        }
        if (bonusPlanYear) {
          bonusPlanYear.addEventListener('change', async function(){
            syncBonusWindowModeUi();
          });
        }
        if (bonusPlanQuarter) {
          bonusPlanQuarter.addEventListener('change', async function(){
            await reloadBonusWindowDraft();
          });
        }
        if (bonusCustomDateFrom) {
          bonusCustomDateFrom.addEventListener('change', async function(){
            await reloadBonusWindowDraft();
          });
        }
        if (bonusCustomDateTo) {
          bonusCustomDateTo.addEventListener('change', async function(){
            await reloadBonusWindowDraft();
          });
        }
        if (bonusLevelCurve) {
          bonusLevelCurve.addEventListener('change', function(){
            if (bonusLevelCurveHint) bonusLevelCurveHint.textContent = describeBonusLevelCurveHint(bonusLevelCurve.value);
            renderBonusWeightMix();
          });
        }
        if (bonusBudget) {
          bonusBudget.addEventListener('input', function(){
            var setupState = getBonusMetricSetupState();
            renderBonusReadiness(setupState.poolWeightTotal);
            renderBonusRail(setupState.poolWeightTotal);
          });
        }
        if (bonusMetricList) {
          bonusMetricList.addEventListener('input', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var card = target.closest ? target.closest('[data-bonus-metric-key]') : null;
            var key = String(card && card.getAttribute ? card.getAttribute('data-bonus-metric-key') || '' : '').trim();
            if (!key) return;
            if (target.hasAttribute('data-bonus-metric-weight')) {
              var toggleNode = card && card.querySelector ? card.querySelector('[data-bonus-metric-enabled]') : null;
              if (toggleNode && Number(target.value) > 0) {
                toggleNode.checked = true;
              }
              if (!bonusMetricDraftState[key]) bonusMetricDraftState[key] = {};
              bonusMetricDraftState[key].enabled = Number(target.value) > 0;
              bonusMetricDraftState[key].weight = Math.max(0, Math.round(Number(target.value) || 0));
              var valueNode = target.parentNode && target.parentNode.querySelector
                ? target.parentNode.querySelector('[data-bonus-metric-weight-value]')
                : null;
              if (valueNode) valueNode.textContent = String(Math.max(0, Math.round(Number(target.value) || 0)));
              renderBonusMetricWeightShares();
              renderBonusWeightMix();
              return;
            }
            if (target.hasAttribute('data-bonus-metric-payout-percent')) {
              if (!bonusMetricDraftState[key]) bonusMetricDraftState[key] = {};
              bonusMetricDraftState[key].enabled = Number(target.value) > 0;
              bonusMetricDraftState[key].payout_percent = Math.max(0, Number(target.value) || 0);
              syncRecoveryMetricCardUi(card, bonusMetricDraftState[key].payout_percent);
              renderBonusWeightMix();
              return;
            }
            if (target.hasAttribute('data-bonus-metric-goal')) {
              if (!bonusMetricDraftState[key]) bonusMetricDraftState[key] = {};
              bonusMetricDraftState[key].goal = Number(target.value) || 0;
              renderBonusWeightMix();
              return;
            }
            if (target.hasAttribute('data-bonus-metric-minimum-recovered')) {
              if (!bonusMetricDraftState[key]) bonusMetricDraftState[key] = {};
              bonusMetricDraftState[key].minimum_recovered = Math.max(0, Number(target.value) || 0);
              renderBonusWeightMix();
              return;
            }
            if (target.hasAttribute('data-bonus-metric-threshold')) {
              if (!bonusMetricDraftState[key]) bonusMetricDraftState[key] = {};
              bonusMetricDraftState[key].threshold = bonusThresholdDisplayToRatio(
                Number((card.querySelector('[data-bonus-metric-goal]') || {}).value || 0),
                Number(target.value) || 0
              );
              renderBonusWeightMix();
              return;
            }
            if (target.hasAttribute('data-bonus-metric-max-payout')) {
              if (!bonusMetricDraftState[key]) bonusMetricDraftState[key] = {};
              bonusMetricDraftState[key].max_payout = Math.max(0, Number(target.value) || 0);
              renderBonusWeightMix();
              return;
            }
            if (target.hasAttribute('data-bonus-metric-cap')) {
              if (!bonusMetricDraftState[key]) bonusMetricDraftState[key] = {};
              bonusMetricDraftState[key].cap = Number(target.value) || 1.25;
              renderBonusWeightMix();
            }
          });
          bonusMetricList.addEventListener('change', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var card = target.closest ? target.closest('[data-bonus-metric-key]') : null;
            var key = String(card && card.getAttribute ? card.getAttribute('data-bonus-metric-key') || '' : '').trim();
            if (target.hasAttribute('data-bonus-metric-enabled')) {
              if (!bonusMetricDraftState[key]) bonusMetricDraftState[key] = {};
              bonusMetricDraftState[key].enabled = !!target.checked;
              if (!target.checked) {
                if (bonusMetricUsesRecoveryPercent(key, bonusMetricDraftState[key].mode)) {
                  bonusMetricDraftState[key].payout_percent = 0;
                } else {
                  bonusMetricDraftState[key].weight = 0;
                }
              }
              renderBonusMetricSelector();
              syncBonusMetricAvailability();
              renderBonusMetricWeightShares();
              renderBonusWeightMix();
              return;
            }
            if (target.hasAttribute('data-bonus-metric-weight')) {
              sanitizeBonusWeightInputs();
              return;
            }
            if (target.hasAttribute('data-bonus-metric-mode')) {
              if (!bonusMetricDraftState[key]) bonusMetricDraftState[key] = {};
              var nextMode = String(target.value || 'ranked').trim().toLowerCase();
              bonusMetricDraftState[key].mode = nextMode === 'goal' ? 'goal' : (nextMode === 'recovery_percent' ? 'recovery_percent' : 'ranked');
              syncBonusMetricAvailability();
              renderBonusMetricWeightShares();
              renderBonusWeightMix();
              return;
            }
          });
        }
        if (bonusMetricAvailableList) {
          bonusMetricAvailableList.addEventListener('click', function(event){
            var target = event && event.target;
            var button = target && target.closest ? target.closest('[data-bonus-metric-activate]') : null;
            if (!button || !button.getAttribute) return;
            var key = String(button.getAttribute('data-bonus-metric-activate') || '').trim();
            var metric = retailArray(bonusMetricCatalog).find(function(entry){
              return String(entry && entry.key || '').trim() === key;
            }) || null;
            if (!key || !metric) return;
            if (!bonusMetricDraftState[key]) {
              bonusMetricDraftState[key] = buildBonusMetricDraftState({ weights: {}, rules: { metric_rules: {} } })[key] || {};
            }
            bonusMetricDraftState[key].enabled = true;
            if (bonusMetricUsesRecoveryPercent(key, bonusMetricDraftState[key].mode || metric.recommended_mode)) {
              if (!(Number(bonusMetricDraftState[key].payout_percent) > 0)) {
                bonusMetricDraftState[key].payout_percent = Number(metric.default_payout_percent) || 5;
              }
            } else if (!(Number(bonusMetricDraftState[key].weight) > 0)) {
              bonusMetricDraftState[key].weight = Number(metric.default_weight) || 10;
            }
            renderBonusMetricSelector();
            renderBonusWeightMix();
          });
        }
        if (bonusIncludedStaff) {
          bonusIncludedStaff.addEventListener('click', function(event){
            var trigger = event && event.target && event.target.closest
              ? event.target.closest('[data-bonus-staff-id]')
              : null;
            if (!trigger) return;
            var currentlyPressed = String(trigger.getAttribute('aria-pressed') || 'false') === 'true';
            trigger.setAttribute('aria-pressed', currentlyPressed ? 'false' : 'true');
            trigger.classList.toggle('is-selected', !currentlyPressed);
            syncBonusMetricAvailability();
            renderBonusMetricWeightShares();
            renderBonusWeightMix();
            renderBonusTeamSummary();
          });
        }
        [bonusStaffSearch, bonusStaffRoleFilter, bonusStaffLevelFilter].forEach(function(node){
          if (!node) return;
          node.addEventListener('input', function(){
            renderBonusIncludedStaffSelector(getBonusSelectedStaffIds());
          });
          node.addEventListener('change', function(){
            renderBonusIncludedStaffSelector(getBonusSelectedStaffIds());
          });
        });
        if (bonusSelectAllStaffBtn) {
          bonusSelectAllStaffBtn.addEventListener('click', function(){
            Array.prototype.slice.call((bonusIncludedStaff && bonusIncludedStaff.querySelectorAll('[data-bonus-staff-id]')) || []).forEach(function(node){
              node.setAttribute('aria-pressed', 'true');
              node.classList.add('is-selected');
            });
            syncBonusMetricAvailability();
            renderBonusMetricWeightShares();
            renderBonusWeightMix();
            renderBonusTeamSummary();
          });
        }
        if (bonusClearStaffBtn) {
          bonusClearStaffBtn.addEventListener('click', function(){
            Array.prototype.slice.call((bonusIncludedStaff && bonusIncludedStaff.querySelectorAll('[data-bonus-staff-id]')) || []).forEach(function(node){
              node.setAttribute('aria-pressed', 'false');
              node.classList.remove('is-selected');
            });
            syncBonusMetricAvailability();
            renderBonusMetricWeightShares();
            renderBonusWeightMix();
            renderBonusTeamSummary();
          });
        }
        if (bonusRefreshBtn) {
          bonusRefreshBtn.addEventListener('click', async function(){
            hasLoadedBonus = false;
            await ensureBonusLoaded(true);
          });
        }
        if (bonusSaveBtn) {
          bonusSaveBtn.addEventListener('click', async function(){
            await saveBonusPlan();
          });
        }
        if (modelsSearch) {
          modelsSearch.addEventListener('input', function(){
            refreshModelIntakeView();
          });
        }
        if (modelsPhotoFilter) {
          modelsPhotoFilter.addEventListener('change', function(){
            refreshModelIntakeView();
          });
        }
        if (modelsSort) {
          modelsSort.addEventListener('change', function(){
            refreshModelIntakeView();
          });
        }
        if (modelsHideDuplicates) {
          modelsHideDuplicates.addEventListener('change', function(){
            refreshModelIntakeView();
          });
        }
        if (modelsQuickFilters) {
          modelsQuickFilters.addEventListener('click', function(event){
            var target = event && event.target;
            var button = target && target.closest ? target.closest('[data-model-filter-value]') : target;
            if (!button || !button.getAttribute) return;
            var nextFilter = String(button.getAttribute('data-model-filter-value') || '').trim() || 'all';
            if (nextFilter === modelIntakeActiveFilter) return;
            modelIntakeActiveFilter = nextFilter;
            refreshModelIntakeView();
          });
        }
        if (modelsRefreshBtn) {
          modelsRefreshBtn.addEventListener('click', async function(){
            hasLoadedModels = false;
            await ensureModelsLoaded(true);
          });
        }
        if (modelsDetailDeleteBtn) {
          modelsDetailDeleteBtn.addEventListener('click', function(){
            var intakeId = String(modelIntakeSelectedId || '').trim();
            if (!intakeId) return;
            var confirmed = window.confirm('Remove this model from the manager list? This will only hide it from this dashboard.');
            if (!confirmed) return;
            hideModelFromDashboard(intakeId);
            refreshModelIntakeView();
            setModelsStatus('Model removed from this dashboard list.', 'success');
          });
        }
        if (modelsList) {
          modelsList.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target) return;
            var row = target.closest ? target.closest('[data-model-id]') : null;
            if (!row || !row.getAttribute) return;
            if (target.closest && target.closest('a')) return;
            await selectModelIntake(String(row.getAttribute('data-model-id') || '').trim());
          });
        }
        if (inventoryTabs) {
          inventoryTabs.addEventListener('click', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var button = target.closest ? target.closest('[data-inventory-view]') : target;
            if (!button || !button.getAttribute) return;
            var nextView = String(button.getAttribute('data-inventory-view') || '').trim();
            if (!nextView || nextView === activeInventoryView) return;
            activeInventoryView = nextView === 'ordered' ? 'ordered' : 'needed';
            renderInventoryTabs();
            renderInventoryList();
          });
        }
        if (inventorySearch) {
          inventorySearch.addEventListener('input', function(){
            renderInventoryList();
          });
        }
        if (inventoryRefreshBtn) {
          inventoryRefreshBtn.addEventListener('click', async function(){
            hasLoadedInventory = false;
            await ensureInventoryLoaded(true);
          });
        }
        if (fullStorySearch) {
          fullStorySearch.addEventListener('input', function(){
            renderFullStoryList();
          });
        }
        if (fullStoryTabs) {
          fullStoryTabs.addEventListener('click', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var button = target.closest ? target.closest('[data-full-story-view]') : target;
            if (!button || !button.getAttribute) return;
            var nextView = String(button.getAttribute('data-full-story-view') || '').trim();
            if (!nextView || nextView === activeFullStoryView) return;
            activeFullStoryView = nextView === 'orders' ? 'orders' : 'inventory';
            renderFullStoryTabs();
            renderFullStoryList();
          });
        }
        if (fullStoryRefreshBtn) {
          fullStoryRefreshBtn.addEventListener('click', async function(){
            hasLoadedFullStory = false;
            await ensureFullStoryLoaded(true);
          });
        }
        if (postAppointmentSmsStatusFilter) {
          postAppointmentSmsStatusFilter.addEventListener('change', async function(){
            hasLoadedPostAppointmentSms = false;
            await ensurePostAppointmentSmsLoaded(true, false);
          });
        }
        if (postAppointmentSmsFamilyFilter) {
          postAppointmentSmsFamilyFilter.addEventListener('change', async function(){
            hasLoadedPostAppointmentSms = false;
            await ensurePostAppointmentSmsLoaded(true, false);
          });
        }
        if (postAppointmentSmsSettingsFamily) {
          postAppointmentSmsSettingsFamily.addEventListener('change', async function(){
            hasLoadedPostAppointmentSms = false;
            await ensurePostAppointmentSmsLoaded(true, false);
          });
        }
        if (postAppointmentSmsSearch) {
          postAppointmentSmsSearch.addEventListener('input', function(){
            renderPostAppointmentSmsQueue();
          });
        }
        if (postAppointmentSmsRefreshBtn) {
          postAppointmentSmsRefreshBtn.addEventListener('click', async function(){
            hasLoadedPostAppointmentSms = false;
            await ensurePostAppointmentSmsLoaded(true, false);
          });
        }
        if (postAppointmentSmsSaveSettingsBtn) {
          postAppointmentSmsSaveSettingsBtn.addEventListener('click', async function(){
            await savePostAppointmentSmsSettings(postAppointmentSmsSaveSettingsBtn);
          });
        }
        if (postAppointmentSmsProcessBtn) {
          postAppointmentSmsProcessBtn.addEventListener('click', async function(){
            hasLoadedPostAppointmentSms = false;
            await ensurePostAppointmentSmsLoaded(true, true);
          });
        }
        if (postAppointmentSmsList) {
          postAppointmentSmsList.addEventListener('click', async function(event){
            var target = event && event.target;
            var button = target && target.closest ? target.closest('[data-post-appointment-sms-action]') : target;
            if (!button || !button.getAttribute) return;
            var action = String(button.getAttribute('data-post-appointment-sms-action') || '').trim();
            var queueId = String(button.getAttribute('data-post-appointment-sms-id') || '').trim();
            if (!queueId) return;
            if (action === 'reschedule') {
              var scheduledAtInput = postAppointmentSmsList.querySelector('[data-post-appointment-sms-scheduled-at="' + queueId + '"]');
              await updatePostAppointmentSmsQueueItem(queueId, scheduledAtInput && scheduledAtInput.value, button);
              return;
            }
            if (action === 'delete') {
              await deletePostAppointmentSmsQueueItem(queueId, button);
              return;
            }
            if (action === 'send-now') {
              await sendPostAppointmentSmsNow(queueId, button);
            }
          });
        }
        document.addEventListener('visibilitychange', function(){
          var selectedButton = tabButtons.find(function(button){
            return button && button.getAttribute && button.getAttribute('aria-selected') === 'true';
          });
          var selectedKey = selectedButton && selectedButton.getAttribute
            ? String(selectedButton.getAttribute('data-tab-target') || '').trim()
            : '';
          syncPostAppointmentSmsPolling(selectedKey);
        });
        if (inventoryList) {
          inventoryList.addEventListener('click', async function(event){
            var target = event && event.target;
            var button = target && target.closest ? target.closest('[data-inventory-action]') : target;
            if (!button || !button.getAttribute) return;
            var action = String(button.getAttribute('data-inventory-action') || '').trim();
            var groupKey = String(button.getAttribute('data-inventory-group') || '').trim();
            if (!groupKey) return;
            if (action === 'order') {
              await saveInventoryGroup(groupKey, 'ordered', button);
              return;
            }
            if (action === 'reopen') {
              await saveInventoryGroup(groupKey, 'pending', button);
              return;
            }
            if (action === 'dismiss') {
              await saveInventoryGroup(groupKey, 'dismissed', button);
            }
          });
        }
        if (todoTabs) {
          todoTabs.addEventListener('click', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var button = target.closest ? target.closest('[data-todo-view]') : target;
            if (!button || !button.getAttribute) return;
            var nextView = String(button.getAttribute('data-todo-view') || '').trim();
            if (!nextView || nextView === activeTodoView) return;
            activeTodoView = nextView === 'completed' ? 'completed' : 'pending';
            renderTodoAdminTabs();
            renderTodoAdminList();
          });
        }
        if (todoSearch) {
          todoSearch.addEventListener('input', function(){
            renderTodoAdminList();
          });
        }
        if (todoRefreshBtn) {
          todoRefreshBtn.addEventListener('click', async function(){
            hasLoadedTodo = false;
            await ensureTodoLoaded(true);
          });
        }
        if (todoAdminList) {
          todoAdminList.addEventListener('click', async function(event){
            var target = event && event.target;
            var button = target && target.closest ? target.closest('[data-todo-action]') : target;
            if (!button || !button.getAttribute) return;
            var action = String(button.getAttribute('data-todo-action') || '').trim();
            var todoId = String(button.getAttribute('data-todo-id') || '').trim();
            if (!todoId) return;
            if (action === 'complete') {
              await saveTodoAdminItem(todoId, 'completed', button);
              return;
            }
            if (action === 'reopen') {
              await saveTodoAdminItem(todoId, 'pending', button);
            }
          });
        }
        if (checkpointAdminRoleTrackFilter) {
          checkpointAdminRoleTrackFilter.addEventListener('change', function(){
            renderCheckpointAdminList();
          });
        }
        if (checkpointAdminMetricName) {
          checkpointAdminMetricName.addEventListener('change', function(){
            applyCheckpointAdminMetricDefaults(String(checkpointAdminMetricName.value || ''));
            updateCheckpointAdminBenchmarkSummary();
            updateCheckpointAdminAdvancedState(String(checkpointAdminRequirementType && checkpointAdminRequirementType.value || ''));
          });
        }
        if (checkpointAdminRequirementType) {
          checkpointAdminRequirementType.addEventListener('change', function(){
            updateCheckpointAdminAdvancedState(String(checkpointAdminRequirementType.value || ''));
          });
        }
        if (checkpointAdminLabel) {
          checkpointAdminLabel.addEventListener('input', function(){
            syncCheckpointAdminKeyFromLabel();
          });
        }
        if (checkpointAdminRequirementKey) {
          checkpointAdminRequirementKey.addEventListener('input', function(){
            var normalized = normalizeProgressionKey(String(checkpointAdminRequirementKey.value || ''));
            checkpointAdminKeyDirty = normalized !== '';
            if (checkpointAdminRequirementKey.value !== normalized) {
              checkpointAdminRequirementKey.value = normalized;
            }
          });
        }
        if (checkpointAdminLevelMoveFilter) {
          checkpointAdminLevelMoveFilter.addEventListener('change', function(){
            renderCheckpointAdminList();
          });
        }
        if (checkpointAdminSearch) {
          checkpointAdminSearch.addEventListener('input', function(){
            renderCheckpointAdminList();
          });
        }
        if (checkpointAdminList) {
          checkpointAdminList.addEventListener('click', function(event){
            var target = event && event.target;
            if (!target) return;
            var button = target.closest ? target.closest('[data-checkpoint-admin-id]') : null;
            if (!button || !button.getAttribute) return;
            selectCheckpointAdminRecord(String(button.getAttribute('data-checkpoint-admin-id') || ''));
          });
        }
        if (checkpointAdminRefreshBtn) {
          checkpointAdminRefreshBtn.addEventListener('click', async function(){
            await ensureCheckpointAdminControlsLoaded(true);
          });
        }
        if (checkpointAdminNewBtn) {
          checkpointAdminNewBtn.addEventListener('click', function(){
            startNewCheckpointAdminRecord();
          });
        }
        if (checkpointAdminSaveBtn) {
          checkpointAdminSaveBtn.addEventListener('click', async function(){
            await saveCheckpointAdminRecord();
          });
        }
        if (checkpointAdminDeleteBtn) {
          checkpointAdminDeleteBtn.addEventListener('click', async function(){
            await deleteCheckpointAdminRecord();
          });
        }
        if (retailWeekTabs) {
          retailWeekTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target) return;
            var button = target.closest ? target.closest('[data-retail-period]') : null;
            if (!button || !button.getAttribute) return;
            var nextValue = String(button.getAttribute('data-retail-period') || '').trim();
            if (!nextValue || activeRetailPayrollStart === nextValue) return;
            setRetailPayrollWindow(nextValue);
            await ensureRetailLoaded();
          });
        }
        if (colorDisciplineWeekTabs) {
          colorDisciplineWeekTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target) return;
            var button = target.closest ? target.closest('[data-color-period]') : null;
            if (!button || !button.getAttribute) return;
            var nextValue = String(button.getAttribute('data-color-period') || '').trim();
            if (!nextValue || activeColorDisciplineImportId === nextValue) return;
            activeColorDisciplineImportId = nextValue;
            hasLoadedColorDiscipline = false;
            await ensureColorDisciplineLoaded(true);
          });
        }
        if (dueRefreshBtn) {
          dueRefreshBtn.addEventListener('click', async function(){
            await refreshDueQueueAuto();
          });
        }
        if (dueFreshRefreshBtn) {
          dueFreshRefreshBtn.addEventListener('click', async function(){
            await refreshDueQueueFresh();
          });
        }
        if (dueBackfillBtn) {
          dueBackfillBtn.addEventListener('click', async function(){
            await backfillDueHistoryChunk();
          });
        }
        if (dueResetHistoryBtn) {
          dueResetHistoryBtn.addEventListener('click', function(){
            resetDueHistorySyncState();
            setDueStatus('History sync cursor reset. The next auto-sync will start from the beginning again.', 'success');
          });
        }
        if (dueResetBtn) {
          dueResetBtn.addEventListener('click', async function(){
            if (dueStaffFilter) dueStaffFilter.value = '';
            if (dueSearchFilter) dueSearchFilter.value = '';
            if (dueCategoryFilter) dueCategoryFilter.value = '';
            if (dueCadenceSourceFilter) dueCadenceSourceFilter.value = '';
            if (dueSortSelect) dueSortSelect.value = 'priority_score';
            if (dueDuplicatesOnly) dueDuplicatesOnly.checked = false;
            if (dueHasPhoneOnly) dueHasPhoneOnly.checked = false;
            if (dueHasEmailOnly) dueHasEmailOnly.checked = false;
            applyDueWorkspaceSelection('all');
            dueQueueWorkflowFilter = 'all';
            dueQueueOwnerFilter = 'all';
            dueQueueActiveFilter = 'all';
            dueQueueActiveClientType = 'all';
            dueQueueSortMode = 'priority_score';
            syncDueWorkspaceTabs();
            syncDueStageTabs();
            syncDueOpportunityTabs();
            syncDueWorkflowTabs();
            syncDueOwnerTabs();
            syncDueClientTypeTabs();
            dueQueueOffset = 0;
            clearDueQueueWorkspaceCache();
            renderDueCriteriaNote();
            setDueQueueLoadingState('Loading reset queue view...');
            await loadDueQueue({ clearCache: true });
          });
        }
        if (dueWorkspaceTabs) {
          dueWorkspaceTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.closest) return;
            var workspaceButton = target.closest('[data-due-workspace]');
            if (!workspaceButton || !dueWorkspaceTabs.contains(workspaceButton)) return;
            var workspaceKey = String(workspaceButton.getAttribute('data-due-workspace') || '').trim() || 'all';
            if (workspaceKey === dueQueueWorkspace) return;
            if (workspaceKey === 'my_claimed') {
              await ensureDueQueueManagerSession();
            }
            applyDueWorkspaceSelection(workspaceKey);
            syncDueWorkspaceTabs();
            syncDueStageTabs();
            syncDueOpportunityTabs();
            if (applyDueQueueWorkspaceCache(workspaceKey)) {
              setDueStatus('Showing ' + workspaceKey.replace(/_/g, ' ') + ' opportunities.', 'success');
              return;
            }
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing ' + workspaceKey.replace(/_/g, ' ') + ' opportunities.');
              return;
            }
            dueQueueOffset = 0;
            renderDueCriteriaNote();
            setDueQueueLoadingState('Loading ' + workspaceKey.replace(/_/g, ' ') + ' opportunities...');
            await loadDueQueue({ workspace: workspaceKey });
          });
        }
        if (dueHealthSummaryMount) {
          dueHealthSummaryMount.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.closest) return;
            var card = target.closest('[data-due-health-key]');
            if (!card || !card.getAttribute) return;
            var healthKey = String(card.getAttribute('data-due-health-key') || '').trim();
            if (!healthKey) return;
            if (healthKey === 'tracked' || healthKey === 'candidates' || healthKey === 'suppressed') {
              return;
            }
            var filter = dueHealthFilterForKey(healthKey);
            if (filter.workflow === 'mine') {
              await ensureDueQueueManagerSession();
            }
            applyDueWorkspaceSelection(filter.workspace);
            dueQueueWorkflowFilter = filter.workflow;
            syncDueWorkspaceTabs();
            syncDueWorkflowTabs();
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing selected opportunity group.');
              return;
            }
            dueQueueOffset = 0;
            renderDueCriteriaNote();
            setDueQueueLoadingState('Loading selected opportunity group...');
            await loadDueQueue();
          });
        }
        if (dueRecommendedFocusMount) {
          dueRecommendedFocusMount.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.closest) return;
            var focusButton = target.closest('[data-due-focus-workspace]');
            if (!focusButton) return;
            var workspaceKey = String(focusButton.getAttribute('data-due-focus-workspace') || '').trim() || 'all';
            var workflowKey = String(focusButton.getAttribute('data-due-focus-workflow') || '').trim() || 'all';
            if (workspaceKey === 'my_claimed' || workflowKey === 'mine') {
              await ensureDueQueueManagerSession();
            }
            applyDueWorkspaceSelection(workspaceKey);
            dueQueueWorkflowFilter = workflowKey;
            syncDueWorkspaceTabs();
            syncDueWorkflowTabs();
            syncDueStageTabs();
            syncDueOpportunityTabs();
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing selected focus lane.');
              return;
            }
            dueQueueOffset = 0;
            renderDueCriteriaNote();
            setDueQueueLoadingState('Loading selected focus lane...');
            await loadDueQueue({ workspace: workspaceKey });
          });
        }
        if (dueStageTabs) {
          dueStageTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var stageKey = String(target.getAttribute('data-due-stage') || '').trim();
            if (!stageKey || stageKey === dueQueueActiveStage) return;
            dueQueueActiveStage = stageKey;
            dueQueueWorkspace = 'appointments';
            syncDueWorkspaceTabs();
            syncDueStageTabs();
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing appointment opportunities.');
              return;
            }
            dueQueueOffset = 0;
            renderDueCriteriaNote();
            setDueQueueLoadingState('Loading appointment opportunities...');
            await loadDueQueue();
          });
        }
        if (dueOpportunityTabs) {
          dueOpportunityTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var filterKey = String(target.getAttribute('data-due-opportunity') || '').trim() || 'all';
            if (filterKey === dueQueueOpportunityFilter) return;
            dueQueueOpportunityFilter = filterKey;
            dueQueueWorkspace = filterKey === 'appointment_growth'
              ? 'appointments'
              : filterKey === 'retail_opportunity'
                ? 'retail'
                : filterKey === 'referral_opportunity'
                  ? 'referral'
                  : filterKey === 'review_opportunity'
                    ? 'review'
                    : 'all';
            syncDueWorkspaceTabs();
            syncDueOpportunityTabs();
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing selected opportunity type.');
              return;
            }
            dueQueueOffset = 0;
            renderDueCriteriaNote();
            setDueQueueLoadingState('Loading selected opportunity type...');
            await loadDueQueue();
          });
        }
        if (dueWorkflowTabs) {
          dueWorkflowTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var filterKey = String(target.getAttribute('data-due-workflow') || '').trim() || 'all';
            if (filterKey === dueQueueWorkflowFilter) return;
            if (filterKey === 'mine') {
              await ensureDueQueueManagerSession();
            }
            dueQueueWorkflowFilter = filterKey;
            syncDueWorkflowTabs();
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing ' + filterKey.replace(/_/g, ' ') + ' queue.');
              return;
            }
            dueQueueOffset = 0;
            renderDueCriteriaNote();
            setDueQueueLoadingState('Loading ' + filterKey.replace(/_/g, ' ') + ' queue...');
            await loadDueQueue();
          });
        }
        if (dueOwnerTabs) {
          dueOwnerTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var filterKey = String(target.getAttribute('data-due-owner') || '').trim() || 'all';
            if (filterKey === dueQueueOwnerFilter) return;
            if (filterKey === 'mine') {
              await ensureDueQueueManagerSession();
            }
            dueQueueOwnerFilter = filterKey;
            syncDueOwnerTabs();
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing updated ownership filter.');
              return;
            }
            dueQueueOffset = 0;
            renderDueCriteriaNote();
            setDueQueueLoadingState('Loading ownership filter...');
            await loadDueQueue();
          });
        }
        if (dueScorecardRangeTabs) {
          dueScorecardRangeTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var rangeValue = Number(String(target.getAttribute('data-due-scorecard-range') || '').trim() || '30');
            var nextValue = rangeValue === 90 ? 90 : 30;
            if (nextValue === dueScorecardLookbackDays) return;
            dueScorecardLookbackDays = nextValue;
            syncDueScorecardRangeTabs();
            setDueQueueLoadingState('Refreshing manager results...');
            await loadDueQueue();
          });
        }
        if (dueScorecardAudienceTabs) {
          dueScorecardAudienceTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var focusValue = String(target.getAttribute('data-due-scorecard-focus') || '').trim() || 'team';
            var nextFocus = focusValue === 'mine' ? 'mine' : 'team';
            if (nextFocus === dueScorecardFocus) return;
            if (nextFocus === 'mine') {
              await ensureDueQueueManagerSession();
            }
            dueScorecardFocus = nextFocus;
            syncDueScorecardAudienceTabs();
            setDueQueueLoadingState('Refreshing manager results...');
            await loadDueQueue();
          });
        }
        if (dueSortSelect) {
          dueSortSelect.addEventListener('change', async function(){
            dueQueueSortMode = String((dueSortSelect && dueSortSelect.value) || '').trim() || 'priority_score';
            dueQueueVisibleCount = dueQueuePageSize;
            dueQueueOffset = 0;
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing updated sort order.');
              return;
            }
            scheduleDueQueueRefresh('Resorting opportunities...', {
              status_message: 'Showing updated sort order.'
            });
          });
        }
        if (dueQueueTabs) {
          dueQueueTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var filterKey = String(target.getAttribute('data-due-filter') || '').trim();
            if (!filterKey || filterKey === dueQueueActiveFilter) return;
            dueQueueActiveFilter = filterKey;
            syncDueQueueTabs();
            dueQueueOffset = 0;
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing updated queue view.');
              return;
            }
            setDueQueueLoadingState('Refreshing queue view...');
            await loadDueQueue();
          });
        }
        if (dueDuplicatesOnly) {
          dueDuplicatesOnly.addEventListener('change', async function(){
            dueQueueVisibleCount = dueQueuePageSize;
            dueQueueOffset = 0;
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing updated queue filters.');
              return;
            }
            scheduleDueQueueRefresh('Refreshing filters...', {
              status_message: 'Showing updated queue filters.'
            });
          });
        }
        if (dueHasPhoneOnly) {
          dueHasPhoneOnly.addEventListener('change', async function(){
            dueQueueVisibleCount = dueQueuePageSize;
            dueQueueOffset = 0;
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing updated queue filters.');
              return;
            }
            scheduleDueQueueRefresh('Refreshing filters...', {
              status_message: 'Showing updated queue filters.'
            });
          });
        }
        if (dueHasEmailOnly) {
          dueHasEmailOnly.addEventListener('change', async function(){
            dueQueueVisibleCount = dueQueuePageSize;
            dueQueueOffset = 0;
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing updated queue filters.');
              return;
            }
            scheduleDueQueueRefresh('Refreshing filters...', {
              status_message: 'Showing updated queue filters.'
            });
          });
        }
        if (dueClientTypeTabs) {
          dueClientTypeTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var filterKey = String(target.getAttribute('data-due-client-type') || '').trim();
            if (!filterKey || filterKey === dueQueueActiveClientType) return;
            dueQueueActiveClientType = filterKey;
            syncDueClientTypeTabs();
            dueQueueOffset = 0;
            renderDueCriteriaNote();
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing selected client segment.');
              return;
            }
            setDueQueueLoadingState('Loading client segment...');
            await loadDueQueue();
          });
        }
        if (dueStaffFilter) {
          dueStaffFilter.addEventListener('input', async function(){
            dueQueueVisibleCount = dueQueuePageSize;
            dueQueueOffset = 0;
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Filtering by staff name...');
              return;
            }
            scheduleDueQueueRefresh('Searching queue...', {
              status_message: 'Filtering by staff name...',
              delay_ms: 180
            });
          });
        }
        if (dueSearchFilter) {
          dueSearchFilter.addEventListener('input', async function(){
            dueQueueVisibleCount = dueQueuePageSize;
            dueQueueOffset = 0;
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Filtering opportunities by guest name...');
              return;
            }
            scheduleDueQueueRefresh('Searching queue...', {
              status_message: 'Filtering opportunities by guest name...',
              delay_ms: 180
            });
          });
        }
        if (dueCategoryFilter) {
          dueCategoryFilter.addEventListener('change', async function(){
            renderDueCriteriaNote();
            dueQueueVisibleCount = dueQueuePageSize;
            dueQueueOffset = 0;
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing selected category.');
              return;
            }
            scheduleDueQueueRefresh('Filtering by category...', {
              status_message: 'Showing selected category.'
            });
          });
        }
        if (dueCadenceSourceFilter) {
          dueCadenceSourceFilter.addEventListener('change', async function(){
            renderDueCriteriaNote();
            dueQueueVisibleCount = dueQueuePageSize;
            dueQueueOffset = 0;
            if (dueCanRenderLocally()) {
              rerenderDueQueueLocally('Showing selected cadence pattern.');
              return;
            }
            scheduleDueQueueRefresh('Filtering by cadence...', {
              status_message: 'Showing selected cadence pattern.'
            });
          });
        }
        if (dueQueueList) {
          dueQueueList.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            if (target.hasAttribute('data-due-toggle-rhythm')) {
              var rhythmCard = target.closest ? target.closest('[data-due-card]') : null;
              var rhythmDetails = rhythmCard ? rhythmCard.querySelector('[data-due-rhythm]') : null;
              if (rhythmDetails) {
                event.preventDefault();
                var shouldOpenRhythm = rhythmDetails.hasAttribute('hidden') || !rhythmDetails.open;
                if (shouldOpenRhythm) {
                  rhythmDetails.removeAttribute('hidden');
                  rhythmDetails.open = true;
                } else {
                  rhythmDetails.open = false;
                  rhythmDetails.setAttribute('hidden', 'hidden');
                }
                if (shouldOpenRhythm) {
                  rhythmDetails.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                }
              }
              return;
            }
            if (target.hasAttribute('data-due-toggle-details')) {
              var toggleCard = target.closest ? target.closest('[data-due-card]') : null;
              var toggleDetails = toggleCard ? toggleCard.querySelector('[data-due-details]') : null;
              if (toggleDetails) {
                event.preventDefault();
                var shouldOpen = toggleDetails.hasAttribute('hidden') || !toggleDetails.open;
                if (shouldOpen) {
                  toggleDetails.removeAttribute('hidden');
                  toggleDetails.open = true;
                } else {
                  toggleDetails.open = false;
                  toggleDetails.setAttribute('hidden', 'hidden');
                }
                if (shouldOpen) {
                  toggleDetails.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                }
              }
              return;
            }
            if (target.hasAttribute('data-due-toggle-payload')) {
              var payloadCard = target.closest ? target.closest('[data-due-card]') : null;
              var payloadDetails = payloadCard ? payloadCard.querySelector('[data-due-payload]') : null;
              if (payloadDetails) {
                event.preventDefault();
                var shouldOpenPayload = payloadDetails.hasAttribute('hidden') || !payloadDetails.open;
                if (shouldOpenPayload) {
                  payloadDetails.removeAttribute('hidden');
                  payloadDetails.open = true;
                } else {
                  payloadDetails.open = false;
                  payloadDetails.setAttribute('hidden', 'hidden');
                }
                if (shouldOpenPayload) {
                  payloadDetails.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                }
              }
              return;
            }
            var reviewCopyText = String(target.getAttribute('data-review-copy-sms') || '').trim();
            if (reviewCopyText) {
              try {
                target.disabled = true;
                await navigator.clipboard.writeText(reviewCopyText);
                setDueStatus('Review outreach copied to clipboard.', 'success');
              } catch (error) {
                setDueStatus(humanizeClientFetchErrorMessage(error, 'Could not copy review outreach.'), 'error');
              } finally {
                target.disabled = false;
              }
              return;
            }
            var taskAction = String(target.getAttribute('data-task-action') || '').trim();
            if (taskAction) {
              var opportunityKey = String(target.getAttribute('data-opportunity-key') || '').trim();
              var taskRow = retailArray(dueQueueRows).find(function(row){
                return retailTextValue(row && row.opportunity_key, '') === opportunityKey;
              });
              if (!taskRow) return;
              try {
                target.disabled = true;
                setDueStatus(taskAction === 'assigned' ? 'Claiming opportunity...' : 'Updating task state...');
                var updatedTask = hydrateClaimedBusinessDevelopmentTask(
                  await updateBusinessDevelopmentTask(taskRow, taskAction),
                  taskAction
                );
                syncLocalClaimedRowFromTask(taskRow, updatedTask);
                if (taskAction === 'assigned') {
                  applyDueWorkspaceSelection('my_claimed');
                  dueQueueOffset = 0;
                  syncDueWorkspaceTabs();
                  syncDueWorkflowTabs();
                  syncDueOwnerTabs();
                }
                applyUpdatedBusinessDevelopmentTaskToQueue(updatedTask);
                if (dueCanRenderLocally()) {
                  renderDueQueue();
                }
                setDueStatus(taskAction === 'assigned' ? 'Claimed. Moved to My Claimed Opportunities.' : 'Task state updated.', 'success');
                loadDueQueue({ background: true }).catch(function(){});
              } catch (error) {
                setDueStatus(humanizeClientFetchErrorMessage(error, 'Could not update task state.'), 'error');
                target.disabled = false;
              }
              return;
            }
            var outcomeAction = String(target.getAttribute('data-outcome-action') || '').trim();
            if (outcomeAction) {
              var outcomeOpportunityKey = String(target.getAttribute('data-opportunity-key') || '').trim();
              var outcomeRow = retailArray(dueQueueRows).find(function(row){
                return retailTextValue(row && row.opportunity_key, '') === outcomeOpportunityKey;
              });
              if (!outcomeRow) return;
              try {
                target.disabled = true;
                setDueStatus('Recording outcome...');
                var updatedOutcome = await updateBusinessDevelopmentOutcome(outcomeRow, outcomeAction);
                applyUpdatedBusinessDevelopmentOutcomeToQueue(updatedOutcome);
                if (dueCanRenderLocally()) {
                  renderDueQueue();
                }
                setDueStatus('Outcome recorded.', 'success');
                loadDueQueue({ background: true }).catch(function(){});
              } catch (error) {
                setDueStatus(humanizeClientFetchErrorMessage(error, 'Could not record outcome.'), 'error');
                target.disabled = false;
              }
              return;
            }
            var action = String(target.getAttribute('data-due-action') || '').trim();
            var bucketKey = String(target.getAttribute('data-due-bucket-key') || '').trim();
            if (!action || !bucketKey) return;
            var card = target.closest ? target.closest('[data-due-card]') : null;
            var offerSelect = card ? card.querySelector('[data-due-offer-select]') : null;
            var customOfferInput = card ? card.querySelector('[data-due-custom-offer]') : null;
            var draftEditor = card ? card.querySelector('[data-due-draft-editor]') : null;
            var reviewedToggle = card ? card.querySelector('[data-due-reviewed]') : null;
            var offerKey = String((offerSelect && offerSelect.value) || 'none').trim() || 'none';
            var offerOption = getDueOfferOption(offerKey);
            var offerText = offerKey === 'custom'
              ? String((customOfferInput && customOfferInput.value) || '').trim()
              : getDueOfferText(offerKey);
            var offerLabel = offerOption ? retailTextValue(offerOption.label, '') : '';
            var offerId = offerOption ? retailTextValue(offerOption.boulevard_offer_id, '') : '';
            var offerCode = offerOption ? retailTextValue(offerOption.boulevard_offer_code, '') : '';
            var offerName = offerOption ? retailTextValue(offerOption.boulevard_offer_name, '') : '';
            target.disabled = true;
            try {
              if (action === 'draft') {
                setDueStatus('Drafting recapture text...');
                var draftResult = await createDueQueueDraft(bucketKey, {
                  offerKey: offerKey,
                  offerText: offerText,
                  offerLabel: offerLabel,
                  offerId: offerId,
                  offerCode: offerCode,
                  offerName: offerName
                });
                if (draftEditor && draftResult && draftResult.message_body) {
                  draftEditor.value = String(draftResult.message_body || '');
                }
                if (reviewedToggle) {
                  reviewedToggle.checked = false;
                  reviewedToggle.disabled = !(draftResult && draftResult.message_body);
                }
                setDueStatus('Draft ready for review.', 'success');
                loadDueQueue({ background: true }).catch(function(){});
                return;
              }
              if (action === 'send') {
                setDueStatus('Sending recapture text...');
                var sendResult = await sendDueQueueText(bucketKey, {
                  offerKey: offerKey,
                  offerText: offerText,
                  offerLabel: offerLabel,
                  offerId: offerId,
                  offerCode: offerCode,
                  offerName: offerName,
                  messageBody: String((draftEditor && draftEditor.value) || '').trim(),
                  reviewed: !!(reviewedToggle && reviewedToggle.checked)
                });
                if (sendResult && sendResult.canceled) {
                  setDueStatus('Send canceled.', 'warning');
                  target.disabled = false;
                  return;
                }
                setDueStatus('Text sent via ClickSend.', 'success');
                loadDueQueue({ background: true }).catch(function(){});
                return;
              }
              if (action === 'mark-contacted') {
                setDueStatus('Marking guest as contacted...');
                await markDueQueueContacted(bucketKey, {
                  offerKey: offerKey,
                  offerText: offerText,
                  offerLabel: offerLabel,
                  offerId: offerId,
                  offerCode: offerCode,
                  offerName: offerName,
                  messageBody: String((draftEditor && draftEditor.value) || '').trim()
                });
                setDueStatus('Guest marked as contacted.', 'success');
                loadDueQueue({ background: true }).catch(function(){});
                return;
              }
              if (action === 'snooze-7') {
                setDueStatus('Snoozing guest for 7 days...');
                await snoozeDueQueueRow(bucketKey, 7, 'snoozed');
                setDueStatus('Guest snoozed for 7 days.', 'success');
                loadDueQueue({ background: true }).catch(function(){});
                return;
              }
              if (action === 'dismiss-30') {
                setDueStatus('Dismissing guest for 30 days...');
                await snoozeDueQueueRow(bucketKey, 30, 'dismissed');
                setDueStatus('Guest dismissed for 30 days.', 'success');
                loadDueQueue({ background: true }).catch(function(){});
                return;
              }
            } catch (error) {
              setDueStatus(humanizeClientFetchErrorMessage(error, 'Could not update recapture outreach.'), 'error');
              target.disabled = false;
            }
          });
          dueQueueList.addEventListener('change', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            if (target.hasAttribute('data-due-offer-select')) {
              var card = target.closest ? target.closest('[data-due-card]') : null;
              var customWrap = card ? card.querySelector('[data-due-custom-offer-wrap]') : null;
              if (customWrap) {
                customWrap.hidden = String(target.value || '').trim() !== 'custom';
              }
              return;
            }
            if (target.hasAttribute('data-due-reviewed')) {
              var reviewedCard = target.closest ? target.closest('[data-due-card]') : null;
              var sendButton = reviewedCard ? reviewedCard.querySelector('[data-due-action="send"]') : null;
              var draftEditor = reviewedCard ? reviewedCard.querySelector('[data-due-draft-editor]') : null;
              if (sendButton) {
                sendButton.disabled = !(target.checked && String((draftEditor && draftEditor.value) || '').trim());
              }
            }
          });
        }
        if (duePrevPageBtn) {
          duePrevPageBtn.addEventListener('click', async function(){
            dueQueueVisibleCount = Math.max(dueQueuePageSize, dueQueueVisibleCount - dueQueuePageSize);
            dueQueueOffset = 0;
            renderDueQueue();
          });
        }
        if (dueNextPageBtn) {
          dueNextPageBtn.addEventListener('click', async function(){
            await advanceDueQueueVisibleRows();
          });
        }
        if (dueBottomLoadMoreBtn) {
          dueBottomLoadMoreBtn.addEventListener('click', async function(){
            await advanceDueQueueVisibleRows();
          });
        }
        if (bdFastRefreshV4Btn) {
          bdFastRefreshV4Btn.addEventListener('click', async function(){
            await previewBdFastQueueRefreshV4();
          });
        }
        if (bdFastRefreshPreviewCancelBtn) {
          bdFastRefreshPreviewCancelBtn.addEventListener('click', function(){
            closeBdFastRefreshPreview();
          });
        }
        if (bdFastRefreshPreviewConfirmBtn) {
          bdFastRefreshPreviewConfirmBtn.addEventListener('click', async function(){
            var previewState = bdFastRefreshPreviewState;
            closeBdFastRefreshPreview();
            if (!previewState || !Array.isArray(previewState.guest_bucket_keys) || !previewState.guest_bucket_keys.length) return;
            await refreshBdFastQueueV4(previewState.guest_bucket_keys);
          });
        }
        if (bdFastRefreshPreviewDialog) {
          bdFastRefreshPreviewDialog.addEventListener('cancel', function(event){
            if (event && event.preventDefault) event.preventDefault();
            closeBdFastRefreshPreview();
          });
        }
        if (bdFastSearch) {
          bdFastSearch.addEventListener('input', function(){
            if (bdFastSearchTimer) window.clearTimeout(bdFastSearchTimer);
            bdFastSearchTimer = window.setTimeout(function(){
              bdFastPage = 0;
              renderBdFastQueue();
            }, 160);
          });
        }
        if (bdFastMode) {
          syncBdFastModeOptions();
          bdFastMode.addEventListener('change', function(){
            bdFastPage = 0;
            clearBdFastRefreshStatusPolling();
            var nextMode = bdFastLaneFetchMode(bdFastCurrentLane());
            var nextState = bdFastReadModeState(nextMode);
            if ((nextState.loading === true || nextState.hasLoaded === true || bdFastStateHasRenderableRows(nextState)) && bdFastStateMatchesMode(nextState, nextMode)) {
              bdFastApplyModeStateToGlobals(nextMode);
              setBdFastShellState(nextState.allRowsLoaded === true ? 'ready' : 'loading');
              setBdFastStatus(
                nextState.allRowsLoaded === true
                  ? 'Fast queue ready.'
                  : 'Showing the first rows now. Loading the rest in the background…',
                nextState.allRowsLoaded === true ? 'success' : 'info'
              );
              renderBdFastQueue();
              return;
            }
            loadBdFastAllLaneData({ reset: true, clearUi: false, forceRefresh: true }).catch(function(error){
              setBdFastShellState('error');
              setBdFastStatus(humanizeClientFetchErrorMessage(error, 'Could not reload the fast queue.'), 'error');
            });
          });
        }
        if (bdFastModeTabs) {
          bdFastModeTabs.addEventListener('click', function(event){
            var target = event && event.target;
            if (!target || !target.closest || !bdFastMode) return;
            var tabButton = target.closest('[data-bd-fast-mode-tab]');
            if (!tabButton) return;
            var nextMode = String(tabButton.getAttribute('data-bd-fast-mode-tab') || '').trim();
            if (!nextMode || nextMode === bdFastCurrentLane()) return;
            bdFastPersistCurrentModeState();
            syncBdFastModeOptions();
            bdFastMode.value = nextMode;
            bdFastMode.dispatchEvent(new Event('change'));
          });
        }
        if (bdFastHistoryBtn) {
          bdFastHistoryBtn.addEventListener('click', function(){
            if (!bdFastMode) return;
            bdFastPersistCurrentModeState();
            bdFastMode.value = bdFastIsHistoryView() ? BD_FAST_ACTIVE_VIEW_KEY : 'acted_on';
            bdFastMode.dispatchEvent(new Event('change'));
          });
        }
        if (bdFastScorecardRangeTabs) {
          bdFastScorecardRangeTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.closest) return;
            var button = target.closest('[data-bd-fast-scorecard-range]');
            if (!button) return;
            var nextValue = Number(String(button.getAttribute('data-bd-fast-scorecard-range') || '').trim() || '30');
            if (!nextValue || nextValue === bdFastScorecardLookbackDays) return;
            bdFastScorecardLookbackDays = nextValue;
            await loadBdFastScorecard().catch(function(){
              if (bdFastScorecardMount) bdFastScorecardMount.innerHTML = '<div class="retail-empty">Could not load SMS performance right now.</div>';
            });
          });
        }
        if (bdFastScorecardAudienceTabs) {
          bdFastScorecardAudienceTabs.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.closest) return;
            var button = target.closest('[data-bd-fast-scorecard-focus]');
            if (!button) return;
            var nextFocus = String(button.getAttribute('data-bd-fast-scorecard-focus') || '').trim() || 'team';
            if (nextFocus === bdFastScorecardFocus) return;
            bdFastScorecardFocus = nextFocus;
            if (!bdFastScorecard) {
              await loadBdFastScorecard().catch(function(){
                if (bdFastScorecardMount) bdFastScorecardMount.innerHTML = '<div class="retail-empty">Could not load SMS performance right now.</div>';
              });
              return;
            }
            syncBdFastScorecardControls();
            renderBdFastScorecard();
          });
        }
        [bdFastSort].forEach(function(control){
          if (!control) return;
          control.addEventListener('change', function(){
            bdFastPage = 0;
            renderBdFastQueue();
          });
        });
        if (bdFastPrevBtn) {
          bdFastPrevBtn.addEventListener('click', function(){
            bdFastPage = Math.max(0, bdFastPage - 1);
            renderBdFastQueue();
          });
        }
        if (bdFastNextBtn) {
          bdFastNextBtn.addEventListener('click', function(){
            bdFastPage += 1;
            renderBdFastQueue();
          });
        }
        if (bdFastQueueSelectedBtn) {
          bdFastQueueSelectedBtn.addEventListener('click', async function(){
            await queueBdFastSelectedRows();
          });
        }
        if (bdFastList) {
          bdFastList.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var fastAction = String(target.getAttribute('data-bd-fast-action') || '').trim();
            if (fastAction) {
              var rowKey = String(target.getAttribute('data-bd-fast-row-key') || '').trim();
              await performBdFastOutreachAction(fastAction, rowKey, target.closest ? target.closest('[data-bd-fast-row]') : null, target);
              return;
            }
            if (target.closest && target.closest('input, textarea, select, label')) {
              return;
            }
            if (target.closest && target.closest('.bd-fastExpanded')) {
              return;
            }
            var openKey = String(target.getAttribute('data-bd-fast-open') || '').trim();
            if (!openKey && target.closest) {
              var rowCard = target.closest('[data-bd-fast-row]');
              openKey = rowCard ? String(rowCard.getAttribute('data-bd-fast-row') || '').trim() : '';
            }
            if (openKey) {
              var openRow = retailArray(bdFastAllRows).find(function(row){
                return retailTextValue(row && row.opportunity_key, '') === openKey;
              });
              var willOpen = bdFastSelectedOpportunityKey !== openKey;
              bdFastSelectedOpportunityKey = willOpen ? openKey : '';
              renderBdFastQueue();
              if (willOpen && openRow) {
                loadBdFastDetailForRow(openRow).catch(function(){});
              }
            }
          });
          bdFastList.addEventListener('input', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var draftEditorKey = String(target.getAttribute('data-bd-fast-draft-editor') || '').trim();
            if (draftEditorKey) {
              var draftValue = String(target.value || '').trim();
              bdFastPersistOutreachState(draftEditorKey, {
                draftBody: draftValue,
                reviewed: !!draftValue
              });
              renderBdFastClaimedList();
            }
          });
          bdFastList.addEventListener('change', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var offerSelectKey = String(target.getAttribute('data-bd-fast-offer-select') || '').trim();
            if (offerSelectKey) {
              bdFastPersistOutreachState(offerSelectKey, {
                offerKey: String(target.value || 'none').trim() || 'none'
              });
              var offerRow = retailArray(bdFastAllRows).find(function(row){
                return bdFastOutreachStateKey(row) === offerSelectKey;
              });
              if (offerRow) {
                ensureBdFastDraftForRow(offerRow, { force: true }).then(function(){
                  renderBdFastQueue();
                }).catch(function(){});
              }
              return;
            }
          });
        }
        if (bdFastDetailPanel) {
          bdFastDetailPanel.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            if (target.closest) {
              var opportunityPickButton = target.closest('[data-bd-fast-opportunity-pick]');
              if (opportunityPickButton) {
                var pickRowKey = String(opportunityPickButton.getAttribute('data-bd-fast-opportunity-pick') || '').trim();
                var pickLaneKey = String(opportunityPickButton.getAttribute('data-bd-fast-opportunity-lane') || '').trim();
                if (pickRowKey && pickLaneKey) {
                  bdFastSetSelectedOpportunityLane(pickRowKey, pickLaneKey);
                  var pickedRow = retailArray(bdFastAllRows).find(function(row){
                    return retailTextValue(row && row.opportunity_key, '') === pickRowKey;
                  });
                  renderBdFastClaimedList();
                  if (pickedRow) {
                    loadBdFastAiStrategyForRow(pickedRow).catch(function(){});
                  }
                }
                return;
              }
              var detailTabButton = target.closest('[data-bd-fast-detail-tab]');
              if (detailTabButton) {
                bdFastSetDetailTab(
                  String(detailTabButton.getAttribute('data-bd-fast-row-key') || '').trim(),
                  String(detailTabButton.getAttribute('data-bd-fast-detail-tab') || '').trim()
                );
                return;
              }
            }
            var fastAction = String(target.getAttribute('data-bd-fast-action') || '').trim();
            if (fastAction) {
              var rowKey = String(target.getAttribute('data-bd-fast-row-key') || '').trim();
              await performBdFastOutreachAction(fastAction, rowKey, target.closest ? target.closest('[data-bd-fast-outreach]') : null, target);
              return;
            }
            var removeKey = String(target.getAttribute('data-bd-fast-queue-remove') || '').trim();
            if (removeKey) {
              bdFastSmsQueueOrder = bdFastSmsQueueOrder.filter(function(key){
                return key !== removeKey;
              });
              renderBdFastQueue();
            }
          });
          bdFastDetailPanel.addEventListener('input', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var draftEditorKey = String(target.getAttribute('data-bd-fast-draft-editor') || '').trim();
            if (draftEditorKey) {
              var draftValue = String(target.value || '').trim();
              bdFastPersistOutreachState(draftEditorKey, {
                draftBody: draftValue,
                reviewed: !!draftValue
              });
              return;
            }
            var productSearchKey = String(target.getAttribute('data-bd-fast-product-search') || '').trim();
            if (productSearchKey) {
              queueBdFastRetailProductCatalogSearch(productSearchKey, String(target.value || ''));
            }
          });
          bdFastDetailPanel.addEventListener('change', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var offerSelectKey = String(target.getAttribute('data-bd-fast-offer-select') || '').trim();
            if (!offerSelectKey) return;
            bdFastPersistOutreachState(offerSelectKey, {
              offerKey: String(target.value || 'none').trim() || 'none'
            });
            var offerRow = retailArray(bdFastAllRows).find(function(row){
              return bdFastOutreachStateKey(row) === offerSelectKey;
            });
            if (offerRow) {
              ensureBdFastDraftForRow(offerRow, { force: true }).then(function(){
                renderBdFastQueue();
              }).catch(function(){});
            }
          });
          bdFastDetailPanel.addEventListener('click', function(event){
            var target = event && event.target;
            if (!target || !target.closest) return;
            var addButton = target.closest('[data-bd-fast-product-pick]');
            if (addButton) {
              bdFastAddManualProductTag(
                String(addButton.getAttribute('data-bd-fast-product-pick') || '').trim(),
                String(addButton.getAttribute('data-bd-fast-product-handle') || '').trim()
              );
              return;
            }
            var removeButton = target.closest('[data-bd-fast-product-remove]');
            if (removeButton) {
              bdFastRemoveManualProductTag(
                String(removeButton.getAttribute('data-bd-fast-product-remove') || '').trim(),
                String(removeButton.getAttribute('data-bd-fast-product-handle') || '').trim()
              );
            }
          });
        }
        if (retailOpportunityList) {
          retailOpportunityList.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var appointmentId = String(target.getAttribute('data-retail-queue-appointment-id') || '').trim();
            if (!appointmentId) return;
            try {
              target.disabled = true;
              setRetailStatus('Queueing SMS draft...');
              await queueRetailOutreachDraft(appointmentId);
              setRetailStatus('Retail SMS draft queued.', 'success');
              await loadRetailDashboard();
            } catch (error) {
              setRetailStatus(humanizeClientFetchErrorMessage(error, 'Could not queue retail SMS draft.'), 'error');
              target.disabled = false;
            }
          });
        }
        if (retailQueuedList) {
          retailQueuedList.addEventListener('click', async function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var queueId = String(
              target.getAttribute('data-retail-mark-sent-id')
              || target.getAttribute('data-retail-save-draft-id')
              || target.getAttribute('data-retail-mark-reviewed-id')
              || target.getAttribute('data-retail-skip-id')
              || target.getAttribute('data-retail-regenerate-id')
              || ''
            ).trim();
            if (!queueId) return;
            var card = target.closest('[data-retail-queue-card]') || retailQueuedList;
            var draftEditor = card ? card.querySelector('[data-retail-draft-editor]') : null;
            var draftedText = String(draftEditor && draftEditor.value || '').trim();
            try {
              target.disabled = true;
              if (target.hasAttribute('data-retail-save-draft-id')) {
                setRetailStatus('Saving draft...');
                await updateRetailOutreachDraft(queueId, draftedText, false);
                setRetailStatus('Draft saved.', 'success');
              } else if (target.hasAttribute('data-retail-mark-reviewed-id')) {
                setRetailStatus('Marking draft reviewed...');
                await updateRetailOutreachDraft(queueId, draftedText, true);
                setRetailStatus('Draft marked reviewed.', 'success');
              } else if (target.hasAttribute('data-retail-mark-sent-id')) {
                setRetailStatus('Marking retail outreach sent...');
                await markRetailOutreachSent(queueId);
                setRetailStatus('Retail outreach marked sent.', 'success');
              } else if (target.hasAttribute('data-retail-skip-id')) {
                var skipReason = window.prompt('Optional skip reason:', '') || '';
                setRetailStatus('Skipping retail outreach...');
                await skipRetailOutreach(queueId, skipReason);
                setRetailStatus('Retail outreach skipped.', 'success');
              } else if (target.hasAttribute('data-retail-regenerate-id')) {
                var force = window.confirm('If this draft was edited, regenerating will overwrite manager changes. Continue?');
                setRetailStatus('Regenerating draft...');
                await regenerateRetailOutreachDraft(queueId, force);
                setRetailStatus('Draft regenerated.', 'success');
              }
              await loadRetailDashboard();
            } catch (error) {
              setRetailStatus(humanizeClientFetchErrorMessage(error, 'Could not update retail outreach status.'), 'error');
              target.disabled = false;
            }
          });
        }
        copyDebugBtn.addEventListener('click', async function(){
          try {
            await navigator.clipboard.writeText(JSON.stringify(lastDebugPayload || {}, null, 2));
            setStatus('Debug JSON copied.');
          } catch (_error) {
            setStatus('Could not copy debug JSON.');
          }
        });
        if (requestOffStaff) {
          requestOffStaff.addEventListener('change', function(){
            syncRequestOffScopeOptions();
            renderRequestOffSelectedStaff();
          });
        }
        if (requestOffDate) {
          requestOffDate.addEventListener('change', function(){
            syncRequestOffScopeOptions();
            renderRequestOffSelectedStaff();
          });
        }
        if (requestOffScope) {
          requestOffScope.addEventListener('change', function(){
            renderRequestOffSelectedStaff();
          });
        }
        manualOpenShiftDate.addEventListener('change', function(){
          renderManualOpenShiftShiftOptions();
        });
        if (manualOpenShiftShift) {
          manualOpenShiftShift.addEventListener('change', function(){
            syncManualOpenShiftCustomField();
          });
        }
        if (coveragePrevWeekBtn) {
          coveragePrevWeekBtn.addEventListener('click', function(){
            coverageWeekOffset -= 1;
            renderCoverageCalendarWeek();
          });
        }
        if (coverageNextWeekBtn) {
          coverageNextWeekBtn.addEventListener('click', function(){
            coverageWeekOffset += 1;
            renderCoverageCalendarWeek();
          });
        }
        if (managerCalendarViewToggle) {
          managerCalendarViewToggle.addEventListener('click', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var nextView = String(target.getAttribute('data-calendar-view') || '').trim();
            if (nextView !== 'week' && nextView !== 'month') return;
            if (managerCalendarView === nextView) return;
            managerCalendarView = nextView;
            managerCalendarLoadedRangeKey = '';
            ensureManagerCalendarLoaded(true);
          });
        }
        if (managerCalendarTodayBtn) {
          managerCalendarTodayBtn.addEventListener('click', function(){
            managerCalendarAnchorDate = startOfLocalDay(new Date());
            managerCalendarLoadedRangeKey = '';
            ensureManagerCalendarLoaded(true);
          });
        }
        if (managerCalendarPrevBtn) {
          managerCalendarPrevBtn.addEventListener('click', function(){
            managerCalendarAnchorDate = managerCalendarView === 'week'
              ? new Date(managerCalendarAnchorDate.getFullYear(), managerCalendarAnchorDate.getMonth(), managerCalendarAnchorDate.getDate() - 7)
              : new Date(managerCalendarAnchorDate.getFullYear(), managerCalendarAnchorDate.getMonth() - 1, 1);
            managerCalendarLoadedRangeKey = '';
            ensureManagerCalendarLoaded(true);
          });
        }
        if (managerCalendarNextBtn) {
          managerCalendarNextBtn.addEventListener('click', function(){
            managerCalendarAnchorDate = managerCalendarView === 'week'
              ? new Date(managerCalendarAnchorDate.getFullYear(), managerCalendarAnchorDate.getMonth(), managerCalendarAnchorDate.getDate() + 7)
              : new Date(managerCalendarAnchorDate.getFullYear(), managerCalendarAnchorDate.getMonth() + 1, 1);
            managerCalendarLoadedRangeKey = '';
            ensureManagerCalendarLoaded(true);
          });
        }
        if (managerCalendarMount) {
          managerCalendarMount.addEventListener('click', function(event){
            var target = event && event.target;
            if (!target || !target.closest) return;
            var openTrigger = target.closest('[data-calendar-open]');
            var deleteTrigger = target.closest('[data-calendar-delete]');
            var editTrigger = target.closest('[data-calendar-item-edit]');
            var openDateKey = String(openTrigger && openTrigger.getAttribute('data-calendar-open') || '').trim();
            var editId = String(editTrigger && editTrigger.getAttribute('data-calendar-item-edit') || '').trim();
            if (deleteTrigger) {
              var deleteId = String(deleteTrigger.getAttribute('data-calendar-delete') || '').trim();
              if (deleteId) {
                deleteManagerCalendarItemById(deleteId);
              }
              return;
            }
            if (editId) {
              openManagerCalendarItemEditor(editId);
              return;
            }
            if (openDateKey) {
              openManagerCalendarModal(openDateKey);
              return;
            }
          });
        }
        if (managerCalendarModalBackdrop) {
          managerCalendarModalBackdrop.addEventListener('click', function(event){
            if (event.target === managerCalendarModalBackdrop) {
              closeManagerCalendarModal();
            }
          });
        }
        if (managerCalendarModalClose) {
          managerCalendarModalClose.addEventListener('click', closeManagerCalendarModal);
        }
        if (managerCalendarModalCancel) {
          managerCalendarModalCancel.addEventListener('click', closeManagerCalendarModal);
        }
        if (managerCalendarModalSave) {
          managerCalendarModalSave.addEventListener('click', function(){
            if (!managerCalendarActiveModalDate) return;
            saveManagerCalendarItemForDate(managerCalendarActiveModalDate);
          });
        }
        if (managerCalendarModalItemTitle) {
          managerCalendarModalItemTitle.addEventListener('keydown', function(event){
            if (event.key === 'Enter') {
              event.preventDefault();
              if (!managerCalendarActiveModalDate) return;
              saveManagerCalendarItemForDate(managerCalendarActiveModalDate);
            }
          });
        }
        if (managerCalendarModalAudienceChecklist) {
          managerCalendarModalAudienceChecklist.addEventListener('click', function(event){
            var target = event && event.target;
            var suggestion = target && typeof target.closest === 'function'
              ? target.closest('[data-calendar-audience-suggestion]')
              : null;
            if (!suggestion) return;
            event.preventDefault();
            setManagerCalendarAudienceValue(suggestion.getAttribute('data-calendar-audience-suggestion'), true);
            if (managerCalendarModalAudienceSearch) {
              managerCalendarModalAudienceSearch.value = '';
              managerCalendarAudienceSearchValue = '';
              filterManagerCalendarAudienceOptions();
              if (typeof managerCalendarModalAudienceSearch.focus === 'function') {
                managerCalendarModalAudienceSearch.focus();
              }
            }
          });
        }
        if (managerCalendarAudienceChips) {
          managerCalendarAudienceChips.addEventListener('click', function(event){
            var target = event && event.target;
            var chip = target && typeof target.closest === 'function'
              ? target.closest('[data-calendar-audience-chip]')
              : null;
            if (!chip) return;
            event.preventDefault();
            setManagerCalendarAudienceValue(chip.getAttribute('data-calendar-audience-chip'), false);
            if (managerCalendarModalAudienceSearch && typeof managerCalendarModalAudienceSearch.focus === 'function') {
              managerCalendarModalAudienceSearch.focus();
            }
          });
        }
        if (managerCalendarModalAudienceSearch) {
          managerCalendarModalAudienceSearch.addEventListener('input', function(event){
            managerCalendarAudienceSearchValue = String(event && event.target && event.target.value || '').trim().toLowerCase();
            filterManagerCalendarAudienceOptions();
          });
          managerCalendarModalAudienceSearch.addEventListener('search', function(event){
            managerCalendarAudienceSearchValue = String(event && event.target && event.target.value || '').trim().toLowerCase();
            filterManagerCalendarAudienceOptions();
          });
          managerCalendarModalAudienceSearch.addEventListener('keydown', function(event){
            if (event.key === 'Backspace' && !String(event && event.target && event.target.value || '').trim()) {
              var selectedValues = getManagerCalendarAudienceCheckedValues();
              if (selectedValues.length) {
                var lastValue = selectedValues[selectedValues.length - 1];
                if (lastValue && lastValue !== 'all_staff') {
                  event.preventDefault();
                  setManagerCalendarAudienceValue(lastValue, false);
                  return;
                }
              }
            }
            if (event.key !== 'Enter') return;
            event.preventDefault();
            selectFirstVisibleManagerCalendarAudienceOption();
          });
        }
        document.addEventListener('keydown', function(event){
          if (event.key === 'Escape' && managerCalendarModalBackdrop && !managerCalendarModalBackdrop.hidden) {
            closeManagerCalendarModal();
          }
        });
        masterScheduleWeekMount.addEventListener('change', async function(event){
          var target = event && event.target;
          if (!target || !target.getAttribute) return;
          var staffId = String(target.getAttribute('data-master-staff-id') || '').trim();
          var dayKey = String(target.getAttribute('data-master-day') || '').trim();
          var field = String(target.getAttribute('data-master-field') || 'shift').trim();
          if (!staffId || !dayKey) return;
          try {
            await saveMasterScheduleCell(staffId, dayKey, field, target.value);
          } catch (error) {
            setMasterScheduleStatus(String((error && error.message) || 'Could not save recurring schedule.'));
          }
        });
        if (requestOffSubmitBtn) {
          requestOffSubmitBtn.addEventListener('click', async function(){
            try {
              requestOffSubmitBtn.disabled = true;
              setRequestOffStatus('Sending request-off text...');
              var result = await submitRequestOffForm();
              var createdCount = Array.isArray(result.timeblocks) ? result.timeblocks.length : 0;
              var warnings = Array.isArray(result.timeblock_warnings) ? result.timeblock_warnings : [];
              var julianneCreated = !!(result && result.julianne_timeblock && result.julianne_timeblock.id);
              var scopeLabel = formatRequestOffScopeLabel(getRequestOffMeta(result && result.request_row).request_scope);
              var successMessage = 'Request off sent for '
                + String(result.staff_name || '')
                + ' on '
                + String((result.requested_dates && result.requested_dates[0]) || (requestOffDate && requestOffDate.value) || '')
                + ' (' + scopeLabel + ')'
                + '. Pending approval.';
              if (createdCount) {
                successMessage += ' Approved staff block already exists.';
              }
              if (julianneCreated) {
                successMessage += ' Julianne review block added.';
              } else if (warnings.length) {
                successMessage += ' Julianne review block was not created.';
              }
              if (!createdCount && warnings.length) {
                successMessage += ' Staff calendar block will be added when approved.';
              }
              setRequestOffStatus(
                warnings.length ? successMessage + ' ' + String(warnings[0] || '') : successMessage,
                warnings.length ? 'error' : 'success'
              );
              if (requestOffNote) requestOffNote.value = '';
              syncRequestOffScopeOptions();
              if (requestOffScope) requestOffScope.value = 'full_shift';
              renderRequestOffSelectedStaff();
              await refreshRequestOffQueue();
              setRequestReviewStatus('Request queue updated.', 'success');
            } catch (error) {
              setRequestOffStatus(humanizeClientFetchErrorMessage(error, 'Could not submit request off.'), 'error');
            } finally {
              requestOffSubmitBtn.disabled = false;
            }
          });
        }
        manualOpenShiftSubmitBtn.addEventListener('click', async function(){
          try {
            manualOpenShiftSubmitBtn.disabled = true;
            setOpenShiftStatus('Posting manual open shift...');
            var openShiftRow = await submitManualOpenShiftForm();
            shiftChangeQueue = Array.isArray(shiftChangeQueue) ? [openShiftRow].concat(shiftChangeQueue) : [openShiftRow];
            renderOpenShiftView();
            renderCoverageCalendarWeek();
            setOpenShiftStatus('Manual open shift posted for ' + String((openShiftRow && openShiftRow.request_date) || '') + '.', 'success');
            manualOpenShiftNote.value = '';
          } catch (error) {
            setOpenShiftStatus(humanizeClientFetchErrorMessage(error, 'Could not post manual open shift.'), 'error');
          } finally {
            manualOpenShiftSubmitBtn.disabled = false;
          }
        });
        requestReviewList.addEventListener('click', async function(event){
          var target = event && event.target && event.target.closest
            ? event.target.closest('button')
            : (event && event.target);
          if (!target || !target.getAttribute) return;
          if (String(target.getAttribute('data-fill-shift-submit') || '').trim()) {
            var fillOwnerType = String(target.getAttribute('data-fill-owner-type') || '').trim();
            var fillOwnerId = String(target.getAttribute('data-fill-owner-id') || '').trim();
            var fillTargetDate = String(target.getAttribute('data-fill-target-date') || '').trim();
            try {
              target.disabled = true;
              var fillMode = String((getFillShiftField(requestReviewList, fillOwnerType, fillOwnerId, fillTargetDate, 'mode') || {}).value || '').trim() || 'new_shift';
              var fillStaffId = String((getFillShiftField(requestReviewList, fillOwnerType, fillOwnerId, fillTargetDate, 'staff') || {}).value || '').trim();
              var fillStaff = getStaffOptionByIdOrName(fillStaffId, '');
              var shiftSelect = requestReviewList.querySelector('[data-open-shift-date="' + fillTargetDate + '"][data-open-shift-request-id="' + fillOwnerId + '"]');
              var shiftTypeSelect = requestReviewList.querySelector('[data-open-shift-type-date="' + fillTargetDate + '"][data-open-shift-request-id="' + fillOwnerId + '"]');
              var shiftLabel = String((shiftSelect && shiftSelect.value) || '').trim();
              var allowedRoles = collectCheckedRoles(
                requestReviewList,
                '[data-open-shift-request-id="' + fillOwnerId + '"][data-open-shift-allowed-role="' + fillTargetDate + '"]'
              );
              if (!fillStaffId || !fillStaff) {
                throw new Error('Choose who should fill this shift.');
              }
              if (!shiftLabel) {
                throw new Error('Choose which shift to fill.');
              }
              if (!allowedRoles.length) {
                throw new Error('Choose at least one eligible role.');
              }
              var sourceDate = String((getFillShiftField(requestReviewList, fillOwnerType, fillOwnerId, fillTargetDate, 'source-date') || {}).value || '').trim();
              var sourceShift = String((getFillShiftField(requestReviewList, fillOwnerType, fillOwnerId, fillTargetDate, 'source-shift') || {}).value || '').trim();
              setOpenShiftStatus(fillMode === 'existing_shift' ? 'Filling shift and reposting displaced shift...' : 'Filling shift...');
              var fillResult = await submitManagerFillShift({
                request_off_id: fillOwnerId,
                request_date: fillTargetDate,
                shift_label: shiftLabel,
                shift_type: String((shiftTypeSelect && shiftTypeSelect.value) || '').trim() || 'assisting',
                allowed_role_labels: allowedRoles,
                fill_mode: fillMode,
                fill_staff_id: fillStaffId,
                fill_staff_name: fillStaff.name,
                fill_staff_role_name: fillStaff.role,
                source_request_date: fillMode === 'existing_shift' ? sourceDate : '',
                source_shift_label: fillMode === 'existing_shift' ? sourceShift : '',
                source_shift_type: fillMode === 'existing_shift' ? getAssignedShiftTypeForStaffOption(fillStaff, sourceDate) : ''
              });
              setLastManagerFillResult(fillResult);
              applyShiftChangeActionResult(fillResult);
              renderRequestOffQueue();
              renderOpenShiftView();
              renderCoverageCalendarWeek();
              setOpenShiftStatus(
                fillResult && fillResult.displaced_open_shift_row
                  ? 'Shift filled and the displaced shift was posted as a new open shift.'
                  : 'Shift filled.',
                'success'
              );
            } catch (error) {
              setOpenShiftStatus(humanizeClientFetchErrorMessage(error, 'Could not fill shift.'), 'error');
              target.disabled = false;
            }
            return;
          }
          var action = String(target.getAttribute('data-request-action') || '').trim();
          var requestId = String(target.getAttribute('data-request-id') || '').trim();
          var requestKind = String(target.getAttribute('data-request-kind') || '').trim().toLowerCase();
          if (!action || !requestId) return;

          try {
            target.disabled = true;
            if (action === 'post-open-shift') {
              var requestDate = String(target.getAttribute('data-request-date') || '').trim();
              var select = Array.prototype.slice.call(requestReviewList.querySelectorAll('[data-open-shift-request-id]')).find(function(node){
                return String(node.getAttribute('data-open-shift-request-id') || '').trim() === requestId
                  && !node.hasAttribute('data-open-shift-allowed-role')
                  && String(node.getAttribute('data-open-shift-date') || '').trim() === requestDate;
              }) || null;
              var shiftLabel = String(select && select.value || '').trim();
              var allowedRoles = collectCheckedRoles(
                requestReviewList,
                '[data-open-shift-request-id="' + requestId + '"][data-open-shift-allowed-role="' + requestDate + '"]'
              );
              if (!allowedRoles.length) {
                throw new Error('Choose at least one eligible role.');
              }
              setOpenShiftStatus('Posting open shift...');
              var openShiftRow = await postOpenShift(requestId, requestDate, shiftLabel, allowedRoles);
              shiftChangeQueue = Array.isArray(shiftChangeQueue) ? [openShiftRow].concat(shiftChangeQueue) : [openShiftRow];
              renderOpenShiftView();
              renderCoverageCalendarWeek();
              setOpenShiftStatus('Open shift posted for ' + String((openShiftRow && openShiftRow.request_date) || requestDate) + '.', 'success');
              return;
            }
            if (action === 'delete') {
              var deleteMessage = requestKind === 'swap'
                ? 'Delete this shift swap request?'
                : 'Cancel and remove this request off entry? Boulevard timeblocks will not be changed.';
              if (typeof window !== 'undefined' && window.confirm && !window.confirm(deleteMessage)) {
                target.disabled = false;
                return;
              }
              setRequestReviewStatus(requestKind === 'swap' ? 'Deleting shift swap request...' : 'Canceling request off...');
              var deleted = requestKind === 'swap'
                ? await deleteShiftChangeQueueRow(requestId)
                : await deleteRequestOffQueueRow(requestId);
              if (requestKind === 'swap') {
                renderRequestOffQueue();
              }
              setRequestReviewStatus(
                String((deleted && deleted.staff_name) || 'Request') + (requestKind === 'swap' ? ' deleted.' : ' request off canceled.'),
                'success'
              );
              return;
            }
            setRequestReviewStatus((action === 'approve' ? 'Approving' : 'Denying') + (requestKind === 'swap' ? ' shift swap...' : ' request...'));
            var updated = requestKind === 'swap'
              ? await updatePickupQueueStatus(requestId, action === 'approve' ? 'approved' : 'denied')
              : await updateRequestOffQueueStatus(requestId, action === 'approve' ? 'approved' : 'denied');
            if (requestKind === 'swap') {
              var updatedRow = updated && (updated.row || updated.open_shift_row) ? updated.row : null;
              if (updatedRow) {
                shiftChangeQueue = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).map(function(row){
                  return String((row && row.id) || '').trim() === String((updatedRow && updatedRow.id) || '').trim() ? updatedRow : row;
                });
              }
              if (updated && updated.open_shift_row) {
                var openShiftId = String((updated.open_shift_row && updated.open_shift_row.id) || '').trim();
                var matched = false;
                shiftChangeQueue = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).map(function(row){
                  if (String((row && row.id) || '').trim() === openShiftId) {
                    matched = true;
                    return updated.open_shift_row;
                  }
                  return row;
                });
                if (!matched) {
                  shiftChangeQueue.push(updated.open_shift_row);
                }
              }
              renderRequestOffQueue();
              renderOpenShiftView();
              renderCoverageCalendarWeek();
              updated = updatedRow || updated;
            }
            setRequestReviewStatus(
              String((updated && updated.staff_name) || 'Request') + ' marked ' + String((updated && updated.status) || action) + '.',
              'success'
            );
          } catch (error) {
            if (action === 'post-open-shift') {
              setOpenShiftStatus(humanizeClientFetchErrorMessage(error, 'Could not post open shift.'), 'error');
            } else {
              setRequestReviewStatus(humanizeClientFetchErrorMessage(error, 'Could not update request status.'), 'error');
            }
            target.disabled = false;
          }
        });
        requestReviewList.addEventListener('change', function(event){
          var target = event && event.target;
          if (!target || !target.getAttribute) return;
          var ownerType = String(target.getAttribute('data-fill-owner-type') || '').trim();
          var ownerId = String(target.getAttribute('data-fill-owner-id') || '').trim();
          var targetDate = String(target.getAttribute('data-fill-target-date') || '').trim();
          if (!ownerType || !ownerId || !targetDate) return;
          syncFillShiftControls(requestReviewList, ownerType, ownerId, targetDate);
        });
        if (requestQueueTabs) {
          requestQueueTabs.addEventListener('click', function(event){
            var target = event && event.target && event.target.closest
              ? event.target.closest('[data-request-queue-filter]')
              : null;
            if (!target || !target.getAttribute) return;
            setRequestQueueFilter(String(target.getAttribute('data-request-queue-filter') || 'all'));
          });
        }
        if (requestQueueSearch) {
          requestQueueSearch.addEventListener('input', function(){
            requestQueueSearchTerm = String(requestQueueSearch.value || '').trim().toLowerCase();
            renderRequestOffQueue();
          });
        }
        if (openShiftViewTabs) {
          openShiftViewTabs.addEventListener('click', function(event){
            var target = event && event.target && event.target.closest
              ? event.target.closest('[data-open-shift-view]')
              : null;
            if (!target || !target.getAttribute) return;
            setOpenShiftViewFilter(String(target.getAttribute('data-open-shift-view') || 'available'));
          });
        }
        if (openShiftResultsList) {
          openShiftResultsList.addEventListener('click', async function(event){
            var target = event && event.target && event.target.closest
              ? event.target.closest('button')
              : (event && event.target);
            if (!target || !target.getAttribute) return;
            if (String(target.getAttribute('data-fill-shift-submit') || '').trim()) {
              var fillOwnerType = String(target.getAttribute('data-fill-owner-type') || '').trim();
              var fillOwnerId = String(target.getAttribute('data-fill-owner-id') || '').trim();
              var fillTargetDate = String(target.getAttribute('data-fill-target-date') || '').trim();
              try {
                target.disabled = true;
                var fillMode = String((getFillShiftField(openShiftResultsList, fillOwnerType, fillOwnerId, fillTargetDate, 'mode') || {}).value || '').trim() || 'new_shift';
                var fillStaffId = String((getFillShiftField(openShiftResultsList, fillOwnerType, fillOwnerId, fillTargetDate, 'staff') || {}).value || '').trim();
                var fillStaff = getStaffOptionByIdOrName(fillStaffId, '');
                if (!fillStaffId || !fillStaff) {
                  throw new Error('Choose who should fill this shift.');
                }
                var sourceDate = String((getFillShiftField(openShiftResultsList, fillOwnerType, fillOwnerId, fillTargetDate, 'source-date') || {}).value || '').trim();
                var sourceShift = String((getFillShiftField(openShiftResultsList, fillOwnerType, fillOwnerId, fillTargetDate, 'source-shift') || {}).value || '').trim();
                setOpenShiftStatus(fillMode === 'existing_shift' ? 'Filling shift and reposting displaced shift...' : 'Filling shift...');
                var fillResult = await submitManagerFillShift({
                  open_shift_id: fillOwnerId,
                  fill_mode: fillMode,
                  fill_staff_id: fillStaffId,
                  fill_staff_name: fillStaff.name,
                  fill_staff_role_name: fillStaff.role,
                  source_request_date: fillMode === 'existing_shift' ? sourceDate : '',
                  source_shift_label: fillMode === 'existing_shift' ? sourceShift : '',
                  source_shift_type: fillMode === 'existing_shift' ? getAssignedShiftTypeForStaffOption(fillStaff, sourceDate) : ''
                });
                setLastManagerFillResult(fillResult);
                applyShiftChangeActionResult(fillResult);
                renderOpenShiftView();
                renderCoverageCalendarWeek();
                setOpenShiftStatus(
                  fillResult && fillResult.displaced_open_shift_row
                    ? 'Shift filled and the displaced shift was posted as a new open shift.'
                    : 'Shift filled.',
                  'success'
                );
              } catch (error) {
                setOpenShiftStatus(humanizeClientFetchErrorMessage(error, 'Could not fill shift.'), 'error');
                target.disabled = false;
              }
              return;
            }
            var manageAction = String(target.getAttribute('data-open-shift-manage') || '').trim();
            var manageRequestId = String(target.getAttribute('data-request-id') || '').trim();
            if (manageAction && manageRequestId) {
              try {
                target.disabled = true;
                var manageOptions = {};
                if (manageAction === 'update-eligibility') {
                  var shiftTypeEditor = openShiftResultsList.querySelector('[data-open-shift-edit-type="' + manageRequestId + '"]');
                  var roleEditors = openShiftResultsList.querySelectorAll('[data-open-shift-edit-role="' + manageRequestId + '"]:checked');
                  manageOptions.shift_type = String(shiftTypeEditor && shiftTypeEditor.value || '').trim();
                  manageOptions.allowed_role_labels = Array.prototype.map.call(roleEditors, function(input){
                    return String(input.value || '').trim();
                  }).filter(Boolean);
                  if (!manageOptions.allowed_role_labels.length) {
                    throw new Error('Choose at least one eligible level or role.');
                  }
                }
                setOpenShiftStatus(
                  manageAction === 'unpost'
                    ? 'Unposting shift...'
                    : (manageAction === 'update-eligibility' ? 'Saving shift eligibility...' : 'Deleting approved pickup...')
                );
                var managed = await manageOpenShiftRow(manageRequestId, manageAction, manageOptions);
                var updatedRow = managed && (managed.row || managed.open_shift_row) ? managed.row : null;
                if (updatedRow) {
                  shiftChangeQueue = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).map(function(row){
                    return String((row && row.id) || '').trim() === String((updatedRow && updatedRow.id) || '').trim() ? updatedRow : row;
                  });
                }
                if (managed && managed.open_shift_row) {
                  var openShiftId = String((managed.open_shift_row && managed.open_shift_row.id) || '').trim();
                  var matched = false;
                  shiftChangeQueue = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).map(function(row){
                    if (String((row && row.id) || '').trim() === openShiftId) {
                      matched = true;
                      return managed.open_shift_row;
                    }
                    return row;
                  });
                  if (!matched) {
                    shiftChangeQueue.push(managed.open_shift_row);
                  }
                }
                renderOpenShiftView();
                renderCoverageCalendarWeek();
                setOpenShiftStatus(
                  manageAction === 'unpost'
                    ? 'Open shift unposted.'
                    : (manageAction === 'update-eligibility' ? 'Shift role and eligible levels updated.' : 'Approved pickup removed.'),
                  'success'
                );
              } catch (error) {
                setOpenShiftStatus(humanizeClientFetchErrorMessage(error, 'Could not update shift.'), 'error');
                target.disabled = false;
              }
              return;
            }
            var action = String(target.getAttribute('data-pickup-action') || '').trim();
            var requestId = String(target.getAttribute('data-request-id') || '').trim();
            if (!action || !requestId) return;

            try {
              target.disabled = true;
              if (action === 'delete') {
                if (typeof window !== 'undefined' && window.confirm && !window.confirm('Delete this pending shift request?')) {
                  target.disabled = false;
                  return;
                }
                setPickupQueueStatus('Deleting shift request...');
                var deletedShiftRequest = await deleteShiftChangeQueueRow(requestId);
                setPickupQueueStatus(String((deletedShiftRequest && deletedShiftRequest.staff_name) || 'Shift request') + ' deleted.', 'success');
                return;
              }
              setPickupQueueStatus((action === 'approve' ? 'Approving' : 'Denying') + ' shift request...');
              var result = await updatePickupQueueStatus(requestId, action === 'approve' ? 'approved' : 'denied');
              var updatedRow = result && (result.row || result.open_shift_row) ? result.row : null;
              if (updatedRow) {
                shiftChangeQueue = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).map(function(row){
                  return String((row && row.id) || '').trim() === String((updatedRow && updatedRow.id) || '').trim() ? updatedRow : row;
                });
              }
              if (result && result.open_shift_row) {
                var openShiftId = String((result.open_shift_row && result.open_shift_row.id) || '').trim();
                var matched = false;
                shiftChangeQueue = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).map(function(row){
                  if (String((row && row.id) || '').trim() === openShiftId) {
                    matched = true;
                    return result.open_shift_row;
                  }
                  return row;
                });
                if (!matched) {
                  shiftChangeQueue.push(result.open_shift_row);
                }
              }
              renderOpenShiftView();
              renderCoverageCalendarWeek();
              setPickupQueueStatus('Shift request updated.', 'success');
            } catch (error) {
              setPickupQueueStatus(humanizeClientFetchErrorMessage(error, 'Could not update shift request.'), 'error');
              target.disabled = false;
            }
          });
          openShiftResultsList.addEventListener('change', function(event){
            var target = event && event.target;
            if (!target || !target.getAttribute) return;
            var ownerType = String(target.getAttribute('data-fill-owner-type') || '').trim();
            var ownerId = String(target.getAttribute('data-fill-owner-id') || '').trim();
            var targetDate = String(target.getAttribute('data-fill-target-date') || '').trim();
            if (!ownerType || !ownerId || !targetDate) return;
            syncFillShiftControls(openShiftResultsList, ownerType, ownerId, targetDate);
          });
        }
        initializeRequestOffForm();
        setRetailPayrollWindow(activeRetailPayrollStart);
        fetchRetailAvailableQuarterOptions().catch(function(){});
        populateGlobalQuarterOptions();
        setOpenShiftViewFilter(openShiftViewFilter);
        if (currentProgressionEditor && currentProgressionEditor.staff_id && canManageTodo()) {
          ensureTodoLoaded();
        }
        if (currentProgressionEditor && currentProgressionEditor.staff_id && canManageInventory()) {
          ensureInventoryLoaded();
        }
        if (
          currentProgressionEditor
          && currentProgressionEditor.staff_id
          && currentProgressionEditorPermission
          && currentProgressionEditorPermission.can_sign_off === true
        ) {
          refreshProgressionAuditQueue();
        }
        setActiveTab(getStoredStaffOpsLastTab() || 'kpis');
        primeDueQueueOnPageLoad().catch(function(){});
        warmRetailDashboardInBackground();
      }

      async function fetchStaffOpsAuth(pin){
        var lastError = null;
        for (var attempt = 0; attempt < 3; attempt += 1) {
          try {
            var response = await fetch(REPORT_PROXY_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                action: 'staff-ops-auth',
                pin: pin
              })
            });
            var rawText = await response.text();
            var data = null;
            try {
              data = rawText ? JSON.parse(rawText) : null;
            } catch (_error) {
              data = null;
            }
            if (response.ok && data && data.ok) return data;
            if (response.status < 500 && response.status !== 429) {
              var authError = new Error((data && data.error) || rawText || 'Incorrect PIN.');
              authError.nonRetryable = true;
              throw authError;
            }
            lastError = new Error((data && data.error) || rawText || 'Manager login is temporarily unavailable.');
          } catch (error) {
            if (error && error.nonRetryable === true) throw error;
            lastError = error;
          }
          if (attempt < 2) {
            await new Promise(function(resolve){ window.setTimeout(resolve, 450 * (attempt + 1)); });
          }
        }
        throw lastError || new Error('Manager login is temporarily unavailable.');
      }

      async function unlockWithPin(){
        var entered = String((pinInput && pinInput.value) || '').trim();
        if (!entered) {
          setPinStatus('Enter your login code.', 'error');
          if (pinInput) {
            pinInput.focus();
          }
          return;
        }

        if (entered !== STAFF_OPERATIONS_PIN) {
          try {
            setPinValidationState(true, 'Checking your login code...');
            var data = await fetchStaffOpsAuth(entered);
            if (!data.editor || !data.staff_ops_permission) throw new Error('Manager login is temporarily unavailable.');
            currentStaffOpsPermission = data.staff_ops_permission;
            currentProgressionEditor = data.editor;
            currentProgressionEditorPermission = data.editor_permission || null;
            persistStaffOpsAccessSession();
            persistProgressionEditorSession();
            persistSharedAccessSession({
              mode: 'manager',
              editor: currentProgressionEditor,
              permission: currentStaffOpsPermission
            });
            try {
              window.localStorage.setItem(STAFF_OPERATIONS_PIN_STORAGE_KEY, '1');
              window.localStorage.removeItem(LEGACY_SHARED_UNLOCKED_STORAGE_KEY);
            } catch (_error) {
            }
            if (pinInput) {
              pinInput.value = '';
            }
            setPinStatus('Unlocked as ' + String((data.editor && data.editor.staff_name) || 'authorized editor') + '.', 'success');
            finishStaffOpsUnlock({
              firstTab: getFirstAccessibleStaffOpsTab() || 'progression'
            });
            return;
          } catch (_error) {
            setPinValidationState(false);
            setPinStatus('Incorrect PIN.', 'error');
            if (pinInput) {
              pinInput.value = '';
              pinInput.focus();
            }
            return;
          }
        }
        setPinValidationState(true, 'Checking your login code...');
        try {
          window.localStorage.setItem(STAFF_OPERATIONS_PIN_STORAGE_KEY, '1');
          window.localStorage.removeItem(LEGACY_SHARED_UNLOCKED_STORAGE_KEY);
        } catch (_error) {
        }
        clearStaffOpsAccessSession();
        clearProgressionEditorSession();
        persistSharedAccessSession({
          mode: 'manager',
          editor: null,
          permission: null
        });
        setPinStatus('Unlocked.', 'success');
        finishStaffOpsUnlock();
      }

      function humanizeDashboardErrorMessage(message){
        var raw = normalizeErrorLikeText(message);
        if (!raw) return 'Could not build totals.';

        if (/Boulevard rate limited this request/i.test(raw)) {
          return raw;
        }

        if (/API limit exceeded/i.test(raw)) {
          var waitMatch = raw.match(/please wait\s+(\d+)\s*ms/i);
          var waitMs = waitMatch ? Number(waitMatch[1]) : 0;
          if (waitMs >= 1000) {
            return 'Boulevard rate limited this request. Please wait about ' + ((waitMs / 1000) % 1 === 0 ? String(waitMs / 1000) : (waitMs / 1000).toFixed(1)) + 's and try again.';
          }
          if (waitMs > 0) {
            return 'Boulevard rate limited this request. Please wait about ' + waitMs + 'ms and try again.';
          }
          return 'Boulevard rate limited this request. Please wait a moment and try again.';
        }

        if (/Raw KPI export is still processing/i.test(raw)) {
          return 'KPI export is still processing on Boulevard. Attendance totals are ready. Try again in about 2-3 minutes.';
        }

        if (/export is still processing/i.test(raw)) {
          return 'Boulevard is still preparing this export. Try again in about 1 minute.';
        }

        if (/57014|statement timeout/i.test(raw)) {
          return 'Retail Success took too long to refresh. Showing the most recently saved results when available.';
        }

        if (/timed out/i.test(raw)) {
          return raw;
        }

        return raw;
      }

      function humanizeClientFetchErrorMessage(error, fallbackMessage){
        var raw = normalizeErrorLikeText(error && error.message ? error.message : error);
        if (!raw) {
          raw = normalizeErrorLikeText(fallbackMessage);
        }
        if (!raw) return 'Could not reach the reporting proxy.';

        if (error && error.name === 'AbortError') {
          return 'The request was canceled before Supabase could respond.';
        }

        if (/Failed to fetch/i.test(raw) || /NetworkError/i.test(raw) || /Load failed/i.test(raw)) {
          return 'The browser could not reach the reporting proxy. Supabase may not have received the request.';
        }

        if (/Could not fetch leaderboard from proxy\./i.test(raw)) {
          return 'The browser reached the proxy URL, but did not get a usable response back.';
        }

        var proxyStatusMatch = raw.match(/^Proxy response was not usable \(status (\d+)\)(?:\.\s*Body:\s*(.*))?$/i);
        if (proxyStatusMatch) {
          var status = proxyStatusMatch[1];
          var body = String(proxyStatusMatch[2] || '').trim();
          if (body) {
            return 'The proxy responded with status ' + status + '. ' + body;
          }
          return 'The proxy responded with status ' + status + ', but did not return usable JSON.';
        }

        return humanizeDashboardErrorMessage(raw);
      }

      function parseRetryAfterMs(error){
        var raw = normalizeErrorLikeText(error && error.message ? error.message : error);
        if (!raw) return 0;
        var match = raw.match(/Retry after\s+(\d+)ms/i);
        return match ? (Number(match[1]) || 0) : 0;
      }

      function delayMs(waitMs){
        return new Promise(function(resolve){
          window.setTimeout(resolve, Math.max(0, Number(waitMs) || 0));
        });
      }

      function normalizeErrorLikeText(value){
        if (value == null) return '';
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
          return String(value).trim();
        }
        if (Array.isArray(value)) {
          return value.map(function(item){
            return normalizeErrorLikeText(item);
          }).filter(Boolean).join(' ');
        }
        if (typeof value === 'object') {
          var preferredKeys = ['message', 'error', 'msg', 'details', 'hint', 'code'];
          for (var index = 0; index < preferredKeys.length; index += 1) {
            var preferredValue = normalizeErrorLikeText(value[preferredKeys[index]]);
            if (preferredValue) return preferredValue;
          }
          try {
            return JSON.stringify(value);
          } catch (_error) {
            return '';
          }
        }
        return '';
      }

      function setRequestOffStatus(text, tone){
        if (!requestOffStatus) return;
        requestOffStatus.textContent = text;
        requestOffStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setRequestReviewStatus(text, tone){
        requestReviewStatus.textContent = text;
        requestReviewStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setOpenShiftStatus(text, tone){
        if (!openShiftStatus) return;
        openShiftStatus.textContent = String(text || '');
        openShiftStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function formatRelativeDurationFromIso(value){
        var raw = String(value || '').trim();
        if (!raw) return '';
        var parsed = new Date(raw);
        if (isNaN(parsed.getTime())) return '';
        var diffMs = Math.max(0, Date.now() - parsed.getTime());
        var totalMinutes = Math.floor(diffMs / 60000);
        var hours = Math.floor(totalMinutes / 60);
        var minutes = totalMinutes % 60;
        if (hours > 0) {
          return String(hours) + 'h ' + String(minutes) + 'm';
        }
        if (minutes > 0) {
          return String(minutes) + 'm';
        }
        var seconds = Math.max(0, Math.floor(diffMs / 1000));
        return String(seconds) + 's';
      }

      function formatRecaptureNumber(value){
        if (value == null || value === '') return '--';
        var numberValue = Number(value || 0) || 0;
        try {
          return numberValue.toLocaleString('en-US');
        } catch (_error) {
          return String(numberValue);
        }
      }

      function dueRefreshCountText(value, fallbackLabel){
        if (value == null || value === '') return fallbackLabel || '--';
        return formatRecaptureNumber(value);
      }

      function dueRefreshStatusLabel(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'running') return 'Updating';
        if (normalized === 'complete') return 'Ready';
        if (normalized === 'failed') return 'Needs Attention';
        if (normalized === 'not_started') return 'Not Started';
        return '--';
      }

      function dueRefreshTone(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var status = String(info.status || '').trim().toLowerCase();
        var safeSnapshot = info.safe_to_use_snapshot === true;
        var requiresBaselineRebuild = info.requires_baseline_rebuild === true;
        var staleRunning = info.stale_running === true;
        if (status === 'failed') return 'error';
        if (status === 'complete' && safeSnapshot) return 'success';
        if (status === 'running') return 'warning';
        if (staleRunning || requiresBaselineRebuild) return safeSnapshot ? 'warning' : 'error';
        if (status === 'not_started' && !safeSnapshot) return 'error';
        return safeSnapshot ? 'success' : 'warning';
      }

      function dueRefreshHealthLabel(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var status = String(info.status || '').trim().toLowerCase();
        var safeSnapshot = info.safe_to_use_snapshot === true;
        var staleRunning = info.stale_running === true;
        var requiresBaselineRebuild = info.requires_baseline_rebuild === true;
        if (status === 'failed') return 'Needs attention';
        if (status === 'running') return 'Refreshing now';
        if (status === 'complete' && safeSnapshot) return 'Ready to work';
        if (staleRunning) return safeSnapshot ? 'Refresh paused' : 'Queue unavailable';
        if (requiresBaselineRebuild) return safeSnapshot ? 'Baseline refresh needed' : 'Queue unavailable';
        if (status === 'not_started' && !safeSnapshot) return 'Queue unavailable';
        return safeSnapshot ? 'Ready to work' : 'Checking queue';
      }

      function dueRefreshReadinessLabel(progress){
        var tone = dueRefreshTone(progress);
        if (tone === 'success') return 'Ready';
        if (tone === 'warning') return 'Refreshing';
        if (tone === 'error') return 'Needs attention';
        return 'Checking';
      }

      function dueRefreshUpdatedCountValue(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        return Math.max(0, Number(info.queue_rows_updated != null ? info.queue_rows_updated : info.queue_rows_changed) || 0);
      }

      function dueRefreshSinceText(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var value = String(info.incremental_since || '').trim();
        if (!value) return '';
        return formatRecaptureDateTime(value);
      }

      function dueRefreshTimestampValue(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var candidates = [
          info.completed_at,
          info.updated_at,
          info.last_successful_refresh_at,
          info.started_at
        ];
        for (var index = 0; index < candidates.length; index += 1) {
          var raw = String(candidates[index] || '').trim();
          if (!raw) continue;
          var parsed = new Date(raw);
          if (!isNaN(parsed.getTime())) return parsed.getTime();
        }
        return 0;
      }

      function dueManualRefreshUpdatedSinceIso(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var baseRaw = String(
          info.incremental_since
          || info.last_successful_refresh_at
          || info.updated_at
          || ''
        ).trim();
        var baseDate = baseRaw ? new Date(baseRaw) : null;
        var baseMs = baseDate && !isNaN(baseDate.getTime()) ? baseDate.getTime() : NaN;
        var fallbackMs = Date.now() - (7 * 24 * 60 * 60 * 1000);
        var replayMs = isFinite(baseMs) ? (baseMs - (3 * 24 * 60 * 60 * 1000)) : fallbackMs;
        var finalDate = new Date(Math.max(0, replayMs));
        return isNaN(finalDate.getTime()) ? new Date(fallbackMs).toISOString() : finalDate.toISOString();
      }

      function chooseDueRefreshProgress(primary, fallback){
        var first = primary && typeof primary === 'object' ? primary : null;
        var second = fallback && typeof fallback === 'object' ? fallback : null;
        if (!hasDueRefreshProgressData(first)) return second || first || {};
        if (!hasDueRefreshProgressData(second)) return first || second || {};
        var firstStatus = String(first.status || '').trim().toLowerCase();
        var secondStatus = String(second.status || '').trim().toLowerCase();
        var firstAt = dueRefreshTimestampValue(first);
        var secondAt = dueRefreshTimestampValue(second);
        if (firstStatus === 'complete' && secondStatus !== 'complete' && firstAt >= secondAt) return first;
        if (secondStatus === 'complete' && firstStatus !== 'complete' && secondAt >= firstAt) return second;
        return secondAt > firstAt ? second : first;
      }

      function dueRefreshActionLabel(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var status = String(info.status || '').trim().toLowerCase();
        var refreshType = String(info.refresh_type || '').trim().toLowerCase();
        var requiresBaselineRebuild = info && info.requires_baseline_rebuild === true;
        if (status === 'running' && (refreshType === 'direct_guest_facts' || refreshType === 'fast_refresh')) return 'Updating queue';
        if (status === 'running' && refreshType === 'full_rebuild') return 'Rebuilding queue';
        if (requiresBaselineRebuild) return 'Needs repair';
        if (status === 'not_started') return 'Not started';
        if (status === 'failed') return 'Needs attention';
        return 'Saved queue';
      }

      function dueRefreshStepLabel(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var status = String(info.status || '').trim().toLowerCase();
        var refreshType = String(info.refresh_type || '').trim().toLowerCase();
        if (status === 'complete') return 'Waiting for next update';
        if (status === 'not_started') return 'Waiting for first update';
        if (status === 'failed') return 'Last update failed';
        if (status === 'running' && refreshType === 'direct_guest_facts') return 'Processing changed guests';
        if (status === 'running' && Number(info.appointments_remaining || 0) <= 0 && Number(info.clients_remaining || 0) > 0) {
          return (refreshType === 'fast_refresh' || refreshType === 'direct_guest_facts') ? 'Refreshing affected guests' : 'Rebuilding guest queue';
        }
        if (status === 'running' && (refreshType === 'fast_refresh' || refreshType === 'direct_guest_facts')) return 'Checking changed Boulevard appointments';
        if (status === 'running' && refreshType === 'full_rebuild') return 'Scanning history and rebuilding queue';
        return retailTextValue(info.current_step_label, '--');
      }

      function buildDueSyncHint(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var status = String(info.status || '').trim().toLowerCase();
        var refreshType = String(info.refresh_type || '').trim().toLowerCase();
        var safeSnapshot = info.safe_to_use_snapshot === true;
        var staleRunning = info.stale_running === true;
        if (status === 'failed') {
          return safeSnapshot
            ? 'The queue is still usable. Resume sync if you want to retry the latest update.'
            : 'The queue needs attention before it can be trusted.';
        }
        if (staleRunning) {
          return 'The last sync paused. Resume Sync will continue from the last checkpoint.';
        }
        if (status === 'running' && refreshType === 'full_rebuild') {
          return safeSnapshot
            ? 'A deeper repair is running in the background. The saved queue stays available.'
            : 'The queue is being rebuilt now.';
        }
        if (status === 'running') {
          return 'Checking recent Boulevard changes and updating only the guests that were affected.';
        }
        if (status === 'not_started' && !safeSnapshot) {
          return 'Run the first sync to load a saved queue.';
        }
        return 'Refresh checks recent Boulevard changes and keeps the current queue ready to work.';
      }

      function shouldShowDueResumeAction(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var status = String(info.status || '').trim().toLowerCase();
        return info.stale_running === true || status === 'failed';
      }

      function formatRecaptureDateTime(value){
        var raw = String(value || '').trim();
        if (!raw) return '--';
        var parsed = new Date(raw);
        if (isNaN(parsed.getTime())) return '--';
        try {
          return new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit'
          }).format(parsed);
        } catch (_error) {
          return parsed.toLocaleString('en-US');
        }
      }

      function getCurrentSnapshotHealthQuarterValue(){
        var today = startOfLocalDay(new Date());
        return String(today.getFullYear()) + '-Q' + String(Math.floor(today.getMonth() / 3) + 1);
      }

      function getCurrentSnapshotHealthYearValue(){
        return String(startOfLocalDay(new Date()).getFullYear());
      }

      function buildSnapshotHealthYearValues(startYear){
        var firstYear = Number(startYear) || startOfLocalDay(new Date()).getFullYear();
        var currentYear = startOfLocalDay(new Date()).getFullYear();
        var years = [];
        for (var year = firstYear; year <= currentYear; year += 1) {
          years.push(String(year));
        }
        return years;
      }

      function buildSnapshotHealthQuarterValuesForYear(yearValue){
        var year = Number(yearValue) || startOfLocalDay(new Date()).getFullYear();
        var today = startOfLocalDay(new Date());
        var currentYear = today.getFullYear();
        var currentQuarter = Math.floor(today.getMonth() / 3) + 1;
        var quarterCount = year === currentYear ? currentQuarter : 4;
        var values = [];
        for (var quarter = 1; quarter <= quarterCount; quarter += 1) {
          values.push(String(year) + '-Q' + String(quarter));
        }
        return values;
      }

      function getSnapshotHealthTodayKey(){
        return formatDateInputValue(startOfLocalDay(new Date()));
      }

      function getSnapshotHealthDateKey(entry){
        var snapshotDate = String(entry && entry.snapshot_date || '').trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(snapshotDate)) return snapshotDate;
        var updatedAt = String(entry && entry.updated_at || '').trim();
        if (updatedAt.length >= 10) return updatedAt.slice(0, 10);
        return '';
      }

      function getSnapshotHealthTone(entry){
        var status = String(entry && entry.status || '').trim().toLowerCase();
        if (status === 'failed') return 'error';
        if (status === 'queued' || status === 'processing') return 'warning';
        if (entry && entry.ok !== true) return 'error';
        if (getSnapshotHealthDateKey(entry) === getSnapshotHealthTodayKey()) return 'success';
        if (getSnapshotHealthDateKey(entry)) return 'warning';
        return 'error';
      }

      function getSnapshotHealthLabel(entry){
        var status = String(entry && entry.status || '').trim().toLowerCase();
        if (status === 'queued') return 'Queued';
        if (status === 'processing') return 'Processing';
        if (status === 'failed') return 'Failed';
        if (entry && entry.ok === true && getSnapshotHealthDateKey(entry) === getSnapshotHealthTodayKey()) return 'Fresh today';
        if (entry && entry.ok === true) return 'Saved';
        return 'Error';
      }

      function buildSnapshotHealthDefinitions(){
        var currentQuarter = getCurrentSnapshotHealthQuarterValue();
        var currentYear = getCurrentSnapshotHealthYearValue();
        var globalAnnualYears = buildSnapshotHealthYearValues(2021);
        return [
          {
            group: 'Attendance',
            group_description: 'Feeds Staff Level KPI attendance and reliability views.',
            entries: [
              { label: 'Attendance YTD', used_by: 'Staff Level KPI', action: 'attendance-totals-snapshot-get', body: { snapshot_key: 'attendance_ytd' }, refresh_action: 'attendance-totals-snapshot-refresh', refresh_body: { snapshot_key: 'attendance_ytd' } },
              { label: 'Attendance MTD', used_by: 'Attendance rollups', action: 'attendance-totals-snapshot-get', body: { snapshot_key: 'attendance_month_to_date' }, refresh_action: 'attendance-totals-snapshot-refresh', refresh_body: { snapshot_key: 'attendance_month_to_date' } },
              { label: 'Attendance 90D', used_by: 'Attendance rollups', action: 'attendance-totals-snapshot-get', body: { snapshot_key: 'attendance_last_90_days' }, refresh_action: 'attendance-totals-snapshot-refresh', refresh_body: { snapshot_key: 'attendance_last_90_days' } },
              { label: 'Attendance 30D', used_by: 'Attendance rollups', action: 'attendance-totals-snapshot-get', body: { snapshot_key: 'attendance_last_30_days' }, refresh_action: 'attendance-totals-snapshot-refresh', refresh_body: { snapshot_key: 'attendance_last_30_days' } }
            ]
          },
          {
            group: 'Staff KPI',
            group_description: 'Feeds the KPI tab and saved KPI period windows.',
            entries: [
              { label: 'Staff KPI YTD', used_by: 'KPIs tab', action: 'staff-kpi-snapshot-get', body: { snapshot_key: 'staff_kpi_ytd' }, refresh_action: 'staff-kpi-snapshot-refresh', refresh_body: { snapshot_key: 'staff_kpi_ytd' } },
              { label: 'Staff KPI MTD', used_by: 'KPIs tab', action: 'staff-kpi-snapshot-get', body: { snapshot_key: 'staff_kpi_month_to_date' }, refresh_action: 'staff-kpi-snapshot-refresh', refresh_body: { snapshot_key: 'staff_kpi_month_to_date' } },
              { label: 'Staff KPI 90D', used_by: 'KPIs tab', action: 'staff-kpi-snapshot-get', body: { snapshot_key: 'staff_kpi_last_90_days' }, refresh_action: 'staff-kpi-snapshot-refresh', refresh_body: { snapshot_key: 'staff_kpi_last_90_days' } },
              { label: 'Staff KPI 30D', used_by: 'KPIs tab', action: 'staff-kpi-snapshot-get', body: { snapshot_key: 'staff_kpi_last_30_days' }, refresh_action: 'staff-kpi-snapshot-refresh', refresh_body: { snapshot_key: 'staff_kpi_last_30_days' } },
              { label: 'Staff KPI 7D', used_by: 'KPIs tab', action: 'staff-kpi-snapshot-get', body: { snapshot_key: 'staff_kpi_last_7_days' }, refresh_action: 'staff-kpi-snapshot-refresh', refresh_body: { snapshot_key: 'staff_kpi_last_7_days' } }
            ]
          },
          {
            group: 'Global KPI',
            group_description: 'Feeds Global KPI current-quarter and current-year YTD views.',
            entries: [
              { label: currentQuarter + ' snapshot', used_by: 'Global KPIs quarter view', action: 'global-kpi-snapshot-get', body: { quarter_value: currentQuarter, refresh_if_missing: false }, refresh_action: 'global-kpi-snapshot-refresh', refresh_body: { quarter_value: currentQuarter } },
              { label: currentYear + ' YTD annual', used_by: 'Global KPIs YTD view', action: 'global-kpi-annual-refresh-status', body: { year_value: currentYear }, annual_status: true, refresh_action: 'global-kpi-annual-refresh', refresh_body: { year_value: currentYear, async: true } }
            ]
          },
          {
            group: 'Staff Growth',
            group_description: 'Feeds Staff Growth and all past-year Staff Level KPI comparisons. Historical staff years live inside one saved staff_growth_history snapshot, not separate yearly staff KPI snapshots.',
            entries: [
              { label: 'Staff growth history', used_by: 'Staff Growth · Staff Level KPI all years', action: 'staff-growth-snapshot-get', body: {}, refresh_action: 'staff-growth-snapshot-refresh', refresh_body: {} }
            ]
          },
          {
            group: 'Retail Success',
            group_description: 'Feeds saved quarter Retail Success attach leaderboard views. Payroll periods still load live.',
            entries: buildSnapshotHealthQuarterValuesForYear(currentYear).map(function(quarterValue){
              var isCurrentQuarter = quarterValue === currentQuarter;
              return {
                label: quarterValue + (isCurrentQuarter ? ' retail attach QTD' : ' retail attach'),
                used_by: 'Retail Success quarter view',
                action: 'retail-quarter-snapshot-get',
                body: { quarter_value: quarterValue, refresh_if_missing: false },
                refresh_action: 'retail-quarter-snapshot-refresh',
                refresh_body: { quarter_value: quarterValue }
              };
            })
          },
          {
            group: 'Shopify',
            group_description: 'Tracks the saved Shopify order sync state that feeds online sales into shared and global KPI reporting.',
            entries: [
              { label: 'Shopify orders sync state', used_by: 'Online sales in Global KPIs and shared dashboard refreshes', action: 'shopify-sync-state-get', body: {}, refresh_action: 'shopify-sync-state-refresh', refresh_body: {} }
            ]
          },
          {
            group: 'Global KPI History',
            group_description: 'Saved annual historical Global KPI snapshots by year.',
            entries: globalAnnualYears.map(function(year){
              return {
                label: year + (year === currentYear ? ' YTD annual' : ' annual'),
                used_by: 'Global KPIs year view',
                action: 'global-kpi-annual-refresh-status',
                body: { year_value: year },
                annual_status: true,
                refresh_action: 'global-kpi-annual-refresh',
                refresh_body: { year_value: year, async: true }
              };
            })
          },
          {
            group: 'Service Mix',
            group_description: 'Feeds saved service mix reporting windows.',
            entries: [
              { label: 'Service Mix YTD', used_by: 'Service mix reporting', action: 'service-mix-snapshot-get', body: { snapshot_key: 'service_mix_ytd' }, refresh_action: 'service-mix-snapshot-refresh', refresh_body: { snapshot_key: 'service_mix_ytd' } },
              { label: 'Service Mix 365D', used_by: 'Service mix reporting', action: 'service-mix-snapshot-get', body: { snapshot_key: 'service_mix_last_365_days' }, refresh_action: 'service-mix-snapshot-refresh', refresh_body: { snapshot_key: 'service_mix_last_365_days' } },
              { label: 'Service Mix 180D', used_by: 'Service mix reporting', action: 'service-mix-snapshot-get', body: { snapshot_key: 'service_mix_last_180_days' }, refresh_action: 'service-mix-snapshot-refresh', refresh_body: { snapshot_key: 'service_mix_last_180_days' } },
              { label: 'Service Mix 90D', used_by: 'Service mix reporting', action: 'service-mix-snapshot-get', body: { snapshot_key: 'service_mix_last_90_days' }, refresh_action: 'service-mix-snapshot-refresh', refresh_body: { snapshot_key: 'service_mix_last_90_days' } }
            ]
          }
        ];
      }

      async function fetchSnapshotHealthEntry(definition){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Object.assign({ action: definition.action }, definition.body || {}))
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data) {
          throw new Error((data && data.error) || rawText || 'Could not load snapshot health.');
        }
        if (definition.annual_status) {
          var latestSnapshot = data && data.latest_snapshot && typeof data.latest_snapshot === 'object' ? data.latest_snapshot : null;
          return {
            ok: data.ok === true,
            status: String(data.status || '').trim(),
            snapshot_key: latestSnapshot && latestSnapshot.snapshot_key ? latestSnapshot.snapshot_key : ('global_kpi_' + getCurrentSnapshotHealthYearValue()),
            snapshot_date: latestSnapshot && latestSnapshot.snapshot_date ? latestSnapshot.snapshot_date : '',
            date_from: latestSnapshot && latestSnapshot.date_from ? latestSnapshot.date_from : '',
            date_to: latestSnapshot && latestSnapshot.date_to ? latestSnapshot.date_to : '',
            created_at: latestSnapshot && latestSnapshot.created_at ? latestSnapshot.created_at : '',
            updated_at: latestSnapshot && latestSnapshot.updated_at ? latestSnapshot.updated_at : '',
            error: String(data.error || '').trim()
          };
        }
        var snapshot = data && data.snapshot && typeof data.snapshot === 'object' ? data.snapshot : null;
        return {
          ok: data.ok === true,
          status: data && data.ok === true ? 'complete' : '',
          snapshot_key: snapshot && snapshot.snapshot_key ? snapshot.snapshot_key : '',
          snapshot_date: snapshot && snapshot.snapshot_date ? snapshot.snapshot_date : '',
          date_from: snapshot && snapshot.date_from ? snapshot.date_from : '',
          date_to: snapshot && snapshot.date_to ? snapshot.date_to : '',
          created_at: snapshot && snapshot.created_at ? snapshot.created_at : '',
          updated_at: snapshot && snapshot.updated_at ? snapshot.updated_at : '',
          error: String(data && data.error || '').trim()
        };
      }

      function buildSnapshotHealthSummary(groups){
        var total = 0;
        var fresh = 0;
        var warning = 0;
        var error = 0;
        (Array.isArray(groups) ? groups : []).forEach(function(group){
          (Array.isArray(group.entries) ? group.entries : []).forEach(function(entry){
            total += 1;
            var tone = getSnapshotHealthTone(entry);
            if (tone === 'success') fresh += 1;
            else if (tone === 'warning') warning += 1;
            else error += 1;
          });
        });
        return { total: total, fresh: fresh, warning: warning, error: error };
      }

      function renderSnapshotHealthTable(group){
        var entries = Array.isArray(group && group.entries) ? group.entries : [];
        return ''
          + '<div class="level7-compare-tableWrap">'
          +   '<table class="level7-compare-table">'
          +     '<thead><tr><th>Snapshot</th><th>Feeds</th><th>Coverage</th><th>Snapshot Date</th><th>Updated</th><th>Status</th><th>Action</th></tr></thead>'
          +     '<tbody>'
          +       entries.map(function(entry){
                    var coverage = entry.date_from && entry.date_to ? (entry.date_from + ' - ' + entry.date_to) : 'N/A';
                    var updatedAt = entry.updated_at || entry.created_at || '';
                    var tone = getSnapshotHealthTone(entry);
                    var statusMeta = entry.error ? entry.error : (tone === 'success' ? 'Current saved snapshot' : tone === 'warning' ? 'Not rebuilt today' : 'Needs attention');
                    var refreshId = buildSnapshotHealthRefreshId(entry.refresh_action, entry.refresh_body);
                    var isRefreshing = snapshotHealthRefreshInFlight[refreshId] === true;
                    var actionLabel = isRefreshing ? 'Refreshing...' : (entry.annual_status ? 'Queue rebuild' : 'Refresh');
                    return ''
                      + '<tr>'
                      +   '<td class="level7-compare-staff"><div class="level7-compare-staffStatic"><span class="level7-compare-staffName">' + escapeHtml(entry.label || 'Snapshot') + '</span><span class="level7-compare-staffMeta">' + escapeHtml(entry.snapshot_key || '') + '</span></div></td>'
                      +   '<td class="level7-compare-trendCell">' + escapeHtml(entry.used_by || '') + '</td>'
                      +   '<td class="level7-compare-cellNumeric">' + escapeHtml(coverage) + '</td>'
                      +   '<td class="level7-compare-cellNumeric">' + escapeHtml(entry.snapshot_date || 'N/A') + '</td>'
                      +   '<td class="level7-compare-cellNumeric">' + escapeHtml(updatedAt ? formatRecaptureDateTime(updatedAt) : 'N/A') + '</td>'
                      +   '<td class="level7-compare-trendCell">' + escapeHtml(getSnapshotHealthLabel(entry)) + '<span class="level7-compare-trendMeta">' + escapeHtml(statusMeta) + '</span></td>'
                      +   '<td class="level7-compare-cellNumeric"><button class="btn-secondary btn-secondary--small" type="button" data-snapshot-refresh-id="' + escapeHtml(refreshId) + '"' + (isRefreshing ? ' disabled' : '') + '>' + escapeHtml(actionLabel) + '</button></td>'
                      + '</tr>';
                  }).join('')
          +     '</tbody>'
          +   '</table>'
          + '</div>';
      }

      function renderSnapshotHealth(groups){
        if (!snapshotHealthMount) return;
        snapshotHealthGroups = Array.isArray(groups) ? groups : [];
        var summary = buildSnapshotHealthSummary(groups);
        snapshotHealthMount.className = 'retail-layout';
        snapshotHealthMount.innerHTML = ''
          + '<div class="retail-grid">'
          +   '<div class="retail-panel">'
          +     '<div class="retail-panelHead retail-panelHead--stack"><div><h2 class="retail-panelTitle">Snapshot overview</h2><p class="retail-panelMeta">Saved snapshot health across the dashboards the manager tools use right now.</p></div></div>'
          +     '<div class="retail-scoreboardStats">'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(summary.total)) + '</strong><span>snapshots checked</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(summary.fresh)) + '</strong><span>fresh today</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(summary.warning)) + '</strong><span>saved older</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(summary.error)) + '</strong><span>needs attention</span></div>'
          +     '</div>'
          +   '</div>'
          +   (Array.isArray(groups) ? groups : []).map(function(group){
                return ''
                  + '<div class="retail-panel">'
                  +   '<div class="retail-panelHead retail-panelHead--stack"><div><h2 class="retail-panelTitle">' + escapeHtml(group.group || 'Snapshots') + '</h2><p class="retail-panelMeta">' + escapeHtml(group.group_description || '') + '</p></div></div>'
                  +   renderSnapshotHealthTable(group)
                  + '</div>';
              }).join('')
          + '</div>';
      }

      function findSnapshotHealthEntryByRefreshId(refreshId){
        var groups = Array.isArray(snapshotHealthGroups) ? snapshotHealthGroups : [];
        for (var groupIndex = 0; groupIndex < groups.length; groupIndex += 1) {
          var entries = Array.isArray(groups[groupIndex] && groups[groupIndex].entries) ? groups[groupIndex].entries : [];
          for (var entryIndex = 0; entryIndex < entries.length; entryIndex += 1) {
            var entry = entries[entryIndex];
            if (buildSnapshotHealthRefreshId(entry && entry.refresh_action, entry && entry.refresh_body) === refreshId) {
              return entry;
            }
          }
        }
        return null;
      }

      function replaceSnapshotHealthEntryByRefreshId(refreshId, nextEntry){
        var groups = Array.isArray(snapshotHealthGroups) ? snapshotHealthGroups : [];
        for (var groupIndex = 0; groupIndex < groups.length; groupIndex += 1) {
          var entries = Array.isArray(groups[groupIndex] && groups[groupIndex].entries) ? groups[groupIndex].entries : [];
          for (var entryIndex = 0; entryIndex < entries.length; entryIndex += 1) {
            var entry = entries[entryIndex];
            if (buildSnapshotHealthRefreshId(entry && entry.refresh_action, entry && entry.refresh_body) === refreshId) {
              entries[entryIndex] = nextEntry;
              return true;
            }
          }
        }
        return false;
      }

      function clearSnapshotHealthPoll(refreshId){
        if (!snapshotHealthPollTimerById[refreshId]) return;
        window.clearTimeout(snapshotHealthPollTimerById[refreshId]);
        delete snapshotHealthPollTimerById[refreshId];
      }

      async function pollSnapshotHealthAnnualRefresh(entry, refreshId){
        clearSnapshotHealthPoll(refreshId);
        try {
          var latestEntry = Object.assign({}, entry, await fetchSnapshotHealthEntry(entry));
          replaceSnapshotHealthEntryByRefreshId(refreshId, latestEntry);
          renderSnapshotHealth(snapshotHealthGroups);
          var latestStatus = String(latestEntry && latestEntry.status || '').trim().toLowerCase();
          if (latestStatus === 'queued' || latestStatus === 'processing') {
            setSnapshotHealthStatus(String(entry.label || 'Snapshot') + ' is rebuilding in the background...', 'warning');
            snapshotHealthPollTimerById[refreshId] = window.setTimeout(function(){
              pollSnapshotHealthAnnualRefresh(entry, refreshId);
            }, 4000);
            return;
          }
          if (latestStatus === 'complete') {
            setSnapshotHealthStatus(String(entry.label || 'Snapshot') + ' finished rebuilding.', 'success');
          } else if (latestStatus === 'failed') {
            setSnapshotHealthStatus(String(entry.label || 'Snapshot') + ' failed to rebuild.', 'error');
          }
        } catch (error) {
          setSnapshotHealthStatus(humanizeClientFetchErrorMessage(error, 'Could not refresh rebuild status.'), 'error');
        } finally {
          var currentEntry = findSnapshotHealthEntryByRefreshId(refreshId);
          var currentStatus = String(currentEntry && currentEntry.status || '').trim().toLowerCase();
          if (currentStatus !== 'queued' && currentStatus !== 'processing') {
            clearSnapshotHealthPoll(refreshId);
            delete snapshotHealthRefreshInFlight[refreshId];
            renderSnapshotHealth(snapshotHealthGroups);
          }
        }
      }

      async function refreshSnapshotHealthEntry(entry){
        if (!entry || !entry.refresh_action) return;
        var refreshId = buildSnapshotHealthRefreshId(entry.refresh_action, entry.refresh_body);
        if (snapshotHealthRefreshInFlight[refreshId] === true) return;
        snapshotHealthRefreshInFlight[refreshId] = true;
        renderSnapshotHealth(snapshotHealthGroups);
        setSnapshotHealthStatus((entry.annual_status ? 'Queueing rebuild for ' : 'Refreshing ') + String(entry.label || 'snapshot') + '...', 'warning');
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(Object.assign({ action: entry.refresh_action }, entry.refresh_body || {}))
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data) {
            throw new Error((data && data.error) || rawText || 'Could not refresh snapshot.');
          }
          if (entry.annual_status && (data.queued === true || data.status === 'queued' || data.status === 'processing' || data.already_running === true)) {
            var queuedEntry = Object.assign({}, entry, {
              ok: true,
              status: String(data.status || 'queued').trim() || 'queued'
            });
            replaceSnapshotHealthEntryByRefreshId(refreshId, queuedEntry);
            renderSnapshotHealth(snapshotHealthGroups);
            setSnapshotHealthStatus(String(entry.label || 'Snapshot') + ' queued for rebuild.', 'success');
            snapshotHealthPollTimerById[refreshId] = window.setTimeout(function(){
              pollSnapshotHealthAnnualRefresh(entry, refreshId);
            }, 1500);
            return;
          } else {
            setSnapshotHealthStatus(String(entry.label || 'Snapshot') + ' refreshed.', 'success');
          }
          hasLoadedSnapshotHealth = false;
          await loadSnapshotHealth();
        } catch (error) {
          setSnapshotHealthStatus(humanizeClientFetchErrorMessage(error, 'Could not refresh snapshot.'), 'error');
        } finally {
          if (!entry.annual_status || !snapshotHealthPollTimerById[refreshId]) {
            delete snapshotHealthRefreshInFlight[refreshId];
            renderSnapshotHealth(snapshotHealthGroups);
          }
        }
      }

      async function loadSnapshotHealth(){
        if (!snapshotHealthMount) return;
        try {
          setSnapshotHealthStatus('Reading saved snapshot health...');
          snapshotHealthMount.className = 'empty';
          snapshotHealthMount.innerHTML = 'Reading saved snapshot health...';
          var definitions = buildSnapshotHealthDefinitions();
          var groups = await Promise.all(definitions.map(async function(group){
            var entries = await Promise.all((group.entries || []).map(async function(entry){
              try {
                return Object.assign({}, entry, await fetchSnapshotHealthEntry(entry));
              } catch (error) {
                return Object.assign({}, entry, {
                  ok: false,
                  status: 'failed',
                  snapshot_key: '',
                  snapshot_date: '',
                  date_from: '',
                  date_to: '',
                  created_at: '',
                  updated_at: '',
                  error: humanizeClientFetchErrorMessage(error, 'Could not load snapshot.')
                });
              }
            }));
            return {
              group: group.group,
              group_description: group.group_description,
              entries: entries
            };
          }));
          renderSnapshotHealth(groups);
          hasLoadedSnapshotHealth = true;
          var summary = buildSnapshotHealthSummary(groups);
          setSnapshotHealthStatus(String(summary.fresh) + ' fresh today • ' + String(summary.warning) + ' saved older • ' + String(summary.error) + ' need attention', summary.error ? 'warning' : (summary.warning ? 'warning' : 'success'));
        } catch (error) {
          var message = humanizeClientFetchErrorMessage(error, 'Could not load snapshot health.');
          setSnapshotHealthStatus(message, 'error');
          snapshotHealthMount.className = 'empty';
          snapshotHealthMount.innerHTML = escapeHtml(message);
        }
      }

      async function ensureSnapshotHealthLoaded(){
        await loadSnapshotHealth();
      }

      function renderDueRefreshMeta(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var summaryProgress = hasSafeDueSummary(dueQueueSummary)
          ? (deriveDueRefreshProgressFromSummary(dueQueueSummary) || null)
          : null;
        info = chooseDueRefreshProgress(info, summaryProgress);
        if (dueQueueHealth) {
          dueQueueHealth.setAttribute('data-tone', dueRefreshTone(info));
        }
        if (dueQueueHealthLabel) {
          dueQueueHealthLabel.textContent = dueRefreshHealthLabel(info);
        }
        if (dueQueueHealthState) {
          dueQueueHealthState.textContent = dueRefreshReadinessLabel(info);
        }
        if (dueRefreshStatusValue) dueRefreshStatusValue.textContent = dueRefreshStatusLabel(info.status);
        if (dueRefreshTypeValue) dueRefreshTypeValue.textContent = dueRefreshActionLabel(info);
        if (dueRefreshStepValue) dueRefreshStepValue.textContent = dueRefreshStepLabel(info);
        if (dueRefreshPercentValue) {
          var percentValue = Number(info.percent_complete || 0);
          dueRefreshPercentValue.textContent = isFinite(percentValue) ? (String(percentValue) + '%') : '--';
        }
        if (dueRefreshAppointmentsProcessed) dueRefreshAppointmentsProcessed.textContent = dueRefreshCountText(info.appointments_processed, 'Discovering...');
        if (dueRefreshAppointmentsRemaining) dueRefreshAppointmentsRemaining.textContent = dueRefreshCountText(info.appointments_remaining, 'Discovering...');
        if (dueRefreshAppointmentsTotal) dueRefreshAppointmentsTotal.textContent = dueRefreshCountText(info.appointments_total, 'Discovering...');
        if (dueRefreshReplayRows) dueRefreshReplayRows.textContent = dueRefreshCountText(info.replay_rows_checked, '0');
        if (dueRefreshClientsProcessed) dueRefreshClientsProcessed.textContent = dueRefreshCountText(info.clients_processed, '0');
        if (dueRefreshClientsRemaining) dueRefreshClientsRemaining.textContent = dueRefreshCountText(info.clients_remaining, 'Calculating...');
        if (dueRefreshClientsTotal) dueRefreshClientsTotal.textContent = dueRefreshCountText(info.clients_total, 'Calculating...');
        if (dueRefreshChangedGuestsTotal) dueRefreshChangedGuestsTotal.textContent = dueRefreshCountText(info.changed_guest_keys_total, dueRefreshCountText(info.clients_total, 'Calculating...'));
        if (dueRefreshQueueDelta) dueRefreshQueueDelta.textContent = buildDueRefreshQueueDeltaText(info);
        if (dueRefreshStartedAt) dueRefreshStartedAt.textContent = formatRecaptureDateTime(info.started_at);
        if (dueRefreshUpdatedAt) dueRefreshUpdatedAt.textContent = formatRecaptureDateTime(info.updated_at);
        if (dueRefreshLastSuccessAt) dueRefreshLastSuccessAt.textContent = formatRecaptureDateTime(info.last_successful_refresh_at);
        if (dueRefreshSafeValue) dueRefreshSafeValue.textContent = info.safe_to_use_snapshot === true ? 'Yes' : 'No';
        if (dueLiveStatusValue) dueLiveStatusValue.textContent = dueRefreshStepLabel(info);
        if (dueLiveGuestsValue) dueLiveGuestsValue.textContent = dueRefreshCountText(info.changed_guest_keys_total, dueRefreshCountText(info.clients_processed, '0'));
        if (dueLiveAppointmentsValue) dueLiveAppointmentsValue.textContent = dueRefreshCountText(info.appointments_processed, '0');
        if (dueLiveUpdatedValue) dueLiveUpdatedValue.textContent = formatRecaptureDateTime(info.updated_at || info.last_successful_refresh_at);
        renderDueDirtyAlert(info);
        renderDueRefreshImpact(dueLastRefreshImpact, info);
        var normalizedStatus = String(info.status || '').trim().toLowerCase();
        var uiPhase = normalizedStatus === 'failed'
          ? 'error'
          : normalizedStatus === 'complete'
            ? 'ready'
            : 'syncing';
        var uiPercent = Number(info.percent_complete || 0);
        if (!isFinite(uiPercent) || uiPercent <= 0) {
          uiPercent = uiPhase === 'ready' ? 100 : (info.safe_to_use_snapshot === true ? 100 : 12);
        }
        setDueQueueUiState(uiPhase, {
          tone: dueRefreshTone(info),
          label: uiPhase === 'ready' ? 'Queue ready' : dueRefreshStepLabel(info),
          hint: buildDueSyncHint(info),
          percent: uiPercent
        });
      }

      function deriveDueRefreshProgressFromSummary(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var refresh = safeSummary.refresh && typeof safeSummary.refresh === 'object' ? safeSummary.refresh : {};
        var snapshot = safeSummary.snapshot && typeof safeSummary.snapshot === 'object' ? safeSummary.snapshot : {};
        var totalRows = Number(
          safeSummary.filtered_total_rows
          || safeSummary.total_snapshot_rows
          || safeSummary.unified_appointment_count
          || 0
        ) || 0;
        var workspaceCounts = safeSummary.workspace_counts && typeof safeSummary.workspace_counts === 'object'
          ? safeSummary.workspace_counts
          : {};
        var hasWorkspaceRows = Object.keys(workspaceCounts).some(function(key){
          return (Number(workspaceCounts[key] || 0) || 0) > 0;
        });
        var safeSnapshot = hasSafeDueSummary(safeSummary);
        if (!safeSnapshot && !Object.keys(refresh).length && !Object.keys(snapshot).length) {
          return null;
        }
        var lastSuccessfulRefreshAt = retailTextValue(
          refresh.last_successful_refresh_at
          || refresh.updated_at
          || snapshot.last_successful_refresh_at
          || snapshot.updated_at
          || snapshot.generated_at
          || snapshot.snapshot_date,
          ''
        );
        return {
          status: retailTextValue(refresh.status, '') || (safeSnapshot ? 'complete' : 'not_started'),
          refresh_type: retailTextValue(refresh.refresh_type, '') || (safeSnapshot ? 'fast_refresh' : ''),
          current_step_label: retailTextValue(refresh.current_step_label, '') || (safeSnapshot ? 'Waiting for next update' : ''),
          safe_to_use_snapshot: safeSnapshot,
          percent_complete: Number(refresh.percent_complete || 0) || (safeSnapshot ? 100 : 0),
          updated_at: retailTextValue(refresh.updated_at, '') || lastSuccessfulRefreshAt,
          last_successful_refresh_at: lastSuccessfulRefreshAt,
          appointments_processed: Number(refresh.appointments_processed || 0) || 0,
          appointments_remaining: Number(refresh.appointments_remaining || 0) || 0,
          appointments_total: Number(refresh.appointments_total || 0) || 0,
          replay_rows_checked: Number(refresh.replay_rows_checked || 0) || 0,
          clients_processed: Number(refresh.clients_processed || 0) || 0,
          clients_remaining: Number(refresh.clients_remaining || 0) || 0,
          clients_total: Number(refresh.clients_total || 0) || 0,
          changed_guest_keys_total: Number(refresh.changed_guest_keys_total || 0) || 0,
          queue_rows_added: Number(refresh.queue_rows_added || 0) || 0,
          queue_rows_updated: Number(refresh.queue_rows_updated != null ? refresh.queue_rows_updated : refresh.queue_rows_changed) || 0,
          queue_rows_removed: Number(refresh.queue_rows_removed || 0) || 0
        };
      }

      function hasDueRefreshProgressData(progress){
        if (!progress || typeof progress !== 'object') return false;
        return Object.keys(progress).some(function(key){
          var value = progress[key];
          if (value == null) return false;
          if (typeof value === 'string') return value.trim() !== '';
          if (typeof value === 'number') return !isNaN(value);
          if (typeof value === 'boolean') return true;
          if (Array.isArray(value)) return value.length > 0;
          if (typeof value === 'object') return Object.keys(value).length > 0;
          return true;
        });
      }

      function hasSafeDueSummary(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var refresh = safeSummary.refresh && typeof safeSummary.refresh === 'object' ? safeSummary.refresh : {};
        var snapshot = safeSummary.snapshot && typeof safeSummary.snapshot === 'object' ? safeSummary.snapshot : {};
        var totalRows = Number(
          safeSummary.filtered_total_rows
          || safeSummary.total_snapshot_rows
          || safeSummary.unified_appointment_count
          || 0
        ) || 0;
        var workspaceCounts = safeSummary.workspace_counts && typeof safeSummary.workspace_counts === 'object'
          ? safeSummary.workspace_counts
          : {};
        var hasWorkspaceRows = Object.keys(workspaceCounts).some(function(key){
          return (Number(workspaceCounts[key] || 0) || 0) > 0;
        });
        var lastSuccess = retailTextValue(
          refresh.last_successful_refresh_at
          || refresh.updated_at
          || snapshot.last_successful_refresh_at
          || snapshot.updated_at
          || snapshot.generated_at
          || snapshot.snapshot_date,
          ''
        );
        return refresh.safe_to_use_snapshot === true
          || snapshot.safe_to_use_snapshot === true
          || !!lastSuccess
          || totalRows > 0
          || hasWorkspaceRows;
      }

      function buildDueRefreshQueueDeltaText(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var added = Math.max(0, Number(info.queue_rows_added || 0) || 0);
        var changed = dueRefreshUpdatedCountValue(info);
        var removed = Math.max(0, Number(info.queue_rows_removed || 0) || 0);
        var total = Math.max(0, added + changed + removed);
        if (!total) {
          total = Math.max(0, Number(info.client_record_changes || 0) || 0);
        }
        if (!total) return 'No changes';
        return String(added) + ' / ' + String(changed) + ' / ' + String(removed);
      }

      function formatDueSnapshotAgeLabel(value){
        var iso = String(value || '').trim();
        if (!iso) return '--';
        var parsed = new Date(iso);
        if (!isFinite(parsed.getTime())) return '--';
        var diffMs = Date.now() - parsed.getTime();
        if (!isFinite(diffMs)) return '--';
        var diffDays = Math.floor(diffMs / 86400000);
        if (diffDays <= 0) return 'Today';
        if (diffDays === 1) return '1 day old';
        return String(diffDays) + ' days old';
      }

      function buildDueRefreshChangeSummary(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var added = Math.max(0, Number(info.queue_rows_added || 0) || 0);
        var updated = dueRefreshUpdatedCountValue(info);
        var removed = Math.max(0, Number(info.queue_rows_removed || 0) || 0);
        var total = Math.max(0, added + updated + removed);
        if (!total) {
          total = Math.max(0, Number(info.client_record_changes || 0) || 0);
        }
        if (!total) {
          if (String(info.status || '').trim().toLowerCase() === 'complete') {
            return {
              value: 'No changes',
              sub: 'Latest Boulevard check did not change the saved queue.'
            };
          }
          return {
            value: '--',
              sub: 'Use Refresh Queue to compare newer Boulevard appointments.'
          };
        }
        return {
          value: String(total),
          sub: String(added) + ' added, ' + String(updated) + ' updated, ' + String(removed) + ' deleted'
        };
      }

      function buildDueRefreshRecentChangesText(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var changes = Array.isArray(info.recent_queue_changes) ? info.recent_queue_changes : [];
        if (!changes.length) return '';
        var labels = changes.map(function(change){
          var safeChange = change && typeof change === 'object' ? change : {};
          var type = String((safeChange && safeChange.type) || 'updated').trim().toLowerCase();
          var guestName = String((safeChange && safeChange.guest_name) || 'Guest').trim() || 'Guest';
          if (type === 'added') return guestName + ' added';
          if (type === 'removed') return guestName + ' removed';
          return guestName + ' updated';
        }).filter(Boolean);
        if (!labels.length) return '';
        return ' Recent changes: ' + labels.join('; ') + '.';
      }

      function dueRefreshNormalizeImpactRow(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var changeType = String(
          safeRow.change_type != null
            ? safeRow.change_type
            : (safeRow.type != null ? safeRow.type : 'updated')
        ).trim().toLowerCase();
        if (changeType === 'removed') changeType = 'deleted';
        if (changeType !== 'added' && changeType !== 'updated' && changeType !== 'deleted') {
          changeType = 'updated';
        }
        return {
          guest_bucket_key: retailTextValue(safeRow.guest_bucket_key, ''),
          guest_name: retailTextValue(safeRow.guest_name, 'Guest') || 'Guest',
          change_type: changeType,
          queue_stage: retailTextValue(safeRow.queue_stage, ''),
          queue_stage_label: retailTextValue(safeRow.queue_stage_label, ''),
          primary_category: retailTextValue(safeRow.primary_category, ''),
          primary_label: retailTextValue(safeRow.primary_label || safeRow.detail, ''),
          detail: retailTextValue(safeRow.detail, '')
        };
      }

      function dueRefreshImpactRowsFromProgress(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        return retailArray(info.recent_queue_changes).map(dueRefreshNormalizeImpactRow);
      }

      function dueRefreshGroupImpactRows(rows){
        var groups = {
          added: [],
          updated: [],
          deleted: []
        };
        retailArray(rows).forEach(function(row){
          var normalized = dueRefreshNormalizeImpactRow(row);
          groups[normalized.change_type].push(normalized);
        });
        Object.keys(groups).forEach(function(key){
          groups[key] = groups[key].sort(function(left, right){
            return retailTextValue(left.guest_name, '').localeCompare(retailTextValue(right.guest_name, ''));
          });
        });
        return groups;
      }

      function dueRefreshCountLabel(count, singular, plural){
        var numeric = Math.max(0, Number(count || 0) || 0);
        return String(numeric) + ' ' + (numeric === 1 ? singular : plural);
      }

      function dueRefreshNamesText(rows){
        return retailArray(rows).map(function(row){
          return retailTextValue(row && row.guest_name, '');
        }).filter(Boolean).join(', ');
      }

      function dueRefreshImpactTone(changeType){
        var normalized = String(changeType || '').trim().toLowerCase();
        if (normalized === 'added') return 'added';
        if (normalized === 'removed' || normalized === 'deleted') return 'removed';
        if (normalized === 'updated') return 'updated';
        return 'unchanged';
      }

      function dueRefreshImpactLabel(changeType){
        var normalized = String(changeType || '').trim().toLowerCase();
        if (normalized === 'added') return 'Added';
        if (normalized === 'removed' || normalized === 'deleted') return 'Deleted';
        if (normalized === 'updated') return 'Updated';
        return 'Reviewed';
      }

      function dueRefreshImpactRows(result){
        var safeResult = result && typeof result === 'object' ? result : {};
        return retailArray(safeResult.affected_guests).map(function(row){
          return dueRefreshNormalizeImpactRow(row && typeof row === 'object' ? row : {});
        });
      }

      function dueRefreshImpactMarkup(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var changeType = String(safeRow.change_type || 'unchanged').trim().toLowerCase();
        var guestName = String(safeRow.guest_name || 'Guest').trim() || 'Guest';
        var lane = String(safeRow.queue_stage_label || safeRow.queue_stage || '').trim();
        var detail = String(safeRow.primary_label || safeRow.primary_category || safeRow.detail || '').trim();
        var subline = [lane, detail].filter(Boolean).join(' • ') || 'Queue row reviewed from appointment changes';
        return ''
          + '<div class="due-refreshImpactItem">'
          +   '<div class="due-refreshImpactCopy">'
          +     '<div class="due-refreshImpactName">' + escapeHtml(guestName) + '</div>'
          +     '<div class="due-refreshImpactSub">' + escapeHtml(subline) + '</div>'
          +   '</div>'
          +   '<span class="due-refreshImpactType" data-tone="' + escapeHtml(dueRefreshImpactTone(changeType)) + '">' + escapeHtml(dueRefreshImpactLabel(changeType)) + '</span>'
          + '</div>';
      }

      function renderDueRefreshImpact(result, progress){
        if (!dueRefreshImpact || !dueRefreshImpactMeta || !dueRefreshImpactList) return;
        var rows = dueRefreshImpactRows(result);
        if (!rows.length) {
          rows = dueRefreshImpactRowsFromProgress(progress);
        }
        if (!rows.length) {
          dueRefreshImpact.hidden = true;
          if (dueRefreshAddedCount) dueRefreshAddedCount.textContent = '0';
          if (dueRefreshUpdatedCount) dueRefreshUpdatedCount.textContent = '0';
          if (dueRefreshRemovedCount) dueRefreshRemovedCount.textContent = '0';
          dueRefreshImpactMeta.textContent = 'Run a manual refresh to see exactly which queue rows changed.';
          dueRefreshImpactList.innerHTML = '<div class="retail-empty">No changed guests have been loaded yet.</div>';
          return;
        }
        var groups = dueRefreshGroupImpactRows(rows);
        dueRefreshImpact.hidden = false;
        if (dueRefreshAddedCount) dueRefreshAddedCount.textContent = String(groups.added.length);
        if (dueRefreshUpdatedCount) dueRefreshUpdatedCount.textContent = String(groups.updated.length);
        if (dueRefreshRemovedCount) dueRefreshRemovedCount.textContent = String(groups.deleted.length);
        var summaryBits = [];
        if (groups.added.length) summaryBits.push(dueRefreshCountLabel(groups.added.length, 'row added', 'rows added'));
        if (groups.updated.length) summaryBits.push(dueRefreshCountLabel(groups.updated.length, 'row updated', 'rows updated'));
        if (groups.deleted.length) summaryBits.push(dueRefreshCountLabel(groups.deleted.length, 'row deleted', 'rows deleted'));
        dueRefreshImpactMeta.textContent = summaryBits.length
          ? summaryBits.join(' • ') + '. Names below are the exact clients touched by the latest refresh.'
          : 'Names below are the exact clients touched by the latest refresh.';
        var orderedRows = []
          .concat(groups.added)
          .concat(groups.updated)
          .concat(groups.deleted);
        dueRefreshImpactList.innerHTML = orderedRows.map(dueRefreshImpactMarkup).join('');
      }

      async function applyDueInlineRefreshResult(result){
        var safeResult = result && typeof result === 'object' ? result : {};
        var refreshedRows = retailArray(safeResult.affected_queue_rows).map(function(row){
          return row && typeof row === 'object'
            ? Object.assign({ queue_source: retailTextValue(row && row.queue_source, '') || 'appointment', opportunity_key: retailTextValue(row && row.opportunity_key, '') || buildPriorityOpportunityKey(row) }, row)
            : row;
        });
        var removedBucketKeys = new Set(
          retailArray(safeResult.removed_guest_bucket_keys).map(function(value){
            return String(value || '').trim();
          }).filter(Boolean)
        );
        if (!refreshedRows.length && !removedBucketKeys.size) {
          return false;
        }
        var refreshedByBucket = new Map();
        refreshedRows.forEach(function(row){
          var bucketKey = retailTextValue(row && row.guest_bucket_key, '');
          if (!bucketKey) return;
          refreshedByBucket.set(bucketKey, row);
        });
        var seenBucketKeys = new Set();
        var nextRows = [];
        retailArray(dueQueueRows).forEach(function(row){
          var bucketKey = retailTextValue(row && row.guest_bucket_key, '');
          if (bucketKey && removedBucketKeys.has(bucketKey)) return;
          if (bucketKey && refreshedByBucket.has(bucketKey)) {
            nextRows.push(Object.assign({}, row, refreshedByBucket.get(bucketKey)));
            seenBucketKeys.add(bucketKey);
            return;
          }
          nextRows.push(row);
        });
        refreshedRows.forEach(function(row){
          var bucketKey = retailTextValue(row && row.guest_bucket_key, '');
          if (!bucketKey || seenBucketKeys.has(bucketKey)) return;
          nextRows.push(row);
        });
        dueQueueRows = mergePriorityRowsByOpportunityKey(mergeLocalClaimedRows(nextRows));
        if (dueQueueSummary && dueQueueSummary.unified_queue === true) {
          dueQueueSummary = dueHydrateUnifiedSummaryRowSets(dueQueueSummary, dueQueueRows);
          dueQueueOverviewSummary = dueBuildOverviewSummary(dueQueueSummary);
        }
        dueQueueTotalRows = Number((dueQueueSummary && (dueQueueSummary.total_snapshot_rows || dueQueueSummary.filtered_total_rows)) || 0) || dueQueueRows.length;
        storeDueQueueWorkspaceCache(dueQueueWorkspace, dueQueueRows, dueQueueSummary, dueQueueRefreshProgress, dueQueueOfferOptions, dueQueueScorecard);
        renderDueQueue();
        return true;
      }

      function buildDueSnapshotSummary(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var lastSuccess = formatRecaptureDateTime(info.last_successful_refresh_at);
        var ageLabel = formatDueSnapshotAgeLabel(info.last_successful_refresh_at);
        var safeSnapshot = info.safe_to_use_snapshot === true;
        if (!safeSnapshot) {
          return {
            value: 'No queue data',
            sub: 'Run the direct queue refresh to load current client follow-up data.'
          };
        }
        return {
          value: ageLabel,
          sub: lastSuccess === '--'
            ? 'Direct queue data is available, but last successful refresh time is unknown.'
            : 'Direct queue data is current through ' + lastSuccess + '.'
        };
      }

      function setDueDirtyAlert(text, tone){
        if (!dueDirtyAlert) return;
        dueDirtyAlert.textContent = String(text || '');
        dueDirtyAlert.className = 'due-queueHealthNote' + (tone ? ' due-queueHealthNote--' + tone : '');
      }

      function renderDueDirtyAlert(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var summaryProgress = hasSafeDueSummary(dueQueueSummary)
          ? (deriveDueRefreshProgressFromSummary(dueQueueSummary) || null)
          : null;
        info = chooseDueRefreshProgress(info, summaryProgress);
        var status = String(info.status || '').trim().toLowerCase();
        var refreshType = String(info.refresh_type || '').trim().toLowerCase();
        var safeSnapshot = info.safe_to_use_snapshot === true;
        var requiresBaselineRebuild = info && info.requires_baseline_rebuild === true;
        var staleRunning = info && info.stale_running === true;
        var lastSuccess = formatRecaptureDateTime(info.last_successful_refresh_at);
        var incrementalSince = dueRefreshSinceText(info);
        var rawLastError = retailTextValue(info.last_error, '');
        var failedPhase = retailTextValue(info.failed_phase || info.current_step, '');
        var failedPhaseLabel = failedPhase ? dueRefreshStepLabel({ status: 'running', refresh_type: info.refresh_type, current_step_label: failedPhase, current_step: failedPhase }) : 'the last update';
        var lastError = rawLastError
          .replace(/^Refresh failed during failed\.?\s*/i, '')
          .trim();
        if (requiresBaselineRebuild && status !== 'running') {
          if (safeSnapshot) {
            setDueDirtyAlert('The queue is still usable. The next sync will repair only the parts that need updating.', 'warning');
          } else {
            setDueDirtyAlert('There is no healthy saved queue yet. Run sync to rebuild it.', 'warning');
          }
          return;
        }
        if (status === 'running' && staleRunning) {
          setDueDirtyAlert('The last sync paused. Resume Sync will continue from the last checkpoint.', safeSnapshot ? 'warning' : 'error');
          return;
        }
        if (!status || status === 'not_started') {
          if (safeSnapshot) {
            setDueDirtyAlert('Queue is ready. Refresh checks only recent Boulevard changes.', 'success');
          } else {
            setDueDirtyAlert('No saved queue yet. Refresh Queue will load the first one.', 'warning');
          }
          return;
        }
        if (status === 'running' && refreshType === 'full_rebuild') {
          if (safeSnapshot) {
            setDueDirtyAlert('A deeper repair is running. The current queue stays available until it finishes.', 'warning');
          } else {
            setDueDirtyAlert('The queue is still being built. Wait for the first sync to finish.', 'warning');
          }
          return;
        }
        if (status === 'running' && (refreshType === 'fast_refresh' || refreshType === 'direct_guest_facts')) {
          var appointmentsProcessed = Math.max(0, Number(info.appointments_processed || 0) || 0);
          var appointmentsTotal = Math.max(0, Number(info.appointments_total || 0) || 0);
          var changedGuests = Math.max(0, Number(info.changed_guest_keys_total || 0) || 0);
          var clientsProcessed = Math.max(0, Number(info.clients_processed || 0) || 0);
          if (appointmentsTotal > 0 && appointmentsProcessed < appointmentsTotal) {
            setDueDirtyAlert(
              'Checking recent appointment changes: ' + formatRecaptureNumber(appointmentsProcessed) + ' of ' + formatRecaptureNumber(appointmentsTotal) + ' reviewed.',
              'warning'
            );
            return;
          }
          setDueDirtyAlert(
            'Updating the guests touched by those changes: '
            + formatRecaptureNumber(clientsProcessed) + ' updated'
            + (changedGuests > 0 ? ' of ' + formatRecaptureNumber(changedGuests) : '')
            + '.',
            'warning'
          );
          return;
        }
        if (status === 'failed') {
          if (safeSnapshot) {
            setDueDirtyAlert(
              lastError
                ? ('The last sync failed while ' + String(failedPhaseLabel || 'processing').toLowerCase() + '. ' + lastError + ' The queue is still using the last safe version from ' + lastSuccess + '.')
                : ('The last sync failed. The queue is still using the last safe version from ' + lastSuccess + '.'),
              'error'
            );
          } else {
            setDueDirtyAlert(
              lastError
                ? ('The last sync failed while ' + String(failedPhaseLabel || 'processing').toLowerCase() + '. ' + lastError)
                : 'The last sync failed and there is no safe queue yet.',
              'error'
            );
          }
          return;
        }
        if (status === 'complete') {
          var changeSummary = buildDueRefreshChangeSummary(info);
          var noChanges = changeSummary && /no changes/i.test(String(changeSummary.value || ''));
          if (noChanges) {
            setDueDirtyAlert('Last sync finished ' + lastSuccess + '. No queue rows needed to change.', 'success');
            return;
          }
          var recentRows = dueRefreshImpactRowsFromProgress(info);
          var groupedRows = dueRefreshGroupImpactRows(recentRows);
          var namedSummary = [];
          if (groupedRows.added.length) namedSummary.push('Added: ' + dueRefreshNamesText(groupedRows.added));
          if (groupedRows.updated.length) namedSummary.push('Updated: ' + dueRefreshNamesText(groupedRows.updated));
          if (groupedRows.deleted.length) namedSummary.push('Deleted: ' + dueRefreshNamesText(groupedRows.deleted));
          var changeSuffix = namedSummary.length
            ? namedSummary.join(' | ')
            : (changeSummary && changeSummary.value && changeSummary.value !== '--'
              ? changeSummary.value + (changeSummary.sub ? ' (' + changeSummary.sub + ')' : '')
              : 'Saved queue rows were refreshed from recent Boulevard changes.');
          setDueDirtyAlert('Last sync finished ' + lastSuccess + '. ' + changeSuffix, 'success');
          return;
        }
        setDueDirtyAlert('Queue status is available. Refresh Queue will choose the right next step automatically.', 'warning');
      }

      function getDuePrimaryActionPlan(progress){
        var info = progress && typeof progress === 'object' ? progress : {};
        var status = String(info.status || '').trim().toLowerCase();
        var refreshType = String(info.refresh_type || '').trim().toLowerCase();
        var safeSnapshot = info.safe_to_use_snapshot === true;
        var requiresBaselineRebuild = info && info.requires_baseline_rebuild === true;
        var staleRunning = info && info.stale_running === true;
        var incrementalSince = dueRefreshSinceText(info);
        if (status === 'running' && refreshType === 'full_rebuild') {
          return {
            forceFullRebuild: false,
            label: staleRunning ? 'Resume Sync' : 'Refresh Queue',
            message: staleRunning
              ? 'The last sync looks paused. Resuming from the last checkpoint now.'
              : 'The queue is still repairing in the background. Refresh will keep using the lightweight update path.'
          };
        }
        if (requiresBaselineRebuild) {
          return {
            forceFullRebuild: false,
            label: 'Refresh Queue',
            message: safeSnapshot
              ? 'The queue is still usable. Refreshing only the parts touched by recent Boulevard changes.'
              : 'Starting the first saved queue sync now.'
          };
        }
        if (!safeSnapshot || status === 'not_started') {
          return {
            forceFullRebuild: false,
            label: 'Refresh Queue',
            message: 'Starting the queue sync now.'
          };
        }
        if (status === 'failed' && refreshType === 'full_rebuild' && !safeSnapshot) {
          return {
            forceFullRebuild: false,
            label: 'Resume Sync',
            message: 'The last sync failed. Retrying now.'
          };
        }
        return {
          forceFullRebuild: false,
          label: 'Refresh Queue',
          message: 'Checking recent Boulevard changes' + (incrementalSince ? ' since ' + incrementalSince : '') + ' and updating the affected guests now.'
        };
      }

      function buildRecaptureProgressSummary(progress, options){
        var safeProgress = progress && typeof progress === 'object' ? progress : {};
        if (!hasDueRefreshProgressData(safeProgress) && hasSafeDueSummary(dueQueueSummary)) {
          safeProgress = deriveDueRefreshProgressFromSummary(dueQueueSummary) || safeProgress;
        }
        var status = retailTextValue(safeProgress.status, '').toLowerCase();
        var refreshType = retailTextValue(safeProgress.refresh_type, '').toLowerCase();
        var incrementalSince = dueRefreshSinceText(safeProgress);
        var stepLabel = retailTextValue(safeProgress.current_step_label, '') || dueRefreshStepLabel(safeProgress);
        var appointmentsProcessed = Math.max(0, Number(safeProgress.appointments_processed || 0) || 0);
        var appointmentsTotal = Math.max(0, Number(safeProgress.appointments_total || 0) || 0);
        var appointmentsRemaining = Math.max(0, Number(safeProgress.appointments_remaining || 0) || 0);
        var changedGuests = Math.max(0, Number(safeProgress.changed_guest_keys_total || 0) || 0);
        var clientsProcessed = Math.max(0, Number(safeProgress.clients_processed || 0) || 0);
        var safeSnapshot = safeProgress.safe_to_use_snapshot === true;
        if (status === 'running' && refreshType === 'full_rebuild') {
          if (appointmentsTotal > 0) {
            return stepLabel + ': '
              + formatRecaptureNumber(appointmentsProcessed)
              + ' of '
              + formatRecaptureNumber(appointmentsTotal)
              + ' appointments checked. '
              + formatRecaptureNumber(appointmentsRemaining)
              + ' appointments remaining.'
              + (safeSnapshot ? ' The current saved queue is still safe to use.' : '');
          }
          return 'Rebuilding the full queue baseline in the background.'
            + (safeSnapshot ? ' The current saved queue is still safe to use.' : '');
        }
        if (status === 'running' && (refreshType === 'fast_refresh' || refreshType === 'direct_guest_facts')) {
          if (appointmentsTotal > 0) {
            return stepLabel + ': '
              + formatRecaptureNumber(appointmentsProcessed)
              + ' of '
              + formatRecaptureNumber(appointmentsTotal)
              + ' changed appointments checked.'
              + (incrementalSince ? ' Since ' + incrementalSince + '.' : '');
          }
          if (clientsProcessed > 0 || changedGuests > 0) {
            return 'Refreshing saved guest rows: '
              + formatRecaptureNumber(clientsProcessed)
              + ' updated'
              + (changedGuests > 0 ? ' of ' + formatRecaptureNumber(changedGuests) : '')
              + '.';
          }
          return 'Checking changed Boulevard appointments' + (incrementalSince ? ' since ' + incrementalSince : '') + '.';
        }
        if (status === 'complete') {
          if (changedGuests > 0) {
            return 'Refresh finished. ' + formatRecaptureNumber(changedGuests) + ' client'
              + (changedGuests === 1 ? '' : 's') + ' changed.';
          }
          return 'Refresh finished. No queue rows changed.';
        }
        if (status === 'failed') {
          return 'The last queue update did not finish cleanly.';
        }
        return 'Queue status unavailable.';
      }

      function workspaceCountText(value){
        var numberValue = Number(value || 0) || 0;
        if (numberValue >= 1000) {
          if (numberValue >= 10000) return Math.round(numberValue / 1000) + 'k+';
          return (Math.round((numberValue / 1000) * 10) / 10).toFixed(1).replace(/\.0$/, '') + 'k';
        }
        return String(numberValue);
      }

      function dueRowCadenceDays(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var primaryDue = safeRow.primary_due_item && typeof safeRow.primary_due_item === 'object'
          ? safeRow.primary_due_item
          : null;
        return Math.max(0, Number(
          (primaryDue && (primaryDue.due_days || primaryDue.cadence_days))
          || safeRow.due_days
          || safeRow.cadence_days
          || 0
        ) || 0);
      }

      function dueRowDaysSinceLastVisit(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var primaryDue = safeRow.primary_due_item && typeof safeRow.primary_due_item === 'object'
          ? safeRow.primary_due_item
          : null;
        return Math.max(0, Number(
          (primaryDue && primaryDue.days_since_last_visit)
          || safeRow.days_since_last_visit
          || 0
        ) || 0);
      }

      function dueRowDaysOverdue(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var primaryDue = safeRow.primary_due_item && typeof safeRow.primary_due_item === 'object'
          ? safeRow.primary_due_item
          : null;
        return Math.max(0, Number(
          (primaryDue && primaryDue.days_overdue)
          || safeRow.days_overdue
          || safeRow.max_days_overdue
          || 0
        ) || 0);
      }

      function dueRowIsRecaptureOpportunity(row){
        return retailTextValue(row && row.queue_source, 'appointment') === 'appointment'
          && retailTextValue(row && row.queue_stage, '').toLowerCase() === 'non_current_recapture';
      }

      function dueRowBusinessBucketKey(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var debug = safeRow.debug && typeof safeRow.debug === 'object' ? safeRow.debug : {};
        var normalizedFields = debug.normalized_fields && typeof debug.normalized_fields === 'object'
          ? debug.normalized_fields
          : {};
        var diagnosis = debug.diagnosis && typeof debug.diagnosis === 'object'
          ? debug.diagnosis
          : {};
        return retailTextValue(
          safeRow.business_bucket_key
            || safeRow.business_subcategory
            || safeRow.business_subcategory_key
            || normalizedFields.business_bucket_key
            || normalizedFields.business_subcategory
            || diagnosis.business_subcategory
            || diagnosis.business_category,
          ''
        ).toLowerCase();
      }

      function dueSummaryBusinessBucketCounts(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var snapshot = safeSummary.snapshot && typeof safeSummary.snapshot === 'object'
          ? safeSummary.snapshot
          : {};
        var snapshotPayload = snapshot.payload && typeof snapshot.payload === 'object'
          ? snapshot.payload
          : {};
        var snapshotSummary = snapshotPayload.summary && typeof snapshotPayload.summary === 'object'
          ? snapshotPayload.summary
          : {};
        if (safeSummary.business_bucket_counts_actionable && typeof safeSummary.business_bucket_counts_actionable === 'object') {
          return safeSummary.business_bucket_counts_actionable;
        }
        if (snapshotSummary.business_bucket_counts_actionable && typeof snapshotSummary.business_bucket_counts_actionable === 'object') {
          return snapshotSummary.business_bucket_counts_actionable;
        }
        return {};
      }

      function dueBusinessBucketCountTotal(counts){
        var safeCounts = counts && typeof counts === 'object' ? counts : {};
        return Object.keys(safeCounts).reduce(function(sum, key){
          return sum + (Number(safeCounts[key] || 0) || 0);
        }, 0);
      }

      function dueSummaryStrength(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var snapshot = safeSummary.snapshot && typeof safeSummary.snapshot === 'object'
          ? safeSummary.snapshot
          : {};
        var snapshotPayload = snapshot.payload && typeof snapshot.payload === 'object'
          ? snapshot.payload
          : {};
        var snapshotSummary = snapshotPayload.summary && typeof snapshotPayload.summary === 'object'
          ? snapshotPayload.summary
          : {};
        return Math.max(
          Number(safeSummary.filtered_total_rows || 0) || 0,
          Number(safeSummary.total_due_clients || 0) || 0,
          Number(safeSummary.total_snapshot_rows || 0) || 0,
          Number(safeSummary.total_tracked_guests || 0) || 0,
          Number(snapshotSummary.filtered_total_rows || 0) || 0,
          Number(snapshotSummary.total_due_clients || 0) || 0,
          Number(snapshotSummary.total_snapshot_rows || 0) || 0,
          Number(snapshotSummary.total_tracked_guests || 0) || 0,
          Number(snapshotPayload.total_due_clients || 0) || 0,
          Number(snapshotPayload.row_count || 0) || 0,
          dueBusinessBucketCountTotal(safeSummary.business_bucket_counts_actionable),
          dueBusinessBucketCountTotal(snapshotSummary.business_bucket_counts_actionable)
        );
      }

      function duePickBestSummary(){
        var candidates = Array.prototype.slice.call(arguments || []).filter(function(candidate){
          return candidate && typeof candidate === 'object';
        });
        if (!candidates.length) return {};
        return candidates.reduce(function(best, candidate){
          return dueSummaryStrength(candidate) > dueSummaryStrength(best) ? candidate : best;
        }, candidates[0]);
      }

      function dueSummaryTrackedGuestCount(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var snapshot = safeSummary.snapshot && typeof safeSummary.snapshot === 'object'
          ? safeSummary.snapshot
          : {};
        var snapshotPayload = snapshot.payload && typeof snapshot.payload === 'object'
          ? snapshot.payload
          : {};
        var snapshotSummary = snapshotPayload.summary && typeof snapshotPayload.summary === 'object'
          ? snapshotPayload.summary
          : {};
        return Number(
          safeSummary.total_tracked_guests
          || safeSummary.tracked_guests
          || snapshotSummary.total_tracked_guests
          || snapshotPayload.total_tracked_guests
          || snapshotPayload.tracked_guest_count
          || 0
        ) || 0;
      }

      function dueSummaryActionableAppointmentCount(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var snapshot = safeSummary.snapshot && typeof safeSummary.snapshot === 'object'
          ? safeSummary.snapshot
          : {};
        var snapshotPayload = snapshot.payload && typeof snapshot.payload === 'object'
          ? snapshot.payload
          : {};
        var snapshotSummary = snapshotPayload.summary && typeof snapshotPayload.summary === 'object'
          ? snapshotPayload.summary
          : {};
        var bucketCounts = dueSummaryBusinessBucketCounts(safeSummary);
        var bucketTotal = dueBusinessBucketCountTotal(bucketCounts);
        return Number(
          bucketTotal
          || safeSummary.total_due_clients
          || snapshotSummary.total_due_clients
          || snapshotPayload.total_due_clients
          || safeSummary.total_snapshot_rows
          || snapshotPayload.row_count
          || 0
        ) || 0;
      }

      function dueRowsMatchingBusinessBucket(rows, bucketKey){
        var normalizedBucket = String(bucketKey || '').trim().toLowerCase();
        if (!normalizedBucket) return retailArray(rows);
        var bucketKeys = normalizedBucket.split(',').map(function(part){
          return String(part || '').trim().toLowerCase();
        }).filter(Boolean);
        return retailArray(rows).filter(function(row){
          return bucketKeys.indexOf(dueRowBusinessBucketKey(row)) >= 0;
        });
      }

      function dueWorkspaceBusinessBucketFilter(workspace){
        var normalized = String(workspace || 'all').trim() || 'all';
        if (
          normalized === 'never_visited'
          || normalized === 'needs_prebook'
          || normalized === 'needs_attention'
          || normalized === 'needs_recovery'
          || normalized === 'no_pattern'
        ) {
          return '';
        }
        if (normalized === 'prebook') return 'watch_due_soon,watch_due_now';
        if (normalized === 'active_drift') {
          return [
            'at_risk_cadence_break',
            'at_risk_canceled_unbooked',
            'at_risk_no_show_unbooked',
            'at_risk_declining_frequency',
            'at_risk_partial_return'
          ].join(',');
        }
        if (normalized === 'long_lost') return 'lost_likely_lapsed';
        if (
          normalized === 'watch_due_soon'
          || normalized === 'watch_due_now'
          || normalized === 'at_risk_cadence_break'
          || normalized === 'at_risk_canceled_unbooked'
          || normalized === 'at_risk_no_show_unbooked'
          || normalized === 'at_risk_declining_frequency'
          || normalized === 'at_risk_partial_return'
          || normalized === 'lost_likely_lapsed'
        ) {
          return normalized;
        }
        return '';
      }

      function dueRowIsLongLost(row){
        return dueRowBusinessBucketKey(row) === 'lost_likely_lapsed';
      }

      function dueRowIsActiveDrift(row){
        var bucketKey = dueRowBusinessBucketKey(row);
        return [
          'at_risk_cadence_break',
          'at_risk_canceled_unbooked',
          'at_risk_no_show_unbooked',
          'at_risk_declining_frequency',
          'at_risk_partial_return'
        ].indexOf(bucketKey) >= 0;
      }

      function cloneDueSummary(summary){
        if (!summary || typeof summary !== 'object') return {};
        try {
          return JSON.parse(JSON.stringify(summary));
        } catch (_error) {
          return Object.assign({}, summary);
        }
      }

      function dueAuthoritativeSummary(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        if (safeSummary.unified_queue === true && dueQueueOverviewSummary && typeof dueQueueOverviewSummary === 'object') {
          return Object.assign({}, dueQueueOverviewSummary, {
            workspace_row_sets: safeSummary.workspace_row_sets && typeof safeSummary.workspace_row_sets === 'object'
              ? safeSummary.workspace_row_sets
              : dueQueueOverviewSummary.workspace_row_sets,
            workspace_counts_contextual: safeSummary.workspace_counts_contextual && typeof safeSummary.workspace_counts_contextual === 'object'
              ? safeSummary.workspace_counts_contextual
              : dueQueueOverviewSummary.workspace_counts_contextual,
            workspace_counts_live: safeSummary.workspace_counts_live && typeof safeSummary.workspace_counts_live === 'object'
              ? safeSummary.workspace_counts_live
              : dueQueueOverviewSummary.workspace_counts_live,
            unified_my_queue_count: safeSummary.unified_my_queue_count != null
              ? safeSummary.unified_my_queue_count
              : dueQueueOverviewSummary.unified_my_queue_count
          });
        }
        return safeSummary;
      }

      function dueBuildOverviewSummary(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        if (safeSummary.unified_queue !== true) return null;
        var snapshot = safeSummary.snapshot && typeof safeSummary.snapshot === 'object'
          ? safeSummary.snapshot
          : {};
        var snapshotPayload = snapshot.payload && typeof snapshot.payload === 'object'
          ? snapshot.payload
          : {};
        var snapshotSummary = snapshotPayload.summary && typeof snapshotPayload.summary === 'object'
          ? snapshotPayload.summary
          : {};
        var strongestSummary = duePickBestSummary(
          dueQueueOverviewSummary,
          safeSummary,
          snapshotSummary
        );
        return cloneDueSummary(strongestSummary);
      }

      function buildDueWorkspaceCounts(summary){
        var directSummary = summary && typeof summary === 'object' ? summary : {};
        if (
          directSummary.unified_queue === true
          && directSummary.local_row_set_complete === true
          && directSummary.workspace_row_sets
          && typeof directSummary.workspace_row_sets === 'object'
          && retailArray(directSummary.workspace_row_sets.all).length
        ) {
          return buildUnifiedQueueWorkspaceCounts(retailArray(directSummary.workspace_row_sets.all));
        }
        var safeSummary = dueAuthoritativeSummary(summary);
        if (
          safeSummary.unified_queue === true
          && safeSummary.local_row_set_complete === true
          && safeSummary.workspace_row_sets
          && typeof safeSummary.workspace_row_sets === 'object'
          && retailArray(safeSummary.workspace_row_sets.all).length
        ) {
          return buildUnifiedQueueWorkspaceCounts(retailArray(safeSummary.workspace_row_sets.all));
        }
        var bucketCounts = dueSummaryBusinessBucketCounts(safeSummary);
        if (Object.keys(bucketCounts).length) {
          var watchDueSoon = Number(bucketCounts.watch_due_soon || 0) || 0;
          var watchDueNow = Number(bucketCounts.watch_due_now || 0) || 0;
          var atRiskCadenceBreak = Number(bucketCounts.at_risk_cadence_break || 0) || 0;
          var atRiskCanceledUnbooked = Number(bucketCounts.at_risk_canceled_unbooked || 0) || 0;
          var atRiskNoShowUnbooked = Number(bucketCounts.at_risk_no_show_unbooked || 0) || 0;
          var atRiskDecliningFrequency = Number(bucketCounts.at_risk_declining_frequency || 0) || 0;
          var atRiskPartialReturn = Number(bucketCounts.at_risk_partial_return || 0) || 0;
          var lostLikelyLapsed = Number(bucketCounts.lost_likely_lapsed || 0) || 0;
          var prebook = watchDueSoon + watchDueNow;
          var retailCount = Number((safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.retail) || safeSummary.unified_retail_count || 0) || 0;
          var referralCount = Number((safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.referral) || safeSummary.unified_referral_count || 0) || 0;
          var reviewCount = Number((safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.review) || safeSummary.unified_review_count || 0) || 0;
          var myClaimed = Number((safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.my_claimed) || safeSummary.unified_my_queue_count || 0) || 0;
          var neverVisited = Number((safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.never_visited) || (safeSummary.workspace_counts && safeSummary.workspace_counts.never_visited) || 0) || 0;
          var needsPrebook = Number((safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.needs_prebook) || (safeSummary.workspace_counts && safeSummary.workspace_counts.needs_prebook) || prebook || 0) || 0;
          var needsAttention = Number((safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.needs_attention) || (safeSummary.workspace_counts && safeSummary.workspace_counts.needs_attention) || (atRiskCadenceBreak + atRiskCanceledUnbooked + atRiskNoShowUnbooked + atRiskDecliningFrequency + atRiskPartialReturn) || 0) || 0;
          var needsRecovery = Number((safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.needs_recovery) || (safeSummary.workspace_counts && safeSummary.workspace_counts.needs_recovery) || lostLikelyLapsed || 0) || 0;
          var noPattern = Number((safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.no_pattern) || (safeSummary.workspace_counts && safeSummary.workspace_counts.no_pattern) || 0) || 0;
          var activeDrift = atRiskCadenceBreak + atRiskCanceledUnbooked + atRiskNoShowUnbooked + atRiskDecliningFrequency + atRiskPartialReturn;
          var appointments = neverVisited + needsPrebook + needsAttention + needsRecovery + noPattern;
          var allCount = appointments + retailCount + referralCount + reviewCount;
          return {
            all: allCount,
            my_claimed: myClaimed,
            appointments: appointments,
            never_visited: neverVisited,
            needs_prebook: needsPrebook,
            needs_attention: needsAttention,
            needs_recovery: needsRecovery,
            no_pattern: noPattern,
            watch_due_soon: watchDueSoon,
            watch_due_now: watchDueNow,
            at_risk_cadence_break: atRiskCadenceBreak,
            at_risk_canceled_unbooked: atRiskCanceledUnbooked,
            at_risk_no_show_unbooked: atRiskNoShowUnbooked,
            at_risk_declining_frequency: atRiskDecliningFrequency,
            at_risk_partial_return: atRiskPartialReturn,
            lost_likely_lapsed: lostLikelyLapsed,
            prebook: prebook,
            active_drift: activeDrift,
            long_lost: lostLikelyLapsed,
            retail: retailCount,
            referral: referralCount,
            review: reviewCount
          };
        }
        if (safeSummary.workspace_counts_all && typeof safeSummary.workspace_counts_all === 'object') {
          return {
            all: Number(safeSummary.workspace_counts_all.all || 0) || 0,
            my_claimed: Number(safeSummary.workspace_counts_all.my_claimed || 0) || 0,
            appointments: Number(safeSummary.workspace_counts_all.appointments || 0) || 0,
            never_visited: Number(safeSummary.workspace_counts_all.never_visited || 0) || 0,
            needs_prebook: Number(safeSummary.workspace_counts_all.needs_prebook || 0) || 0,
            needs_attention: Number(safeSummary.workspace_counts_all.needs_attention || 0) || 0,
            needs_recovery: Number(safeSummary.workspace_counts_all.needs_recovery || 0) || 0,
            no_pattern: Number(safeSummary.workspace_counts_all.no_pattern || 0) || 0,
            prebook: Number(safeSummary.workspace_counts_all.prebook || 0) || 0,
            active_drift: Number(safeSummary.workspace_counts_all.active_drift || 0) || 0,
            long_lost: Number(safeSummary.workspace_counts_all.long_lost || 0) || 0,
            retail: Number(safeSummary.workspace_counts_all.retail || 0) || 0,
            referral: Number(safeSummary.workspace_counts_all.referral || 0) || 0,
            review: Number(safeSummary.workspace_counts_all.review || 0) || 0
          };
        }
        if (safeSummary.workspace_counts_contextual && typeof safeSummary.workspace_counts_contextual === 'object') {
          var contextualCounts = safeSummary.workspace_counts_contextual;
          var allCounts = safeSummary.workspace_counts_all && typeof safeSummary.workspace_counts_all === 'object'
            ? safeSummary.workspace_counts_all
            : (safeSummary.workspace_counts && typeof safeSummary.workspace_counts === 'object'
              ? safeSummary.workspace_counts
              : {});
          return {
            all: Number(allCounts.all != null ? allCounts.all : (contextualCounts.all != null ? contextualCounts.all : (safeSummary.filtered_total_rows || 0))) || 0,
            my_claimed: Number(allCounts.my_claimed != null ? allCounts.my_claimed : (contextualCounts.my_claimed != null ? contextualCounts.my_claimed : (safeSummary.unified_my_queue_count || 0))) || 0,
            appointments: Number(allCounts.appointments != null ? allCounts.appointments : contextualCounts.appointments) || 0,
            never_visited: Number(allCounts.never_visited != null ? allCounts.never_visited : contextualCounts.never_visited) || 0,
            needs_prebook: Number(allCounts.needs_prebook != null ? allCounts.needs_prebook : contextualCounts.needs_prebook) || 0,
            needs_attention: Number(allCounts.needs_attention != null ? allCounts.needs_attention : contextualCounts.needs_attention) || 0,
            needs_recovery: Number(allCounts.needs_recovery != null ? allCounts.needs_recovery : contextualCounts.needs_recovery) || 0,
            no_pattern: Number(allCounts.no_pattern != null ? allCounts.no_pattern : contextualCounts.no_pattern) || 0,
            prebook: Number(allCounts.prebook != null ? allCounts.prebook : contextualCounts.prebook) || 0,
            active_drift: Number(allCounts.active_drift != null ? allCounts.active_drift : contextualCounts.active_drift) || 0,
            long_lost: Number(allCounts.long_lost != null ? allCounts.long_lost : contextualCounts.long_lost) || 0,
            retail: Number(allCounts.retail != null ? allCounts.retail : contextualCounts.retail) || 0,
            referral: Number(allCounts.referral != null ? allCounts.referral : contextualCounts.referral) || 0,
            review: Number(allCounts.review != null ? allCounts.review : contextualCounts.review) || 0
          };
        }
        if (safeSummary.workspace_counts && typeof safeSummary.workspace_counts === 'object') {
          return {
            all: Number(safeSummary.workspace_counts.all || 0) || 0,
            my_claimed: Number(safeSummary.workspace_counts.my_claimed || 0) || 0,
            appointments: Number(safeSummary.workspace_counts.appointments || 0) || 0,
            never_visited: Number(safeSummary.workspace_counts.never_visited || 0) || 0,
            needs_prebook: Number(safeSummary.workspace_counts.needs_prebook || 0) || 0,
            needs_attention: Number(safeSummary.workspace_counts.needs_attention || 0) || 0,
            needs_recovery: Number(safeSummary.workspace_counts.needs_recovery || 0) || 0,
            no_pattern: Number(safeSummary.workspace_counts.no_pattern || 0) || 0,
            prebook: Number(safeSummary.workspace_counts.prebook || 0) || 0,
            active_drift: Number(safeSummary.workspace_counts.active_drift || 0) || 0,
            long_lost: Number(safeSummary.workspace_counts.long_lost || 0) || 0,
            retail: Number(safeSummary.workspace_counts.retail || 0) || 0,
            referral: Number(safeSummary.workspace_counts.referral || 0) || 0,
            review: Number(safeSummary.workspace_counts.review || 0) || 0
          };
        }
        if (safeSummary.unified_queue === true) {
          return {
            all: Number(safeSummary.filtered_total_rows || safeSummary.total_snapshot_rows || 0) || 0,
            my_claimed: Number(safeSummary.unified_my_queue_count || 0) || 0,
            appointments: Number(safeSummary.unified_appointment_count || 0) || 0,
            never_visited: Number(safeSummary.never_visited_count || 0) || 0,
            needs_prebook: Number(safeSummary.needs_prebook_count || safeSummary.unified_prebook_count || 0) || 0,
            needs_attention: Number(safeSummary.needs_attention_count || safeSummary.unified_active_drift_count || 0) || 0,
            needs_recovery: Number(safeSummary.needs_recovery_count || safeSummary.unified_long_lost_count || 0) || 0,
            no_pattern: Number(safeSummary.no_pattern_count || 0) || 0,
            prebook: Number(safeSummary.unified_prebook_count || 0) || 0,
            active_drift: Number(safeSummary.unified_active_drift_count || 0) || 0,
            long_lost: Number(safeSummary.unified_long_lost_count || 0) || 0,
            retail: Number(safeSummary.unified_retail_count || 0) || 0,
            referral: Number(safeSummary.unified_referral_count || 0) || 0,
            review: Number(safeSummary.unified_review_count || 0) || 0
          };
        }
        var currentFilteredTotal = Number(safeSummary.filtered_total_rows || 0) || 0;
        var currentStage = String(dueQueueActiveStage || 'all').trim().toLowerCase();
        return {
          all: Number(safeSummary.filtered_total_rows || safeSummary.total_snapshot_rows || 0) || 0,
          my_claimed: 0,
          appointments: Number(safeSummary.filtered_total_rows || safeSummary.total_snapshot_rows || 0) || 0,
          never_visited: 0,
          needs_prebook: 0,
          needs_attention: 0,
          needs_recovery: 0,
          no_pattern: 0,
          prebook: currentStage === 'current_needs_prebooking'
            ? currentFilteredTotal
            : (Number(safeSummary.current_needs_prebooking_client_groups || safeSummary.needs_prebooking_client_groups || 0) || 0),
          active_drift: 0,
          long_lost: currentStage === 'non_current_recapture'
            ? currentFilteredTotal
            : (Number(safeSummary.non_current_recapture_client_groups || safeSummary.recapture_client_groups || 0) || 0),
          retail: 0,
          referral: 0,
          review: 0
        };
      }

      function renderDueWorkspaceCounts(summary){
        if (!dueWorkspaceTabs) return;
        var counts = buildDueWorkspaceCounts(summary);
        Array.prototype.forEach.call(dueWorkspaceTabs.querySelectorAll('[data-due-workspace-count]'), function(node){
          var key = String(node.getAttribute('data-due-workspace-count') || '').trim();
          node.textContent = workspaceCountText(counts[key]);
        });
        if (dueWorkspaceRetailCount) {
          dueWorkspaceRetailCount.textContent = workspaceCountText(counts.retail);
        }
        if (dueWorkspaceReferralCount) {
          dueWorkspaceReferralCount.textContent = workspaceCountText(counts.referral);
        }
        if (dueWorkspaceReviewCount) {
          dueWorkspaceReviewCount.textContent = workspaceCountText(counts.review);
        }
        if (dueWorkspaceOverlapNote) {
          var appointmentSlices = (Number(counts.never_visited || 0) || 0)
            + (Number(counts.needs_prebook || 0) || 0)
            + (Number(counts.needs_attention || 0) || 0)
            + (Number(counts.needs_recovery || 0) || 0)
            + (Number(counts.no_pattern || 0) || 0)
            + (Number(counts.retail || 0) || 0)
            + (Number(counts.referral || 0) || 0)
            + (Number(counts.review || 0) || 0);
          var allCount = Number(counts.all || 0) || 0;
          if (appointmentSlices === allCount) {
            dueWorkspaceOverlapNote.textContent = 'My Claimed overlaps the other groups.';
          } else {
            dueWorkspaceOverlapNote.textContent = 'My Claimed overlaps the other groups. ' + String(Math.max(0, allCount - appointmentSlices)) + ' items are still outside the visible slices.';
          }
        }
        if (dueQueueManagerTabCount) {
          var dueCountValue = Number(counts.all || 0) || 0;
          dueQueueManagerTabCount.textContent = workspaceCountText(dueCountValue);
          dueQueueManagerTabCount.hidden = dueCountValue <= 0;
        }
      }

      function stopDueRefreshProgressPolling(){
        if (dueRefreshProgressPollTimer) {
          window.clearTimeout(dueRefreshProgressPollTimer);
          dueRefreshProgressPollTimer = null;
        }
      }

      async function continueDueRefreshIfNeeded(progress){
        var safeProgress = progress && typeof progress === 'object' ? progress : {};
        var status = String(safeProgress.status || '').trim().toLowerCase();
        var refreshType = String(safeProgress.refresh_type || '').trim().toLowerCase();
        var staleRunning = safeProgress.stale_running === true;
        if (dueRefreshAutoContinueInFlight) return true;
        if (status !== 'running' || (refreshType !== 'full_rebuild' && refreshType !== 'fast_refresh' && refreshType !== 'direct_guest_facts')) return false;
        if ((Date.now() - dueRefreshAutoResumeLastAttemptAt) < DUE_REFRESH_AUTO_RESUME_COOLDOWN_MS) return true;
        dueRefreshAutoResumeLastAttemptAt = Date.now();
        dueRefreshAutoContinueInFlight = true;
        try {
          var plan = getDuePrimaryActionPlan(safeProgress);
          setDueStatus(
            staleRunning
              ? plan.message
              : 'Continuing the changed-appointments refresh and updating the next batch of affected guests.',
            'warning'
          );
          var result = await refreshDueQueueSnapshot(!!plan.forceFullRebuild, false, true);
          dueQueueRefreshProgress = result && hasDueRefreshProgressData(result.refresh_progress)
            ? result.refresh_progress
            : (dueQueueRefreshProgress || deriveDueRefreshProgressFromSummary(dueQueueSummary) || null);
          renderDueRefreshMeta(dueQueueRefreshProgress);
          if (result && result.complete === true) {
            stopDueRefreshProgressPolling();
            dueQueueOffset = 0;
            await loadDueQueue();
            setDueStatus(buildRecaptureProgressSummary(dueQueueRefreshProgress, {}), 'success');
            return true;
          }
          setDueStatus(buildRecaptureProgressSummary(dueQueueRefreshProgress, {}), 'warning');
          return true;
        } catch (error) {
          setDueStatus(humanizeClientFetchErrorMessage(error, 'Could not continue updating the client follow-up queue.'), 'error');
          return false;
        } finally {
          dueRefreshAutoContinueInFlight = false;
        }
      }

      function scheduleDueRefreshProgressPolling(delayMs, useLegacy){
        stopDueRefreshProgressPolling();
        dueRefreshProgressPollTimer = window.setTimeout(async function(){
          try {
            var status = await fetchDueQueueBuildStatus(!!useLegacy);
            var progress = status && hasDueRefreshProgressData(status.refresh_progress)
              ? status.refresh_progress
              : (dueQueueRefreshProgress || deriveDueRefreshProgressFromSummary(dueQueueSummary) || null);
            if (progress) {
              dueQueueRefreshProgress = progress;
              renderDueRefreshMeta(progress);
              if (String(progress.status || '').trim().toLowerCase() === 'running') {
                setDueStatus(buildRecaptureProgressSummary(progress, {}), 'warning');
                await continueDueRefreshIfNeeded(progress);
                scheduleDueRefreshProgressPolling(3000, !!useLegacy);
                return;
              }
              if (String(progress.status || '').trim().toLowerCase() === 'complete') {
                await loadDueQueue();
                return;
              }
            }
            stopDueRefreshProgressPolling();
          } catch (_error) {
            scheduleDueRefreshProgressPolling(15000, !!useLegacy);
          }
        }, Math.max(1000, Number(delayMs || 10000) || 10000));
      }

      function setDueRefreshButtonsState(options){
        var safeOptions = options && typeof options === 'object' ? options : {};
        var running = safeOptions.running === true;
        var forceFullRebuild = safeOptions.forceFullRebuild === true;
        var progress = safeOptions.progress && typeof safeOptions.progress === 'object'
          ? safeOptions.progress
          : (dueQueueRefreshProgress || deriveDueRefreshProgressFromSummary(dueQueueSummary) || {});
        if (dueRefreshBtn) {
          dueRefreshBtn.disabled = running;
          dueRefreshBtn.textContent = running
            ? (forceFullRebuild ? 'Rebuilding…' : 'Refreshing…')
            : 'Refresh Queue';
        }
        if (dueFreshRefreshBtn) {
          dueFreshRefreshBtn.hidden = !shouldShowDueResumeAction(progress);
          dueFreshRefreshBtn.disabled = running;
          dueFreshRefreshBtn.textContent = 'Resume Sync';
        }
      }

      function setPickupQueueStatus(text, tone){
        if (!pickupQueueStatus) return;
        pickupQueueStatus.textContent = String(text || '');
        pickupQueueStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setRetailStatus(text, tone){
        if (!retailStatus) return;
        retailStatus.textContent = String(text || '');
        retailStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function setDueStatus(text, tone){
        if (!dueStatus) return;
        dueStatus.textContent = String(text || '');
        dueStatus.className = 'due-commandStatus' + (tone ? ' due-commandStatus--' + tone : '');
      }

      function restoreDueHistorySyncState(){
        try {
          dueHistoryCursor = window.localStorage.getItem(DUE_HISTORY_CURSOR_KEY) || null;
          var storedHasMore = window.localStorage.getItem(DUE_HISTORY_HAS_MORE_KEY);
          if (storedHasMore === 'false') dueHistoryHasMore = false;
          else if (storedHasMore === 'true') dueHistoryHasMore = true;
        } catch (_error) {}
        if (dueBackfillBtn) {
          dueBackfillBtn.textContent = dueHistoryHasMore === false
            ? 'History sync complete'
            : (dueHistoryCursor ? 'Continue history sync' : 'Sync Appointment History');
        }
      }

      function persistDueHistorySyncState(){
        try {
          if (dueHistoryCursor) window.localStorage.setItem(DUE_HISTORY_CURSOR_KEY, dueHistoryCursor);
          else window.localStorage.removeItem(DUE_HISTORY_CURSOR_KEY);
          window.localStorage.setItem(DUE_HISTORY_HAS_MORE_KEY, dueHistoryHasMore === false ? 'false' : 'true');
        } catch (_error) {}
      }

      function resetDueHistorySyncState(){
        dueHistoryCursor = null;
        dueHistoryHasMore = true;
        try {
          window.localStorage.removeItem(DUE_HISTORY_CURSOR_KEY);
          window.localStorage.removeItem(DUE_HISTORY_HAS_MORE_KEY);
        } catch (_error) {}
        if (dueBackfillBtn) dueBackfillBtn.textContent = 'Sync Appointment History';
      }

      function setTabCount(node, count){
        if (!node) return;
        var numeric = Math.max(0, Number(count) || 0);
        node.textContent = String(numeric);
        node.hidden = numeric <= 0;
      }

      function updateRequestsTabCount(){
        var requestCount = getVisibleRequestQueueRows().filter(function(row){
          return String((row && row.status) || '').trim().toLowerCase() === 'pending';
        }).length;
        var pickupCount = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).filter(function(row){
          var requestType = String((row && row.request_type) || '').trim().toLowerCase();
          return requestType === 'pick_up_shift'
            && String((row && row.status) || '').trim().toLowerCase() === 'pending'
            && !isPastRequestRow({ requested_dates: [row && row.request_date] });
        }).length;
        setTabCount(requestsTabCount, requestCount);
        setTabCount(openShiftsManagerTabCount, pickupCount);
      }

      function normalizeOpenShiftViewFilter(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'pending') return 'pending';
        if (normalized === 'picked-up') return 'picked-up';
        return 'available';
      }

      function setOpenShiftViewFilter(value){
        openShiftViewFilter = normalizeOpenShiftViewFilter(value);
        setStoredStaffOpsValue(STAFF_OPERATIONS_OPEN_SHIFT_FILTER_STORAGE_KEY, openShiftViewFilter);
        if (openShiftViewTabs) {
          Array.prototype.slice.call(openShiftViewTabs.querySelectorAll('[data-open-shift-view]')).forEach(function(button){
            var filterValue = normalizeOpenShiftViewFilter(button.getAttribute('data-open-shift-view'));
            var isActive = filterValue === openShiftViewFilter;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        }
        if (pickupQueueStatus) {
          pickupQueueStatus.hidden = openShiftViewFilter !== 'pending';
        }
        if (openShiftViewFilter !== 'available') {
          clearLastManagerFillResult();
        }
        renderOpenShiftView();
      }

      function getOpenShiftSourceLabel(meta){
        return meta && meta.posted_manually ? 'Posted manually' : 'Posted from approved request off';
      }

      function normalizeRequestQueueFilter(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'pending' || normalized === 'approved' || normalized === 'denied') {
          return normalized;
        }
        return 'all';
      }

      function setRequestQueueFilter(value){
        requestQueueFilter = normalizeRequestQueueFilter(value);
        setStoredStaffOpsValue(STAFF_OPERATIONS_REQUEST_QUEUE_FILTER_STORAGE_KEY, requestQueueFilter);
        syncRequestQueueFilterUi();
        renderRequestOffQueue();
      }

      function syncRequestQueueFilterUi(){
        if (!requestQueueTabs) return;
        Array.prototype.slice.call(requestQueueTabs.querySelectorAll('[data-request-queue-filter]')).forEach(function(button){
          var filterValue = normalizeRequestQueueFilter(button.getAttribute('data-request-queue-filter'));
          var isActive = filterValue === requestQueueFilter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function updateRequestQueueFilterCounts(rows){
        var list = Array.isArray(rows) ? rows : [];
        if (requestQueueCountAll) requestQueueCountAll.textContent = String(list.length);
        if (requestQueueCountPending) {
          requestQueueCountPending.textContent = String(list.filter(function(row){
            return String((row && row.status) || '').trim().toLowerCase() === 'pending';
          }).length);
        }
        if (requestQueueCountApproved) {
          requestQueueCountApproved.textContent = String(list.filter(function(row){
            return String((row && row.status) || '').trim().toLowerCase() === 'approved';
          }).length);
        }
        if (requestQueueCountDenied) {
          requestQueueCountDenied.textContent = String(list.filter(function(row){
            return String((row && row.status) || '').trim().toLowerCase() === 'denied';
          }).length);
        }
      }

      function getRequestQueueStatusOrder(status){
        var normalized = String(status || '').trim().toLowerCase();
        if (normalized === 'pending') return 0;
        if (normalized === 'approved') return 1;
        if (normalized === 'denied') return 2;
        return 3;
      }

      function getRequestQueueStatusLabel(status){
        var normalized = String(status || '').trim().toLowerCase();
        if (normalized === 'pending') return 'Pending';
        if (normalized === 'approved') return 'Approved';
        if (normalized === 'denied') return 'Denied';
        return 'Other';
      }

      function isShiftSwapQueueRow(row){
        return String((row && row.request_type) || '').trim().toLowerCase() === 'replace_shift';
      }

      function getVisibleRequestQueueRows(){
        var requestRows = Array.isArray(requestOffQueue) ? requestOffQueue.filter(function(row){
          return !isPastRequestRow(row);
        }) : [];
        var swapRows = Array.isArray(shiftChangeQueue) ? shiftChangeQueue.filter(function(row){
          return isShiftSwapQueueRow(row) && !isPastRequestRow({ requested_dates: [row && row.request_date] });
        }) : [];
        return requestRows.concat(swapRows);
      }

      function renderRequestOffQueueCard(row){
        var status = String((row && row.status) || 'pending').trim().toLowerCase() || 'pending';
        var rowId = String((row && row.id) || '').trim();
        var staffId = String((row && row.staff_id) || '').trim();
        var staffName = String((row && row.staff_name) || '').trim();
        var roleName = String((row && row.role_name) || '').trim();
        var note = String((row && row.note) || '').trim();
        var submittedAt = formatRequestReviewSubmitted(row && row.submitted_at);
        var requestedDates = formatRequestReviewDates(row && row.requested_dates);
        var reviewedBy = String((row && row.reviewed_by) || '').trim();
        var statusNote = String((row && row.status_note) || '').trim();
        var notifyPhone = String((row && row.notify_phone) || '').trim();
        var verifiedLast4 = String((row && row.verified_phone_last4) || '').trim();
        var requestScope = normalizeRequestOffScope(getRequestOffMeta(row).request_scope);
        var requestScopeLabel = getRequestOffScopeOptionLabel(
          requestScope,
          buildRequestOffScopeDetails(row && row.staff_id, firstRequestDateValue(row), row && row.staff_name)
        );
        var statusSms = row && row.sms && row.sms.status_update ? row.sms.status_update : null;
        var statusSmsSentAt = String((statusSms && statusSms.sent_at) || '').trim();
        var statusSmsCode = String((((statusSms && statusSms.result) || {}).response_code) || '').trim();
        var statusSmsMessage = String((((statusSms && statusSms.result) || {}).response_msg) || '').trim();
        var statusSmsSummary = statusSms
          ? [statusSmsCode || 'sent', statusSmsMessage].filter(Boolean).join(' - ')
          : '';
        var rawJson = JSON.stringify(row || {}, null, 2);
        var approvedDisabled = status === 'approved' ? ' disabled' : '';
        var deniedDisabled = status === 'denied' ? ' disabled' : '';
        var reliabilityLabel = getRequestQueueReliabilityScoreLabel(staffName);
        var callOutCount = getRequestQueueAttendanceCount(requestQueueCallOutsByStaff, staffName);
        var lateArrivalCount = getRequestQueueAttendanceCount(requestQueueLateArrivalsByStaff, staffName);
        var requestsOffCount = getRequestQueueAttendanceCount(requestQueueRequestsOffByStaff, staffName);
        var approvedFutureDaysCount = getRequestQueueAttendanceCount(requestQueueApprovedFutureDaysByStaff, staffName);
        var defaultAllowedRoles = roleName ? [roleName] : [];
        var shiftOptions = (Array.isArray(row && row.requested_dates) ? row.requested_dates : []).map(function(dateValue){
          var trimmedDate = String(dateValue || '').trim();
          if (!trimmedDate) return '';
          var coverageSummary = findCoverageSummaryForRequestRow(row, trimmedDate);
          if (coverageSummary && coverageSummary.openStatus === 'filled') {
            return ''
              + '<div class="schedule-inlineAction schedule-inlineAction--filled">'
              +   '<div class="schedule-inlineActionHead">'
              +     '<strong>' + escapeHtml(formatRequestReviewDates([trimmedDate])) + '</strong>'
              +     '<span>This request is already covered.</span>'
              +   '</div>'
              +   renderFilledCoverageSummary(coverageSummary.fillSummary)
              + '</div>';
          }
          var shiftChoices = getMasterScheduleOptionsForDate(trimmedDate);
          var assignedShift = getAssignedShiftForRequestRow(row, trimmedDate);
          var assignedShiftType = getAssignedShiftTypeForRequestRow(row, trimmedDate);
          var selectedShift = shiftChoices.indexOf(assignedShift) !== -1 ? assignedShift : (shiftChoices[0] || '');
          var selectOptions = shiftChoices.length
            ? shiftChoices.map(function(option){
                var selected = option === selectedShift ? ' selected' : '';
                return '<option value="' + escapeHtml(option) + '"' + selected + '>' + escapeHtml(option) + '</option>';
              }).join('')
            : '<option value="">No shift options</option>';
          var typeOptions = MASTER_SCHEDULE_SHIFT_TYPES.map(function(option){
            var selected = option.value === assignedShiftType ? ' selected' : '';
            return '<option value="' + escapeHtml(option.value) + '"' + selected + '>' + escapeHtml(option.label) + '</option>';
          }).join('');
          var disablePost = (!shiftChoices.length || requestScope !== 'full_shift') ? ' disabled' : '';
          var roleChecklistMarkup = (Array.isArray(requestOffRoleOptions) ? requestOffRoleOptions : []).map(function(role){
            var checked = defaultAllowedRoles.indexOf(role) !== -1 ? ' checked' : '';
            return ''
              + '<label class="role-check">'
                +   '<input type="checkbox" value="' + escapeHtml(role) + '" data-open-shift-allowed-role="' + escapeHtml(trimmedDate) + '" data-open-shift-request-id="' + escapeHtml(rowId) + '"' + checked + ' />'
                +   '<span>' + escapeHtml(role) + '</span>'
              + '</label>';
          }).join('') || '<div class="request-review-empty">No roles available yet.</div>';
          return ''
            + '<div class="schedule-inlineAction schedule-inlineAction--coverage">'
            +   '<div class="schedule-inlineActionHead">'
            +     '<strong>' + escapeHtml(formatRequestReviewDates([trimmedDate])) + '</strong>'
            +     '<span>Post this approved full-day request as an open shift, or fill it immediately.</span>'
            +   '</div>'
            +   '<div class="request-off-actions schedule-inlineActionRow">'
            +       '<select class="progression-valueEditor" data-open-shift-date="' + escapeHtml(trimmedDate) + '" data-open-shift-request-id="' + escapeHtml(rowId) + '">'
            +         selectOptions
            +       '</select>'
            +       '<select class="progression-valueEditor" data-open-shift-type-date="' + escapeHtml(trimmedDate) + '" data-open-shift-request-id="' + escapeHtml(rowId) + '">'
            +         typeOptions
            +       '</select>'
            +       '<button class="btn-secondary" type="button" data-request-action="post-open-shift" data-request-id="' + escapeHtml(rowId) + '" data-request-date="' + escapeHtml(trimmedDate) + '"' + disablePost + '>Post open shift</button>'
            +   '</div>'
            +     (requestScope === 'full_shift'
                    ? '<div class="role-checklist schedule-roleChecklist">' + roleChecklistMarkup + '</div>'
                    : '<div class="schedule-inlineActionFoot">Half-shift requests stay on the coverage board for now. Post any partial coverage manually if needed.</div>')
            +     (requestScope === 'full_shift'
                    ? renderFillShiftControls('request', rowId, trimmedDate, staffId, staffName)
                    : '')
            + '</div>';
        }).filter(Boolean).join('');
        return ''
          + '<article class="request-review-card request-review-card--schedule" data-status="' + escapeHtml(status) + '">'
          +   '<div class="request-review-card-head">'
          +     '<div class="request-review-card-main">'
          +       '<div class="request-review-name">' + escapeHtml(staffName) + '</div>'
          +       '<div class="request-review-dates">' + escapeHtml(requestedDates) + '</div>'
          +       '<div class="request-review-metaRow">'
          +         '<span class="request-review-token">' + escapeHtml(requestScopeLabel) + '</span>'
          +         (submittedAt ? '<span class="request-review-token">Submitted ' + escapeHtml(submittedAt) + '</span>' : '')
          +       '</div>'
          +       '<div class="request-review-meta">'
          +         (note ? '<div>Note: ' + escapeHtml(note) + '</div>' : '')
          +         '<div class="request-review-metrics">'
          +           renderRequestReviewMetric('Reliability', reliabilityLabel)
          +           renderRequestReviewMetric('Callouts', String(callOutCount))
          +           renderRequestReviewMetric('Late', String(lateArrivalCount))
          +           renderRequestReviewMetric('Requests Off', String(requestsOffCount))
          +           renderRequestReviewMetric('Approved Future', String(approvedFutureDaysCount))
          +         '</div>'
          +         '<div class="request-review-metricsNote">Attendance figures use a rolling 365-day lookback. Approved future is based on currently approved upcoming request-off days.</div>'
          +       '</div>'
          +     '</div>'
          +     '<div class="request-review-side">'
          +       '<span class="request-review-badge" data-status="' + escapeHtml(status) + '">' + escapeHtml(status) + '</span>'
          +       '<div class="request-review-actions">'
          +         '<button class="btn-primary" type="button" data-request-action="approve" data-request-id="' + escapeHtml(rowId) + '"' + approvedDisabled + '>Approve</button>'
          +         '<button class="btn-secondary" type="button" data-request-action="deny" data-request-id="' + escapeHtml(rowId) + '"' + deniedDisabled + '>Deny</button>'
          +         '<button class="btn-secondary" type="button" data-request-action="delete" data-request-id="' + escapeHtml(rowId) + '">Cancel request</button>'
          +       '</div>'
          +     '</div>'
          +   '</div>'
          +   (status === 'approved' && shiftOptions
                ? '<div class="schedule-inlineWorkbench"><div class="schedule-inlineWorkbenchTitle">Coverage actions</div>' + shiftOptions + '</div>'
                : '')
          +   '<details class="request-review-details">'
          +     '<summary>Details</summary>'
          +     '<div class="request-review-debug">'
          +       '<div class="request-review-debug-grid">'
          +         renderRequestReviewDebugLine('Request ID', rowId)
          +         renderRequestReviewDebugLine('Status', status)
          +         renderRequestReviewDebugLine('Coverage', requestScopeLabel)
          +         renderRequestReviewDebugLine('Submitted', submittedAt)
          +         renderRequestReviewDebugLine('Role', roleName)
          +         renderRequestReviewDebugLine('Reviewed by', reviewedBy)
          +         renderRequestReviewDebugLine('Status note', statusNote)
          +         renderRequestReviewDebugLine('Notify Phone', notifyPhone || 'none')
          +         renderRequestReviewDebugLine('Verified Last 4', verifiedLast4 || 'none')
          +         renderRequestReviewDebugLine('Status Text', statusSmsSummary || 'not sent')
          +         renderRequestReviewDebugLine('Status Text At', statusSmsSentAt || 'n/a')
          +         (status === 'approved' ? shiftOptions : '')
          +       '</div>'
          +       '<details class="request-review-raw">'
          +         '<summary>Raw request debug</summary>'
          +         '<pre>' + escapeHtml(rawJson) + '</pre>'
          +       '</details>'
          +     '</div>'
          +   '</details>'
            + '</article>';
      }

      function renderShiftSwapQueueCard(row){
        var rowId = String((row && row.id) || '').trim();
        var status = String((row && row.status) || 'pending').trim().toLowerCase() || 'pending';
        var meta = getShiftChangeMeta(row);
        var roleName = String((row && row.role_name) || '').trim() || 'Salon Team';
        var replacementName = String(meta.replacement_staff_name || '').trim();
        var replacementDate = String(meta.replacement_request_date || '').trim();
        var replacementShift = String(meta.replacement_shift_label || '').trim();
        var submittedAt = formatRequestReviewSubmitted(row && row.submitted_at);
        var reviewedBy = String((row && row.reviewed_by) || '').trim();
        var statusNote = String((row && row.status_note) || '').trim();
        var statusSms = row && row.sms && row.sms.status_update ? row.sms.status_update : null;
        var statusSmsSentAt = String((statusSms && statusSms.sent_at) || '').trim();
        var statusSmsCode = String((((statusSms && statusSms.result) || {}).response_code) || '').trim();
        var statusSmsMessage = String((((statusSms && statusSms.result) || {}).response_msg) || '').trim();
        var statusSmsSummary = statusSms
          ? [statusSmsCode || 'sent', statusSmsMessage].filter(Boolean).join(' - ')
          : '';
        var replacementStatusSms = row && row.sms && row.sms.replacement_status_update ? row.sms.replacement_status_update : null;
        var replacementStatusSmsSentAt = String((replacementStatusSms && replacementStatusSms.sent_at) || '').trim();
        var replacementStatusSmsCode = String((((replacementStatusSms && replacementStatusSms.result) || {}).response_code) || '').trim();
        var replacementStatusSmsMessage = String((((replacementStatusSms && replacementStatusSms.result) || {}).response_msg) || '').trim();
        var replacementStatusSmsSummary = replacementStatusSms
          ? [replacementStatusSmsCode || 'sent', replacementStatusSmsMessage].filter(Boolean).join(' - ')
          : '';
        var warnings = Array.isArray(row && row.warnings) ? row.warnings.filter(Boolean) : [];
        var actionMarkup = status === 'pending'
          ? ''
            + '<div class="request-review-actions">'
            +   '<button class="btn-primary" type="button" data-request-kind="swap" data-request-action="approve" data-request-id="' + escapeHtml(rowId) + '">Approve</button>'
            +   '<button class="btn-secondary" type="button" data-request-kind="swap" data-request-action="deny" data-request-id="' + escapeHtml(rowId) + '">Deny</button>'
            +   '<button class="btn-secondary" type="button" data-request-kind="swap" data-request-action="delete" data-request-id="' + escapeHtml(rowId) + '">Delete</button>'
            + '</div>'
          : '';
        return ''
          + '<article class="request-review-card request-review-card--schedule" data-status="' + escapeHtml(status) + '">'
          +   '<div class="request-review-card-head">'
          +     '<div class="request-review-card-main">'
          +       '<div class="request-review-name">' + escapeHtml(String((row && row.staff_name) || '').trim()) + '</div>'
          +       '<div class="request-review-dates">' + escapeHtml(formatRequestReviewDates([row && row.request_date])) + '</div>'
          +       '<div class="request-review-metaRow">'
          +         '<span class="request-review-token">Shift swap</span>'
          +         (submittedAt ? '<span class="request-review-token">Submitted ' + escapeHtml(submittedAt) + '</span>' : '')
          +       '</div>'
          +       renderOpenShiftCardShiftBlock(String((row && row.shift_label) || '').trim(), '', 'Role', roleName)
          +       '<div class="request-review-meta">'
          +         (replacementName ? '<div>Switch with: ' + escapeHtml(replacementName) + '</div>' : '')
          +         (replacementDate ? '<div>Their date: ' + escapeHtml(formatRequestReviewDates([replacementDate])) + '</div>' : '')
          +         (replacementShift ? '<div>Their shift: ' + escapeHtml(replacementShift) + '</div>' : '')
          +         (row && row.note ? '<div>Note: ' + escapeHtml(String(row.note || '').trim()) + '</div>' : '')
          +       '</div>'
          +     '</div>'
          +     '<div class="request-review-side">'
          +       '<span class="request-review-badge" data-status="' + escapeHtml(status) + '">' + escapeHtml(status) + '</span>'
          +       actionMarkup
          +     '</div>'
          +   '</div>'
          +   '<details class="request-review-details">'
          +     '<summary>Details</summary>'
          +     '<div class="request-review-debug">'
          +       '<div class="request-review-debug-grid">'
          +         renderRequestReviewDebugLine('Request ID', rowId)
          +         renderRequestReviewDebugLine('Type', 'Shift swap')
          +         renderRequestReviewDebugLine('Switch With', replacementName)
          +         renderRequestReviewDebugLine('Their Date', replacementDate)
          +         renderRequestReviewDebugLine('Their Shift', replacementShift)
          +         renderRequestReviewDebugLine('Reviewed By', reviewedBy)
          +         renderRequestReviewDebugLine('Status Note', statusNote)
          +         renderRequestReviewDebugLine('SMS', statusSmsSentAt ? formatRequestReviewSubmitted(statusSmsSentAt) + (statusSmsSummary ? ' - ' + statusSmsSummary : '') : '')
          +         renderRequestReviewDebugLine('Partner SMS', replacementStatusSmsSentAt ? formatRequestReviewSubmitted(replacementStatusSmsSentAt) + (replacementStatusSmsSummary ? ' - ' + replacementStatusSmsSummary : '') : '')
          +         renderRequestReviewDebugLine('Warnings', warnings.length ? warnings.join(' | ') : '')
          +       '</div>'
          +     '</div>'
          +   '</details>'
          + '</article>';
      }

      function retailArray(value){
        return Array.isArray(value) ? value : [];
      }

      function retailUniqueTextArray(value){
        if (Array.isArray(value)) {
          return value.map(function(item){
            return String(item || '').trim();
          }).filter(Boolean);
        }
        var text = String(value || '').trim();
        return text ? [text] : [];
      }

      function retailChipsMarkup(values, tone){
        var items = retailUniqueTextArray(values);
        if (!items.length) {
          return '<span class="retail-chip retail-chip--muted">None</span>';
        }
        return items.map(function(item){
          return '<span class="retail-chip' + (tone ? ' retail-chip--' + tone : '') + '">' + escapeHtml(item) + '</span>';
        }).join('');
      }

      function retailHandleLabel(value){
        var normalized = String(value || '').trim().split(/[/:]/).filter(Boolean).pop() || String(value || '');
        return normalized
          .replace(/[_-]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
          .replace(/\b\w/g, function(char){ return char.toUpperCase(); });
      }

      function retailDisplayProductName(item, fallback){
        var safeItem = item && typeof item === 'object' ? item : {};
        var name = retailTextValue(safeItem && safeItem.name, '');
        if (name) return name;
        var handle = retailTextValue(safeItem && safeItem.handle, retailTextValue(item, fallback || ''));
        return retailHandleLabel(handle || fallback || 'Product');
      }

      function formatRetailStrategyAppointmentAt(value){
        var raw = String(value || '').trim();
        if (!raw) return '';
        var parsed = new Date(raw);
        if (isNaN(parsed.getTime())) return '';
        try {
          return new Intl.DateTimeFormat('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit'
          }).format(parsed);
        } catch (_error) {
          return parsed.toLocaleString('en-US');
        }
      }

      function retailBookFocusMarkup(upcomingBook){
        var safeBook = upcomingBook && typeof upcomingBook === 'object' ? upcomingBook : {};
        var revisitBrand = retailTextValue(safeBook && safeBook.top_revisit_brand, '');
        var repeatBrand = retailTextValue(safeBook && safeBook.top_repeat_brand, '');
        var restockBrand = retailTextValue(safeBook && safeBook.top_restock_brand, '');
        var repeatProduct = retailTextValue(safeBook && safeBook.top_repeat_product, '');
        var restockProduct = retailTextValue(safeBook && safeBook.top_restock_product, '');
        var items = [];
        if (repeatBrand || repeatProduct) {
          items.push({
            label: 'Best refill',
            tone: 'success',
            value: repeatProduct || repeatBrand
          });
        }
        if (restockBrand || restockProduct) {
          items.push({
            label: 'Likely restock',
            tone: 'accent',
            value: restockProduct || restockBrand
          });
        }
        if (revisitBrand) {
          items.push({
            label: 'Conversation reopen',
            tone: 'workflow',
            value: revisitBrand
          });
        }
        if (!items.length) return '';
        return '<div class="retail-bookFocusList">' + items.map(function(item){
          return ''
            + '<article class="retail-bookFocus retail-bookFocus--' + escapeHtml(item.tone) + '">'
            +   '<div class="retail-bookFocusLabel">' + escapeHtml(item.label) + '</div>'
            +   '<div class="retail-bookFocusValue">' + escapeHtml(item.value) + '</div>'
            + '</article>';
        }).join('') + '</div>';
      }

      function retailUpcomingBookMarkup(upcomingBook){
        var safeBook = upcomingBook && typeof upcomingBook === 'object' ? upcomingBook : {};
        var upcomingCount = Number((safeBook && safeBook.upcoming_appointments) || 0) || 0;
        if (upcomingCount <= 0) return '';
        var upcomingReturning = Number((safeBook && safeBook.returning_clients) || 0) || 0;
        var upcomingPriorRetail = Number((safeBook && safeBook.returning_clients_with_prior_retail) || 0) || 0;
        var upcomingRevisit = Number((safeBook && safeBook.revisit_opportunity_clients) || 0) || 0;
        return ''
          + '<div class="retail-cardRow retail-cardRow--stacked">'
          +   '<div class="retail-cardLabel">Upcoming book</div>'
          +   '<div class="retail-bookPulse">'
          +     '<article class="retail-bookStat"><strong>' + escapeHtml(String(upcomingCount)) + '</strong><span>Booked this week</span></article>'
          +     '<article class="retail-bookStat"><strong>' + escapeHtml(String(upcomingReturning)) + '</strong><span>Returning guests</span></article>'
          +     '<article class="retail-bookStat"><strong>' + escapeHtml(String(upcomingPriorRetail)) + '</strong><span>Prior retail buyers</span></article>'
          +     '<article class="retail-bookStat"><strong>' + escapeHtml(String(upcomingRevisit)) + '</strong><span>Missed last retail chance</span></article>'
          +   '</div>'
          +   retailBookFocusMarkup(safeBook)
          + '</div>';
      }

      function retailFutureStrategyMarkup(item){
        var safeItem = item && typeof item === 'object' ? item : {};
        var title = retailTextValue(safeItem && safeItem.strategy_title, 'Upcoming opportunity');
        var detail = retailTextValue(safeItem && safeItem.strategy_detail, '');
        var clientName = retailTextValue(safeItem && safeItem.client_name, 'Upcoming client');
        var appointmentAt = formatRetailStrategyAppointmentAt(safeItem && safeItem.appointment_at);
        var purchased = retailArray(safeItem && safeItem.prior_purchased_products).slice(0, 2).map(function(product){
          return retailTextValue(product, '');
        }).filter(Boolean);
        var concerns = retailArray(safeItem && safeItem.tagged_concerns).slice(0, 3).map(function(concern){
          return retailTextValue(concern, '');
        }).filter(Boolean);
        return ''
          + '<article class="retail-miniStrategy">'
          +   '<div class="retail-miniStrategyHead">'
          +     '<div class="retail-miniStrategyIdentity"><strong>' + escapeHtml(clientName) + '</strong>' + (appointmentAt ? '<span class="retail-miniStrategyMeta">' + escapeHtml(appointmentAt) + '</span>' : '') + '</div>'
          +     '<span>' + escapeHtml(title) + '</span>'
          +   '</div>'
          +   '<p class="retail-miniStrategyDetail">' + escapeHtml(detail) + '</p>'
          +   '<div class="retail-miniStrategySignals">'
          +   (purchased.length ? '<div class="retail-cardRow"><div class="retail-cardLabel">Past retail</div><div class="retail-cardChips">' + retailChipsMarkup(purchased, 'accent') + '</div></div>' : '')
          +   (concerns.length ? '<div class="retail-cardRow"><div class="retail-cardLabel">Tagged concerns</div><div class="retail-cardChips">' + retailChipsMarkup(concerns, 'history') + '</div></div>' : '')
          +   '</div>'
          + '</article>';
      }

      function retailProductDetailLabel(item){
        var safeItem = item && typeof item === 'object' ? item : {};
        var name = retailDisplayProductName(safeItem, retailTextValue(item, ''));
        var category = retailTextValue(safeItem && safeItem.category, '');
        return category ? (name + ' (' + category + ')') : name;
      }

      function retailProductDetailChipsMarkup(values, tone){
        var items = retailArray(values).map(function(item){
          return retailProductDetailLabel(item);
        }).filter(Boolean);
        if (!items.length) {
          return '<span class="retail-chip retail-chip--muted">None</span>';
        }
        return items.map(function(item){
          return '<span class="retail-chip' + (tone ? ' retail-chip--' + tone : '') + '">' + escapeHtml(item) + '</span>';
        }).join('');
      }

      function retailProductCategoriesSummary(values){
        var counts = {};
        retailArray(values).forEach(function(item){
          var safeItem = item && typeof item === 'object' ? item : {};
          var category = retailTextValue(safeItem && safeItem.category, '');
          if (!category) return;
          counts[category] = (counts[category] || 0) + 1;
        });
        return Object.keys(counts).sort().map(function(category){
          return category + ' (' + counts[category] + ')';
        });
      }

      function retailMetricMarkup(label, value, sub){
        return ''
          + '<article class="retail-metric">'
          +   '<div class="retail-metric-label">' + escapeHtml(label) + '</div>'
          +   '<div class="retail-metric-value">' + escapeHtml(value) + '</div>'
          +   '<div class="retail-metric-sub">' + escapeHtml(sub || '') + '</div>'
          + '</article>';
      }

      function canonicalRetailStaffName(value){
        var raw = String(value || '').trim().toLowerCase();
        if (!raw) return '';
        var cleaned = raw.replace(/[^\w\s'-]+/g, ' ').replace(/\s+/g, ' ').trim();
        if (!cleaned) return '';
        var parts = cleaned.split(' ');
        if (!parts.length) return cleaned;
        var first = parts[0];
        var aliases = {
          jo: 'josephine',
          josie: 'josephine',
          joe: 'joseph',
          jen: 'jennifer',
          jenn: 'jennifer',
          jenna: 'jennifer',
          mike: 'michael',
          nikki: 'nicole',
          sam: 'samantha',
          alex: 'alexandra',
          six: 'six'
        };
        parts[0] = aliases[first] || first;
        return parts.join(' ');
      }

      function sameRetailStaffName(left, right){
        var normalizedLeft = canonicalRetailStaffName(left);
        var normalizedRight = canonicalRetailStaffName(right);
        if (!normalizedLeft || !normalizedRight) return false;
        if (normalizedLeft === normalizedRight) return true;
        var leftParts = normalizedLeft.split(' ');
        var rightParts = normalizedRight.split(' ');
        var leftFirst = leftParts[0] || '';
        var rightFirst = rightParts[0] || '';
        if (leftParts.length === 1 || rightParts.length === 1) {
          return !!leftFirst && !!rightFirst && (
            leftFirst === rightFirst
            || leftFirst.indexOf(rightFirst) === 0
            || rightFirst.indexOf(leftFirst) === 0
          );
        }
        if (leftParts.length < 2 || rightParts.length < 2) return false;
        return leftFirst === rightFirst && leftParts[leftParts.length - 1] === rightParts[rightParts.length - 1];
      }

      function isRetailAssistantRole(role){
        var levelNumber = parseRoleLevelNumber(role);
        return levelNumber != null && levelNumber >= 0 && levelNumber <= 4;
      }

      function retailEligibleStaffOptions(){
        return (Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions : []).filter(function(option){
          var role = String((option && option.role) || '').trim();
          return role && !isManagementRole(role);
        });
      }

      function retailFindStaffOption(name){
        return retailEligibleStaffOptions().find(function(option){
          return sameRetailStaffName(option && option.name, name);
        }) || null;
      }

      function sortRetailSuccessRows(rows, mode){
        var isAssistantMode = String(mode || '').trim().toLowerCase() === 'assistant';
        return retailArray(rows).slice().sort(function(left, right){
          if (isAssistantMode) {
            var supportDiff = Number((right && right.retail_visits) || 0) - Number((left && left.retail_visits) || 0);
            if (supportDiff) return supportDiff;
            var unitsDiff = Number((right && right.units_sold) || 0) - Number((left && left.units_sold) || 0);
            if (unitsDiff) return unitsDiff;
            var taggedDiff = Number((right && right.closed_appointments) || 0) - Number((left && left.closed_appointments) || 0);
            if (taggedDiff) return taggedDiff;
          } else {
            var attachDiff = Number((right && right.attach_rate) || 0) - Number((left && left.attach_rate) || 0);
            if (attachDiff) return attachDiff;
            var retailVisitDiff = Number((right && right.retail_visits) || 0) - Number((left && left.retail_visits) || 0);
            if (retailVisitDiff) return retailVisitDiff;
            var closedDiff = Number((right && right.closed_appointments) || 0) - Number((left && left.closed_appointments) || 0);
            if (closedDiff) return closedDiff;
          }
          return String((left && left.staff_name) || '').localeCompare(String((right && right.staff_name) || ''));
        }).map(function(row, index){
          return Object.assign({}, row, {
            attach_rank: index + 1
          });
        });
      }

      function retailSuccessLevelName(metricValue, mode){
        var value = Number(metricValue || 0) || 0;
        if (String(mode || '') === 'assistant') {
          if (value >= 8) return 'Master';
          if (value >= 6) return 'Diamond';
          if (value >= 4) return 'Platinum';
          if (value >= 3) return 'Gold';
          if (value >= 2) return 'Silver';
          return 'Bronze';
        }
        if (value >= 50) return 'Master';
        if (value >= 40) return 'Diamond';
        if (value >= 30) return 'Platinum';
        if (value >= 20) return 'Gold';
        if (value >= 10) return 'Silver';
        return 'Bronze';
      }

      function retailSuccessStatusLabel(row, mode){
        var isAssistantMode = String(mode || '') === 'assistant';
        var metric = Number(isAssistantMode ? ((row && row.retail_visits) || 0) : ((row && row.attach_rate) || 0)) || 0;
        if (isAssistantMode) {
          if (metric >= 5) return 'Hot streak';
          if (metric >= 3) return 'Climbing';
          if (metric >= 1) return 'On board';
          return 'Opening';
        }
        if (metric >= 40) return 'Elite attach';
        if (metric >= 25) return 'Strong routine';
        if (metric >= 10) return 'Building';
        return 'Opening';
      }

      function retailSuccessTone(row, mode){
        var status = retailSuccessStatusLabel(row, mode).toLowerCase();
        if (status.indexOf('elite') >= 0 || status.indexOf('hot') >= 0) return 'crown';
        if (status.indexOf('strong') >= 0 || status.indexOf('climbing') >= 0 || status.indexOf('board') >= 0) return 'surge';
        return 'steady';
      }

      function retailSuccessProgressWidth(row, mode){
        var isAssistantMode = String(mode || '') === 'assistant';
        var value = Math.max(0, Number(isAssistantMode ? ((row && row.retail_visits) || 0) : ((row && row.attach_rate) || 0)) || 0);
        var maxValue = isAssistantMode ? 8 : 50;
        return Math.max(8, Math.min(100, Math.round((value / maxValue) * 100)));
      }

      function retailSuccessAverage(rows, mode){
        var isAssistantMode = String(mode || '') === 'assistant';
        var pool = retailArray(rows).filter(function(row){
          return Number((row && row.closed_appointments) || 0) > 0;
        });
        if (!pool.length) return 0;
        return pool.reduce(function(sum, row){
          return sum + Number(isAssistantMode ? ((row && row.retail_visits) || 0) : ((row && row.attach_rate) || 0));
        }, 0) / pool.length;
      }

      function retailSuccessSummaryLine(summary, mode){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        if (String(mode || '') === 'assistant') {
          return String(Number(safeSummary.attributed_retail_visits || 0) || 0) + ' retail-attached support appointments in range';
        }
        return formatPercent(Number(safeSummary.attach_rate || 0) || 0) + ' salon attach across the filtered stylist book';
      }

      function retailBuildLaneRows(mode){
        var leaderboard = retailSalesLeaderboard && retailSalesLeaderboard[mode] ? retailSalesLeaderboard[mode] : {};
        var rankedRows = sortRetailSuccessRows(leaderboard.rows, mode);
        var eligibleOptions = retailEligibleStaffOptions().filter(function(option){
          return String(mode || '') === 'assistant'
            ? isRetailAssistantRole(option && option.role)
            : !isRetailAssistantRole(option && option.role);
        });
        var merged = eligibleOptions.map(function(option){
          var matched = rankedRows.find(function(row){
            return sameRetailStaffName(row && row.staff_name, option && option.name);
          }) || null;
          return Object.assign({
            staff_name: String((option && option.name) || '').trim(),
            role_name: String((option && option.role) || '').trim(),
            closed_appointments: 0,
            retail_visits: 0,
            units_sold: 0,
            attach_rate: 0,
            attach_rank: 0
          }, matched || {});
        }).filter(function(row){
          return String((row && row.staff_name) || '').trim();
        });
        return sortRetailSuccessRows(merged, mode);
      }

      function retailSuccessCardMarkup(row, mode){
        var safeRow = row && typeof row === 'object' ? row : {};
        var isAssistantMode = String(mode || '') === 'assistant';
        var staffOption = retailFindStaffOption(safeRow.staff_name);
        var roleName = retailTextValue(safeRow && safeRow.role_name, retailTextValue(staffOption && staffOption.role, isAssistantMode ? 'Assistant' : 'Stylist'));
        var rank = Number((safeRow && safeRow.attach_rank) || 0) || 0;
        var closedAppointments = Number((safeRow && safeRow.closed_appointments) || 0) || 0;
        var retailVisits = Number((safeRow && safeRow.retail_visits) || 0) || 0;
        var unitsSold = Number((safeRow && safeRow.units_sold) || 0) || 0;
        var attachRate = Number((safeRow && safeRow.attach_rate) || 0) || 0;
        var levelName = retailSuccessLevelName(isAssistantMode ? retailVisits : attachRate, mode);
        var progressWidth = retailSuccessProgressWidth(safeRow, mode);
        var statusLabel = retailSuccessStatusLabel(safeRow, mode);
        var primaryValue = isAssistantMode ? String(retailVisits) : formatPercent(attachRate);
        var primaryLabel = isAssistantMode ? 'Support wins' : 'Attach rate';
        var rankLabel = rank ? ('#' + String(rank) + ' ' + (isAssistantMode ? 'assistant' : 'stylist')) : 'Unranked';
        var summaryCopy = isAssistantMode
          ? (closedAppointments > 0
            ? String(retailVisits) + ' of ' + String(closedAppointments) + ' tagged appointments closed with retail'
            : 'No tagged supported appointments in this range yet')
          : (closedAppointments > 0
            ? String(retailVisits) + ' retail-attached appointments across ' + String(closedAppointments) + ' closed appointments'
            : 'No closed appointments in this range yet');
        return ''
          + '<article class="retail-card retail-card--compact retail-successCard retail-successCard--' + escapeHtml(retailSuccessTone(safeRow, mode)) + '">'
          +   '<div class="retail-cardHead">'
          +     '<div class="retail-cardIdentity">'
          +       '<h3 class="retail-cardTitle">' + escapeHtml(retailTextValue(safeRow && safeRow.staff_name, 'Staff')) + '</h3>'
          +       '<p class="retail-cardMeta">' + escapeHtml(roleName + ' • ' + rankLabel) + '</p>'
          +     '</div>'
          +     '<div class="retail-cardBadges">'
          +       '<span class="retail-chip retail-chip--accent">' + escapeHtml(levelName) + '</span>'
          +       '<span class="retail-chip retail-chip--history">' + escapeHtml(statusLabel) + '</span>'
          +     '</div>'
          +   '</div>'
          +   '<div class="retail-successCardHero">'
          +     '<div class="retail-successCardValue">' + escapeHtml(primaryValue) + '</div>'
          +     '<div class="retail-successCardLabel">' + escapeHtml(primaryLabel) + '</div>'
          +   '</div>'
          +   '<div class="retail-rankTrack retail-rankTrack--success"><span style="width:' + escapeHtml(String(progressWidth)) + '%"></span></div>'
          +   '<div class="retail-cardFacts">'
          +     '<article class="retail-cardFact"><strong>' + escapeHtml(String(closedAppointments)) + '</strong><span class="retail-cardFactLabel">' + escapeHtml(isAssistantMode ? 'Tagged appts' : 'Closed appts') + '</span></article>'
          +     '<article class="retail-cardFact"><strong>' + escapeHtml(String(retailVisits)) + '</strong><span class="retail-cardFactLabel">' + escapeHtml(isAssistantMode ? 'With retail' : 'Retail visits') + '</span></article>'
          +     '<article class="retail-cardFact"><strong>' + escapeHtml(String(unitsSold)) + '</strong><span class="retail-cardFactLabel">Products linked</span></article>'
          +   '</div>'
          +   '<div class="retail-reason">' + escapeHtml(summaryCopy) + '</div>'
          + '</article>';
      }

      function retailMissionTone(mission){
        var type = retailTextValue(mission && mission.type, '').toLowerCase();
        if (type === 'chase') return 'crown';
        if (type === 'brand' || type === 'replenish' || type === 'restock') return 'surge';
        if (type === 'attach' || type === 'basket') return 'climb';
        if (type === 'diversify' || type === 'revisit') return 'surge';
        return 'steady';
      }

      function syncRetailWeekTabs(){
        if (!retailWeekTabs) return;
        var periods = buildRetailPeriodOptions();
        if (!activeRetailPayrollStart && periods.length) {
          activeRetailPayrollStart = String(periods[0].value || '');
        }
        retailWeekTabs.innerHTML = periods.map(function(period){
          var value = String(period && period.value || '');
          var isActive = value === activeRetailPayrollStart;
          var label = String((period && (period.short_label || period.label)) || '').trim();
          return '<button class="request-queue-tab' + (isActive ? ' is-active' : '') + '" type="button" data-retail-period="' + escapeHtml(value) + '" aria-pressed="' + (isActive ? 'true' : 'false') + '">' + escapeHtml(label) + '</button>';
        }).join('');
        Array.prototype.slice.call(retailWeekTabs.querySelectorAll('[data-retail-period]')).forEach(function(button){
          var value = String(button.getAttribute('data-retail-period') || '').trim();
          var isActive = value === activeRetailPayrollStart;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function setRetailPayrollWindow(value){
        var nextValue = String(value || '').trim();
        if (!nextValue) {
          var firstPeriod = buildRetailPeriodOptions()[0] || null;
          activeRetailPayrollStart = firstPeriod ? String(firstPeriod.value || '') : '';
        } else {
          activeRetailPayrollStart = nextValue;
        }
        syncRetailWeekTabs();
      }

      function buildRetailWeekRange(periodStart){
        var requestedStart = String(periodStart || '').trim();
        var periods = buildRetailPeriodOptions();
        var target = periods.find(function(period){
          return String(period && period.value || '') === requestedStart;
        }) || null;
        if (!target && /^\d{4}-Q\d$/i.test(requestedStart)) {
          target = buildRetailQuarterCandidates().find(function(period){
            return String(period && period.value || '') === requestedStart;
          }) || null;
        }
        if (!target) {
          target = periods[0] || null;
        }
        return target ? {
          date_from: target.date_from,
          date_to: target.date_to,
          label: target.label,
          payroll_start: String(target.value || ''),
          short_label: String((target && target.short_label) || ''),
          period_date_to: String((target && target.period_date_to) || (target && target.date_to) || ''),
          live_through: String((target && target.live_through) || ''),
          is_live_current: target && target.is_live_current === true,
          period_kind: String((target && target.period_kind) || 'payroll')
        } : {
          date_from: '',
          date_to: '',
          label: '',
          payroll_start: '',
          short_label: '',
          period_date_to: '',
          live_through: '',
          is_live_current: false,
          period_kind: 'payroll'
        };
      }

      function buildBusinessDevelopmentRetailRange(){
        var today = startOfLocalDay(new Date());
        var start = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 13);
        return {
          date_from: formatDateInputValue(start),
          date_to: formatDateInputValue(today),
          label: formatRecaptureDate(start.toISOString()) + ' - ' + formatRecaptureDate(today.toISOString())
        };
      }

      function cloneRetailSnapshot(snapshot){
        if (!snapshot || typeof snapshot !== 'object') return null;
        try {
          return JSON.parse(JSON.stringify(snapshot));
        } catch (_error) {
          return null;
        }
      }

      function retailSnapshotStorageTtlMs(snapshot){
        var range = snapshot && snapshot.range && typeof snapshot.range === 'object' ? snapshot.range : null;
        return range && range.is_live_current ? (10 * 60 * 1000) : (24 * 60 * 60 * 1000);
      }

      function readRetailSnapshotStorage(){
        if (!window.localStorage) return {};
        try {
          var raw = window.localStorage.getItem(RETAIL_PERIOD_SNAPSHOTS_STORAGE_KEY);
          var parsed = raw ? JSON.parse(raw) : {};
          return parsed && typeof parsed === 'object' ? parsed : {};
        } catch (_error) {
          return {};
        }
      }

      function writeRetailSnapshotStorage(nextValue){
        if (!window.localStorage) return;
        try {
          window.localStorage.setItem(RETAIL_PERIOD_SNAPSHOTS_STORAGE_KEY, JSON.stringify(nextValue && typeof nextValue === 'object' ? nextValue : {}));
        } catch (_error) {
        }
      }

      function hydrateRetailSnapshotsFromStorage(){
        if (retailSnapshotsHydrated) return;
        retailSnapshotsHydrated = true;
        var stored = readRetailSnapshotStorage();
        Object.keys(stored || {}).forEach(function(periodKey){
          var entry = stored[periodKey];
          var savedAt = Number(entry && entry.saved_at) || 0;
          var snapshot = cloneRetailSnapshot(entry && entry.snapshot);
          if (!periodKey || !savedAt || !snapshot) return;
          if ((Date.now() - savedAt) > retailSnapshotStorageTtlMs(snapshot)) return;
          retailPeriodSnapshots[periodKey] = snapshot;
        });
      }

      function persistRetailSnapshot(periodKey, snapshot){
        var normalizedKey = String(periodKey || '').trim();
        var clonedSnapshot = cloneRetailSnapshot(snapshot);
        if (!normalizedKey || !clonedSnapshot) return;
        retailPeriodSnapshots[normalizedKey] = clonedSnapshot;
        var stored = readRetailSnapshotStorage();
        stored[normalizedKey] = {
          saved_at: Date.now(),
          snapshot: clonedSnapshot
        };
        writeRetailSnapshotStorage(stored);
      }

      function isRetailSnapshotFresh(snapshot){
        if (!snapshot || typeof snapshot !== 'object') return false;
        var periodKey = String(snapshot && snapshot.range && snapshot.range.payroll_start || snapshot && snapshot.week_window || '').trim();
        if (!periodKey) return false;
        var stored = readRetailSnapshotStorage();
        var entry = stored[periodKey];
        var savedAt = Number(entry && entry.saved_at) || 0;
        if (!savedAt) return false;
        return (Date.now() - savedAt) <= retailSnapshotStorageTtlMs(snapshot);
      }

      async function prefetchRetailQuarterSnapshot(periodKey){
        var normalizedKey = String(periodKey || '').trim();
        if (!normalizedKey || retailQuarterPrefetchPromiseByPeriod[normalizedKey]) return;
        var targetRange = buildRetailWeekRange(normalizedKey);
        if (!targetRange || targetRange.period_kind !== 'quarter') return;
        var cached = getRetailSnapshotForPeriod(normalizedKey);
        if (cached && isRetailSnapshotFresh(cached)) return;
        retailQuarterPrefetchPromiseByPeriod[normalizedKey] = fetchRetailAnalyticsDashboardForWeek(normalizedKey).then(function(snapshot){
          var range = snapshot && snapshot.range ? snapshot.range : targetRange;
          var storageKey = String(range && range.payroll_start || normalizedKey).trim();
          if (storageKey) {
            persistRetailSnapshot(storageKey, snapshot);
          }
        }).catch(function(){
        }).finally(function(){
          delete retailQuarterPrefetchPromiseByPeriod[normalizedKey];
        });
        await retailQuarterPrefetchPromiseByPeriod[normalizedKey];
      }

      function scheduleRetailQuarterPrefetch(){
        var periods = buildRetailQuarterOptions();
        var currentQuarter = periods.find(function(period){
          return period && period.is_live_current === true;
        }) || periods[0] || null;
        if (!currentQuarter || !currentQuarter.value) return;
        prefetchRetailQuarterSnapshot(String(currentQuarter.value || '')).catch(function(){
        });
      }

      function retailStatusPrefixForRange(range){
        var kind = String((range && range.period_kind) || 'payroll').trim().toLowerCase();
        if (kind === 'quarter') {
          return range && range.is_live_current ? 'Current quarter QTD' : 'Closed quarter';
        }
        return range && range.is_live_current ? 'Current payroll' : 'Closed payroll';
      }

      function renderDueRangeNote(){
        if (!dueRangeNote) return;
        dueRangeNote.hidden = true;
        dueRangeNote.textContent = '';
      }

      function dueWorkspaceCriteriaText(){
        var workspace = String(dueQueueWorkspace || 'all').trim() || 'all';
        if (workspace === 'my_claimed') {
          return 'These are your currently claimed opportunities across every opportunity type, without any extra queue slicing.';
        }
        if (workspace === 'never_visited') {
          return 'These guests do not have a completed visit yet and should be reviewed separately from the cadence-based follow-up lanes.';
        }
        if (workspace === 'needs_prebook') {
          return 'These appointment guests have a trusted personalized cadence, are not overdue yet, and still need the next visit booked.';
        }
        if (workspace === 'needs_attention') {
          return 'These appointment guests are overdue against a trusted personalized cadence and need timely outreach now.';
        }
        if (workspace === 'needs_recovery') {
          return 'These appointment guests are more than 45 days overdue against a trusted personalized cadence and need recovery outreach.';
        }
        if (workspace === 'no_pattern') {
          return 'These appointment guests do not have a future booking, but there is not enough trusted personalized cadence yet to assign urgency.';
        }
        if (workspace === 'prebook') {
          return 'This is a rollup view that combines Watch - Due Soon and Watch - Due Now. These guests are still within their normal timing, do not have the next appointment booked, and are sorted by who is due soonest.';
        }
        if (workspace === 'active_drift') {
          return 'This is a rollup view that combines the at-risk appointment buckets. These guests recently broke their normal routine, do not have the next appointment booked, and still look recoverable with timely outreach.';
        }
        if (workspace === 'long_lost') {
          return 'This rollup mirrors Lost - Likely Lapsed. These guests have not returned in 12 or more months or are far beyond their expected rhythm and still do not have a future appointment.';
        }
        if (workspace === 'retail') {
          return 'These are closed visits from the last 14 days where home-care follow-up is still eligible.';
        }
        if (workspace === 'referral') {
          return 'These are recent strong relationships and positive visits that are good candidates for a referral ask.';
        }
        if (workspace === 'review') {
          return 'These are recent completed visits where feedback follow-up is still timely.';
        }
        if (workspace === 'appointments') {
          return 'This combines appointment-growth opportunities from both prebook and recapture.';
        }
        return 'This combines appointment growth, retail, referral, and review opportunities into one prioritized manager queue.';
      }

      function dueWorkflowCriteriaText(){
        if (String(dueQueueWorkspace || 'all').trim() === 'my_claimed') {
          return 'This view already combines your active claimed work, so the secondary queue filter is not being used here.';
        }
        var workflow = String(dueQueueWorkflowFilter || 'all').trim() || 'all';
        if (workflow === 'needs_action') {
          return 'They still need action and are not in a cooldown window, future follow-up hold, completed win, or active owner workflow.';
        }
        if (workflow === 'mine') {
          return 'They are already assigned to you or currently in progress under your name.';
        }
        if (workflow === 'waiting') {
          return 'They were snoozed, have a future follow-up date, or were worked recently enough that the next move is to wait instead of re-contacting now.';
        }
        if (workflow === 'completed') {
          return 'They already produced a recorded win or were completed without another follow-up scheduled.';
        }
        return 'They are the strongest next opportunities to work first based on priority, timing, and whether they still need action.';
      }

      function renderDueCriteriaNote(summary){
        if (!dueCriteriaNote) return;
        var safeSummary = summary && typeof summary === 'object' ? summary : (dueQueueSummary && typeof dueQueueSummary === 'object' ? dueQueueSummary : {});
        var contextualCounts = dueContextualWorkspaceCounts(safeSummary);
        var workspace = String(dueQueueWorkspace || 'all').trim() || 'all';
        var totalRows = Number(
          workspace === 'all'
            ? (contextualCounts.all || safeSummary.filtered_total_rows || safeSummary.total_snapshot_rows || dueQueueTotalRows || 0)
            : (contextualCounts[workspace] || safeSummary.filtered_total_rows || dueQueueTotalRows || 0)
        ) || 0;
        var visibleRows = Number(safeSummary.visible_row_count || 0) || 0;
        var lead = dueCriteriaLeadText(totalRows, visibleRows);
        var details = dueWorkspaceCriteriaText() + ' ' + dueWorkflowCriteriaText();
        var rangeNote = '';
        if (workspace === 'retail' || workspace === 'all') {
          var retailRange = buildBusinessDevelopmentRetailRange();
          rangeNote = ' Retail follow-up uses a rolling 14-day lookback: ' + retailRange.label + '.';
        }
        dueCriteriaNote.textContent = lead + ' ' + details + ' Recent no-response outcomes stay in Waiting for 14 days before they return to Needs Action. Counts match the live queue view on this screen.' + rangeNote;
      }

      function setDueQueueLoadingState(message){
        var text = String(message || 'Loading current queue view...').trim();
        setDueStatus(text, 'warning');
        setDueQueueUiState('syncing', {
          label: 'Refreshing Boulevard',
          hint: text,
          percent: dueQueueRefreshProgress && isFinite(Number(dueQueueRefreshProgress.percent_complete))
            ? Number(dueQueueRefreshProgress.percent_complete)
            : 18
        });
        if (dueQueueList) {
          dueQueueList.innerHTML = buildDueQueueSkeletonMarkup(3);
        }
        if (dueQueuePagerSummary) {
          dueQueuePagerSummary.textContent = 'Refreshing queue…';
        }
        if (dueWorkspaceTabs && !hasSafeDueSummary(dueQueueSummary)) {
          Array.prototype.forEach.call(dueWorkspaceTabs.querySelectorAll('[data-due-workspace-count]'), function(node){
            node.textContent = '—';
          });
        }
      }

      function buildDueQueueSkeletonMarkup(count){
        var total = Math.max(1, Number(count || 3) || 3);
        var cards = [];
        for (var i = 0; i < total; i += 1) {
          cards.push(
            ''
            + '<article class="retail-card retail-card--compact retail-card--queue queue-opportunityCard queue-opportunityCard--skeleton" aria-hidden="true">'
            +   '<div class="queue-skeletonBlock queue-skeletonBlock--header"></div>'
            +   '<div class="queue-skeletonBlock queue-skeletonBlock--subline"></div>'
            +   '<div class="queue-skeletonBlock queue-skeletonBlock--timeline"></div>'
            +   '<div class="queue-skeletonRow">'
            +     '<div class="queue-skeletonBlock queue-skeletonBlock--recommendation"></div>'
            +     '<div class="queue-skeletonBlock queue-skeletonBlock--actions"></div>'
            +   '</div>'
            + '</article>'
          );
        }
        return cards.join('');
      }

      function setDueQueueUiState(state, options){
        var phase = String(state || 'ready').trim() || 'ready';
        var opts = options && typeof options === 'object' ? options : {};
        if (dueShell) {
          dueShell.setAttribute('data-state', phase);
        }
        if (dueQueueList) {
          dueQueueList.setAttribute('aria-busy', phase === 'syncing' || phase === 'loading' ? 'true' : 'false');
        }
        var controlsDisabled = phase === 'syncing' || phase === 'loading';
        var disableTargets = []
          .concat(Array.prototype.slice.call((dueWorkspaceTabs && dueWorkspaceTabs.querySelectorAll('button')) || []))
          .concat([dueSearchFilter, dueSortSelect, dueResetBtn]);
        disableTargets.forEach(function(node){
          if (!node) return;
          node.disabled = controlsDisabled;
        });
        if (dueSyncRail) {
          dueSyncRail.setAttribute('data-tone', String(opts.tone || (phase === 'error' ? 'error' : (phase === 'ready' ? 'success' : 'warning'))));
        }
        if (dueSyncStageLabel) {
          dueSyncStageLabel.textContent = String(opts.label || (phase === 'ready' ? 'Queue ready' : phase === 'error' ? 'Queue unavailable' : 'Checking Boulevard'));
        }
        if (dueSyncStageHint) {
          dueSyncStageHint.textContent = String(opts.hint || (phase === 'ready' ? 'The latest opportunity queue is ready to work.' : 'The queue will load after the latest sync finishes.'));
        }
        if (dueSyncRailFill) {
          var percent = Math.max(0, Math.min(100, Number(opts.percent != null ? opts.percent : (phase === 'ready' ? 100 : phase === 'error' ? 100 : 18)) || 0));
          dueSyncRailFill.style.width = String(percent) + '%';
        }
      }

      async function waitForDueQueueRefreshToFinish(){
        var startedAt = Date.now();
        var maxWaitMs = 180000;
        while ((Date.now() - startedAt) < maxWaitMs) {
          var buildStatus = await fetchDueQueueBuildStatus(false).catch(function(){
            return null;
          });
          var progress = buildStatus && hasDueRefreshProgressData(buildStatus.refresh_progress)
            ? buildStatus.refresh_progress
            : (dueQueueRefreshProgress || deriveDueRefreshProgressFromSummary(dueQueueSummary) || null);
          if (progress) {
            dueQueueRefreshProgress = progress;
            renderDueRefreshMeta(progress);
          }
          var normalizedStatus = String((progress && progress.status) || '').trim().toLowerCase();
          if (normalizedStatus === 'failed') {
            throw new Error(buildRecaptureProgressSummary(progress, {}));
          }
          if (
            normalizedStatus === 'complete'
            || (
              buildStatus
              && buildStatus.complete === true
              && progress
              && progress.safe_to_use_snapshot === true
            )
          ) {
            return progress;
          }
          if (normalizedStatus === 'running') {
            setDueStatus(buildRecaptureProgressSummary(progress, {}), 'warning');
            await continueDueRefreshIfNeeded(progress);
          } else {
            setDueStatus('Checking Boulevard for new business-development changes...', 'warning');
          }
          await delayMs(1250);
        }
        throw new Error('Boulevard sync is taking longer than expected. Try refresh again.');
      }

      function dueCanRenderLocally(){
        return !!(
          dueQueueSummary
          && dueQueueSummary.unified_queue === true
          && dueQueueSummary.local_row_set_complete === true
          && dueQueueRows.length
        );
      }

      function dueNeedsFullHydrateForPaging(){
        var safeSummary = dueQueueSummary && typeof dueQueueSummary === 'object' ? dueQueueSummary : {};
        if (!(safeSummary && safeSummary.unified_queue === true)) return false;
        if (safeSummary.local_row_set_complete === true) return false;
        var authoritativeTotal = Math.max(
          0,
          Number(
            safeSummary.filtered_total_rows
            || safeSummary.total_snapshot_rows
            || safeSummary.total_due_clients
            || 0
          ) || 0
        );
        return authoritativeTotal > retailArray(dueQueueRows).length;
      }

      async function ensureDueQueueFullyHydratedForPaging(){
        if (!dueNeedsFullHydrateForPaging()) return false;
        if (!dueQueueHydrationPromise) {
          setDueStatus('Loading more of the queue...', 'warning');
          dueQueuePreserveVisibleCountOnNextRender = true;
          dueQueueHydrationPromise = fetchUnifiedBusinessPriorityQueue({
            appendAppointmentPage: true,
            existingRows: dueQueueRows
          }).then(function(result){
            dueQueueSummary = result && result.summary ? result.summary : {};
            dueQueueScorecard = dueQueueSummary && dueQueueSummary.unified_scorecard ? dueQueueSummary.unified_scorecard : dueQueueScorecard;
            dueQueueOfferOptions = retailArray(result && result.offers);
            var rawRows = retailArray(result && result.rows).map(function(row){
              return row && typeof row === 'object'
                ? Object.assign({ queue_source: retailTextValue(row && row.queue_source, '') || 'appointment', opportunity_key: retailTextValue(row && row.opportunity_key, '') || buildPriorityOpportunityKey(row) }, row)
                : row;
            });
            dueQueueSummary = dueHydrateUnifiedSummaryRowSets(dueQueueSummary, rawRows);
            dueQueueOverviewSummary = dueBuildOverviewSummary(dueQueueSummary);
            dueQueueRows = mergePriorityRowsByOpportunityKey(mergeLocalClaimedRows(rawRows));
            dueQueueTotalRows = Number((dueQueueSummary && (dueQueueSummary.total_snapshot_rows || dueQueueSummary.filtered_total_rows)) || 0) || dueQueueRows.length;
            renderDueQueue();
            storeDueQueueWorkspaceCache(dueWorkspaceCacheKey(dueQueueWorkspace), dueQueueRows, dueQueueSummary, dueQueueRefreshProgress, dueQueueOfferOptions, dueQueueScorecard);
          }).finally(function(){
            dueQueuePreserveVisibleCountOnNextRender = false;
            dueQueueHydrationPromise = null;
          });
        }
        await dueQueueHydrationPromise;
        return true;
      }

      async function advanceDueQueueVisibleRows(){
        if (dueQueueLoadMoreInFlight) return false;
        if (dueQueueVisibleCount >= dueQueueRenderableRowCount && !dueNeedsFullHydrateForPaging()) return false;
        dueQueueLoadMoreInFlight = true;
        try {
          if (dueQueueVisibleCount >= retailArray(dueQueueRows).length && dueNeedsFullHydrateForPaging()) {
            await ensureDueQueueFullyHydratedForPaging();
          }
          if (dueQueueVisibleCount >= dueQueueRenderableRowCount) return false;
          dueQueueVisibleCount = Math.min(dueQueueRenderableRowCount, dueQueueVisibleCount + dueQueuePageSize);
          dueQueueOffset = 0;
          renderDueQueue();
          return true;
        } finally {
          dueQueueLoadMoreInFlight = false;
        }
      }

      function dueWorkspaceCacheKey(workspaceKey){
        return String(workspaceKey || 'all').trim() || 'all';
      }

      function clearDueQueueWorkspaceCache(){
        dueQueueWorkspaceCache = {};
      }

      function cloneDueQueueSummary(summary){
        return summary && typeof summary === 'object'
          ? Object.assign({}, summary)
          : {};
      }

      function storeDueQueueWorkspaceCache(workspaceKey, rows, summary, refreshProgress, offers, scorecard){
        var cacheKey = dueWorkspaceCacheKey(workspaceKey);
        dueQueueWorkspaceCache[cacheKey] = {
          rows: mergePriorityRowsByOpportunityKey(mergeLocalClaimedRows(retailArray(rows))),
          summary: cloneDueQueueSummary(summary),
          refresh_progress: refreshProgress || null,
          offers: retailArray(offers),
          scorecard: scorecard || null,
          total_rows: Number(dueQueueTotalRows || 0) || retailArray(rows).length,
          stored_at: Date.now()
        };
      }

      function applyDueQueueWorkspaceCache(workspaceKey){
        var cacheKey = dueWorkspaceCacheKey(workspaceKey);
        var cached = dueQueueWorkspaceCache && dueQueueWorkspaceCache[cacheKey];
        if (!cached) return false;
        dueQueueRows = mergePriorityRowsByOpportunityKey(mergeLocalClaimedRows(retailArray(cached.rows)));
        dueQueueSummary = cloneDueQueueSummary(cached.summary);
        dueQueueScorecard = cached.scorecard || (dueQueueSummary && dueQueueSummary.unified_scorecard ? dueQueueSummary.unified_scorecard : null);
        dueQueueRefreshProgress = cached.refresh_progress || deriveDueRefreshProgressFromSummary(dueQueueSummary);
        dueQueueOfferOptions = retailArray(cached.offers);
        if (dueQueueSummary && dueQueueSummary.unified_queue === true) {
          dueQueueSummary = dueHydrateUnifiedSummaryRowSets(dueQueueSummary, dueQueueRows);
          dueQueueOverviewSummary = dueBuildOverviewSummary(dueQueueSummary);
        } else {
          dueQueueOverviewSummary = null;
        }
        dueQueueTotalRows = Number(cached.total_rows || (dueQueueSummary && (dueQueueSummary.filtered_total_rows || dueQueueSummary.total_snapshot_rows)) || 0) || dueQueueRows.length;
        dueQueueOffset = 0;
        dueQueueVisibleCount = dueQueuePageSize;
        renderDueQueue();
        return true;
      }

      function dueActionablePrebookWindowDays(){
        return 30;
      }

      function dueRowIsAppointmentSource(row){
        return retailTextValue(row && row.queue_source, 'appointment') === 'appointment';
      }

      function dueRowAppointmentVisitCount(row){
        return Math.max(0, Number(
          (row && row.appointment_count)
          || (row && row.total_completed_visits)
          || (row && row.visit_count)
          || 0
        ) || 0);
      }

      function dueRowKnownCadencePattern(row){
        return dueDisplayPatternItems(dueAllPatternItems(row), null).find(function(item){
          return duePatternCadenceExactDays(row, item) > 0
            && duePatternSource(row, item).toLowerCase() === 'personalized'
            && duePatternSample(row, item) >= 3;
        }) || null;
      }

      function dueRowKnownCadenceDays(row){
        var pattern = dueRowKnownCadencePattern(row);
        return pattern ? duePatternCadenceExactDays(row, pattern) : 0;
      }

      function dueRowCanonicalCategoryKey(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var direct = retailTextValue(
          safeRow.canonical_category_key
            || safeRow.canonicalCategoryKey,
          ''
        ).toLowerCase();
        if (direct) return direct;
        if (!dueRowIsAppointmentSource(row)) return '';
        if (dueHasFutureBooking(row)) return '';
        var visitCount = dueRowAppointmentVisitCount(row);
        if (visitCount <= 0) return 'never_visited';
        var cadenceDays = dueRowKnownCadenceDays(row);
        if (!(cadenceDays > 0)) return 'no_pattern';
        var overdueDays = Math.max(0, dueRowDaysOverdue(row));
        if (overdueDays > 45) return 'needs_recovery';
        if (overdueDays > 0) return 'needs_attention';
        return 'needs_prebook';
      }

      function dueRowUnifiedAppointmentStatusKey(row){
        return dueRowCanonicalCategoryKey(row);
      }

      function dueRowSimpleTimingBucketKey(row){
        return dueRowUnifiedAppointmentStatusKey(row);
      }

      function dueRowIsActionablePrebook(row){
        return dueRowUnifiedAppointmentStatusKey(row) === 'needs_prebook';
      }

      function buildUnifiedQueueContextRows(rows){
        if (String(dueQueueWorkspace || 'all').trim() === 'my_claimed') {
          return retailArray(rows).filter(function(row){
            return dueRowAssignedToCurrentManager(row) && !dueRowIsCompleted(row);
          });
        }
        return retailArray(rows);
      }

      function buildUnifiedQueueWorkspaceCounts(rows){
        var safeRows = retailArray(rows);
        return {
          all: safeRows.length,
          my_claimed: safeRows.filter(function(row){
            return dueRowAssignedToCurrentManager(row) && !dueRowIsCompleted(row);
          }).length,
          never_visited: safeRows.filter(function(row){
            return dueRowSimpleTimingBucketKey(row) === 'never_visited';
          }).length,
          needs_prebook: safeRows.filter(function(row){
            return dueRowSimpleTimingBucketKey(row) === 'needs_prebook';
          }).length,
          needs_attention: safeRows.filter(function(row){
            return dueRowSimpleTimingBucketKey(row) === 'needs_attention';
          }).length,
          needs_recovery: safeRows.filter(function(row){
            return dueRowSimpleTimingBucketKey(row) === 'needs_recovery';
          }).length,
          no_pattern: safeRows.filter(function(row){
            return dueRowSimpleTimingBucketKey(row) === 'no_pattern';
          }).length,
          watch_due_soon: safeRows.filter(function(row){
            return dueRowBusinessBucketKey(row) === 'watch_due_soon';
          }).length,
          watch_due_now: safeRows.filter(function(row){
            return dueRowBusinessBucketKey(row) === 'watch_due_now';
          }).length,
          at_risk_cadence_break: safeRows.filter(function(row){
            return dueRowBusinessBucketKey(row) === 'at_risk_cadence_break';
          }).length,
          at_risk_canceled_unbooked: safeRows.filter(function(row){
            return dueRowBusinessBucketKey(row) === 'at_risk_canceled_unbooked';
          }).length,
          at_risk_no_show_unbooked: safeRows.filter(function(row){
            return dueRowBusinessBucketKey(row) === 'at_risk_no_show_unbooked';
          }).length,
          at_risk_declining_frequency: safeRows.filter(function(row){
            return dueRowBusinessBucketKey(row) === 'at_risk_declining_frequency';
          }).length,
          at_risk_partial_return: safeRows.filter(function(row){
            return dueRowBusinessBucketKey(row) === 'at_risk_partial_return';
          }).length,
          lost_likely_lapsed: safeRows.filter(function(row){
            return dueRowBusinessBucketKey(row) === 'lost_likely_lapsed';
          }).length,
          prebook: safeRows.filter(function(row){
            return dueRowIsActionablePrebook(row);
          }).length,
          active_drift: safeRows.filter(dueRowIsActiveDrift).length,
          long_lost: safeRows.filter(dueRowIsLongLost).length,
          retail: safeRows.filter(function(row){
            return retailTextValue(row && row.queue_source, '') === 'retail';
          }).length,
          referral: safeRows.filter(function(row){
            return retailTextValue(row && row.queue_source, '') === 'referral';
          }).length,
          review: safeRows.filter(function(row){
            return retailTextValue(row && row.queue_source, '') === 'review';
          }).length
        };
      }

      function buildUnifiedQueueWorkspaceRowSets(rows){
        var safeRows = retailArray(rows);
        return {
          all: safeRows,
          my_claimed: dueRowsForWorkspace(safeRows, 'my_claimed'),
          never_visited: dueRowsForWorkspace(safeRows, 'never_visited'),
          needs_prebook: dueRowsForWorkspace(safeRows, 'needs_prebook'),
          needs_attention: dueRowsForWorkspace(safeRows, 'needs_attention'),
          needs_recovery: dueRowsForWorkspace(safeRows, 'needs_recovery'),
          no_pattern: dueRowsForWorkspace(safeRows, 'no_pattern'),
          watch_due_soon: dueRowsForWorkspace(safeRows, 'watch_due_soon'),
          watch_due_now: dueRowsForWorkspace(safeRows, 'watch_due_now'),
          at_risk_cadence_break: dueRowsForWorkspace(safeRows, 'at_risk_cadence_break'),
          at_risk_canceled_unbooked: dueRowsForWorkspace(safeRows, 'at_risk_canceled_unbooked'),
          at_risk_no_show_unbooked: dueRowsForWorkspace(safeRows, 'at_risk_no_show_unbooked'),
          at_risk_declining_frequency: dueRowsForWorkspace(safeRows, 'at_risk_declining_frequency'),
          at_risk_partial_return: dueRowsForWorkspace(safeRows, 'at_risk_partial_return'),
          lost_likely_lapsed: dueRowsForWorkspace(safeRows, 'lost_likely_lapsed'),
          prebook: dueRowsForWorkspace(safeRows, 'prebook'),
          active_drift: dueRowsForWorkspace(safeRows, 'active_drift'),
          long_lost: dueRowsForWorkspace(safeRows, 'long_lost'),
          retail: dueRowsForWorkspace(safeRows, 'retail'),
          referral: dueRowsForWorkspace(safeRows, 'referral'),
          review: dueRowsForWorkspace(safeRows, 'review')
        };
      }

      function dueRowsForWorkspace(rows, workspace){
        var safeRows = retailArray(rows);
        var normalized = String(workspace || 'all').trim() || 'all';
        if (normalized === 'my_claimed') {
          return safeRows.filter(function(row){
            return dueRowAssignedToCurrentManager(row) && !dueRowIsCompleted(row);
          });
        }
        if (
          normalized === 'never_visited'
          || normalized === 'needs_prebook'
          || normalized === 'needs_attention'
          || normalized === 'needs_recovery'
          || normalized === 'no_pattern'
        ) {
          return safeRows.filter(function(row){
            return dueRowSimpleTimingBucketKey(row) === normalized;
          });
        }
        if (
          normalized === 'watch_due_soon'
          || normalized === 'watch_due_now'
          || normalized === 'at_risk_cadence_break'
          || normalized === 'at_risk_canceled_unbooked'
          || normalized === 'at_risk_no_show_unbooked'
          || normalized === 'at_risk_declining_frequency'
          || normalized === 'at_risk_partial_return'
          || normalized === 'lost_likely_lapsed'
        ) {
          return safeRows.filter(function(row){
            return dueRowBusinessBucketKey(row) === normalized;
          });
        }
        if (normalized === 'prebook') {
          return safeRows.filter(dueRowIsActionablePrebook);
        }
        if (normalized === 'active_drift') {
          return safeRows.filter(dueRowIsActiveDrift);
        }
        if (normalized === 'long_lost') {
          return safeRows.filter(dueRowIsLongLost);
        }
        if (normalized === 'retail' || normalized === 'referral' || normalized === 'review') {
          return safeRows.filter(function(row){
            return retailTextValue(row && row.queue_source, '') === normalized;
          });
        }
        return safeRows;
      }

      function dueWorkspaceBackendBucketKey(workspace){
        var normalized = String(workspace || '').trim();
        if (
          normalized === 'watch_due_soon'
          || normalized === 'watch_due_now'
          || normalized === 'at_risk_cadence_break'
          || normalized === 'at_risk_canceled_unbooked'
          || normalized === 'at_risk_no_show_unbooked'
          || normalized === 'at_risk_declining_frequency'
          || normalized === 'at_risk_partial_return'
          || normalized === 'lost_likely_lapsed'
        ) {
          return normalized;
        }
        if (normalized === 'long_lost') return 'lost_likely_lapsed';
        return '';
      }

      function dueUnifiedWorkspaceRows(summary, workspace){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var rowSets = safeSummary.workspace_row_sets && typeof safeSummary.workspace_row_sets === 'object'
          ? safeSummary.workspace_row_sets
          : {};
        var normalized = String(workspace || 'all').trim() || 'all';
        if (!Object.keys(rowSets).length) return [];
        if (normalized === 'my_claimed') {
          return retailArray(rowSets.all).filter(function(row){
            return dueRowAssignedToCurrentManager(row) && !dueRowIsCompleted(row);
          });
        }
        if (Object.prototype.hasOwnProperty.call(rowSets, normalized)) {
          var directRows = retailArray(rowSets[normalized]);
          if (directRows.length) return directRows;
          var fallbackRows = dueRowsForWorkspace(retailArray(rowSets.all), normalized);
          if (fallbackRows.length) return fallbackRows;
          return directRows;
        }
        return dueRowsForWorkspace(retailArray(rowSets.all), normalized);
      }

      function dueHydrateUnifiedSummaryRowSets(summary, overlayRows){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        if (safeSummary.unified_queue !== true) return safeSummary;
        var rowSets = safeSummary.workspace_row_sets && typeof safeSummary.workspace_row_sets === 'object'
          ? safeSummary.workspace_row_sets
          : {};
        if (!Object.keys(rowSets).length) return safeSummary;
        var safeOverlayRows = retailArray(overlayRows);
        var overlayByOpportunityKey = new Map();
        safeOverlayRows.forEach(function(row){
          var opportunityKey = retailTextValue(row && row.opportunity_key, '') || buildPriorityOpportunityKey(row);
          if (!opportunityKey) return;
          overlayByOpportunityKey.set(opportunityKey, row);
        });
        var seededAllRows = retailArray(rowSets.all).map(function(row){
          var opportunityKey = retailTextValue(row && row.opportunity_key, '') || buildPriorityOpportunityKey(row);
          if (!opportunityKey || !overlayByOpportunityKey.has(opportunityKey)) return row;
          return overlayByOpportunityKey.get(opportunityKey);
        });
        if (!seededAllRows.length && safeOverlayRows.length) {
          seededAllRows = safeOverlayRows.slice();
        }
        var hydratedAllRows = mergePriorityRowsByOpportunityKey(mergeLocalClaimedRows(seededAllRows.concat(safeOverlayRows)));
        var hydratedRowSets = {
          all: hydratedAllRows,
          never_visited: dueRowsForWorkspace(hydratedAllRows, 'never_visited'),
          needs_prebook: dueRowsForWorkspace(hydratedAllRows, 'needs_prebook'),
          needs_attention: dueRowsForWorkspace(hydratedAllRows, 'needs_attention'),
          needs_recovery: dueRowsForWorkspace(hydratedAllRows, 'needs_recovery'),
          no_pattern: dueRowsForWorkspace(hydratedAllRows, 'no_pattern'),
          watch_due_soon: dueRowsForWorkspace(hydratedAllRows, 'watch_due_soon'),
          watch_due_now: dueRowsForWorkspace(hydratedAllRows, 'watch_due_now'),
          at_risk_cadence_break: dueRowsForWorkspace(hydratedAllRows, 'at_risk_cadence_break'),
          at_risk_canceled_unbooked: dueRowsForWorkspace(hydratedAllRows, 'at_risk_canceled_unbooked'),
          at_risk_no_show_unbooked: dueRowsForWorkspace(hydratedAllRows, 'at_risk_no_show_unbooked'),
          at_risk_declining_frequency: dueRowsForWorkspace(hydratedAllRows, 'at_risk_declining_frequency'),
          at_risk_partial_return: dueRowsForWorkspace(hydratedAllRows, 'at_risk_partial_return'),
          lost_likely_lapsed: dueRowsForWorkspace(hydratedAllRows, 'lost_likely_lapsed'),
          prebook: dueRowsForWorkspace(hydratedAllRows, 'prebook'),
          active_drift: dueRowsForWorkspace(hydratedAllRows, 'active_drift'),
          long_lost: dueRowsForWorkspace(hydratedAllRows, 'long_lost'),
          retail: dueRowsForWorkspace(hydratedAllRows, 'retail'),
          referral: dueRowsForWorkspace(hydratedAllRows, 'referral'),
          review: dueRowsForWorkspace(hydratedAllRows, 'review')
        };
        var liveCounts = buildUnifiedQueueWorkspaceCounts(hydratedAllRows);
        liveCounts.all = hydratedAllRows.length;
        var liveTotalRows = hydratedAllRows.length || safeOverlayRows.length || 0;
        return Object.assign({}, safeSummary, {
          local_row_set_complete: safeSummary.local_row_set_complete === true,
          workspace_row_sets: hydratedRowSets,
          workspace_counts: liveCounts,
          workspace_counts_all: liveCounts,
          workspace_counts_contextual: liveCounts,
          filtered_total_rows: liveTotalRows,
          total_snapshot_rows: liveTotalRows,
          hydrated_visible_row_count: safeOverlayRows.length || hydratedAllRows.length || 0
        });
      }

      function dueCurrentRenderSignature(summaryRows){
        var counts = buildUnifiedQueueWorkspaceCounts(summaryRows);
        return [
          String(dueQueueWorkspace || 'all').trim() || 'all',
          String(dueQueueOpportunityFilter || 'all').trim() || 'all',
          String(dueQueueActiveStage || 'all').trim() || 'all',
          String(dueQueueWorkflowFilter || 'all').trim() || 'all',
          String(dueQueueOwnerFilter || 'all').trim() || 'all',
          String(dueQueueActiveClientType || 'all').trim() || 'all',
          String(dueQueueSortMode || 'priority_score').trim() || 'priority_score',
          String(currentDueGuestSearchTerm() || '').trim().toLowerCase(),
          String(counts.all || 0),
          String(counts.my_claimed || 0),
          String(counts.never_visited || 0),
          String(counts.needs_prebook || 0),
          String(counts.needs_attention || 0),
          String(counts.needs_recovery || 0),
          String(counts.no_pattern || 0),
          String(counts.watch_due_soon || 0),
          String(counts.watch_due_now || 0),
          String(counts.at_risk_cadence_break || 0),
          String(counts.at_risk_canceled_unbooked || 0),
          String(counts.at_risk_no_show_unbooked || 0),
          String(counts.at_risk_declining_frequency || 0),
          String(counts.at_risk_partial_return || 0),
          String(counts.lost_likely_lapsed || 0),
          String(counts.prebook || 0),
          String(counts.active_drift || 0),
          String(counts.long_lost || 0),
          String(counts.retail || 0),
          String(counts.referral || 0),
          String(counts.review || 0)
        ].join('|');
      }

      function syncDueInfiniteScroll(totalRows, visibleRows){
        if (dueQueueInfiniteObserver) {
          dueQueueInfiniteObserver.disconnect();
          dueQueueInfiniteObserver = null;
        }
        if (!dueQueueLoadMoreSentinel) return;
        var safeTotalRows = Math.max(0, Number(totalRows || 0) || 0);
        var safeVisibleRows = Math.max(0, Number(visibleRows || 0) || 0);
        var hasMoreRows = safeTotalRows > safeVisibleRows;
        dueQueueLoadMoreSentinel.hidden = true;
        dueQueueLoadMoreSentinel.setAttribute('aria-hidden', 'true');
      }

      function rerenderDueQueueLocally(statusMessage){
        dueQueueOffset = 0;
        dueQueueVisibleCount = dueQueuePageSize;
        renderDueQueue();
        if (statusMessage) {
          setDueStatus(String(statusMessage).trim(), 'success');
        }
      }

      var dueQueueDeferredRefreshTimer = null;

      function cancelDueQueueDeferredRefresh(){
        if (!dueQueueDeferredRefreshTimer) return;
        window.clearTimeout(dueQueueDeferredRefreshTimer);
        dueQueueDeferredRefreshTimer = null;
      }

      function scheduleDueQueueRefresh(message, options){
        var opts = options && typeof options === 'object' ? options : {};
        var delayMs = Number(opts.delay_ms || 0) || 0;
        var forceRemote = opts.force_remote === true;
        var statusMessage = String(opts.status_message || message || 'Refreshing queue...').trim();
        dueQueueOffset = 0;
        if (!forceRemote && dueCanRenderLocally()) {
          cancelDueQueueDeferredRefresh();
          rerenderDueQueueLocally(statusMessage);
          return;
        }
        cancelDueQueueDeferredRefresh();
        if (statusMessage) {
          setDueStatus(statusMessage, 'warning');
        }
        dueQueueDeferredRefreshTimer = window.setTimeout(async function(){
          dueQueueDeferredRefreshTimer = null;
          setDueQueueLoadingState(message || statusMessage || 'Refreshing queue...');
          await loadDueQueue();
        }, delayMs);
      }

      function renderRetailSalesLeaderboard(){
        if (!retailSalesLeaderboardMount) return;
        var stylistBoard = retailSalesLeaderboard && retailSalesLeaderboard.stylist ? retailSalesLeaderboard.stylist : {};
        var assistantBoard = retailSalesLeaderboard && retailSalesLeaderboard.assistant ? retailSalesLeaderboard.assistant : {};
        var stylistRows = retailBuildLaneRows('stylist');
        var assistantRows = retailBuildLaneRows('assistant');
        var hasRows = stylistRows.length || assistantRows.length;
        var stylistSummary = stylistBoard.summary && typeof stylistBoard.summary === 'object' ? stylistBoard.summary : {};
        var assistantSummary = assistantBoard.summary && typeof assistantBoard.summary === 'object' ? assistantBoard.summary : {};
        if (!hasRows) {
          retailSalesLeaderboardMount.innerHTML = '<div class="retail-empty">No Retail Success activity found in this filter range yet.</div>';
          return;
        }
        retailSalesLeaderboardMount.innerHTML = ''
          + '<section class="retail-successLane">'
          +   '<div class="retail-fieldBoardHead">'
          +     '<div>'
          +       '<div class="retail-scoreboardEyebrow">Retail Success</div>'
          +       '<h3 class="retail-fieldBoardTitle">Stylist Leaderboard</h3>'
          +       '<p class="retail-fieldBoardMeta">' + escapeHtml(retailSuccessSummaryLine(stylistBoard.summary, 'stylist')) + '</p>'
          +     '</div>'
          +     '<div class="retail-scoreboardStats retail-scoreboardStats--lane">'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(formatPercent(Number(stylistSummary.attach_rate || 0) || 0)) + '</strong><span>salon attach</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(stylistRows.length)) + '</strong><span>stylists tracked</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(Number(stylistSummary.attributed_units_sold || 0) || 0)) + '</strong><span>products linked</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(Number(stylistSummary.attributed_retail_visits || 0) || 0)) + '</strong><span>retail visits</span></div>'
          +     '</div>'
          +   '</div>'
          +   '<div class="retail-successGrid">' + (stylistRows.length ? stylistRows.map(function(row){
                return retailSuccessCardMarkup(row, 'stylist');
              }).join('') : '<div class="retail-empty">No stylist retail activity found in this range yet.</div>') + '</div>'
          + '</section>'
          + '<section class="retail-successLane">'
          +   '<div class="retail-fieldBoardHead">'
          +     '<div>'
          +       '<div class="retail-scoreboardEyebrow">Retail Success</div>'
          +       '<h3 class="retail-fieldBoardTitle">Assistant Leaderboard</h3>'
          +       '<p class="retail-fieldBoardMeta">' + escapeHtml(retailSuccessSummaryLine(assistantBoard.summary, 'assistant')) + '</p>'
          +     '</div>'
          +     '<div class="retail-scoreboardStats retail-scoreboardStats--lane">'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(assistantRows.length)) + '</strong><span>assistants tracked</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(Number(assistantSummary.attributed_units_sold || 0) || 0)) + '</strong><span>products linked</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(Number(assistantSummary.attributed_retail_visits || 0) || 0)) + '</strong><span>support wins</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(Math.round(retailSuccessAverage(assistantRows, 'assistant') * 10) / 10)) + '</strong><span>avg support wins</span></div>'
          +     '</div>'
          +   '</div>'
          +   '<div class="retail-successGrid">' + (assistantRows.length ? assistantRows.map(function(row){
                return retailSuccessCardMarkup(row, 'assistant');
              }).join('') : '<div class="retail-empty">No assistant support activity found in this range yet.</div>') + '</div>'
          + '</section>';
      }

      function getRetailDateRange(){
        return buildRetailWeekRange(activeRetailPayrollStart);
      }

      function getRetailSnapshotForPeriod(periodKey){
        var normalizedKey = String(periodKey || '').trim();
        return retailPeriodSnapshots && normalizedKey && retailPeriodSnapshots[normalizedKey]
          ? retailPeriodSnapshots[normalizedKey]
          : null;
      }

      function getRetailSnapshotForActiveWeek(){
        return getRetailSnapshotForPeriod(activeRetailPayrollStart);
      }

      function retailTextValue(value, fallback){
        if (value == null) return String(fallback || '');
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
          var primitiveText = String(value).trim();
          return primitiveText || String(fallback || '');
        }
        if (Array.isArray(value)) {
          var arrayText = value.map(function(item){
            return retailTextValue(item, '');
          }).filter(Boolean).join(', ');
          return arrayText || String(fallback || '');
        }
        if (typeof value === 'object') {
          var preferredKeys = ['label', 'name', 'title', 'message', 'text', 'value'];
          for (var index = 0; index < preferredKeys.length; index += 1) {
            var preferredValue = retailTextValue(value[preferredKeys[index]], '');
            if (preferredValue) return preferredValue;
          }
          try {
            return JSON.stringify(value);
          } catch (_error) {
            return String(fallback || '');
          }
        }
        return String(fallback || '');
      }

      function buildRetailReasonText(row){
        var explicitReason = retailTextValue(row && row.opportunity_reason, '');
        if (explicitReason) {
          return 'Why this is in queue: ' + explicitReason;
        }
        var opportunityType = retailTextValue(row && row.opportunity_type, 'opportunity');
        var recommendedCount = Number((row && row.recommended_count) || 0) || 0;
        var purchasedRecommendedCount = Number((row && row.purchased_recommended_count) || 0) || 0;
        var missingCount = Number((row && row.missing_count) || 0) || 0;

        if (String(opportunityType).toLowerCase() === 'no_consult') {
          return 'Why this is in queue: no consult appears to have been captured for this completed visit.';
        }
        if (String(opportunityType).toLowerCase() === 'no_recommendations') {
          return 'Why this is in queue: the visit closed without product recommendations being captured.';
        }
        if (String(opportunityType).toLowerCase() === 'no_retail') {
          return 'Why this is in queue: recommendations were captured, but no retail purchase was recorded after the appointment.';
        }

        var parts = [];
        if (recommendedCount > 0) {
          parts.push('recommended ' + recommendedCount);
        }
        if (purchasedRecommendedCount > 0) {
          parts.push('purchased ' + purchasedRecommendedCount);
        }
        if (missingCount > 0) {
          parts.push('missing ' + missingCount);
        }

        if (parts.length) {
          return 'Why this is in queue: ' + parts.join(', ') + ' from the recommended routine after a closed visit.';
        }

        return 'Why this is in queue: this appointment still looks like a retail follow-up opportunity based on the saved recommendation data.';
      }

      function retailOpportunityCardMarkup(row){
        var clientName = retailTextValue(row && row.client_name, 'Unknown client');
        var staffName = retailTextValue(row && row.staff_name, 'No stylist');
        var opportunityType = retailTextValue(row && row.opportunity_type, 'opportunity');
        var reasonText = buildRetailReasonText(row);
        var queueStatus = retailTextValue(row && row.existing_queue_status, '');
        var token = retailTextValue(row && row.public_token, '');
        var activityBucket = getRetailActivityBucket(row);
        return ''
          + '<article class="retail-card">'
          +   '<div class="retail-cardHead">'
          +     '<div>'
          +       '<h3 class="retail-cardTitle">' + escapeHtml(clientName) + '</h3>'
          +       '<p class="retail-cardMeta">' + escapeHtml(formatRequestReviewDates([row && (row.appointment_closed_date || row.appointment_date)]) + ' • ' + staffName) + '</p>'
          +     '</div>'
          +     '<span class="retail-chip">' + escapeHtml(opportunityType) + '</span>'
          +   '</div>'
          +   (queueStatus ? '<div class="retail-cardMeta">Queue status: ' + escapeHtml(queueStatus) + '</div>' : '')
          +   (token ? '<div class="retail-cardMeta">Public token: ' + escapeHtml(token) + '</div>' : '')
          +   '<div class="retail-cardRow">'
          +     '<div class="retail-cardLabel">Services</div>'
          +     '<div class="retail-cardChips">' + retailChipsMarkup(row && row.service_names) + '</div>'
          +   '</div>'
          +   '<div class="retail-cardRow">'
          +     '<div class="retail-cardLabel">Missing routine pieces</div>'
          +     '<div class="retail-cardChips">' + retailChipsMarkup(row && (row.missing_product_handles || row.missing_handles)) + '</div>'
          +   '</div>'
          +   '<div class="retail-cardRow">'
          +     '<div class="retail-cardLabel">Already purchased</div>'
          +     '<div class="retail-cardChips">' + retailChipsMarkup(row && (row.purchased_product_handles || row.purchased_handles), 'success') + '</div>'
          +   '</div>'
          +   '<div class="retail-cardMeta">Check-in activity: ' + escapeHtml(retailActivitySummaryText(activityBucket)) + '</div>'
          +   '<div class="retail-reason">' + escapeHtml(reasonText) + '</div>'
          +   '<div class="retail-cardActions">'
          +     '<button class="btn-primary" type="button" data-retail-queue-appointment-id="' + escapeHtml(String((row && row.appointment_id) || '')) + '">Queue SMS</button>'
          +   '</div>'
          + '</article>';
      }

      function retailBusinessSubcategoryLabel(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'no_consult') return 'Consult Missed';
        if (normalized === 'no_recommendations') return 'Recommendations Missing';
        if (normalized === 'no_retail') return 'Retail Never Purchased';
        if (normalized === 'partial_routine') return 'Routine Incomplete';
        if (normalized === 'full_routine') return 'Routine Complete';
        return retailTextValue(value, 'Retail Opportunity');
      }

      function retailBusinessDiagnosisTitle(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'no_consult') return 'Consult opportunity missed';
        if (normalized === 'no_recommendations') return 'Recommendation gap';
        if (normalized === 'no_retail') return 'Retail attach missed';
        if (normalized === 'partial_routine') return 'Routine still incomplete';
        if (normalized === 'full_routine') return 'Retail routine complete';
        return 'Retail opportunity';
      }

      function retailBusinessRecommendedAction(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'no_consult') return 'Coach the stylist to capture consult and homecare needs next visit.';
        if (normalized === 'no_recommendations') return 'Follow up with a concise product recommendation.';
        if (normalized === 'no_retail') return 'Text the guest with the top recommended product and pickup option.';
        if (normalized === 'partial_routine') return 'Offer the missing routine pieces as the next homecare step.';
        return 'Monitor retail follow-up.';
      }

      function retailBusinessWorkflowState(row){
        var queueStatus = String((row && (row.existing_queue_status || row.queue_status)) || '').trim().toLowerCase();
        var lastContactedAt = retailTextValue(row && row.last_contacted_at, '');
        if (queueStatus === 'sent' || queueStatus === 'reviewed' || queueStatus === 'queued' || lastContactedAt) {
          return {
            label: 'Working',
            tone: 'warning',
            summary: 'Retail outreach is already in progress.'
          };
        }
        if (row && row.followup_ready === true) {
          return {
            label: 'Needs Manager',
            tone: 'warning',
            summary: 'Ready for same-day retail follow-up.'
          };
        }
        return {
          label: 'Monitor',
          tone: 'muted',
          summary: 'Keep this retail opportunity in view.'
        };
      }

      function scoreRetailBusinessOpportunity(row){
        var opportunityType = String((row && row.opportunity_type) || '').trim().toLowerCase();
        var baseScore = 40;
        if (opportunityType === 'no_retail') baseScore = 78;
        else if (opportunityType === 'partial_routine') baseScore = 72;
        else if (opportunityType === 'no_recommendations') baseScore = 62;
        else if (opportunityType === 'no_consult') baseScore = 54;
        else if (opportunityType === 'full_routine') baseScore = 24;
        var missingCount = Number((row && row.missing_count) || 0) || 0;
        var recommendedCount = Number((row && row.recommended_count) || 0) || 0;
        var purchasedCount = Number((row && row.purchased_count) || 0) || 0;
        var inVisitPurchaseCount = Number((row && row.appointment_purchase_count) || 0) || 0;
        var postPurchaseCount = Number((row && row.post_purchase_count) || 0) || 0;
        var readyBonus = row && row.followup_ready === true ? 12 : 0;
        var queuePenalty = retailTextValue(row && row.existing_queue_status, '') ? 10 : 0;
        var contactPenalty = retailTextValue(row && row.last_contacted_at, '') ? 8 : 0;
        var appointmentAt = retailTextValue(row && row.appointment_datetime, '');
        var recencyBonus = 0;
        if (appointmentAt) {
          var date = new Date(appointmentAt);
          if (!isNaN(date.getTime())) {
            var diffDays = Math.max(0, Math.floor((Date.now() - date.getTime()) / 86400000));
            if (diffDays <= 7) recencyBonus = 12;
            else if (diffDays <= 14) recencyBonus = 9;
            else if (diffDays <= 30) recencyBonus = 5;
            else if (diffDays <= 60) recencyBonus = 2;
          }
        }
        return Math.max(
          1,
          baseScore
            + Math.min(20, missingCount * 6)
            + Math.min(10, recommendedCount * 2)
            + Math.min(6, purchasedCount)
            + Math.min(8, postPurchaseCount * 2)
            + readyBonus
            + recencyBonus
            - Math.min(10, inVisitPurchaseCount * 4)
            - queuePenalty
            - contactPenalty
        );
      }

      function normalizeRetailPriorityQueueRow(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var opportunityType = String((safeRow && safeRow.opportunity_type) || '').trim().toLowerCase();
        var workflow = retailBusinessWorkflowState(safeRow);
        var priorityScore = scoreRetailBusinessOpportunity(safeRow);
        var subcategoryLabel = retailBusinessSubcategoryLabel(opportunityType);
        var diagnosisTitle = retailBusinessDiagnosisTitle(opportunityType);
        return {
          queue_source: 'retail',
          opportunity_key: 'retail:' + retailTextValue(safeRow && safeRow.appointment_id, ''),
          appointment_id: retailTextValue(safeRow && safeRow.appointment_id, ''),
          client_id: retailTextValue(safeRow && safeRow.client_id, ''),
          guest_name: retailTextValue(safeRow && safeRow.client_name, 'Unknown guest'),
          client_phone: retailTextValue(safeRow && safeRow.client_phone, ''),
          client_email: retailTextValue(safeRow && safeRow.client_email, ''),
          primary_staff_name: retailTextValue(safeRow && safeRow.staff_name, ''),
          staff_names: retailArray(safeRow && safeRow.staff_name ? [safeRow.staff_name] : []),
          history_rating: 'Retail Opportunity',
          priority_score: priorityScore,
          business_priority_score: priorityScore,
          opportunity_priority_tier: priorityScore >= 85 ? 'critical' : (priorityScore >= 70 ? 'high' : (priorityScore >= 55 ? 'medium' : 'low')),
          business_category: 'retail_opportunity',
          business_category_label: 'Retail Opportunity',
          business_subcategory: opportunityType,
          business_subcategory_label: subcategoryLabel,
          diagnosis_key: opportunityType,
          diagnosis_title: diagnosisTitle,
          diagnosis_summary: buildRetailReasonText(safeRow).replace(/^Why this is in queue:\s*/i, ''),
          opportunity_type: 'retail_growth',
          opportunity_lane: 'Retail Growth',
          recommended_action: retailBusinessRecommendedAction(opportunityType),
          diagnosis_confidence: safeRow.followup_ready === true ? 'high' : 'medium',
          workflow_state_label: workflow.label,
          workflow_state_tone: workflow.tone,
          workflow_state_summary: workflow.summary,
          outcome_state_label: '',
          queue_stage: 'retail_followup',
          retail_opportunity_type: opportunityType,
          retail_row: safeRow,
          appointment_count: 0,
          debug: {
            retail_followup: true,
            source_row: safeRow
          }
        };
      }

      async function fetchReviewOpportunities(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'get-review-opportunities',
            lookback_days: 30,
            limit: 120
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load review opportunities.');
        }
        return data;
      }

      async function fetchReferralOpportunities(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'get-referral-opportunities',
            lookback_days: 90,
            limit: 180
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load referral opportunities.');
        }
        return data;
      }

      function scoreReviewBusinessOpportunity(row){
        var opportunityType = String((row && row.opportunity_type) || '').trim().toLowerCase();
        var rating = Number((row && row.appointment_rating) || 0) || 0;
        var daysSinceVisit = Number((row && row.days_since_visit) || 0) || 0;
        var baseScore = opportunityType === 'external_review_request' ? 58 : 46;
        var ratingBonus = rating >= 5 ? 18 : rating >= 4 ? 12 : 0;
        var recencyBonus = daysSinceVisit <= 3 ? 18 : daysSinceVisit <= 7 ? 12 : daysSinceVisit <= 14 ? 7 : 2;
        return Math.max(1, baseScore + ratingBonus + recencyBonus);
      }

      function buildReviewSuggestedMessage(row){
        var firstName = retailTextValue(row && row.client_name, 'there').split(/\s+/)[0] || 'there';
        var staffName = retailTextValue(row && row.staff_name, '');
        var services = retailArray(row && row.service_names).filter(function(value){
          return !!retailTextValue(value, '');
        });
        var leadService = services[0] || 'your visit';
        if (String((row && row.opportunity_type) || '').trim().toLowerCase() === 'external_review_request') {
          return 'Hi ' + firstName + ', we\'re so glad you enjoyed your ' + leadService + (staffName ? ' with ' + staffName : '') + '. If you have a minute, we\'d really appreciate a quick review.';
        }
        return 'Hi ' + firstName + ', thanks again for visiting us' + (staffName ? ' and seeing ' + staffName : '') + '. We\'d love to hear how your ' + leadService + ' went if you have a quick moment to share feedback.';
      }

      function normalizeReviewPriorityQueueRow(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var opportunityType = String((safeRow && safeRow.opportunity_type) || '').trim().toLowerCase();
        var priorityScore = scoreReviewBusinessOpportunity(safeRow);
        var reviewTypeLabel = opportunityType === 'external_review_request' ? 'External Review Request' : 'Internal Review Request';
        return {
          queue_source: 'review',
          opportunity_key: 'review:' + retailTextValue(safeRow && safeRow.appointment_id, ''),
          appointment_id: retailTextValue(safeRow && safeRow.appointment_id, ''),
          client_id: retailTextValue(safeRow && safeRow.client_id, ''),
          guest_name: retailTextValue(safeRow && safeRow.client_name, 'Unknown guest'),
          client_phone: retailTextValue(safeRow && safeRow.client_phone, ''),
          client_email: retailTextValue(safeRow && safeRow.client_email, ''),
          primary_staff_name: retailTextValue(safeRow && safeRow.staff_name, ''),
          staff_names: retailArray(safeRow && safeRow.staff_name ? [safeRow.staff_name] : []),
          history_rating: 'Review Opportunity',
          priority_score: priorityScore,
          business_priority_score: priorityScore,
          opportunity_priority_tier: priorityScore >= 75 ? 'high' : (priorityScore >= 55 ? 'medium' : 'low'),
          business_category: 'review_opportunity',
          business_category_label: 'Review Opportunity',
          business_subcategory: opportunityType,
          business_subcategory_label: reviewTypeLabel,
          diagnosis_key: opportunityType,
          diagnosis_title: opportunityType === 'external_review_request' ? 'Positive experience to amplify' : 'Feedback still missing',
          diagnosis_summary: retailTextValue(safeRow && safeRow.opportunity_reason, ''),
          opportunity_type: 'review_growth',
          opportunity_lane: 'Review Growth',
          recommended_action: opportunityType === 'external_review_request'
            ? 'Ask for a public review while the experience is still fresh.'
            : 'Ask for quick internal feedback while the visit is recent.',
          diagnosis_confidence: opportunityType === 'external_review_request' ? 'high' : 'medium',
          workflow_state_label: 'Needs Manager',
          workflow_state_tone: 'accent',
          workflow_state_summary: 'Fresh review opportunity ready for outreach.',
          queue_stage: 'review_followup',
          review_row: safeRow,
          appointment_count: 0,
          review_suggested_message: buildReviewSuggestedMessage(safeRow),
          debug: {
            review_followup: true,
            source_row: safeRow
          }
        };
      }

      function scoreReferralBusinessOpportunity(row){
        var opportunityType = String((row && row.opportunity_type) || '').trim().toLowerCase();
        if (opportunityType === 'referral_reward_created') return 88;
        if (opportunityType === 'referral_created') return 74;
        if (opportunityType === 'referral_updated') return 62;
        if (opportunityType === 'referral_deleted') return 18;
        var totalVisits = Number((row && row.total_completed_visits) || 0) || 0;
        var positiveVisitCount = Number((row && row.positive_visit_count) || 0) || 0;
        var daysSinceVisit = Number((row && row.days_since_visit) || 0) || 0;
        var baseScore = 42;
        if (opportunityType === 'vip_referral_request') baseScore = 66;
        else if (opportunityType === 'recent_positive_experience') baseScore = 58;
        else if (opportunityType === 'consistent_positive_guest') baseScore = 52;
        var visitBonus = Math.min(18, totalVisits * 2);
        var positiveBonus = Math.min(12, positiveVisitCount * 3);
        var recencyBonus = daysSinceVisit <= 7 ? 14 : daysSinceVisit <= 21 ? 10 : daysSinceVisit <= 45 ? 5 : 1;
        return Math.max(1, baseScore + visitBonus + positiveBonus + recencyBonus);
      }

      function buildReferralSuggestedMessage(row){
        var opportunityType = String((row && row.opportunity_type) || '').trim().toLowerCase();
        var firstName = retailTextValue(row && row.client_name, 'there').split(/\s+/)[0] || 'there';
        var referrerName = retailTextValue(row && row.referrer_client_name, '').split(/\s+/)[0] || '';
        var staffName = retailTextValue(row && row.staff_name, '');
        var services = retailArray(row && row.service_names).filter(function(value){
          return !!retailTextValue(value, '');
        });
        var leadService = services[0] || 'hair';
        if (opportunityType === 'referral_created') {
          return 'New referral from ' + (referrerName || firstName) + '. Follow up quickly and help the referred guest get booked.';
        }
        if (opportunityType === 'referral_reward_created') {
          return 'Referral reward was created for ' + (referrerName || firstName) + '. Mark this as won and acknowledge the relationship.';
        }
        if (opportunityType === 'referral_updated') {
          return 'A Boulevard referral was updated for ' + (referrerName || firstName) + '. Review the status and decide the next step.';
        }
        return 'Hi ' + firstName + ', thanks for being such a loyal guest' + (staffName ? ' with ' + staffName : '') + '. If you have a friend or family member looking for help with ' + leadService + ', we’d love to meet them.';
      }

      function normalizeReferralPriorityQueueRow(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var opportunityType = String((safeRow && safeRow.opportunity_type) || '').trim().toLowerCase();
        var priorityScore = scoreReferralBusinessOpportunity(safeRow);
        var subcategoryLabel = 'Referral Opportunity';
        var diagnosisTitle = 'Referral opportunity';
        var workflowStateSummary = 'Strong candidate for a referral ask.';
        var recommendedAction = 'Send a short referral ask while the relationship is strong and recent.';
        var workflowStateLabel = 'Needs Manager';
        var workflowStateTone = 'accent';
        var diagnosisConfidence = opportunityType === 'vip_referral_request' ? 'high' : 'medium';
        if (opportunityType === 'referral_created') {
          subcategoryLabel = 'Referral Event';
          diagnosisTitle = 'New referral received';
          workflowStateSummary = 'A live Boulevard referral event needs follow-up.';
          recommendedAction = 'Review the referred guest and push the next booking step.';
          diagnosisConfidence = 'high';
        } else if (opportunityType === 'referral_reward_created') {
          subcategoryLabel = 'Referral Reward';
          diagnosisTitle = 'Referral converted';
          workflowStateSummary = 'Boulevard created a referral reward.';
          recommendedAction = 'Mark this referral as won and log the outcome.';
          workflowStateLabel = 'Won';
          workflowStateTone = 'success';
          diagnosisConfidence = 'high';
        } else if (opportunityType === 'referral_updated') {
          subcategoryLabel = 'Referral Updated';
          diagnosisTitle = 'Referral status changed';
          workflowStateSummary = 'Boulevard updated this referral record.';
          recommendedAction = 'Review the latest referral status and refresh any follow-up.';
          diagnosisConfidence = 'medium';
        } else if (opportunityType === 'referral_deleted') {
          subcategoryLabel = 'Referral Removed';
          diagnosisTitle = 'Referral deleted';
          workflowStateSummary = 'The referral was deleted in Boulevard.';
          recommendedAction = 'Close this referral opportunity unless another workflow still depends on it.';
          workflowStateLabel = 'Closed';
          workflowStateTone = 'muted';
          diagnosisConfidence = 'high';
        } else if (opportunityType === 'vip_referral_request') {
          subcategoryLabel = 'VIP Referral Ask';
          diagnosisTitle = 'Loyal guest ready for referral ask';
        } else if (opportunityType === 'recent_positive_experience') {
          subcategoryLabel = 'Recent Positive Experience';
          diagnosisTitle = 'Fresh positive visit to leverage';
        } else if (opportunityType === 'consistent_positive_guest') {
          subcategoryLabel = 'Consistent Positive Guest';
          diagnosisTitle = 'Strong relationship worth activating';
        }
        return {
          queue_source: 'referral',
          opportunity_key: 'referral:' + retailTextValue(safeRow && safeRow.appointment_id, ''),
          appointment_id: retailTextValue(safeRow && safeRow.appointment_id, ''),
          client_id: retailTextValue(safeRow && safeRow.client_id, ''),
          guest_name: retailTextValue(safeRow && safeRow.client_name, 'Unknown guest'),
          client_phone: retailTextValue(safeRow && safeRow.client_phone, ''),
          client_email: retailTextValue(safeRow && safeRow.client_email, ''),
          primary_staff_name: retailTextValue(safeRow && safeRow.staff_name, ''),
          staff_names: retailArray(safeRow && safeRow.staff_name ? [safeRow.staff_name] : []),
          history_rating: retailTextValue(safeRow && safeRow.history_rating, 'Referral Opportunity'),
          priority_score: priorityScore,
          business_priority_score: priorityScore,
          opportunity_priority_tier: priorityScore >= 78 ? 'high' : (priorityScore >= 58 ? 'medium' : 'low'),
          business_category: 'referral_opportunity',
          business_category_label: 'Referral Opportunity',
          business_subcategory: opportunityType,
          business_subcategory_label: subcategoryLabel,
          diagnosis_key: opportunityType,
          diagnosis_title: diagnosisTitle,
          diagnosis_summary: retailTextValue(safeRow && safeRow.opportunity_reason, ''),
          opportunity_type: 'referral_growth',
          opportunity_lane: 'Referral Growth',
          recommended_action: recommendedAction,
          diagnosis_confidence: diagnosisConfidence,
          workflow_state_label: workflowStateLabel,
          workflow_state_tone: workflowStateTone,
          workflow_state_summary: workflowStateSummary,
          queue_stage: 'referral_followup',
          referral_row: safeRow,
          appointment_count: Number((safeRow && safeRow.total_completed_visits) || 0) || 0,
          referral_suggested_message: buildReferralSuggestedMessage(safeRow),
          debug: {
            referral_followup: true,
            source_row: safeRow
          }
        };
      }

      function buildPriorityOpportunityKey(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var source = String((safeRow && safeRow.queue_source) || '').trim();
        function normalizeGuestBucketKey(value){
          var raw = String(value || '').trim();
          var digits = raw.replace(/\D+/g, '');
          if (!digits) return raw;
          if (digits.length === 11 && digits.charAt(0) === '1') return digits;
          if (digits.length === 10) return '1' + digits;
          if (digits.length > 11) return '1' + digits.slice(-10);
          return digits;
        }
        if (source === 'retail') return 'retail:' + retailTextValue(safeRow && safeRow.appointment_id, '');
        if (source === 'review') return 'review:' + retailTextValue(safeRow && safeRow.appointment_id, '');
        if (source === 'referral') return 'referral:' + retailTextValue(safeRow && safeRow.appointment_id, '');
        return 'appointment:' + normalizeGuestBucketKey(retailTextValue(safeRow && safeRow.guest_bucket_key, ''));
      }

      function taskStatusLabel(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'assigned') return 'Assigned';
        if (normalized === 'working') return 'Working';
        if (normalized === 'snoozed') return 'Snoozed';
        if (normalized === 'completed') return 'Completed';
        return 'Needs Manager';
      }

      function taskStatusTone(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'completed') return 'success';
        if (normalized === 'working' || normalized === 'assigned') return 'accent';
        if (normalized === 'snoozed') return 'muted';
        return 'warning';
      }

      async function fetchBusinessDevelopmentTasks(opportunityKeys){
        var keys = retailArray(opportunityKeys).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        if (!keys.length) return [];
        var batchSize = 250;
        var rows = [];
        for (var batchStart = 0; batchStart < keys.length; batchStart += batchSize) {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'get-business-development-tasks',
              opportunity_keys: keys.slice(batchStart, batchStart + batchSize)
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not load business-development tasks.');
          }
          rows = rows.concat(retailArray(data && data.rows));
        }
        return rows;
      }

      async function fetchBusinessDevelopmentClaimedRows(managerStaffIds){
        var ids = retailArray(Array.isArray(managerStaffIds) ? managerStaffIds : [managerStaffIds]).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean).filter(function(value, index, array){
          return array.indexOf(value) === index;
        });
        if (!ids.length) return [];
        var rowMap = {};
        for (var index = 0; index < ids.length; index += 1) {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'get-business-development-claimed-rows',
              manager_staff_id: ids[index]
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not load claimed business-development rows.');
          }
          retailArray(data && data.rows).forEach(function(row){
            var key = retailTextValue(row && row.opportunity_key, '') || retailTextValue(row && row.guest_bucket_key, '');
            if (!key) return;
            rowMap[key] = row;
          });
        }
        return Object.keys(rowMap).map(function(key){
          return rowMap[key];
        });
      }

      async function fetchBusinessDevelopmentOutcomes(opportunityKeys){
        var keys = retailArray(opportunityKeys).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        if (!keys.length) return [];
        var batchSize = 250;
        var rows = [];
        for (var batchStart = 0; batchStart < keys.length; batchStart += batchSize) {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'get-business-development-outcomes',
              opportunity_keys: keys.slice(batchStart, batchStart + batchSize)
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not load business-development outcomes.');
          }
          rows = rows.concat(retailArray(data && data.rows));
        }
        return rows;
      }

      async function fetchBusinessDevelopmentScorecard(options){
        var opts = options && typeof options === 'object' ? options : {};
        var payload = {
          action: 'get-business-development-scorecard',
          lookback_days: Number(opts.lookbackDays || dueScorecardLookbackDays) || 30
        };
        if (opts.dateFrom) payload.date_from = String(opts.dateFrom);
        if (opts.dateTo) payload.date_to = String(opts.dateTo);
        if (opts.sourceFilter) payload.source_filter = String(opts.sourceFilter);
        var managerStaffId = currentDueQueueManagerStaffId();
        if (managerStaffId) {
          payload.manager_staff_id = managerStaffId;
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load business-development scorecard.');
        }
        return data && data.summary ? data.summary : null;
      }

      async function fetchTfsCollectionSalesSummary(options){
        var opts = options && typeof options === 'object' ? options : {};
        var payload = {
          action: 'shopify-collection-order-search',
          collection_handle: String(opts.collectionHandle || 'the-full-story').trim() || 'the-full-story',
          max_pages: Math.max(1, Math.min(25, Number(opts.maxPages || 25) || 25))
        };
        if (opts.dateFrom) payload.processed_since = String(opts.dateFrom).trim();
        if (opts.dateTo) payload.processed_until = String(opts.dateTo).trim();
        if (opts.updatedSince) payload.updated_since = String(opts.updatedSince).trim();
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load TFS Shopify sales.');
        }
        var orders = Array.isArray(data && data.orders) ? data.orders : [];
        var filteredOrders = orders.filter(function(order){
          var processedAt = String((order && order.processed_at) || (order && order.created_at) || '').trim();
          if (opts.dateFrom && processedAt && processedAt.slice(0, 10) < String(opts.dateFrom).trim()) return false;
          if (opts.dateTo && processedAt && processedAt.slice(0, 10) > String(opts.dateTo).trim()) return false;
          return true;
        });
        var summary = filteredOrders.reduce(function(acc, order){
          var lines = Array.isArray(order && order.lines) ? order.lines : [];
          acc.order_count += 1;
          lines.forEach(function(line){
            var gross = Math.max(0, Number(line && line.gross_amount || 0) || 0);
            var discounted = Math.max(0, Number(line && line.discounted_amount || 0) || 0);
            var net = Math.max(0, Number(line && line.net_amount || 0) || 0);
            var quantity = Math.max(0, Number(line && line.current_quantity != null ? line.current_quantity : line && line.quantity || 0) || 0);
            acc.gross_sales += gross;
            acc.discounted_sales += discounted;
            acc.net_sales += net;
            acc.refunded_sales += Math.max(0, discounted - net);
            acc.units += quantity;
          });
          return acc;
        }, {
          order_count: 0,
          gross_sales: 0,
          discounted_sales: 0,
          net_sales: 0,
          refunded_sales: 0,
          units: 0
        });
        summary.average_order_value = summary.order_count > 0 ? (summary.net_sales / summary.order_count) : 0;
        summary.orders = filteredOrders;
        return summary;
      }

      function syncBdFastScorecardControls(){
        if (bdFastScorecardRangeTabs) {
          Array.prototype.forEach.call(bdFastScorecardRangeTabs.querySelectorAll('[data-bd-fast-scorecard-range]'), function(button){
            var rangeValue = Number(String(button.getAttribute('data-bd-fast-scorecard-range') || '').trim() || '30');
            var isActive = rangeValue === bdFastScorecardLookbackDays;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
        }
        if (bdFastScorecardAudienceTabs) {
          Array.prototype.forEach.call(bdFastScorecardAudienceTabs.querySelectorAll('[data-bd-fast-scorecard-focus]'), function(button){
            var focusValue = String(button.getAttribute('data-bd-fast-scorecard-focus') || '').trim() || 'team';
            var isActive = focusValue === bdFastScorecardFocus;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
        }
      }

      function renderBdFastScorecard(){
        if (!bdFastScorecardMount) return;
        var summary = bdFastScorecard && typeof bdFastScorecard === 'object' ? bdFastScorecard : null;
        if (!summary) {
          bdFastScorecardMount.innerHTML = '<div class="retail-empty">BD Fast performance will load here.</div>';
          return;
        }
        var overall = summary.overall && typeof summary.overall === 'object' ? summary.overall : {};
        var conversionRate = Number((overall && overall.conversion_rate_pct) || 0) || 0;
        if (bdFastResultsPeriod) {
          bdFastResultsPeriod.textContent = bdFastPerformancePeriodLabel();
        }
        bdFastScorecardMount.innerHTML = ''
          + '<div class="bd-fastMetric">'
          +   '<span>SMS Sent</span>'
          +   '<strong>' + escapeHtml(String(overall.sms_sent || 0)) + '</strong>'
          + '</div>'
          + '<div class="bd-fastMetric">'
          +   '<span>Booked Wins</span>'
          +   '<strong>' + escapeHtml(String(overall.appointments_recovered || 0)) + '</strong>'
          + '</div>'
          + '<div class="bd-fastMetric">'
          +   '<span>Booked Services Value</span>'
          +   '<strong>' + escapeHtml(formatCurrencyDollarsFromCents(Number(overall.service_revenue_cents || 0) || 0)) + '</strong>'
          + '</div>'
          + '<div class="bd-fastMetric">'
          +   '<span>Retail Wins</span>'
          +   '<strong>' + escapeHtml(String(overall.retail_wins || 0)) + '</strong>'
          + '</div>'
          + '<div class="bd-fastMetric">'
          +   '<span>Retail Sales</span>'
          +   '<strong>' + escapeHtml(formatCurrencyDollarsFromCents(Number(overall.retail_revenue_cents || 0) || 0)) + '</strong>'
          + '</div>'
          + '<div class="bd-fastMetric">'
          +   '<span>Conversion Rate</span>'
          +   '<strong>' + escapeHtml(conversionRate.toFixed(1) + '%') + '</strong>'
          + '</div>';
      }

      async function loadBdFastScorecard(){
        if (!bdFastScorecardMount) return null;
        if (bdFastResultsPeriod) {
          bdFastResultsPeriod.textContent = bdFastPerformancePeriodLabel();
        }
        bdFastScorecardMount.innerHTML = '<div class="retail-empty">Loading BD Fast performance…</div>';
        bdFastScorecard = await fetchBusinessDevelopmentScorecard({
          dateFrom: formatDateInputValue(bdFastPerformanceDateFrom()),
          dateTo: formatDateInputValue(bdFastPerformanceDateTo()),
          sourceFilter: 'client_followup_queue_v4'
        });
        renderBdFastScorecard();
        return bdFastScorecard;
      }

      async function updateBusinessDevelopmentTask(row, taskStatus){
        var managerStaffId = await ensureDueQueueManagerSession();
        var payload = {
          action: 'update-business-development-task',
          editor_staff_id: managerStaffId,
          opportunity_key: retailTextValue(row && row.opportunity_key, '') || buildPriorityOpportunityKey(row),
          opportunity_family: retailTextValue(row && row.business_category, '') || 'appointment_growth',
          opportunity_source: retailTextValue(row && row.queue_source, '') || 'appointment',
          client_bucket_key: (function(value){
            var raw = String(value || '').trim();
            var digits = raw.replace(/\D+/g, '');
            if (!digits) return raw;
            if (digits.length === 11 && digits.charAt(0) === '1') return digits;
            if (digits.length === 10) return '1' + digits;
            if (digits.length > 11) return '1' + digits.slice(-10);
            return digits;
          })(retailTextValue(row && row.guest_bucket_key, '')),
          appointment_id: retailTextValue(row && row.appointment_id, ''),
          client_id: retailTextValue(row && (row.client_id || row.primary_client_id), ''),
          guest_name: retailTextValue(row && row.guest_name, ''),
          task_status: taskStatus,
          metadata: {
            queue_stage: retailTextValue(row && row.queue_stage, ''),
            queue_source: retailTextValue(row && row.queue_source, ''),
            business_category: retailTextValue(row && row.business_category, ''),
            business_subcategory: retailTextValue(row && row.business_subcategory, ''),
            opportunity_type: retailTextValue(row && row.opportunity_type, '')
          }
        };
        if (taskStatus === 'snoozed') {
          var snoozeUntil = new Date();
          snoozeUntil.setDate(snoozeUntil.getDate() + 7);
          payload.next_followup_at = snoozeUntil.toISOString();
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not update task state.');
        }
        return data && data.row ? data.row : null;
      }

      function outcomeLabelForKey(outcomeKey){
        var normalized = String(outcomeKey || '').trim().toLowerCase();
        if (normalized === 'appointment_booked') return 'Booked';
        if (normalized === 'retail_purchased') return 'Purchased';
        if (normalized === 'referral_booked') return 'Referral Won';
        if (normalized === 'review_completed') return 'Review Done';
        if (normalized === 'no_response') return 'No Response';
        return retailTextValue(outcomeKey, 'Outcome');
      }

      function outcomeToneForKey(outcomeKey){
        var normalized = String(outcomeKey || '').trim().toLowerCase();
        if (normalized === 'no_response') return 'muted';
        return 'success';
      }

      function outcomeSummaryForKey(outcomeKey){
        var normalized = String(outcomeKey || '').trim().toLowerCase();
        if (normalized === 'appointment_booked') return 'Appointment recovered after manager follow-up.';
        if (normalized === 'retail_purchased') return 'Retail purchase completed after outreach.';
        if (normalized === 'referral_booked') return 'Referral request produced a booked guest.';
        if (normalized === 'review_completed') return 'Review request produced a completed review.';
        if (normalized === 'no_response') return 'No response after outreach attempt.';
        return 'Outcome recorded.';
      }

      function latestBusinessHistoryEntry(metadata, key){
        var safeMetadata = metadata && typeof metadata === 'object' ? metadata : {};
        var history = retailArray(safeMetadata && safeMetadata[key]).filter(function(entry){
          return entry && typeof entry === 'object';
        });
        return history.length ? history[history.length - 1] : null;
      }

      function dueLastActionSummary(row){
        var outcomeSummary = retailTextValue(row && row.outcome_state_summary, '');
        var outcomeAt = retailTextValue(row && row.outcome_completed_at, '');
        var outcomeBy = retailTextValue(row && row.outcome_recorded_by_name, '');
        if (outcomeSummary) {
          if (dueAutoBookedOutcome(row)) {
            return 'Auto-credited from Boulevard booking' + (outcomeBy || outcomeAt ? ' • ' + [outcomeBy, outcomeAt ? formatRecaptureDate(outcomeAt) : ''].filter(Boolean).join(' on ') : '');
          }
          return outcomeSummary + (outcomeBy || outcomeAt ? ' • ' + [outcomeBy, outcomeAt ? formatRecaptureDate(outcomeAt) : ''].filter(Boolean).join(' on ') : '');
        }
        var taskLabel = retailTextValue(row && row.manager_task_status_label, '');
        var taskAt = retailTextValue(row && row.manager_task_last_event_at, '') || retailTextValue(row && row.manager_task_completed_at, '') || retailTextValue(row && row.manager_task_next_followup_at, '');
        var taskBy = retailTextValue(row && row.manager_task_last_event_by_name, '') || retailTextValue(row && row.manager_task_assigned_name, '');
        if (!taskLabel) return '';
        return taskLabel + (taskBy || taskAt ? ' • ' + [taskBy, taskAt ? formatRecaptureDate(taskAt) : ''].filter(Boolean).join(' on ') : '');
      }

      function dueHasBookedOutcome(row){
        return retailTextValue(row && row.outcome_state_key, '').toLowerCase() === 'appointment_booked';
      }

      function dueHasFutureBooking(row){
        return !!(
          row && (
            row.has_future_appointment === true ||
            row.future_appointment_found === true ||
            retailTextValue(row && row.future_appointment_at, '')
          )
        );
      }

      function dueAutoBookedOutcome(row){
        return dueHasBookedOutcome(row) && !!(row && row.outcome_auto_detected === true);
      }

      function dueAutoBookedBadgeMarkup(row){
        if (!dueAutoBookedOutcome(row)) return '';
        return '<span class="retail-chip retail-chip--workflow retail-chip--success">Auto-credited from Boulevard booking</span>';
      }

      function dueAutoBookedAuditText(row){
        if (!dueAutoBookedOutcome(row)) return '';
        var metadata = row && row.outcome_metadata && typeof row.outcome_metadata === 'object' ? row.outcome_metadata : {};
        var creditedTo = retailTextValue(row && row.outcome_recorded_by_name, '') || retailTextValue(row && row.manager_task_assigned_name, '') || 'assigned manager';
        var outreachAt = retailTextValue(metadata && metadata.last_contacted_at, '') || retailTextValue(row && row.outreach && row.outreach.last_contacted_at, '');
        var bookedAt = retailTextValue(metadata && metadata.future_appointment_at, '') || retailTextValue(row && row.future_appointment_at, '');
        var pieces = ['Auto-credited to ' + creditedTo];
        if (outreachAt) pieces.push('from ' + formatRecaptureDate(outreachAt) + ' outreach');
        if (bookedAt) pieces.push('after Boulevard saw a booking for ' + formatRecaptureDate(bookedAt));
        else pieces.push('after Boulevard saw the booking');
        return pieces.join(' ');
      }

      function dueOutcomeSyncNoteText(row){
        if (dueHasBookedOutcome(row) || !dueHasFutureBooking(row)) return '';
        if (retailTextValue(row && row.queue_source, 'appointment').toLowerCase() !== 'appointment') return '';
        return 'Future appointment found. Waiting for the Boulevard booking sync to credit this outreach.';
      }

      function formatCurrencyDollarsFromCents(value){
        var cents = Number(value || 0) || 0;
        var dollars = cents / 100;
        try {
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
          }).format(dollars);
        } catch (_error) {
          return '$' + Math.round(dollars).toLocaleString('en-US');
        }
      }

      function estimateAppointmentOpportunityRevenueCents(row){
        var primaryCategory = retailTextValue(row && (row.primary_category || row.latest_primary_service_family), '').toLowerCase();
        var primaryLabel = retailTextValue(row && (row.primary_label || row.latest_primary_service_name), '').toLowerCase();
        var families = retailArray(row && row.future_appointment_categories).map(function(value){
          return retailTextValue(value, '').toLowerCase();
        }).filter(Boolean);
        var signals = [primaryCategory, primaryLabel].concat(families);
        if (signals.some(function(value){ return value.indexOf('extension') !== -1; })) return 25000;
        if (signals.some(function(value){ return value.indexOf('lighter') !== -1 || value.indexOf('highlight') !== -1 || value.indexOf('blond') !== -1; })) return 22000;
        if (signals.some(function(value){ return value.indexOf('keratin') !== -1 || value.indexOf('smoothing') !== -1; })) return 30000;
        if (signals.some(function(value){ return value.indexOf('single_process') !== -1 || value.indexOf('color') !== -1 || value.indexOf('gloss') !== -1 || value.indexOf('toner') !== -1; })) return 14000;
        if (signals.some(function(value){ return value.indexOf('haircut') !== -1; })) return 9000;
        if (signals.some(function(value){ return value.indexOf('blowdry') !== -1 || value.indexOf('blowout') !== -1; })) return 5500;
        var visitCount = Number((row && row.appointment_count) || 0) || 0;
        if (visitCount >= 40) return 14000;
        if (visitCount >= 20) return 11000;
        return 8500;
      }

      function estimateRetailOpportunityRevenueCents(row){
        var retailRow = row && row.retail_row && typeof row.retail_row === 'object' ? row.retail_row : row;
        var missingCount = Number((retailRow && retailRow.missing_count) || 0) || 0;
        var recommendedCount = Number((retailRow && retailRow.recommended_count) || 0) || 0;
        var missingDetails = retailArray(retailRow && retailRow.missing_product_details);
        var categories = retailProductCategoriesSummary(missingDetails);
        var categoryBonus = Math.min(3000, categories.length * 700);
        return Math.max(2800, Math.min(18000, (missingCount * 3200) + (recommendedCount * 900) + categoryBonus));
      }

      function estimateReferralOpportunityRevenueCents(row){
        var priorityScore = Number((row && row.business_priority_score) || 0) || 0;
        return priorityScore >= 80 ? 18000 : 12000;
      }

      function estimatedOutcomeRevenueCents(row, outcomeKey){
        var normalized = String(outcomeKey || '').trim().toLowerCase();
        if (normalized === 'appointment_booked') return estimateAppointmentOpportunityRevenueCents(row);
        if (normalized === 'retail_purchased') return estimateRetailOpportunityRevenueCents(row);
        if (normalized === 'referral_booked') return estimateReferralOpportunityRevenueCents(row);
        return 0;
      }

      async function updateBusinessDevelopmentOutcome(row, outcomeKey){
        var managerStaffId = await ensureDueQueueManagerSession();
        var payload = {
          action: 'update-business-development-outcome',
          editor_staff_id: managerStaffId,
          opportunity_key: retailTextValue(row && row.opportunity_key, '') || buildPriorityOpportunityKey(row),
          opportunity_family: retailTextValue(row && row.business_category, '') || 'appointment_growth',
          opportunity_source: retailTextValue(row && row.queue_source, '') || 'appointment',
          client_bucket_key: (function(value){
            var raw = String(value || '').trim();
            var digits = raw.replace(/\D+/g, '');
            if (!digits) return raw;
            if (digits.length === 11 && digits.charAt(0) === '1') return digits;
            if (digits.length === 10) return '1' + digits;
            if (digits.length > 11) return '1' + digits.slice(-10);
            return digits;
          })(retailTextValue(row && row.guest_bucket_key, '')),
          appointment_id: retailTextValue(row && row.appointment_id, ''),
          client_id: retailTextValue(row && (row.client_id || row.primary_client_id), ''),
          guest_name: retailTextValue(row && row.guest_name, ''),
          outcome_key: outcomeKey,
          outcome_summary: outcomeSummaryForKey(outcomeKey),
          revenue_cents: estimatedOutcomeRevenueCents(row, outcomeKey),
          metadata: {
            queue_stage: retailTextValue(row && row.queue_stage, ''),
            queue_source: retailTextValue(row && row.queue_source, ''),
            business_category: retailTextValue(row && row.business_category, ''),
            business_subcategory: retailTextValue(row && row.business_subcategory, ''),
            opportunity_type: retailTextValue(row && row.opportunity_type, '')
          }
        };
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not update outcome state.');
        }
        return data && data.row ? data.row : null;
      }

      function mergeTaskStateOntoRows(rows, tasks){
        var taskMap = {};
        retailArray(tasks).forEach(function(task){
          var key = retailTextValue(task && task.opportunity_key, '');
          if (key) taskMap[key] = task;
        });
        return retailArray(rows).map(function(row){
          var safeRow = row && typeof row === 'object' ? row : {};
          var opportunityKey = retailTextValue(safeRow && safeRow.opportunity_key, '') || buildPriorityOpportunityKey(safeRow);
          var task = taskMap[opportunityKey] || null;
          if (!task) {
            return Object.assign({}, safeRow, { opportunity_key: opportunityKey });
          }
          var lastTaskEvent = latestBusinessHistoryEntry(task && task.metadata, 'status_history');
          return Object.assign({}, safeRow, {
            opportunity_key: opportunityKey,
            manager_task: task,
            manager_task_metadata: task && task.metadata ? task.metadata : {},
            manager_task_status: retailTextValue(task && task.task_status, ''),
            manager_task_status_label: taskStatusLabel(task && task.task_status),
            manager_task_status_tone: taskStatusTone(task && task.task_status),
            manager_task_assigned_staff_id: retailTextValue(task && task.assigned_manager_staff_id, ''),
            manager_task_assigned_name: retailTextValue(task && task.assigned_manager_name, ''),
            manager_task_next_followup_at: retailTextValue(task && task.next_followup_at, ''),
            manager_task_completed_at: retailTextValue(task && task.completed_at, ''),
            manager_task_last_event_label: taskStatusLabel(lastTaskEvent && lastTaskEvent.task_status),
            manager_task_last_event_at: retailTextValue(lastTaskEvent && lastTaskEvent.updated_at, ''),
            manager_task_last_event_by_name: retailTextValue(lastTaskEvent && lastTaskEvent.updated_by_name, '')
          });
        });
      }

      function mergeOutcomeStateOntoRows(rows, outcomes){
        var outcomeMap = {};
        retailArray(outcomes).forEach(function(outcome){
          var key = retailTextValue(outcome && outcome.opportunity_key, '');
          if (key) outcomeMap[key] = outcome;
        });
        return retailArray(rows).map(function(row){
          var safeRow = row && typeof row === 'object' ? row : {};
          var opportunityKey = retailTextValue(safeRow && safeRow.opportunity_key, '') || buildPriorityOpportunityKey(safeRow);
          var outcome = outcomeMap[opportunityKey] || null;
          if (!outcome) return safeRow;
          var outcomeKey = retailTextValue(outcome && outcome.outcome_key, '');
          var lastOutcomeEvent = latestBusinessHistoryEntry(outcome && outcome.metadata, 'outcome_history');
          return Object.assign({}, safeRow, {
            outcome_state_key: outcomeKey,
            outcome_state_label: outcomeLabelForKey(outcomeKey),
            outcome_state_tone: outcomeToneForKey(outcomeKey),
            outcome_state_summary: retailTextValue(outcome && outcome.outcome_summary, '') || outcomeSummaryForKey(outcomeKey),
            outcome_completed_at: retailTextValue(outcome && outcome.completed_at, ''),
            outcome_recorded_by_name: retailTextValue(outcome && outcome.recorded_by_name, ''),
            outcome_metadata: outcome && outcome.metadata ? outcome.metadata : {},
            outcome_auto_detected: !!(outcome && outcome.metadata && outcome.metadata.auto_detected_from_future_booking === true),
            outcome_last_event_at: retailTextValue(lastOutcomeEvent && lastOutcomeEvent.completed_at, ''),
            outcome_last_event_by_name: retailTextValue(lastOutcomeEvent && lastOutcomeEvent.recorded_by_name, '')
          });
        });
      }

      function mergePriorityRowsByOpportunityKey(baseRows, extraRows){
        var rowMap = {};
        retailArray(baseRows).forEach(function(row){
          var key = retailTextValue(row && row.opportunity_key, '') || buildPriorityOpportunityKey(row);
          if (!key) return;
          rowMap[key] = Object.assign({}, row, { opportunity_key: key });
        });
        retailArray(extraRows).forEach(function(row){
          var key = retailTextValue(row && row.opportunity_key, '') || buildPriorityOpportunityKey(row);
          if (!key) return;
          rowMap[key] = Object.assign({}, rowMap[key] || {}, row, { opportunity_key: key });
        });
        return Object.keys(rowMap).map(function(key){
          return rowMap[key];
        });
      }

      function applyUpdatedBusinessDevelopmentTaskToQueue(updatedTask){
        if (!updatedTask || typeof updatedTask !== 'object') return;
        dueQueueRows = mergeTaskStateOntoRows(dueQueueRows, [updatedTask]);
        dueQueueTotalRows = Number((dueQueueSummary && (dueQueueSummary.total_snapshot_rows || dueQueueSummary.filtered_total_rows)) || 0) || dueQueueRows.length;
        renderDueQueue();
      }

      function applyUpdatedBusinessDevelopmentTaskToBdFast(updatedTask){
        if (!updatedTask || typeof updatedTask !== 'object') return;
        bdFastAllRows = mergeTaskStateOntoRows(bdFastAllRows, [updatedTask]);
        renderBdFastQueue();
      }

      function currentDueQueueManagerName(){
        return retailTextValue(
          (currentProgressionEditor && currentProgressionEditor.staff_name)
            || (currentStaffOpsPermission && currentStaffOpsPermission.staff_name)
            || (currentStaffOpsPermission && currentStaffOpsPermission.name),
          ''
        );
      }

      function currentDueQueueManagerStaffIds(){
        var ids = [
          currentStaffOpsPermission && currentStaffOpsPermission.boulevard_staff_id,
          currentStaffOpsPermission && currentStaffOpsPermission.staff_id,
          currentProgressionEditor && currentProgressionEditor.staff_id
        ].map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        return ids.filter(function(value, index, array){
          return array.indexOf(value) === index;
        });
      }

      function dueRowAssignedManagerName(row){
        return retailTextValue(
          row && (
            row.manager_task_assigned_name
            || row.assigned_manager_name
            || row.manager_task_owner_name
          ),
          ''
        );
      }

      function hydrateClaimedBusinessDevelopmentTask(task, taskStatus){
        var safeTask = task && typeof task === 'object' ? Object.assign({}, task) : {};
        var normalizedStatus = String(taskStatus || retailTextValue(safeTask && safeTask.task_status, '')).trim().toLowerCase();
        if (normalizedStatus !== 'assigned' && normalizedStatus !== 'working') {
          return safeTask;
        }
        var assignedStaffId = retailTextValue(safeTask && safeTask.assigned_manager_staff_id, '') || currentDueQueueManagerStaffId();
        var assignedName = retailTextValue(safeTask && safeTask.assigned_manager_name, '') || currentDueQueueManagerName();
        if (assignedStaffId) safeTask.assigned_manager_staff_id = assignedStaffId;
        if (assignedName) safeTask.assigned_manager_name = assignedName;
        if (!retailTextValue(safeTask && safeTask.task_status, '') && normalizedStatus) {
          safeTask.task_status = normalizedStatus;
        }
        return safeTask;
      }

      var dueLocalClaimedRowsByKey = {};

      function syncLocalClaimedRowFromTask(row, task){
        var opportunityKey = retailTextValue(row && row.opportunity_key, '') || retailTextValue(task && task.opportunity_key, '');
        if (!opportunityKey) return;
        var mergedRows = mergeTaskStateOntoRows([row], [task]);
        var mergedRow = mergedRows.length ? mergedRows[0] : row;
        if (dueRowAssignedToCurrentManager(mergedRow) && !dueRowIsCompleted(mergedRow)) {
          dueLocalClaimedRowsByKey[opportunityKey] = mergedRow;
          return;
        }
        delete dueLocalClaimedRowsByKey[opportunityKey];
      }

      function mergeLocalClaimedRows(rows){
        var baseRows = retailArray(rows);
        var rowMap = {};
        baseRows.forEach(function(row){
          var key = retailTextValue(row && row.opportunity_key, '');
          if (key) rowMap[key] = row;
        });
        Object.keys(dueLocalClaimedRowsByKey).forEach(function(key){
          var localRow = dueLocalClaimedRowsByKey[key];
          if (!localRow || !dueRowAssignedToCurrentManager(localRow) || dueRowIsCompleted(localRow)) {
            delete dueLocalClaimedRowsByKey[key];
            return;
          }
          if (!rowMap[key]) {
            rowMap[key] = localRow;
          }
        });
        return Object.keys(rowMap).map(function(key){ return rowMap[key]; });
      }

      function applyUpdatedBusinessDevelopmentOutcomeToQueue(updatedOutcome){
        if (!updatedOutcome || typeof updatedOutcome !== 'object') return;
        dueQueueRows = mergeOutcomeStateOntoRows(dueQueueRows, [updatedOutcome]);
        dueQueueTotalRows = Number((dueQueueSummary && (dueQueueSummary.total_snapshot_rows || dueQueueSummary.filtered_total_rows)) || 0) || dueQueueRows.length;
        renderDueQueue();
      }

      function currentDueQueueManagerStaffId(){
        var ids = currentDueQueueManagerStaffIds();
        return ids.length ? ids[0] : '';
      }

      function unifiedQueueFiltersActive(){
        var dueFilterConfig = getDueQueueFilterConfig();
        return !!(
          dueQueueOpportunityFilter !== 'all' ||
          dueQueueWorkflowFilter !== 'all' ||
          dueQueueOwnerFilter !== 'all' ||
          dueQueueActiveStage !== 'all' ||
          dueFilterConfig.category ||
          dueFilterConfig.duplicateOnly === true ||
          dueQueueActiveClientType !== 'all' ||
          String((dueStaffFilter && dueStaffFilter.value) || '').trim() ||
          String((dueSearchFilter && dueSearchFilter.value) || '').trim() ||
          String((dueCadenceSourceFilter && dueCadenceSourceFilter.value) || '').trim() ||
          !!(dueHasPhoneOnly && dueHasPhoneOnly.checked) ||
          !!(dueHasEmailOnly && dueHasEmailOnly.checked)
        );
      }

      function currentDueGuestSearchTerm(){
        return String((dueSearchFilter && dueSearchFilter.value) || '').trim();
      }

      function rowMatchesDueGuestSearch(row, searchTerm){
        var needle = String(searchTerm || '').trim().toLowerCase();
        if (!needle) return true;
        var guestName = retailTextValue(row && (row.guest_name || row.client_name), '').toLowerCase();
        return guestName.indexOf(needle) !== -1;
      }

      function shouldUseUnifiedBusinessPriorityQueue(){
        return true;
      }

      function opportunitySourceMatchesFilter(row){
        var filter = String(dueQueueOpportunityFilter || 'all').trim() || 'all';
        var source = String((row && row.queue_source) || 'appointment').trim();
        var businessCategory = retailTextValue(row && row.business_category, '').toLowerCase();
        if (filter === 'all') return true;
        if (filter === 'appointment_growth') {
          return source === 'appointment' || businessCategory === 'appointment_growth';
        }
        if (filter === 'retail_opportunity') {
          return source === 'retail' || businessCategory === 'retail_opportunity';
        }
        if (filter === 'review_opportunity') {
          return source === 'review' || businessCategory === 'review_opportunity';
        }
        if (filter === 'referral_opportunity') {
          return source === 'referral' || businessCategory === 'referral_opportunity';
        }
        return true;
      }

      function unifiedStageMatchesActiveFilter(row){
        var activeStage = String(dueQueueActiveStage || 'all').trim().toLowerCase();
        if (!activeStage || activeStage === 'all') return true;
        var stage = retailTextValue(row && row.queue_stage, '').toLowerCase();
        if (activeStage === 'current_needs_prebooking') {
          return stage === 'current_needs_prebooking' || stage === 'needs_prebooking';
        }
        if (activeStage === 'non_current_recapture') {
          return stage === 'non_current_recapture' || stage === 'recapture';
        }
        return stage === activeStage;
      }

      function unifiedRowMatchesSharedFilters(row){
        var dueFilterConfig = getDueQueueFilterConfig();
        var categoryFilter = String(dueFilterConfig.category || '').trim().toLowerCase();
        if (categoryFilter) {
          var primaryCategory = retailTextValue(row && (row.primary_category || row.latest_primary_service_family || row.service_category), '').toLowerCase();
          if (primaryCategory !== categoryFilter) return false;
        }
        if (dueFilterConfig.duplicateOnly === true) {
          var duplicateFlag = !!(row && (row.duplicate_account_flag === true || row.has_duplicate_accounts === true));
          var duplicateCount = Number((row && row.duplicate_account_count) || 0) || 0;
          if (!duplicateFlag && duplicateCount <= 0) return false;
        }
        if (dueQueueActiveClientType !== 'all') {
          var historyKey = dueHistoryRatingKey(retailTextValue(row && row.history_rating, ''));
          if (historyKey !== String(dueQueueActiveClientType || '').trim().toLowerCase()) return false;
        }
        var cadenceFilter = String((dueCadenceSourceFilter && dueCadenceSourceFilter.value) || '').trim().toLowerCase();
        if (cadenceFilter) {
          var cadenceSource = retailTextValue(row && row.cadence_source, '').toLowerCase();
          if (cadenceSource !== cadenceFilter) return false;
        }
        if (dueHasPhoneOnly && dueHasPhoneOnly.checked) {
          if (!retailTextValue(row && (row.client_phone || row.normalized_phone), '')) return false;
        }
        if (dueHasEmailOnly && dueHasEmailOnly.checked) {
          if (!retailTextValue(row && row.client_email, '')) return false;
        }
        var guestSearch = currentDueGuestSearchTerm();
        if (guestSearch) {
          if (!rowMatchesDueGuestSearch(row, guestSearch)) return false;
        }
        var staffSearch = String((dueStaffFilter && dueStaffFilter.value) || '').trim().toLowerCase();
        if (staffSearch) {
          var staffNames = retailArray(row && row.staff_names).join(' ').toLowerCase();
          var primaryStaff = retailTextValue(row && row.primary_staff_name, '').toLowerCase();
          if (staffNames.indexOf(staffSearch) === -1 && primaryStaff.indexOf(staffSearch) === -1) return false;
        }
        return true;
      }

      function currentDueWorkspaceLabel(){
        var workspace = String(dueQueueWorkspace || 'all').trim() || 'all';
        if (workspace === 'appointments') return 'appointment';
        if (workspace === 'prebook') return 'prebook';
        if (workspace === 'active_drift') return 'active drift';
        if (workspace === 'long_lost') return 'long-lost';
        if (workspace === 'retail') return 'retail';
        if (workspace === 'referral') return 'referral';
        if (workspace === 'review') return 'review';
        return 'business development';
      }

      function currentDueWorkflowLabel(){
        var workflow = String(dueQueueWorkflowFilter || 'all').trim() || 'all';
        if (workflow === 'all') return 'all';
        if (workflow === 'needs_action') return 'needs action';
        if (workflow === 'mine') return 'my follow-up';
        if (workflow === 'waiting') return 'waiting';
        if (workflow === 'completed') return 'recently completed';
        return 'recommended';
      }

      function dueRowPriorityScore(row){
        return Number((row && (row.business_priority_score || row.priority_score)) || 0) || 0;
      }

      function dueRowHasOutcome(row){
        return !!retailTextValue(row && row.outcome_state_key, '');
      }

      function dueRowOutcomeKey(row){
        return retailTextValue(row && row.outcome_state_key, '').toLowerCase();
      }

      function dueRowTaskStatus(row){
        return retailTextValue(row && row.manager_task_status, '').toLowerCase();
      }

      function dueRowPositiveOutcome(row){
        var outcomeKey = dueRowOutcomeKey(row);
        return outcomeKey === 'appointment_booked'
          || outcomeKey === 'retail_purchased'
          || outcomeKey === 'referral_booked'
          || outcomeKey === 'review_completed';
      }

      function dueRowOutcomeCompletedAt(row){
        return retailTextValue(row && row.outcome_completed_at, '');
      }

      function dueRowTaskFollowupAt(row){
        return retailTextValue(row && row.manager_task_next_followup_at, '');
      }

      function dueRowTaskCompletedAt(row){
        return retailTextValue(row && row.manager_task_completed_at, '');
      }

      function dueRowTaskTouchedAt(row){
        return retailTextValue(row && row.manager_task_last_event_at, '')
          || dueRowTaskCompletedAt(row)
          || dueRowTaskFollowupAt(row);
      }

      function dueRowDateIsFuture(value){
        var iso = retailTextValue(value, '');
        if (!iso) return false;
        var date = new Date(iso);
        if (!isFinite(date.getTime())) return false;
        return date.getTime() > Date.now();
      }

      function dueRowDateIsRecent(value, days){
        var iso = retailTextValue(value, '');
        if (!iso) return false;
        var date = new Date(iso);
        if (!isFinite(date.getTime())) return false;
        return (Date.now() - date.getTime()) <= ((Number(days || 0) || 0) * 24 * 60 * 60 * 1000);
      }

      function dueRowAssignedToCurrentManager(row){
        var assignedStaffId = retailTextValue(row && row.manager_task_assigned_staff_id, '');
        var managerStaffIds = currentDueQueueManagerStaffIds();
        if (assignedStaffId && managerStaffIds.indexOf(assignedStaffId) !== -1) {
          return true;
        }
        var assignedName = dueRowAssignedManagerName(row).toLowerCase();
        var managerName = currentDueQueueManagerName().toLowerCase();
        return !!assignedName && !!managerName && assignedName === managerName;
      }

      function dueRowRecentlyContacted(row){
        var outreach = row && row.outreach && typeof row.outreach === 'object' ? row.outreach : null;
        var lastContactedAt = retailTextValue(outreach && outreach.last_contacted_at, '');
        return dueRowDateIsRecent(lastContactedAt, 14);
      }

      function dueRowHasRecentNoResponse(row){
        return dueRowOutcomeKey(row) === 'no_response' && dueRowDateIsRecent(dueRowOutcomeCompletedAt(row), 14);
      }

      function dueRowIsCompleted(row){
        if (dueRowPositiveOutcome(row)) return true;
        if (dueRowOutcomeKey(row) === 'no_response') return false;
        return !dueRowTaskFollowupAt(row) && dueRowTaskStatus(row) === 'completed';
      }

      function dueRowIsWaiting(row){
        var taskStatus = dueRowTaskStatus(row);
        if (taskStatus === 'snoozed') return true;
        if (dueRowDateIsFuture(dueRowTaskFollowupAt(row))) return true;
        if (dueRowHasRecentNoResponse(row)) return true;
        if (taskStatus === 'completed' && dueRowDateIsRecent(dueRowTaskCompletedAt(row), 14) && !dueRowIsCompleted(row)) return true;
        if (dueRowDateIsRecent(dueRowTaskTouchedAt(row), 7) && !dueRowIsCompleted(row)) return true;
        return !dueRowIsCompleted(row) && dueRowRecentlyContacted(row);
      }

      function dueRowIsInProgress(row){
        var taskStatus = dueRowTaskStatus(row);
        return taskStatus === 'assigned' || taskStatus === 'working';
      }

      function dueRowNeedsAction(row){
        return !dueRowIsCompleted(row) && !dueRowIsWaiting(row) && !dueRowIsInProgress(row);
      }

      function dueRowIsRecommended(row){
        if (!dueRowNeedsAction(row)) return false;
        var score = dueRowPriorityScore(row);
        var source = retailTextValue(row && row.queue_source, 'appointment').toLowerCase();
        if (source !== 'appointment') return score >= 58;
        var stage = retailTextValue(row && row.queue_stage, '').toLowerCase();
        if (stage === 'non_current_recapture') return score >= 65;
        return score >= 72;
      }

      function dueRowWorkflowBucket(row){
        if (dueRowIsCompleted(row)) return 'completed';
        if (dueRowAssignedToCurrentManager(row)) return 'mine';
        if (dueRowIsWaiting(row) || dueRowIsInProgress(row)) return 'waiting';
        if (dueRowIsRecommended(row)) return 'recommended';
        return 'needs_action';
      }

      function workflowStateMatchesFilter(row){
        var filter = String(dueQueueWorkflowFilter || 'all').trim() || 'all';
        if (filter === 'all') return true;
        return dueRowWorkflowBucket(row) === filter;
      }

      function ownerStateMatchesFilter(row){
        var filter = String(dueQueueOwnerFilter || 'all').trim() || 'all';
        if (filter === 'all') return true;
        var assignedStaffId = retailTextValue(row && row.manager_task_assigned_staff_id, '');
        if (filter === 'unassigned') {
          return !assignedStaffId && !dueRowAssignedManagerName(row);
        }
        if (filter === 'mine') {
          return dueRowAssignedToCurrentManager(row);
        }
        return true;
      }

      function unifiedPriorityOpportunitySort(left, right){
        var rightScore = Number((right && (right.business_priority_score || right.priority_score)) || 0) || 0;
        var leftScore = Number((left && (left.business_priority_score || left.priority_score)) || 0) || 0;
        if (rightScore !== leftScore) return rightScore - leftScore;
        var leftDate = retailTextValue(left && (left.last_in_date || left.expected_due_date || (left.retail_row && left.retail_row.appointment_datetime)), '');
        var rightDate = retailTextValue(right && (right.last_in_date || right.expected_due_date || (right.retail_row && right.retail_row.appointment_datetime)), '');
        if (leftDate && rightDate) return rightDate.localeCompare(leftDate);
        return retailTextValue(left && left.guest_name, '').localeCompare(retailTextValue(right && right.guest_name, ''));
      }

      function dueSortQueueRowsLocally(rows){
        var safeRows = retailArray(rows).slice();
        function rowDateTime(row, keys){
          var value = '';
          retailArray(keys).some(function(key){
            value = bdFirstText(row, [key], '');
            return !!value;
          });
          var date = new Date(value);
          return Number.isFinite(date.getTime()) ? date.getTime() : 0;
        }
        function rowOverdue(row){
          return Math.max(
            bdNumber(row && row.max_days_overdue, 0),
            bdNumber(row && row.days_overdue, 0),
            bdNumber(row && row.days_past_due, 0)
          );
        }
        function rowUntilDue(row){
          var direct = Number(row && row.days_until_due);
          if (Number.isFinite(direct)) return direct;
          return 999999;
        }
        if (dueQueueSortMode === 'due_soonest') {
          return safeRows.sort(function(left, right){
            var dueDelta = rowUntilDue(left) - rowUntilDue(right);
            return dueDelta || unifiedPriorityOpportunitySort(left, right);
          });
        }
        if (dueQueueSortMode === 'most_overdue') {
          return safeRows.sort(function(left, right){
            var overdueDelta = rowOverdue(right) - rowOverdue(left);
            return overdueDelta || unifiedPriorityOpportunitySort(left, right);
          });
        }
        if (dueQueueSortMode === 'last_visit_newest') {
          return safeRows.sort(function(left, right){
            return rowDateTime(right, ['last_appointment_date', 'last_in_at', 'last_in_date', 'last_visit_at']) - rowDateTime(left, ['last_appointment_date', 'last_in_at', 'last_in_date', 'last_visit_at']);
          });
        }
        if (dueQueueSortMode === 'last_visit_oldest') {
          return safeRows.sort(function(left, right){
            return rowDateTime(left, ['last_appointment_date', 'last_in_at', 'last_in_date', 'last_visit_at']) - rowDateTime(right, ['last_appointment_date', 'last_in_at', 'last_in_date', 'last_visit_at']);
          });
        }
        if (dueQueueSortMode === 'highest_appointment_count') {
          return safeRows.sort(function(left, right){
            return bdVisitCount(right) - bdVisitCount(left) || unifiedPriorityOpportunitySort(left, right);
          });
        }
        if (dueQueueSortMode === 'guest_name') {
          return safeRows.sort(function(left, right){
            return bdClientName(left).toLowerCase().localeCompare(bdClientName(right).toLowerCase());
          });
        }
        if (dueQueueSortMode === 'primary_staff') {
          return safeRows.sort(function(left, right){
            var leftStaff = bdFirstText(left, ['primary_staff_name'], '').toLowerCase();
            var rightStaff = bdFirstText(right, ['primary_staff_name'], '').toLowerCase();
            return leftStaff.localeCompare(rightStaff) || unifiedPriorityOpportunitySort(left, right);
          });
        }
        if (dueQueueSortMode === 'category') {
          return safeRows.sort(function(left, right){
            return bdBucketLabel(left).localeCompare(bdBucketLabel(right)) || unifiedPriorityOpportunitySort(left, right);
          });
        }
        return safeRows.sort(unifiedPriorityOpportunitySort);
      }

      function bdNestedValue(source, path){
        if (!source || typeof source !== 'object') return null;
        var parts = String(path || '').split('.').filter(Boolean);
        var current = source;
        for (var index = 0; index < parts.length; index += 1) {
          if (!current || typeof current !== 'object') return null;
          current = current[parts[index]];
        }
        return current;
      }

      function bdCleanText(value, fallback){
        var text = retailTextValue(value, '').trim();
        if (!text || /^(nan|nan0|null|undefined|invalid date)$/i.test(text)) {
          return fallback != null ? retailTextValue(fallback, '') : '';
        }
        return text;
      }

      function bdFirstText(row, keys, fallback){
        var safeKeys = retailArray(keys);
        for (var index = 0; index < safeKeys.length; index += 1) {
          var key = String(safeKeys[index] || '').trim();
          if (!key) continue;
          var value = key.indexOf('.') !== -1 ? bdNestedValue(row, key) : (row && row[key]);
          var text = bdCleanText(value, '');
          if (text) return text;
        }
        return fallback != null ? bdCleanText(fallback, '') : '';
      }

      function bdNumber(value, fallback){
        var number = Number(value);
        return Number.isFinite(number) ? number : (Number.isFinite(Number(fallback)) ? Number(fallback) : 0);
      }

      function bdDateText(value){
        var raw = bdCleanText(value, '');
        if (!raw) return '';
        var date = new Date(raw);
        if (!Number.isFinite(date.getTime())) return raw;
        try {
          return new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          }).format(date);
        } catch (_error) {
          return formatRecaptureDate(raw);
        }
      }

      function bdArrayValue(value){
        if (Array.isArray(value)) return value;
        if (value && typeof value === 'object') return [value];
        return retailArray(value);
      }

      function bdOpportunityKey(row){
        return bdFirstText(row, ['opportunity_key'], '') || buildPriorityOpportunityKey(row);
      }

      function bdBucketKey(row){
        var unifiedAppointmentStatus = dueRowUnifiedAppointmentStatusKey(row);
        if (unifiedAppointmentStatus) return unifiedAppointmentStatus;
        var direct = dueRowBusinessBucketKey(row);
        if (direct) return direct;
        return bdFirstText(row, ['queue_source'], 'appointment');
      }

      function bdBucketLabel(row){
        var key = bdBucketKey(row);
        var labels = {
          never_visited: 'Never Visited',
          needs_prebook: 'Needs Prebook',
          needs_attention: 'Needs Attention',
          needs_recovery: 'Needs Recovery',
          no_pattern: 'No Pattern',
          watch_due_soon: 'Watch - Due Soon',
          watch_due_now: 'Watch - Due Now',
          at_risk_cadence_break: 'Cadence Break',
          at_risk_canceled_unbooked: 'Canceled + Unbooked',
          at_risk_no_show_unbooked: 'No-show + Unbooked',
          at_risk_declining_frequency: 'Declining Frequency',
          at_risk_partial_return: 'Partial Return',
          lost_likely_lapsed: 'Long-lost',
          retail: 'Retail Follow-up',
          referral: 'Referral',
          review: 'Review',
          appointment: 'Appointment'
        };
        return labels[key] || key.replace(/_/g, ' ').replace(/\b\w/g, function(letter){
          return letter.toUpperCase();
        });
      }

      function bdClientName(row){
        return bdFirstText(row, [
          'guest_name',
          'client_name',
          'client.full_name',
          'client.name',
          'retail_row.client_name',
          'review_row.client_name',
          'referral_row.client_name'
        ], 'Unknown guest');
      }

      function bdVisitCount(row){
        return bdNumber(bdFirstText(row, [
          'appointment_count',
          'visit_count',
          'total_completed_visits',
          'retail_row.total_completed_visits',
          'review_row.total_completed_visits',
          'referral_row.total_completed_visits'
        ], ''), 0);
      }

      function bdLastVisitAt(row){
        return bdFirstText(row, [
          'last_appointment_date',
          'last_in_at',
          'last_in_date',
          'last_visit_at',
          'retail_row.appointment_datetime',
          'review_row.appointment_datetime',
          'referral_row.appointment_datetime'
        ], '');
      }

      function bdLastService(row){
        return bdFirstText(row, [
          'last_service_name',
          'latest_primary_service_name',
          'focus_service_name',
          'service_name',
          'primary_label',
          'service_category',
          'retail_row.service_name',
          'review_row.service_name',
          'referral_row.service_name'
        ], '');
      }

      function bdFutureBookingText(row){
        var futureAt = bdFirstText(row, ['future_appointment_at', 'futureAppointmentAt'], '');
        if (!futureAt) return 'No future booking';
        var services = bdArrayValue(row && row.future_appointment_services).map(function(value){
          return bdCleanText(value && (value.name || value.service_name || value), '');
        }).filter(Boolean);
        return bdDateText(futureAt) + (services.length ? ' - ' + services.slice(0, 2).join(', ') : '');
      }

      function bdPatternItems(row){
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        var guestSignals = debug.guest_signals && typeof debug.guest_signals === 'object' ? debug.guest_signals : {};
        return bdArrayValue(row && row.pattern_items)
          .concat(bdArrayValue(row && row.patterns))
          .concat(bdArrayValue(guestSignals && guestSignals.pattern_items))
          .concat(bdArrayValue(debug && debug.due_items))
          .filter(function(item){
            return item && typeof item === 'object';
          });
      }

      function bdFocusPattern(row, patterns){
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        var focus = debug.focus_pattern_item && typeof debug.focus_pattern_item === 'object' ? debug.focus_pattern_item : null;
        if (focus) return focus;
        return dueFocusPatternItem(patterns) || dueDisplayPatternItems(patterns, null)[0] || null;
      }

      function bdCadenceText(row, focus){
        var days = duePatternCadenceDays(focus) || bdNumber(row && row.cadence_days, 0);
        return days > 0 ? dueCadenceFriendlyText(days) : '';
      }

      function bdHistoryCadenceText(row, focus){
        var safeRow = row && typeof row === 'object' ? row : {};
        var safeFocus = focus && typeof focus === 'object' ? focus : {};
        var source = retailTextValue(safeFocus.cadence_source, '').toLowerCase() || retailTextValue(safeRow.cadence_source, '').toLowerCase();
        var sampleSize = Math.max(
          0,
          Number(safeFocus.cadence_sample_size || 0) || 0,
          Number(safeRow.cadence_sample_size || 0) || 0
        );
        if (source !== 'personalized' || sampleSize < 3) return '';
        return bdCadenceText(safeRow, safeFocus);
      }

      function bdDisruptionSummary(row){
        var cancels = bdNumber(row && (row.canceled_after_last_visit_count || row.cancelled_after_last_visit_count || row.post_last_visit_canceled_count || row.post_last_visit_cancelled_count), 0);
        var noShows = bdNumber(row && (row.no_show_after_last_visit_count || row.no_shows_after_last_visit_count || row.post_last_visit_no_show_count || row.post_last_visit_no_shows_count), 0);
        cancels = Math.max(cancels, bdArrayValue(row && (row.canceled_appointments_after_last_visit || row.cancelled_appointments_after_last_visit || row.post_last_visit_cancellations)).length);
        noShows = Math.max(noShows, bdArrayValue(row && (row.no_show_appointments_after_last_visit || row.no_shows_after_last_visit || row.post_last_visit_no_shows)).length);
        var missedPrebook = bdNumber(row && (row.missed_prebook_count || row.missed_prebook_behavior_count), 0);
        var declining = bdCleanText(row && (row.declining_interval_summary || row.declining_frequency_summary), '');
        return {
          cancels: cancels,
          noShows: noShows,
          missedPrebook: missedPrebook,
          declining: declining
        };
      }

      function bdSituationText(row, focus){
        var bucket = bdBucketKey(row);
        var source = bdCleanText(row && row.queue_source, '');
        var lastVisit = bdDateText(bdLastVisitAt(row));
        var lastService = bdLastService(row);
        var cadence = bdCadenceText(row, focus);
        var future = bdFutureBookingText(row);
        if (source === 'retail' || bucket === 'retail') {
          return 'Recommended home care was captured, but the purchase is still missing.';
        }
        if (source === 'review' || bucket === 'review') {
          return 'Recent visit is ready for a review follow-up.';
        }
        if (source === 'referral' || bucket === 'referral') {
          return 'Strong guest relationship is ready for a referral ask.';
        }
        if (bucket === 'never_visited') return 'No completed visit yet, no future booking, and no visit history to calculate a pattern from.';
        if (bucket === 'needs_prebook') return 'Known personalized cadence, not overdue yet, and still missing the next booking.';
        if (bucket === 'needs_attention') return 'Known personalized cadence and now overdue without a future booking.';
        if (bucket === 'needs_recovery') return 'More than 45 days overdue against a known personalized cadence with no future booking.';
        if (bucket === 'no_pattern') return 'No future booking, but there is not enough trusted personalized cadence yet to place this guest in a due lane.';
        if (bucket === 'at_risk_canceled_unbooked') return 'Canceled after the last completed visit and no replacement booking is linked.';
        if (bucket === 'at_risk_no_show_unbooked') return 'Missed a recent appointment and has no future booking.';
        if (bucket === 'at_risk_partial_return') return 'Some services may be booked, but a recurring routine still looks missing.';
        if (bucket === 'at_risk_declining_frequency') return 'Recent visits are stretching beyond this guest’s usual rhythm.';
        if (bucket === 'new_guest_no_prebook') return 'First-time guest completed visit one within the last 14 days.';
        if (bucket === 'watch_due_soon') return 'Approaching the expected return window with no future booking.';
        if (bucket === 'watch_due_now') return 'At the expected return window with no future booking.';
        if (bucket === 'lost_likely_lapsed') return 'Far beyond the usual rhythm with no future booking.';
        var pieces = [];
        if (lastVisit) pieces.push('Last visit ' + lastVisit);
        if (lastService) pieces.push('for ' + lastService);
        if (cadence) pieces.push('usual rhythm ' + cadence.toLowerCase());
        if (future) pieces.push(future);
        return pieces.length ? pieces.join(' - ') + '.' : 'Review the durable facts before taking action.';
      }

      function bdBucketTone(row){
        var bucket = bdBucketKey(row);
        if (bucket === 'never_visited' || bucket === 'needs_prebook') return 'watch';
        if (bucket === 'needs_attention') return 'risk';
        if (bucket === 'needs_recovery') return 'lost';
        if (bucket === 'no_pattern') return 'neutral';
        if (/retail|referral|review/.test(bucket)) return 'growth';
        if (/watch/.test(bucket)) return 'watch';
        if (/lost|lapsed/.test(bucket)) return 'lost';
        if (/risk|canceled|no_show|declining|partial/.test(bucket)) return 'risk';
        return 'neutral';
      }

      function bdExpectedDueText(row, focus){
        var dueAt = bdFirstText(row, ['expected_due_date'], '') || bdCleanText(focus && focus.due_at, '');
        return bdDateText(dueAt);
      }

      function bdLiveTimingText(row, focus){
        var future = bdFirstText(row, ['future_appointment_at'], '');
        if (future) return 'Future booked ' + bdDateText(future);
        var daysUntilDue = Number(focus && focus.days_overdue) < 0
          ? Math.abs(Number(focus && focus.days_overdue) || 0)
          : Number(row && row.days_until_due);
        if (Number.isFinite(daysUntilDue) && daysUntilDue > 0) return 'Due in ' + Math.round(daysUntilDue) + 'd';
        var overdue = Math.max(
          0,
          Number(focus && focus.days_overdue) || 0,
          Number(row && row.days_overdue) || 0,
          Number(row && row.max_days_overdue) || 0
        );
        if (overdue > 0) return Math.round(overdue) + 'd overdue';
        var daysSince = Math.max(
          0,
          Number(focus && focus.days_since_last_visit) || 0,
          Number(row && row.days_since_last_visit) || 0
        );
        if (daysSince <= 14) return 'Visited ' + Math.round(daysSince) + 'd ago';
        return 'Monitor timing';
      }

      function bdSignalText(row, focus){
        var bucket = bdBucketKey(row);
        var rhythm = bdCadenceText(row, focus);
        var expected = bdExpectedDueText(row, focus);
        var last = bdDateText(bdLastVisitAt(row));
        var service = bdLastService(row);
        if (bucket === 'retail' || bdCleanText(row && row.queue_source, '') === 'retail') {
          return 'Home-care recommendation is captured, but the retail purchase is still open.';
        }
        if (bucket === 'at_risk_canceled_unbooked') {
          return row && row.has_post_visit_cancel
            ? 'Canceled after the last completed visit and no replacement is booked.'
            : 'Cancellation history exists, but no post-visit cancellation is marked in the durable facts.';
        }
        if (bucket === 'at_risk_no_show_unbooked') {
          return row && row.has_post_visit_no_show
            ? 'No-show after the last completed visit and no future appointment is booked.'
            : 'No-show history exists, but no post-visit no-show is marked in the durable facts.';
        }
        if (bucket === 'at_risk_declining_frequency') return 'The latest interval is stretching compared with the guest’s historical rhythm.';
        if (bucket === 'at_risk_partial_return') return 'A future visit exists, but at least one recurring routine still appears uncovered.';
        if (bucket === 'new_guest_no_prebook') return bdFastHasFutureBooking(row)
          ? 'First-time guest completed visit one within the last 14 days and already has visit two booked.'
          : 'First-time guest completed visit one within the last 14 days and still needs visit two booked.';
        if (bucket === 'watch_due_soon') return 'Not overdue yet, but close enough to prep a prebook nudge.';
        if (bucket === 'watch_due_now') return 'At the expected return window with no future booking attached.';
        if (bucket === 'lost_likely_lapsed') return 'Well outside the usual rhythm with no future appointment attached.';
        var parts = [];
        if (service) parts.push(service);
        if (last) parts.push('last ' + last);
        if (rhythm) parts.push('usually ' + rhythm.toLowerCase());
        if (expected) parts.push('expected ' + expected);
        return parts.length ? parts.join(' - ') : bdSituationText(row, focus);
      }

      function bdCompactFactMarkup(label, value, tone){
        var text = bdCleanText(value, '');
        if (!text) return '';
        return '<div class="bd-compactFact' + (tone ? ' bd-compactFact--' + escapeHtml(tone) : '') + '"><span>' + escapeHtml(label) + '</span><strong>' + escapeHtml(text) + '</strong></div>';
      }

      function bdFactMarkup(label, value){
        var text = bdCleanText(value, '');
        if (!text) return '';
        return '<div class="bd-fact"><span>' + escapeHtml(label) + '</span><strong>' + escapeHtml(text) + '</strong></div>';
      }

      function bdFactGridMarkup(row, focus){
        var disruption = bdDisruptionSummary(row);
        var facts = [];
        facts.push(bdFactMarkup('Last visit', bdDateText(bdLastVisitAt(row))));
        facts.push(bdFactMarkup('Last service', bdLastService(row)));
        facts.push(bdFactMarkup('Normal rhythm', bdCadenceText(row, focus)));
        facts.push(bdFactMarkup('Future booking', bdFutureBookingText(row)));
        if (disruption.cancels > 0) facts.push(bdFactMarkup('Cancels after last visit', String(disruption.cancels)));
        if (disruption.noShows > 0) facts.push(bdFactMarkup('No-shows after last visit', String(disruption.noShows)));
        var duplicates = bdNumber(row && row.duplicate_account_count, 0);
        if (duplicates > 1) facts.push(bdFactMarkup('Duplicate accounts', String(duplicates)));
        return '<div class="bd-factGrid">' + facts.filter(Boolean).join('') + '</div>';
      }

      function bdContactLine(row){
        var phone = bdFirstText(row, ['client_phone', 'phone', 'retail_row.client_phone', 'review_row.client_phone', 'referral_row.client_phone'], '');
        var email = bdFirstText(row, ['client_email', 'email', 'retail_row.client_email', 'review_row.client_email', 'referral_row.client_email'], '');
        return [phone, email].filter(Boolean).join(' - ');
      }

      function bdDetailsMarkup(row, patterns){
        var staffNames = bdArrayValue(row && row.staff_names).map(function(value){
          return bdCleanText(value && (value.name || value.staff_name || value), '');
        }).filter(Boolean);
        var duplicates = bdArrayValue(row && row.duplicate_client_names).map(function(value){
          return bdCleanText(value && (value.name || value.client_name || value), '');
        }).filter(Boolean);
        var futureServices = bdArrayValue(row && row.future_appointment_services).map(function(value){
          return bdCleanText(value && (value.name || value.service_name || value), '');
        }).filter(Boolean);
        var patternSummary = dueDisplayPatternItems(patterns, null).slice(0, 8).map(function(item){
          var label = bdCleanText(item && item.label, 'Routine');
          var last = bdDateText(item && item.last_visit_at);
          var cadence = bdHistoryCadenceText(row, item);
          return label + (cadence ? ' - ' + cadence : '') + (last ? ' - last ' + last : '');
        });
        var lines = [
          bdFactMarkup('Contact', bdContactLine(row)),
          bdFactMarkup('Guest key', bdFirstText(row, ['guest_bucket_key', 'normalized_phone', 'dedupe_key'], '')),
          bdFactMarkup('Client id', bdFirstText(row, ['primary_client_id', 'client_id'], '')),
          bdFactMarkup('Staff relationship', staffNames.slice(0, 4).join(', ') || bdFirstText(row, ['primary_staff_name'], '')),
          bdFactMarkup('Location', bdFirstText(row, ['latest_location_name'], '')),
          bdFactMarkup('Future services', futureServices.slice(0, 4).join(', ')),
          bdFactMarkup('Duplicate names', duplicates.slice(0, 4).join(', ')),
          bdFactMarkup('Patterns', patternSummary.join(' | '))
        ].filter(Boolean);
        return '<div class="bd-panel bd-detailsPanel" data-due-details hidden>' + lines.join('') + '</div>';
      }

      function bdPrimaryActionMarkup(row){
        var key = bdOpportunityKey(row);
        if (!key) return '';
        if (dueNeedsClaim(row)) {
          return '<button class="bd-action bd-action--primary" type="button" data-task-action="assigned" data-opportunity-key="' + escapeHtml(key) + '">Claim</button>';
        }
        var action = duePrimaryActionMarkup(row);
        if (action) return action;
        return '<button class="bd-action bd-action--primary" type="button" data-due-toggle-details>Contact</button>';
      }

      function bdOpportunityCardMarkup(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var name = bdClientName(safeRow);
        var bucketLabel = bdBucketLabel(safeRow);
        var bucketTone = bdBucketTone(safeRow);
        var patterns = bdPatternItems(safeRow);
        var focus = bdFocusPattern(safeRow, patterns);
        var disruption = bdDisruptionSummary(safeRow);
        var visitCount = bdVisitCount(safeRow);
        var rhythm = bdHistoryCadenceText(safeRow, focus) ? duePatternTimelineMarkup(safeRow, focus, patterns) : '';
        var details = bdDetailsMarkup(safeRow, patterns);
        var payload = duePayloadMarkup(safeRow);
        var lastVisit = bdDateText(bdLastVisitAt(safeRow)) || 'No completed visit yet';
        var metaBits = ['Last visit ' + lastVisit];
        if (visitCount > 0) metaBits.push(String(visitCount) + ' visit' + (visitCount === 1 ? '' : 's'));
        if (disruption.cancels > 0) metaBits.push(String(disruption.cancels) + ' cancel' + (disruption.cancels === 1 ? '' : 's'));
        return ''
          + '<article class="retail-card retail-card--compact retail-card--queue bd-opportunityCard" data-due-card data-opportunity-key="' + escapeHtml(bdOpportunityKey(safeRow)) + '">'
          +   '<div class="bd-opportunityTop">'
          +     '<div class="bd-opportunityIdentity">'
          +       '<div class="queue-opportunityAvatar bd-avatar" aria-hidden="true">' + escapeHtml(dueClientInitials(name)) + '</div>'
          +       '<div class="bd-opportunityCopy">'
          +         '<div class="bd-opportunityTitleRow">'
          +           '<h3 class="bd-opportunityName">' + escapeHtml(name) + '</h3>'
          +           '<span class="bd-bucket bd-bucket--' + escapeHtml(bucketTone) + '">' + escapeHtml(bucketLabel) + '</span>'
          +         '</div>'
          +         '<div class="bd-opportunityMeta">' + escapeHtml(metaBits.join(' • ')) + '</div>'
          +       '</div>'
          +     '</div>'
          +     '<div class="bd-opportunityActions">'
          +       bdPrimaryActionMarkup(safeRow)
          +       (rhythm ? '<button class="bd-action" type="button" data-due-toggle-rhythm>Booking rhythm</button>' : '')
          +       '<button class="bd-action" type="button" data-due-toggle-details>Client details</button>'
          +       (payload ? '<button class="bd-action" type="button" data-due-toggle-payload>Payload</button>' : '')
          +     '</div>'
          +   '</div>'
          +   rhythm
          +   details
          +   payload
          + '</article>';
      }

      function priorityOpportunityCardMarkup(row){
        return bdOpportunityCardMarkup(row);
      }

      function safePriorityOpportunityCardMarkup(row){
        try {
          return priorityOpportunityCardMarkup(row)
            .replace(/NaN0/gi, '')
            .replace(/\bNaN\b/gi, '')
            .replace(/\s{2,}/g, ' ');
        } catch (error) {
          var errorMessage = retailTextValue(error && error.message, '') || retailTextValue(error, '') || 'Unknown render error';
          console.error('Could not render opportunity card: ' + errorMessage, row);
          var fallbackName = retailTextValue(row && (row.guest_name || row.client_name), 'Unknown client');
          return ''
            + '<article class="retail-card retail-card--compact retail-card--queue queue-opportunityCard queue-opportunityCard--error">'
            +   '<div class="queue-opportunityHeader">'
            +     '<div class="queue-opportunityClient">'
            +       '<div class="queue-opportunityAvatar" aria-hidden="true">' + escapeHtml(dueClientInitials(fallbackName)) + '</div>'
            +       '<div class="queue-opportunityHeaderCopy">'
            +         '<h3 class="queue-opportunityClientName">' + escapeHtml(fallbackName) + '</h3>'
            +         '<div class="queue-opportunitySubline">Render issue: ' + escapeHtml(errorMessage) + '</div>'
            +       '</div>'
            +     '</div>'
            +   '</div>'
            + '</article>';
        }
      }

      function retailPrioritySnapshotItems(row){
        var retailRow = row && row.retail_row && typeof row.retail_row === 'object' ? row.retail_row : {};
        var items = [];
        var priorityLabel = dueOpportunityPriorityLabel(row);
        var stylist = retailTextValue(row && row.primary_staff_name, '');
        var lastContacted = retailTextValue(retailRow && retailRow.last_contacted_at, '');
        var appointmentDate = retailTextValue(retailRow && retailRow.appointment_datetime, '');
        var missingCount = Number((retailRow && retailRow.missing_count) || 0) || 0;
        var inVisitPurchaseCount = Number((retailRow && retailRow.appointment_purchase_count) || 0) || 0;
        var postPurchaseCount = Number((retailRow && retailRow.post_purchase_count) || 0) || 0;
        var orderId = retailTextValue(retailRow && retailRow.boulevard_order_id, '');
        if (priorityLabel) items.push({ label: 'Priority', value: priorityLabel });
        if (stylist) items.push({ label: 'Stylist', value: stylist });
        if (appointmentDate) items.push({ label: 'Visit', value: formatRecaptureDate(appointmentDate) });
        if (orderId) items.push({ label: 'Order', value: 'Linked' });
        if (inVisitPurchaseCount > 0) items.push({ label: 'In visit', value: String(inVisitPurchaseCount) + ' bought' });
        else if (postPurchaseCount > 0) items.push({ label: 'After visit', value: String(postPurchaseCount) + ' bought' });
        if (lastContacted) items.push({ label: 'Contact', value: 'Last contacted ' + formatRecaptureDate(lastContacted) });
        if (missingCount > 0) items.push({ label: 'Missing', value: String(missingCount) + ' product' + (missingCount === 1 ? '' : 's') });
        return items.slice(0, 4);
      }

      function retailPriorityQueueCardMarkup(row){
        var retailRow = row && row.retail_row && typeof row.retail_row === 'object' ? row.retail_row : {};
        var clientName = retailTextValue(row && row.guest_name, 'Unknown guest');
        var phone = retailTextValue(row && row.client_phone, '');
        var email = retailTextValue(row && row.client_email, '');
        var primaryStaff = retailTextValue(row && row.primary_staff_name, '');
        var subcategory = retailTextValue(row && row.business_subcategory_label, 'Retail Opportunity');
        var diagnosisTitle = retailTextValue(row && row.diagnosis_title, 'Retail opportunity');
        var diagnosisSummary = retailTextValue(row && row.diagnosis_summary, buildRetailReasonText(retailRow).replace(/^Why this is in queue:\s*/i, ''));
        var workflowChip = dueWorkflowChip(row);
        var outcomeChip = dueOutcomeChip(row);
        var services = retailArray(retailRow && retailRow.service_names);
        var missingProducts = retailArray(retailRow && retailRow.missing_product_handles);
        var purchasedProducts = retailArray(retailRow && retailRow.purchased_product_handles);
        var recommendedProducts = retailArray(retailRow && retailRow.recommended_product_handles);
        var missingProductDetails = retailArray(retailRow && retailRow.missing_product_details);
        var purchasedProductDetails = retailArray(retailRow && retailRow.purchased_product_details);
        var recommendedProductDetails = retailArray(retailRow && retailRow.recommended_product_details);
        var inVisitPurchaseDetails = retailArray(retailRow && retailRow.appointment_purchase_details);
        var postPurchaseDetails = retailArray(retailRow && retailRow.post_purchase_details);
        var appointmentDate = retailTextValue(retailRow && retailRow.appointment_datetime, '');
        var orderId = retailTextValue(retailRow && retailRow.boulevard_order_id, '');
        var latestRetailPurchaseAt = retailTextValue(retailRow && retailRow.latest_retail_purchase_at, '');
        var missingCategories = retailProductCategoriesSummary(missingProductDetails);
        var quickFacts = retailPrioritySnapshotItems(row).slice(0, 4);
        var lastActionSummary = dueLastActionSummary(row);
        var taskActionsMarkup = dueTaskActionsMarkup(row);
        var outcomeActionsMarkup = dueOutcomeActionsMarkup(row);
        var primaryActionMarkup = dueNeedsClaim(row)
          ? '<button class="btn-primary" type="button" data-task-action="assigned" data-opportunity-key="' + escapeHtml(retailTextValue(row && row.opportunity_key, '')) + '">Claim</button>'
          : '<button class="btn-primary" type="button" data-retail-queue-appointment-id="' + escapeHtml(String((retailRow && retailRow.appointment_id) || '')) + '">Draft retail text</button>';
        return ''
          + '<article class="retail-card retail-card--compact retail-card--queue retail-card--opportunity" data-retail-priority-card>'
          +   '<div class="retail-cardHead">'
          +     '<div class="retail-cardIdentity queue-cardIdentity">'
          +       '<h3 class="retail-cardTitle">' + escapeHtml(clientName) + '</h3>'
          +       '<div class="queue-cardSegments">'
          +         '<div class="queue-cardSegment">Retail</div>'
          +         (workflowChip ? '<span class="' + escapeHtml(workflowChip.className) + '">' + escapeHtml(workflowChip.label) + '</span>' : '')
          +         (outcomeChip ? '<span class="' + escapeHtml(outcomeChip.className) + '">' + escapeHtml(outcomeChip.label) + '</span>' : '')
          +       '</div>'
          +     '</div>'
          +   '</div>'
          +   '<div class="queue-cardDiagnosis queue-cardDiagnosis--accent">'
          +     '<div class="queue-cardDiagnosisTitle">' + escapeHtml(diagnosisTitle) + '</div>'
          +     '<div class="queue-cardReason">' + escapeHtml(diagnosisSummary) + '</div>'
          +     (retailTextValue(row && row.recommended_action, '') ? '<div class="queue-cardDiagnosisAction">Next: ' + escapeHtml(retailTextValue(row && row.recommended_action, '')) + '</div>' : '')
          +   '</div>'
          +   (quickFacts.length ? '<div class="queue-cardQuickFacts">' + quickFacts.map(function(item){
                return '<div class="queue-cardQuickFact"><span>' + escapeHtml(retailTextValue(item.label, '')) + '</span><strong>' + escapeHtml(retailTextValue(item.value, '')) + '</strong></div>';
              }).join('') + '</div>' : '')
          +   '<div class="queue-cardCompactMeta">' + escapeHtml(subcategory) + ' • ' + escapeHtml((missingProducts.length || recommendedProducts.length) ? (missingProducts.length + ' missing from routine') : 'Retail follow-up needed') + (appointmentDate ? ' • Visit ' + escapeHtml(formatRecaptureDate(appointmentDate)) : '') + '</div>'
          +   '<div class="retail-cardActions retail-cardActions--queue">'
          +     primaryActionMarkup
          +   '</div>'
          +   '<details class="retail-cardDetails">'
          +     '<summary class="retail-cardDetailsSummary">View details</summary>'
          +     '<div class="retail-cardDetailsBody">'
          +       (lastActionSummary ? '<div class="retail-cardMeta"><strong>Last action:</strong> ' + escapeHtml(lastActionSummary) + '</div>' : '')
          +       (phone ? '<div class="retail-cardMeta"><strong>Phone:</strong> ' + escapeHtml(phone) + '</div>' : '')
          +       (email ? '<div class="retail-cardMeta"><strong>Email:</strong> ' + escapeHtml(email) + '</div>' : '')
          +       (primaryStaff ? '<div class="retail-cardMeta"><strong>Primary stylist:</strong> ' + escapeHtml(primaryStaff) + '</div>' : '')
          +       (orderId ? '<div class="retail-cardMeta"><strong>Order:</strong> ' + escapeHtml(orderId) + '</div>' : '')
          +       (latestRetailPurchaseAt ? '<div class="retail-cardMeta"><strong>Last retail purchase:</strong> ' + escapeHtml(formatRecaptureDate(latestRetailPurchaseAt)) + '</div>' : '')
          +       (retailTextValue(row && row.outcome_state_summary, '') ? '<div class="retail-cardMeta"><strong>Outcome:</strong> ' + escapeHtml(retailTextValue(row && row.outcome_state_summary, '')) + '</div>' : '')
          +       (taskActionsMarkup ? '<div class="retail-cardActions retail-cardActions--queue">' + taskActionsMarkup + '</div>' : '')
          +       (outcomeActionsMarkup ? '<div class="retail-cardActions retail-cardActions--queue">' + outcomeActionsMarkup + '</div>' : '')
          +       (services.length ? '<div class="retail-cardRow"><div class="retail-cardLabel">Service history</div><div class="retail-cardChips">' + retailChipsMarkup(services) + '</div></div>' : '')
          +       (recommendedProducts.length ? '<div class="retail-cardRow"><div class="retail-cardLabel">Recommended products</div><div class="retail-cardChips">' + retailProductDetailChipsMarkup(recommendedProductDetails.length ? recommendedProductDetails : recommendedProducts) + '</div></div>' : '')
          +       (missingProducts.length ? '<div class="retail-cardRow"><div class="retail-cardLabel">Still missing</div><div class="retail-cardChips">' + retailProductDetailChipsMarkup(missingProductDetails.length ? missingProductDetails : missingProducts) + '</div></div>' : '')
          +       (missingCategories.length ? '<div class="retail-cardMeta"><strong>Missing categories:</strong> ' + escapeHtml(missingCategories.join(', ')) + '</div>' : '')
          +       (inVisitPurchaseDetails.length ? '<div class="retail-cardRow"><div class="retail-cardLabel">Bought during visit</div><div class="retail-cardChips">' + retailProductDetailChipsMarkup(inVisitPurchaseDetails, 'success') + '</div></div>' : '')
          +       (postPurchaseDetails.length ? '<div class="retail-cardRow"><div class="retail-cardLabel">Bought after visit</div><div class="retail-cardChips">' + retailProductDetailChipsMarkup(postPurchaseDetails, 'success') + '</div></div>' : '')
          +       (!inVisitPurchaseDetails.length && purchasedProducts.length ? '<div class="retail-cardRow"><div class="retail-cardLabel">Already purchased</div><div class="retail-cardChips">' + retailProductDetailChipsMarkup(purchasedProductDetails.length ? purchasedProductDetails : purchasedProducts, 'success') + '</div></div>' : '')
          +       '<div class="retail-reason">' + escapeHtml(buildRetailReasonText(retailRow)) + '</div>'
          +     '</div>'
          +   '</details>'
          + '</article>';
      }

      function reviewPrioritySnapshotItems(row){
        var reviewRow = row && row.review_row && typeof row.review_row === 'object' ? row.review_row : {};
        var items = [];
        var priorityLabel = dueOpportunityPriorityLabel(row);
        var stylist = retailTextValue(row && row.primary_staff_name, '');
        var visitDate = retailTextValue(reviewRow && reviewRow.appointment_datetime, '');
        var rating = Number((reviewRow && reviewRow.appointment_rating) || 0) || 0;
        if (priorityLabel) items.push({ label: 'Priority', value: priorityLabel });
        if (stylist) items.push({ label: 'Stylist', value: stylist });
        if (visitDate) items.push({ label: 'Visit', value: formatRecaptureDate(visitDate) });
        if (rating > 0) items.push({ label: 'Rating', value: String(rating) + '/5' });
        return items.slice(0, 4);
      }

      function referralPrioritySnapshotItems(row){
        var referralRow = row && row.referral_row && typeof row.referral_row === 'object' ? row.referral_row : {};
        var items = [];
        var priorityLabel = dueOpportunityPriorityLabel(row);
        var stylist = retailTextValue(row && row.primary_staff_name, '');
        var visitDate = retailTextValue(referralRow && referralRow.appointment_datetime, '');
        var totalVisits = Number((referralRow && referralRow.total_completed_visits) || 0) || 0;
        var positiveVisits = Number((referralRow && referralRow.positive_visit_count) || 0) || 0;
        if (priorityLabel) items.push({ label: 'Priority', value: priorityLabel });
        if (stylist) items.push({ label: 'Stylist', value: stylist });
        if (visitDate) items.push({ label: 'Visit', value: formatRecaptureDate(visitDate) });
        if (totalVisits > 0) items.push({ label: 'Visit depth', value: String(totalVisits) + ' visits' });
        if (positiveVisits > 0) items.push({ label: 'Positive visits', value: String(positiveVisits) });
        return items.slice(0, 4);
      }

      function reviewPriorityQueueCardMarkup(row){
        var reviewRow = row && row.review_row && typeof row.review_row === 'object' ? row.review_row : {};
        var clientName = retailTextValue(row && row.guest_name, 'Unknown guest');
        var phone = retailTextValue(row && row.client_phone, '');
        var email = retailTextValue(row && row.client_email, '');
        var primaryStaff = retailTextValue(row && row.primary_staff_name, '');
        var subcategory = retailTextValue(row && row.business_subcategory_label, 'Review Opportunity');
        var diagnosisTitle = retailTextValue(row && row.diagnosis_title, 'Review opportunity');
        var diagnosisSummary = retailTextValue(row && row.diagnosis_summary, '');
        var workflowChip = dueWorkflowChip(row);
        var outcomeChip = dueOutcomeChip(row);
        var services = retailArray(reviewRow && reviewRow.service_names);
        var appointmentDate = retailTextValue(reviewRow && reviewRow.appointment_datetime, '');
        var feedback = retailTextValue(reviewRow && reviewRow.appointment_feedback, '');
        var suggestedMessage = retailTextValue(row && row.review_suggested_message, '');
        var quickFacts = reviewPrioritySnapshotItems(row).slice(0, 4);
        var lastActionSummary = dueLastActionSummary(row);
        var taskActionsMarkup = dueTaskActionsMarkup(row);
        var outcomeActionsMarkup = dueOutcomeActionsMarkup(row);
        var primaryActionMarkup = dueNeedsClaim(row)
          ? '<button class="btn-primary" type="button" data-task-action="assigned" data-opportunity-key="' + escapeHtml(retailTextValue(row && row.opportunity_key, '')) + '">Claim</button>'
          : '<button class="btn-primary" type="button" data-review-copy-sms="' + escapeHtml(suggestedMessage) + '">Copy review text</button>';
        return ''
          + '<article class="retail-card retail-card--compact retail-card--queue retail-card--opportunity" data-review-priority-card>'
          +   '<div class="retail-cardHead">'
          +     '<div class="retail-cardIdentity queue-cardIdentity">'
          +       '<h3 class="retail-cardTitle">' + escapeHtml(clientName) + '</h3>'
          +       '<div class="queue-cardSegments">'
          +         '<div class="queue-cardSegment">Review</div>'
          +         (workflowChip ? '<span class="' + escapeHtml(workflowChip.className) + '">' + escapeHtml(workflowChip.label) + '</span>' : '')
          +         (outcomeChip ? '<span class="' + escapeHtml(outcomeChip.className) + '">' + escapeHtml(outcomeChip.label) + '</span>' : '')
          +       '</div>'
          +     '</div>'
          +   '</div>'
          +   '<div class="queue-cardDiagnosis queue-cardDiagnosis--accent">'
          +     '<div class="queue-cardDiagnosisTitle">' + escapeHtml(diagnosisTitle) + '</div>'
          +     '<div class="queue-cardReason">' + escapeHtml(diagnosisSummary) + '</div>'
          +     (retailTextValue(row && row.recommended_action, '') ? '<div class="queue-cardDiagnosisAction">Next: ' + escapeHtml(retailTextValue(row && row.recommended_action, '')) + '</div>' : '')
          +   '</div>'
          +   (quickFacts.length ? '<div class="queue-cardQuickFacts">' + quickFacts.map(function(item){
                return '<div class="queue-cardQuickFact"><span>' + escapeHtml(retailTextValue(item.label, '')) + '</span><strong>' + escapeHtml(retailTextValue(item.value, '')) + '</strong></div>';
              }).join('') + '</div>' : '')
          +   '<div class="queue-cardCompactMeta">' + escapeHtml(subcategory) + ' • ' + escapeHtml(appointmentDate ? ('Visit ' + formatRecaptureDate(appointmentDate)) : 'Recent completed visit') + (services.length ? ' • ' + escapeHtml(services.slice(0, 2).join(', ')) : '') + '</div>'
          +   '<div class="retail-cardActions retail-cardActions--queue">'
          +     primaryActionMarkup
          +   '</div>'
          +   '<details class="retail-cardDetails">'
          +     '<summary class="retail-cardDetailsSummary">View details</summary>'
          +     '<div class="retail-cardDetailsBody">'
          +       (lastActionSummary ? '<div class="retail-cardMeta"><strong>Last action:</strong> ' + escapeHtml(lastActionSummary) + '</div>' : '')
          +       (phone ? '<div class="retail-cardMeta"><strong>Phone:</strong> ' + escapeHtml(phone) + '</div>' : '')
          +       (email ? '<div class="retail-cardMeta"><strong>Email:</strong> ' + escapeHtml(email) + '</div>' : '')
          +       (primaryStaff ? '<div class="retail-cardMeta"><strong>Primary stylist:</strong> ' + escapeHtml(primaryStaff) + '</div>' : '')
          +       (retailTextValue(row && row.outcome_state_summary, '') ? '<div class="retail-cardMeta"><strong>Outcome:</strong> ' + escapeHtml(retailTextValue(row && row.outcome_state_summary, '')) + '</div>' : '')
          +       (taskActionsMarkup ? '<div class="retail-cardActions retail-cardActions--queue">' + taskActionsMarkup + '</div>' : '')
          +       (outcomeActionsMarkup ? '<div class="retail-cardActions retail-cardActions--queue">' + outcomeActionsMarkup + '</div>' : '')
          +       (services.length ? '<div class="retail-cardRow"><div class="retail-cardLabel">Service history</div><div class="retail-cardChips">' + retailChipsMarkup(services) + '</div></div>' : '')
          +       (feedback ? '<div class="retail-cardMeta"><strong>Feedback:</strong> ' + escapeHtml(feedback) + '</div>' : '')
          +       (suggestedMessage ? '<div class="retail-draft"><strong>Suggested outreach</strong>\n' + escapeHtml(suggestedMessage) + '</div>' : '')
          +     '</div>'
          +   '</details>'
          + '</article>';
      }

      function referralPriorityQueueCardMarkup(row){
        var referralRow = row && row.referral_row && typeof row.referral_row === 'object' ? row.referral_row : {};
        var clientName = retailTextValue(row && row.guest_name, 'Unknown guest');
        var phone = retailTextValue(row && row.client_phone, '');
        var email = retailTextValue(row && row.client_email, '');
        var primaryStaff = retailTextValue(row && row.primary_staff_name, '');
        var subcategory = retailTextValue(row && row.business_subcategory_label, 'Referral Opportunity');
        var diagnosisTitle = retailTextValue(row && row.diagnosis_title, 'Referral opportunity');
        var diagnosisSummary = retailTextValue(row && row.diagnosis_summary, '');
        var workflowChip = dueWorkflowChip(row);
        var outcomeChip = dueOutcomeChip(row);
        var services = retailArray(referralRow && referralRow.service_names);
        var appointmentDate = retailTextValue(referralRow && referralRow.appointment_datetime, '');
        var suggestedMessage = retailTextValue(row && row.referral_suggested_message, '');
        var historyRating = retailTextValue(referralRow && referralRow.history_rating, '');
        var quickFacts = referralPrioritySnapshotItems(row).slice(0, 4);
        var lastActionSummary = dueLastActionSummary(row);
        var taskActionsMarkup = dueTaskActionsMarkup(row);
        var outcomeActionsMarkup = dueOutcomeActionsMarkup(row);
        var primaryActionMarkup = dueNeedsClaim(row)
          ? '<button class="btn-primary" type="button" data-task-action="assigned" data-opportunity-key="' + escapeHtml(retailTextValue(row && row.opportunity_key, '')) + '">Claim</button>'
          : '<button class="btn-primary" type="button" data-review-copy-sms="' + escapeHtml(suggestedMessage) + '">Copy referral text</button>';
        return ''
          + '<article class="retail-card retail-card--compact retail-card--queue retail-card--opportunity" data-referral-priority-card>'
          +   '<div class="retail-cardHead">'
          +     '<div class="retail-cardIdentity queue-cardIdentity">'
          +       '<h3 class="retail-cardTitle">' + escapeHtml(clientName) + '</h3>'
          +       '<div class="queue-cardSegments">'
          +         '<div class="queue-cardSegment">Referral</div>'
          +         (historyRating ? '<div class="queue-cardSegment">' + escapeHtml(historyRating) + '</div>' : '')
          +         (workflowChip ? '<span class="' + escapeHtml(workflowChip.className) + '">' + escapeHtml(workflowChip.label) + '</span>' : '')
          +         (outcomeChip ? '<span class="' + escapeHtml(outcomeChip.className) + '">' + escapeHtml(outcomeChip.label) + '</span>' : '')
          +       '</div>'
          +     '</div>'
          +   '</div>'
          +   '<div class="queue-cardDiagnosis queue-cardDiagnosis--accent">'
          +     '<div class="queue-cardDiagnosisTitle">' + escapeHtml(diagnosisTitle) + '</div>'
          +     '<div class="queue-cardReason">' + escapeHtml(diagnosisSummary) + '</div>'
          +     (retailTextValue(row && row.recommended_action, '') ? '<div class="queue-cardDiagnosisAction">Next: ' + escapeHtml(retailTextValue(row && row.recommended_action, '')) + '</div>' : '')
          +   '</div>'
          +   (quickFacts.length ? '<div class="queue-cardQuickFacts">' + quickFacts.map(function(item){
                return '<div class="queue-cardQuickFact"><span>' + escapeHtml(retailTextValue(item.label, '')) + '</span><strong>' + escapeHtml(retailTextValue(item.value, '')) + '</strong></div>';
              }).join('') + '</div>' : '')
          +   '<div class="queue-cardCompactMeta">' + escapeHtml(subcategory) + ' • ' + escapeHtml(appointmentDate ? ('Last visit ' + formatRecaptureDate(appointmentDate)) : 'Strong recent relationship') + (services.length ? ' • ' + escapeHtml(services.slice(0, 2).join(', ')) : '') + '</div>'
          +   '<div class="retail-cardActions retail-cardActions--queue">'
          +     primaryActionMarkup
          +   '</div>'
          +   '<details class="retail-cardDetails">'
          +     '<summary class="retail-cardDetailsSummary">View details</summary>'
          +     '<div class="retail-cardDetailsBody">'
          +       (lastActionSummary ? '<div class="retail-cardMeta"><strong>Last action:</strong> ' + escapeHtml(lastActionSummary) + '</div>' : '')
          +       (phone ? '<div class="retail-cardMeta"><strong>Phone:</strong> ' + escapeHtml(phone) + '</div>' : '')
          +       (email ? '<div class="retail-cardMeta"><strong>Email:</strong> ' + escapeHtml(email) + '</div>' : '')
          +       (primaryStaff ? '<div class="retail-cardMeta"><strong>Primary stylist:</strong> ' + escapeHtml(primaryStaff) + '</div>' : '')
          +       (retailTextValue(row && row.outcome_state_summary, '') ? '<div class="retail-cardMeta"><strong>Outcome:</strong> ' + escapeHtml(retailTextValue(row && row.outcome_state_summary, '')) + '</div>' : '')
          +       (taskActionsMarkup ? '<div class="retail-cardActions retail-cardActions--queue">' + taskActionsMarkup + '</div>' : '')
          +       (outcomeActionsMarkup ? '<div class="retail-cardActions retail-cardActions--queue">' + outcomeActionsMarkup + '</div>' : '')
          +       (services.length ? '<div class="retail-cardRow"><div class="retail-cardLabel">Recent services</div><div class="retail-cardChips">' + retailChipsMarkup(services) + '</div></div>' : '')
          +       (suggestedMessage ? '<div class="retail-draft"><strong>Suggested outreach</strong>\n' + escapeHtml(suggestedMessage) + '</div>' : '')
          +     '</div>'
          +   '</details>'
          + '</article>';
      }

      function retailQueuedCardMarkup(row){
        var clientName = retailTextValue(row && row.client_name, 'Unknown client');
        var staffName = retailTextValue(row && row.staff_name, 'No stylist');
        var status = retailTextValue(row && row.status, 'queued');
        var opportunityType = retailTextValue(row && row.opportunity_type, 'queued');
        var messageDraft = retailTextValue((row && (row.drafted_sms_message || row.message_draft)) || '', '');
        var queueStatus = retailTextValue(row && row.queue_status, status);
        var token = retailTextValue(row && row.public_token, '');
        var reviewedAt = retailTextValue(row && row.reviewed_at, '');
        var activityBucket = getRetailActivityBucket(row);
        return ''
          + '<article class="retail-card retail-card--queued" data-retail-queue-card>'
          +   '<div class="retail-cardHead">'
          +     '<div>'
          +       '<h3 class="retail-cardTitle">' + escapeHtml(clientName) + '</h3>'
          +       '<p class="retail-cardMeta">' + escapeHtml(staffName + ' • ' + queueStatus) + '</p>'
          +     '</div>'
          +     '<span class="retail-chip retail-chip--success">' + escapeHtml(opportunityType) + '</span>'
          +   '</div>'
          +   (token ? '<div class="retail-cardMeta">Public token: ' + escapeHtml(token) + '</div>' : '')
          +   (reviewedAt ? '<div class="retail-cardMeta">Reviewed at: ' + escapeHtml(reviewedAt) + '</div>' : '')
          +   '<div class="retail-cardMeta">Check-in activity: ' + escapeHtml(retailActivitySummaryText(activityBucket)) + '</div>'
          +   '<div class="retail-cardRow">'
          +     '<div class="retail-cardLabel">Missing routine pieces</div>'
          +     '<div class="retail-cardChips">' + retailChipsMarkup(row && (row.missing_product_handles || row.missing_handles)) + '</div>'
          +   '</div>'
          +   '<div class="retail-cardRow">'
          +     '<div class="retail-cardLabel">Drafted SMS</div>'
          +     '<textarea class="retail-draftEditor" data-retail-draft-editor>' + escapeHtml(messageDraft) + '</textarea>'
          +   '</div>'
          +   '<div class="retail-cardActions">'
          +     '<button class="btn-secondary" type="button" data-retail-save-draft-id="' + escapeHtml(String((row && row.id) || '')) + '">Save draft</button>'
          +     '<button class="btn-secondary" type="button" data-retail-mark-reviewed-id="' + escapeHtml(String((row && row.id) || '')) + '">Mark reviewed</button>'
          +     '<button class="btn-secondary" type="button" data-retail-regenerate-id="' + escapeHtml(String((row && row.id) || '')) + '">Regenerate</button>'
          +     '<button class="btn-secondary" type="button" data-retail-mark-sent-id="' + escapeHtml(String((row && row.id) || '')) + '">Mark sent</button>'
          +     '<button class="btn-secondary" type="button" data-retail-skip-id="' + escapeHtml(String((row && row.id) || '')) + '">Skip</button>'
          +   '</div>'
          + '</article>';
      }

      function getRetailActivityBucket(row){
        var appointmentId = String((row && row.appointment_id) || '').trim();
        var publicToken = String((row && row.public_token) || '').trim();
        if (appointmentId && retailActivityByAppointment[appointmentId]) return retailActivityByAppointment[appointmentId];
        if (publicToken && retailActivityByAppointment[publicToken]) return retailActivityByAppointment[publicToken];
        if (row && row.checkin_activity_summary && typeof row.checkin_activity_summary === 'object') return row.checkin_activity_summary;
        return null;
      }

      function mergeCheckinActivitySummary(data){
        var rows = retailArray(data && data.by_appointment);
        rows.forEach(function(bucket){
          var safeBucket = bucket && typeof bucket === 'object' ? bucket : {};
          var appointmentId = retailTextValue(safeBucket && safeBucket.appointment_id, '');
          var publicToken = retailTextValue(safeBucket && safeBucket.public_token, '');
          if (appointmentId) retailActivityByAppointment[appointmentId] = safeBucket;
          if (publicToken) retailActivityByAppointment[publicToken] = safeBucket;
        });
      }

      function bdFastCheckinActivityIntentText(bucket){
        var safeBucket = bucket && typeof bucket === 'object' ? bucket : null;
        if (!safeBucket) return '';
        var retailAdds = Math.max(0, Number(safeBucket.retail_add_count) || 0);
        var pageViews = Math.max(0, Number(safeBucket.page_view_count) || 0);
        if (retailAdds > 0) return String(retailAdds) + ' retail add' + (retailAdds === 1 ? '' : 's') + ' from check-in';
        if (safeBucket.recommendation_saved === true) return 'Saved routine in check-in';
        if (safeBucket.hair_story_saved === true) return 'Saved hair story in check-in';
        if (safeBucket.hair_story_started === true) return 'Started hair story in check-in';
        if (safeBucket.rating_saved === true) return 'Left a check-in rating';
        if (pageViews > 0) return pageViews === 1 ? 'Opened check-in once' : 'Opened check-in ' + String(pageViews) + ' times';
        return '';
      }

      function bdFastCheckinActivitySupportText(bucket){
        var safeBucket = bucket && typeof bucket === 'object' ? bucket : null;
        if (!safeBucket) return '';
        var signals = [];
        var pageViews = Math.max(0, Number(safeBucket.page_view_count) || 0);
        var retailAdds = Math.max(0, Number(safeBucket.retail_add_count) || 0);
        if (pageViews > 0) signals.push(pageViews === 1 ? '1 page view' : String(pageViews) + ' page views');
        if (safeBucket.hair_story_started) signals.push('hair story started');
        if (safeBucket.hair_story_saved) signals.push('hair story saved');
        if (safeBucket.recommendation_saved) signals.push('routine saved');
        if (retailAdds > 0) signals.push(String(retailAdds) + ' retail add' + (retailAdds === 1 ? '' : 's'));
        if (safeBucket.rating_saved) signals.push('rating saved');
        return signals.join(' • ');
      }

      function queueCheckinActivityFetch(rows){
        var appointmentIds = uniqueNonEmptyStrings(retailArray(rows).map(function(row){
          return retailTextValue(row && row.appointment_id, '');
        }).filter(function(value){
          return value && !retailActivityByAppointment[value];
        }));
        if (!appointmentIds.length) return;
        window.setTimeout(function(){
          fetchRetailCheckinActivity(appointmentIds.map(function(id){
            return { appointment_id: id };
          })).then(function(result){
            mergeCheckinActivitySummary(result);
            renderBdFastQueue();
          }).catch(function(){
          });
        }, 0);
      }

      function retailActivitySummaryText(bucket){
        if (!bucket) return 'No tracked check-in activity yet.';
        var bits = [];
        if (Number(bucket.page_view_count || 0) > 0) bits.push(String(bucket.page_view_count) + ' page view' + (Number(bucket.page_view_count || 0) === 1 ? '' : 's'));
        if (bucket.hair_story_started) bits.push('hair story started');
        if (bucket.hair_story_saved) bits.push('hair story saved');
        if (bucket.recommendation_saved) bits.push('recommendations saved');
        if (Number(bucket.retail_add_count || 0) > 0) bits.push(String(bucket.retail_add_count) + ' retail add' + (Number(bucket.retail_add_count || 0) === 1 ? '' : 's'));
        if (bucket.rating_saved) bits.push('rating saved');
        return bits.length ? bits.join(' • ') : 'No tracked check-in activity yet.';
      }

      function renderRetailDashboard(){
        var snapshot = getRetailSnapshotForActiveWeek();
        var leaderboard = retailSalesLeaderboard || (snapshot && snapshot.sales_leaderboard) || {};
        var stylistSummary = leaderboard.stylist && leaderboard.stylist.summary ? leaderboard.stylist.summary : {};
        var assistantSummary = leaderboard.assistant && leaderboard.assistant.summary ? leaderboard.assistant.summary : {};
        var eligibleStaff = retailEligibleStaffOptions();
        var stylistRows = retailBuildLaneRows('stylist');
        var assistantRows = retailBuildLaneRows('assistant');
        renderRetailSalesLeaderboard();
      }

      function renderRetailQueuedDrafts(){
        var rows = retailArray(retailQueuedRows);
        if (!retailQueuedList) return;
        retailQueuedList.innerHTML = rows.length
          ? rows.map(retailQueuedCardMarkup).join('')
          : '<div class="retail-empty">No queued retail SMS drafts yet.</div>';
      }

      function dueCadenceSummary(item){
        var dueDays = Number((item && (item.cadence_days || item.due_days)) || 0) || 0;
        if (!dueDays) return '';
        var cadenceSource = String((item && item.cadence_source) || '').trim();
        var cadenceSampleSize = Number((item && item.cadence_sample_size) || 0) || 0;
        var cadenceExplanation = retailTextValue(item && item.cadence_explanation, '');
        if (cadenceExplanation) return cadenceExplanation;
        if (cadenceSource === 'personalized') {
          return String(dueDays) + ' days, estimated from visit history'
            + (cadenceSampleSize ? ' (' + String(cadenceSampleSize) + ' visits)' : '');
        }
        if (cadenceSource === 'service_category') {
          return String(dueDays) + ' days from the service-category cadence';
        }
        return String(dueDays) + ' days from the fallback cadence';
      }

      function dueCadenceSourceChipClass(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'personalized') return 'retail-chip retail-chip--history';
        if (normalized === 'service_category') return 'retail-chip retail-chip--accent';
        return 'retail-chip retail-chip--muted';
      }

      function dueCadenceChipsMarkup(row, primaryDueItem){
        var safeRow = row && typeof row === 'object' ? row : {};
        var safeItem = primaryDueItem && typeof primaryDueItem === 'object' ? primaryDueItem : {};
        var cadenceDays = Number(safeRow.cadence_days || safeItem.cadence_days || safeItem.due_days || 0) || 0;
        if (!cadenceDays) return '';
        var cadenceSourceKey = retailTextValue(safeRow.cadence_source, '') || retailTextValue(safeItem.cadence_source, '') || 'fallback';
        var cadenceSourceLabel = retailTextValue(safeRow.cadence_source_label, '') || 'Fallback';
        var cadenceSampleSize = Number(safeRow.cadence_sample_size || safeItem.cadence_sample_size || 0) || 0;
        var chips = [
          '<span class="retail-chip">' + escapeHtml(String(cadenceDays)) + ' day cadence</span>',
          '<span class="' + escapeHtml(dueCadenceSourceChipClass(cadenceSourceKey)) + '">' + escapeHtml(cadenceSourceLabel) + '</span>'
        ];
        if (cadenceSampleSize > 0) {
          chips.push(
            '<span class="retail-chip retail-chip--muted">'
              + escapeHtml(String(cadenceSampleSize))
              + ' '
              + escapeHtml(cadenceSourceKey === 'fallback' ? 'total visits' : 'matching visits')
            + '</span>'
          );
        }
        return chips.join('');
      }

      function dueCadencePatternText(row, primaryDueItem){
        var safeRow = row && typeof row === 'object' ? row : {};
        var safeItem = primaryDueItem && typeof primaryDueItem === 'object' ? primaryDueItem : {};
        var categoryLabel = retailTextValue(safeRow.primary_label || safeRow.service_category, '') || retailTextValue(safeItem.label, '') || 'Visit';
        var cadenceDays = Number(safeRow.cadence_days || safeItem.cadence_days || safeItem.due_days || 0) || 0;
        var lastVisit = formatRecaptureDate(retailTextValue(safeRow.last_appointment_date || safeItem.last_visit_at, ''));
        var dueAt = formatRecaptureDate(retailTextValue(safeRow.expected_due_date || safeItem.due_at, ''));
        var daysOverdue = Number(safeRow.days_overdue || safeItem.days_overdue || 0) || 0;
        var daysUntilDue = Number(safeRow.days_until_due || 0) || 0;
        if (!cadenceDays) return '';
        return 'Pattern: '
          + categoryLabel
          + ' every ' + String(cadenceDays) + 'd'
          + ' • Last in ' + lastVisit
          + ' • Due ' + dueAt
          + ' • '
          + (daysOverdue > 0 ? String(daysOverdue) + 'd overdue' : 'Due in ' + String(Math.max(0, daysUntilDue)) + 'd');
      }

      function duePatternStatusText(item){
        var safeItem = item && typeof item === 'object' ? item : {};
        var daysOverdue = Number((safeItem && safeItem.days_overdue) || 0) || 0;
        if (daysOverdue > 0) return String(daysOverdue) + 'd overdue';
        var dueAt = retailTextValue(safeItem && safeItem.due_at, '');
        var lastVisitAt = retailTextValue(safeItem && safeItem.last_visit_at, '');
        if (dueAt && lastVisitAt) {
          var dueDate = dueAt.indexOf('T') >= 0 ? new Date(dueAt) : new Date(dueAt + 'T12:00:00');
          var now = new Date();
          var startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
          if (!isNaN(dueDate.getTime())) {
            var startOfDue = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());
            var diffDays = Math.round((startOfDue.getTime() - startOfToday.getTime()) / 86400000);
            return diffDays > 0 ? 'Due in ' + String(diffDays) + 'd' : 'Due now';
          }
        }
        return 'Timing unavailable';
      }

      function duePatternSourceLabel(item){
        var source = String((item && item.cadence_source) || '').trim().toLowerCase();
        if (source === 'personalized') return 'Personalized';
        if (source === 'service_category') return 'Category default';
        return 'Fallback';
      }

      function duePatternSampleSize(item){
        return Math.max(0, Number((item && item.cadence_sample_size) || 0) || 0);
      }

      function duePatternEffectiveSampleSize(row, item){
        var rawSampleSize = duePatternSampleSize(item);
        var familyKey = duePatternFamilyKey(item);
        var familyVisitCount = familyKey ? duePatternFamilyCountForKey(row, familyKey) : 0;
        if (familyVisitCount > 0 && rawSampleSize > 0) {
          return Math.min(rawSampleSize, familyVisitCount);
        }
        return familyVisitCount > 0 ? familyVisitCount : rawSampleSize;
      }

      function duePatternIsReliable(item){
        return duePatternSampleSize(item) >= 3;
      }

      function duePatternFamilyKey(item){
        var text = [
          item && item.category,
          item && item.label,
          retailArray(item && item.service_names).join(' ')
        ].map(function(value){ return String(value || '').trim().toLowerCase(); }).filter(Boolean).join(' ');
        if (/single[\s_-]*process|gloss|highlight|foil|balayage|dimensional|blond|blonde|color|toner|glaze/.test(text)) return 'color';
        if (/haircut|hair\s*cut|trim|curly[\s_-]*cut|bang/.test(text)) return 'haircut';
        if (/extension|weft|k[\s_-]*tip|hand[\s_-]*tied|tape[\s_-]*in/.test(text)) return 'extensions';
        if (/keratin|smoothing|treatment/.test(text)) return 'keratin';
        if (/blow[\s_-]*dry|blowdry/.test(text)) return 'blowdry';
        if (/consult/.test(text)) return 'consult';
        return String((item && item.category) || '').trim().toLowerCase() || String((item && item.label) || '').trim().toLowerCase() || 'other';
      }

      function duePatternFamilyLabel(key, fallbackLabel){
        var normalized = String(key || '').trim().toLowerCase();
        if (normalized === 'color') return 'Color';
        if (normalized === 'extensions') return 'Extensions';
        if (normalized === 'haircut') return 'Haircut';
        if (normalized === 'keratin') return 'Keratin';
        if (normalized === 'blowdry') return 'Blowdry';
        if (normalized === 'consult') return 'Consult';
        if (normalized === 'general_rebook') return 'General visit';
        return retailTextValue(fallbackLabel, 'Visit');
      }

      function duePatternFamilyCountForKey(row, familyKey){
        var seen = {};
        return dueFamilyVisitDatesForKey(row, familyKey).filter(function(value){
          var text = retailTextValue(value, '');
          if (!text || seen[text]) return false;
          seen[text] = true;
          return true;
        }).length;
      }

      function dueComboRoutineSignal(row, focusItem){
        var focusFamily = duePatternFamilyKey(focusItem);
        if (!focusFamily || focusFamily === 'blowdry' || focusFamily === 'general_rebook') return null;
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        var guestSignals = debug && debug.guest_signals && typeof debug.guest_signals === 'object' ? debug.guest_signals : {};
        var comboCounts = guestSignals && guestSignals.family_combo_counts && typeof guestSignals.family_combo_counts === 'object'
          ? guestSignals.family_combo_counts
          : {};
        var comboLatestAt = guestSignals && guestSignals.family_combo_latest_at && typeof guestSignals.family_combo_latest_at === 'object'
          ? guestSignals.family_combo_latest_at
          : {};
        var focusFamilyCount = duePatternFamilyCountForKey(row, focusFamily);
        if (focusFamilyCount < 3) return null;
        var best = null;
        Object.keys(comboCounts).forEach(function(comboKey){
          var families = String(comboKey || '').split('+').map(function(value){
            return retailTextValue(value, '').toLowerCase();
          }).filter(Boolean);
          if (families.indexOf(focusFamily) === -1 || families.length < 2) return;
          var comboCount = Math.max(0, Number(comboCounts[comboKey] || 0) || 0);
          var comboRate = focusFamilyCount > 0 ? comboCount / focusFamilyCount : 0;
          if (comboCount < 3 || comboRate < 0.55) return;
          var latestAtText = retailTextValue(comboLatestAt[comboKey], '');
          var latestAt = latestAtText ? new Date(latestAtText).getTime() : 0;
          var score = (comboCount * 100) + Math.round(comboRate * 100) + (Number.isFinite(latestAt) ? Math.round(latestAt / 1000000000) : 0);
          if (!best || score > best.score) {
            best = {
              comboKey: comboKey,
              families: families,
              count: comboCount,
              rate: comboRate,
              latestAtText: latestAtText,
              score: score
            };
          }
        });
        return best;
      }

      function dueRoutineFamiliesLabel(families, mode){
        var safeFamilies = retailArray(families).map(function(value){
          return retailTextValue(value, '').toLowerCase();
        }).filter(Boolean);
        if (!safeFamilies.length) return '';
        var labels = safeFamilies.map(function(familyKey){
          return duePatternFamilyLabel(familyKey, familyKey);
        });
        if (labels.length === 1) return labels[0];
        if (mode === 'sentence') {
          if (labels.length === 2) return labels[0].toLowerCase() + ' and ' + labels[1].toLowerCase();
          return labels.slice(0, -1).map(function(label){ return label.toLowerCase(); }).join(', ') + ', and ' + labels[labels.length - 1].toLowerCase();
        }
        return labels.join(' + ');
      }

      function dueOpportunityRoutineSignal(row, focusItem){
        var comboSignal = dueComboRoutineSignal(row, focusItem);
        if (comboSignal) {
          return {
            families: comboSignal.families,
            titleLabel: dueRoutineFamiliesLabel(comboSignal.families, 'title'),
            sentenceLabel: dueRoutineFamiliesLabel(comboSignal.families, 'sentence'),
            together: true,
            comboCount: comboSignal.count
          };
        }
        var familyKey = duePatternFamilyKey(focusItem);
        return {
          families: [familyKey],
          titleLabel: duePatternFamilyLabel(familyKey, retailTextValue(focusItem && focusItem.label, 'Routine')),
          sentenceLabel: duePatternFamilyLabel(familyKey, retailTextValue(focusItem && focusItem.label, 'routine')).toLowerCase(),
          together: false,
          comboCount: 0
        };
      }

      function dueUniqueTextValues(values){
        return retailArray(values).reduce(function(list, value){
          var normalized = retailTextValue(value, '');
          if (!normalized || list.indexOf(normalized) >= 0) return list;
          list.push(normalized);
          return list;
        }, []);
      }

      function duePatternStrengthScore(item){
        var safeItem = item && typeof item === 'object' ? item : {};
        var sampleSize = duePatternSampleSize(safeItem);
        var source = String(safeItem.cadence_source || '').trim().toLowerCase();
        var daysOverdue = Number(safeItem.days_overdue || 0) || 0;
        var daysUntilDue = Math.max(0, (Number((safeItem.due_days || safeItem.cadence_days)) || 0) - (Number(safeItem.days_since_last_visit || 0) || 0));
        var personalizedBonus = source === 'personalized' ? 1000 : source === 'service_category' ? 500 : 0;
        var reliabilityBonus = duePatternIsReliable(safeItem) ? 10000 : 0;
        var urgencyScore = daysOverdue > 0 ? 250 + Math.min(daysOverdue, 250) : Math.max(0, 120 - Math.min(daysUntilDue, 120));
        return reliabilityBonus + personalizedBonus + (sampleSize * 25) + urgencyScore;
      }

      function duePatternSort(left, right){
        var scoreDiff = duePatternStrengthScore(right) - duePatternStrengthScore(left);
        if (scoreDiff) return scoreDiff;
        var leftLast = new Date(retailTextValue(left && left.last_visit_at, '') || '').getTime();
        var rightLast = new Date(retailTextValue(right && right.last_visit_at, '') || '').getTime();
        return (Number.isFinite(rightLast) ? rightLast : 0) - (Number.isFinite(leftLast) ? leftLast : 0);
      }

      function duePatternLastVisitSort(left, right){
        var leftLast = new Date(retailTextValue(left && left.last_visit_at, '') || '').getTime();
        var rightLast = new Date(retailTextValue(right && right.last_visit_at, '') || '').getTime();
        var normalizedLeftLast = Number.isFinite(leftLast) ? leftLast : 0;
        var normalizedRightLast = Number.isFinite(rightLast) ? rightLast : 0;
        if (normalizedRightLast !== normalizedLeftLast) return normalizedRightLast - normalizedLeftLast;
        return duePatternSort(left, right);
      }

      function dueNumericValue(value, fallback){
        var numeric = Number(value);
        if (Number.isFinite(numeric)) return numeric;
        var fallbackNumeric = Number(fallback);
        return Number.isFinite(fallbackNumeric) ? fallbackNumeric : 0;
      }

      function dueGroupedPatterns(items){
        var grouped = {};
        retailArray(items).forEach(function(item){
          if (!item || (!item.label && !item.category && !item.last_visit_at && !item.due_at)) return;
          var familyKey = duePatternFamilyKey(item);
          if (!grouped[familyKey]) {
            grouped[familyKey] = {
              familyKey: familyKey,
              items: []
            };
          }
          grouped[familyKey].items.push(item);
        });
        return Object.keys(grouped).map(function(familyKey){
          var family = grouped[familyKey];
          var sortedItems = retailArray(family.items).sort(duePatternSort);
          var representative = sortedItems[0] || {};
          var latestItem = retailArray(family.items).sort(duePatternLastVisitSort)[0] || representative;
          var merged = Object.assign({}, representative);
          merged.category = familyKey;
          merged.label = duePatternFamilyLabel(familyKey, representative.label);
          merged.last_visit_at = retailTextValue(latestItem && latestItem.last_visit_at, '') || retailTextValue(representative && representative.last_visit_at, '');
          merged.due_at = retailTextValue(latestItem && latestItem.due_at, '') || retailTextValue(representative && representative.due_at, '');
          merged.due_days = dueNumericValue(latestItem && latestItem.due_days, dueNumericValue(representative && representative.due_days, 0));
          merged.days_overdue = dueNumericValue(latestItem && latestItem.days_overdue, dueNumericValue(representative && representative.days_overdue, 0));
          merged.cadence_days = dueNumericValue(latestItem && latestItem.cadence_days, dueNumericValue(representative && representative.cadence_days, 0));
          merged.cadence_source = retailTextValue(latestItem && latestItem.cadence_source, '') || retailTextValue(representative && representative.cadence_source, '');
          merged.cadence_sample_size = sortedItems.reduce(function(max, item){
            return Math.max(max, duePatternSampleSize(item));
          }, 0);
          merged.service_names = dueUniqueTextValues(sortedItems.reduce(function(list, item){
            return list.concat(retailArray(item && item.service_names));
          }, []));
          merged.source_labels = dueUniqueTextValues(sortedItems.map(function(item){
            return retailTextValue(item && item.label, '');
          }).filter(Boolean));
          merged.pattern_count = sortedItems.length;
          return merged;
        }).sort(duePatternSort);
      }

      function dueDisplayPatternItems(items, focusItem){
        var focusFamily = duePatternFamilyKey(focusItem);
        var grouped = dueGroupedPatterns(items).filter(function(item){
          return !!retailTextValue(item && item.label, '') && duePatternIsReliable(item);
        });
        var preferred = grouped.filter(function(item){
          var familyKey = duePatternFamilyKey(item);
          return familyKey === 'color' || familyKey === 'haircut' || familyKey === 'extensions' || familyKey === 'keratin';
        });
        var selected = preferred.length ? preferred : grouped.filter(function(item){
          return duePatternFamilyKey(item) !== 'general_rebook';
        });
        if (!selected.length) selected = grouped;
        var deduped = [];
        selected.forEach(function(item){
          var familyKey = duePatternFamilyKey(item);
          if (!familyKey) return;
          if (deduped.some(function(existing){ return duePatternFamilyKey(existing) === familyKey; })) return;
          deduped.push(item);
        });
        if (focusFamily && !deduped.some(function(item){ return duePatternFamilyKey(item) === focusFamily; })) {
          var focusMatch = grouped.find(function(item){ return duePatternFamilyKey(item) === focusFamily; });
          if (focusMatch) deduped.unshift(focusMatch);
        }
        return deduped.slice(0, 4);
      }

      function dueServiceCategoryCounts(items){
        return dueGroupedPatterns(items).map(function(item){
          var safeItem = item && typeof item === 'object' ? item : {};
          var visitSupport = duePatternSampleSize(safeItem);
          var fallbackServiceCount = retailArray(safeItem.service_names).length;
          return {
            key: retailTextValue(safeItem.familyKey || safeItem.category, '').toLowerCase(),
            label: retailTextValue(safeItem.label, 'Visit'),
            count: Math.max(1, visitSupport || fallbackServiceCount || Number(safeItem.pattern_count || 0) || 1)
          };
        }).filter(function(item){
          return item.label;
        }).sort(function(left, right){
          var countDiff = Number(right.count || 0) - Number(left.count || 0);
          if (countDiff) return countDiff;
          return String(left.label || '').localeCompare(String(right.label || ''));
        });
      }

      function dueServiceCategoryCountsMarkup(items){
        var rows = dueServiceCategoryCounts(items).slice(0, 4);
        if (!rows.length) return '';
        return ''
          + '<div class="queue-cardCategoryStrip">'
          + rows.map(function(item){
            return ''
              + '<div class="queue-cardCategoryPill">'
              +   '<span>' + escapeHtml(retailTextValue(item.label, 'Visit')) + '</span>'
              +   '<strong>' + escapeHtml(String(Math.max(1, Number(item.count || 0) || 1))) + '</strong>'
              + '</div>';
          }).join('')
          + '</div>';
      }

      function dueRecoveryStrategyText(row, focusItem, diagnosisTitle){
        var safeRow = row && typeof row === 'object' ? row : {};
        var focusLabel = retailTextValue(focusItem && focusItem.label, '') || retailTextValue(safeRow.primary_label || safeRow.service_category, 'visit');
        var lastVisit = retailTextValue(focusItem && focusItem.last_visit_at, '') || retailTextValue(safeRow.last_appointment_date || safeRow.last_in_date || safeRow.last_in_at, '');
        var cadenceDays = duePatternCadenceDays(focusItem) || Math.max(0, Number(safeRow.cadence_days || 0) || 0);
        var overdue = focusItem ? Number((focusItem && focusItem.days_overdue) || 0) || 0 : Number((safeRow.days_overdue || safeRow.max_days_overdue) || 0) || 0;
        var focusDaysSince = Number((focusItem && focusItem.days_since_last_visit) || 0) || 0;
        var untilDue = focusItem
          ? Math.max(0, (Number((focusItem && (focusItem.due_days || focusItem.cadence_days)) || 0) || 0) - focusDaysSince)
          : Number(safeRow.days_until_due || 0) || 0;
        var timing = dueTimingLabel(overdue, untilDue);
        var bits = [];
        if (diagnosisTitle) bits.push(diagnosisTitle + ' play');
        if (focusLabel) bits.push('Reopen ' + focusLabel.toLowerCase());
        if (lastVisit) bits.push('last in ' + formatRecaptureDate(lastVisit));
        if (cadenceDays > 0) bits.push('usual rhythm ' + String(cadenceDays) + 'd');
        bits.push(timing.label.toLowerCase() + ' ' + timing.value);
        return bits.join(' • ');
      }

      function dueManagerOwnerSummary(row){
        var assignedManager = retailTextValue(row && row.manager_task_assigned_name, '');
        if (assignedManager) return assignedManager;
        var primaryStaff = retailTextValue(row && row.primary_staff_name, '');
        return primaryStaff || 'Unassigned';
      }

      function duePatternDiagnosis(row, groupedPatterns){
        var hasFutureAppointment = row && (row.has_future_appointment === true || row.future_appointment_found === true);
        var futureAppointmentAt = retailTextValue(row && row.future_appointment_at, '') || retailTextValue(row && row.futureAppointmentAt, '');
        var backendTitle = retailTextValue(row && row.diagnosis_title, '') || retailTextValue(row && row.diagnosisTitle, '');
        var backendSummary = retailTextValue(row && row.diagnosis_summary, '') || retailTextValue(row && row.diagnosisSummary, '');
        var backendOpportunity = retailTextValue(row && row.opportunity_type, '') || retailTextValue(row && row.opportunityType, '');
        var backendBusinessCategory = retailTextValue(row && row.business_category_label, '') || retailTextValue(row && row.businessCategoryLabel, '');
        var backendBusinessSubcategory = retailTextValue(row && row.business_subcategory_label, '') || retailTextValue(row && row.businessSubcategoryLabel, '');
        var backendLane = retailTextValue(row && row.opportunity_lane, '') || retailTextValue(row && row.opportunityLane, '');
        var backendPriorityTier = retailTextValue(row && row.opportunity_priority_tier, '') || retailTextValue(row && row.opportunityPriorityTier, '');
        var backendPriorityScore = Number((row && (row.business_priority_score || row.businessPriorityScore || row.priority_score || row.priorityScore)) || 0) || 0;
        var backendAction = retailTextValue(row && row.recommended_action, '') || retailTextValue(row && row.recommendedAction, '');
        var backendConfidence = retailTextValue(row && row.diagnosis_confidence, '') || retailTextValue(row && row.diagnosisConfidence, '');
        if (hasFutureAppointment) {
          return {
            title: backendTitle || 'Already booked',
            summary: backendSummary || (futureAppointmentAt ? 'Future visit booked for ' + formatRecaptureDate(futureAppointmentAt) + '.' : 'Future appointment already booked.'),
            opportunityType: backendOpportunity || 'protect',
            businessCategory: backendBusinessCategory || 'Appointment Growth',
            businessSubcategory: backendBusinessSubcategory || 'Booked',
            opportunityLane: backendLane || 'Monitor',
            priorityTier: backendPriorityTier || '',
            priorityScore: backendPriorityScore,
            recommendedAction: backendAction || 'Monitor the upcoming booking',
            confidence: backendConfidence || 'high'
          };
        }
        if (backendTitle || backendSummary) {
          return {
            title: backendTitle || 'Pattern diagnosis',
            summary: backendSummary || '',
            opportunityType: backendOpportunity || '',
            businessCategory: backendBusinessCategory || '',
            businessSubcategory: backendBusinessSubcategory || '',
            opportunityLane: backendLane || '',
            priorityTier: backendPriorityTier || '',
            priorityScore: backendPriorityScore,
            recommendedAction: backendAction || '',
            confidence: backendConfidence || ''
          };
        }
        var stage = String((row && row.queue_stage) || '').trim().toLowerCase();
        var reliable = retailArray(groupedPatterns).filter(duePatternIsReliable);
        if (!reliable.length) {
          return {
            title: 'Early pattern',
            summary: 'There is not enough repeat history yet to trust one strong booking routine.',
            businessCategory: 'Appointment Growth',
            businessSubcategory: 'Pattern Forming',
            opportunityLane: 'Nurture'
          };
        }
        function isLapsed(item){
          var overdue = Number((item && item.days_overdue) || 0) || 0;
          var cadence = Number((item && (item.due_days || item.cadence_days)) || 0) || 0;
          return overdue >= Math.max(30, cadence);
        }
        function isActive(item){
          return !isLapsed(item);
        }
        var active = reliable.filter(isActive);
        var lapsed = reliable.filter(isLapsed);
        var activeLabels = active.map(function(item){ return retailTextValue(item && item.label, ''); }).filter(Boolean);
        var lapsedLabels = lapsed.map(function(item){ return retailTextValue(item && item.label, ''); }).filter(Boolean);
        if (active.length && lapsed.length) {
          return {
            title: 'Mixed routine',
            summary: 'Still current for ' + activeLabels.join(', ') + '. ' + lapsedLabels.join(', ') + ' may need attention.',
            businessCategory: 'Appointment Growth',
            businessSubcategory: 'Category Dropoff',
            opportunityLane: 'Recover Category'
          };
        }
        if (!active.length && lapsed.length) {
          return {
            title: 'At risk',
            summary: 'No strong routine looks current right now. Reach out to bring them back in.',
            businessCategory: 'Appointment Growth',
            businessSubcategory: 'Lost Client',
            opportunityLane: 'Win Back'
          };
        }
        if (stage === 'current_needs_prebooking') {
          return {
            title: 'Ready to prebook',
            summary: 'They are still actively returning. The opportunity is to get the next visit on the books now.',
            businessCategory: 'Appointment Growth',
            businessSubcategory: 'Prebook Missing',
            opportunityLane: 'Prebook'
          };
        }
        return {
          title: 'Healthy relationship',
          summary: 'Strong repeat patterns are still present across this guest history.',
          businessCategory: 'Appointment Growth',
          businessSubcategory: 'Due Soon',
          opportunityLane: 'Protect'
        };
      }

      function dueWorkflowChip(row){
        var taskLabel = retailTextValue(row && row.manager_task_status_label, '');
        if (taskLabel) {
          var taskTone = retailTextValue(row && row.manager_task_status_tone, 'muted').toLowerCase();
          if (['warning', 'accent', 'success', 'muted'].indexOf(taskTone) === -1) taskTone = 'muted';
          return {
            label: taskLabel,
            className: 'retail-chip retail-chip--workflow retail-chip--' + taskTone
          };
        }
        var normalizedDiagnosis = retailTextValue(row && (row.diagnosis_key || row.business_bucket_key || row.business_subcategory || row.history_rating), '').toLowerCase();
        var hasFuture = row && (row.has_future_appointment === true || row.future_appointment_found === true || !!retailTextValue(row.future_appointment_at, ''));
        var isActionable = !row || row.is_actionable !== false;
        if (isActionable && !hasFuture && /(lost|lapsed|long_lost)/.test(normalizedDiagnosis)) {
          return {
            label: 'Win Back',
            className: 'retail-chip retail-chip--workflow retail-chip--warning'
          };
        }
        if (isActionable && !hasFuture && /at_risk/.test(normalizedDiagnosis)) {
          return {
            label: 'Needs Manager',
            className: 'retail-chip retail-chip--workflow retail-chip--warning'
          };
        }
        var label = retailTextValue(row && row.workflow_state_label, '');
        if (!label) return null;
        var tone = retailTextValue(row && row.workflow_state_tone, 'muted').toLowerCase();
        if (['warning', 'accent', 'success', 'muted'].indexOf(tone) === -1) tone = 'muted';
        return {
          label: label,
          className: 'retail-chip retail-chip--workflow retail-chip--' + tone
        };
      }

      function dueOutcomeChip(row){
        var label = retailTextValue(row && row.outcome_state_label, '');
        if (!label) return null;
        var tone = retailTextValue(row && row.outcome_state_tone, 'success').toLowerCase();
        if (['warning', 'accent', 'success', 'muted'].indexOf(tone) === -1) tone = 'success';
        return {
          label: label,
          className: 'retail-chip retail-chip--workflow retail-chip--' + tone
        };
      }

      function dueFutureBookingSummary(row){
        var at = retailTextValue(row && row.future_appointment_at, '');
        if (!at) return '';
        var services = retailArray(row && row.future_appointment_services).filter(function(value){
          return !!retailTextValue(value, '');
        });
        return 'Booked ' + formatRecaptureDate(at) + (services.length ? ' • ' + services.slice(0, 2).join(', ') : '');
      }

      function dueFutureBookingSentence(row){
        var future = dueFutureBookingSummary(row);
        if (!future) return 'no future appointment';
        if (/^(none|no future booking|no future appointment)$/i.test(future)) return 'no future appointment';
        return future.toLowerCase();
      }

      function dueLatestLocationName(row){
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        var guestSignals = debug && debug.guest_signals && typeof debug.guest_signals === 'object' ? debug.guest_signals : {};
        return retailTextValue((guestSignals && guestSignals.latest_location_name) || row && row.latest_location_name, '');
      }

      function dueOpportunityPriorityLabel(row){
        var tier = retailTextValue(row && row.opportunity_priority_tier, '');
        if (!tier) return '';
        return tier.replace(/_/g, ' ').replace(/\b\w/g, function(char){ return char.toUpperCase(); });
      }

      function dueManagerSnapshotItems(row, outreach){
        var items = [];
        var locationName = dueLatestLocationName(row);
        var contactStatus = dueContactStatusText(outreach);
        var futureBooking = dueFutureBookingSummary(row);
        var latestDraft = outreach && outreach.latest_draft && typeof outreach.latest_draft === 'object' ? outreach.latest_draft : null;
        var draftReady = retailTextValue(latestDraft && latestDraft.message_body, '');
        var priorityLabel = dueOpportunityPriorityLabel(row);
        var duplicateCount = Number((row && row.duplicate_account_count) || 0) || 0;
        var primaryStaff = retailTextValue(row && row.primary_staff_name, '');
        var assignedManager = retailTextValue(row && row.manager_task_assigned_name, '');
        if (priorityLabel) items.push({ label: 'Priority', value: priorityLabel });
        if (assignedManager) items.push({ label: 'Owner', value: assignedManager });
        if (primaryStaff) items.push({ label: 'Stylist', value: primaryStaff });
        if (locationName) items.push({ label: 'Location', value: locationName });
        if (futureBooking) items.push({ label: 'Booking', value: futureBooking });
        if (contactStatus) items.push({ label: 'Contact', value: contactStatus });
        else if (draftReady) items.push({ label: 'Contact', value: 'Draft ready' });
        if (duplicateCount > 1) items.push({ label: 'Duplicates', value: String(duplicateCount) + ' accounts' });
        return items.slice(0, 4);
      }

      function dueTaskActionsMarkup(row){
        var status = retailTextValue(row && row.manager_task_status, '').toLowerCase();
        var key = retailTextValue(row && row.opportunity_key, '');
        if (!key) return '';
        var buttons = [];
        if (!status || status === 'needs_manager') {
          buttons.push('<button class="btn-secondary" type="button" data-task-action="assigned" data-opportunity-key="' + escapeHtml(key) + '">Claim</button>');
        }
        if (status !== 'working' && status !== 'completed') {
          buttons.push('<button class="btn-secondary" type="button" data-task-action="working" data-opportunity-key="' + escapeHtml(key) + '">In Progress</button>');
        }
        if (status !== 'completed') {
          buttons.push('<button class="btn-secondary" type="button" data-task-action="completed" data-opportunity-key="' + escapeHtml(key) + '">Mark Complete</button>');
        }
        if (status !== 'snoozed' && status !== 'completed') {
          buttons.push('<button class="btn-secondary" type="button" data-task-action="snoozed" data-opportunity-key="' + escapeHtml(key) + '">Follow Up Later</button>');
        }
        return buttons.join('');
      }

      function dueManagerTaskStatus(row){
        return retailTextValue(row && row.manager_task_status, '').toLowerCase();
      }

      function dueNeedsClaim(row){
        var status = dueManagerTaskStatus(row);
        return !status || status === 'needs_manager';
      }

      function dueIsClaimed(row){
        var status = dueManagerTaskStatus(row);
        return ['assigned', 'working', 'snoozed', 'completed'].indexOf(status) !== -1;
      }

      function dueShouldShowCommunication(row){
        return dueIsClaimed(row) && !dueHasBookedOutcome(row);
      }

      function duePrimaryActionMarkup(row){
        var bucketKey = String((row && row.guest_bucket_key) || '');
        if (dueHasBookedOutcome(row)) return '';
        if (dueNeedsClaim(row) || dueHasFutureBooking(row) || !bucketKey) return '';
        var firstName = dueFirstName(row && (row.guest_name || row.client_name)) || 'client';
        return '<button class="queue-opportunityInlineButton queue-opportunityInlineButton--primary" type="button" data-due-action="draft" data-due-bucket-key="' + escapeHtml(bucketKey) + '">Contact ' + escapeHtml(firstName) + '</button>';
      }

      function dueSecondaryActionMarkup(row){
        var bucketKey = String((row && row.guest_bucket_key) || '');
        if (!bucketKey || dueHasBookedOutcome(row) || dueNeedsClaim(row) || dueHasFutureBooking(row)) return '';
        return '<button class="btn-secondary" type="button" data-due-action="snooze-7" data-due-bucket-key="' + escapeHtml(bucketKey) + '">Later</button>';
      }

      function dueFocusPatternItem(items){
        var rows = dueGroupedPatterns(items)
          .filter(function(item){
            return item && duePatternIsReliable(item);
          })
          .sort(duePatternLastVisitSort);
        return rows[0] || null;
      }

      function dueGuestTimingSummary(row, focusItem){
        var focusLabel = retailTextValue(focusItem && focusItem.label, '');
        var cadenceDays = duePatternCadenceDays(focusItem);
        var focusLastVisit = retailTextValue(focusItem && focusItem.last_visit_at, '');
        var focusDaysOverdue = Number((focusItem && focusItem.days_overdue) || 0) || 0;
        var focusDaysSinceLastVisit = Number((focusItem && focusItem.days_since_last_visit) || 0) || 0;
        var focusDaysUntilDue = Math.max(0, (Number((focusItem && (focusItem.due_days || focusItem.cadence_days)) || 0) || 0) - focusDaysSinceLastVisit);
        var timing = focusItem ? dueTimingLabel(focusDaysOverdue, focusDaysUntilDue) : dueTimingLabel(Number((row && (row.days_overdue || row.max_days_overdue)) || 0) || 0, Number((row && row.days_until_due) || 0) || 0);
        var bits = [];
        if (focusLabel) bits.push('Routine: ' + focusLabel);
        if (cadenceDays > 0) bits.push('Every ' + String(cadenceDays) + ' days');
        if (focusLastVisit) bits.push('Last in ' + formatRecaptureDate(focusLastVisit));
        bits.push(timing.label + ' ' + timing.value);
        return bits.join(' • ');
      }

      function dueStrategyCardMarkup(row, focusItem){
        var safeRow = row && typeof row === 'object' ? row : {};
        var label = retailTextValue(focusItem && focusItem.label, '');
        var cadenceDays = duePatternCadenceDays(focusItem);
        var lastVisit = retailTextValue(focusItem && focusItem.last_visit_at, '') || retailTextValue(safeRow.last_appointment_date || safeRow.last_in_date || safeRow.last_in_at, '');
        var overdue = focusItem
          ? Number((focusItem && focusItem.days_overdue) || 0) || 0
          : Number((safeRow.days_overdue || safeRow.max_days_overdue) || 0) || 0;
        var focusDaysSinceLastVisit = Number((focusItem && focusItem.days_since_last_visit) || 0) || 0;
        var untilDue = focusItem
          ? Math.max(0, (Number((focusItem && (focusItem.due_days || focusItem.cadence_days)) || 0) || 0) - focusDaysSinceLastVisit)
          : Number(safeRow.days_until_due || 0) || 0;
        var timing = dueTimingLabel(overdue, untilDue);
        var bits = [];
        if (label) bits.push('Focus on ' + label.toLowerCase());
        if (lastVisit) bits.push('Last in ' + formatRecaptureDate(lastVisit));
        if (cadenceDays > 0) bits.push('Usually every ' + String(cadenceDays) + ' days');
        bits.push(timing.label + ' ' + timing.value);
        return ''
          + '<div class="queue-cardStrategy">'
          +   '<div class="queue-cardStrategyLabel">Strategy</div>'
          +   '<div class="queue-cardStrategyText">' + escapeHtml(bits.join(' • ')) + '</div>'
          + '</div>';
      }

      function dueFallbackAssessmentMarkup(row, focusItem, patternItems){
        var safeRow = row && typeof row === 'object' ? row : {};
        var groupedPatterns = dueGroupedPatterns(patternItems);
        var diagnosis = duePatternDiagnosis(row, groupedPatterns);
        var lastVisitRaw = retailTextValue((focusItem && focusItem.last_visit_at) || safeRow.last_appointment_date || safeRow.last_in_date || safeRow.last_in_at, '');
        var lastVisit = lastVisitRaw ? formatRecaptureDate(lastVisitRaw) : '';
        var lastService = retailTextValue(safeRow.last_service_name || (focusItem && focusItem.label), '');
        var futureBooking = dueFutureBookingSummary(row);
        var cancelCountAfterLastVisit = dueOverallCancelDateList(row).filter(function(entry){
          if (!lastVisitRaw) return true;
          var lastSeen = lastVisitRaw.indexOf('T') >= 0 ? new Date(lastVisitRaw) : new Date(lastVisitRaw + 'T12:00:00');
          if (isNaN(lastSeen.getTime())) return true;
          return entry && entry.date && entry.date.getTime() > lastSeen.getTime();
        }).length;
        var facts = [];
        if (lastVisit) facts.push({ label: 'Last visit', value: lastVisit });
        if (lastService) facts.push({ label: 'Latest service', value: lastService });
        if (futureBooking) facts.push({ label: 'Booked', value: futureBooking });
        else if (cancelCountAfterLastVisit > 0) facts.push({ label: 'Recent cancels', value: String(cancelCountAfterLastVisit) });
        else if (groupedPatterns.length) facts.push({ label: 'Tracked routines', value: String(groupedPatterns.length) });
        var summary = dueCleanOpportunityText(diagnosis && diagnosis.summary)
          || dueCleanOpportunityText(duePatternBreakSentence(row, focusItem))
          || 'There is not enough repeat history to trust one clean cadence yet, but this guest still needs a manager read.';
        var title = dueCleanOpportunityText(diagnosis && diagnosis.title) || 'Best current read';
        var action = dueCleanOpportunityText(dueRecommendedActionText(row));
        return ''
          + '<div class="queue-opportunityAssessment">'
          +   '<div class="queue-opportunitySnapshotCard">'
          +     '<div class="queue-opportunityEyebrow">Best current read</div>'
          +     '<div class="queue-opportunitySnapshotTitle">' + escapeHtml(title) + '</div>'
          +     '<div class="queue-opportunitySnapshotText">' + escapeHtml(summary) + '</div>'
          +     (facts.length
                ? '<div class="queue-cardQuickFacts">' + facts.map(function(item){
                    return '<div class="queue-cardQuickFact"><span>' + escapeHtml(retailTextValue(item && item.label, '')) + '</span><strong>' + escapeHtml(retailTextValue(item && item.value, '')) + '</strong></div>';
                  }).join('') + '</div>'
                : '')
          +     (action ? '<div class="queue-cardStrategy queue-cardStrategy--recovery"><div class="queue-cardStrategyLabel">Next move</div><div class="queue-cardStrategyText">' + escapeHtml(action) + '</div></div>' : '')
          +   '</div>'
          + '</div>';
      }

      function dueOutcomeActionsMarkup(row){
        var key = retailTextValue(row && row.opportunity_key, '');
        if (!key) return '';
        var source = retailTextValue(row && row.queue_source, 'appointment').toLowerCase();
        var buttons = [];
        if (source === 'retail') {
          buttons.push('<button class="btn-secondary" type="button" data-outcome-action="retail_purchased" data-opportunity-key="' + escapeHtml(key) + '">Purchased</button>');
        } else if (source === 'review') {
          buttons.push('<button class="btn-secondary" type="button" data-outcome-action="review_completed" data-opportunity-key="' + escapeHtml(key) + '">Review Done</button>');
        } else if (source === 'referral') {
          buttons.push('<button class="btn-secondary" type="button" data-outcome-action="referral_booked" data-opportunity-key="' + escapeHtml(key) + '">Referral Won</button>');
        } else {
          if (!dueHasFutureBooking(row) && !dueHasBookedOutcome(row)) {
            buttons.push('<button class="btn-secondary" type="button" data-outcome-action="appointment_booked" data-opportunity-key="' + escapeHtml(key) + '">Booked</button>');
          }
        }
        if (!dueHasBookedOutcome(row) && !dueHasFutureBooking(row)) {
          buttons.push('<button class="btn-secondary" type="button" data-outcome-action="no_response" data-opportunity-key="' + escapeHtml(key) + '">No Response</button>');
        }
        return buttons.join('');
      }

      function dueManagerSnapshotMarkup(items){
        var safeItems = retailArray(items).filter(function(item){
          return item && retailTextValue(item.label, '') && retailTextValue(item.value, '');
        });
        if (!safeItems.length) return '';
        return safeItems.map(function(item){
          return ''
            + '<div class="queue-cardSnapshotItem">'
            +   '<span class="queue-cardSnapshotLabel">' + escapeHtml(retailTextValue(item.label, '')) + '</span>'
            +   '<strong>' + escapeHtml(retailTextValue(item.value, '')) + '</strong>'
            + '</div>';
        }).join('');
      }

      function duePatternMatchedServiceText(item){
        var serviceNames = retailArray(item && item.service_names).filter(function(name){
          return !!retailTextValue(name, '');
        });
        return serviceNames.length ? serviceNames.join(', ') : '';
      }

      function duePatternCadenceDays(item){
        return Math.max(0, Number((item && (item.cadence_days || item.due_days)) || 0) || 0);
      }

      function duePatternLeadText(item){
        var label = retailTextValue(item && item.label, 'Visit');
        var cadenceDays = duePatternCadenceDays(item);
        return label + (cadenceDays > 0 ? ' every ' + String(cadenceDays) + 'd' : '');
      }

      function duePatternVisualMarkersMarkup(item){
        var sampleSize = Math.max(0, duePatternSampleSize(item));
        var visibleCount = Math.max(3, Math.min(sampleSize || 3, 6));
        var markers = [];
        for (var index = 0; index < visibleCount; index += 1) {
          markers.push('<span class="queue-patternRhythmDot' + (index === visibleCount - 1 ? ' is-last' : '') + '"></span>');
        }
        return markers.join('');
      }

      function duePatternRowsMarkup(items){
        var rows = dueGroupedPatterns(items)
          .filter(function(item){
            return item && (item.label || item.cadence_days || item.due_days || item.last_visit_at || item.due_at);
          })
          .sort(duePatternLastVisitSort);
        if (!rows.length) return '';
        return rows.map(function(item){
          var label = retailTextValue(item && item.label, 'Visit');
          var cadenceDays = duePatternCadenceDays(item);
          var statusText = duePatternStatusText(item);
          var lastVisit = formatRecaptureDate(retailTextValue(item && item.last_visit_at, ''));
          var dueAt = formatRecaptureDate(retailTextValue(item && item.due_at, ''));
          var matchedServices = duePatternMatchedServiceText(item);
          var sampleSize = duePatternSampleSize(item);
          var daysOverdue = Number((item && item.days_overdue) || 0) || 0;
          var daysSinceLastVisit = Number((item && item.days_since_last_visit) || 0) || 0;
          var daysUntilDue = Math.max(0, (Number((item && (item.due_days || item.cadence_days)) || 0) || 0) - daysSinceLastVisit);
          var urgencyTone = dueUrgencyTone(daysOverdue, daysUntilDue);
          if (statusText && statusText !== 'Timing unavailable') {
            if (statusText.indexOf('Due now') === 0) urgencyTone = 'soon';
            else if (statusText.indexOf('Due in') === 0) urgencyTone = 'upcoming';
          }
          var storyLabel = daysOverdue > 0
            ? 'Pattern broke after the expected return.'
            : daysUntilDue <= 7
              ? 'Guest is at the expected return window now.'
              : 'Pattern still looks intact, but the next visit is approaching.';
          var urgencyMarkup = (statusText && statusText !== 'Timing unavailable')
            ? '<div class="queue-detailPatternUrgency queue-detailPatternUrgency--' + escapeHtml(urgencyTone) + '">' + escapeHtml(statusText) + '</div>'
            : '';
          return ''
            + '<div class="queue-detailPatternCard queue-detailPatternCard--' + escapeHtml(urgencyTone) + '">'
            +   '<div class="queue-detailPatternTop">'
            +     '<div class="queue-detailPatternMain">'
            +       '<div class="queue-detailPatternService">' + escapeHtml(label) + '</div>'
            +       (cadenceDays > 0 ? '<div class="queue-detailPatternCadence">Usually every ' + escapeHtml(String(cadenceDays)) + ' days</div>' : '')
            +     '</div>'
            +     urgencyMarkup
            +   '</div>'
            +   '<div class="queue-patternRhythm">'
            +     '<div class="queue-patternRhythmTrack">' + duePatternVisualMarkersMarkup(item) + '</div>'
            +     '<div class="queue-patternRhythmArrow"></div>'
            +     '<div class="queue-patternRhythmBreak queue-patternRhythmBreak--' + escapeHtml(urgencyTone) + '"></div>'
            +   '</div>'
            +   (((lastVisit && lastVisit !== 'Unknown') || (dueAt && dueAt !== 'Unknown')) ? '<div class="queue-detailPatternMeta">'
            +     [
                    (lastVisit && lastVisit !== 'Unknown') ? 'Last in ' + lastVisit : '',
                    (dueAt && dueAt !== 'Unknown') ? 'Due ' + dueAt : ''
                  ].filter(Boolean).map(escapeHtml).join(' • ')
            +   '</div>' : '')
            +   '<div class="queue-detailPatternStory">' + escapeHtml(storyLabel) + '</div>'
            +   (sampleSize > 0 ? '<div class="queue-detailPatternMeta">Based on ' + escapeHtml(String(sampleSize)) + ' similar visits.</div>' : '')
            +   (matchedServices ? '<div class="queue-detailPatternMeta">Services: ' + escapeHtml(matchedServices) + '</div>' : '')
            + '</div>';
        }).join('');
      }

      function duePrimaryRoutineMarkup(items){
        var rows = dueGroupedPatterns(items)
          .filter(function(item){
            return item && duePatternIsReliable(item);
          })
          .sort(duePatternLastVisitSort);
        var item = rows[0] || null;
        if (!item) return '';
        var label = retailTextValue(item && item.label, 'Visit');
        var cadenceDays = duePatternCadenceDays(item);
        var sampleSize = duePatternSampleSize(item);
        var daysOverdue = Number((item && item.days_overdue) || 0) || 0;
        var daysUntilDue = Math.max(0, (Number((item && (item.due_days || item.cadence_days)) || 0) || 0) - (Number((item && item.days_since_last_visit) || 0) || 0));
        var dueTiming = dueTimingLabel(daysOverdue, daysUntilDue);
        var urgencyTone = dueUrgencyTone(daysOverdue, daysUntilDue);
        var lastVisit = formatRecaptureDate(retailTextValue(item && item.last_visit_at, ''));
        var metaBits = [];
        if (sampleSize > 0) metaBits.push(String(sampleSize) + ' Matching Visit' + (sampleSize === 1 ? '' : 's'));
        if (lastVisit && lastVisit !== 'Unknown') metaBits.push('Last in ' + lastVisit);
        return ''
          + '<div class="queue-cardPrimaryRoutine">'
          +   '<div class="queue-cardPrimaryRoutineMain">'
          +     '<div class="queue-cardPrimaryRoutineTitle">' + escapeHtml(label) + '</div>'
          +     (cadenceDays > 0 ? '<div class="queue-cardPrimaryRoutineCadence">Every ' + escapeHtml(String(cadenceDays)) + ' Days</div>' : '')
          +     (metaBits.length ? '<div class="queue-cardPrimaryRoutineMeta">' + escapeHtml(metaBits.join(' • ')) + '</div>' : '')
          +   '</div>'
          +   '<div class="queue-cardPrimaryRoutineUrgency queue-cardPrimaryRoutineUrgency--' + escapeHtml(urgencyTone) + '">'
          +     '<span>' + escapeHtml(dueTiming.label) + '</span>'
          +     '<strong>' + escapeHtml(dueTiming.value) + '</strong>'
          +   '</div>'
          + '</div>';
      }

      function dueTimingLabel(daysOverdue, daysUntilDue){
        var overdue = Number(daysOverdue || 0) || 0;
        var untilDue = Number(daysUntilDue || 0) || 0;
        if (overdue > 0) {
          return {
            label: 'Overdue',
            value: String(overdue) + 'd'
          };
        }
        return {
          label: 'Due in',
          value: String(Math.max(0, untilDue)) + 'd'
        };
      }

      function dueUrgencyTone(daysOverdue, daysUntilDue){
        var overdue = Number(daysOverdue || 0) || 0;
        var untilDue = Number(daysUntilDue || 0) || 0;
        if (overdue > 0) return 'overdue';
        if (untilDue <= 7) return 'soon';
        return 'upcoming';
      }

      function duePrimaryStatusBadge(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        if (safeRow.has_future_appointment === true || safeRow.future_appointment_found === true) return 'Booked';
        var overdue = Number((safeRow.days_overdue || safeRow.max_days_overdue) || 0) || 0;
        var stage = String(safeRow.queue_stage || '').trim().toLowerCase();
        if (overdue > 0) return 'Overdue';
        if (stage === 'non_current_recapture' || stage === 'recapture') return 'Recapture';
        return 'Needs Prebooking';
      }

      function duePrimaryStatusBadgeClass(label){
        var normalized = String(label || '').trim().toLowerCase();
        if (normalized === 'booked') return 'retail-chip retail-chip--muted';
        if (normalized === 'overdue') return 'retail-chip retail-chip--warning';
        if (normalized === 'recapture') return 'retail-chip retail-chip--accent';
        return 'retail-chip retail-chip--success';
      }

      function duePrimaryReasonLine(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        if (safeRow.has_future_appointment === true || safeRow.future_appointment_found === true) {
          return 'Future appointment already booked.';
        }
        var overdue = Number((safeRow.days_overdue || safeRow.max_days_overdue) || 0) || 0;
        var stage = String(safeRow.queue_stage || '').trim().toLowerCase();
        if (overdue > 0 || stage === 'non_current_recapture' || stage === 'recapture') {
          return 'They are past their normal timing and do not have the next visit booked.';
        }
        return 'They are still within routine, but the next visit is not booked yet.';
      }

      function dueHistoryRatingKey(value){
        return String(value || '').trim().toLowerCase().replace(/\s+/g, '_');
      }

      function dueDiagnosisTone(title){
        var normalized = String(title || '').trim().toLowerCase();
        if (normalized === 'already booked') return 'muted';
        if (normalized === 'at risk') return 'warning';
        if (normalized === 'mixed routine') return 'accent';
        if (normalized === 'early pattern') return 'muted';
        return 'success';
      }

      function dueNurtureTag(historyRating){
        var key = dueHistoryRatingKey(historyRating);
        if (key === 'new_guest') {
          return {
            label: 'Needs nurture',
            className: 'retail-chip retail-chip--nurture'
          };
        }
        if (key === 'growing_guest') {
          return {
            label: 'Growing relationship',
            className: 'retail-chip retail-chip--history'
          };
        }
        return null;
      }

      function duePatternStackMarkup(items){
        var rows = dueGroupedPatterns(items)
          .filter(function(item){
            return item && (item.label || item.cadence_days || item.due_days || item.last_visit_at || item.due_at);
          })
          .filter(function(item){
            return duePatternIsReliable(item);
          })
          .sort(duePatternLastVisitSort);
        if (!rows.length) return '';
        return rows.map(function(item, index){
          var label = retailTextValue(item && item.label, 'Visit');
          var cadenceDays = Number((item && (item.cadence_days || item.due_days)) || 0) || 0;
          var sampleSize = duePatternSampleSize(item);
          var daysOverdue = Number((item && item.days_overdue) || 0) || 0;
          var daysUntilDue = Math.max(0, (Number((item && (item.due_days || item.cadence_days)) || 0) || 0) - (Number((item && item.days_since_last_visit) || 0) || 0));
          var dueTiming = dueTimingLabel(daysOverdue, daysUntilDue);
          var urgencyTone = dueUrgencyTone(daysOverdue, daysUntilDue);
          var lastVisit = formatRecaptureDate(retailTextValue(item && item.last_visit_at, ''));
          var dueAt = formatRecaptureDate(retailTextValue(item && item.due_at, ''));
          return ''
            + '<div class="queue-patternCard' + (index === 0 ? ' queue-patternCard--primary' : '') + '">'
            +   '<div class="queue-patternTop">'
            +     '<div class="queue-patternMain">'
            +       '<div class="queue-patternService">' + escapeHtml(label) + '</div>'
            +       '<div class="queue-patternCadence">Every ' + escapeHtml(String(cadenceDays || 0)) + ' Days</div>'
            +       (sampleSize > 0 ? '<div class="queue-patternMeta">' + escapeHtml(String(sampleSize)) + ' Matching Visits</div>' : '')
            +     '</div>'
            +     '<div class="queue-patternUrgency queue-patternUrgency--' + escapeHtml(urgencyTone) + '">'
            +       '<span class="queue-patternUrgencyLabel">' + escapeHtml(dueTiming.label) + '</span>'
            +       '<strong>' + escapeHtml(dueTiming.value) + '</strong>'
            +     '</div>'
            +   '</div>'
            +   '<div class="queue-patternDates">' + escapeHtml(lastVisit) + ' → ' + escapeHtml(dueAt) + '</div>'
            + '</div>';
        }).join('');
      }

      function dueStageLabel(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'current_needs_prebooking' || normalized === 'needs_prebooking') return 'Current / Needs Prebooking';
        if (normalized === 'non_current_recapture' || normalized === 'recapture') return 'Non-Current / Need Follow-Up';
        if (normalized === 'future_booked_suppressed' || normalized === 'future_booked') return 'Already Future Booked';
        return 'Visible Queue Client';
      }

      function dueStageDescriptionText(stage){
        var normalized = String(stage || '').trim().toLowerCase();
        if (normalized === 'current_needs_prebooking') {
          return 'Current clients are still within cadence but need their next visit prebooked.';
        }
        if (normalized === 'non_current_recapture') {
          return 'Non-current clients are past cadence and need follow-up.';
        }
        return 'Shows the highest-priority appointment growth opportunities across the full queue.';
      }

      function dueSortLabel(value){
        var normalized = String(value || '').trim();
        if (normalized === 'priority_score') return 'Highest business priority';
        if (normalized === 'due_soonest') return 'Due soonest';
        if (normalized === 'most_overdue') return 'Most overdue';
        if (normalized === 'last_visit_newest') return 'Last visit newest';
        if (normalized === 'last_visit_oldest') return 'Last visit oldest';
        if (normalized === 'highest_appointment_count') return 'Highest appointment count';
        if (normalized === 'guest_name') return 'Guest name';
        if (normalized === 'primary_staff') return 'Primary staff';
        if (normalized === 'category') return 'Category';
        return normalized || 'Custom';
      }

      function dueHistoryRatingLabel(value){
        var normalized = String(value || '').trim();
        if (!normalized) return '';
        return normalized.replace(/_/g, ' ').replace(/\b\w/g, function(char){
          return char.toUpperCase();
        });
      }

      function dueContactStatusText(outreach){
        var lastContactedAt = outreach && outreach.last_contacted_at ? String(outreach.last_contacted_at) : '';
        if (!lastContactedAt) return '';
        var formatted = formatRequestReviewDates([lastContactedAt]);
        var today = new Date();
        var sentDate = new Date(lastContactedAt);
        var isToday = !isNaN(sentDate.getTime())
          && sentDate.getFullYear() === today.getFullYear()
          && sentDate.getMonth() === today.getMonth()
          && sentDate.getDate() === today.getDate();
        return isToday ? 'Contacted today' : 'Last contacted ' + formatted;
      }

      function getDueOfferText(key){
        var normalized = String(key || '').trim();
        var match = getDueOfferOption(normalized);
        return match ? retailTextValue(match.text, '') : '';
      }

      function getDueOfferOption(key){
        var normalized = String(key || '').trim();
        return retailArray(dueQueueOfferOptions).find(function(option){
          return String(option && option.key || '') === normalized;
        }) || null;
      }

      function defaultDueOfferOptions(){
        return [
          { key: 'none', label: 'No offer', text: '' },
          { key: 'complimentary_gloss', label: 'Complimentary gloss with color service', text: 'a complimentary gloss with your color service' },
          { key: 'color_25_off', label: '$25 off your next color appointment', text: '$25 off your next color appointment' },
          { key: 'free_treatment_blowout', label: 'Free treatment with blowout', text: 'a free treatment with your next blowout' },
          { key: 'custom', label: 'Custom manager-written offer', text: '' }
        ];
      }

      function getDueQueueFilterConfig(){
        return {
          key: String((dueCategoryFilter && dueCategoryFilter.value) || '').trim() || 'all',
          category: String((dueCategoryFilter && dueCategoryFilter.value) || '').trim(),
          duplicateOnly: !!(dueDuplicatesOnly && dueDuplicatesOnly.checked),
          label: String((dueCategoryFilter && dueCategoryFilter.value) || '').trim() || 'all'
        };
      }

      function applyDueWorkspaceSelection(workspaceKey){
        var nextWorkspace = String(workspaceKey || '').trim() || 'all';
        dueQueueWorkspace = nextWorkspace;
        if (nextWorkspace === 'my_claimed') {
          dueQueueWorkflowFilter = 'mine';
          dueQueueOwnerFilter = 'mine';
          dueQueueOpportunityFilter = 'all';
          dueQueueActiveStage = 'all';
          return;
        }
        if (nextWorkspace === 'never_visited') {
          dueQueueWorkflowFilter = 'all';
          dueQueueOwnerFilter = 'all';
          dueQueueOpportunityFilter = 'all';
          dueQueueActiveStage = 'all';
          dueQueueSortMode = 'last_visit_newest';
          return;
        }
        if (nextWorkspace === 'needs_prebook') {
          dueQueueWorkflowFilter = 'all';
          dueQueueOwnerFilter = 'all';
          dueQueueOpportunityFilter = 'all';
          dueQueueActiveStage = 'all';
          dueQueueSortMode = 'due_soonest';
          return;
        }
        if (nextWorkspace === 'needs_attention' || nextWorkspace === 'needs_recovery') {
          dueQueueWorkflowFilter = 'all';
          dueQueueOwnerFilter = 'all';
          dueQueueOpportunityFilter = 'all';
          dueQueueActiveStage = 'all';
          dueQueueSortMode = 'most_overdue';
          return;
        }
        if (nextWorkspace === 'no_pattern') {
          dueQueueWorkflowFilter = 'all';
          dueQueueOwnerFilter = 'all';
          dueQueueOpportunityFilter = 'all';
          dueQueueActiveStage = 'all';
          dueQueueSortMode = 'last_visit_newest';
          return;
        }
        if (nextWorkspace === 'watch_due_soon' || nextWorkspace === 'watch_due_now' || nextWorkspace === 'prebook') {
          dueQueueWorkflowFilter = 'all';
          dueQueueOwnerFilter = 'all';
          dueQueueOpportunityFilter = 'all';
          dueQueueActiveStage = 'all';
          dueQueueSortMode = 'due_soonest';
          return;
        }
        if (
          nextWorkspace === 'at_risk_cadence_break'
          || nextWorkspace === 'at_risk_canceled_unbooked'
          || nextWorkspace === 'at_risk_no_show_unbooked'
          || nextWorkspace === 'at_risk_declining_frequency'
          || nextWorkspace === 'at_risk_partial_return'
          || nextWorkspace === 'lost_likely_lapsed'
          || nextWorkspace === 'active_drift'
          || nextWorkspace === 'long_lost'
        ) {
          dueQueueWorkflowFilter = 'all';
          dueQueueOwnerFilter = 'all';
          dueQueueOpportunityFilter = 'all';
          dueQueueActiveStage = 'all';
          return;
        }
        if (nextWorkspace === 'retail') {
          dueQueueWorkflowFilter = 'all';
          dueQueueOwnerFilter = 'all';
          dueQueueOpportunityFilter = 'retail_opportunity';
          dueQueueActiveStage = 'all';
          return;
        }
        if (nextWorkspace === 'referral') {
          dueQueueWorkflowFilter = 'all';
          dueQueueOwnerFilter = 'all';
          dueQueueOpportunityFilter = 'referral_opportunity';
          dueQueueActiveStage = 'all';
          return;
        }
        if (nextWorkspace === 'review') {
          dueQueueWorkflowFilter = 'all';
          dueQueueOwnerFilter = 'all';
          dueQueueOpportunityFilter = 'review_opportunity';
          dueQueueActiveStage = 'all';
          return;
        }
        dueQueueWorkflowFilter = 'all';
        dueQueueOwnerFilter = 'all';
        dueQueueOpportunityFilter = 'all';
        dueQueueActiveStage = 'all';
      }

      function syncDueWorkspaceTabs(){
        if (!dueWorkspaceTabs) return;
        Array.prototype.forEach.call(dueWorkspaceTabs.querySelectorAll('[data-due-workspace]'), function(button){
          var isActive = String(button.getAttribute('data-due-workspace') || '') === String(dueQueueWorkspace || 'all');
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function syncDueStageTabs(){
        if (!dueStageTabs) return;
        Array.prototype.forEach.call(dueStageTabs.querySelectorAll('[data-due-stage]'), function(button){
          var isActive = String(button.getAttribute('data-due-stage') || '') === String(dueQueueActiveStage || 'all');
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        if (dueStageDescription) {
          dueStageDescription.textContent = dueStageDescriptionText(dueQueueActiveStage);
        }
      }

      function syncDueOpportunityTabs(){
        if (!dueOpportunityTabs) return;
        Array.prototype.forEach.call(dueOpportunityTabs.querySelectorAll('[data-due-opportunity]'), function(button){
          var isActive = String(button.getAttribute('data-due-opportunity') || '') === String(dueQueueOpportunityFilter || 'all');
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function syncDueWorkflowTabs(){
        if (!dueWorkflowTabs) return;
        if (dueSubTabs) {
          dueSubTabs.hidden = String(dueQueueWorkspace || 'all').trim() === 'my_claimed';
        }
        Array.prototype.forEach.call(dueWorkflowTabs.querySelectorAll('[data-due-workflow]'), function(button){
          var isActive = String(button.getAttribute('data-due-workflow') || '') === String(dueQueueWorkflowFilter || 'all');
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function syncDueOwnerTabs(){
        if (!dueOwnerTabs) return;
        Array.prototype.forEach.call(dueOwnerTabs.querySelectorAll('[data-due-owner]'), function(button){
          var isActive = String(button.getAttribute('data-due-owner') || '') === String(dueQueueOwnerFilter || 'all');
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function syncDueScorecardRangeTabs(){
        if (!dueScorecardRangeTabs) return;
        Array.prototype.forEach.call(dueScorecardRangeTabs.querySelectorAll('[data-due-scorecard-range]'), function(button){
          var rangeValue = Number(String(button.getAttribute('data-due-scorecard-range') || '').trim() || '30');
          var isActive = rangeValue === dueScorecardLookbackDays;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function syncDueScorecardAudienceTabs(){
        if (!dueScorecardAudienceTabs) return;
        Array.prototype.forEach.call(dueScorecardAudienceTabs.querySelectorAll('[data-due-scorecard-focus]'), function(button){
          var focusValue = String(button.getAttribute('data-due-scorecard-focus') || '').trim() || 'team';
          var isActive = focusValue === dueScorecardFocus;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function syncDueQueueTabs(){
        if (!dueQueueTabs) return;
        Array.prototype.forEach.call(dueQueueTabs.querySelectorAll('[data-due-filter]'), function(button){
          var isActive = String(button.getAttribute('data-due-filter') || '') === String(dueQueueActiveFilter || 'all');
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function syncDueSortTabs(){
        if (dueSortSelect) {
          dueSortSelect.value = String(dueQueueSortMode || 'due_soonest');
        }
      }

      function syncDueClientTypeTabs(){
        if (!dueClientTypeTabs) return;
        Array.prototype.forEach.call(dueClientTypeTabs.querySelectorAll('[data-due-client-type]'), function(button){
          var isActive = String(button.getAttribute('data-due-client-type') || '') === String(dueQueueActiveClientType || 'all');
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function formatRecaptureDate(value){
        var raw = String(value || '').trim();
        if (!raw) return 'Unknown';
        var parsed = raw.indexOf('T') >= 0 ? new Date(raw) : new Date(raw + 'T12:00:00');
        if (isNaN(parsed.getTime())) return raw;
        var options = {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        };
        return parsed.toLocaleDateString(undefined, options);
      }

      function getDaysSinceDate(value){
        var raw = String(value || '').trim();
        if (!raw) return null;
        var parsed = raw.indexOf('T') >= 0 ? new Date(raw) : new Date(raw + 'T12:00:00');
        if (isNaN(parsed.getTime())) return null;
        var now = new Date();
        var startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var startOfSeen = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
        return Math.max(0, Math.round((startOfToday.getTime() - startOfSeen.getTime()) / 86400000));
      }

      function dueOfferSelectOptionsMarkup(selectedKey){
        return retailArray(dueQueueOfferOptions).map(function(option){
          var key = String(option && option.key || '').trim();
          var label = retailTextValue(option && option.label, key || 'Offer');
          var selected = key === String(selectedKey || 'none') ? ' selected' : '';
          return '<option value="' + escapeHtml(key) + '"' + selected + '>' + escapeHtml(label) + '</option>';
        }).join('');
      }

      function dueClientStageLabel(row){
        var explicit = retailTextValue(row && row.history_rating, '').toLowerCase();
        if (explicit === 'new_guest') return 'New';
        if (explicit === 'growing_guest') return 'Growing';
        if (explicit === 'established_regular') return 'Established';
        if (explicit === 'loyal_regular') return 'Loyal';
        var visits = Math.max(0, Number((row && row.appointment_count) || 0) || 0);
        if (visits >= 12) return 'Loyal';
        if (visits >= 6) return 'Established';
        if (visits >= 3) return 'Growing';
        return 'New';
      }

      function dueRiskState(row, focusItem){
        var safeRow = row && typeof row === 'object' ? row : {};
        if (safeRow.has_future_appointment === true || safeRow.future_appointment_found === true) {
          return {
            label: 'Booked',
            tone: 'booked',
            detail: 'future appointment set'
          };
        }
        var overdue = focusItem
          ? Number((focusItem && focusItem.days_overdue) || 0) || 0
          : Number((safeRow.days_overdue || safeRow.max_days_overdue) || 0) || 0;
        var untilDue = focusItem
          ? Math.max(0, (Number((focusItem && (focusItem.due_days || focusItem.cadence_days)) || 0) || 0) - (Number((focusItem && focusItem.days_since_last_visit) || 0) || 0))
          : Math.max(0, Number(safeRow.days_until_due || 0) || 0);
        if (overdue >= 90) {
          return { label: 'Lost', tone: 'lost', detail: String(overdue) + ' days overdue' };
        }
        if (overdue >= 30) {
          return { label: 'High Risk', tone: 'high', detail: String(overdue) + ' days overdue' };
        }
        if (overdue > 0) {
          return { label: 'Medium Risk', tone: 'medium', detail: String(overdue) + ' days overdue' };
        }
        return {
          label: 'Watch',
          tone: 'watch',
          detail: untilDue <= 0 ? 'due now' : 'due in ' + String(untilDue) + ' days'
        };
      }

      function duePatternBreakSentence(row, focusItem){
        var safeRow = row && typeof row === 'object' ? row : {};
        var clientName = retailTextValue(safeRow.guest_name || safeRow.client_name, 'This client');
        var serviceLabel = retailTextValue(focusItem && focusItem.label, '') || retailTextValue(safeRow.primary_label || safeRow.service_category, 'their usual service');
        var cadenceDays = duePatternCadenceDays(focusItem) || Math.max(0, Number(safeRow.cadence_days || 0) || 0);
        var daysSince = focusItem
          ? Number((focusItem && focusItem.days_since_last_visit) || 0) || 0
          : Number(safeRow.days_since_last_visit || 0) || 0;
        var daysOverdue = focusItem
          ? Number((focusItem && focusItem.days_overdue) || 0) || 0
          : Number((safeRow.days_overdue || safeRow.max_days_overdue) || 0) || 0;
        var futureBooked = safeRow.has_future_appointment === true || safeRow.future_appointment_found === true;
        if (futureBooked) {
          return clientName + ' already has a future appointment booked, so this opportunity is now in monitor mode.';
        }
        if (cadenceDays > 0 && daysOverdue > 0) {
          return clientName + ' usually comes in about every ' + String(cadenceDays) + ' days for ' + serviceLabel.toLowerCase() + '. It has been ' + String(daysSince) + ' days since the last visit and nothing new is booked.';
        }
        if (cadenceDays > 0) {
          return clientName + ' is approaching the usual ' + serviceLabel.toLowerCase() + ' return window. It has been ' + String(daysSince) + ' days since the last visit and the next appointment is still open.';
        }
        return retailTextValue(safeRow.explanation, '') || 'The guest does not have the next visit booked and should be checked in on now.';
      }

      function duePatternBreakFactsMarkup(row, focusItem){
        var safeRow = row && typeof row === 'object' ? row : {};
        var lastVisit = retailTextValue(focusItem && focusItem.last_visit_at, '') || retailTextValue(safeRow.last_appointment_date || safeRow.last_in_date || safeRow.last_in_at, '');
        var cadenceDays = duePatternCadenceDays(focusItem) || Math.max(0, Number(safeRow.cadence_days || 0) || 0);
        var daysSince = focusItem
          ? Number((focusItem && focusItem.days_since_last_visit) || 0) || 0
          : Number(safeRow.days_since_last_visit || 0) || 0;
        var daysOverdue = focusItem
          ? Number((focusItem && focusItem.days_overdue) || 0) || 0
          : Number((safeRow.days_overdue || safeRow.max_days_overdue) || 0) || 0;
        var facts = [
          { label: 'Last visit', value: lastVisit ? formatRecaptureDate(lastVisit) : 'Unknown' },
          cadenceDays > 0 ? { label: 'Typical cadence', value: String(cadenceDays) + ' days' } : null,
          { label: daysOverdue > 0 ? 'Current gap' : 'Status', value: daysOverdue > 0 ? String(Math.max(0, daysSince)) + ' days' : dueRiskState(row, focusItem).detail }
        ].filter(Boolean);
        return ''
          + '<div class="queue-opportunityFacts">'
          + facts.map(function(item){
            return ''
              + '<div class="queue-opportunityFact">'
              +   '<span>' + escapeHtml(retailTextValue(item && item.label, '')) + '</span>'
              +   '<strong>' + escapeHtml(retailTextValue(item && item.value, '')) + '</strong>'
              + '</div>';
          }).join('')
          + '</div>';
      }

      function dueRecommendedActionText(row){
        var action = retailTextValue(row && row.recommended_action, '');
        var stylist = retailTextValue(row && row.primary_staff_name, '');
        if (!action && stylist) {
          return 'Start with a personal check-in from ' + stylist + '.';
        }
        if (!action) return 'Reach out and help get the next visit booked.';
        if (stylist && action.toLowerCase().indexOf('manager') === -1 && action.toLowerCase().indexOf(stylist.toLowerCase()) === -1) {
          return action + ' Start with ' + stylist + ' if a personal touch will help.';
        }
        return action;
      }

      function dueOwnerStatusMarkup(row){
        var owner = retailTextValue(row && row.manager_task_assigned_name, '');
        var workflow = dueWorkflowChip(row);
        var lastAction = dueLastActionSummary(row);
        return ''
          + '<div class="queue-opportunityOwnership">'
          +   '<div class="queue-opportunityOwnershipMain">'
          +     '<span class="queue-opportunityOwnershipLabel">Status</span>'
          +     '<strong>' + escapeHtml(owner ? ('Owned by ' + owner) : 'Unclaimed') + '</strong>'
          +   '</div>'
          +   (workflow ? '<span class="' + escapeHtml(workflow.className) + '">' + escapeHtml(workflow.label) + '</span>' : '')
          +   (lastAction ? '<div class="queue-opportunityOwnershipMeta">' + escapeHtml(lastAction) + '</div>' : '')
          + '</div>';
      }

      function dueClientInitials(name){
        var parts = retailTextValue(name, '')
          .split(/\s+/)
          .filter(Boolean)
          .slice(0, 2);
        if (!parts.length) return 'HS';
        return parts.map(function(part){ return part.charAt(0).toUpperCase(); }).join('');
      }

      function dueCadenceFriendlyText(days){
        var cadenceDays = Math.max(0, Number(days || 0) || 0);
        if (!cadenceDays) return '';
        if (cadenceDays >= 28) {
          var lowWeeks = Math.max(1, Math.floor(Math.max(7, cadenceDays - 6) / 7));
          var highWeeks = Math.max(lowWeeks, Math.ceil((cadenceDays + 6) / 7));
          return 'Every ' + String(lowWeeks) + (highWeeks > lowWeeks ? '–' + String(highWeeks) : '') + ' weeks';
        }
        if (cadenceDays >= 14) {
          var roundedWeeks = Math.max(2, Math.round(cadenceDays / 7));
          return 'About every ' + String(roundedWeeks) + ' weeks';
        }
        return 'About every ' + String(cadenceDays) + ' days';
      }

      function dueWeeksPastText(daysOverdue){
        var overdueDays = Math.max(0, Number(daysOverdue || 0) || 0);
        if (!overdueDays) return '';
        var weeks = Math.max(1, Math.round(overdueDays / 7));
        return String(weeks) + ' week' + (weeks === 1 ? '' : 's') + ' beyond rhythm';
      }

      function dueCleanOpportunityText(value){
        return retailTextValue(value, '')
          .replace(/\bNaN0?\b/gi, '')
          .replace(/\s{2,}/g, ' ')
          .trim();
      }

      function duePatternStrengthDescriptor(item, effectiveSampleSize){
        var sampleSize = Math.max(0, Number(effectiveSampleSize != null ? effectiveSampleSize : duePatternSampleSize(item)) || 0);
        var source = retailTextValue(item && item.cadence_source, '').toLowerCase();
        if (source === 'personalized' && sampleSize >= 5) return 'Strong pattern';
        if (source === 'personalized' && sampleSize >= 3) return 'Clear pattern';
        if (sampleSize >= 3) return 'Pattern set';
        if (sampleSize >= 2) return 'Emerging pattern';
        return 'Light pattern';
      }

      function dueOpportunityHeadline(row, focusItem){
        var safeRow = row && typeof row === 'object' ? row : {};
        if (safeRow.has_future_appointment === true || safeRow.future_appointment_found === true) {
          return 'Future visit already secured.';
        }
        var routineSignal = dueOpportunityRoutineSignal(row, focusItem);
        var familyLabel = retailTextValue(routineSignal && routineSignal.titleLabel, duePatternFamilyLabel(duePatternFamilyKey(focusItem), retailTextValue(focusItem && focusItem.label, 'Routine')));
        var overdue = Number((focusItem && focusItem.days_overdue) || safeRow.max_days_overdue || 0) || 0;
        if (overdue > 0) {
          return familyLabel + ' routine has broken.';
        }
        return 'Time to secure the next ' + familyLabel.toLowerCase() + ' visit.';
      }

      function dueOpportunityExplanation(row, focusItem){
        var safeRow = row && typeof row === 'object' ? row : {};
        var clientName = retailTextValue(safeRow.guest_name || safeRow.client_name, 'This guest');
        var routineSignal = dueOpportunityRoutineSignal(row, focusItem);
        var familyLabel = retailTextValue(routineSignal && routineSignal.sentenceLabel, duePatternFamilyLabel(duePatternFamilyKey(focusItem), retailTextValue(focusItem && focusItem.label, 'their routine')).toLowerCase());
        var cadenceDays = duePatternCadenceDays(focusItem) || Math.max(0, Number(safeRow.cadence_days || 0) || 0);
        var cadenceText = dueCadenceFriendlyText(cadenceDays).toLowerCase();
        var daysOverdue = Number((focusItem && focusItem.days_overdue) || safeRow.max_days_overdue || 0) || 0;
        var daysUntilDue = Math.max(0, Number(safeRow.days_until_due || 0) || 0);
        if (safeRow.has_future_appointment === true || safeRow.future_appointment_found === true) {
          return clientName + ' already has a future appointment booked, so this is now a monitor opportunity.';
        }
        if (daysOverdue > 0) {
          return clientName + ' usually returns for ' + familyLabel + (routineSignal && routineSignal.together ? ' together ' : ' ') + (cadenceText ? cadenceText : 'on a steady cadence') + '. The expected return has passed by ' + dueWeeksPastText(daysOverdue) + ' and no future appointment is booked.';
        }
        return clientName + ' is still inside the normal ' + familyLabel + (routineSignal && routineSignal.together ? ' rhythm together' : ' rhythm') + ', but the next visit is due in ' + String(daysUntilDue) + ' day' + (daysUntilDue === 1 ? '' : 's') + ' and nothing is booked yet.';
      }

      function dueOpportunityStageLine(row, focusItem){
        var bits = [];
        var clientStage = dueClientStageLabel(row);
        var visitCount = Math.max(0, Number((row && row.appointment_count) || 0) || 0);
        if (clientStage) bits.push(clientStage + ' guest');
        if (visitCount > 0) bits.push(String(visitCount) + ' visit' + (visitCount === 1 ? '' : 's'));
        var summary = dueCleanOpportunityText(bits.join(' · '));
        if (!summary) return '';
        if (/nan/i.test(summary)) return '';
        if (!/^(New|Growing|Established|Loyal) guest · \d+ visits?$/.test(summary)) return '';
        return summary;
      }

      function dueWorkflowBadgeMarkup(row){
        var opportunityKey = retailTextValue(row && row.opportunity_key, '');
        var owner = retailTextValue(row && row.manager_task_assigned_name, '');
        var outcome = dueOutcomeChip(row);
        if (outcome) {
          return '<span class="queue-opportunityWorkflow queue-opportunityWorkflow--success">' + escapeHtml(outcome.label) + '</span>';
        }
        if (dueNeedsClaim(row) && opportunityKey) {
          return '<button class="queue-opportunityWorkflow queue-opportunityWorkflow--action" type="button" data-task-action="assigned" data-opportunity-key="' + escapeHtml(opportunityKey) + '">Claim</button>';
        }
        if (owner) {
          return ''
            + '<span class="queue-opportunityWorkflow queue-opportunityWorkflow--owned">'
            +   '<span class="queue-opportunityWorkflowAvatar">' + escapeHtml(dueClientInitials(owner)) + '</span>'
            +   '<span>' + escapeHtml(owner) + '</span>'
            + '</span>';
        }
        var workflow = dueWorkflowChip(row);
        return '<span class="queue-opportunityWorkflow queue-opportunityWorkflow--open">' + escapeHtml(workflow ? workflow.label : 'Unclaimed') + '</span>';
      }

      function dueRiskBadgeMarkup(row, focusItem){
        var risk = dueRiskState(row, focusItem);
        return '<span class="queue-opportunityRiskBadge queue-opportunityRiskBadge--' + escapeHtml(risk.tone) + '">' + escapeHtml(risk.label) + '</span>';
      }

      function dueFamilyVisitDateList(row, focusItem){
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        var guestSignals = debug && debug.guest_signals && typeof debug.guest_signals === 'object' ? debug.guest_signals : {};
        var familyMap = guestSignals && guestSignals.family_visit_dates && typeof guestSignals.family_visit_dates === 'object'
          ? guestSignals.family_visit_dates
          : {};
        var familyKey = duePatternFamilyKey(focusItem);
        var rawDates = retailArray(familyMap && familyMap[familyKey]).filter(function(value){
          return !!retailTextValue(value, '');
        });
        var fallbackDate = [
          retailTextValue(focusItem && focusItem.last_visit_at, ''),
          retailTextValue(row && row.last_appointment_date, ''),
          retailTextValue(row && row.last_in_date, ''),
          retailTextValue(row && row.last_in_at, '')
        ].reduce(function(latest, candidate){
          if (!candidate) return latest;
          var latestParsed = latest ? new Date(latest.indexOf('T') >= 0 ? latest : latest + 'T12:00:00') : null;
          var candidateParsed = new Date(candidate.indexOf('T') >= 0 ? candidate : candidate + 'T12:00:00');
          if (isNaN(candidateParsed.getTime())) return latest;
          if (!latestParsed || isNaN(latestParsed.getTime()) || candidateParsed.getTime() > latestParsed.getTime()) {
            return candidate;
          }
          return latest;
        }, '');
        if (fallbackDate) {
          if (!rawDates.length) {
            rawDates = [fallbackDate];
          } else if (rawDates.indexOf(fallbackDate) === -1) {
            var fallbackParsed = fallbackDate.indexOf('T') >= 0 ? new Date(fallbackDate) : new Date(fallbackDate + 'T12:00:00');
            var latestFamilyAt = retailArray(rawDates).reduce(function(maxAt, value){
              var raw = retailTextValue(value, '');
              if (!raw) return maxAt;
              var parsed = raw.indexOf('T') >= 0 ? new Date(raw) : new Date(raw + 'T12:00:00');
              if (isNaN(parsed.getTime())) return maxAt;
              return Math.max(maxAt, parsed.getTime());
            }, 0);
            if (!isNaN(fallbackParsed.getTime()) && fallbackParsed.getTime() > latestFamilyAt) {
              rawDates.push(fallbackDate);
            }
          }
        }
        var lookbackStart = new Date();
        lookbackStart.setHours(0, 0, 0, 0);
        lookbackStart.setFullYear(lookbackStart.getFullYear() - 5);
        var lookbackStartMs = lookbackStart.getTime();
        return rawDates
          .map(function(value){
            var raw = retailTextValue(value, '');
            if (!raw) return null;
            var parsed = raw.indexOf('T') >= 0 ? new Date(raw) : new Date(raw + 'T12:00:00');
            if (isNaN(parsed.getTime())) return null;
            if (parsed.getTime() < lookbackStartMs) return null;
            return { raw: raw, date: parsed };
          })
          .filter(Boolean)
          .sort(function(left, right){
            return left.date.getTime() - right.date.getTime();
          });
      }

      function dueFamilyCancelDateList(row, focusItem){
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        var guestSignals = debug && debug.guest_signals && typeof debug.guest_signals === 'object' ? debug.guest_signals : {};
        var familyMap = guestSignals && guestSignals.family_cancel_dates && typeof guestSignals.family_cancel_dates === 'object'
          ? guestSignals.family_cancel_dates
          : {};
        var familyKey = duePatternFamilyKey(focusItem);
        var lookbackStart = new Date();
        lookbackStart.setHours(0, 0, 0, 0);
        lookbackStart.setFullYear(lookbackStart.getFullYear() - 5);
        var lookbackStartMs = lookbackStart.getTime();
        return retailArray(familyMap && familyMap[familyKey])
          .map(function(value){
            var raw = retailTextValue(value, '');
            if (!raw) return null;
            var parsed = raw.indexOf('T') >= 0 ? new Date(raw) : new Date(raw + 'T12:00:00');
            if (isNaN(parsed.getTime()) || parsed.getTime() < lookbackStartMs) return null;
            return { raw: raw, date: parsed };
          })
          .filter(Boolean)
          .sort(function(left, right){
            return left.date.getTime() - right.date.getTime();
          });
      }

      function dueOverallCancelDateList(row){
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        var guestSignals = debug && debug.guest_signals && typeof debug.guest_signals === 'object' ? debug.guest_signals : {};
        var lookbackStart = new Date();
        lookbackStart.setHours(0, 0, 0, 0);
        lookbackStart.setFullYear(lookbackStart.getFullYear() - 5);
        var lookbackStartMs = lookbackStart.getTime();
        return retailArray(guestSignals && guestSignals.cancel_dates)
          .map(function(value){
            var raw = retailTextValue(value, '');
            if (!raw) return null;
            var parsed = raw.indexOf('T') >= 0 ? new Date(raw) : new Date(raw + 'T12:00:00');
            if (isNaN(parsed.getTime()) || parsed.getTime() < lookbackStartMs) return null;
            return { raw: raw, date: parsed };
          })
          .filter(Boolean)
          .sort(function(left, right){
            return left.date.getTime() - right.date.getTime();
          });
      }

      function dueCompactDateLabel(date){
        if (!(date instanceof Date) || isNaN(date.getTime())) return '';
        return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
      }

      function dueBuildTimelineData(row, focusItem){
        if (!duePatternIsReliable(focusItem)) return null;
        var visitDates = dueFamilyVisitDateList(row, focusItem);
        if (visitDates.length < 3) return null;
        var cancelDates = dueFamilyCancelDateList(row, focusItem);
        var cadenceDays = duePatternCadenceDays(focusItem) || 0;
        var dueAtRaw = retailTextValue(focusItem && focusItem.due_at, '') || retailTextValue(row && row.expected_due_date, '');
        var dueAt = dueAtRaw ? new Date(dueAtRaw.indexOf('T') >= 0 ? dueAtRaw : dueAtRaw + 'T12:00:00') : null;
        var today = new Date();
        var plottedVisits = visitDates.slice();
        var lastVisit = plottedVisits.length ? plottedVisits[plottedVisits.length - 1].date : null;
        var computedDueAt = (lastVisit && cadenceDays > 0)
          ? new Date(lastVisit.getTime() + (cadenceDays * 86400000))
          : null;
        if (computedDueAt && (!dueAt || isNaN(dueAt.getTime()) || dueAt.getTime() < computedDueAt.getTime() || dueAt.getTime() < lastVisit.getTime())) {
          dueAt = computedDueAt;
        }
        if (!lastVisit || !dueAt || isNaN(dueAt.getTime())) return null;
        var allCancelDates = dueOverallCancelDateList(row);
        var plottedCancels = allCancelDates.length ? allCancelDates : cancelDates;
        plottedCancels = plottedCancels.filter(function(entry){
          return entry.date.getTime() > lastVisit.getTime();
        });
        var overdueDays = Math.max(0, Math.round((today.getTime() - dueAt.getTime()) / 86400000));
        return {
          familyLabel: duePatternFamilyLabel(duePatternFamilyKey(focusItem), retailTextValue(focusItem && focusItem.label, 'Routine')),
          cadenceLabel: dueCadenceFriendlyText(cadenceDays),
          overdue: overdueDays,
          cadenceDays: cadenceDays,
          visibleVisitCount: visitDates.length,
          visits: plottedVisits.map(function(entry, index){
            return {
              label: index === plottedVisits.length - 1 ? 'Last visit' : '',
              date: entry.date
            };
          }),
          cancellations: plottedCancels.map(function(entry){
            return {
              label: 'Cancelled appointment',
              date: entry.date
            };
          }),
          lastVisit: lastVisit,
          dueAt: dueAt,
          today: today
        };
      }

      function dueNormalizeTimelineRows(timelines){
        var safeTimelines = retailArray(timelines).filter(Boolean);
        if (!safeTimelines.length) return { rows: [], startAt: null, endAt: null };
        var allTimes = [];
        safeTimelines.forEach(function(timeline){
          retailArray(timeline.visits).forEach(function(entry){
            if (entry && entry.date instanceof Date && !isNaN(entry.date.getTime())) allTimes.push(entry.date.getTime());
          });
          retailArray(timeline.cancellations).forEach(function(entry){
            if (entry && entry.date instanceof Date && !isNaN(entry.date.getTime())) allTimes.push(entry.date.getTime());
          });
          if (timeline.lastVisit instanceof Date && !isNaN(timeline.lastVisit.getTime())) allTimes.push(timeline.lastVisit.getTime());
          if (timeline.dueAt instanceof Date && !isNaN(timeline.dueAt.getTime())) allTimes.push(timeline.dueAt.getTime());
          if (timeline.today instanceof Date && !isNaN(timeline.today.getTime())) allTimes.push(timeline.today.getTime());
        });
        if (!allTimes.length) return { rows: [], startAt: null, endAt: null };
        var minCore = Math.min.apply(Math, allTimes);
        var maxCore = Math.max.apply(Math, allTimes);
        var widestCadence = safeTimelines.reduce(function(max, timeline){
          return Math.max(max, Number(timeline && timeline.cadenceDays) || 0);
        }, 14);
        var cadenceWindowMs = Math.max(14, widestCadence || 14) * 86400000;
        var paddingMs = cadenceWindowMs * 0.6;
        var fiveYearLookback = new Date();
        fiveYearLookback.setFullYear(fiveYearLookback.getFullYear() - 5);
        var minAt = Math.max(minCore - paddingMs, fiveYearLookback.getTime());
        var maxAt = maxCore + (paddingMs * 0.45);
        if (!(maxAt > minAt)) return { rows: [], startAt: null, endAt: null };
        function percent(date){
          var value = ((date.getTime() - minAt) / (maxAt - minAt)) * 100;
          return Math.max(5, Math.min(95, value));
        }
        return {
          startAt: new Date(minAt),
          endAt: new Date(maxAt),
          rows: safeTimelines.map(function(timeline){
            return Object.assign({}, timeline, {
              visits: retailArray(timeline.visits).map(function(entry){
                return Object.assign({}, entry, {
                  position: percent(entry.date)
                });
              }),
              cancellations: retailArray(timeline.cancellations).map(function(entry){
                return Object.assign({}, entry, {
                  position: percent(entry.date)
                });
              }),
              duePosition: percent(timeline.dueAt),
              todayPosition: percent(timeline.today)
            });
          })
        };
      }

      function duePatternStrengthMarkup(row, item){
        var sampleSize = duePatternEffectiveSampleSize(row, item);
        var descriptor = duePatternStrengthDescriptor(item, sampleSize);
        var detail = sampleSize > 0 ? String(sampleSize) + ' visits' : duePatternSourceLabel(item);
        return '<span class="queue-opportunityPatternStrength">' + escapeHtml(descriptor + ' · ' + detail) + '</span>';
      }

      var DUE_TIMELINE_GRAPH_LEFT_PX = 0;
      var DUE_TIMELINE_GRAPH_RIGHT_PX = 24;

      function dueTimelineLeftStyle(percent){
        var safePercent = Math.max(0, Math.min(100, Number(percent || 0) || 0));
        var usablePx = DUE_TIMELINE_GRAPH_LEFT_PX + DUE_TIMELINE_GRAPH_RIGHT_PX;
        return 'calc(' + String(DUE_TIMELINE_GRAPH_LEFT_PX) + 'px + (' + String(safePercent) + ' * (100% - ' + String(usablePx) + 'px) / 100))';
      }

      function dueTimelineWidthStyle(startPercent, endPercent){
        var safeStart = Math.max(0, Math.min(100, Number(startPercent || 0) || 0));
        var safeEnd = Math.max(safeStart, Math.min(100, Number(endPercent || 0) || 0));
        var usablePx = DUE_TIMELINE_GRAPH_LEFT_PX + DUE_TIMELINE_GRAPH_RIGHT_PX;
        return 'calc(' + String(Math.max(0, safeEnd - safeStart)) + ' * (100% - ' + String(usablePx) + 'px) / 100)';
      }

      function duePatternTimelineLaneMarkup(row, timeline, focusItem, laneIndex){
        if (!timeline) return '';
        var dueLabel = dueCompactDateLabel(timeline.dueAt);
        var todayLabel = dueCompactDateLabel(timeline.today);
        var overdue = Number(timeline.overdue || 0) || 0;
        var calloutLeft = Math.max(8, Math.min(92, (timeline.duePosition + timeline.todayPosition) / 2));
        var laneSampleSize = Math.max(0, Number(timeline && timeline.visibleVisitCount) || duePatternEffectiveSampleSize(row, focusItem));
        var laneCaption = [timeline.cadenceLabel, duePatternStrengthDescriptor(focusItem, laneSampleSize)].filter(Boolean).join(' • ');
        var laneTop = 22 + (laneIndex * 64);
        return ''
          + '<div class="queue-opportunityTimelineLane">'
          +   '<div class="queue-opportunityTimelineLaneMeta" style="top:' + escapeHtml(String(laneTop - 22)) + 'px;">'
          +     '<strong>' + escapeHtml(retailTextValue(timeline.familyLabel, 'Routine')) + '</strong>'
          +     (laneCaption ? '<span>' + escapeHtml(laneCaption) + '</span>' : '')
          +   '</div>'
          +   '<div class="queue-opportunityTimelineTrack" style="top:' + escapeHtml(String(laneTop)) + 'px;"></div>'
          +   '<div class="queue-opportunityTimelineSolid" style="top:' + escapeHtml(String(laneTop)) + 'px; left:' + escapeHtml(dueTimelineLeftStyle(timeline.visits[0].position)) + '; width:' + escapeHtml(dueTimelineWidthStyle(timeline.visits[0].position, timeline.duePosition)) + ';"></div>'
          +   '<div class="queue-opportunityTimelineDashed" style="top:' + escapeHtml(String(laneTop)) + 'px; left:' + escapeHtml(dueTimelineLeftStyle(timeline.duePosition)) + '; width:' + escapeHtml(dueTimelineWidthStyle(timeline.duePosition, timeline.todayPosition)) + ';"></div>'
          +     timeline.visits.map(function(entry, index){
                  var tooltipText = entry.label ? entry.label + ' · ' + dueCompactDateLabel(entry.date) : dueCompactDateLabel(entry.date);
                  var labelMarkup = entry.label
                    ? '<span class="queue-opportunityTimelineLabel queue-opportunityTimelineLabel--bottom">' + escapeHtml(tooltipText) + '</span>'
                    : '';
                  return ''
                    + '<span class="queue-opportunityTimelinePoint queue-opportunityTimelinePoint--visit' + (index === timeline.visits.length - 1 ? ' is-latest' : '') + '" style="top:' + escapeHtml(String(laneTop - (index === timeline.visits.length - 1 ? 10 : 8))) + 'px; left:' + escapeHtml(dueTimelineLeftStyle(entry.position)) + ';" title="' + escapeHtml(tooltipText) + '">'
                    +   labelMarkup
                    + '</span>';
                }).join('')
          +     retailArray(timeline.cancellations).map(function(entry){
                  var tooltipText = (entry.label || 'Cancelled appointment') + ' · ' + dueCompactDateLabel(entry.date);
                  return ''
                    + '<span class="queue-opportunityTimelinePoint queue-opportunityTimelinePoint--cancel" style="top:' + escapeHtml(String(laneTop - 8)) + 'px; left:' + escapeHtml(dueTimelineLeftStyle(entry.position)) + ';" title="' + escapeHtml(tooltipText) + '">'
                    +   '<span class="queue-opportunityTimelinePointGlyph" aria-hidden="true">×</span>'
                    + '</span>';
                }).join('')
          +     '<span class="queue-opportunityTimelinePoint queue-opportunityTimelinePoint--due" style="top:' + escapeHtml(String(laneTop - 8)) + 'px; left:' + escapeHtml(dueTimelineLeftStyle(timeline.duePosition)) + ';" title="' + escapeHtml(retailTextValue(timeline.familyLabel, 'Routine') + ' expected back · ' + dueLabel) + '">'
          +       '<span class="queue-opportunityTimelineLabel queue-opportunityTimelineLabel--top">Expected back · ' + escapeHtml(dueLabel) + '</span>'
          +     '</span>'
          +     (overdue > 0 ? '<span class="queue-opportunityTimelineCallout" style="top:' + escapeHtml(String(laneTop + 14)) + 'px; left:' + escapeHtml(dueTimelineLeftStyle(calloutLeft)) + ';">' + escapeHtml(dueWeeksPastText(overdue)) + '</span>' : '')
          + '</div>';
      }

      function duePatternTimelineMarkup(row, focusItem, patternItems){
        var displayItems = dueDisplayPatternItems(patternItems, focusItem);
        var rawTimelines = displayItems.map(function(item){
          return dueBuildTimelineData(row, item);
        }).filter(Boolean);
        var normalizedTimelineSet = dueNormalizeTimelineRows(rawTimelines);
        var normalizedTimelines = retailArray(normalizedTimelineSet && normalizedTimelineSet.rows);
        var lanes = normalizedTimelines.map(function(timeline, index){
          return duePatternTimelineLaneMarkup(row, timeline, displayItems[index], index);
        }).filter(Boolean);
        if (!lanes.length) return '';
        var canvasHeight = Math.max(160, 36 + (lanes.length * 64));
        var windowStartLabel = dueCompactDateLabel(normalizedTimelineSet && normalizedTimelineSet.startAt);
        var windowEndLabel = dueCompactDateLabel(normalizedTimelineSet && normalizedTimelineSet.endAt);
        var todayLabel = dueCompactDateLabel(normalizedTimelines[0] && normalizedTimelines[0].today);
        var todayPosition = normalizedTimelines[0] ? normalizedTimelines[0].todayPosition : null;
        var flipTodayTag = todayPosition !== null && todayPosition > 84;
        return ''
          + '<details class="queue-opportunityRhythmDetails" data-due-rhythm hidden>'
          +   '<summary class="queue-opportunityRhythmToggle">'
          +     '<div class="queue-opportunityRhythmToggleCopy">'
          +       '<div class="queue-opportunityEyebrow">Booking rhythm</div>'
          +       '<strong>Show booking rhythm</strong>'
          +     '</div>'
          +     '<span class="queue-opportunityPatternStrength">' + escapeHtml(String(lanes.length) + ' tracked routine' + (lanes.length === 1 ? '' : 's')) + '</span>'
          +   '</summary>'
          +   '<div class="queue-opportunityRhythmPanel">'
          +     '<div class="queue-opportunityTimelineLegend"><span class="queue-opportunityTimelineLegendItem"><i class="is-solid"></i>On rhythm</span><span class="queue-opportunityTimelineLegendItem"><i class="is-cancel">×</i>Cancelled after last visit</span><span class="queue-opportunityTimelineLegendItem"><i class="is-dashed"></i>Overdue stretch</span><span class="queue-opportunityTimelineLegendItem"><i class="is-today"></i>Today</span></div>'
          +     '<div class="queue-opportunityTimelineCanvas" style="min-height:' + escapeHtml(String(canvasHeight)) + 'px;" role="img" aria-label="' + escapeHtml('Booking rhythm with ' + String(lanes.length) + ' routine lines for this guest') + '">'
          +       (todayPosition !== null ? '<div class="queue-opportunityTimelineTodayGuide" style="left:' + escapeHtml(dueTimelineLeftStyle(todayPosition)) + ';"><span class="queue-opportunityTimelineTodayTag' + (flipTodayTag ? ' is-flip-left' : '') + '">Today' + (todayLabel ? ' · ' + escapeHtml(todayLabel) : '') + '</span></div>' : '')
          +       lanes.join('')
          +     '</div>'
          +     ((windowStartLabel || windowEndLabel) ? '<div class="queue-opportunityTimelineAxis"><span>' + escapeHtml(windowStartLabel || '') + '</span><span>' + escapeHtml(windowEndLabel || '') + '</span></div>' : '')
          +   '</div>'
          + '</details>';
      }

      function duePatternSummaryItems(row, focusItem, patternItems){
        var items = [];
        var displayPatterns = dueDisplayPatternItems(patternItems, focusItem);
        var focusLabel = displayPatterns.map(function(item){
          return duePatternFamilyLabel(duePatternFamilyKey(item), retailTextValue(item && item.label, 'Routine'));
        }).filter(Boolean).join(' + ');
        var cadenceText = dueCadenceFriendlyText(duePatternCadenceDays(focusItem) || row && row.cadence_days);
        var preferredStylist = retailTextValue(row && row.primary_staff_name, '') || retailTextValue(focusItem && focusItem.staff_name, '');
        if (focusLabel) items.push({ label: 'Tracked routines', value: focusLabel });
        if (cadenceText) items.push({ label: 'Normal cadence', value: cadenceText });
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        var guestSignals = debug && debug.guest_signals && typeof debug.guest_signals === 'object' ? debug.guest_signals : {};
        var preferredBooking = retailTextValue(guestSignals && guestSignals.preferred_booking_summary, '');
        if (preferredBooking) items.push({ label: 'Usual booking', value: preferredBooking });
        if (preferredStylist) items.push({ label: 'Preferred stylist', value: preferredStylist });
        return items;
      }

      function duePatternSummaryMarkup(row, focusItem, patternItems){
        var items = duePatternSummaryItems(row, focusItem, patternItems);
        if (!items.length) return '';
        return ''
          + '<div class="queue-opportunityPatternSummary">'
          + items.map(function(item){
            return ''
              + '<div class="queue-opportunityPatternFact">'
              +   '<span>' + escapeHtml(item.label) + '</span>'
              +   '<strong>' + escapeHtml(item.value) + '</strong>'
              + '</div>';
          }).join('')
          + '</div>';
      }

      function dueRecommendationReasonBits(row, focusItem){
        var bits = [];
        var sampleSize = duePatternEffectiveSampleSize(row, focusItem);
        var preferredStylist = retailTextValue(row && row.primary_staff_name, '') || retailTextValue(focusItem && focusItem.staff_name, '');
        var routineSignal = dueOpportunityRoutineSignal(row, focusItem);
        if (sampleSize >= 3) bits.push('This routine has at least ' + String(sampleSize) + ' matching visits behind it.');
        if (retailTextValue(focusItem && focusItem.cadence_source, '').toLowerCase() === 'personalized') {
          bits.push('The cadence is personalized from this guest’s own history, not just a category fallback.');
        }
        if (routineSignal && routineSignal.together && routineSignal.comboCount >= 3) {
          bits.push(routineSignal.titleLabel + ' have been booked together ' + String(routineSignal.comboCount) + ' times in the tracked history.');
        }
        if (preferredStylist) bits.push(preferredStylist + ' is still the strongest stylist relationship in the record.');
        if (!bits.length) bits.push('This is the clearest active pattern the queue can support from current booking history.');
        return bits;
      }

      function dueRecommendationMarkup(row, focusItem){
        var routineSignal = dueOpportunityRoutineSignal(row, focusItem);
        var serviceLabel = routineSignal && routineSignal.sentenceLabel
          ? routineSignal.sentenceLabel
          : duePatternFamilyLabel(duePatternFamilyKey(focusItem), retailTextValue(focusItem && focusItem.label, 'visit')).toLowerCase();
        var stylist = retailTextValue(row && row.primary_staff_name, '') || retailTextValue(focusItem && focusItem.staff_name, '');
        var mainLine = dueNeedsClaim(row)
          ? 'Claim this opportunity and start the rebooking outreach.'
          : dueRecommendedActionText(row);
        var supportLine = stylist
          ? 'Lead with ' + stylist + ' and anchor the note around the ' + serviceLabel + (routineSignal && routineSignal.together ? ' routine together.' : ' routine.')
          : 'Keep the note focused on getting the next ' + serviceLabel + ' visit back on the books.';
        var whyBits = dueRecommendationReasonBits(row, focusItem);
        return ''
          + '<div class="queue-opportunityRecommendation">'
          +   '<div class="queue-opportunityRecommendationIcon" aria-hidden="true">✓</div>'
          +   '<div class="queue-opportunityRecommendationBody">'
          +     '<div class="queue-opportunityEyebrow">Recommended next step</div>'
          +     '<strong>' + escapeHtml(mainLine) + '</strong>'
          +     '<p>' + escapeHtml(supportLine) + '</p>'
          +     '<details class="queue-opportunityWhy">'
          +       '<summary>Why this is likely to work</summary>'
          +       '<div class="queue-opportunityWhyBody">'
          +         whyBits.map(function(bit){
                      return '<div class="queue-opportunityWhyItem">' + escapeHtml(bit) + '</div>';
                    }).join('')
          +       '</div>'
          +     '</details>'
          +   '</div>'
          + '</div>';
      }

      function dueDetailsBodyMarkup(row, options){
        var safeOptions = options && typeof options === 'object' ? options : {};
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        var guestSignals = debug && debug.guest_signals && typeof debug.guest_signals === 'object' ? debug.guest_signals : {};
        var phone = retailTextValue(
          safeOptions.phone
          || row && (row.client_phone || row.normalized_phone || row.phone)
          || guestSignals && guestSignals.phone,
          ''
        );
        var email = retailTextValue(
          safeOptions.email
          || row && (row.client_email || row.email)
          || guestSignals && guestSignals.email,
          ''
        );
        var assignedManager = retailTextValue(
          safeOptions.assignedManager
          || row && (row.manager_task_assigned_name || row.assigned_manager_name || row.manager_name),
          ''
        );
        var futureBookingSummary = retailTextValue(
          safeOptions.futureBookingSummary
          || row && (row.future_appointment_summary || row.future_booking_summary),
          ''
        );
        var contactStatus = retailTextValue(
          safeOptions.contactStatus
          || row && (row.contact_status || row.outreach_status),
          ''
        );
        var lastService = retailTextValue(
          safeOptions.lastService
          || row && (row.last_service_name || row.most_recent_service_name || row.focus_service_name),
          ''
        );
        var lastActionSummary = retailTextValue(
          safeOptions.lastActionSummary
          || row && (row.last_action_summary || row.last_manager_action_summary),
          ''
        );
        var outcomeSyncNoteText = retailTextValue(
          safeOptions.outcomeSyncNoteText
          || row && row.outcome_sync_note,
          ''
        );
        var autoBookedAuditText = retailTextValue(
          safeOptions.autoBookedAuditText
          || row && row.auto_booked_audit_note,
          ''
        );
        var cadencePatternRows = retailTextValue(safeOptions.cadencePatternRows, '');
        var communicationMarkup = retailTextValue(safeOptions.communicationMarkup, '');
        var hasDuplicateAccounts = !!safeOptions.hasDuplicateAccounts;
        var duplicateCount = Number(safeOptions.duplicateCount || 0) || 0;
        var duplicateHint = retailTextValue(safeOptions.duplicateHint, '');
        var guestName = dueCleanOpportunityText(row && (row.guest_name || row.client_name));
        var opportunityLabel = dueOpportunityLabelText(row);
        var serviceCategory = dueCleanOpportunityText(row && row.service_category);
        var lastInDate = dueCleanOpportunityText(row && (row.last_appointment_date || row.last_in_date || row.last_in_at));
        var bucketKey = dueCleanOpportunityText(row && row.guest_bucket_key);
        var bucketLabel = dueCleanOpportunityText(
          row && (row.business_bucket_label || row.business_subcategory_label || row.business_category_label)
        );
        var queueStage = dueCleanOpportunityText(row && row.queue_stage);
        var riskLevel = dueCleanOpportunityText(row && (row.risk_level_label || row.risk_level || row.status_label));
        var cadenceText = bdHistoryCadenceText(row, row && row.debug && row.debug.focus_pattern_item);
        var blocks = [];
        var contactBits = [];
        if (phone) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Phone</strong><span>' + escapeHtml(phone) + '</span></div>');
        if (email) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Email</strong><span>' + escapeHtml(email) + '</span></div>');
        if (assignedManager) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Owner</strong><span>' + escapeHtml(assignedManager) + '</span></div>');
        if (futureBookingSummary) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Booked</strong><span>' + escapeHtml(futureBookingSummary) + '</span></div>');
        if (guestName) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Guest</strong><span>' + escapeHtml(guestName) + '</span></div>');
        if (opportunityLabel) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Opportunity</strong><span>' + escapeHtml(opportunityLabel) + '</span></div>');
        if (serviceCategory) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Service lane</strong><span>' + escapeHtml(serviceCategory) + '</span></div>');
        if (lastInDate) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Last visit</strong><span>' + escapeHtml(lastInDate) + '</span></div>');
        if (bucketLabel) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Bucket</strong><span>' + escapeHtml(bucketLabel) + '</span></div>');
        if (queueStage) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Stage</strong><span>' + escapeHtml(queueStage) + '</span></div>');
        if (riskLevel) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Risk</strong><span>' + escapeHtml(riskLevel) + '</span></div>');
        if (cadenceText) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Cadence</strong><span>' + escapeHtml(cadenceText) + '</span></div>');
        if (bucketKey) contactBits.push('<div class="queue-opportunityDetailMeta"><strong>Bucket key</strong><span>' + escapeHtml(bucketKey) + '</span></div>');
        if (contactBits.length) {
          blocks.push('<div class="queue-opportunityDetailSection"><div class="queue-opportunityDetailTitle">Client details</div><div class="queue-opportunityDetailGrid">' + contactBits.join('') + '</div></div>');
        }
        if (lastActionSummary || contactStatus || outcomeSyncNoteText || autoBookedAuditText) {
          blocks.push(
            '<div class="queue-opportunityDetailSection"><div class="queue-opportunityDetailTitle">Follow-up</div>'
            + (lastActionSummary ? '<div class="queue-opportunityDetailNote"><strong>Latest activity:</strong> ' + escapeHtml(lastActionSummary) + '</div>' : '')
            + (contactStatus ? '<div class="queue-opportunityDetailNote"><strong>Contact status:</strong> ' + escapeHtml(contactStatus) + '</div>' : '')
            + (outcomeSyncNoteText ? '<div class="queue-opportunityDetailNote"><strong>Booking sync:</strong> ' + escapeHtml(outcomeSyncNoteText) + '</div>' : '')
            + (autoBookedAuditText ? '<div class="queue-opportunityDetailNote"><strong>Credit:</strong> ' + escapeHtml(autoBookedAuditText) + '</div>' : '')
            + '</div>'
          );
        }
        if (lastService || cadencePatternRows) {
          blocks.push(
            '<div class="queue-opportunityDetailSection"><div class="queue-opportunityDetailTitle">Pattern support</div>'
            + (lastService ? '<div class="queue-opportunityDetailNote"><strong>Most recent service:</strong> ' + escapeHtml(lastService) + '</div>' : '')
            + (cadencePatternRows ? '<div class="queue-opportunityPatterns">' + cadencePatternRows + '</div>' : '')
            + '</div>'
          );
        }
        if (hasDuplicateAccounts) {
          blocks.push('<div class="queue-opportunityDetailSection"><div class="queue-opportunityDetailTitle">Duplicate accounts</div><div class="queue-opportunityDetailNote">' + escapeHtml(String(Math.max(2, duplicateCount || 2)) + ' accounts' + (duplicateHint ? ' on ' + duplicateHint : '')) + '</div></div>');
        }
        if (communicationMarkup) {
          blocks.push('<div class="queue-opportunityDetailSection"><div class="queue-opportunityDetailTitle">Outreach</div>' + communicationMarkup + '</div>');
        }
        if (!blocks.length) {
          blocks.push('<div class="queue-opportunityDetailSection"><div class="queue-opportunityDetailTitle">Client details</div><div class="queue-opportunityDetailNote">No extra client detail is available on this row yet.</div></div>');
        }
        return blocks.join('');
      }

      function duePayloadSnapshot(row){
        if (!row || typeof row !== 'object') return null;
        var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
        function sanitizeValue(value, depth){
          if (depth > 6) return '[max-depth]';
          if (value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            return value;
          }
          if (typeof value === 'undefined' || typeof value === 'function') return undefined;
          if (value instanceof Date) return value.toISOString();
          if (Array.isArray(value)) {
            return value.map(function(item){
              return sanitizeValue(item, depth + 1);
            }).filter(function(item){
              return typeof item !== 'undefined';
            });
          }
          if (typeof value === 'object') {
            if (seen) {
              if (seen.has(value)) return '[circular]';
              seen.add(value);
            }
            var output = {};
            Object.keys(value).forEach(function(key){
              var nextValue = sanitizeValue(value[key], depth + 1);
              if (typeof nextValue !== 'undefined') output[key] = nextValue;
            });
            return output;
          }
          return String(value);
        }
        return sanitizeValue(row, 0);
      }

      function duePayloadMarkup(row){
        var snapshot = duePayloadSnapshot(row);
        if (!snapshot || !Object.keys(snapshot).length) return '';
        try {
          return ''
            + '<details class="queue-opportunityDetails" data-due-payload hidden><summary class="queue-opportunityDetailsToggle">Payload</summary><div class="queue-opportunityDetailsBody"><pre class="queue-opportunityPayload">'
            + escapeHtml(JSON.stringify(snapshot, null, 2))
            + '</pre></div></details>';
        } catch (error) {
          return '';
        }
      }

      function dueOpportunityLabelText(row){
        var label = dueCleanOpportunityText(
          retailTextValue(row && row.business_bucket_label, '')
          || retailTextValue(row && row.business_subcategory_label, '')
          || retailTextValue(row && row.business_category_label, '')
          || retailTextValue(row && row.primary_label, '')
          || retailTextValue(row && row.queue_stage, '')
          || retailTextValue(row && row.opportunity_type, '')
        );
        if (!label || /nan/i.test(label)) return '';
        return label;
      }

      function dueSafeRecord(value){
        return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
      }

      function dueFactSnapshot(row){
        return dueSafeRecord(dueSafeRecord(row && row.debug).fact_snapshot);
      }

      function dueFactSection(row, key){
        return dueSafeRecord(dueFactSnapshot(row)[key]);
      }

      function dueGuestSignals(row){
        return dueSafeRecord(dueSafeRecord(row && row.debug).guest_signals);
      }

      function dueDateMs(value){
        var text = retailTextValue(value, '');
        if (!text) return null;
        var date = new Date(text);
        var time = date.getTime();
        return Number.isFinite(time) ? time : null;
      }

      function dueFullDateLabel(value){
        var time = dueDateMs(value);
        if (time === null) return '';
        try {
          return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(time));
        } catch (error) {
          return formatRecaptureDate(value);
        }
      }

      function dueTodayStartMs(){
        var now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      }

      function dueDaysBetween(startValue, endValue){
        var start = dueDateMs(startValue);
        var end = dueDateMs(endValue);
        if (start === null || end === null) return null;
        return Math.floor((end - start) / 86400000);
      }

      function dueFirstName(name){
        return retailTextValue(name, 'client').split(/\s+/).filter(Boolean)[0] || 'client';
      }

      function dueFamilyVisitDatesForKey(row, familyKey){
        var key = duePatternFamilyKey({ category: familyKey, label: familyKey });
        var fact = dueFactSnapshot(row);
        var candidates = [
          dueSafeRecord(row && row.family_visit_dates),
          dueSafeRecord(row && row.standalone_family_visit_dates),
          dueSafeRecord(fact.family_visit_dates),
          dueSafeRecord(fact.standalone_family_visit_dates),
          dueSafeRecord(dueFactSection(row, 'cadence').family_visit_dates),
          dueSafeRecord(dueGuestSignals(row).family_visit_dates)
        ];
        var seen = {};
        var dates = [];
        candidates.forEach(function(map){
          retailArray(map[key]).forEach(function(value){
            var text = retailTextValue(value, '');
            if (!text || seen[text]) return;
            seen[text] = true;
            dates.push(text);
          });
        });
        return dates.sort(function(a, b){
          return (dueDateMs(a) || 0) - (dueDateMs(b) || 0);
        });
      }

      function dueAllPatternItems(row){
        var fact = dueFactSnapshot(row);
        var cadenceFact = dueFactSection(row, 'cadence');
        var debug = dueSafeRecord(row && row.debug);
        var raw = []
          .concat(retailArray(row && row.pattern_items))
          .concat(retailArray(cadenceFact.pattern_items))
          .concat(retailArray(fact.pattern_items))
          .concat(retailArray(debug.pattern_items))
          .concat(retailArray(debug.due_items));
        var seen = {};
        return raw.filter(function(item){
          if (!item || typeof item !== 'object') return false;
          var key = [
            duePatternFamilyKey(item),
            retailTextValue(item.label, ''),
            retailTextValue(item.last_visit_at, ''),
            retailTextValue(item.due_at, '')
          ].join('|');
          if (seen[key]) return false;
          seen[key] = true;
          return true;
        });
      }

      function duePatternDisplayName(row, item){
        var serviceNames = retailArray(item && item.service_names)
          .map(function(name){ return retailTextValue(name, ''); })
          .filter(Boolean);
        var familyKey = duePatternFamilyKey(item);
        if (serviceNames.length === 1) return serviceNames[0];
        if (familyKey && familyKey === duePatternFamilyKey({ category: row && row.latest_primary_service_family, label: row && row.latest_primary_service_family })) {
          return retailTextValue(row && row.latest_primary_service_name, '') || retailTextValue(row && row.last_service_name, '') || duePatternFamilyLabel(familyKey, retailTextValue(item && item.label, 'Routine'));
        }
        return retailTextValue(item && item.label, '') || duePatternFamilyLabel(familyKey, 'Routine');
      }

      function duePatternCadenceExactDays(row, item){
        var cadence = Number(item && (item.cadence_days || item.due_days));
        if (Number.isFinite(cadence) && cadence > 0) return Math.round(cadence);
        var familyKey = duePatternFamilyKey(item);
        var rowFamily = duePatternFamilyKey({ category: row && row.latest_primary_service_family, label: row && row.latest_primary_service_family });
        cadence = Number(row && row.cadence_days);
        if (familyKey && rowFamily && familyKey === rowFamily && Number.isFinite(cadence) && cadence > 0) return Math.round(cadence);
        return 0;
      }

      function duePatternLastAt(row, item){
        var direct = retailTextValue(item && item.last_visit_at, '');
        if (direct) return direct;
        var familyKey = duePatternFamilyKey(item);
        var rowFamily = duePatternFamilyKey({ category: row && row.latest_primary_service_family, label: row && row.latest_primary_service_family });
        if (familyKey && rowFamily && familyKey === rowFamily) {
          return retailTextValue(row && (row.last_appointment_date || row.last_in_date || row.last_in_at), '');
        }
        var dates = dueFamilyVisitDatesForKey(row, familyKey);
        return dates.length ? dates[dates.length - 1] : '';
      }

      function duePatternDueAt(row, item){
        var direct = retailTextValue(item && item.due_at, '');
        if (direct) return direct;
        var familyKey = duePatternFamilyKey(item);
        var rowFamily = duePatternFamilyKey({ category: row && row.latest_primary_service_family, label: row && row.latest_primary_service_family });
        if (familyKey && rowFamily && familyKey === rowFamily && retailTextValue(row && row.expected_due_date, '')) return retailTextValue(row && row.expected_due_date, '');
        var lastAt = duePatternLastAt(row, item);
        var cadenceDays = duePatternCadenceExactDays(row, item);
        var lastMs = dueDateMs(lastAt);
        if (lastMs !== null && cadenceDays > 0) return new Date(lastMs + cadenceDays * 86400000).toISOString();
        return '';
      }

      function duePatternOverdueDays(row, item){
        var direct = Number(item && item.days_overdue);
        if (Number.isFinite(direct)) return Math.round(direct);
        var dueAt = duePatternDueAt(row, item);
        var dueMs = dueDateMs(dueAt);
        if (dueMs !== null) return Math.floor((dueTodayStartMs() - dueMs) / 86400000);
        var familyKey = duePatternFamilyKey(item);
        var rowFamily = duePatternFamilyKey({ category: row && row.latest_primary_service_family, label: row && row.latest_primary_service_family });
        var rowOverdue = Number(row && row.days_overdue);
        if (familyKey && rowFamily && familyKey === rowFamily && Number.isFinite(rowOverdue)) return Math.round(rowOverdue);
        return 0;
      }

      function duePatternProvider(row, item){
        return retailTextValue(item && item.staff_name, '') || retailTextValue(row && row.primary_staff_name, '');
      }

      function duePatternSample(row, item){
        var sample = Number(item && item.cadence_sample_size);
        if (Number.isFinite(sample) && sample > 0) return Math.round(sample);
        var familyCount = dueFamilyVisitDatesForKey(row, duePatternFamilyKey(item)).length;
        if (familyCount > 0) return familyCount;
        sample = Number(item && item.appointment_count);
        return Number.isFinite(sample) && sample > 0 ? Math.round(sample) : 0;
      }

      function duePatternSource(row, item){
        return retailTextValue(item && item.cadence_source, '') || retailTextValue(row && row.cadence_source, '');
      }

      function duePatternConfidence(row, item){
        var sample = duePatternSample(row, item);
        var source = duePatternSource(row, item).toLowerCase();
        if (source === 'personalized' && sample >= 5) return 'Strong pattern';
        if (source === 'personalized' && sample >= 3) return 'Clear pattern';
        if (sample >= 3) return 'Lower confidence';
        return 'Limited signal';
      }

      function duePatternTrustLine(row, item){
        var cadence = duePatternCadenceExactDays(row, item);
        var sample = duePatternSample(row, item);
        var source = duePatternSource(row, item).toLowerCase();
        if (cadence > 0 && source === 'personalized' && sample > 0) {
          return String(cadence) + '-day personalized cadence based on ' + String(sample) + ' visit' + (sample === 1 ? '' : 's');
        }
        if (cadence > 0) return String(cadence) + '-day service-category cadence';
        return sample > 0 ? String(sample) + ' historical visit' + (sample === 1 ? '' : 's') : '';
      }

      function duePatternBusinessWeight(item){
        var family = duePatternFamilyKey(item);
        if (family === 'color') return 60;
        if (family === 'haircut') return 54;
        if (family === 'extensions' || family === 'extensions_install' || family === 'extensions_maintenance') return 48;
        if (family === 'keratin') return 28;
        if (family === 'gloss') return 24;
        if (family === 'blowdry') return 12;
        return 20;
      }

      function duePatternRankScore(row, item){
        var sample = duePatternSample(row, item);
        var source = duePatternSource(row, item).toLowerCase();
        var overdue = duePatternOverdueDays(row, item);
        var lastMs = dueDateMs(duePatternLastAt(row, item));
        var recencyPenalty = lastMs === null ? 0 : Math.max(0, Math.floor((dueTodayStartMs() - lastMs) / 86400000));
        return duePatternBusinessWeight(item)
          + Math.min(sample, 20) * 4
          + (source === 'personalized' ? 35 : 0)
          + Math.max(-20, Math.min(60, overdue || 0))
          - Math.min(45, Math.floor(recencyPenalty / 60));
      }

      function dueRankedPatterns(row){
        return dueAllPatternItems(row).sort(function(a, b){
          return duePatternRankScore(row, b) - duePatternRankScore(row, a);
        });
      }

      function duePatternStatusLabel(row, item){
        var overdue = duePatternOverdueDays(row, item);
        if (overdue > 0) return String(overdue) + 'd overdue';
        if (overdue === 0) return 'Due now';
        return 'Due in ' + String(Math.abs(overdue)) + 'd';
      }

      function dueDiagnosisDisplay(row){
        var unifiedStatus = dueRowUnifiedAppointmentStatusKey(row);
        if (unifiedStatus === 'never_visited') return 'Never Visited';
        if (unifiedStatus === 'needs_prebook') return 'Needs Prebook';
        if (unifiedStatus === 'needs_attention') return 'Needs Attention';
        if (unifiedStatus === 'needs_recovery') return 'Needs Recovery';
        if (unifiedStatus === 'no_pattern') return 'No Pattern';
        var label = dueOpportunityLabelText(row) || dueCleanOpportunityText(row && row.diagnosis_title) || 'Opportunity';
        return label.replace(/\s*-\s*/g, ' · ');
      }

      function duePriorityDisplay(row){
        var score = Number((row && (row.business_priority_score || row.priority_score)) || 0) || 0;
        if (score >= 90) return 'High Priority';
        if (score >= 70) return 'Priority';
        return 'Watch';
      }

      function dueTotalHistoryCount(row, patterns){
        var counts = [Number(row && row.total_completed_visits), Number(row && row.appointment_count)]
          .concat(retailArray(patterns).map(function(item){ return duePatternSample(row, item); }))
          .filter(function(value){ return Number.isFinite(value) && value > 0; });
        return counts.length ? Math.max.apply(Math, counts) : 0;
      }

      function duePrimaryPattern(row, patterns){
        var reliable = retailArray(patterns).filter(function(item){
          return duePatternSample(row, item) >= 3 && duePatternCadenceExactDays(row, item) > 0;
        });
        return reliable[0] || retailArray(patterns)[0] || null;
      }

      function duePrimaryDiagnosisMarkup(row, focusPattern){
        var name = dueCleanOpportunityText(row && (row.guest_name || row.client_name)) || 'This client';
        var family = duePatternFamilyLabel(duePatternFamilyKey(focusPattern), retailTextValue(focusPattern && focusPattern.label, 'service')).toLowerCase();
        var cadence = duePatternCadenceExactDays(row, focusPattern);
        var last = dueFullDateLabel(duePatternLastAt(row, focusPattern) || (row && (row.last_appointment_date || row.last_in_date || row.last_in_at)));
        var overdue = duePatternOverdueDays(row, focusPattern);
        var future = dueFutureBookingSentence(row);
        if (focusPattern && cadence > 0 && last && overdue > 0) {
          return name + ' was a regular ' + family + ' client visiting about every ' + String(cadence) + ' days. Last visit was ' + last + ', and they are now ' + String(overdue) + ' days overdue with ' + future + '.';
        }
        if (focusPattern && cadence > 0 && last) {
          return name + ' has a ' + family + ' pattern about every ' + String(cadence) + ' days. Last visit was ' + last + ', with ' + future + '.';
        }
        var summary = dueCleanOpportunityText(row && (row.diagnosis_summary || row.business_bucket_reason || row.explanation));
        return summary || 'This client has a follow-up opportunity that needs manager review.';
      }

      function duePatternFactGridMarkup(row, focusPattern){
        var facts = [];
        var last = dueFullDateLabel(duePatternLastAt(row, focusPattern) || (row && (row.last_appointment_date || row.last_in_date || row.last_in_at)));
        var service = duePatternDisplayName(row, focusPattern) || retailTextValue(row && row.latest_primary_service_name, '') || retailTextValue(row && row.last_service_name, '');
        var cadence = duePatternCadenceExactDays(row, focusPattern);
        var expected = dueFullDateLabel(duePatternDueAt(row, focusPattern) || (row && row.expected_due_date));
        var status = focusPattern ? duePatternStatusLabel(row, focusPattern) : '';
        var future = dueFutureBookingSummary(row) || 'None';
        if (last) facts.push({ label: 'Last visit', value: last });
        if (service) facts.push({ label: 'Primary service', value: service });
        if (cadence > 0) facts.push({ label: 'Normal cadence', value: 'Every ' + String(cadence) + ' days', note: duePatternTrustLine(row, focusPattern) });
        if (expected) facts.push({ label: 'Expected return', value: expected });
        if (status) facts.push({ label: 'Current status', value: status });
        facts.push({ label: 'Future booking', value: future });
        return '<div class="bd-compactFacts bd-compactFacts--opportunity">'
          + facts.slice(0, 6).map(function(fact){
            return '<div class="bd-compactFact"><span>' + escapeHtml(fact.label) + '</span><strong title="' + escapeHtml(fact.note || '') + '">' + escapeHtml(fact.value) + '</strong>' + (fact.note ? '<small>' + escapeHtml(fact.note) + '</small>' : '') + '</div>';
          }).join('')
          + '</div>';
      }

      function dueServicePatternCardsMarkup(row, patterns){
        var topPatterns = retailArray(patterns).filter(function(item){
          return duePatternSample(row, item) >= 3 && duePatternCadenceExactDays(row, item) > 0;
        }).slice(0, 2);
        if (!topPatterns.length) return '';
        var combo = dueOpportunityRoutineSignal(row, topPatterns[0]);
        return '<div class="bd-patternSummary">'
          + (combo && combo.together ? '<div class="bd-usualVisit"><span>Usual visit</span><strong>' + escapeHtml(combo.titleLabel) + '</strong><small>Booked together ' + escapeHtml(String(combo.comboCount || 'multiple')) + ' times</small></div>' : '')
          + topPatterns.map(function(item){
            var provider = duePatternProvider(row, item);
            return '<div class="bd-patternPreviewItem">'
              + '<div><strong>' + escapeHtml(duePatternDisplayName(row, item)) + '</strong><span>' + escapeHtml(duePatternConfidence(row, item)) + '</span></div>'
              + '<div class="bd-patternPreviewMeta">'
              +   '<span>Every ' + escapeHtml(String(duePatternCadenceExactDays(row, item) || '?')) + ' days</span>'
              +   '<span>Last ' + escapeHtml(dueFullDateLabel(duePatternLastAt(row, item)) || 'unknown') + '</span>'
              +   '<span>' + escapeHtml(duePatternStatusLabel(row, item)) + '</span>'
              +   (provider ? '<span>Provider: ' + escapeHtml(provider) + '</span>' : '')
              + '</div>'
            + '</div>';
          }).join('')
          + '</div>';
      }

      function dueDiagnosisToneClass(row){
        var unifiedStatus = dueRowUnifiedAppointmentStatusKey(row);
        if (unifiedStatus === 'never_visited' || unifiedStatus === 'needs_prebook') return 'bd-bucket--watch';
        if (unifiedStatus === 'needs_attention') return 'bd-bucket--risk';
        if (unifiedStatus === 'needs_recovery') return 'bd-bucket--lost';
        if (unifiedStatus === 'no_pattern') return 'bd-bucket--growth';
        var text = [
          dueDiagnosisDisplay(row),
          row && row.history_rating,
          row && row.business_bucket_key,
          row && row.diagnosis_key
        ].map(function(value){ return retailTextValue(value, '').toLowerCase(); }).join(' ');
        if (/lost|lapsed|long/.test(text)) return 'bd-bucket--lost';
        if (/risk|cancel|no-show|declin|partial|overdue/.test(text)) return 'bd-bucket--risk';
        if (/watch|due/.test(text)) return 'bd-bucket--watch';
        return 'bd-bucket--growth';
      }

      function dueExpandedPatternRowsMarkup(row, patterns){
        var rows = retailArray(patterns).map(function(item){
          return '<div class="bd-historyRow">'
            + '<strong>' + escapeHtml(duePatternDisplayName(row, item)) + '</strong>'
            + '<span>' + escapeHtml(duePatternStatusLabel(row, item)) + '</span>'
            + '<span>Last ' + escapeHtml(dueFullDateLabel(duePatternLastAt(row, item)) || 'unknown') + '</span>'
            + '<span>Expected ' + escapeHtml(dueFullDateLabel(duePatternDueAt(row, item)) || 'unknown') + '</span>'
            + '<span>' + escapeHtml(duePatternTrustLine(row, item) || duePatternConfidence(row, item)) + '</span>'
            + (duePatternProvider(row, item) ? '<span>Provider ' + escapeHtml(duePatternProvider(row, item)) + '</span>' : '')
          + '</div>';
        }).join('');
        return rows ? '<div class="bd-historyList">' + rows + '</div>' : '';
      }

      function dueDisruptionSignalsMarkup(row){
        var disruption = dueFactSection(row, 'disruption');
        var cancelDates = retailArray(row && row.cancel_dates).concat(retailArray(disruption.cancel_dates));
        var noShowDates = retailArray(row && row.no_show_dates).concat(retailArray(disruption.no_show_dates));
        var postCancel = row && row.has_post_visit_cancel === true || disruption.has_post_visit_cancel === true;
        var postNoShow = row && row.has_post_visit_no_show === true || disruption.has_post_visit_no_show === true;
        var latestPostCancel = retailTextValue(disruption.latest_post_visit_cancel_at, '');
        var parts = [];
        if (postCancel) parts.push('Unresolved cancellation after last visit' + (latestPostCancel ? ' on ' + dueFullDateLabel(latestPostCancel) : ''));
        else if (cancelDates.length) parts.push('Past cancellations exist, but none are unresolved after the last completed visit');
        else parts.push('No cancellations on this payload');
        if (postNoShow) parts.push('Unresolved no-show after last visit');
        else if (!noShowDates.length) parts.push('No no-shows');
        if (row && row.future_appointment_found === true) parts.push('Future appointment booked');
        else parts.push('No future appointment');
        return '<div class="bd-disruptionSignals">' + parts.map(function(part){ return '<span>' + escapeHtml(part) + '</span>'; }).join('') + '</div>';
      }

      function dueRecommendationSummaryMarkup(row, focusPattern, patterns){
        var name = dueFirstName(row && (row.guest_name || row.client_name));
        var provider = duePatternProvider(row, focusPattern);
        var topPatterns = retailArray(patterns).slice(0, 2);
        var routine = topPatterns.map(function(item){ return duePatternDisplayName(row, item); }).filter(Boolean).join(' + ');
        var action = retailTextValue(row && row.recommended_action, '');
        if (provider && routine) return 'Reach out about ' + routine + ' with ' + provider + '.';
        if (routine) return 'Reach out about ' + routine + '.';
        if (action) return action;
        return 'Contact ' + name + ' with a personal rebooking note.';
      }

      function dueOwnerStatusMarkup(row){
        var owner = retailTextValue(row && row.manager_task_assigned_name, '');
        var lastAction = dueLastActionSummary(row);
        if (owner && lastAction) return 'Assigned to ' + owner + ' · ' + lastAction;
        if (owner) return 'Assigned to ' + owner;
        if (lastAction) return lastAction;
        return 'Unclaimed';
      }

      function dueSanitizeCardMarkup(markup){
        return String(markup || '')
          .replace(/NaN\d*/gi, '')
          .replace(/\bNaN\b/gi, '')
          .replace(/>[^<]*NaN\d*[^<]*</gi, '><')
          .replace(/>[^<]*NaN[^<]*</gi, '><')
          .replace(/<div[^>]*>\s*<\/div>/gi, '')
          .replace(/<div class="queue-opportunitySubline">[^<]*<\/div>/gi, '')
          .replace(/<div class="queue-opportunityDivider"><\/div>/gi, '')
          .replace(/<hr\s*\/?>/gi, '')
          .replace(/<details class="queue-opportunity(?:RhythmDetails|Details)"[^>]*>\s*<\/details>/gi, '')
          .replace(/<div class="queue-opportunitySubline">\s*<\/div>/gi, '')
          .replace(/<div class="queue-opportunityAuxChips">\s*<\/div>/gi, '')
          .replace(/<div class="queue-opportunityCompactMeta">\s*<\/div>/gi, '')
          .replace(/<div class="queue-opportunityHeaderCopy">\s*<\/div>/gi, '')
          .replace(/<div class="queue-opportunityHeaderCopy">\s*(<h3[^>]*>.*?<\/h3>)\s*<\/div>/gi, '<div class="queue-opportunityHeaderCopy">$1</div>')
          .replace(/>\s+</g, '><');
      }

      function dueClientCardMarkup(row){
        var outreach = row && row.outreach && typeof row.outreach === 'object' ? row.outreach : null;
        var clientName = dueCleanOpportunityText((row && (row.guest_name || row.client_name))) || 'Unknown client';
        var phone = retailTextValue((row && (row.client_phone || row.normalized_phone)), 'No phone');
        var email = retailTextValue((row && row.client_email), '');
        var hasDuplicateAccounts = row && (row.duplicate_account_flag === true || row.has_duplicate_accounts === true);
        var duplicateCount = Number((row && (row.duplicate_account_count)) || 0) || 0;
        var duplicateHint = retailTextValue(row && row.normalized_phone, '');
        var lastService = retailTextValue((row && row.last_service_name), '');
        var lastMessage = outreach && outreach.last_message ? retailTextValue(outreach.last_message, '') : '';
        var latestDraft = outreach && outreach.latest_draft && typeof outreach.latest_draft === 'object' ? outreach.latest_draft : null;
        var draftBody = retailTextValue(latestDraft && latestDraft.message_body, '');
        var draftOfferKey = retailTextValue(latestDraft && latestDraft.offer_key, 'none') || 'none';
        var draftOfferText = retailTextValue(latestDraft && latestDraft.offer_text, '');
        var rawPatternItems = dueRankedPatterns(row);
        var focusPatternItem = duePrimaryPattern(row, rawPatternItems);
        var cadencePatternRows = dueExpandedPatternRowsMarkup(row, rawPatternItems);
        var outcomeChip = dueOutcomeChip(row);
        var futureBookingSummary = dueFutureBookingSummary(row);
        var contactStatus = dueContactStatusText(outreach);
        var lastActionSummary = dueLastActionSummary(row);
        var autoBookedAuditText = dueAutoBookedAuditText(row);
        var outcomeSyncNoteText = dueOutcomeSyncNoteText(row);
        var assignedManager = retailTextValue(row && row.manager_task_assigned_name, '');
        var diagnosisLabel = dueDiagnosisDisplay(row);
        var priorityLabel = duePriorityDisplay(row);
        var historyCount = dueTotalHistoryCount(row, rawPatternItems);
        var provider = duePatternProvider(row, focusPatternItem) || retailTextValue(row && row.primary_staff_name, '');
        var focusFamily = duePatternFamilyKey(focusPatternItem || { category: row && row.latest_primary_service_family, label: row && row.latest_primary_service_family });
        var focusFamilyLabel = duePatternFamilyLabel(focusFamily, retailTextValue(focusPatternItem && focusPatternItem.label, 'service'));
        var relationshipParts = [];
        if (focusFamilyLabel) relationshipParts.push('Regular ' + focusFamilyLabel.toLowerCase() + ' client');
        if (provider) relationshipParts.push('Primary provider: ' + provider);
        if (hasDuplicateAccounts) relationshipParts.push('Duplicate account' + (duplicateCount > 1 ? 's: ' + String(duplicateCount) : ''));
        var relationshipLine = dueCleanOpportunityText(relationshipParts.join(' · '));
        var primaryActionMarkup = duePrimaryActionMarkup(row);
        var taskActionsMarkup = dueTaskActionsMarkup(row);
        var outcomeActionsMarkup = dueOutcomeActionsMarkup(row);
        var shouldShowCommunication = dueShouldShowCommunication(row);
        var communicationMarkup = shouldShowCommunication
          ? ''
            + '<div class="queue-communicationCard">'
            +   '<div class="queue-detailSectionLabel">Outreach</div>'
            +   '<div class="retail-queueControls">'
            +     '<select class="progression-valueEditor" data-due-offer-select>'
            +       dueOfferSelectOptionsMarkup(draftOfferKey)
            +     '</select>'
            +     '<div class="field retail-inlineField" data-due-custom-offer-wrap' + (draftOfferKey === 'custom' ? '' : ' hidden') + '>'
            +       '<input data-due-custom-offer type="text" placeholder="Custom offer" value="' + escapeHtml(draftOfferKey === 'custom' ? draftOfferText : '') + '" />'
            +     '</div>'
            +     '<textarea class="retail-draftEditor" data-due-draft-editor placeholder="Draft a message to review before sending.">' + escapeHtml(draftBody) + '</textarea>'
            +   '</div>'
            +   '<div class="retail-cardActions retail-cardActions--queue retail-cardActions--queueTight">'
            +     '<label class="retail-toggle retail-toggle--compact"><input type="checkbox" data-due-reviewed' + (draftBody ? '' : ' disabled') + ' /><span>Reviewed</span></label>'
            +     '<button class="btn-secondary" type="button" data-due-action="send" data-due-bucket-key="' + escapeHtml(String((row && row.guest_bucket_key) || '')) + '" disabled>Send via ClickSend</button>'
            +     '<button class="btn-secondary" type="button" data-due-action="mark-contacted" data-due-bucket-key="' + escapeHtml(String((row && row.guest_bucket_key) || '')) + '">Log Manual Contact</button>'
            +     '<button class="btn-secondary" type="button" data-due-action="dismiss-30" data-due-bucket-key="' + escapeHtml(String((row && row.guest_bucket_key) || '')) + '">Dismiss 30 Days</button>'
            +   '</div>'
            +   (lastMessage ? '<div class="retail-draft"><strong>Last message</strong>\n' + escapeHtml(lastMessage) + '</div>' : '')
            + '</div>'
          : '';
        var patternHistoryMarkup = rawPatternItems.length
          ? '<div class="bd-historyPanel">'
            + '<div class="queue-detailSectionLabel">Service patterns</div>'
            + dueExpandedPatternRowsMarkup(row, rawPatternItems)
            + '<div class="queue-detailSectionLabel">Disruption signals</div>'
            + dueDisruptionSignalsMarkup(row)
          + '</div>'
          : '';
        var detailsBodyMarkup = dueDetailsBodyMarkup(row, {
          phone: phone,
          email: email,
          assignedManager: assignedManager,
          futureBookingSummary: futureBookingSummary,
          contactStatus: contactStatus,
          lastService: lastService,
          lastActionSummary: lastActionSummary,
          outcomeSyncNoteText: outcomeSyncNoteText,
          autoBookedAuditText: autoBookedAuditText,
          cadencePatternRows: cadencePatternRows,
          communicationMarkup: communicationMarkup,
          hasDuplicateAccounts: hasDuplicateAccounts,
          duplicateCount: duplicateCount,
          duplicateHint: duplicateHint
        });
        var payloadMarkup = duePayloadMarkup(row);
        var hasExpandableDetails = !!dueCleanOpportunityText(String((patternHistoryMarkup || '') + (detailsBodyMarkup || '')).replace(/<[^>]+>/g, ' '));
        var rhythmMarkup = duePatternTimelineMarkup(row, focusPatternItem, rawPatternItems);
        var diagnosisMarkup = duePrimaryDiagnosisMarkup(row, focusPatternItem);
        var factGridMarkup = duePatternFactGridMarkup(row, focusPatternItem);
        var servicePatternMarkup = dueServicePatternCardsMarkup(row, rawPatternItems);
        var recommendationMarkup = dueRecommendationSummaryMarkup(row, focusPatternItem, rawPatternItems);
        var ownerLine = dueOwnerStatusMarkup(row);
        var historyBadgeMarkup = historyCount > 0
          ? '<span class="bd-badge bd-badge--history">' + escapeHtml(String(historyCount)) + ' visits</span>'
          : '';
        var rhythmToggleMarkup = rhythmMarkup
          ? '<button class="queue-opportunityInlineButton" type="button" data-due-toggle-rhythm>Client pattern</button>'
          : '';
        var detailsToggleMarkup = hasExpandableDetails
          ? '<button class="queue-opportunityInlineButton" type="button" data-due-toggle-details>View history</button>'
          : '';
        var payloadToggleMarkup = payloadMarkup
          ? '<button class="btn-secondary" type="button" data-due-toggle-payload>Payload</button>'
          : '';
        var inlineActionsMarkup = (primaryActionMarkup || rhythmToggleMarkup || detailsToggleMarkup)
          ? '<div class="queue-opportunityInlineActions">' + primaryActionMarkup + rhythmToggleMarkup + detailsToggleMarkup + '</div>'
          : '';
        var workflowMenuMarkup = (payloadToggleMarkup || taskActionsMarkup || outcomeActionsMarkup || hasDuplicateAccounts)
          ? ''
            + '<details class="queue-opportunityMenu">'
            +   '<summary class="queue-opportunityMenuButton" aria-label="More actions">•••</summary>'
            +   '<div class="queue-opportunityMenuPanel">'
            +     (payloadToggleMarkup ? '<div class="queue-opportunityMenuGroup">' + payloadToggleMarkup + '</div>' : '')
            +     (taskActionsMarkup ? '<div class="queue-opportunityMenuGroup">' + taskActionsMarkup + '</div>' : '')
            +     (outcomeActionsMarkup ? '<div class="queue-opportunityMenuGroup">' + outcomeActionsMarkup + '</div>' : '')
            +     (hasDuplicateAccounts ? '<button class="btn-secondary" type="button" data-due-toggle-details>Review duplicate accounts</button>' : '')
            +   '</div>'
            + '</details>'
          : '';
        var cardMarkup = ''
          + '<article class="retail-card retail-card--compact retail-card--queue queue-opportunityCard bd-opportunityCard bd-opportunityCard--rich" data-due-card data-due-bucket="' + escapeHtml(String((row && row.guest_bucket_key) || '')) + '">'
          +   '<div class="queue-opportunityHeader bd-opportunityTop">'
          +     '<div class="queue-opportunityClient bd-opportunityIdentity">'
          +       '<div class="queue-opportunityAvatar bd-avatar" aria-hidden="true">' + escapeHtml(dueClientInitials(clientName)) + '</div>'
          +       '<div class="queue-opportunityHeaderCopy bd-opportunityCopy">'
          +         '<div class="bd-opportunityTitleRow">'
          +           '<h3 class="queue-opportunityClientName bd-opportunityName">' + escapeHtml(clientName) + '</h3>'
          +           '<span class="bd-bucket ' + escapeHtml(dueDiagnosisToneClass(row)) + '">' + escapeHtml(diagnosisLabel) + '</span>'
          +           '<span class="bd-badge bd-badge--priority">' + escapeHtml(priorityLabel) + '</span>'
          +           historyBadgeMarkup
          +         '</div>'
          +         (relationshipLine ? '<div class="bd-opportunityMeta">' + escapeHtml(relationshipLine) + '</div>' : '')
          +         '<div class="bd-opportunityOwner">' + escapeHtml(ownerLine) + '</div>'
          +       '</div>'
          +     '</div>'
          +     '<div class="queue-opportunityHeaderAside bd-opportunityActions">'
          +       dueWorkflowBadgeMarkup(row)
          +       inlineActionsMarkup
          +       workflowMenuMarkup
          +     '</div>'
          +   '</div>'
          +   '<div class="bd-opportunityBody">'
          +     '<div class="bd-opportunityLead">'
          +       '<div class="bd-opportunitySignal">' + escapeHtml(diagnosisMarkup) + '</div>'
          +       factGridMarkup
          +     '</div>'
          +     servicePatternMarkup
          +     '<div class="bd-recommendationBox"><span>Recommended</span><strong>' + escapeHtml(retailTextValue(row && row.recommended_action, '') || 'Win-back outreach') + '</strong><p>' + escapeHtml(recommendationMarkup) + '</p></div>'
          +   '</div>'
          +   rhythmMarkup
          +   (hasExpandableDetails
                  ? '<details class="queue-opportunityDetails" data-due-details hidden><summary class="queue-opportunityDetailsToggle">Client history</summary><div class="queue-opportunityDetailsBody">'
                    + patternHistoryMarkup
                    + detailsBodyMarkup
                  + '</div></details>'
                  : '')
          +   payloadMarkup
          + '</article>';
        return dueSanitizeCardMarkup(cardMarkup)
          .replace(/NaN\d*/gi, '')
          .replace(/\bNaN\b/gi, '')
          .replace(/>\s+</g, '><');
      }

      function scrubDueQueueCardDom(card){
        if (!card || !card.querySelectorAll) return;
        card.innerHTML = dueSanitizeCardMarkup(card.innerHTML);
        card.querySelectorAll('.queue-opportunityClientName, .queue-opportunityCompactMeta, .queue-opportunityMiniChip, .queue-opportunityDetailNote, .queue-opportunityDetailMeta span, .bd-opportunityMeta, .bd-opportunityOwner, .bd-opportunitySignal, .bd-compactFact strong, .bd-compactFact small, .bd-patternPreviewItem, .bd-recommendationBox').forEach(function(node){
          if (!node) return;
          var cleanedLabel = String(node.textContent || '')
            .replace(/NaN\d*/gi, '')
            .replace(/\bNaN\b/gi, '')
            .replace(/\s+/g, ' ')
            .trim();
          if (!cleanedLabel) {
            if (node.classList && node.classList.contains('queue-opportunityClientName')) {
              node.textContent = '';
            } else if (node.parentNode) {
              node.parentNode.removeChild(node);
            }
            return;
          }
          if (cleanedLabel !== String(node.textContent || '').trim()) {
            node.textContent = cleanedLabel;
          }
        });
        Array.prototype.slice.call(card.childNodes || []).forEach(function(node){
          if (!node || node.nodeType !== 3) return;
          var cleanedRootText = String(node.textContent || '')
            .replace(/NaN\d*/gi, '')
            .replace(/\bNaN\b/gi, '')
            .replace(/\s+/g, ' ')
            .trim();
          if (!cleanedRootText) {
            node.textContent = '';
          } else if (cleanedRootText !== String(node.textContent || '').trim()) {
            node.textContent = cleanedRootText;
          }
        });
        card.querySelectorAll('.queue-opportunitySubline, .queue-opportunityDivider, hr').forEach(function(node){
          if (node && node.parentNode) node.parentNode.removeChild(node);
        });
        card.querySelectorAll('.queue-opportunityDetailsToggle').forEach(function(node){
          if (!node) return;
          var parent = node.parentNode;
          if (parent && parent.hasAttribute && parent.hasAttribute('hidden')) {
            parent.parentNode && parent.parentNode.removeChild(parent);
          }
        });
        var headerCopy = card.querySelector('.queue-opportunityHeaderCopy');
        if (headerCopy) {
          Array.prototype.slice.call(headerCopy.childNodes || []).forEach(function(node){
            if (node && node.nodeType === 3) node.textContent = '';
          });
          Array.prototype.slice.call(headerCopy.children || []).forEach(function(node){
            if (!node || !node.matches) return;
            if (!node.matches('.queue-opportunityClientName, .queue-opportunityCompactMeta, .queue-opportunityAuxChips, .bd-opportunityTitleRow, .bd-opportunityMeta, .bd-opportunityOwner')) {
              node.parentNode && node.parentNode.removeChild(node);
            }
          });
        }
        card.querySelectorAll('.queue-opportunityCompactMeta').forEach(function(node){
          if (!node) return;
          var cleanedMeta = String(node.textContent || '')
            .replace(/NaN\d*/gi, '')
            .replace(/\bNaN\b/gi, '')
            .replace(/\s+/g, ' ')
            .trim();
          if (!cleanedMeta) {
            node.parentNode && node.parentNode.removeChild(node);
            return;
          }
          node.textContent = cleanedMeta;
        });
        var clientShell = card.querySelector('.queue-opportunityClient');
        if (clientShell) {
          Array.prototype.slice.call(clientShell.childNodes || []).forEach(function(node){
            if (node && node.nodeType === 3) node.textContent = '';
          });
        }
        card.querySelectorAll('[hidden]').forEach(function(node){
          if (!node || !node.style) return;
          node.style.display = 'none';
          node.style.margin = '0';
          node.style.padding = '0';
          node.style.border = '0';
          node.style.minHeight = '0';
        });
        card.querySelectorAll('*').forEach(function(node){
          if (!node || !node.childNodes) return;
          Array.prototype.slice.call(node.childNodes).forEach(function(child){
            if (!child || child.nodeType !== 3) return;
            var cleaned = String(child.textContent || '')
              .replace(/NaN\d*/gi, '')
              .replace(/\s{2,}/g, ' ')
              .trim();
            if (!cleaned) {
              child.textContent = '';
              return;
            }
            if (cleaned !== String(child.textContent || '').trim()) {
              child.textContent = cleaned;
            }
          });
        });
        card.querySelectorAll('.queue-opportunityHeader, .queue-opportunityHeaderCopy, .queue-opportunityAuxChips, .queue-opportunityInlineActions, .queue-opportunityHeaderAside, .queue-opportunityClient').forEach(function(node){
          if (!node || !node.querySelector) return;
          var cleanedText = String(node.textContent || '').replace(/NaN\d*/gi, '').replace(/\bNaN\b/gi, '').replace(/\s+/g, ' ').trim();
          var hasVisibleChild = Array.prototype.some.call(node.children || [], function(child){
            return child && child.hidden !== true && child.style.display !== 'none';
          });
          if (!cleanedText && !hasVisibleChild && node.parentNode) {
            node.parentNode.removeChild(node);
          }
        });
        Array.prototype.slice.call(card.children || []).forEach(function(node){
          if (!node || !node.querySelectorAll) return;
          var cleanedText = String(node.textContent || '')
            .replace(/NaN\d*/gi, '')
            .replace(/\bNaN\b/gi, '')
            .replace(/\s+/g, ' ')
            .trim();
          var interactiveChild = node.querySelector('button, summary, details, a, input, select, textarea');
          var visibleMeaningfulChild = Array.prototype.some.call(node.children || [], function(child){
            return child
              && child.hidden !== true
              && child.style.display !== 'none'
              && String(child.textContent || '').replace(/NaN\d*/gi, '').replace(/\bNaN\b/gi, '').replace(/\s+/g, ' ').trim();
          });
          if (!cleanedText && !interactiveChild && !visibleMeaningfulChild && node.parentNode) {
            node.parentNode.removeChild(node);
          }
        });
        card.querySelectorAll('.queue-opportunityCompactMeta').forEach(function(node){
          var cleaned = String(node.textContent || '').replace(/NaN\d*/gi, '').replace(/\bNaN\b/gi, '').replace(/\s+/g, ' ').trim();
          node.textContent = cleaned;
          if (!cleaned && node.parentNode) {
            node.parentNode.removeChild(node);
          }
        });
        Array.prototype.slice.call(card.children || []).forEach(function(node){
          if (!node || !node.classList) return;
          var keepNode = node.classList.contains('queue-opportunityHeader')
            || node.classList.contains('queue-opportunityRhythmDetails')
            || node.classList.contains('queue-opportunityDetails')
            || node.hasAttribute('data-due-payload');
          var cleaned = String(node.textContent || '')
            .replace(/NaN\d*/gi, '')
            .replace(/\bNaN\b/gi, '')
            .replace(/\s+/g, ' ')
            .trim();
          var visibleInteractiveChild = node.querySelector && node.querySelector('button,summary,details,a,input,select,textarea');
          if (!keepNode && !cleaned && !visibleInteractiveChild && node.parentNode) {
            node.parentNode.removeChild(node);
          }
        });
        Array.prototype.slice.call(card.children || []).forEach(function(node){
          if (!node || !node.classList) return;
          var cleaned = String(node.textContent || '').replace(/NaN\d*/gi, '').replace(/\bNaN\b/gi, '').replace(/\s+/g, ' ').trim();
          var keepNode = node.classList.contains('queue-opportunityHeader')
            || node.classList.contains('bd-opportunityBody')
            || node.classList.contains('queue-opportunityRhythmDetails')
            || node.classList.contains('queue-opportunityDetails')
            || node.hasAttribute('data-due-payload');
          if (!keepNode && !cleaned && node.parentNode) {
            node.parentNode.removeChild(node);
          }
        });
      }

      function scrubDueQueueListDom(){
        if (!dueQueueList || !dueQueueList.querySelectorAll) return;
        dueQueueList.querySelectorAll('[data-due-card]').forEach(scrubDueQueueCardDom);
      }

      function dueQueueCardsMarkup(rows){
        return retailArray(rows).map(safePriorityOpportunityCardMarkup).join('');
      }

      function appendDueQueueCards(rows){
        if (!dueQueueList) return;
        var nextRows = retailArray(rows);
        if (!nextRows.length) return;
        var markup = dueQueueCardsMarkup(nextRows);
        if (!markup) return;
        dueQueueList.insertAdjacentHTML('beforeend', markup);
        Array.prototype.slice.call(dueQueueList.querySelectorAll('[data-due-card]')).slice(-nextRows.length).forEach(scrubDueQueueCardDom);
      }

      function dueHealthCardMarkup(key, label, value, sub, isActive){
        return ''
          + '<button class="due-healthCard' + (isActive ? ' is-active' : '') + '" type="button" data-due-health-key="' + escapeHtml(key) + '">'
          +   '<span class="due-healthCardLabel">' + escapeHtml(label) + '</span>'
          +   '<strong class="due-healthCardValue">' + escapeHtml(String(value || '0')) + '</strong>'
          +   '<span class="due-healthCardSub">' + escapeHtml(sub || '') + '</span>'
          + '</button>';
      }

      function dueFocusRowsForWorkspace(summary, workspace){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var rowSets = safeSummary.workspace_row_sets && typeof safeSummary.workspace_row_sets === 'object'
          ? safeSummary.workspace_row_sets
          : {};
        var rows = retailArray(rowSets[workspace]);
        if (rows.length) return rows;
        return dueRowsForWorkspace(retailArray(dueQueueRows), workspace);
      }

      function dueFocusPreviewNames(rows){
        return retailArray(rows).slice(0, 2).map(function(row){
          return retailTextValue(row && row.guest_name, '');
        }).filter(Boolean);
      }

      function dueFocusPreviewText(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        return retailTextValue(safeRow && safeRow.recommended_action, '')
          || retailTextValue(safeRow && safeRow.diagnosis_summary, '')
          || retailTextValue(safeRow && safeRow.business_bucket_reason, '')
          || retailTextValue(safeRow && safeRow.explanation, '')
          || 'Open the lane to see the next guests to contact.';
      }

      function dueFocusCardMarkup(definition, count, rows){
        var safeDef = definition && typeof definition === 'object' ? definition : {};
        var workspace = String(safeDef.workspace || 'all').trim() || 'all';
        var workflow = String(safeDef.workflow || 'all').trim() || 'all';
        var previewRows = retailArray(rows);
        var leadRow = previewRows[0] || null;
        var isActive = String(dueQueueWorkspace || 'all') === workspace
          && String(dueQueueWorkflowFilter || 'all') === workflow;
        var cardClass = 'due-healthCard due-focusCard' + (isActive ? ' is-active' : '');
        var reason = leadRow
          ? dueFocusPreviewText(leadRow)
          : retailTextValue(safeDef.empty_copy, 'Queue is clear here for now.');
        return ''
          + '<button class="' + escapeHtml(cardClass) + '" type="button" data-due-focus-workspace="' + escapeHtml(workspace) + '" data-due-focus-workflow="' + escapeHtml(workflow) + '">'
          +   '<span class="due-healthCardLabel">' + escapeHtml(retailTextValue(safeDef.label, 'Focus lane')) + '</span>'
          +   '<strong class="due-healthCardValue">' + escapeHtml(workspaceCountText(count)) + '</strong>'
          +   '<span class="due-focusCardReason">' + escapeHtml(reason) + '</span>'
          +   '<span class="due-focusCardAction">' + escapeHtml(count > 0 ? 'Open lane' : 'Nothing waiting') + '</span>'
          + '</button>';
      }

      function renderDueQueueMetrics(summary){
        if (!dueMetricsMount) return;
        var allRows = retailArray(dueQueueRows);
        var reachablePhone = allRows.filter(function(row){
          return row && row.has_phone === true;
        }).length;
        var reachableEmail = allRows.filter(function(row){
          return row && row.has_email === true;
        }).length;
        var duplicateAccounts = allRows.filter(function(row){
          return row && (row.duplicate_account_flag === true || Number(row.duplicate_account_count || 0) > 1);
        }).length;
        var futureBooked = allRows.filter(function(row){
          return row && (row.has_future_appointment === true || row.future_appointment_found === true);
        }).length;
        var missingContact = allRows.filter(function(row){
          return row && row.has_phone !== true && row.has_email !== true;
        }).length;
        dueMetricsMount.innerHTML = ''
          + dueScorecardCardMarkup('Actionable now', workspaceCountText(dueFunnelActiveGuests(summary)), 'Guests currently active in the queue')
          + dueScorecardCardMarkup('Phone ready', workspaceCountText(reachablePhone), 'Rows with a callable/textable number')
          + dueScorecardCardMarkup('Email ready', workspaceCountText(reachableEmail), 'Rows with an email fallback')
          + dueScorecardCardMarkup('Duplicate accounts', workspaceCountText(duplicateAccounts), 'Guests that may need account cleanup while working')
          + dueScorecardCardMarkup('Future booked', workspaceCountText(futureBooked), 'Rows that still need manager awareness despite a future appointment')
          + dueScorecardCardMarkup('No contact path', workspaceCountText(missingContact), 'Rows missing both phone and email');
      }

      function dueHealthFilterForKey(key){
        var normalized = String(key || '').trim();
        var currentWorkflow = String(dueQueueWorkflowFilter || 'all').trim() || 'all';
        if (normalized === 'all') {
          return { workspace: 'all', workflow: currentWorkflow };
        }
        if (
          normalized === 'never_visited'
          || normalized === 'needs_prebook'
          || normalized === 'needs_attention'
          || normalized === 'needs_recovery'
          || normalized === 'no_pattern'
        ) {
          return { workspace: normalized, workflow: currentWorkflow };
        }
        if (normalized === 'appointments') {
          return { workspace: 'appointments', workflow: currentWorkflow };
        }
        if (normalized === 'active_drift') {
          return { workspace: 'active_drift', workflow: currentWorkflow };
        }
        if (normalized === 'long_lost') {
          return { workspace: 'long_lost', workflow: currentWorkflow };
        }
        if (normalized === 'prebook') {
          return { workspace: 'prebook', workflow: currentWorkflow };
        }
        if (normalized === 'retail') {
          return { workspace: 'retail', workflow: currentWorkflow };
        }
        if (normalized === 'referral') {
          return { workspace: 'referral', workflow: currentWorkflow };
        }
        if (normalized === 'review') {
          return { workspace: 'review', workflow: currentWorkflow };
        }
        if (normalized === 'wins') {
          return { workspace: 'all', workflow: 'completed' };
        }
        return { workspace: 'all', workflow: currentWorkflow };
      }

      function dueHealthKeyIsActive(key){
        var filter = dueHealthFilterForKey(key);
        return String(dueQueueWorkspace || 'all') === filter.workspace
          && String(dueQueueWorkflowFilter || 'all') === filter.workflow;
      }

      function dueFunnelTrackedGuests(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var snapshot = safeSummary.snapshot && typeof safeSummary.snapshot === 'object'
          ? safeSummary.snapshot
          : {};
        var snapshotPayload = snapshot.payload && typeof snapshot.payload === 'object'
          ? snapshot.payload
          : {};
        var debugCounts = safeSummary.debug_counts && typeof safeSummary.debug_counts === 'object'
          ? safeSummary.debug_counts
          : {};
        return Number(
          safeSummary.total_tracked_guests
          || safeSummary.tracked_guests
          || snapshotPayload.total_tracked_guests
          || snapshotPayload.tracked_guest_count
          || debugCounts.deduped_clients
          || 0
        ) || 0;
      }

      function dueFunnelSuppressedGuests(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var debugCounts = safeSummary.debug_counts && typeof safeSummary.debug_counts === 'object'
          ? safeSummary.debug_counts
          : {};
        return Number(
          safeSummary.future_booked_suppressed_client_groups
          || safeSummary.future_booked_client_groups
          || safeSummary.suppressed_with_future_appointment
          || debugCounts.suppressed_same_category_future_groups
          || 0
        ) || 0;
      }

      function dueFunnelActiveGuests(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var allWorkspace = safeSummary.workspace_counts_all && typeof safeSummary.workspace_counts_all === 'object'
          ? safeSummary.workspace_counts_all
          : (safeSummary.workspace_counts && typeof safeSummary.workspace_counts === 'object'
            ? safeSummary.workspace_counts
            : {});
        return Number(
          allWorkspace.all
          || safeSummary.total_snapshot_rows
          || (Number(dueSummaryActionableAppointmentCount(safeSummary) || 0)
            + Number((safeSummary.unified_retail_count || 0)) 
            + Number((safeSummary.unified_referral_count || 0))
            + Number((safeSummary.unified_review_count || 0)))
          || safeSummary.total_due_clients
          || dueSummaryActionableAppointmentCount(safeSummary)
          || 0
        ) || 0;
      }

      function dueFunnelClaimedGuests(summary){
        var safeSummary = dueAuthoritativeSummary(summary);
        var allWorkspace = safeSummary.workspace_counts_all && typeof safeSummary.workspace_counts_all === 'object'
          ? safeSummary.workspace_counts_all
          : (safeSummary.workspace_counts && typeof safeSummary.workspace_counts === 'object'
            ? safeSummary.workspace_counts
            : {});
        return Number(
          allWorkspace.my_claimed
          || safeSummary.unified_my_queue_count
          || 0
        ) || 0;
      }

      function dueFunnelCandidateGuests(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var debugCounts = safeSummary.debug_counts && typeof safeSummary.debug_counts === 'object'
          ? safeSummary.debug_counts
          : {};
        return Number(
          safeSummary.total_snapshot_rows
          || safeSummary.total_due_clients
          || debugCounts.returned_groups
          || debugCounts.published_actionable_groups
          || debugCounts.actionable_classified_groups
          || dueFunnelActiveGuests(safeSummary)
          || 0
        ) || 0;
      }

      function dueContextualWorkspaceCounts(summary){
        var directSummary = summary && typeof summary === 'object' ? summary : {};
        if (
          directSummary.unified_queue === true
          && directSummary.local_row_set_complete === true
          && directSummary.workspace_row_sets
          && typeof directSummary.workspace_row_sets === 'object'
          && retailArray(directSummary.workspace_row_sets.all).length
        ) {
          return buildUnifiedQueueWorkspaceCounts(retailArray(directSummary.workspace_row_sets.all));
        }
        var safeSummary = dueAuthoritativeSummary(summary);
        if (
          safeSummary.unified_queue === true
          && safeSummary.local_row_set_complete === true
          && safeSummary.workspace_row_sets
          && typeof safeSummary.workspace_row_sets === 'object'
          && retailArray(safeSummary.workspace_row_sets.all).length
        ) {
          return buildUnifiedQueueWorkspaceCounts(retailArray(safeSummary.workspace_row_sets.all));
        }
        var unifiedContextualCounts = safeSummary.workspace_counts_contextual && typeof safeSummary.workspace_counts_contextual === 'object'
          ? safeSummary.workspace_counts_contextual
          : {};
        var unifiedAllCounts = safeSummary.workspace_counts_all && typeof safeSummary.workspace_counts_all === 'object'
          ? safeSummary.workspace_counts_all
          : (safeSummary.workspace_counts && typeof safeSummary.workspace_counts === 'object'
            ? safeSummary.workspace_counts
            : {});
        if (safeSummary.unified_queue === true) {
          if (Object.keys(unifiedAllCounts).length) {
            return unifiedAllCounts;
          }
          if (Object.keys(unifiedContextualCounts).length) {
            return Object.assign({}, unifiedAllCounts, unifiedContextualCounts);
          }
          if (dueQueueRows.length) {
            return buildUnifiedQueueWorkspaceCounts(retailArray(dueQueueRows));
          }
        }
        var bucketCounts = dueSummaryBusinessBucketCounts(safeSummary);
        if (Object.keys(bucketCounts).length) {
          var watchDueSoon = Number(bucketCounts.watch_due_soon || 0) || 0;
          var watchDueNow = Number(bucketCounts.watch_due_now || 0) || 0;
          var atRiskCadenceBreak = Number(bucketCounts.at_risk_cadence_break || 0) || 0;
          var atRiskCanceledUnbooked = Number(bucketCounts.at_risk_canceled_unbooked || 0) || 0;
          var atRiskNoShowUnbooked = Number(bucketCounts.at_risk_no_show_unbooked || 0) || 0;
          var atRiskDecliningFrequency = Number(bucketCounts.at_risk_declining_frequency || 0) || 0;
          var atRiskPartialReturn = Number(bucketCounts.at_risk_partial_return || 0) || 0;
          var lostLikelyLapsed = Number(bucketCounts.lost_likely_lapsed || 0) || 0;
          var prebook = watchDueSoon + watchDueNow;
          var retailCount = Number((safeSummary.workspace_counts_contextual && safeSummary.workspace_counts_contextual.retail) || (safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.retail) || safeSummary.unified_retail_count || 0) || 0;
          var referralCount = Number((safeSummary.workspace_counts_contextual && safeSummary.workspace_counts_contextual.referral) || (safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.referral) || safeSummary.unified_referral_count || 0) || 0;
          var reviewCount = Number((safeSummary.workspace_counts_contextual && safeSummary.workspace_counts_contextual.review) || (safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.review) || safeSummary.unified_review_count || 0) || 0;
          var myClaimed = Number((safeSummary.workspace_counts_contextual && safeSummary.workspace_counts_contextual.my_claimed) || (safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.my_claimed) || safeSummary.unified_my_queue_count || 0) || 0;
          var activeDrift = atRiskCadenceBreak + atRiskCanceledUnbooked + atRiskNoShowUnbooked + atRiskDecliningFrequency + atRiskPartialReturn;
          var neverVisited = Number((safeSummary.workspace_counts_contextual && safeSummary.workspace_counts_contextual.never_visited) || (safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.never_visited) || 0) || 0;
          var needsPrebook = Number((safeSummary.workspace_counts_contextual && safeSummary.workspace_counts_contextual.needs_prebook) || (safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.needs_prebook) || prebook || 0) || 0;
          var needsAttention = Number((safeSummary.workspace_counts_contextual && safeSummary.workspace_counts_contextual.needs_attention) || (safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.needs_attention) || activeDrift || 0) || 0;
          var needsRecovery = Number((safeSummary.workspace_counts_contextual && safeSummary.workspace_counts_contextual.needs_recovery) || (safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.needs_recovery) || lostLikelyLapsed || 0) || 0;
          var noPattern = Number((safeSummary.workspace_counts_contextual && safeSummary.workspace_counts_contextual.no_pattern) || (safeSummary.workspace_counts_all && safeSummary.workspace_counts_all.no_pattern) || 0) || 0;
          var appointments = neverVisited + needsPrebook + needsAttention + needsRecovery + noPattern;
          return {
            all: appointments + retailCount + referralCount + reviewCount,
            my_claimed: myClaimed,
            never_visited: neverVisited,
            needs_prebook: needsPrebook,
            needs_attention: needsAttention,
            needs_recovery: needsRecovery,
            no_pattern: noPattern,
            watch_due_soon: watchDueSoon,
            watch_due_now: watchDueNow,
            at_risk_cadence_break: atRiskCadenceBreak,
            at_risk_canceled_unbooked: atRiskCanceledUnbooked,
            at_risk_no_show_unbooked: atRiskNoShowUnbooked,
            at_risk_declining_frequency: atRiskDecliningFrequency,
            at_risk_partial_return: atRiskPartialReturn,
            lost_likely_lapsed: lostLikelyLapsed,
            prebook: prebook,
            active_drift: activeDrift,
            long_lost: lostLikelyLapsed,
            retail: retailCount,
            referral: referralCount,
            review: reviewCount
          };
        }
        var allWorkspace = safeSummary.workspace_counts_all && typeof safeSummary.workspace_counts_all === 'object'
          ? safeSummary.workspace_counts_all
          : (safeSummary.workspace_counts && typeof safeSummary.workspace_counts === 'object'
            ? safeSummary.workspace_counts
            : {});
        var contextual = safeSummary.workspace_counts_contextual && typeof safeSummary.workspace_counts_contextual === 'object'
          ? safeSummary.workspace_counts_contextual
          : {};
        return {
          all: Number(contextual.all != null ? contextual.all : (allWorkspace.all != null ? allWorkspace.all : (safeSummary.filtered_total_rows || 0))) || 0,
          my_claimed: Number(contextual.my_claimed != null ? contextual.my_claimed : (allWorkspace.my_claimed || safeSummary.unified_my_queue_count || 0)) || 0,
          never_visited: Number(contextual.never_visited != null ? contextual.never_visited : (allWorkspace.never_visited || 0)) || 0,
          needs_prebook: Number(contextual.needs_prebook != null ? contextual.needs_prebook : (allWorkspace.needs_prebook || 0)) || 0,
          needs_attention: Number(contextual.needs_attention != null ? contextual.needs_attention : (allWorkspace.needs_attention || 0)) || 0,
          needs_recovery: Number(contextual.needs_recovery != null ? contextual.needs_recovery : (allWorkspace.needs_recovery || 0)) || 0,
          no_pattern: Number(contextual.no_pattern != null ? contextual.no_pattern : (allWorkspace.no_pattern || 0)) || 0,
          watch_due_soon: Number(contextual.watch_due_soon != null ? contextual.watch_due_soon : (allWorkspace.watch_due_soon || 0)) || 0,
          watch_due_now: Number(contextual.watch_due_now != null ? contextual.watch_due_now : (allWorkspace.watch_due_now || 0)) || 0,
          at_risk_cadence_break: Number(contextual.at_risk_cadence_break != null ? contextual.at_risk_cadence_break : (allWorkspace.at_risk_cadence_break || 0)) || 0,
          at_risk_canceled_unbooked: Number(contextual.at_risk_canceled_unbooked != null ? contextual.at_risk_canceled_unbooked : (allWorkspace.at_risk_canceled_unbooked || 0)) || 0,
          at_risk_no_show_unbooked: Number(contextual.at_risk_no_show_unbooked != null ? contextual.at_risk_no_show_unbooked : (allWorkspace.at_risk_no_show_unbooked || 0)) || 0,
          at_risk_declining_frequency: Number(contextual.at_risk_declining_frequency != null ? contextual.at_risk_declining_frequency : (allWorkspace.at_risk_declining_frequency || 0)) || 0,
          at_risk_partial_return: Number(contextual.at_risk_partial_return != null ? contextual.at_risk_partial_return : (allWorkspace.at_risk_partial_return || 0)) || 0,
          lost_likely_lapsed: Number(contextual.lost_likely_lapsed != null ? contextual.lost_likely_lapsed : (allWorkspace.lost_likely_lapsed || 0)) || 0,
          prebook: Number(contextual.prebook != null ? contextual.prebook : (allWorkspace.prebook || 0)) || 0,
          active_drift: Number(contextual.active_drift != null ? contextual.active_drift : (allWorkspace.active_drift || 0)) || 0,
          long_lost: Number(contextual.long_lost != null ? contextual.long_lost : (allWorkspace.long_lost || 0)) || 0,
          retail: Number(contextual.retail != null ? contextual.retail : (allWorkspace.retail || 0)) || 0,
          referral: Number(contextual.referral != null ? contextual.referral : (allWorkspace.referral || 0)) || 0,
          review: Number(contextual.review != null ? contextual.review : (allWorkspace.review || 0)) || 0
        };
      }

      function dueWorkspaceLabelText(workspace){
        var normalized = String(workspace || 'all').trim() || 'all';
        if (normalized === 'my_claimed') return 'My Claimed Opportunities';
        if (normalized === 'never_visited') return 'Never Visited';
        if (normalized === 'needs_prebook') return 'Needs Prebook';
        if (normalized === 'needs_attention') return 'Needs Attention';
        if (normalized === 'needs_recovery') return 'Needs Recovery';
        if (normalized === 'no_pattern') return 'No Pattern';
        if (normalized === 'watch_due_soon') return 'Watch - Due Soon';
        if (normalized === 'watch_due_now') return 'Watch - Due Now';
        if (normalized === 'at_risk_cadence_break') return 'At Risk - Cadence Break';
        if (normalized === 'at_risk_canceled_unbooked') return 'At Risk - Canceled and Unbooked';
        if (normalized === 'at_risk_no_show_unbooked') return 'At Risk - No-Show and Unbooked';
        if (normalized === 'at_risk_declining_frequency') return 'At Risk - Declining Frequency';
        if (normalized === 'at_risk_partial_return') return 'At Risk - Partial Return';
        if (normalized === 'lost_likely_lapsed') return 'Lost - Likely Lapsed';
        if (normalized === 'prebook') return 'Prebook Rollup';
        if (normalized === 'active_drift') return 'Active Drift Rollup';
        if (normalized === 'long_lost') return 'Long-Lost Rollup';
        if (normalized === 'retail') return 'Retail';
        if (normalized === 'referral') return 'Referral';
        if (normalized === 'review') return 'Review';
        return 'All Opportunities';
      }

      function dueWorkflowLabelText(workflow){
        var normalized = String(workflow || 'all').trim() || 'all';
        if (normalized === 'all') return 'All';
        if (normalized === 'needs_action') return 'Needs Action';
        if (normalized === 'mine') return 'My Follow-ups';
        if (normalized === 'waiting') return 'Waiting';
        if (normalized === 'completed') return 'Recently Completed';
        return 'Recommended';
      }

      function dueCriteriaLeadText(totalRows, visibleRows){
        var workspace = String(dueQueueWorkspace || 'all').trim() || 'all';
        var workspaceLabel = dueWorkspaceLabelText(workspace).toLowerCase();
        var total = Number(totalRows || 0) || 0;
        var visible = Number(visibleRows || 0) || 0;
        if (visible > 0 && total > visible) {
          if (workspace === 'all') {
            return String(total) + ' opportunities match this queue. You are seeing the first ' + String(visible) + '.';
          }
          return String(total) + ' ' + workspaceLabel + ' opportunities match this queue. You are seeing the first ' + String(visible) + '.';
        }
        if (workspace === 'all') {
          return 'Showing ' + String(total) + ' opportunities.';
        }
        return 'Showing ' + String(total) + ' ' + workspaceLabel + ' opportunities.';
      }

      function dueVisibleRowCount(totalRows, availableRows){
        var total = Math.max(0, Number(totalRows || 0) || 0);
        var available = Math.max(0, Number(availableRows || 0) || 0);
        var requested = Math.max(dueQueuePageSize, Number(dueQueueVisibleCount || dueQueuePageSize) || dueQueuePageSize);
        if (!total && !available) return 0;
        return Math.min(requested, available || requested, total || available || requested);
      }

      function dueVisibleOpportunityKeys(rows){
        var visibleCount = dueVisibleRowCount(retailArray(rows).length, retailArray(rows).length);
        return retailArray(rows).slice(0, visibleCount).map(function(row){
          return retailTextValue(row && row.opportunity_key, '');
        }).filter(Boolean);
      }

      function renderDueHealthSummary(summary){
        if (!dueHealthSummaryMount) return;
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var trackedGuests = dueFunnelTrackedGuests(safeSummary);
        var candidateGuests = dueFunnelCandidateGuests(safeSummary);
        var suppressedGuests = dueFunnelSuppressedGuests(safeSummary);
        var activeGuests = dueFunnelActiveGuests(safeSummary);
        var claimedGuests = dueFunnelClaimedGuests(safeSummary);
        dueHealthSummaryMount.innerHTML = [
          dueHealthCardMarkup('tracked', 'Tracked Guests', workspaceCountText(trackedGuests), 'Everyone we can evaluate from Boulevard history in the current lookback.', false),
          dueHealthCardMarkup('candidates', 'Candidates Found', workspaceCountText(candidateGuests), 'Guests who triggered a real opportunity signal before suppression.', false),
          dueHealthCardMarkup('suppressed', 'Suppressed', workspaceCountText(suppressedGuests), 'Guests removed because they already future-booked or self-resolved.', false),
          dueHealthCardMarkup('all', 'Active Opportunities', workspaceCountText(activeGuests), 'Guests who are actually actionable in Business Development right now.', dueHealthKeyIsActive('all')),
          dueHealthCardMarkup('my_claimed', 'Claimed By Team', workspaceCountText(claimedGuests), 'Active opportunities already owned by a manager.', dueHealthKeyIsActive('my_claimed'))
        ].join('');
      }

      function dueRecommendedFocusMarkup(summary){
        if (!dueRecommendedFocusMount) return;
        var counts = dueContextualWorkspaceCounts(summary);
        var definitions = [
          {
            workspace: 'my_claimed',
            workflow: 'mine',
            label: 'My Queue',
            description: 'Owned guests that already have manager momentum.',
            empty_copy: 'Nothing is currently claimed in your lane.'
          },
          {
            workspace: 'never_visited',
            workflow: 'all',
            label: 'Never Visited',
            description: 'No completed visit yet, no future booking, and no visit history to calculate a pattern from.',
            empty_copy: 'No never-visited guests are waiting right now.'
          },
          {
            workspace: 'needs_prebook',
            workflow: 'all',
            label: 'Needs Prebook',
            description: 'Known cadence and not overdue yet, but still missing the next booking.',
            empty_copy: 'No known-cadence guests are waiting for a prebook right now.'
          },
          {
            workspace: 'needs_attention',
            workflow: 'all',
            label: 'Needs Attention',
            description: 'Known cadence and overdue without a future booking.',
            empty_copy: 'No overdue known-cadence guests are waiting right now.'
          },
          {
            workspace: 'needs_recovery',
            workflow: 'all',
            label: 'Needs Recovery',
            description: 'More than 45 days overdue against known cadence with no future booking.',
            empty_copy: 'No recovery-level appointment guests are sitting open right now.'
          },
          {
            workspace: 'no_pattern',
            workflow: 'all',
            label: 'No Pattern',
            description: 'No future booking, but not enough trusted cadence yet to assign urgency.',
            empty_copy: 'Nothing is sitting in no pattern right now.'
          },
          {
            workspace: 'retail',
            workflow: 'all',
            label: 'Retail Follow-Up',
            description: 'Post-visit retail opportunities missing the full routine.',
            empty_copy: 'Retail follow-up is clear right now.'
          },
          {
            workspace: 'review',
            workflow: 'all',
            label: 'Review Asks',
            description: 'Fresh positive visits still in the ideal review window.',
            empty_copy: 'No review opportunities are waiting right now.'
          },
          {
            workspace: 'referral',
            workflow: 'all',
            label: 'Referral Asks',
            description: 'Loyal guests ready for a referral conversation.',
            empty_copy: 'No referral asks are waiting right now.'
          }
        ];
        dueRecommendedFocusMount.innerHTML = definitions.map(function(definition){
          var workspace = String(definition.workspace || 'all').trim() || 'all';
          var count = Number(counts[workspace] || 0) || 0;
          var rows = dueFocusRowsForWorkspace(summary, workspace);
          return dueFocusCardMarkup(definition, count, rows);
        }).join('');
      }

      function renderDueQueue(){
        var summary = dueQueueSummary || {};
        var authoritativeSummary = dueAuthoritativeSummary(summary);
        var workspace = String(dueQueueWorkspace || 'all').trim() || 'all';
        var isUnifiedQueue = !!(summary && summary.unified_queue === true);
        var opportunityUniverse = mergePriorityRowsByOpportunityKey(
          mergeLocalClaimedRows(retailArray(dueQueueRows))
        );
          var contextUniverse = opportunityUniverse;

        var rows = [];
        if (isUnifiedQueue) {
          rows = contextUniverse.filter(unifiedRowMatchesSharedFilters);
        } else {
          rows = contextUniverse
            .filter(opportunitySourceMatchesFilter)
            .filter(unifiedRowMatchesSharedFilters)
            .filter(unifiedStageMatchesActiveFilter);
        }
        var sharedRows = rows;
        var localRowSetComplete = !!(summary && summary.unified_queue === true && summary.local_row_set_complete === true);
        var backendBucketKey = dueWorkspaceBackendBucketKey(workspace);
        var workspaceRows = (isUnifiedQueue && !localRowSetComplete && backendBucketKey)
          ? sharedRows
          : dueRowsForWorkspace(sharedRows, workspace);
        rows = dueSortQueueRowsLocally(workspaceRows);
        var workspaceCountsAll = buildUnifiedQueueWorkspaceCounts(sharedRows);
        workspaceCountsAll.all = sharedRows.length;
        var workspaceCountsContextual = workspaceCountsAll;
        var workspaceRowSets = buildUnifiedQueueWorkspaceRowSets(sharedRows);
        var authoritativeCounts = summary && summary.workspace_counts_all && typeof summary.workspace_counts_all === 'object'
          ? Object.assign({}, workspaceCountsAll, summary.workspace_counts_all)
          : (summary && summary.workspace_counts && typeof summary.workspace_counts === 'object'
            ? Object.assign({}, workspaceCountsAll, summary.workspace_counts)
            : workspaceCountsAll);
        var authoritativeContextualCounts = summary && summary.workspace_counts_contextual && typeof summary.workspace_counts_contextual === 'object'
          ? Object.assign({}, workspaceCountsContextual, summary.workspace_counts_contextual)
          : authoritativeCounts;
        var selectedWorkspaceTotal = Object.prototype.hasOwnProperty.call(authoritativeCounts, workspace)
          ? (Number(authoritativeCounts[workspace]) || 0)
          : (Number(workspaceCountsAll[workspace]) || Number(summary && summary.filtered_total_rows) || Number(authoritativeCounts.all) || rows.length || 0);
        var totalSnapshotRows = localRowSetComplete
          ? (Number(sharedRows.length || 0) || 0)
          : (Number(summary && summary.total_snapshot_rows) || Number(authoritativeCounts.all) || Number(sharedRows.length || 0) || 0);

        var renderSignature = dueCurrentRenderSignature(sharedRows) + '|' + workspace + '|' + String(rows.length || 0);
        if (renderSignature !== dueQueueRenderSignature) {
          dueQueueRenderSignature = renderSignature;
          if (dueQueuePreserveVisibleCountOnNextRender !== true) {
            dueQueueVisibleCount = dueQueuePageSize;
            dueQueueOffset = 0;
          }
        }
        var totalRows = rows.length;
        dueQueueRenderableRowCount = localRowSetComplete
          ? totalRows
          : Math.max(totalRows, selectedWorkspaceTotal);
        var visibleCount = dueVisibleRowCount(dueQueueRenderableRowCount, rows.length);
        var pagedRows = rows.slice(0, visibleCount);
        var appendOnlyListRender = (
          renderSignature === dueQueueListRenderSignature
          && dueQueueListRenderedCount > 0
          && visibleCount > dueQueueListRenderedCount
          && dueQueueList
          && dueQueueList.children
          && dueQueueList.children.length > 0
        );
        var renderSummary = summary && summary.unified_queue === true
          ? Object.assign({}, authoritativeSummary, summary, {
              filtered_total_rows: localRowSetComplete ? (Number(rows.length || 0) || 0) : selectedWorkspaceTotal,
              total_snapshot_rows: totalSnapshotRows,
              total_due_clients: Number((summary && summary.total_due_clients) || totalSnapshotRows || 0) || 0,
              business_bucket_counts_actionable: summary.business_bucket_counts_actionable || workspaceCountsAll,
              business_bucket_counts_rows: summary.business_bucket_counts_rows || workspaceCountsAll,
              workspace_row_sets: localRowSetComplete ? workspaceRowSets : {},
              unified_my_queue_count: Number((authoritativeCounts && authoritativeCounts.my_claimed) || workspaceCountsAll.my_claimed || 0) || 0,
              workspace_counts: summary.workspace_counts || authoritativeCounts,
              workspace_counts_live: summary.workspace_counts_live || authoritativeCounts,
              workspace_counts_all: authoritativeCounts,
              workspace_counts_contextual: authoritativeContextualCounts,
              visible_row_count: visibleCount
            })
          : summary;
        renderDueCriteriaNote(renderSummary);
        renderDueRangeNote();
        var contextualCounts = dueContextualWorkspaceCounts(renderSummary);
        totalRows = rows.length;
        var dueFilterConfig = getDueQueueFilterConfig();
        var hasDueFilters = !!(
          dueQueueOpportunityFilter !== 'all' ||
          dueQueueActiveStage !== 'all' ||
          dueFilterConfig.category ||
          dueFilterConfig.duplicateOnly === true ||
          dueQueueActiveClientType !== 'all' ||
          String((dueCadenceSourceFilter && dueCadenceSourceFilter.value) || '').trim() ||
          !!(dueHasPhoneOnly && dueHasPhoneOnly.checked) ||
          !!(dueHasEmailOnly && dueHasEmailOnly.checked)
        );
        syncDueWorkspaceTabs();
        syncDueStageTabs();
        syncDueOpportunityTabs();
        syncDueWorkflowTabs();
        syncDueOwnerTabs();
        syncDueScorecardRangeTabs();
        syncDueScorecardAudienceTabs();
        renderDueWorkspaceCounts(renderSummary);
        syncDueSortTabs();
        syncDueClientTypeTabs();
        var activeRefreshProgress = dueQueueRefreshProgress || deriveDueRefreshProgressFromSummary(renderSummary) || {};
        var activeRefreshStatus = String((activeRefreshProgress && activeRefreshProgress.status) || '').trim().toLowerCase();
        if (!appendOnlyListRender) {
          renderDueScorecard();
          renderDueRefreshMeta(activeRefreshProgress);
          renderDueRefreshImpact(dueLastRefreshImpact);
          setDueStatus(
            buildRecaptureProgressSummary(activeRefreshProgress, {}),
            activeRefreshStatus === 'failed'
              ? 'error'
              : activeRefreshStatus === 'running'
                ? 'warning'
                : 'success'
          );
        }
        if (dueQueueList) {
          if (appendOnlyListRender && pagedRows.length) {
            appendDueQueueCards(pagedRows.slice(dueQueueListRenderedCount, visibleCount));
          } else {
            dueQueueList.innerHTML = pagedRows.length
              ? dueQueueCardsMarkup(pagedRows)
              : '<div class="retail-empty">No business-development opportunities match this view right now.</div>';
            scrubDueQueueListDom();
          }
        }
        dueQueueListRenderSignature = renderSignature;
        dueQueueListRenderedCount = pagedRows.length;
        if (dueQueuePagerSummary) {
          var start = pagedRows.length ? 1 : 0;
          var end = Math.min(visibleCount, totalRows || visibleCount || 0);
          if (!localRowSetComplete && dueQueueRenderableRowCount > totalRows) {
            dueQueuePagerSummary.textContent = String(start) + '–' + String(end) + ' of ' + String(totalRows || 0) + ' loaded. ' + String(dueQueueRenderableRowCount || 0) + ' available.';
          } else {
            dueQueuePagerSummary.textContent = String(start) + '–' + String(end) + ' of ' + String(totalRows || 0) + ' shown.';
          }
        }
        if (duePrevPageBtn) duePrevPageBtn.disabled = visibleCount <= dueQueuePageSize;
        if (dueNextPageBtn) dueNextPageBtn.disabled = visibleCount >= dueQueueRenderableRowCount;
        if (dueBottomLoadMoreBtn) dueBottomLoadMoreBtn.disabled = visibleCount >= dueQueueRenderableRowCount;
        if (dueBottomPager) dueBottomPager.hidden = visibleCount >= dueQueueRenderableRowCount;
        syncDueInfiniteScroll(dueQueueRenderableRowCount || totalRows || rows.length || 0, pagedRows.length);
      }

      async function fetchLikelyDueClients(limitOverride, offsetOverride, overrides){
        var dueFilterConfig = getDueQueueFilterConfig();
        var requestOverrides = overrides && typeof overrides === 'object' ? overrides : {};
        var sortBy = 'priority_score';
        var sortDirection = 'desc';
        if (dueQueueSortMode === 'due_soonest') {
          sortBy = 'days_until_due';
          sortDirection = 'asc';
        } else if (dueQueueSortMode === 'most_overdue') {
          sortBy = 'days_overdue';
          sortDirection = 'desc';
        } else if (dueQueueSortMode === 'last_visit_newest') {
          sortBy = 'last_in_date';
          sortDirection = 'desc';
        } else if (dueQueueSortMode === 'last_visit_oldest') {
          sortBy = 'last_in_date';
          sortDirection = 'asc';
        } else if (dueQueueSortMode === 'highest_appointment_count') {
          sortBy = 'appointment_count';
          sortDirection = 'desc';
        } else if (dueQueueSortMode === 'guest_name') {
          sortBy = 'guest_name';
          sortDirection = 'asc';
        } else if (dueQueueSortMode === 'primary_staff') {
          sortBy = 'primary_staff_name';
          sortDirection = 'asc';
        } else if (dueQueueSortMode === 'category') {
          sortBy = 'primary_category';
          sortDirection = 'asc';
        }
        if (requestOverrides.sort_by != null) {
          sortBy = String(requestOverrides.sort_by || '').trim() || sortBy;
        }
        if (requestOverrides.sort_direction != null) {
          var overrideDirection = String(requestOverrides.sort_direction || '').trim().toLowerCase();
          sortDirection = overrideDirection === 'asc' ? 'asc' : 'desc';
        }
        var requestBody = {
          action: 'client_followup_queue_v3',
          guest_search: String((requestOverrides.guest_search != null ? requestOverrides.guest_search : ((dueSearchFilter && dueSearchFilter.value) || ''))).trim(),
          staff_name: String((requestOverrides.staff_name != null ? requestOverrides.staff_name : ((dueStaffFilter && dueStaffFilter.value) || ''))).trim(),
          category: dueFilterConfig.category,
          queue_stage: requestOverrides.queue_stage != null
            ? String(requestOverrides.queue_stage || '').trim()
            : (dueQueueActiveStage !== 'all' ? dueQueueActiveStage : ''),
          business_bucket_key: String(requestOverrides.business_bucket_key || requestOverrides.businessBucketKey || '').trim(),
          history_rating: requestOverrides.history_rating != null
            ? String(requestOverrides.history_rating || '').trim()
            : (dueQueueActiveClientType !== 'all' ? dueQueueActiveClientType : ''),
          cadence_source: String((dueCadenceSourceFilter && dueCadenceSourceFilter.value) || '').trim(),
          duplicate_only: dueFilterConfig.duplicateOnly === true,
          has_phone: !!(dueHasPhoneOnly && dueHasPhoneOnly.checked),
          has_email: !!(dueHasEmailOnly && dueHasEmailOnly.checked),
          sort_by: sortBy,
          sort_direction: sortDirection,
          limit: Number(limitOverride || dueQueuePageSize) || dueQueuePageSize,
          offset: Number(offsetOverride || dueQueueOffset) || 0
        };
        if (requestOverrides.max_days_until_due != null && String(requestOverrides.max_days_until_due).trim() !== '') {
          requestBody.max_days_until_due = Number(requestOverrides.max_days_until_due);
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load client follow-up queue.');
        }
        data.summary = data && data.summary && typeof data.summary === 'object' ? data.summary : {};
        data.summary.refresh = data && hasDueRefreshProgressData(data.refresh_progress) ? data.refresh_progress : {};
        data.summary.snapshot = data && data.snapshot ? data.snapshot : null;
        return data;
      }

      var BD_FAST_NON_ACTIONABLE_BUCKETS = {
        safe_future_booked: true,
        safe_on_cadence: true,
        inactive_historical: true,
        unclassified_data_exception: true
      };
      var BD_FAST_STRATEGY_CONFIG = {
        recovery_overdue_days: 45,
        level2_overdue_days: 14,
        strong_history_min_appointments: 4,
        strong_cadence_min_sample: 3,
        high_return_overdue_grace_days: 7,
        low_return_missed_cycles: 2,
        medium_return_missed_cycles: 1
      };
      var BD_FAST_CATEGORY_LABELS = {
        retail: 'Retail',
        wellness: 'Wellness',
        new_guest_no_prebook: 'First-Time Guests',
        never_visited: 'Never visited',
        future_protected: 'Future Protected',
        needs_booking: 'Needs Booking',
        acted_on: 'Acted On'
      };
      var BD_FAST_MODE_LABELS = {
        retail_growth: 'Drive Retail',
        service_growth: 'Book Appointment',
        hybrid_growth: 'Retail + Booking'
      };
      var BD_FAST_LANE_TABS = [
        { key: 'retail', label: 'Retail' },
        { key: 'wellness', label: 'Wellness' },
        { key: 'new_guest_no_prebook', label: 'First-Time Guests' },
        { key: 'never_visited', label: 'Never Visited' },
        { key: 'needs_booking', label: 'Needs Booking' }
      ];
      var BD_FAST_ACTIVE_VIEW_KEY = 'all_open';

      function setBdFastStatus(text, tone){
        if (!bdFastStatus) return;
        bdFastStatus.textContent = String(text || '');
        bdFastStatus.className = 'bd-fastStatus' + (tone ? ' bd-fastStatus--' + tone : '');
      }

      function setBdFastShellState(state){
        if (!bdFastShell) return;
        bdFastShell.setAttribute('data-state', String(state || 'idle'));
      }

      function bdFastNormalizeViewKey(value){
        var normalized = String(value || '').trim().toLowerCase();
        return normalized === 'acted_on' ? 'acted_on' : BD_FAST_ACTIVE_VIEW_KEY;
      }

      function bdFastCurrentLane(){
        return bdFastNormalizeViewKey((bdFastMode && bdFastMode.value) || BD_FAST_ACTIVE_VIEW_KEY);
      }

      function ensureBdFastModeOption(value, label){
        if (!bdFastMode) return;
        var normalizedValue = String(value || '').trim();
        if (!normalizedValue) return;
        var existing = retailArray(bdFastMode.options).find(function(option){
          return retailTextValue(option && option.value, '') === normalizedValue;
        });
        if (existing) {
          if (label) existing.textContent = String(label);
          return;
        }
        var option = document.createElement('option');
        option.value = normalizedValue;
        option.textContent = String(label || normalizedValue);
        bdFastMode.appendChild(option);
      }

      function syncBdFastModeOptions(){
        if (!bdFastMode) return;
        ensureBdFastModeOption(BD_FAST_ACTIVE_VIEW_KEY, 'Open Opportunities');
        ensureBdFastModeOption('acted_on', 'Acted On');
        bdFastMode.value = bdFastNormalizeViewKey(bdFastMode.value || BD_FAST_ACTIVE_VIEW_KEY);
      }

      function bdFastIsHistoryView(){
        return bdFastCurrentLane() === 'acted_on';
      }

      function bdFastPerformanceDateFrom(){
        return new Date(new Date().getFullYear(), 0, 1);
      }

      function bdFastPerformanceDateTo(){
        return startOfLocalDay(new Date());
      }

      function bdFastPerformancePeriodLabel(){
        var start = bdFastPerformanceDateFrom();
        return String(start.getFullYear()) + ' YTD';
      }

      function bdFastLastRefreshLabel(summary, progress){
        var summarySnapshot = summary && typeof summary === 'object' ? summary : {};
        var refreshProgress = progress && typeof progress === 'object' ? progress : {};
        var candidates = [
          retailTextValue(refreshProgress.completed_at, ''),
          retailTextValue(refreshProgress.finished_at, ''),
          retailTextValue(refreshProgress.updated_at, ''),
          retailTextValue(summarySnapshot.updated_at, ''),
          retailTextValue(summarySnapshot.generated_at, ''),
          retailTextValue(summarySnapshot.snapshot_at, '')
        ].filter(Boolean);
        var latest = candidates[0] || '';
        return latest ? formatRecaptureDateTime(latest) : 'Waiting for first refresh';
      }

      function updateBdFastLastRefreshValue(summary, progress){
        if (!bdFastLastRefreshValue) return;
        bdFastLastRefreshValue.textContent = bdFastLastRefreshLabel(summary, progress);
      }

      function bdFastLaneFetchMode(lane){
        return String(lane || '').trim() === 'acted_on' ? 'acted_on_actions' : 'all';
      }

      function bdFastModeIsActive(mode){
        return String(mode || '').trim() === bdFastLaneFetchMode(bdFastCurrentLane());
      }

      async function fetchBdFastQueuePage(mode, limitValue, offsetValue){
        var requestedMode = String(mode || 'all').trim() || 'all';
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: requestedMode === 'acted_on_actions' ? 'client_followup_queue_v4_actions' : 'client_followup_queue_v4',
            opportunity_mode: requestedMode,
            include_all_states: true,
            limit: Math.max(1, Number(limitValue) || 500),
            offset: Math.max(0, Number(offsetValue) || 0),
            sort_by: 'priority_score',
            sort_direction: 'desc'
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load fast business-development queue.');
        }
        return data;
      }

      function clearBdFastRefreshStatusPolling(){
        if (bdFastRefreshPollTimer) {
          window.clearTimeout(bdFastRefreshPollTimer);
          bdFastRefreshPollTimer = null;
        }
      }

      function bdFastModeLabel(mode){
        return BD_FAST_MODE_LABELS[String(mode || '').trim()] || 'Book Appointment';
      }

      function bdFastReadModeState(mode){
        var key = String(mode || '').trim() || 'all';
        var existing = bdFastModeStateByMode[key];
        if (existing && typeof existing === 'object') return existing;
        var created = {
          allRows: [],
          filteredRows: [],
          allRowsLoaded: false,
          loadedRowCount: 0,
          totalRowEstimate: 0,
          page: 0,
          hasLoaded: false,
          loading: false,
          loadRequestId: 0,
          error: ''
        };
        bdFastModeStateByMode[key] = created;
        return created;
      }

      function bdFastModeHasLoadedCompletely(mode){
        var state = bdFastReadModeState(mode);
        return state.hasLoaded === true && state.allRowsLoaded === true;
      }

      function bdFastAllModeDataReady(){
        return bdFastModeHasLoadedCompletely(bdFastLaneFetchMode(bdFastCurrentLane()));
      }

      function bdFastPersistModeState(mode){
        var key = String(mode || '').trim() || 'all';
        var state = bdFastReadModeState(key);
        state.allRows = retailArray(bdFastAllRows).slice();
        state.filteredRows = retailArray(bdFastFilteredRows).slice();
        state.allRowsLoaded = bdFastAllRowsLoaded === true;
        state.loadedRowCount = Math.max(0, Number(bdFastLoadedRowCount) || 0);
        state.totalRowEstimate = Math.max(0, Number(bdFastTotalRowEstimate) || 0);
        state.page = Math.max(0, Number(bdFastPage) || 0);
        state.hasLoaded = state.loadedRowCount > 0 || (state.allRowsLoaded === true && state.totalRowEstimate > 0);
      }

      function bdFastPersistCurrentModeState(){
        var mode = bdFastLaneFetchMode(bdFastCurrentLane());
        bdFastPersistModeState(mode);
      }

      function bdFastRestoreModeState(mode){
        var state = bdFastReadModeState(mode);
        bdFastAllRows = retailArray(state.allRows).slice();
        bdFastFilteredRows = retailArray(state.filteredRows).slice();
        bdFastAllRowsLoaded = state.allRowsLoaded === true;
        bdFastLoadedRowCount = Math.max(0, Number(state.loadedRowCount) || 0);
        bdFastTotalRowEstimate = Math.max(0, Number(state.totalRowEstimate) || 0);
        bdFastPage = Math.max(0, Number(state.page) || 0);
        hasLoadedDueQueueFast = state.hasLoaded === true;
        return state;
      }

      function bdFastMergeRows(existingRows, pageRows){
        return mergePriorityRowsByOpportunityKey(retailArray(existingRows), retailArray(pageRows));
      }

      function bdFastStateHasRenderableRows(state){
        var safeState = state && typeof state === 'object' ? state : {};
        return retailArray(safeState.allRows).length > 0 || Math.max(0, Number(safeState.loadedRowCount) || 0) > 0;
      }

      function bdFastRowsMatchMode(rows, mode){
        var expectedMode = String(mode || '').trim() || 'all';
        var safeRows = retailArray(rows);
        if (!safeRows.length) return true;
        if (expectedMode === 'acted_on_actions') {
          return safeRows.every(function(row){
            return bdFastIsActionHistoryRow(row);
          });
        }
        return safeRows.every(function(row){
          return !bdFastIsActionHistoryRow(row);
        });
      }

      function bdFastStateMatchesMode(state, mode){
        var safeState = state && typeof state === 'object' ? state : {};
        return bdFastRowsMatchMode(safeState.allRows, mode);
      }

      function bdFastLastVisitDateValue(row){
        return retailTextValue(
          row && (
            row.last_in_date
            || row.last_visit_at
            || row.last_in_at
            || row.last_appointment_date
          ),
          ''
        );
      }

      function bdFastHasFutureBooking(row){
        return !!(row && (
          row.has_future_appointment === true
          || row.future_appointment_found === true
          || !!retailTextValue(row && row.future_appointment_at, '')
        ));
      }

      function bdFastDaysSinceLastVisit(row){
        var dateValue = bdFastLastVisitDateValue(row);
        if (!dateValue) return null;
        var diff = bdFastDateDiffFromToday(dateValue);
        if (diff === null) return null;
        return Math.max(0, 0 - diff);
      }

      function bdFastHasCompletedVisit(row){
        return !!bdFastLastVisitDateValue(row);
      }

      function bdFastWellnessTagValues(row){
        var directValues = Array.isArray(row && row.wellness_tag_values) ? row.wellness_tag_values : [];
        if (directValues.length) {
          return uniqueNonEmptyStrings(directValues.map(function(value){
            return retailTextValue(value, '');
          }).filter(Boolean));
        }
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        var factSnapshot = debug.fact_snapshot && typeof debug.fact_snapshot === 'object' ? debug.fact_snapshot : {};
        var factTags = factSnapshot.tags && typeof factSnapshot.tags === 'object' ? factSnapshot.tags : {};
        return uniqueNonEmptyStrings(retailArray(factTags.wellness_tag_values).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean));
      }

      function bdFastHasWellnessTags(row){
        if (!row) return false;
        if (row.has_wellness_tags === true) return true;
        return bdFastWellnessTagValues(row).length > 0;
      }

      function bdFastIsNeverVisitedRow(row){
        var appointmentCount = Math.max(0, Number((row && row.appointment_count) || 0) || 0);
        return appointmentCount <= 0 && !bdFastHasCompletedVisit(row);
      }

      function bdFastIsRetailLaneRow(row){
        var daysSince = bdFastDaysSinceLastVisit(row);
        if (daysSince === null) return false;
        return daysSince >= 0 && daysSince <= 14;
      }

      function bdFastIsFirstTimeGuestRow(row){
        var appointmentCount = Math.max(0, Number((row && row.appointment_count) || 0) || 0);
        var daysSince = bdFastDaysSinceLastVisit(row);
        return !!row
          && appointmentCount === 1
          && daysSince !== null
          && daysSince >= 0
          && daysSince <= 14
          && !bdFastIsNeverVisitedRow(row);
      }

      function bdFastNeedsBookingRow(row){
        return !!row
          && !bdFastIsNeverVisitedRow(row)
          && !bdFastIsFirstTimeGuestRow(row)
          && !bdFastHasFutureBooking(row);
      }

      function bdFastIsActionHistoryRow(row){
        return !!(row && row.action_history_row === true);
      }

      function bdFastOpportunityState(row){
        var state = retailTextValue(row && row.opportunity_state, '').toLowerCase();
        if (state) return state;
        return row && row.opportunity_is_available === false ? 'acted_on' : 'available';
      }

      function bdFastOpportunityStateLabel(row){
        var label = retailTextValue(row && row.opportunity_state_label, '');
        if (label) return label;
        var state = bdFastOpportunityState(row);
        if (state === 'hidden') return 'Hidden';
        if (state === 'converted_booking') return 'Booked Win';
        if (state === 'converted_retail') return 'Retail Win';
        if (state === 'closed_no_conversion') return 'Closed No Conversion';
        if (state === 'acted_on') return 'Acted On';
        return 'Available';
      }

      function bdFastOutreachModeForState(row){
        var mode = normalizeLowerTextValue(row && row.last_outreach_mode);
        if (mode === 'retail_growth' || mode === 'service_growth' || mode === 'hybrid_growth') return mode;
        var state = bdFastOpportunityState(row);
        if (state === 'converted_retail') return 'retail_growth';
        if (state === 'converted_booking') return 'service_growth';
        return '';
      }

      function bdFastLaneOpportunityMode(laneKey){
        var normalized = String(laneKey || '').trim().toLowerCase();
        if (normalized === 'retail') return 'retail_growth';
        if (normalized === 'retail_needs_booking') return 'hybrid_growth';
        if (normalized === 'needs_booking' || normalized === 'never_visited' || normalized === 'new_guest_no_prebook') return 'service_growth';
        return '';
      }

      function bdFastOpenOpportunityEntries(row){
        return bdFastOpportunityEntries(row, true);
      }

      function bdFastOpenOpportunityLaneKeys(row){
        return bdFastOpenOpportunityEntries(row).map(function(entry){
          return retailTextValue(entry && entry.lane_key, '').toLowerCase();
        }).filter(Boolean);
      }

      function bdFastHasOpenOpportunityLane(row, laneKey){
        var normalizedLane = String(laneKey || '').trim().toLowerCase();
        if (!normalizedLane) return false;
        return bdFastOpenOpportunityLaneKeys(row).indexOf(normalizedLane) !== -1;
      }

      function bdFastIsRetailNeedsBookingHybrid(row){
        return !!row
          && !bdFastIsActionHistoryRow(row)
          && bdFastHasOpenOpportunityLane(row, 'retail')
          && bdFastHasOpenOpportunityLane(row, 'needs_booking');
      }

      function bdFastLaneSpecificStateField(laneKey){
        var normalized = String(laneKey || '').trim().toLowerCase();
        if (!normalized) return '';
        return normalized + '_opportunity_state';
      }

      function bdFastLaneOpportunityState(row, lane){
        if (bdFastIsActionHistoryRow(row)) return bdFastOpportunityState(row);
        var laneKey = String(lane || '').trim().toLowerCase();
        var state = bdFastOpportunityState(row);
        if (!laneKey || laneKey === 'acted_on' || state === 'available') return state;
        var laneSpecificField = bdFastLaneSpecificStateField(laneKey);
        var laneSpecificState = retailTextValue(row && laneSpecificField ? row[laneSpecificField] : '', '').toLowerCase();
        if (laneSpecificState) return laneSpecificState;
        var laneMode = bdFastLaneOpportunityMode(laneKey);
        if (laneMode === 'retail_growth') {
          var retailState = retailTextValue(row && row.retail_opportunity_state, '').toLowerCase();
          if (retailState) return retailState;
        }
        if (laneMode === 'service_growth') {
          var serviceState = retailTextValue(row && row.service_opportunity_state, '').toLowerCase();
          if (serviceState) return serviceState;
        }
        var outreachMode = bdFastOutreachModeForState(row);
        if (!laneMode) return state;
        if (outreachMode && outreachMode !== laneMode) return 'available';
        return state;
      }

      function bdFastLaneIsActedOnRow(row, lane){
        if (bdFastIsActionHistoryRow(row)) return true;
        var state = bdFastLaneOpportunityState(row, lane);
        return state === 'hidden'
          || state === 'acted_on'
          || state === 'converted_booking'
          || state === 'converted_retail'
          || state === 'closed_no_conversion';
      }

      function bdFastIsActedOnRow(row){
        return bdFastLaneIsActedOnRow(row, bdFastCurrentLane());
      }

      function bdFastIsAvailableRow(row){
        return !bdFastLaneIsActedOnRow(row, bdFastCurrentLane());
      }

      function bdFastOpportunityEntries(row, onlyOpen){
        var source = onlyOpen ? (row && row.open_opportunities) : (row && row.all_opportunities);
        return retailArray(source).map(function(entry){
          return entry && typeof entry === 'object' ? entry : {};
        });
      }

      function bdFastOpportunityEntryForLane(row, lane, onlyOpen){
        var laneKey = String(lane || '').trim().toLowerCase();
        if (!laneKey || bdFastIsActionHistoryRow(row)) return null;
        var entries = bdFastOpportunityEntries(row, onlyOpen !== false);
        return entries.find(function(entry){
          return retailTextValue(entry && entry.lane_key, '').toLowerCase() === laneKey;
        }) || null;
      }

      function bdFastPrimaryOpportunityEntry(row){
        var entries = bdFastOpportunityEntries(row, true);
        return entries[0] || null;
      }

      function bdFastActiveOpportunityEntry(row, onlyOpen){
        if (!row || bdFastIsActionHistoryRow(row)) return null;
        var selectedLane = bdFastSelectedOpportunityLane(row);
        var currentLane = bdFastCurrentLane();
        var activeEntry = bdFastOpportunityEntryForLane(row, selectedLane, onlyOpen !== false);
        if (activeEntry) return activeEntry;
        if (currentLane !== BD_FAST_ACTIVE_VIEW_KEY) {
          activeEntry = bdFastOpportunityEntryForLane(row, currentLane, onlyOpen !== false);
          if (activeEntry) return activeEntry;
        }
        if (onlyOpen === false) {
          return bdFastOpportunityEntries(row, false)[0] || null;
        }
        return bdFastPrimaryOpportunityEntry(row);
      }

      function bdFastOpportunityCategoryKey(row, onlyOpen){
        var entry = bdFastActiveOpportunityEntry(row, onlyOpen);
        return retailTextValue(entry && entry.lane_key, '');
      }

      function bdFastOpportunityCategoryLabel(row, onlyOpen){
        var entry = bdFastActiveOpportunityEntry(row, onlyOpen);
        return retailTextValue(entry && entry.lane_label, '');
      }

      function bdFastRowMatchesLane(row, lane){
        var laneKey = String(lane || '').trim();
        if (!row || !laneKey) return false;
        if (laneKey === BD_FAST_ACTIVE_VIEW_KEY) {
          if (bdFastIsActionHistoryRow(row)) return false;
          if (bdFastOpportunityEntries(row, true).length) return true;
          var fallbackCategory = bdFastCategoryMeta(row);
          return !!(fallbackCategory && fallbackCategory.actionable);
        }
        if (bdFastIsActionHistoryRow(row)) return laneKey === 'acted_on';
        if (laneKey === 'acted_on') return bdFastLaneIsActedOnRow(row, laneKey);
        var explicitEntry = bdFastOpportunityEntryForLane(row, laneKey, true);
        if (explicitEntry) return true;
        if (bdFastOpportunityEntries(row, false).length) return false;
        if (bdFastLaneIsActedOnRow(row, laneKey)) return false;
        if (laneKey === 'wellness') return bdFastHasWellnessTags(row);
        if (laneKey === 'retail') return bdFastIsRetailLaneRow(row);
        if (laneKey === 'new_guest_no_prebook') return bdFastIsFirstTimeGuestRow(row);
        if (laneKey === 'never_visited') return bdFastIsNeverVisitedRow(row);
        if (laneKey === 'future_protected') return bdFastHasFutureBooking(row);
        if (laneKey === 'needs_booking') return bdFastNeedsBookingRow(row);
        var category = bdFastCategoryMeta(row);
        return retailTextValue(category && category.key, '') === laneKey;
      }

      function bdFastOpportunityMode(row){
        if (bdFastIsActionHistoryRow(row)) {
          var historyMode = normalizeLowerTextValue(row && row.last_outreach_mode);
          if (historyMode === 'retail_growth' || historyMode === 'hybrid_growth') return historyMode;
          return 'service_growth';
        }
        if (bdFastIsRetailNeedsBookingHybrid(row)) {
          return 'hybrid_growth';
        }
        var activeEntry = bdFastActiveOpportunityEntry(row, true);
        if (activeEntry) {
          return retailTextValue(activeEntry && activeEntry.mode, 'service_growth') || 'service_growth';
        }
        return retailTextValue(bdFastCategoryMeta(row) && bdFastCategoryMeta(row).key, '') === 'retail'
          ? 'retail_growth'
          : 'service_growth';
      }

      function bdFastOutreachLaneForRow(row, preferredLane){
        var normalizedPreferredLane = String(preferredLane || '').trim().toLowerCase();
        if (bdFastIsRetailNeedsBookingHybrid(row)) {
          if (normalizedPreferredLane === 'retail' || normalizedPreferredLane === 'needs_booking' || !normalizedPreferredLane) {
            return 'retail_needs_booking';
          }
        }
        return normalizedPreferredLane || bdFastOpportunityCategoryKey(row, false) || bdFastCurrentLane();
      }

      function summarizeBdFastRefreshProgress(progress){
        var data = progress && typeof progress === 'object' ? progress : {};
        var status = String(data.status || '').trim().toLowerCase();
        var processed = Math.max(0, Number(data.rows_processed || 0) || 0);
        var total = Math.max(0, Number(data.total_rows || 0) || 0);
        var percent = Math.max(0, Number(data.percent_complete || 0) || 0);
        if (status === 'complete') {
          return 'V4 queue refresh complete.';
        }
        if (status === 'failed') {
          return String(data.last_error || 'V4 queue refresh failed.');
        }
        if (total > 0) {
          return 'Refreshing V4 queue in the background… ' + String(processed) + ' of ' + String(total) + ' guests rebuilt (' + String(percent) + '%).';
        }
        if (processed > 0) {
          return 'Refreshing V4 queue in the background… ' + String(processed) + ' guests rebuilt so far.';
        }
        return 'Refreshing V4 queue in the background…';
      }

      async function fetchBdFastRefreshStatusV4(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'get-client-followup-status-v4'
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load V4 refresh status.');
        }
        return data;
      }

      function startBdFastRefreshStatusPolling(){
        clearBdFastRefreshStatusPolling();
        bdFastRefreshPollRequestId += 1;
        var pollRequestId = bdFastRefreshPollRequestId;

        async function tick(){
          if (pollRequestId !== bdFastRefreshPollRequestId) return;
          try {
            var statusResult = await fetchBdFastRefreshStatusV4();
            if (pollRequestId !== bdFastRefreshPollRequestId) return;
            var progress = statusResult && statusResult.refresh_progress ? statusResult.refresh_progress : {};
            var status = String((progress && progress.status) || '').trim().toLowerCase();
            updateBdFastLastRefreshValue(statusResult && statusResult.summary, progress);
            if (status === 'complete') {
              clearBdFastRefreshStatusPolling();
              if (bdFastRefreshV4Btn) bdFastRefreshV4Btn.disabled = false;
              setBdFastShellState('ready');
              setBdFastStatus('V4 queue refreshed. Reloading the latest rows…', 'success');
              hasLoadedDueQueueFast = false;
              await loadBdFastAllLaneData({ reset: true, clearUi: false, forceRefresh: true });
              return;
            }
            if (status === 'failed') {
              clearBdFastRefreshStatusPolling();
              if (bdFastRefreshV4Btn) bdFastRefreshV4Btn.disabled = false;
              setBdFastShellState('ready');
              setBdFastStatus(summarizeBdFastRefreshProgress(progress), 'error');
              return;
            }
            setBdFastShellState('loading');
            setBdFastStatus(summarizeBdFastRefreshProgress(progress), 'warning');
            bdFastRefreshPollTimer = window.setTimeout(tick, 2000);
          } catch (error) {
            clearBdFastRefreshStatusPolling();
            if (bdFastRefreshV4Btn) bdFastRefreshV4Btn.disabled = false;
            setBdFastShellState('ready');
            setBdFastStatus(humanizeClientFetchErrorMessage(error, 'Could not monitor the V4 refresh.'), 'error');
          }
        }

        bdFastRefreshPollTimer = window.setTimeout(tick, 1500);
      }

      function bdFastRefreshPreviewItemMarkup(item){
        var guestName = retailTextValue(item && item.guest_name, 'Unknown guest');
        var guestKey = retailTextValue(item && item.guest_bucket_key, '');
        var rowAction = retailTextValue(item && item.row_action, 'adding').toLowerCase() === 'updating' ? 'updating' : 'adding';
        var changedAt = formatRecaptureDateTime(retailTextValue(item && item.latest_changed_at, ''));
        var changedState = retailTextValue(item && item.latest_changed_state, '');
        var changedStartAt = formatRecaptureDateTime(retailTextValue(item && item.latest_changed_start_at, ''));
        var lastVisit = formatRecaptureDate(retailTextValue(item && item.last_in_date, '')) || 'No completed visit';
        var meta = [];
        if (guestKey) meta.push('Guest key ' + guestKey);
        if (changedState) meta.push('State ' + changedState);
        if (changedAt) meta.push('Changed ' + changedAt);
        if (changedStartAt) meta.push('Appointment ' + changedStartAt);
        return ''
          + '<div class="bd-fastPreviewItem">'
          +   '<div class="bd-fastPreviewTitle"><strong>' + escapeHtml(guestName) + '</strong><em class="bd-fastPreviewAction bd-fastPreviewAction--' + escapeHtml(rowAction) + '">' + escapeHtml(rowAction) + '</em></div>'
          +   '<span>' + escapeHtml(meta.join(' • ') || 'Changed booking data') + '</span>'
          +   '<small>Last visit ' + escapeHtml(lastVisit) + '</small>'
          + '</div>';
      }

      function closeBdFastRefreshPreview(){
        bdFastRefreshPreviewState = null;
        if (bdFastRefreshPreviewConfirmBtn) bdFastRefreshPreviewConfirmBtn.disabled = false;
        if (bdFastRefreshPreviewDialog && bdFastRefreshPreviewDialog.open) {
          bdFastRefreshPreviewDialog.close();
        }
      }

      function openBdFastRefreshPreview(preview){
        if (!bdFastRefreshPreviewDialog || !bdFastRefreshPreviewSummary || !bdFastRefreshPreviewList) return;
        bdFastRefreshPreviewState = preview || null;
        var guestCount = Math.max(0, Number(preview && preview.total_guest_keys) || 0);
        var addCount = Math.max(0, Number(preview && preview.add_count) || 0);
        var updateCount = Math.max(0, Number(preview && preview.update_count) || 0);
        var scope = retailTextValue(preview && preview.refresh_scope, 'delta');
        bdFastRefreshPreviewSummary.textContent = guestCount
          ? ('Refresh ' + guestCount + ' guest' + (guestCount === 1 ? '' : 's') + ' from the ' + scope + ' set? ' + addCount + ' adding, ' + updateCount + ' updating.')
          : 'No changed guests were found for refresh.';
        var guests = retailArray(preview && preview.guests);
        if (!guests.length) {
          bdFastRefreshPreviewList.innerHTML = '<div class="bd-fastPreviewEmpty">No guest keys need a refresh right now.</div>';
        } else {
          bdFastRefreshPreviewList.innerHTML = guests.map(function(item){
            return bdFastRefreshPreviewItemMarkup(item);
          }).join('');
        }
        if (bdFastRefreshPreviewConfirmBtn) {
          bdFastRefreshPreviewConfirmBtn.disabled = guestCount < 1;
        }
        if (typeof bdFastRefreshPreviewDialog.showModal === 'function') {
          bdFastRefreshPreviewDialog.showModal();
        }
      }

      async function fetchBdFastRefreshPreviewV4(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'preview-client-followup-queue-v4-refresh'
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not preview the V4 refresh.');
        }
        return data;
      }

      async function previewBdFastQueueRefreshV4(){
        if (bdFastRefreshV4Btn) bdFastRefreshV4Btn.disabled = true;
        setBdFastStatus('Checking which guest keys changed…', 'warning');
        try {
          var preview = await fetchBdFastRefreshPreviewV4();
          if (bdFastRefreshV4Btn) bdFastRefreshV4Btn.disabled = false;
          if (!preview || !Array.isArray(preview.guest_bucket_keys) || !preview.guest_bucket_keys.length) {
            setBdFastShellState('ready');
            setBdFastStatus('No guest keys need a refresh right now.', 'success');
            return;
          }
          setBdFastShellState('ready');
          setBdFastStatus('Review the guest keys to refresh.', 'warning');
          openBdFastRefreshPreview(preview);
        } catch (error) {
          setBdFastShellState('ready');
          setBdFastStatus(humanizeClientFetchErrorMessage(error, 'Could not preview the V4 refresh.'), 'error');
          if (bdFastRefreshV4Btn) bdFastRefreshV4Btn.disabled = false;
        }
      }

      async function refreshBdFastQueueV4(guestKeysOverride){
        if (bdFastRefreshV4Btn) bdFastRefreshV4Btn.disabled = true;
        clearBdFastRefreshStatusPolling();
        setBdFastShellState('loading');
        setBdFastStatus('Starting the V4 queue refresh…', 'warning');
        try {
          var normalizedGuestKeys = retailArray(guestKeysOverride).map(function(value){
            return String(value || '').trim();
          }).filter(Boolean);
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'refresh-client-followup-queue-v4',
              guest_bucket_keys: normalizedGuestKeys,
              continue_until_complete: true,
              schedule_continuation: true,
              page_size: 60,
              max_pages_per_pass: 1,
              max_runtime_ms: 4000
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not refresh the V4 queue.');
          }
          var progress = data && data.refresh_progress ? data.refresh_progress : {};
          if (data.complete === true) {
            setBdFastStatus('V4 queue refreshed. Reloading the latest rows…', 'success');
            hasLoadedDueQueueFast = false;
            await loadBdFastAllLaneData({ reset: true, clearUi: false, forceRefresh: true });
            return;
          }
          setBdFastStatus(summarizeBdFastRefreshProgress(progress), 'warning');
          startBdFastRefreshStatusPolling();
        } catch (error) {
          setBdFastShellState('ready');
          setBdFastStatus(humanizeClientFetchErrorMessage(error, 'Could not refresh the V4 queue.'), 'error');
          if (bdFastRefreshV4Btn) bdFastRefreshV4Btn.disabled = false;
        }
      }

      function bdFastCategoryMeta(row){
        var explicitCurrentEntry = bdFastActiveOpportunityEntry(row, true);
        if (explicitCurrentEntry) {
          return {
            key: retailTextValue(explicitCurrentEntry && explicitCurrentEntry.lane_key, ''),
            label: retailTextValue(explicitCurrentEntry && explicitCurrentEntry.lane_label, 'Opportunity'),
            actionable: explicitCurrentEntry && explicitCurrentEntry.is_available === true
          };
        }
        if (bdFastCurrentLane() === 'wellness' && bdFastHasWellnessTags(row)) {
          return {
            key: 'wellness',
            label: BD_FAST_CATEGORY_LABELS.wellness,
            actionable: true
          };
        }
        if (bdFastIsNeverVisitedRow(row)) {
          return {
            key: 'never_visited',
            label: BD_FAST_CATEGORY_LABELS.never_visited,
            actionable: true
          };
        }
        if (bdFastIsRetailLaneRow(row)) {
          return {
            key: 'retail',
            label: BD_FAST_CATEGORY_LABELS.retail,
            actionable: true
          };
        }
        if (bdFastIsFirstTimeGuestRow(row)) {
          return {
            key: 'new_guest_no_prebook',
            label: BD_FAST_CATEGORY_LABELS.new_guest_no_prebook,
            actionable: true
          };
        }
        if (bdFastHasFutureBooking(row)) {
          return {
            key: 'future_protected',
            label: BD_FAST_CATEGORY_LABELS.future_protected,
            actionable: true
          };
        }
        if (bdFastNeedsBookingRow(row)) {
          return {
            key: 'needs_booking',
            label: BD_FAST_CATEGORY_LABELS.needs_booking,
            actionable: true
          };
        }
        return null;
      }

      function bdFastLaneLabel(lane){
        if (String(lane || '').trim() === BD_FAST_ACTIVE_VIEW_KEY) return 'Open Opportunities';
        return BD_FAST_CATEGORY_LABELS[String(lane || '').trim()] || 'Opportunity';
      }

      function bdFastLaneCount(lane){
        var state = bdFastReadModeState(bdFastLaneFetchMode(lane));
        var rows = retailArray(state && state.allRows);
        return rows.filter(function(row){
          return bdFastRowMatchesLane(row, lane);
        }).length;
      }

      function bdFastActionHistoryCount(){
        var state = bdFastReadModeState('acted_on_actions');
        return retailArray(state && state.allRows).filter(function(row){
          return bdFastRowMatchesLane(row, 'acted_on');
        }).length;
      }

      function bdFastFirstNonEmptyLane(){
        return BD_FAST_ACTIVE_VIEW_KEY;
      }

      function bdFastTabLabelMarkup(tab){
        var count = bdFastLaneCount(tab && tab.key);
        return {
          label: retailTextValue(tab && tab.label, 'Opportunity') + (count > 0 || bdFastAllModeDataReady() ? ' ' + String(count) : '')
        };
      }

      function renderBdFastModeTabs(){
        if (!bdFastModeTabs) return;
        syncBdFastModeOptions();
        bdFastModeTabs.innerHTML = '';
        bdFastModeTabs.hidden = true;
        if (bdFastHistoryBtn) {
          var historyActive = bdFastIsHistoryView();
          var historyCount = bdFastActionHistoryCount();
          bdFastHistoryBtn.className = 'bd-fastHistoryBtn' + (historyActive ? ' is-active' : '');
          bdFastHistoryBtn.textContent = 'Action History ' + String(historyCount);
          bdFastHistoryBtn.setAttribute('aria-pressed', historyActive ? 'true' : 'false');
        }
      }

      function bdFastRowsForTabCounts(){
        var filters = {
          search: String((bdFastSearch && bdFastSearch.value) || '').trim().toLowerCase()
        };
        return retailArray(bdFastAllRows).filter(function(row){
          var category = bdFastCategoryMeta(row);
          if (!category || !category.actionable) return false;
          var guestName = retailTextValue(row && row.guest_name, '').toLowerCase();
          if (filters.search && guestName.indexOf(filters.search) === -1) return false;
          return true;
        });
      }

      function bdFastActionableRow(row){
        var category = bdFastCategoryMeta(row);
        return !!(category && category.actionable);
      }

      function bdFastCurrentFilters(){
        return {
          search: String((bdFastSearch && bdFastSearch.value) || '').trim().toLowerCase(),
          lane: bdFastIsHistoryView() ? 'acted_on' : '',
          sort: String((bdFastSort && bdFastSort.value) || 'priority_score').trim()
        };
      }

      function bdFastCardStatusPillMarkup(row){
        if (!bdFastLaneIsActedOnRow(row, bdFastCurrentLane())) return '';
        return '<span class="bd-fastNeed">' + escapeHtml(bdFastOpportunityStateLabel(row)) + '</span>';
      }

      function bdFastSortRows(rows, sortKey){
        var safeRows = retailArray(rows).slice();
        return safeRows.sort(function(a, b){
          if (sortKey === 'guest_name') {
            return retailTextValue(a && a.guest_name, '').localeCompare(retailTextValue(b && b.guest_name, ''));
          }
          if (sortKey === 'primary_staff_name') {
            return retailTextValue(a && a.primary_staff_name, '').localeCompare(retailTextValue(b && b.primary_staff_name, ''));
          }
          if (sortKey === 'last_in_date') {
            return retailTextValue(b && b.last_in_date, '').localeCompare(retailTextValue(a && a.last_in_date, ''));
          }
          if (sortKey === 'days_overdue') {
            return bdFastDaysOverdue(b) - bdFastDaysOverdue(a);
          }
          return (Number((b && (b.business_priority_score || b.priority_score)) || 0) || 0) - (Number((a && (a.business_priority_score || a.priority_score)) || 0) || 0);
        });
      }

      function bdFastApplyFilters(){
        var filters = bdFastCurrentFilters();
        bdFastFilteredRows = bdFastSortRows(bdFastAllRows.filter(function(row){
          if (bdFastIsActionHistoryRow(row)) {
            if (filters.search) {
              var actionGuestName = retailTextValue(row && row.guest_name, '').toLowerCase();
              if (actionGuestName.indexOf(filters.search) === -1) return false;
            }
            return !filters.lane || bdFastRowMatchesLane(row, filters.lane);
          }
          var category = bdFastCategoryMeta(row);
          if (!category) return false;
          var guestName = retailTextValue(row && row.guest_name, '').toLowerCase();
          if (filters.search && guestName.indexOf(filters.search) === -1) return false;
          if (filters.lane && !bdFastRowMatchesLane(row, filters.lane)) return false;
          return true;
        }), filters.sort);
        if (bdFastSelectedOpportunityKey) {
          var stillVisible = bdFastFilteredRows.some(function(row){
            return retailTextValue(row && row.opportunity_key, '') === bdFastSelectedOpportunityKey;
          });
          if (!stillVisible) {
            bdFastSelectedOpportunityKey = '';
          }
        }
      }

      function bdFastPageRows(){
        var start = bdFastPage * bdFastPageSize;
        return bdFastFilteredRows.slice(start, start + bdFastPageSize);
      }

      function bdFastSummaryText(){
        if (!bdFastFilteredRows.length) return bdFastIsHistoryView() ? 'No acted-on rows match the current search.' : 'No open opportunities match the current search.';
        var start = (bdFastPage * bdFastPageSize) + 1;
        var end = Math.min(bdFastFilteredRows.length, start + bdFastPageSize - 1);
        var laneLabel = bdFastIsHistoryView() ? 'Action History' : 'Open Opportunities';
        var loadedSuffix = bdFastAllRowsLoaded
          ? ' across the full queue.'
          : ' from ' + String(Math.max(bdFastLoadedRowCount, bdFastAllRows.length)) + ' loaded so far.';
        return laneLabel + ' · ' + String(start) + '–' + String(end) + ' of ' + String(bdFastFilteredRows.length) + ' matching rows' + loadedSuffix;
      }

      function bdFastLaneWorkspaceDescription(laneKey){
        var normalized = String(laneKey || '').trim().toLowerCase();
        if (normalized === BD_FAST_ACTIVE_VIEW_KEY) return 'One master queue. Open a guest to choose the right opportunity and send the next action.';
        if (normalized === 'retail') return 'Guests with a closed visit in the last 14 days.';
        if (normalized === 'wellness') return 'Guests carrying wellness tags from stored appointment history.';
        if (normalized === 'new_guest_no_prebook') return 'Guests whose first completed visit was in the last 14 days.';
        if (normalized === 'needs_booking') return 'Returning guests with no future appointment booked.';
        if (normalized === 'never_visited') return 'Prospects who have never completed a visit.';
        if (normalized === 'acted_on') return 'Worked opportunities, sent outreach, and recorded outcomes.';
        return 'Loading today’s worklist.';
      }

      function bdFastLaneCountPillText(){
        var count = bdFastFilteredRows.length;
        if (bdFastIsHistoryView()) return String(count) + ' actions';
        return String(count) + ' open';
      }

      function bdFastReasonLine(row){
        var entryReason = retailTextValue((bdFastActiveOpportunityEntry(row, false) || {}).reason, '');
        if (entryReason) return entryReason;
        return retailTextValue(row && row.diagnosis_summary, '')
          || retailTextValue(row && row.business_bucket_reason, '')
          || retailTextValue(row && row.non_actionable_reason, '')
          || 'Open this guest to review the full history and next move.';
      }

      function bdFastDeterminationText(row){
        if (bdFastCurrentLane() === 'wellness' && bdFastHasWellnessTags(row)) {
          return 'Wellness-related tags are present in appointment history, so this row can support an hs.Wellness introduction.';
        }
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var appointmentCount = Number((row && row.appointment_count) || 0) || 0;
        if (!categoryKey) return '';
        if (categoryKey === 'retail') {
          return 'Closed today or within the last 14 days, so this row is for post-visit retail follow-up.';
        }
        if (categoryKey === 'new_guest_no_prebook') {
          return bdFastHasFutureBooking(row)
            ? 'This guest completed a first visit within the last 14 days and already has visit two booked.'
            : 'This guest completed a first visit within the last 14 days and still needs visit two booked.';
        }
        if (categoryKey === 'never_visited') {
          return 'No completed visit found in the current durable history.';
        }
        if (categoryKey === 'future_protected') {
          return 'A future appointment is already on the books, so service is currently protected.';
        }
        if (categoryKey === 'needs_booking') {
          return appointmentCount > 0
            ? 'There is completed visit history, but no future appointment is currently booked.'
            : 'No future appointment is currently booked.';
        }
        return '';
      }

      function bdFastCadenceChipText(row){
        var cadenceDays = Math.max(0, Number((row && row.cadence_days) || 0) || 0);
        if (!(cadenceDays > 0)) return '';
        return 'Cadence: ' + dueCadenceFriendlyText(cadenceDays);
      }

      function bdFastOutreachStateKey(row){
        return retailTextValue(row && row.opportunity_key, '') || retailTextValue(row && row.guest_bucket_key, '');
      }

      function bdFastOfferOptions(){
        return retailArray(dueQueueOfferOptions);
      }

      function bdFastOfferOption(key){
        var normalized = String(key || '').trim();
        return bdFastOfferOptions().find(function(option){
          return retailTextValue(option && option.key, '') === normalized;
        }) || null;
      }

      function bdFastOfferMatchesCode(option, code){
        var target = retailTextValue(code, '').toLowerCase();
        if (!target) return false;
        var values = [
          retailTextValue(option && option.key, ''),
          retailTextValue(option && option.label, ''),
          retailTextValue(option && option.boulevard_offer_code, ''),
          retailTextValue(option && option.boulevard_offer_name, '')
        ].map(function(value){
          return retailTextValue(value, '').toLowerCase();
        }).filter(Boolean);
        return values.some(function(value){
          return value === target || value.indexOf(target) !== -1;
        });
      }

      function bdFastStartYourStoryOffer(){
        return bdFastOfferOptions().find(function(option){
          return bdFastOfferMatchesCode(option, 'startyourstory');
        }) || null;
      }

      function bdFastWelcomeBackOffer(){
        return bdFastOfferOptions().find(function(option){
          return bdFastOfferMatchesCode(option, 'welcomeback');
        }) || null;
      }

      function bdFastTaskStatus(row){
        return retailTextValue(row && row.manager_task_status, '').toLowerCase();
      }

      function bdFastWorkflowState(row){
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        var businessState = debug && debug.business_development_state && typeof debug.business_development_state === 'object'
          ? debug.business_development_state
          : {};
        return businessState && businessState.workflow && typeof businessState.workflow === 'object'
          ? businessState.workflow
          : null;
      }

      function bdFastOutreachMeta(row){
        return row && row.outreach && typeof row.outreach === 'object' ? row.outreach : null;
      }

      function bdFastHasReliableCadence(row){
        var cadenceDays = Math.max(0, Number((row && row.cadence_days) || 0) || 0);
        var sampleSize = Math.max(0, Number((row && row.cadence_sample_size) || 0) || 0);
        var source = retailTextValue(row && row.cadence_source, '').toLowerCase();
        return cadenceDays > 0
          && source === 'personalized'
          && sampleSize >= BD_FAST_STRATEGY_CONFIG.strong_cadence_min_sample;
      }

      function bdFastCadenceConfidence(row){
        if (bdFastHasReliableCadence(row)) return 'High';
        var cadenceDays = Math.max(0, Number((row && row.cadence_days) || 0) || 0);
        var appointmentCount = Math.max(0, Number((row && row.appointment_count) || 0) || 0);
        if (cadenceDays > 0 && appointmentCount >= 2) return 'Medium';
        return 'Low';
      }

      function bdFastFutureBookingText(row){
        var at = retailTextValue(row && row.future_appointment_at, '');
        if (!at) return 'No future booking';
        return 'Booked ' + formatRecaptureDate(at);
      }

      function bdFastRetailFactText(row){
        if (bdFastHasFutureBooking(row)) return bdFastFutureBookingText(row);
        var daysSince = bdFastDaysSinceLastVisit(row);
        if (daysSince === null) return 'Recent closed visit';
        if (daysSince === 0) return 'Closed today';
        if (daysSince === 1) return 'Closed yesterday';
        return 'Closed ' + String(daysSince) + ' days ago';
      }

      function bdFastDateDiffFromToday(dateValue){
        var normalized = retailTextValue(dateValue, '');
        if (!normalized) return null;
        var parsed = new Date(normalized);
        if (isNaN(parsed.getTime())) {
          var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(normalized);
          if (!match) return null;
          parsed = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
        }
        var targetDate = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
        var now = new Date();
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return Math.round((targetDate.getTime() - today.getTime()) / 86400000);
      }

      function bdFastDaysOverdue(row){
        var dueDiff = bdFastDateDiffFromToday(row && row.expected_due_date);
        if (dueDiff !== null) return Math.max(0, 0 - dueDiff);
        return Math.max(0, Number((row && row.days_overdue) || 0) || 0);
      }

      function bdFastDaysUntilDue(row){
        var dueDiff = bdFastDateDiffFromToday(row && row.expected_due_date);
        if (dueDiff !== null) return Math.max(0, dueDiff);
        return Math.max(0, Number((row && row.days_until_due) || 0) || 0);
      }

      function bdFastMissedCycles(row){
        if (!bdFastHasReliableCadence(row)) return 0;
        var overdueDays = bdFastDaysOverdue(row);
        var cadenceDays = Math.max(0, Number((row && row.cadence_days) || 0) || 0);
        if (!(overdueDays > 0) || !(cadenceDays > 0)) return 0;
        return Math.max(0, Math.floor(overdueDays / cadenceDays));
      }

      function bdFastHasCancellationSignal(row){
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        return !!(
          row && (
            row.has_post_visit_cancel === true
            || row.has_post_visit_no_show === true
            || row.latest_post_visit_cancel_at
            || row.latest_post_visit_no_show_at
            || debug.latest_post_visit_cancel_at
            || debug.latest_post_visit_no_show_at
          )
        );
      }

      function bdFastLatestCancellationSignalAt(row){
        var debug = row && row.debug && typeof row.debug === 'object' ? row.debug : {};
        return retailTextValue(
          row && (row.latest_post_visit_cancel_at || row.latest_post_visit_no_show_at),
          retailTextValue(debug.latest_post_visit_cancel_at || debug.latest_post_visit_no_show_at, '')
        );
      }

      function bdFastHasRecentCancellationSignal(row, maxAgeDays){
        var signalAt = bdFastLatestCancellationSignalAt(row);
        var diff = bdFastDateDiffFromToday(signalAt);
        var maxDays = Math.max(0, Number(maxAgeDays) || 0);
        if (!signalAt || diff === null || diff > 0) return false;
        if (!maxDays) return diff <= 0;
        return Math.abs(diff) <= maxDays;
      }

      function bdFastHasDecliningFrequency(row){
        return !!(row && row.declining_frequency_detected === true);
      }

      function bdFastRelationshipStrength(row){
        var appointmentCount = Math.max(0, Number((row && row.appointment_count) || 0) || 0);
        if (appointmentCount >= 8) return 'strong';
        if (appointmentCount >= 3) return 'established';
        if (appointmentCount >= 1) return 'early';
        return 'none';
      }

      function bdFastReturnLikelihood(row){
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var overdueDays = bdFastDaysOverdue(row);
        var missedCycles = bdFastMissedCycles(row);
        var hasReliableCadence = bdFastHasReliableCadence(row);
        var recentNoResponse = dueRowHasRecentNoResponse(row);
        var cancellationSignal = bdFastHasCancellationSignal(row);
        if (categoryKey === 'retail') return 'high';
        if (categoryKey === 'never_visited') return 'low';
        if (categoryKey === 'future_protected') return 'high';
        if (categoryKey === 'needs_booking') {
          if (hasReliableCadence && !cancellationSignal) return 'high';
          if (recentNoResponse) return 'low';
          if (overdueDays > 45 || missedCycles >= BD_FAST_STRATEGY_CONFIG.low_return_missed_cycles) return 'low';
          if (overdueDays > 0) return 'medium';
          return 'medium';
        }
        return hasReliableCadence ? 'medium' : 'low';
      }

      function bdFastOutreachLevel(row, returnLikelihood){
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var overdueDays = bdFastDaysOverdue(row);
        var missedCycles = bdFastMissedCycles(row);
        var cancellationSignal = bdFastHasCancellationSignal(row);
        if (categoryKey === 'retail' || categoryKey === 'future_protected') return 0;
        if (categoryKey === 'never_visited') return 1;
        if (categoryKey === 'needs_booking') {
          if (returnLikelihood === 'high' && !cancellationSignal && overdueDays < BD_FAST_STRATEGY_CONFIG.level2_overdue_days) return 1;
          if (missedCycles >= BD_FAST_STRATEGY_CONFIG.low_return_missed_cycles || overdueDays >= BD_FAST_STRATEGY_CONFIG.recovery_overdue_days) return 3;
          if (overdueDays >= BD_FAST_STRATEGY_CONFIG.level2_overdue_days || cancellationSignal) return 2;
          return 1;
        }
        return 1;
      }

      function bdFastLikelihoodLabel(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (!normalized) return 'Unknown';
        return normalized.charAt(0).toUpperCase() + normalized.slice(1);
      }

      function bdFastOutreachLevelLabel(level){
        var numeric = Number(level || 0) || 0;
        if (numeric <= 0) return 'Level 0 · Reminder only';
        if (numeric === 1) return 'Level 1 · Personal attention';
        if (numeric === 2) return 'Level 2 · Light recovery';
        return 'Level 3 · Strong recovery';
      }

      function bdFastSignalSummary(row){
        var parts = [];
        if (bdFastHasCancellationSignal(row)) parts.push('Recent cancel/no-show signal');
        if (bdFastHasDecliningFrequency(row)) parts.push('Frequency is slipping');
        if (dueRowRecentlyContacted(row)) parts.push('Contacted recently');
        if (dueRowHasRecentNoResponse(row)) parts.push('Recent no-response');
        return parts.join(' · ');
      }

      function bdFastPreviousOutreachText(row){
        var outreach = bdFastOutreachMeta(row);
        if (!outreach) return 'No prior outreach logged.';
        var latestSend = outreach.latest_send && typeof outreach.latest_send === 'object' ? outreach.latest_send : null;
        var latestManual = outreach.latest_manual_contact && typeof outreach.latest_manual_contact === 'object' ? outreach.latest_manual_contact : null;
        var latestDraft = outreach.latest_draft && typeof outreach.latest_draft === 'object' ? outreach.latest_draft : null;
        if (latestSend && retailTextValue(latestSend.sent_at, '')) {
          return 'Last SMS sent ' + formatRecaptureDate(retailTextValue(latestSend.sent_at, '')) + '.';
        }
        if (latestManual && retailTextValue(latestManual.sent_at, '')) {
          return 'Last manual contact logged ' + formatRecaptureDate(retailTextValue(latestManual.sent_at, '')) + '.';
        }
        if (latestDraft && retailTextValue(latestDraft.sent_at, '')) {
          return 'Draft prepared ' + formatRecaptureDate(retailTextValue(latestDraft.sent_at, '')) + '.';
        }
        if (retailTextValue(outreach.last_contacted_at, '')) {
          return 'Last contact attempt ' + formatRecaptureDate(retailTextValue(outreach.last_contacted_at, '')) + '.';
        }
        return 'No prior outreach logged.';
      }

      function bdFastClaimStateText(row){
        var statusLabel = retailTextValue(row && row.manager_task_status_label, '') || taskStatusLabel(row && row.manager_task_status);
        var assignedName = retailTextValue(row && row.manager_task_assigned_name, '');
        var touchedAt = retailTextValue(row && row.manager_task_last_event_at, '')
          || retailTextValue(row && row.manager_task_completed_at, '')
          || retailTextValue(row && row.manager_task_next_followup_at, '');
        if (assignedName && touchedAt) {
          return statusLabel + ' · ' + assignedName + ' · ' + formatRecaptureDate(touchedAt);
        }
        if (assignedName) return statusLabel + ' · ' + assignedName;
        return statusLabel || 'Needs Manager';
      }

      function bdFastPreferredOfferKey(row, categoryKey){
        if (categoryKey === 'never_visited') {
          var startYourStory = bdFastStartYourStoryOffer();
          return retailTextValue(startYourStory && startYourStory.key, 'none') || 'none';
        }
        if (categoryKey === 'needs_booking') {
          var welcomeBack = bdFastWelcomeBackOffer();
          return retailTextValue(welcomeBack && welcomeBack.key, 'none') || 'none';
        }
        return 'none';
      }

      function bdFastStrategy(row){
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var mode = bdFastOpportunityMode(row);
        var cadenceDays = Math.max(0, Number((row && row.cadence_days) || 0) || 0);
        var overdueDays = bdFastDaysOverdue(row);
        var appointmentCount = Math.max(0, Number((row && row.appointment_count) || 0) || 0);
        var returnLikelihood = bdFastReturnLikelihood(row);
        var outreachLevel = bdFastOutreachLevel(row, returnLikelihood);
        var missedCycles = bdFastMissedCycles(row);
        var cadenceConfidence = bdFastCadenceConfidence(row);
        var hasReliableCadence = bdFastHasReliableCadence(row);
        var preferredOfferKey = categoryKey === 'needs_booking' || categoryKey === 'never_visited'
          ? bdFastPreferredOfferKey(row, categoryKey)
          : 'none';
        var preferredOffer = bdFastOfferOption(preferredOfferKey);
        var offerLabel = retailTextValue(preferredOffer && preferredOffer.label, 'No offer');
        var boulevardLinked = !!(
          preferredOffer
          && (retailTextValue(preferredOffer.boulevard_offer_id, '')
            || retailTextValue(preferredOffer.boulevard_offer_code, '')
            || retailTextValue(preferredOffer.boulevard_offer_name, ''))
        );
        var primaryStaff = retailTextValue(row && row.primary_staff_name, '');
        var serviceLabel = retailTextValue(row && row.last_service_name, 'visit');
        var justification = '';
        var recommendedAction = '';
        if (categoryKey === 'wellness') {
          return {
            title: 'Wellness introduction',
            detail: 'Use the trust this guest already has with Hairstories to introduce hs.Wellness as a clinician-backed next step.',
            recommendedAction: 'Send a concise stylist-led intro that connects their salon relationship to hs.Wellness and invites them to learn more or book.',
            offerKey: 'none',
            offerLabel: 'No offer',
            tone: 'Trusted introduction',
            boulevardLinked: false,
            returnLikelihood: 'medium',
            outreachLevel: 1,
            confidence: 'Tag-led',
            missedCycles: 0,
            justification: 'Wellness-related tags exist in appointment history and can support a relevant hs.Wellness outreach.',
            serviceLabel: serviceLabel,
            primaryStaff: primaryStaff
          };
        }
        if (categoryKey === 'retail') {
          return {
            title: 'Retail follow-up',
            detail: 'They closed a visit today or in the last 14 days. Use this row to drive an online retail purchase while the result is still fresh.',
            recommendedAction: 'Reach out with a retail recommendation tied to the guest relationship and track whether an online Shopify purchase happens after outreach.',
            offerKey: 'none',
            offerLabel: 'No offer',
            tone: 'Retail growth',
            boulevardLinked: false,
            returnLikelihood: 'high',
            outreachLevel: 1,
            confidence: 'Booked',
            missedCycles: 0,
            justification: 'Their most recent completed appointment is still inside the immediate post-visit retail window.',
            serviceLabel: serviceLabel,
            primaryStaff: primaryStaff
          };
        }
        if (categoryKey === 'future_protected') {
          recommendedAction = 'Service is already protected. Use client details only if you need context for follow-up.';
          justification = 'A future appointment is already booked.';
        } else if (categoryKey === 'needs_booking') {
          recommendedAction = outreachLevel >= 3
            ? 'Use a strong recovery message and an approved offer only because the chance of natural return has materially dropped.'
            : 'Use recovery outreach with a light approved value-add if needed.';
          justification = missedCycles > 0
            ? 'They appear to have missed about ' + String(missedCycles) + ' expected cycle' + (missedCycles === 1 ? '' : 's') + ' with no future booking.'
            : 'They are substantially overdue with no future booking, so organic return probability is falling.';
        } else if (categoryKey === 'never_visited') {
          recommendedAction = 'Treat this as a first-visit conversion and avoid return-language or incentive assumptions.';
          justification = 'No completed visit exists in the current history.';
        } else {
          recommendedAction = 'Review the row before outreach and fix any missing timing signal you can confirm.';
          justification = 'The row does not have the clean timing fields needed for a confident lane assignment.';
        }
        if (categoryKey === 'future_protected') {
          return {
            title: 'Future protected',
            detail: 'They already have a future appointment booked, so the service objective is protected.',
            recommendedAction: recommendedAction,
            offerKey: 'none',
            offerLabel: 'No offer',
            tone: 'Protected',
            boulevardLinked: false,
            returnLikelihood: returnLikelihood,
            outreachLevel: outreachLevel,
            confidence: 'Booked',
            missedCycles: 0,
            justification: justification,
            serviceLabel: serviceLabel,
            primaryStaff: primaryStaff
          };
        }
        if (categoryKey === 'needs_booking') {
          return {
            title: 'Needs booking',
            detail: 'They do not have a future appointment booked. Use client details and actual appointment history to decide how to recover the booking.',
            recommendedAction: recommendedAction,
            offerKey: preferredOfferKey,
            offerLabel: offerLabel,
            tone: 'Urgent but personal',
            boulevardLinked: boulevardLinked,
            returnLikelihood: returnLikelihood,
            outreachLevel: outreachLevel,
            confidence: cadenceConfidence,
            missedCycles: missedCycles,
            justification: justification,
            serviceLabel: serviceLabel,
            primaryStaff: primaryStaff
          };
        }
        if (categoryKey === 'never_visited') {
          return {
            title: 'First visit conversion',
            detail: appointmentCount > 0
              ? 'History exists but the durable visit record is inconsistent. Lead with a first-visit conversion message and a simple approved offer.'
              : 'No completed visit is on record. Treat this as a first-visit conversion message with a simple approved offer.',
            recommendedAction: recommendedAction,
            offerKey: preferredOfferKey,
            offerLabel: offerLabel,
            tone: 'Invite and convert',
            boulevardLinked: boulevardLinked,
            returnLikelihood: returnLikelihood,
            outreachLevel: outreachLevel,
            confidence: cadenceConfidence,
            missedCycles: missedCycles,
            justification: justification,
            serviceLabel: serviceLabel,
            primaryStaff: primaryStaff
          };
        }
        return {
          title: 'Review row',
          detail: 'Review the client detail before acting on this row.',
          recommendedAction: recommendedAction,
          offerKey: 'none',
          offerLabel: 'No offer',
          tone: 'Review first',
          boulevardLinked: false,
          returnLikelihood: returnLikelihood,
          outreachLevel: outreachLevel,
          confidence: cadenceConfidence,
          missedCycles: missedCycles,
          justification: justification,
          serviceLabel: serviceLabel,
          primaryStaff: primaryStaff
        };
      }

      function bdFastCategoryTabLabel(categoryKey){
        var match = BD_FAST_LANE_TABS.find(function(tab){
          return retailTextValue(tab && tab.key, '') === retailTextValue(categoryKey, '');
        });
        return retailTextValue(match && match.label, BD_FAST_CATEGORY_LABELS[categoryKey] || 'Opportunity');
      }

      function bdFastOpportunityModePillMarkup(row){
        var mode = bdFastOpportunityMode(row);
        var modeClass = mode === 'retail_growth' ? 'retail' : 'service';
        return '<span class="bd-fastNeed bd-fastNeed--' + escapeHtml(modeClass) + '">' + escapeHtml(bdFastModeLabel(mode)) + '</span>';
      }

      function bdFastCategoryPillMarkup(row){
        if (bdFastIsActionHistoryRow(row)) return '';
        if (bdFastLaneIsActedOnRow(row, bdFastCurrentLane())) {
          return '<span class="bd-fastNeed">' + escapeHtml(bdFastOpportunityStateLabel(row)) + '</span>';
        }
        var category = bdFastCategoryMeta(row);
        if (!category) return '';
        return '<span class="bd-fastNeed bd-fastNeed--' + escapeHtml(retailTextValue(category && category.key, 'unknown')) + '">' + escapeHtml(bdFastCategoryTabLabel(category.key)) + '</span>';
      }

      function bdFastVisitCountText(row){
        if (bdFastIsActionHistoryRow(row)) {
          var winCount = Math.max(0, Number((row && row.action_win_count) || 0) || 0);
          return winCount === 1 ? '1 win' : String(winCount) + ' wins';
        }
        var count = Math.max(0, Number((row && row.appointment_count) || 0) || 0);
        return count === 1 ? '1 visit' : String(count) + ' visits';
      }

      function bdFastOverdueFactText(row){
        var overdueDays = bdFastDaysOverdue(row);
        if (overdueDays <= 0) return '0 days overdue';
        return overdueDays === 1 ? '1 day overdue' : String(overdueDays) + ' days overdue';
      }

      function bdFastServiceLaneFactText(row){
        if (bdFastIsActionHistoryRow(row)) {
          return retailTextValue(row && row.action_summary_text, '') || 'No win yet';
        }
        if (bdFastLaneIsActedOnRow(row, bdFastCurrentLane())) {
          return retailTextValue(row && row.action_summary_text, '')
            || bdFastActionOutcomeSummaryText(row)
            || bdFastOpportunityStateLabel(row);
        }
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        if (categoryKey === 'future_protected') return bdFastFutureBookingText(row);
        if (categoryKey === 'never_visited') return 'No completed visit';
        if (categoryKey === 'needs_booking') {
          if (bdFastHasReliableCadence(row)) return bdFastOverdueFactText(row);
          return 'No future booking';
        }
        return bdFastOverdueFactText(row);
      }

      function bdFastAllowsOfferChoice(row){
        return false;
      }

      function bdFastEligibleOfferKeysForRow(row){
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        if (!bdFastOfferOptions().length) return [];
        var keys = [];
        function pushKey(key){
          if (!key || !bdFastOfferOption(key) || keys.indexOf(key) !== -1) return;
          keys.push(key);
        }
        if (categoryKey !== 'needs_booking' && categoryKey !== 'never_visited') return [];
        if (categoryKey === 'needs_booking') {
          pushKey(retailTextValue(bdFastWelcomeBackOffer() && bdFastWelcomeBackOffer().key, ''));
          return keys;
        }
        pushKey(retailTextValue(bdFastStartYourStoryOffer() && bdFastStartYourStoryOffer().key, ''));
        return keys;
      }

      function bdFastOfferKeysForRow(row){
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        if (categoryKey === 'needs_booking' || categoryKey === 'never_visited') {
          var preferred = bdFastPreferredOfferKey(row, categoryKey);
          return preferred ? [preferred] : ['none'];
        }
        return ['none'];
      }

      function bdFastHasSmsBookingData(row){
        if (bdFastIsActionHistoryRow(row)) return false;
        return !!(retailTextValue(row && row.guest_bucket_key, '') && retailTextValue(row && row.client_phone, ''));
      }

      function normalizeLowerTextValue(value){
        return retailTextValue(value, '').toLowerCase();
      }

      function bdFastActionSentText(row){
        var sentAt = retailTextValue(row && row.last_outreach_sent_at, '');
        return sentAt ? ('Sent ' + formatRecaptureDate(sentAt)) : 'Sent';
      }

      function bdFastActionHistoryItems(row){
        return retailArray(row && row.action_outcome_history).map(function(item){
          return item && typeof item === 'object' ? item : {};
        });
      }

      function bdFastActionPrimaryOutcome(row){
        return bdFastActionHistoryItems(row)[0] || null;
      }

      function bdFastActionOutcomeSummaryText(row){
        var primary = bdFastActionPrimaryOutcome(row);
        if (!primary) return 'No win yet';
        var outcomeKey = retailTextValue(primary && primary.outcome_key, '').toLowerCase();
        if (outcomeKey === 'retail_purchased') {
          var purchases = retailArray(primary && primary.purchase_items);
          if (purchases.length) {
            return purchases.map(function(item){
              return retailTextValue(item && item.product_name, '');
            }).filter(Boolean).slice(0, 2).join(', ') || 'Retail win';
          }
          return 'Retail win';
        }
        if (outcomeKey === 'appointment_booked') {
          var bookedAt = retailTextValue(primary && primary.booked_appointment_at, '');
          var label = retailTextValue(primary && primary.booked_service_label, '');
          return label || (bookedAt ? ('Booked ' + formatRecaptureDate(bookedAt)) : 'Booked win');
        }
        return retailTextValue(primary && primary.outcome_label, '') || 'No win yet';
      }

      function bdFastActedOnSmsDetailMarkup(row){
        var message = retailTextValue(row && row.last_outreach_message, '');
        var offerOption = bdFastOfferOption(retailTextValue(row && row.last_outreach_offer_key, 'none') || 'none');
        var offerLabel = retailTextValue(offerOption && offerOption.label, '');
        var facts = [
          bdFastDetailFact('SMS sent', formatRecaptureDateTime(retailTextValue(row && row.last_outreach_sent_at, ''))),
          bdFastDetailFact('Mode', bdFastModeLabel(retailTextValue(row && row.last_outreach_mode, 'service_growth'))),
          bdFastDetailFact('Offer', offerLabel && offerLabel !== 'No offer' ? offerLabel : ''),
          bdFastDetailFact('Sent by', retailTextValue(row && row.sent_by_name, ''))
        ].filter(Boolean).join('');
        return ''
          + '<div class="bd-fastDetailSection">'
          +   '<div class="bd-fastDetailLead">SMS Sent</div>'
          +   '<div class="bd-fastDetailFacts">' + facts + '</div>'
          +   (message ? '<div class="bd-fastStrategyHero"><div class="bd-fastStrategyEyebrow">Message</div><p>' + escapeHtml(message) + '</p></div>' : '')
          + '</div>';
      }

      function bdFastOfferSelectOptionsMarkup(row, selectedKey){
        var safeSelected = retailTextValue(selectedKey, 'none') || 'none';
        return bdFastOfferKeysForRow(row).map(function(key){
          var option = bdFastOfferOption(key);
          if (!option) return '';
          return '<option value="' + escapeHtml(key) + '"' + (key === safeSelected ? ' selected' : '') + '>' + escapeHtml(retailTextValue(option && option.label, key)) + '</option>';
        }).join('');
      }

      function bdFastIsQueued(row){
        var key = retailTextValue(row && row.opportunity_key, '');
        return !!(key && bdFastSmsQueueOrder.indexOf(key) !== -1);
      }

      function bdFastQueueRows(){
        return bdFastSmsQueueOrder.map(function(key){
          return retailArray(bdFastAllRows).find(function(row){
            return retailTextValue(row && row.opportunity_key, '') === key;
          }) || null;
        }).filter(Boolean);
      }

      function renderBdFastSelectionState(){
        if (bdFastQueueSelectedBtn) {
          bdFastQueueSelectedBtn.disabled = true;
        }
      }

      async function queueBdFastSelectedRows(){
        var selectedKeys = Object.keys(bdFastSelectedRows || {}).filter(function(key){
          return !!bdFastSelectedRows[key];
        });
        if (!selectedKeys.length) return;
        setBdFastStatus('Preparing selected SMS drafts...');
        var skippedCount = 0;
        for (var index = 0; index < selectedKeys.length; index += 1) {
          var selectedKey = selectedKeys[index];
          var row = retailArray(bdFastAllRows).find(function(item){
            return retailTextValue(item && item.opportunity_key, '') === selectedKey;
          });
          if (!row) continue;
          if (!bdFastHasSmsBookingData(row)) {
            bdFastSelectedRows[selectedKey] = false;
            skippedCount += 1;
            continue;
          }
          if (bdFastSmsQueueOrder.indexOf(selectedKey) === -1) {
            bdFastSmsQueueOrder.push(selectedKey);
          }
          try {
            await ensureBdFastDraftForRow(row, { force: false });
          } catch (_error) {
          }
          bdFastSelectedRows[selectedKey] = false;
        }
        bdFastSmsQueueOrder = bdFastSmsQueueOrder.filter(function(key, position, source){
          return source.indexOf(key) === position;
        });
        renderBdFastQueue();
        setBdFastStatus(
          skippedCount > 0
            ? 'Added available rows to the SMS queue. ' + String(skippedCount) + ' row' + (skippedCount === 1 ? ' was' : 's were') + ' skipped because SMS booking data is missing.'
            : 'Selected rows added to the SMS queue.',
          skippedCount > 0 ? 'warning' : 'success'
        );
      }

      async function performBdFastOutreachAction(fastAction, rowKey, scopeRoot, trigger){
        var actionRow = retailArray(bdFastAllRows).find(function(row){
          return bdFastOutreachStateKey(row) === rowKey || retailTextValue(row && row.opportunity_key, '') === rowKey;
        });
        if (!actionRow) return;
        var bucketKey = retailTextValue(actionRow && actionRow.guest_bucket_key, '');
        if (!bucketKey) {
          setBdFastStatus('This row is missing a guest bucket key, so outreach cannot be sent.', 'error');
          return;
        }
        var offerSelect = scopeRoot ? scopeRoot.querySelector('[data-bd-fast-offer-select]') : null;
        var draftEditor = scopeRoot ? scopeRoot.querySelector('[data-bd-fast-draft-editor]') : null;
        var offerKey = String((offerSelect && offerSelect.value) || bdFastOutreachStateForRow(actionRow).offerKey || 'none').trim() || 'none';
        var offerOption = bdFastOfferOption(offerKey);
        var offerText = retailTextValue(offerOption && offerOption.text, '');
        var offerLabel = offerOption ? retailTextValue(offerOption.label, '') : '';
        var offerId = offerOption ? retailTextValue(offerOption.boulevard_offer_id, '') : '';
        var offerCode = offerOption ? retailTextValue(offerOption.boulevard_offer_code, '') : '';
        var offerName = offerOption ? retailTextValue(offerOption.boulevard_offer_name, '') : '';
        var draftBody = String((draftEditor && draftEditor.value) || '').trim();
        var activeEntry = bdFastActiveOpportunityEntry(actionRow, false);
        var activeLane = retailTextValue(activeEntry && activeEntry.lane_key, '') || bdFastCurrentLane();
        var opportunityMode = retailTextValue(activeEntry && activeEntry.mode, '') || bdFastOpportunityMode(actionRow);
        if (bdFastIsRetailNeedsBookingHybrid(actionRow)) {
          opportunityMode = 'hybrid_growth';
        }
        var opportunityLane = bdFastOutreachLaneForRow(actionRow, activeLane);
        bdFastPersistOutreachState(rowKey, {
          offerKey: offerKey,
          draftBody: draftBody,
          reviewed: !!draftBody
        });
        var currentVisibleRows = retailArray(bdFastFilteredRows);
        var currentIndex = currentVisibleRows.findIndex(function(row){
          return retailTextValue(row && row.opportunity_key, '') === retailTextValue(actionRow && actionRow.opportunity_key, '');
        });
        var nextRowKey = currentIndex >= 0
          ? retailTextValue((currentVisibleRows[currentIndex + 1] || currentVisibleRows[currentIndex - 1] || {}).opportunity_key, '')
          : '';
        function removeBdFastRowLocally(){
          bdFastAllRows = retailArray(bdFastAllRows).filter(function(row){
            return retailTextValue(row && row.guest_bucket_key, '') !== bucketKey;
          });
          Object.keys(bdFastModeStateByMode).forEach(function(cacheKey){
            var state = bdFastModeStateByMode[cacheKey];
            if (!state) return;
            state.allRows = retailArray(state.allRows).filter(function(row){
              return retailTextValue(row && row.guest_bucket_key, '') !== bucketKey;
            });
            state.filteredRows = retailArray(state.filteredRows).filter(function(row){
              return retailTextValue(row && row.guest_bucket_key, '') !== bucketKey;
            });
            state.loadedRowCount = retailArray(state.allRows).length;
          });
          bdFastSmsQueueOrder = bdFastSmsQueueOrder.filter(function(key){
            return key !== retailTextValue(actionRow && actionRow.opportunity_key, '');
          });
          if (bdFastSelectedOpportunityKey === retailTextValue(actionRow && actionRow.opportunity_key, '')) {
            bdFastSelectedOpportunityKey = nextRowKey || '';
          }
        }
        if (trigger) trigger.disabled = true;
        try {
          if (fastAction === 'draft') {
            if (opportunityMode === 'retail_growth' || opportunityMode === 'hybrid_growth') {
              var retailDraftState = bdFastDetailState(actionRow);
              var retailDraftSummary = bdFastStrategySummary(actionRow, retailDraftState);
              bdFastPersistOutreachState(rowKey, {
                draftBody: retailDraftSummary ? bdFastStrategySmsMessage(retailDraftSummary) : '',
                reviewed: false
              });
              setBdFastStatus('Retail draft updated.', 'success');
              renderBdFastQueue();
              return;
            }
            setBdFastStatus('Drafting SMS...');
            var draftResult = await createDueQueueDraft(bucketKey, {
              offerKey: offerKey,
              offerText: offerText,
              offerLabel: offerLabel,
              offerId: offerId,
              offerCode: offerCode,
              offerName: offerName,
              queueSource: 'client_followup_queue_v4',
              opportunityKey: retailTextValue(actionRow && actionRow.opportunity_key, ''),
              opportunityMode: opportunityMode,
              opportunityLane: opportunityLane
            });
            bdFastPersistOutreachState(rowKey, {
              draftBody: String((draftResult && draftResult.message_body) || ''),
              reviewed: false
            });
            setBdFastStatus('Draft ready.', 'success');
            renderBdFastQueue();
            return;
          }
          if (fastAction === 'save-retail-tags') {
            var detailState = bdFastDetailState(actionRow);
            var detailResult = detailState && detailState.detail && typeof detailState.detail === 'object' ? detailState.detail : {};
            var detail = detailResult.detail && typeof detailResult.detail === 'object' ? detailResult.detail : {};
            var summary = bdFastStrategySummary(actionRow, detailState);
            var anchorAppointment = summary && summary.recentAppointment && typeof summary.recentAppointment === 'object'
              ? summary.recentAppointment
              : {};
            var appointmentId = retailTextValue(anchorAppointment && anchorAppointment.appointment_id, '');
            var outreachState = bdFastOutreachStateForRow(actionRow);
            var productTags = bdFastManualRetailOverrideList(outreachState && outreachState.manualProductTags);
            if (!appointmentId) {
              throw new Error('No anchor appointment was found for saving recommendation tags.');
            }
            var pickerState = bdFastRetailProductPickerState(rowKey);
            pickerState.query = '';
            pickerState.results = [];
            pickerState.loading = false;
            pickerState.error = '';
            setBdFastStatus('Saving selected products...', 'loading');
            bdFastPersistOutreachState(rowKey, {
              manualConcernTags: ''
            });
            await saveBdFastRetailTags({
              opportunityKey: retailTextValue(actionRow && actionRow.opportunity_key, ''),
              appointmentId: appointmentId,
              concernTags: [],
              productTags: productTags
            });
            renderBdFastRetailProductPickerSuggestions(rowKey);
            setBdFastStatus('Product tags saved.', 'success');
            fetchBdFastDetail(actionRow).then(function(freshDetail){
              var refreshedState = bdFastDetailState(actionRow);
              if (!refreshedState) return;
              refreshedState.detail = freshDetail;
              refreshedState.error = '';
              var refreshedSummary = bdFastStrategySummary(actionRow, refreshedState);
              bdFastPersistOutreachState(rowKey, {
                draftBody: refreshedSummary ? bdFastStrategySmsMessage(refreshedSummary) : draftBody,
                reviewed: false
              });
            }).catch(function(){});
            return;
          }
          if (fastAction === 'send') {
            setBdFastActionPendingState(trigger, true, 'Sending');
            var sendResult = await sendDueQueueText(bucketKey, {
              offerKey: offerKey,
              offerText: offerText,
              offerLabel: offerLabel,
              offerId: offerId,
              offerCode: offerCode,
              offerName: offerName,
              messageBody: draftBody,
              queueSource: 'client_followup_queue_v4',
              opportunityKey: retailTextValue(actionRow && actionRow.opportunity_key, ''),
              opportunityMode: opportunityMode,
              opportunityLane: opportunityLane,
              reviewed: true
            });
            if (sendResult && sendResult.canceled) {
              setBdFastActionPendingState(trigger, false);
              setBdFastStatus('Send canceled.', 'warning');
              if (trigger) trigger.disabled = false;
              return;
            }
            if (String(sendResult && sendResult.queue_delivery_status || '').trim().toLowerCase() === 'queued') {
              setBdFastStatus('Text added to the outbound queue.', 'success');
            } else {
              setBdFastStatus('Text sent via outbound queue.', 'success');
            }
            removeBdFastRowLocally();
            renderBdFastQueue();
            if (bdFastSelectedOpportunityKey) {
              var nextSelectedRow = retailArray(bdFastAllRows).find(function(row){
                return retailTextValue(row && row.opportunity_key, '') === bdFastSelectedOpportunityKey;
              });
              if (nextSelectedRow) {
                loadBdFastDetailForRow(nextSelectedRow).catch(function(){});
              }
            }
            loadBdFastScorecard().catch(function(){});
            return;
          }
          if (fastAction === 'hide-until-trigger') {
            setBdFastActionPendingState(trigger, true, 'Hiding');
            await hideBdFastOpportunityUntilTrigger(bucketKey, opportunityLane);
            setBdFastStatus('Opportunity hidden until a new trigger updates this guest.', 'success');
            removeBdFastRowLocally();
            renderBdFastQueue();
            if (bdFastSelectedOpportunityKey) {
              var replacementSelectedRow = retailArray(bdFastAllRows).find(function(row){
                return retailTextValue(row && row.opportunity_key, '') === bdFastSelectedOpportunityKey;
              });
              if (replacementSelectedRow) {
                loadBdFastDetailForRow(replacementSelectedRow).catch(function(){});
              }
            }
            return;
          }
          if (fastAction === 'snooze-7') {
            setBdFastStatus('Snoozing guest for 7 days...');
            await snoozeDueQueueRow(bucketKey, 7, 'snoozed');
            setBdFastStatus('Guest snoozed for 7 days.', 'success');
            if (bdFastSelectedOpportunityKey === retailTextValue(actionRow && actionRow.opportunity_key, '')) {
              bdFastSelectedOpportunityKey = nextRowKey || '';
            }
            renderBdFastQueue();
            loadBdFastAllLaneData({ reset: true, clearUi: false, forceRefresh: true }).catch(function(){});
            return;
          }
          if (fastAction === 'dismiss-30') {
            setBdFastStatus('Skipping this guest for 30 days...');
            await snoozeDueQueueRow(bucketKey, 30, 'dismissed');
            setBdFastStatus('Guest skipped for 30 days.', 'success');
            if (bdFastSelectedOpportunityKey === retailTextValue(actionRow && actionRow.opportunity_key, '')) {
              bdFastSelectedOpportunityKey = nextRowKey || '';
            }
            renderBdFastQueue();
            loadBdFastAllLaneData({ reset: true, clearUi: false, forceRefresh: true }).catch(function(){});
            return;
          }
        } catch (error) {
          if (fastAction === 'send') {
            setBdFastActionPendingState(trigger, false);
          }
          if (fastAction === 'hide-until-trigger') {
            setBdFastActionPendingState(trigger, false);
          }
          setBdFastStatus(humanizeClientFetchErrorMessage(error, 'Could not update fast-queue outreach.'), 'error');
          if (trigger) trigger.disabled = false;
        }
      }

      function setBdFastActionPendingState(trigger, pending, loadingLabel){
        if (!trigger || !trigger.classList) return;
        if (pending) {
          if (!trigger.dataset.originalLabel) {
            trigger.dataset.originalLabel = String(trigger.textContent || '').trim() || 'Working';
          }
          trigger.classList.add('is-pending');
          trigger.setAttribute('aria-busy', 'true');
          trigger.setAttribute('aria-label', loadingLabel || 'Working');
          trigger.innerHTML = '<span class="bd-fastLoadingSpinner bd-fastLoadingSpinner--button" aria-hidden="true"></span><span>' + escapeHtml(loadingLabel || 'Working') + '</span>';
          return;
        }
        trigger.classList.remove('is-pending');
        trigger.removeAttribute('aria-busy');
        trigger.removeAttribute('aria-label');
        if (trigger.dataset.originalLabel) {
          trigger.textContent = trigger.dataset.originalLabel;
          delete trigger.dataset.originalLabel;
        }
      }

      function bdFastSimpleTimingText(row){
        var overdueDays = bdFastDaysOverdue(row);
        var daysUntilDue = bdFastDaysUntilDue(row);
        if (overdueDays > 0) {
          return overdueDays === 1 ? '1 day overdue' : String(overdueDays) + ' days overdue';
        }
        if (daysUntilDue > 0) {
          return daysUntilDue === 1 ? 'Due in 1 day' : 'Due in ' + String(daysUntilDue) + ' days';
        }
        return 'Due now';
      }

      function bdFastQueueOwnerText(row){
        return retailTextValue(row && row.primary_staff_name, '') || 'Unassigned owner';
      }

      function bdFastQueueLastVisitText(row){
        var lastVisit = bdFastLastVisitDateValue(row);
        if (!lastVisit) return 'No completed visit';
        return 'Last visit ' + formatRecaptureDate(lastVisit);
      }

      function bdFastQueueFutureAppointmentText(row){
        var futureAt = retailTextValue(row && row.future_appointment_at, '');
        if (!futureAt) return 'No future appointment';
        return 'Future booked ' + formatRecaptureDate(futureAt);
      }

      function bdFastQueueReasonText(row){
        if (bdFastLaneIsActedOnRow(row, bdFastCurrentLane())) {
          var actedOnState = bdFastOpportunityState(row);
          if (actedOnState === 'converted_booking') return 'Already converted to a booked appointment';
          if (actedOnState === 'converted_retail') return 'Already converted to a retail purchase';
          if (actedOnState === 'closed_no_conversion') return 'Outreach closed without a recorded conversion';
          if (actedOnState === 'hidden') return 'Hidden until a new trigger happens';
          return 'Outreach already handled';
        }
        if (bdFastCurrentLane() === 'wellness' && bdFastHasWellnessTags(row)) {
          return 'Wellness opportunity on file';
        }
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var recommendationSnapshot = row && row.recommendation_snapshot_count > 0;
        if (categoryKey === 'retail') {
          if (recommendationSnapshot) return 'Routine ready from recent visit';
          if (bdFastHasFutureBooking(row)) return 'Retail follow-up with future booking';
          return 'Post-visit retail opportunity';
        }
        if (categoryKey === 'never_visited') {
          if (retailTextValue(row && row.latest_cancelled_at, '')) return 'Cancelled first visit';
          if (retailTextValue(row && row.latest_no_show_at, '')) return 'Missed first visit';
          return 'Booked once but never completed';
        }
        if (categoryKey === 'needs_booking') {
          if (bdFastHasRecentCancellationSignal(row, 30)) return 'Unbooked after cancellation';
          if (bdFastHasReliableCadence(row) && bdFastDaysOverdue(row) > 0) return 'Overdue against known cadence';
          if (bdFastHasReliableCadence(row)) return 'No future booking against known cadence';
          return 'Returning guest with no future booking';
        }
        return bdFastReasonLine(row);
      }

      function bdFastQueuePriorityText(row){
        var score = Number((row && (row.business_priority_score || row.priority_score)) || 0) || 0;
        if (bdFastIsActionHistoryRow(row)) return bdFastOpportunityStateLabel(row);
        if (score >= 80) return 'Highest priority';
        if (score >= 60) return 'High priority';
        if (score >= 40) return 'Priority';
        return 'Standard priority';
      }

      function bdFastLastVisitText(row){
        var lastVisit = retailTextValue(row && row.last_in_date, '');
        if (!lastVisit) return 'No completed visit';
        return 'Last seen ' + formatRecaptureDate(lastVisit);
      }

      function bdFastCollapsedReason(row){
        if (bdFastLaneIsActedOnRow(row, bdFastCurrentLane())) {
          var actedOnState = bdFastOpportunityState(row);
          if (actedOnState === 'converted_booking') {
            return 'This outreach already turned into a booked appointment, so it should stay in history instead of reading like an open recovery opportunity.';
          }
          if (actedOnState === 'converted_retail') {
            return 'This outreach already turned into a retail purchase, so it should read like a completed retail win rather than a live follow-up target.';
          }
          if (actedOnState === 'closed_no_conversion') {
            return 'This outreach window already closed without a recorded conversion, so it belongs in acted-on history instead of the active queue.';
          }
          if (actedOnState === 'hidden') {
            return 'This guest was intentionally hidden until a new trigger happens, so the row should stay out of the live opportunity framing for now.';
          }
          return 'This guest has already been worked, so the row should read like prior outreach history instead of an open opportunity.';
        }
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var cadenceDays = Math.max(0, Number((row && row.cadence_days) || 0) || 0);
        var service = retailTextValue(row && row.last_service_name, 'visit');
        if (categoryKey === 'wellness') {
          return 'This guest has wellness-related tags in their appointment history, so the next move is a trusted hs.Wellness introduction.';
        }
        if (categoryKey === 'retail') {
          return 'Closed today or within the last 14 days, so this row is focused on post-visit retail follow-up.';
        }
        if (categoryKey === 'future_protected') {
          return 'Already has a future appointment on the books.';
        }
        if (categoryKey === 'needs_booking') {
          if (bdFastHasReliableCadence(row)) {
            return 'Has completed visit history, no future appointment, and a past pattern around ' + dueCadenceFriendlyText(cadenceDays) + '.';
          }
          return 'Has completed visit history, but no future appointment.';
        }
        if (categoryKey === 'new_guest_no_prebook') {
          return bdFastHasFutureBooking(row)
            ? 'Completed a first visit in the last 14 days and already has visit two booked.'
            : 'Completed a first visit in the last 14 days and still needs visit two booked.';
        }
        if (categoryKey === 'never_visited') {
          return 'Is in the database, but no completed visit is on record yet.';
        }
        return bdFastReasonLine(row);
      }

      function bdFastWhyText(row){
        if (bdFastLaneIsActedOnRow(row, bdFastCurrentLane())) {
          var actedOnState = bdFastOpportunityState(row);
          var firstNameActedOn = dueFirstName(row && row.guest_name) || 'This guest';
          if (actedOnState === 'converted_booking') {
            return firstNameActedOn + ' already booked from this outreach, so management should read this as a completed booking win and not re-queue it as a fresh opportunity.';
          }
          if (actedOnState === 'converted_retail') {
            return firstNameActedOn + ' already purchased from this outreach, so this row should stay framed as a retail conversion win instead of a current retail ask.';
          }
          if (actedOnState === 'closed_no_conversion') {
            return firstNameActedOn + ' was already worked and the current outreach window ended without a recorded conversion, so the next step should wait for a new trigger instead of repeating the same opportunity framing.';
          }
          if (actedOnState === 'hidden') {
            return firstNameActedOn + ' was deliberately hidden until a new trigger happens, so the row should stay quiet in history until the guest creates a fresh reason to reach out.';
          }
          return firstNameActedOn + ' has already been acted on, so this row should read like prior outreach context while the team waits for a response, conversion, or new trigger.';
        }
        if (bdFastCurrentLane() === 'wellness' && bdFastHasWellnessTags(row)) {
          var firstName = dueFirstName(row && row.guest_name) || 'This guest';
          var wellnessTags = bdFastWellnessTagValues(row);
          var wellnessContext = wellnessTags.length ? (' Tags on file: ' + wellnessTags.join(', ') + '.') : '';
          if (bdFastHasFutureBooking(row)) {
            return firstName + ' has wellness-related tags and an active salon relationship, so this is a strong moment to introduce hs.Wellness through stylist trust.' + wellnessContext;
          }
          if (bdFastHasCompletedVisit(row)) {
            return firstName + ' has wellness-related tags and completed visit history, so hs.Wellness can be introduced as a natural extension of the Hairstories relationship.' + wellnessContext;
          }
          return firstName + ' has wellness-related tags in their history, so this lane should use a warm hs.Wellness invitation rather than a generic salon follow-up.' + wellnessContext;
        }
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var firstName = dueFirstName(row && row.guest_name) || 'This guest';
        var stylist = retailTextValue(row && row.primary_staff_name, '');
        var service = retailTextValue(row && row.last_service_name, 'visit');
        var cadenceDays = Math.max(0, Number((row && row.cadence_days) || 0) || 0);
        if (categoryKey === 'retail') {
          return firstName + ' closed a visit today or within the last 14 days, so the next growth move is retail outreach while the result is still top of mind.';
        }
        if (categoryKey === 'future_protected') {
          return firstName + ' already has a future appointment booked, so service is currently protected.';
        }
        if (categoryKey === 'needs_booking') {
          if (bdFastHasReliableCadence(row)) {
            return firstName + ' has completed visit history and no future appointment. Their detail history suggests a rhythm around ' + dueCadenceFriendlyText(cadenceDays) + ' for ' + service + ', which should guide the outreach strategy.';
          }
          return firstName + ' has completed visit history and no future appointment. Open client details to decide the best way to recover the booking.';
        }
        if (categoryKey === 'new_guest_no_prebook') {
          if (stylist) {
            return bdFastHasFutureBooking(row)
              ? firstName + ' is brand new to Hairstories, completed a first visit recently with ' + stylist + ', and already has visit two booked. This should read like a warm continuation of that first experience, not a generic return reminder.'
              : firstName + ' is brand new to Hairstories, completed a first visit recently with ' + stylist + ', and still needs visit two booked. This should read like a warm continuation of that first experience, not a generic return reminder.';
          }
          return bdFastHasFutureBooking(row)
            ? firstName + ' is brand new to Hairstories, completed a first visit recently, and already has visit two booked. This should read like a warm continuation of that first experience, not a generic return reminder.'
            : firstName + ' is brand new to Hairstories, completed a first visit recently, and still needs visit two booked. This should read like a warm continuation of that first experience, not a generic return reminder.';
        }
        if (categoryKey === 'never_visited') {
          return firstName + ' is in the database but no completed visit is currently on record, so this should be treated as a first-visit conversion rather than a return reminder.';
        }
        return bdFastCollapsedReason(row);
      }

      function bdFastOfferSummaryText(row, strategy, offerOption){
        var selectedLabel = retailTextValue(offerOption && offerOption.label, strategy.offerLabel || 'No offer');
        if (!selectedLabel || selectedLabel === 'No offer') {
          return 'No offer recommended — a personal reminder should be enough.';
        }
        return selectedLabel;
      }

      async function ensureBdFastDraftForRow(row, options){
        var opts = options && typeof options === 'object' ? options : {};
        var key = bdFastOutreachStateKey(row);
        var bucketKey = retailTextValue(row && row.guest_bucket_key, '');
        if (!key || !bucketKey) return;
        var state = bdFastOutreachStateForRow(row);
        if (!opts.force && retailTextValue(state && state.draftBody, '')) return;
        var offerKey = retailTextValue(state && state.offerKey, 'none') || 'none';
        var offerOption = bdFastOfferOption(offerKey);
        var offerText = offerKey === 'custom'
          ? retailTextValue(state && state.customOfferText, '')
          : retailTextValue(offerOption && offerOption.text, '');
        var opportunityMode = bdFastOpportunityMode(row);
        if (opportunityMode === 'retail_growth') {
          var retailState = bdFastDetailState(row);
          var retailSummary = bdFastStrategySummary(row, retailState);
          bdFastPersistOutreachState(key, {
            draftBody: retailSummary ? bdFastStrategySmsMessage(retailSummary) : '',
            reviewed: false
          });
          return;
        }
        var draftResult = await createDueQueueDraft(bucketKey, {
          offerKey: offerKey,
          offerText: offerText,
          offerLabel: retailTextValue(offerOption && offerOption.label, ''),
          offerId: retailTextValue(offerOption && offerOption.boulevard_offer_id, ''),
          offerCode: retailTextValue(offerOption && offerOption.boulevard_offer_code, ''),
          offerName: retailTextValue(offerOption && offerOption.boulevard_offer_name, ''),
          queueSource: 'client_followup_queue_v4',
          opportunityKey: retailTextValue(row && row.opportunity_key, ''),
          opportunityMode: opportunityMode
        });
        bdFastPersistOutreachState(key, {
          draftBody: retailTextValue(draftResult && draftResult.message_body, ''),
          reviewed: false
        });
      }

      function bdFastOutreachStateForRow(row){
        var key = bdFastOutreachStateKey(row);
        var existing = key ? bdFastOutreachState[key] : null;
        var savedProductTags = bdFastSavedManagerProductTagList(row);
        if (existing) {
          if ((!existing.manualProductTags || !String(existing.manualProductTags).trim()) && savedProductTags.length) {
            existing.manualProductTags = savedProductTags.join(', ');
          }
          return existing;
        }
        var strategy = bdFastStrategy(row);
        var outreach = bdFastOutreachMeta(row);
        var latestDraft = outreach && outreach.latest_draft && typeof outreach.latest_draft === 'object' ? outreach.latest_draft : null;
        var nextState = {
          offerKey: retailTextValue(latestDraft && latestDraft.offer_key, strategy.offerKey || 'none') || 'none',
          customOfferText: '',
          draftBody: retailTextValue(latestDraft && latestDraft.message_body, ''),
          reviewed: false,
          manualConcernTags: '',
          manualProductTags: savedProductTags.join(', ')
        };
        if (key) {
          bdFastOutreachState[key] = nextState;
        }
        return nextState;
      }

      function bdFastPersistOutreachState(key, partial){
        if (!key) return;
        var current = bdFastOutreachState[key] && typeof bdFastOutreachState[key] === 'object'
          ? bdFastOutreachState[key]
          : { offerKey: 'none', customOfferText: '', draftBody: '', reviewed: false, manualConcernTags: '', manualProductTags: '' };
        bdFastOutreachState[key] = Object.assign({}, current, partial || {});
      }

      function bdFastManualRetailOverrideList(value){
        return uniqueNonEmptyStrings(String(value || '')
          .split(/[\n,|]+/)
          .map(function(entry){
            return retailTextValue(entry, '').replace(/^(concern|product)\s*:\s*/i, '').trim();
          })
          .filter(Boolean));
      }

      function bdFastManualConcernTagValues(value){
        return bdFastManualRetailOverrideList(value).map(function(entry){
          return 'concern: ' + entry;
        });
      }

      function bdFastManualProductTagValues(value){
        return bdFastManualRetailOverrideList(value).map(function(entry){
          return 'product: ' + entry;
        });
      }

      function bdFastSavedManagerProductTagList(row){
        var state = bdFastDetailState(row);
        var detailResult = state && state.detail && typeof state.detail === 'object' ? state.detail : {};
        var detail = detailResult.detail && typeof detailResult.detail === 'object' ? detailResult.detail : {};
        var recentAppointment = bdFastDetailAppointmentWithRichContext(detail) || bdFastStrategyRecentAppointment(detail);
        var appointmentData = recentAppointment && recentAppointment.appointment_data && typeof recentAppointment.appointment_data === 'object'
          ? recentAppointment.appointment_data
          : {};
        var managerTags = appointmentData && appointmentData.manager_recommendation_tags && typeof appointmentData.manager_recommendation_tags === 'object'
          ? appointmentData.manager_recommendation_tags
          : {};
        return bdFastManualRetailOverrideList(managerTags && managerTags.product_tags);
      }

      function bdFastOutreachComposerMarkup(row){
        var state = bdFastOutreachStateForRow(row);
        var key = bdFastOutreachStateKey(row);
        var bucketKey = retailTextValue(row && row.guest_bucket_key, '');
        var strategy = bdFastStrategy(row);
        var offerOption = bdFastOfferOption(state.offerKey || strategy.offerKey || 'none');
        var hasPhone = !!retailTextValue(row && row.client_phone, '');
        var canCommunicate = dueShouldShowCommunication(row) && !!bucketKey && hasPhone;
        if (!canCommunicate) {
          return '';
        }
        return ''
          + '<div class="bd-fastCompose" data-bd-fast-outreach="' + escapeHtml(key) + '">'
          +   (bdFastAllowsOfferChoice(row)
                ? '<div class="bd-fastInlineOffer"><span>Offer</span><select class="progression-valueEditor" data-bd-fast-offer-select="' + escapeHtml(key) + '">' + bdFastOfferSelectOptionsMarkup(row, state.offerKey || strategy.offerKey || 'none') + '</select></div>'
                : (retailTextValue(offerOption && offerOption.label, '') && retailTextValue(offerOption && offerOption.label, '') !== 'No offer'
                    ? '<p class="bd-fastOfferInline">' + escapeHtml(retailTextValue(offerOption && offerOption.label, '')) + '</p>'
                    : ''))
          +   '<textarea class="retail-draftEditor bd-fastDraftEditor" data-bd-fast-draft-editor="' + escapeHtml(key) + '" placeholder="Draft a message to review before sending.">' + escapeHtml(state.draftBody || '') + '</textarea>'
          + '</div>';
      }

      function bdFastCardMarkup(row){
        var key = retailTextValue(row && row.opportunity_key, '');
        var guestName = retailTextValue(row && row.guest_name, 'Unknown guest');
        var active = key && key === bdFastSelectedOpportunityKey;
        var showQuickHide = !bdFastIsActionHistoryRow(row) && !bdFastLaneIsActedOnRow(row, bdFastCurrentLane());
        var activityBucket = getRetailActivityBucket(row);
        var activityText = bdFastCheckinActivityIntentText(activityBucket);
        var secondaryMeta = (bdFastIsActionHistoryRow(row) || bdFastLaneIsActedOnRow(row, bdFastCurrentLane()))
          ? [
              retailTextValue(row && row.action_summary_text, '') || bdFastActionOutcomeSummaryText(row) || bdFastOpportunityStateLabel(row),
              activityText,
              bdFastOpportunityStateLabel(row),
              retailTextValue(row && row.last_outreach_sent_at, '') ? ('Sent ' + formatRecaptureDate(row.last_outreach_sent_at)) : ''
            ].filter(Boolean)
          : [
              bdFastQueueLastVisitText(row),
              bdFastVisitCountText(row),
              bdFastQueueFutureAppointmentText(row),
              activityText
            ].filter(Boolean);
        return ''
          + '<article class="bd-fastCard' + (active ? ' is-active' : '') + '" data-bd-fast-row="' + escapeHtml(key) + '">'
          +   '<div class="bd-fastRowMain">'
          +     '<div class="bd-fastRowTop">'
          +       '<div class="bd-fastTitleBlock">'
          +         '<h3>' + escapeHtml(guestName) + '</h3>'
          +       '</div>'
          +       '<div class="bd-fastRowStatus">'
          +         (showQuickHide
                      ? '<button class="bd-fastRowQuickAction" type="button" data-bd-fast-action="hide-until-trigger" data-bd-fast-row-key="' + escapeHtml(key) + '">Hide</button>'
                      : '')
          +         '<span class="bd-fastChevron" aria-hidden="true">›</span>'
          +       '</div>'
          +     '</div>'
          +     '<div class="bd-fastFactsRow">'
          +       secondaryMeta.map(function(value){
                    return '<span>' + escapeHtml(value) + '</span>';
                  }).join('<span class="bd-fastMetaDot">•</span>')
          +     '</div>'
          +   '</div>'
          + '</article>';
      }

      function bdFastActedOnPurchaseMatches(detail, row){
        var safeDetail = detail && typeof detail === 'object' ? detail : {};
        var sentAt = retailTextValue(row && row.last_outreach_sent_at, '');
        var sentAtMs = sentAt ? new Date(sentAt).getTime() : NaN;
        var purchases = retailArray(safeDetail.shopify_purchases).concat(retailArray(safeDetail.purchases));
        return purchases.filter(function(item){
          var completedAt = retailTextValue(item && item.completed_at, '');
          if (!completedAt) return false;
          var completedMs = new Date(completedAt).getTime();
          if (!Number.isFinite(completedMs)) return false;
          if (Number.isFinite(sentAtMs) && completedMs < sentAtMs) return false;
          return true;
        }).sort(function(a, b){
          return retailTextValue(b && b.completed_at, '').localeCompare(retailTextValue(a && a.completed_at, ''));
        });
      }

      function bdFastActedOnProductsMarkup(items){
        var safeItems = retailArray(items);
        if (!safeItems.length) return '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">Retail win recorded, but purchased products were not resolved yet.</div>';
        return '<div class="bd-fastTimelineList">' + safeItems.slice(0, 6).map(bdFastDetailPurchaseRowMarkup).join('') + '</div>';
      }

      function bdFastActedOnLinkActivityMarkup(row){
        var activityBucket = getRetailActivityBucket(row);
        var activityRows = retailArray(row && row.checkin_activity_rows);
        var headline = bdFastCheckinActivityIntentText(activityBucket);
        var support = bdFastCheckinActivitySupportText(activityBucket);
        if (!headline && !support && !activityRows.length) return '';
        var timelineMarkup = activityRows.length
          ? '<div class="bd-fastTimelineList">' + activityRows.slice(0, 80).map(function(item){
              var safeItem = item && typeof item === 'object' ? item : {};
              var metadata = safeItem.metadata && typeof safeItem.metadata === 'object' ? safeItem.metadata : {};
              var detailBits = [];
              var metaLine = bdFastCheckinEventMeta(safeItem);
              if (metaLine) detailBits.push(metaLine);
              if (retailTextValue(metadata.product_name, '')) detailBits.push('Product: ' + retailTextValue(metadata.product_name, ''));
              if (retailTextValue(metadata.handle, '')) detailBits.push('Handle: ' + retailTextValue(metadata.handle, ''));
              if (retailTextValue(metadata.rating_value, '')) detailBits.push('Rating: ' + retailTextValue(metadata.rating_value, ''));
              return ''
                + '<article class="bd-fastTimelineItem">'
                +   '<div class="bd-fastTimelineTop"><strong>' + escapeHtml(bdFastCheckinEventLabel(safeItem)) + '</strong><span>' + escapeHtml(formatRecaptureDateTime(retailTextValue(safeItem.occurred_at, '')) || 'Unknown time') + '</span></div>'
                +   (detailBits.length ? '<div class="bd-fastTimelineMeta">' + escapeHtml(detailBits.join(' • ')) + '</div>' : '')
                +   (retailTextValue(safeItem.source_url, '') ? '<div class="bd-fastTimelineSub">' + escapeHtml(retailTextValue(safeItem.source_url, '')) + '</div>' : '')
                + '</article>';
            }).join('') + '</div>'
          : '';
        return ''
          + '<div class="bd-fastDetailSection">'
          +   '<div class="bd-fastDetailLead">Link activity</div>'
          +   '<div class="bd-fastDetailFacts">'
          +     bdFastDetailFact('Activity', headline || support)
          +     bdFastDetailFact('Details', support && support !== headline ? support : '')
          +   '</div>'
          +   (timelineMarkup
                ? bdFastExpandableSectionMarkup('Interaction timeline', activityRows.length, timelineMarkup, '', { openByDefault: false })
                : '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No tracked link interactions yet for this link.</div>')
          + '</div>';
      }

      function bdFastActedOnBookedSummaryMarkup(row, outcome){
        var safeOutcome = outcome && typeof outcome === 'object' ? outcome : {};
        var services = retailArray(safeOutcome && safeOutcome.booked_service_names).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        if (!services.length) {
          services = retailArray(row && row.future_appointment_services).map(function(value){
            return retailTextValue(value, '');
          }).filter(Boolean);
        }
        var bookedAt = retailTextValue(safeOutcome && safeOutcome.booked_appointment_at, '') || retailTextValue(row && row.future_appointment_at, '');
        var serviceLabel = retailTextValue(safeOutcome && safeOutcome.booked_service_label, '');
        var staffNames = retailArray(safeOutcome && safeOutcome.booked_staff_names).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        if (!staffNames.length) {
          staffNames = retailArray(row && row.staff_names).map(function(value){
          return retailTextValue(value, '');
          }).filter(Boolean);
        }
        var staffLabel = staffNames.slice(0, 3).join(', ') || retailTextValue(row && row.primary_staff_name, '');
        var facts = [
          bdFastDetailFact('Status', 'Booked win'),
          bdFastDetailFact('Booked for', formatRecaptureDateTime(bookedAt) || formatRecaptureDate(bookedAt)),
          bdFastDetailFact('Services', services.slice(0, 3).join(', ') || serviceLabel),
          bdFastDetailFact('Staff', staffLabel),
          bdFastDetailFact('Value', Number(safeOutcome && safeOutcome.revenue_cents) > 0 ? formatCurrencyDollarsFromCents(Number(safeOutcome && safeOutcome.revenue_cents) || 0) : '')
        ].filter(Boolean).join('');
        return ''
          + '<div class="bd-fastDetailSection">'
          +   bdFastActedOnSmsDetailMarkup(row)
          + '</div>'
          + bdFastActedOnLinkActivityMarkup(row)
          + '<div class="bd-fastDetailSection">'
          +   '<div class="bd-fastDetailLead">Outcome</div>'
          +   '<div class="bd-fastDetailFacts">' + facts + '</div>'
          +   '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">This outreach led to a booked appointment.</div>'
          + '</div>';
      }

      function bdFastActedOnRetailSummaryMarkup(row, outcome, state){
        var safeOutcome = outcome && typeof outcome === 'object' ? outcome : {};
        var purchases = retailArray(safeOutcome && safeOutcome.purchase_items);
        var purchaseSource = purchases.some(function(item){
          return retailTextValue(item && item.source, '').toLowerCase() === 'shopify';
        }) || retailTextValue(safeOutcome && safeOutcome.purchase_source, '').toLowerCase() === 'shopify' ? 'Shopify win' : 'Retail win';
        var facts = [
          bdFastDetailFact('Status', purchaseSource),
          bdFastDetailFact('Purchased', formatRecaptureDate(retailTextValue(safeOutcome && safeOutcome.completed_at, '') || retailTextValue(row && row.last_conversion_at, ''))),
          bdFastDetailFact('Revenue', Number(safeOutcome && safeOutcome.revenue_cents) > 0 ? formatCurrencyDollarsFromCents(Number(safeOutcome && safeOutcome.revenue_cents) || 0) : '')
        ].filter(Boolean).join('');
        return ''
          + '<div class="bd-fastDetailSection">'
          +   bdFastActedOnSmsDetailMarkup(row)
          + '</div>'
          + bdFastActedOnLinkActivityMarkup(row)
          + '<div class="bd-fastDetailSection">'
          +   '<div class="bd-fastDetailLead">Outcome</div>'
          +   '<div class="bd-fastDetailFacts">' + facts + '</div>'
          +   bdFastActedOnProductsMarkup(purchases)
          + '</div>';
      }

      function bdFastActedOnPendingSummaryMarkup(row){
        var offerOption = bdFastOfferOption(retailTextValue(row && row.last_outreach_offer_key, 'none') || 'none');
        var offerLabel = retailTextValue(offerOption && offerOption.label, '');
        var facts = [
          bdFastDetailFact('Status', retailTextValue(row && row.opportunity_state_label, '') || 'Acted On'),
          bdFastDetailFact('SMS sent', formatRecaptureDateTime(retailTextValue(row && row.last_outreach_sent_at, ''))),
          bdFastDetailFact('Mode', bdFastModeLabel(retailTextValue(row && row.last_outreach_mode, 'service_growth'))),
          bdFastDetailFact('Offer', offerLabel && offerLabel !== 'No offer' ? offerLabel : '')
        ].filter(Boolean).join('');
        return ''
          + '<div class="bd-fastDetailSection">'
          +   bdFastActedOnSmsDetailMarkup(row)
          + '</div>'
          + bdFastActedOnLinkActivityMarkup(row)
          + '<div class="bd-fastDetailSection">'
          +   '<div class="bd-fastDetailLead">Outcome</div>'
          +   '<div class="bd-fastDetailFacts">' + facts + '</div>'
          +   '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No win yet.</div>'
          + '</div>';
      }

      function bdFastActedOnSummaryMarkup(row, state){
        if (bdFastIsActionHistoryRow(row)) {
          var history = bdFastActionHistoryItems(row);
          if (!history.length) return bdFastActedOnPendingSummaryMarkup(row);
          return '<div class="bd-fastDetailSection"><div class="bd-fastDetailLead">Outcome History</div>' + history.map(function(item){
            var outcomeKey = retailTextValue(item && item.outcome_key, '').toLowerCase();
            if (outcomeKey === 'retail_purchased') return bdFastActedOnRetailSummaryMarkup(row, item, state);
            if (outcomeKey === 'appointment_booked') return bdFastActedOnBookedSummaryMarkup(row, item);
            return bdFastActedOnPendingSummaryMarkup(row);
          }).join('') + '</div>';
        }
        var outcomeKey = retailTextValue(row && row.last_conversion_outcome_key, '').toLowerCase();
        if (outcomeKey === 'appointment_booked' || retailTextValue(row && row.opportunity_state, '').toLowerCase() === 'converted_booking') {
          return bdFastActedOnBookedSummaryMarkup(row, row);
        }
        if (outcomeKey === 'retail_purchased' || retailTextValue(row && row.opportunity_state, '').toLowerCase() === 'converted_retail') {
          return bdFastActedOnRetailSummaryMarkup(row, row, state);
        }
        return bdFastActedOnPendingSummaryMarkup(row);
      }

      function bdFastExpandedMarkup(row){
        if (bdFastLaneIsActedOnRow(row, bdFastCurrentLane())) {
          return '<div class="bd-fastExpanded"><div class="bd-fastInlineDetail">' + bdFastActedOnSummaryMarkup(row, bdFastDetailState(row)) + '</div></div>';
        }
        var state = bdFastDetailState(row);
        return ''
          + '<div class="bd-fastExpanded">'
          +   bdFastOutreachComposerMarkup(row)
          +   '<div class="bd-fastInlineDetail">' + bdFastDetailContentMarkup(row, state) + '</div>'
          + '</div>';
      }

      function bdFastDetailState(row){
        var key = retailTextValue(row && row.opportunity_key, '');
        if (!key) return null;
        if (!bdFastDetailStateByKey[key] || typeof bdFastDetailStateByKey[key] !== 'object') {
          bdFastDetailStateByKey[key] = {
            loading: false,
            error: '',
            detail: null,
            selectedOpportunityLane: '',
            activeTab: 'overview',
            checkinActivityLoading: false,
            checkinActivityError: '',
            checkinActivity: null,
            aiStrategyLoading: false,
            aiStrategyError: '',
            aiStrategy: null
          };
        }
        return bdFastDetailStateByKey[key];
      }

      function bdFastSelectedOpportunityLane(row){
        var state = bdFastDetailState(row);
        return retailTextValue(state && state.selectedOpportunityLane, '');
      }

      function bdFastSetSelectedOpportunityLane(rowKey, laneKey){
        var key = retailTextValue(rowKey, '');
        var nextLane = retailTextValue(laneKey, '');
        if (!key || !nextLane) return;
        if (!bdFastDetailStateByKey[key] || typeof bdFastDetailStateByKey[key] !== 'object') return;
        bdFastDetailStateByKey[key].selectedOpportunityLane = nextLane;
        bdFastDetailStateByKey[key].aiStrategyLoading = false;
        bdFastDetailStateByKey[key].aiStrategyError = '';
        bdFastDetailStateByKey[key].aiStrategy = null;
      }

      async function fetchBdFastDetail(row){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'client_followup_queue_v4_detail',
            opportunity_key: retailTextValue(row && row.opportunity_key, ''),
            guest_bucket_key: retailTextValue(row && row.guest_bucket_key, '')
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load client detail.');
        }
        return data;
      }

      async function loadBdFastDetailForRow(row){
        var key = retailTextValue(row && row.opportunity_key, '');
        var state = bdFastDetailState(row);
        if (!key || !state) return;
        if (bdFastIsActionHistoryRow(row)) {
          renderBdFastQueue();
          return;
        }
        if (state.detail) {
          loadBdFastAiStrategyForRow(row).catch(function(){});
          renderBdFastQueue();
          return;
        }
        state.loading = true;
        state.error = '';
        bdFastDetailLoadingKey = key;
        renderBdFastQueue();
        try {
          state.detail = await fetchBdFastDetail(row);
          state.loading = false;
          if (bdFastDetailLoadingKey === key) bdFastDetailLoadingKey = '';
          loadBdFastCheckinActivityForRow(row).catch(function(){});
          loadBdFastAiStrategyForRow(row).catch(function(){});
          renderBdFastQueue();
        } catch (error) {
          state.loading = false;
          state.error = humanizeClientFetchErrorMessage(error, 'Could not load client detail.');
          if (bdFastDetailLoadingKey === key) bdFastDetailLoadingKey = '';
          renderBdFastQueue();
        }
      }

      function bdFastDetailActiveTab(state){
        var safeState = state && typeof state === 'object' ? state : {};
        var value = retailTextValue(safeState.activeTab, 'overview');
        return value || 'overview';
      }

      function bdFastSetDetailTab(rowKey, tabKey){
        var key = retailTextValue(rowKey, '');
        var nextTab = retailTextValue(tabKey, 'overview');
        if (!key || !nextTab) return;
        if (!bdFastDetailStateByKey[key] || typeof bdFastDetailStateByKey[key] !== 'object') return;
        bdFastDetailStateByKey[key].activeTab = nextTab;
        renderBdFastClaimedList();
      }

      function bdFastCheckinActivityAppointmentIds(selectedRow, detail){
        var ids = [];
        var primaryAppointmentId = retailTextValue(selectedRow && selectedRow.appointment_id, '');
        if (primaryAppointmentId) ids.push(primaryAppointmentId);
        retailArray(detail && detail.appointments).forEach(function(item){
          var appointmentId = retailTextValue(item && item.appointment_id, '');
          if (appointmentId) ids.push(appointmentId);
        });
        return uniqueNonEmptyStrings(ids);
      }

      async function loadBdFastCheckinActivityForRow(row){
        var state = bdFastDetailState(row);
        if (!state || !state.detail) return;
        if (state.checkinActivity || state.checkinActivityLoading === true) return;
        var detailResult = state.detail && typeof state.detail === 'object' ? state.detail : {};
        var detail = detailResult.detail && typeof detailResult.detail === 'object' ? detailResult.detail : {};
        var appointmentIds = bdFastCheckinActivityAppointmentIds(row, detail);
        if (!appointmentIds.length) {
          state.checkinActivity = { summary: {}, rows: [], by_appointment: [] };
          return;
        }
        state.checkinActivityLoading = true;
        state.checkinActivityError = '';
        renderBdFastClaimedList();
        try {
          state.checkinActivity = await fetchRetailCheckinActivity(appointmentIds.map(function(id){
            return { appointment_id: id };
          }));
          state.checkinActivityLoading = false;
          mergeCheckinActivitySummary(state.checkinActivity);
          renderBdFastClaimedList();
        } catch (error) {
          state.checkinActivityLoading = false;
          state.checkinActivityError = humanizeClientFetchErrorMessage(error, 'Could not load link activity.');
          renderBdFastClaimedList();
        }
      }

      function bdFastCheckinEventLabel(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var eventName = retailTextValue(safeRow.event_name, '');
        if (eventName === 'page_view') return 'Opened link';
        if (eventName === 'start_hair_story') return 'Started hair story';
        if (eventName === 'hair_story_saved') return 'Saved hair story';
        if (eventName === 'recommendation_snapshot_saved') return 'Saved recommendations';
        if (eventName === 'retail_add_one_succeeded') return 'Added one product';
        if (eventName === 'retail_add_routine_succeeded') return 'Added routine';
        if (eventName === 'appointment_rating_saved') return 'Saved rating';
        if (eventName === 'next_visit_booking_opened') return 'Opened next-visit booking';
        if (eventName === 'next_visit_booking_service_selected') return 'Selected service';
        if (eventName === 'next_visit_booking_question_answered') return 'Answered booking question';
        if (eventName === 'next_visit_booking_stylist_selected') return 'Selected stylist';
        if (eventName === 'next_visit_booking_range_selected') return 'Changed availability range';
        if (eventName === 'next_visit_booking_time_selected') return 'Selected time';
        if (eventName === 'next_visit_booking_auth_started') return 'Requested booking code';
        if (eventName === 'next_visit_booking_auth_verified') return 'Verified booking code';
        if (eventName === 'next_visit_booking_auth_reset') return 'Reset booking sign-in';
        if (eventName === 'next_visit_booking_waitlist_joined') return 'Joined waitlist';
        if (eventName === 'next_visit_booking_completed') return 'Booked next visit';
        if (eventName === 'next_visit_text_desk_clicked') return 'Texted desk from next visit';
        if (eventName === 'next_visit_open_full_clicked') return 'Opened full booking page';
        if (eventName === 'manage_text_desk_clicked') return 'Texted desk';
        if (eventName === 'cancelled_text_desk_clicked') return 'Texted desk from cancelled visit';
        if (eventName === 'manage_auth_started') return 'Requested management code';
        if (eventName === 'manage_auth_verified') return 'Verified management code';
        if (eventName === 'tip_module_opened') return 'Opened tipping';
        if (eventName === 'tip_venmo_clicked') return 'Opened tip link';
        return eventName ? eventName.replace(/_/g, ' ') : 'Link event';
      }

      function bdFastCheckinEventMeta(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        var bits = [];
        var pageName = retailTextValue(safeRow.page_name, '');
        var pageSection = retailTextValue(safeRow.page_section, '');
        var eventType = retailTextValue(safeRow.event_type, '');
        if (pageName) bits.push(pageName);
        if (pageSection) bits.push(pageSection);
        if (eventType) bits.push(eventType);
        return bits.join(' • ');
      }

      function bdFastCheckinActivityTabMarkup(selectedRow, state){
        var safeState = state && typeof state === 'object' ? state : {};
        if (safeState.checkinActivityLoading === true) {
          return '<div class="bd-fastDetailEmpty">Loading link activity…</div>';
        }
        if (safeState.checkinActivityError) {
          return '<div class="bd-fastDetailEmpty">' + escapeHtml(safeState.checkinActivityError) + '</div>';
        }
        var payload = safeState.checkinActivity && typeof safeState.checkinActivity === 'object' ? safeState.checkinActivity : {};
        var summary = payload.summary && typeof payload.summary === 'object' ? payload.summary : {};
        var rows = retailArray(payload.rows);
        var appointmentId = retailTextValue(selectedRow && selectedRow.appointment_id, '');
        var filteredRows = rows.filter(function(item){
          if (!appointmentId) return true;
          return retailTextValue(item && item.appointment_id, '') === appointmentId;
        });
        var summaryFacts = [
          bdFastDetailFact('Total events', String(Math.max(0, Number(summary.total_events || filteredRows.length) || 0))),
          bdFastDetailFact('Page views', String(Math.max(0, Number(summary.page_views || 0) || 0))),
          bdFastDetailFact('Retail adds', String(Math.max(0, Number(summary.retail_adds || 0) || 0))),
          bdFastDetailFact('Last activity', formatRecaptureDateTime(retailTextValue((retailArray(payload.by_appointment)[0] || {}).last_activity_at, '')))
        ].filter(Boolean).join('');
        var timelineMarkup = filteredRows.length
          ? '<div class="bd-fastTimelineList">' + filteredRows.slice(0, 80).map(function(item){
              var safeItem = item && typeof item === 'object' ? item : {};
              var metadata = safeItem.metadata && typeof safeItem.metadata === 'object' ? safeItem.metadata : {};
              var detailBits = [];
              var metaLine = bdFastCheckinEventMeta(safeItem);
              if (metaLine) detailBits.push(metaLine);
              if (retailTextValue(metadata.product_name, '')) detailBits.push('Product: ' + retailTextValue(metadata.product_name, ''));
              if (retailTextValue(metadata.handle, '')) detailBits.push('Handle: ' + retailTextValue(metadata.handle, ''));
              if (retailTextValue(metadata.rating_value, '')) detailBits.push('Rating: ' + retailTextValue(metadata.rating_value, ''));
              if (retailTextValue(metadata.selection_value, '')) detailBits.push('Selection: ' + retailTextValue(metadata.selection_value, ''));
              if (retailTextValue(metadata.answer_value, '')) detailBits.push('Answer: ' + retailTextValue(metadata.answer_value, ''));
              if (retailTextValue(metadata.question_key, '')) detailBits.push('Question: ' + retailTextValue(metadata.question_key, ''));
              if (retailTextValue(metadata.stylist_label, '')) detailBits.push('Stylist: ' + retailTextValue(metadata.stylist_label, ''));
              if (retailTextValue(metadata.range_label, '')) detailBits.push('Range: ' + retailTextValue(metadata.range_label, ''));
              if (retailTextValue(metadata.slot_label, '')) detailBits.push('Time: ' + retailTextValue(metadata.slot_label, ''));
              if (retailTextValue(metadata.tip_label, '')) detailBits.push('Tip: ' + retailTextValue(metadata.tip_label, ''));
              if (retailTextValue(metadata.waitlist_mode, '')) detailBits.push('Waitlist: ' + retailTextValue(metadata.waitlist_mode, ''));
              if (retailTextValue(metadata.preferred_date, '')) detailBits.push('Date: ' + retailTextValue(metadata.preferred_date, ''));
              return ''
                + '<article class="bd-fastTimelineItem">'
                +   '<div class="bd-fastTimelineTop"><strong>' + escapeHtml(bdFastCheckinEventLabel(safeItem)) + '</strong><span>' + escapeHtml(formatRecaptureDateTime(retailTextValue(safeItem.occurred_at, '')) || 'Unknown time') + '</span></div>'
                +   (detailBits.length ? '<div class="bd-fastTimelineMeta">' + escapeHtml(detailBits.join(' • ')) + '</div>' : '')
                +   (retailTextValue(safeItem.source_url, '') ? '<div class="bd-fastTimelineSub">' + escapeHtml(retailTextValue(safeItem.source_url, '')) + '</div>' : '')
                + '</article>';
            }).join('') + '</div>'
          : '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No tracked link interactions yet for this guest.</div>';
        return ''
          + '<div class="bd-fastDetailSection">'
          +   (summaryFacts ? '<div class="bd-fastDetailFacts">' + summaryFacts + '</div>' : '')
          +   bdFastExpandableSectionMarkup('Interaction timeline', filteredRows.length, timelineMarkup, '')
          + '</div>';
      }

      function bdFastDetailTabsMarkup(selectedRow, state, detailMarkup){
        var safeState = state && typeof state === 'object' ? state : {};
        var rowKey = retailTextValue(selectedRow && selectedRow.opportunity_key, '');
        var activeTab = bdFastDetailActiveTab(safeState);
        var linkActivityMarkup = bdFastCheckinActivityTabMarkup(selectedRow, safeState);
        var tabs = [
          { key: 'overview', label: 'Overview' },
          { key: 'link_activity', label: 'Link activity' }
        ];
        return ''
          + '<div class="bd-fastDetailTabs" role="tablist" aria-label="Client detail sections">'
          +   tabs.map(function(tab){
                var active = activeTab === tab.key;
                return '<button class="bd-fastTab' + (active ? ' is-active' : '') + '" type="button" role="tab" aria-selected="' + (active ? 'true' : 'false') + '" data-bd-fast-detail-tab="' + escapeHtml(tab.key) + '" data-bd-fast-row-key="' + escapeHtml(rowKey) + '">' + escapeHtml(tab.label) + '</button>';
              }).join('')
          + '</div>'
          + '<div class="bd-fastDetailTabPanel">'
          +   (activeTab === 'link_activity' ? linkActivityMarkup : detailMarkup)
          + '</div>';
      }

      function bdFastDetailFact(label, value){
        var text = retailTextValue(value, '');
        if (!text) return '';
        return '<div class="bd-fastDetailFact"><span>' + escapeHtml(label) + '</span><strong>' + escapeHtml(text) + '</strong></div>';
      }

      function bdFastRetailProductJsonUrl(shopifyUrl){
        var raw = retailTextValue(shopifyUrl, '');
        if (!raw) return '';
        var base = raw.replace(/\/+$/, '');
        if (!base) return '';
        return base + '.js';
      }

      function bdFastRetailImageFromProductPayload(data){
        var safeData = data && typeof data === 'object' ? data : {};
        var directUrl = retailTextValue(
          safeData && (
            safeData.featured_image
            || safeData.image
            || (safeData.product && safeData.product.featured_image)
            || (safeData.product && safeData.product.image)
          ),
          ''
        );
        if (directUrl) return directUrl;
        var featuredMedia = safeData && safeData.product && safeData.product.featured_media && typeof safeData.product.featured_media === 'object'
          ? safeData.product.featured_media
          : {};
        var previewImage = featuredMedia && featuredMedia.preview_image && typeof featuredMedia.preview_image === 'object'
          ? featuredMedia.preview_image
          : {};
        var previewUrl = retailTextValue(previewImage.src || previewImage.url, '');
        if (previewUrl) return previewUrl;
        var images = Array.isArray(safeData.images)
          ? safeData.images
          : Array.isArray(safeData.product && safeData.product.images)
            ? safeData.product.images
            : [];
        if (images.length) {
          var firstImage = images[0] && typeof images[0] === 'object' ? images[0] : {};
          var firstImageUrl = retailTextValue(firstImage.src || firstImage.url, '');
          if (firstImageUrl) return firstImageUrl;
          if (typeof images[0] === 'string' && retailTextValue(images[0], '')) return retailTextValue(images[0], '');
        }
        return '';
      }

      function bdFastExpandableSectionMarkup(title, count, bodyMarkup, emptyMarkup, options){
        var opts = options && typeof options === 'object' ? options : {};
        var normalizedTitle = retailTextValue(title, 'Details');
        var numericCount = Math.max(0, Number(count || 0) || 0);
        return ''
          + '<details class="bd-fastExpandableSection"' + (opts.openByDefault ? ' open' : '') + '>'
          +   '<summary><span class="bd-fastExpandableTitle">' + escapeHtml(normalizedTitle) + '</span>' + (numericCount > 0 ? '<span class="bd-fastExpandableCount">' + escapeHtml(String(numericCount)) + '</span>' : '') + '</summary>'
          +   '<div class="bd-fastExpandableBody">'
          +     (bodyMarkup || emptyMarkup || '')
          +   '</div>'
          + '</details>';
      }

      async function bdFastEnsureRetailImage(shopifyUrl){
        var key = retailTextValue(shopifyUrl, '');
        if (!key || bdFastRetailImageByUrl[key] || bdFastRetailImageLoadingByUrl[key]) return;
        var jsonUrl = bdFastRetailProductJsonUrl(key);
        if (!jsonUrl) return;
        bdFastRetailImageLoadingByUrl[key] = true;
        try {
          var response = await fetch(jsonUrl, { credentials: 'same-origin' });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          var imageUrl = bdFastRetailImageFromProductPayload(data);
          if (imageUrl) {
            bdFastRetailImageByUrl[key] = imageUrl;
            renderBdFastQueue();
          }
        } catch (_error) {
        } finally {
          delete bdFastRetailImageLoadingByUrl[key];
        }
      }

      function bdFastDetailAppointmentRowMarkup(item){
        var safeItem = item && typeof item === 'object' ? item : {};
        var services = retailArray(safeItem.service_names).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        var staff = retailArray(safeItem.staff_names).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        return ''
          + '<article class="bd-fastTimelineItem">'
          +   '<div class="bd-fastTimelineTop"><strong>' + escapeHtml(bdDateText(safeItem.start_at) || 'Unknown date') + '</strong><span>' + escapeHtml(retailTextValue(safeItem.state, 'unknown')) + '</span></div>'
          +   '<div class="bd-fastTimelineMeta">' + escapeHtml(services.join(', ') || 'No service names') + '</div>'
          +   (staff.length ? '<div class="bd-fastTimelineSub">' + escapeHtml(staff.join(', ')) + '</div>' : '')
          + '</article>';
      }

      function bdFastDetailPurchaseRowMarkup(item){
        var safeItem = item && typeof item === 'object' ? item : {};
        var amount = Number(safeItem.total_amount || 0);
        var amountLabel = Number.isFinite(amount) && amount > 0 ? ('$' + amount.toFixed(2)) : '';
        var shopifyUrl = retailTextValue(safeItem.shopify_url, '');
        var directImageUrl = retailTextValue(safeItem.image_url, '');
        var imageUrl = directImageUrl || (shopifyUrl ? retailTextValue(bdFastRetailImageByUrl[shopifyUrl], '') : '');
        var sourceLabel = retailTextValue(safeItem.source, '').toLowerCase() === 'shopify'
          ? (retailTextValue(safeItem.order_name, '') || 'Shopify')
          : '';
        if (!directImageUrl && shopifyUrl && !imageUrl) bdFastEnsureRetailImage(shopifyUrl);
        return ''
          + '<article class="bd-fastTimelineItem bd-fastTimelineItem--purchase">'
          +   (imageUrl
                ? '<div class="bd-fastPurchaseThumbWrap"><img class="bd-fastPurchaseThumb" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(retailTextValue(safeItem.product_name, 'Retail item')) + '"></div>'
                : '<div class="bd-fastPurchaseThumbWrap bd-fastPurchaseThumbWrap--placeholder" aria-hidden="true"></div>')
          +   '<div class="bd-fastPurchaseBody">'
          +     '<div class="bd-fastTimelineTop"><strong>' + escapeHtml(retailTextValue(safeItem.product_name, 'Retail item')) + '</strong><span>' + escapeHtml(bdDateText(safeItem.completed_at) || retailTextValue(safeItem.status, '')) + '</span></div>'
          +     '<div class="bd-fastTimelineMeta">' + escapeHtml('Qty ' + String(Math.max(1, Number(safeItem.quantity || 1) || 1)) + (amountLabel ? ' · ' + amountLabel : '')) + '</div>'
          +     (sourceLabel ? '<div class="bd-fastTimelineSub">' + escapeHtml(sourceLabel) + '</div>' : '')
          +   '</div>'
          + '</article>';
      }

      function bdFastDetailCadenceRowMarkup(item){
        var safeItem = item && typeof item === 'object' ? item : {};
        var cadenceDays = Math.max(0, Number(safeItem.cadence_days || 0) || 0);
        var sampleSize = Math.max(0, Number(safeItem.cadence_sample_size || 0) || 0);
        var daysOverdue = Math.max(0, Number(safeItem.days_overdue || 0) || 0);
        var dueAtText = retailTextValue(safeItem.due_at, '');
        var dueStateClass = '';
        if (daysOverdue > 0) {
          dueStateClass = ' bd-fastCadenceItem--overdue';
        } else if (dueAtText) {
          var dueAtDate = new Date(dueAtText);
          var nowDate = new Date();
          var dueAtTime = dueAtDate.getTime();
          if (Number.isFinite(dueAtTime)) {
            var diffDays = Math.ceil((dueAtTime - nowDate.getTime()) / 86400000);
            dueStateClass = diffDays <= 0 ? ' bd-fastCadenceItem--due' : ' bd-fastCadenceItem--within';
          }
        }
        var titleBits = [retailTextValue(safeItem.label, retailTextValue(safeItem.family_label, 'Visit'))];
        if (sampleSize > 0) titleBits[0] += ' (' + String(sampleSize) + ')';
        if (cadenceDays > 0) titleBits.push('every ' + String(cadenceDays) + ' days');
        var metaBits = [];
        if (daysOverdue > 0) metaBits.push(String(daysOverdue) + ' days overdue');
        else if (retailTextValue(safeItem.due_at, '')) metaBits.push('Due ' + bdDateText(safeItem.due_at));
        return ''
          + '<article class="bd-fastCadenceItem' + dueStateClass + '">'
          +   '<div class="bd-fastTimelineTop"><strong>' + escapeHtml(titleBits.join(' ')) + '</strong></div>'
          +   (retailTextValue(safeItem.last_visit_at, '') ? '<div class="bd-fastTimelineMeta">Last service date: ' + escapeHtml(bdDateText(safeItem.last_visit_at)) + '</div>' : '')
          +   (metaBits.length ? '<div class="bd-fastTimelineSub">' + escapeHtml(metaBits.join(' · ')) + '</div>' : '')
          + '</article>';
      }

      function bdFastDetailChipListMarkup(values, tone){
        var items = retailArray(values).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        if (!items.length) {
          return '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">None saved.</div>';
        }
        return '<div class="retail-cardChips">' + retailChipsMarkup(items, tone) + '</div>';
      }

      function bdFastRecommendationSnapshotSectionMarkup(snapshot){
        var safeSnapshot = snapshot && typeof snapshot === 'object' ? snapshot : null;
        if (!safeSnapshot) {
          return '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No saved product recommendation snapshot on the recent appointment.</div>';
        }
        var topFacts = [
          safeSnapshot.consultGoal ? bdFastDetailFact('Goal', safeSnapshot.consultGoal) : '',
          safeSnapshot.consultHomeHelp ? bdFastDetailFact('Home help', safeSnapshot.consultHomeHelp) : '',
          safeSnapshot.recommendedCount > 0 ? bdFastDetailFact('Recommended', String(safeSnapshot.recommendedCount)) : '',
          safeSnapshot.missingCount > 0 ? bdFastDetailFact('Missing', String(safeSnapshot.missingCount)) : ''
        ].filter(Boolean).join('');
        return ''
          + (topFacts ? '<div class="bd-fastDetailFacts">' + topFacts + '</div>' : '')
          + '<div class="bd-fastDetailStack">'
          +   '<div><span class="bd-fastDetailMiniLabel">Consult concerns</span>' + bdFastDetailChipListMarkup(safeSnapshot.consultConcerns, 'history') + '</div>'
          +   '<div><span class="bd-fastDetailMiniLabel">Consult routine</span>' + bdFastDetailChipListMarkup(safeSnapshot.consultRoutine, 'accent') + '</div>'
          +   '<div><span class="bd-fastDetailMiniLabel">Recommended products</span>' + bdFastDetailChipListMarkup(safeSnapshot.recommendedProducts) + '</div>'
          +   '<div><span class="bd-fastDetailMiniLabel">Missing routine pieces</span>' + bdFastDetailChipListMarkup(safeSnapshot.missingProducts) + '</div>'
          +   '<div><span class="bd-fastDetailMiniLabel">Purchased from routine</span>' + bdFastDetailChipListMarkup(safeSnapshot.purchasedProducts, 'success') + '</div>'
          + '</div>';
      }

      function bdFastTagHistory(detail){
        var byTag = new Map();
        retailArray(detail && detail.appointments).forEach(function(appointment){
          var tags = bdFastStrategyAppointmentTags(appointment);
          if (!tags.length) return;
          var dateLabel = bdDateText(appointment && appointment.start_at) || 'Unknown date';
          tags.forEach(function(tag){
            var key = retailTextValue(tag, '');
            if (!key) return;
            if (!byTag.has(key)) byTag.set(key, []);
            var dates = byTag.get(key);
            if (dates.indexOf(dateLabel) === -1) dates.push(dateLabel);
          });
        });
        return Array.from(byTag.entries()).map(function(entry){
          return {
            tag: entry[0],
            dates: retailArray(entry[1])
          };
        }).sort(function(left, right){
          return retailTextValue(left && left.tag, '').localeCompare(retailTextValue(right && right.tag, ''));
        });
      }

      function bdFastTagHistoryMarkup(items){
        var rows = retailArray(items);
        if (!rows.length) {
          return '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No appointment tags found in the loaded appointment history.</div>';
        }
        return '<div class="bd-fastTimelineList">' + rows.map(function(item){
          return ''
            + '<article class="bd-fastTimelineItem">'
            +   '<div class="bd-fastTimelineTop"><strong>' + escapeHtml(retailTextValue(item && item.tag, 'Tag')) + '</strong></div>'
            +   '<div class="bd-fastTimelineSub">' + escapeHtml(retailArray(item && item.dates).join(' • ')) + '</div>'
            + '</article>';
        }).join('') + '</div>';
      }

      function bdFastRecommendationHistory(detail){
        return retailArray(detail && detail.appointments).map(function(appointment){
          var snapshot = bdFastRecommendationSnapshot(appointment);
          if (!snapshot) return null;
          return {
            appointment: appointment,
            snapshot: snapshot
          };
        }).filter(Boolean).sort(function(left, right){
          return retailTextValue(right && right.appointment && right.appointment.start_at, '').localeCompare(retailTextValue(left && left.appointment && left.appointment.start_at, ''));
        });
      }

      function bdFastRecommendationHistoryMarkup(items){
        var rows = retailArray(items);
        if (!rows.length) {
          return '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No saved product recommendation snapshots found in the loaded appointment history.</div>';
        }
        return '<div class="bd-fastTimelineList">' + rows.map(function(item){
          var appointment = item && item.appointment && typeof item.appointment === 'object' ? item.appointment : {};
          var snapshot = item && item.snapshot && typeof item.snapshot === 'object' ? item.snapshot : null;
          var services = retailArray(appointment && appointment.service_names).map(function(value){
            return retailTextValue(value, '');
          }).filter(Boolean);
          return ''
            + '<article class="bd-fastTimelineItem">'
            +   '<div class="bd-fastTimelineTop"><strong>' + escapeHtml(bdDateText(appointment && appointment.start_at) || 'Unknown date') + '</strong><span>' + escapeHtml(services.slice(0, 2).join(', ') || retailTextValue(snapshot && snapshot.consultServiceLabel, 'Recommendation')) + '</span></div>'
            +   bdFastRecommendationSnapshotSectionMarkup(snapshot)
            + '</article>';
        }).join('') + '</div>';
      }

      function bdFastDetailContentMarkup(selectedRow, state){
        var selectedKey = retailTextValue(selectedRow && selectedRow.opportunity_key, '');
        if (!selectedRow) {
          return '<div class="bd-fastDetailEmpty">Select a client to view cadence, appointment history, and retail purchases.</div>';
        }
        if (!state || state.loading === true || bdFastDetailLoadingKey === selectedKey) {
          return '<div class="bd-fastDetailEmpty">Loading client history…</div>';
        }
        if (state.error) {
          return '<div class="bd-fastDetailEmpty">' + escapeHtml(state.error) + '</div>';
        }
        var detailResult = state.detail && typeof state.detail === 'object' ? state.detail : {};
        var detail = detailResult.detail && typeof detailResult.detail === 'object' ? detailResult.detail : {};
        var row = detailResult.row && typeof detailResult.row === 'object' ? detailResult.row : selectedRow;
        var familyCadences = retailArray(detail.family_cadences);
        var appointments = retailArray(detail.appointments);
        var purchases = retailArray(detail.purchases);
        var shopifyPurchases = retailArray(detail.shopify_purchases);
        var recentAppointment = bdFastStrategyRecentAppointment(detail);
        var detailSourceAppointment = bdFastDetailAppointmentWithRichContext(detail) || recentAppointment;
        var appointmentTags = bdFastTagHistory(detail);
        var recommendationHistory = bdFastRecommendationHistory(detail);
        var recommendationSnapshot = bdFastRecommendationSnapshot(detailSourceAppointment);
        var familyCadenceMarkup = familyCadences.length
          ? '<div class="bd-fastTimelineList">' + familyCadences.slice(0, 12).map(bdFastDetailCadenceRowMarkup).join('') + '</div>'
          : '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No calculated family cadence yet.</div>';
        var appointmentsMarkup = appointments.length
          ? '<div class="bd-fastTimelineList">' + appointments.slice(0, 24).map(bdFastDetailAppointmentRowMarkup).join('') + '</div>'
          : '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No appointment history found.</div>';
        var purchasesMarkup = purchases.length
          ? '<div class="bd-fastTimelineList">' + purchases.slice(0, 24).map(bdFastDetailPurchaseRowMarkup).join('') + '</div>'
          : '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No retail purchases found.</div>';
        var shopifyPurchasesMarkup = shopifyPurchases.length
          ? '<div class="bd-fastTimelineList">' + shopifyPurchases.slice(0, 24).map(bdFastDetailPurchaseRowMarkup).join('') + '</div>'
          : '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No Shopify purchases found.</div>';
        var overviewMarkup = ''
          + '<div class="bd-fastDetailSection">'
          +   bdFastExpandableSectionMarkup('Appointment tags', appointmentTags.length, bdFastTagHistoryMarkup(appointmentTags), '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No appointment tags found in the loaded appointment history.</div>')
          +   bdFastExpandableSectionMarkup('Product recommendations', recommendationHistory.length, bdFastRecommendationHistoryMarkup(recommendationHistory), recommendationSnapshot ? bdFastRecommendationSnapshotSectionMarkup(recommendationSnapshot) : '')
          +   bdFastExpandableSectionMarkup('Family cadence', familyCadences.length, familyCadenceMarkup, '')
          +   bdFastExpandableSectionMarkup('Appointments', appointments.length, appointmentsMarkup)
          +   bdFastExpandableSectionMarkup('Salon retail', purchases.length, purchasesMarkup)
          +   bdFastExpandableSectionMarkup('Shopify orders', shopifyPurchases.length, shopifyPurchasesMarkup)
          + '</div>';
        return bdFastDetailTabsMarkup(selectedRow, state, overviewMarkup);
      }

      function bdFastStrategyTimelineSignal(summaryLabel, value){
        var safeLabel = retailTextValue(summaryLabel, '');
        var safeValue = retailTextValue(value, '');
        if (!safeLabel || !safeValue) return '';
        return '<div class="bd-fastStrategySignal"><span>' + escapeHtml(safeLabel) + '</span><strong>' + escapeHtml(safeValue) + '</strong></div>';
      }

      function bdFastStrategyPrimaryCadenceItem(detail){
        var familyCadences = retailArray(detail && detail.family_cadences);
        if (!familyCadences.length) return null;
        var sorted = familyCadences.slice().sort(function(a, b){
          var aOverdue = Math.max(0, Number(a && a.days_overdue) || 0);
          var bOverdue = Math.max(0, Number(b && b.days_overdue) || 0);
          if (aOverdue !== bOverdue) return bOverdue - aOverdue;
          var aDueDiff = bdFastDateDiffFromToday(a && a.due_at);
          var bDueDiff = bdFastDateDiffFromToday(b && b.due_at);
          var safeADue = aDueDiff === null ? 999999 : aDueDiff;
          var safeBDue = bDueDiff === null ? 999999 : bDueDiff;
          if (safeADue !== safeBDue) return safeADue - safeBDue;
          return (Math.max(0, Number(b && b.cadence_sample_size) || 0) - Math.max(0, Number(a && a.cadence_sample_size) || 0));
        });
        return sorted[0] || null;
      }

      function bdFastStrategyRecentAppointment(detail){
        return retailArray(detail && detail.appointments).find(function(item){
          var state = retailTextValue(item && item.state, '').toLowerCase();
          return state === 'closed' || state === 'final';
        }) || null;
      }

      function bdFastDetailAppointmentWithRichContext(detail){
        return retailArray(detail && detail.appointments).find(function(item){
          if (!item || typeof item !== 'object') return false;
          var tags = bdFastStrategyAppointmentTags(item);
          if (tags.length) return true;
          return !!bdFastRecommendationSnapshot(item);
        }) || null;
      }

      function bdFastStrategyRecentRetailPurchase(detail){
        return retailArray(detail && detail.purchases)[0] || null;
      }

      function bdFastStrategyTagValues(value){
        if (Array.isArray(value)) {
          return value.map(function(entry){
            if (typeof entry === 'string') return retailTextValue(entry, '');
            if (entry && typeof entry === 'object') {
              return retailTextValue(entry.name || entry.label || entry.title || entry.tag, '');
            }
            return '';
          }).filter(Boolean);
        }
        if (typeof value === 'string') {
          return value.split(',').map(function(entry){
            return retailTextValue(entry, '');
          }).filter(Boolean);
        }
        if (value && typeof value === 'object') {
          var single = retailTextValue(value.name || value.label || value.title || value.tag, '');
          return single ? [single] : [];
        }
        return [];
      }

      function bdFastStrategyAppointmentTags(appointment){
        var appointmentData = appointment && appointment.appointment_data && typeof appointment.appointment_data === 'object'
          ? appointment.appointment_data
          : {};
        return []
          .concat(bdFastStrategyTagValues(appointment && appointment.tags))
          .concat(bdFastStrategyTagValues(appointmentData && appointmentData.tags))
          .concat(bdFastStrategyTagValues(appointmentData && appointmentData.tag_names))
          .concat(bdFastStrategyTagValues(appointmentData && appointmentData.appointment_tags))
          .filter(function(value, index, source){
            return source.indexOf(value) === index;
          });
      }

      function bdFastSnapshotStringArray(value){
        if (Array.isArray(value)) {
          return value.map(function(entry){
            if (typeof entry === 'string') return retailTextValue(entry, '');
            if (entry && typeof entry === 'object') {
              return retailTextValue(entry.name || entry.label || entry.title || entry.handle || entry.product_handle, '');
            }
            return '';
          }).filter(Boolean);
        }
        var single = retailTextValue(value, '');
        return single ? [single] : [];
      }

      function bdFastSnapshotProductNames(value){
        return retailArray(value).map(function(entry){
          if (typeof entry === 'string') return retailHandleLabel(entry);
          if (entry && typeof entry === 'object') {
            return retailDisplayProductName(entry, retailTextValue(entry.handle || entry.product_handle, 'Product'));
          }
          return '';
        }).filter(Boolean);
      }

      function bdFastRecommendationSnapshot(appointment){
        var appointmentData = appointment && appointment.appointment_data && typeof appointment.appointment_data === 'object'
          ? appointment.appointment_data
          : {};
        var snapshot = appointmentData && appointmentData.recommendation_snapshot && typeof appointmentData.recommendation_snapshot === 'object'
          ? appointmentData.recommendation_snapshot
          : null;
        if (!snapshot) return null;
        var missingProducts = bdFastSnapshotProductNames(snapshot.missingProducts || snapshot.missing_products || snapshot.missing_product_details);
        var recommendedProducts = bdFastSnapshotProductNames(snapshot.recommendedProducts || snapshot.recommended_product_details);
        var purchasedProducts = bdFastSnapshotProductNames(snapshot.purchasedProducts || snapshot.purchased_product_details);
        var routineItems = retailArray(snapshot.routine_items).map(function(item){
          var safeItem = item && typeof item === 'object' ? item : {};
          return {
            name: retailDisplayProductName({
              handle: retailTextValue(safeItem.handle, ''),
              name: retailTextValue(safeItem.name, '')
            }, retailTextValue(safeItem.handle, 'Product')),
            reason: retailTextValue(safeItem.reason, ''),
            role: retailTextValue(safeItem.role || safeItem.routine_slot, ''),
            matchedSignals: bdFastSnapshotStringArray(safeItem.matched_signals)
          };
        }).filter(function(item){
          return retailTextValue(item && item.name, '');
        });
        var upgradeItems = retailArray(snapshot.upgrade_items).map(function(item){
          var safeItem = item && typeof item === 'object' ? item : {};
          return {
            name: retailDisplayProductName({
            handle: retailTextValue(safeItem.handle, ''),
            name: retailTextValue(safeItem.name, '')
          }, retailTextValue(safeItem.handle, 'Product')),
            reason: retailTextValue(safeItem.reason, ''),
            role: retailTextValue(safeItem.role || safeItem.routine_slot, ''),
            matchedSignals: bdFastSnapshotStringArray(safeItem.matched_signals)
          };
        }).filter(function(item){
          return retailTextValue(item && item.name, '');
        });
        var missingHandles = bdFastSnapshotStringArray(snapshot.missing_product_handles || snapshot.missing_handles);
        var recommendedHandles = bdFastSnapshotStringArray(snapshot.all_recommended_handles || snapshot.recommended_product_handles || snapshot.recommended_handles);
        var purchasedHandles = bdFastSnapshotStringArray(snapshot.purchased_product_handles || snapshot.purchased_handles);
        return {
          missingProducts: missingProducts.length ? missingProducts : missingHandles.map(retailHandleLabel).filter(Boolean),
          recommendedProducts: recommendedProducts.length ? recommendedProducts : recommendedHandles.map(retailHandleLabel).filter(Boolean),
          purchasedProducts: purchasedProducts.length ? purchasedProducts : purchasedHandles.map(retailHandleLabel).filter(Boolean),
          routineItems: routineItems.map(function(item){ return item.name; }),
          routineItemDetails: routineItems,
          upgradeItems: upgradeItems.map(function(item){ return item.name; }),
          upgradeItemDetails: upgradeItems,
          consultConcerns: bdFastSnapshotStringArray(snapshot.consult_concerns || snapshot.concerns),
          consultGoal: retailTextValue(snapshot.consult_goal || snapshot.goal, ''),
          consultHomeHelp: retailTextValue(snapshot.consult_home_help || snapshot.home_help, ''),
          consultRoutine: bdFastSnapshotStringArray(snapshot.consult_routine || snapshot.routine),
          consultServiceLabel: retailTextValue(snapshot.consult_service_label || snapshot.service_label, ''),
          summaryCopy: retailTextValue(snapshot.ai_summary_copy, ''),
          voiceLabel: retailTextValue(snapshot.ai_voice && snapshot.ai_voice.label, ''),
          voiceBody: retailTextValue(snapshot.ai_voice && snapshot.ai_voice.body, ''),
          routines: bdFastSnapshotStringArray(snapshot.routines),
          traits: bdFastSnapshotStringArray(snapshot.traits),
          serviceNames: bdFastSnapshotStringArray(snapshot.service_names),
          recommendedCount: Math.max(0, Number(snapshot.recommended_count || recommendedHandles.length || recommendedProducts.length) || 0),
          purchasedCount: Math.max(0, Number(snapshot.purchased_count || purchasedHandles.length || purchasedProducts.length) || 0),
          missingCount: Math.max(0, Number(snapshot.missing_count || missingHandles.length || missingProducts.length) || 0)
        };
      }

      function bdFastRetailRoutineLead(snapshot){
        var safeSnapshot = snapshot && typeof snapshot === 'object' ? snapshot : {};
        var concerns = retailArray(safeSnapshot.consultConcerns).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        if (concerns.length) return ' especially for ' + concerns.slice(0, 2).join(' and ').toLowerCase();
        var goal = retailTextValue(safeSnapshot.consultGoal, '');
        if (goal) return ' to support your ' + goal.toLowerCase();
        return '';
      }

      function bdFastRetailRoutineProductPhrase(snapshot){
        var safeSnapshot = snapshot && typeof snapshot === 'object' ? snapshot : {};
        var missing = retailArray(safeSnapshot.missingProducts).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        var recommended = retailArray(safeSnapshot.recommendedProducts).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        var routine = retailArray(safeSnapshot.consultRoutine).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        if (missing.length === 1) return missing[0];
        if (missing.length > 1) return missing.slice(0, 2).join(' and ');
        if (recommended.length === 1) return recommended[0];
        if (recommended.length > 1) return recommended.slice(0, 2).join(' and ');
        if (routine.length === 1) return routine[0] + ' routine';
        if (routine.length > 1) return routine.slice(0, 2).join(' and ') + ' routine';
        return '';
      }

      function bdFastStrategyDaysSince(dateValue){
        var diff = bdFastDateDiffFromToday(dateValue);
        if (diff === null) return null;
        return Math.max(0, 0 - diff);
      }

      function bdFastRetailRecommendationContext(services, tags, purchaseName){
        var joined = String(retailArray(services).join(' ') + ' ' + retailArray(tags).join(' ') + ' ' + retailTextValue(purchaseName, '')).toLowerCase();
        if (!joined) {
          return {
            focus: 'home-care support',
            productFamily: 'an easy home-care staple',
            sms: 'Recommend one easy home-care product tied to their upcoming visit.'
          };
        }
        if (joined.indexOf('single process') !== -1 || joined.indexOf('gloss') !== -1 || joined.indexOf('highlight') !== -1 || joined.indexOf('dimensional') !== -1 || joined.indexOf('blonde') !== -1 || joined.indexOf('color') !== -1) {
          return {
            focus: 'color-safe care',
            productFamily: 'color-safe shampoo + conditioner',
            sms: 'Recommend color-protecting home care that supports the result of their last color service.'
          };
        }
        if (joined.indexOf('keratin') !== -1 || joined.indexOf('smoothfiller') !== -1 || joined.indexOf('smoothing') !== -1) {
          return {
            focus: 'smoothing maintenance',
            productFamily: 'a smoothing wash + treatment pair',
            sms: 'Recommend smoothing-support home care that helps extend the treatment result.'
          };
        }
        if (joined.indexOf('extension') !== -1) {
          return {
            focus: 'extension-safe care',
            productFamily: 'extension-safe maintenance care',
            sms: 'Recommend extension-safe maintenance products tied to preserving wear and softness.'
          };
        }
        if (joined.indexOf('curl') !== -1 || joined.indexOf('texture') !== -1) {
          return {
            focus: 'curl support',
            productFamily: 'curl moisture + styling support',
            sms: 'Recommend styling and moisture support that helps them keep the same texture result at home.'
          };
        }
        if (joined.indexOf('scalp') !== -1 || joined.indexOf('thinning') !== -1 || joined.indexOf('shed') !== -1) {
          return {
            focus: 'scalp care',
            productFamily: 'a scalp-support treatment',
            sms: 'Recommend a scalp-support product tied to the concern already visible in their visit history.'
          };
        }
        if (joined.indexOf('blowdry') !== -1 || joined.indexOf('blowout') !== -1 || joined.indexOf('blow dry') !== -1) {
          return {
            focus: 'styling support',
            productFamily: 'a styling or finishing product',
            sms: 'Recommend one styling or finish product that helps recreate the in-salon blowdry result.'
          };
        }
        return {
          focus: 'home-care support',
          productFamily: 'a home-care support product',
          sms: 'Recommend one home-care product that fits the service pattern on their recent visits.'
        };
      }

      function bdFastRetailRecommendedProductText(recentPurchaseName, recentRetailDaysSince, retailContext){
        var purchaseName = retailTextValue(recentPurchaseName, '');
        if (purchaseName && recentRetailDaysSince !== null && recentRetailDaysSince >= 45) {
          return 'Replenish ' + purchaseName;
        }
        if (purchaseName) {
          return 'Pair with ' + purchaseName;
        }
        return 'Recommend ' + retailTextValue(retailContext && retailContext.productFamily, 'a home-care product');
      }

      function bdFastStrategyGuestFirstName(row){
        var guestName = retailTextValue(row && row.guest_name, '').trim();
        if (!guestName) return 'there';
        return guestName.split(/\s+/)[0] || 'there';
      }

      function bdFastStrategyStylistName(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var snapshot = safeSummary.recommendationSnapshot && typeof safeSummary.recommendationSnapshot === 'object'
          ? safeSummary.recommendationSnapshot
          : {};
        var recentAppointment = safeSummary.recentAppointment && typeof safeSummary.recentAppointment === 'object'
          ? safeSummary.recentAppointment
          : {};
        var voiceLabel = retailTextValue(snapshot.voiceLabel, '').trim();
        if (voiceLabel) {
          voiceLabel = voiceLabel.replace(/^recommended by\s+/i, '').trim();
          if (voiceLabel) return voiceLabel;
        }
        var staffNames = retailArray(recentAppointment.staff_names).map(function(value){
          return retailTextValue(value, '').trim();
        }).filter(Boolean);
        if (staffNames.length) return staffNames[0];
        return '';
      }

      function bdFastStrategyStylistFirstName(summary){
        var stylistName = bdFastStrategyStylistName(summary);
        if (!stylistName) return '';
        return stylistName.split(/\s+/)[0] || stylistName;
      }

      function bdFastServiceLabelForSms(services){
        var list = retailArray(services).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        if (!list.length) return '';
        var normalized = list.map(function(value){
          return {
            raw: value,
            lower: retailTextValue(value, '').toLowerCase()
          };
        });
        var colorLabels = normalized.filter(function(item){
          return /(color|colour|gloss|toner|single process|single-process|double process|retouch|root touch|highlight|lowlight|balayage|blonding|bleach|platinum|dimensional)/.test(item.lower);
        }).map(function(item){ return item.raw; });
        if (colorLabels.length) return colorLabels.slice(0, 2).join(' and ');
        var smoothingLabels = normalized.filter(function(item){
          return /(keratin|brazilian|smoothing|relaxer|magic sleek|magicsleek)/.test(item.lower);
        }).map(function(item){ return item.raw; });
        if (smoothingLabels.length) return smoothingLabels[0];
        var extensionLabels = normalized.filter(function(item){
          return /(extension|move up|move-up|weft|tape-in|tape in|k-tip|keratin tip|hand tied|hand-tied)/.test(item.lower);
        }).map(function(item){ return item.raw; });
        if (extensionLabels.length) return extensionLabels[0];
        var haircutLabels = normalized.filter(function(item){
          return /(haircut|cut|trim|bang|shape|layers|bob|pixie|fade|barber|clipper)/.test(item.lower);
        }).map(function(item){ return item.raw; });
        if (haircutLabels.length) return haircutLabels[0];
        var blowdryLabels = normalized.filter(function(item){
          return /(blowout|blow dry|blowdry|style|styling)/.test(item.lower);
        }).map(function(item){ return item.raw; });
        if (blowdryLabels.length && blowdryLabels.length === list.length) return blowdryLabels.slice(0, 2).join(' and ');
        return list.slice(0, 1).join('');
      }

      function bdFastRetailPhraseList(values, maxItems){
        var items = retailArray(values).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean).slice(0, Math.max(1, Number(maxItems) || 2));
        if (!items.length) return '';
        if (items.length === 1) return items[0];
        if (items.length === 2) return items[0] + ' and ' + items[1];
        return items.slice(0, -1).join(', ') + ', and ' + items[items.length - 1];
      }

      function bdFastRetailConcernPhrase(snapshot){
        var safeSnapshot = snapshot && typeof snapshot === 'object' ? snapshot : {};
        var concerns = retailArray(safeSnapshot.consultConcerns).map(function(value){
          return retailTextValue(value, '').replace(/-/g, ' ');
        }).filter(Boolean);
        if (!concerns.length) return '';
        if (concerns.length === 1) return concerns[0];
        if (concerns.length === 2) return concerns[0] + ' and ' + concerns[1];
        return concerns.slice(0, 2).join(', ') + ', and ' + concerns[2];
      }

      function bdFastRetailRoutineContextPhrase(snapshot){
        var safeSnapshot = snapshot && typeof snapshot === 'object' ? snapshot : {};
        var routines = retailArray(safeSnapshot.consultRoutine.length ? safeSnapshot.consultRoutine : safeSnapshot.routines).map(function(value){
          return retailTextValue(value, '').replace(/-/g, ' ');
        }).filter(Boolean);
        var traits = retailArray(safeSnapshot.traits).map(function(value){
          return retailTextValue(value, '').replace(/-/g, ' ');
        }).filter(Boolean);
        var bits = [];
        if (routines.length) bits.push(routines[0]);
        if (traits.length) bits.push(traits[0]);
        return bits.join(' ');
      }

      function bdFastRetailReasonSnippet(reason){
        var text = retailTextValue(reason, '');
        if (!text) return '';
        text = text.replace(/\s+/g, ' ').trim();
        var sentence = text.split(/(?<=[.!?])\s+/)[0] || text;
        sentence = sentence.replace(/\.$/, '');
        return sentence;
      }

      function bdFastRetailRoutineExplanation(snapshot){
        var details = retailArray(snapshot && snapshot.routineItemDetails).slice(0, 3).map(function(item){
          var name = retailTextValue(item && item.name, '');
          var reason = bdFastRetailReasonSnippet(item && item.reason);
          if (!name || !reason) return '';
          return name + ' for ' + reason.charAt(0).toLowerCase() + reason.slice(1);
        }).filter(Boolean);
        return bdFastRetailPhraseList(details, 3);
      }

      function bdFastRetailHistoryContext(detail){
        var appointments = retailArray(detail && detail.appointments);
        var concernsMap = new Map();
        var routinesMap = new Map();
        var traitsMap = new Map();
        var tagsMap = new Map();
        var productsMap = new Map();
        appointments.forEach(function(appointment, index){
          var weight = Math.max(1, appointments.length - index);
          var snapshot = bdFastRecommendationSnapshot(appointment);
          bdFastStrategyAppointmentTags(appointment).forEach(function(tag){
            var key = retailTextValue(tag, '');
            if (!key) return;
            tagsMap.set(key, (tagsMap.get(key) || 0) + weight);
          });
          if (!snapshot) return;
          retailArray(snapshot.consultConcerns).forEach(function(value){
            var key = retailTextValue(value, '');
            if (!key) return;
            concernsMap.set(key, (concernsMap.get(key) || 0) + weight);
          });
          retailArray(snapshot.consultRoutine.length ? snapshot.consultRoutine : snapshot.routines).forEach(function(value){
            var key = retailTextValue(value, '');
            if (!key) return;
            routinesMap.set(key, (routinesMap.get(key) || 0) + weight);
          });
          retailArray(snapshot.traits).forEach(function(value){
            var key = retailTextValue(value, '');
            if (!key) return;
            traitsMap.set(key, (traitsMap.get(key) || 0) + weight);
          });
          retailArray(snapshot.routineItemDetails).forEach(function(item){
            var key = retailTextValue(item && item.name, '');
            if (!key) return;
            productsMap.set(key, (productsMap.get(key) || 0) + weight);
          });
        });
        function topKeys(map, limit){
          return Array.from(map.entries())
            .sort(function(left, right){
              return Number(right[1] || 0) - Number(left[1] || 0);
            })
            .slice(0, Math.max(1, Number(limit) || 3))
            .map(function(entry){ return entry[0]; });
        }
        return {
          concerns: topKeys(concernsMap, 3),
          routines: topKeys(routinesMap, 2),
          traits: topKeys(traitsMap, 2),
          tags: topKeys(tagsMap, 4),
          products: topKeys(productsMap, 4)
        };
      }

      function bdFastRetailTimeLead(appointmentAt, recentVisitDaysSince){
        var diff = bdFastDateDiffFromToday(appointmentAt);
        if (diff !== null && diff === 0) return 'for your appointment today';
        if (diff !== null && diff > 0) return 'before your appointment on ' + formatRecaptureDate(appointmentAt);
        if (recentVisitDaysSince !== null && recentVisitDaysSince <= 14) return 'after your recent visit';
        if (appointmentAt) return 'around your appointment on ' + formatRecaptureDate(appointmentAt);
        return 'for your routine';
      }

      function bdFastRetailSupportSentence(snapshot, retailContext, appointmentTags){
        var safeSnapshot = snapshot && typeof snapshot === 'object' ? snapshot : null;
        if (safeSnapshot) {
          var goal = retailTextValue(safeSnapshot.consultGoal, '');
          var concerns = bdFastRetailConcernPhrase(safeSnapshot);
          var routines = bdFastRetailRoutineContextPhrase(safeSnapshot);
          var bits = [];
          if (goal) bits.push('support ' + goal.toLowerCase());
          if (concerns) bits.push('help with ' + concerns.toLowerCase());
          if (routines) bits.push('fit your ' + routines.toLowerCase() + ' routine');
          if (bits.length) return 'I built this to ' + bits.join(', ') + '.';
        }
        var tags = bdFastRetailPhraseList(appointmentTags, 2);
        if (tags) return 'This is built around ' + tags.toLowerCase() + '.';
        if (retailTextValue(retailContext && retailContext.focus, '')) {
          return 'This is focused on ' + retailTextValue(retailContext.focus, '').toLowerCase() + '.';
        }
        return 'This should support the result you want to maintain at home.';
      }

      function bdFastRetailHistorySupportSentence(historyContext, snapshot, retailContext, appointmentTags){
        var history = historyContext && typeof historyContext === 'object' ? historyContext : {};
        var concernPhrase = bdFastRetailPhraseList(retailArray(history.concerns).map(function(value){
          return retailTextValue(value, '').replace(/-/g, ' ');
        }), 2);
        var routinePhrase = bdFastRetailPhraseList(retailArray(history.routines).map(function(value){
          return retailTextValue(value, '').replace(/-/g, ' ');
        }), 2);
        var traitPhrase = bdFastRetailPhraseList(retailArray(history.traits).map(function(value){
          return retailTextValue(value, '').replace(/-/g, ' ');
        }), 2);
        var base = bdFastRetailSupportSentence(snapshot, retailContext, appointmentTags);
        var bits = [];
        if (concernPhrase) bits.push(concernPhrase.toLowerCase());
        if (routinePhrase) bits.push(routinePhrase.toLowerCase() + ' routine');
        if (traitPhrase) bits.push(traitPhrase.toLowerCase() + ' hair');
        if (!bits.length) return base;
        return base + ' Across your recent history, the strongest themes are ' + bits.join(', ') + '.';
      }

      function bdFastRetailRecommendedLine(snapshot, productText, retailContext){
        var safeSnapshot = snapshot && typeof snapshot === 'object' ? snapshot : null;
        if (safeSnapshot) {
          var primaryProducts = bdFastRetailPhraseList(
            safeSnapshot.missingProducts.length
              ? safeSnapshot.missingProducts
              : safeSnapshot.routineItems.length
              ? safeSnapshot.routineItems
              : safeSnapshot.recommendedProducts,
            2
          );
          var explanation = bdFastRetailRoutineExplanation(safeSnapshot);
          if (primaryProducts && explanation) return 'I’d start with ' + primaryProducts + '. More specifically: ' + explanation + '.';
          if (primaryProducts) return 'I’d start with ' + primaryProducts + '.';
        }
        if (productText) return 'I’d start with ' + productText + '.';
        return 'I’d start with ' + retailTextValue(retailContext && retailContext.productFamily, 'a simple home-care routine') + '.';
      }

      function bdFastRetailHistoryProductSentence(historyContext, snapshot){
        var history = historyContext && typeof historyContext === 'object' ? historyContext : {};
        var recentProducts = retailArray(history.products).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        var snapshotProducts = snapshot && typeof snapshot === 'object'
          ? retailArray(snapshot.routineItems.length ? snapshot.routineItems : snapshot.recommendedProducts).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean)
          : [];
        var merged = [];
        snapshotProducts.concat(recentProducts).forEach(function(value){
          if (merged.indexOf(value) === -1) merged.push(value);
        });
        if (!merged.length) return '';
        return 'The products that fit best here are ' + bdFastRetailPhraseList(merged, 3) + '.';
      }

      function bdFastRetailCta(snapshot){
        var safeSnapshot = snapshot && typeof snapshot === 'object' ? snapshot : null;
        if (safeSnapshot) {
          var linkCount = Math.max(
            retailArray(safeSnapshot.missingProducts).length,
            retailArray(safeSnapshot.routineItems).length,
            retailArray(safeSnapshot.recommendedProducts).length
          );
          return linkCount > 1 ? 'Want me to send the links?' : 'Want me to send the link?';
        }
        return 'Want me to send the link?';
      }

      function bdFastAppointmentPublicToken(appointment){
        var safeAppointment = appointment && typeof appointment === 'object' ? appointment : {};
        var appointmentData = safeAppointment.appointment_data && typeof safeAppointment.appointment_data === 'object'
          ? safeAppointment.appointment_data
          : {};
        return retailTextValue(
          safeAppointment.public_token
            || appointmentData.public_token
            || appointmentData.publicToken,
          ''
        ).trim();
      }

      function bdFastRoutinePageUrl(token){
        var normalizedToken = retailTextValue(token, '').trim();
        if (!normalizedToken) return '';
        return 'go.hairstories.com/' + encodeURIComponent(normalizedToken);
      }

      function bdFastRetailMessageWithRoutineLink(message, routinePageUrl){
        var baseMessage = retailTextValue(message, '').trim();
        var link = retailTextValue(routinePageUrl, '').trim();
        if (!baseMessage || !link) return baseMessage;
        if (baseMessage.indexOf(link) !== -1) return baseMessage;
        return baseMessage + ' ' + link;
      }

      function bdFastRetailStylistLead(summary, recentVisitAt, futureBookingAt){
        var stylistFirstName = bdFastStrategyStylistFirstName(summary);
        var timeLead = bdFastRetailTimeLead(futureBookingAt || recentVisitAt, bdFastStrategyDaysSince(recentVisitAt));
        if (!stylistFirstName) return timeLead + ', I wanted to send over the home-care routine I’d recommend.';
        if (futureBookingAt) return 'before your appointment on ' + formatRecaptureDate(futureBookingAt) + ', ' + stylistFirstName + ' wanted me to send over the home-care routine they’d recommend.';
        if (recentVisitAt) return 'after your visit on ' + formatRecaptureDate(recentVisitAt) + ', ' + stylistFirstName + ' wanted me to send over the home-care routine they’d recommend.';
        return timeLead + ', ' + stylistFirstName + ' wanted me to send over the home-care routine they’d recommend.';
      }

      function bdFastRetailStylistAuthority(summary){
        var stylistFirstName = bdFastStrategyStylistFirstName(summary);
        if (!stylistFirstName) return 'I wanted to send over';
        return stylistFirstName + ' wanted me to send over';
      }

      function bdFastRetailServiceContextPhrase(recentServiceLabel, retailContext){
        var label = retailTextValue(recentServiceLabel, '').trim();
        if (label) {
          var lower = label.toLowerCase();
          if (/(blowout|blow dry|blowdry|style|styling)/.test(lower)) return 'your recent blowdry';
          return 'your recent ' + label;
        }
        var focus = retailTextValue(retailContext && retailContext.focus, '').trim();
        if (focus === 'color maintenance') return 'your recent color service';
        if (focus === 'smooth, frizz-controlled hair') return 'your recent smoothing service';
        if (focus === 'volume, shape, and finish') return 'your recent blowdry';
        if (focus === 'shape and style longevity') return 'your recent haircut';
        return 'your recent visit';
      }

      function bdFastRetailRoutineSms(firstName, stylistAuthority, serviceContextPhrase){
        return 'Hi ' + firstName + ' - ' + stylistAuthority + ' a routine to help maintain ' + serviceContextPhrase + ' at home.';
      }

      function bdFastStrategySmsMessage(summary){
        var row = summary && summary.row && typeof summary.row === 'object' ? summary.row : {};
        var categoryKey = retailTextValue(summary && summary.categoryKey, '') || bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var firstName = bdFastStrategyGuestFirstName(row);
        var mode = bdFastOpportunityMode(row);
        var recentAppointment = summary && summary.recentAppointment && typeof summary.recentAppointment === 'object'
          ? summary.recentAppointment
          : {};
        var recommendationSnapshot = summary && summary.recommendationSnapshot && typeof summary.recommendationSnapshot === 'object'
          ? summary.recommendationSnapshot
          : null;
        var recentServices = retailArray(recentAppointment && recentAppointment.service_names);
        var recentServiceLabel = bdFastServiceLabelForSms(recentServices) || retailTextValue(row && row.last_service_name, 'your last visit');
        var recentVisitAt = retailTextValue(recentAppointment && recentAppointment.start_at, '') || retailTextValue(row && row.last_in_date, '');
        var recentVisitDaysSince = bdFastStrategyDaysSince(recentVisitAt);
        var retailContext = summary && summary.retailContext && typeof summary.retailContext === 'object'
          ? summary.retailContext
          : {};
        var routinePageUrl = retailTextValue(summary && summary.routinePageUrl, '');
        var stylistAuthority = bdFastRetailStylistAuthority(summary);
        var appointmentTags = retailArray(summary && summary.appointmentTags).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        if (categoryKey === 'wellness') {
          var stylistFirstName = bdFastStrategyStylistFirstName(summary);
          return stylistFirstName
            ? 'Hi ' + firstName + ' - ' + stylistFirstName + ' thought hs.Wellness could be a strong fit for you. It is our clinician-backed side for support like peptides, hormones, and GLP-1. Learn more or book at www.hairstories.com.'
            : 'Hi ' + firstName + ' - hs.Wellness could be a strong fit for you. It is our clinician-backed side for support like peptides, hormones, and GLP-1. Learn more or book at www.hairstories.com.';
        }
        if (mode === 'hybrid_growth') {
          var hybridContextPhrase = bdFastRetailServiceContextPhrase(recentServiceLabel, retailContext);
          var hybridMessage = 'Hi ' + firstName + ' - ' + stylistAuthority + ' a routine to help maintain ' + hybridContextPhrase + ' at home, and I’d also love to help get your next visit on the books.';
          if (!recommendationSnapshot && recentVisitDaysSince !== null && recentVisitDaysSince > 14) {
            hybridMessage = 'Hi ' + firstName + ' - ' + stylistAuthority + ' a routine to help maintain your result at home, and I’d also love to help get your next visit on the books.';
          }
          hybridMessage = bdFastRetailMessageWithRoutineLink(hybridMessage, routinePageUrl);
          return hybridMessage + ' If you want, I can send over the best appointment options for you.';
        }
        if (mode === 'retail_growth') {
          var serviceContextPhrase = bdFastRetailServiceContextPhrase(recentServiceLabel, retailContext);
          var retailMessage = bdFastRetailRoutineSms(firstName, stylistAuthority, serviceContextPhrase);
          if (!recommendationSnapshot && recentVisitDaysSince !== null && recentVisitDaysSince > 14) {
            retailMessage = 'Hi ' + firstName + ' - ' + stylistAuthority + ' a routine to help maintain your result at home.';
          }
          return bdFastRetailMessageWithRoutineLink(retailMessage, routinePageUrl);
        }
        if (categoryKey === 'future_protected') {
          return 'Hi ' + firstName + ' - you are already booked, so everything is set on the appointment side.';
        }
        if (categoryKey === 'needs_booking') {
          return 'Hi ' + firstName + ' - I’d love to help get your next visit on the books. If you want, I can send over the best appointment options for you.';
        }
        if (categoryKey === 'never_visited') {
          return 'Hi ' + firstName + ' - I wanted to reach out in case you still wanted to come in. If you’d like, I can send over a few appointment options to make booking easy.';
        }
        return 'Hi ' + firstName + ' - I wanted to check in and help with your next step. If you want, I can send over the best booking options for you.';
      }

      function bdFastStrategyGoalLabel(row){
        if ((bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '')) === 'wellness') return 'Build wellness';
        if (bdFastOpportunityMode(row) === 'hybrid_growth') return 'Retail + booking';
        return bdFastOpportunityMode(row) === 'retail_growth' ? 'Build retail' : 'Book appointment';
      }

      function bdFastStrategySummary(selectedRow, state){
        if (!selectedRow) return null;
        var detailResult = state && state.detail && typeof state.detail === 'object' ? state.detail : {};
        var detail = detailResult.detail && typeof detailResult.detail === 'object' ? detailResult.detail : {};
        var row = detailResult.row && typeof detailResult.row === 'object' ? detailResult.row : selectedRow;
        var baseStrategy = bdFastStrategy(row);
        var outreachState = bdFastOutreachStateForRow(row);
        var mode = bdFastOpportunityMode(row);
        var primaryCadence = bdFastStrategyPrimaryCadenceItem(detail);
        var recentAppointment = bdFastDetailAppointmentWithRichContext(detail) || bdFastStrategyRecentAppointment(detail);
        var recentPurchase = bdFastStrategyRecentRetailPurchase(detail);
        var familyLabel = retailTextValue(primaryCadence && (primaryCadence.label || primaryCadence.family_label), '');
        var cadenceDays = Math.max(0, Number(primaryCadence && primaryCadence.cadence_days) || Number((row && row.cadence_days) || 0) || 0);
        var cadenceSample = Math.max(0, Number(primaryCadence && primaryCadence.cadence_sample_size) || 0);
        var daysOverdue = primaryCadence
          ? Math.max(0, Number(primaryCadence.days_overdue || 0) || 0)
          : bdFastDaysOverdue(row);
        var futureBookingAt = retailTextValue(row && row.future_appointment_at, '');
        var appointmentServices = retailArray(recentAppointment && recentAppointment.service_names).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        var appointmentTags = bdFastStrategyAppointmentTags(recentAppointment)
          .concat(bdFastManualProductTagValues(outreachState && outreachState.manualProductTags));
        var recentRetailName = retailTextValue(recentPurchase && recentPurchase.product_name, '');
        var recentRetailAt = retailTextValue(recentPurchase && recentPurchase.completed_at, '');
        var recentRetailDaysSince = bdFastStrategyDaysSince(recentRetailAt);
        var retailContext = bdFastRetailRecommendationContext(appointmentServices, appointmentTags, recentRetailName);
        var manualProductList = bdFastManualRetailOverrideList(outreachState && outreachState.manualProductTags);
        var recommendedProductText = manualProductList.length
          ? 'Recommend ' + manualProductList.slice(0, 2).join(' and ')
          : bdFastRetailRecommendedProductText(recentRetailName, recentRetailDaysSince, retailContext);
        var recommendationSnapshot = bdFastRecommendationSnapshot(recentAppointment);
        var routinePageToken = bdFastAppointmentPublicToken(recentAppointment);
        var routinePageUrl = bdFastRoutinePageUrl(routinePageToken);
        var historyContext = bdFastRetailHistoryContext(detail);
        var activeOpportunity = bdFastActiveOpportunityEntry(row, false);
        var categoryKey = retailTextValue(activeOpportunity && activeOpportunity.lane_key, '') || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var categoryLabel = retailTextValue(activeOpportunity && activeOpportunity.lane_label, '') || bdFastLaneLabel(categoryKey);
        var opportunityReason = retailTextValue(activeOpportunity && activeOpportunity.reason, '');
        var wellnessTags = bdFastWellnessTagValues(row);
        var appointments = retailArray(detail && detail.appointments);
        var completedAppointments = appointments.filter(function(item){
          var normalizedState = retailTextValue(item && item.state, '').toLowerCase();
          return normalizedState === 'closed' || normalizedState === 'final' || normalizedState === 'completed';
        });
        var cancelledAppointments = appointments.filter(function(item){
          return retailTextValue(item && item.state, '').toLowerCase() === 'cancelled';
        });
        var noShowAppointments = appointments.filter(function(item){
          var normalizedState = retailTextValue(item && item.state, '').toLowerCase();
          return normalizedState === 'no_show' || normalizedState === 'no-show';
        });
        var futureAppointment = detail && detail.future_appointment && typeof detail.future_appointment === 'object'
          ? detail.future_appointment
          : {};
        var futureAppointmentState = retailTextValue(futureAppointment && futureAppointment.state, '').toLowerCase();
        var futureAppointmentAt = retailTextValue(futureAppointment && futureAppointment.start_at, '') || futureBookingAt;
        var hasActiveFutureAppointment = !!futureAppointmentAt && futureAppointmentState !== 'cancelled' && futureAppointmentState !== 'no_show' && futureAppointmentState !== 'no-show';
        var latestCancelledAppointment = cancelledAppointments[0] || {};
        var latestNoShowAppointment = noShowAppointments[0] || {};
        var latestFailedAt = retailTextValue(latestCancelledAppointment && latestCancelledAppointment.start_at, '') || retailTextValue(latestNoShowAppointment && latestNoShowAppointment.start_at, '');
        var latestFailedDiff = bdFastDateDiffFromToday(latestFailedAt);
        var hasRecentFailedBooking = !!(latestFailedAt && latestFailedDiff !== null && latestFailedDiff <= 0 && Math.abs(latestFailedDiff) <= 30);
        var factualTriggerTitle = '';
        var whyNow = '';
        var nextMove = baseStrategy.recommendedAction || 'Review the latest history and send a personal outreach.';
        var smsAngle = '';
        var offerGuidance = baseStrategy.offerLabel || 'No offer';
        if (categoryKey === 'wellness') {
          factualTriggerTitle = completedAppointments.length > 0
            ? 'Wellness tags on completed visit history'
            : 'Wellness tags saved in history';
          whyNow = 'Their appointment history supports a relevant hs.Wellness introduction through the existing Hairstories relationship.';
          smsAngle = 'Lead with the stylist relationship, position hs.Wellness as clinician-backed support, and keep the CTA simple.';
          nextMove = 'Send a short stylist-led introduction to hs.Wellness that feels like a trusted recommendation, not a medical pitch.';
          offerGuidance = 'No offer recommended. Lead with trust, relevance, and clinician-backed support.';
        } else if (mode === 'hybrid_growth') {
          var hybridVisitLabel = recentAppointment && recentAppointment.start_at ? bdDateText(recentAppointment.start_at) : formatRecaptureDate(bdFastLastVisitDateValue(row));
          factualTriggerTitle = hybridVisitLabel
            ? 'Closed visit on ' + hybridVisitLabel
            : 'Recent visit with no future booking';
          whyNow = hybridVisitLabel
            ? 'They closed a visit on ' + hybridVisitLabel + ' and still do not have their next appointment booked, so retail and rebooking should be handled together.'
            : 'They have a fresh completed visit and no future booking, so this is both a retail and rebooking opportunity.';
          smsAngle = 'Use one text to protect the result at home and make the next appointment feel easy to lock in.';
          nextMove = 'Send one blended SMS that covers home-care follow-up and getting the next visit on the books so the guest gets one clear next step.';
          offerGuidance = 'No discount by default. Lead with relevance, continuity, and an easy booking next step.';
        } else if (mode === 'retail_growth') {
          var recentVisitLabel = recentAppointment && recentAppointment.start_at ? bdDateText(recentAppointment.start_at) : formatRecaptureDate(bdFastLastVisitDateValue(row));
          factualTriggerTitle = recentVisitLabel
            ? 'Closed visit on ' + recentVisitLabel
            : 'Post-visit retail opportunity';
          whyNow = recentVisitLabel
            ? 'They closed a visit on ' + recentVisitLabel + ', so this is a post-appointment retail opportunity while the result is still fresh.'
            : 'They closed a visit today or inside the last 14 days, so this opportunity should focus on retail conversion.';
          if (hasActiveFutureAppointment && futureAppointmentAt) {
            whyNow += ' A future appointment is also booked for ' + bdDateText(futureAppointmentAt) + ', so service is already protected while retail remains the opportunity.';
          }
          if (recentRetailName && recentRetailDaysSince !== null && recentRetailDaysSince >= 45) {
            smsAngle = 'Reference the recent visit and suggest a replenish of ' + recentRetailName + ' because the last recorded purchase was ' + recentRetailDaysSince + ' days ago.';
          } else if (recentRetailName && recentRetailAt) {
            smsAngle = 'Reference the recent visit and recommend a complementary product alongside their last purchase of ' + recentRetailName + ' from ' + formatRecaptureDate(recentRetailAt) + '.';
          } else if (appointmentTags.length) {
            smsAngle = 'Reference the recent visit and lead with ' + retailContext.focus + ' based on appointment tags like ' + appointmentTags.slice(0, 2).join(' + ') + '.';
          } else {
            smsAngle = 'Reference the recent visit and ' + retailContext.sms.charAt(0).toLowerCase() + retailContext.sms.slice(1);
          }
          nextMove = 'Send a short SMS that ties their recent appointment to a specific retail recommendation and pushes to the online store.';
          offerGuidance = 'No discount by default. Lead with relevance, replenishment timing, and convenience.';
        } else if (hasActiveFutureAppointment) {
          factualTriggerTitle = 'Future appointment booked for ' + formatRecaptureDate(futureAppointmentAt);
          whyNow = 'An active future appointment is already booked for ' + bdDateText(futureAppointmentAt) + ', so service is currently protected.';
          smsAngle = 'No booking recovery outreach is needed while that future appointment remains active.';
          nextMove = 'No service outreach is needed. Review detail only if you want context or a different follow-up path.';
          offerGuidance = 'No offer recommended.';
        } else if (categoryKey === 'new_guest_no_prebook') {
          var firstVisitAt = retailTextValue(recentAppointment && recentAppointment.start_at, '') || bdFastLastVisitDateValue(row);
          factualTriggerTitle = firstVisitAt
            ? 'First visit completed on ' + formatRecaptureDate(firstVisitAt)
            : 'Recent first visit completed';
          whyNow = firstVisitAt
            ? (bdFastHasFutureBooking(row)
              ? 'They completed a first visit on ' + bdDateText(firstVisitAt) + ' and already have visit two booked.'
              : 'They completed a first visit on ' + bdDateText(firstVisitAt) + ' and still need visit two booked.')
            : (bdFastHasFutureBooking(row)
              ? 'They completed a recent first visit and already have visit two booked.'
              : 'They completed a recent first visit and still need visit two booked.');
          smsAngle = stylist
            ? 'Acknowledge that they are brand new to Hairstories, reference the first visit with ' + stylist + ', and make visit two feel easy to lock in.'
            : 'Acknowledge that they are brand new to Hairstories and make visit two feel easy to lock in.';
          nextMove = 'Send a warm second-visit follow-up while the first appointment is still fresh and the relationship is new.';
          offerGuidance = 'No offer recommended. Lead with continuity, confidence, and an easy next step.';
        } else if (categoryKey === 'future_protected') {
          factualTriggerTitle = futureBookingAt
            ? 'Future appointment booked for ' + formatRecaptureDate(futureBookingAt)
            : 'Future appointment already booked';
          whyNow = bdFastDeterminationText(row) || 'A future appointment is already on the books.';
          smsAngle = 'No service recovery outreach is needed because the appointment is already protected.';
          nextMove = 'No service outreach is needed unless you want to review the client detail for context.';
          offerGuidance = 'No offer recommended.';
        } else if (categoryKey === 'needs_booking' && familyLabel && cadenceDays > 0) {
          if (hasRecentFailedBooking) {
            factualTriggerTitle = (retailTextValue(latestCancelledAppointment && latestCancelledAppointment.start_at, '')
              ? 'Cancelled appointment on '
              : 'No-show on ') + bdDateText(latestFailedAt);
            whyNow = 'Their last failed booking was ' + bdDateText(latestFailedAt) + ' and they still do not have a future appointment booked.';
          } else if (daysOverdue > 0) {
            factualTriggerTitle = 'Overdue ' + String(daysOverdue) + ' days against ' + familyLabel.toLowerCase() + ' cadence';
            whyNow = familyLabel + ' cadence shows they are ' + String(daysOverdue) + ' days overdue against an expected ' + cadenceDays + '-day rhythm.';
          } else {
            var dueAtText = retailTextValue(primaryCadence && primaryCadence.due_at, '');
            var lastVisitForTitle = retailTextValue(recentAppointment && recentAppointment.start_at, '') || bdFastLastVisitDateValue(row);
            factualTriggerTitle = lastVisitForTitle
              ? 'No future booking after last visit on ' + formatRecaptureDate(lastVisitForTitle)
              : 'No future booking against known cadence';
            whyNow = familyLabel + ' cadence is the best signal right now' + (dueAtText ? ', with the next due date on ' + bdDateText(dueAtText) + '.' : '.');
          }
          smsAngle = hasRecentFailedBooking
            ? 'Acknowledge the missed booking window and make the next step feel simple and easy to act on.'
            : (daysOverdue > 0
              ? 'Lead with that specific service rhythm and make rebooking feel urgent but easy.'
              : 'Lead with that specific service rhythm and frame this as the cleanest time to get back on the books.');
        } else if (mode === 'service_growth') {
          if (hasRecentFailedBooking) {
            factualTriggerTitle = (retailTextValue(latestCancelledAppointment && latestCancelledAppointment.start_at, '')
              ? 'Cancelled appointment on '
              : 'No-show on ') + bdDateText(latestFailedAt);
            whyNow = 'Their last failed booking was ' + bdDateText(latestFailedAt) + ' and they have not rebooked since.';
          } else {
            var lastVisitForFallback = retailTextValue(recentAppointment && recentAppointment.start_at, '') || bdFastLastVisitDateValue(row);
            factualTriggerTitle = lastVisitForFallback
              ? 'No future booking after last visit on ' + formatRecaptureDate(lastVisitForFallback)
              : 'No future appointment currently booked';
            whyNow = bdFastDeterminationText(row) || baseStrategy.justification || 'They do not have a future booking and need a simple next-step recommendation.';
          }
          smsAngle = 'Keep the text personal and short. Focus on getting a reply and a booked time, not explaining the full logic.';
        } else if (categoryKey === 'never_visited') {
          if (retailTextValue(latestCancelledAppointment && latestCancelledAppointment.start_at, '')) {
            factualTriggerTitle = 'Cancelled appointment on ' + bdDateText(latestCancelledAppointment.start_at);
          } else if (retailTextValue(latestNoShowAppointment && latestNoShowAppointment.start_at, '')) {
            factualTriggerTitle = 'No-show on ' + bdDateText(latestNoShowAppointment.start_at);
          } else {
            factualTriggerTitle = 'Booked first visit but never completed';
          }
          whyNow = 'No completed visit is currently on record, so this should be treated as a first-visit conversion opportunity.';
        }
        if (retailTextValue(baseStrategy.offerLabel, '').toLowerCase() === 'no offer') {
          if (categoryKey === 'needs_booking' || categoryKey === 'never_visited') {
            offerGuidance = 'Use an approved Boulevard offer only if the guest needs extra incentive to commit.';
          } else {
            offerGuidance = 'No offer recommended.';
          }
        }
        return {
          row: row,
          activeOpportunity: activeOpportunity,
          categoryKey: categoryKey,
          categoryLabel: categoryLabel,
          opportunityReason: opportunityReason,
          detail: detail,
          baseStrategy: baseStrategy,
          goalLabel: bdFastStrategyGoalLabel(row),
          factualTriggerTitle: factualTriggerTitle,
          whyNow: whyNow,
          nextMove: nextMove,
          smsAngle: smsAngle,
          offerGuidance: offerGuidance,
          primaryCadence: primaryCadence,
          cadenceLabel: familyLabel,
          cadenceDays: cadenceDays,
          cadenceSample: cadenceSample,
          daysOverdue: daysOverdue,
          recentAppointment: recentAppointment,
          recentPurchase: recentPurchase,
          recommendationSnapshot: recommendationSnapshot,
          routinePageUrl: routinePageUrl,
          historyContext: historyContext,
          appointmentTags: appointmentTags,
          completedCount: completedAppointments.length,
          cancelledCount: cancelledAppointments.length,
          noShowCount: noShowAppointments.length,
          futureAppointment: futureAppointment,
          hasActiveFutureAppointment: hasActiveFutureAppointment,
          latestCancelledAt: retailTextValue(latestCancelledAppointment && latestCancelledAppointment.start_at, ''),
          latestNoShowAt: retailTextValue(latestNoShowAppointment && latestNoShowAppointment.start_at, ''),
          latestFailedAt: latestFailedAt,
          hasRecentFailedBooking: hasRecentFailedBooking,
          managerOverrides: {
            concerns: [],
            products: manualProductList
          },
          retailContext: retailContext,
          recommendedProductText: recommendedProductText,
          sourceSignals: {
            lastService: appointmentServices.slice(0, 2).join(', '),
            lastPurchase: recentRetailName,
            lastPurchaseDaysSince: recentRetailDaysSince,
            tags: appointmentTags.slice(0, 3).join(', ')
          }
        };
      }

      function bdFastStrategyReasonTitle(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var factualTitle = retailTextValue(safeSummary.factualTriggerTitle, '');
        if (factualTitle) return factualTitle;
        var row = safeSummary.row && typeof safeSummary.row === 'object' ? safeSummary.row : {};
        var categoryKey = retailTextValue(safeSummary.categoryKey, '') || bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var mode = bdFastOpportunityMode(row);
        var recommendationSnapshot = !!safeSummary.recommendationSnapshot;
        var recentAppointment = safeSummary.recentAppointment && typeof safeSummary.recentAppointment === 'object'
          ? safeSummary.recentAppointment
          : {};
        var futureAppointment = safeSummary.futureAppointment && typeof safeSummary.futureAppointment === 'object'
          ? safeSummary.futureAppointment
          : {};
        var futureAt = retailTextValue(futureAppointment && futureAppointment.start_at, '') || retailTextValue(row && row.future_appointment_at, '');
        var daysOverdue = Math.max(0, Number(safeSummary.daysOverdue) || 0);
        var recentFailedBooking = safeSummary.hasRecentFailedBooking === true;
        if (safeSummary.hasActiveFutureAppointment === true && futureAt) {
          return 'Future appointment booked for ' + formatRecaptureDate(futureAt);
        }
        if (categoryKey === 'wellness') {
          return retailTextValue(safeSummary.completedCount, '') && Number(safeSummary.completedCount) > 0
            ? 'Wellness opportunity from client history'
            : 'Wellness opportunity from saved tags';
        }
        if (mode === 'retail_growth' || categoryKey === 'retail') {
          if (recommendationSnapshot) return 'Routine ready from recent visit';
          if (futureAt) return 'Retail follow-up with future booking';
          return 'Post-visit retail opportunity';
        }
        if (categoryKey === 'never_visited') {
          if (retailTextValue(safeSummary.latestCancelledAt, '')) return 'Cancelled first visit';
          if (retailTextValue(safeSummary.latestNoShowAt, '')) return 'Missed first visit';
          return 'Booked once but never completed';
        }
        if (categoryKey === 'needs_booking') {
          if (recentFailedBooking) {
            return 'Unbooked after cancellation';
          }
          if (safeSummary.cadenceLabel && safeSummary.cadenceDays > 0 && daysOverdue > 0) {
            return 'Overdue against known cadence';
          }
          if (safeSummary.cadenceLabel && safeSummary.cadenceDays > 0) {
            return 'No future booking against known cadence';
          }
          return 'Returning guest with no future booking';
        }
        return bdFastQueueReasonText(row);
      }

      function bdFastStrategyPayload(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var row = safeSummary.row && typeof safeSummary.row === 'object'
          ? safeSummary.row
          : {};
        var detail = safeSummary.detail && typeof safeSummary.detail === 'object'
          ? safeSummary.detail
          : {};
        var primaryCadence = safeSummary.primaryCadence && typeof safeSummary.primaryCadence === 'object'
          ? safeSummary.primaryCadence
          : {};
        var recentAppointment = safeSummary.recentAppointment && typeof safeSummary.recentAppointment === 'object'
          ? safeSummary.recentAppointment
          : {};
        var snapshot = safeSummary.recommendationSnapshot && typeof safeSummary.recommendationSnapshot === 'object'
          ? safeSummary.recommendationSnapshot
          : {};
        var history = safeSummary.historyContext && typeof safeSummary.historyContext === 'object'
          ? safeSummary.historyContext
          : {};
        var recentPurchase = safeSummary.recentPurchase && typeof safeSummary.recentPurchase === 'object'
          ? safeSummary.recentPurchase
          : {};
        var appointments = retailArray(detail && detail.appointments);
        var purchases = retailArray(detail && detail.purchases);
        var familyCadences = retailArray(detail && detail.family_cadences);
        var futureAppointment = detail && detail.future_appointment && typeof detail.future_appointment === 'object'
          ? detail.future_appointment
          : {};
        var completedAppointments = appointments.filter(function(item){
          var state = retailTextValue(item && item.state, '').toLowerCase();
          return state === 'closed' || state === 'final' || state === 'completed';
        });
        var cancelledAppointments = appointments.filter(function(item){
          return retailTextValue(item && item.state, '').toLowerCase() === 'cancelled';
        });
        var noShowAppointments = appointments.filter(function(item){
          var state = retailTextValue(item && item.state, '').toLowerCase();
          return state === 'no_show' || state === 'no-show';
        });
        var latestCompletedAppointment = completedAppointments[0] || recentAppointment || {};
        var latestCompletedAt = retailTextValue(latestCompletedAppointment && latestCompletedAppointment.start_at, '');
        var latestCancelledAt = retailTextValue(cancelledAppointments[0] && cancelledAppointments[0].start_at, '');
        var latestNoShowAt = retailTextValue(noShowAppointments[0] && noShowAppointments[0].start_at, '');
        return {
          category_key: retailTextValue(safeSummary.categoryKey, '') || bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, ''),
          mode: bdFastOpportunityMode(row),
          wellness_tag_values: bdFastWellnessTagValues(row),
          guest_name: retailTextValue(row && row.guest_name, ''),
          future_booking_at: retailTextValue(futureAppointment && futureAppointment.start_at, '') || retailTextValue(row && row.future_appointment_at, ''),
          last_visit_at: latestCompletedAt || retailTextValue(row && row.last_in_date, ''),
          appointment_count: completedAppointments.length || appointments.length,
          days_overdue: Math.max(0, Number(safeSummary.daysOverdue) || 0),
          cadence: {
            label: retailTextValue(safeSummary.cadenceLabel, ''),
            cadence_days: Math.max(0, Number(safeSummary.cadenceDays) || 0),
            cadence_sample_size: Math.max(0, Number(safeSummary.cadenceSample) || 0),
            due_at: retailTextValue(primaryCadence && primaryCadence.due_at, ''),
            days_overdue: Math.max(0, Number(primaryCadence && primaryCadence.days_overdue) || 0)
          },
          detail_signals: {
            has_future_booking: !!retailTextValue(futureAppointment && futureAppointment.start_at, '') || bdFastHasFutureBooking(row),
            completed_count: completedAppointments.length,
            cancelled_count: cancelledAppointments.length,
            no_show_count: noShowAppointments.length,
            latest_cancelled_at: latestCancelledAt,
            latest_no_show_at: latestNoShowAt,
            primary_staff_name: bdFastStrategyStylistName(safeSummary),
            last_service_name: bdFastServiceLabelForSms(retailArray(latestCompletedAppointment && latestCompletedAppointment.service_names)) || retailTextValue(row && row.last_service_name, '')
          },
          future_appointment: {
            start_at: retailTextValue(futureAppointment && futureAppointment.start_at, ''),
            state: retailTextValue(futureAppointment && futureAppointment.state, ''),
            stylist_name: retailArray(futureAppointment && futureAppointment.staff_names).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean)[0] || '',
            service_names: retailArray(futureAppointment && futureAppointment.service_names).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean),
            appointment_tags: bdFastStrategyAppointmentTags(futureAppointment)
          },
          anchor_appointment: {
            start_at: retailTextValue(recentAppointment.start_at, ''),
            state: retailTextValue(recentAppointment.state, ''),
            stylist_name: bdFastStrategyStylistName(safeSummary),
            public_token: bdFastAppointmentPublicToken(recentAppointment),
            routine_page_url: retailTextValue(safeSummary.routinePageUrl, ''),
            service_names: retailArray(recentAppointment.service_names).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean),
            appointment_tags: retailArray(safeSummary.appointmentTags).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean)
          },
          recommendation_snapshot: {
            consult_goal: retailTextValue(snapshot.consultGoal, ''),
            consult_home_help: retailTextValue(snapshot.consultHomeHelp, ''),
            consult_concerns: retailArray(snapshot.consultConcerns).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean),
            consult_routine: retailArray(snapshot.consultRoutine).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean),
            traits: retailArray(snapshot.traits).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean),
            voice_label: retailTextValue(snapshot.voiceLabel, ''),
            summary_copy: retailTextValue(snapshot.summaryCopy, ''),
            routine_items: retailArray(snapshot.routineItemDetails).map(function(item){
              return {
                name: retailTextValue(item && item.name, ''),
                reason: retailTextValue(item && item.reason, ''),
                role: retailTextValue(item && item.role, '')
              };
            }).filter(function(item){
              return item.name;
            }),
            upgrade_items: retailArray(snapshot.upgradeItemDetails).map(function(item){
              return {
                name: retailTextValue(item && item.name, ''),
                reason: retailTextValue(item && item.reason, ''),
                role: retailTextValue(item && item.role, '')
              };
            }).filter(function(item){
              return item.name;
            }),
            recommended_products: retailArray(snapshot.recommendedProducts).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean),
            missing_products: retailArray(snapshot.missingProducts).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean),
            purchased_products: retailArray(snapshot.purchasedProducts).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean)
          },
          history_themes: {
            concerns: retailArray(history.concerns).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean),
            routines: retailArray(history.routines).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean),
            traits: retailArray(history.traits).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean),
            tags: retailArray(history.tags).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean),
            products: retailArray(history.products).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean)
          },
          recent_purchase: {
            product_name: retailTextValue(recentPurchase.product_name, ''),
            completed_at: retailTextValue(recentPurchase.completed_at, '')
          },
          derived: {
            retail_focus: retailTextValue(safeSummary.retailContext && safeSummary.retailContext.focus, ''),
            recommended_product_text: retailTextValue(safeSummary.recommendedProductText, ''),
            source_signals: safeSummary.sourceSignals || {}
          },
          manager_overrides: {
            concern_tags: [],
            product_tags: retailArray(safeSummary.managerOverrides && safeSummary.managerOverrides.products).map(function(value){
              return retailTextValue(value, '');
            }).filter(Boolean)
          },
          family_cadences: familyCadences.slice(0, 3).map(function(item){
            return {
              label: retailTextValue(item && (item.label || item.family_label), ''),
              cadence_days: Math.max(0, Number(item && item.cadence_days) || 0),
              cadence_sample_size: Math.max(0, Number(item && item.cadence_sample_size) || 0),
              last_service_date: retailTextValue(item && item.last_service_date, ''),
              due_at: retailTextValue(item && item.due_at, ''),
              days_overdue: Math.max(0, Number(item && item.days_overdue) || 0)
            };
          }),
          recent_appointments: retailArray(safeSummary.detail && safeSummary.detail.appointments).slice(0, 6).map(function(item){
            return {
              start_at: retailTextValue(item && item.start_at, ''),
              state: retailTextValue(item && item.state, ''),
              service_names: retailArray(item && item.service_names).map(function(value){
                return retailTextValue(value, '');
              }).filter(Boolean),
              staff_names: retailArray(item && item.staff_names).map(function(value){
                return retailTextValue(value, '');
              }).filter(Boolean),
              tags: bdFastStrategyAppointmentTags(item)
            };
          }),
          recent_purchases: purchases.slice(0, 3).map(function(item){
            return {
              product_name: retailTextValue(item && item.product_name, ''),
              completed_at: retailTextValue(item && item.completed_at, ''),
              quantity: Math.max(0, Number(item && item.quantity) || 0)
            };
          })
        };
      }

      function bdFastAiOfferCatalogForRow(row){
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        if (categoryKey !== 'needs_booking' && categoryKey !== 'never_visited') return [];
        return bdFastOfferOptions().filter(function(option){
          var optionKey = retailTextValue(option && option.key, '');
          return !!option && optionKey !== 'custom' && optionKey !== 'none';
        }).map(function(option){
          return {
            key: retailTextValue(option && option.key, ''),
            label: retailTextValue(option && option.label, ''),
            text: retailTextValue(option && option.text, ''),
            boulevard_offer_code: retailTextValue(option && option.boulevard_offer_code, ''),
            boulevard_offer_name: retailTextValue(option && option.boulevard_offer_name, '')
          };
        });
      }

      function bdFastAiStrategyRequestPayload(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        return {
          category_key: retailTextValue(safeSummary.categoryKey, '') || bdFastOpportunityCategoryKey(safeSummary.row, false) || retailTextValue((bdFastCategoryMeta(safeSummary.row) || {}).key, ''),
          goal_label: retailTextValue(safeSummary.goalLabel, ''),
          why_now: retailTextValue(safeSummary.whyNow, ''),
          next_move: retailTextValue(safeSummary.nextMove, ''),
          sms_angle: retailTextValue(safeSummary.smsAngle, ''),
          offer_guidance: retailTextValue(safeSummary.offerGuidance, ''),
          available_offers: bdFastAiOfferCatalogForRow(safeSummary.row),
          strategy_payload: bdFastStrategyPayload(safeSummary)
        };
      }

      function bdFastStrategyDisplayLabel(value){
        var normalized = retailTextValue(value, '').toLowerCase();
        if (normalized === 'wellness_intro') return 'Wellness Introduction';
        if (normalized === 'wellness_followup') return 'Wellness Follow-Up';
        if (normalized === 'simple_invitation') return 'First Visit Invite';
        if (normalized === 'rescheduling_help') return 'Reschedule Help';
        if (normalized === 'routine_reminder') return 'Routine Reminder';
        if (normalized === 'recovery') return 'Recovery';
        if (normalized === 'light_check_in') return 'Light Check-In';
        if (normalized === 'win_back') return 'Win-Back';
        if (normalized === 'already_booked') return 'Already Booked';
        return retailTextValue(value, '').replace(/_/g, ' ');
      }

      function bdFastOfferDecisionDisplayLabel(value){
        var normalized = retailTextValue(value, '').toLowerCase();
        if (normalized === 'offer_yes') return 'Offer Yes';
        if (normalized === 'offer_no') return 'Offer No';
        return retailTextValue(value, '').replace(/_/g, ' ');
      }

      async function fetchBdFastAiStrategy(summary){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'generate-bd-fast-strategy',
            payload: bdFastAiStrategyRequestPayload(summary)
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not generate the strategy SMS.');
        }
        return data;
      }

      function bdFastActionPanelFactMarkup(label, value){
        var safeLabel = retailTextValue(label, '');
        var safeValue = retailTextValue(value, '');
        if (!safeLabel || !safeValue) return '';
        return ''
          + '<div class="bd-fastActionFact">'
          +   '<span>' + escapeHtml(safeLabel) + '</span>'
          +   '<strong>' + escapeHtml(safeValue) + '</strong>'
          + '</div>';
      }

      function bdFastOpportunityPillMarkup(entry, tone){
        var safeEntry = entry && typeof entry === 'object' ? entry : {};
        var laneLabel = retailTextValue(safeEntry.lane_label, retailTextValue(safeEntry.lane_key, 'Opportunity'));
        var reason = retailTextValue(safeEntry.reason, '');
        return ''
          + '<div class="bd-fastActionFact">'
          +   '<span>' + escapeHtml(tone || 'Opportunity') + '</span>'
          +   '<strong>' + escapeHtml(laneLabel) + '</strong>'
          +   (reason ? '<small>' + escapeHtml(reason) + '</small>' : '')
          + '</div>';
      }

      function bdFastOpportunitySwitchMarkup(selectedRow, entry){
        var safeEntry = entry && typeof entry === 'object' ? entry : {};
        var rowKey = retailTextValue(selectedRow && selectedRow.opportunity_key, '');
        var laneKey = retailTextValue(safeEntry.lane_key, '');
        var laneLabel = retailTextValue(safeEntry.lane_label, laneKey || 'Opportunity');
        var reason = retailTextValue(safeEntry.reason, '');
        var activeLane = retailTextValue((bdFastActiveOpportunityEntry(selectedRow, true) || {}).lane_key, '');
        var isActive = laneKey && laneKey === (bdFastSelectedOpportunityLane(selectedRow) || activeLane);
        return ''
          + '<button class="bd-fastOpportunitySwitch' + (isActive ? ' is-active' : '') + '" type="button" data-bd-fast-opportunity-pick="' + escapeHtml(rowKey) + '" data-bd-fast-opportunity-lane="' + escapeHtml(laneKey) + '">'
          +   '<span>' + escapeHtml(laneLabel) + '</span>'
          +   (reason ? '<small>' + escapeHtml(reason) + '</small>' : '')
          + '</button>';
      }

      function bdFastOpportunitySetMarkup(selectedRow){
        var openEntries = bdFastOpportunityEntries(selectedRow, true);
        var allEntries = bdFastOpportunityEntries(selectedRow, false);
        var workedEntries = allEntries.filter(function(entry){
          return openEntries.indexOf(entry) === -1;
        });
        if (!openEntries.length && !workedEntries.length) return '';
        var openMarkup = openEntries.length
          ? openEntries.map(function(entry){ return bdFastOpportunitySwitchMarkup(selectedRow, entry); }).join('')
          : '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No open opportunities on this guest.</div>';
        var workedMarkup = workedEntries.length
          ? workedEntries.map(function(entry){ return bdFastOpportunityPillMarkup(entry, 'Worked'); }).join('')
          : '';
        return ''
          + '<div class="bd-fastActionSection">'
          +   '<span class="bd-fastActionLabel">Opportunities on this guest</span>'
          +   '<div class="bd-fastOpportunitySwitches">' + openMarkup + '</div>'
          +   (workedMarkup ? '<div class="bd-fastActionFacts">' + workedMarkup + '</div>' : '')
          + '</div>';
      }

      function bdFastActionPanelFactsMarkup(summary, state){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var row = safeSummary.row && typeof safeSummary.row === 'object' ? safeSummary.row : {};
        var recentAppointment = safeSummary.recentAppointment && typeof safeSummary.recentAppointment === 'object'
          ? safeSummary.recentAppointment
          : {};
        var recentPurchase = safeSummary.recentPurchase && typeof safeSummary.recentPurchase === 'object'
          ? safeSummary.recentPurchase
          : {};
        var activityBucket = getRetailActivityBucket(row);
        var activityText = bdFastCheckinActivityIntentText(activityBucket);
        var snapshot = safeSummary.recommendationSnapshot && typeof safeSummary.recommendationSnapshot === 'object'
          ? safeSummary.recommendationSnapshot
          : null;
        var categoryKey = retailTextValue(safeSummary.categoryKey, '') || bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var facts = [];
        if (categoryKey === 'wellness') {
          facts.push(bdFastActionPanelFactMarkup('Last completed service', bdFastServiceLabelForSms(retailArray(recentAppointment && recentAppointment.service_names)) || retailTextValue(row && row.last_service_name, '')));
          facts.push(bdFastActionPanelFactMarkup('Last visit date', formatRecaptureDate(retailTextValue(recentAppointment && recentAppointment.start_at, '') || bdFastLastVisitDateValue(row))));
          facts.push(bdFastActionPanelFactMarkup('Primary stylist', retailTextValue(row && row.primary_staff_name, '') || 'No stylist on file'));
          facts.push(bdFastActionPanelFactMarkup('Wellness tags', bdFastWellnessTagValues(row).slice(0, 4).join(', ') || 'Wellness tag present'));
          facts.push(bdFastActionPanelFactMarkup('Current relationship', bdFastHasFutureBooking(row) ? 'Future salon appointment booked' : (bdFastHasCompletedVisit(row) ? 'Completed salon history exists' : 'Tag-only opportunity')));
        } else if (categoryKey === 'retail') {
          facts.push(bdFastActionPanelFactMarkup('Last completed service', bdFastServiceLabelForSms(retailArray(recentAppointment && recentAppointment.service_names)) || retailTextValue(row && row.last_service_name, '')));
          facts.push(bdFastActionPanelFactMarkup('Visit date', formatRecaptureDate(retailTextValue(recentAppointment && recentAppointment.start_at, '') || bdFastLastVisitDateValue(row))));
          facts.push(bdFastActionPanelFactMarkup('Check-in intent', activityText || 'No tracked check-in activity'));
          facts.push(bdFastActionPanelFactMarkup('Recommendation snapshot', snapshot ? 'Saved routine ready' : 'No saved routine snapshot'));
          facts.push(bdFastActionPanelFactMarkup('Recent retail history', retailTextValue(recentPurchase && recentPurchase.product_name, '') ? (retailTextValue(recentPurchase && recentPurchase.product_name, '') + ' on ' + formatRecaptureDate(retailTextValue(recentPurchase && recentPurchase.completed_at, ''))) : 'No recent product purchase found'));
          facts.push(bdFastActionPanelFactMarkup('Future appointment', bdFastFutureBookingText(row)));
        } else if (categoryKey === 'new_guest_no_prebook') {
          facts.push(bdFastActionPanelFactMarkup('First visit service', bdFastServiceLabelForSms(retailArray(recentAppointment && recentAppointment.service_names)) || retailTextValue(row && row.last_service_name, '')));
          facts.push(bdFastActionPanelFactMarkup('First visit date', formatRecaptureDate(retailTextValue(recentAppointment && recentAppointment.start_at, '') || bdFastLastVisitDateValue(row))));
          facts.push(bdFastActionPanelFactMarkup('Check-in engagement', activityText || 'No tracked check-in activity'));
          facts.push(bdFastActionPanelFactMarkup('Primary stylist', retailTextValue(row && row.primary_staff_name, '') || 'No stylist on file'));
          facts.push(bdFastActionPanelFactMarkup('Future appointment', bdFastFutureBookingText(row)));
        } else if (categoryKey === 'needs_booking') {
          facts.push(bdFastActionPanelFactMarkup('Last completed service', bdFastServiceLabelForSms(retailArray(recentAppointment && recentAppointment.service_names)) || retailTextValue(row && row.last_service_name, '')));
          facts.push(bdFastActionPanelFactMarkup('Last visit date', formatRecaptureDate(bdFastLastVisitDateValue(row))));
          facts.push(bdFastActionPanelFactMarkup('Normal cadence', safeSummary.cadenceLabel && safeSummary.cadenceDays > 0 ? (safeSummary.cadenceLabel + ' every ' + String(safeSummary.cadenceDays) + ' days') : 'No reliable cadence calculated yet'));
          facts.push(bdFastActionPanelFactMarkup('Due timing', bdFastDaysOverdue(row) > 0 ? (String(bdFastDaysOverdue(row)) + ' days overdue') : bdFastSimpleTimingText(row)));
          facts.push(bdFastActionPanelFactMarkup('Future appointment', bdFastFutureBookingText(row)));
          facts.push(bdFastActionPanelFactMarkup('Pattern break', bdFastHasRecentCancellationSignal(row, 30) ? 'Recent cancellation or no-show with no recovery booking' : (bdFastHasReliableCadence(row) ? 'Known cadence with no future booking' : 'Returning guest with no future booking')));
        } else if (categoryKey === 'never_visited') {
          facts.push(bdFastActionPanelFactMarkup('Attempted service', retailTextValue(row && row.last_service_name, '') || bdFastServiceLabelForSms(retailArray(recentAppointment && recentAppointment.service_names))));
          facts.push(bdFastActionPanelFactMarkup('Original appointment date', formatRecaptureDate(retailTextValue(row && row.latest_cancelled_at, '') || retailTextValue(row && row.latest_no_show_at, ''))));
          facts.push(bdFastActionPanelFactMarkup('Appointment outcome', retailTextValue(row && row.latest_no_show_at, '') ? 'No-show' : (retailTextValue(row && row.latest_cancelled_at, '') ? 'Cancelled' : 'Never completed')));
          facts.push(bdFastActionPanelFactMarkup('Prior outreach', bdFastPreviousOutreachText(row)));
          facts.push(bdFastActionPanelFactMarkup('Completed visit check', 'No completed visit found'));
        }
        return facts.filter(Boolean).join('');
      }

      function bdFastActionPanelLinkMarkup(summary, aiStrategy){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var row = safeSummary.row && typeof safeSummary.row === 'object' ? safeSummary.row : {};
        var categoryKey = retailTextValue(safeSummary.categoryKey, '') || bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var routineUrl = retailTextValue(safeSummary.routinePageUrl, '');
        var mode = bdFastOpportunityMode(row);
        if (categoryKey === 'wellness') {
          return '<div class="bd-fastActionLink"><span>hs.Wellness</span><a href="https://www.hairstories.com/pages/wellness" target="_blank" rel="noopener noreferrer">www.hairstories.com/pages/wellness</a></div>';
        }
        if ((categoryKey === 'retail' || mode === 'hybrid_growth') && routineUrl) {
          return '<div class="bd-fastActionLink"><span>Routine link</span><a href="' + escapeHtml(routineUrl) + '" target="_blank" rel="noopener noreferrer">' + escapeHtml(routineUrl) + '</a></div>';
        }
        if (categoryKey === 'needs_booking' || categoryKey === 'never_visited') {
          return '<div class="bd-fastActionLink"><span>Booking link</span><a href="https://www.hairstories.com" target="_blank" rel="noopener noreferrer">www.hairstories.com</a></div>';
        }
        return '';
      }

      function bdFastActionPanelOfferText(selectedRow, aiStrategy){
        var stateKey = bdFastOutreachStateKey(selectedRow);
        var outreachState = bdFastOutreachStateForRow(selectedRow);
        var selectedOfferKey = retailTextValue(outreachState && outreachState.offerKey, retailTextValue(aiStrategy && aiStrategy.offer_key, 'none') || 'none') || 'none';
        var selectedOfferOption = bdFastOfferOption(selectedOfferKey);
        var offerDecision = bdFastOfferDecisionDisplayLabel(aiStrategy && aiStrategy.offer_decision);
        if (selectedOfferOption && retailTextValue(selectedOfferOption.label, '') && retailTextValue(selectedOfferOption.label, '') !== 'No offer') {
          return ''
            + '<div class="bd-fastActionOfferRow">'
            +   '<strong>' + escapeHtml(retailTextValue(selectedOfferOption.label, 'Offer recommended')) + '</strong>'
            +   (retailTextValue(selectedOfferOption.boulevard_offer_code, '') ? '<span>Code ' + escapeHtml(retailTextValue(selectedOfferOption.boulevard_offer_code, '')) + '</span>' : '')
            + '</div>'
            + (bdFastAllowsOfferChoice(selectedRow)
              ? '<div class="bd-fastInlineOffer"><span>Offer</span><select class="progression-valueEditor" data-bd-fast-offer-select="' + escapeHtml(stateKey) + '">' + bdFastOfferSelectOptionsMarkup(selectedRow, selectedOfferKey) + '</select></div>'
              : '');
        }
        return ''
          + '<div class="bd-fastActionOfferRow">'
          +   '<strong>' + escapeHtml(offerDecision || 'No offer needed') + '</strong>'
          + '</div>'
          + (bdFastAllowsOfferChoice(selectedRow)
            ? '<div class="bd-fastInlineOffer"><span>Offer</span><select class="progression-valueEditor" data-bd-fast-offer-select="' + escapeHtml(stateKey) + '">' + bdFastOfferSelectOptionsMarkup(selectedRow, selectedOfferKey) + '</select></div>'
            : '');
      }

      function bdFastWhyContextSentence(summary, selectedRow){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        var row = selectedRow && typeof selectedRow === 'object' ? selectedRow : {};
        var recentAppointment = safeSummary.recentAppointment && typeof safeSummary.recentAppointment === 'object' ? safeSummary.recentAppointment : {};
        var futureAppointment = safeSummary.futureAppointment && typeof safeSummary.futureAppointment === 'object' ? safeSummary.futureAppointment : {};
        var activityBucket = getRetailActivityBucket(row);
        var activitySupport = bdFastCheckinActivitySupportText(activityBucket);
        var categoryKey = retailTextValue(safeSummary.categoryKey, '') || bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        var lastServiceLabel = bdFastServiceLabelForSms(retailArray(recentAppointment && recentAppointment.service_names)) || retailTextValue(row && row.last_service_name, '');
        var lastVisitLabel = retailTextValue(recentAppointment && recentAppointment.start_at, '') || bdFastLastVisitDateValue(row);
        var completedCount = Math.max(0, Number(safeSummary.completedCount) || 0);
        var cancelledLabel = retailTextValue(safeSummary.latestCancelledAt, '') || retailTextValue(safeSummary.latestNoShowAt, '');
        var futureBookingLabel = retailTextValue(futureAppointment && futureAppointment.start_at, '') || retailTextValue(row && row.future_appointment_at, '');
        var parts = [];
        if (safeSummary.hasActiveFutureAppointment === true && futureBookingLabel) {
          if (completedCount > 0) {
            parts.push(String(completedCount) + ' completed visit' + (completedCount === 1 ? '' : 's') + ' on record');
          } else {
            parts.push('No completed visit is on record yet');
          }
          if (lastServiceLabel) {
            parts.push('last known service: ' + lastServiceLabel);
          }
        } else if (categoryKey === 'never_visited') {
          if (cancelledLabel) {
            parts.push('Latest failed appointment was ' + formatRecaptureDate(cancelledLabel));
          } else {
            parts.push('No completed visit is on record yet');
          }
          if (lastServiceLabel) {
            parts.push('attempted service: ' + lastServiceLabel);
          }
        } else if (categoryKey === 'retail') {
          if (futureBookingLabel) {
            parts.push('Future appointment booked for ' + formatRecaptureDate(futureBookingLabel));
          }
          if (lastServiceLabel) {
            parts.push('last service: ' + lastServiceLabel);
          }
          if (completedCount > 0 && lastVisitLabel) {
            parts.push(String(completedCount) + ' completed visit' + (completedCount === 1 ? '' : 's') + ', most recent ' + formatRecaptureDate(lastVisitLabel));
          }
          if (activitySupport) {
            parts.push('check-in activity: ' + activitySupport);
          }
        } else {
          if (lastServiceLabel) {
            parts.push('last service: ' + lastServiceLabel);
          }
          if (completedCount > 0 && lastVisitLabel) {
            parts.push(String(completedCount) + ' completed visit' + (completedCount === 1 ? '' : 's') + ', most recent ' + formatRecaptureDate(lastVisitLabel));
          } else if (completedCount > 0) {
            parts.push(String(completedCount) + ' completed visit' + (completedCount === 1 ? '' : 's') + ' on record');
          }
          if (categoryKey === 'new_guest_no_prebook' && activitySupport) {
            parts.push('check-in activity: ' + activitySupport);
          }
        }
        parts = parts.filter(Boolean);
        if (!parts.length) return '';
        return parts.join('. ') + '.';
      }

      function bdFastRetailTagEditorMarkup(selectedRow){
        var mode = bdFastOpportunityMode(selectedRow);
        if (mode !== 'retail_growth' && mode !== 'hybrid_growth') return '';
        var stateKey = bdFastOutreachStateKey(selectedRow);
        var outreachState = bdFastOutreachStateForRow(selectedRow);
        var savedProductTags = bdFastManualRetailOverrideList(outreachState && outreachState.manualProductTags);
        var pickerState = bdFastRetailProductPickerState(stateKey);
        var selectedMarkup = savedProductTags.length
          ? '<div class="bd-fastProductPickerChips">' + savedProductTags.map(function(handle){
              return '<button class="bd-fastProductPickerChip" type="button" data-bd-fast-product-remove="' + escapeHtml(stateKey) + '" data-bd-fast-product-handle="' + escapeHtml(handle) + '"><span>' + escapeHtml(handle) + '</span><strong>×</strong></button>';
            }).join('') + '</div>'
          : '<div class="bd-fastDetailEmpty bd-fastDetailEmpty--inline">No direct products selected yet.</div>';
        return ''
          + '<div class="bd-fastActionSection">'
          +   '<span class="bd-fastActionLabel">Direct product tags</span>'
          +   '<p class="bd-fastActionHint">Search the live product catalog and click products to save them directly onto the appointment.</p>'
          +   '<div class="bd-fastProductPickerShell">'
          +     '<div class="bd-fastProductPickerHeader"><span class="bd-fastDetailMiniLabel">Find a product</span>' + (savedProductTags.length ? '<span class="bd-fastProductPickerCount">' + escapeHtml(String(savedProductTags.length)) + ' selected</span>' : '') + '</div>'
          +     '<div class="bd-fastProductPickerInputWrap">'
          +       '<span class="bd-fastProductPickerSearchGlyph" aria-hidden="true">⌕</span>'
          +       '<input class="progression-valueEditor bd-fastProductPickerInput" type="text" data-bd-fast-product-search="' + escapeHtml(stateKey) + '" value="' + escapeHtml(retailTextValue(pickerState.query, '')) + '" placeholder="Search by product name or handle">'
          +     '</div>'
          +     '<div class="bd-fastProductPickerSelected">'
          +       '<span class="bd-fastDetailMiniLabel">Selected products</span>'
          +       selectedMarkup
          +     '</div>'
          +     '<div class="bd-fastProductPickerResults" data-bd-fast-product-picker="' + escapeHtml(stateKey) + '"></div>'
          +   '</div>'
          + '</div>';
      }

      function bdFastSelectedClientIdentityMarkup(selectedRow){
        var safeRow = selectedRow && typeof selectedRow === 'object' ? selectedRow : {};
        return ''
          + '<div class="bd-fastWorkbenchIdentity">'
          +   '<div>'
          +     '<span class="bd-fastSectionEyebrow">' + escapeHtml(bdFastIsActionHistoryRow(safeRow) ? 'Action History' : 'Selected Opportunity') + '</span>'
          +     '<h3>' + escapeHtml(retailTextValue(safeRow && safeRow.guest_name, 'Unknown guest')) + '</h3>'
          +   '</div>'
          + '</div>';
      }

      function bdFastLoadingPanelMarkup(selectedRow, message){
        return ''
          + bdFastSelectedClientIdentityMarkup(selectedRow)
          + '<div class="bd-fastLoadingState" role="status" aria-live="polite">'
          +   '<span class="bd-fastLoadingSpinner" aria-hidden="true"></span>'
          +   '<p>' + escapeHtml(retailTextValue(message, 'Loading…')) + '</p>'
          + '</div>';
      }

      async function loadBdFastAiStrategyForRow(row){
        var key = retailTextValue(row && row.opportunity_key, '');
        var state = bdFastDetailState(row);
        var categoryKey = bdFastOpportunityCategoryKey(row, false) || retailTextValue((bdFastCategoryMeta(row) || {}).key, '');
        if (!key || !state || !state.detail) return;
        if (categoryKey !== 'needs_booking' && categoryKey !== 'never_visited' && categoryKey !== 'wellness') return;
        if (state.aiStrategyLoading === true || state.aiStrategy) return;
        var summary = bdFastStrategySummary(row, state);
        if (!summary) return;
        state.aiStrategyLoading = true;
        state.aiStrategyError = '';
        renderBdFastQueue();
        try {
          var result = await fetchBdFastAiStrategy(summary);
          state.aiStrategyLoading = false;
          state.aiStrategyError = '';
          state.aiStrategy = result && result.strategy ? result.strategy : null;
          if (state.aiStrategy) {
            bdFastPersistOutreachState(key, {
              offerKey: retailTextValue(state.aiStrategy.offer_key, 'none') || 'none',
              draftBody: retailTextValue(state.aiStrategy.sms_message, ''),
              reviewed: false
            });
          }
          renderBdFastQueue();
        } catch (error) {
          state.aiStrategyLoading = false;
          state.aiStrategyError = humanizeClientFetchErrorMessage(error, 'Could not generate the strategy SMS.');
          renderBdFastQueue();
        }
      }

      function bdFastStrategyPanelMarkup(selectedRow, state){
        if (!selectedRow) {
          return '<div class="bd-fastDetailEmpty">Select a guest to review the opportunity, edit the message, and send the SMS.</div>';
        }
        if (!state) {
          return bdFastLoadingPanelMarkup(selectedRow, 'Loading the selected client…');
        }
        if (bdFastLaneIsActedOnRow(selectedRow, bdFastCurrentLane())) {
          var sentMessageBody = retailTextValue(selectedRow && (selectedRow.last_outreach_message || selectedRow.last_outreach_message_body || selectedRow.message_body), '');
          return ''
            + bdFastSelectedClientIdentityMarkup(selectedRow)
            + '<div class="bd-fastActionSection"><span class="bd-fastActionLabel">Message sent</span><p class="bd-fastActionBody">' + escapeHtml(sentMessageBody || 'No stored SMS body found for this action.') + '</p></div>'
            + '<div class="bd-fastActionSection"><span class="bd-fastActionLabel">Outcome</span>' + bdFastActedOnSummaryMarkup(selectedRow, state) + '</div>';
        }
        var detailLoading = state.loading === true || bdFastDetailLoadingKey === retailTextValue(selectedRow && selectedRow.opportunity_key, '');
        if (detailLoading) {
          return bdFastLoadingPanelMarkup(selectedRow, 'Loading client detail…');
        }
        if (state.error) {
          return '<div class="bd-fastDetailEmpty">' + escapeHtml(state.error) + '</div>';
        }
        var summary = bdFastStrategySummary(selectedRow, state);
        if (!summary) {
          return '<div class="bd-fastDetailEmpty">No SMS is available for this row yet.</div>';
        }
        var categoryKey = retailTextValue(summary.categoryKey, '') || bdFastOpportunityCategoryKey(summary.row, false) || retailTextValue((bdFastCategoryMeta(summary.row) || {}).key, '');
        var shouldUseAiStrategy = categoryKey === 'needs_booking' || categoryKey === 'never_visited' || categoryKey === 'wellness';
        var aiStrategy = state && state.aiStrategy && typeof state.aiStrategy === 'object' ? state.aiStrategy : {};
        var aiLoading = shouldUseAiStrategy && state && state.aiStrategyLoading === true;
        if (aiLoading) {
          return bdFastLoadingPanelMarkup(selectedRow, 'Thinking through the strategy…');
        }
        var strategyLabel = bdFastStrategyDisplayLabel(aiStrategy.message_strategy);
        strategyLabel = strategyLabel ? strategyLabel.replace(/\b\w/g, function(match){ return match.toUpperCase(); }) : '';
        var situationSummary = retailTextValue(aiStrategy.situation_summary, '');
        var smsMessage = retailTextValue(aiStrategy.sms_message, '') || bdFastStrategySmsMessage(summary);
        var outreachEligible = aiStrategy.eligible_for_outreach !== false;
        var ineligibleReason = retailTextValue(aiStrategy.ineligible_reason, '');
        var supportingSignals = retailArray(aiStrategy.supporting_signals).map(function(value){
          return retailTextValue(value, '');
        }).filter(Boolean);
        var outreachState = bdFastOutreachStateForRow(selectedRow);
        var stateKey = bdFastOutreachStateKey(selectedRow);
        var currentDraft = outreachEligible ? (retailTextValue(outreachState && outreachState.draftBody, '') || smsMessage) : '';
        var charCount = currentDraft.length;
        var whyText = summary.whyNow || situationSummary || 'Open the client detail to review the factual history behind this opportunity.';
        var strategyText = strategyLabel || summary.nextMove;
        var signalText = supportingSignals.length ? supportingSignals.slice(0, 3).join(' • ') : summary.smsAngle;
        var hasDraft = !!retailTextValue(currentDraft, '');
        var detailMarkup = bdFastDetailContentMarkup(selectedRow, state);
        var offerMarkup = bdFastActionPanelOfferText(selectedRow, aiStrategy);
        var factsMarkup = bdFastActionPanelFactsMarkup(summary, state);
        var whyContextSentence = bdFastWhyContextSentence(summary, selectedRow);
        var composerStatusText = shouldUseAiStrategy ? 'Personalized from appointment history' : 'Built from durable client history';
        return ''
          + '<div class="bd-fastActionPanel" data-bd-fast-outreach="' + escapeHtml(stateKey) + '">'
          +   bdFastSelectedClientIdentityMarkup(selectedRow)
          +   '<div class="bd-fastWhyCard"><div class="bd-fastWhyCardHead"><span class="bd-fastWhyIcon">✦</span><span class="bd-fastActionLabel">Why this guest</span></div><p class="bd-fastActionBody"><strong>' + escapeHtml(bdFastStrategyReasonTitle(summary)) + '</strong></p><p class="bd-fastActionHint">' + escapeHtml(whyText) + '</p>' + (whyContextSentence ? '<p class="bd-fastActionHint bd-fastActionHint--context">' + escapeHtml(whyContextSentence) + '</p>' : '') + '</div>'
          +   bdFastOpportunitySetMarkup(selectedRow)
          +   (factsMarkup ? '<div class="bd-fastActionSection"><span class="bd-fastActionLabel">Snapshot</span><div class="bd-fastActionFacts">' + factsMarkup + '</div></div>' : '')
          +   (offerMarkup ? '<div class="bd-fastActionSection"><span class="bd-fastActionLabel">Offer decision</span>' + offerMarkup + '</div>' : '')
          +   bdFastRetailTagEditorMarkup(selectedRow)
          +   '<div class="bd-fastActionSection bd-fastStrategyRow"><div><span class="bd-fastActionLabel">Recommended approach</span><p class="bd-fastActionBody">' + escapeHtml(strategyText) + '</p>' + (signalText ? '<p class="bd-fastActionHint">' + escapeHtml(signalText) + '</p>' : '') + (!outreachEligible && ineligibleReason ? '<p class="bd-fastActionHint">' + escapeHtml(ineligibleReason) + '</p>' : '') + '</div></div>'
          +   '<div class="bd-fastComposerCard">'
          +     '<div class="bd-fastComposerHead"><span class="bd-fastActionLabel">Message</span><span class="bd-fastComposerCount">' + escapeHtml(String(charCount)) + '/320</span></div>'
          +     bdFastActionPanelLinkMarkup(summary, aiStrategy)
          +     '<textarea class="retail-draftEditor bd-fastDraftEditor" data-bd-fast-draft-editor="' + escapeHtml(stateKey) + '" placeholder="Draft a message to review before sending.">' + escapeHtml(currentDraft) + '</textarea>'
          +     '<div class="bd-fastComposerFoot"><span>' + escapeHtml(composerStatusText) + '</span></div>'
          +   '</div>'
          +   '<div class="bd-fastComposeActions bd-fastComposeActions--footer">'
          +       '<button class="btn-primary" type="button" data-bd-fast-action="send" data-bd-fast-row-key="' + escapeHtml(stateKey) + '"' + (hasDraft ? '' : ' disabled') + '>Send SMS</button>'
          +     '</div>'
          +     '<p class="bd-fastComposerNote">After sending, this guest moves to Action History and the next guest opens automatically.</p>'
          +     (state && state.aiStrategyError ? '<p>' + escapeHtml(state.aiStrategyError) + '</p>' : '')
          +     (state && state.error ? '<p>' + escapeHtml(state.error) + '</p>' : '')
          +   '<div class="bd-fastActionSection"><span class="bd-fastActionLabel">Client detail</span>' + detailMarkup + '</div>'
          + '</div>';
      }

      function renderBdFastClaimedList(){
        var selectedRow = retailArray(bdFastAllRows).find(function(row){
          return retailTextValue(row && row.opportunity_key, '') === bdFastSelectedOpportunityKey;
        }) || null;
        var state = selectedRow ? bdFastDetailState(selectedRow) : null;
        if (bdFastDetailTitle) {
          bdFastDetailTitle.textContent = bdFastIsHistoryView() ? 'Action History' : 'Client Action Panel';
        }
        if (bdFastDetailSummary) {
          bdFastDetailSummary.textContent = selectedRow
            ? (bdFastIsHistoryView() ? 'Review the sent message and the recorded outcome.' : 'Review the opportunity, edit the message, and send.')
            : (bdFastIsHistoryView() ? 'Select a completed action to review its outcome.' : 'Select a guest to review the opportunity and send the message.');
        }
        if (!bdFastDetailPanel) return;
        bdFastDetailPanel.innerHTML = bdFastStrategyPanelMarkup(selectedRow, state);
        if (selectedRow && bdFastOpportunityMode(selectedRow) === 'retail_growth') {
          renderBdFastRetailProductPickerSuggestions(bdFastOutreachStateKey(selectedRow));
        }
      }

      function renderBdFastQueue(){
        bdFastApplyFilters();
        bdFastPersistCurrentModeState();
        renderBdFastModeTabs();
        renderBdFastSelectionState();
        var pageRows = bdFastPageRows();
        if (bdFastCount) {
          var loadedCount = Math.max(bdFastLoadedRowCount, bdFastAllRows.length);
          var totalEstimate = Math.max(bdFastTotalRowEstimate, loadedCount);
          bdFastCount.textContent = bdFastAllRowsLoaded
            ? String(bdFastFilteredRows.length) + (bdFastIsHistoryView() ? ' actions' : ' opportunities')
            : String(bdFastFilteredRows.length) + (bdFastIsHistoryView() ? ' actions' : ' opportunities') + ' (' + String(loadedCount) + '/' + String(totalEstimate || loadedCount) + ' loaded)';
        }
        if (bdFastCountHint) {
          bdFastCountHint.textContent = bdFastIsHistoryView()
            ? 'Worked BD Fast rows live here after sends, hides, and recorded outcomes.'
            : (bdFastAllRowsLoaded
                ? 'Search and sorting cover the full active queue.'
                : 'Showing the first rows now while the rest loads in the background.');
        }
        if (bdFastLaneTitle) {
          bdFastLaneTitle.textContent = bdFastIsHistoryView() ? 'Action History' : 'Open Opportunities';
        }
        if (bdFastLaneDescription) {
          bdFastLaneDescription.textContent = bdFastLaneWorkspaceDescription(bdFastIsHistoryView() ? 'acted_on' : BD_FAST_ACTIVE_VIEW_KEY);
        }
        if (bdFastLaneCountPill) {
          bdFastLaneCountPill.textContent = bdFastLaneCountPillText();
        }
        if (bdFastSummary) {
          bdFastSummary.textContent = bdFastSummaryText();
        }
        if (bdFastList) {
          bdFastList.innerHTML = pageRows.length
            ? pageRows.map(bdFastCardMarkup).join('')
            : '<div class="retail-empty">' + escapeHtml(bdFastIsHistoryView() ? 'No completed outreach actions match the current filters.' : 'No active opportunities match the current filters.') + '</div>';
        }
        if (bdFastPrevBtn) bdFastPrevBtn.disabled = bdFastPage <= 0;
        if (bdFastNextBtn) bdFastNextBtn.disabled = ((bdFastPage + 1) * bdFastPageSize) >= bdFastFilteredRows.length;
        if (bdFastPageLabel) bdFastPageLabel.textContent = 'Page ' + String(bdFastPage + 1);
        renderBdFastClaimedList();
      }

      function mergeBdFastRows(pageRows){
        bdFastAllRows = mergePriorityRowsByOpportunityKey(bdFastAllRows, retailArray(pageRows));
        bdFastLoadedRowCount = bdFastAllRows.length;
        bdFastPersistCurrentModeState();
      }

      function bdFastApplyModeStateToGlobals(mode){
        var state = bdFastReadModeState(mode);
        bdFastAllRows = retailArray(state.allRows).slice();
        bdFastFilteredRows = retailArray(state.filteredRows).slice();
        bdFastAllRowsLoaded = state.allRowsLoaded === true;
        bdFastLoadedRowCount = Math.max(0, Number(state.loadedRowCount) || 0);
        bdFastTotalRowEstimate = Math.max(0, Number(state.totalRowEstimate) || 0);
        bdFastPage = Math.max(0, Number(state.page) || 0);
        hasLoadedDueQueueFast = state.hasLoaded === true;
        return state;
      }

      async function bdFastLoadModeFully(mode, options){
        var requestedMode = String(mode || 'all').trim() || 'all';
        var opts = options && typeof options === 'object' ? options : {};
        var announce = opts.announce !== false;
        var resetState = opts.reset !== false;
        var modeState = bdFastReadModeState(requestedMode);
        if (!resetState && modeState.hasLoaded === true && modeState.allRowsLoaded === true && retailArray(modeState.allRows).length) {
          return modeState;
        }
        modeState.loadRequestId = Math.max(0, Number(modeState.loadRequestId) || 0) + 1;
        modeState.loading = true;
        modeState.error = '';
        if (resetState) {
          modeState.allRows = [];
          modeState.filteredRows = [];
          modeState.allRowsLoaded = false;
          modeState.loadedRowCount = 0;
          modeState.totalRowEstimate = 0;
          modeState.page = 0;
          modeState.hasLoaded = false;
        }
        var loadRequestId = modeState.loadRequestId;
        var nextOffset = Math.max(0, Number(modeState.loadedRowCount) || 0);
        var firstPage = true;
        while (loadRequestId === modeState.loadRequestId) {
          var pageSize = firstPage ? 250 : 500;
          if (announce) {
            setBdFastStatus('Loading full fast queue…', 'info');
          }
          var result = await fetchBdFastQueuePage(requestedMode, pageSize, nextOffset);
          if (loadRequestId !== modeState.loadRequestId) return modeState;
          var pageRows = retailArray(result && result.rows);
          if (!pageRows.length) {
            modeState.allRowsLoaded = true;
            modeState.loading = false;
            modeState.hasLoaded = true;
            modeState.error = '';
            return modeState;
          }
          modeState.allRows = bdFastMergeRows(modeState.allRows, pageRows);
          modeState.loadedRowCount = modeState.allRows.length;
          queueCheckinActivityFetch(pageRows);
          var summary = result && result.summary ? result.summary : {};
          modeState.totalRowEstimate = Math.max(
            modeState.totalRowEstimate,
            Number(summary && (summary.total_snapshot_rows || summary.filtered_total_rows)) || 0,
            modeState.loadedRowCount
          );
          modeState.hasLoaded = modeState.loadedRowCount > 0;
          modeState.error = '';
          if (pageRows.length < pageSize || (modeState.totalRowEstimate > 0 && modeState.loadedRowCount >= modeState.totalRowEstimate) || nextOffset > 25000) {
            modeState.allRowsLoaded = true;
            modeState.loading = false;
            modeState.hasLoaded = true;
            return modeState;
          }
          nextOffset += pageRows.length;
          firstPage = false;
        }
        return modeState;
      }

      async function loadBdFastAllLaneData(options){
        var opts = options && typeof options === 'object' ? options : {};
        var targetMode = bdFastLaneFetchMode(bdFastCurrentLane());
        var existingState = bdFastReadModeState(targetMode);
        var visibleGlobalsMatchTarget = bdFastRowsMatchMode(bdFastAllRows, targetMode) && retailArray(bdFastAllRows).length > 0;
        var keepVisible = (opts.clearUi === false && visibleGlobalsMatchTarget)
          || bdFastStateHasRenderableRows(existingState)
          || visibleGlobalsMatchTarget;
        if (bdFastBootstrapPromise) return bdFastBootstrapPromise;
        bdFastBootstrapPromise = (async function(){
          setBdFastShellState(keepVisible ? 'ready' : 'loading');
          setBdFastStatus(
            keepVisible
              ? 'Refreshing the fast queue in the background…'
              : 'Loading the first queue rows…',
            'info'
          );
          if (bdFastList && opts.clearUi !== false && !keepVisible) {
            bdFastList.innerHTML = '<div class="retail-empty">Loading the first queue rows…</div>';
          }
          await loadBdFastQueue(targetMode, opts);
          if (bdFastMode) bdFastMode.value = bdFastIsHistoryView() ? 'acted_on' : BD_FAST_ACTIVE_VIEW_KEY;
          bdFastApplyModeStateToGlobals(targetMode);
          setBdFastShellState(bdFastAllRowsLoaded ? 'ready' : 'loading');
          setBdFastStatus(
            bdFastAllRowsLoaded
              ? 'Fast queue ready.'
              : 'Showing the first rows now. Loading the rest in the background…',
            bdFastAllRowsLoaded ? 'success' : 'info'
          );
          renderBdFastQueue();
          loadBdFastScorecard().catch(function(){});
          fetchBdFastRefreshStatusV4().then(function(statusResult){
            updateBdFastLastRefreshValue(statusResult && statusResult.summary, statusResult && statusResult.refresh_progress);
          }).catch(function(){});
          loadBdFastQueue('acted_on_actions', { clearUi: false, reset: true, forceRefresh: true }).catch(function(){});
          hasLoadedDueQueueFast = true;
        })().catch(function(error){
          setBdFastShellState('error');
          setBdFastStatus(humanizeClientFetchErrorMessage(error, 'Could not load the fast queue.'), 'error');
          throw error;
        }).finally(function(){
          bdFastBootstrapPromise = null;
        });
        return bdFastBootstrapPromise;
      }

      async function continueBdFastQueueLoad(mode, loadRequestId, offset, pageSize){
        var requestedMode = String(mode || 'all').trim() || 'all';
        var modeState = bdFastReadModeState(requestedMode);
        var nextOffset = Math.max(0, Number(offset) || 0);
        var safePageSize = Math.max(50, Number(pageSize) || 500);
        while (loadRequestId === modeState.loadRequestId) {
          var result = await fetchBdFastQueuePage(requestedMode, safePageSize, nextOffset);
          if (loadRequestId !== modeState.loadRequestId) return;
          var pageRows = retailArray(result && result.rows);
          if (!pageRows.length) {
            modeState.allRowsLoaded = true;
            modeState.loading = false;
            modeState.hasLoaded = true;
            modeState.error = '';
            if (bdFastModeIsActive(requestedMode)) {
              bdFastApplyModeStateToGlobals(requestedMode);
              setBdFastShellState('ready');
              setBdFastStatus('Fast queue ready.', 'success');
              renderBdFastQueue();
            }
            return;
          }
          modeState.allRows = bdFastMergeRows(modeState.allRows, pageRows);
          modeState.loadedRowCount = modeState.allRows.length;
          queueCheckinActivityFetch(pageRows);
          var summary = result && result.summary ? result.summary : {};
          modeState.totalRowEstimate = Math.max(
            modeState.totalRowEstimate,
            Number(summary && (summary.total_snapshot_rows || summary.filtered_total_rows)) || 0,
            modeState.loadedRowCount
          );
          modeState.hasLoaded = modeState.loadedRowCount > 0;
          modeState.error = '';
          if (bdFastModeIsActive(requestedMode)) {
            bdFastApplyModeStateToGlobals(requestedMode);
            setBdFastStatus('Loading more queue rows in the background… (' + String(modeState.loadedRowCount) + ' loaded)', 'info');
            renderBdFastQueue();
          }
          if (pageRows.length < safePageSize) {
            modeState.allRowsLoaded = true;
            modeState.loading = false;
            modeState.hasLoaded = true;
            if (bdFastModeIsActive(requestedMode)) {
              bdFastApplyModeStateToGlobals(requestedMode);
              setBdFastShellState('ready');
              setBdFastStatus('Fast queue ready.', 'success');
              renderBdFastQueue();
            }
            return;
          }
          nextOffset += pageRows.length;
          if (nextOffset > 25000) {
            modeState.allRowsLoaded = true;
            modeState.loading = false;
            modeState.hasLoaded = true;
            if (bdFastModeIsActive(requestedMode)) {
              bdFastApplyModeStateToGlobals(requestedMode);
              setBdFastShellState('ready');
              setBdFastStatus('Fast queue loaded to the current safety cap.', 'success');
              renderBdFastQueue();
            }
            return;
          }
        }
      }

      async function loadBdFastQueue(modeOverride, options){
        var requestedMode = String(modeOverride || 'all').trim() || 'all';
        var opts = options && typeof options === 'object' ? options : {};
        var preserveVisibleRows = opts.clearUi === false && bdFastRowsMatchMode(bdFastAllRows, requestedMode);
        var forceRefresh = opts.forceRefresh === true;
        var shouldReset = opts.reset !== false;
        if (bdFastAllModeDataReady()) {
          var readyState = preserveVisibleRows
            ? bdFastReadModeState(requestedMode)
            : bdFastRestoreModeState(requestedMode);
          if (bdFastModeIsActive(requestedMode)) {
            if (preserveVisibleRows || bdFastStateHasRenderableRows(readyState)) {
              bdFastApplyModeStateToGlobals(requestedMode);
            }
            setBdFastShellState('ready');
            setBdFastStatus('Fast queue ready.', 'success');
            renderBdFastQueue();
          }
          return readyState;
        }
        var cachedState = preserveVisibleRows
          ? bdFastReadModeState(requestedMode)
          : bdFastRestoreModeState(requestedMode);
        if (!forceRefresh && cachedState.hasLoaded === true && retailArray(cachedState.allRows).length && bdFastStateMatchesMode(cachedState, requestedMode)) {
          if (bdFastModeIsActive(requestedMode)) {
            bdFastApplyModeStateToGlobals(requestedMode);
            setBdFastShellState('ready');
            setBdFastStatus('Fast queue ready.', 'success');
            renderBdFastQueue();
          }
          return;
        }
        if (!forceRefresh && cachedState.loading === true && cachedState.loadRequestId > 0) {
          if (bdFastModeIsActive(requestedMode)) {
            if (!preserveVisibleRows || bdFastStateHasRenderableRows(cachedState)) {
              bdFastApplyModeStateToGlobals(requestedMode);
            }
            setBdFastShellState(bdFastStateHasRenderableRows(cachedState) ? 'ready' : 'loading');
            setBdFastStatus('Loading the queue…', 'info');
            renderBdFastQueue();
          }
          return;
        }
        cachedState.loadRequestId = Math.max(0, Number(cachedState.loadRequestId) || 0) + 1;
        cachedState.loading = true;
        cachedState.error = '';
        var loadRequestId = cachedState.loadRequestId;
        var firstPageSize = 250;
        var backgroundPageSize = 500;
        if (shouldReset || forceRefresh) {
          cachedState.allRows = [];
          cachedState.filteredRows = [];
          cachedState.allRowsLoaded = false;
          cachedState.loadedRowCount = 0;
          cachedState.totalRowEstimate = 0;
          cachedState.page = 0;
          cachedState.hasLoaded = false;
        }
        if (bdFastModeIsActive(requestedMode)) {
          var hasRenderableRows = bdFastStateHasRenderableRows(cachedState)
            || (bdFastRowsMatchMode(bdFastAllRows, requestedMode) && retailArray(bdFastAllRows).length > 0);
          setBdFastShellState((!shouldReset && hasRenderableRows) || preserveVisibleRows ? 'ready' : 'loading');
          setBdFastStatus(
            (((!shouldReset && !forceRefresh) && hasRenderableRows) || preserveVisibleRows)
              ? ('Refreshing ' + bdFastLaneLabel(bdFastCurrentLane()) + ' in the background…')
              : ('Loading ' + bdFastLaneLabel(bdFastCurrentLane()) + '…'),
            'info'
          );
          if (!preserveVisibleRows && (shouldReset || forceRefresh)) {
            bdFastAllRows = [];
            bdFastFilteredRows = [];
            bdFastOutreachState = {};
            bdFastSelectedOpportunityKey = '';
            bdFastSelectedRows = {};
            bdFastSmsQueueOrder = [];
            bdFastPage = 0;
            bdFastAllRowsLoaded = false;
            bdFastLoadedRowCount = 0;
            bdFastTotalRowEstimate = 0;
          }
          if (bdFastList && !preserveVisibleRows && shouldReset && !hasRenderableRows) {
            bdFastList.innerHTML = '<div class="retail-empty">Loading the first rows…</div>';
          }
        }
        try {
          var result = await fetchBdFastQueuePage(requestedMode, firstPageSize, 0);
          if (loadRequestId !== cachedState.loadRequestId) return;
          cachedState.allRows = bdFastMergeRows(cachedState.allRows, result && result.rows);
          cachedState.loadedRowCount = cachedState.allRows.length;
          queueCheckinActivityFetch(result && result.rows);
          var summary = result && result.summary ? result.summary : {};
          cachedState.totalRowEstimate = Math.max(
            Number(summary && (summary.total_snapshot_rows || summary.filtered_total_rows)) || 0,
            cachedState.loadedRowCount
          );
          cachedState.hasLoaded = cachedState.loadedRowCount > 0;
          if (bdFastModeIsActive(requestedMode)) {
            bdFastApplyModeStateToGlobals(requestedMode);
            setBdFastShellState('ready');
            setBdFastStatus(
            cachedState.loadedRowCount >= cachedState.totalRowEstimate && cachedState.totalRowEstimate > 0
              ? 'Fast queue ready.'
              : 'Showing the first rows now. Loading the rest in the background…',
            cachedState.loadedRowCount >= cachedState.totalRowEstimate && cachedState.totalRowEstimate > 0 ? 'success' : 'info'
            );
            renderBdFastQueue();
          }
          if (cachedState.loadedRowCount < firstPageSize || (cachedState.totalRowEstimate > 0 && cachedState.loadedRowCount >= cachedState.totalRowEstimate)) {
            cachedState.allRowsLoaded = true;
            cachedState.loading = false;
            cachedState.hasLoaded = true;
            if (bdFastModeIsActive(requestedMode)) {
              bdFastApplyModeStateToGlobals(requestedMode);
              setBdFastStatus('Fast queue ready.', 'success');
              renderBdFastQueue();
            }
            return;
          }
          window.setTimeout(function(){
            continueBdFastQueueLoad(requestedMode, loadRequestId, cachedState.loadedRowCount, backgroundPageSize).catch(function(error){
              if (loadRequestId !== cachedState.loadRequestId) return;
              cachedState.loading = false;
              cachedState.error = humanizeClientFetchErrorMessage(error, 'Loaded the first rows, but background queue loading stopped.');
              if (bdFastModeIsActive(requestedMode)) {
                bdFastApplyModeStateToGlobals(requestedMode);
                setBdFastShellState('ready');
                setBdFastStatus(cachedState.error, 'error');
                renderBdFastQueue();
              }
            });
          }, 0);
        } catch (error) {
          cachedState.loading = false;
          cachedState.error = humanizeClientFetchErrorMessage(error, 'Could not load the fast queue.');
          if (bdFastModeIsActive(requestedMode)) {
            setBdFastShellState('error');
            setBdFastStatus(cachedState.error, 'error');
            if (bdFastList) {
              bdFastList.innerHTML = '<div class="retail-empty">Could not load the fast queue right now.</div>';
            }
          }
        }
      }

      async function ensureDueQueueFastLoaded(){
        var targetMode = bdFastLaneFetchMode(bdFastCurrentLane());
        var targetState = bdFastReadModeState(targetMode);
        if (bdFastAllModeDataReady()) {
          bdFastRestoreModeState(bdFastLaneFetchMode(bdFastCurrentLane()));
          renderBdFastQueue();
          return;
        }
        if ((targetState.loading === true || targetState.hasLoaded === true || bdFastStateHasRenderableRows(targetState)) && bdFastStateMatchesMode(targetState, targetMode)) {
          bdFastApplyModeStateToGlobals(targetMode);
          renderBdFastQueue();
          return;
        }
        await loadBdFastAllLaneData({ reset: true, clearUi: false, forceRefresh: true });
      }

      async function fetchAllLikelyDueClientsPaged(overrides, options){
        var pageSize = 250;
        var opts = options && typeof options === 'object' ? options : {};
        var offset = Math.max(0, Number(opts.startOffset) || 0);
        var maxPages = Math.max(1, Number(opts.maxPages) || 1);
        var pageCount = 0;
        var firstResult = null;
        var mergedRows = [];
        var seenOpportunityKeys = new Set();
        var allPagesLoaded = false;
        while (pageCount < maxPages) {
          var pageResult = await fetchLikelyDueClients(pageSize, offset, overrides);
          if (!firstResult) firstResult = pageResult;
          var pageRows = retailArray(pageResult && pageResult.rows);
          pageRows.forEach(function(row){
            var opportunityKey = retailTextValue(row && row.opportunity_key, '') || buildPriorityOpportunityKey(row);
            if (opportunityKey && seenOpportunityKeys.has(opportunityKey)) return;
            if (opportunityKey) seenOpportunityKeys.add(opportunityKey);
            mergedRows.push(row);
          });
          pageCount += 1;
          if (!pageRows.length) {
            allPagesLoaded = true;
            break;
          }
          offset += pageRows.length;
          if (pageRows.length < pageSize) {
            allPagesLoaded = true;
            break;
          }
        }
        if (!firstResult) {
          return { ok: true, rows: [], summary: {}, all_pages_loaded: true };
        }
        return Object.assign({}, firstResult, {
          rows: mergedRows,
          all_pages_loaded: allPagesLoaded
        });
      }

      function dueAppointmentQueueRows(rows){
        return retailArray(rows).filter(function(row){
          return retailTextValue(row && row.queue_source, '') === 'appointment';
        });
      }

      function dueNonAppointmentQueueRows(rows){
        return retailArray(rows).filter(function(row){
          return retailTextValue(row && row.queue_source, '') !== 'appointment';
        });
      }

      async function fetchUnifiedBusinessPriorityQueue(options){
        var opts = options && typeof options === 'object' ? options : {};
        var existingRows = retailArray(opts.existingRows);
        var appendAppointmentPage = opts.appendAppointmentPage === true;
        var existingSummary = appendAppointmentPage && dueQueueSummary && typeof dueQueueSummary === 'object'
          ? dueQueueSummary
          : null;
        var existingAppointmentRows = appendAppointmentPage ? dueAppointmentQueueRows(existingRows) : [];
        var existingNonAppointmentRows = appendAppointmentPage ? dueNonAppointmentQueueRows(existingRows) : [];
        var guestSearch = '';
        var selectedBusinessBucketKey = dueWorkspaceBackendBucketKey(dueQueueWorkspace);
        var appointmentRequestOverrides = {
          queue_stage: '',
          guest_search: '',
          staff_name: '',
          business_bucket_key: selectedBusinessBucketKey,
          sort_by: dueQueueSortMode === 'due_soonest' ? 'days_until_due' : 'priority_score',
          sort_direction: dueQueueSortMode === 'due_soonest' ? 'asc' : 'desc'
        };
        var appointmentSummaryResult = await fetchAllLikelyDueClientsPaged(appointmentRequestOverrides, {
          maxPages: opts.fullHydrate === true ? 40 : 1,
          startOffset: appendAppointmentPage ? existingAppointmentRows.length : 0
        });
        var datasetResults = appendAppointmentPage
          ? []
          : await Promise.allSettled([
              fetchRetailFollowupOpportunitiesForBusinessDevelopment(),
              fetchReviewOpportunities(),
              fetchReferralOpportunities(),
              fetchBusinessDevelopmentScorecard().catch(function(){
                return null;
              })
            ]);
        function settledValueAt(index, fallback){
          var entry = datasetResults[index];
          return entry && entry.status === 'fulfilled' ? entry.value : fallback;
        }
        var appointmentSummary = duePickBestSummary(
          appointmentSummaryResult && appointmentSummaryResult.summary,
          appointmentSummaryResult && appointmentSummaryResult.snapshot && appointmentSummaryResult.snapshot.payload && appointmentSummaryResult.snapshot.payload.summary
        );
        var appointmentDebugCounts = appointmentSummary.debug_counts && typeof appointmentSummary.debug_counts === 'object'
          ? appointmentSummary.debug_counts
          : {};
        var appointmentTotalCount = dueSummaryActionableAppointmentCount(appointmentSummary);
        var retailDashboard = appendAppointmentPage ? { rows: existingNonAppointmentRows.filter(function(row){
          return retailTextValue(row && row.queue_source, '') === 'retail';
        }) } : settledValueAt(0, { rows: [] });
        var reviewDashboard = appendAppointmentPage ? { rows: existingNonAppointmentRows.filter(function(row){
          return retailTextValue(row && row.queue_source, '') === 'review';
        }) } : settledValueAt(1, { rows: [] });
        var referralDashboard = appendAppointmentPage ? { rows: existingNonAppointmentRows.filter(function(row){
          return retailTextValue(row && row.queue_source, '') === 'referral';
        }) } : settledValueAt(2, { rows: [] });
        var scorecardSummary = appendAppointmentPage ? (dueQueueSummary && dueQueueSummary.unified_scorecard ? dueQueueSummary.unified_scorecard : null) : settledValueAt(3, null);
        var fetchedAppointmentRows = retailArray(appointmentSummaryResult && appointmentSummaryResult.rows).map(function(row){
          return row && typeof row === 'object'
            ? Object.assign({ queue_source: 'appointment', opportunity_key: 'appointment:' + retailTextValue(row && row.guest_bucket_key, '') }, row)
            : row;
        });
        var appointmentRows = appendAppointmentPage
          ? mergePriorityRowsByOpportunityKey(existingAppointmentRows, fetchedAppointmentRows)
          : fetchedAppointmentRows;
        var retailRows = retailArray(retailDashboard && retailDashboard.rows)
          .filter(function(row){
            return row && (appendAppointmentPage || row.followup_ready === true);
          })
          .map(function(row){
            return appendAppointmentPage ? row : normalizeRetailPriorityQueueRow(row);
          });
        var reviewRows = retailArray(reviewDashboard && reviewDashboard.rows)
          .map(function(row){
            return appendAppointmentPage ? row : normalizeReviewPriorityQueueRow(row);
          });
        var referralRows = retailArray(referralDashboard && referralDashboard.rows)
          .map(function(row){
            return appendAppointmentPage ? row : normalizeReferralPriorityQueueRow(row);
          });
        var allAppointmentOpportunityRows = mergePriorityRowsByOpportunityKey(appointmentRows);
        var allOpportunityRows = mergePriorityRowsByOpportunityKey(
          allAppointmentOpportunityRows,
          retailRows.concat(reviewRows, referralRows)
        );
        var appointmentBucketCounts = dueSummaryBusinessBucketCounts(appointmentSummary);
        var allMergedRows = allOpportunityRows.slice().sort(unifiedPriorityOpportunitySort);
        var mergedRetailRows = retailRows.slice().sort(unifiedPriorityOpportunitySort);
        var mergedReviewRows = reviewRows.slice().sort(unifiedPriorityOpportunitySort);
        var mergedReferralRows = referralRows.slice().sort(unifiedPriorityOpportunitySort);
        var appointmentWorkspaceCounts = buildUnifiedQueueWorkspaceCounts(allAppointmentOpportunityRows);
        var workspaceRowSets = {
          all: allMergedRows.slice().sort(unifiedPriorityOpportunitySort),
          never_visited: dueRowsForWorkspace(allMergedRows, 'never_visited').sort(unifiedPriorityOpportunitySort),
          needs_prebook: dueRowsForWorkspace(allMergedRows, 'needs_prebook').sort(unifiedPriorityOpportunitySort),
          needs_attention: dueRowsForWorkspace(allMergedRows, 'needs_attention').sort(unifiedPriorityOpportunitySort),
          needs_recovery: dueRowsForWorkspace(allMergedRows, 'needs_recovery').sort(unifiedPriorityOpportunitySort),
          no_pattern: dueRowsForWorkspace(allMergedRows, 'no_pattern').sort(unifiedPriorityOpportunitySort),
          watch_due_soon: dueRowsForWorkspace(allMergedRows, 'watch_due_soon').sort(unifiedPriorityOpportunitySort),
          watch_due_now: dueRowsForWorkspace(allMergedRows, 'watch_due_now').sort(unifiedPriorityOpportunitySort),
          at_risk_cadence_break: dueRowsForWorkspace(allMergedRows, 'at_risk_cadence_break').sort(unifiedPriorityOpportunitySort),
          at_risk_canceled_unbooked: dueRowsForWorkspace(allMergedRows, 'at_risk_canceled_unbooked').sort(unifiedPriorityOpportunitySort),
          at_risk_no_show_unbooked: dueRowsForWorkspace(allMergedRows, 'at_risk_no_show_unbooked').sort(unifiedPriorityOpportunitySort),
          at_risk_declining_frequency: dueRowsForWorkspace(allMergedRows, 'at_risk_declining_frequency').sort(unifiedPriorityOpportunitySort),
          at_risk_partial_return: dueRowsForWorkspace(allMergedRows, 'at_risk_partial_return').sort(unifiedPriorityOpportunitySort),
          lost_likely_lapsed: dueRowsForWorkspace(allMergedRows, 'lost_likely_lapsed').sort(unifiedPriorityOpportunitySort),
          prebook: dueRowsForWorkspace(allMergedRows, 'prebook').sort(unifiedPriorityOpportunitySort),
          active_drift: dueRowsForWorkspace(allMergedRows, 'active_drift').sort(unifiedPriorityOpportunitySort),
          long_lost: dueRowsForWorkspace(allMergedRows, 'long_lost').sort(unifiedPriorityOpportunitySort),
          retail: dueRowsForWorkspace(allMergedRows, 'retail').sort(unifiedPriorityOpportunitySort),
          referral: dueRowsForWorkspace(allMergedRows, 'referral').sort(unifiedPriorityOpportunitySort),
          review: dueRowsForWorkspace(allMergedRows, 'review').sort(unifiedPriorityOpportunitySort)
        };
        var workspaceCounts = buildUnifiedQueueWorkspaceCounts(allMergedRows);
        workspaceCounts.all = allMergedRows.length;
        workspaceCounts.my_claimed = allMergedRows.filter(function(row){
          return dueRowAssignedToCurrentManager(row) && !dueRowIsCompleted(row);
        }).length;
        var watchDueSoonCount = Number(appointmentBucketCounts.watch_due_soon || 0) || 0;
        var watchDueNowCount = Number(appointmentBucketCounts.watch_due_now || 0) || 0;
        var atRiskCadenceBreakCount = Number(appointmentBucketCounts.at_risk_cadence_break || 0) || 0;
        var atRiskCanceledUnbookedCount = Number(appointmentBucketCounts.at_risk_canceled_unbooked || 0) || 0;
        var atRiskNoShowUnbookedCount = Number(appointmentBucketCounts.at_risk_no_show_unbooked || 0) || 0;
        var atRiskDecliningFrequencyCount = Number(appointmentBucketCounts.at_risk_declining_frequency || 0) || 0;
        var atRiskPartialReturnCount = Number(appointmentBucketCounts.at_risk_partial_return || 0) || 0;
        var lostLikelyLapsedCount = Number(appointmentBucketCounts.lost_likely_lapsed || 0) || 0;
        var authoritativePrebookCount = watchDueSoonCount + watchDueNowCount;
        var authoritativeActiveDriftCount = atRiskCadenceBreakCount
          + atRiskCanceledUnbookedCount
          + atRiskNoShowUnbookedCount
          + atRiskDecliningFrequencyCount
          + atRiskPartialReturnCount;
        var authoritativeAppointmentCount = Number(appointmentTotalCount || 0) || (
          authoritativePrebookCount + authoritativeActiveDriftCount + lostLikelyLapsedCount
        );
        var authoritativeWorkspaceCounts = {
          all: authoritativeAppointmentCount + retailRows.length + referralRows.length + reviewRows.length,
          my_claimed: workspaceCounts.my_claimed,
          appointments: authoritativeAppointmentCount,
          never_visited: workspaceCounts.never_visited,
          needs_prebook: workspaceCounts.needs_prebook,
          needs_attention: workspaceCounts.needs_attention,
          needs_recovery: workspaceCounts.needs_recovery,
          no_pattern: workspaceCounts.no_pattern,
          watch_due_soon: watchDueSoonCount,
          watch_due_now: watchDueNowCount,
          at_risk_cadence_break: atRiskCadenceBreakCount,
          at_risk_canceled_unbooked: atRiskCanceledUnbookedCount,
          at_risk_no_show_unbooked: atRiskNoShowUnbookedCount,
          at_risk_declining_frequency: atRiskDecliningFrequencyCount,
          at_risk_partial_return: atRiskPartialReturnCount,
          lost_likely_lapsed: lostLikelyLapsedCount,
          prebook: authoritativePrebookCount,
          active_drift: authoritativeActiveDriftCount,
          long_lost: lostLikelyLapsedCount,
          retail: retailRows.length,
          referral: referralRows.length,
          review: reviewRows.length
        };
        if (appendAppointmentPage && existingSummary) {
          var existingAllCounts = existingSummary.workspace_counts_all && typeof existingSummary.workspace_counts_all === 'object'
            ? existingSummary.workspace_counts_all
            : {};
          Object.keys(existingAllCounts).forEach(function(key){
            var priorValue = Number(existingAllCounts[key] || 0) || 0;
            var currentValue = Number(authoritativeWorkspaceCounts[key] || 0) || 0;
            authoritativeWorkspaceCounts[key] = Math.max(priorValue, currentValue);
          });
          authoritativeWorkspaceCounts.all = Math.max(
            Number(existingSummary.total_snapshot_rows || 0) || 0,
            Number(existingAllCounts.all || 0) || 0,
            Number(authoritativeWorkspaceCounts.all || 0) || 0
          );
          authoritativeWorkspaceCounts.appointments = Math.max(
            Number(existingAllCounts.appointments || 0) || 0,
            Number(authoritativeWorkspaceCounts.appointments || 0) || 0
          );
        }
        var selectedWorkspace = String(dueQueueWorkspace || 'all').trim() || 'all';
        var selectedWorkspaceTotal = Object.prototype.hasOwnProperty.call(authoritativeWorkspaceCounts, selectedWorkspace)
          ? (Number(authoritativeWorkspaceCounts[selectedWorkspace]) || 0)
          : (authoritativeWorkspaceCounts.all || allMergedRows.length);
        var allNeedsActionCount = allMergedRows.filter(dueRowNeedsAction).length;
        var allWaitingCount = allMergedRows.filter(dueRowIsWaiting).length;
        var allCompletedCount = allMergedRows.filter(dueRowIsCompleted).length;
        var allInProgressCount = allMergedRows.filter(dueRowIsInProgress).length;
        var allRecommendedRows = allMergedRows.filter(dueRowIsRecommended);
        var topRecommendedRow = allRecommendedRows.length ? allRecommendedRows[0] : null;
        var contextRows = allMergedRows
          .filter(unifiedRowMatchesSharedFilters);
        var contextualWorkspaceCounts = buildUnifiedQueueWorkspaceCounts(contextRows);
        var mergedRows = contextRows.slice().sort(unifiedPriorityOpportunitySort);
        var needsManagerCount = mergedRows.filter(function(row){
          return (retailTextValue(row && row.manager_task_status_label, '') || retailTextValue(row && row.workflow_state_label, '')).toLowerCase() === 'needs manager';
        }).length;
        var workingCount = mergedRows.filter(function(row){
          return (retailTextValue(row && row.manager_task_status_label, '') || retailTextValue(row && row.workflow_state_label, '')).toLowerCase() === 'working';
        }).length;
        var wonBackCount = mergedRows.filter(function(row){
          return (retailTextValue(row && row.manager_task_status_label, '') || retailTextValue(row && row.workflow_state_label, '')).toLowerCase() === 'won back';
        }).length;
        var myQueueCount = mergedRows.filter(function(row){
          return dueRowAssignedToCurrentManager(row);
        }).length;
        var unassignedCount = mergedRows.filter(function(row){
          return !retailTextValue(row && row.manager_task_assigned_staff_id, '');
        }).length;
        var highPriorityCount = mergedRows.filter(function(row){
          return Number((row && (row.business_priority_score || row.priority_score)) || 0) >= 70;
        }).length;
        var topRecommendedOpportunity = topRecommendedRow ? {
          headline: topRecommendedRow.queue_source === 'appointment'
            ? (
              retailTextValue(topRecommendedRow && topRecommendedRow.queue_stage, '').toLowerCase() === 'non_current_recapture'
                ? 'High-priority recapture guest with no future appointment.'
                : 'High-value guest is active but still missing the next booking.'
            )
            : topRecommendedRow.queue_source === 'retail'
              ? 'Retail follow-up is ready for a guest who left without the full routine.'
              : topRecommendedRow.queue_source === 'referral'
                ? 'Strong relationship is ready for a referral ask.'
                : 'Fresh positive visit is ready for review follow-up.',
          reason: retailTextValue(topRecommendedRow && topRecommendedRow.diagnosis_summary, '') || duePrimaryReasonLine(topRecommendedRow),
          owner: retailTextValue(topRecommendedRow && topRecommendedRow.primary_staff_name, ''),
          last_visit: retailTextValue(topRecommendedRow && (topRecommendedRow.last_in_date || (topRecommendedRow.retail_row && topRecommendedRow.retail_row.appointment_datetime) || (topRecommendedRow.review_row && topRecommendedRow.review_row.appointment_datetime) || (topRecommendedRow.referral_row && topRecommendedRow.referral_row.appointment_datetime)), ''),
          next_action: retailTextValue(topRecommendedRow && topRecommendedRow.recommended_action, ''),
          opportunity_key: retailTextValue(topRecommendedRow && topRecommendedRow.opportunity_key, ''),
          queue_source: retailTextValue(topRecommendedRow && topRecommendedRow.queue_source, '')
        } : null;
        return {
          ok: true,
          rows: allMergedRows,
          offers: appointmentSummaryResult && appointmentSummaryResult.offers ? appointmentSummaryResult.offers : [],
          refresh_progress: appointmentSummaryResult && appointmentSummaryResult.refresh_progress ? appointmentSummaryResult.refresh_progress : null,
          summary: {
            unified_queue: true,
            local_row_set_complete: appointmentSummaryResult && appointmentSummaryResult.all_pages_loaded === true,
            filtered_total_rows: selectedWorkspaceTotal,
            total_snapshot_rows: authoritativeWorkspaceCounts.all,
            total_due_clients: appointmentTotalCount,
            total_tracked_guests: dueSummaryTrackedGuestCount(appointmentSummary),
            deduped_client_groups: Number(appointmentSummary.deduped_client_groups || appointmentDebugCounts.deduped_clients || 0) || 0,
            total_deduped_client_groups: Number(appointmentSummary.total_deduped_client_groups || appointmentSummary.deduped_client_groups || appointmentDebugCounts.deduped_clients || 0) || 0,
            duplicate_client_groups: Number(appointmentSummary.duplicate_client_groups || 0) || 0,
            current_needs_prebooking_client_groups: Number(appointmentSummary.current_needs_prebooking_client_groups || 0) || 0,
            non_current_recapture_client_groups: Number(appointmentSummary.non_current_recapture_client_groups || 0) || 0,
            future_booked_suppressed_client_groups: Number(appointmentSummary.future_booked_suppressed_client_groups || appointmentSummary.future_booked_client_groups || appointmentSummary.suppressed_with_future_appointment || appointmentDebugCounts.suppressed_same_category_future_groups || 0) || 0,
            future_booked_client_groups: Number(appointmentSummary.future_booked_client_groups || appointmentSummary.future_booked_suppressed_client_groups || appointmentDebugCounts.suppressed_same_category_future_groups || 0) || 0,
            suppressed_with_future_appointment: Number(appointmentSummary.suppressed_with_future_appointment || appointmentSummary.future_booked_suppressed_client_groups || appointmentDebugCounts.suppressed_same_category_future_groups || 0) || 0,
            workspace_row_sets: {},
            workspace_counts: authoritativeWorkspaceCounts,
            business_bucket_counts_actionable: appointmentBucketCounts,
            business_bucket_counts_rows: appointmentWorkspaceCounts,
            unified_appointment_count: appointmentTotalCount,
            unified_prebook_count: authoritativeWorkspaceCounts.prebook,
            unified_active_drift_count: authoritativeWorkspaceCounts.active_drift,
            unified_long_lost_count: authoritativeWorkspaceCounts.long_lost,
            unified_retail_count: retailRows.length,
            unified_review_count: reviewRows.length,
            unified_referral_count: referralRows.length,
            unified_needs_manager_count: needsManagerCount,
            unified_needs_action_count: allNeedsActionCount,
            unified_working_count: workingCount,
            unified_in_progress_count: allInProgressCount,
            unified_waiting_count: allWaitingCount,
            unified_completed_count: allCompletedCount,
            unified_won_back_count: wonBackCount,
            unified_my_queue_count: myQueueCount,
            unified_unassigned_count: unassignedCount,
            unified_high_priority_count: highPriorityCount,
            unified_recommended_count: allRecommendedRows.length,
            top_recommended_opportunity: topRecommendedOpportunity,
            unified_scorecard: scorecardSummary,
            workspace_counts_all: authoritativeWorkspaceCounts,
            workspace_counts_contextual: appendAppointmentPage && existingSummary && existingSummary.workspace_counts_contextual && typeof existingSummary.workspace_counts_contextual === 'object'
              ? Object.assign({}, existingSummary.workspace_counts_contextual)
              : authoritativeWorkspaceCounts,
            refresh: appointmentSummaryResult && appointmentSummaryResult.refresh ? appointmentSummaryResult.refresh : {},
            snapshot: appointmentSummaryResult && appointmentSummaryResult.snapshot ? appointmentSummaryResult.snapshot : null,
            debug_counts: appointmentSummary.debug_counts && typeof appointmentSummary.debug_counts === 'object'
              ? appointmentSummary.debug_counts
              : (appointmentSummaryResult && appointmentSummaryResult.summary && appointmentSummaryResult.summary.debug_counts
                ? appointmentSummaryResult.summary.debug_counts
                : null)
          }
        };
      }

      async function ensureDueQueueManagerSession(){
        var currentStaffId = currentDueQueueManagerStaffId();
        if (currentStaffId) return currentStaffId;

        var enteredPin = window.prompt('Enter your manager login code to draft or send recapture texts.');
        var normalizedPin = String(enteredPin || '').trim();
        if (!normalizedPin) {
          throw new Error('Manager login code is required to use recapture outreach.');
        }

        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-ops-auth',
            pin: normalizedPin
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.staff_ops_permission || !data.editor) {
          throw new Error((data && data.error) || rawText || 'Could not unlock manager outreach tools.');
        }

        currentStaffOpsPermission = data.staff_ops_permission;
        currentProgressionEditor = data.editor;
        currentProgressionEditorPermission = data.editor_permission || currentProgressionEditorPermission || null;
        persistStaffOpsAccessSession();
        persistProgressionEditorSession();
        applyStaffOpsAccess();
        updateProgressionEditorStatusDisplay();

        var unlockedStaffId = currentDueQueueManagerStaffId();
        if (!unlockedStaffId) {
          throw new Error('This manager login does not have rebook queue access.');
        }
        return unlockedStaffId;
      }

      async function createDueQueueDraft(bucketKey, payload){
        var managerStaffId = await ensureDueQueueManagerSession();
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'recapture_draft_sms',
            editor_staff_id: managerStaffId,
            guest_bucket_key: bucketKey,
            offer_key: payload && payload.offerKey || 'none',
            offer_text: payload && payload.offerText || '',
            offer_label: payload && payload.offerLabel || '',
            boulevard_offer_id: payload && payload.offerId || '',
            boulevard_offer_code: payload && payload.offerCode || '',
            boulevard_offer_name: payload && payload.offerName || '',
            queue_source: payload && payload.queueSource || '',
            opportunity_key: payload && payload.opportunityKey || '',
            opportunity_mode: payload && payload.opportunityMode || '',
            opportunity_lane: payload && payload.opportunityLane || ''
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not draft recapture SMS.');
        }
        return data;
      }

      async function saveBdFastRetailTags(payload){
        var managerStaffId = await ensureDueQueueManagerSession();
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'client_followup_queue_v4_save_retail_tags',
            editor_staff_id: managerStaffId,
            opportunity_key: payload && payload.opportunityKey || '',
            appointment_id: payload && payload.appointmentId || '',
            concern_tags: payload && payload.concernTags || [],
            product_tags: payload && payload.productTags || []
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not save retail recommendation tags.');
        }
        return data;
      }

      function bdFastRetailProductPickerState(rowKey){
        var key = String(rowKey || '').trim();
        if (!key) return { query: '', loading: false, results: [], error: '' };
        if (!bdFastRetailProductPickerByKey[key] || typeof bdFastRetailProductPickerByKey[key] !== 'object') {
          bdFastRetailProductPickerByKey[key] = { query: '', loading: false, results: [], error: '' };
        }
        return bdFastRetailProductPickerByKey[key];
      }

      async function fetchBdFastRetailProductCatalog(query){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'client_followup_queue_v4_retail_product_catalog',
            query: query,
            limit: 8
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load product suggestions.');
        }
        return Array.isArray(data.products) ? data.products : [];
      }

      function renderBdFastRetailProductPickerSuggestions(rowKey){
        var key = String(rowKey || '').trim();
        var mount = key ? document.querySelector('[data-bd-fast-product-picker="' + key.replace(/"/g, '\\"') + '"]') : null;
        if (!mount) return;
        var pickerState = bdFastRetailProductPickerState(key);
        var storedState = bdFastOutreachState[key] && typeof bdFastOutreachState[key] === 'object' ? bdFastOutreachState[key] : null;
        var selectedHandles = bdFastManualRetailOverrideList(storedState && storedState.manualProductTags);
        var html = '';
        if (pickerState.loading) {
          html = '<div class="bd-fastProductPickerEmpty">Searching products…</div>';
        } else if (pickerState.saving) {
          html = '<div class="bd-fastProductPickerEmpty">Saving selected products…</div>';
        } else if (pickerState.error) {
          html = '<div class="bd-fastProductPickerEmpty">' + escapeHtml(pickerState.error) + '</div>';
        } else if (pickerState.query && pickerState.results.length) {
          html = '<div class="bd-fastProductPickerMenu">'
            + pickerState.results.filter(function(item){
              var handle = retailTextValue(item && item.handle, '');
              return handle && selectedHandles.indexOf(handle) === -1;
            }).map(function(item){
              var handle = retailTextValue(item && item.handle, '');
              var title = retailTextValue(item && item.title, handle || 'Product');
              if (!handle) return '';
              return '<button class="bd-fastProductPickerOption" type="button" data-bd-fast-product-pick="' + escapeHtml(key) + '" data-bd-fast-product-handle="' + escapeHtml(handle) + '"><strong>' + escapeHtml(title) + '</strong><span>' + escapeHtml(handle) + '</span></button>';
            }).join('') + '</div>';
          if (html === '<div class="bd-fastProductPickerMenu"></div>') {
            html = '<div class="bd-fastProductPickerEmpty">Already added.</div>';
          }
        } else if (pickerState.query) {
          html = '<div class="bd-fastProductPickerEmpty">No matching products found.</div>';
        }
        mount.innerHTML = html;
      }

      function queueBdFastRetailProductCatalogSearch(rowKey, query){
        var key = String(rowKey || '').trim();
        if (!key) return;
        var pickerState = bdFastRetailProductPickerState(key);
        pickerState.query = String(query || '').trim();
        pickerState.error = '';
        if (bdFastRetailProductPickerTimerByKey[key]) {
          window.clearTimeout(bdFastRetailProductPickerTimerByKey[key]);
        }
        if (!pickerState.query) {
          pickerState.loading = false;
          pickerState.results = [];
          renderBdFastRetailProductPickerSuggestions(key);
          return;
        }
        pickerState.loading = true;
        pickerState.results = [];
        renderBdFastRetailProductPickerSuggestions(key);
        bdFastRetailProductPickerTimerByKey[key] = window.setTimeout(function(){
          fetchBdFastRetailProductCatalog(pickerState.query).then(function(results){
            var nextState = bdFastRetailProductPickerState(key);
            if (nextState.query !== pickerState.query) return;
            nextState.loading = false;
            nextState.results = Array.isArray(results) ? results : [];
            nextState.error = '';
            renderBdFastRetailProductPickerSuggestions(key);
          }).catch(function(error){
            var nextState = bdFastRetailProductPickerState(key);
            if (nextState.query !== pickerState.query) return;
            nextState.loading = false;
            nextState.results = [];
            nextState.error = humanizeClientFetchErrorMessage(error, 'Could not load product suggestions.');
            renderBdFastRetailProductPickerSuggestions(key);
          });
        }, 180);
      }

      async function persistBdFastRetailProductTagsForRow(rowKey){
        var key = String(rowKey || '').trim();
        if (!key) return;
        var actionRow = retailArray(bdFastAllRows).find(function(row){
          return bdFastOutreachStateKey(row) === key;
        });
        if (!actionRow) return;
        var detailState = bdFastDetailState(actionRow);
        var summary = bdFastStrategySummary(actionRow, detailState);
        var anchorAppointment = summary && summary.recentAppointment && typeof summary.recentAppointment === 'object'
          ? summary.recentAppointment
          : {};
        var appointmentId = retailTextValue(anchorAppointment && anchorAppointment.appointment_id, '');
        var outreachState = bdFastOutreachStateForRow(actionRow);
        var productTags = bdFastManualRetailOverrideList(outreachState && outreachState.manualProductTags);
        var pickerState = bdFastRetailProductPickerState(key);
        if (!appointmentId) {
          pickerState.error = 'No anchor appointment was found.';
          renderBdFastRetailProductPickerSuggestions(key);
          return;
        }
        pickerState.saving = true;
        pickerState.error = '';
        renderBdFastRetailProductPickerSuggestions(key);
        setBdFastStatus('Saving selected products...', 'loading');
        try {
          await saveBdFastRetailTags({
            opportunityKey: retailTextValue(actionRow && actionRow.opportunity_key, ''),
            appointmentId: appointmentId,
            concernTags: [],
            productTags: productTags
          });
          pickerState.query = '';
          pickerState.results = [];
          pickerState.loading = false;
          pickerState.error = '';
          pickerState.saving = false;
          renderBdFastRetailProductPickerSuggestions(key);
          setBdFastStatus('Product tags saved.', 'success');
          fetchBdFastDetail(actionRow).then(function(freshDetail){
            var refreshedState = bdFastDetailState(actionRow);
            if (!refreshedState) return;
            refreshedState.detail = freshDetail;
            refreshedState.error = '';
            var refreshedSummary = bdFastStrategySummary(actionRow, refreshedState);
            bdFastPersistOutreachState(key, {
              draftBody: refreshedSummary ? bdFastStrategySmsMessage(refreshedSummary) : '',
              reviewed: false
            });
          }).catch(function(){});
        } catch (error) {
          pickerState.saving = false;
          pickerState.error = humanizeClientFetchErrorMessage(error, 'Could not save selected products.');
          renderBdFastRetailProductPickerSuggestions(key);
          setBdFastStatus(pickerState.error, 'error');
        }
      }

      function bdFastAddManualProductTag(rowKey, handle){
        var key = String(rowKey || '').trim();
        var productHandle = String(handle || '').trim();
        if (!key || !productHandle) return;
        var currentState = bdFastOutreachState[key] && typeof bdFastOutreachState[key] === 'object' ? bdFastOutreachState[key] : {};
        var nextHandles = bdFastManualRetailOverrideList(currentState && currentState.manualProductTags);
        if (nextHandles.indexOf(productHandle) === -1) nextHandles.push(productHandle);
        bdFastPersistOutreachState(key, {
          manualProductTags: nextHandles.join(', ')
        });
        var pickerState = bdFastRetailProductPickerState(key);
        pickerState.query = '';
        pickerState.results = [];
        pickerState.loading = false;
        pickerState.error = '';
        renderBdFastClaimedList();
        persistBdFastRetailProductTagsForRow(key).catch(function(){});
      }

      function bdFastRemoveManualProductTag(rowKey, handle){
        var key = String(rowKey || '').trim();
        var productHandle = String(handle || '').trim();
        if (!key || !productHandle) return;
        var currentState = bdFastOutreachState[key] && typeof bdFastOutreachState[key] === 'object' ? bdFastOutreachState[key] : {};
        var nextHandles = bdFastManualRetailOverrideList(currentState && currentState.manualProductTags).filter(function(value){
          return value !== productHandle;
        });
        bdFastPersistOutreachState(key, {
          manualProductTags: nextHandles.join(', ')
        });
        renderBdFastClaimedList();
        persistBdFastRetailProductTagsForRow(key).catch(function(){});
      }

      async function sendDueQueueText(bucketKey, payload){
        var managerStaffId = await ensureDueQueueManagerSession();
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'recapture_send_sms',
            editor_staff_id: managerStaffId,
            guest_bucket_key: bucketKey,
            offer_key: payload && payload.offerKey || 'none',
            offer_text: payload && payload.offerText || '',
            offer_label: payload && payload.offerLabel || '',
            boulevard_offer_id: payload && payload.offerId || '',
            boulevard_offer_code: payload && payload.offerCode || '',
            boulevard_offer_name: payload && payload.offerName || '',
            message_body: payload && payload.messageBody || '',
            queue_source: payload && payload.queueSource || '',
            opportunity_key: payload && payload.opportunityKey || '',
            opportunity_mode: payload && payload.opportunityMode || '',
            opportunity_lane: payload && payload.opportunityLane || '',
            reviewed: !!(payload && payload.reviewed),
            force_send: !!(payload && payload.forceSend)
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (response.status === 409 && data && data.requires_confirmation) {
          var confirmed = window.confirm('This guest was contacted recently. Send another text anyway?');
          if (!confirmed) {
            return { ok: false, canceled: true };
          }
          return await sendDueQueueText(bucketKey, {
            offerKey: payload && payload.offerKey || 'none',
            offerText: payload && payload.offerText || '',
            offerLabel: payload && payload.offerLabel || '',
            offerId: payload && payload.offerId || '',
            offerCode: payload && payload.offerCode || '',
            offerName: payload && payload.offerName || '',
            messageBody: payload && payload.messageBody || '',
            queueSource: payload && payload.queueSource || '',
            opportunityKey: payload && payload.opportunityKey || '',
            opportunityMode: payload && payload.opportunityMode || '',
            opportunityLane: payload && payload.opportunityLane || '',
            reviewed: !!(payload && payload.reviewed),
            forceSend: true
          });
        }
        if (!response.ok || !data) {
          throw new Error((data && data.error) || rawText || 'Could not send recapture SMS.');
        }
        if (data.ok !== true) {
          if (data.canceled) return data;
          throw new Error(data.error || 'Could not send recapture SMS.');
        }
        return data;
      }

      async function markDueQueueContacted(bucketKey, payload){
        var managerStaffId = await ensureDueQueueManagerSession();
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'recapture_mark_contacted',
            editor_staff_id: managerStaffId,
            guest_bucket_key: bucketKey,
            offer_key: payload && payload.offerKey || 'none',
            offer_text: payload && payload.offerText || '',
            offer_label: payload && payload.offerLabel || '',
            boulevard_offer_id: payload && payload.offerId || '',
            boulevard_offer_code: payload && payload.offerCode || '',
            boulevard_offer_name: payload && payload.offerName || '',
            message_body: payload && payload.messageBody || ''
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not mark guest as contacted.');
        }
        return data;
      }

      async function snoozeDueQueueRow(bucketKey, days, reason){
        var managerStaffId = await ensureDueQueueManagerSession();
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'recapture_snooze',
            editor_staff_id: managerStaffId,
            guest_bucket_key: bucketKey,
            days: days,
            reason: reason || ''
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not snooze this guest.');
        }
        return data;
      }

      async function hideBdFastOpportunityUntilTrigger(bucketKey, opportunityLane){
        var managerStaffId = await ensureDueQueueManagerSession();
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'client_followup_queue_v4_hide',
            editor_staff_id: managerStaffId,
            guest_bucket_key: bucketKey,
            queue_source: 'client_followup_queue_v4',
            opportunity_lane: opportunityLane || ''
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not hide this opportunity.');
        }
        return data;
      }

      async function fetchDueQueueBuildStatus(useLegacy){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: useLegacy ? 'get-client-followup-status-v3' : 'get-client-followup-status-v3'
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load client follow-up build status.');
        }
        return data;
      }

      async function refreshDueQueueSnapshot(forceFullRebuild, forceFreshQuickRefresh, backgroundKickoff){
        forceFullRebuild = false;
        backgroundKickoff = backgroundKickoff === true;
        var maxPasses = backgroundKickoff ? 1 : 6;
        var finalResult = null;
        var useLegacy = false;
        var buildStatus = await fetchDueQueueBuildStatus(useLegacy).catch(function(){
          return null;
        });
        var buildProgress = buildStatus && hasDueRefreshProgressData(buildStatus.refresh_progress)
          ? buildStatus.refresh_progress
          : {};
        var fallbackKnownProgress = dueQueueRefreshProgress
          || deriveDueRefreshProgressFromSummary(dueQueueSummary)
          || null;
        var buildIsRunning = String((buildProgress && buildProgress.status) || '').trim().toLowerCase() === 'running';
        var shouldRestart = !buildStatus || buildStatus.exists !== true || !buildIsRunning;
        setDueRefreshButtonsState({
          running: true,
          forceFullRebuild: !!forceFullRebuild,
          phase: ''
        });
        if (buildStatus && buildStatus.exists === true && buildStatus.complete === true) {
          renderDueRefreshMeta(hasDueRefreshProgressData(buildStatus.refresh_progress) ? buildStatus.refresh_progress : fallbackKnownProgress);
          setDueStatus(
            buildRecaptureProgressSummary(hasDueRefreshProgressData(buildStatus.refresh_progress) ? buildStatus.refresh_progress : fallbackKnownProgress, {}),
            'warning'
          );
        }
        if (buildStatus && buildStatus.exists === true && buildStatus.complete !== true) {
          renderDueRefreshMeta(hasDueRefreshProgressData(buildStatus.refresh_progress) ? buildStatus.refresh_progress : fallbackKnownProgress);
          setDueStatus(
            buildRecaptureProgressSummary(hasDueRefreshProgressData(buildStatus.refresh_progress) ? buildStatus.refresh_progress : fallbackKnownProgress, {}),
            'warning'
          );
        }
        for (var pass = 0; pass < maxPasses; pass += 1) {
          var knownProgress = finalResult && hasDueRefreshProgressData(finalResult.refresh_progress)
            ? finalResult.refresh_progress
            : buildStatus && hasDueRefreshProgressData(buildStatus.refresh_progress)
              ? buildStatus.refresh_progress
              : fallbackKnownProgress;
          renderDueRefreshMeta(knownProgress);
          setDueStatus(
            buildRecaptureProgressSummary(knownProgress, {}),
            'warning'
          );
          setDueRefreshButtonsState({
            running: true,
            forceFullRebuild: !!forceFullRebuild,
            phase: ''
          });
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'refresh-client-followup-queue-v3',
              force_restart: (!!forceFreshQuickRefresh) && shouldRestart && pass === 0,
              force_fresh_quick_refresh: (!!forceFreshQuickRefresh),
              lookback_days: 1825,
              chunk_page_size: backgroundKickoff ? 100 : 175,
              max_pages_per_pass: backgroundKickoff ? 1 : 3,
              max_changed_guest_keys_per_pass: backgroundKickoff ? 30 : 90,
              recent_replay_window_days: 7
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not refresh client follow-up queue.');
          }
          finalResult = data;
          renderDueRefreshMeta(data && hasDueRefreshProgressData(data.refresh_progress)
            ? data.refresh_progress
            : (dueQueueRefreshProgress || deriveDueRefreshProgressFromSummary(dueQueueSummary) || null));
          if (data.complete === true) {
            return finalResult;
          }
          var inFlightProgress = data && hasDueRefreshProgressData(data.refresh_progress)
            ? data.refresh_progress
            : (dueQueueRefreshProgress || deriveDueRefreshProgressFromSummary(dueQueueSummary) || null);
          setDueStatus(
            buildRecaptureProgressSummary(inFlightProgress, {}),
            'warning'
          );
          setDueRefreshButtonsState({
            running: true,
            forceFullRebuild: !!forceFullRebuild,
            phase: ''
          });
          if (!backgroundKickoff) {
            await delayMs(400);
          }
        }
        if (finalResult) {
          return finalResult;
        }
        throw new Error('Could not refresh client follow-up queue.');
      }

      async function backfillDueHistoryChunk(){
        if (dueBackfillBtn) dueBackfillBtn.disabled = true;
        if (dueHistoryHasMore === false) {
          setDueStatus('Appointment history sync has already reached the current end. If you want to rescan from the beginning, reset the sync cursor first.', 'warning');
          if (dueBackfillBtn) dueBackfillBtn.disabled = false;
          return;
        }
        setDueStatus('Syncing appointment history from Boulevard...');
        try {
          var maxChunks = 50;
          var maxRuntimeMs = 120000;
          var startedAt = Date.now();
          var completedChunks = 0;
          var totalClientsBackfilled = 0;
          var totalAppointmentsProcessed = 0;
          var totalAppointmentsInserted = 0;
          var totalAppointmentsExisting = 0;
          while (completedChunks < maxChunks && dueHistoryHasMore !== false && (Date.now() - startedAt) < maxRuntimeMs) {
            setDueStatus(
              'Syncing appointment history... chunk ' + String(completedChunks + 1)
                + ' of up to ' + String(maxChunks)
                + ' in this run.'
            );
            var response = await fetch(REPORT_PROXY_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                action: 'backfill-boulevard-appointment-history',
                after: dueHistoryCursor || '',
                client_first: 40,
                client_page_limit: 1,
                appointment_page_limit: 10,
                appointment_page_size: 100,
                enrichment_concurrency: 3
              })
            });
            var rawText = await response.text();
            var data = null;
            try {
              data = rawText ? JSON.parse(rawText) : null;
            } catch (_error) {
              data = null;
            }
            if (!response.ok || !data || !data.ok) {
              throw new Error((data && data.error) || rawText || 'Could not sync appointment history.');
            }
            completedChunks += 1;
            totalClientsBackfilled += Number(data.clients_backfilled || 0) || 0;
            totalAppointmentsProcessed += Number(data.appointments_processed || 0) || 0;
            totalAppointmentsInserted += Number(data.appointments_inserted || 0) || 0;
            totalAppointmentsExisting += Number(data.appointments_existing || 0) || 0;
            dueHistoryCursor = data.next_after || null;
            dueHistoryHasMore = data.has_more === true;
            persistDueHistorySyncState();
            if (!dueHistoryHasMore) {
              break;
            }
          }
          if (dueBackfillBtn) {
            dueBackfillBtn.textContent = dueHistoryHasMore ? 'Continue history sync' : 'History sync complete';
          }
          var hitChunkCap = completedChunks >= maxChunks && dueHistoryHasMore;
          var hitTimeCap = (Date.now() - startedAt) >= maxRuntimeMs && dueHistoryHasMore;
          var noRowsInserted = totalAppointmentsInserted <= 0;
          var nextStepNote = dueHistoryHasMore
            ? (hitTimeCap
                ? ' Paused after the time limit. Click again to continue.'
                : hitChunkCap
                  ? ' Paused after the batch limit. Click again to continue.'
                  : ' More clients remain to backfill.')
            : ' History backfill has reached the current end.';
          setDueStatus(
            'Synced ' + String(totalClientsBackfilled || 0)
              + ' clients and processed ' + String(totalAppointmentsProcessed || 0)
              + ' appointment rows across ' + String(completedChunks || 0) + ' chunk' + (completedChunks === 1 ? '' : 's') + '.'
              + ' Inserted ' + String(totalAppointmentsInserted || 0)
              + ' new rows and revisited ' + String(totalAppointmentsExisting || 0) + ' existing rows.'
              + (noRowsInserted ? ' No brand-new appointment rows were added in this run.' : '')
              + nextStepNote,
            'success'
          );
          await loadDueQueue();
        } catch (error) {
          setDueStatus(humanizeClientFetchErrorMessage(error, 'Could not sync appointment history.'), 'error');
        } finally {
          if (dueBackfillBtn) dueBackfillBtn.disabled = false;
        }
      }

      async function loadDueQueue(options){
        var opts = options && typeof options === 'object' ? options : {};
        var background = opts.background === true;
        var suppressPolling = opts.suppressPolling === true;
        var activeWorkspaceForLoad = dueWorkspaceCacheKey(opts.workspace || dueQueueWorkspace);
        if (opts.clearCache === true) {
          clearDueQueueWorkspaceCache();
        }
        if (!background) {
          setDueRefreshButtonsState({ running: true, forceFullRebuild: false, phase: '' });
        }
        if (!background) {
          setDueStatus(String(opts.loadingMessage || 'Loading queue...'));
        }
        try {
          var result = shouldUseUnifiedBusinessPriorityQueue()
            ? await fetchUnifiedBusinessPriorityQueue({ fullHydrate: opts.fullHydrate === true })
            : await fetchLikelyDueClients();
          dueQueueSummary = result && result.summary ? result.summary : {};
          dueQueueScorecard = dueQueueSummary && dueQueueSummary.unified_scorecard ? dueQueueSummary.unified_scorecard : null;
          dueQueueRefreshProgress = result && hasDueRefreshProgressData(result.refresh_progress) ? result.refresh_progress : null;
          if (!dueQueueRefreshProgress) {
            dueQueueRefreshProgress = deriveDueRefreshProgressFromSummary(dueQueueSummary);
          }
          if (!suppressPolling && dueQueueRefreshProgress && String(dueQueueRefreshProgress.status || '').trim().toLowerCase() === 'running') {
            scheduleDueRefreshProgressPolling(3000, false);
          } else {
            stopDueRefreshProgressPolling();
          }
          dueQueueOfferOptions = retailArray(result && result.offers);
          var rawRows = retailArray(result && result.rows).map(function(row){
            return row && typeof row === 'object'
              ? Object.assign({ queue_source: retailTextValue(row && row.queue_source, '') || 'appointment', opportunity_key: retailTextValue(row && row.opportunity_key, '') || buildPriorityOpportunityKey(row) }, row)
              : row;
          });
          if (dueQueueSummary && dueQueueSummary.unified_queue === true) {
            dueQueueSummary = dueHydrateUnifiedSummaryRowSets(dueQueueSummary, rawRows);
            dueQueueOverviewSummary = dueBuildOverviewSummary(dueQueueSummary);
          } else {
            dueQueueOverviewSummary = null;
          }
          dueQueueRows = mergePriorityRowsByOpportunityKey(mergeLocalClaimedRows(rawRows));
          dueQueueTotalRows = Number((dueQueueSummary && (dueQueueSummary.total_snapshot_rows || dueQueueSummary.filtered_total_rows)) || 0) || dueQueueRows.length;
          renderDueQueue();
          storeDueQueueWorkspaceCache(activeWorkspaceForLoad, dueQueueRows, dueQueueSummary, dueQueueRefreshProgress, dueQueueOfferOptions, dueQueueScorecard);
          if (!dueQueueRows.length) {
            var debugCounts = dueQueueSummary && dueQueueSummary.debug_counts ? dueQueueSummary.debug_counts : null;
            if (debugCounts) {
              if (!debugCounts.history_available) {
                if (!background) {
                  setDueStatus(
                    'The queue is empty right now because the baseline rebuild has not finished yet.',
                    'warning'
                  );
                }
              } else {
                if (!background) {
                  setDueStatus(
                    dueQueueSummary && dueQueueSummary.unified_queue === true
                      ? 'No business-development opportunities match the current view.'
                      : 'No guests match the current filters.',
                    'warning'
                  );
                }
              }
            } else {
              if (!background) {
                setDueStatus(
                  dueQueueSummary && dueQueueSummary.unified_queue === true
                    ? 'No business-development opportunities match the current view.'
                    : 'No guests match the current filters.',
                  'warning'
                );
              }
            }
          } else {
            var successDebugCounts = dueQueueSummary && dueQueueSummary.debug_counts ? dueQueueSummary.debug_counts : null;
            if (successDebugCounts) {
              var totalRows = dueQueueRows.length;
              var shownCount = dueVisibleRowCount(totalRows, dueQueueRows.length);
              var start = shownCount ? 1 : 0;
              var end = shownCount;
              var dueFilterConfig = getDueQueueFilterConfig();
              var hasDueFilters = !!(
                dueQueueActiveStage !== 'all' ||
                dueQueueOpportunityFilter !== 'all' ||
                dueQueueWorkflowFilter !== 'all' ||
                dueQueueOwnerFilter !== 'all' ||
                dueFilterConfig.category ||
                dueFilterConfig.duplicateOnly === true ||
                dueQueueActiveClientType !== 'all' ||
                String((dueCadenceSourceFilter && dueCadenceSourceFilter.value) || '').trim() ||
                !!(dueHasPhoneOnly && dueHasPhoneOnly.checked) ||
                !!(dueHasEmailOnly && dueHasEmailOnly.checked)
              );
              if (!background) {
                setDueStatus(
                  (hasDueFilters
                    ? String(start) + '–' + String(end) + ' of ' + String(totalRows || 0) + ' shown.'
                    : String(start) + '–' + String(end) + ' of ' + String(totalRows || 0) + ' shown.'
                  ),
                  'success'
                );
              }
            } else {
              var simpleTotalRows = dueQueueRows.length;
              var simpleShownCount = dueVisibleRowCount(simpleTotalRows, dueQueueRows.length);
              var simpleStart = simpleShownCount ? 1 : 0;
              var simpleEnd = simpleShownCount;
              var simpleFilterConfig = getDueQueueFilterConfig();
              var hasSimpleFilters = !!(
                dueQueueActiveStage !== 'all' ||
                dueQueueOpportunityFilter !== 'all' ||
                dueQueueWorkflowFilter !== 'all' ||
                dueQueueOwnerFilter !== 'all' ||
                simpleFilterConfig.category ||
                simpleFilterConfig.duplicateOnly === true ||
                dueQueueActiveClientType !== 'all' ||
                String((dueCadenceSourceFilter && dueCadenceSourceFilter.value) || '').trim() ||
                !!(dueHasPhoneOnly && dueHasPhoneOnly.checked) ||
                !!(dueHasEmailOnly && dueHasEmailOnly.checked)
              );
              if (!background) {
                setDueStatus(
                  String(simpleStart) + '–' + String(simpleEnd) + ' of ' + String(simpleTotalRows || 0) + ' shown.',
                  'success'
                );
              }
            }
          }
        } catch (error) {
          stopDueRefreshProgressPolling();
          if (!background) {
            if (hasSafeDueSummary(dueQueueSummary)) {
              renderDueRefreshMeta(dueQueueRefreshProgress || deriveDueRefreshProgressFromSummary(dueQueueSummary));
              renderDueWorkspaceCounts(dueQueueSummary);
            } else {
              dueQueueSummary = null;
              dueQueueOverviewSummary = null;
              dueQueueScorecard = null;
              dueQueueRefreshProgress = null;
              dueQueueOfferOptions = [];
              dueQueueRows = [];
              dueQueueTotalRows = 0;
              renderDueRefreshMeta(null);
              renderDueWorkspaceCounts(null);
              if (dueHealthSummaryMount) {
                dueHealthSummaryMount.innerHTML = '<div class="retail-empty">Business health could not load right now.</div>';
              }
              if (dueRecommendedFocusMount) {
                dueRecommendedFocusMount.innerHTML = '<div class="retail-empty">Recommended focus could not load right now.</div>';
              }
              if (dueMetricsMount) {
                dueMetricsMount.innerHTML = retailMetricMarkup('Current Clients Without Prebooked Appointment', '--', 'Refresh the queue to load current counts.');
              }
              if (dueScorecardMount) {
                dueScorecardMount.innerHTML = '<div class="retail-empty">Manager scorecard will load here.</div>';
              }
              if (dueQueueList) {
                dueQueueList.innerHTML = '<div class="retail-empty">No client follow-up queue data is loaded yet. Refresh Queue to build it.</div>';
              }
            }
          }
          setDueQueueUiState('error', {
            tone: 'error',
            label: 'Queue unavailable',
            hint: humanizeClientFetchErrorMessage(error, background ? 'Background queue refresh failed.' : 'Could not load client follow-up queue.'),
            percent: 100
          });
          setDueStatus(humanizeClientFetchErrorMessage(error, background ? 'Background queue refresh failed.' : 'Could not load client follow-up queue.'), 'error');
        } finally {
          if (!background) {
            setDueRefreshButtonsState({ running: false, forceFullRebuild: false, phase: '' });
          }
        }
      }

      async function refreshDueQueueAuto(){
        var currentProgress = dueQueueRefreshProgress;
        if (!currentProgress) {
          try {
            var buildStatus = await fetchDueQueueBuildStatus(false);
            currentProgress = buildStatus && hasDueRefreshProgressData(buildStatus.refresh_progress) ? buildStatus.refresh_progress : null;
            if (currentProgress) {
              dueQueueRefreshProgress = currentProgress;
              renderDueRefreshMeta(currentProgress);
            }
          } catch (_error) {
            currentProgress = dueQueueRefreshProgress;
          }
        }
        var plan = getDuePrimaryActionPlan(currentProgress);
        setDueStatus(plan.message, 'warning');
        await refreshDueQueue(!!plan.forceFullRebuild);
      }

      async function refreshDueQueueFresh(){
        setDueStatus('Resuming the queue sync from the latest saved checkpoint.', 'warning');
        await refreshDueQueue(false, true);
      }

      async function refreshDueQueue(forceFullRebuild, forceFreshQuickRefresh){
        forceFullRebuild = false;
        clearDueQueueWorkspaceCache();
        dueLastRefreshImpact = null;
        setDueRefreshButtonsState({ running: true, forceFullRebuild: false, phase: '' });
        setDueStatus(
          forceFreshQuickRefresh
            ? 'Refreshing from the latest saved checkpoint now.'
            : 'Refreshing the queue now. The current saved list stays available while the update runs.',
          'warning'
        );
        try {
          var result = await refreshDueQueueSnapshot(false, !!forceFreshQuickRefresh);
          if (result && result.complete === true) {
            stopDueRefreshProgressPolling();
            if (result && result.summary && typeof result.summary === 'object' && Object.keys(result.summary).length) {
              dueQueueSummary = result.summary;
              dueQueueOverviewSummary = dueBuildOverviewSummary(dueQueueSummary);
            }
            dueQueueRefreshProgress = result && hasDueRefreshProgressData(result.refresh_progress) ? result.refresh_progress : null;
            if (!dueQueueRefreshProgress) {
              dueQueueRefreshProgress = deriveDueRefreshProgressFromSummary(dueQueueSummary);
            }
            dueLastRefreshImpact = result;
            var appliedInline = await applyDueInlineRefreshResult(result);
            if (!appliedInline) {
              dueQueueOffset = 0;
              await loadDueQueue();
            } else {
              renderDueRefreshMeta(dueQueueRefreshProgress);
              renderDueRefreshImpact(dueLastRefreshImpact);
              loadDueQueue({ background: true }).catch(function(){});
            }
            setDueStatus(
              buildRecaptureProgressSummary(dueQueueRefreshProgress, {}),
              'success'
            );
          } else {
            if (result && (retailArray(result.affected_guests).length || retailArray(result.affected_queue_rows).length)) {
              dueLastRefreshImpact = result;
              renderDueRefreshImpact(dueLastRefreshImpact);
            }
            dueQueueRefreshProgress = result && hasDueRefreshProgressData(result.refresh_progress) ? result.refresh_progress : null;
            if (!dueQueueRefreshProgress) {
              dueQueueRefreshProgress = deriveDueRefreshProgressFromSummary(dueQueueSummary);
            }
            renderDueRefreshMeta(dueQueueRefreshProgress);
            setDueStatus(
              buildRecaptureProgressSummary(dueQueueRefreshProgress, {}),
              'warning'
            );
            scheduleDueRefreshProgressPolling(3000, false);
          }
        } catch (error) {
          stopDueRefreshProgressPolling();
          setDueStatus(humanizeClientFetchErrorMessage(error, 'Could not refresh client follow-up queue.'), 'error');
        } finally {
          setDueRefreshButtonsState({ running: false, forceFullRebuild: false, phase: '' });
        }
      }

      async function ensureDueQueueLoaded(){
        await primeDueQueueOnPageLoad();
        if (dueQueueBootLoadPromise) {
          await dueQueueBootLoadPromise;
        }
        if (!hasLoadedDueQueue) {
          dueQueueRows = [];
          dueQueueTotalRows = 0;
          setDueQueueLoadingState('Loading saved business-development queue...');
          try {
            dueQueueOffset = 0;
            await loadDueQueue({
              loadingMessage: 'Loading saved opportunities...',
              suppressPolling: true,
              allowBackgroundHydrate: false
            });
            hasLoadedDueQueue = true;
          } catch (error) {
            setDueStatus(humanizeClientFetchErrorMessage(error, 'Could not load the saved Business Development queue.'), 'error');
            return;
          }
        }
        var currentProgress = dueQueueRefreshProgress || deriveDueRefreshProgressFromSummary(dueQueueSummary) || null;
        if (currentProgress) {
          renderDueRefreshMeta(currentProgress);
        }
        if (String((currentProgress && currentProgress.status) || '').trim().toLowerCase() === 'running') {
          scheduleDueRefreshProgressPolling(3000, false);
          setDueStatus(buildRecaptureProgressSummary(currentProgress, {}), 'warning');
          return;
        }
        stopDueRefreshProgressPolling();
        setDueStatus('Showing the last saved business-development queue.', 'success');
      }

      async function primeDueQueueOnPageLoad(){
        if (hasLoadedDueQueue) return;
        if (dueQueueBootLoadPromise) {
          await dueQueueBootLoadPromise;
          return;
        }
        dueQueueBootLoadPromise = (async function(){
          try {
            var buildStatus = await fetchDueQueueBuildStatus(false).catch(function(){
              return null;
            });
            var currentProgress = buildStatus && hasDueRefreshProgressData(buildStatus.refresh_progress)
              ? buildStatus.refresh_progress
              : (dueQueueRefreshProgress || deriveDueRefreshProgressFromSummary(dueQueueSummary) || null);
            if (currentProgress) {
              dueQueueRefreshProgress = currentProgress;
              renderDueRefreshMeta(currentProgress);
            }
            dueQueueOffset = 0;
            await loadDueQueue({
              background: true,
              suppressPolling: true,
              allowBackgroundHydrate: false
            });
            hasLoadedDueQueue = true;
          } finally {
            dueQueueBootLoadPromise = null;
          }
        })();
        await dueQueueBootLoadPromise;
      }

      async function fetchRetailAnalyticsDashboardForMode(mode, payrollStart){
        var retailRange = buildRetailWeekRange(payrollStart);
        var body = {
          action: 'get-retail-sales-leaderboard',
          date_from: retailRange.date_from,
          date_to: retailRange.date_to,
          appointment_state: 'closed',
          leaderboard_mode: String(mode || '') === 'assistant' ? 'assistant' : 'stylist'
        };
        var response = await fetch(RETAIL_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load Retail Success.');
        }
        return data;
      }

      async function fetchRetailQuarterSnapshot(periodValue){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'retail-quarter-snapshot-get',
            quarter_value: String(periodValue || ''),
            refresh_if_missing: true
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load the retail quarter snapshot.');
        }
        return data;
      }

      async function fetchRetailAvailableQuarterOptions(){
        if (Array.isArray(retailAvailableQuarterOptions)) {
          return retailAvailableQuarterOptions.slice();
        }
        if (retailAvailableQuarterOptionsPromise) {
          return retailAvailableQuarterOptionsPromise;
        }
        retailAvailableQuarterOptionsPromise = (async function(){
          retailAvailableQuarterOptions = buildRetailQuarterCandidates();
          syncRetailWeekTabs();
          return retailAvailableQuarterOptions.slice();
        })().finally(function(){
          retailAvailableQuarterOptionsPromise = null;
        });
        return retailAvailableQuarterOptionsPromise;
      }

      async function fetchRetailAnalyticsDashboardForWeek(payrollStart){
        var range = buildRetailWeekRange(payrollStart);
        if (range && range.period_kind === 'quarter') {
          var quarterSnapshot = await fetchRetailQuarterSnapshot(range.payroll_start || payrollStart);
          return {
            week_window: range.payroll_start || '',
            range: {
              date_from: String(quarterSnapshot.date_from || range.date_from || ''),
              date_to: String(quarterSnapshot.date_to || range.date_to || ''),
              label: String(quarterSnapshot.period_label || range.label || ''),
              payroll_start: String(quarterSnapshot.period_value || range.payroll_start || ''),
              short_label: String(range.short_label || range.label || ''),
              period_date_to: String(quarterSnapshot.period_date_to || range.period_date_to || range.date_to || ''),
              live_through: String(quarterSnapshot.live_through || range.live_through || ''),
              is_live_current: quarterSnapshot.is_live_current === true || range.is_live_current === true,
              period_kind: 'quarter'
            },
            snapshot: quarterSnapshot.snapshot || null,
            stylist: quarterSnapshot.stylist || {},
            assistant: quarterSnapshot.assistant || {},
            sales_leaderboard: quarterSnapshot.sales_leaderboard || {
              stylist: quarterSnapshot.stylist && quarterSnapshot.stylist.sales_leaderboard ? quarterSnapshot.stylist.sales_leaderboard : null,
              assistant: quarterSnapshot.assistant && quarterSnapshot.assistant.sales_leaderboard ? quarterSnapshot.assistant.sales_leaderboard : null
            },
            appointment_count_considered: quarterSnapshot.appointment_count_considered || {
              stylist: Number(quarterSnapshot.stylist && quarterSnapshot.stylist.appointment_count_considered || 0) || 0,
              assistant: Number(quarterSnapshot.assistant && quarterSnapshot.assistant.appointment_count_considered || 0) || 0
            }
          };
        }
        var responses = await Promise.all([
          fetchRetailAnalyticsDashboardForMode('stylist', payrollStart),
          fetchRetailAnalyticsDashboardForMode('assistant', payrollStart)
        ]);
        var stylist = responses[0] || {};
        var assistant = responses[1] || {};
        return {
          week_window: range.payroll_start || '',
          range: range,
          stylist: stylist,
          assistant: assistant,
          sales_leaderboard: {
            stylist: stylist && stylist.sales_leaderboard ? stylist.sales_leaderboard : null,
            assistant: assistant && assistant.sales_leaderboard ? assistant.sales_leaderboard : null
          },
          appointment_count_considered: {
            stylist: Number(stylist && stylist.appointment_count_considered || 0) || 0,
            assistant: Number(assistant && assistant.appointment_count_considered || 0) || 0
          }
        };
      }

      async function fetchRetailAnalyticsDashboard(){
        return {
          selected: await fetchRetailAnalyticsDashboardForWeek(activeRetailPayrollStart || ((buildRetailPeriodOptions()[0] || {}).value || ''))
        };
      }

      function applyRetailSnapshotToUi(snapshot, statusTone, statusSuffix){
        var activeSnapshot = snapshot || getRetailSnapshotForActiveWeek();
        var loadedRange = activeSnapshot && activeSnapshot.range ? activeSnapshot.range : getRetailDateRange();
        retailAnalyticsSummary = activeSnapshot || {};
        retailAnalyticsRows = [];
        retailSalesLeaderboard = activeSnapshot && activeSnapshot.sales_leaderboard ? activeSnapshot.sales_leaderboard : null;
        retailActivitySummary = {};
        retailActivityRows = [];
        retailActivityByAppointment = {};
        renderRetailDashboard();
        if (loadedRange) {
          var retailStatusLabel = loadedRange.label || (loadedRange.date_from + ' to ' + loadedRange.date_to);
          var liveThrough = String(loadedRange && loadedRange.live_through || '').trim();
          var suffix = String(statusSuffix || '').trim();
          setRetailStatus(
            retailStatusPrefixForRange(loadedRange)
              + ' · ' + retailStatusLabel
              + (loadedRange && loadedRange.is_live_current && liveThrough ? ' · live through ' + liveThrough : '')
              + (suffix ? ' · ' + suffix : ''),
            statusTone || 'success'
          );
        }
      }

      async function fetchRetailFollowupOpportunitiesForBusinessDevelopment(){
        var retailRange = buildBusinessDevelopmentRetailRange();
        var response = await fetch(RETAIL_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'get-retail-followup-opportunities',
            date_from: retailRange.date_from,
            date_to: retailRange.date_to,
            appointment_state: 'closed',
            followup_ready_only: true,
            limit: 250
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load retail follow-up opportunities.');
        }
        return data;
      }

      async function fetchRetailQueuedDrafts(){
        var queueStatus = String((retailQueueStatusFilter && retailQueueStatusFilter.value) || '').trim();
        var response = await fetch(RETAIL_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'get-retail-outreach-queue',
            status: queueStatus || '',
            limit: 50
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load queued retail drafts.');
        }
        return retailArray(data.rows);
      }

      async function fetchRetailCheckinActivity(rows){
        var appointmentIds = retailArray(rows).map(function(row){
          return String((row && row.appointment_id) || '').trim();
        }).filter(Boolean);
        if (!appointmentIds.length) {
          return {
            summary: {},
            rows: [],
            by_appointment: []
          };
        }
        var response = await fetch(RETAIL_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'get-checkin-activity-summary',
            appointment_ids: appointmentIds,
            limit: 2000
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load check-in activity.');
        }
        return data;
      }

      async function loadRetailQueuedDrafts(){
        retailQueuedRows = await fetchRetailQueuedDrafts();
        renderRetailQueuedDrafts();
      }

      async function loadRetailDashboard(){
        if (retailLoadPromise) return retailLoadPromise;
        retailLoadPromise = (async function(){
        hydrateRetailSnapshotsFromStorage();
        if (!activeRetailPayrollStart) {
          setRetailPayrollWindow('');
        }
        setRetailStatus('Loading retail period...');
        try {
          var dashboard;
          try {
            dashboard = await fetchRetailAnalyticsDashboard();
          } catch (initialError) {
            var retryAfterMs = parseRetryAfterMs(initialError);
            if (retryAfterMs > 0) {
              var retrySeconds = Math.max(1, Math.ceil(retryAfterMs / 1000));
              if (retryAfterMs <= RETAIL_AUTO_RETRY_MAX_MS) {
                setRetailStatus('Retail Success is rate limited. Retrying in about ' + String(retrySeconds) + 's...', 'warning');
                await delayMs(retryAfterMs);
                dashboard = await fetchRetailAnalyticsDashboard();
              } else {
                throw new Error('Retail Success is rate limited right now. Try refresh again in about ' + String(retrySeconds) + 's.');
              }
            } else {
              throw initialError;
            }
          }
          var selectedSnapshot = dashboard && dashboard.selected ? dashboard.selected : null;
          var selectedRange = selectedSnapshot && selectedSnapshot.range ? selectedSnapshot.range : getRetailDateRange();
          if (selectedRange && selectedRange.payroll_start) {
            persistRetailSnapshot(selectedRange.payroll_start, selectedSnapshot);
            activeRetailPayrollStart = selectedRange.payroll_start;
          }
          applyRetailSnapshotToUi(getRetailSnapshotForActiveWeek(), 'success');
          scheduleRetailQuarterPrefetch();
        } catch (error) {
          var savedSnapshot = getRetailSnapshotForActiveWeek();
          if (savedSnapshot) {
            applyRetailSnapshotToUi(savedSnapshot, 'warning', 'Showing the last saved results');
          } else {
            retailAnalyticsSummary = null;
            retailAnalyticsRows = [];
            retailSalesLeaderboard = null;
            retailActivitySummary = null;
            retailActivityRows = [];
            retailActivityByAppointment = {};
            if (retailSalesLeaderboardMount) {
              retailSalesLeaderboardMount.innerHTML = '<div class="retail-empty">Retail Success is taking longer than expected. Tap Refresh to try again.</div>';
            }
            setRetailStatus(humanizeClientFetchErrorMessage(error, 'Could not load Retail Success.'), 'error');
          }
        } finally {
          retailLoadPromise = null;
        }
        })();
        return retailLoadPromise;
      }

      async function ensureRetailLoaded(){
        hydrateRetailSnapshotsFromStorage();
        if (hasLoadedRetail) {
          var activeSnapshot = getRetailSnapshotForActiveWeek();
          if (activeSnapshot) {
            applyRetailSnapshotToUi(activeSnapshot, 'success', '');
            return;
          }
          await loadRetailDashboard();
          return;
        }
        hasLoadedRetail = true;
        await loadRetailDashboard();
      }

      async function logRetailOpportunityViews(rows){
        var appointmentIds = retailArray(rows).map(function(row){
          return String((row && row.appointment_id) || '').trim();
        }).filter(Boolean);
        if (!appointmentIds.length) return;
        try {
          await fetch(RETAIL_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'log-retail-opportunity-view',
              appointment_ids: appointmentIds,
              source: 'manager-dashboard'
            })
          });
        } catch (_error) {
        }
      }

      async function queueRetailOutreachDraft(appointmentId){
        var response = await fetch(RETAIL_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'create-retail-outreach-queue-item',
            appointment_id: appointmentId
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not queue retail SMS draft.');
        }
        return data;
      }

      async function markRetailOutreachSent(queueId){
        var response = await fetch(RETAIL_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'mark-retail-outreach-sent',
            queue_id: queueId,
            status: 'sent'
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not update retail outreach status.');
        }
        return data;
      }

      async function updateRetailOutreachDraft(queueId, draftedSmsMessage, markReviewed){
        var response = await fetch(RETAIL_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'update-retail-outreach-draft',
            queue_id: queueId,
            drafted_sms_message: draftedSmsMessage,
            mark_reviewed: !!markReviewed
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not update retail outreach draft.');
        }
        return data;
      }

      async function skipRetailOutreach(queueId, reason){
        var response = await fetch(RETAIL_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'skip-retail-outreach',
            queue_id: queueId,
            reason: String(reason || '')
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not skip retail outreach.');
        }
        return data;
      }

      async function regenerateRetailOutreachDraft(queueId, force){
        var response = await fetch(RETAIL_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'regenerate-retail-outreach-draft',
            queue_id: queueId,
            force: !!force
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not regenerate retail draft.');
        }
        return data;
      }

      async function fetchMasterScheduleAssignments(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'master-schedule-list'
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load master schedule.');
        }

        return data.rows.reduce(function(map, row){
          var staffId = String((row && row.staff_id) || '').trim();
          if (staffId) {
            map[staffId] = row;
          }
          return map;
        }, {});
      }

      async function fetchRequestOffQueue(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-request-off-list'
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load request queue.');
        }
        return data.rows;
      }

      async function fetchShiftChangeQueue(requestType){
        var body = {
          action: 'staff-shift-change-list'
        };
        if (requestType) {
          body.request_type = requestType;
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load shift change queue.');
        }
        return data.rows;
      }

      function getShiftChangeMeta(row){
        var sms = row && row.sms && typeof row.sms === 'object' ? row.sms : null;
        var meta = sms && sms.meta && typeof sms.meta === 'object' ? sms.meta : null;
        return meta || {};
      }

      function getRequestOffMeta(row){
        var sms = row && row.sms && typeof row.sms === 'object' ? row.sms : null;
        var meta = sms && sms.meta && typeof sms.meta === 'object' ? sms.meta : null;
        return meta || {};
      }

      function normalizeRequestOffScope(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'first_half') return 'first_half';
        if (normalized === 'second_half') return 'second_half';
        return 'full_shift';
      }

      function parseShiftLabelTimeRangeMinutes(label){
        var raw = String(label || '').trim().toLowerCase();
        if (!raw || raw === 'off') return null;
        var matched = raw.match(/^(\d{1,2})(?::(\d{2}))?\s*(a|am|p|pm)?\s*-\s*(\d{1,2})(?::(\d{2}))?\s*(a|am|p|pm)?$/i);
        if (!matched) return null;

        var startHour = Number(matched[1]);
        var startMinute = Number(matched[2] || 0);
        var startMeridiem = String(matched[3] || '').toLowerCase();
        var endHour = Number(matched[4]);
        var endMinute = Number(matched[5] || 0);
        var endMeridiem = String(matched[6] || '').toLowerCase();

        function toMinutes(hour, minute, meridiem){
          if (!isFinite(hour) || !isFinite(minute)) return null;
          var safeHour = hour % 12;
          var suffix = String(meridiem || '').toLowerCase();
          if (suffix === 'p' || suffix === 'pm') safeHour += 12;
          return (safeHour * 60) + minute;
        }

        function inferStartMeridiem(){
          if (startMeridiem) return startMeridiem;
          if (!endMeridiem) return '';
          var sameMeridiemStart = toMinutes(startHour, startMinute, endMeridiem);
          var endWithGivenMeridiem = toMinutes(endHour, endMinute, endMeridiem);
          if (sameMeridiemStart != null && endWithGivenMeridiem != null && sameMeridiemStart < endWithGivenMeridiem) {
            return endMeridiem;
          }
          if (endMeridiem === 'p' || endMeridiem === 'pm') {
            return startHour === 12 ? 'pm' : 'am';
          }
          if (endMeridiem === 'a' || endMeridiem === 'am') {
            return startHour === 12 ? 'am' : 'pm';
          }
          return '';
        }

        var resolvedStartMeridiem = inferStartMeridiem();
        var startMinutes = toMinutes(startHour, startMinute, resolvedStartMeridiem);
        var endMinutes = toMinutes(endHour, endMinute, endMeridiem);
        if (startMinutes == null || endMinutes == null || endMinutes <= startMinutes) return null;
        return {
          startMinutes: startMinutes,
          endMinutes: endMinutes,
          midpointMinutes: startMinutes + Math.round((endMinutes - startMinutes) / 2)
        };
      }

      function formatMinutesAsTimeLabel(totalMinutes){
        var safeMinutes = Number(totalMinutes);
        if (!isFinite(safeMinutes)) return '';
        var minutes = Math.max(0, Math.round(safeMinutes));
        var hour24 = Math.floor(minutes / 60) % 24;
        var minute = minutes % 60;
        var meridiem = hour24 >= 12 ? 'PM' : 'AM';
        var hour12 = hour24 % 12;
        if (!hour12) hour12 = 12;
        return hour12 + ':' + String(minute).padStart(2, '0') + ' ' + meridiem;
      }

      function buildRequestOffScopeDetails(staffId, dateValue, staffName){
        var shiftLabel = getAssignedShiftForRequestRow({ staff_id: staffId, staff_name: staffName }, dateValue);
        var parsedRange = parseShiftLabelTimeRangeMinutes(shiftLabel);
        return {
          shiftLabel: shiftLabel,
          parsedRange: parsedRange
        };
      }

      function getRequestOffScopeOptionLabel(scope, details){
        var normalized = normalizeRequestOffScope(scope);
        var shiftLabel = String(details && details.shiftLabel || '').trim();
        var parsedRange = details && details.parsedRange ? details.parsedRange : null;
        if (normalized === 'full_shift') {
          return shiftLabel ? 'Full day off (' + shiftLabel + ')' : 'Full day off';
        }
        if (!parsedRange) {
          return normalized === 'first_half'
            ? 'First half off (coming in late)'
            : 'Second half off (leaving early)';
        }
        if (normalized === 'first_half') {
          return 'First half off (coming in at ' + formatMinutesAsTimeLabel(parsedRange.midpointMinutes) + ')';
        }
        return 'Second half off (leaving at ' + formatMinutesAsTimeLabel(parsedRange.midpointMinutes) + ')';
      }

      function resolveRequestOffLevelNumber(roleName, staffName){
        var directLevel = parseRoleLevelNumber(roleName);
        if (directLevel != null) return directLevel;
        var mappedLevel = parseRoleLevelNumber(getLevelLabel(staffName));
        if (mappedLevel != null) return mappedLevel;
        return null;
      }

      function canStaffRequestPartialShift(roleName, staffName){
        var levelNumber = resolveRequestOffLevelNumber(roleName, staffName);
        return levelNumber != null && levelNumber >= 4;
      }

      function formatRequestOffScopeLabel(value){
        return getRequestOffScopeOptionLabel(value, null);
      }

      function formatShiftChangeTypeLabel(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'pick_up_shift') return 'Pick Up Shift';
        if (normalized === 'open_shift') return 'Open Shift';
        return 'Shift Switch';
      }

      function getMasterScheduleOptionsForDate(dateValue){
        var parsed = new Date(String(dateValue || '').trim() + 'T12:00:00');
        if (isNaN(parsed.getTime())) return [];
        var weekday = parsed.getDay();
        var key = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][weekday] || '';
        var dayConfig = MASTER_SCHEDULE_DAYS.find(function(entry){
          return entry.key === key;
        }) || null;
        var options = dayConfig && Array.isArray(dayConfig.options)
          ? dayConfig.options
          : MANUAL_OPEN_SHIFT_WEEKEND_OPTIONS;
        return options.filter(function(option){
          return String(option || '').trim() && String(option || '').trim().toUpperCase() !== 'OFF';
        });
      }

      function parseRoleLevelNumber(role){
        var raw = String(role || '').trim();
        if (!raw) return null;
        var matched = raw.match(/level\s+(\d+)/i);
        if (!matched) return null;
        var level = Number(matched[1]);
        return isFinite(level) ? level : null;
      }

      function canonicalStaffName(value){
        return String(value || '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      }

      function sameStaffName(left, right){
        var normalizedLeft = canonicalStaffName(left);
        var normalizedRight = canonicalStaffName(right);
        return !!normalizedLeft && normalizedLeft === normalizedRight;
      }

      function getUniqueRoleOptionsFromStaffOptions(options){
        var seen = {};
        return (Array.isArray(options) ? options : []).reduce(function(list, option){
          var role = String((option && option.role) || '').trim();
          if (!role) return list;
          var key = role.toLowerCase();
          if (seen[key]) return list;
          seen[key] = true;
          list.push(role);
          return list;
        }, []).sort(function(a, b){
          var aLevel = parseRoleLevelNumber(a);
          var bLevel = parseRoleLevelNumber(b);
          if (aLevel != null && bLevel != null && aLevel !== bLevel) return aLevel - bLevel;
          if (aLevel != null && bLevel == null) return -1;
          if (aLevel == null && bLevel != null) return 1;
          return String(a).localeCompare(String(b));
        });
      }

      function renderRoleChecklist(container, selectedRoles, attrsBuilder){
        if (!container) return;
        var roles = Array.isArray(requestOffRoleOptions) ? requestOffRoleOptions.slice() : [];
        if (!roles.length) {
          container.innerHTML = '<div class="request-review-empty">No roles available yet.</div>';
          return;
        }
        var selectedMap = {};
        (Array.isArray(selectedRoles) ? selectedRoles : []).forEach(function(role){
          selectedMap[String(role || '').trim().toLowerCase()] = true;
        });
        container.innerHTML = roles.map(function(role){
          var checked = !!selectedMap[String(role).toLowerCase()];
          var attrs = typeof attrsBuilder === 'function' ? attrsBuilder(role) : '';
          return ''
            + '<label class="role-check">'
            +   '<input type="checkbox" value="' + escapeHtml(role) + '"' + (checked ? ' checked' : '') + (attrs ? ' ' + attrs : '') + ' />'
            +   '<span>' + escapeHtml(role) + '</span>'
            + '</label>';
        }).join('');
      }

      function collectCheckedRoles(root, selector){
        return Array.prototype.slice.call((root || document).querySelectorAll(selector)).filter(function(node){
          return !!(node && node.checked);
        }).map(function(node){
          return String(node.value || '').trim();
        }).filter(Boolean);
      }

      function findMasterScheduleAssignment(staffId, staffName){
        var safeStaffId = String(staffId || '').trim();
        if (safeStaffId && masterScheduleAssignments[safeStaffId]) {
          return masterScheduleAssignments[safeStaffId];
        }
        var safeStaffName = String(staffName || '').trim();
        if (!safeStaffName) return null;
        var keys = Object.keys(masterScheduleAssignments || {});
        for (var index = 0; index < keys.length; index += 1) {
          var entry = masterScheduleAssignments[keys[index]];
          if (sameStaffName(entry && entry.staff_name, safeStaffName)) {
            return entry;
          }
        }
        return null;
      }

      function getAssignedShiftForRequestRow(row, dateValue){
        var staffId = String((row && row.staff_id) || '').trim();
        var staffName = String((row && row.staff_name) || '').trim();
        if (!staffId && !staffName) return '';
        var parsed = new Date(String(dateValue || '').trim() + 'T12:00:00');
        if (isNaN(parsed.getTime())) return '';
        var weekdayKey = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][parsed.getDay()] || '';
        var assignment = findMasterScheduleAssignment(staffId, staffName) || {};
        var value = String((assignment && assignment[weekdayKey]) || '').trim();
        return value && value.toUpperCase() !== 'OFF' ? value : '';
      }

      function getAssignedShiftTypeForRequestRow(row, dateValue){
        var staffId = String((row && row.staff_id) || '').trim();
        if (!staffId) return 'assisting';
        var parsed = new Date(String(dateValue || '').trim() + 'T12:00:00');
        if (isNaN(parsed.getTime())) return inferShiftTypeFromRole(row && row.role_name);
        var weekdayKey = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][parsed.getDay()] || '';
        var assignment = masterScheduleAssignments[staffId] || {};
        return getMasterScheduleShiftType(assignment, weekdayKey, row && row.role_name);
      }

      function getStaffOptionByIdOrName(staffId, staffName){
        var safeStaffId = String(staffId || '').trim();
        var safeStaffName = String(staffName || '').trim();
        return (Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions : []).find(function(option){
          return (safeStaffId && String((option && option.id) || '').trim() === safeStaffId)
            || (safeStaffName && sameStaffName(option && option.name, safeStaffName));
        }) || null;
      }

      function getAssignedShiftForStaffOption(option, dateValue){
        if (!option) return '';
        return getAssignedShiftForRequestRow({
          staff_id: option.id,
          staff_name: option.name
        }, dateValue);
      }

      function getAssignedShiftTypeForStaffOption(option, dateValue){
        if (!option) return 'assisting';
        return getAssignedShiftTypeForRequestRow({
          staff_id: option.id,
          role_name: option.role
        }, dateValue);
      }

      function getAssignedShiftChoicesForStaffOption(option, dateValue){
        var assignedShift = String(getAssignedShiftForStaffOption(option, dateValue) || '').trim();
        return assignedShift ? [assignedShift] : [];
      }

      function buildFillShiftFieldSelector(ownerType, ownerId, targetDate, fieldName){
        return '[data-fill-owner-type="' + escapeHtml(String(ownerType || '').trim())
          + '"][data-fill-owner-id="' + escapeHtml(String(ownerId || '').trim())
          + '"][data-fill-target-date="' + escapeHtml(String(targetDate || '').trim())
          + '"][data-fill-field="' + escapeHtml(String(fieldName || '').trim()) + '"]';
      }

      function getFillShiftField(root, ownerType, ownerId, targetDate, fieldName){
        return (root || document).querySelector(buildFillShiftFieldSelector(ownerType, ownerId, targetDate, fieldName));
      }

      function buildFillShiftStaffOptionsMarkup(selectedStaffId, excludedStaffId, excludedStaffName){
        var safeSelectedStaffId = String(selectedStaffId || '').trim();
        var safeExcludedStaffId = String(excludedStaffId || '').trim();
        var safeExcludedStaffName = String(excludedStaffName || '').trim();
        var options = (Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions : []).filter(function(option){
          if (!option) return false;
          if (safeExcludedStaffId && String(option.id || '').trim() === safeExcludedStaffId) return false;
          if (safeExcludedStaffName && sameStaffName(option.name, safeExcludedStaffName)) return false;
          return true;
        });
        return '<option value="">Choose staff</option>' + options.map(function(option){
          var optionId = String((option && option.id) || '').trim();
          var roleLabel = String((option && option.role) || '').trim();
          var selected = optionId === safeSelectedStaffId ? ' selected' : '';
          return '<option value="' + escapeHtml(optionId) + '"' + selected + '>'
            + escapeHtml(String((option && option.name) || '').trim() + (roleLabel ? ' - ' + roleLabel : ''))
            + '</option>';
        }).join('');
      }

      function renderFillShiftControls(ownerType, ownerId, targetDate, excludedStaffId, excludedStaffName){
        var safeOwnerType = String(ownerType || '').trim();
        var safeOwnerId = String(ownerId || '').trim();
        var safeTargetDate = String(targetDate || '').trim();
        return ''
          + '<div class="schedule-inlineAction">'
          +   '<div class="schedule-inlineActionHead">'
          +     '<strong>Fill this shift</strong>'
          +     '<span>Assign someone directly, or move them from another scheduled shift and repost that displaced coverage automatically.</span>'
          +   '</div>'
          +   '<div class="request-off-actions schedule-inlineActionRow">'
          +       '<select class="progression-valueEditor"'
          +         ' data-fill-owner-type="' + escapeHtml(safeOwnerType) + '"'
          +         ' data-fill-owner-id="' + escapeHtml(safeOwnerId) + '"'
          +         ' data-fill-target-date="' + escapeHtml(safeTargetDate) + '"'
          +         ' data-fill-field="mode">'
          +         '<option value="new_shift">New shift</option>'
          +         '<option value="existing_shift">Existing shift</option>'
          +       '</select>'
          +       '<select class="progression-valueEditor"'
          +         ' data-fill-owner-type="' + escapeHtml(safeOwnerType) + '"'
          +         ' data-fill-owner-id="' + escapeHtml(safeOwnerId) + '"'
          +         ' data-fill-target-date="' + escapeHtml(safeTargetDate) + '"'
          +         ' data-fill-field="staff">'
          +         buildFillShiftStaffOptionsMarkup('', excludedStaffId, excludedStaffName)
          +       '</select>'
          +       '<button class="btn-primary" type="button"'
          +         ' data-fill-shift-submit="true"'
          +         ' data-fill-owner-type="' + escapeHtml(safeOwnerType) + '"'
          +         ' data-fill-owner-id="' + escapeHtml(safeOwnerId) + '"'
          +         ' data-fill-target-date="' + escapeHtml(safeTargetDate) + '">Fill shift</button>'
          +   '</div>'
          +   '<div class="request-off-actions schedule-inlineActionRow" hidden'
          +       ' data-fill-source-group="true"'
          +       ' data-fill-owner-type="' + escapeHtml(safeOwnerType) + '"'
          +       ' data-fill-owner-id="' + escapeHtml(safeOwnerId) + '"'
          +       ' data-fill-target-date="' + escapeHtml(safeTargetDate) + '">'
          +       '<input class="progression-valueEditor" type="date"'
          +         ' value="' + escapeHtml(safeTargetDate) + '"'
          +         ' data-fill-owner-type="' + escapeHtml(safeOwnerType) + '"'
          +         ' data-fill-owner-id="' + escapeHtml(safeOwnerId) + '"'
          +         ' data-fill-target-date="' + escapeHtml(safeTargetDate) + '"'
          +         ' data-fill-field="source-date">'
          +       '<select class="progression-valueEditor"'
          +         ' data-fill-owner-type="' + escapeHtml(safeOwnerType) + '"'
          +         ' data-fill-owner-id="' + escapeHtml(safeOwnerId) + '"'
          +         ' data-fill-target-date="' + escapeHtml(safeTargetDate) + '"'
          +         ' data-fill-field="source-shift">'
          +         '<option value="">Choose the shift being replaced</option>'
          +       '</select>'
          +     '</div>'
          +   '<div class="schedule-inlineActionFoot">New shift assigns directly. Existing shift moves them off another scheduled shift and posts the gap as a new open shift.</div>'
          + '</div>';
      }

      function syncFillShiftControls(root, ownerType, ownerId, targetDate){
        var safeOwnerType = String(ownerType || '').trim();
        var safeOwnerId = String(ownerId || '').trim();
        var safeTargetDate = String(targetDate || '').trim();
        var modeField = getFillShiftField(root, safeOwnerType, safeOwnerId, safeTargetDate, 'mode');
        var staffField = getFillShiftField(root, safeOwnerType, safeOwnerId, safeTargetDate, 'staff');
        var sourceDateField = getFillShiftField(root, safeOwnerType, safeOwnerId, safeTargetDate, 'source-date');
        var sourceShiftField = getFillShiftField(root, safeOwnerType, safeOwnerId, safeTargetDate, 'source-shift');
        var submitButton = (root || document).querySelector(
          '[data-fill-shift-submit="true"][data-fill-owner-type="' + escapeHtml(safeOwnerType)
          + '"][data-fill-owner-id="' + escapeHtml(safeOwnerId)
          + '"][data-fill-target-date="' + escapeHtml(safeTargetDate) + '"]'
        );
        var sourceGroup = (root || document).querySelector(
          '[data-fill-source-group="true"][data-fill-owner-type="' + escapeHtml(safeOwnerType)
          + '"][data-fill-owner-id="' + escapeHtml(safeOwnerId)
          + '"][data-fill-target-date="' + escapeHtml(safeTargetDate) + '"]'
        );
        if (!modeField) return;
        var existingMode = String(modeField.value || '').trim() === 'existing_shift';
        if (sourceGroup) {
          sourceGroup.hidden = !existingMode;
        }
        if (!existingMode || !sourceShiftField) {
          if (submitButton) submitButton.disabled = false;
          return;
        }
        var selectedStaff = getStaffOptionByIdOrName(String(staffField && staffField.value || '').trim(), '');
        var sourceDateValue = String(sourceDateField && sourceDateField.value || '').trim();
        var options = sourceDateValue ? getAssignedShiftChoicesForStaffOption(selectedStaff, sourceDateValue) : [];
        var assignedShift = options[0] || '';
        var currentValue = String(sourceShiftField.value || '').trim();
        var selectedValue = options.indexOf(currentValue) !== -1
          ? currentValue
          : (options.indexOf(assignedShift) !== -1 ? assignedShift : (options[0] || ''));
        sourceShiftField.innerHTML = options.length
          ? options.map(function(option){
              var selected = option === selectedValue ? ' selected' : '';
              return '<option value="' + escapeHtml(option) + '"' + selected + '>' + escapeHtml(option) + '</option>';
            }).join('')
          : '<option value="">No scheduled shift found for this staff/date</option>';
        sourceShiftField.disabled = options.length <= 0;
        if (submitButton) {
          submitButton.disabled = options.length <= 0;
        }
      }

      function syncRequestOffScopeOptions(){
        if (!requestOffScope) return;
        var selectedStaffId = String(requestOffStaff && requestOffStaff.value || '').trim();
        var selectedDate = String(requestOffDate && requestOffDate.value || '').trim();
        var currentValue = normalizeRequestOffScope(requestOffScope.value);
        var selected = (Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions : []).find(function(option){
          return String((option && option.id) || '').trim() === selectedStaffId;
        }) || null;
        var details = buildRequestOffScopeDetails(selectedStaffId, selectedDate, selected && selected.name);
        var allowsPartialShift = canStaffRequestPartialShift(selected && selected.role, selected && selected.name);
        var canSplitShift = allowsPartialShift && !!(details && details.parsedRange);
        requestOffScope.innerHTML = ''
          + '<option value="full_shift">' + escapeHtml(getRequestOffScopeOptionLabel('full_shift', details)) + '</option>'
          + '<option value="first_half"' + (canSplitShift ? '' : ' disabled') + '>' + escapeHtml(getRequestOffScopeOptionLabel('first_half', details)) + '</option>'
          + '<option value="second_half"' + (canSplitShift ? '' : ' disabled') + '>' + escapeHtml(getRequestOffScopeOptionLabel('second_half', details)) + '</option>';
        if ((currentValue === 'first_half' || currentValue === 'second_half') && !canSplitShift) {
          requestOffScope.value = 'full_shift';
        } else {
          requestOffScope.value = currentValue;
        }
      }

      function buildRecentDateRange(days){
        var normalizedDays = Math.max(1, Number(days) || 1);
        var end = startOfLocalDay(new Date());
        var start = new Date(end);
        start.setDate(start.getDate() - (normalizedDays - 1));
        return {
          date_from: formatDateInputValue(start),
          date_to: formatDateInputValue(end)
        };
      }

      function buildAttendanceMetricMaps(remote){
        var sourceRows = Array.isArray(remote && remote.leaderboard)
          ? remote.leaderboard
          : [];
        var debugLeaderboards = remote && remote.debug && remote.debug.leaderboards
          ? remote.debug.leaderboards
          : {};

        function buildMetricMap(primaryKey, debugKey){
          if (sourceRows.length) {
            return sourceRows.reduce(function(map, row){
              var staffName = String((row && row.staff_name) || '').trim();
              if (staffName) {
                map[staffName] = primaryKey === 'reliability_score'
                  ? row[primaryKey]
                  : (Number((row && row[primaryKey]) || 0) || 0);
              }
              return map;
            }, {});
          }

          var debugRows = Array.isArray(debugLeaderboards && debugLeaderboards[debugKey] && debugLeaderboards[debugKey].leaderboard)
            ? debugLeaderboards[debugKey].leaderboard
            : [];
          return debugRows.reduce(function(map, row){
            var staffName = String((row && row.staff_name) || '').trim();
            if (staffName) {
              map[staffName] = primaryKey === 'reliability_score'
                ? row.reliability_score
                : (Number((row && row[primaryKey]) || 0) || 0);
            }
            return map;
          }, {});
        }

        return {
          reliabilityScoreByStaff: buildMetricMap('reliability_score', 'reliability_score'),
          requestsOffByStaff: buildMetricMap('requests_off', 'requests_off'),
          callOutsByStaff: buildMetricMap('call_outs', 'call_outs'),
          lateArrivalsByStaff: buildMetricMap('late_arrivals', 'late_arrivals')
        };
      }

      async function fetchAttendanceTotalsForDateRange(dateFromValue, dateToValue){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'attendance-totals',
            date_from: dateFromValue || '',
            date_to: dateToValue || ''
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          var bodySnippet = String((data && data.error) || rawText || '')
            .replace(/\s+/g, ' ')
            .trim()
            .slice(0, 220);
          throw new Error(
            'Proxy response was not usable (status ' + response.status + ')'
            + (bodySnippet ? '. Body: ' + bodySnippet : '')
          );
        }
        return data;
      }

      function resolveAttendanceSnapshotKey(dateFromValue, dateToValue){
        var matchedFrom = parseYmd(dateFromValue);
        var matchedTo = parseYmd(dateToValue);
        if (!matchedFrom || !matchedTo) return '';

        var today = startOfLocalDay(new Date());
        if (startOfLocalDay(matchedTo).getTime() !== today.getTime()) {
          return '';
        }

        var totalDays = diffDaysInclusive(matchedFrom, matchedTo);
        if (totalDays === 30) return 'attendance_last_30_days';
        if (totalDays === 90 || totalDays === 365) return 'attendance_last_90_days';

        if (matchedFrom.getFullYear() === today.getFullYear() &&
            matchedFrom.getMonth() === today.getMonth() &&
            matchedFrom.getDate() === 1) {
          return 'attendance_month_to_date';
        }

        if (matchedFrom.getFullYear() === today.getFullYear() &&
            matchedFrom.getMonth() === 0 &&
            matchedFrom.getDate() === 1) {
          return 'attendance_ytd';
        }

        return '';
      }

      async function fetchAttendanceTotalsSnapshotOrLive(dateFromValue, dateToValue){
        var snapshotKey = resolveAttendanceSnapshotKey(dateFromValue, dateToValue);
        if (snapshotKey) {
          try {
            var snapshotResponse = await fetch(REPORT_PROXY_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                action: 'attendance-totals-snapshot-get',
                snapshot_key: snapshotKey,
                refresh_if_missing: false
              })
            });
            var snapshotRawText = await snapshotResponse.text();
            var snapshotData = null;
            try {
              snapshotData = snapshotRawText ? JSON.parse(snapshotRawText) : null;
            } catch (_error) {
              snapshotData = null;
            }
            if (snapshotResponse.ok && snapshotData && snapshotData.ok && snapshotData.snapshot) {
              snapshotData.snapshot_source = 'saved';
              snapshotData.snapshot_date = snapshotData.snapshot.snapshot_date || '';
              snapshotData.snapshot_key = snapshotKey;
              return snapshotData;
            }
          } catch (_snapshotError) {
          }
        }

        var liveData = await fetchAttendanceTotalsForDateRange(dateFromValue, dateToValue);
        if (liveData && typeof liveData === 'object') {
          liveData.snapshot_source = 'live';
        }
        return liveData;
      }

      async function loadRequestQueueAttendanceMetrics(){
        var remote = null;
        try {
          var snapshotResponse = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'attendance-totals-snapshot-get',
              snapshot_key: 'attendance_last_90_days',
              refresh_if_missing: true
            })
          });
          var snapshotRawText = await snapshotResponse.text();
          var snapshotData = null;
          try {
            snapshotData = snapshotRawText ? JSON.parse(snapshotRawText) : null;
          } catch (_error) {
            snapshotData = null;
          }
          if (!snapshotResponse.ok || !snapshotData || !snapshotData.ok) {
            throw new Error((snapshotData && snapshotData.error) || snapshotRawText || 'Could not load attendance snapshot.');
          }
          remote = snapshotData;
        } catch (_error) {
          var range = buildRecentDateRange(365);
          remote = await fetchAttendanceTotalsForDateRange(range.date_from, range.date_to);
        }
        var metrics = buildAttendanceMetricMaps(remote);
        requestQueueReliabilityScoreByStaff = metrics.reliabilityScoreByStaff;
        requestQueueRequestsOffByStaff = metrics.requestsOffByStaff;
        requestQueueCallOutsByStaff = metrics.callOutsByStaff;
        requestQueueLateArrivalsByStaff = metrics.lateArrivalsByStaff;
      }

      function formatRequestReviewSubmitted(value){
        if (value == null) return '';
        var normalized = String(value || '').trim();
        if (!normalized || normalized === '0') return '';
        var parsed = new Date(normalized);
        if (isNaN(parsed.getTime()) || parsed.getTime() <= 1000) return '';
        return parsed.toLocaleString(undefined, {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        });
      }

      function formatRequestReviewDates(values){
        if (!Array.isArray(values) || !values.length) return 'No dates';
        return values.map(function(value){
          var parsed = new Date(String(value) + 'T12:00:00');
          if (isNaN(parsed.getTime())) return String(value || '');
          return parsed.toLocaleDateString(undefined, {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          });
        }).join(', ');
      }

      function formatDateTimeLocalInputValue(value){
        if (value == null) return '';
        var normalized = String(value || '').trim();
        if (!normalized || normalized === '0') return '';
        var parsed = new Date(normalized);
        if (isNaN(parsed.getTime()) || parsed.getTime() <= 1000) return '';
        var local = new Date(parsed.getTime() - (parsed.getTimezoneOffset() * 60000));
        return local.toISOString().slice(0, 16);
      }

      function buildPostAppointmentSmsEngagementSummary(row){
        var engagement = row && row.engagement && typeof row.engagement === 'object' ? row.engagement : {};
        var shopifyPurchase = row && row.shopify_purchase && typeof row.shopify_purchase === 'object' ? row.shopify_purchase : {};
        var bits = [];
        var pageViews = Math.max(0, Number(engagement.page_view_count || 0) || 0);
        var retailAdds = Math.max(0, Number(engagement.retail_add_count || 0) || 0);
        var shopifyOrderCount = Math.max(0, Number(shopifyPurchase.order_count || 0) || 0);
        var shopifySales = Number(shopifyPurchase.total_sales || 0);
        var gratuityLabel = String(engagement.gratuity_label || '').trim();
        var tipLinkClickCount = Math.max(0, Number(engagement.tip_link_click_count || 0) || 0);
        var tipTargetName = String(engagement.tip_target_name || '').trim();
        if (pageViews > 0) bits.push(pageViews === 1 ? 'Opened link once' : String(pageViews) + ' link opens');
        if (engagement.next_visit_booking_opened === true) bits.push('Opened booking');
        if (engagement.next_visit_booking_completed === true) bits.push('Booked next visit');
        if (engagement.tip_module_opened === true) bits.push('Opened tipping');
        if (engagement.tip_link_clicked === true) {
          if (tipTargetName && tipLinkClickCount <= 1) bits.push('Opened tip for ' + tipTargetName);
          else if (tipLinkClickCount > 1) bits.push('Opened ' + String(tipLinkClickCount) + ' tip links');
          else bits.push('Opened tip link');
        } else if (engagement.gratuity_selected === true) {
          if (/^no\s*tip$/i.test(gratuityLabel)) bits.push('Chose no tip');
          else if (gratuityLabel) bits.push('Selected gratuity ' + gratuityLabel);
          else bits.push('Selected gratuity');
        }
        if (engagement.recommendation_saved === true) bits.push('Saved routine');
        if (retailAdds > 0) bits.push(retailAdds === 1 ? 'Added 1 product' : 'Added ' + String(retailAdds) + ' products');
        if (engagement.hair_story_saved === true) bits.push('Saved story');
        if (shopifyPurchase.has_purchase === true && shopifyOrderCount > 0) {
          bits.push(
            shopifyOrderCount === 1
              ? ('Purchased on Shopify' + (shopifySales > 0 ? ' (' + formatCurrency(shopifySales) + ')' : ''))
              : (String(shopifyOrderCount) + ' Shopify orders' + (shopifySales > 0 ? ' (' + formatCurrency(shopifySales) + ')' : ''))
          );
        }
        return {
          summary: bits.join(' · '),
          lastActivityAt: formatRequestReviewSubmitted(engagement.last_activity_at)
        };
      }

      function buildPostAppointmentSmsRatingSummary(row){
        var engagement = row && row.engagement && typeof row.engagement === 'object' ? row.engagement : {};
        var rating = Number((row && row.appointment_rating) || (engagement && engagement.rating_value) || 0) || 0;
        var feedback = compactWhitespace(row && row.appointment_feedback);
        var submittedAt = formatRequestReviewSubmitted((row && row.appointment_rating_submitted_at) || (engagement && engagement.rating_submitted_at));
        var feedbackLength = Math.max(0, Number(engagement && engagement.rating_feedback_length || 0) || 0);
        if (rating > 0) {
          var normalizedRating = Math.max(0, Math.min(5, Math.trunc(rating)));
          return {
            ratingValue: normalizedRating,
            headline: String(normalizedRating) + ' stars',
            detail: submittedAt ? ('Submitted ' + submittedAt) : 'Rating submitted',
            feedback: feedback || (feedbackLength > 0 ? 'Feedback added.' : '')
          };
        }
        if (engagement.rating_saved === true) {
          return {
            ratingValue: 0,
            headline: 'Saved',
            detail: submittedAt ? ('Submitted ' + submittedAt) : 'Rating interaction tracked',
            feedback: feedback || (feedbackLength > 0 ? 'Feedback added.' : '')
          };
        }
        return {
          ratingValue: 0,
          headline: 'No rating',
          detail: 'No saved rating yet.',
          feedback: ''
        };
      }

      function compactWhitespace(value){
        return String(value || '').replace(/\s+/g, ' ').trim();
      }

      function buildPostAppointmentSmsMessagePreview(body){
        var compact = compactWhitespace(body);
        if (!compact) return 'No message saved.';
        if (compact.length <= 138) return compact;
        return compact.slice(0, 135).replace(/[,\s.;:!?-]+$/g, '') + '...';
      }

      function firstRequestDateValue(row){
        var values = Array.isArray(row && row.requested_dates) ? row.requested_dates : [];
        return String(values[0] || '').trim();
      }

      function isPastRequestRow(row){
        var firstDate = firstRequestDateValue(row);
        if (!firstDate) return false;
        var today = new Date();
        var todayValue = [
          today.getFullYear(),
          String(today.getMonth() + 1).padStart(2, '0'),
          String(today.getDate()).padStart(2, '0')
        ].join('-');
        return firstDate < todayValue;
      }

      function uniqueNonEmptyStrings(values){
        if (!Array.isArray(values)) return [];
        var seen = {};
        return values.reduce(function(list, value){
          var text = String(value || '').trim();
          if (!text || seen[text]) return list;
          seen[text] = true;
          list.push(text);
          return list;
        }, []);
      }

      function renderRequestReviewDebugLine(label, value){
        var text = String(value || '').trim();
        if (!text) return '';
        return ''
          + '<div class="request-review-debug-line">'
          +   '<div class="request-review-debug-label">' + escapeHtml(label) + '</div>'
          +   '<div class="request-review-debug-value">' + escapeHtml(text) + '</div>'
          + '</div>';
      }

      function dueScorecardCardMarkup(label, value, sub){
        return ''
          + '<div class="queue-scorecardCard">'
          +   '<div class="queue-scorecardLabel">' + escapeHtml(label) + '</div>'
          +   '<div class="queue-scorecardValue">' + escapeHtml(String(value || '0')) + '</div>'
          +   '<div class="queue-scorecardSub">' + escapeHtml(sub || '') + '</div>'
          + '</div>';
      }

      function trendDeltaLabel(value, suffix){
        var numeric = Number(value || 0) || 0;
        var rounded = Math.round(Math.abs(numeric));
        var prefix = numeric > 0 ? '+' : (numeric < 0 ? '−' : '');
        return prefix + String(rounded) + (suffix || '');
      }

      function trendTone(value){
        var numeric = Number(value || 0) || 0;
        if (numeric > 0) return 'success';
        if (numeric < 0) return 'danger';
        return 'muted';
      }

      function dueTrendMetricMarkup(label, currentValue, deltaValue, suffix){
        return ''
          + '<div class="queue-trendMetric">'
          +   '<div class="queue-trendMetricLabel">' + escapeHtml(label) + '</div>'
          +   '<div class="queue-trendMetricValue">' + escapeHtml(String(currentValue || '0')) + '</div>'
          +   '<div class="queue-trendMetricDelta" data-tone="' + escapeHtml(trendTone(deltaValue)) + '">' + escapeHtml(trendDeltaLabel(deltaValue, suffix)) + ' vs prior</div>'
          + '</div>';
      }

      function dueRecoveryDateLabel(row){
        var recoveryAt = retailTextValue(row && row.completed_at, '') || retailTextValue(row && row.completed_visit_at, '') || retailTextValue(row && row.future_appointment_at, '');
        return recoveryAt ? formatRecaptureDate(recoveryAt) : 'Unknown date';
      }

      function dueRecoveryMethodLabel(row){
        var method = retailTextValue(row && row.recovery_type, '').toLowerCase();
        if (method === 'completed_visit') return 'Completed visit';
        if (method === 'future_booking') return 'Future booking';
        return retailTextValue(row && row.recovery_label, '') || 'Recorded win';
      }

      function dueRecoveryFeedMarkup(rows, isMine){
        var feedRows = retailArray(rows).slice(0, 12);
        if (!feedRows.length) {
          return '<div class="retail-empty">' + escapeHtml(isMine ? 'No recovered clients credited to you in this window yet.' : 'No recovered clients recorded in this window yet.') + '</div>';
        }
        return feedRows.map(function(row){
          var guestName = retailTextValue(row && row.guest_name, 'Unknown guest');
          var managerName = retailTextValue(row && row.recorded_by_name, 'Unknown manager');
          var methodLabel = dueRecoveryMethodLabel(row);
          var whenLabel = dueRecoveryDateLabel(row);
          var summary = retailTextValue(row && row.outcome_summary, '');
          var bookedServicesValue = Number(row && row.revenue_cents) > 0
            ? formatCurrencyDollarsFromCents(Number(row && row.revenue_cents) || 0)
            : '';
          return ''
            + '<div class="queue-recoveryRow">'
            +   '<div class="queue-recoveryMain">'
            +     '<strong>' + escapeHtml(guestName) + '</strong>'
            +     '<span>' + escapeHtml(methodLabel + ' • ' + whenLabel) + '</span>'
            +     (summary ? '<span>' + escapeHtml(summary) + '</span>' : '')
            +   '</div>'
            +   '<div class="queue-recoveryMeta">' + escapeHtml((bookedServicesValue ? 'Booked services ' + bookedServicesValue + ' • ' : '') + (isMine ? 'Credited to you' : 'Credited to ' + managerName)) + '</div>'
            + '</div>';
        }).join('');
      }

      function renderDueScorecard(){
        if (!dueScorecardMount) return;
        var summary = dueQueueScorecard && typeof dueQueueScorecard === 'object' ? dueQueueScorecard : null;
        if (!summary) {
          dueScorecardMount.innerHTML = '<div class="retail-empty">Manager scorecard will load here.</div>';
          return;
        }
        var overall = summary.overall && typeof summary.overall === 'object' ? summary.overall : {};
        var mine = summary.mine && typeof summary.mine === 'object' ? summary.mine : null;
        if (dueScorecardFocus === 'mine' && !mine) {
          dueScorecardMount.innerHTML = '<div class="retail-empty">Unlock a manager session to view personal results.</div>';
          return;
        }
        var activeSummary = dueScorecardFocus === 'mine' && mine ? mine : overall;
        var trend = dueScorecardFocus === 'mine' && mine && mine.trend && typeof mine.trend === 'object'
          ? mine.trend
          : (summary.trend && typeof summary.trend === 'object' ? summary.trend : {});
        var currentVsPrevious = trend.current_vs_previous && typeof trend.current_vs_previous === 'object' ? trend.current_vs_previous : {};
        var trailingNinety = trend.trailing_90_days && typeof trend.trailing_90_days === 'object' ? trend.trailing_90_days : {};
        var windowDays = Number((trend && trend.window_days) || 30) || 30;
        var recentRecoveries = retailArray(activeSummary && activeSummary.recent_recoveries);
        var leaderboard = retailArray(summary.leaderboard).slice(0, 5);
        var leaderboardMarkup = leaderboard.length
          ? leaderboard.map(function(row){
              var name = retailTextValue(row && row.staff_name, 'Unknown manager');
              var rank = Number((row && row.rank) || 0) || 0;
              var score = Number((row && row.score) || 0) || 0;
              var wins = (Number((row && row.appointments_recovered) || 0) || 0)
                + (Number((row && row.retail_wins) || 0) || 0)
                + (Number((row && row.referral_wins) || 0) || 0)
                + (Number((row && row.reviews_completed) || 0) || 0);
              var recovered = Number((row && row.appointments_recovered) || 0) || 0;
              return ''
                + '<div class="queue-leaderboardRow">'
                +   '<div class="queue-leaderboardMain">'
                +     '<strong>' + escapeHtml('#' + String(rank) + ' ' + name) + '</strong>'
                +     '<span>' + escapeHtml(String(recovered) + ' recovered • ' + String(wins) + ' wins • ' + String(score) + ' pts') + '</span>'
                +   '</div>'
                + '</div>';
            }).join('')
          : '<div class="retail-empty">No manager outcomes recorded yet.</div>';
        var myLine = mine && mine.leaderboard
          ? '<div class="queue-leaderboardMyLine">Your rank: #' + escapeHtml(String((mine.leaderboard && mine.leaderboard.rank) || 0)) + ' • ' + escapeHtml(String((mine.leaderboard && mine.leaderboard.appointments_recovered) || 0)) + ' recovered • ' + escapeHtml(String((mine.leaderboard && mine.leaderboard.score) || 0)) + ' pts</div>'
          : '<div class="queue-leaderboardMyLine">Record outcomes to start your manager scorecard.</div>';
        dueScorecardMount.innerHTML = ''
          + '<div class="queue-scorecardGrid">'
          +   dueScorecardCardMarkup('Recovered', String(activeSummary.appointments_recovered || 0), dueScorecardFocus === 'mine' ? 'Your booked outcomes after follow-up' : 'Appointments booked after follow-up')
          +   dueScorecardCardMarkup('Booked Services Value', formatCurrencyDollarsFromCents(Number(activeSummary.service_revenue_cents || 0) || 0), dueScorecardFocus === 'mine' ? 'Value of your booked service wins' : 'Value of services booked after follow-up')
          +   dueScorecardCardMarkup('Open Tasks', String(activeSummary.open_tasks || 0), dueScorecardFocus === 'mine' ? 'Claimed or assigned clients still being worked' : 'Queue items still being worked')
          +   dueScorecardCardMarkup('Retail Wins', String(activeSummary.retail_wins || 0), dueScorecardFocus === 'mine' ? 'Your retail outcomes recorded' : 'Retail outcomes recorded')
          +   dueScorecardCardMarkup('Referral Wins', String(activeSummary.referral_wins || 0), dueScorecardFocus === 'mine' ? 'Your referral bookings recorded' : 'Referral bookings recorded')
          +   dueScorecardCardMarkup('Reviews', String(activeSummary.reviews_completed || 0), dueScorecardFocus === 'mine' ? 'Your review completions recorded' : 'Review completions recorded')
          + '</div>'
          + '<div class="queue-leaderboardBlock">'
          +   '<div class="queue-leaderboardTitle">' + escapeHtml((dueScorecardFocus === 'mine' ? 'My ' : 'Team ') + String(windowDays) + '-Day Trend') + '</div>'
          +   '<div class="queue-trendGrid">'
          +     dueTrendMetricMarkup('Total Wins', String(currentVsPrevious.total_outcomes && currentVsPrevious.total_outcomes.current || 0), currentVsPrevious.total_outcomes && currentVsPrevious.total_outcomes.delta, '')
          +     dueTrendMetricMarkup('Recovered', String(currentVsPrevious.appointments_recovered && currentVsPrevious.appointments_recovered.current || 0), currentVsPrevious.appointments_recovered && currentVsPrevious.appointments_recovered.delta, '')
          +     dueTrendMetricMarkup('Retail', String(currentVsPrevious.retail_wins && currentVsPrevious.retail_wins.current || 0), currentVsPrevious.retail_wins && currentVsPrevious.retail_wins.delta, '')
          +     dueTrendMetricMarkup('Referrals', String(currentVsPrevious.referral_wins && currentVsPrevious.referral_wins.current || 0), currentVsPrevious.referral_wins && currentVsPrevious.referral_wins.delta, '')
          +   '</div>'
          +   '<div class="queue-leaderboardMyLine">Trailing 90 days: ' + escapeHtml(String(trailingNinety.total_outcomes || 0)) + ' wins • ' + escapeHtml(String(trailingNinety.appointments_recovered || 0)) + ' recovered</div>'
          + '</div>'
          + '<div class="queue-leaderboardBlock">'
          +   '<div class="queue-leaderboardTitle">' + (dueScorecardFocus === 'mine' ? 'My Recovered Clients' : 'Recovered Clients') + '</div>'
          +   dueRecoveryFeedMarkup(recentRecoveries, dueScorecardFocus === 'mine')
          + '</div>'
          + '<div class="queue-leaderboardBlock">'
          +   '<div class="queue-leaderboardTitle">' + (dueScorecardFocus === 'mine' ? 'Leaderboard Context' : 'Top Managers') + '</div>'
          +   myLine
          +   leaderboardMarkup
          + '</div>';
      }

      function renderRequestReviewMetric(label, value){
        return ''
          + '<div class="request-review-metric">'
          +   '<span class="request-review-metric-label">' + escapeHtml(label) + '</span>'
          +   '<strong>' + escapeHtml(value) + '</strong>'
          + '</div>';
      }

      function getRequestQueueReliabilityScoreLabel(staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName) return '100.0%';
        var score = requestQueueReliabilityScoreByStaff[normalizedName];
        var numeric = score == null ? 100 : Number(score);
        if (!isFinite(numeric)) numeric = 100;
        return numeric.toFixed(1) + '%';
      }

      function getRequestQueueAttendanceCount(map, staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName) return 0;
        var value = map && map[normalizedName];
        var numeric = Number(value);
        return isFinite(numeric) ? numeric : 0;
      }

      function buildApprovedFutureDaysByStaff(rows){
        var today = startOfLocalDay(new Date());
        var todayValue = [
          today.getFullYear(),
          String(today.getMonth() + 1).padStart(2, '0'),
          String(today.getDate()).padStart(2, '0')
        ].join('-');

        var datesByStaff = (Array.isArray(rows) ? rows : []).reduce(function(map, row){
          var status = String((row && row.status) || '').trim().toLowerCase();
          var staffName = String((row && row.staff_name) || '').trim();
          var requestedDates = Array.isArray(row && row.requested_dates) ? row.requested_dates : [];
          if (status !== 'approved' || !staffName || !requestedDates.length) {
            return map;
          }

          if (!map[staffName]) {
            map[staffName] = [];
          }

          requestedDates.forEach(function(value){
            var dateValue = String(value || '').trim();
            if (dateValue && dateValue >= todayValue) {
              map[staffName].push(dateValue);
            }
          });
          return map;
        }, {});

        return Object.keys(datesByStaff).reduce(function(map, staffName){
          map[staffName] = uniqueNonEmptyStrings(datesByStaff[staffName]).length;
          return map;
        }, {});
      }

      function renderRequestOffQueue(){
        var visibleRows = getVisibleRequestQueueRows();
        requestQueueApprovedFutureDaysByStaff = buildApprovedFutureDaysByStaff(requestOffQueue);
        updateRequestQueueFilterCounts(visibleRows);
        syncRequestQueueFilterUi();

        visibleRows.sort(function(a, b){
          var dateA = firstRequestDateValue(a);
          var dateB = firstRequestDateValue(b);
          if (dateA !== dateB) return dateA.localeCompare(dateB);

          var statusCompare = getRequestQueueStatusOrder((a && a.status)) - getRequestQueueStatusOrder((b && b.status));
          if (statusCompare) return statusCompare;

          var submittedA = String((a && a.submitted_at) || '').trim();
          var submittedB = String((b && b.submitted_at) || '').trim();
          if (submittedA !== submittedB) return submittedA.localeCompare(submittedB);
          return String((a && a.staff_name) || '').trim().localeCompare(String((b && b.staff_name) || '').trim());
        });

        var filteredRows = visibleRows.filter(function(row){
          var matchesStatus = requestQueueFilter === 'all'
            || String((row && row.status) || '').trim().toLowerCase() === requestQueueFilter;
          if (!matchesStatus) return false;
          if (!requestQueueSearchTerm) return true;
          return String((row && row.staff_name) || '').trim().toLowerCase().indexOf(requestQueueSearchTerm) !== -1;
        });

        if (!filteredRows.length) {
          var emptyMessage = requestQueueSearchTerm
            ? 'No request-off entries match your name search.'
            : (requestQueueFilter === 'all'
              ? 'No request-off submissions yet.'
              : 'No ' + requestQueueFilter + ' request-off submissions.');
          requestReviewList.innerHTML = '<div class="request-review-empty">' + escapeHtml(emptyMessage) + '</div>';
          updateRequestsTabCount();
          return;
        }

        if (requestQueueFilter === 'all') {
          var statusOrder = ['pending', 'approved', 'denied'];
          requestReviewList.innerHTML = statusOrder.map(function(status){
            var rows = filteredRows.filter(function(row){
              return String((row && row.status) || '').trim().toLowerCase() === status;
            });
            if (!rows.length) return '';
            return ''
              + '<section class="request-review-group" data-status-group="' + escapeHtml(status) + '">'
              +   '<div class="request-review-groupHead">'
              +     '<h3 class="request-review-groupTitle">' + escapeHtml(getRequestQueueStatusLabel(status)) + '</h3>'
              +     '<span class="request-review-groupCount">' + escapeHtml(String(rows.length)) + '</span>'
              +   '</div>'
              +   rows.map(function(row){
                    return isShiftSwapQueueRow(row) ? renderShiftSwapQueueCard(row) : renderRequestOffQueueCard(row);
                  }).join('')
              + '</section>';
          }).filter(Boolean).join('');
        } else {
          requestReviewList.innerHTML = filteredRows.map(function(row){
            return isShiftSwapQueueRow(row) ? renderShiftSwapQueueCard(row) : renderRequestOffQueueCard(row);
          }).join('');
        }
        updateRequestsTabCount();
      }

      function getShiftChangeRequestTypeLabel(value){
        return formatShiftChangeTypeLabel(value);
      }

      function renderOpenShiftCardShiftBlock(shiftLabel, shiftTypeLabel, roleLabel, roleValue){
        var safeShiftLabel = String(shiftLabel || '').trim();
        var safeShiftTypeLabel = String(shiftTypeLabel || '').trim();
        var safeRoleLabel = String(roleLabel || '').trim();
        var safeRoleValue = String(roleValue || '').trim();
        return ''
          + (safeShiftLabel || safeShiftTypeLabel
              ? '<div class="request-review-shiftLine">'
                + (safeShiftLabel ? '<span class="request-review-shiftValue">' + escapeHtml(safeShiftLabel) + '</span>' : '')
                + (safeShiftTypeLabel ? '<span class="request-review-token request-review-token--accent">' + escapeHtml(safeShiftTypeLabel) + '</span>' : '')
              + '</div>'
              : '')
          + (safeRoleValue
              ? '<div class="request-review-roleLine">'
                + (safeRoleLabel ? '<span class="request-review-label">' + escapeHtml(safeRoleLabel) + '</span>' : '')
                + '<span>' + escapeHtml(safeRoleValue) + '</span>'
              + '</div>'
              : '');
      }

      function getAvailableOpenShiftRows(){
        var rows = Array.isArray(shiftChangeQueue) ? shiftChangeQueue.filter(function(row){
          var meta = getShiftChangeMeta(row);
          return String((row && row.request_type) || '').trim().toLowerCase() === 'open_shift'
            && String((row && row.status) || '').trim().toLowerCase() === 'approved'
            && String((meta.open_status) || 'open').trim().toLowerCase() !== 'filled'
            && !isPastRequestRow({ requested_dates: [row && row.request_date] });
        }) : [];

        rows.sort(function(a, b){
          return String((a && a.request_date) || '').localeCompare(String((b && b.request_date) || ''))
            || String((a && a.shift_label) || '').localeCompare(String((b && b.shift_label) || ''));
        });
        return rows;
      }

      function getAvailableOpenShiftMarkup(rows){
        return rows.map(function(row){
          var rowId = String((row && row.id) || '').trim();
          var meta = getShiftChangeMeta(row);
          var allowedRoles = Array.isArray(meta.allowed_role_labels) ? meta.allowed_role_labels : [];
          var allowedRolesLabel = allowedRoles.join(', ');
          var sourceLabel = getOpenShiftSourceLabel(meta);
          var shiftTypeLabel = formatShiftTypeLabel(meta.shift_type);
          var shiftTypeOptions = MASTER_SCHEDULE_SHIFT_TYPES.map(function(option){
            var selected = option.value === String(meta.shift_type || '').trim().toLowerCase() ? ' selected' : '';
            return '<option value="' + escapeHtml(option.value) + '"' + selected + '>' + escapeHtml(option.label) + '</option>';
          }).join('');
          var eligibilityRoleOptions = Array.isArray(requestOffRoleOptions) ? requestOffRoleOptions.slice() : [];
          allowedRoles.forEach(function(role){
            if (eligibilityRoleOptions.indexOf(role) === -1) eligibilityRoleOptions.push(role);
          });
          var eligibilityRoleMarkup = eligibilityRoleOptions.map(function(role){
            var checked = allowedRoles.indexOf(role) !== -1 ? ' checked' : '';
            return '<label class="role-check"><input type="checkbox" value="' + escapeHtml(role) + '" data-open-shift-edit-role="' + escapeHtml(rowId) + '"' + checked + ' /><span>' + escapeHtml(role) + '</span></label>';
          }).join('') || '<div class="request-review-empty">No Boulevard levels or roles are available yet.</div>';
          return ''
            + '<article class="request-review-card request-review-card--schedule" data-status="approved" data-open-kind="available">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
            +       '<div class="request-review-meta">'
            +         '<div class="request-review-name">Open shift available</div>'
            +         '<div class="request-review-dates">' + escapeHtml(formatRequestReviewDates([row && row.request_date])) + '</div>'
            +         renderOpenShiftCardShiftBlock(String((row && row.shift_label) || '').trim(), shiftTypeLabel, 'Eligible', allowedRolesLabel || 'Any role')
            +         '<div>' + escapeHtml(sourceLabel) + '</div>'
            +       '</div>'
            +     '</div>'
            +     '<div class="request-review-side">'
            +       '<span class="request-review-badge" data-status="approved">open</span>'
            +       '<div class="request-review-actions">'
            +         '<button class="btn-secondary" type="button" data-open-shift-manage="unpost" data-request-id="' + escapeHtml(rowId) + '">Unpost</button>'
            +       '</div>'
            +     '</div>'
            +   '</div>'
            +   '<details class="schedule-inlineWorkbench" data-open-shift-eligibility-editor="' + escapeHtml(rowId) + '">'
            +     '<summary>Edit role &amp; eligible levels</summary>'
            +     '<div class="request-off-grid request-off-grid--manual-open">'
            +       '<div class="field"><label>Shift role</label><select data-open-shift-edit-type="' + escapeHtml(rowId) + '">' + shiftTypeOptions + '</select></div>'
            +       '<div class="field schedule-fastFieldSpan"><label>Eligible levels and roles</label><div class="role-checklist">' + eligibilityRoleMarkup + '</div></div>'
            +       '<div class="request-off-actions schedule-fastFieldSpan"><button class="btn-primary" type="button" data-open-shift-manage="update-eligibility" data-request-id="' + escapeHtml(rowId) + '">Save eligibility</button></div>'
            +     '</div>'
            +   '</details>'
            +   '<div class="schedule-inlineWorkbench"><div class="schedule-inlineWorkbenchTitle">Coverage actions</div>' + renderFillShiftControls('open', rowId, String((row && row.request_date) || '').trim(), String((row && row.staff_id) || '').trim(), String((row && row.staff_name) || '').trim()) + '</div>'
            +   '<details class="request-review-details">'
            +     '<summary>Details</summary>'
            +     '<div class="request-review-debug">'
            +       '<div class="request-review-debug-grid">'
            +         renderRequestReviewDebugLine('Open Shift ID', String((row && row.id) || '').trim())
            +         renderRequestReviewDebugLine('Original Request Off', String(meta.source_request_off_id || '').trim())
            +         renderRequestReviewDebugLine('Posted By', String(meta.posted_by || '').trim() || 'Dashboard')
            +         renderRequestReviewDebugLine('Shift Type', shiftTypeLabel)
            +         renderRequestReviewDebugLine('Eligible Roles', allowedRolesLabel || 'Any role')
            +         renderRequestReviewDebugLine('Source', sourceLabel)
            +         renderRequestReviewDebugLine('Original Note', String(meta.source_note || '').trim() || String((row && row.note) || '').trim())
          +       '</div>'
            +     '</div>'
            +   '</details>'
            + '</article>';
        }).join('');
      }

      function getApprovedPickupRowsForView(){
        var rows = Array.isArray(shiftChangeQueue) ? shiftChangeQueue.filter(function(row){
          return String((row && row.request_type) || '').trim().toLowerCase() === 'pick_up_shift'
            && String((row && row.status) || '').trim().toLowerCase() === 'approved'
            && !isPastRequestRow({ requested_dates: [row && row.request_date] });
        }) : [];

        rows.sort(function(a, b){
          return String((a && a.request_date) || '').localeCompare(String((b && b.request_date) || ''))
            || String((a && a.shift_label) || '').localeCompare(String((b && b.shift_label) || ''))
            || String((a && a.staff_name) || '').localeCompare(String((b && b.staff_name) || ''));
        });
        return rows;
      }

      function getApprovedPickupMarkup(rows){
        return rows.map(function(row){
          var meta = getShiftChangeMeta(row);
          var linkedOpenShift = String(meta.open_shift_id || '').trim()
            ? (Array.isArray(shiftChangeQueue) ? shiftChangeQueue.find(function(candidate){
                return String((candidate && candidate.id) || '').trim() === String(meta.open_shift_id || '').trim();
              }) : null)
            : null;
          var linkedOpenShiftMeta = getShiftChangeMeta(linkedOpenShift);
          var shiftTypeLabel = formatShiftTypeLabel(linkedOpenShiftMeta.shift_type || meta.shift_type);
          var sourceLabel = linkedOpenShift ? getOpenShiftSourceLabel(linkedOpenShiftMeta) : 'Approved pickup';
          var roleName = String((row && row.role_name) || '').trim() || 'Salon Team';
          return ''
            + '<article class="request-review-card request-review-card--schedule" data-status="approved" data-open-kind="picked-up">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
            +       '<div class="request-review-meta">'
            +         '<div class="request-review-name">' + escapeHtml(String((row && row.staff_name) || '').trim()) + '</div>'
            +         '<div class="request-review-dates">' + escapeHtml(formatRequestReviewDates([row && row.request_date])) + '</div>'
            +         renderOpenShiftCardShiftBlock(String((row && row.shift_label) || '').trim(), shiftTypeLabel, 'Role', roleName)
            +         '<div>Picked up shift</div>'
            +         '<div>' + escapeHtml(sourceLabel) + '</div>'
            +         (row && row.note ? '<div>Note: ' + escapeHtml(String(row.note || '').trim()) + '</div>' : '')
            +       '</div>'
            +     '</div>'
            +     '<div class="request-review-side">'
            +       '<span class="request-review-badge" data-status="approved">approved</span>'
            +       '<div class="request-review-actions">'
            +         '<button class="btn-secondary" type="button" data-open-shift-manage="delete-approved-pickup" data-request-id="' + escapeHtml(String((row && row.id) || '').trim()) + '">Delete</button>'
            +       '</div>'
            +     '</div>'
            +   '</div>'
            + '</article>';
        }).join('');
      }

      function getPendingShiftRequestRows(){
        var rows = Array.isArray(shiftChangeQueue) ? shiftChangeQueue.filter(function(row){
          var requestType = String((row && row.request_type) || '').trim().toLowerCase();
          return requestType === 'pick_up_shift'
            && String((row && row.status) || '').trim().toLowerCase() === 'pending'
            && !isPastRequestRow({ requested_dates: [row && row.request_date] });
        }) : [];

        rows.sort(function(a, b){
          var dateCompare = String((a && a.request_date) || '').localeCompare(String((b && b.request_date) || ''));
          if (dateCompare) return dateCompare;

          var submittedA = String((a && a.submitted_at) || '').trim();
          var submittedB = String((b && b.submitted_at) || '').trim();
          if (submittedA !== submittedB) return submittedA.localeCompare(submittedB);

          var statusA = String((a && a.status) || '').trim().toLowerCase();
          var statusB = String((b && b.status) || '').trim().toLowerCase();
          return statusA.localeCompare(statusB);
        });
        return rows;
      }

      function getPendingShiftRequestMarkup(rows){
        return rows.map(function(row){
          var rowId = String((row && row.id) || '').trim();
          var status = String((row && row.status) || 'pending').trim().toLowerCase() || 'pending';
          var meta = getShiftChangeMeta(row);
          var requestType = String((row && row.request_type) || '').trim().toLowerCase();
          var linkedOpenShift = requestType === 'pick_up_shift' && String(meta.open_shift_id || '').trim()
            ? (Array.isArray(shiftChangeQueue) ? shiftChangeQueue.find(function(candidate){
                return String((candidate && candidate.id) || '').trim() === String(meta.open_shift_id || '').trim();
              }) : null)
            : null;
          var linkedOpenShiftMeta = getShiftChangeMeta(linkedOpenShift);
          var shiftTypeLabel = formatShiftTypeLabel(linkedOpenShiftMeta.shift_type || meta.shift_type);
          var roleName = String((row && row.role_name) || '').trim() || 'Salon Team';
          var replacementName = String(meta.replacement_staff_name || '').trim();
          var replacementDate = String(meta.replacement_request_date || '').trim();
          var replacementShift = String(meta.replacement_shift_label || '').trim();
          return ''
            + '<article class="request-review-card request-review-card--schedule" data-status="' + escapeHtml(status) + '">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
            +       '<div class="request-review-name">' + escapeHtml(String((row && row.staff_name) || '').trim()) + '</div>'
            +       '<div class="request-review-dates">' + escapeHtml(formatRequestReviewDates([row && row.request_date])) + '</div>'
            +       '<div class="request-review-metaRow">'
            +         '<span class="request-review-token">' + escapeHtml(getShiftChangeRequestTypeLabel(row && row.request_type)) + '</span>'
            +         (row && row.submitted_at ? '<span class="request-review-token">Submitted ' + escapeHtml(formatRequestReviewSubmitted(row.submitted_at)) + '</span>' : '')
            +       '</div>'
            +       renderOpenShiftCardShiftBlock(String((row && row.shift_label) || '').trim(), shiftTypeLabel, 'Role', roleName)
            +       '<div class="request-review-meta">'
            +         (requestType === 'replace_shift' && replacementName ? '<div>Switch with: ' + escapeHtml(replacementName) + '</div>' : '')
            +         (requestType === 'replace_shift' && replacementDate ? '<div>Their date: ' + escapeHtml(formatRequestReviewDates([replacementDate])) + '</div>' : '')
            +         (requestType === 'replace_shift' && replacementShift ? '<div>Their shift: ' + escapeHtml(replacementShift) + '</div>' : '')
            +         (row && row.note ? '<div>Note: ' + escapeHtml(String(row.note || '').trim()) + '</div>' : '')
            +       '</div>'
            +     '</div>'
            +     '<div class="request-review-side">'
            +       '<span class="request-review-badge" data-status="' + escapeHtml(status) + '">' + escapeHtml(status) + '</span>'
            +       '<div class="request-review-actions">'
            +         '<button class="btn-primary" type="button" data-pickup-action="approve" data-request-id="' + escapeHtml(rowId) + '">Approve</button>'
            +         '<button class="btn-secondary" type="button" data-pickup-action="deny" data-request-id="' + escapeHtml(rowId) + '">Deny</button>'
            +         '<button class="btn-secondary" type="button" data-pickup-action="delete" data-request-id="' + escapeHtml(rowId) + '">Delete</button>'
            +       '</div>'
            +     '</div>'
            +   '</div>'
            +   '<details class="request-review-details">'
            +     '<summary>Details</summary>'
            +     '<div class="request-review-debug">'
            +       '<div class="request-review-debug-grid">'
            +         renderRequestReviewDebugLine('Request ID', rowId)
            +         renderRequestReviewDebugLine('Open Shift ID', String(meta.open_shift_id || '').trim())
            +         renderRequestReviewDebugLine('Switch With', replacementName)
            +         renderRequestReviewDebugLine('Their Date', replacementDate)
            +         renderRequestReviewDebugLine('Their Shift', replacementShift)
            +         renderRequestReviewDebugLine('Shift Type', shiftTypeLabel)
            +         renderRequestReviewDebugLine('Reviewed By', String((row && row.reviewed_by) || '').trim())
            +         renderRequestReviewDebugLine('Status Note', String((row && row.status_note) || '').trim())
            +       '</div>'
            +     '</div>'
            +   '</details>'
            + '</article>';
        }).join('');
      }

      function renderOpenShiftView(){
        if (!openShiftResultsList) return;
        var availableRows = getAvailableOpenShiftRows();
        var pendingRows = getPendingShiftRequestRows();
        var approvedRows = getApprovedPickupRowsForView();
        setTabCount(openShiftViewCountAvailable, availableRows.length);
        setTabCount(openShiftViewCountPending, pendingRows.length);
        setTabCount(openShiftViewCountPickedUp, approvedRows.length);

        if (openShiftViewFilter === 'pending') {
          openShiftResultsList.innerHTML = pendingRows.length
            ? getPendingShiftRequestMarkup(pendingRows)
            : '<div class="request-review-empty">No pending shift requests right now.</div>';
        } else if (openShiftViewFilter === 'picked-up') {
          openShiftResultsList.innerHTML = approvedRows.length
            ? getApprovedPickupMarkup(approvedRows)
            : '<div class="request-review-empty">No approved pickups yet.</div>';
        } else {
          openShiftResultsList.innerHTML = renderLastManagerFillBanner()
            + (availableRows.length
              ? getAvailableOpenShiftMarkup(availableRows)
              : '<div class="request-review-empty">No posted available shifts right now.</div>');
        }
        updateRequestsTabCount();
      }

      async function refreshShiftChangeQueue(){
        shiftChangeQueue = await fetchShiftChangeQueue();
        renderOpenShiftView();
        renderCoverageCalendarWeek();
      }

      async function manageOpenShiftRow(requestId, action, options){
        var safeOptions = options && typeof options === 'object' ? options : {};
        var payload = {
          action: action === 'unpost'
            ? 'staff-shift-change-unpost-open'
            : (action === 'update-eligibility'
                ? 'staff-shift-change-update-open-eligibility'
                : 'staff-shift-change-delete-approved-pickup'),
          request_id: requestId,
          reviewed_by: 'Dashboard',
          shift_type: String(safeOptions.shift_type || '').trim(),
          allowed_role_labels: Array.isArray(safeOptions.allowed_role_labels) ? safeOptions.allowed_role_labels : []
        };
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not update shift.');
        }
        return data;
      }

      async function postOpenShift(requestId, requestDate, shiftLabel, allowedRoles){
        var shiftTypeField = requestReviewList
          ? requestReviewList.querySelector('[data-open-shift-type-date="' + requestDate + '"][data-open-shift-request-id="' + requestId + '"]')
          : null;
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'open-shift-post',
            request_off_id: requestId,
            request_date: requestDate,
            shift_label: shiftLabel,
            shift_type: String(shiftTypeField && shiftTypeField.value || '').trim() || 'assisting',
            allowed_role_labels: Array.isArray(allowedRoles) ? allowedRoles : [],
            posted_by: 'Dashboard'
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not post open shift.');
        }
        return data.row;
      }

      function renderManualOpenShiftShiftOptions(){
        if (!manualOpenShiftShift) return;
        var selectedDate = String(manualOpenShiftDate && manualOpenShiftDate.value || '').trim();
        var options = selectedDate ? getMasterScheduleOptionsForDate(selectedDate) : [];
        manualOpenShiftShift.innerHTML = options.length
          ? options.map(function(option, index){
              var label = option === 'CUSTOM' ? 'Custom shift' : option;
              return '<option value="' + escapeHtml(option) + '"' + (index === 0 ? ' selected' : '') + '>' + escapeHtml(label) + '</option>';
            }).join('')
          : '<option value="">Choose date first</option>';
        if (manualOpenShiftType) {
          manualOpenShiftType.value = 'floor';
        }
        syncManualOpenShiftCustomField();
      }

      function syncManualOpenShiftCustomField(){
        var usesCustom = String(manualOpenShiftShift && manualOpenShiftShift.value || '').trim().toUpperCase() === 'CUSTOM';
        if (manualOpenShiftCustomWrap) {
          manualOpenShiftCustomWrap.hidden = !usesCustom;
        }
        if (!usesCustom && manualOpenShiftCustom) {
          manualOpenShiftCustom.value = '';
        }
      }

      async function submitManualOpenShiftForm(){
        var selectedDate = String(manualOpenShiftDate && manualOpenShiftDate.value || '').trim();
        var selectedShiftValue = String(manualOpenShiftShift && manualOpenShiftShift.value || '').trim();
        var customShiftLabel = String(manualOpenShiftCustom && manualOpenShiftCustom.value || '').trim();
        var shiftLabel = selectedShiftValue.toUpperCase() === 'CUSTOM' ? customShiftLabel : selectedShiftValue;
        var shiftType = String(manualOpenShiftType && manualOpenShiftType.value || '').trim();
        var allowedRoles = collectCheckedRoles(manualOpenShiftRoleChecklist, 'input[type="checkbox"]');
        if (!selectedDate) {
          throw new Error('Choose a shift date first.');
        }
        if (!selectedShiftValue) {
          throw new Error('Choose a shift first.');
        }
        if (selectedShiftValue.toUpperCase() === 'CUSTOM' && !customShiftLabel) {
          throw new Error('Enter the custom shift label.');
        }
        if (!allowedRoles.length) {
          throw new Error('Choose at least one eligible role.');
        }

        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'open-shift-post-manual',
            request_date: selectedDate,
            shift_label: shiftLabel,
            shift_type: shiftType || 'floor',
            allowed_role_labels: allowedRoles,
            note: String(manualOpenShiftNote && manualOpenShiftNote.value || '').trim(),
            posted_by: 'Dashboard'
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not post manual open shift.');
        }
        return data.row;
      }

      function mergeShiftChangeQueueRow(row){
        var rowId = String((row && row.id) || '').trim();
        if (!rowId) return;
        var matched = false;
        shiftChangeQueue = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).map(function(existing){
          if (String((existing && existing.id) || '').trim() === rowId) {
            matched = true;
            return row;
          }
          return existing;
        });
        if (!matched) {
          shiftChangeQueue = [row].concat(Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []);
        }
      }

      function buildManagerFillResultSummary(result){
        if (!result || typeof result !== 'object') return null;
        var pickupRow = result.row || null;
        var openShiftRow = result.open_shift_row || null;
        var displacedRow = result.displaced_open_shift_row || null;
        var openShiftMeta = getShiftChangeMeta(openShiftRow);
        var pickupMeta = getShiftChangeMeta(pickupRow);
        return {
          openShiftId: String((openShiftRow && openShiftRow.id) || (pickupMeta && pickupMeta.open_shift_id) || '').trim(),
          requestDate: String((pickupRow && pickupRow.request_date) || (openShiftRow && openShiftRow.request_date) || '').trim(),
          shiftLabel: String((pickupRow && pickupRow.shift_label) || (openShiftRow && openShiftRow.shift_label) || '').trim(),
          filledByName: String((pickupRow && pickupRow.staff_name) || (openShiftMeta && openShiftMeta.filled_by_staff_name) || '').trim(),
          filledAt: String((openShiftMeta && openShiftMeta.filled_at) || (pickupRow && pickupRow.reviewed_at) || '').trim(),
          displacedDate: String((displacedRow && displacedRow.request_date) || '').trim(),
          displacedShiftLabel: String((displacedRow && displacedRow.shift_label) || '').trim()
        };
      }

      function setLastManagerFillResult(result){
        lastManagerFillResult = buildManagerFillResultSummary(result);
      }

      function clearLastManagerFillResult(){
        lastManagerFillResult = null;
      }

      function getFilledOpenShiftSummary(row){
        var meta = getShiftChangeMeta(row);
        var filledRequestId = String(meta.filled_by_request_id || '').trim();
        var pickupRow = filledRequestId && Array.isArray(shiftChangeQueue)
          ? shiftChangeQueue.find(function(candidate){
              return String((candidate && candidate.id) || '').trim() === filledRequestId;
            }) || null
          : null;
        var displacedRow = pickupRow && Array.isArray(shiftChangeQueue)
          ? shiftChangeQueue.find(function(candidate){
              var candidateMeta = getShiftChangeMeta(candidate);
              return String((candidateMeta.generated_from_fill_request_id) || '').trim() === String((pickupRow && pickupRow.id) || '').trim();
            }) || null
          : null;
        return {
          filledByName: String((meta && meta.filled_by_staff_name) || (pickupRow && pickupRow.staff_name) || '').trim(),
          filledAt: String((meta && meta.filled_at) || (pickupRow && pickupRow.reviewed_at) || '').trim(),
          displacedRow: displacedRow
        };
      }

      function findCoverageSummaryForRequestRow(row, dateValue){
        var requestId = String((row && row.id) || '').trim();
        var targetDate = String(dateValue || '').trim();
        if (!requestId || !targetDate || !Array.isArray(shiftChangeQueue)) return null;
        var linkedOpenShift = shiftChangeQueue.find(function(candidate){
          if (String((candidate && candidate.request_type) || '').trim().toLowerCase() !== 'open_shift') return false;
          if (String((candidate && candidate.request_date) || '').trim() !== targetDate) return false;
          var candidateMeta = getShiftChangeMeta(candidate);
          return String((candidateMeta.source_request_off_id) || '').trim() === requestId;
        }) || null;
        if (!linkedOpenShift) return null;
        var linkedMeta = getShiftChangeMeta(linkedOpenShift);
        return {
          openShiftRow: linkedOpenShift,
          openStatus: String((linkedMeta && linkedMeta.open_status) || 'open').trim().toLowerCase(),
          fillSummary: getFilledOpenShiftSummary(linkedOpenShift)
        };
      }

      function renderFilledCoverageSummary(fillSummary){
        if (!fillSummary) return '';
        var filledByName = String(fillSummary.filledByName || '').trim();
        var filledAt = formatRequestReviewSubmitted(fillSummary.filledAt);
        var displacedRow = fillSummary.displacedRow || null;
        return ''
          + '<div class="schedule-fillSuccess">'
          +   '<div class="schedule-fillSuccessHead">'
          +     '<strong>Filled</strong>'
          +     '<span>' + escapeHtml([
                filledByName ? 'Covered by ' + filledByName : '',
                filledAt || ''
              ].filter(Boolean).join(' • ') || 'Coverage assigned') + '</span>'
          +   '</div>'
          +   '<div class="schedule-fillSuccessNote">'
          +     escapeHtml(
                displacedRow
                  ? 'Displaced shift posted for ' + formatRequestReviewDates([displacedRow.request_date]) + (displacedRow.shift_label ? ' • ' + String(displacedRow.shift_label || '').trim() : '') + '.'
                  : 'Coverage update saved.'
              )
          +   '</div>'
          + '</div>';
      }

      function renderLastManagerFillBanner(){
        if (!lastManagerFillResult) return '';
        return ''
          + '<div class="schedule-fillNotice">'
          +   '<div class="schedule-fillNoticeHead">'
          +     '<strong>Shift filled</strong>'
          +     '<span>' + escapeHtml([
                lastManagerFillResult.requestDate ? formatRequestReviewDates([lastManagerFillResult.requestDate]) : '',
                lastManagerFillResult.shiftLabel || '',
                lastManagerFillResult.filledByName ? 'Covered by ' + lastManagerFillResult.filledByName : ''
              ].filter(Boolean).join(' • ')) + '</span>'
          +   '</div>'
          +   '<div class="schedule-fillNoticeFoot">' + escapeHtml(
                lastManagerFillResult.displacedDate
                  ? 'Replacement shift posted for ' + formatRequestReviewDates([lastManagerFillResult.displacedDate]) + (lastManagerFillResult.displacedShiftLabel ? ' • ' + lastManagerFillResult.displacedShiftLabel : '') + '.'
                  : 'The coverage update was saved immediately.'
              ) + '</div>'
          + '</div>';
      }

      function applyShiftChangeActionResult(result){
        if (!result || typeof result !== 'object') return;
        if (result.row) mergeShiftChangeQueueRow(result.row);
        if (result.open_shift_row) mergeShiftChangeQueueRow(result.open_shift_row);
        if (result.displaced_open_shift_row) mergeShiftChangeQueueRow(result.displaced_open_shift_row);
      }

      async function submitManagerFillShift(payload){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-shift-change-manager-fill',
            reviewed_by: 'Dashboard',
            status_note: 'Filled from management dashboard',
            fill_mode: payload && payload.fill_mode,
            fill_staff_id: payload && payload.fill_staff_id,
            fill_staff_name: payload && payload.fill_staff_name,
            fill_staff_role_name: payload && payload.fill_staff_role_name,
            request_off_id: payload && payload.request_off_id,
            open_shift_id: payload && payload.open_shift_id,
            request_date: payload && payload.request_date,
            shift_label: payload && payload.shift_label,
            shift_type: payload && payload.shift_type,
            allowed_role_labels: payload && payload.allowed_role_labels,
            source_request_date: payload && payload.source_request_date,
            source_shift_label: payload && payload.source_shift_label,
            source_shift_type: payload && payload.source_shift_type
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not fill shift.');
        }
        return data;
      }

      async function updatePickupQueueStatus(requestId, status){
        var existingRow = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).find(function(row){
          return String((row && row.id) || '').trim() === String(requestId || '').trim();
        }) || null;
        var requestType = String((existingRow && existingRow.request_type) || '').trim().toLowerCase();
        var payload = {
          action: status === 'approved' && requestType === 'pick_up_shift'
            ? 'staff-shift-change-approve-pickup'
            : 'staff-shift-change-update-status',
          request_id: requestId,
          status: status,
          reviewed_by: 'Dashboard'
        };
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not update shift request.');
        }
        return data;
      }

      async function deleteShiftChangeQueueRow(requestId){
        var payload = {
          action: 'staff-shift-change-delete',
          request_id: requestId
        };
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not delete shift request.');
        }
        var deletedId = String((data.row && data.row.id) || '').trim();
        shiftChangeQueue = (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).filter(function(row){
          return String((row && row.id) || '').trim() !== deletedId;
        });
        renderOpenShiftView();
        renderCoverageCalendarWeek();
        return data.row;
      }

      async function refreshRequestOffQueue(){
        requestOffQueue = await fetchRequestOffQueue();
        renderRequestOffQueue();
        renderCoverageCalendarWeek();
      }

      async function updateRequestOffQueueStatus(requestId, status){
        var payload = {
          action: 'staff-request-off-update-status',
          request_id: requestId,
          status: status,
          reviewed_by: 'Dashboard'
        };
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not update request status.');
        }
        var nextId = String((data.row && data.row.id) || '').trim();
        requestOffQueue = (Array.isArray(requestOffQueue) ? requestOffQueue : []).map(function(row){
          return String((row && row.id) || '').trim() === nextId ? data.row : row;
        });
        renderRequestOffQueue();
        renderCoverageCalendarWeek();
        return data.row;
      }

      async function deleteRequestOffQueueRow(requestId){
        var payload = {
          action: 'staff-request-off-delete',
          request_id: requestId
        };
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not cancel request off.');
        }
        var deletedId = String((data.row && data.row.id) || '').trim();
        requestOffQueue = (Array.isArray(requestOffQueue) ? requestOffQueue : []).filter(function(row){
          return String((row && row.id) || '').trim() !== deletedId;
        });
        renderRequestOffQueue();
        renderCoverageCalendarWeek();
        return data.row;
      }

      function setMasterScheduleStatus(text, tone){
        masterScheduleStatus.textContent = String(text || '');
        if (tone) {
          masterScheduleStatus.setAttribute('data-tone', tone);
        } else {
          masterScheduleStatus.removeAttribute('data-tone');
        }
      }

      function setCoverageCalendarStatus(text, tone){
        if (!coverageCalendarStatus) return;
        coverageCalendarStatus.textContent = String(text || '');
        if (tone) {
          coverageCalendarStatus.setAttribute('data-tone', tone);
        } else {
          coverageCalendarStatus.removeAttribute('data-tone');
        }
      }

      function managerCalendarColorLabel(token){
        var normalized = String(token || '').trim().toLowerCase();
        if (normalized === 'peach') return 'Important';
        if (normalized === 'ink') return 'Internal';
        if (normalized === 'sage') return 'Confirmed';
        return 'General';
      }

      function managerCalendarMonthStart(date){
        return new Date(date.getFullYear(), date.getMonth(), 1);
      }

      function managerCalendarWeekStart(date){
        var base = startOfLocalDay(date);
        var weekday = base.getDay();
        var offset = 0 - weekday;
        return new Date(base.getFullYear(), base.getMonth(), base.getDate() + offset);
      }

      function managerCalendarRangeForView(view, anchorDate){
        var safeView = String(view || 'month').trim() === 'week' ? 'week' : 'month';
        var safeAnchor = anchorDate instanceof Date ? anchorDate : startOfLocalDay(new Date());
        if (safeView === 'week') {
          var weekStart = managerCalendarWeekStart(safeAnchor);
          return {
            view: 'week',
            start: weekStart,
            end: new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + 6)
          };
        }
        var monthStart = managerCalendarMonthStart(safeAnchor);
        var gridStart = managerCalendarWeekStart(monthStart);
        return {
          view: 'month',
          start: gridStart,
          end: new Date(gridStart.getFullYear(), gridStart.getMonth(), gridStart.getDate() + 41),
          monthStart: monthStart
        };
      }

      function managerCalendarRangeKey(range){
        if (!range || !range.start || !range.end) return '';
        return formatDateInputValue(range.start) + '|' + formatDateInputValue(range.end);
      }

      function managerCalendarFormatRangeLabel(range){
        if (!range || !range.start || !range.end) return '';
        if (range.view === 'week') {
          var sameMonth = range.start.getMonth() === range.end.getMonth() && range.start.getFullYear() === range.end.getFullYear();
          return range.start.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
            + ' - '
            + range.end.toLocaleDateString(undefined, { month: sameMonth ? undefined : 'short', day: 'numeric', year: 'numeric' });
        }
        return range.monthStart.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
      }

      function managerCalendarItemsByDate(){
        return (Array.isArray(managerCalendarItems) ? managerCalendarItems : []).reduce(function(map, item){
          var dateKey = String(item && item.event_date || '').trim();
          if (!dateKey) return map;
          if (!map[dateKey]) map[dateKey] = [];
          map[dateKey].push(item);
          return map;
        }, {});
      }

      function managerCalendarAudienceOptions(){
        var options = [
          { value: 'all_staff', label: 'All staff' },
          { value: 'all_managers', label: 'All managers' },
          { value: 'level_7', label: 'All Level 7' },
          { value: 'level_6', label: 'All Level 6' },
          { value: 'level_5', label: 'All Level 5' },
          { value: 'level_4', label: 'All Level 4' },
          { value: 'level_3', label: 'All Level 3' },
          { value: 'level_2', label: 'All Level 2' },
          { value: 'level_1', label: 'All Level 1' }
        ];
        var seenStaff = {};
        (Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions : []).slice().sort(function(left, right){
          return String((left && left.name) || '').localeCompare(String((right && right.name) || ''));
        }).forEach(function(option){
          var staffId = String((option && option.id) || '').trim();
          var staffName = String((option && option.name) || '').trim();
          if (!staffId || !staffName || seenStaff[staffId]) return;
          seenStaff[staffId] = true;
          options.push({
            value: 'staff:' + staffId,
            label: staffName
          });
        });
        return options;
      }

      function normalizeManagerCalendarAudienceSelectedValues(selectedValues){
        var values = (Array.isArray(selectedValues) ? selectedValues : [selectedValues]).map(function(value){
          return String(value || '').trim();
        }).filter(Boolean);
        if (!values.length) return ['all_staff'];
        if (values.indexOf('all_staff') !== -1 && values.length > 1) {
          values = values.filter(function(value){ return value !== 'all_staff'; });
        }
        return values.length ? values : ['all_staff'];
      }

      function syncManagerCalendarAudienceOptions(selectedValues){
        if (!managerCalendarModalAudienceChecklist) return;
        managerCalendarAudienceSelectedValues = normalizeManagerCalendarAudienceSelectedValues(selectedValues);
        filterManagerCalendarAudienceOptions();
        syncManagerCalendarAudienceChips();
      }

      function filterManagerCalendarAudienceOptions(){
        if (!managerCalendarModalAudienceChecklist) return;
        var searchValue = String(managerCalendarAudienceSearchValue || '').trim().toLowerCase();
        if (!searchValue) {
          managerCalendarModalAudienceChecklist.hidden = true;
          managerCalendarModalAudienceChecklist.innerHTML = '';
          return;
        }
        var selectedMap = {};
        getManagerCalendarAudienceCheckedValues().forEach(function(value){
          selectedMap[String(value || '').trim()] = true;
        });
        var matches = managerCalendarAudienceOptions().filter(function(option){
          var value = String(option && option.value || '').trim();
          var label = String(option && option.label || '').trim();
          return !selectedMap[value] && label.toLowerCase().indexOf(searchValue) !== -1;
        });
        managerCalendarModalAudienceChecklist.hidden = false;
        if (!matches.length) {
          managerCalendarModalAudienceChecklist.innerHTML = '<div class="manager-calendarAudienceEmpty">No staff matched that search.</div>';
          return;
        }
        managerCalendarModalAudienceChecklist.innerHTML = matches.map(function(option){
          var value = String(option && option.value || '').trim();
          var label = String(option && option.label || '').trim();
          return ''
            + '<button class="manager-calendarAudienceSuggestion" type="button" data-calendar-audience-suggestion="' + escapeHtml(value) + '">'
            +   '<span>' + escapeHtml(label) + '</span>'
            + '</button>';
        }).join('');
      }

      function getManagerCalendarAudienceCheckedValues(){
        return normalizeManagerCalendarAudienceSelectedValues(managerCalendarAudienceSelectedValues);
      }

      function syncManagerCalendarAudienceChips(){
        if (!managerCalendarAudienceChips) return;
        var selectedMap = {};
        getManagerCalendarAudienceCheckedValues().forEach(function(value){
          selectedMap[String(value || '').trim()] = true;
        });
        var selectedOptions = managerCalendarAudienceOptions().filter(function(option){
          return selectedMap[String(option && option.value || '').trim()] === true;
        });
        managerCalendarAudienceChips.innerHTML = selectedOptions.map(function(option){
          var value = String(option && option.value || '').trim();
          var label = String(option && option.label || '').trim();
          return ''
            + '<button class="manager-calendarAudienceChip" type="button" data-calendar-audience-chip="' + escapeHtml(value) + '" aria-label="Remove ' + escapeHtml(label) + '">'
            +   '<span>' + escapeHtml(label) + '</span>'
            +   '<strong aria-hidden="true">×</strong>'
            + '</button>';
        }).join('');
      }

      function setManagerCalendarAudienceValue(value, checked){
        var normalizedValue = String(value || '').trim();
        if (!normalizedValue) return false;
        var nextValues = getManagerCalendarAudienceCheckedValues().slice();
        if (checked === false) {
          nextValues = nextValues.filter(function(entry){ return entry !== normalizedValue; });
        } else if (normalizedValue === 'all_staff') {
          nextValues = ['all_staff'];
        } else {
          nextValues = nextValues.filter(function(entry){ return entry !== 'all_staff'; });
          if (nextValues.indexOf(normalizedValue) === -1) nextValues.push(normalizedValue);
        }
        managerCalendarAudienceSelectedValues = normalizeManagerCalendarAudienceSelectedValues(nextValues);
        syncManagerCalendarAudienceChips();
        filterManagerCalendarAudienceOptions();
        return true;
      }

      function selectFirstVisibleManagerCalendarAudienceOption(){
        if (!managerCalendarModalAudienceChecklist) return false;
        var firstVisibleOption = managerCalendarModalAudienceChecklist.querySelector('[data-calendar-audience-suggestion]');
        if (!firstVisibleOption) return false;
        setManagerCalendarAudienceValue(firstVisibleOption.getAttribute('data-calendar-audience-suggestion'), true);
        if (managerCalendarModalAudienceSearch) {
          managerCalendarModalAudienceSearch.value = '';
        }
        managerCalendarAudienceSearchValue = '';
        filterManagerCalendarAudienceOptions();
        if (managerCalendarModalAudienceSearch && typeof managerCalendarModalAudienceSearch.select === 'function') {
          managerCalendarModalAudienceSearch.select();
        }
        return true;
      }

      function getManagerCalendarAudienceSelection(){
        var options = managerCalendarAudienceOptions();
        var checkedValues = getManagerCalendarAudienceCheckedValues();
        var selected = options.filter(function(option){
          return checkedValues.indexOf(String((option && option.value) || '').trim()) !== -1;
        });
        if (!selected.length) {
          selected = [{ value: 'all_staff', label: 'All staff' }];
        }
        return {
          key: selected.map(function(option){ return String((option && option.value) || '').trim(); }).filter(Boolean).join('|'),
          label: selected.map(function(option){ return String((option && option.label) || '').trim(); }).filter(Boolean).join(', ')
        };
      }

      async function fetchManagerCalendarItems(range){
        var effectiveRange = range || managerCalendarRangeForView(managerCalendarView, managerCalendarAnchorDate);
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'manager-calendar-list',
            from_date: formatDateInputValue(effectiveRange.start),
            to_date: formatDateInputValue(effectiveRange.end)
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load calendar.');
        }
        return Array.isArray(data.rows) ? data.rows : [];
      }

      function managerCalendarOpenButtonMarkup(dateKey){
        var saveBusy = managerCalendarSaveInFlightByDate[dateKey] === true;
        return ''
          + '<button class="manager-calendarAddBtn" type="button" data-calendar-open="' + escapeHtml(dateKey) + '"' + (saveBusy ? ' disabled' : '') + ' aria-label="Add calendar item for ' + escapeHtml(dateKey) + '">'
          +   (saveBusy ? '<span class="manager-calendarAddBtnSpinner" aria-hidden="true"></span>' : '+')
          + '</button>';
      }

      function renderManagerCalendarItem(item){
        var itemId = String(item && item.id || '').trim();
        var title = String(item && item.title || '').trim();
        var notes = String(item && item.notes || '').trim();
        var isDeleting = managerCalendarDeleteInFlightById[itemId] === true;
        return ''
          + '<article class="manager-calendarItem">'
          +   '<button class="manager-calendarItemButton" type="button" data-calendar-item-edit="' + escapeHtml(itemId) + '">'
          +     '<span class="manager-calendarItemTitle">' + escapeHtml(title) + '</span>'
          +     (notes ? '<span class="manager-calendarItemNotes">' + escapeHtml(notes) + '</span>' : '')
          +   '</button>'
          +   '<button class="manager-calendarDeleteBtn" type="button" data-calendar-delete="' + escapeHtml(itemId) + '"' + (isDeleting ? ' disabled' : '') + ' aria-label="Delete calendar item">×</button>'
          + '</article>';
      }

      function renderManagerCalendarMonthGrid(){
        var range = managerCalendarRangeForView('month', managerCalendarAnchorDate);
        var itemsByDate = managerCalendarItemsByDate();
        var todayKey = formatDateInputValue(startOfLocalDay(new Date()));
        var cells = [];
        for (var index = 0; index < 42; index += 1) {
          var cellDate = new Date(range.start.getFullYear(), range.start.getMonth(), range.start.getDate() + index);
          var dateKey = formatDateInputValue(cellDate);
          var isCurrentMonth = cellDate.getMonth() === range.monthStart.getMonth();
          var items = itemsByDate[dateKey] || [];
          cells.push(''
            + '<section class="manager-calendarDay' + (isCurrentMonth ? '' : ' is-outside') + (dateKey === todayKey ? ' is-today' : '') + '">'
            +   '<div class="manager-calendarDayHead">'
            +     '<div class="manager-calendarDayHeadMain">'
            +       '<div class="manager-calendarDayWeekday">' + escapeHtml(cellDate.toLocaleDateString(undefined, { weekday: 'short' })) + '</div>'
            +       '<div class="manager-calendarDayNumber">' + escapeHtml(String(cellDate.getDate())) + '</div>'
            +     '</div>'
            +     managerCalendarOpenButtonMarkup(dateKey)
            +   '</div>'
            +   '<div class="manager-calendarDayBody">'
            +     '<div class="manager-calendarItems">' + (items.length ? items.map(renderManagerCalendarItem).join('') : '') + '</div>'
            +   '</div>'
            + '</section>');
        }
        managerCalendarMount.innerHTML = ''
          + '<div class="manager-calendarGrid manager-calendarGrid--month">'
          + cells.join('')
          + '</div>';
      }

      function renderManagerCalendarWeekGrid(){
        var range = managerCalendarRangeForView('week', managerCalendarAnchorDate);
        var itemsByDate = managerCalendarItemsByDate();
        var todayKey = formatDateInputValue(startOfLocalDay(new Date()));
        var days = [];
        for (var index = 0; index < 7; index += 1) {
          var dayDate = new Date(range.start.getFullYear(), range.start.getMonth(), range.start.getDate() + index);
          var dateKey = formatDateInputValue(dayDate);
          var items = itemsByDate[dateKey] || [];
          days.push(''
            + '<section class="manager-calendarDay manager-calendarDay--week' + (dateKey === todayKey ? ' is-today' : '') + '">'
            +   '<div class="manager-calendarDayHead">'
            +     '<div class="manager-calendarDayHeadMain">'
            +       '<div class="manager-calendarDayWeekday">' + escapeHtml(dayDate.toLocaleDateString(undefined, { weekday: 'long' })) + '</div>'
            +       '<div class="manager-calendarDayNumber">' + escapeHtml(dayDate.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })) + '</div>'
            +     '</div>'
            +     managerCalendarOpenButtonMarkup(dateKey)
            +   '</div>'
            +   '<div class="manager-calendarDayBody">'
            +     '<div class="manager-calendarItems">' + (items.length ? items.map(renderManagerCalendarItem).join('') : '') + '</div>'
            +   '</div>'
            + '</section>');
        }
        managerCalendarMount.innerHTML = ''
          + '<div class="manager-calendarGrid manager-calendarGrid--week">'
          + days.join('')
          + '</div>';
      }

      function syncManagerCalendarControls(){
        if (managerCalendarRangeLabel) {
          managerCalendarRangeLabel.textContent = managerCalendarFormatRangeLabel(managerCalendarRangeForView(managerCalendarView, managerCalendarAnchorDate));
        }
        if (managerCalendarViewToggle) {
          Array.prototype.slice.call(managerCalendarViewToggle.querySelectorAll('[data-calendar-view]')).forEach(function(button){
            var view = String(button.getAttribute('data-calendar-view') || '').trim();
            var active = view === managerCalendarView;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        }
      }

      function renderManagerCalendar(){
        if (!managerCalendarMount) return;
        syncManagerCalendarControls();
        if (managerCalendarView === 'week') {
          renderManagerCalendarWeekGrid();
        } else {
          renderManagerCalendarMonthGrid();
        }
      }

      async function loadManagerCalendar(forceRefresh){
        var range = managerCalendarRangeForView(managerCalendarView, managerCalendarAnchorDate);
        var nextRangeKey = managerCalendarRangeKey(range);
        if (hasLoadedManagerCalendar && !forceRefresh && managerCalendarLoadedRangeKey === nextRangeKey) {
          renderManagerCalendar();
          return;
        }
        setManagerCalendarStatus('Loading calendar...', '');
        try {
          managerCalendarItems = await fetchManagerCalendarItems(range);
          managerCalendarLoadedRangeKey = nextRangeKey;
          hasLoadedManagerCalendar = true;
          renderManagerCalendar();
          setManagerCalendarStatus('Use + to add, or click an item to edit it.', 'success');
        } catch (error) {
          setManagerCalendarStatus(humanizeClientFetchErrorMessage(error, 'Could not load calendar.'), 'error');
        }
      }

      function ensureManagerCalendarLoaded(forceRefresh){
        loadManagerCalendar(!!forceRefresh);
      }

      function findManagerCalendarItemById(itemId){
        var normalizedId = String(itemId || '').trim();
        if (!normalizedId) return null;
        var items = Array.isArray(managerCalendarItems) ? managerCalendarItems : [];
        for (var index = 0; index < items.length; index += 1) {
          if (String(items[index] && items[index].id || '').trim() === normalizedId) {
            return items[index];
          }
        }
        return null;
      }

      function closeManagerCalendarModal(){
        managerCalendarActiveModalDate = '';
        managerCalendarActiveModalItemId = '';
        managerCalendarActiveModalIsEdit = false;
        if (managerCalendarModalBackdrop) managerCalendarModalBackdrop.hidden = true;
        if (managerCalendarModalItemTitle) managerCalendarModalItemTitle.value = '';
        if (managerCalendarModalAudienceSearch) managerCalendarModalAudienceSearch.value = '';
        if (managerCalendarModalSendSms) managerCalendarModalSendSms.checked = true;
        if (managerCalendarModalSmsWrap) managerCalendarModalSmsWrap.hidden = false;
        if (managerCalendarModalSmsHint) managerCalendarModalSmsHint.textContent = 'Only new calendar items will queue staff texts.';
        if (managerCalendarModalEyebrow) managerCalendarModalEyebrow.textContent = 'Add Calendar Item';
        if (managerCalendarModalTitle) managerCalendarModalTitle.textContent = 'Item to add';
        if (managerCalendarModalSave) managerCalendarModalSave.textContent = 'Add item';
        managerCalendarAudienceSearchValue = '';
        syncManagerCalendarAudienceOptions(['all_staff']);
      }

      async function ensureManagerCalendarAudienceRosterLoaded(){
        if (requestOffStaffOptions.length || managerCalendarAudienceLoading) return;
        managerCalendarAudienceLoading = true;
        try {
          var options = await fetchRequestOffFormOptions();
          populateRequestOffStaffOptions(options);
        } catch (error) {
          setManagerCalendarStatus(humanizeClientFetchErrorMessage(error, 'Could not load staff list.'), 'error');
        } finally {
          managerCalendarAudienceLoading = false;
        }
      }

      async function openManagerCalendarModal(dateKey){
        var normalizedDate = String(dateKey || '').trim();
        if (!normalizedDate || !managerCalendarModalBackdrop) return;
        await ensureManagerCalendarAudienceRosterLoaded();
        managerCalendarActiveModalDate = normalizedDate;
        managerCalendarActiveModalItemId = '';
        managerCalendarActiveModalIsEdit = false;
        if (managerCalendarModalDate) {
          var parts = normalizedDate.split('-');
          var parsedDate = parts.length === 3 ? new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])) : null;
          managerCalendarModalDate.textContent = parsedDate instanceof Date && !isNaN(parsedDate.getTime())
            ? parsedDate.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
            : normalizedDate;
        }
        if (managerCalendarModalItemTitle) managerCalendarModalItemTitle.value = '';
        if (managerCalendarModalAudienceSearch) managerCalendarModalAudienceSearch.value = '';
        if (managerCalendarModalEyebrow) managerCalendarModalEyebrow.textContent = 'Add Calendar Item';
        if (managerCalendarModalTitle) managerCalendarModalTitle.textContent = 'Item to add';
        if (managerCalendarModalSave) managerCalendarModalSave.textContent = 'Add item';
        if (managerCalendarModalSendSms) managerCalendarModalSendSms.checked = true;
        if (managerCalendarModalSmsWrap) managerCalendarModalSmsWrap.hidden = false;
        if (managerCalendarModalSmsHint) managerCalendarModalSmsHint.textContent = 'Only new calendar items will queue staff texts.';
        managerCalendarAudienceSearchValue = '';
        syncManagerCalendarAudienceOptions(['all_staff']);
        managerCalendarModalBackdrop.hidden = false;
        if (managerCalendarModalItemTitle && typeof managerCalendarModalItemTitle.focus === 'function') {
          window.setTimeout(function(){
            managerCalendarModalItemTitle.focus();
          }, 40);
        }
      }

      async function openManagerCalendarItemEditor(itemId){
        var item = findManagerCalendarItemById(itemId);
        if (!item) return;
        await ensureManagerCalendarAudienceRosterLoaded();
        managerCalendarActiveModalDate = String(item && item.event_date || '').trim();
        managerCalendarActiveModalItemId = String(item && item.id || '').trim();
        managerCalendarActiveModalIsEdit = true;
        if (managerCalendarModalDate) {
          var parts = managerCalendarActiveModalDate.split('-');
          var parsedDate = parts.length === 3 ? new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])) : null;
          managerCalendarModalDate.textContent = parsedDate instanceof Date && !isNaN(parsedDate.getTime())
            ? parsedDate.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
            : managerCalendarActiveModalDate;
        }
        if (managerCalendarModalItemTitle) managerCalendarModalItemTitle.value = String(item && item.title || '').trim();
        if (managerCalendarModalAudienceSearch) managerCalendarModalAudienceSearch.value = '';
        if (managerCalendarModalEyebrow) managerCalendarModalEyebrow.textContent = 'Edit Calendar Item';
        if (managerCalendarModalTitle) managerCalendarModalTitle.textContent = 'Edit item';
        if (managerCalendarModalSave) managerCalendarModalSave.textContent = 'Save changes';
        if (managerCalendarModalSendSms) managerCalendarModalSendSms.checked = false;
        if (managerCalendarModalSmsWrap) managerCalendarModalSmsWrap.hidden = false;
        if (managerCalendarModalSmsHint) managerCalendarModalSmsHint.textContent = 'Optional update text. Leave off unless you want to notify this audience again.';
        managerCalendarAudienceSearchValue = '';
        syncManagerCalendarAudienceOptions(
          String(item && item.audience_key || '').trim().split('|').map(function(value){
            return String(value || '').trim();
          }).filter(Boolean)
        );
        managerCalendarModalBackdrop.hidden = false;
        if (managerCalendarModalItemTitle && typeof managerCalendarModalItemTitle.focus === 'function') {
          window.setTimeout(function(){
            managerCalendarModalItemTitle.focus();
            managerCalendarModalItemTitle.select();
          }, 40);
        }
      }

      async function saveManagerCalendarItemForDate(dateKey){
        var title = String(managerCalendarModalItemTitle && managerCalendarModalItemTitle.value || '').trim();
        if (!title) {
          setManagerCalendarStatus('Add a short title first.', 'warning');
          if (managerCalendarModalItemTitle && typeof managerCalendarModalItemTitle.focus === 'function') managerCalendarModalItemTitle.focus();
          return;
        }
        var audience = getManagerCalendarAudienceSelection();
        managerCalendarSaveInFlightByDate[dateKey] = true;
        if (managerCalendarModalSave) managerCalendarModalSave.disabled = true;
        renderManagerCalendar();
        try {
          var sendStaffSms = !!(managerCalendarModalSendSms && managerCalendarModalSendSms.checked);
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'manager-calendar-save',
              id: managerCalendarActiveModalItemId || undefined,
              event_date: dateKey,
              title: title,
              notes: '',
              color_token: 'sand',
              audience_key: audience.key,
              audience_label: audience.label,
              send_staff_sms: sendStaffSms,
              created_by_name: (currentProgressionEditor && currentProgressionEditor.staff_name) || (currentStaffOpsPermission && (currentStaffOpsPermission.staff_name || currentStaffOpsPermission.name)) || 'Manager',
              created_by_staff_id: (currentProgressionEditor && currentProgressionEditor.staff_id) || (currentStaffOpsPermission && (currentStaffOpsPermission.staff_id || currentStaffOpsPermission.boulevard_staff_id)) || ''
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !data.row) {
            throw new Error((data && data.error) || rawText || 'Could not save calendar item.');
          }
          var smsQueuedCount = Number(data && data.sms_queued_count || 0) || 0;
          var smsProcessedCount = Number(data && data.sms_processed_count || 0) || 0;
          managerCalendarItems = (Array.isArray(managerCalendarItems) ? managerCalendarItems : [])
            .filter(function(item){
              return String(item && item.id || '').trim() !== String(data.row && data.row.id || '').trim();
            })
            .concat([data.row])
            .sort(function(a, b){
              return String(a && a.event_date || '').localeCompare(String(b && b.event_date || ''))
                || String(a && a.created_at || '').localeCompare(String(b && b.created_at || ''));
            });
          var statusMessage = managerCalendarActiveModalItemId ? 'Calendar item updated.' : 'Calendar item added.';
          if (smsQueuedCount > 0) {
            statusMessage += smsProcessedCount > 0
              ? ' Text sent to ' + smsProcessedCount + ' staff.'
              : ' Text queued for ' + smsQueuedCount + ' staff.';
          } else if (sendStaffSms) {
            statusMessage += ' No staff texts were queued.';
          }
          setManagerCalendarStatus(statusMessage, 'success');
          closeManagerCalendarModal();
        } catch (error) {
          setManagerCalendarStatus(humanizeClientFetchErrorMessage(error, 'Could not save calendar item.'), 'error');
        } finally {
          delete managerCalendarSaveInFlightByDate[dateKey];
          if (managerCalendarModalSave) managerCalendarModalSave.disabled = false;
          managerCalendarLoadedRangeKey = managerCalendarRangeKey(managerCalendarRangeForView(managerCalendarView, managerCalendarAnchorDate));
          renderManagerCalendar();
        }
      }

      async function deleteManagerCalendarItemById(itemId){
        var normalizedId = String(itemId || '').trim();
        if (!normalizedId) return;
        managerCalendarDeleteInFlightById[normalizedId] = true;
        renderManagerCalendar();
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'manager-calendar-delete',
              id: normalizedId
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not delete calendar item.');
          }
          managerCalendarItems = (Array.isArray(managerCalendarItems) ? managerCalendarItems : []).filter(function(item){
            return String(item && item.id || '').trim() !== normalizedId;
          });
          var deletedSms = data && data.sms ? data.sms : null;
          var deletedProcessedCount = Number(deletedSms && deletedSms.processed_count || 0) || 0;
          var deletedQueuedCount = Number(deletedSms && deletedSms.queued_count || 0) || 0;
          if (deletedProcessedCount > 0) {
            setManagerCalendarStatus('Calendar item removed. Text sent to ' + deletedProcessedCount + ' staff.', 'success');
          } else if (deletedQueuedCount > 0) {
            setManagerCalendarStatus('Calendar item removed. Text queued for ' + deletedQueuedCount + ' staff.', 'success');
          } else {
            setManagerCalendarStatus('Calendar item removed.', 'success');
          }
        } catch (error) {
          setManagerCalendarStatus(humanizeClientFetchErrorMessage(error, 'Could not delete calendar item.'), 'error');
        } finally {
          delete managerCalendarDeleteInFlightById[normalizedId];
          renderManagerCalendar();
        }
      }

      function normalizeMasterScheduleValue(value, dayConfig){
        var normalized = String(value || '').trim();
        return dayConfig.options.indexOf(normalized) !== -1 ? normalized : 'OFF';
      }

      function getMasterScheduleCustomFieldKey(dayKey){
        return String(dayKey || '').trim() + '_custom_shift';
      }

      function getMasterScheduleDisplayShift(assignment, dayKey){
        var dayConfig = MASTER_SCHEDULE_DAYS.find(function(entry){
          return entry.key === dayKey;
        }) || { options: ['OFF'] };
        var shiftValue = normalizeMasterScheduleValue(assignment && assignment[dayKey], dayConfig);
        if (shiftValue !== 'CUSTOM') return shiftValue;
        var customValue = String((assignment && assignment[getMasterScheduleCustomFieldKey(dayKey)]) || '').trim();
        return customValue || 'Custom shift';
      }

      function normalizeMasterScheduleShiftType(value){
        var normalized = String(value || '').trim().toLowerCase();
        return normalized === 'manager' || normalized === 'floor' || normalized === 'assisting' || normalized === 'off'
          ? normalized
          : '';
      }

      function getMasterScheduleTypeFieldKey(dayKey){
        return String(dayKey || '').trim() + '_shift_type';
      }

      function isManagementRole(roleName){
        var role = String(roleName || '').trim().toLowerCase();
        return role.indexOf('manager') >= 0
          || role.indexOf('owner') >= 0
          || role.indexOf('front desk') >= 0
          || role.indexOf('general staff') >= 0;
      }

      function inferShiftTypeFromRole(roleName){
        var role = String(roleName || '').trim().toLowerCase();
        if (!role) return 'assisting';
        if (isManagementRole(roleName)) {
          return 'manager';
        }
        var level = parseRoleLevelNumber(roleName);
        if (level != null && level >= 5) return 'floor';
        if (level != null) return 'assisting';
        if (role.indexOf('stylist') >= 0) return 'floor';
        return 'assisting';
      }

      function getMasterScheduleShiftType(assignment, dayKey, roleName){
        var shiftValue = normalizeMasterScheduleValue(assignment && assignment[dayKey], MASTER_SCHEDULE_DAYS.find(function(entry){
          return entry.key === dayKey;
        }) || { options: ['OFF'] });
        if (shiftValue === 'OFF') return 'off';
        var raw = normalizeMasterScheduleShiftType(assignment && assignment[getMasterScheduleTypeFieldKey(dayKey)]);
        if (raw === 'manager' || raw === 'floor' || raw === 'assisting') return raw;
        return inferShiftTypeFromRole(roleName);
      }

      function formatShiftTypeLabel(value){
        var normalized = normalizeMasterScheduleShiftType(value);
        if (normalized === 'manager') return 'Manager';
        if (normalized === 'floor') return 'Floor';
        if (normalized === 'assisting') return 'Assisting';
        return '';
      }

      function getCoverageLane(roleName, shiftType){
        var normalizedShiftType = normalizeMasterScheduleShiftType(shiftType);
        if (normalizedShiftType === 'manager') return 'management';
        if (normalizedShiftType === 'floor') return 'floor';
        if (normalizedShiftType === 'assisting') return 'assisting';
        if (isManagementRole(roleName)) return 'management';
        return 'assisting';
      }

      function toLocalDateKey(date){
        return [
          date.getFullYear(),
          String(date.getMonth() + 1).padStart(2, '0'),
          String(date.getDate()).padStart(2, '0')
        ].join('-');
      }

      function getWorkWeekDays(weekOffset){
        var today = new Date();
        var currentDay = today.getDay();
        var mondayOffset = currentDay === 0 ? -6 : 1 - currentDay;
        var monday = new Date(today.getFullYear(), today.getMonth(), today.getDate() + mondayOffset + ((Number(weekOffset) || 0) * 7));
        return COVERAGE_WEEK_DAYS.map(function(dayConfig, index){
          var date = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + index);
          return {
            key: dayConfig.key,
            label: dayConfig.label,
            date: date,
            dateKey: toLocalDateKey(date)
          };
        });
      }

      function formatWeekRangeLabel(days){
        if (!Array.isArray(days) || !days.length) return '';
        var start = days[0].date;
        var end = days[days.length - 1].date;
        var sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
        var startText = start.toLocaleDateString(undefined, {
          month: 'short',
          day: 'numeric'
        });
        var endText = end.toLocaleDateString(undefined, {
          month: sameMonth ? undefined : 'short',
          day: 'numeric',
          year: 'numeric'
        });
        return startText + ' - ' + endText;
      }

      function buildApprovedRequestOffMap(){
        return (Array.isArray(requestOffQueue) ? requestOffQueue : []).reduce(function(map, row){
          if (String((row && row.status) || '').trim().toLowerCase() !== 'approved') {
            return map;
          }
          var staffId = String((row && row.staff_id) || '').trim();
          if (!staffId) return map;
          var dates = uniqueNonEmptyStrings(row && row.requested_dates);
          if (!dates.length) return map;
          if (!map[staffId]) {
            map[staffId] = {};
          }
          var scope = normalizeRequestOffScope(getRequestOffMeta(row).request_scope);
          dates.forEach(function(dateKey){
            map[staffId][dateKey] = {
              scope: scope,
              label: formatRequestOffScopeLabel(scope)
            };
          });
          return map;
        }, {});
      }

      function getShiftSortWeight(shift){
        var value = String(shift || '').trim().toLowerCase();
        if (value === '8-3pm') return 1;
        if (value === '11-6p') return 2;
        if (value === '12-9:30p') return 3;
        if (value === '3-9:30p') return 4;
        return 99;
      }

      function renderMasterScheduleCellSelect(staffId, dayConfig, shiftValue, shiftTypeValue){
        var normalizedShiftValue = normalizeMasterScheduleValue(shiftValue, dayConfig);
        var normalizedShiftType = normalizeMasterScheduleShiftType(shiftTypeValue);
        var effectiveShiftType = normalizedShiftValue === 'OFF'
          ? 'off'
          : (normalizedShiftType === 'manager' || normalizedShiftType === 'floor' || normalizedShiftType === 'assisting' ? normalizedShiftType : 'assisting');
        return ''
          + '<div class="master-schedule-cellStack">'
          +   '<select'
          +   ' data-master-staff-id="' + escapeHtml(staffId) + '"'
          +   ' data-master-day="' + escapeHtml(dayConfig.key) + '"'
          +   ' data-master-field="shift"'
          +   '>'
          +   dayConfig.options.map(function(option){
                var label = option === 'OFF' ? 'Off' : (option === 'CUSTOM' ? 'Custom' : option);
                var selectedAttr = option === normalizedShiftValue ? ' selected' : '';
                return '<option value="' + escapeHtml(option) + '"' + selectedAttr + '>' + escapeHtml(label) + '</option>';
              }).join('')
          +   '</select>'
          +   '<select'
          +   ' data-master-staff-id="' + escapeHtml(staffId) + '"'
          +   ' data-master-day="' + escapeHtml(dayConfig.key) + '"'
          +   ' data-master-field="type"'
          +   (normalizedShiftValue === 'OFF' ? ' disabled' : '')
          +   '>'
          +   MASTER_SCHEDULE_SHIFT_TYPES.map(function(option){
                var selectedAttr = option.value === effectiveShiftType ? ' selected' : '';
                return '<option value="' + escapeHtml(option.value) + '"' + selectedAttr + '>' + escapeHtml(option.label) + '</option>';
              }).join('')
          +   '</select>'
          +   (normalizedShiftValue === 'CUSTOM'
                ? '<input'
                  + ' class="master-schedule-customInput"'
                  + ' data-master-staff-id="' + escapeHtml(staffId) + '"'
                  + ' data-master-day="' + escapeHtml(dayConfig.key) + '"'
                  + ' data-master-field="custom"'
                  + ' type="text"'
                  + ' placeholder="Enter custom shift"'
                  + ' value="' + escapeHtml(String((masterScheduleAssignments[staffId] && masterScheduleAssignments[staffId][getMasterScheduleCustomFieldKey(dayConfig.key)]) || '')) + '"'
                  + '>'
                : '')
          + '</div>';
      }

      function renderMasterScheduleWeekView(){
        var staffOptions = Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions.slice() : [];
        if (!staffOptions.length) {
          masterScheduleWeekMount.innerHTML = 'No staff available for the master schedule.';
          renderCoverageCalendarWeek();
          return;
        }

        masterScheduleWeekMount.innerHTML = ''
          + '<table>'
          +   '<thead><tr>'
          +     '<th>Staff</th>'
          +     MASTER_SCHEDULE_DAYS.map(function(dayConfig){
                  return '<th>' + escapeHtml(dayConfig.label) + '</th>';
                }).join('')
          +   '</tr></thead>'
          +   '<tbody>'
          +   staffOptions.map(function(option){
                var assignment = masterScheduleAssignments[option.id] || {};
                return ''
                  + '<tr>'
                  +   '<td class="master-schedule-staff">' + escapeHtml(option.name || '') + '<br><span class="live-weekly-card-level">' + escapeHtml(option.role || 'Salon Team') + '</span></td>'
                  +   MASTER_SCHEDULE_DAYS.map(function(dayConfig){
                        var shiftValue = normalizeMasterScheduleValue(assignment[dayConfig.key], dayConfig);
                        var shiftTypeValue = getMasterScheduleShiftType(assignment, dayConfig.key, option.role);
                        return '<td class="master-schedule-cell">' + renderMasterScheduleCellSelect(option.id || '', dayConfig, shiftValue, shiftTypeValue) + '</td>';
                      }).join('')
                  + '</tr>';
                }).join('')
          +   '</tbody>'
          + '</table>';
        renderCoverageCalendarWeek();
      }

      function getCoverageWeekDays(){
        return getWorkWeekDays(coverageWeekOffset);
      }

      function getApprovedOpenShiftRows(){
        return (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).filter(function(row){
          return String((row && row.request_type) || '').trim().toLowerCase() === 'open_shift'
            && String((row && row.status) || '').trim().toLowerCase() === 'approved';
        });
      }

      function getApprovedPickupRows(){
        return (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).filter(function(row){
          return String((row && row.request_type) || '').trim().toLowerCase() === 'pick_up_shift'
            && String((row && row.status) || '').trim().toLowerCase() === 'approved';
        });
      }

      function getApprovedSwapRows(){
        return (Array.isArray(shiftChangeQueue) ? shiftChangeQueue : []).filter(function(row){
          return String((row && row.request_type) || '').trim().toLowerCase() === 'replace_shift'
            && String((row && row.status) || '').trim().toLowerCase() === 'approved';
        });
      }

      function getCoverageDayConfigByDateKey(dateKey){
        var safeDateKey = String(dateKey || '').trim();
        if (!safeDateKey) return null;
        return getCoverageWeekDays().find(function(day){
          return String(day && day.dateKey || '').trim() === safeDateKey;
        }) || null;
      }

      function removeCoverageBaseEntry(entriesByDate, dateKey, staffId){
        var safeDateKey = String(dateKey || '').trim();
        var safeStaffId = String(staffId || '').trim();
        if (!safeDateKey || !safeStaffId || !entriesByDate[safeDateKey]) return;
        entriesByDate[safeDateKey] = (Array.isArray(entriesByDate[safeDateKey]) ? entriesByDate[safeDateKey] : []).filter(function(entry){
          var source = String((entry && entry.source) || '').trim();
          return !(String((entry && entry.staff_id) || '').trim() === safeStaffId
            && (source === 'master_schedule' || source === 'approved_request_off' || source === 'approved_partial_request_off'));
        });
      }

      function buildCoverageCalendarEntries(days){
        var staffOptions = Array.isArray(requestOffStaffOptions) ? requestOffStaffOptions.slice() : [];
        var staffById = staffOptions.reduce(function(map, option){
          var key = String((option && option.id) || '').trim();
          if (key) map[key] = option;
          return map;
        }, {});
        var approvedRequestOffMap = buildApprovedRequestOffMap();
        var entriesByDate = {};
        (Array.isArray(days) ? days : []).forEach(function(day){
          entriesByDate[day.dateKey] = [];
        });

        staffOptions.forEach(function(option){
          var assignment = masterScheduleAssignments[option.id] || {};
          (Array.isArray(days) ? days : []).forEach(function(day){
            var shiftValue = normalizeMasterScheduleValue(assignment[day.key], MASTER_SCHEDULE_DAYS.find(function(entry){
              return entry.key === day.key;
            }) || { options: ['OFF'] });
            if (shiftValue === 'OFF') return;
            var approvedRequest = approvedRequestOffMap[option.id] && approvedRequestOffMap[option.id][day.dateKey]
              ? approvedRequestOffMap[option.id][day.dateKey]
              : null;
            var requestScope = approvedRequest && approvedRequest.scope ? approvedRequest.scope : '';
            var hasApprovedRequestOff = !!approvedRequest && requestScope === 'full_shift';
            var hasPartialRequestOff = !!approvedRequest && requestScope !== 'full_shift';
            entriesByDate[day.dateKey].push({
              staff_id: String(option.id || ''),
              staff_name: String(option.name || ''),
              role_name: String(option.role || ''),
              shift_label: getMasterScheduleDisplayShift(assignment, day.key),
              shift_type: getMasterScheduleShiftType(assignment, day.key, option.role),
              lane: getCoverageLane(option.role, getMasterScheduleShiftType(assignment, day.key, option.role)),
              source: hasApprovedRequestOff
                ? 'approved_request_off'
                : (hasPartialRequestOff ? 'approved_partial_request_off' : 'master_schedule'),
              note: hasApprovedRequestOff
                ? 'Approved request off'
                : (hasPartialRequestOff ? formatRequestOffScopeLabel(requestScope) : '')
            });
          });
        });

        var openShiftById = getApprovedOpenShiftRows().reduce(function(map, row){
          var rowId = String((row && row.id) || '').trim();
          if (rowId) map[rowId] = row;
          return map;
        }, {});

        getApprovedOpenShiftRows().forEach(function(row){
          var requestDate = String((row && row.request_date) || '').trim();
          if (!requestDate || !entriesByDate[requestDate]) return;
          var meta = getShiftChangeMeta(row);
          if (String((meta.open_status) || 'open').trim().toLowerCase() === 'filled') return;
          var roleName = String((row && row.role_name) || '').trim();
          var shiftType = normalizeMasterScheduleShiftType(meta.shift_type) || inferShiftTypeFromRole(roleName);
          var allowedRoles = Array.isArray(meta.allowed_role_labels) ? meta.allowed_role_labels : [];
          entriesByDate[requestDate].push({
            staff_id: String((row && row.id) || '').trim(),
            staff_name: 'Open shift available',
            role_name: roleName || (allowedRoles.length ? 'Eligible: ' + allowedRoles.join(', ') : 'Salon Team'),
            shift_label: String((row && row.shift_label) || '').trim(),
            shift_type: shiftType,
            lane: getCoverageLane(roleName, shiftType),
            source: 'open_shift',
            note: getOpenShiftSourceLabel(meta)
          });
        });

        getApprovedPickupRows().forEach(function(row){
          var requestDate = String((row && row.request_date) || '').trim();
          if (!requestDate || !entriesByDate[requestDate]) return;
          var meta = getShiftChangeMeta(row);
          var openShiftRow = openShiftById[String(meta.open_shift_id || '').trim()] || null;
          var openShiftMeta = getShiftChangeMeta(openShiftRow);
          var roleName = String((row && row.role_name) || '').trim()
            || String(((staffById[row.staff_id] || {}).role) || '').trim();
          var shiftType = normalizeMasterScheduleShiftType(openShiftMeta.shift_type || meta.shift_type) || inferShiftTypeFromRole(roleName);
          entriesByDate[requestDate].push({
            staff_id: String((row && row.staff_id) || '').trim(),
            staff_name: String((row && row.staff_name) || '').trim(),
            role_name: roleName,
            shift_label: String((row && row.shift_label) || '').trim(),
            shift_type: shiftType,
            lane: getCoverageLane(roleName, shiftType),
            source: 'approved_pickup'
          });
        });

        getApprovedSwapRows().forEach(function(row){
          var requestDate = String((row && row.request_date) || '').trim();
          if (!requestDate) return;
          var meta = getShiftChangeMeta(row);
          var replacementStaffId = String(meta.replacement_staff_id || '').trim();
          var replacementStaffName = String(meta.replacement_staff_name || '').trim();
          var replacementRoleName = String(meta.replacement_role_name || '').trim()
            || String(((staffById[replacementStaffId] || {}).role) || '').trim();
          var replacementDate = String(meta.replacement_request_date || '').trim();
          var replacementShift = String(meta.replacement_shift_label || '').trim();
          var requesterRoleName = String((row && row.role_name) || '').trim()
            || String(((staffById[row && row.staff_id] || {}).role) || '').trim();
          if (!replacementStaffId || !replacementStaffName || !replacementDate || !replacementShift) return;

          var requesterDay = getCoverageDayConfigByDateKey(requestDate);
          var replacementDay = getCoverageDayConfigByDateKey(replacementDate);
          var requesterAssignment = masterScheduleAssignments[String((row && row.staff_id) || '').trim()] || {};
          var replacementAssignment = masterScheduleAssignments[replacementStaffId] || {};
          var requesterShiftType = requesterDay
            ? getMasterScheduleShiftType(requesterAssignment, requesterDay.key, requesterRoleName)
            : inferShiftTypeFromRole(requesterRoleName);
          var replacementShiftType = replacementDay
            ? getMasterScheduleShiftType(replacementAssignment, replacementDay.key, replacementRoleName)
            : inferShiftTypeFromRole(replacementRoleName);

          removeCoverageBaseEntry(entriesByDate, requestDate, String((row && row.staff_id) || '').trim());
          removeCoverageBaseEntry(entriesByDate, replacementDate, replacementStaffId);

          if (entriesByDate[requestDate]) {
            entriesByDate[requestDate].push({
              staff_id: replacementStaffId,
              staff_name: replacementStaffName,
              role_name: replacementRoleName || 'Salon Team',
              shift_label: String((row && row.shift_label) || '').trim(),
              shift_type: requesterShiftType,
              lane: getCoverageLane(replacementRoleName, requesterShiftType),
              source: 'approved_swap',
              note: 'Approved swap with ' + String((row && row.staff_name) || '').trim()
            });
          }

          if (entriesByDate[replacementDate]) {
            entriesByDate[replacementDate].push({
              staff_id: String((row && row.staff_id) || '').trim(),
              staff_name: String((row && row.staff_name) || '').trim(),
              role_name: requesterRoleName || 'Salon Team',
              shift_label: replacementShift,
              shift_type: replacementShiftType,
              lane: getCoverageLane(requesterRoleName, replacementShiftType),
              source: 'approved_swap',
              note: 'Approved swap with ' + replacementStaffName
            });
          }
        });

        Object.keys(entriesByDate).forEach(function(dateKey){
          entriesByDate[dateKey].sort(function(a, b){
            var shiftCompare = getShiftSortWeight(a.shift_label) - getShiftSortWeight(b.shift_label);
            if (shiftCompare !== 0) return shiftCompare;
            return String(a.staff_name || '').localeCompare(String(b.staff_name || ''));
          });
        });

        return entriesByDate;
      }

      function renderCoverageLane(entries, laneKey, emptyLabel){
        var filtered = (Array.isArray(entries) ? entries : []).filter(function(entry){
          return entry.lane === laneKey;
        });
        var counted = filtered.filter(function(entry){
          return coverageEntryCountsTowardTotals(entry);
        });
        var title = laneKey === 'management'
          ? 'Managers'
          : (laneKey === 'floor' ? 'On Floor' : 'Asst.');
        return ''
          + '<section class="live-weekly-lane live-weekly-lane--' + escapeHtml(laneKey) + '">'
          +   '<div class="live-weekly-laneHead">'
          +     '<h3 class="live-weekly-laneTitle">' + escapeHtml(title) + '</h3>'
          +     '<span class="live-weekly-laneCount">' + escapeHtml(String(counted.length)) + '</span>'
          +   '</div>'
          +   (filtered.length
                ? '<div class="live-weekly-list">' + filtered.map(function(entry){
                    return ''
                      + '<article class="live-weekly-card" data-source="' + escapeHtml(String(entry.source || '')) + '">'
                      +   '<div class="live-weekly-card-name">' + escapeHtml(entry.staff_name || '') + '</div>'
                      +   '<div class="live-weekly-card-level">' + escapeHtml(entry.role_name || 'Salon Team') + '</div>'
                      +   '<div class="live-weekly-card-meta">'
                      +     '<span class="live-weekly-card-shift">' + escapeHtml(entry.shift_label || '') + '</span>'
                      +     '<span class="live-weekly-card-type">' + escapeHtml(formatShiftTypeLabel(entry.shift_type)) + '</span>'
                      +   '</div>'
                      +   (entry.source === 'approved_pickup'
                            ? '<div class="live-weekly-card-note">Approved pickup</div>'
                            : (entry.source === 'approved_swap'
                                ? '<div class="live-weekly-card-note">' + escapeHtml(entry.note || 'Approved swap') + '</div>'
                            : (entry.source === 'open_shift'
                                ? '<div class="live-weekly-card-note">' + escapeHtml(entry.note || 'Posted open shift') + '</div>'
                                : (entry.source === 'approved_request_off'
                                    ? '<div class="live-weekly-card-note">Approved request off</div>'
                                    : (entry.source === 'approved_partial_request_off'
                                        ? '<div class="live-weekly-card-note">' + escapeHtml(entry.note || 'Partial request off') + '</div>'
                                        : '')))))
                      + '</article>';
                  }).join('') + '</div>'
                : '<div class="live-weekly-empty">' + escapeHtml(emptyLabel) + '</div>')
          + '</section>';
      }

      function getCoverageLaneCount(entries, laneKey){
        return (Array.isArray(entries) ? entries : []).reduce(function(total, entry){
          return total + (entry && entry.lane === laneKey && coverageEntryCountsTowardTotals(entry) ? 1 : 0);
        }, 0);
      }

      function renderCoverageCountChip(label, count, laneKey){
        return ''
          + '<div class="live-weekly-countChip live-weekly-countChip--' + escapeHtml(laneKey) + '">'
          +   '<div class="live-weekly-countChipLabel">' + escapeHtml(label) + '</div>'
          +   '<div class="live-weekly-countChipValue">' + escapeHtml(String(count)) + '</div>'
          + '</div>';
      }

      function renderCoverageBalance(entries){
        var floorCount = getCoverageLaneCount(entries, 'floor');
        var assistingCount = getCoverageLaneCount(entries, 'assisting');
        var total = floorCount + assistingCount;
        var floorWidth = total > 0 ? Math.max(10, Math.round((floorCount / total) * 100)) : 50;
        var assistingWidth = total > 0 ? Math.max(10, 100 - floorWidth) : 50;
        return ''
          + '<div class="live-weekly-balance">'
          +   '<div class="live-weekly-balanceBar">'
          +     '<span class="live-weekly-balanceFill live-weekly-balanceFill--floor" style="width:' + escapeHtml(String(floorWidth)) + '%"></span>'
          +     '<span class="live-weekly-balanceFill live-weekly-balanceFill--assisting" style="width:' + escapeHtml(String(assistingWidth)) + '%"></span>'
          +   '</div>'
          +   '<div class="live-weekly-balanceMeta">'
          +     '<span class="live-weekly-balanceLabel live-weekly-balanceLabel--floor">Floor ' + escapeHtml(String(floorCount)) + '</span>'
          +     '<span class="live-weekly-balanceLabel live-weekly-balanceLabel--assisting">Assisting ' + escapeHtml(String(assistingCount)) + '</span>'
          +   '</div>'
          + '</div>';
      }

      function renderCoverageDaySummary(entries){
        return ''
          + '<div class="live-weekly-summary">'
          +   renderCoverageCountChip('Mgr', getCoverageLaneCount(entries, 'management'), 'management')
          +   renderCoverageCountChip('Floor', getCoverageLaneCount(entries, 'floor'), 'floor')
          +   renderCoverageCountChip('Asst.', getCoverageLaneCount(entries, 'assisting'), 'assisting')
          + '</div>'
          + renderCoverageBalance(entries);
      }

      function renderCoverageRoleSection(title, laneKey, entries, emptyLabel){
        var filtered = (Array.isArray(entries) ? entries : []).filter(function(entry){
          return entry && entry.lane === laneKey;
        });
        var counted = filtered.filter(function(entry){
          return coverageEntryCountsTowardTotals(entry);
        });
        return ''
          + '<section class="live-weekly-roleSection live-weekly-roleSection--' + escapeHtml(laneKey) + '">'
          +   '<div class="live-weekly-roleHead">'
          +     '<div class="live-weekly-roleTitle">' + escapeHtml(title) + '</div>'
          +     '<div class="live-weekly-roleCount">' + escapeHtml(String(counted.length)) + '</div>'
          +   '</div>'
          +   (filtered.length
                ? '<div class="live-weekly-roster">' + filtered.map(function(entry){
                    return renderCoverageEntryRow(entry);
                  }).join('') + '</div>'
                : '<div class="live-weekly-empty">' + escapeHtml(emptyLabel) + '</div>')
          + '</section>';
      }

      function renderCoverageRoleColumns(entries){
        var managers = (Array.isArray(entries) ? entries : []).filter(function(entry){
          return entry && entry.lane === 'management';
        });
        var serviceTeam = (Array.isArray(entries) ? entries : []).filter(function(entry){
          return entry && entry.lane !== 'management';
        });
        return ''
          + (managers.length
              ? '<div class="live-weekly-managerBlock">'
                + renderCoverageRoleSection('Managers', 'management', managers, 'No managers scheduled.')
                + '</div>'
              : '')
          + '<div class="live-weekly-coverageColumns">'
          +   renderCoverageRoleSection('Floor', 'floor', serviceTeam, 'No floor coverage.')
          +   renderCoverageRoleSection('Assisting', 'assisting', serviceTeam, 'No assisting coverage.')
          + '</div>';
      }

      function getCoverageEntryRoleSummary(entry){
        var lane = String((entry && entry.lane) || '').trim();
        var roleName = String((entry && entry.role_name) || '').trim();
        var shiftType = normalizeMasterScheduleShiftType(entry && entry.shift_type);
        var levelLabel = getLevelLabel(entry && entry.staff_name);
        var levelMatch = String(levelLabel || roleName).match(/level\s+(\d+)/i);
        var levelShort = levelMatch ? ('L' + String(levelMatch[1])) : '';
        if (shiftType === 'floor' && isManagementRole(roleName)) {
          return 'Floor';
        }
        if (shiftType === 'assisting' && isManagementRole(roleName)) {
          return 'Assisting';
        }
        if (lane === 'management') {
          return levelShort ? (levelShort + ' Manager') : 'Manager';
        }
        if (/finishing/i.test(roleName)) {
          return levelShort ? (levelShort + ' Finishing') : 'Finishing';
        }
        if (/color support/i.test(roleName)) {
          return levelShort ? (levelShort + ' Color Support') : 'Color Support';
        }
        if (/stylist/i.test(roleName)) {
          return levelShort ? (levelShort + ' Stylist') : 'Stylist';
        }
        if (/assistant/i.test(roleName) || lane === 'assisting') {
          return levelShort ? (levelShort + ' Assisting') : 'Assisting';
        }
        return levelShort || roleName || 'Salon Team';
      }

      function coverageEntryCountsTowardTotals(entry){
        var source = String((entry && entry.source) || '').trim().toLowerCase();
        if (!source) return true;
        if (source === 'open_shift') return false;
        if (source === 'approved_request_off') return false;
        return true;
      }

      function getCoverageEntryStateLabel(entry){
        if ((entry && entry.source) === 'approved_pickup') return 'Picked up';
        if ((entry && entry.source) === 'approved_swap') return String((entry && entry.note) || 'Swapped');
        if ((entry && entry.source) === 'open_shift') return String((entry && entry.note) || 'Open shift');
        if ((entry && entry.source) === 'approved_request_off') return 'Requested off';
        if ((entry && entry.source) === 'approved_partial_request_off') return String((entry && entry.note) || 'Partial off');
        return '';
      }

      function renderCoverageEntryRow(entry){
        var shiftTypeLabel = formatShiftTypeLabel(entry.shift_type);
        var roleSummary = getCoverageEntryRoleSummary(entry);
        var stateLabel = getCoverageEntryStateLabel(entry);
        return ''
          + '<article class="live-weekly-row live-weekly-row--' + escapeHtml(String((entry && entry.lane) || 'assisting')) + '" data-source="' + escapeHtml(String((entry && entry.source) || '')) + '">'
          +   '<div class="live-weekly-rowMain">'
          +     '<div class="live-weekly-rowName">' + escapeHtml((entry && entry.staff_name) || '') + '</div>'
          +     '<div class="live-weekly-rowRole">' + escapeHtml(roleSummary) + '</div>'
          +   '</div>'
          +   '<div class="live-weekly-rowMeta">'
          +     (shiftTypeLabel ? '<div class="live-weekly-rowType">' + escapeHtml(shiftTypeLabel) + '</div>' : '')
          +     (stateLabel ? '<div class="live-weekly-rowNote">' + escapeHtml(stateLabel) + '</div>' : '')
          +   '</div>'
          + '</article>';
      }

      function renderCoverageShiftGroup(shiftLabel, entries){
        var title = String(shiftLabel || '').trim() || 'Shift';
        var countedEntries = (Array.isArray(entries) ? entries : []).filter(function(entry){
          return coverageEntryCountsTowardTotals(entry);
        });
        return ''
          + '<section class="live-weekly-shiftGroup">'
          +   '<div class="live-weekly-shiftHead">'
          +     '<div class="live-weekly-shiftTitleWrap">'
          +       '<div class="live-weekly-shiftTitle">' + escapeHtml(title) + '</div>'
          +       '<div class="live-weekly-shiftMeta">' + escapeHtml(String(countedEntries.length)) + ' on this shift</div>'
          +     '</div>'
          +     renderCoverageBalance(entries)
          +   '</div>'
          +   renderCoverageRoleColumns(entries)
          + '</section>';
      }

      function renderCoverageShiftGroups(entries){
        var list = Array.isArray(entries) ? entries : [];
        if (!list.length) {
          return '<div class="live-weekly-empty">No one scheduled.</div>';
        }
        var groups = [];
        list.forEach(function(entry){
          var shiftLabel = String((entry && entry.shift_label) || '').trim() || 'Shift';
          var existing = groups.find(function(group){
            return group.shiftLabel === shiftLabel;
          });
          if (!existing) {
            existing = { shiftLabel: shiftLabel, entries: [] };
            groups.push(existing);
          }
          existing.entries.push(entry);
        });
        groups.sort(function(a, b){
          return getShiftSortWeight(a.shiftLabel) - getShiftSortWeight(b.shiftLabel);
        });
        return groups.map(function(group){
          return renderCoverageShiftGroup(group.shiftLabel, group.entries);
        }).join('');
      }

      function renderCoverageCalendarWeek(){
        if (!coverageCalendarMount) return;
        var days = getCoverageWeekDays();
        if (coverageWeekRange) {
          coverageWeekRange.textContent = formatWeekRangeLabel(days);
        }
        if (!requestOffStaffOptions.length) {
          coverageCalendarMount.innerHTML = '<div class="live-weekly-empty">No staff available yet.</div>';
          setCoverageCalendarStatus('Weekly coverage will appear once staff and schedule rows load.');
          return;
        }
        var entriesByDate = buildCoverageCalendarEntries(days);
        coverageCalendarMount.innerHTML = days.map(function(day){
          var entries = entriesByDate[day.dateKey] || [];
          return ''
            + '<section class="live-weekly-day">'
            +   '<div class="live-weekly-day-head">'
            +     '<div class="live-weekly-day-label">' + escapeHtml(day.label) + '</div>'
            +     '<div class="live-weekly-day-date">' + escapeHtml(day.date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })) + '</div>'
            +   '</div>'
            +   renderCoverageDaySummary(entries)
            +   '<div class="live-weekly-dayBody">'
            +     renderCoverageShiftGroups(entries)
            +   '</div>'
            + '</section>';
        }).join('');
        setCoverageCalendarStatus('Weekly coverage starts from master schedule, crosses out approved requests off, shows posted open shifts, adds approved pickups, and swaps approved trades into place.', 'success');
      }

      function populateMasterScheduleStaffOptions(options){
        renderMasterScheduleWeekView();
      }

      async function saveMasterScheduleCell(staffId, dayKey, fieldName, rawValue){
        var selected = requestOffStaffOptions.find(function(option){
          return String(option.id || '') === String(staffId || '').trim();
        }) || null;
        var isCustomField = fieldName === 'custom';
        var dayConfig = MASTER_SCHEDULE_DAYS.find(function(item){
          return item.key === dayKey;
        }) || null;
        if (!selected || !dayConfig) {
          throw new Error('Could not match staff schedule row.');
        }

        var nextEntry = masterScheduleAssignments[staffId] || {
          staff_id: selected.id || '',
          staff_name: selected.name || ''
        };
        nextEntry.staff_id = selected.id || '';
        nextEntry.staff_name = selected.name || '';
        if (isCustomField) {
          nextEntry[getMasterScheduleCustomFieldKey(dayKey)] = String(rawValue || '').trim();
        } else if (fieldName === 'type') {
          var normalizedTypeValue = normalizeMasterScheduleShiftType(rawValue);
          nextEntry[getMasterScheduleTypeFieldKey(dayKey)] = normalizedTypeValue === 'manager' || normalizedTypeValue === 'floor' || normalizedTypeValue === 'assisting'
            ? normalizedTypeValue
            : inferShiftTypeFromRole(selected.role);
        } else {
          nextEntry[dayKey] = normalizeMasterScheduleValue(rawValue, dayConfig);
          if (nextEntry[dayKey] === 'OFF') {
            nextEntry[getMasterScheduleTypeFieldKey(dayKey)] = 'off';
            nextEntry[getMasterScheduleCustomFieldKey(dayKey)] = '';
          } else if (nextEntry[dayKey] === 'CUSTOM') {
            nextEntry[getMasterScheduleTypeFieldKey(dayKey)] = normalizeMasterScheduleShiftType(nextEntry[getMasterScheduleTypeFieldKey(dayKey)]) || inferShiftTypeFromRole(selected.role);
          } else {
            nextEntry[getMasterScheduleCustomFieldKey(dayKey)] = '';
            var existingType = normalizeMasterScheduleShiftType(nextEntry[getMasterScheduleTypeFieldKey(dayKey)]);
            nextEntry[getMasterScheduleTypeFieldKey(dayKey)] = existingType === 'manager' || existingType === 'floor' || existingType === 'assisting'
              ? existingType
              : inferShiftTypeFromRole(selected.role);
          }
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'master-schedule-upsert',
            staff_id: nextEntry.staff_id,
            staff_name: nextEntry.staff_name,
            monday: normalizeMasterScheduleValue(nextEntry.monday, MASTER_SCHEDULE_DAYS[0]),
            monday_custom_shift: String(nextEntry.monday_custom_shift || '').trim(),
            monday_shift_type: normalizeMasterScheduleValue(nextEntry.monday, MASTER_SCHEDULE_DAYS[0]) === 'OFF' ? 'off' : getMasterScheduleShiftType(nextEntry, 'monday', selected.role),
            tuesday: normalizeMasterScheduleValue(nextEntry.tuesday, MASTER_SCHEDULE_DAYS[1]),
            tuesday_custom_shift: String(nextEntry.tuesday_custom_shift || '').trim(),
            tuesday_shift_type: normalizeMasterScheduleValue(nextEntry.tuesday, MASTER_SCHEDULE_DAYS[1]) === 'OFF' ? 'off' : getMasterScheduleShiftType(nextEntry, 'tuesday', selected.role),
            wednesday: normalizeMasterScheduleValue(nextEntry.wednesday, MASTER_SCHEDULE_DAYS[2]),
            wednesday_custom_shift: String(nextEntry.wednesday_custom_shift || '').trim(),
            wednesday_shift_type: normalizeMasterScheduleValue(nextEntry.wednesday, MASTER_SCHEDULE_DAYS[2]) === 'OFF' ? 'off' : getMasterScheduleShiftType(nextEntry, 'wednesday', selected.role),
            thursday: normalizeMasterScheduleValue(nextEntry.thursday, MASTER_SCHEDULE_DAYS[3]),
            thursday_custom_shift: String(nextEntry.thursday_custom_shift || '').trim(),
            thursday_shift_type: normalizeMasterScheduleValue(nextEntry.thursday, MASTER_SCHEDULE_DAYS[3]) === 'OFF' ? 'off' : getMasterScheduleShiftType(nextEntry, 'thursday', selected.role),
            friday: normalizeMasterScheduleValue(nextEntry.friday, MASTER_SCHEDULE_DAYS[4]),
            friday_custom_shift: String(nextEntry.friday_custom_shift || '').trim(),
            friday_shift_type: normalizeMasterScheduleValue(nextEntry.friday, MASTER_SCHEDULE_DAYS[4]) === 'OFF' ? 'off' : getMasterScheduleShiftType(nextEntry, 'friday', selected.role),
            saturday: normalizeMasterScheduleValue(nextEntry.saturday, MASTER_SCHEDULE_DAYS[5]),
            saturday_custom_shift: String(nextEntry.saturday_custom_shift || '').trim(),
            saturday_shift_type: normalizeMasterScheduleValue(nextEntry.saturday, MASTER_SCHEDULE_DAYS[5]) === 'OFF' ? 'off' : getMasterScheduleShiftType(nextEntry, 'saturday', selected.role),
            sunday: normalizeMasterScheduleValue(nextEntry.sunday, MASTER_SCHEDULE_DAYS[6]),
            sunday_custom_shift: String(nextEntry.sunday_custom_shift || '').trim(),
            sunday_shift_type: normalizeMasterScheduleValue(nextEntry.sunday, MASTER_SCHEDULE_DAYS[6]) === 'OFF' ? 'off' : getMasterScheduleShiftType(nextEntry, 'sunday', selected.role)
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.row) {
          throw new Error((data && data.error) || rawText || 'Could not save recurring schedule.');
        }
        masterScheduleAssignments[staffId] = data.row;
        renderMasterScheduleWeekView();
        setMasterScheduleStatus(
          isCustomField
            ? 'Saved custom shift for ' + String(selected.name || '') + ' on ' + dayConfig.label + '.'
            : ('Saved ' + dayConfig.label + ' schedule for ' + String(selected.name || '') + '.'),
          'success'
        );
      }

      function formatDateInputValue(date){
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return year + '-' + month + '-' + day;
      }

      function colorDisciplineDefaultWeekEnding(){
        var today = new Date();
        var base = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        var diffToSaturday = (6 - base.getDay() + 7) % 7;
        base.setDate(base.getDate() + diffToSaturday);
        return formatDateInputValue(base);
      }

      function colorDisciplineDefaultReportStart(){
        var today = new Date();
        return formatDateInputValue(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6));
      }

      function applyQuickRange(range){
        var today = new Date();
        var end = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        var start;

        if (range === 'ytd') {
          start = new Date(end.getFullYear(), 0, 1);
        } else if (range === 'mtd') {
          start = new Date(end.getFullYear(), end.getMonth(), 1);
        } else if (range === 'last-year') {
          start = new Date(end.getFullYear() - 1, 0, 1);
          end = new Date(end.getFullYear() - 1, 11, 31);
        } else {
          var days = Number(range);
          if (!days) return;
          start = new Date(end);
          start.setDate(start.getDate() - (days - 1));
        }

        dateFrom.value = formatDateInputValue(start);
        dateTo.value = formatDateInputValue(end);
      }

      var BONUS_PERIOD_DATA_START = '2026-01-01';
      var GLOBAL_KPI_QUARTER_DATA_START = '2021-01-01';

      function buildQuarterOptions(startDateValue){
        var options = [];
        var minimumDataDate = parseLocalDateKey(startDateValue);
        var startYear = minimumDataDate ? minimumDataDate.getFullYear() : 2020;
        var now = new Date();
        var endYear = now.getFullYear();
        var currentQuarter = Math.floor(now.getMonth() / 3) + 1;

        for (var year = startYear; year <= endYear; year += 1) {
          for (var quarter = 1; quarter <= 4; quarter += 1) {
            if (year === endYear && quarter > currentQuarter) break;
            var startMonth = (quarter - 1) * 3;
            var quarterStart = new Date(year, startMonth, 1);
            var quarterEnd = new Date(year, startMonth + 3, 0);
            options.push({
              value: String(year) + '-Q' + String(quarter),
              label: String(year) + ' Q' + String(quarter),
              start: quarterStart,
              end: quarterEnd
            });
          }
        }

        return options;
      }

      function parseLocalDateKey(value){
        var text = String(value || '').trim();
        if (!text) return null;
        var parts = text.split('-');
        if (parts.length !== 3) return null;
        var year = Number(parts[0]);
        var month = Number(parts[1]);
        var day = Number(parts[2]);
        if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return null;
        return new Date(year, month - 1, day);
      }

      function addDaysToDateKey(value, days){
        var date = parseLocalDateKey(value);
        if (!date) return '';
        return formatDateInputValue(new Date(date.getFullYear(), date.getMonth(), date.getDate() + Number(days || 0)));
      }

      function formatPayrollPeriodLabel(dateFrom, dateTo){
        var start = parseLocalDateKey(dateFrom);
        var end = parseLocalDateKey(dateTo);
        if (!start || !end) return '';
        var sameYear = start.getFullYear() === end.getFullYear();
        var sameMonth = sameYear && start.getMonth() === end.getMonth();
        if (sameMonth) {
          return start.toLocaleDateString('en-US', { month: 'short' }) + ' ' + start.getDate() + '-' + end.getDate() + ', ' + end.getFullYear();
        }
        if (sameYear) {
          return start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ' - ' + end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        }
        return start.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) + ' - ' + end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      }

      function buildConcludedPayrollPeriodOptions(limit){
        var maxCount = Math.max(1, Number(limit) || 1);
        var anchor = parseLocalDateKey(PAYROLL_PERIOD_ANCHOR_START);
        var today = startOfLocalDay(new Date());
        if (!anchor) return [];
        var daysSinceAnchor = Math.floor((today.getTime() - anchor.getTime()) / 86400000);
        var latestIndex = Math.floor((daysSinceAnchor - 14) / 14);
        if (!Number.isFinite(latestIndex) || latestIndex < 0) return [];
        var options = [];
        var earliestIndex = latestIndex - (maxCount - 1);
        for (var index = latestIndex; index >= earliestIndex && options.length < maxCount; index -= 1) {
          var start = new Date(anchor.getFullYear(), anchor.getMonth(), anchor.getDate() + (index * 14));
          var end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 13);
          if (!(end.getTime() < today.getTime())) continue;
          var dateFrom = formatDateInputValue(start);
          var dateTo = formatDateInputValue(end);
          options.push({
            value: dateFrom,
            label: formatPayrollPeriodLabel(dateFrom, dateTo),
            start: start,
            end: end,
            date_from: dateFrom,
            date_to: dateTo
          });
        }
        return options;
      }

      function buildCurrentPayrollPeriodOption(){
        var anchor = parseLocalDateKey(PAYROLL_PERIOD_ANCHOR_START);
        var today = startOfLocalDay(new Date());
        if (!anchor) return null;
        var daysSinceAnchor = Math.floor((today.getTime() - anchor.getTime()) / 86400000);
        if (!Number.isFinite(daysSinceAnchor) || daysSinceAnchor < 0) return null;
        var currentIndex = Math.floor(daysSinceAnchor / 14);
        if (!Number.isFinite(currentIndex) || currentIndex < 0) return null;
        var start = new Date(anchor.getFullYear(), anchor.getMonth(), anchor.getDate() + (currentIndex * 14));
        var end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 13);
        var dateFrom = formatDateInputValue(start);
        var dateTo = formatDateInputValue(end);
        return {
          value: dateFrom,
          label: formatPayrollPeriodLabel(dateFrom, dateTo),
          short_label: 'Live current',
          start: start,
          end: end,
          date_from: dateFrom,
          date_to: formatDateInputValue(today),
          period_date_to: dateTo,
          live_through: formatDateInputValue(today),
          is_live_current: today.getTime() <= end.getTime()
        };
      }

      function buildRetailPayrollPeriodOptions(limit){
        var concluded = buildConcludedPayrollPeriodOptions(limit);
        var current = buildCurrentPayrollPeriodOption();
        concluded = concluded.map(function(period){
          return Object.assign({ period_kind: 'payroll' }, period);
        });
        if (current) {
          current = Object.assign({ period_kind: 'payroll' }, current);
        }
        if (!current || current.is_live_current !== true) {
          return concluded;
        }
        return [current].concat(concluded);
      }

      function buildRetailQuarterCandidates(){
        var today = startOfLocalDay(new Date());
        return buildQuarterOptions(RETAIL_QUARTER_DATA_START).filter(function(option){
          return !!(option && option.start) && option.start.getFullYear() === today.getFullYear();
        }).map(function(option){
          var quarterEnd = option && option.end ? startOfLocalDay(option.end) : today;
          var isCurrentQuarter = quarterEnd.getTime() >= today.getTime();
          return {
            value: String((option && option.value) || ''),
            label: String((option && option.label) || '') + (isCurrentQuarter ? ' QTD' : ''),
            short_label: String((option && option.label) || '') + (isCurrentQuarter ? ' QTD' : ''),
            date_from: formatDateInputValue(option.start),
            date_to: formatDateInputValue(isCurrentQuarter ? today : quarterEnd),
            period_date_to: formatDateInputValue(quarterEnd),
            live_through: isCurrentQuarter ? formatDateInputValue(today) : '',
            is_live_current: isCurrentQuarter,
            period_kind: 'quarter'
          };
        }).filter(function(option){
          return !!String(option.value || '').trim();
        }).reverse();
      }

      function buildRetailQuarterOptions(){
        return Array.isArray(retailAvailableQuarterOptions) ? retailAvailableQuarterOptions.slice() : [];
      }

      function buildRetailPeriodOptions(){
        return buildRetailPayrollPeriodOptions(8).concat(buildRetailQuarterOptions());
      }

      function populateGlobalQuarterOptions(){
        if (!globalKpiQuarter) return;
        var quarterOptions = buildQuarterOptions(GLOBAL_KPI_QUARTER_DATA_START);
        var today = startOfLocalDay(new Date());
        var currentYear = today.getFullYear();
        var minimumDataDate = parseLocalDateKey(GLOBAL_KPI_QUARTER_DATA_START);
        var startYear = minimumDataDate ? minimumDataDate.getFullYear() : currentYear;
        var annualOptions = [];
        for (var year = startYear; year <= currentYear; year += 1) {
          annualOptions.push({
            value: String(year),
            label: year === currentYear ? (String(year) + ' YTD') : (String(year) + ' Total')
          });
        }
        var options = annualOptions.concat(quarterOptions);
        globalKpiQuarter.innerHTML = options.map(function(option){
          return '<option value="' + escapeHtml(option.value) + '">' + escapeHtml(option.label) + '</option>';
        }).join('');
        if (options.length) {
          globalKpiQuarter.value = String(currentYear);
        }
        syncGlobalKpiRefreshYtdButton();
      }

      function getSelectedGlobalQuarter(){
        var selectedValue = String((globalKpiQuarter && globalKpiQuarter.value) || '').trim();
        var quarterMatch = buildQuarterOptions(GLOBAL_KPI_QUARTER_DATA_START).find(function(option){
          return option.value === selectedValue;
        }) || null;
        if (quarterMatch) return quarterMatch;
        var annualMatch = selectedValue.match(/^(\d{4})$/);
        if (!annualMatch) return null;
        var year = Number(annualMatch[1]);
        if (!isFinite(year)) return null;
        var currentYear = startOfLocalDay(new Date()).getFullYear();
        return {
          value: selectedValue,
          label: year === currentYear ? (selectedValue + ' YTD') : (selectedValue + ' Total'),
          start: new Date(year, 0, 1),
          end: new Date(year, 11, 31)
        };
      }

      function isCurrentYearGlobalKpiYtdSelection(selectedQuarter){
        var selected = selectedQuarter || getSelectedGlobalQuarter();
        if (!selected) return false;
        if (isGlobalKpiQuarterSelection(selected)) return false;
        var selectedYear = Number(String(selected.value || '').trim());
        var currentYear = startOfLocalDay(new Date()).getFullYear();
        return isFinite(selectedYear) && selectedYear === currentYear;
      }

      function syncGlobalKpiRefreshYtdButton(){
        if (!globalKpiRefreshYtdBtn) return;
        var show = isCurrentYearGlobalKpiYtdSelection();
        globalKpiRefreshYtdBtn.hidden = !show;
        globalKpiRefreshYtdBtn.disabled = !show;
      }

      function isGlobalKpiQuarterSelection(selectedQuarter){
        var selected = selectedQuarter || getSelectedGlobalQuarter();
        var directValue = String(selected && selected.value || '').trim();
        return /^\d{4}-Q\d$/i.test(directValue);
      }

      function diffDaysFromToday(date){
        var today = startOfLocalDay(new Date());
        var target = startOfLocalDay(date);
        return Math.floor((today.getTime() - target.getTime()) / 86400000);
      }

      function buildGlobalKpiReportFilters(){
        var quarter = getSelectedGlobalQuarter();
        if (!quarter) {
          return { mode: 'missing_quarter', report_filters: [], warning: 'Choose a period first.' };
        }

        var today = startOfLocalDay(new Date());
        var effectiveEnd = quarter.end.getTime() > today.getTime() ? today : quarter.end;
        var startDiff = diffDaysFromToday(quarter.start);
        var endDiff = diffDaysFromToday(effectiveEnd);
        if (startDiff < 0 || endDiff < 0) {
          return { mode: 'future_quarter', report_filters: [], warning: 'Future periods are not supported.' };
        }

        return {
          mode: 'quarter_range',
          report_filters: [
            {
              attribute_name: 'Sale Date',
              relative_date_query: {
                greater_equal: 'P' + String(startDiff + 1) + 'D'
              }
            },
            {
              attribute_name: 'Sale Date',
              relative_date_query: {
                less_equal: 'P' + String(endDiff) + 'D'
              }
            }
          ]
        };
      }

      async function fetchAttendanceTotals(){
        if (activeController) {
          activeController.abort();
        }

        var controller = new AbortController();
        activeController = controller;
        var timeoutId = setTimeout(function(){
          if (activeController === controller) {
            controller.abort();
          }
        }, REQUEST_TIMEOUT_MS);

        try {
          return await fetchAttendanceTotalsSnapshotOrLive(dateFrom.value || '', dateTo.value || '');
        } catch (error) {
          if (error && error.name === 'AbortError') {
            throw new Error('Attendance request timed out after about 3 minutes. Boulevard is still preparing the export. Please try again in a moment.');
          }
          throw new Error(humanizeClientFetchErrorMessage(error, 'Could not fetch leaderboard from proxy.'));
        } finally {
          clearTimeout(timeoutId);
          if (activeController === controller) {
            activeController = null;
          }
        }
      }

      function applyAttendanceMetricMaps(remote){
        var metrics = buildAttendanceMetricMaps(remote);
        reliabilityScoreByStaff = metrics.reliabilityScoreByStaff;
        requestsOffByStaff = metrics.requestsOffByStaff;
        callOutsByStaff = metrics.callOutsByStaff;
        lateArrivalsByStaff = metrics.lateArrivalsByStaff;
      }

      function renderMergedTable(rows){
        if (!rows.length) {
          tableMount.className = 'empty';
          tableMount.innerHTML = 'No attendance totals matched your filters.';
          return;
        }

        tableMount.className = 'table-wrap';
        tableMount.innerHTML = ''
          + '<table>'
          +   '<thead><tr>'
          +     '<th>Rank</th>'
          +     '<th>Staff</th>'
          +     '<th>Call Outs</th>'
          +     '<th>Late / Left Early</th>'
          +     '<th>Requests Off</th>'
          +     '<th>Reliability Score</th>'
          +   '</tr></thead>'
          +   '<tbody>'
          +   rows.map(function(row){
                var combinedLateLeftEarly = (Number(row.late_arrivals || 0) || 0) + (Number(row.leaving_early || 0) || 0);
                return ''
                  + '<tr>'
                  +   '<td class="rank">' + row.rank + '</td>'
                  +   '<td>' + escapeHtml(row.staff_name) + '</td>'
                  +   '<td class="count">' + row.call_outs + '</td>'
                  +   '<td class="count">' + combinedLateLeftEarly + '</td>'
                  +   '<td class="count">' + row.requests_off + '</td>'
                  +   '<td class="count">' + (row.reliability_score != null ? row.reliability_score : '') + '</td>'
                  + '</tr>';
              }).join('')
          +   '</tbody>'
          + '</table>';
      }

      function renderCallOutsTable(rows){
        if (!rows.length) {
          tableMount.className = 'empty';
          tableMount.innerHTML = 'No call-out totals matched your filters.';
          return;
        }

        tableMount.className = 'table-wrap';
        tableMount.innerHTML = ''
          + '<table>'
          +   '<thead><tr>'
          +     '<th>Rank</th>'
          +     '<th>Staff</th>'
          +     '<th>Call Outs</th>'
          +   '</tr></thead>'
          +   '<tbody>'
          +   rows.map(function(row){
                return ''
                  + '<tr>'
                  +   '<td class="rank">' + row.rank + '</td>'
                  +   '<td>' + escapeHtml(row.staff_name) + '</td>'
                  +   '<td class="count">' + row.sales_count + '</td>'
                  + '</tr>';
              }).join('')
          +   '</tbody>'
          + '</table>';
      }

      function formatMoney(value){
        var numeric = Number(value || 0);
        return '$' + numeric.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }

      function formatPercent(value){
        var numeric = Number(value || 0);
        return numeric.toFixed(1) + '%';
      }

      function formatKpiDate(value){
        var text = value == null ? '' : String(value).trim();
        if (!text || text.toLowerCase() === 'all') return text;

        var parsed = text.indexOf('T') >= 0 ? new Date(text) : new Date(text + 'T12:00:00');
        if (isNaN(parsed.getTime())) return text;

        return parsed.toLocaleDateString(undefined, {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      function formatShortDate(value){
        var text = value == null ? '' : String(value).trim();
        if (!text) return text;
        var parsed = text.indexOf('T') >= 0 ? new Date(text) : new Date(text + 'T12:00:00');
        if (isNaN(parsed.getTime())) return text;
        return parsed.toLocaleDateString(undefined, {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      function formatNumericCell(header, value){
        var text = value == null ? '' : String(value);
        if (!text) return '';

        var normalizedHeader = String(header || '').toLowerCase();
        if (normalizedHeader === 'saledate date') {
          return formatKpiDate(text);
        }
        if (normalizedHeader === 'utilization %' && text === '__UNSCHEDULED__') {
          return 'Unscheduled';
        }
        var numeric = Number(text);
        if (!isFinite(numeric)) return text;

        if (normalizedHeader === 'prebooked %' || normalizedHeader === 'utilization %') {
          return (numeric * 100).toFixed(1) + '%';
        }
        if (/percent|%/.test(normalizedHeader)) {
          return (numeric <= 1 ? numeric * 100 : numeric).toFixed(1) + '%';
        }
        if (normalizedHeader === 'production rate') {
          return '$' + numeric.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) + '/hr';
        }
        if (/aov|average order|order value/.test(normalizedHeader)) {
          return '$' + numeric.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        }
        if (/sales|tips?/.test(normalizedHeader)) {
          return '$' + numeric.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        }
        if (/hours?/.test(normalizedHeader)) {
          return numeric.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          });
        }
        if (/count/.test(normalizedHeader)) {
          return numeric.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          });
        }

        return text;
      }

      function startOfLocalDay(date){
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      }

      function parseYmd(value){
        if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
        var parts = value.split('-').map(Number);
        return new Date(parts[0], parts[1] - 1, parts[2]);
      }

      function diffDaysInclusive(startDate, endDate){
        var start = startOfLocalDay(startDate);
        var end = startOfLocalDay(endDate);
        var diffMs = end.getTime() - start.getTime();
        if (diffMs < 0) return 0;
        return Math.floor(diffMs / 86400000) + 1;
      }

      function getSelectedRangeDays(){
        var matchedFrom = parseYmd(dateFrom.value);
        var matchedTo = parseYmd(dateTo.value);
        if (!matchedFrom || !matchedTo) return 0;
        return diffDaysInclusive(matchedFrom, matchedTo);
      }

      function resolveStaffKpiSnapshotKey(dateFromValue, dateToValue){
        var matchedFrom = parseYmd(dateFromValue);
        var matchedTo = parseYmd(dateToValue);
        if (!matchedFrom || !matchedTo) return '';

        var today = startOfLocalDay(new Date());
        if (startOfLocalDay(matchedTo).getTime() !== today.getTime()) {
          return '';
        }

        var totalDays = diffDaysInclusive(matchedFrom, matchedTo);
        if (totalDays === 30) return 'staff_kpi_last_30_days';
        if (totalDays === 90) return 'staff_kpi_last_90_days';

        if (matchedFrom.getFullYear() === today.getFullYear() &&
            matchedFrom.getMonth() === today.getMonth() &&
            matchedFrom.getDate() === 1) {
          return 'staff_kpi_month_to_date';
        }

        if (matchedFrom.getFullYear() === today.getFullYear() &&
            matchedFrom.getMonth() === 0 &&
            matchedFrom.getDate() === 1) {
          return 'staff_kpi_ytd';
        }

        return '';
      }

      function buildKpiReportFilters(){
        var snapshotKey = resolveStaffKpiSnapshotKey(dateFrom.value || '', dateTo.value || '');
        if (!snapshotKey) {
          return {
            mode: 'unsupported_snapshot_range',
            report_filters: [],
            warning: 'Choose one of the saved snapshot windows.'
          };
        }

        return {
          mode: 'snapshot_range',
          snapshot_key: snapshotKey,
          report_filters: []
        };
      }

      function canFetchKpiForSelectedRange(filterConfig){
        return !!filterConfig && (
          filterConfig.mode === 'snapshot_range'
        );
      }

      function parseCsv(text){
        var rows = [];
        var row = [];
        var value = '';
        var inQuotes = false;
        for (var i = 0; i < text.length; i += 1) {
          var char = text[i];
          var next = text[i + 1];

          if (char === '"') {
            if (inQuotes && next === '"') {
              value += '"';
              i += 1;
            } else {
              inQuotes = !inQuotes;
            }
            continue;
          }

          if (char === ',' && !inQuotes) {
            row.push(value);
            value = '';
            continue;
          }

          if ((char === '\n' || char === '\r') && !inQuotes) {
            if (char === '\r' && next === '\n') {
              i += 1;
            }
            row.push(value);
            value = '';
            if (row.some(function(cell){ return cell !== ''; })) {
              rows.push(row);
            }
            row = [];
            continue;
          }

          value += char;
        }

        row.push(value);
        if (row.some(function(cell){ return cell !== ''; })) {
          rows.push(row);
        }
        return rows;
      }

      function parseDelimitedGrid(text){
        var raw = String(text || '').replace(/\u00a0/g, ' ').trim();
        if (!raw) return [];
        var firstLine = raw.split(/\r?\n/)[0] || '';
        if (firstLine.indexOf('\t') >= 0 && firstLine.indexOf(',') < 0) {
          return raw.split(/\r?\n/).filter(Boolean).map(function(line){
            return line.split('\t').map(function(cell){
              return String(cell == null ? '' : cell).trim();
            });
          });
        }
        return parseCsv(raw).map(function(row){
          return row.map(function(cell){
            return String(cell == null ? '' : cell).trim();
          });
        });
      }

      async function readColorDisciplineFile(file){
        if (!file) return '';
        var name = String(file.name || '').toLowerCase();
        if (/\.xlsx$/i.test(name)) {
          throw new Error('XLSX upload is not supported in-browser yet. Open the Vish workbook and save the Employee Performance sheet as CSV, then upload that file.');
        }
        if (!(/\.(csv|tsv|txt)$/i.test(name))) {
          throw new Error('Use a CSV, TSV, or TXT export for upload.');
        }
        return await new Promise(function(resolve, reject){
          var reader = new FileReader();
          reader.onerror = function(){
            reject(new Error('Could not read that file.'));
          };
          reader.onload = function(){
            resolve(String(reader.result || ''));
          };
          reader.readAsText(file);
        });
      }

      function csvRowsToObjects(csvRows){
        if (!csvRows.length) return { headers: [], rows: [] };
        var headers = csvRows[0];
        var rows = csvRows.slice(1).map(function(values){
          var entry = {};
          headers.forEach(function(header, index){
            entry[header] = values[index] == null ? '' : values[index];
          });
          return entry;
        });
        return { headers: headers, rows: rows };
      }

      function parseNumericCell(value){
        var text = value == null ? '' : String(value).trim();
        if (!text) return 0;
        var numeric = Number(text);
        return isFinite(numeric) ? numeric : 0;
      }

      function formatRawNumeric(value){
        if (!isFinite(value)) return '';
        if (Math.abs(value % 1) < 0.0000001) {
          return String(Math.round(value));
        }
        return String(Number(value.toFixed(6)));
      }

      function isAggregateKpiRow(row){
        var staffName = String((row && row['Staff Name']) || '').trim().toLowerCase();
        var locationName = String((row && row['Location name']) || '').trim().toLowerCase();
        return staffName === 'all' || locationName === 'all';
      }

      function detectKpiGroupingHeader(headers, rows){
        var reservedHeaders = {
          'location name': true,
          'staff name': true,
          'prebooked %': true,
          'appointment count': true,
          'service sales': true,
          'tip sales': true,
          'product sales': true,
          'utilization %': true,
          'hours booked': true,
          'hours scheduled': true
        };

        for (var index = 0; index < headers.length; index += 1) {
          var header = headers[index];
          var normalizedHeader = String(header || '').toLowerCase();
          if (reservedHeaders[normalizedHeader]) continue;

          var hasAll = false;
          var hasDetail = false;
          rows.forEach(function(row){
            var value = String((row && row[header]) || '').trim();
            if (!value) return;
            if (value.toLowerCase() === 'all') {
              hasAll = true;
            } else {
              hasDetail = true;
            }
          });

          if (hasAll && hasDetail) {
            return header;
          }
        }

        return '';
      }

      function selectKpiSummaryRows(headers, rows){
        var groupingHeader = detectKpiGroupingHeader(headers, rows);

        if (!groupingHeader) {
          return rows.filter(function(row){
            return !isAggregateKpiRow(row);
          });
        }

        return rows.filter(function(row){
          if (isAggregateKpiRow(row)) return false;
          return String((row && row[groupingHeader]) || '').trim().toLowerCase() !== 'all';
        });
      }

      function buildComputedKpiTotalRow(headers, rows){
        if (!rows.length) return null;

        var detailRows = rows.slice();

        var locationNames = detailRows
          .map(function(row){ return String(row['Location name'] || '').trim(); })
          .filter(Boolean)
          .filter(function(value, index, list){ return list.indexOf(value) === index; });

        var appointmentCount = 0;
        var serviceSales = 0;
        var tipSales = 0;
        var productSales = 0;
        var hoursBooked = 0;
        var hoursScheduled = 0;
        var weightedPrebooked = 0;

        detailRows.forEach(function(row){
          var rowAppointmentCount = parseNumericCell(row['Appointment Count']);
          var rowPrebookedRaw = parseNumericCell(row['Prebooked %']);
          var rowPrebooked = rowPrebookedRaw > 1 ? rowPrebookedRaw / 100 : rowPrebookedRaw;

          appointmentCount += rowAppointmentCount;
          serviceSales += parseNumericCell(row['Service Sales']);
          tipSales += parseNumericCell(row['Tip Sales']);
          productSales += parseNumericCell(row['Product Sales']);
          hoursBooked += parseNumericCell(row['Hours Booked']);
          hoursScheduled += parseNumericCell(row['Hours Scheduled']);
          weightedPrebooked += rowPrebooked * rowAppointmentCount;
        });

        var computed = {};
        headers.forEach(function(header){
          computed[header] = '';
        });

        computed['Location name'] = locationNames.length === 1 ? locationNames[0] : 'Computed Total';
        computed['Staff Name'] = 'Computed Total';
        if (headers.indexOf('Appointment Count') !== -1) {
          computed['Appointment Count'] = formatRawNumeric(appointmentCount);
        }
        if (headers.indexOf('Service Sales') !== -1) {
          computed['Service Sales'] = formatRawNumeric(serviceSales);
        }
        if (headers.indexOf('Tip Sales') !== -1) {
          computed['Tip Sales'] = formatRawNumeric(tipSales);
        }
        if (headers.indexOf('Product Sales') !== -1) {
          computed['Product Sales'] = formatRawNumeric(productSales);
        }
        if (headers.indexOf('Hours Booked') !== -1) {
          computed['Hours Booked'] = formatRawNumeric(hoursBooked);
        }
        if (headers.indexOf('Hours Scheduled') !== -1) {
          computed['Hours Scheduled'] = formatRawNumeric(hoursScheduled);
        }
        if (headers.indexOf('Prebooked %') !== -1) {
          computed['Prebooked %'] = appointmentCount > 0
            ? formatRawNumeric(weightedPrebooked / appointmentCount)
            : '0';
        }
        if (headers.indexOf('Utilization %') !== -1) {
          computed['Utilization %'] = hoursScheduled > 0
            ? formatRawNumeric(hoursBooked / hoursScheduled)
            : '0';
        }
        computed['Production Rate'] = hoursBooked > 0
          ? formatRawNumeric(serviceSales / hoursBooked)
          : '0';

        return computed;
      }

      function getWeekdayLabel(value){
        var text = value == null ? '' : String(value).trim();
        if (!text || text.toLowerCase() === 'all') return '';
        var parsed = new Date(text);
        if (isNaN(parsed.getTime())) return '';
        return parsed.toLocaleDateString(undefined, { weekday: 'short' });
      }

      function buildWeekdayUtilizationLines(rows, groupingHeader){
        if (!groupingHeader || !Array.isArray(rows) || !rows.length) return '';

        var weekdayOrder = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        var weekdayTotals = {};
        rows.forEach(function(row){
          var weekday = getWeekdayLabel(row[groupingHeader]);
          if (!weekday) return;

          if (!weekdayTotals[weekday]) {
            weekdayTotals[weekday] = {
              hoursBooked: 0,
              hoursScheduled: 0
            };
          }

          weekdayTotals[weekday].hoursBooked += parseNumericCell(row['Hours Booked']);
          weekdayTotals[weekday].hoursScheduled += parseNumericCell(row['Hours Scheduled']);
        });

        var labels = weekdayOrder
          .filter(function(weekday){
            return !!weekdayTotals[weekday];
          })
          .map(function(weekday){
            var totals = weekdayTotals[weekday];
            if (totals.hoursScheduled <= 0) {
              return weekday + ' Unscheduled';
            }
            return weekday + ' ' + formatNumericCell('Utilization %', String(totals.hoursBooked / totals.hoursScheduled));
          });

        return labels;
      }

      function buildExtremeDayLabels(rows, groupingHeader){
        if (!groupingHeader || !Array.isArray(rows) || !rows.length) {
          return { highestDayLabel: '', lowestDayLabel: '' };
        }

        var highestRow = null;
        var lowestRow = null;

        rows.forEach(function(row){
          var dateValue = String((row && row[groupingHeader]) || '').trim();
          if (!dateValue || dateValue.toLowerCase() === 'all') return;

          var serviceSales = parseNumericCell(row['Service Sales']);
          if (!highestRow || serviceSales > parseNumericCell(highestRow['Service Sales'])) {
            highestRow = row;
          }

          if (serviceSales <= 0) return;

          if (!lowestRow || serviceSales < parseNumericCell(lowestRow['Service Sales'])) {
            lowestRow = row;
          }
        });

        function formatDayLabel(prefix, row){
          if (!row) return '';
          var dateLabel = formatKpiDate(row[groupingHeader]);
          var salesLabel = formatNumericCell('Service Sales', row['Service Sales'] || '0');
          return prefix + ': ' + dateLabel + ' ' + salesLabel;
        }

        return {
          highestDayLabel: formatDayLabel('High', highestRow),
          lowestDayLabel: formatDayLabel('Low', lowestRow)
        };
      }

      function buildUnscheduledOpportunityLabel(rows, rangeDays){
        if (!Array.isArray(rows) || !rows.length) return '';

        var unscheduledDays = 0;
        var unscheduledHoursBooked = 0;
        var unscheduledSales = 0;
        var unscheduledAppointments = 0;
        var scheduledHours = 0;
        var scheduledBookedHours = 0;

        rows.forEach(function(row){
          var hoursScheduled = parseNumericCell(row['Hours Scheduled']);
          var hoursBooked = parseNumericCell(row['Hours Booked']);
          var appointmentCount = parseNumericCell(row['Appointment Count']);
          if (hoursScheduled > 0) {
            scheduledHours += hoursScheduled;
            scheduledBookedHours += hoursBooked;
            return;
          }
          if (hoursBooked <= 0) return;

          unscheduledDays += 1;
          unscheduledHoursBooked += hoursBooked;
          unscheduledSales += parseNumericCell(row['Service Sales']);
          unscheduledAppointments += appointmentCount;
        });

        if (!unscheduledDays) return '';
        var baselineUtilization = scheduledHours > 0 ? (scheduledBookedHours / scheduledHours) : 0;
        var unscheduledProduction = unscheduledHoursBooked > 0 ? (unscheduledSales / unscheduledHoursBooked) : 0;
        var normalizedRangeDays = Math.max(0, Number(rangeDays) || 0);
        var requiredUnscheduledDays = normalizedRangeDays
          ? Math.max(3, Math.ceil(normalizedRangeDays * 0.08))
          : 3;
        var requiredUnscheduledAppointments = normalizedRangeDays
          ? Math.max(8, Math.ceil(normalizedRangeDays * 0.2))
          : 8;
        var requiredBookedHours = normalizedRangeDays
          ? Math.max(6, Math.ceil(normalizedRangeDays * 0.12))
          : 6;
        var requiredSales = normalizedRangeDays
          ? Math.max(500, normalizedRangeDays * 15)
          : 500;
        var highUnscheduledDayCount = unscheduledDays >= requiredUnscheduledDays;
        var highUnscheduledAppointmentCount = unscheduledAppointments >= requiredUnscheduledAppointments;
        var meaningfulSupport = unscheduledHoursBooked >= requiredBookedHours || unscheduledSales >= requiredSales;
        var hasBaseline = scheduledHours > 0 && baselineUtilization >= 0.65;

        if (!(highUnscheduledDayCount && highUnscheduledAppointmentCount && meaningfulSupport)) return '';

        var reasonParts = [
          unscheduledDays + (normalizedRangeDays ? '/' + normalizedRangeDays : '') + ' unscheduled day' + (unscheduledDays === 1 ? '' : 's'),
          formatNumericCell('Appointment Count', String(unscheduledAppointments)) + ' appts',
          formatNumericCell('Hours Booked', String(unscheduledHoursBooked)) + ' booked',
          formatNumericCell('Service Sales', String(unscheduledSales))
        ];

        if (hasBaseline) {
          reasonParts.push('scheduled util ' + formatNumericCell('Utilization %', String(baselineUtilization)));
        }
        if (unscheduledProduction > 0) {
          reasonParts.push(formatNumericCell('Production Rate', String(unscheduledProduction)));
        }

        return 'Floor time recommendation: ' + reasonParts.join(' · ');
      }

      function buildSupportPatternLabel(rows, rangeDays){
        if (!Array.isArray(rows) || !rows.length) return '';

        var normalizedRangeDays = Math.max(0, Number(rangeDays) || 0);
        var activeBookingDays = 0;
        var appointmentCount = 0;
        var serviceSales = 0;
        var hoursBooked = 0;

        rows.forEach(function(row){
          var rowAppointments = parseNumericCell(row['Appointment Count']);
          var rowSales = parseNumericCell(row['Service Sales']);
          var rowHoursBooked = parseNumericCell(row['Hours Booked']);

          appointmentCount += rowAppointments;
          serviceSales += rowSales;
          hoursBooked += rowHoursBooked;

          if (rowAppointments > 0 || rowHoursBooked > 0 || rowSales > 0) {
            activeBookingDays += 1;
          }
        });

        var lowBookingDaysThreshold = normalizedRangeDays
          ? Math.max(4, Math.ceil(normalizedRangeDays * 0.1))
          : 4;
        var lowAppointmentsThreshold = normalizedRangeDays
          ? Math.max(10, Math.ceil(normalizedRangeDays * 0.18))
          : 10;
        var lowSalesThreshold = normalizedRangeDays
          ? Math.max(600, normalizedRangeDays * 12)
          : 600;
        var lowBookedHoursThreshold = normalizedRangeDays
          ? Math.max(10, Math.ceil(normalizedRangeDays * 0.2))
          : 10;

        var veryLowBookingDaysThreshold = normalizedRangeDays
          ? Math.max(2, Math.ceil(normalizedRangeDays * 0.06))
          : 2;
        var veryLowAppointmentsThreshold = normalizedRangeDays
          ? Math.max(4, Math.ceil(normalizedRangeDays * 0.08))
          : 4;
        var veryLowSalesThreshold = normalizedRangeDays
          ? Math.max(250, normalizedRangeDays * 5)
          : 250;

        if (
          activeBookingDays <= veryLowBookingDaysThreshold
          && appointmentCount <= veryLowAppointmentsThreshold
          && serviceSales <= veryLowSalesThreshold
        ) {
          return 'Likely support / non-producing role: '
            + activeBookingDays + (normalizedRangeDays ? '/' + normalizedRangeDays : '') + ' booking days'
            + ' · '
            + formatNumericCell('Appointment Count', String(appointmentCount)) + ' appts'
            + ' · '
            + formatNumericCell('Service Sales', String(serviceSales));
        }

        if (
          activeBookingDays <= lowBookingDaysThreshold
          && appointmentCount <= lowAppointmentsThreshold
          && serviceSales <= lowSalesThreshold
          && hoursBooked <= lowBookedHoursThreshold
        ) {
          return 'Support-staff pattern: '
            + activeBookingDays + (normalizedRangeDays ? '/' + normalizedRangeDays : '') + ' booking days'
            + ' · '
            + formatNumericCell('Appointment Count', String(appointmentCount)) + ' appts'
            + ' · '
            + formatNumericCell('Hours Booked', String(hoursBooked)) + ' booked';
        }

        return '';
      }

      function buildDisplayKpiRows(headers, rows){
        if (!Array.isArray(rows) || !rows.length) return [];

        var detailRows = selectKpiSummaryRows(headers, rows);

        if (!detailRows.length) {
          return rows.slice();
        }

        var computedTotalRow = buildComputedKpiTotalRow(headers, detailRows);
        return computedTotalRow ? [computedTotalRow].concat(detailRows) : detailRows;
      }

      function buildKpiStaffGroups(headers, rows){
        var groupingHeader = detectKpiGroupingHeader(headers, rows);
        if (!groupingHeader) return null;
        var selectedRangeDays = getSelectedRangeDays();

        var detailRows = selectKpiSummaryRows(headers, rows);
        if (!detailRows.length) return null;

        var order = [];
        var grouped = {};

        detailRows.forEach(function(row){
          var staffName = String((row && row['Staff Name']) || '').trim();
          if (!staffName) return;
          if (!grouped[staffName]) {
            grouped[staffName] = [];
            order.push(staffName);
          }
          grouped[staffName].push(row);
        });

        var totalRow = buildComputedKpiTotalRow(headers, detailRows);
        return {
          groupingHeader: groupingHeader,
          totalRow: totalRow,
          companyServiceSales: parseNumericCell(totalRow && totalRow['Service Sales']),
          groups: order.map(function(staffName){
            var staffRows = grouped[staffName];
            var summaryRow = buildComputedKpiTotalRow(headers, staffRows) || {};
            var extremeDayLabels = buildExtremeDayLabels(staffRows, groupingHeader);
            summaryRow['Staff Name'] = staffName;
            if (groupingHeader) {
              summaryRow[groupingHeader] = 'All';
            }
            return {
              staffName: staffName,
              summaryRow: summaryRow,
              rows: staffRows,
              weekdayUtilizationLines: buildWeekdayUtilizationLines(staffRows, groupingHeader),
              highestDayLabel: extremeDayLabels.highestDayLabel,
              lowestDayLabel: extremeDayLabels.lowestDayLabel,
              unscheduledOpportunityLabel: buildUnscheduledOpportunityLabel(staffRows, selectedRangeDays),
              supportPatternLabel: buildSupportPatternLabel(staffRows, selectedRangeDays)
            };
          })
        };
      }

      function getDisplayedKpiHeaders(headers){
        var displayed = headers.filter(function(header){
          var normalized = String(header || '').toLowerCase();
          return normalized !== 'location name'
            && normalized !== 'appointment count'
            && normalized !== 'tip sales';
        });

        if (displayed.indexOf('Production Rate') === -1) {
          var insertIndex = displayed.indexOf('Service Sales');
          if (insertIndex === -1) {
            displayed.push('Production Rate');
          } else {
            displayed.splice(insertIndex + 1, 0, 'Production Rate');
          }
        }

        return displayed;
      }

      function getKpiDisplayValue(header, row){
        if (header === 'Utilization %') {
          var hoursBooked = parseNumericCell(row['Hours Booked']);
          var hoursScheduled = parseNumericCell(row['Hours Scheduled']);
          if (hoursScheduled <= 0 && hoursBooked > 0) {
            return '__UNSCHEDULED__';
          }
          return hoursScheduled > 0 ? String(hoursBooked / hoursScheduled) : '0';
        }
        if (header === 'Production Rate') {
          var serviceSales = parseNumericCell(row['Service Sales']);
          var hoursBooked = parseNumericCell(row['Hours Booked']);
          return hoursBooked > 0 ? String(serviceSales / hoursBooked) : '0';
        }
        return row[header];
      }

      function renderKpiDataRow(headers, row){
        return '<tr>'
          + headers.map(function(header){
              var formatted = formatNumericCell(header, getKpiDisplayValue(header, row));
              var cellClass = /sales|tips?|hours?|count|percent|%/i.test(header) ? 'count' : '';
              return '<td class="' + cellClass + '">' + escapeHtml(formatted) + '</td>';
            }).join('')
          + '</tr>';
      }

      function renderKpiTableMarkup(headers, rows){
        var displayedHeaders = getDisplayedKpiHeaders(headers);
        return ''
          + '<table>'
          +   '<thead><tr>'
          +   displayedHeaders.map(function(header){
                return '<th>' + escapeHtml(header) + '</th>';
              }).join('')
          +   '</tr></thead>'
          +   '<tbody>'
          +   rows.map(function(row){
                return renderKpiDataRow(displayedHeaders, row);
              }).join('')
          +   '</tbody>'
          + '</table>';
      }

      function renderSummaryLine(label, value, extraClass){
        if (!value) return '';
        var labelMarkup = label
          ? '<span class="kpi-summary-label">' + escapeHtml(label) + '</span>'
          : '';
        return ''
          + '<span class="kpi-summary-line' + (extraClass ? ' ' + extraClass : '') + '">'
          +   labelMarkup
          +   '<span class="kpi-summary-value">' + escapeHtml(value) + '</span>'
          + '</span>';
      }

      function getReliabilityScoreLabel(staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName) return '100.0%';
        var score = reliabilityScoreByStaff[normalizedName];
        var numeric = score == null ? 100 : Number(score);
        if (!isFinite(numeric)) numeric = 100;
        return numeric.toFixed(1) + '%';
      }

      function getStaffAttendanceCount(map, staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName) return 0;
        var value = map && map[normalizedName];
        var numeric = Number(value);
        return isFinite(numeric) ? numeric : 0;
      }

      function renderReliabilityDetailLines(staffName){
        return ''
          + renderSummaryLine('Requests off', String(getStaffAttendanceCount(requestsOffByStaff, staffName)))
          + renderSummaryLine('Callouts', String(getStaffAttendanceCount(callOutsByStaff, staffName)))
          + renderSummaryLine('Late arrivals', String(getStaffAttendanceCount(lateArrivalsByStaff, staffName)));
      }

      function getStaffGrowthYtdSummaryOverride(staffName){
        var snapshotKey = resolveStaffKpiSnapshotKey(dateFrom.value || '', dateTo.value || '');
        if (snapshotKey !== 'staff_kpi_ytd') return null;
        if (!staffGrowthDataset || !staffGrowthDataset.byStaff) return null;

        var normalizedName = String(staffName || '').trim();
        if (!normalizedName) return null;

        var currentYear = String(startOfLocalDay(new Date()).getFullYear());
        var staffRows = staffGrowthDataset.byStaff[normalizedName];
        if (!Array.isArray(staffRows) || !staffRows.length) return null;

        var ytdRow = staffRows.find(function(row){
          return row && String(row.year || '') === currentYear && row.isYtd;
        });
        if (!ytdRow) return null;

        return {
          'Appointment Count': String(ytdRow.appointmentCount || 0),
          'Service Sales': String(ytdRow.serviceSales || 0),
          'Product Sales': String(ytdRow.productSales || 0),
          'Tip Sales': String(ytdRow.tipSales || 0),
          'Hours Booked': String(ytdRow.hoursBooked || 0),
          'Hours Scheduled': String(ytdRow.hoursScheduled || 0),
          'Prebooked %': String(ytdRow.prebookedRate || 0),
          'Utilization %': String(ytdRow.utilizationRate || 0)
        };
      }

      function getLevelLabel(staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName) return '';
        return levelByStaff[normalizedName] || '';
      }

      function getAvatarUrl(staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName) return '';
        return avatarByStaff[normalizedName] || '';
      }

      function getInitials(name){
        return String(name || '')
          .trim()
          .split(/\s+/)
          .slice(0, 2)
          .map(function(part){ return part.charAt(0).toUpperCase(); })
          .join('') || 'S';
      }

      function extractLevelFromRecord(record){
        if (!record || typeof record !== 'object') return '';

        var candidates = [
          record.role_name,
          record.roleName,
          record.staff_role_name,
          record.staffRoleName,
          record['Role Name'],
          record['role_name'],
          record['role name'],
          record['Staff Role Name'],
          record['staff_role_name'],
          record['staff role name'],
          record.level,
          record.Level,
          record['Staff Level'],
          record['staff level']
        ];

        for (var index = 0; index < candidates.length; index += 1) {
          var value = String(candidates[index] || '').trim();
          if (value) return value;
        }

        return '';
      }

      async function createKpiExport(){
        var filterConfig = buildKpiReportFilters();
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'create-report-export',
            report_id: KPI_REPORT_ID,
            file_content_type: 'CSV',
            frequency: 'ONCE',
            report_filters: filterConfig.report_filters
          })
        });
        var data = await response.json().catch(function(){ return null; });
        if (!response.ok || !data || !data.ok || !data.report_export) {
          throw new Error((data && data.error) || 'Could not create raw KPI export.');
        }
        return {
          report_export: data.report_export,
          filter_config: filterConfig
        };
      }

      async function fetchStaffDirectoryInfo(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-directory-derived',
            force_refresh: false
          })
        });
        var data = await response.json().catch(function(){ return null; });
        if (!response.ok || !data || !data.ok) {
          return {};
        }

        return Array.isArray(data.staff)
          ? data.staff.reduce(function(map, member){
              var staffName = String((member && member.name) || '').trim();
              var roleName = String((member && member.role) || '').trim();
              var avatar = String((member && member.avatar) || '').trim();
              if (staffName && !map[staffName]) {
                map[staffName] = {
                  role: roleName,
                  avatar: avatar
                };
              }
              return map;
            }, {})
          : {};
      }

      async function fetchRequestOffFormOptions(){
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'staff-request-off-form-options'
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not load staff request-off options.');
          }
          return Array.isArray(data.staff) ? data.staff : [];
        } catch (_error) {
          var mergedMap = {};
          async function readStaffAction(action){
            var response = await fetch(REPORT_PROXY_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ action: action })
            });
            var rawText = await response.text();
            var data = null;
            try {
              data = rawText ? JSON.parse(rawText) : null;
            } catch (_error) {
              data = null;
            }
            if (!response.ok || !data || !data.ok || !Array.isArray(data.staff)) {
              return [];
            }
            return data.staff;
          }

          var directStaff = await readStaffAction('staff-directory');
          var derivedStaff = await readStaffAction('staff-directory-derived');
          directStaff.concat(derivedStaff).forEach(function(member){
            var staffName = String((member && member.name) || '').trim();
            if (!staffName) return;
            if (!mergedMap[staffName]) {
              mergedMap[staffName] = {
                name: staffName,
                role: String((member && member.role) || '').trim(),
                avatar: String((member && member.avatar) || '').trim()
              };
              return;
            }
            if (!mergedMap[staffName].role) {
              mergedMap[staffName].role = String((member && member.role) || '').trim();
            }
            if (!mergedMap[staffName].avatar) {
              mergedMap[staffName].avatar = String((member && member.avatar) || '').trim();
            }
          });

          return Object.keys(mergedMap).sort(function(a, b){
            var roleA = String((mergedMap[a] && mergedMap[a].role) || '').trim();
            var roleB = String((mergedMap[b] && mergedMap[b].role) || '').trim();
            var roleCompare = roleA.localeCompare(roleB);
            if (roleCompare !== 0) return roleCompare;
            return a.localeCompare(b);
          }).map(function(staffName){
            var item = mergedMap[staffName] || {};
            return {
              id: staffName,
              name: staffName,
              role: String(item.role || '').trim(),
              avatar: String(item.avatar || '').trim(),
              display_label: [staffName, String(item.role || '').trim() || 'Salon Team'].filter(Boolean).join(' · ')
            };
          });
        }
      }

      function renderRequestOffSelectedStaff(){
        if (!requestOffStaff || !requestOffMeta) return;
        var selectedId = String(requestOffStaff.value || '');
        var selected = requestOffStaffOptions.find(function(option){
          return String(option.id || '') === selectedId;
        }) || null;

        if (!selected) {
          requestOffMeta.innerHTML = ''
            + '<div class="request-off-meta-name">No staff selected</div>'
            + '<div class="request-off-meta-copy">Choose a staff member, date, and coverage size before sending the request-off text.</div>';
          return;
        }

        var selectedDate = String(requestOffDate && requestOffDate.value || '').trim();
        var details = buildRequestOffScopeDetails(selectedId, selectedDate, selected && selected.name);
        var scopeLabel = getRequestOffScopeOptionLabel(requestOffScope && requestOffScope.value, details);
        var shiftLabel = String(details && details.shiftLabel || '').trim();
        if (!selectedDate) {
          requestOffMeta.innerHTML = ''
            + '<div class="request-off-meta-name">' + escapeHtml(selected.name || '') + '</div>'
            + '<div class="request-off-meta-copy">Pick the date to see that day\'s shift and exact half-shift split.</div>';
          return;
        }
        if (!shiftLabel || shiftLabel === 'OFF') {
          requestOffMeta.innerHTML = ''
            + '<div class="request-off-meta-name">' + escapeHtml(selected.name || '') + '</div>'
            + '<div class="request-off-meta-copy">No regular shift is scheduled that day. You can still request the full day off.</div>';
          return;
        }
        if (!canStaffRequestPartialShift(selected && selected.role, selected && selected.name)) {
          requestOffMeta.innerHTML = ''
            + '<div class="request-off-meta-name">' + escapeHtml(selected.name || '') + ' · ' + escapeHtml(shiftLabel) + '</div>'
            + '<div class="request-off-meta-copy">Only level 4 and above can request part of a shift. You can still request the full day off here.</div>';
          return;
        }
        requestOffMeta.innerHTML = ''
          + '<div class="request-off-meta-name">' + escapeHtml(selected.name || '') + ' · ' + escapeHtml(shiftLabel) + '</div>'
          + '<div class="request-off-meta-copy">' + escapeHtml(scopeLabel) + ' will be sent for review.</div>';
      }

      function populateRequestOffStaffOptions(options){
        requestOffStaffOptions = Array.isArray(options) ? options.slice() : [];
        requestOffRoleOptions = getUniqueRoleOptionsFromStaffOptions(requestOffStaffOptions);
        if (requestOffStaff) {
          requestOffStaff.innerHTML = ''
            + '<option value="">Choose staff</option>'
            + requestOffStaffOptions.filter(function(option){
                return String((option && option.name) || '').trim().toLowerCase() !== 'chase ognibene';
              }).map(function(option){
                return '<option value="' + escapeHtml(option.id || '') + '">' + escapeHtml(option.display_label || option.name || '') + '</option>';
              }).join('');
        }
        renderRequestOffSelectedStaff();
        syncRequestOffScopeOptions();
        populateMasterScheduleStaffOptions(requestOffStaffOptions);
        renderRoleChecklist(manualOpenShiftRoleChecklist, [], function(){ return ''; });
      }

      async function submitRequestOffForm(){
        var selectedId = String(requestOffStaff.value || '');
        var selected = requestOffStaffOptions.find(function(option){
          return String(option.id || '') === selectedId;
        }) || null;
        var notifyPhones = REQUEST_OFF_NOTIFY_PHONES.slice();
        var staffPhoneLast4 = String((requestOffPhoneLast4 && requestOffPhoneLast4.value) || '').replace(/\D+/g, '').slice(-4);

        if (!selected) {
          throw new Error('Choose a staff member first.');
        }
        if (!requestOffDate.value) {
          throw new Error('Choose a requested date first.');
        }
        if (!notifyPhones.length) {
          throw new Error('Missing hardcoded notify phones.');
        }
        if (staffPhoneLast4.length !== 4) {
          throw new Error('Enter the last 4 digits of your phone number on file.');
        }

        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-request-off-submit',
            staff_id: selected.id || '',
            staff_name: selected.name || '',
            role_name: selected.role || '',
            requested_date: requestOffDate.value,
            request_scope: normalizeRequestOffScope(requestOffScope && requestOffScope.value),
            note: requestOffNote.value || '',
            notify_phone: notifyPhones,
            staff_phone_last4: staffPhoneLast4
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not submit request off.');
        }
        return data;
      }

      async function initializeRequestOffForm(){
        try {
          setRequestOffStatus('Loading staff options...');
          setRequestReviewStatus('Loading request queue...');
          setOpenShiftStatus('Loading open shifts...');
          setPickupQueueStatus('Loading pickup requests...');
          setMasterScheduleStatus('Loading staff for master schedule...');
          var results = await Promise.allSettled([
            fetchRequestOffFormOptions(),
            fetchMasterScheduleAssignments(),
            fetchRequestOffQueue(),
            loadRequestQueueAttendanceMetrics(),
            fetchShiftChangeQueue()
          ]);
          var optionsResult = results[0];
          var masterScheduleResult = results[1];
          var queueResult = results[2];
          var queueMetricsResult = results[3];
          var shiftQueueResult = results[4];

          if (!optionsResult || optionsResult.status !== 'fulfilled') {
            throw (optionsResult && optionsResult.reason) || new Error('Could not load staff request-off options.');
          }
          if (!masterScheduleResult || masterScheduleResult.status !== 'fulfilled') {
            throw (masterScheduleResult && masterScheduleResult.reason) || new Error('Could not load staff for the master schedule.');
          }
          if (!queueResult || queueResult.status !== 'fulfilled') {
            throw (queueResult && queueResult.reason) || new Error('Could not load request queue.');
          }
          if (!shiftQueueResult || shiftQueueResult.status !== 'fulfilled') {
            throw (shiftQueueResult && shiftQueueResult.reason) || new Error('Could not load shift change queue.');
          }

          var options = optionsResult.value;
          masterScheduleAssignments = masterScheduleResult.value || {};
          requestOffQueue = queueResult.value || [];
          shiftChangeQueue = shiftQueueResult.value || [];
          populateRequestOffStaffOptions(options);
          renderRequestOffQueue();
          renderOpenShiftView();
          renderManualOpenShiftShiftOptions();
          setRequestOffStatus('Ready to submit a request off.');
          syncRequestOffScopeOptions();
          setRequestReviewStatus(
            queueMetricsResult && queueMetricsResult.status === 'fulfilled'
              ? 'Review pending requests below. Staff attendance snapshot covers the last 365 days.'
              : 'Review pending requests below. Staff attendance snapshot could not be loaded.',
            queueMetricsResult && queueMetricsResult.status === 'fulfilled' ? '' : 'error'
          );
          setOpenShiftStatus('Posted available shifts and approved pickups are organized below.');
          setPickupQueueStatus('Pending pickup requests appear here for manager review.');
          setMasterScheduleStatus('Ready to edit recurring shifts.');
        } catch (error) {
          setRequestOffStatus(humanizeClientFetchErrorMessage(error, 'Could not load staff request-off options.'), 'error');
          setRequestReviewStatus(humanizeClientFetchErrorMessage(error, 'Could not load request queue.'), 'error');
          setOpenShiftStatus(humanizeClientFetchErrorMessage(error, 'Could not load open shifts.'), 'error');
          setPickupQueueStatus(humanizeClientFetchErrorMessage(error, 'Could not load pickup queue.'), 'error');
          setMasterScheduleStatus('Could not load staff for the master schedule.');
        }
      }

      function setProgressionStatus(text, tone){
        if (!progressionStatus) return;
        progressionStatus.textContent = String(text || '');
        progressionStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function normalizeProgressionKey(value){
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '');
      }

      function isProgressionToggleValue(value){
        var normalized = String(value || '').trim().toUpperCase();
        return normalized === 'YES' || normalized === 'NO';
      }

      function isProgressionThresholdKey(key){
        return /_threshold(?:_|$)/i.test(String(key || ''));
      }

      function isProgressionFocusMarkerKey(key){
        var normalized = normalizeProgressionKey(key);
        return normalized === 'focus_area' || normalized === 'group';
      }

      function formatProgressionLabel(key){
        var normalized = normalizeProgressionKey(key);
        if (!normalized) return '';
        return normalized
          .replace(/^to_level_(\d+)$/, 'To Level $1')
          .replace(/^level_(\d+)_ongoing$/, 'Level $1 Ongoing')
          .replace(/_/g, ' ')
          .replace(/\b\w/g, function(match){ return match.toUpperCase(); });
      }

      var PROGRESSION_FOCUS_AREA_LABELS = {
        staff_page: 'Operations',
        clocking_in: 'Operations',
        station_reset: 'Operations',
        clean_cape_standard: 'Operations',
        towel_rollup_standard: 'Operations',
        chair_area_cleanliness: 'Operations',
        product_organization: 'Operations',
        towel_bin_management: 'Operations',
        laundry_procedures: 'Operations',
        clean_cape_storage: 'Operations',
        dish_station_organization: 'Operations',
        schedule_reading: 'Floor Awareness',
        appointment_status_awareness: 'Floor Awareness',
        service_finish_awareness: 'Floor Awareness',
        client_transfer_awareness: 'Floor Awareness',
        late_client_identification: 'Floor Awareness',
        running_behind_communication: 'Communication',
        front_desk_communication: 'Communication',
        understand_kp_vs_color_touch: 'Color Knowledge',
        glaze_formula_knowledge: 'Color Knowledge',
        color_formula_awareness: 'Color Knowledge',
        understand_service_being_applied: 'Color Knowledge',
        brush_from_ends: 'Prep and Detangling',
        detangle_around_ears: 'Prep and Detangling',
        extension_detangling: 'Prep and Detangling',
        proper_parting: 'Prep and Detangling',
        brushing_detangling: 'Prep and Detangling',
        foil_cutting: 'Foil Work',
        foil_separation: 'Foil Work',
        foil_stack_quality: 'Foil Work',
        foil_takedown: 'Foil Work',
        caping: 'Guest Setup',
        preguard: 'Guest Setup',
        client_prep: 'Guest Setup',
        greet_and_seat: 'Guest Setup',
        service_flow: 'Guest Experience',
        timing_handoffs: 'Guest Experience',
        guest_flow: 'Guest Experience',
        timer_management: 'Guest Experience',
        shampoo_products: 'Shampoo',
        shampoo_client_needs: 'Shampoo',
        shampoo_cleanse_rinse: 'Shampoo',
        shampoo_detangle: 'Shampoo',
        shampoo_remove_residue: 'Shampoo',
        shampoo_reset_sink: 'Shampoo',
        formula_retention: 'Color Formulation',
        bowl_labeling: 'Color Formulation',
        mixing_lightener: 'Color Formulation',
        mixing_glaze: 'Color Formulation',
        mixing_single_process: 'Color Formulation',
        understand_levels: 'Color Technique',
        rinsing_technique: 'Color Technique',
        shampoo_after_color: 'Color Technique',
        glaze_prep: 'Color Technique',
        follow_direction: 'Color Technique',
        short_shadow: 'Color Technique',
        long_shadow: 'Color Technique',
        hairline_sectioning: 'Color Technique',
        booked_model_blowdry: 'Blowdry',
        consult_to_finish_blowdry: 'Blowdry',
        product_selection: 'Blowdry',
        sectioning: 'Blowdry',
        timing: 'Blowdry',
        polish: 'Blowdry',
        finishing_standard: 'Blowdry',
        beyond_blowdry_consistency: 'Service Standards',
        haircut_standard: 'Service Standards',
        single_process_standard: 'Service Standards',
        independent_service_standard: 'Service Standards',
        hairstories_core_values: 'Leadership and Culture',
        all_assistant_days_traded_out: 'Business Readiness',
        retention_rebooking: 'Business Readiness',
        independent_operation: 'Business Readiness',
        professionalism_timing_quality: 'Leadership and Culture',
        operational_value: 'Leadership and Culture',
        advanced_consistency: 'Leadership and Culture',
        leadership_presence: 'Leadership and Culture',
        culture_support: 'Leadership and Culture',
        mentorship_visibility: 'Leadership and Culture',
        management_invitation: 'Leadership and Culture',
        point_of_difference_confidence: 'Brand and Positioning',
        unique_client_experience: 'Brand and Positioning',
        articulate_value: 'Brand and Positioning',
        staff_presentation_completed: 'Brand and Positioning',
        culture_fit: 'Leadership and Culture'
      };

      function getProgressionFocusArea(key){
        var normalized = normalizeProgressionKey(key);
        if (!normalized) return 'General';
        if (PROGRESSION_FOCUS_AREA_LABELS[normalized]) {
          return PROGRESSION_FOCUS_AREA_LABELS[normalized];
        }
        if (/^(single_process_|mixing_|formula_|glaze_)/.test(normalized)) {
          return 'Color Formulation';
        }
        if (/^shampoo_/.test(normalized)) {
          return 'Shampoo';
        }
        if (/^foil_/.test(normalized)) {
          return 'Foil Work';
        }
        if (/_threshold(?:_|$)/.test(normalized)) {
          return 'Benchmarks';
        }
        return 'General';
      }

      function groupProgressionItemsByFocusArea(items){
        var groups = [];
        (Array.isArray(items) ? items : []).forEach(function(item){
          if (!item) return;
          var focusArea = String(item.focus_area || '').trim() || getProgressionFocusArea(item.key);
          var existing = groups.find(function(group){
            return group && group.label === focusArea;
          });
          if (!existing) {
            existing = {
              label: focusArea,
              items: []
            };
            groups.push(existing);
          }
          existing.items.push(item);
        });
        return groups;
      }

      function parseProgressionBio(value){
        var raw = String(value || '');
        var lines = raw.split(/\n+/);
        var sections = [];
        var currentSection = null;

        function ensureSection(sectionKey){
          var normalized = normalizeProgressionKey(sectionKey);
          if (!normalized) return null;
          var existing = sections.find(function(section){
            return section.key === normalized;
          });
          if (existing) return existing;
          var created = {
            key: normalized,
            title: formatProgressionLabel(normalized),
            items: []
          };
          sections.push(created);
          return created;
        }

        lines.forEach(function(line){
          String(line || '').split(',').forEach(function(segment){
            var part = String(segment || '').trim();
            if (!part) return;
            var sectionMatch = part.match(/^(to_level_\d+|level_\d+_ongoing)\s*:\s*$/i);
            if (sectionMatch) {
              currentSection = ensureSection(sectionMatch[1]);
              return;
            }
            var matched = part.match(/^([^:=]+)\s*[:=]\s*(.+)$/);
            if (!matched) return;
            if (!currentSection) {
              currentSection = ensureSection('ungrouped');
            }
            var key = normalizeProgressionKey(matched[1]);
            var rawValue = String(matched[2] || '').trim();
            if (!key) return;
            if (isProgressionFocusMarkerKey(key)) {
              currentSection.currentFocusArea = rawValue || '';
              return;
            }
            currentSection.items.push({
              key: key,
              label: formatProgressionLabel(key),
              value: rawValue,
              kind: isProgressionToggleValue(rawValue) ? 'toggle' : 'value',
              focus_area: String(currentSection.currentFocusArea || '').trim()
            });
          });
        });

        return {
          raw: raw,
          sections: sections
        };
      }

      function cloneProgressionDraft(draft){
        return {
          raw: String((draft && draft.raw) || ''),
          sections: Array.isArray(draft && draft.sections)
            ? draft.sections.map(function(section){
                return {
                  key: section.key,
                  title: section.title,
                  items: Array.isArray(section.items) ? section.items.map(function(item){
                  return {
                      key: item.key,
                      label: item.label,
                      value: item.value,
                      kind: item.kind,
                      requirement_id: String(item.requirement_id || '').trim(),
                      focus_area: String(item.focus_area || '').trim(),
                      source_level: item.source_level,
                      target_level: item.target_level,
                      signoff_required: item.signoff_required === true,
                      signed_off_by: String(item.signed_off_by || '').trim(),
                      signed_off_at: String(item.signed_off_at || '').trim(),
                      training_status: String(item.training_status || '').trim(),
                      audit_status: String(item.audit_status || '').trim(),
                      audit_requested_at: String(item.audit_requested_at || '').trim(),
                      audit_requested_by: String(item.audit_requested_by || '').trim(),
                      audit_request_note: String(item.audit_request_note || '').trim(),
                      audit_reviewed_at: String(item.audit_reviewed_at || '').trim(),
                      audit_reviewed_by: String(item.audit_reviewed_by || '').trim(),
                      audit_review_note: String(item.audit_review_note || '').trim()
                    };
                  }) : []
                };
              })
            : []
        };
      }

      function buildProgressionBioFromDraft(draft){
        var sections = Array.isArray(draft && draft.sections) ? draft.sections : [];
        return sections.map(function(section){
          var lines = [section.key + ':'];
          var lastFocusArea = '';
          (Array.isArray(section.items) ? section.items : []).forEach(function(item){
            var focusArea = String(item && item.focus_area || '').trim();
            if (focusArea && focusArea !== lastFocusArea) {
              lines.push('focus_area=' + focusArea + ',');
              lastFocusArea = focusArea;
            }
            lines.push(item.key + '=' + String(item.value || '') + ',');
          });
          return lines.join('\n');
        }).join('\n\n').trim();
      }

      function updateProgressionSaveButton(){
        if (!progressionSaveBtn) return;
        var canSave = !!(progressionSelectedStaff && progressionDraft && hasProgressionEditorAccess());
        var currentBio = canSave ? buildProgressionBioFromDraft(progressionDraft) : '';
        var roleChanged = String(progressionSelectedRoleId || '') !== String(progressionOriginalRoleId || '');
        progressionSaveBtn.disabled = !canSave || (currentBio === progressionOriginalBio && !roleChanged);
      }

      function formatSignedOffAt(value){
        var raw = String(value || '').trim();
        if (!raw) return '';
        var parsed = new Date(raw);
        if (Number.isNaN(parsed.getTime())) return raw;
        return parsed.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      function getProgressionSectionByKey(draft, sectionKey){
        var normalizedSection = normalizeProgressionKey(sectionKey);
        var sections = Array.isArray(draft && draft.sections) ? draft.sections : [];
        return sections.find(function(section){
          return section && normalizeProgressionKey(section.key) === normalizedSection;
        }) || null;
      }

      function summarizeProgressionDraft(profile, draft){
        var normalizedProfile = profile && typeof profile === 'object' ? profile : {};
        var currentLevel = Number(normalizedProfile.current_level);
        var targetLevel = Number(normalizedProfile.target_level);
        var roleTrack = String(normalizedProfile.role_track || '').trim() || 'assistant';
        var sections = Array.isArray(draft && draft.sections) ? draft.sections : [];
        var allToggleItems = [];
        sections.forEach(function(section){
          (Array.isArray(section && section.items) ? section.items : []).forEach(function(item){
            if (item && item.kind === 'toggle') {
              allToggleItems.push(item);
            }
          });
        });
        var metOverall = allToggleItems.filter(function(item){
          return String(item.value || '').trim().toUpperCase() === 'YES';
        }).length;
        var overallTotal = allToggleItems.length;
        var targetSection = Number.isFinite(targetLevel) ? getProgressionSectionByKey(draft, 'to_level_' + String(targetLevel)) : null;
        var targetItems = Array.isArray(targetSection && targetSection.items) ? targetSection.items.filter(function(item){
          return item && item.kind === 'toggle';
        }) : [];
        var targetBenchmarkItems = Array.isArray(targetSection && targetSection.items) ? targetSection.items.filter(function(item){
          return item && item.kind !== 'toggle';
        }) : [];
        var metTarget = targetItems.filter(function(item){
          return String(item.value || '').trim().toUpperCase() === 'YES';
        }).length;
        var completionPercent = targetItems.length ? Math.round((metTarget / targetItems.length) * 100) : 0;
        var nextFocusArea = 'Ready for review';
        if (targetItems.length) {
          var grouped = groupProgressionItemsByFocusArea(targetItems);
          var nextGroup = grouped.find(function(group){
            return (group.items || []).some(function(item){
              return String(item.value || '').trim().toUpperCase() !== 'YES';
            });
          });
          if (nextGroup && nextGroup.label) {
            nextFocusArea = nextGroup.label;
          }
        } else if (!Number.isFinite(targetLevel)) {
          nextFocusArea = 'Not mapped yet';
        }

        return {
          currentLevel: Number.isFinite(currentLevel) ? currentLevel : null,
          targetLevel: Number.isFinite(targetLevel) ? targetLevel : null,
          roleTrack: roleTrack,
          overallMet: metOverall,
          overallTotal: overallTotal,
          targetMet: metTarget,
          targetTotal: targetItems.length,
          targetBenchmarks: targetBenchmarkItems,
          completionPercent: completionPercent,
          nextFocusArea: nextFocusArea
        };
      }

      function renderProgressionSummary(){
        return;
      }

      function setProgressionAuditQueueStatus(text, tone){
        if (!progressionAuditQueueStatus) return;
        progressionAuditQueueStatus.textContent = String(text || '');
        progressionAuditQueueStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function renderProgressionAuditQueue(){
        if (!progressionAuditQueueList) return;
        setTabCount(progressionAuditTabCount, progressionAuditQueue.length);
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id || !currentProgressionEditorPermission || currentProgressionEditorPermission.can_sign_off !== true) {
          progressionAuditQueueList.innerHTML = '<div class="request-review-empty">Unlock progression editor with signoff access to review checkpoint audits.</div>';
          setProgressionAuditQueueStatus('Unlock progression editor to review audit requests.');
          return;
        }
        if (!progressionAuditQueue.length) {
          progressionAuditQueueList.innerHTML = '<div class="request-review-empty">No pending checkpoint audit requests right now.</div>';
          setProgressionAuditQueueStatus('No pending checkpoint audit requests right now.', 'success');
          return;
        }
        progressionAuditQueueList.innerHTML = progressionAuditQueue.map(function(row){
          var progressId = String((row && row.id) || '').trim();
          var requestedAt = String((row && row.requested_at) || '').trim();
          var requestedOn = requestedAt ? formatSignedOffAt(requestedAt) : '';
          var sourceLevel = Number((row && row.source_level));
          var targetLevel = Number((row && row.target_level));
          var levelMove = 'Level ' + String(isFinite(sourceLevel) ? sourceLevel : '?') + ' to ' + String(isFinite(targetLevel) ? targetLevel : '?');
          return ''
            + '<article class="request-review-card" data-status="pending">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
            +       '<div class="request-review-name">' + escapeHtml(String((row && row.staff_name) || '').trim() || 'Staff member') + '</div>'
            +       '<div class="request-review-dates">' + escapeHtml(String((row && row.label) || '').trim() || 'Checkpoint audit request') + '</div>'
            +       '<div class="request-review-roleLine"><span class="request-review-label">Focus</span><span>' + escapeHtml(String((row && row.focus_area) || '').trim() || 'General') + '</span></div>'
            +       '<div class="request-review-meta">'
            +         '<div>' + escapeHtml(levelMove) + '</div>'
            +         (((row && row.requested_by) || requestedOn) ? '<div>' + escapeHtml([row && row.requested_by ? 'Requested by ' + String(row.requested_by).trim() : '', requestedOn ? 'on ' + requestedOn : ''].filter(Boolean).join(' ')) + '</div>' : '')
            +         (row && row.request_note ? '<div>Note: ' + escapeHtml(String(row.request_note || '').trim()) + '</div>' : '')
            +       '</div>'
            +     '</div>'
            +     '<div class="request-review-side">'
            +       '<span class="request-review-badge" data-status="pending">audit</span>'
            +       '<div class="request-review-actions">'
            +         '<button class="btn-primary" type="button" data-progression-audit-review="approve" data-progress-id="' + escapeHtml(progressId) + '">Approve</button>'
            +         '<button class="btn-secondary" type="button" data-progression-audit-review="deny" data-progress-id="' + escapeHtml(progressId) + '">Deny</button>'
            +       '</div>'
            +     '</div>'
            +   '</div>'
            +   '<div class="progression-audit-feedback">'
            +     '<label class="progression-audit-feedbackLabel" for="progressionAuditFeedback-' + escapeHtml(progressId) + '">Manager feedback</label>'
            +     '<textarea class="progression-audit-feedbackInput" id="progressionAuditFeedback-' + escapeHtml(progressId) + '" rows="3" placeholder="Share what still needs work before this checkpoint can be signed off." data-progression-audit-note="' + escapeHtml(progressId) + '"></textarea>'
            +   '</div>'
            + '</article>';
        }).join('');
        setProgressionAuditQueueStatus(String(progressionAuditQueue.length) + ' checkpoint audit request' + (progressionAuditQueue.length === 1 ? '' : 's') + ' need review.');
      }

      function renderProgressionEditor(){
        if (!progressionEditorMount) return;
        if (!progressionSelectedStaff) {
          progressionEditorMount.innerHTML = '<div class="empty">Choose a stylist to load progression checkpoints.</div>';
          if (progressionBioPreview) progressionBioPreview.textContent = 'No progression map loaded.';
          renderProgressionSummary();
          updateProgressionSaveButton();
          return;
        }

        var draft = progressionDraft || { sections: [] };
        var sections = Array.isArray(draft.sections) ? draft.sections : [];
        var currentBio = buildProgressionBioFromDraft(draft);
        if (progressionBioPreview) {
          progressionBioPreview.textContent = currentBio || 'No progression map loaded.';
        }

        if (!sections.length) {
          progressionEditorMount.innerHTML = '<div class="empty">No progression sections were found in this bio field yet.</div>';
          renderProgressionSummary();
          updateProgressionSaveButton();
          return;
        }

        progressionEditorMount.innerHTML = sections.map(function(section){
          var items = Array.isArray(section.items) ? section.items : [];
          var canEditSection = canEditProgressionSection(section.key);
          var toggleCount = items.filter(function(item){
            return item && item.kind === 'toggle';
          }).length;
          var sectionActions = toggleCount
            ? ''
              + '<div class="progression-sectionActions">'
              +   '<button class="progression-bulkBtn" type="button" data-progression-bulk-section="' + escapeHtml(section.key) + '" data-progression-bulk-value="YES"' + (canEditSection ? '' : ' disabled') + '>All Yes</button>'
              +   '<button class="progression-bulkBtn" type="button" data-progression-bulk-section="' + escapeHtml(section.key) + '" data-progression-bulk-value="NO"' + (canEditSection ? '' : ' disabled') + '>All No</button>'
              + '</div>'
            : '';
          var focusGroups = groupProgressionItemsByFocusArea(items);
          return ''
            + '<div class="progression-section">'
            +   '<div class="progression-sectionHead">'
            +     '<div>'
            +       '<h3 class="progression-sectionTitle">' + escapeHtml(section.title || formatProgressionLabel(section.key)) + '</h3>'
            +       '<p class="progression-sectionMeta">' + escapeHtml(String(items.length) + ' item' + (items.length === 1 ? '' : 's')) + '</p>'
            +     '</div>'
            +     sectionActions
            +   '</div>'
            +   '<div class="progression-focusGroups">'
            +   focusGroups.map(function(group){
                  return ''
                    + '<div class="progression-focusGroup">'
                    +   '<div class="progression-focusHead">'
                    +     '<h4 class="progression-focusTitle">' + escapeHtml(group.label || 'General') + '</h4>'
                    +     '<span class="progression-focusCount">' + escapeHtml(String((group.items || []).length)) + '</span>'
                    +   '</div>'
                    +   '<div class="progression-grid">'
                    +     (group.items || []).map(function(item){
                    var canEditItem = canEditSection;
                    if (item.kind === 'toggle') {
                      var value = String(item.value || '').trim().toUpperCase();
                      var signedOffBy = String(item.signed_off_by || '').trim();
                      var signedOffAt = formatSignedOffAt(item.signed_off_at);
                      var auditStatus = String(item.audit_status || '').trim().toLowerCase();
                      var auditReviewNote = String(item.audit_review_note || '').trim();
                      var signoffMeta = signedOffBy
                        ? '<p class="progression-cardMeta">Signed off by ' + escapeHtml(signedOffBy) + (signedOffAt ? ' on ' + escapeHtml(signedOffAt) : '') + '</p>'
                        : '';
                      var auditMeta = auditStatus === 'requested'
                        ? '<p class="progression-cardMeta">Audit requested by staff and waiting for review.</p>'
                        : (auditStatus === 'denied'
                          ? '<p class="progression-cardMeta">Audit denied' + (auditReviewNote ? ': ' + escapeHtml(auditReviewNote) : '.') + '</p>'
                          : '');
                      return ''
                        + '<div class="progression-card' + (canEditItem ? '' : ' progression-card--locked') + '" data-tone="' + escapeHtml(value === 'YES' ? 'yes' : 'no') + '">'
                        +   '<p class="progression-cardName">' + escapeHtml(item.label || formatProgressionLabel(item.key)) + '</p>'
                        +   signoffMeta
                        +   auditMeta
                        +   '<div class="progression-toggleRow">'
                        +     '<label class="progression-switch">'
                        +       '<input class="progression-switchInput" type="checkbox" data-progression-section="' + escapeHtml(section.key) + '" data-progression-key="' + escapeHtml(item.key) + '"' + (value === 'YES' ? ' checked' : '') + (canEditItem ? '' : ' disabled') + ' />'
                        +       '<span class="progression-switchTrack"></span>'
                        +     '</label>'
                        +     '<span class="progression-stateChip" data-tone="' + escapeHtml(value === 'YES' ? 'yes' : 'no') + '">' + escapeHtml(value || 'NO') + '</span>'
                        +   '</div>'
                        + '</div>';
                    }
                    if (isProgressionThresholdKey(item.key)) {
                      return ''
                        + '<div class="progression-valueRow progression-valueRow--editable' + (canEditItem ? '' : ' progression-valueRow--locked') + '">'
                        +   '<p class="progression-valueLabel">' + escapeHtml(item.label || formatProgressionLabel(item.key)) + '</p>'
                        +   '<input class="progression-valueEditor" type="number" step="1" min="0" data-progression-section="' + escapeHtml(section.key) + '" data-progression-key="' + escapeHtml(item.key) + '" value="' + escapeHtml(String(item.value || '')) + '"' + (canEditItem ? '' : ' disabled') + ' />'
                        + '</div>';
                    }
                    return ''
                      + '<div class="progression-valueRow">'
                      +   '<p class="progression-valueLabel">' + escapeHtml(item.label || formatProgressionLabel(item.key)) + '</p>'
                      +   '<span class="progression-valueChip">' + escapeHtml(String(item.value || '')) + '</span>'
                      + '</div>';
                  }).join('')
                    +   '</div>'
                    + '</div>';
                }).join('')
            +   '</div>'
            + '</div>';
        }).join('');

        renderProgressionSummary();
        updateProgressionSaveButton();
      }

      async function fetchProgressionStaffState(staffId){
        var normalizedId = String(staffId || '').trim();
        if (!normalizedId) {
          throw new Error('Missing staff id.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'progression-staff-get',
            staff_id: normalizedId,
            editor_staff_id: currentProgressionEditor && currentProgressionEditor.staff_id ? currentProgressionEditor.staff_id : ''
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.staff || !data.draft) {
          throw new Error((data && data.error) || rawText || 'Could not load progression state.');
        }
        return data;
      }

      async function fetchProgressionAuditQueue(){
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          return { requests: [], editor_permission: currentProgressionEditorPermission || null };
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'progression-audit-list',
            editor_staff_id: currentProgressionEditor.staff_id
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.requests)) {
          throw new Error((data && data.error) || rawText || 'Could not load progression audit requests.');
        }
        return data;
      }

      async function refreshProgressionAuditQueue(options){
        var settings = options && typeof options === 'object' ? options : {};
        var silent = settings.silent === true;
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id || !currentProgressionEditorPermission || currentProgressionEditorPermission.can_sign_off !== true) {
          progressionAuditQueue = [];
          renderProgressionAuditQueue();
          return;
        }
        if (!silent) {
          setProgressionAuditQueueStatus('Loading audit requests...');
        }
        try {
          var data = await fetchProgressionAuditQueue();
          progressionAuditQueue = Array.isArray(data.requests) ? data.requests.slice() : [];
          currentProgressionEditorPermission = data.editor_permission || currentProgressionEditorPermission;
          persistProgressionEditorSession();
          updateProgressionEditorStatusDisplay();
          renderProgressionAuditQueue();
        } catch (error) {
          if (!silent) {
            progressionAuditQueue = [];
            renderProgressionAuditQueue();
            setProgressionAuditQueueStatus(humanizeClientFetchErrorMessage(error, 'Could not load progression audit requests.'), 'error');
          }
        }
      }

      async function reviewProgressionAuditRequest(progressId, decision, reviewNote){
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          throw new Error('Unlock progression editor before reviewing audit requests.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'progression-audit-review',
            editor_staff_id: currentProgressionEditor.staff_id,
            progress_id: String(progressId || '').trim(),
            decision: String(decision || '').trim().toLowerCase(),
            note: String(reviewNote || '').trim()
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.staff) {
          throw new Error((data && data.error) || rawText || 'Could not review audit request.');
        }
        currentProgressionEditorPermission = data.editor_permission || currentProgressionEditorPermission;
        persistProgressionEditorSession();
        updateProgressionEditorStatusDisplay();
        progressionAuditQueue = progressionAuditQueue.filter(function(row){
          return String((row && row.id) || '').trim() !== String(progressId || '').trim();
        });
        renderProgressionAuditQueue();
        return data;
      }

      async function selectProgressionStaff(staffId, options){
        var normalizedId = String(staffId || '').trim();
        var settings = options && typeof options === 'object' ? options : {};
        var backgroundRefresh = settings.background === true;
        var requestId = ++progressionLoadRequestId;
        progressionSelectedStaff = progressionStaffOptions.find(function(option){
          return String((option && option.id) || '').trim() === normalizedId;
        }) || null;

        if (!progressionSelectedStaff) {
          progressionOriginalBio = '';
          progressionOriginalRoleId = '';
          progressionSelectedRoleId = '';
          progressionDraft = null;
          progressionProfile = null;
          if (progressionRole) {
            progressionRole.disabled = !canManageProgressionRoles();
            progressionRole.value = '';
          }
          setProgressionStatus('Choose a stylist to load progression checkpoints.');
          renderProgressionEditor();
          return;
        }

        var fallbackBio = String(progressionSelectedStaff.bio || '').trim();
        if (!backgroundRefresh) {
          progressionOriginalBio = fallbackBio;
          progressionOriginalRoleId = String(progressionSelectedStaff.role_id || '').trim();
          progressionSelectedRoleId = progressionOriginalRoleId;
          progressionDraft = null;
        }

        if (progressionRole) {
          progressionRole.disabled = !canManageProgressionRoles();
          progressionRole.value = progressionSelectedRoleId || '';
        }

        if (!backgroundRefresh) {
          setProgressionStatus('Loading progression for ' + String(progressionSelectedStaff.name || 'selected stylist') + '...');
          renderProgressionEditor();
        }

        try {
          var result = await fetchProgressionStaffState(normalizedId);
          if (requestId !== progressionLoadRequestId || !progressionSelectedStaff || String(progressionSelectedStaff.id || '').trim() !== normalizedId) {
            return;
          }
          progressionProfile = result.profile || null;
          currentProgressionEditorPermission = result.editor_permission || currentProgressionEditorPermission;
          persistProgressionEditorSession();
          updateProgressionEditorStatusDisplay();
          var resultStaff = result.staff || {};
          progressionSelectedStaff.bio = String(resultStaff.bio || progressionSelectedStaff.bio || '');
          progressionSelectedStaff.role = String(resultStaff.role || progressionSelectedStaff.role || '');
          progressionSelectedStaff.role_id = String(resultStaff.role_id || progressionSelectedStaff.role_id || '');
          progressionOriginalBio = String((result.draft && result.draft.raw) || progressionSelectedStaff.bio || '').trim();
          progressionOriginalRoleId = progressionSelectedStaff.role_id;
          progressionSelectedRoleId = progressionOriginalRoleId;
          progressionDraft = cloneProgressionDraft(result.draft);
          progressionStaffOptions = progressionStaffOptions.map(function(option){
            if (String(option.id || '').trim() !== normalizedId) return option;
            return Object.assign({}, option, {
              bio: progressionSelectedStaff.bio,
              role: progressionSelectedStaff.role,
              role_id: progressionSelectedStaff.role_id
            });
          });
          if (progressionRole) {
            progressionRole.disabled = !canManageProgressionRoles();
            progressionRole.value = progressionSelectedRoleId || '';
          }
          if (!backgroundRefresh) {
            setProgressionStatus('Editing ' + String(progressionSelectedStaff.name || 'selected stylist') + '.', '');
            renderProgressionEditor();
          }
        } catch (error) {
          if (requestId !== progressionLoadRequestId || !progressionSelectedStaff || String(progressionSelectedStaff.id || '').trim() !== normalizedId) {
            return;
          }
          if (!backgroundRefresh) {
            progressionProfile = null;
            progressionDraft = cloneProgressionDraft(parseProgressionBio(fallbackBio));
            setProgressionStatus(
              humanizeClientFetchErrorMessage(error, 'Could not load Supabase progression state. Using Boulevard bio fallback.'),
              'error'
            );
            renderProgressionEditor();
          }
        }
      }

      function updateProgressionToggle(sectionKey, itemKey, itemValue){
        if (!progressionDraft) return;
        if (!canEditProgressionSection(sectionKey)) return;
        var normalizedSection = normalizeProgressionKey(sectionKey);
        var normalizedKey = normalizeProgressionKey(itemKey);
        var normalizedValue = String(itemValue || '').trim().toUpperCase();
        if (!normalizedSection || !normalizedKey || !isProgressionToggleValue(normalizedValue)) return;

        (progressionDraft.sections || []).forEach(function(section){
          if (section.key !== normalizedSection) return;
          (section.items || []).forEach(function(item){
            if (item.key !== normalizedKey || item.kind !== 'toggle') return;
            item.value = normalizedValue;
          });
        });

        renderProgressionEditor();
      }

      function updateProgressionSectionToggles(sectionKey, itemValue){
        if (!progressionDraft) return;
        if (!canEditProgressionSection(sectionKey)) return;
        var normalizedSection = normalizeProgressionKey(sectionKey);
        var normalizedValue = String(itemValue || '').trim().toUpperCase();
        if (!normalizedSection || !isProgressionToggleValue(normalizedValue)) return;

        (progressionDraft.sections || []).forEach(function(section){
          if (section.key !== normalizedSection) return;
          (section.items || []).forEach(function(item){
            if (!item || item.kind !== 'toggle') return;
            item.value = normalizedValue;
          });
        });

        renderProgressionEditor();
      }

      function updateProgressionValue(sectionKey, itemKey, itemValue){
        if (!progressionDraft) return;
        if (!canEditProgressionSection(sectionKey)) return;
        var normalizedSection = normalizeProgressionKey(sectionKey);
        var normalizedKey = normalizeProgressionKey(itemKey);
        if (!normalizedSection || !normalizedKey) return;

        (progressionDraft.sections || []).forEach(function(section){
          if (section.key !== normalizedSection) return;
          (section.items || []).forEach(function(item){
            if (item.key !== normalizedKey) return;
            item.value = String(itemValue == null ? '' : itemValue).trim();
          });
        });

        renderProgressionEditor();
      }

      async function fetchProgressionStaffOptions(){
        async function readStaffAction(action){
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: action,
              force_refresh: false
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !Array.isArray(data.staff)) {
            return [];
          }
          return data.staff;
        }

        var directStaff = await readStaffAction('staff-directory');
        var derivedStaff = await readStaffAction('staff-directory-derived');
        var merged = {};

        directStaff.concat(derivedStaff).forEach(function(member){
          var id = String((member && member.id) || '').trim();
          var name = String((member && member.name) || '').trim();
          if (!id || !name) return;
          if (!merged[id]) {
            merged[id] = {
              id: id,
              name: name,
              role: String((member && member.role) || '').trim(),
              role_id: String((member && member.role_id) || '').trim(),
              bio: String((member && member.bio) || ''),
              active: member && typeof member.active === 'boolean' ? member.active : null
            };
            return;
          }
          if (!merged[id].role) merged[id].role = String((member && member.role) || '').trim();
          if (!merged[id].role_id) merged[id].role_id = String((member && member.role_id) || '').trim();
          if (!merged[id].bio) merged[id].bio = String((member && member.bio) || '');
          if (merged[id].active == null && member && typeof member.active === 'boolean') {
            merged[id].active = member.active;
          }
        });

        return Object.keys(merged).map(function(id){
          var member = merged[id];
          return {
            id: member.id,
            name: member.name,
            role: member.role,
            role_id: member.role_id,
            bio: member.bio,
            active: member.active,
            display_label: [
              member.name,
              member.role || 'Salon Team'
            ].filter(Boolean).join(' · ')
          };
        }).filter(function(member){
          return !!member.id && !!member.name && member.active !== false;
        }).sort(function(a, b){
          var roleCompare = String(a.role || '').localeCompare(String(b.role || ''));
          if (roleCompare !== 0) return roleCompare;
          return String(a.name || '').localeCompare(String(b.name || ''));
        });
      }

      function populateProgressionStaffOptions(options){
        progressionStaffOptions = Array.isArray(options) ? options.slice() : [];
        if (!progressionStaff) return;
        progressionStaff.innerHTML = ''
          + '<option value="">Choose stylist</option>'
          + progressionStaffOptions.map(function(option){
              return '<option value="' + escapeHtml(option.id || '') + '">' + escapeHtml(option.display_label || option.name || '') + '</option>';
            }).join('');
      }

      function populateProgressionRoleOptions(options){
        progressionRoleOptions = Array.isArray(options) ? options.slice() : [];
        if (!progressionRole) return;
        progressionRole.innerHTML = ''
          + '<option value="">Choose role</option>'
          + progressionRoleOptions.map(function(option){
              return '<option value="' + escapeHtml(option.id || '') + '">' + escapeHtml(option.name || '') + '</option>';
            }).join('');
      }

      async function fetchProgressionRoleOptions(){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-roles',
            first: 100
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.roles)) {
          throw new Error((data && data.error) || rawText || 'Could not load staff roles.');
        }
        return data.roles.map(function(role){
          return {
            id: String((role && role.id) || '').trim(),
            name: String((role && role.name) || '').trim()
          };
        }).filter(function(role){
          return !!role.id && !!role.name;
        }).sort(function(a, b){
          return String(a.name || '').localeCompare(String(b.name || ''));
        });
      }

      async function ensureProgressionControlsLoaded(){
        if (hasLoadedProgressionControls) return;
        hasLoadedProgressionControls = true;
        try {
          setProgressionStatus('Loading progression controls...');
          var results = await Promise.all([
            fetchProgressionStaffOptions(),
            fetchProgressionRoleOptions()
          ]);
          populateProgressionStaffOptions(results[0]);
          populateProgressionRoleOptions(results[1]);
          setProgressionStatus('Choose a stylist to edit checkpoint statuses.');
          renderProgressionAuditQueue();
          if (currentProgressionEditor && currentProgressionEditor.staff_id && currentProgressionEditorPermission && currentProgressionEditorPermission.can_sign_off === true) {
            await refreshProgressionAuditQueue();
          }
          renderProgressionEditor();
        } catch (error) {
          hasLoadedProgressionControls = false;
          setProgressionStatus(humanizeClientFetchErrorMessage(error, 'Could not load progression controls.'), 'error');
          if (progressionEditorMount) {
            progressionEditorMount.innerHTML = '<div class="empty">Could not load progression controls.</div>';
          }
        }
      }

      async function authenticateProgressionEditor(){
        var pin = String(progressionEditorPin && progressionEditorPin.value || '').trim();
        if (!pin) {
          setProgressionEditorStatus('Enter a staff PIN to unlock progression editing.', 'error');
          return;
        }
        if (progressionEditorUnlockBtn) progressionEditorUnlockBtn.disabled = true;
        setProgressionEditorStatus('Authorizing progression editor...');
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'progression-editor-auth',
              pin: pin
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !data.editor || !data.permission) {
            throw new Error((data && data.error) || rawText || 'Could not authorize progression editor.');
          }
          currentProgressionEditor = data.editor;
          currentProgressionEditorPermission = data.permission;
          persistProgressionEditorSession();
          if (progressionEditorPin) progressionEditorPin.value = '';
          updateProgressionEditorStatusDisplay();
          await refreshProgressionAuditQueue();
          renderProgressionEditor();
          if (progressionSelectedStaff) {
            await selectProgressionStaff(String(progressionSelectedStaff.id || ''));
          } else {
            updateProgressionSaveButton();
          }
        } catch (error) {
          clearProgressionEditorSession();
          progressionAuditQueue = [];
          setProgressionEditorStatus(humanizeClientFetchErrorMessage(error, 'Could not authorize progression editor.'), 'error');
          renderProgressionAuditQueue();
          renderProgressionEditor();
        } finally {
          if (progressionEditorUnlockBtn) progressionEditorUnlockBtn.disabled = false;
        }
      }

      async function saveProgressionDraft(){
        if (!progressionSelectedStaff || !progressionDraft) {
          setProgressionStatus('Choose a stylist first.', 'error');
          return;
        }
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          setProgressionStatus('Unlock progression editor with an authorized staff PIN before saving.', 'error');
          updateProgressionSaveButton();
          return;
        }

        var nextBio = buildProgressionBioFromDraft(progressionDraft);
        progressionSaveBtn.disabled = true;
        setProgressionStatus('Saving progression map...');
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'progression-staff-save',
              staff_id: progressionSelectedStaff.id,
              bio: nextBio,
              role_id: progressionSelectedRoleId || '',
              editor_staff_id: currentProgressionEditor.staff_id
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !data.staff) {
            throw new Error((data && data.error) || rawText || 'Could not save progression map.');
          }

          progressionSelectedStaff.bio = String((data.staff && data.staff.bio) || '');
          progressionSelectedStaff.role = String((data.staff && data.staff.role) || progressionSelectedStaff.role || '');
          progressionSelectedStaff.role_id = String((data.staff && data.staff.role_id) || progressionSelectedRoleId || '');
          progressionProfile = data.profile || progressionProfile || null;
          currentProgressionEditorPermission = data.editor_permission || currentProgressionEditorPermission;
          persistProgressionEditorSession();
          updateProgressionEditorStatusDisplay();
          progressionOriginalBio = String((data.draft && data.draft.raw) || progressionSelectedStaff.bio || '').trim();
          progressionOriginalRoleId = String(progressionSelectedStaff.role_id || '');
          progressionSelectedRoleId = progressionOriginalRoleId;
          progressionDraft = cloneProgressionDraft(data.draft || parseProgressionBio(progressionOriginalBio));
          progressionStaffOptions = progressionStaffOptions.map(function(option){
            if (String(option.id || '').trim() !== String(progressionSelectedStaff.id || '').trim()) return option;
            return Object.assign({}, option, {
              bio: progressionSelectedStaff.bio,
              role: progressionSelectedStaff.role,
              role_id: progressionSelectedStaff.role_id
            });
          });
          if (progressionRole) {
            progressionRole.disabled = !canManageProgressionRoles();
            progressionRole.value = progressionSelectedRoleId || '';
          }
          renderProgressionEditor();
          setProgressionStatus(String(progressionSelectedStaff.name || 'Stylist') + ' progression map saved.', 'success');
        } catch (error) {
          setProgressionStatus(humanizeClientFetchErrorMessage(error, 'Could not save progression map.'), 'error');
          updateProgressionSaveButton();
        }
      }

      function setCheckpointAdminStatus(text, tone){
        if (!checkpointAdminStatus) return;
        checkpointAdminStatus.textContent = String(text || '');
        checkpointAdminStatus.className = 'request-off-status' + (tone ? ' request-off-status--' + tone : '');
      }

      function canManageCheckpointAdmin(){
        return canManageStaffOpsPermissions();
      }

      function defaultCheckpointAdminRecord(){
        return {
          id: '',
          role_track: 'assistant',
          source_level: 0,
          target_level: 1,
          category: '',
          focus_area: '',
          requirement_key: '',
          label: '',
          requirement_type: 'boolean_pass',
          metric_name: '',
          threshold_numeric: '',
          threshold_unit: '',
          window_days: '',
          sort_order: '',
          focus_area_sort_order: '',
          requirement_sort_order: '',
          evaluation_mode: 'manual',
          evidence_source: 'manual',
          is_required: true,
          signoff_required: true,
          checkpoint_description: '',
          manager_guidance: '',
          staff_guidance: ''
        };
      }

      function buildNewCheckpointAdminRecord(){
        return defaultCheckpointAdminRecord();
      }

      function formatCheckpointAdminLevelMove(sourceLevel, targetLevel){
        var sourceText = Number.isFinite(Number(sourceLevel)) ? String(sourceLevel) : '?';
        var targetText = Number.isFinite(Number(targetLevel)) ? String(targetLevel) : '?';
        return 'Level ' + sourceText + ' to ' + targetText;
      }

      function populateCheckpointAdminSuggestions(){
        var categories = [];
        var focusAreas = [];
        checkpointAdminRows.forEach(function(row){
          var category = String((row && row.category) || '').trim();
          var focusArea = String((row && row.focus_area) || '').trim();
          if (category && categories.indexOf(category) === -1) categories.push(category);
          if (focusArea && focusAreas.indexOf(focusArea) === -1) focusAreas.push(focusArea);
        });
        categories.sort(function(a, b){ return a.localeCompare(b); });
        focusAreas.sort(function(a, b){ return a.localeCompare(b); });
        if (checkpointAdminCategoryOptions) {
          checkpointAdminCategoryOptions.innerHTML = categories.map(function(value){
            return '<option value="' + escapeHtml(value) + '"></option>';
          }).join('');
        }
        if (checkpointAdminFocusAreaOptions) {
          checkpointAdminFocusAreaOptions.innerHTML = focusAreas.map(function(value){
            return '<option value="' + escapeHtml(value) + '"></option>';
          }).join('');
        }
      }

      function getCheckpointAdminSelectedRecord(){
        var selectedId = String(checkpointAdminSelectedId || '').trim();
        if (!selectedId) return null;
        return checkpointAdminRows.find(function(row){
          return String((row && row.id) || '').trim() === selectedId;
        }) || null;
      }

      function setCheckpointAdminFormDisabled(disabled){
        [
          checkpointAdminRoleTrack,
          checkpointAdminSourceLevel,
          checkpointAdminTargetLevel,
          checkpointAdminCategory,
          checkpointAdminFocusArea,
          checkpointAdminRequirementKey,
          checkpointAdminLabel,
          checkpointAdminRequirementType,
          checkpointAdminMetricName,
          checkpointAdminThresholdNumeric,
          checkpointAdminThresholdUnit,
          checkpointAdminWindowDays,
          checkpointAdminSortOrder,
          checkpointAdminFocusAreaSort,
          checkpointAdminRequirementSort,
          checkpointAdminEvaluationMode,
          checkpointAdminEvidenceSource,
          checkpointAdminRequired,
          checkpointAdminSignoffRequired,
          checkpointAdminDescription,
          checkpointAdminManagerGuidance,
          checkpointAdminStaffGuidance,
          checkpointAdminSaveBtn
        ].forEach(function(node){
          if (node) node.disabled = !!disabled;
        });
        if (checkpointAdminDeleteBtn) checkpointAdminDeleteBtn.disabled = !!disabled || !String(checkpointAdminSelectedId || '').trim();
      }

      function findCheckpointAdminMetricDefinition(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (!normalized) return null;
        return CHECKPOINT_ADMIN_KPI_METRICS.find(function(metric){
          return String(metric.value || '').trim().toLowerCase() === normalized;
        }) || null;
      }

      function populateCheckpointAdminRequirementTypeOptions(selectedValue){
        if (!checkpointAdminRequirementType) return;
        var selected = String(selectedValue || '').trim();
        var html = CHECKPOINT_ADMIN_REQUIREMENT_TYPES.map(function(type){
          return '<option value="' + escapeHtml(type.value) + '">' + escapeHtml(type.label) + '</option>';
        }).join('');
        var known = CHECKPOINT_ADMIN_REQUIREMENT_TYPES.some(function(type){
          return type.value === selected;
        });
        if (selected && !known) {
          html += '<option value="' + escapeHtml(selected) + '">' + escapeHtml(selected + ' (Legacy)') + '</option>';
        }
        checkpointAdminRequirementType.innerHTML = html;
      }

      function populateCheckpointAdminMetricOptions(selectedValue){
        if (!checkpointAdminMetricName) return;
        var selected = String(selectedValue || '').trim();
        var groups = {};
        CHECKPOINT_ADMIN_KPI_METRICS.forEach(function(metric){
          var group = String(metric.group || 'Other');
          if (!groups[group]) groups[group] = [];
          groups[group].push(metric);
        });
        var html = '<option value="">Choose KPI metric</option>';
        Object.keys(groups).forEach(function(groupLabel){
          html += '<optgroup label="' + escapeHtml(groupLabel) + '">';
          html += groups[groupLabel].map(function(metric){
            return '<option value="' + escapeHtml(metric.value) + '">' + escapeHtml(metric.label) + '</option>';
          }).join('');
          html += '</optgroup>';
        });
        if (selected && !findCheckpointAdminMetricDefinition(selected)) {
          html += '<option value="' + escapeHtml(selected) + '">' + escapeHtml(selected + ' (Current custom value)') + '</option>';
        }
        checkpointAdminMetricName.innerHTML = html;
      }

      function applyCheckpointAdminMetricDefaults(metricValue){
        var metric = findCheckpointAdminMetricDefinition(metricValue);
        if (!metric) return;
        if (checkpointAdminThresholdUnit) checkpointAdminThresholdUnit.value = String(metric.threshold_unit || '');
        if (checkpointAdminWindowDays) checkpointAdminWindowDays.value = String(metric.window_days || '');
        if (checkpointAdminEvaluationMode) checkpointAdminEvaluationMode.value = 'snapshot';
        if (checkpointAdminEvidenceSource) checkpointAdminEvidenceSource.value = 'boulevard_snapshot';
        if (checkpointAdminRequirementType) {
          checkpointAdminRequirementType.value = metric.threshold_unit === 'percent'
            ? 'percent_min'
            : 'count_min';
        }
      }

      function updateCheckpointAdminBenchmarkSummary(){
        if (!checkpointAdminBenchmarkSummary) return;
        var metric = findCheckpointAdminMetricDefinition(checkpointAdminMetricName && checkpointAdminMetricName.value);
        var unit = String(checkpointAdminThresholdUnit && checkpointAdminThresholdUnit.value || '').trim();
        var windowDays = String(checkpointAdminWindowDays && checkpointAdminWindowDays.value || '').trim();
        if (!metric) {
          checkpointAdminBenchmarkSummary.textContent = 'This checkpoint will use the standard KPI snapshot defaults.';
          return;
        }
        var summaryParts = [
          metric.label,
          windowDays ? windowDays + '-day lookback' : '',
          unit ? unit.replace(/_/g, ' ') : '',
          'Boulevard snapshot'
        ].filter(Boolean);
        checkpointAdminBenchmarkSummary.textContent = summaryParts.join(' · ');
      }

      function checkpointAdminTypeNeedsBenchmarkFields(requirementType){
        var normalized = String(requirementType || '').trim().toLowerCase();
        return normalized === 'count_min'
          || normalized === 'percent_min';
      }

      function updateCheckpointAdminAdvancedState(requirementType){
        if (!checkpointAdminAdvanced) return;
        var needsAdvanced = checkpointAdminTypeNeedsBenchmarkFields(requirementType);
        checkpointAdminAdvanced.hidden = !needsAdvanced;
        if (!needsAdvanced) {
          if (checkpointAdminMetricName) checkpointAdminMetricName.value = '';
          updateCheckpointAdminBenchmarkSummary();
          return;
        }
        if (checkpointAdminRequirementType) {
          var currentType = String(checkpointAdminRequirementType.value || '').trim().toLowerCase();
          if (currentType === 'percent_min' && checkpointAdminThresholdUnit) {
            checkpointAdminThresholdUnit.value = 'percent';
          }
        }
        updateCheckpointAdminBenchmarkSummary();
      }

      function renderCheckpointAdminForm(record){
        var canManage = canManageCheckpointAdmin();
        var safe = record || defaultCheckpointAdminRecord();
        var isCreating = !safe.id;
        setCheckpointAdminFormDisabled(!canManage);
        checkpointAdminKeyDirty = !!safe.id;
        if (checkpointAdminEditorPanel) {
          checkpointAdminEditorPanel.classList.toggle('is-creating', isCreating);
        }
        if (checkpointAdminEditorTitle) {
          checkpointAdminEditorTitle.textContent = safe.id
            ? (safe.label || safe.requirement_key || 'Checkpoint Details')
            : 'Create new checkpoint';
        }
        if (checkpointAdminEditorHint) {
          checkpointAdminEditorHint.textContent = isCreating
            ? 'Start fresh. Add the checkpoint name first, then fill in only the fields you need.'
            : 'Update the checkpoint details here. Benchmark checkpoints only ask for the KPI and the target.';
        }
        if (checkpointAdminModeBadge) {
          checkpointAdminModeBadge.textContent = isCreating
            ? 'Creating new checkpoint'
            : 'Editing existing checkpoint';
        }
        if (checkpointAdminSaveBtn) {
          checkpointAdminSaveBtn.textContent = safe.id ? 'Save checkpoint' : 'Create checkpoint';
        }
        populateCheckpointAdminRequirementTypeOptions(safe.requirement_type || 'boolean_pass');
        populateCheckpointAdminMetricOptions(safe.metric_name || '');
        if (checkpointAdminRoleTrack) checkpointAdminRoleTrack.value = String(safe.role_track || 'assistant');
        if (checkpointAdminSourceLevel) checkpointAdminSourceLevel.value = String(safe.source_level != null ? safe.source_level : 0);
        if (checkpointAdminTargetLevel) checkpointAdminTargetLevel.value = String(safe.target_level != null ? safe.target_level : 1);
        if (checkpointAdminCategory) checkpointAdminCategory.value = String(safe.category || '');
        if (checkpointAdminFocusArea) checkpointAdminFocusArea.value = String(safe.focus_area || '');
        if (checkpointAdminRequirementKey) checkpointAdminRequirementKey.value = String(safe.requirement_key || '');
        if (checkpointAdminLabel) checkpointAdminLabel.value = String(safe.label || '');
        if (checkpointAdminRequirementType) checkpointAdminRequirementType.value = String(safe.requirement_type || 'boolean_pass');
        if (checkpointAdminMetricName) checkpointAdminMetricName.value = String(safe.metric_name || '');
        if (checkpointAdminThresholdNumeric) checkpointAdminThresholdNumeric.value = safe.threshold_numeric == null ? '' : String(safe.threshold_numeric);
        if (checkpointAdminThresholdUnit) checkpointAdminThresholdUnit.value = String(safe.threshold_unit || '');
        if (checkpointAdminWindowDays) checkpointAdminWindowDays.value = safe.window_days == null ? '' : String(safe.window_days);
        if (checkpointAdminSortOrder) checkpointAdminSortOrder.value = safe.sort_order == null ? '' : String(safe.sort_order);
        if (checkpointAdminFocusAreaSort) checkpointAdminFocusAreaSort.value = safe.focus_area_sort_order == null ? '' : String(safe.focus_area_sort_order);
        if (checkpointAdminRequirementSort) checkpointAdminRequirementSort.value = safe.requirement_sort_order == null ? '' : String(safe.requirement_sort_order);
        if (checkpointAdminEvaluationMode) checkpointAdminEvaluationMode.value = String(safe.evaluation_mode || 'manual');
        if (checkpointAdminEvidenceSource) checkpointAdminEvidenceSource.value = String(safe.evidence_source || 'manual');
        if (checkpointAdminRequired) checkpointAdminRequired.checked = safe.is_required !== false;
        if (checkpointAdminSignoffRequired) checkpointAdminSignoffRequired.checked = safe.signoff_required !== false;
        if (checkpointAdminDescription) checkpointAdminDescription.value = String(safe.checkpoint_description || '');
        if (checkpointAdminManagerGuidance) checkpointAdminManagerGuidance.value = String(safe.manager_guidance || '');
        if (checkpointAdminStaffGuidance) checkpointAdminStaffGuidance.value = String(safe.staff_guidance || '');
        updateCheckpointAdminAdvancedState(safe.requirement_type || 'boolean_pass');
        updateCheckpointAdminBenchmarkSummary();
      }

      function syncCheckpointAdminKeyFromLabel(){
        if (checkpointAdminKeyDirty) return;
        if (!checkpointAdminLabel || !checkpointAdminRequirementKey) return;
        checkpointAdminRequirementKey.value = normalizeProgressionKey(String(checkpointAdminLabel.value || ''));
      }

      function getFilteredCheckpointAdminRows(){
        var roleTrackFilter = String(checkpointAdminRoleTrackFilter && checkpointAdminRoleTrackFilter.value || '').trim().toLowerCase();
        var levelMoveFilter = String(checkpointAdminLevelMoveFilter && checkpointAdminLevelMoveFilter.value || '').trim();
        var search = String(checkpointAdminSearch && checkpointAdminSearch.value || '').trim().toLowerCase();
        return checkpointAdminRows.filter(function(row){
          if (roleTrackFilter && String(row.role_track || '').trim().toLowerCase() !== roleTrackFilter) return false;
          if (levelMoveFilter) {
            var rowMove = String(row.source_level) + '-' + String(row.target_level);
            if (rowMove !== levelMoveFilter) return false;
          }
          if (!search) return true;
          var haystack = [
            row.requirement_key,
            row.label,
            row.category,
            row.focus_area,
            row.role_track
          ].join(' ').toLowerCase();
          return haystack.indexOf(search) !== -1;
        });
      }

      function renderCheckpointAdminList(){
        if (!checkpointAdminList) return;
        var canManage = canManageCheckpointAdmin();
        if (checkpointAdminRefreshBtn) checkpointAdminRefreshBtn.disabled = !canManage;
        if (checkpointAdminNewBtn) checkpointAdminNewBtn.disabled = !canManage;
        var rows = getFilteredCheckpointAdminRows();
        if (!canManage) {
          checkpointAdminList.innerHTML = '<div class="empty">Log in as Chase or Julianne to manage checkpoints.</div>';
          renderCheckpointAdminForm(defaultCheckpointAdminRecord());
          return;
        }
        if (!rows.length) {
          checkpointAdminList.innerHTML = '<div class="empty">No checkpoints match the current filters.</div>';
          renderCheckpointAdminForm(getCheckpointAdminSelectedRecord() || defaultCheckpointAdminRecord());
          return;
        }
        var groups = [];
        rows.forEach(function(row){
          var groupKey = String(row.source_level) + '-' + String(row.target_level);
          var existing = groups.find(function(group){
            return group.key === groupKey;
          });
          if (!existing) {
            existing = {
              key: groupKey,
              label: formatCheckpointAdminLevelMove(row.source_level, row.target_level),
              rows: []
            };
            groups.push(existing);
          }
          existing.rows.push(row);
        });
        checkpointAdminList.innerHTML = groups.map(function(group){
          return ''
            + '<section class="checkpoint-adminGroup">'
            +   '<div class="checkpoint-adminGroupHead">'
            +     '<h4 class="checkpoint-adminGroupTitle">' + escapeHtml(group.label) + '</h4>'
            +     '<span class="checkpoint-adminGroupCount">' + escapeHtml(String(group.rows.length)) + '</span>'
            +   '</div>'
            +   '<div class="checkpoint-adminGroupRows">'
            +   group.rows.map(function(row){
                  var selected = String(row.id || '') === String(checkpointAdminSelectedId || '');
                  return ''
                    + '<button class="checkpoint-adminRow' + (selected ? ' is-selected' : '') + '" type="button" data-checkpoint-admin-id="' + escapeHtml(String(row.id || '')) + '">'
                    +   '<strong class="checkpoint-adminRowTitle">' + escapeHtml(String(row.label || row.requirement_key || 'Untitled checkpoint')) + '</strong>'
                    + '</button>';
                }).join('')
            +   '</div>'
            + '</section>';
        }).join('');
      }

      function selectCheckpointAdminRecord(recordId){
        checkpointAdminSelectedId = String(recordId || '').trim();
        renderCheckpointAdminList();
        renderCheckpointAdminForm(getCheckpointAdminSelectedRecord() || defaultCheckpointAdminRecord());
      }

      function startNewCheckpointAdminRecord(){
        checkpointAdminSelectedId = '';
        renderCheckpointAdminList();
        renderCheckpointAdminForm(buildNewCheckpointAdminRecord());
        syncCheckpointAdminKeyFromLabel();
        if (checkpointAdminLabel && !checkpointAdminLabel.disabled) {
          checkpointAdminLabel.focus();
        }
        setCheckpointAdminStatus('Creating a new checkpoint.', '');
      }

      async function fetchCheckpointAdminRows(){
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          throw new Error('Use a named admin PIN to manage checkpoints.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'checkpoint-admin-list',
            editor_staff_id: currentProgressionEditor.staff_id
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.requirements)) {
          throw new Error((data && data.error) || rawText || 'Could not load checkpoints.');
        }
        return data.requirements;
      }

      async function ensureCheckpointAdminControlsLoaded(forceRefresh){
        if (hasLoadedCheckpointAdminControls && !forceRefresh) return;
        hasLoadedCheckpointAdminControls = true;
        try {
          setCheckpointAdminStatus('Loading checkpoints...');
          checkpointAdminRows = await fetchCheckpointAdminRows();
          populateCheckpointAdminSuggestions();
          if (!getCheckpointAdminSelectedRecord()) {
            checkpointAdminSelectedId = checkpointAdminRows.length ? String(checkpointAdminRows[0].id || '') : '';
          }
          renderCheckpointAdminList();
          renderCheckpointAdminForm(getCheckpointAdminSelectedRecord() || defaultCheckpointAdminRecord());
          setCheckpointAdminStatus('Checkpoint admin ready.', '');
        } catch (error) {
          hasLoadedCheckpointAdminControls = false;
          checkpointAdminRows = [];
          populateCheckpointAdminSuggestions();
          checkpointAdminSelectedId = '';
          renderCheckpointAdminList();
          renderCheckpointAdminForm(defaultCheckpointAdminRecord());
          setCheckpointAdminStatus(humanizeClientFetchErrorMessage(error, 'Could not load checkpoints.'), 'error');
        }
      }

      function collectCheckpointAdminPayload(){
        var focusAreaValue = String(checkpointAdminFocusArea && checkpointAdminFocusArea.value || '').trim();
        return {
          id: String(checkpointAdminSelectedId || '').trim(),
          role_track: String(checkpointAdminRoleTrack && checkpointAdminRoleTrack.value || 'assistant').trim(),
          source_level: String(checkpointAdminSourceLevel && checkpointAdminSourceLevel.value || '0').trim(),
          target_level: String(checkpointAdminTargetLevel && checkpointAdminTargetLevel.value || '1').trim(),
          category: String(checkpointAdminCategory && checkpointAdminCategory.value || focusAreaValue).trim(),
          focus_area: focusAreaValue,
          requirement_key: String(checkpointAdminRequirementKey && checkpointAdminRequirementKey.value || '').trim(),
          label: String(checkpointAdminLabel && checkpointAdminLabel.value || '').trim(),
          requirement_type: String(checkpointAdminRequirementType && checkpointAdminRequirementType.value || 'boolean_pass').trim(),
          metric_name: String(checkpointAdminMetricName && checkpointAdminMetricName.value || '').trim(),
          threshold_numeric: String(checkpointAdminThresholdNumeric && checkpointAdminThresholdNumeric.value || '').trim(),
          threshold_unit: String(checkpointAdminThresholdUnit && checkpointAdminThresholdUnit.value || '').trim(),
          window_days: String(checkpointAdminWindowDays && checkpointAdminWindowDays.value || '').trim(),
          sort_order: String(checkpointAdminSortOrder && checkpointAdminSortOrder.value || '').trim(),
          focus_area_sort_order: String(checkpointAdminFocusAreaSort && checkpointAdminFocusAreaSort.value || '').trim(),
          requirement_sort_order: String(checkpointAdminRequirementSort && checkpointAdminRequirementSort.value || '').trim(),
          evaluation_mode: String(checkpointAdminEvaluationMode && checkpointAdminEvaluationMode.value || 'manual').trim(),
          evidence_source: String(checkpointAdminEvidenceSource && checkpointAdminEvidenceSource.value || 'manual').trim(),
          is_required: !!(checkpointAdminRequired && checkpointAdminRequired.checked),
          signoff_required: !!(checkpointAdminSignoffRequired && checkpointAdminSignoffRequired.checked),
          checkpoint_description: String(checkpointAdminDescription && checkpointAdminDescription.value || '').trim(),
          manager_guidance: String(checkpointAdminManagerGuidance && checkpointAdminManagerGuidance.value || '').trim(),
          staff_guidance: String(checkpointAdminStaffGuidance && checkpointAdminStaffGuidance.value || '').trim()
        };
      }

      async function saveCheckpointAdminRecord(){
        if (!canManageCheckpointAdmin()) {
          setCheckpointAdminStatus('Use a named admin PIN to save checkpoints.', 'error');
          return;
        }
        var payload = collectCheckpointAdminPayload();
        if (!payload.requirement_key || !payload.label || !payload.focus_area) {
          setCheckpointAdminStatus('Requirement key, label, and focus area are required.', 'error');
          return;
        }
        checkpointAdminSaveBtn.disabled = true;
        setCheckpointAdminStatus('Saving checkpoint...');
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'checkpoint-admin-save',
              editor_staff_id: currentProgressionEditor.staff_id,
              requirement: payload
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !data.requirement) {
            throw new Error((data && data.error) || rawText || 'Could not save checkpoint.');
          }
          checkpointAdminSelectedId = String(data.requirement.id || '').trim();
          hasLoadedCheckpointAdminControls = false;
          await ensureCheckpointAdminControlsLoaded(true);
          setCheckpointAdminStatus('Checkpoint saved.', 'success');
        } catch (error) {
          setCheckpointAdminStatus(humanizeClientFetchErrorMessage(error, 'Could not save checkpoint.'), 'error');
        } finally {
          if (checkpointAdminSaveBtn) checkpointAdminSaveBtn.disabled = false;
        }
      }

      async function deleteCheckpointAdminRecord(){
        var selected = getCheckpointAdminSelectedRecord();
        if (!selected || !selected.id) {
          setCheckpointAdminStatus('Choose a checkpoint first.', 'error');
          return;
        }
        if (!canManageCheckpointAdmin()) {
          setCheckpointAdminStatus('Use a named admin PIN to delete checkpoints.', 'error');
          return;
        }
        checkpointAdminDeleteBtn.disabled = true;
        setCheckpointAdminStatus('Deleting checkpoint...');
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'checkpoint-admin-delete',
              editor_staff_id: currentProgressionEditor.staff_id,
              requirement_id: selected.id
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not delete checkpoint.');
          }
          checkpointAdminSelectedId = '';
          hasLoadedCheckpointAdminControls = false;
          await ensureCheckpointAdminControlsLoaded(true);
          setCheckpointAdminStatus('Checkpoint deleted.', 'success');
        } catch (error) {
          setCheckpointAdminStatus(humanizeClientFetchErrorMessage(error, 'Could not delete checkpoint.'), 'error');
        } finally {
          if (checkpointAdminDeleteBtn) checkpointAdminDeleteBtn.disabled = false;
        }
      }

      function populatePermissionsStaffOptions(options){
        permissionsStaffOptions = Array.isArray(options) ? options.slice() : [];
        if (!permissionsStaff) return;
        permissionsStaff.innerHTML = ''
          + '<option value="">Choose staff member</option>'
          + permissionsStaffOptions.map(function(option){
              return '<option value="' + escapeHtml(option.id || '') + '">' + escapeHtml(option.display_label || option.name || '') + '</option>';
            }).join('');
      }

      function canManageBonus(){
        if (!currentStaffOpsPermission) return true;
        return currentStaffOpsPermission.active !== false
          && currentStaffOpsPermission.can_access_staff_ops === true
          && currentStaffOpsPermission.can_manage_access_permissions === true;
      }

      function getAvailableBonusQuarterOptions(){
        var minimumDataDate = parseLocalDateKey(BONUS_PERIOD_DATA_START);
        return buildQuarterOptions(BONUS_PERIOD_DATA_START).filter(function(option){
          var endDiff = diffDaysFromToday(option.end);
          if (!(endDiff > 0)) return false;
          if (!minimumDataDate) return true;
          return option.end && option.end.getTime() >= minimumDataDate.getTime();
        });
      }

      function getAvailableBonusPayrollOptions(){
        var minimumDataDate = parseLocalDateKey(BONUS_PERIOD_DATA_START);
        return buildConcludedPayrollPeriodOptions(104).filter(function(option){
          if (!minimumDataDate) return true;
          return option.end && option.end.getTime() >= minimumDataDate.getTime();
        });
      }

      function getAvailableBonusPeriodOptions(){
        var quarterOptions = getAvailableBonusQuarterOptions().map(function(option){
          return {
            kind: 'quarter',
            value: 'quarter|' + String(option.value || ''),
            label: String(option.label || '').replace(/^(\d{4})\s+Q(\d)$/i, 'Q$2 $1'),
            raw_value: String(option.value || ''),
            plan_year: Number(String(option.value || '').split('-Q')[0]) || null,
            quarter_label: 'Q' + String(String(option.value || '').split('-Q')[1] || '').trim(),
            date_from: option.start ? formatDateInputValue(option.start) : '',
            date_to: option.end ? formatDateInputValue(option.end) : ''
          };
        });
        var payrollOptions = getAvailableBonusPayrollOptions().map(function(option){
          return {
            kind: 'payroll',
            value: 'payroll|' + String(option.value || ''),
            label: 'Payroll · ' + String(option.label || ''),
            raw_value: String(option.value || ''),
            plan_year: option.value ? Number(String(option.value).slice(0, 4)) || null : null,
            quarter_label: '',
            date_from: String(option.value || ''),
            date_to: String(option.date_to || '')
          };
        });
        return quarterOptions.concat(payrollOptions).sort(function(a, b){
          return String(b.date_to || '').localeCompare(String(a.date_to || ''));
        });
      }

      function parseBonusPeriodSelection(rawValue){
        var text = String(rawValue || '').trim();
        if (!text) return {
          kind: 'quarter',
          raw_value: '',
          plan_year: new Date().getFullYear(),
          quarter_label: '',
          date_from: '',
          date_to: '',
          option: null
        };
        var parts = text.split('|');
        var kind = String(parts[0] || 'quarter').trim().toLowerCase() === 'payroll' ? 'payroll' : 'quarter';
        var raw = String(parts.slice(1).join('|') || '').trim();
        var option = getAvailableBonusPeriodOptions().find(function(entry){
          return String(entry.value || '') === text;
        }) || null;
        if (option) {
          return {
            kind: kind,
            raw_value: raw,
            plan_year: option.plan_year || new Date().getFullYear(),
            quarter_label: option.quarter_label || '',
            date_from: option.date_from || '',
            date_to: option.date_to || '',
            option: option
          };
        }
        if (kind === 'payroll') {
          return {
            kind: 'payroll',
            raw_value: raw,
            plan_year: raw ? Number(String(raw).slice(0, 4)) || new Date().getFullYear() : new Date().getFullYear(),
            quarter_label: '',
            date_from: raw,
            date_to: '',
            option: null
          };
        }
        return {
          kind: 'quarter',
          raw_value: raw,
          plan_year: Number(String(raw).split('-Q')[0]) || new Date().getFullYear(),
          quarter_label: raw ? ('Q' + String(String(raw).split('-Q')[1] || '').trim()) : '',
          date_from: '',
          date_to: '',
          option: null
        };
      }

      function syncBonusWindowModeUi(options){
        var settings = options && typeof options === 'object' ? options : {};
        if (bonusPlanQuarterLabel) bonusPlanQuarterLabel.textContent = 'Period';
        if (bonusPlanQuarter && bonusPlanQuarter.parentElement) bonusPlanQuarter.parentElement.hidden = false;
        if (bonusPlanYear && bonusPlanYear.parentElement) bonusPlanYear.parentElement.hidden = true;
        if (bonusRangeKind && bonusRangeKind.parentElement) bonusRangeKind.parentElement.hidden = true;
        if (bonusCustomDateFromField) bonusCustomDateFromField.hidden = true;
        if (bonusCustomDateToField) bonusCustomDateToField.hidden = true;
        populateBonusPeriodOptions(String((settings && settings.selectedValue) || (bonusPlanQuarter && bonusPlanQuarter.value) || '').trim());
      }

      async function reloadBonusWindowDraft(){
        var hasPeriod = !!String((bonusPlanQuarter && bonusPlanQuarter.value) || '').trim();
        if (!hasPeriod) {
          syncBonusWindowModeUi();
          renderBonusWeightMix();
          return;
        }
        hasLoadedBonus = false;
        applyBonusDraftStateFromInputs();
        await refreshBonusMetricAvailability();
      }

      function canInspectBonusWindow(){
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) return false;
        if (!canManageBonus()) return false;
        return !!String((bonusPlanQuarter && bonusPlanQuarter.value) || '').trim();
      }

      function scheduleBonusMetricAvailabilityRefresh(){
        if (bonusAvailabilityTimer) {
          clearTimeout(bonusAvailabilityTimer);
          bonusAvailabilityTimer = null;
        }
        if (!canInspectBonusWindow()) return;
        bonusAvailabilityTimer = setTimeout(function(){
          bonusAvailabilityTimer = null;
          refreshBonusMetricAvailability();
        }, 220);
      }

      async function fetchBonusWindowAvailability(){
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          throw new Error('Use a named admin PIN to manage bonus plans.');
        }
        var body = readBonusPlanInput();
        body.action = 'bonus-plan-window-inspect';
        body.editor_staff_id = currentProgressionEditor.staff_id;
        return fetchBonusPlanRequest(body, 'Could not load available bonus metrics.');
      }

      async function refreshBonusMetricAvailability(){
        if (!canInspectBonusWindow()) return;
        var requestVersion = ++bonusAvailabilityRequestVersion;
        try {
          setBonusStatus('Checking which metrics are available for this period...');
          var result = await fetchBonusWindowAvailability();
          if (requestVersion !== bonusAvailabilityRequestVersion) return;
          bonusMetricCatalog = Array.isArray(result && result.metric_catalog) ? result.metric_catalog.slice() : [];
          bonusIncludedStaffOptions = Array.isArray(result && result.eligible_staff) ? result.eligible_staff.slice() : bonusIncludedStaffOptions;
          renderBonusIncludedStaffSelector(getBonusSelectedStaffIds());
          renderBonusMetricSelector({ weights: readBonusPlanInput().weights, rules: readBonusPlanInput().rules });
          renderBonusWeightMix();
          var availabilitySummary = result && result.availability_summary ? result.availability_summary : {};
          var count = Number(availabilitySummary.available_metric_count || bonusMetricCatalog.length || 0);
          var labels = Array.isArray(availabilitySummary.available_metric_labels)
            ? availabilitySummary.available_metric_labels.map(function(value){
                return String(value || '').trim();
              }).filter(Boolean)
            : [];
          if (!labels.length) {
            labels = retailArray(bonusMetricCatalog).map(function(metric){
              return String(metric && metric.label || metric && metric.short_label || '').trim();
            }).filter(Boolean);
          }
          var previewLabels = labels.slice(0, 4).join(', ');
          var moreCount = Math.max(0, labels.length - 4);
          setBonusStatus(
            count > 0
              ? (String(count) + ' bonus metrics are available for this period' + (previewLabels ? (': ' + previewLabels + (moreCount > 0 ? (' +' + String(moreCount) + ' more') : '') + '.') : '.'))
              : 'No bonus metrics are available for this period yet.',
            'success'
          );
        } catch (error) {
          if (requestVersion !== bonusAvailabilityRequestVersion) return;
          setBonusStatus(humanizeClientFetchErrorMessage(error, 'Could not load available bonus metrics.'), 'error');
        }
      }

      function populateBonusPeriodOptions(selectedValue){
        if (!bonusPlanQuarter) return;
        var options = getAvailableBonusPeriodOptions();
        bonusPlanQuarter.innerHTML = options.map(function(option){
          return '<option value="' + escapeHtml(option.value) + '">' + escapeHtml(option.label) + '</option>';
        }).join('');
        if (!options.length) {
          bonusPlanQuarter.innerHTML = '<option value="">No periods available</option>';
          return;
        }
        var matched = options.find(function(option){
          return String(option.value || '') === String(selectedValue || '');
        }) || null;
        bonusPlanQuarter.value = matched ? matched.value : options[0].value;
      }

      function describeBonusLevelCurve(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'strongly_favor_higher_levels') return 'Level curve: strongly favors higher levels.';
        if (normalized === 'favor_higher_levels') return 'Level curve: favors higher levels.';
        return 'Level curve: balanced across levels.';
      }

      function getBonusSelectedMetricInputs(){
        if (!bonusMetricList || !bonusMetricList.querySelectorAll) return [];
        return Array.prototype.slice.call(bonusMetricList.querySelectorAll('[data-bonus-metric-weight]'));
      }

      function getBonusMetricSelectionMap(){
        return bonusMetricDraftState && typeof bonusMetricDraftState === 'object'
          ? bonusMetricDraftState
          : {};
      }

      function getBonusSelectedStaffIds(){
        if (!bonusIncludedStaff || !bonusIncludedStaff.querySelectorAll) return [];
        return Array.prototype.slice.call(bonusIncludedStaff.querySelectorAll('[data-bonus-staff-id]'))
          .filter(function(node){
            return String(node.getAttribute('aria-pressed') || 'false') === 'true';
          })
          .map(function(node){
            return String(node.getAttribute('data-bonus-staff-id') || '').trim();
          })
          .filter(Boolean);
      }

      function bonusSelectionHasManagers(){
        var selectedIds = getBonusSelectedStaffIds();
        var selectedLookup = {};
        selectedIds.forEach(function(id){
          selectedLookup[String(id || '').trim()] = true;
        });
        var relevantOptions = retailArray(bonusIncludedStaffOptions).filter(function(option){
          return selectedLookup[String(option.id || '').trim()] === true;
        });
        return relevantOptions.some(function(option){
          return String(option && option.bonus_role_group || '').trim().toLowerCase() === 'manager';
        });
      }

      function getBonusMetricByKey(metricKey){
        var key = String(metricKey || '').trim();
        return retailArray(bonusMetricCatalog).find(function(entry){
          return String(entry && entry.key || '').trim() === key;
        }) || null;
      }

      function bonusMetricUsesRecoveryPercent(metricKey, mode){
        var normalizedMode = String(mode || '').trim().toLowerCase();
        if (normalizedMode === 'recovery_percent') return true;
        var metric = getBonusMetricByKey(metricKey);
        return String(metric && metric.recommended_mode || '').trim().toLowerCase() === 'recovery_percent';
      }

      function formatBonusMetricValue(metricKey, value){
        var numeric = Number(value);
        if (!Number.isFinite(numeric)) return '—';
        var key = String(metricKey || '').trim();
        if (key === 'production_rate') return formatMoney(numeric).replace('.00', '') + '/hr';
        if (key === 'service_sales' || key === 'product_sales' || key === 'tip_sales' || key === 'salon_service_sales' || key === 'salon_product_sales') {
          return formatMoney(numeric);
        }
        if (key === 'prebook_recovered_revenue'
          || key === 'recapture_recovered_revenue'
          || key === 'retail_followup_recovered_revenue'
          || key === 'team_prebook_recovered_revenue'
          || key === 'team_recapture_recovered_revenue'
          || key === 'team_retail_followup_recovered_revenue') {
          return formatMoney(numeric);
        }
        if (key.indexOf('rate') >= 0 || key.indexOf('ratio') >= 0 || key.indexOf('reliability') >= 0 || key.indexOf('utilization') >= 0 || key.indexOf('progression') >= 0) {
          return formatPercent(numeric);
        }
        if (Math.abs(numeric) >= 1000) return numeric.toLocaleString();
        if (Math.round(numeric) === numeric) return String(numeric);
        return numeric.toFixed(1);
      }

      function bonusMetricUsesPercentGoal(metricKey){
        var key = String(metricKey || '').trim();
        return key.indexOf('rate') >= 0
          || key.indexOf('ratio') >= 0
          || key.indexOf('reliability') >= 0
          || key.indexOf('utilization') >= 0
          || key.indexOf('progression') >= 0
          || key === 'attach_rate'
          || key === 'color_discipline_reweigh_rate';
      }

      function bonusMetricUsesCurrencyGoal(metricKey){
        var key = String(metricKey || '').trim();
        return key === 'production_rate'
          || key === 'service_sales'
          || key === 'product_sales'
          || key === 'tip_sales'
          || key === 'salon_service_sales'
          || key === 'salon_product_sales';
      }

      function getBonusTargetLabel(metricKey){
        if (bonusMetricUsesPercentGoal(metricKey)) return 'Target %';
        if (bonusMetricUsesCurrencyGoal(metricKey)) return 'Target $';
        if (bonusMetricUsesRecoveryPercent(metricKey)) return 'Recovered $ goal';
        return 'Target';
      }

      function getBonusTargetStep(metricKey){
        if (bonusMetricUsesCurrencyGoal(metricKey)) return '1';
        return '0.1';
      }

      function getBonusTargetPlaceholder(metricKey){
        if (bonusMetricUsesPercentGoal(metricKey)) return 'Ex. 85';
        if (bonusMetricUsesCurrencyGoal(metricKey)) return 'Ex. 1200';
        if (bonusMetricUsesRecoveryPercent(metricKey)) return 'Ex. 3000';
        return 'Optional';
      }

      function getBonusThresholdLabel(metricKey){
        if (bonusMetricUsesPercentGoal(metricKey)) return 'Starts paying at %';
        if (bonusMetricUsesCurrencyGoal(metricKey)) return 'Starts paying at $';
        if (bonusMetricUsesRecoveryPercent(metricKey)) return 'Starts paying at $';
        return 'Starts paying at';
      }

      function getBonusThresholdStep(metricKey){
        return getBonusTargetStep(metricKey);
      }

      function getBonusThresholdPlaceholder(metricKey){
        return getBonusTargetPlaceholder(metricKey);
      }

      function buildBonusPayoutRuleSummary(metricKey, mode, goalValue, thresholdDisplayValue, capValue){
        var normalizedMode = String(mode || '').trim().toLowerCase();
        if (normalizedMode === 'recovery_percent') {
          var payoutPercent = Number(goalValue);
          var minimumRecovered = Number(thresholdDisplayValue);
          var maxPayoutAmount = Number(capValue);
          var recoveryParts = [];
          if (Number.isFinite(payoutPercent) && payoutPercent > 0) {
            recoveryParts.push('Pays ' + payoutPercent.toFixed(1).replace(/\.0$/, '') + '% of recovered dollars');
          }
          if (Number.isFinite(minimumRecovered) && minimumRecovered > 0) {
            recoveryParts.push('Starts after ' + formatMoney(minimumRecovered));
          }
          if (Number.isFinite(maxPayoutAmount) && maxPayoutAmount > 0) {
            recoveryParts.push('Caps at ' + formatMoney(maxPayoutAmount));
          }
          return recoveryParts.join(' • ') || 'Set a payout percent on recovered dollars.';
        }
        if (normalizedMode !== 'goal') return 'Payout is based on team comparison for this metric.';
        var goal = Number(goalValue);
        var threshold = Number(thresholdDisplayValue);
        var cap = Number(capValue);
        var parts = [];
        if (Number.isFinite(threshold) && threshold > 0) {
          parts.push('Starts paying at ' + formatBonusMetricValue(metricKey, threshold));
        }
        if (Number.isFinite(goal) && goal > 0) {
          parts.push('Full credit at ' + formatBonusMetricValue(metricKey, goal));
        }
        if (Number.isFinite(cap) && cap > 1) {
          parts.push('Caps at ' + String(Math.round(cap * 100)) + '% credit');
        }
        return parts.join(' • ') || 'Set a target and payout ramp for this metric.';
      }

      function getBonusLevelCurveLabel(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'favor_higher_levels') return 'Reward progression';
        if (normalized === 'strongly_favor_higher_levels') return 'Strongly reward progression';
        return 'Balanced';
      }

      function describeBonusLevelCurveHint(value){
        var normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'strongly_favor_higher_levels') return 'Higher levels receive the strongest emphasis.';
        if (normalized === 'favor_higher_levels') return 'Higher levels receive more emphasis.';
        return 'Levels have a moderate influence.';
      }

      function getBonusStaffCategory(option){
        var role = String(option && option.role || '').trim().toLowerCase();
        var group = String(option && option.bonus_role_group || '').trim().toLowerCase();
        if (role.indexOf('owner') >= 0) return 'owner';
        if (group === 'manager' || role.indexOf('manager') >= 0) return 'manager';
        if (role.indexOf('assistant') >= 0 || role.indexOf('support') >= 0 || role.indexOf('finishing') >= 0) return 'assistant';
        return 'stylist';
      }

      function getBonusStaffCategoryLabel(category){
        if (category === 'owner') return 'Owners';
        if (category === 'manager') return 'Managers';
        if (category === 'assistant') return 'Assistants';
        return 'Stylists';
      }

      function formatBonusStaffRoleMeta(option){
        var level = option && option.level != null ? 'L' + option.level : '';
        var rawRole = String(option && option.role || '').trim();
        var cleanedRole = rawRole
          .replace(/\s*\(L\d+\)\s*/gi, ' ')
          .replace(/^Level\s+\d+\s*:\s*/i, '')
          .replace(/\s+/g, ' ')
          .trim();
        return [level, cleanedRole].filter(Boolean).join(' · ');
      }

      function getBonusMetricCategory(metric){
        var key = String(metric && metric.key || '').trim();
        if (key === 'achieved_level' || key === 'progression_accomplishments') return 'Growth and Development';
        if (key === 'prebook_wins' || key === 'recapture_wins' || key === 'retail_followup_wins' || key === 'team_prebook_wins' || key === 'team_recapture_wins' || key === 'team_retail_followup_wins') return 'Business Development';
        if (key === 'reliability_score') return 'Reliability and Attendance';
        if (key === 'attach_rate' || key === 'assistant_support_wins' || key === 'retail_service_ratio' || key === 'product_sales') return 'Retail Success';
        if (key === 'utilization_score' || key === 'production_rate' || key === 'appointment_count' || key === 'service_sales' || key === 'hours_booked' || key === 'hours_scheduled') return 'Service Performance';
        if (key === 'color_discipline_reweigh_rate') return 'Quality and Technical Discipline';
        if (String(metric && metric.scope || '').trim().toLowerCase() === 'salon') return 'Salon Leadership';
        if (key === 'tip_sales') return 'Other Compensation Data';
        return 'Other Compensation Data';
      }

      function buildBonusMetricDraftState(config){
        var weights = config && config.weights ? config.weights : {};
        var metricRules = config && config.rules && config.rules.metric_rules ? config.rules.metric_rules : {};
        return retailArray(bonusMetricCatalog).reduce(function(result, metric){
          var key = String(metric && metric.key || '').trim();
          if (!key) return result;
          var weight = Number(weights[key]);
          if (!Number.isFinite(weight)) weight = Number(metric.default_weight) || 0;
          var rule = metricRules && metricRules[key] ? metricRules[key] : (metric.default_rule || {});
          var isSalonWide = String(metric.scope || '').trim().toLowerCase() === 'salon';
          var mode = String(rule.mode || metric.recommended_mode || 'ranked').trim().toLowerCase();
          if (mode !== 'goal' && mode !== 'recovery_percent') mode = 'ranked';
          if (String(metric.recommended_mode || '').trim().toLowerCase() === 'recovery_percent') mode = 'recovery_percent';
          var payoutPercent = Number(rule.payout_percent);
          if (!Number.isFinite(payoutPercent)) payoutPercent = Number(metric.default_payout_percent) || 0;
          var minimumRecovered = Number(rule.minimum_recovered);
          if (!Number.isFinite(minimumRecovered)) minimumRecovered = Number(metric.default_minimum_recovered) || 0;
          var maxPayout = Number(rule.max_payout);
          if (!Number.isFinite(maxPayout)) maxPayout = Number(metric.default_max_payout) || 0;
          var enabled = rule && rule.enabled === true;
          if (!enabled) {
            enabled = mode === 'recovery_percent'
              ? payoutPercent > 0
              : weight > 0;
          }
          result[key] = {
            enabled: enabled,
            weight: Math.max(0, Math.round(weight)),
            mode: isSalonWide && mode !== 'recovery_percent' ? 'goal' : mode,
            goal: Number.isFinite(Number(rule.goal)) ? Number(rule.goal) : (Number(metric.default_goal) || 0),
            threshold: Number.isFinite(Number(rule.threshold)) ? Number(rule.threshold) : (Number(metric.default_threshold) || 0),
            cap: Number.isFinite(Number(rule.cap)) ? Number(rule.cap) : (Number(metric.default_cap) || 1.25),
            payout_percent: Math.max(0, payoutPercent),
            minimum_recovered: Math.max(0, minimumRecovered),
            max_payout: Math.max(0, maxPayout)
          };
          return result;
        }, {});
      }

      function getBonusMetricSetupState(){
        var selections = getBonusMetricSelectionMap();
        var hasManagers = bonusSelectionHasManagers();
        var poolWeightTotal = 0;
        var activeCount = 0;
        var activePoolCount = 0;
        var activeRecoveryCount = 0;
        retailArray(bonusMetricCatalog).forEach(function(metric){
          var key = String(metric && metric.key || '').trim();
          if (!key) return;
          if (String(metric.audience || '').trim().toLowerCase() === 'manager_only' && !hasManagers) return;
          var selection = selections[key] || {};
          if (selection.enabled !== true) return;
          if (bonusMetricUsesRecoveryPercent(key, selection.mode)) {
            if (Number(selection.payout_percent) > 0) {
              activeCount += 1;
              activeRecoveryCount += 1;
            }
            return;
          }
          if (Number(selection.weight) > 0) {
            activeCount += 1;
            activePoolCount += 1;
            poolWeightTotal += Number(selection.weight) || 0;
          }
        });
        return {
          activeCount: activeCount,
          activePoolCount: activePoolCount,
          activeRecoveryCount: activeRecoveryCount,
          poolWeightTotal: poolWeightTotal
        };
      }

      function bonusMetricIsSalonWide(metricKey){
        var key = String(metricKey || '').trim();
        var metric = retailArray(bonusMetricCatalog).find(function(entry){
          return String(entry && entry.key || '').trim() === key;
        }) || null;
        return String(metric && metric.scope || '').trim().toLowerCase() === 'salon';
      }

      function setBonusBusyState(isBusy){
        bonusUiBusy = isBusy === true;
        if (bonusRangeKind) bonusRangeKind.disabled = bonusUiBusy;
        if (bonusPlanYear) bonusPlanYear.disabled = bonusUiBusy;
        if (bonusPlanQuarter) bonusPlanQuarter.disabled = bonusUiBusy;
        if (bonusCustomDateFrom) bonusCustomDateFrom.disabled = bonusUiBusy;
        if (bonusCustomDateTo) bonusCustomDateTo.disabled = bonusUiBusy;
        if (bonusBudget) bonusBudget.disabled = bonusUiBusy;
        if (bonusNotes) bonusNotes.disabled = bonusUiBusy;
        if (bonusLevelCurve) bonusLevelCurve.disabled = bonusUiBusy;
        if (bonusPublishedToStaff) bonusPublishedToStaff.disabled = bonusUiBusy;
        if (bonusRefreshBtn) bonusRefreshBtn.disabled = bonusUiBusy;
        if (bonusSaveBtn) bonusSaveBtn.disabled = bonusUiBusy;
        if (bonusSelectAllStaffBtn) bonusSelectAllStaffBtn.disabled = bonusUiBusy;
        if (bonusClearStaffBtn) bonusClearStaffBtn.disabled = bonusUiBusy;
        if (bonusIncludedStaff) bonusIncludedStaff.classList.toggle('is-busy', bonusUiBusy);
        if (bonusMetricList) bonusMetricList.classList.toggle('is-busy', bonusUiBusy);
      }

      function describeBonusWeightValue(weight){
        var numeric = Math.max(0, Math.round(Number(weight) || 0));
        if (numeric >= 75) return 'Very high impact';
        if (numeric >= 50) return 'High impact';
        if (numeric >= 25) return 'Medium impact';
        if (numeric > 0) return 'Low impact';
        return 'Off';
      }

      function buildBonusDriverPlainDetail(metricKey, metricLabel, metricValue, rule, weightValue, scoreValue, componentAmount){
        var safeLabel = metricLabel || metricKey || 'This metric';
        var rawMode = String(rule && rule.mode || '').trim().toLowerCase();
        var mode = rawMode === 'recovery_percent' ? 'recovery_percent' : (rawMode === 'goal' ? 'goal' : 'ranked');
        var targetValue = Number(rule && rule.goal);
        var thresholdRatio = Number(rule && rule.threshold);
        var thresholdValue = bonusThresholdRatioToDisplay(targetValue, thresholdRatio);
        var safeAmounts = componentAmount && typeof componentAmount === 'object' ? componentAmount : {};
        var earnedAmount = Number(safeAmounts.earned_amount);
        var leftOnTableAmount = Number(safeAmounts.left_on_table_amount);
        var maxAmount = Number(safeAmounts.max_amount);
        var lines = [];
        if (mode === 'recovery_percent') {
          var recoveredAmount = Number(safeAmounts.recovered_amount);
          var payoutPercent = Number(safeAmounts.payout_percent);
          var minimumRecovered = Number(safeAmounts.minimum_recovered_amount);
          var maxPayout = Number(safeAmounts.max_payout_amount);
          lines.push('Recovered ' + formatBonusMetricValue(metricKey, recoveredAmount) + ' in tracked dollars.');
          if (Number.isFinite(payoutPercent) && payoutPercent > 0) {
            lines.push('This metric pays ' + payoutPercent.toFixed(1).replace(/\.0$/, '') + '% of that recovered amount.');
          }
          if (Number.isFinite(minimumRecovered) && minimumRecovered > 0) {
            lines.push('Payout started after ' + formatMoney(minimumRecovered) + ' was recovered.');
          }
          if (Number.isFinite(earnedAmount)) {
            lines.push('You earned ' + formatMoney(earnedAmount) + ' here.');
          }
          if (Number.isFinite(maxPayout) && maxPayout > 0 && Number.isFinite(leftOnTableAmount) && leftOnTableAmount > 0) {
            lines.push('About ' + formatMoney(leftOnTableAmount) + ' was left on the table because of the cap.');
          }
          return ''
            + '<div class="bonus-driverDetail">'
            +   '<strong>' + escapeHtml(safeLabel) + '</strong>'
            +   lines.map(function(line){
                  return '<span>' + escapeHtml(line) + '</span>';
                }).join('')
            + '</div>';
        }
        if (mode === 'goal' && Number.isFinite(targetValue) && targetValue > 0) {
          lines.push('You got ' + formatBonusMetricValue(metricKey, metricValue) + '. The goal was ' + formatBonusMetricValue(metricKey, targetValue) + '.');
          if (Number.isFinite(thresholdValue) && thresholdValue > 0) {
            lines.push('You started getting credit at ' + formatBonusMetricValue(metricKey, thresholdValue) + '. Full bonus credit was at ' + formatBonusMetricValue(metricKey, targetValue) + '.');
          }
        } else {
          lines.push('You got ' + formatBonusMetricValue(metricKey, metricValue) + ' here.');
        }
        if (Number.isFinite(earnedAmount)) {
          lines.push('You earned ' + formatMoney(earnedAmount) + ' here.');
        }
        if (mode === 'goal') {
          if (Number.isFinite(leftOnTableAmount) && leftOnTableAmount > 0) {
            lines.push('About ' + formatMoney(leftOnTableAmount) + ' was left on the table here.');
          } else if (Number.isFinite(maxAmount) && Number.isFinite(earnedAmount) && earnedAmount >= maxAmount) {
            lines.push('Nothing was left on the table here.');
          }
        } else if (Number.isFinite(scoreValue)) {
          lines.push('This one was based on how you stacked up against the group.');
        }
        return ''
          + '<div class="bonus-driverDetail">'
          +   '<strong>' + escapeHtml(safeLabel) + '</strong>'
          +   lines.map(function(line){
                return '<span>' + escapeHtml(line) + '</span>';
              }).join('')
          + '</div>';
      }

      function bonusThresholdRatioToDisplay(goalValue, thresholdRatio){
        var goal = Number(goalValue);
        var threshold = Number(thresholdRatio);
        if (!Number.isFinite(threshold) || threshold <= 0) return 0;
        if (!Number.isFinite(goal) || goal <= 0) return threshold;
        return goal * threshold;
      }

      function bonusThresholdDisplayToRatio(goalValue, thresholdDisplayValue){
        var goal = Number(goalValue);
        var thresholdDisplay = Number(thresholdDisplayValue);
        if (!Number.isFinite(thresholdDisplay) || thresholdDisplay <= 0) return 0;
        if (!Number.isFinite(goal) || goal <= 0) return 0;
        return thresholdDisplay / goal;
      }

      function syncRecoveryMetricCardUi(card, payoutPercent){
        if (!card || !card.querySelector) return;
        var normalizedPayout = Math.max(0, Number(payoutPercent) || 0);
        var payoutLabel = normalizedPayout.toFixed(1).replace(/\.0$/, '') + '%';
        var valueNode = card.querySelector('[data-bonus-metric-weight-value]');
        var hintNode = card.querySelector('[data-bonus-metric-weight-hint]');
        var summaryPrimary = card.querySelector('.bonus-metricSummaryPrimary');
        var summarySecondary = card.querySelector('[data-bonus-metric-share]');
        if (valueNode) valueNode.textContent = payoutLabel;
        if (hintNode) hintNode.textContent = 'Payout rate: ' + payoutLabel;
        if (summaryPrimary) summaryPrimary.textContent = normalizedPayout > 0 ? ('On · pays ' + payoutLabel) : 'Off';
        if (summarySecondary) summarySecondary.textContent = normalizedPayout > 0 ? (payoutLabel + ' of recovered dollars') : 'Not paying out yet';
      }

      function renderBonusWeightMix(){
        var selections = getBonusMetricSelectionMap();
        var poolMetrics = [];
        var recoveryMetrics = [];
        var hasManagers = bonusSelectionHasManagers();
        retailArray(bonusMetricCatalog).forEach(function(metric){
          var selection = selections[metric.key] || {};
          if (selection.enabled !== true) return;
          if (String(metric.audience || '').trim().toLowerCase() === 'manager_only' && !hasManagers) return;
          if (bonusMetricUsesRecoveryPercent(metric.key, selection.mode)) {
            var payoutPercent = Number(selection.payout_percent) || 0;
            if (payoutPercent <= 0) return;
            recoveryMetrics.push({ label: metric.short_label || metric.label || metric.key, payout_percent: payoutPercent });
            return;
          }
          var weight = Number(selection.weight) || 0;
          if (weight <= 0) return;
          poolMetrics.push({ label: metric.short_label || metric.label || metric.key, weight: weight });
        });
        var totalWeight = poolMetrics.reduce(function(sum, entry){ return sum + entry.weight; }, 0);
        if (bonusActiveMetricsSummary) {
          if (!poolMetrics.length && !recoveryMetrics.length) {
            bonusActiveMetricsSummary.className = 'bonus-activeSummary empty';
            bonusActiveMetricsSummary.innerHTML = '<div class="bonus-activeSummaryHead"><strong>0 active metrics</strong><span class="bonus-activeWeight">No payout rules yet</span></div>';
          } else {
            var poolItems = poolMetrics.map(function(entry){
              return '<div class="bonus-activeMetric"><strong>' + escapeHtml(entry.label) + '</strong><span>' + escapeHtml(String(entry.weight) + '%') + '</span></div>';
            }).join('');
            var recoveryItems = recoveryMetrics.map(function(entry){
              return '<div class="bonus-activeMetric"><strong>' + escapeHtml(entry.label) + '</strong><span>' + escapeHtml(entry.payout_percent.toFixed(1).replace(/\.0$/, '') + '% payout') + '</span></div>';
            }).join('');
            var weightTone = (poolMetrics.length === 0 || totalWeight === 100) ? 'ok' : 'warn';
            bonusActiveMetricsSummary.className = 'bonus-activeSummary';
            bonusActiveMetricsSummary.innerHTML = ''
              + '<div class="bonus-activeSummaryHead"><strong>' + escapeHtml(String(poolMetrics.length + recoveryMetrics.length)) + ' active metrics</strong><span class="bonus-activeWeight bonus-activeWeight--' + escapeHtml(weightTone) + '">' + escapeHtml(poolMetrics.length ? ('Pool weight: ' + String(totalWeight) + '%') : 'Recovery % only') + '</span></div>'
              + (poolItems ? '<div class="bonus-activeMetricList">' + poolItems + '</div>' : '')
              + (recoveryItems ? '<div class="bonus-activeMetricList">' + recoveryItems + '</div>' : '')
              + (poolMetrics.length && totalWeight !== 100 ? '<div class="bonus-activeWarning">Pool weights currently total ' + escapeHtml(String(totalWeight)) + '%. Add ' + escapeHtml(String(Math.max(0, 100 - totalWeight))) + '% before the pool plan is ready.</div>' : '');
          }
        }
        renderBonusReadiness(totalWeight);
        renderBonusRail(totalWeight);
      }

      function renderBonusReadiness(totalWeight){
        if (!bonusReadinessMount) return;
        var selectedStaffIds = getBonusSelectedStaffIds();
        var hasWindow = !!String((bonusPlanQuarter && bonusPlanQuarter.value) || '').trim();
        var setupState = getBonusMetricSetupState();
        var hasBudget = Number((bonusBudget && bonusBudget.value) || 0) > 0;
        var hasMetrics = setupState.activeCount > 0;
        var needsBudget = setupState.activePoolCount > 0;
        var weightComplete = setupState.activePoolCount === 0 || totalWeight === 100;
        var hasPreview = !!(bonusPlanState && bonusPlanState.mode !== 'draft' && bonusPlanState.summary);
        var items = [
          { label: 'Period selected', done: hasWindow },
          { label: 'Bonus pool entered', done: needsBudget ? hasBudget : true },
          { label: 'Team included', done: selectedStaffIds.length > 0 },
          { label: 'At least one metric active', done: hasMetrics },
          { label: setupState.activePoolCount > 0 ? 'Pool weights total 100%' : 'Recovery payout rules set', done: weightComplete },
          { label: 'Preview calculated', done: hasPreview }
        ];
        var statusText = !hasWindow || (needsBudget && !hasBudget) || !selectedStaffIds.length || !hasMetrics
          ? 'Still setting up'
          : (weightComplete ? (hasPreview ? 'Preview ready' : 'Ready to calculate') : 'Weights need attention');
        bonusReadinessMount.className = 'bonus-readiness';
        bonusReadinessMount.innerHTML = ''
          + '<div class="bonus-readinessHead"><strong>Plan Readiness</strong><span>' + escapeHtml(statusText) + '</span></div>'
          + '<div class="bonus-readinessList">'
          + items.map(function(item){
              return '<div class="bonus-readinessItem' + (item.done ? ' is-done' : '') + '"><span>' + escapeHtml(item.done ? '✓' : '—') + '</span><span>' + escapeHtml(item.label) + '</span></div>';
            }).join('')
          + '</div>';
        if (bonusStickyStatus) bonusStickyStatus.textContent = statusText;
        if (bonusRefreshBtn) bonusRefreshBtn.textContent = hasPreview ? 'Refresh Preview' : 'Calculate Preview';
        if (bonusRefreshBtn) bonusRefreshBtn.disabled = bonusUiBusy || !hasWindow || (needsBudget && !hasBudget) || !selectedStaffIds.length || !hasMetrics || !weightComplete;
      }

      function renderBonusRail(totalWeight){
        if (!bonusRailMount) return;
        var windowState = bonusPlanState && bonusPlanState.window ? bonusPlanState.window : {};
        var setupState = getBonusMetricSetupState();
        var selectedStaff = getBonusSelectedStaffIds();
        var selectedLookup = {};
        selectedStaff.forEach(function(id){ selectedLookup[id] = true; });
        var included = retailArray(bonusIncludedStaffOptions).filter(function(option){
          return selectedLookup[String(option.id || '').trim()] === true;
        });
        var counts = { stylist: 0, assistant: 0, manager: 0, owner: 0 };
        included.forEach(function(option){
          counts[getBonusStaffCategory(option)] += 1;
        });
        var activeMetrics = Object.keys(getBonusMetricSelectionMap()).filter(function(key){
          var selection = bonusMetricDraftState[key] || {};
          if (selection.enabled !== true) return false;
          if (bonusMetricUsesRecoveryPercent(key, selection.mode)) return Number(selection.payout_percent) > 0;
          return Number(selection.weight) > 0;
        });
        var previewLabel = bonusPlanState && bonusPlanState.summary && bonusPlanState.summary.calculated_at
          ? 'Preview ready'
          : 'No preview yet';
        var selectedPeriod = parseBonusPeriodSelection((bonusPlanQuarter && bonusPlanQuarter.value) || '');
        var rangeLabel = String((windowState && windowState.range_label) || '').trim()
          || String((selectedPeriod.option && selectedPeriod.option.label) || 'Choose a period').trim();
        bonusRailMount.className = 'bonus-railCard';
        bonusRailMount.innerHTML = ''
          + '<div class="bonus-railHead"><strong>Plan Snapshot</strong><span>' + escapeHtml(rangeLabel) + '</span></div>'
          + '<div class="bonus-railStat"><span>' + escapeHtml(setupState.activePoolCount > 0 ? 'Bonus Pool' : 'Projected Bonus Base') + '</span><strong>' + escapeHtml(formatMoney((bonusBudget && bonusBudget.value) || 0)) + '</strong></div>'
          + '<div class="bonus-railStat"><span>Included Team</span><strong>' + escapeHtml(String(included.length)) + '</strong></div>'
          + '<div class="bonus-railMeta">' + escapeHtml(String(counts.stylist) + ' stylists · ' + String(counts.assistant) + ' assistants · ' + String(counts.manager + counts.owner) + ' leaders') + '</div>'
          + '<div class="bonus-railStat"><span>Active Metrics</span><strong>' + escapeHtml(String(activeMetrics.length)) + '</strong></div>'
          + '<div class="bonus-railStat"><span>' + escapeHtml(setupState.activePoolCount > 0 ? 'Pool Weight' : 'Payout Style') + '</span><strong>' + escapeHtml(setupState.activePoolCount > 0 ? (String(totalWeight) + '%') : 'Recovery %') + '</strong></div>'
          + '<div class="bonus-railStat"><span>Staff Visibility</span><strong>' + escapeHtml(bonusPublishedToStaff && bonusPublishedToStaff.checked ? 'Visible' : 'Managers only') + '</strong></div>'
          + '<div class="bonus-railStat"><span>Preview</span><strong>' + escapeHtml(previewLabel) + '</strong></div>';
      }

      function populateBonusStaffLevelFilter(){
        if (!bonusStaffLevelFilter) return;
        var levels = retailArray(bonusIncludedStaffOptions).map(function(option){
          return Number(option && option.level);
        }).filter(function(level, index, array){
          return Number.isFinite(level) && array.indexOf(level) === index;
        }).sort(function(a, b){ return a - b; });
        bonusStaffLevelFilter.innerHTML = '<option value="all">All levels</option>' + levels.map(function(level){
          return '<option value="' + escapeHtml(String(level)) + '">L' + escapeHtml(String(level)) + '</option>';
        }).join('');
      }

      function renderBonusTeamSummary(){
        if (!bonusTeamSummary) return;
        var selectedStaffIds = getBonusSelectedStaffIds();
        var selectedLookup = {};
        selectedStaffIds.forEach(function(id){ selectedLookup[id] = true; });
        var included = retailArray(bonusIncludedStaffOptions).filter(function(option){
          return selectedLookup[String(option.id || '').trim()] === true;
        });
        var counts = { stylist: 0, assistant: 0, manager: 0, owner: 0 };
        included.forEach(function(option){
          counts[getBonusStaffCategory(option)] += 1;
        });
        if (!included.length) {
          bonusTeamSummary.textContent = 'No team members selected yet. Choose exactly who is included in this bonus pool.';
          return;
        }
        bonusTeamSummary.textContent = included.length + ' of ' + bonusIncludedStaffOptions.length + ' team members included · '
          + counts.stylist + ' stylists · '
          + counts.assistant + ' assistants · '
          + (counts.manager + counts.owner) + ' leaders';
      }

      function renderBonusMetricWeightShares(){
        if (!bonusMetricList || !bonusMetricList.querySelectorAll) return;
        var selections = getBonusMetricSelectionMap();
        var hasManagers = bonusSelectionHasManagers();
        var totals = { individual: 0, salon: 0 };
        retailArray(bonusMetricCatalog).forEach(function(metric){
          var key = String(metric && metric.key || '').trim();
          if (!key) return;
          var selection = selections[key] || {};
          if (selection.enabled !== true) return;
          if (String(metric.audience || '').trim().toLowerCase() === 'manager_only' && !hasManagers) return;
          if (bonusMetricUsesRecoveryPercent(key, selection.mode)) return;
          var weight = Number(selection.weight) || 0;
          if (weight <= 0) return;
          if (String(metric.scope || '').trim().toLowerCase() === 'salon') totals.salon += weight;
          else totals.individual += weight;
        });
        Array.prototype.slice.call(bonusMetricList.querySelectorAll('[data-bonus-metric-key]')).forEach(function(card){
          var key = String(card.getAttribute('data-bonus-metric-key') || '').trim();
          var metric = retailArray(bonusMetricCatalog).find(function(entry){
            return String(entry && entry.key || '').trim() === key;
          }) || null;
          var selection = selections[key] || {};
          var weight = Number(selection.weight) || 0;
          var payoutPercent = Number(selection.payout_percent) || 0;
          var shareNode = card.querySelector('[data-bonus-metric-share]');
          var hintNode = card.querySelector('[data-bonus-metric-weight-hint]');
          var panelNode = card.querySelector('.bonus-metricPanel');
          var isManagerOnly = String(metric && metric.audience || '').trim().toLowerCase() === 'manager_only';
          var scopeKey = String(metric && metric.scope || '').trim().toLowerCase() === 'salon' ? 'salon' : 'individual';
          var scopeTotal = totals[scopeKey] || 0;
          var recoveryMetric = bonusMetricUsesRecoveryPercent(key, selection.mode);
          var enabled = selection.enabled === true && (!isManagerOnly || hasManagers) && (recoveryMetric ? payoutPercent > 0 : weight > 0);
          var sharePercent = !recoveryMetric && enabled && scopeTotal > 0 ? Math.round((weight / scopeTotal) * 100) : 0;
          if (shareNode) {
            shareNode.textContent = recoveryMetric
              ? (enabled ? (payoutPercent.toFixed(1).replace(/\.0$/, '') + '% of recovered dollars') : 'Not paying out yet')
              : (enabled ? (String(sharePercent) + '% of ' + (scopeKey === 'salon' ? 'manager pool' : 'individual pool')) : 'Not affecting the pool yet');
          }
          if (hintNode) {
            hintNode.textContent = recoveryMetric
              ? ('Payout rate: ' + payoutPercent.toFixed(1).replace(/\.0$/, '') + '%')
              : ('How much this metric matters: ' + describeBonusWeightValue(weight));
          }
          if (panelNode) {
            panelNode.open = enabled;
          }
        });
      }

      function syncBonusMetricAvailability(){
        if (!bonusMetricList || !bonusMetricList.querySelectorAll) return;
        var hasManagers = bonusSelectionHasManagers();
        Array.prototype.slice.call(bonusMetricList.querySelectorAll('[data-bonus-metric-key]')).forEach(function(card){
          var audience = String(card.getAttribute('data-bonus-metric-audience') || '').trim().toLowerCase();
          var toggleNode = card.querySelector('[data-bonus-metric-enabled]');
          var weightNode = card.querySelector('[data-bonus-metric-weight]');
          var modeNode = card.querySelector('[data-bonus-metric-mode]');
          var goalNode = card.querySelector('[data-bonus-metric-goal]');
          var payoutNode = card.querySelector('[data-bonus-metric-payout-percent]');
          var minimumRecoveredNode = card.querySelector('[data-bonus-metric-minimum-recovered]');
          var thresholdNode = card.querySelector('[data-bonus-metric-threshold]');
          var maxPayoutNode = card.querySelector('[data-bonus-metric-max-payout]');
          var capNode = card.querySelector('[data-bonus-metric-cap]');
          var disabled = audience === 'manager_only' && !hasManagers;
          var isEnabled = !!(toggleNode && toggleNode.checked);
          var isRecoveryMode = bonusMetricUsesRecoveryPercent(card.getAttribute('data-bonus-metric-key'), String(modeNode && modeNode.value || 'ranked'));
          var isGoalMode = bonusMetricIsSalonWide(card.getAttribute('data-bonus-metric-key'))
            ? true
            : String(modeNode && modeNode.value || 'ranked').trim().toLowerCase() === 'goal';
          if (toggleNode) toggleNode.disabled = disabled;
          if (weightNode) weightNode.disabled = disabled || isRecoveryMode;
          if (modeNode) modeNode.disabled = disabled || !isEnabled || isRecoveryMode;
          if (goalNode) goalNode.disabled = disabled || !isEnabled || !isGoalMode || isRecoveryMode;
          if (payoutNode) payoutNode.disabled = disabled || !isEnabled || !isRecoveryMode;
          if (minimumRecoveredNode) minimumRecoveredNode.disabled = disabled || !isEnabled || !isRecoveryMode;
          if (thresholdNode) thresholdNode.disabled = disabled || !isEnabled || !isGoalMode || isRecoveryMode;
          if (maxPayoutNode) maxPayoutNode.disabled = disabled || !isEnabled || !isRecoveryMode;
          if (capNode) capNode.disabled = disabled || !isEnabled || !isGoalMode || isRecoveryMode;
          card.classList.toggle('is-disabled', disabled);
        });
      }

      function sanitizeBonusWeightInputs(){
        getBonusSelectedMetricInputs().forEach(function(node){
          if (!node) return;
          var numeric = Number(node.value);
          if (!Number.isFinite(numeric) || numeric < 0) {
            node.value = '0';
          } else if (String(node.value).indexOf('.') >= 0) {
            node.value = String(Math.round(numeric));
          }
          var valueNode = node.parentNode && node.parentNode.querySelector
            ? node.parentNode.querySelector('[data-bonus-metric-weight-value]')
            : null;
          if (valueNode) valueNode.textContent = String(Math.max(0, Math.round(Number(node.value) || 0)));
        });
        if (bonusMetricList && bonusMetricList.querySelectorAll) {
          Array.prototype.slice.call(bonusMetricList.querySelectorAll('[data-bonus-metric-threshold]')).forEach(function(node){
            var numeric = Number(node.value);
            if (!Number.isFinite(numeric) || numeric < 0) node.value = '0';
          });
          Array.prototype.slice.call(bonusMetricList.querySelectorAll('[data-bonus-metric-cap]')).forEach(function(node){
            var numeric = Number(node.value);
            if (!Number.isFinite(numeric) || numeric < 1) node.value = '1.25';
          });
        }
        renderBonusWeightMix();
      }

      function renderBonusIncludedStaffSelector(selectedIds){
        if (!bonusIncludedStaff) return;
        var selectedLookup = {};
        retailArray(selectedIds).forEach(function(id){
          selectedLookup[String(id || '').trim()] = true;
        });
        if (!bonusIncludedStaffOptions.length) {
          bonusIncludedStaff.className = 'bonus-staffPicker empty';
          bonusIncludedStaff.textContent = 'Eligible staff will appear here.';
          return;
        }
        var searchValue = String((bonusStaffSearch && bonusStaffSearch.value) || '').trim().toLowerCase();
        var roleFilter = String((bonusStaffRoleFilter && bonusStaffRoleFilter.value) || 'all').trim().toLowerCase();
        var levelFilter = String((bonusStaffLevelFilter && bonusStaffLevelFilter.value) || 'all').trim().toLowerCase();
        var filtered = bonusIncludedStaffOptions.filter(function(option){
          var label = String(option.display_label || option.name || '').toLowerCase();
          var role = String(option.role || '').toLowerCase();
          var category = getBonusStaffCategory(option);
          var level = option.level != null ? String(option.level) : '';
          if (searchValue && label.indexOf(searchValue) === -1 && role.indexOf(searchValue) === -1) return false;
          if (roleFilter !== 'all' && category !== roleFilter) return false;
          if (levelFilter !== 'all' && level !== levelFilter) return false;
          return true;
        });
        bonusIncludedStaff.className = 'bonus-staffPicker';
        if (!filtered.length) {
          bonusIncludedStaff.innerHTML = '<div class="request-review-empty">No team members match these filters.</div>';
          renderBonusTeamSummary();
          return;
        }
        var grouped = filtered.reduce(function(result, option){
          var category = getBonusStaffCategory(option);
          if (!result[category]) result[category] = [];
          result[category].push(option);
          return result;
        }, {});
        var orderedCategories = ['stylist', 'assistant', 'manager', 'owner'].filter(function(category){
          return Array.isArray(grouped[category]) && grouped[category].length;
        });
        bonusIncludedStaff.innerHTML = orderedCategories.map(function(category){
          var rows = grouped[category].map(function(option){
            var id = String(option.id || '').trim();
            var label = option.name || option.display_label || id;
            var meta = formatBonusStaffRoleMeta(option);
            var initials = getInitials(label);
            var isSelected = selectedLookup[id] === true;
            var avatarUrl = String(option.avatar || getAvatarUrl(label) || '').trim();
            var avatarMarkup = avatarUrl
              ? '<span class="bonus-staffAvatar bonus-staffAvatar--photo"><img src="' + escapeHtml(avatarUrl) + '" alt="' + escapeHtml(label) + '" loading="lazy" /></span>'
              : '<span class="bonus-staffAvatar">' + escapeHtml(initials) + '</span>';
            return ''
              + '<button class="bonus-staffOption' + (isSelected ? ' is-selected' : '') + '" type="button" data-bonus-staff-id="' + escapeHtml(id) + '" aria-pressed="' + escapeHtml(isSelected ? 'true' : 'false') + '">'
              +   avatarMarkup
              +   '<span class="bonus-staffOptionBody">'
              +     '<strong>' + escapeHtml(label) + '</strong>'
              +     (meta ? '<small>' + escapeHtml(meta) + '</small>' : '')
              +   '</span>'
              + '</button>';
          }).join('');
          return ''
            + '<details class="bonus-staffGroup" open>'
            +   '<summary>' + escapeHtml(getBonusStaffCategoryLabel(category)) + ' <span>' + escapeHtml(String(grouped[category].length)) + '</span></summary>'
            +   '<div class="bonus-staffGroupGrid">' + rows + '</div>'
            + '</details>';
        }).join('');
        renderBonusTeamSummary();
      }

      function renderBonusMetricSelector(config){
        if (!bonusMetricList) return;
        if (config) {
          bonusMetricDraftState = buildBonusMetricDraftState(config);
        }
        if (!bonusMetricCatalog.length) {
          bonusMetricList.className = 'bonus-metricList empty';
          bonusMetricList.textContent = 'No bonus metrics are available for this period yet.';
          if (bonusMetricAvailableList) {
            bonusMetricAvailableList.className = 'bonus-metricAvailableList empty';
            bonusMetricAvailableList.textContent = 'Try a different range or wait until more source data is available.';
          }
          return;
        }
        var activeMetrics = [];
        var inactiveMetrics = [];
        retailArray(bonusMetricCatalog).forEach(function(metric){
          var key = String(metric.key || '').trim();
          var draft = bonusMetricDraftState[key] || {};
          var isSalonWide = String(metric.scope || '').trim().toLowerCase() === 'salon';
          var mode = isSalonWide ? 'goal' : String(draft.mode || metric.recommended_mode || 'ranked').trim().toLowerCase();
          if (String(metric.recommended_mode || '').trim().toLowerCase() === 'recovery_percent') mode = 'recovery_percent';
          var isRecoveryMode = bonusMetricUsesRecoveryPercent(key, mode);
          var weight = Number(draft.weight);
          if (!Number.isFinite(weight)) weight = Number(metric.default_weight) || 0;
          var payoutPercent = Number(draft.payout_percent);
          if (!Number.isFinite(payoutPercent)) payoutPercent = Number(metric.default_payout_percent) || 0;
          var enabled = draft.enabled === true && (isRecoveryMode ? payoutPercent > 0 : weight > 0);
          var goal = Number(draft.goal);
          if (!Number.isFinite(goal)) goal = Number(metric.default_goal) || 0;
          if (isRecoveryMode) goal = payoutPercent;
          var threshold = Number(draft.threshold);
          if (!Number.isFinite(threshold)) threshold = Number(metric.default_threshold);
          if (!Number.isFinite(threshold)) threshold = 0;
          var minimumRecovered = Number(draft.minimum_recovered);
          if (!Number.isFinite(minimumRecovered)) minimumRecovered = Number(metric.default_minimum_recovered);
          if (!Number.isFinite(minimumRecovered)) minimumRecovered = 0;
          var cap = Number(draft.cap);
          if (!Number.isFinite(cap)) cap = Number(metric.default_cap);
          if (!Number.isFinite(cap) || cap < 1) cap = 1.25;
          var maxPayout = Number(draft.max_payout);
          if (!Number.isFinite(maxPayout)) maxPayout = Number(metric.default_max_payout);
          if (!Number.isFinite(maxPayout)) maxPayout = 0;
          var targetLabel = getBonusTargetLabel(key);
          var targetStep = getBonusTargetStep(key);
          var targetPlaceholder = getBonusTargetPlaceholder(key);
          var thresholdLabel = getBonusThresholdLabel(key);
          var thresholdStep = getBonusThresholdStep(key);
          var thresholdPlaceholder = getBonusThresholdPlaceholder(key);
          var thresholdDisplay = isRecoveryMode ? minimumRecovered : bonusThresholdRatioToDisplay(goal, threshold);
          var payoutRuleSummary = buildBonusPayoutRuleSummary(key, mode, goal, thresholdDisplay, isRecoveryMode ? maxPayout : cap);
          var scopeLabel = String(metric.scope || '').trim().toLowerCase() === 'salon'
            ? 'Salon-wide'
            : 'Individual';
          var availableStaffCount = Math.max(0, Number(metric.available_staff_count || 0) || 0);
          var availabilityMeta = availableStaffCount > 0
            ? (availableStaffCount + ' with data')
            : '';
          var detailOpen = enabled ? ' open' : '';
          var cardHtml = ''
            + '<article class="bonus-metricCard" data-bonus-metric-key="' + escapeHtml(key) + '" data-bonus-metric-audience="' + escapeHtml(String(metric.audience || 'all')) + '">'
            +   '<div class="bonus-metricMeta">'
            +     '<div class="bonus-metricTopline">'
            +       '<label class="bonus-metricToggle">'
            +         '<input type="checkbox" data-bonus-metric-enabled ' + (enabled ? 'checked' : '') + ' />'
            +         '<span>' + escapeHtml(metric.label || key) + '</span>'
            +       '</label>'
            +       '<span class="bonus-metricScope bonus-metricScope--pill">' + escapeHtml(scopeLabel) + '</span>'
            +     '</div>'
            +     (metric.eligibility_note ? '<div class="bonus-metricScope">' + escapeHtml(metric.eligibility_note) + '</div>' : '')
            +     '<p>' + escapeHtml(metric.description || '') + '</p>'
            +   '</div>'
            +   '<details class="bonus-metricPanel"' + detailOpen + '>'
            +     '<summary class="bonus-metricSummary">'
            +       '<span class="bonus-metricSummaryPrimary">' + escapeHtml(enabled ? (isRecoveryMode ? ('On · pays ' + payoutPercent.toFixed(1).replace(/\.0$/, '') + '%') : ('On · weight ' + String(Math.round(weight)))) : 'Off') + '</span>'
            +       '<span class="bonus-metricSummarySecondary" data-bonus-metric-share>Calculating pool share…</span>'
            +     '</summary>'
            +     '<div class="bonus-metricControl">'
            +       (isRecoveryMode
                      ? '<div class="bonus-metricWeightRow">'
                        + '<label class="bonus-metricInlineLabel"><span>Payout percent <small>How much of the recovered dollars this metric pays</small></span><span class="bonus-weightValue" data-bonus-metric-weight-value>' + escapeHtml(payoutPercent.toFixed(1).replace(/\.0$/, '')) + '%</span></label>'
                        + '<input type="range" min="0" max="25" step="0.5" value="' + escapeHtml(String(payoutPercent)) + '" data-bonus-metric-payout-percent />'
                        + '<div class="bonus-metricWeightMeta"><span class="bonus-metricWeightHint" data-bonus-metric-weight-hint>' + escapeHtml('Payout rate: ' + payoutPercent.toFixed(1).replace(/\.0$/, '') + '%') + '</span></div>'
                        + '</div>'
                      : '<div class="bonus-metricWeightRow">'
                        + '<label class="bonus-metricInlineLabel"><span>Weight <small>How much this metric matters</small></span><span class="bonus-weightValue" data-bonus-metric-weight-value>' + escapeHtml(String(Math.round(weight))) + '</span></label>'
                        + '<input type="range" min="0" max="100" step="1" value="' + escapeHtml(String(weight)) + '" data-bonus-metric-weight />'
                        + '<div class="bonus-metricWeightMeta"><span class="bonus-metricWeightHint" data-bonus-metric-weight-hint>' + escapeHtml('How much this metric matters: ' + describeBonusWeightValue(weight)) + '</span></div>'
                        + '</div>')
            +       '<div class="bonus-metricGoalGrid">'
            +         (isRecoveryMode
                      ? '<label><span>Payout style</span><div class="bonus-metricStaticValue">Recovered dollars</div></label>'
                      : isSalonWide
                      ? '<label><span>Payout style</span><div class="bonus-metricStaticValue">Use target</div></label>'
                      : '<label><span>Payout style</span><select data-bonus-metric-mode><option value="ranked"' + (mode === 'ranked' ? ' selected' : '') + '>Compare team</option><option value="goal"' + (mode === 'goal' ? ' selected' : '') + '>Use target</option></select></label>')
            +         (isRecoveryMode
                      ? '<label><span>Payout basis</span><div class="bonus-metricStaticValue">Percent of recovered dollars</div></label>'
                      : '<label><span>' + escapeHtml(targetLabel) + '</span><input type="number" min="0" step="' + escapeHtml(targetStep) + '" value="' + escapeHtml(goal > 0 ? String(goal) : '') + '" placeholder="' + escapeHtml(targetPlaceholder) + '" data-bonus-metric-goal /></label>')
            +       '</div>'
            +       '<details class="bonus-metricAdvanced">'
            +         '<summary>Advanced payout settings</summary>'
            +         '<div class="bonus-metricAdvancedGrid">'
            +           '<label><span>' + escapeHtml(thresholdLabel) + '</span><input type="number" min="0" step="' + escapeHtml(thresholdStep) + '" value="' + escapeHtml(thresholdDisplay > 0 ? String(thresholdDisplay) : '') + '" placeholder="' + escapeHtml(thresholdPlaceholder) + '" ' + (isRecoveryMode ? 'data-bonus-metric-minimum-recovered' : 'data-bonus-metric-threshold') + ' /></label>'
            +           '<label><span>' + escapeHtml(isRecoveryMode ? 'Max payout $' : 'Max payout credit') + '</span><input type="number" min="' + escapeHtml(isRecoveryMode ? '0' : '1') + '" ' + (isRecoveryMode ? 'step="1"' : 'max="3" step="0.05"') + ' value="' + escapeHtml(String(isRecoveryMode ? maxPayout : cap)) + '" ' + (isRecoveryMode ? 'data-bonus-metric-max-payout' : 'data-bonus-metric-cap') + ' /></label>'
            +         '</div>'
            +         '<p>' + escapeHtml(payoutRuleSummary) + '</p>'
            +         '<p>' + escapeHtml(isRecoveryMode ? 'Use this if payout should wait until enough dollars are recovered or stop after a payout ceiling.' : 'Only adjust this if you want payout to start after a minimum result or stop growing after a certain point.') + '</p>'
            +       '</details>'
            +     '</div>'
            +   '</details>'
            + '</article>';
          if (enabled) activeMetrics.push(cardHtml);
          else inactiveMetrics.push({ category: getBonusMetricCategory(metric), html: ''
            + '<button class="bonus-metricAddBtn" type="button" data-bonus-metric-activate="' + escapeHtml(key) + '">'
            +   '<strong>' + escapeHtml(metric.label || key) + '</strong>'
            +   '<span>' + escapeHtml([scopeLabel, metric.eligibility_note || '', availabilityMeta].filter(Boolean).join(' · ')) + '</span>'
            +   (metric.availability_note ? '<small>' + escapeHtml(String(metric.availability_note || '')) + '</small>' : '')
            + '</button>' });
        });
        bonusMetricList.className = activeMetrics.length ? 'bonus-metricList' : 'bonus-metricList empty';
        bonusMetricList.innerHTML = activeMetrics.length ? activeMetrics.join('') : 'No active metrics yet. Add the behaviors this bonus should reward.';
        if (bonusMetricAvailableList) {
          if (!inactiveMetrics.length) {
            bonusMetricAvailableList.className = 'bonus-metricAvailableList empty';
            bonusMetricAvailableList.textContent = 'All available metrics are already active.';
          } else {
            var grouped = inactiveMetrics.reduce(function(result, item){
              if (!result[item.category]) result[item.category] = [];
              result[item.category].push(item.html);
              return result;
            }, {});
            bonusMetricAvailableList.className = 'bonus-metricAvailableList';
            bonusMetricAvailableList.innerHTML = Object.keys(grouped).map(function(category){
              return ''
                + '<details class="bonus-metricAvailableGroup">'
                +   '<summary>' + escapeHtml(category) + '</summary>'
                +   '<div class="bonus-metricAvailableGrid">' + grouped[category].join('') + '</div>'
                + '</details>';
            }).join('');
          }
        }
        sanitizeBonusWeightInputs();
        syncBonusMetricAvailability();
        renderBonusMetricWeightShares();
      }

      function readBonusPlanInput(){
        var selectedPeriod = parseBonusPeriodSelection((bonusPlanQuarter && bonusPlanQuarter.value) || '');
        var rangeKind = selectedPeriod.kind === 'payroll' ? 'payroll' : 'quarter';
        var planYear = Number(selectedPeriod.plan_year || ((bonusPlanYear && bonusPlanYear.value) || new Date().getFullYear()));
        var quarterRawValue = String(selectedPeriod.quarter_label || '').trim();
        var quarterValue = rangeKind === 'quarter' ? quarterRawValue.toUpperCase() : '';
        var selections = getBonusMetricSelectionMap();
        return {
          range_kind: rangeKind,
          plan_year: planYear,
          quarter_value: quarterValue ? (String(planYear) + '-Q' + quarterValue.replace(/^Q/i, '')) : '',
          quarter_label: quarterValue ? ('Q' + quarterValue.replace(/^Q/i, '')) : '',
          payroll_start: rangeKind === 'payroll' ? String(selectedPeriod.raw_value || '') : '',
          date_from: '',
          date_to: '',
          total_budget: Number((bonusBudget && bonusBudget.value) || 0),
          notes: String((bonusNotes && bonusNotes.value) || '').trim(),
          published_to_staff: !!(bonusPublishedToStaff && bonusPublishedToStaff.checked),
          included_staff_ids: getBonusSelectedStaffIds(),
          rules: {
            level_curve: String((bonusLevelCurve && bonusLevelCurve.value) || 'balanced').trim() || 'balanced',
            metric_rules: Object.keys(selections).reduce(function(result, key){
              var metric = getBonusMetricByKey(key);
              var mode = selections[key] && selections[key].mode === 'goal' ? 'goal' : 'ranked';
              if (bonusMetricUsesRecoveryPercent(key, mode) || String(metric && metric.recommended_mode || '').trim().toLowerCase() === 'recovery_percent') {
                mode = 'recovery_percent';
              }
              result[key] = {
                enabled: selections[key] && selections[key].enabled === true,
                mode: mode,
                goal: Number(selections[key] && selections[key].goal) || 0,
                threshold: Number(selections[key] && selections[key].threshold) || 0,
                cap: Number(selections[key] && selections[key].cap) || 1.25,
                payout_percent: Number(selections[key] && selections[key].payout_percent) || 0,
                minimum_recovered: Number(selections[key] && selections[key].minimum_recovered) || 0,
                max_payout: Number(selections[key] && selections[key].max_payout) || 0
              };
              return result;
            }, {})
          },
          weights: Object.keys(selections).reduce(function(result, key){
            var metric = retailArray(bonusMetricCatalog).find(function(entry){
              return String(entry && entry.key || '').trim() === String(key || '').trim();
            }) || null;
            var isManagerOnly = String(metric && metric.audience || '').trim().toLowerCase() === 'manager_only';
            var isRecoveryMetric = bonusMetricUsesRecoveryPercent(key, selections[key] && selections[key].mode);
            result[key] = selections[key] && selections[key].enabled && (!isManagerOnly || bonusSelectionHasManagers()) && !isRecoveryMetric
              ? Number(selections[key].weight) || 0
              : 0;
            return result;
          }, {})
        };
      }

      function applyBonusPlanState(result){
        bonusPlanState = result || null;
        var config = result && result.config ? result.config : {};
        var window = result && result.window ? result.window : {};
        bonusMetricCatalog = Array.isArray(result && result.metric_catalog) ? result.metric_catalog.slice() : [];
        bonusIncludedStaffOptions = Array.isArray(result && result.eligible_staff) ? result.eligible_staff.slice() : [];
        var rawRangeKind = String((window && window.range_kind) || (config && config.range_kind) || (bonusRangeKind && bonusRangeKind.value) || 'quarter').trim().toLowerCase();
        var rangeKind = rawRangeKind === 'payroll' ? 'payroll' : 'quarter';
        if (bonusRangeKind) bonusRangeKind.value = rangeKind;
        var selectedPeriodValue = rangeKind === 'payroll'
          ? ('payroll|' + String((window && window.date_from) || (config && config.payroll_start) || '').trim())
          : ('quarter|' + String((window && window.plan_year) || (bonusPlanYear && bonusPlanYear.value) || new Date().getFullYear()) + '-' + String((window && (window.quarter_label || window.half_label)) || '').trim().replace(/^Q/i, 'Q'));
        syncBonusWindowModeUi({ selectedValue: selectedPeriodValue });
        if (bonusBudget) bonusBudget.value = String(config.total_budget != null ? config.total_budget : (bonusBudget.value || '0'));
        if (bonusNotes) bonusNotes.value = String(config.notes || '');
        if (bonusPublishedToStaff) bonusPublishedToStaff.checked = config.published_to_staff === true;
        var rules = config.rules || {};
        if (bonusLevelCurve) bonusLevelCurve.value = String(rules.level_curve || 'balanced');
        if (bonusLevelCurveHint) bonusLevelCurveHint.textContent = describeBonusLevelCurveHint(rules.level_curve || 'balanced');
        populateBonusStaffLevelFilter();
        renderBonusIncludedStaffSelector(config.included_staff_ids || []);
        renderBonusMetricSelector(config);
        syncBonusMetricAvailability();
        renderBonusWeightMix();
        renderBonusTeamSummary();
      }

      async function fetchBonusPlanRequest(body, fallbackMessage){
        var controller = typeof AbortController === 'function' ? new AbortController() : null;
        var timeoutId = controller ? setTimeout(function(){
          try {
            controller.abort();
          } catch (_error) {}
        }, REQUEST_TIMEOUT_MS) : null;
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
            signal: controller ? controller.signal : undefined
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || fallbackMessage);
          }
          return data;
        } finally {
          if (timeoutId) clearTimeout(timeoutId);
        }
      }

      function renderBonusSummary(){
        if (!bonusSummaryMount) return;
        if (!canManageBonus()) {
          bonusSummaryMount.className = 'empty';
          bonusSummaryMount.textContent = 'Your login can access staff ops, but not bonus planning.';
          return;
        }
        if (!bonusPlanState || !bonusPlanState.summary) {
          bonusSummaryMount.className = 'empty';
          bonusSummaryMount.textContent = 'Bonus summary will appear here.';
          return;
        }
        if (bonusPlanState && bonusPlanState.mode === 'draft') {
          bonusSummaryMount.className = 'empty';
          bonusSummaryMount.textContent = 'Finish the plan setup above to calculate a preview.';
          return;
        }
        var summary = bonusPlanState.summary || {};
        var window = bonusPlanState.window || {};
        var rows = Array.isArray(bonusPlanState && bonusPlanState.allocations) ? bonusPlanState.allocations : [];
        var selectedRange = [formatShortDate(window && window.date_from), formatShortDate(window && window.date_to)].filter(Boolean).join(' - ');
        var previewDateTo = String((summary && summary.preview_date_to) || '').trim();
        var effectiveRange = [formatShortDate(window && window.date_from), formatShortDate(previewDateTo || (window && window.date_to))].filter(Boolean).join(' - ');
        var isPartialLiveWindow = !!previewDateTo && String(previewDateTo) !== String((window && window.date_to) || '');
        var previewRange = isPartialLiveWindow
          ? ('Selected ' + selectedRange + ' · live data through ' + formatShortDate(previewDateTo))
          : selectedRange;
        var poolBudget = Number(summary.pool_budget != null ? summary.pool_budget : summary.total_budget) || 0;
        var poolAllocatedBudget = Number(summary.pool_allocated_budget != null ? summary.pool_allocated_budget : summary.allocated_budget) || 0;
        var recoveryAllocatedBonus = Number(summary.recovery_allocated_bonus) || 0;
        var totalProjectedBonus = Number(summary.allocated_budget || 0) || 0;
        var unallocatedBudget = Math.max(0, poolBudget - poolAllocatedBudget);
        var hasPoolMetrics = Number(summary.pool_metric_count || 0) > 0;
        var hasRecoveryMetrics = Number(summary.recovery_metric_count || 0) > 0;
        var activePayoutRows = rows.filter(function(row){
          return Number((row && row.allocation_amount) || 0) > 0;
        });
        var highestPayout = activePayoutRows.reduce(function(max, row){
          return Math.max(max, Number((row && row.allocation_amount) || 0));
        }, 0);
        var averagePayout = activePayoutRows.length
          ? activePayoutRows.reduce(function(sum, row){
              return sum + (Number((row && row.allocation_amount) || 0) || 0);
            }, 0) / activePayoutRows.length
          : 0;
        bonusSummaryMount.className = 'bonus-previewSummary';
        bonusSummaryMount.innerHTML = ''
          + '<section class="bonus-previewHero">'
          +   '<div class="bonus-previewHeroHead">'
          +     '<div>'
          +       '<p class="bonus-previewEyebrow">Allocation Preview</p>'
          +       '<h3>' + escapeHtml(String((window && window.title) || 'Bonus plan')) + '</h3>'
          +       '<p>' + escapeHtml(previewRange || 'Quarter date range') + '</p>'
          +     '</div>'
          +     '<div class="bonus-previewMeta">'
          +       '<span>' + escapeHtml(((bonusPlanState && bonusPlanState.config && bonusPlanState.config.published_to_staff) === true) ? 'Visible to staff' : 'Manager preview only') + '</span>'
          +       '<span>' + escapeHtml(summary.calculated_at ? ('Updated ' + formatRecaptureDateTime(summary.calculated_at)) : 'Preview calculated') + '</span>'
          +     '</div>'
          +   '</div>'
          +   '<div class="bonus-summaryCardGrid">'
          +     '<article class="bonus-summaryCard"><span>' + escapeHtml(hasPoolMetrics ? 'Bonus Pool' : 'Projected Bonus') + '</span><strong>' + escapeHtml(formatMoney(hasPoolMetrics ? poolBudget : totalProjectedBonus)) + '</strong><small>' + escapeHtml(hasPoolMetrics ? 'Total amount available to distribute for this period.' : 'Live payout projected from the active recovery rules.') + '</small></article>'
          +     '<article class="bonus-summaryCard"><span>Total Projected Payout</span><strong>' + escapeHtml(formatMoney(totalProjectedBonus)) + '</strong><small>' + escapeHtml(String(activePayoutRows.length) + ' team members are currently earning from this plan.' + (isPartialLiveWindow && effectiveRange ? ' Live metrics currently reflect ' + effectiveRange + '.' : '')) + '</small></article>'
          +     '<article class="bonus-summaryCard"><span>' + escapeHtml(hasPoolMetrics ? 'Pool Left on Table' : 'Recovery Bonus') + '</span><strong>' + escapeHtml(formatMoney(hasPoolMetrics ? unallocatedBudget : recoveryAllocatedBonus)) + '</strong><small>' + escapeHtml(hasPoolMetrics ? 'Unallocated pool amount based on the current period performance.' : 'Bonus created by recovered dollars in this period.') + '</small></article>'
          +     '<article class="bonus-summaryCard"><span>Highest Projected Payout</span><strong>' + escapeHtml(formatMoney(highestPayout)) + '</strong><small>' + escapeHtml('Average projected payout: ' + formatMoney(averagePayout)) + '</small></article>'
          +     '<article class="bonus-summaryCard"><span>Metrics Driving This Plan</span><strong>' + escapeHtml(String(summary.individual_metric_count || 0) + ' individual') + '</strong><small>' + escapeHtml(String(summary.salon_metric_count || 0) + ' salon-wide · ' + String(summary.recovery_metric_count || 0) + ' recovery-based') + '</small></article>'
          +     '<article class="bonus-summaryCard"><span>Included Team</span><strong>' + escapeHtml(String(summary.staff_count || 0)) + '</strong><small>' + escapeHtml('Preview calculated for ' + String(summary.staff_count || 0) + ' included team members.') + '</small></article>'
          +   '</div>'
          + '</section>';
      }

      function renderBonusTable(){
        if (!bonusTableMount) return;
        if (!canManageBonus()) {
          bonusTableMount.className = 'empty';
          bonusTableMount.textContent = 'Bonus planning is locked for this login.';
          return;
        }
        var rows = Array.isArray(bonusPlanState && bonusPlanState.allocations) ? bonusPlanState.allocations : [];
        if (!rows.length) {
          bonusTableMount.className = 'empty';
          bonusTableMount.textContent = bonusPlanState && bonusPlanState.mode === 'draft'
            ? 'No preview yet. Calculate a preview to see projected allocations.'
            : 'No staff allocations available yet.';
          return;
        }
        bonusTableMount.className = 'bonus-allocationList';
        var metricRules = bonusPlanState && bonusPlanState.config && bonusPlanState.config.rules && bonusPlanState.config.rules.metric_rules
          ? bonusPlanState.config.rules.metric_rules
          : {};
        var summary = bonusPlanState && bonusPlanState.summary ? bonusPlanState.summary : {};
        var totalBudget = Number(summary.total_budget) || 0;
        var totalProjectedBonus = Number(summary.allocated_budget) || 0;
        var hasPoolMetrics = Number(summary.pool_metric_count || 0) > 0;
        var metricsByKey = retailArray(bonusMetricCatalog).reduce(function(map, metric){
          if (metric && metric.key) map[String(metric.key)] = metric;
          return map;
        }, {});
        bonusTableMount.innerHTML = ''
          + '<div class="bonus-allocationHead">'
          +   '<div>'
          +     '<h3>Projected Allocation</h3>'
          +     '<p>' + escapeHtml(hasPoolMetrics ? 'See who is currently earning, how much of the pool they hold, and what is driving each payout.' : 'See who is currently earning, what their projected payout is, and what is driving it.') + '</p>'
          +   '</div>'
          + '</div>'
          + '<div class="bonus-allocationCards">'
          +     rows.map(function(row){
                  var metrics = row && row.performance_metrics ? row.performance_metrics : {};
                  var weights = row && row.component_weights ? row.component_weights : {};
                  var scores = row && row.component_scores ? row.component_scores : {};
                  var componentAmounts = row && row.component_amounts ? row.component_amounts : {};
                  var topDriverKeys = Object.keys(weights).filter(function(key){
                    return Number(weights[key]) > 0 && Number.isFinite(Number(row && row.component_scores ? row.component_scores[key] : NaN));
                  }).sort(function(a, b){
                    return (Number(weights[b]) || 0) - (Number(weights[a]) || 0);
                  });
                  var recoveryDriverKeys = Object.keys(componentAmounts).filter(function(key){
                    var amount = componentAmounts[key] || {};
                    return String(amount && amount.mode || '').trim().toLowerCase() === 'recovery_percent';
                  }).sort(function(a, b){
                    var left = Number(componentAmounts[a] && componentAmounts[a].earned_amount) || 0;
                    var right = Number(componentAmounts[b] && componentAmounts[b].earned_amount) || 0;
                    return right - left;
                  });
                  var detailKeys = topDriverKeys.concat(recoveryDriverKeys.filter(function(key){
                    return topDriverKeys.indexOf(key) === -1;
                  })).slice(0, 4);
                  var topDrivers = topDriverKeys.slice(0, 3).map(function(key){
                    var label = metricsByKey[key] && metricsByKey[key].short_label
                      ? metricsByKey[key].short_label
                      : metricsByKey[key] && metricsByKey[key].label
                      ? metricsByKey[key].label
                      : key;
                    return label + ' ' + formatBonusMetricValue(key, metrics[key]);
                  });
                  recoveryDriverKeys.slice(0, 3).forEach(function(key){
                    var label = metricsByKey[key] && metricsByKey[key].short_label
                      ? metricsByKey[key].short_label
                      : metricsByKey[key] && metricsByKey[key].label
                      ? metricsByKey[key].label
                      : key;
                    topDrivers.push(label + ' ' + formatBonusMetricValue(key, metrics[key]));
                  });
                  topDrivers = topDrivers.slice(0, 3);
                  var driverDetails = detailKeys.map(function(key){
                    var metric = metricsByKey[key] || {};
                    var rule = metricRules && metricRules[key] ? metricRules[key] : {};
                    var weightValue = Number(weights[key]) || 0;
                    var scoreValue = Number(scores[key]);
                    return buildBonusDriverPlainDetail(
                      key,
                      metric.label || key,
                      metrics[key],
                      rule,
                      weightValue,
                      scoreValue,
                      componentAmounts[key]
                    );
                  }).join('');
                  var allocationAmount = Number((row && row.allocation_amount) || 0);
                  var shareBase = hasPoolMetrics && totalBudget > 0 ? totalBudget : totalProjectedBonus;
                  var shareLabel = hasPoolMetrics && totalBudget > 0 ? 'of pool' : 'of projected total';
                  var shareOfPool = shareBase > 0 ? (allocationAmount / shareBase) * 100 : 0;
                  var roleParts = [
                    row && row.current_level != null ? ('L' + row.current_level) : '',
                    String((row && row.role_name) || '').trim()
                  ].filter(Boolean);
                  var statusLabel = allocationAmount > 0 ? 'Earning bonus' : 'Not qualifying yet';
                  return ''
                    + '<article class="bonus-allocationCard">'
                    +   '<div class="bonus-allocationCardTop">'
                    +     '<div class="bonus-allocationIdentity">'
                    +       '<h4>' + escapeHtml(String((row && row.staff_name) || '')) + '</h4>'
                    +       '<p>' + escapeHtml(roleParts.join(' · ')) + '</p>'
                    +     '</div>'
                    +     '<div class="bonus-allocationPayout">'
                    +       '<strong>' + escapeHtml(formatMoney(allocationAmount)) + '</strong>'
                    +       '<span>' + escapeHtml(formatPercent(shareOfPool) + ' ' + shareLabel) + '</span>'
                    +     '</div>'
                    +   '</div>'
                    +   '<div class="bonus-allocationStats">'
                    +     '<div class="bonus-allocationStat"><span>Status</span><strong>' + escapeHtml(statusLabel) + '</strong></div>'
                    +     '<div class="bonus-allocationStat"><span>Active metrics</span><strong>' + escapeHtml(String(detailKeys.length)) + '</strong></div>'
                    +     '<div class="bonus-allocationStat"><span>' + escapeHtml(hasPoolMetrics ? 'Split score' : 'Payout style') + '</span><strong>' + escapeHtml(hasPoolMetrics ? formatPercent((row && row.normalized_score) || 0) : 'Recovery %') + '</strong></div>'
                    +   '</div>'
                    +   '<div class="bonus-driverSummary">' + escapeHtml(topDrivers.join(' · ') || 'No active bonus metrics yet.') + '</div>'
                    +   '<details class="bonus-allocationDetails">'
                    +     '<summary>View calculation</summary>'
                    +     '<div class="bonus-driverDetails">' + (driverDetails || '<div class="bonus-driverDetail"><span>No metric details available yet.</span></div>') + '</div>'
                    +   '</details>'
                    + '</article>';
                }).join('')
          + '</div>';
      }

      async function fetchBonusPlan(forceRefresh){
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          throw new Error('Use a named admin PIN to manage bonus plans.');
        }
        var body = readBonusPlanInput();
        var setupState = getBonusMetricSetupState();
        var hasBudget = Number(body.total_budget || 0) > 0;
        var hasMetrics = Object.keys(body.weights || {}).some(function(key){
          return Number(body.weights[key]) > 0;
        }) || setupState.activeRecoveryCount > 0;
        var hasIncludedStaff = Array.isArray(body.included_staff_ids) && body.included_staff_ids.length > 0;
        var needsBudget = setupState.activePoolCount > 0;
        if (forceRefresh && (((needsBudget && !hasBudget) || !hasMetrics || !hasIncludedStaff))) {
          return buildBonusDraftStateFromInputs(body);
        }
        body.action = 'bonus-plan-get';
        body.editor_staff_id = currentProgressionEditor.staff_id;
        body.force_refresh = !!forceRefresh;
        return fetchBonusPlanRequest(body, 'Could not load bonus plan.');
      }

      function buildBonusDraftStateFromInputs(body){
        var draftBody = body && typeof body === 'object' ? body : readBonusPlanInput();
        var selectedPeriod = parseBonusPeriodSelection((bonusPlanQuarter && bonusPlanQuarter.value) || '');
        var localRangeKind = String(draftBody.range_kind || selectedPeriod.kind || 'quarter').trim().toLowerCase() === 'payroll' ? 'payroll' : 'quarter';
        var localTitle = localRangeKind === 'payroll'
          ? ((selectedPeriod.option && selectedPeriod.option.label ? selectedPeriod.option.label + ' Bonus' : 'Payroll bonus'))
          : ((selectedPeriod.option && selectedPeriod.option.label ? selectedPeriod.option.label + ' Bonus' : (draftBody.quarter_label ? ('Bonus ' + draftBody.quarter_label) : 'Bonus plan')));
        return {
          ok: true,
          mode: 'draft',
          config: draftBody,
          window: {
            plan_year: draftBody.plan_year,
            range_kind: localRangeKind,
            quarter_label: draftBody.quarter_label || '',
            range_label: localRangeKind === 'payroll'
              ? ((selectedPeriod.option && selectedPeriod.option.label) ? selectedPeriod.option.label : 'Payroll period')
              : ((selectedPeriod.option && selectedPeriod.option.label) ? selectedPeriod.option.label : ((draftBody.quarter_label || '') + (draftBody.plan_year ? (' ' + draftBody.plan_year) : '')).trim()),
            title: localTitle,
            date_from: localRangeKind === 'payroll' ? String(draftBody.payroll_start || '') : String(selectedPeriod.date_from || ''),
            date_to: localRangeKind === 'payroll' ? String(selectedPeriod.date_to || '') : String(selectedPeriod.date_to || '')
          },
          eligible_staff: bonusIncludedStaffOptions.slice(),
          metric_catalog: bonusMetricCatalog.slice(),
          summary: null,
          allocations: []
        };
      }

      function applyBonusDraftStateFromInputs(){
        bonusPlanState = buildBonusDraftStateFromInputs();
        hasLoadedBonus = false;
        renderBonusSummary();
        renderBonusTable();
        renderBonusWeightMix();
        setBonusStatus('Period saved locally. Loading matching bonus metrics...', 'success');
      }

      async function ensureBonusLoaded(forceRefresh, options){
        var settings = options && typeof options === 'object' ? options : {};
        var isBackground = settings.background === true;
        if (hasLoadedBonus && !forceRefresh) return;
        if (!canManageBonus()) {
          renderBonusSummary();
          renderBonusTable();
          return;
        }
        hasLoadedBonus = true;
        var requestVersion = ++bonusRequestVersion;
        if (!isBackground) {
          setBonusBusyState(true);
        }
        try {
          var availableBonusPeriods = getAvailableBonusPeriodOptions();
          var latestBonusPeriod = availableBonusPeriods[0] || null;
          syncBonusWindowModeUi({
            selectedValue: (bonusPlanQuarter && bonusPlanQuarter.value) || (latestBonusPeriod ? latestBonusPeriod.value : '')
          });
          setBonusStatus(isBackground ? 'Loading matching metrics...' : 'Loading bonus plan...');
          var result = await fetchBonusPlan(forceRefresh);
          if (requestVersion !== bonusRequestVersion) return;
          applyBonusPlanState(result);
          renderBonusSummary();
          renderBonusTable();
          setBonusStatus(
            result && result.mode === 'saved'
              ? 'Saved plan loaded.'
              : (result && result.mode === 'draft'
                ? 'Finish the setup above to calculate a preview.'
                : 'Preview loaded.'),
            'success'
          );
        } catch (error) {
          if (requestVersion !== bonusRequestVersion) return;
          hasLoadedBonus = false;
          if (settings.preserveDraftOnError === true) {
            applyBonusDraftStateFromInputs();
          } else {
            bonusPlanState = null;
            renderBonusSummary();
            renderBonusTable();
          }
          setBonusStatus(humanizeClientFetchErrorMessage(error, 'Could not load bonus plan.'), 'error');
        } finally {
          if (!isBackground && requestVersion === bonusRequestVersion) {
            setBonusBusyState(false);
          }
        }
      }

      async function saveBonusPlan(){
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          setBonusStatus('Use a named admin PIN to save bonus plans.', 'error');
          return;
        }
        setBonusBusyState(true);
        try {
          setBonusStatus('Saving bonus plan...');
          var body = readBonusPlanInput();
          body.action = 'bonus-plan-save';
          body.editor_staff_id = currentProgressionEditor.staff_id;
          var data = await fetchBonusPlanRequest(body, 'Could not save bonus plan.');
          hasLoadedBonus = true;
          applyBonusPlanState(data);
          renderBonusSummary();
          renderBonusTable();
          setBonusStatus('Bonus plan saved.', 'success');
        } catch (error) {
          setBonusStatus(humanizeClientFetchErrorMessage(error, 'Could not save bonus plan.'), 'error');
        } finally {
          setBonusBusyState(false);
        }
      }

      function canManageModels(){
        if (!currentStaffOpsPermission) return true;
        return currentStaffOpsPermission.active !== false
          && currentStaffOpsPermission.can_access_staff_ops === true
          && currentStaffOpsPermission.can_manage_retail_followup === true;
      }

      function normalizeModelPhone(value){
        return String(value || '').replace(/\D+/g, '');
      }

      function getModelFutureAppointment(rowOrPhone){
        var phoneKey = typeof rowOrPhone === 'string'
          ? normalizeModelPhone(rowOrPhone)
          : normalizeModelPhone(rowOrPhone && rowOrPhone.phone);
        if (!phoneKey) return null;
        return modelFutureAppointmentByPhone[phoneKey] || null;
      }

      function modelHasFutureAppointment(row){
        var booking = getModelFutureAppointment(row);
        return !!(booking && booking.has_future_appointment);
      }

      function normalizeModelName(value){
        return String(value || '').trim().toLowerCase();
      }

      function restoreHiddenModelIds(){
        try {
          var raw = window.localStorage.getItem(MODELS_HIDDEN_IDS_STORAGE_KEY);
          var parsed = raw ? JSON.parse(raw) : [];
          modelHiddenIds = {};
          (Array.isArray(parsed) ? parsed : []).forEach(function(id){
            var normalized = String(id || '').trim();
            if (normalized) modelHiddenIds[normalized] = true;
          });
        } catch (_error) {
          modelHiddenIds = {};
        }
      }

      function persistHiddenModelIds(){
        try {
          if (!window.localStorage) return;
          window.localStorage.setItem(MODELS_HIDDEN_IDS_STORAGE_KEY, JSON.stringify(Object.keys(modelHiddenIds).filter(Boolean)));
        } catch (_error) {
          // Ignore storage failures.
        }
      }

      function isModelHidden(row){
        var intakeId = String(row && row.id || '').trim();
        return !!(intakeId && modelHiddenIds[intakeId]);
      }

      function hideModelFromDashboard(intakeId){
        var normalizedId = String(intakeId || '').trim();
        if (!normalizedId) return false;
        modelHiddenIds[normalizedId] = true;
        persistHiddenModelIds();
        delete modelIntakeDetailCache[normalizedId];
        if (modelIntakeSelectedId === normalizedId) modelIntakeSelectedId = '';
        return true;
      }

      function buildModelIntakeDedupedRows(rows){
        var grouped = {};
        (Array.isArray(rows) ? rows : []).forEach(function(row){
          if (isModelHidden(row)) return;
          var phoneKey = normalizeModelPhone(row && row.phone);
          var nameKey = normalizeModelName(row && row.name);
          var key = phoneKey || nameKey || String(row && row.id || '').trim();
          if (!key) return;
          if (!grouped[key]) grouped[key] = [];
          grouped[key].push(row);
        });
        return Object.keys(grouped).map(function(key){
          var group = grouped[key].slice().sort(function(a, b){
            return new Date((b && b.created_at) || 0).getTime() - new Date((a && a.created_at) || 0).getTime();
          });
          var latest = Object.assign({}, group[0] || {});
          latest._dedupe_key = key;
          latest._duplicate_count = Math.max(0, group.length - 1);
          latest._all_submissions = group.length;
          latest._photo_total = Math.max(0, Number(latest.inspo_count) || 0) + Math.max(0, Number(latest.current_count) || 0);
          return latest;
        });
      }

      function getModelIntakeLatestRows(){
        if (modelsHideDuplicates && modelsHideDuplicates.checked) {
          return buildModelIntakeDedupedRows(modelIntakeRows);
        }
        return (Array.isArray(modelIntakeRows) ? modelIntakeRows : []).filter(function(row){
          return !isModelHidden(row);
        }).map(function(row){
          var next = Object.assign({}, row || {});
          next._duplicate_count = 0;
          next._all_submissions = 1;
          next._photo_total = Math.max(0, Number(next.inspo_count) || 0) + Math.max(0, Number(next.current_count) || 0);
          return next;
        });
      }

      function modelIntakeMatchesQuickFilter(row){
        var filter = String(modelIntakeActiveFilter || 'all').trim();
        if (!row || filter === 'all') return true;
        if (filter === 'dimension') return row.wants_dimension === true;
        if (filter === 'gray') return row.wants_gray === true;
        if (filter === 'cut') return row.wants_cut === true;
        if (filter === 'extensions') return row.wants_extensions === true;
        if (filter === 'no_tags') {
          return !row.wants_gray && !row.wants_dimension && !row.wants_cut && !row.wants_extensions;
        }
        if (filter === 'duplicates') return Number(row._duplicate_count || 0) > 0;
        if (filter === 'recent') {
          var createdAt = new Date((row && row.created_at) || 0).getTime();
          return Number.isFinite(createdAt) && (Date.now() - createdAt) <= (14 * 24 * 60 * 60 * 1000);
        }
        if (filter === 'booked') return modelHasFutureAppointment(row);
        if (filter === 'open') return !modelHasFutureAppointment(row);
        return true;
      }

      function modelIntakeMatchesPhotoFilter(row){
        var filter = String(modelsPhotoFilter && modelsPhotoFilter.value || 'all').trim();
        var inspoCount = Math.max(0, Number(row && row.inspo_count) || 0);
        var currentCount = Math.max(0, Number(row && row.current_count) || 0);
        if (filter === 'with_photos') return inspoCount > 0 || currentCount > 0;
        if (filter === 'inspo_only') return inspoCount > 0;
        if (filter === 'current_only') return currentCount > 0;
        if (filter === 'missing_photos') return inspoCount === 0 && currentCount === 0;
        return true;
      }

      function getFilteredModelIntakeRows(){
        var search = String(modelsSearch && modelsSearch.value || '').trim().toLowerCase();
        var rows = getModelIntakeLatestRows().filter(function(row){
          if (!modelIntakeMatchesQuickFilter(row)) return false;
          if (!modelIntakeMatchesPhotoFilter(row)) return false;
          if (search) {
            var haystack = [
              row && row.name,
              row && row.phone,
              row && row.id
            ].join(' ').toLowerCase();
            if (haystack.indexOf(search) === -1) return false;
          }
          return true;
        });
        var sortMode = String(modelsSort && modelsSort.value || 'newest').trim();
        rows.sort(function(a, b){
          if (sortMode === 'oldest') {
            return new Date((a && a.created_at) || 0).getTime() - new Date((b && b.created_at) || 0).getTime();
          }
          if (sortMode === 'photos') {
            return Number(b && b._photo_total || 0) - Number(a && a._photo_total || 0);
          }
          if (sortMode === 'duplicates') {
            return Number(b && b._duplicate_count || 0) - Number(a && a._duplicate_count || 0);
          }
          if (sortMode === 'name') {
            return String((a && a.name) || '').localeCompare(String((b && b.name) || ''));
          }
          return new Date((b && b.created_at) || 0).getTime() - new Date((a && a.created_at) || 0).getTime();
        });
        return rows;
      }

      function formatModelIntakeTimestamp(value){
        var parsed = new Date(String(value || '').trim());
        if (Number.isNaN(parsed.getTime())) return '';
        return parsed.toLocaleString(undefined, {
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        });
      }

      function formatModelIntakeRelativeAge(value){
        var parsed = new Date(String(value || '').trim());
        if (Number.isNaN(parsed.getTime())) return '';
        var deltaMs = Date.now() - parsed.getTime();
        if (deltaMs < 60 * 60 * 1000) {
          var minutes = Math.max(1, Math.round(deltaMs / (60 * 1000)));
          return minutes + 'm ago';
        }
        if (deltaMs < 24 * 60 * 60 * 1000) {
          var hours = Math.max(1, Math.round(deltaMs / (60 * 60 * 1000)));
          return hours + 'h ago';
        }
        var days = Math.max(1, Math.round(deltaMs / (24 * 60 * 60 * 1000)));
        return days + 'd ago';
      }

      function formatModelFutureAppointment(value){
        var parsed = new Date(String(value || '').trim());
        if (Number.isNaN(parsed.getTime())) return '';
        return parsed.toLocaleString(undefined, {
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        });
      }

      function formatModelHistoryDate(value){
        var parsed = new Date(String(value || '').trim());
        if (Number.isNaN(parsed.getTime())) return '';
        return parsed.toLocaleDateString(undefined, {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      function escapeModelCardText(value){
        return escapeHtml(String(value == null ? '' : value));
      }

      function renderModelDetailStatusCard(booking){
        if (!modelsDetailStatusCard) return;
        var isBooked = !!(booking && booking.has_future_appointment);
        var dateLabel = isBooked ? formatModelFutureAppointment(booking.future_appointment_at) : '';
        var serviceLabel = booking && Array.isArray(booking.future_service_names) ? booking.future_service_names.join(', ') : '';
        var staffLabel = booking && Array.isArray(booking.future_staff_names) ? booking.future_staff_names.join(', ') : '';
        var supportingLine = '';
        if (isBooked && serviceLabel && staffLabel) {
          supportingLine = serviceLabel + ' with ' + staffLabel;
        } else if (isBooked && serviceLabel) {
          supportingLine = serviceLabel;
        } else if (isBooked && staffLabel) {
          supportingLine = 'Booked with ' + staffLabel;
        } else if (!isBooked) {
          supportingLine = 'No future Boulevard appointment is on the calendar.';
        }
        modelsDetailStatusCard.innerHTML = ''
          + '<div class="models-detailSectionLabel">Boulevard status</div>'
          + '<div class="models-statusPillRow">'
          +   '<span class="models-statusPill ' + (isBooked ? 'is-booked' : 'is-open') + '">' + escapeModelCardText(isBooked ? 'Future booked' : 'Open to schedule') + '</span>'
          + '</div>'
          + '<div class="models-statusHeadline">' + escapeModelCardText(isBooked ? ('Booked ' + (dateLabel || 'soon')) : 'Not booked yet') + '</div>'
          + (supportingLine ? '<div class="models-statusSupport">' + escapeModelCardText(supportingLine) + '</div>' : '');
      }

      function renderModelDetailHistoryCard(booking){
        if (!modelsDetailHistoryCard) return;
        var completedCount = Math.max(0, Number(booking && booking.completed_visit_count) || 0);
        var latestCompletedAt = booking && booking.latest_completed_at ? formatModelHistoryDate(booking.latest_completed_at) : '';
        var latestCompletedServices = booking && Array.isArray(booking.latest_completed_service_names)
          ? booking.latest_completed_service_names.join(', ')
          : '';
        var historyState = String(booking && booking.visit_history_state || '').trim();
        var historyLabel = 'Never visited';
        var historyToneClass = 'is-new';
        var historyHeadline = '';
        var historySupport = '';
        if (historyState === 'returning') {
          historyLabel = 'Returning client';
          historyToneClass = 'is-returning';
          historyHeadline = String(completedCount) + ' completed visit' + (completedCount === 1 ? '' : 's');
          historySupport = [latestCompletedAt ? ('Last completed ' + latestCompletedAt) : '', latestCompletedServices || ''].filter(Boolean).join(' • ');
        } else if (historyState === 'booked_never_completed') {
          historyLabel = 'No completed visits';
          historyToneClass = 'is-incomplete';
          historyHeadline = 'Booked before, never completed';
          historySupport = 'There is appointment history, but no finished visit on record.';
        } else if (booking && booking.has_any_appointment_history) {
          historyLabel = 'Appointment history found';
          historyHeadline = 'No completed visits yet';
          historySupport = 'Boulevard has prior appointment activity, but nothing completed.';
        } else {
          historyLabel = 'Never visited';
          historyHeadline = 'No prior visit history';
          historySupport = 'No booked or completed Boulevard visits found yet.';
        }
        modelsDetailHistoryCard.innerHTML = ''
          + '<div class="models-detailSectionLabel">Visit history</div>'
          + '<div class="models-statusPillRow">'
          +   '<span class="models-statusPill ' + historyToneClass + '">' + escapeModelCardText(historyLabel) + '</span>'
          + '</div>'
          + '<div class="models-statusHeadline">' + escapeModelCardText(historyHeadline || 'No completed visits yet') + '</div>'
          + (historySupport ? '<div class="models-statusSupport">' + escapeModelCardText(historySupport) + '</div>' : '');
      }

      function renderModelIntakeSummary(){
        if (!modelsSummaryMount) return;
        var dedupedRows = buildModelIntakeDedupedRows(modelIntakeRows);
        setTabCount(modelsTabCount, dedupedRows.length);
        modelsSummaryMount.innerHTML = '';
      }

      function renderModelIntakeQuickFilters(){
        if (!modelsQuickFilters) return;
        Array.prototype.slice.call(modelsQuickFilters.querySelectorAll('[data-model-filter-value]')).forEach(function(button){
          var nextFilter = String(button.getAttribute('data-model-filter-value') || '').trim();
          var isActive = nextFilter === modelIntakeActiveFilter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function renderModelIntakeEmptyState(message){
        if (!modelsList) return;
        modelsList.innerHTML = '<div class="request-review-empty">' + escapeHtml(String(message || 'No models match these filters.')) + '</div>';
      }

      function renderModelIntakeList(){
        if (!modelsList) return;
        if (!canManageModels()) {
          renderModelIntakeEmptyState('Your login can open staff ops, but not the model queue.');
          setModelsStatus('Model queue access is locked for this login.', 'error');
          return;
        }
        renderModelIntakeSummary();
        renderModelIntakeQuickFilters();
        var rows = getFilteredModelIntakeRows();
        if (!rows.length) {
          renderModelIntakeEmptyState('No models match these filters.');
          return;
        }
        if (!modelIntakeSelectedId || !rows.some(function(row){ return String(row && row.id || '') === modelIntakeSelectedId; })) {
          modelIntakeSelectedId = String(rows[0] && rows[0].id || '').trim();
        }
        modelsList.innerHTML = rows.map(function(row){
          var intakeId = String((row && row.id) || '').trim();
          var futureBooking = getModelFutureAppointment(row);
          var tags = [];
          if (futureBooking && futureBooking.has_future_appointment) {
            tags.push('Booked ' + String(formatModelFutureAppointment(futureBooking.future_appointment_at) || 'soon'));
          } else {
            tags.push('Open in Boulevard');
          }
          if (row && row.wants_dimension) tags.push('Dimension');
          if (row && row.wants_gray) tags.push('Gray');
          if (row && row.wants_cut) tags.push('Cut');
          if (row && row.wants_extensions) tags.push('Extensions');
          if (!tags.length) tags.push('General');
          tags.push(String(Math.max(0, Number(row && row.inspo_count) || 0)) + ' inspo');
          tags.push(String(Math.max(0, Number(row && row.current_count) || 0)) + ' current');
          if (Number(row && row._duplicate_count || 0) > 0) {
            tags.push('+' + String(Number(row._duplicate_count || 0)) + ' duplicate' + (Number(row._duplicate_count || 0) === 1 ? '' : 's'));
          }
          return ''
            + '<article class="models-row' + (intakeId === modelIntakeSelectedId ? ' is-selected' : '') + '" data-model-id="' + escapeHtml(intakeId) + '">'
            +   '<div class="models-rowMain">'
            +     '<div class="models-rowTop">'
            +       '<div>'
            +         '<div class="models-rowName">' + escapeHtml(String((row && row.name) || '').trim() || 'Model') + '</div>'
            +         '<div class="models-rowPhone">' + escapeHtml(String((row && row.phone) || '').trim() || 'No phone saved') + '</div>'
            +       '</div>'
            +       '<div class="models-rowAge">'
            +         '<div>' + escapeHtml(formatModelIntakeRelativeAge(row && row.created_at)) + '</div>'
            +         '<div class="models-rowTimestamp">' + escapeHtml(formatModelIntakeTimestamp(row && row.created_at)) + '</div>'
            +       '</div>'
            +     '</div>'
            +     '<div class="models-rowTags">' + tags.map(function(tag){
                    return '<span class="models-rowTag">' + escapeHtml(tag) + '</span>';
                  }).join('') + '</div>'
            +   '</div>'
            + '</article>';
        }).join('');
      }

      function refreshModelIntakeView(){
        var previousSelectedId = modelIntakeSelectedId;
        renderModelIntakeSummary();
        renderModelIntakeQuickFilters();
        renderModelIntakeList();
        if (!modelIntakeSelectedId) {
          resetModelIntakeDetail('No models match these filters.');
          return;
        }
        if (modelIntakeSelectedId !== previousSelectedId) {
          selectModelIntake(modelIntakeSelectedId);
        }
      }

      function renderModelIntakeImageGrid(node, urls){
        if (!node) return;
        var images = Array.isArray(urls) ? urls.filter(Boolean) : [];
        if (!images.length) {
          node.innerHTML = '<div class="models-photoEmpty">No photos attached.</div>';
          return;
        }
        node.innerHTML = images.map(function(url, index){
          return '<a class="models-photoLink" href="' + escapeHtml(String(url || '')) + '" target="_blank" rel="noopener">'
            + '<img class="models-photoImage" src="' + escapeHtml(String(url || '')) + '" alt="Model photo ' + String(index + 1) + '" loading="lazy" />'
            + '</a>';
        }).join('');
      }

      function renderModelIntakeDetail(detail){
        var intake = detail && detail.intake && typeof detail.intake === 'object' ? detail.intake : {};
        var name = String((intake && intake.name) || '').trim() || 'Model';
        var phone = String((intake && intake.phone) || '').trim();
        var createdAt = String((intake && intake.created_at) || '').trim();
        var futureBooking = getModelFutureAppointment(phone);
        var futureBookingSummary = futureBooking && futureBooking.has_future_appointment
          ? 'Booked ' + String(formatModelFutureAppointment(futureBooking.future_appointment_at) || 'soon')
          : 'No future Boulevard appointment found';
        if (modelsDetailTitle) modelsDetailTitle.textContent = name;
        if (modelsDetailMeta) {
          modelsDetailMeta.textContent = [phone, formatModelIntakeTimestamp(createdAt), createdAt ? formatModelIntakeRelativeAge(createdAt) : ''].filter(Boolean).join(' • ') || 'No model details available.';
        }
        if (modelsDetailActions) modelsDetailActions.hidden = false;
        if (modelsDetailTextLink) {
          var message = 'Hi ' + (name || 'there') + ' - thanks for sending your model intake. Anything else you want us to know before we reach out?';
          modelsDetailTextLink.setAttribute('href', 'sms:' + encodeURIComponent(phone) + '?&body=' + encodeURIComponent(message));
        }
        renderModelDetailStatusCard(futureBooking || {});
        renderModelDetailHistoryCard(futureBooking || {});
        if (modelsDetailPreferenceTags) {
          var preferenceTags = [];
          if (intake && intake.wants_dimension) preferenceTags.push('Dimension');
          if (intake && intake.wants_gray) preferenceTags.push('Gray');
          if (intake && intake.wants_cut) preferenceTags.push('Cut');
          if (intake && intake.wants_extensions) preferenceTags.push('Extensions');
          if (!preferenceTags.length) preferenceTags.push('General');
          modelsDetailPreferenceTags.innerHTML = preferenceTags.map(function(tag){
            return '<span class="models-rowTag">' + escapeHtml(tag) + '</span>';
          }).join('');
        }
        if (modelsDetailPhotoTags) {
          var photoTags = [];
          photoTags.push(String(Math.max(0, Number(intake && intake.inspo_urls && intake.inspo_urls.length) || 0)) + ' inspo');
          photoTags.push(String(Math.max(0, Number(intake && intake.current_urls && intake.current_urls.length) || 0)) + ' current');
          photoTags.push(futureBookingSummary);
          modelsDetailPhotoTags.innerHTML = photoTags.map(function(tag){
            return '<span class="models-rowTag">' + escapeHtml(tag) + '</span>';
          }).join('');
        }
        if (modelsDetailNotes) modelsDetailNotes.textContent = String((intake && intake.notes) || '').trim() || 'No notes added.';
        renderModelIntakeImageGrid(modelsDetailInspo, intake && intake.inspo_urls);
        renderModelIntakeImageGrid(modelsDetailCurrent, intake && intake.current_urls);
      }

      function resetModelIntakeDetail(message){
        if (modelsDetailTitle) modelsDetailTitle.textContent = 'Choose a model';
        if (modelsDetailMeta) modelsDetailMeta.textContent = String(message || 'Select a row to load notes and photos.');
        if (modelsDetailActions) modelsDetailActions.hidden = true;
        if (modelsDetailStatusCard) modelsDetailStatusCard.innerHTML = '<div class="models-detailSectionLabel">Boulevard status</div><div class="models-detailStatusEmpty">Select a row to see booking status.</div>';
        if (modelsDetailHistoryCard) modelsDetailHistoryCard.innerHTML = '<div class="models-detailSectionLabel">Visit history</div><div class="models-detailStatusEmpty">Select a row to see visit history.</div>';
        if (modelsDetailPreferenceTags) modelsDetailPreferenceTags.innerHTML = '';
        if (modelsDetailPhotoTags) modelsDetailPhotoTags.innerHTML = '';
        if (modelsDetailNotes) modelsDetailNotes.textContent = 'No model selected yet.';
        if (modelsDetailInspo) modelsDetailInspo.innerHTML = '<div class="models-photoEmpty">No model selected yet.</div>';
        if (modelsDetailCurrent) modelsDetailCurrent.innerHTML = '<div class="models-photoEmpty">No model selected yet.</div>';
      }

      async function fetchModelIntakeRows(){
        var params = new URLSearchParams();
        params.set('secret', MODEL_INTAKE_SECRET);
        params.set('limit', '250');
        params.set('offset', '0');
        var response = await fetch(MODEL_INTAKE_LIST_ENDPOINT + '?' + params.toString(), {
          method: 'GET'
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load model intake queue.');
        }
        return data.rows;
      }

      async function fetchModelIntakeDetail(intakeId){
        var response = await fetch(MODEL_INTAKE_GET_ENDPOINT + '?id=' + encodeURIComponent(String(intakeId || '').trim()), {
          method: 'GET'
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.intake) {
          throw new Error((data && data.error) || rawText || 'Could not load model detail.');
        }
        return data;
      }

      async function fetchModelFutureAppointments(rows){
        var phoneKeys = [];
        (Array.isArray(rows) ? rows : []).forEach(function(row){
          var phoneKey = normalizeModelPhone(row && row.phone);
          if (phoneKey && phoneKeys.indexOf(phoneKey) === -1) phoneKeys.push(phoneKey);
        });
        if (!phoneKeys.length) return {};
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'model-future-appointments-by-phone',
            phones: phoneKeys
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load model booking status.');
        }
        return data.rows.reduce(function(map, row){
          var phoneKey = normalizeModelPhone(row && row.phone_key);
          if (phoneKey) map[phoneKey] = row;
          return map;
        }, {});
      }

      async function selectModelIntake(intakeId){
        var nextId = String(intakeId || '').trim();
        if (!nextId) {
          resetModelIntakeDetail();
          return;
        }
        modelIntakeSelectedId = nextId;
        renderModelIntakeList();
        if (modelIntakeDetailCache[nextId]) {
          renderModelIntakeDetail(modelIntakeDetailCache[nextId]);
          return;
        }
        resetModelIntakeDetail('Loading notes and photos...');
        try {
          var detail = await fetchModelIntakeDetail(nextId);
          if (modelIntakeSelectedId !== nextId) return;
          modelIntakeDetailCache[nextId] = detail;
          renderModelIntakeDetail(detail);
        } catch (error) {
          if (modelIntakeSelectedId !== nextId) return;
          resetModelIntakeDetail(humanizeClientFetchErrorMessage(error, 'Could not load model detail.'));
        }
      }

      async function ensureModelsLoaded(forceRefresh){
        if (hasLoadedModels && !forceRefresh) {
          refreshModelIntakeView();
          return;
        }
        if (!canManageModels()) {
          renderModelIntakeList();
          return;
        }
        hasLoadedModels = true;
        var requestVersion = modelIntakeRequestVersion + 1;
        modelIntakeRequestVersion = requestVersion;
        try {
          setModelsStatus('Loading model intake queue...');
          resetModelIntakeDetail('Select a row to load notes and photos.');
          restoreHiddenModelIds();
          modelIntakeRows = await fetchModelIntakeRows();
          if (requestVersion !== modelIntakeRequestVersion) return;
          modelFutureAppointmentByPhone = await fetchModelFutureAppointments(modelIntakeRows);
          if (requestVersion !== modelIntakeRequestVersion) return;
          modelIntakeDetailCache = {};
          refreshModelIntakeView();
          if (modelIntakeSelectedId) {
            await selectModelIntake(modelIntakeSelectedId);
          } else {
            resetModelIntakeDetail('No models match these filters.');
          }
          setModelsStatus('Model intake queue loaded with live Boulevard booking status.', 'success');
        } catch (error) {
          if (requestVersion !== modelIntakeRequestVersion) return;
          hasLoadedModels = false;
          modelIntakeRows = [];
          modelFutureAppointmentByPhone = {};
          renderModelIntakeSummary();
          renderModelIntakeQuickFilters();
          renderModelIntakeEmptyState('Could not load model intake queue.');
          resetModelIntakeDetail(humanizeClientFetchErrorMessage(error, 'Could not load model detail.'));
          setModelsStatus(humanizeClientFetchErrorMessage(error, 'Could not load model intake queue.'), 'error');
        }
      }

      function canManageTodo(){
        if (!currentStaffOpsPermission) return true;
        return currentStaffOpsPermission.active !== false
          && currentStaffOpsPermission.can_access_staff_ops === true
          && currentStaffOpsPermission.can_manage_inventory === true;
      }

      function renderTodoAdminTabs(){
        var pendingCount = (Array.isArray(todoAdminRows) ? todoAdminRows : []).filter(function(row){
          return String((row && row.status) || '').trim().toLowerCase() !== 'completed';
        }).length;
        var completedCount = (Array.isArray(todoAdminRows) ? todoAdminRows : []).filter(function(row){
          return String((row && row.status) || '').trim().toLowerCase() === 'completed';
        }).length;
        setTabCount(todoManagerTabCount, pendingCount);
        setInventoryTabCount(todoCountPending, pendingCount);
        setInventoryTabCount(todoCountCompleted, completedCount);
        [todoTabPending, todoTabCompleted].forEach(function(button){
          if (!button) return;
          var view = String(button.getAttribute('data-todo-view') || '').trim();
          var isActive = view === activeTodoView;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function getFilteredTodoAdminRows(){
        var searchFilter = String(todoSearch && todoSearch.value || '').trim().toLowerCase();
        return (Array.isArray(todoAdminRows) ? todoAdminRows : []).filter(function(row){
          var status = String((row && row.status) || '').trim().toLowerCase();
          if (activeTodoView === 'completed' && status !== 'completed') return false;
          if (activeTodoView !== 'completed' && status === 'completed') return false;
          var haystack = [
            row && row.title,
            row && row.detail,
            row && row.staff_name,
            Array.isArray(row && row.tagged_manager_names) ? row.tagged_manager_names.join(' ') : '',
            row && row.completed_by_staff_name
          ].join(' ').toLowerCase();
          if (searchFilter && haystack.indexOf(searchFilter) === -1) return false;
          return true;
        });
      }

      function renderTodoAdminList(){
        if (!todoAdminList) return;
        if (!canManageTodo()) {
          todoAdminList.innerHTML = '<div class="request-review-empty">Your login can open staff ops, but not the to-do queue.</div>';
          setTodoAdminStatus('To-do access is locked for this login.', 'error');
          return;
        }
        renderTodoAdminTabs();
        var rows = getFilteredTodoAdminRows();
        if (!rows.length) {
          todoAdminList.innerHTML = '<div class="request-review-empty">' + escapeHtml(activeTodoView === 'completed' ? 'No completed to-dos match this search yet.' : 'Nothing open matches this search.') + '</div>';
          return;
        }
        todoAdminList.innerHTML = rows.map(function(row){
          var todoId = String((row && row.id) || '').trim();
          var title = String((row && row.title) || '').trim() || 'Salon to-do';
          var detail = String((row && row.detail) || '').trim();
          var status = String((row && row.status) || '').trim().toLowerCase();
          var staffName = String((row && row.staff_name) || '').trim();
          var taggedManagers = Array.isArray(row && row.tagged_manager_names) ? row.tagged_manager_names : [];
          var createdAt = formatRequestReviewSubmitted(row && row.created_at);
          var completedAt = formatRequestReviewSubmitted(row && row.completed_at);
          var completedBy = String((row && row.completed_by_staff_name) || '').trim();
          var meta = row && row.metadata && typeof row.metadata === 'object' ? row.metadata : {};
          var recurrence = String((meta && meta.recurrence) || '').trim().toLowerCase();
          var recurrenceLabel = recurrence === 'weekly'
            ? 'Repeats weekly'
            : recurrence === 'biweekly'
            ? 'Repeats every 2 weeks'
            : recurrence === 'monthly'
            ? 'Repeats every 4 weeks'
            : '';
          var nextDueDate = String((meta && meta.next_due_date) || '').trim();
          var isCompleted = status === 'completed';
          return ''
            + '<article class="request-review-card inventory-card todo-admin-card">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
            +       '<div class="request-review-name">' + escapeHtml(title) + '</div>'
            +       '<div class="request-review-meta">'
            +         '<div>' + escapeHtml((isCompleted ? 'Completed' : 'Open') + (createdAt ? ' • Posted ' + createdAt : '')) + '</div>'
            +         (staffName ? '<div>' + escapeHtml('Posted by ' + staffName) + '</div>' : '')
            +       '</div>'
            +     '</div>'
            +   '</div>'
            +   '<div class="request-review-copy">' + escapeHtml(detail || 'No detail added.') + '</div>'
            +   '<div class="request-review-meta">'
            +     (recurrenceLabel ? '<span>' + escapeHtml(recurrenceLabel) + (nextDueDate ? ' · Next ' + escapeHtml(nextDueDate) : '') + '</span>' : '')
            +     (taggedManagers.length ? '<span>Tagged ' + escapeHtml(taggedManagers.join(', ')) + '</span>' : '')
            +     (isCompleted && completedAt ? '<span>Done ' + escapeHtml(completedAt) + (completedBy ? ' by ' + escapeHtml(completedBy) : '') + '</span>' : '')
            +   '</div>'
            +   '<div class="inventory-cardControls">'
            +     '<div class="request-off-actions">'
            +       '<button class="' + (isCompleted ? 'btn-secondary' : 'btn-primary') + '" type="button" data-todo-action="' + (isCompleted ? 'reopen' : 'complete') + '" data-todo-id="' + escapeHtml(todoId) + '">' + escapeHtml(isCompleted ? 'Move back to open' : 'Mark completed') + '</button>'
            +     '</div>'
            +   '</div>'
            + '</article>';
        }).join('');
      }

      async function fetchTodoAdminQueue(forceRefresh){
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          throw new Error('Use a named manager login to manage the to-do queue.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'todo-item-admin-list',
            editor_staff_id: currentProgressionEditor.staff_id,
            force_refresh: !!forceRefresh
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load to-do queue.');
        }
        return data.rows;
      }

      async function ensureTodoLoaded(forceRefresh){
        if (hasLoadedTodo && !forceRefresh) return;
        if (!canManageTodo()) {
          renderTodoAdminList();
          return;
        }
        hasLoadedTodo = true;
        try {
          setTodoAdminStatus('Loading to-do queue...');
          todoAdminRows = await fetchTodoAdminQueue(forceRefresh);
          renderTodoAdminTabs();
          renderTodoAdminList();
          setTodoAdminStatus(todoAdminRows.length ? 'Open and completed to-dos are organized here.' : 'No to-do items yet.');
        } catch (error) {
          hasLoadedTodo = false;
          todoAdminRows = [];
          renderTodoAdminTabs();
          renderTodoAdminList();
          setTodoAdminStatus(humanizeClientFetchErrorMessage(error, 'Could not load to-do queue.'), 'error');
        }
      }

      async function saveTodoAdminItem(todoId, nextStatus, button){
        if (!todoId) {
          setTodoAdminStatus('Could not find that to-do item.', 'error');
          return;
        }
        if (button) button.disabled = true;
        setTodoAdminStatus(nextStatus === 'completed' ? 'Completing to-do item...' : 'Moving to-do item back to open...');
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'todo-item-update-status',
              editor_staff_id: currentProgressionEditor.staff_id,
              todo_id: todoId,
              status: String(nextStatus || 'pending')
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !data.row) {
            throw new Error((data && data.error) || rawText || 'Could not save to-do item.');
          }
          hasLoadedTodo = false;
          await ensureTodoLoaded(true);
          setTodoAdminStatus(nextStatus === 'completed' ? 'To-do item completed and texts sent.' : 'To-do item moved back to open.', 'success');
        } catch (error) {
          setTodoAdminStatus(humanizeClientFetchErrorMessage(error, 'Could not save to-do item.'), 'error');
        } finally {
          if (button) button.disabled = false;
        }
      }

      function getFilteredPostAppointmentSmsRows(){
        var statusFilter = String(postAppointmentSmsStatusFilter && postAppointmentSmsStatusFilter.value || '').trim().toLowerCase();
        var familyFilter = String(postAppointmentSmsFamilyFilter && postAppointmentSmsFamilyFilter.value || '').trim().toLowerCase();
        var searchFilter = String(postAppointmentSmsSearch && postAppointmentSmsSearch.value || '').trim().toLowerCase();
        return (Array.isArray(postAppointmentSmsRows) ? postAppointmentSmsRows : []).filter(function(row){
          var status = String((row && (row.status || row.queue_status)) || '').trim().toLowerCase();
          var family = String((row && row.message_family) || '').trim().toLowerCase();
          var haystack = [
            family,
            row && row.client_name,
            row && row.staff_name,
            Array.isArray(row && row.service_names) ? row.service_names.join(' ') : '',
            row && row.drafted_sms_message
          ].join(' ').toLowerCase();
          if (statusFilter && status !== statusFilter) return false;
          if (familyFilter && family !== familyFilter) return false;
          if (searchFilter && haystack.indexOf(searchFilter) === -1) return false;
          return true;
        });
      }

      function getPostAppointmentSmsSettingsFamily(){
        return String(postAppointmentSmsSettingsFamily && postAppointmentSmsSettingsFamily.value || 'post_visit_followup').trim() || 'post_visit_followup';
      }

      function formatPostAppointmentSmsFamilyLabel(value){
        var family = String(value || '').trim().toLowerCase();
        if (family === 'appointment_booked') return 'Appointment booked';
        if (family === 'appointment_arrived') return 'Appointment arrived';
        if (family === 'calendar_item_added') return 'Calendar item added';
        if (family === 'calendar_item_deleted') return 'Calendar item deleted';
        if (family === 'manager_outreach') return 'Manager outreach';
        if (family === 'request_off_submission') return 'Request-off submission';
        if (family === 'request_off_status') return 'Request-off status';
        if (family === 'shift_change_submission') return 'Shift-change submission';
        if (family === 'shift_change_status') return 'Shift-change status';
        if (family === 'todo_created') return 'To-do created';
        if (family === 'todo_completed') return 'To-do completed';
        return 'Post-visit follow-up';
      }

      function applyPostAppointmentSmsSettingsToForm(){
        var settings = postAppointmentSmsSettings || {};
        if (postAppointmentSmsQueueEnabled) postAppointmentSmsQueueEnabled.value = String(settings.queue_enabled !== false);
        if (postAppointmentSmsDelayMinutes) postAppointmentSmsDelayMinutes.value = String(Number(settings.delay_after_close_minutes || 0) || 0);
        if (postAppointmentSmsSuppressFutureBooking) postAppointmentSmsSuppressFutureBooking.value = String(settings.suppress_if_future_booking_exists === true);
        if (postAppointmentSmsDailyCap) postAppointmentSmsDailyCap.value = String(Number(settings.daily_send_cap || 0) || 0);
        if (postAppointmentSmsDuplicateGuardHours) postAppointmentSmsDuplicateGuardHours.value = String(Number(settings.duplicate_guard_hours || 0) || 0);
        if (postAppointmentSmsQuietHoursEnabled) postAppointmentSmsQuietHoursEnabled.value = String(settings.quiet_hours_enabled !== false);
        if (postAppointmentSmsQuietStart) postAppointmentSmsQuietStart.value = String(settings.quiet_hours_start_local || '21:00');
        if (postAppointmentSmsQuietEnd) postAppointmentSmsQuietEnd.value = String(settings.quiet_hours_end_local || '09:00');
      }

      function getPostAppointmentSmsSettingsPayload(){
        return {
          message_family: getPostAppointmentSmsSettingsFamily(),
          queue_enabled: String(postAppointmentSmsQueueEnabled && postAppointmentSmsQueueEnabled.value || 'true') === 'true',
          delay_after_close_minutes: Number(postAppointmentSmsDelayMinutes && postAppointmentSmsDelayMinutes.value || 0) || 0,
          suppress_if_future_booking_exists: String(postAppointmentSmsSuppressFutureBooking && postAppointmentSmsSuppressFutureBooking.value || 'false') === 'true',
          daily_send_cap: Number(postAppointmentSmsDailyCap && postAppointmentSmsDailyCap.value || 0) || 0,
          duplicate_guard_hours: Number(postAppointmentSmsDuplicateGuardHours && postAppointmentSmsDuplicateGuardHours.value || 0) || 0,
          quiet_hours_enabled: String(postAppointmentSmsQuietHoursEnabled && postAppointmentSmsQuietHoursEnabled.value || 'true') === 'true',
          quiet_hours_start_local: String(postAppointmentSmsQuietStart && postAppointmentSmsQuietStart.value || '21:00').trim() || '21:00',
          quiet_hours_end_local: String(postAppointmentSmsQuietEnd && postAppointmentSmsQuietEnd.value || '09:00').trim() || '09:00'
        };
      }

      function renderPostAppointmentSmsQueue(){
        if (!postAppointmentSmsList) return;
        var rows = getFilteredPostAppointmentSmsRows();
        var queuedCount = (Array.isArray(postAppointmentSmsRows) ? postAppointmentSmsRows : []).filter(function(row){
          return String((row && (row.status || row.queue_status)) || '').trim().toLowerCase() === 'queued';
        }).length;
        setTabCount(postAppointmentSmsTabCount, queuedCount);
        if (!rows.length) {
          postAppointmentSmsList.innerHTML = '<div class="request-review-empty">No outbound texts match these filters.</div>';
          return;
        }
        postAppointmentSmsList.innerHTML = rows.map(function(row){
          var queueId = String((row && row.id) || '').trim();
          var status = String((row && (row.status || row.queue_status)) || '').trim().toLowerCase() || 'queued';
          var statusLabel = status.charAt(0).toUpperCase() + status.slice(1);
          var familyKey = String((row && row.message_family) || '').trim().toLowerCase();
          var clientName = String((row && row.client_name) || '').trim() || 'Guest';
          var clientPhone = String((row && row.client_phone) || '').trim();
          var staffName = String((row && row.staff_name) || '').trim();
          var services = Array.isArray(row && row.service_names)
            ? row.service_names.map(function(name){ return String(name || '').trim(); }).filter(Boolean)
            : [];
          var scheduledAt = formatRequestReviewSubmitted(row && row.scheduled_at);
          var sentAt = formatRequestReviewSubmitted(row && row.sent_at);
          var closedAt = formatRequestReviewSubmitted(row && row.appointment_closed_at);
          var appointmentAt = formatRequestReviewSubmitted(row && row.appointment_datetime);
          var engagement = buildPostAppointmentSmsEngagementSummary(row);
          var rating = buildPostAppointmentSmsRatingSummary(row);
          var body = String((row && row.drafted_sms_message) || '').trim();
          var bodyPreview = buildPostAppointmentSmsMessagePreview(body);
          var hasGoLink = /go\.hairstories\.com\/|\/pages\/appt\?token=/i.test(body);
          var suppressionReason = String((row && row.suppression_reason) || '').trim();
          var familyLabel = formatPostAppointmentSmsFamilyLabel(row && row.message_family);
          var isInternalFamily = [
            'calendar_item_added',
            'calendar_item_deleted',
            'manager_outreach',
            'request_off_submission',
            'request_off_status',
            'shift_change_submission',
            'shift_change_status',
            'todo_created',
            'todo_completed'
          ].indexOf(familyKey) !== -1;
          var isPostVisitFamily = familyKey === 'post_visit_followup';
          var isBookedFamily = familyKey === 'appointment_booked';
          var isArrivedFamily = familyKey === 'appointment_arrived';
          var isCalendarFamily = familyKey === 'calendar_item_added' || familyKey === 'calendar_item_deleted';
          var isManagerOutreachFamily = familyKey === 'manager_outreach';
          var showRating = isPostVisitFamily;
          var showEngagement = !isInternalFamily && hasGoLink;
          var visitPrimary = services.length
            ? services.join(' • ')
            : isBookedFamily
            ? 'Upcoming appointment'
            : isArrivedFamily
            ? 'Arrived appointment'
            : isCalendarFamily
            ? 'Calendar notice'
            : isManagerOutreachFamily
            ? 'Manager outreach'
            : 'Completed visit';
          var visitSecondary = [];
          if (!isInternalFamily) {
            if (staffName) visitSecondary.push(staffName);
            if (isBookedFamily && appointmentAt) visitSecondary.push('Booked for ' + appointmentAt);
            else if (isArrivedFamily && closedAt) visitSecondary.push('Arrived ' + closedAt);
            else if (isPostVisitFamily && closedAt) visitSecondary.push('Closed ' + closedAt);
          }
          visitSecondary.push(familyLabel);
          if (suppressionReason) visitSecondary.push(suppressionReason.replace(/_/g, ' '));
          var timingBits = [];
          if (status === 'queued' && scheduledAt) timingBits.push({ key: 'Scheduled', value: scheduledAt });
          if (status === 'sent' && sentAt) timingBits.push({ key: 'Sent', value: sentAt });
          else if (status !== 'queued' && scheduledAt) timingBits.push({ key: 'Scheduled', value: scheduledAt });
          if ((showEngagement || showRating) && engagement.lastActivityAt) {
            timingBits.push({ key: 'Last activity', value: engagement.lastActivityAt });
          }
          var timingMarkup = timingBits.map(function(item){
            return '<div class="post-appointment-sms-timingItem"><span class="post-appointment-sms-timingKey">' + escapeHtml(item.key) + '</span><span class="post-appointment-sms-timingValue">' + escapeHtml(item.value) + '</span></div>';
          }).join('');
          var metricMarkup = '';
          if (showRating) {
            metricMarkup += ''
              + '<div class="post-appointment-sms-cell post-appointment-sms-cell--rating">'
              +   '<div class="post-appointment-sms-cellLabel">Rating</div>'
              +   (rating.ratingValue > 0
                    ? '<div class="post-appointment-sms-ratingStars" aria-label="' + escapeHtml(rating.headline) + '">'
                        + [1, 2, 3, 4, 5].map(function(starIndex){
                            return '<span class="post-appointment-sms-ratingStar' + (starIndex <= rating.ratingValue ? ' is-on' : '') + '">★</span>';
                          }).join('')
                      + '</div>'
                    : '<div class="post-appointment-sms-ratingHeadline">' + escapeHtml(rating.headline) + '</div>')
              +   '<div class="post-appointment-sms-secondary">' + escapeHtml(rating.detail) + '</div>'
              +   (rating.feedback ? '<div class="post-appointment-sms-ratingFeedback">' + escapeHtml(rating.feedback) + '</div>' : '')
              + '</div>';
          }
          if (showEngagement) {
            metricMarkup += ''
              + '<div class="post-appointment-sms-cell post-appointment-sms-cell--engagement">'
              +   '<div class="post-appointment-sms-cellLabel">Engagement</div>'
              +   '<div class="post-appointment-sms-engagementInline">' + escapeHtml(engagement.summary || 'No link activity yet.') + '</div>'
              + '</div>';
          }
          var recipientLabel = isInternalFamily ? 'To' : 'Guest';
          var recipientPrimary = isInternalFamily ? (clientPhone || clientName || 'No phone') : clientName;
          var recipientSecondaryBits = [];
          if (isInternalFamily) {
            if (clientName && clientName !== recipientPrimary) recipientSecondaryBits.push(clientName);
          }
          if (visitSecondary.length) recipientSecondaryBits.push(visitSecondary.join(' · '));
          return ''
            + '<article class="request-review-card inventory-card post-appointment-sms-card" data-status="' + escapeHtml(status) + '">'
            +   '<div class="post-appointment-sms-row">'
            +     '<div class="post-appointment-sms-cell post-appointment-sms-cell--guest">'
            +       '<div class="post-appointment-sms-cellLabel">' + escapeHtml(recipientLabel) + '</div>'
            +       '<div class="request-review-name">' + escapeHtml(recipientPrimary) + '</div>'
            +       '<div class="post-appointment-sms-primary">' + escapeHtml(visitPrimary) + '</div>'
            +       (recipientSecondaryBits.length ? '<div class="post-appointment-sms-secondary">' + escapeHtml(recipientSecondaryBits.join(' · ')) + '</div>' : '')
            +     '</div>'
            +     '<div class="post-appointment-sms-cell post-appointment-sms-cell--message">'
            +       '<div class="post-appointment-sms-cellLabel">Message</div>'
            +       '<div class="post-appointment-sms-messagePreview">' + escapeHtml(bodyPreview) + '</div>'
            +     '</div>'
            +     '<div class="post-appointment-sms-cell post-appointment-sms-cell--timing">'
            +       '<div class="post-appointment-sms-cellLabel">Timing</div>'
            +       '<div class="post-appointment-sms-timingList">' + (timingMarkup || '<div class="post-appointment-sms-secondary">No timing yet.</div>') + '</div>'
            +     '</div>'
            +     metricMarkup
            +     '<div class="post-appointment-sms-actionsColumn">'
            +       '<div class="post-appointment-sms-cellLabel">Status</div>'
            +       '<div class="post-appointment-sms-statusBadge post-appointment-sms-statusBadge--' + escapeHtml(status) + '">' + escapeHtml(statusLabel) + '</div>'
            +       '<div class="request-off-actions">'
            +         (status === 'queued'
                        ? '<button class="btn-primary" type="button" data-post-appointment-sms-action="send-now" data-post-appointment-sms-id="' + escapeHtml(queueId) + '">Send now</button>'
                        : '')
            +         (status === 'queued'
                        ? '<button class="btn-secondary" type="button" data-post-appointment-sms-action="delete" data-post-appointment-sms-id="' + escapeHtml(queueId) + '">Delete</button>'
                        : '')
            +       '</div>'
            +     '</div>'
            +   '</div>'
            + '</article>';
        }).join('');
      }

      async function fetchPostAppointmentSmsQueue(processDue){
        var response = await fetch(RETAIL_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'get-post-appointment-sms-queue',
            message_family: String(postAppointmentSmsFamilyFilter && postAppointmentSmsFamilyFilter.value || '').trim(),
            queue_status: String(postAppointmentSmsStatusFilter && postAppointmentSmsStatusFilter.value || '').trim(),
            process_due: processDue !== false,
            limit: 120
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.rows)) {
          throw new Error((data && data.error) || rawText || 'Could not load outbound text queue.');
        }
        return data;
      }

      async function fetchPostAppointmentSmsSettings(){
        var response = await fetch(RETAIL_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'get-post-appointment-sms-queue-settings',
            message_family: getPostAppointmentSmsSettingsFamily()
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !data.settings) {
          throw new Error((data && data.error) || rawText || 'Could not load outbound text settings.');
        }
        return data.settings;
      }

      async function ensurePostAppointmentSmsLoaded(forceRefresh, processDue){
        if (hasLoadedPostAppointmentSms && !forceRefresh) return;
        hasLoadedPostAppointmentSms = true;
        try {
          setPostAppointmentSmsStatus(processDue === true ? 'Processing due outbound texts...' : 'Loading outbound text queue...');
          var results = await Promise.all([
            fetchPostAppointmentSmsQueue(processDue !== false),
            fetchPostAppointmentSmsSettings()
          ]);
          var data = results[0] || {};
          postAppointmentSmsSettings = results[1] || null;
          applyPostAppointmentSmsSettingsToForm();
          postAppointmentSmsRows = Array.isArray(data.rows) ? data.rows : [];
          renderPostAppointmentSmsQueue();
          var processedCount = Number(data && data.processed && data.processed.processed_count || 0) || 0;
          if (processedCount > 0) {
            setPostAppointmentSmsStatus('Processed ' + String(processedCount) + ' due outbound text' + (processedCount === 1 ? '' : 's') + '.', 'success');
          } else {
            setPostAppointmentSmsStatus(postAppointmentSmsRows.length ? 'Queued, sent, skipped, and deleted outbound texts are shown here.' : 'No outbound texts are queued right now.');
          }
        } catch (error) {
          hasLoadedPostAppointmentSms = false;
          postAppointmentSmsRows = [];
          renderPostAppointmentSmsQueue();
          setPostAppointmentSmsStatus(humanizeClientFetchErrorMessage(error, 'Could not load outbound text queue.'), 'error');
        }
      }

      async function savePostAppointmentSmsSettings(button){
        if (button) button.disabled = true;
        setPostAppointmentSmsStatus('Saving outbound text rules...');
        try {
          var response = await fetch(RETAIL_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(Object.assign({
              action: 'update-post-appointment-sms-queue-settings'
            }, getPostAppointmentSmsSettingsPayload()))
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !data.settings) {
            throw new Error((data && data.error) || rawText || 'Could not save outbound text rules.');
          }
          postAppointmentSmsSettings = data.settings;
          applyPostAppointmentSmsSettingsToForm();
          setPostAppointmentSmsStatus('Outbound text rules saved.', 'success');
          hasLoadedPostAppointmentSms = false;
          await ensurePostAppointmentSmsLoaded(true, false);
        } catch (error) {
          setPostAppointmentSmsStatus(humanizeClientFetchErrorMessage(error, 'Could not save outbound text rules.'), 'error');
        } finally {
          if (button) button.disabled = false;
        }
      }

      async function deletePostAppointmentSmsQueueItem(queueId, button){
        if (!queueId) {
          setPostAppointmentSmsStatus('Could not find that queue item.', 'error');
          return;
        }
        if (button) button.disabled = true;
        setPostAppointmentSmsStatus('Removing text from the queue...');
        try {
          var response = await fetch(RETAIL_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'delete-post-appointment-sms-queue-item',
              queue_id: queueId
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !data.row) {
            throw new Error((data && data.error) || rawText || 'Could not delete post-visit text.');
          }
          postAppointmentSmsRows = (Array.isArray(postAppointmentSmsRows) ? postAppointmentSmsRows : []).map(function(row){
            return String((row && row.id) || '').trim() === queueId ? data.row : row;
          });
          renderPostAppointmentSmsQueue();
          setPostAppointmentSmsStatus('Text removed from the queue.', 'success');
        } catch (error) {
          setPostAppointmentSmsStatus(humanizeClientFetchErrorMessage(error, 'Could not delete outbound text.'), 'error');
        } finally {
          if (button) button.disabled = false;
        }
      }

      async function sendPostAppointmentSmsNow(queueId, button){
        if (!queueId) {
          setPostAppointmentSmsStatus('Could not find that queue item.', 'error');
          return;
        }
        if (button) button.disabled = true;
        setPostAppointmentSmsStatus('Sending outbound text now...');
        try {
          var response = await fetch(RETAIL_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'send-post-appointment-sms-now',
              queue_id: queueId
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not send outbound text.');
          }
          hasLoadedPostAppointmentSms = false;
          await ensurePostAppointmentSmsLoaded(true, false);
          setPostAppointmentSmsStatus('Outbound text sent.', 'success');
        } catch (error) {
          setPostAppointmentSmsStatus(humanizeClientFetchErrorMessage(error, 'Could not send outbound text.'), 'error');
        } finally {
          if (button) button.disabled = false;
        }
      }

      async function updatePostAppointmentSmsQueueItem(queueId, scheduledAtValue, button){
        if (!queueId) {
          setPostAppointmentSmsStatus('Could not find that queue item.', 'error');
          return;
        }
        var nextScheduledAt = String(scheduledAtValue || '').trim();
        if (!nextScheduledAt) {
          setPostAppointmentSmsStatus('Choose a new send date and time first.', 'error');
          return;
        }
        if (button) button.disabled = true;
        setPostAppointmentSmsStatus('Saving new send time...');
        try {
          var response = await fetch(RETAIL_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'update-post-appointment-sms-queue-item',
              queue_id: queueId,
              scheduled_at: new Date(nextScheduledAt).toISOString()
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !data.row) {
            throw new Error((data && data.error) || rawText || 'Could not update the send time.');
          }
          postAppointmentSmsRows = (Array.isArray(postAppointmentSmsRows) ? postAppointmentSmsRows : []).map(function(row){
            return String((row && row.id) || '').trim() === queueId ? data.row : row;
          });
          renderPostAppointmentSmsQueue();
          setPostAppointmentSmsStatus('Send time updated.', 'success');
        } catch (error) {
          setPostAppointmentSmsStatus(humanizeClientFetchErrorMessage(error, 'Could not update the send time.'), 'error');
        } finally {
          if (button) button.disabled = false;
        }
      }

      function canManageInventory(){
        if (!currentStaffOpsPermission) return true;
        return currentStaffOpsPermission.active !== false
          && currentStaffOpsPermission.can_access_staff_ops === true
          && currentStaffOpsPermission.can_manage_inventory === true;
      }

      function setInventoryTabCount(node, count){
        if (!node) return;
        var value = Math.max(0, Number(count) || 0);
        node.textContent = String(value);
        node.hidden = value <= 0;
      }

      function normalizeInventoryText(value){
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/&/g, 'and')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      }

      function inventoryVariantQuantityByState(variant, stateName){
        var normalizedState = String(stateName || '').trim().toLowerCase();
        var locations = Array.isArray(variant && variant.locations) ? variant.locations : [];
        if (!locations.length || !normalizedState) return null;
        return locations.reduce(function(total, location){
          var quantities = Array.isArray(location && location.quantities) ? location.quantities : [];
          return total + quantities.reduce(function(sum, entry){
            if (String((entry && entry.name) || '').trim().toLowerCase() !== normalizedState) return sum;
            var quantity = Number(entry && entry.quantity);
            return sum + (Number.isFinite(quantity) ? quantity : 0);
          }, 0);
        }, 0);
      }

      function inventoryVariantOnHandQuantity(variant){
        var onHand = inventoryVariantQuantityByState(variant, 'on_hand');
        if (Number.isFinite(onHand)) return onHand;
        var legacyQuantity = Number(variant && variant.inventory_quantity);
        return Number.isFinite(legacyQuantity) ? legacyQuantity : 0;
      }

      function inventoryVariantIncomingQuantity(variant){
        return inventoryVariantQuantityByState(variant, 'incoming');
      }

      function inventoryTransferIsOpen(transfer){
        var status = String((transfer && transfer.status) || '').trim().toUpperCase();
        return status === 'READY_TO_SHIP' || status === 'IN_PROGRESS';
      }

      function inventoryProductNeedsAttention(product){
        var variants = Array.isArray(product && product.variants) ? product.variants : [];
        if (!variants.length) return true;
        return variants.some(function(variant){
          if (!variant || variant.tracked !== true) return true;
          var quantity = inventoryVariantOnHandQuantity(variant);
          return !Number.isFinite(quantity) || quantity <= 0;
        });
      }

      function inventoryProductTotalQuantity(product){
        return (Array.isArray(product && product.variants) ? product.variants : []).reduce(function(sum, variant){
          var quantity = inventoryVariantOnHandQuantity(variant);
          return sum + (Number.isFinite(quantity) ? quantity : 0);
        }, 0);
      }

      function inventoryProductDisplayName(product){
        var title = String((product && product.title) || '').trim();
        return title
          .replace(/^THE FULL STORY Genius Weft -\s*/i, '')
          .replace(/^THE FULL STORY -\s*/i, '')
          .trim() || title || 'Inventory Item';
      }

      function inventoryProductShadeMeta(product){
        var handleKey = normalizeInventoryText(product && product.handle);
        var titleKey = normalizeInventoryText(inventoryProductDisplayName(product));
        var displayName = inventoryProductDisplayName(product);
        var match = (handleKey && longStoryShadeByHandle[handleKey]) || (titleKey && longStoryShadeByDisplayName[titleKey]) || null;
        if (match) return match;
        match = displayName.match(/^(.*)\s+(Rooted Blend|Rooted Solid|Micro Blend|Blend|Solid)$/i);
        if (match) {
          return {
            label: String(match[1] || '').trim() || displayName,
            category: String(match[2] || '').trim(),
            straight_asset: String((product && product.image_url) || '').trim(),
            wave_asset: ''
          };
        }
        return {
          label: displayName,
          category: '',
          straight_asset: String((product && product.image_url) || '').trim(),
          wave_asset: ''
        };
      }

      function inventoryGroupHandleFromUrl(value){
        var url = String(value || '').trim();
        if (!url) return '';
        var match = url.match(/\/products\/([^/?#]+)/i);
        return normalizeInventoryText(match && match[1] ? decodeURIComponent(match[1]) : '');
      }

      function inventoryOrderedGroupMatchesProduct(group, product, shadeMeta){
        var productHandle = normalizeInventoryText(product && product.handle);
        var orderedHandle = inventoryGroupHandleFromUrl(group && group.product_url);
        if (productHandle && orderedHandle && productHandle === orderedHandle) return true;
        var label = String(shadeMeta && shadeMeta.label || inventoryProductDisplayName(product)).trim();
        var displayCandidates = [
          inventoryProductDisplayName(product),
          label,
          (product && product.title) || ''
        ].map(normalizeInventoryText).filter(Boolean);
        var orderedCandidates = [
          group && group.item_name,
          group && group.matched_catalog_name,
          group && group.suggested_catalog_name
        ].map(normalizeInventoryText).filter(Boolean);
        return orderedCandidates.some(function(candidate){
          return displayCandidates.indexOf(candidate) >= 0;
        });
      }

      function inventoryProductOrderedSummary(product, shadeMeta){
        var matches = (Array.isArray(inventoryOrderedGroups) ? inventoryOrderedGroups : []).filter(function(group){
          return inventoryOrderedGroupMatchesProduct(group, product, shadeMeta);
        });
        if (!matches.length) return null;
        var latestGroup = matches.slice().sort(function(left, right){
          return String((right && right.last_ordered_at) || '').localeCompare(String((left && left.last_ordered_at) || ''));
        })[0] || null;
        if (!latestGroup) return null;
        return {
          count: matches.length,
          lastOrderedAt: String((latestGroup && latestGroup.last_ordered_at) || '').trim()
        };
      }

      function inventoryProductTransferSummary(product){
        var itemIds = (Array.isArray(product && product.variants) ? product.variants : []).map(function(variant){
          return String((variant && variant.inventory_item_id) || '').trim();
        }).filter(Boolean);
        var skus = (Array.isArray(product && product.variants) ? product.variants : []).map(function(variant){
          return normalizeInventoryText(variant && variant.sku);
        }).filter(Boolean);
        if (!itemIds.length && !skus.length) return null;
        var matches = (Array.isArray(inventoryTransferSummaries) ? inventoryTransferSummaries : []).filter(function(transfer){
          if (!inventoryTransferIsOpen(transfer)) return false;
          var items = Array.isArray(transfer && transfer.items) ? transfer.items : [];
          return items.some(function(item){
            var inventoryItemId = String((item && item.inventory_item_id) || '').trim();
            var sku = normalizeInventoryText(item && item.sku);
            return itemIds.indexOf(inventoryItemId) >= 0 || (sku && skus.indexOf(sku) >= 0);
          });
        });
        if (!matches.length) return null;
        var latestTransfer = matches.slice().sort(function(left, right){
          return String((right && right.date_created) || '').localeCompare(String((left && left.date_created) || ''));
        })[0] || null;
        if (!latestTransfer) return null;
        var transferStatus = String((latestTransfer && latestTransfer.status) || '').trim().toUpperCase();
        if (transferStatus === 'TRANSFERRED' || transferStatus === 'RECEIVED' || transferStatus === 'COMPLETED' || transferStatus === 'CANCELLED' || transferStatus === 'CANCELED') {
          return null;
        }
        var itemQuantity = matches.reduce(function(sum, transfer){
          var items = Array.isArray(transfer && transfer.items) ? transfer.items : [];
          return sum + items.reduce(function(itemSum, item){
            var inventoryItemId = String((item && item.inventory_item_id) || '').trim();
            var sku = normalizeInventoryText(item && item.sku);
            if (itemIds.indexOf(inventoryItemId) === -1 && (!sku || skus.indexOf(sku) === -1)) {
              return itemSum;
            }
            var quantity = Number(item && item.total_quantity);
            return itemSum + (Number.isFinite(quantity) ? quantity : 0);
          }, 0);
        }, 0);
        return {
          count: matches.length,
          name: String((latestTransfer && latestTransfer.name) || '').trim(),
          orderedAt: String((latestTransfer && latestTransfer.date_created) || '').trim(),
          totalQuantity: itemQuantity
        };
      }

      function inventoryVariantTransferSummary(variant){
        var inventoryItemId = String((variant && variant.inventory_item_id) || '').trim();
        var sku = normalizeInventoryText(variant && variant.sku);
        if (!inventoryItemId && !sku) return null;
        var incomingQuantity = inventoryVariantIncomingQuantity(variant);
        var matches = (Array.isArray(inventoryTransferSummaries) ? inventoryTransferSummaries : []).filter(function(transfer){
          if (!inventoryTransferIsOpen(transfer)) return false;
          var items = Array.isArray(transfer && transfer.items) ? transfer.items : [];
          return items.some(function(item){
            var itemInventoryId = String((item && item.inventory_item_id) || '').trim();
            var itemSku = normalizeInventoryText(item && item.sku);
            return (inventoryItemId && itemInventoryId === inventoryItemId) || (sku && itemSku === sku);
          });
        });
        if (!matches.length) {
          if (!Number.isFinite(incomingQuantity) || incomingQuantity <= 0) return null;
          return {
            count: 0,
            name: '',
            orderedAt: '',
            totalQuantity: incomingQuantity
          };
        }
        var latestTransfer = matches.slice().sort(function(left, right){
          return String((right && right.date_created) || '').localeCompare(String((left && left.date_created) || ''));
        })[0] || null;
        if (!latestTransfer) return null;
        var transferStatus = String((latestTransfer && latestTransfer.status) || '').trim().toUpperCase();
        if (transferStatus === 'TRANSFERRED' || transferStatus === 'RECEIVED' || transferStatus === 'COMPLETED' || transferStatus === 'CANCELLED' || transferStatus === 'CANCELED') {
          return null;
        }
        var matchedItems = matches.reduce(function(list, transfer){
          var items = Array.isArray(transfer && transfer.items) ? transfer.items : [];
          items.forEach(function(item){
            var itemInventoryId = String((item && item.inventory_item_id) || '').trim();
            var itemSku = normalizeInventoryText(item && item.sku);
            if ((inventoryItemId && itemInventoryId === inventoryItemId) || (sku && itemSku === sku)) {
              list.push(item);
            }
          });
          return list;
        }, []);
        var totalQuantity = matchedItems.reduce(function(sum, item){
          var quantity = Number(item && item.total_quantity);
          return sum + (Number.isFinite(quantity) ? quantity : 0);
        }, 0);
        if (Number.isFinite(incomingQuantity)) {
          totalQuantity = incomingQuantity;
        }
        if (totalQuantity <= 0) return null;
        return {
          count: matches.length,
          name: String((latestTransfer && latestTransfer.name) || '').trim(),
          orderedAt: String((latestTransfer && latestTransfer.date_created) || '').trim(),
          totalQuantity: totalQuantity
        };
      }

      function inventoryVariantTextureLabel(value){
        var texture = String(value || '').trim().toLowerCase();
        if (!texture) return '';
        if (texture === 'light natural wave') return 'LNW';
        if (texture === 'straight') return 'STR';
        return String(value || '').trim();
      }

      function renderInventoryTabs(){
        var neededCount = (Array.isArray(inventoryGroups) ? inventoryGroups : []).filter(function(group){
          return String((group && group.status) || '').trim().toLowerCase() !== 'ordered';
        }).length;
        var fullStoryCount = (Array.isArray(inventoryShopifyProducts) ? inventoryShopifyProducts : []).length;
        setTabCount(inventoryManagerTabCount, neededCount);
        setTabCount(fullStoryManagerTabCount, fullStoryCount);
        setInventoryTabCount(inventoryCountNeeded, neededCount);
        setInventoryTabCount(inventoryCountOrdered, 0);
        [inventoryTabNeeded, inventoryTabOrdered].forEach(function(button){
          if (!button) return;
          var view = String(button.getAttribute('data-inventory-view') || '').trim();
          var isActive = view === activeInventoryView;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function renderFullStoryTabs(){
        var inventoryCount = getFilteredInventoryShopifyProducts().length;
        var orderCount = getFilteredFullStoryOrders().length;
        setInventoryTabCount(fullStoryCountInventory, inventoryCount);
        setInventoryTabCount(fullStoryCountOrders, orderCount);
        [fullStoryTabInventory, fullStoryTabOrders].forEach(function(button){
          if (!button) return;
          var view = String(button.getAttribute('data-full-story-view') || '').trim();
          var isActive = view === activeFullStoryView;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function getFilteredInventoryGroups(){
        var searchFilter = String(inventorySearch && inventorySearch.value || '').trim().toLowerCase();
        return (Array.isArray(inventoryGroups) ? inventoryGroups : []).filter(function(group){
          var status = String((group && group.status) || '').trim().toLowerCase();
          var haystack = [
            group && group.item_name,
            group && group.category,
            group && group.latest_note,
            Array.isArray(group && group.requested_by) ? group.requested_by.join(' ') : '',
            group && group.suggested_catalog_name
          ].join(' ').toLowerCase();
          if (status === 'ordered') return false;
          if (searchFilter && haystack.indexOf(searchFilter) === -1) return false;
          return true;
        });
      }

      function getFilteredInventoryShopifyProducts(){
        var searchFilter = String(fullStorySearch && fullStorySearch.value || '').trim().toLowerCase();
        return (Array.isArray(inventoryShopifyProducts) ? inventoryShopifyProducts : []).filter(function(product){
          var handle = String((product && product.handle) || '').trim().toLowerCase();
          if (
            handle === 'the-full-story-genius-weft-ba8-60'
            || handle === 'the-full-story-genius-weft-8a-10n'
          ) return false;
          var variants = Array.isArray(product && product.variants) ? product.variants : [];
          var haystack = [
            product && product.title,
            product && product.handle,
            variants.map(function(variant){
              return [
                variant && variant.variant_title,
                variant && variant.sku
              ].join(' ');
            }).join(' ')
          ].join(' ').toLowerCase();
          if (searchFilter && haystack.indexOf(searchFilter) === -1) return false;
          return true;
        });
      }

      function getFilteredFullStoryOrders(){
        var searchFilter = String(fullStorySearch && fullStorySearch.value || '').trim().toLowerCase();
        return (Array.isArray(fullStoryShopifyOrders) ? fullStoryShopifyOrders : []).filter(function(order){
          var lines = Array.isArray(order && order.lines) ? order.lines : [];
          var haystack = [
            order && order.order_name,
            order && order.customer_name,
            order && order.customer_email,
            order && order.customer_phone,
            order && order.financial_status,
            order && order.fulfillment_status,
            lines.map(function(line){
              return [
                line && line.product_title,
                line && line.variant_title,
                line && line.sku
              ].join(' ');
            }).join(' ')
          ].join(' ').toLowerCase();
          if (searchFilter && haystack.indexOf(searchFilter) === -1) return false;
          return true;
        });
      }

      function renderGeniusWeftInventoryGrid(target, emptyText){
        if (!target) return;
        target.classList.add('request-review-list--genius');
        var products = getFilteredInventoryShopifyProducts().slice().sort(function(left, right){
          var leftNeedsAttention = inventoryProductNeedsAttention(left) ? 0 : 1;
          var rightNeedsAttention = inventoryProductNeedsAttention(right) ? 0 : 1;
          if (leftNeedsAttention !== rightNeedsAttention) return leftNeedsAttention - rightNeedsAttention;
          return inventoryProductDisplayName(left).localeCompare(inventoryProductDisplayName(right));
        });
        if (!products.length) {
          target.innerHTML = '<div class="request-review-empty">' + escapeHtml(String(emptyText || 'No products matched this search.')) + '</div>';
          return;
        }
        target.innerHTML = products.map(function(product){
          var shadeMeta = inventoryProductShadeMeta(product);
          var shadeLabel = String(shadeMeta && shadeMeta.label || inventoryProductDisplayName(product)).trim();
          var shadeCategory = String(shadeMeta && shadeMeta.category || '').trim();
          var shadeImage = String(shadeMeta && shadeMeta.straight_asset || (product && product.image_url) || '').trim();
          var shadeStyle = shadeImage ? ' style="--inventory-swatch-image:url(' + escapeHtml(shadeImage) + ');"' : '';
          var variants = Array.isArray(product && product.variants) ? product.variants : [];
          var variantMarkup = variants.map(function(variant){
            var tracked = variant && variant.tracked === true;
            var variantQuantity = inventoryVariantOnHandQuantity(variant);
            var safeQuantity = Number.isFinite(variantQuantity) ? variantQuantity : 0;
            var variantTitle = String((variant && variant.variant_title) || 'Variant');
            var variantParts = variantTitle.split(' / ');
            var length = String(variantParts[0] || '').trim();
            var texture = String(variantParts[1] || '').trim();
            var compactTexture = inventoryVariantTextureLabel(texture);
            var transferSummary = inventoryVariantTransferSummary(variant);
            var tone = tracked
              ? (safeQuantity > 0 ? 'in-stock' : (transferSummary ? 'ordered' : 'out'))
              : 'tracking-off';
            var variantOrderMarkup = transferSummary
              ? '<div class="inventory-genius-variantOrder">'
                  + '<span class="inventory-genius-variantOrderQty">' + escapeHtml(String(transferSummary.totalQuantity || 0)) + ' on order</span>'
                  + (transferSummary.name ? '<span class="inventory-genius-variantOrderRef">' + escapeHtml(transferSummary.name) + '</span>' : '')
                + '</div>'
              : '';
            return ''
              + '<div class="inventory-genius-variant inventory-genius-variant--' + tone + '">'
              +   '<div class="inventory-genius-variantMeta">'
              +     '<div class="inventory-genius-variantSku">' + escapeHtml(String((variant && variant.sku) || '')) + '</div>'
              +     '<div class="inventory-genius-variantTopline">'
              +       '<span class="inventory-genius-variantLength">' + escapeHtml(length || variantTitle) + '</span>'
              +       (compactTexture ? '<span class="inventory-genius-variantTexture">' + escapeHtml(compactTexture) + '</span>' : '')
              +     '</div>'
              +     variantOrderMarkup
              +   '</div>'
              +   '<div class="inventory-genius-variantQty">'
              +     '<strong>' + escapeHtml(String(safeQuantity)) + '</strong>'
              +     (tracked ? '' : '<span>Tracking off</span>')
              +   '</div>'
              + '</div>';
          }).join('');
          return ''
            + '<article class="request-review-card inventory-genius-card">'
            +   '<div class="inventory-genius-cardCode"' + shadeStyle + '>'
            +     '<div class="inventory-genius-cardCodeMeta">'
            +       '<div class="inventory-genius-cardCodeValue">' + escapeHtml(shadeLabel) + '</div>'
            +       (shadeCategory ? '<div class="inventory-genius-cardCodeCategory">' + escapeHtml(shadeCategory) + '</div>' : '')
            +     '</div>'
            +   '</div>'
            +   '<div class="inventory-genius-cardBody">'
            +     '<div class="inventory-genius-variantGrid">' + variantMarkup + '</div>'
            +   '</div>'
            + '</article>';
        }).join('');
      }

      function updateInventoryStatusForActiveView(){
        setInventoryStatus(
          inventoryGroups.length
            ? 'Only supply requests that still need action are shown here.'
            : 'No supply requests need action right now.'
        );
      }

      function renderFullStoryList(){
        if (!fullStoryList) return;
        fullStoryList.classList.remove('request-review-list--genius');
        if (!canManageInventory()) {
          fullStoryList.innerHTML = '<div class="request-review-empty">Your login can open staff ops, but not The Full Story inventory.</div>';
          setFullStoryStatus('The Full Story access is locked for this login.', 'error');
          return;
        }
        var products = getFilteredInventoryShopifyProducts().slice().sort(function(left, right){
          var leftNeedsAttention = inventoryProductNeedsAttention(left) ? 0 : 1;
          var rightNeedsAttention = inventoryProductNeedsAttention(right) ? 0 : 1;
          if (leftNeedsAttention !== rightNeedsAttention) return leftNeedsAttention - rightNeedsAttention;
          return inventoryProductDisplayName(left).localeCompare(inventoryProductDisplayName(right));
        });
        var orders = getFilteredFullStoryOrders().slice().sort(function(left, right){
          var leftTime = Date.parse(String((left && (left.processed_at || left.created_at)) || '')) || 0;
          var rightTime = Date.parse(String((right && (right.processed_at || right.created_at)) || '')) || 0;
          return rightTime - leftTime;
        });
        renderFullStoryTabs();
        var inventoryMarkup = products.length
          ? '<div class="request-review-list request-review-list--genius inventory-fullStoryInventory">'
              + products.map(function(product){
                  var shadeMeta = inventoryProductShadeMeta(product);
                  var shadeLabel = String(shadeMeta && shadeMeta.label || inventoryProductDisplayName(product)).trim();
                  var shadeCategory = String(shadeMeta && shadeMeta.category || '').trim();
                  var shadeImage = String(shadeMeta && shadeMeta.straight_asset || (product && product.image_url) || '').trim();
                  var shadeStyle = shadeImage ? ' style="--inventory-swatch-image:url(' + escapeHtml(shadeImage) + ');"' : '';
                  var variants = Array.isArray(product && product.variants) ? product.variants : [];
                  var variantMarkup = variants.map(function(variant){
                    var tracked = variant && variant.tracked === true;
                    var variantQuantity = inventoryVariantOnHandQuantity(variant);
                    var safeQuantity = Number.isFinite(variantQuantity) ? variantQuantity : 0;
                    var variantTitle = String((variant && variant.variant_title) || 'Variant');
                    var variantParts = variantTitle.split(' / ');
                    var length = String(variantParts[0] || '').trim();
                    var texture = String(variantParts[1] || '').trim();
                    var compactTexture = inventoryVariantTextureLabel(texture);
                    var transferSummary = inventoryVariantTransferSummary(variant);
                    var tone = tracked
                      ? (safeQuantity > 0 ? 'in-stock' : (transferSummary ? 'ordered' : 'out'))
                      : 'tracking-off';
                    var variantOrderMarkup = transferSummary
                      ? '<div class="inventory-genius-variantOrder">'
                          + '<span class="inventory-genius-variantOrderQty">' + escapeHtml(String(transferSummary.totalQuantity || 0)) + ' on order</span>'
                          + (transferSummary.name ? '<span class="inventory-genius-variantOrderRef">' + escapeHtml(transferSummary.name) + '</span>' : '')
                        + '</div>'
                      : '';
                    return ''
                      + '<div class="inventory-genius-variant inventory-genius-variant--' + tone + '">'
                      +   '<div class="inventory-genius-variantMeta">'
                      +     '<div class="inventory-genius-variantSku">' + escapeHtml(String((variant && variant.sku) || '')) + '</div>'
                      +     '<div class="inventory-genius-variantTopline">'
                      +       '<span class="inventory-genius-variantLength">' + escapeHtml(length || variantTitle) + '</span>'
                      +       (compactTexture ? '<span class="inventory-genius-variantTexture">' + escapeHtml(compactTexture) + '</span>' : '')
                      +     '</div>'
                      +     variantOrderMarkup
                      +   '</div>'
                      +   '<div class="inventory-genius-variantQty">'
                      +     '<strong>' + escapeHtml(String(safeQuantity)) + '</strong>'
                      +     (tracked ? '' : '<span>Tracking off</span>')
                      +   '</div>'
                      + '</div>';
                  }).join('');
                  return ''
                    + '<article class="request-review-card inventory-genius-card">'
                    +   '<div class="inventory-genius-cardCode"' + shadeStyle + '>'
                    +     '<div class="inventory-genius-cardCodeMeta">'
                    +       '<div class="inventory-genius-cardCodeValue">' + escapeHtml(shadeLabel) + '</div>'
                    +       (shadeCategory ? '<div class="inventory-genius-cardCodeCategory">' + escapeHtml(shadeCategory) + '</div>' : '')
                    +     '</div>'
                    +   '</div>'
                    +   '<div class="inventory-genius-cardBody">'
                    +     '<div class="inventory-genius-variantGrid">' + variantMarkup + '</div>'
                    +   '</div>'
                    + '</article>';
                }).join('')
            + '</div>'
          : '<div class="request-review-empty">No The Full Story products matched this search.</div>';
        var ordersMarkup = orders.length
          ? '<div class="inventory-fullStoryOrders">'
              + orders.map(function(order){
                  var lines = Array.isArray(order && order.lines) ? order.lines : [];
                  var orderTitle = String((order && order.order_name) || '').trim() || 'Shopify order';
                  var customerName = String((order && order.customer_name) || '').trim();
                  var clientName = String((order && order.client_name) || '').trim();
                  var customerEmail = String((order && order.customer_email) || '').trim();
                  var customerPhone = String((order && order.customer_phone) || '').trim();
                  var orderContact = [customerEmail, customerPhone].filter(Boolean).join(' • ');
                  var processedAt = formatRequestReviewSubmitted(order && (order.processed_at || order.created_at));
                  var financialStatus = String((order && order.financial_status) || '').trim();
                  var fulfillmentStatus = String((order && order.fulfillment_status) || '').trim();
                  var totalPrice = Number(order && order.total_price);
                  var totalQuantity = Number(order && order.total_quantity);
                  var totalLabel = Number.isFinite(totalPrice) ? formatMoney(totalPrice) : '';
                  var lineMarkup = lines.map(function(line){
                    var quantity = Number(line && line.current_quantity);
                    if (!Number.isFinite(quantity)) quantity = Number(line && line.quantity);
                    var restockedQuantity = Number(line && line.restocked_quantity);
                    var amount = Number(line && line.total_amount);
                    var lineMetaParts = [line && line.variant_title, line && line.sku].filter(Boolean);
                    if (Number.isFinite(restockedQuantity) && restockedQuantity > 0) {
                      lineMetaParts.push(String(restockedQuantity) + ' restocked');
                    }
                    var lineMeta = lineMetaParts.join(' • ');
                    return ''
                      + '<div class="inventory-fullStoryOrderLine">'
                      +   '<div class="inventory-fullStoryOrderLineMain">'
                      +     '<div class="inventory-fullStoryOrderLineTitle">' + escapeHtml(String((line && line.product_title) || 'The Full Story item')) + '</div>'
                      +     (lineMeta ? '<div class="inventory-fullStoryOrderLineMeta">' + escapeHtml(lineMeta) + '</div>' : '')
                      +   '</div>'
                      +   '<div class="inventory-fullStoryOrderLineQty">'
                      +     '<strong>' + escapeHtml(String(Number.isFinite(quantity) ? quantity : 0)) + '</strong>'
                      +     (Number.isFinite(amount) && amount > 0 ? '<span>' + escapeHtml(formatMoney(amount)) + '</span>' : '')
                      +   '</div>'
                      + '</div>';
                  }).join('');
                  return ''
                    + '<article class="request-review-card inventory-fullStoryOrderCard">'
                    +   '<div class="inventory-fullStoryOrderTop">'
                    +     '<div class="inventory-fullStoryOrderIdentity">'
                    +       '<div class="inventory-fullStoryOrderEyebrow">' + escapeHtml(orderTitle) + '</div>'
                    +       '<div class="inventory-fullStoryOrderBuyer">' + escapeHtml(customerName || 'Customer') + '</div>'
                    +       (clientName ? '<div class="inventory-fullStoryOrderClient">Client: ' + escapeHtml(clientName) + '</div>' : '')
                    +       (orderContact ? '<div class="inventory-fullStoryOrderContact">' + escapeHtml(orderContact) + '</div>' : '')
                    +     '</div>'
                    +     '<div class="inventory-fullStoryOrderTotal">'
                    +       (totalLabel ? '<strong>' + escapeHtml(totalLabel) + '</strong>' : '')
                    +       '<span>' + escapeHtml(String(Number.isFinite(totalQuantity) ? totalQuantity : lines.length) + ' active items') + '</span>'
                    +     '</div>'
                    +   '</div>'
                    +   '<div class="inventory-fullStoryOrderMeta">'
                    +     (processedAt ? '<span class="inventory-fullStoryOrderMetaDate">' + escapeHtml(processedAt) + '</span>' : '')
                    +     (financialStatus ? '<span class="inventory-fullStoryOrderPill">' + escapeHtml(financialStatus) + '</span>' : '')
                    +     (fulfillmentStatus ? '<span class="inventory-fullStoryOrderPill inventory-fullStoryOrderPill--muted">' + escapeHtml(fulfillmentStatus) + '</span>' : '')
                    +   '</div>'
                    +   '<div class="inventory-fullStoryOrderLines">' + lineMarkup + '</div>'
                    + '</article>';
                }).join('')
            + '</div>'
          : '<div class="request-review-empty">No Shopify orders containing The Full Story products matched this search.</div>';
        fullStoryList.innerHTML = activeFullStoryView === 'orders' ? ordersMarkup : inventoryMarkup;
        var hasProducts = Array.isArray(inventoryShopifyProducts) && inventoryShopifyProducts.length > 0;
        var orderCount = Array.isArray(fullStoryShopifyOrders) ? fullStoryShopifyOrders.length : 0;
        setFullStoryStatus(
          hasProducts
            ? (activeFullStoryView === 'orders'
                ? 'Every Shopify order containing The Full Story products is shown here.'
                : 'Live Shopify stock is shown shade by shade.')
            : 'No The Full Story products were returned from Shopify.',
          hasProducts
            ? (orderCount ? 'success' : 'warning')
            : 'error'
        );
      }

      function renderInventoryList(){
        if (!inventoryList) return;
        inventoryList.classList.remove('request-review-list--genius');
        if (!canManageInventory()) {
          inventoryList.innerHTML = '<div class="request-review-empty">Your login can open staff ops, but not the inventory queue.</div>';
          setInventoryStatus('Inventory access is locked for this login.', 'error');
          return;
        }
        renderInventoryTabs();
        var groups = getFilteredInventoryGroups();
        if (!groups.length) {
          inventoryList.innerHTML = '<div class="request-review-empty">Nothing still needs action right now.</div>';
          return;
        }
        inventoryList.innerHTML = groups.map(function(group){
          var groupKey = String((group && group.key) || '').trim();
          var itemName = String((group && group.item_name) || '').trim() || 'Supply item';
          var status = String((group && group.status) || '').trim().toLowerCase();
          var latestNote = String((group && group.latest_note) || '').trim();
          var requestedBy = Array.isArray(group && group.requested_by)
            ? group.requested_by.map(function(name){
                return String(name || '').trim();
              }).filter(Boolean)
            : [];
          var lastOrderedAt = formatRequestReviewSubmitted(group && group.last_ordered_at);
          var latestRequestedAt = formatRequestReviewSubmitted(group && group.latest_request_at);
          var isOrdered = status === 'ordered';
          var isDismissible = !isOrdered;
          var primaryMeta = latestRequestedAt ? 'Last requested ' + latestRequestedAt : 'Recently requested';
          var requesterMeta = requestedBy.length
            ? 'Requested by ' + requestedBy.join(', ')
            : '';
          return ''
            + '<article class="request-review-card inventory-card">'
            +   '<div class="request-review-card-head">'
            +     '<div class="request-review-card-main">'
            +       '<div class="request-review-name">' + escapeHtml(itemName) + '</div>'
            +       '<div class="request-review-meta">'
            +         '<div>' + escapeHtml(primaryMeta) + '</div>'
            +         (requesterMeta ? '<div>' + escapeHtml(requesterMeta) + '</div>' : '')
            +       '</div>'
            +     '</div>'
            +   '</div>'
            +   '<div class="request-review-copy">' + escapeHtml(latestNote || 'No note added.') + '</div>'
            +   '<div class="inventory-cardControls">'
            +     '<div class="request-off-actions">'
            +       '<button class="btn-primary" type="button" data-inventory-action="order" data-inventory-group="' + escapeHtml(groupKey) + '">Mark ordered today</button>'
            +       (isDismissible
                      ? '<button class="btn-secondary" type="button" data-inventory-action="dismiss" data-inventory-group="' + escapeHtml(groupKey) + '">Not ordering</button>'
                      : '')
            +     '</div>'
            +   '</div>'
            + '</article>';
        }).join('');
      }

      async function fetchInventoryQueue(forceRefresh){
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          throw new Error('Use a named inventory-enabled login to manage inventory.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'supply-request-admin-list',
            editor_staff_id: currentProgressionEditor.staff_id,
            force_refresh: !!forceRefresh
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.groups)) {
          throw new Error((data && data.error) || rawText || 'Could not load inventory queue.');
        }
        return {
          groups: data.groups,
          orderedGroups: Array.isArray(data.ordered_groups) ? data.ordered_groups : []
        };
      }

      async function fetchGeniusWeftInventory(forceRefresh){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'shopify-product-inventory-search',
            collection_handle: 'the-full-story',
            force_refresh: !!forceRefresh
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.products)) {
          throw new Error((data && data.error) || rawText || 'Could not load THE FULL STORY inventory.');
        }
        return data.products;
      }

      async function fetchGeniusWeftTransfers(forceRefresh){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'shopify-inventory-transfer-search',
            title_query: 'THE FULL STORY Genius Weft',
            force_refresh: !!forceRefresh
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.transfers)) {
          throw new Error((data && data.error) || rawText || 'Could not load Genius Weft transfer history.');
        }
        return data.transfers;
      }

      async function fetchFullStoryShopifyOrders(forceRefresh, options){
        var opts = options && typeof options === 'object' ? options : {};
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'shopify-collection-order-search',
            collection_handle: 'the-full-story',
            force_refresh: !!forceRefresh,
            updated_since: String(opts.updatedSince || '').trim(),
            max_pages: Number(opts.maxPages || 0) || undefined
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.orders)) {
          throw new Error((data && data.error) || rawText || 'Could not load Shopify orders for The Full Story.');
        }
        return data.orders;
      }

      async function ensureInventoryLoaded(forceRefresh){
        if (hasLoadedInventory && !forceRefresh) return;
        if (!canManageInventory()) {
          renderInventoryList();
          return;
        }
        hasLoadedInventory = true;
        try {
          setInventoryStatus('Loading supply queue...');
          var inventoryResult = await fetchInventoryQueue(forceRefresh);
          inventoryGroups = Array.isArray(inventoryResult && inventoryResult.groups) ? inventoryResult.groups : [];
          inventoryOrderedGroups = Array.isArray(inventoryResult && inventoryResult.orderedGroups) ? inventoryResult.orderedGroups : [];
          renderInventoryTabs();
          renderInventoryList();
          updateInventoryStatusForActiveView();
        } catch (error) {
          hasLoadedInventory = false;
          inventoryGroups = [];
          inventoryOrderedGroups = [];
          renderInventoryTabs();
          renderInventoryList();
          setInventoryStatus(humanizeClientFetchErrorMessage(error, 'Could not load inventory queue.'), 'error');
        }
      }

      async function ensureFullStoryLoaded(forceRefresh){
        if (hasLoadedFullStory && !forceRefresh) return;
        if (!canManageInventory()) {
          renderFullStoryList();
          return;
        }
        hasLoadedFullStory = true;
        try {
          setFullStoryStatus('Loading The Full Story inventory and Shopify orders...');
          var results = await Promise.all([
            fetchGeniusWeftInventory(forceRefresh),
            fetchGeniusWeftTransfers(forceRefresh),
            fetchFullStoryShopifyOrders(forceRefresh)
          ]);
          inventoryShopifyProducts = Array.isArray(results[0]) ? results[0] : [];
          inventoryTransferSummaries = Array.isArray(results[1]) ? results[1] : [];
          fullStoryShopifyOrders = Array.isArray(results[2]) ? results[2] : [];
          renderInventoryTabs();
          renderFullStoryList();
        } catch (error) {
          hasLoadedFullStory = false;
          inventoryShopifyProducts = [];
          inventoryTransferSummaries = [];
          fullStoryShopifyOrders = [];
          renderInventoryTabs();
          renderFullStoryList();
          setFullStoryStatus(humanizeClientFetchErrorMessage(error, 'Could not load The Full Story inventory.'), 'error');
        }
      }

      async function saveInventoryGroup(groupKey, nextStatus, button){
        var group = (Array.isArray(inventoryGroups) ? inventoryGroups : []).find(function(entry){
          return String((entry && entry.key) || '').trim() === String(groupKey || '').trim();
        });
        if (!group || !Array.isArray(group.active_request_ids) || !group.active_request_ids.length) {
          setInventoryStatus('Could not find that queue item.', 'error');
          return;
        }
        if (button) button.disabled = true;
        setInventoryStatus(
          nextStatus === 'ordered'
            ? 'Marking item ordered...'
            : (nextStatus === 'dismissed'
                ? 'Removing item from the queue...'
                : 'Moving item back to the queue...')
        );
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'supply-request-update-status',
              editor_staff_id: currentProgressionEditor.staff_id,
              request_ids: group.active_request_ids,
              status: String(nextStatus || 'pending')
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not save inventory queue item.');
          }
          hasLoadedInventory = false;
          await ensureInventoryLoaded(true);
          setInventoryStatus(
            nextStatus === 'ordered'
              ? 'Item marked ordered.'
              : (nextStatus === 'dismissed'
                  ? 'Item marked not ordering and removed from the queue.'
                  : 'Item moved back to the queue.'),
            'success'
          );
        } catch (error) {
          setInventoryStatus(humanizeClientFetchErrorMessage(error, 'Could not save inventory queue item.'), 'error');
        } finally {
          if (button) button.disabled = false;
        }
      }

      function getPermissionsSelectedRecord(){
        var staffId = String((permissionsSelectedStaff && permissionsSelectedStaff.id) || '').trim();
        if (!staffId) return null;
        return permissionsStaffOptions.find(function(option){
          return String((option && option.id) || '').trim() === staffId;
        }) || null;
      }

      function readPermissionRecordValue(record, key){
        return !!(record && record.permission && record.permission[key] === true);
      }

      function renderPermissionsForm(){
        var record = getPermissionsSelectedRecord();
        var canManage = canManageStaffOpsPermissions();
        if (permissionsStaff) {
          permissionsStaff.disabled = !canManage;
        }
        setPermissionsFormDisabled(!canManage || !record);
        if (!record) {
          if (permissionsSummaryName) permissionsSummaryName.textContent = 'No staff selected';
          if (permissionsSummaryRole) permissionsSummaryRole.textContent = canManage ? 'Pick a staff member to view access.' : 'Log in as Chase or Julianne to manage access.';
          if (permissionsNotes) permissionsNotes.value = '';
          [permissionsActive, permissionsAccess, permissionsKpis, permissionsGlobalKpis, permissionsColorDiscipline, permissionsStaffGrowth, permissionsLevel7, permissionsBonus, permissionsRequests, permissionsOpenShifts, permissionsRetail, permissionsModels, permissionsDueQueue, permissionsSchedule, permissionsCoverage, permissionsTodo, permissionsInventory, permissionsProgression, permissionsAdmin, permissionsCheckpointAdmin]
            .forEach(function(node){
              if (node) node.checked = false;
            });
          if (permissionsProgressionManage) permissionsProgressionManage.checked = false;
          if (permissionsProgressionLevel) permissionsProgressionLevel.value = '';
          if (permissionsProgressionLevel) permissionsProgressionLevel.disabled = true;
          if (!canManage) {
            setPermissionsStatus('Log in as Chase or Julianne to manage staff ops permissions.', 'error');
          } else {
            setPermissionsStatus('Choose a staff member to edit access.', '');
          }
          return;
        }
        if (permissionsSummaryName) permissionsSummaryName.textContent = String(record.name || 'Selected staff');
        if (permissionsSummaryRole) permissionsSummaryRole.textContent = String(record.role || 'Salon Team');
        if (permissionsNotes) permissionsNotes.value = String((record.permission && record.permission.notes) || '');
        if (permissionsActive) permissionsActive.checked = record.permission ? record.permission.active !== false : true;
        if (permissionsAccess) permissionsAccess.checked = readPermissionRecordValue(record, 'can_access_staff_ops');
        if (permissionsKpis) permissionsKpis.checked = readPermissionRecordValue(record, 'can_view_kpis');
        if (permissionsGlobalKpis) permissionsGlobalKpis.checked = readPermissionRecordValue(record, 'can_view_global_kpis');
        if (permissionsColorDiscipline) permissionsColorDiscipline.checked = readPermissionRecordValue(record, 'can_view_color_discipline');
        if (permissionsStaffGrowth) permissionsStaffGrowth.checked = readPermissionRecordValue(record, 'can_view_staff_growth');
        if (permissionsLevel7) permissionsLevel7.checked = readPermissionRecordValue(record, 'can_view_level7');
        if (permissionsBonus) permissionsBonus.checked = readPermissionRecordValue(record, 'can_manage_bonus');
        if (permissionsRequests) permissionsRequests.checked = readPermissionRecordValue(record, 'can_manage_requests_off');
        if (permissionsOpenShifts) permissionsOpenShifts.checked = readPermissionRecordValue(record, 'can_manage_open_shifts');
        if (permissionsRetail) permissionsRetail.checked = readPermissionRecordValue(record, 'can_manage_retail_followup');
        if (permissionsModels) permissionsModels.checked = readPermissionRecordValue(record, 'can_manage_models');
        if (permissionsDueQueue) permissionsDueQueue.checked = readPermissionRecordValue(record, 'can_manage_rebook_queue');
        if (permissionsSchedule) permissionsSchedule.checked = readPermissionRecordValue(record, 'can_manage_schedule');
        if (permissionsCoverage) permissionsCoverage.checked = readPermissionRecordValue(record, 'can_view_weekly_calendar');
        if (permissionsTodo) permissionsTodo.checked = readPermissionRecordValue(record, 'can_manage_todo');
        if (permissionsInventory) permissionsInventory.checked = readPermissionRecordValue(record, 'can_manage_inventory');
        if (permissionsProgression) permissionsProgression.checked = readPermissionRecordValue(record, 'can_view_progression');
        if (permissionsAdmin) permissionsAdmin.checked = readPermissionRecordValue(record, 'can_manage_access_permissions');
        if (permissionsCheckpointAdmin) permissionsCheckpointAdmin.checked = readPermissionRecordValue(record, 'can_manage_checkpoint_admin');
        var progressionPermissionEnabled = !!(record.progression_permission && (record.progression_permission.can_edit_progression === true || record.progression_permission.can_sign_off === true));
        var progressionPermissionLevel = record.progression_permission && record.progression_permission.max_signoff_level != null
          ? String(record.progression_permission.max_signoff_level)
          : record.progression_permission && record.progression_permission.max_edit_level != null
          ? String(record.progression_permission.max_edit_level)
          : '';
        if (permissionsProgressionManage) permissionsProgressionManage.checked = progressionPermissionEnabled;
        if (permissionsProgressionLevel) permissionsProgressionLevel.value = progressionPermissionLevel;
        if (permissionsProgressionLevel) permissionsProgressionLevel.disabled = !progressionPermissionEnabled;
        setPermissionsStatus(canManage
          ? 'Editing access for ' + String(record.name || 'selected staff') + '.'
          : 'Log in as Chase or Julianne to manage staff ops permissions.', canManage ? '' : 'error');
      }

      function selectPermissionsStaff(staffId){
        var normalizedId = String(staffId || '').trim();
        permissionsSelectedStaff = permissionsStaffOptions.find(function(option){
          return String((option && option.id) || '').trim() === normalizedId;
        }) || null;
        renderPermissionsForm();
      }

      async function fetchStaffOpsPermissionsList(){
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          throw new Error('Use a named admin PIN to manage permissions.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-ops-permissions-list',
            editor_staff_id: currentProgressionEditor.staff_id,
            force_refresh: false
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok || !Array.isArray(data.staff)) {
          throw new Error((data && data.error) || rawText || 'Could not load staff ops permissions.');
        }
        return data.staff;
      }

      async function ensurePermissionsControlsLoaded(){
        if (hasLoadedPermissionsControls) return;
        hasLoadedPermissionsControls = true;
        try {
          setPermissionsStatus('Loading permission controls...');
          var options = await fetchStaffOpsPermissionsList();
          populatePermissionsStaffOptions(options);
          renderPermissionsForm();
        } catch (error) {
          hasLoadedPermissionsControls = false;
          permissionsStaffOptions = [];
          permissionsSelectedStaff = null;
          populatePermissionsStaffOptions([]);
          renderPermissionsForm();
          setPermissionsStatus(humanizeClientFetchErrorMessage(error, 'Could not load staff ops permissions.'), 'error');
        }
      }

      function collectStaffOpsPermissionPayload(){
        return {
          active: !!(permissionsActive && permissionsActive.checked),
          can_access_staff_ops: !!(permissionsAccess && permissionsAccess.checked),
          can_view_kpis: !!(permissionsKpis && permissionsKpis.checked),
          can_view_global_kpis: !!(permissionsGlobalKpis && permissionsGlobalKpis.checked),
          can_view_color_discipline: !!(permissionsColorDiscipline && permissionsColorDiscipline.checked),
          can_view_staff_growth: !!(permissionsStaffGrowth && permissionsStaffGrowth.checked),
          can_view_level7: !!(permissionsLevel7 && permissionsLevel7.checked),
          can_manage_bonus: !!(permissionsBonus && permissionsBonus.checked),
          can_manage_requests_off: !!(permissionsRequests && permissionsRequests.checked),
          can_manage_open_shifts: !!(permissionsOpenShifts && permissionsOpenShifts.checked),
          can_manage_retail_followup: !!(permissionsRetail && permissionsRetail.checked),
          can_manage_models: !!(permissionsModels && permissionsModels.checked),
          can_manage_rebook_queue: !!(permissionsDueQueue && permissionsDueQueue.checked),
          can_manage_schedule: !!(permissionsSchedule && permissionsSchedule.checked),
          can_view_weekly_calendar: !!(permissionsCoverage && permissionsCoverage.checked),
          can_manage_todo: !!(permissionsTodo && permissionsTodo.checked),
          can_manage_inventory: !!(permissionsInventory && permissionsInventory.checked),
          can_view_progression: !!(permissionsProgression && permissionsProgression.checked),
          can_manage_access_permissions: !!(permissionsAdmin && permissionsAdmin.checked),
          can_manage_checkpoint_admin: !!(permissionsCheckpointAdmin && permissionsCheckpointAdmin.checked),
          notes: String(permissionsNotes && permissionsNotes.value || '').trim()
        };
      }

      function collectProgressionPermissionPayload(){
        var progressionEnabled = !!(permissionsProgressionManage && permissionsProgressionManage.checked);
        var progressionLevel = String(permissionsProgressionLevel && permissionsProgressionLevel.value || '').trim();
        return {
          active: !!(permissionsActive && permissionsActive.checked),
          can_edit_progression: progressionEnabled,
          max_edit_level: progressionLevel,
          can_sign_off: progressionEnabled,
          max_signoff_level: progressionLevel,
          notes: String(permissionsNotes && permissionsNotes.value || '').trim()
        };
      }

      async function saveStaffOpsPermissions(){
        if (!permissionsSelectedStaff || !permissionsSelectedStaff.id) {
          setPermissionsStatus('Choose a staff member first.', 'error');
          return;
        }
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          setPermissionsStatus('Use a named admin PIN to save permissions.', 'error');
          return;
        }
        permissionsSaveBtn.disabled = true;
        setPermissionsStatus('Saving staff ops permissions...');
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'staff-ops-permissions-save',
              editor_staff_id: currentProgressionEditor.staff_id,
              staff_id: permissionsSelectedStaff.id,
              permission: collectStaffOpsPermissionPayload(),
              progression_permission: collectProgressionPermissionPayload()
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok || !data.permission) {
            throw new Error((data && data.error) || rawText || 'Could not save staff ops permissions.');
          }
          hasLoadedPermissionsControls = false;
          await ensurePermissionsControlsLoaded();
          if (permissionsStaff) {
            permissionsStaff.value = String(permissionsSelectedStaff.id || '');
          }
          selectPermissionsStaff(String(permissionsSelectedStaff.id || ''));
          setPermissionsStatus('Staff ops permissions saved for ' + String(permissionsSelectedStaff.name || 'selected staff') + '.', 'success');
        } catch (error) {
          setPermissionsStatus(humanizeClientFetchErrorMessage(error, 'Could not save staff ops permissions.'), 'error');
        } finally {
          permissionsSaveBtn.disabled = false;
        }
      }

      function renderAvatarMarkup(staffName){
        var avatarUrl = getAvatarUrl(staffName);
        if (avatarUrl) {
          return '<span class="kpi-group-avatar"><img src="' + escapeHtml(avatarUrl) + '" alt="' + escapeHtml(staffName) + '" loading="lazy" /></span>';
        }
        return '<span class="kpi-group-avatar">' + escapeHtml(getInitials(staffName)) + '</span>';
      }

      function renderProductionShareMarkup(serviceSales, companyServiceSales){
        var stylistSales = parseNumericCell(serviceSales);
        var companySales = parseNumericCell(companyServiceSales);
        if (companySales <= 0 || stylistSales <= 0) return '';

        var percent = (stylistSales / companySales) * 100;
        var clampedPercent = Math.max(0, Math.min(100, percent));
        return ''
          + '<span class="kpi-share">'
          +   renderSummaryLine('Company share', percent.toFixed(1) + '%')
          +   '<span class="kpi-share-bar"><span class="kpi-share-fill" style="width:' + clampedPercent.toFixed(2) + '%"></span></span>'
          + '</span>';
      }

      async function waitForKpiExportReady(reportExport){
        if (reportExport && reportExport.current_export_at && reportExport.file_url) {
          return reportExport;
        }

        var exportId = reportExport && reportExport.id;
        var fileUrl = reportExport && reportExport.file_url;
        for (var attempt = 0; attempt < 90; attempt += 1) {
          await new Promise(function(resolve){ setTimeout(resolve, 2000); });
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'report-export-debug',
              report_export_id: exportId,
              file_url: fileUrl
            })
          });
          var data = await response.json().catch(function(){ return null; });
          var matched = data && data.matched_export;
          if (response.ok && data && data.ok && matched && matched.current_export_at && matched.file_url) {
            return matched;
          }
        }

        throw new Error('Raw KPI export is still processing. Please try again in about 2-3 minutes.');
      }

      async function fetchRawKpiRows(){
        var created = await createKpiExport();
        var readyExport = await waitForKpiExportReady(created.report_export);
        var proxyResponse = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'report-export-rows',
            file_url: readyExport.file_url
          })
        });
        var proxyData = await proxyResponse.json().catch(function(){ return null; });
        if (!proxyResponse.ok || !proxyData || !proxyData.ok) {
          throw new Error((proxyData && proxyData.error) || 'Could not download raw KPI CSV.');
        }
        var parsed = {
          headers: Array.isArray(proxyData.headers) ? proxyData.headers : [],
          rows: Array.isArray(proxyData.rows) ? proxyData.rows : []
        };
        return {
          exportInfo: readyExport,
          filterConfig: created.filter_config,
          headers: parsed.headers,
          rows: parsed.rows,
          displayRows: buildDisplayKpiRows(parsed.headers, parsed.rows)
        };
      }

      async function fetchStaffKpiSnapshotOrLive(){
        var filterConfig = buildKpiReportFilters();
        if (filterConfig.mode === 'snapshot_range' && filterConfig.snapshot_key) {
          try {
            var snapshotResponse = await fetch(REPORT_PROXY_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                action: 'staff-kpi-snapshot-get',
                snapshot_key: filterConfig.snapshot_key,
                refresh_if_missing: false
              })
            });
            var snapshotRawText = await snapshotResponse.text();
            var snapshotData = null;
            try {
              snapshotData = snapshotRawText ? JSON.parse(snapshotRawText) : null;
            } catch (_error) {
              snapshotData = null;
            }
            if (snapshotResponse.ok && snapshotData && snapshotData.ok) {
              var snapshotHeaders = Array.isArray(snapshotData.headers) ? snapshotData.headers : [];
              var snapshotRows = Array.isArray(snapshotData.rows) ? snapshotData.rows : [];
              return {
                headers: snapshotHeaders,
                rows: snapshotRows,
                displayRows: buildDisplayKpiRows(snapshotHeaders, snapshotRows),
                snapshot_source: 'saved',
                snapshot_date: snapshotData.snapshot && snapshotData.snapshot.snapshot_date
                  ? snapshotData.snapshot.snapshot_date
                  : '',
                snapshot_key: filterConfig.snapshot_key
              };
            }
          } catch (_snapshotError) {
          }
        }

        var liveData = await fetchRawKpiRows();
        if (liveData && typeof liveData === 'object') {
          liveData.snapshot_source = 'live';
        }
        return liveData;
      }

      async function createGlobalKpiExport(){
        var filterConfig = buildGlobalKpiReportFilters();
        if (!filterConfig.report_filters.length) {
          throw new Error(filterConfig.warning || 'Choose a period first.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'create-report-export',
            report_id: GLOBAL_KPI_REPORT_ID,
            file_content_type: 'CSV',
            frequency: 'ONCE',
            report_filters: filterConfig.report_filters
          })
        });
        var data = await response.json().catch(function(){ return null; });
        if (!response.ok || !data || !data.ok || !data.report_export) {
          throw new Error((data && data.error) || 'Could not create KPI Master export.');
        }
        return {
          report_export: data.report_export,
          filter_config: filterConfig
        };
      }

      async function fetchGlobalKpiRows(){
        var created = await createGlobalKpiExport();
        var readyExport = await waitForKpiExportReady(created.report_export);
        var proxyResponse = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'report-export-rows',
            file_url: readyExport.file_url
          })
        });
        var proxyData = await proxyResponse.json().catch(function(){ return null; });
        if (!proxyResponse.ok || !proxyData || !proxyData.ok) {
          throw new Error((proxyData && proxyData.error) || 'Could not download KPI Master CSV.');
        }
        return {
          exportInfo: readyExport,
          filterConfig: created.filter_config,
          headers: Array.isArray(proxyData.headers) ? proxyData.headers : [],
          rows: Array.isArray(proxyData.rows) ? proxyData.rows : []
        };
      }

      async function fetchGlobalKpiSnapshotRows(){
        var selectedQuarter = getSelectedGlobalQuarter();
        if (!selectedQuarter) {
          throw new Error('Choose a period first.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'global-kpi-snapshot-get',
            quarter_value: selectedQuarter.value,
            refresh_if_missing: true
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load KPI Master snapshot.');
        }
        return {
          snapshot: data.snapshot || null,
          derived_metrics: data && data.derived_metrics && typeof data.derived_metrics === 'object' ? data.derived_metrics : null,
          exportInfo: data && data.exportInfo && typeof data.exportInfo === 'object' ? data.exportInfo : null,
          headers: Array.isArray(data.headers) ? data.headers : [],
          rows: Array.isArray(data.rows) ? data.rows : []
        };
      }

      async function fetchGlobalKpiLiveSalonMetrics(){
        var selectedQuarter = getSelectedGlobalQuarter();
        if (!selectedQuarter) {
          throw new Error('Choose a period first.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'global-kpi-live-salon-metrics',
            quarter_value: selectedQuarter.value
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load live salon metrics.');
        }
        return data || null;
      }

      async function fetchGlobalKpiAnnualRefreshStatus(yearValue){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'global-kpi-annual-refresh-status',
            year_value: String(yearValue || '').trim()
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load YTD refresh status.');
        }
        return data || null;
      }

      async function pollCurrentYearGlobalKpiRefreshStatus(yearValue, options){
        var settings = options && typeof options === 'object' ? options : {};
        var silent = settings.silent === true;
        var reloadOnComplete = settings.reloadOnComplete === true;
        clearGlobalKpiAnnualRefreshPoll();
        try {
          var statusData = await fetchGlobalKpiAnnualRefreshStatus(yearValue);
          var status = String((statusData && statusData.status) || 'idle').trim().toLowerCase();
          if (status === 'queued' || status === 'processing') {
            globalKpiRefreshInFlight = true;
            syncGlobalKpiRefreshVisualState();
            if (globalKpiRefreshYtdBtn && !globalKpiRefreshYtdBtn.hidden) {
              globalKpiRefreshYtdBtn.disabled = true;
              globalKpiRefreshYtdBtn.textContent = 'Refreshing...';
            }
            if (!silent) {
              setGlobalKpiStatus(status === 'queued'
                ? 'YTD refresh queued. Boulevard is building the annual export...'
                : 'Refreshing YTD snapshot from Boulevard...');
            }
            globalKpiAnnualRefreshPollTimer = window.setTimeout(function(){
              pollCurrentYearGlobalKpiRefreshStatus(yearValue, { silent: false });
            }, 5000);
            return;
          }

          globalKpiRefreshInFlight = false;
          syncGlobalKpiRefreshVisualState();
          syncGlobalKpiRefreshYtdButton();
          if (globalKpiRefreshYtdBtn && !globalKpiRefreshYtdBtn.hidden) {
            globalKpiRefreshYtdBtn.disabled = false;
            globalKpiRefreshYtdBtn.textContent = 'Update YTD now';
          }

          if (status === 'complete') {
            setGlobalKpiStatus('YTD snapshot updated.', 'success');
            if (reloadOnComplete) {
              await loadGlobalKpis();
            }
            return;
          }

          if (status === 'failed') {
            setGlobalKpiStatus(humanizeDashboardErrorMessage((statusData && statusData.error) || 'YTD refresh failed.'), 'error');
            return;
          }
        } catch (error) {
          globalKpiRefreshInFlight = false;
          syncGlobalKpiRefreshVisualState();
          syncGlobalKpiRefreshYtdButton();
          if (globalKpiRefreshYtdBtn && !globalKpiRefreshYtdBtn.hidden) {
            globalKpiRefreshYtdBtn.disabled = false;
            globalKpiRefreshYtdBtn.textContent = 'Update YTD now';
          }
          if (!silent) {
            setGlobalKpiStatus(humanizeDashboardErrorMessage(error && error.message ? error.message : 'Could not load YTD refresh status.'), 'error');
          }
        }
      }

      async function refreshCurrentYearGlobalKpiYtd(){
        var selectedQuarter = getSelectedGlobalQuarter();
        if (!isCurrentYearGlobalKpiYtdSelection(selectedQuarter)) {
          throw new Error('Choose the current year YTD view first.');
        }
        var selectedYear = String((selectedQuarter && selectedQuarter.value) || '').trim();
        if (globalKpiRefreshYtdBtn) {
          globalKpiRefreshYtdBtn.disabled = true;
          globalKpiRefreshYtdBtn.textContent = 'Queueing...';
        }
        globalKpiRefreshInFlight = true;
        syncGlobalKpiRefreshVisualState();
        try {
          setGlobalKpiStatus('Queueing ' + selectedQuarter.label + ' refresh...');
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'global-kpi-annual-refresh',
              year_value: selectedYear,
              async: true
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not refresh Global KPI snapshots.');
          }
          setGlobalKpiStatus('YTD refresh queued. Boulevard is building the annual export...');
          if (globalKpiRefreshYtdBtn && !globalKpiRefreshYtdBtn.hidden) {
            globalKpiRefreshYtdBtn.disabled = true;
            globalKpiRefreshYtdBtn.textContent = 'Refreshing...';
          }
          await pollCurrentYearGlobalKpiRefreshStatus(selectedYear, { silent: true, reloadOnComplete: true });
        } catch (error) {
          var message = humanizeDashboardErrorMessage(error && error.message ? error.message : 'Could not refresh Global KPIs.');
          setGlobalKpiStatus(message, 'error');
        } finally {
          globalKpiRefreshInFlight = false;
          syncGlobalKpiRefreshYtdButton();
          syncGlobalKpiRefreshVisualState();
          if (globalKpiRefreshYtdBtn && !globalKpiRefreshYtdBtn.hidden) {
            globalKpiRefreshYtdBtn.disabled = false;
            globalKpiRefreshYtdBtn.textContent = 'Update YTD now';
          }
        }
      }

      function renderKpiTable(headers, rows){
        if (!headers.length || !rows.length) {
          kpiTableMount.className = 'empty';
          kpiTableMount.innerHTML = 'No staff KPI rows are available.';
          return;
        }

        var groupedView = buildKpiStaffGroups(headers, rows);
        if (groupedView && groupedView.totalRow && groupedView.groups.length) {
          var companyServiceSales = groupedView.companyServiceSales || 0;
          kpiTableMount.className = 'kpi-groups';
          kpiTableMount.innerHTML = ''
            + '<div class="table-wrap">'
            + renderKpiTableMarkup(headers, [groupedView.totalRow])
            + '</div>'
            + groupedView.groups.map(function(group){
                var summaryRow = group.summaryRow || {};
                var summaryOverride = getStaffGrowthYtdSummaryOverride(group.staffName);
                if (summaryOverride) {
                  summaryRow = Object.assign({}, summaryRow, summaryOverride);
                }
                var appointmentLabel = formatNumericCell('Appointment Count', summaryRow['Appointment Count'] || '');
                var serviceSalesLabel = formatNumericCell('Service Sales', summaryRow['Service Sales'] || '');
                var utilizationLabel = formatNumericCell('Utilization %', summaryRow['Utilization %'] || '');
                var weekdayUtilizationLines = group.weekdayUtilizationLines || [];
                var highestDayLabel = group.highestDayLabel || '';
                var lowestDayLabel = group.lowestDayLabel || '';
                var productionRateLabel = formatNumericCell('Production Rate', getKpiDisplayValue('Production Rate', summaryRow));
                var unscheduledOpportunityLabel = group.unscheduledOpportunityLabel || '';
                var supportPatternLabel = group.supportPatternLabel || '';
                var reliabilityScoreLabel = getReliabilityScoreLabel(group.staffName);
                var levelLabel = getLevelLabel(group.staffName);
                var productionShareMarkup = renderProductionShareMarkup(summaryRow['Service Sales'], companyServiceSales);
                var isNonProducingRole = !!supportPatternLabel;

                if (isNonProducingRole) {
                  return ''
                    + '<details class="kpi-group">'
                    +   '<summary>'
                    +     '<span class="kpi-group-identity">'
                    +       renderAvatarMarkup(group.staffName)
                    +       '<span class="kpi-group-identity-copy">'
                    +         '<span class="kpi-group-name">' + escapeHtml(group.staffName) + '</span>'
                    +         '<span class="kpi-group-level">'
                    +           renderSummaryLine('Level', levelLabel)
                    +           renderSummaryLine('Reliability', reliabilityScoreLabel)
                    +           renderReliabilityDetailLines(group.staffName)
                    +         '</span>'
                    +       '</span>'
                    +     '</span>'
                    +     '<span class="kpi-group-meta">'
                    +       productionShareMarkup
                    +       '<span class="kpi-group-note">'
                    +         renderSummaryLine('Role', supportPatternLabel, 'kpi-group-note--muted')
                    +       '</span>'
                    +     '</span>'
                    +   '</summary>'
                    +   '<div class="kpi-group-body table-wrap">'
                    +     renderKpiTableMarkup(headers, [summaryRow].concat(group.rows))
                    +   '</div>'
                    + '</details>';
                }

                return ''
                  + '<details class="kpi-group">'
                  +   '<summary>'
                  +     '<span class="kpi-group-identity">'
                  +       renderAvatarMarkup(group.staffName)
                  +       '<span class="kpi-group-identity-copy">'
                  +         '<span class="kpi-group-name">' + escapeHtml(group.staffName) + '</span>'
                  +         '<span class="kpi-group-level">'
                  +           renderSummaryLine('Level', levelLabel)
                  +           renderSummaryLine('Reliability', reliabilityScoreLabel)
                  +           renderReliabilityDetailLines(group.staffName)
                  +         '</span>'
                  +       '</span>'
                  +     '</span>'
                  +     '<span class="kpi-group-meta">'
                  +       '<span class="kpi-group-primary">'
                  +         renderSummaryLine('Volume', appointmentLabel + ' appts')
                  +         renderSummaryLine('Service', serviceSalesLabel)
                  +         renderSummaryLine('Utilization', utilizationLabel)
                  +         renderSummaryLine('Production', productionRateLabel)
                  +       '</span>'
                  +       '<span class="kpi-group-secondary">'
                  +         productionShareMarkup
                  +         weekdayUtilizationLines.map(function(line, index){
                              return renderSummaryLine(index === 0 ? 'Weekdays' : '', line);
                            }).join('')
                  +         renderSummaryLine('Highest day', highestDayLabel.replace(/^High:\s*/, ''))
                  +         renderSummaryLine('Lowest day', lowestDayLabel.replace(/^Low:\s*/, ''))
                  +       '</span>'
                  +       '<span class="kpi-group-note">'
                  +         renderSummaryLine('Recommendation', unscheduledOpportunityLabel.replace(/^Floor time recommendation:\s*/, ''))
                  +       '</span>'
                  +     '</span>'
                  +   '</summary>'
                  +   '<div class="kpi-group-body table-wrap">'
                  +     renderKpiTableMarkup(headers, [summaryRow].concat(group.rows))
                  +   '</div>'
                  + '</details>';
              }).join('');
          return;
        }

        kpiTableMount.className = 'table-wrap';
        kpiTableMount.innerHTML = renderKpiTableMarkup(headers, rows);
      }

      function buildDebugText(data){
        var payload = data || {};
        var sections = [];
        var rawKpiRows = payload.raw_rows && payload.raw_rows.kpi_for_stylists;
        var normalizedKpiRows = payload.normalized_rows && payload.normalized_rows.kpi_for_stylists;
        var kpiRenderedRows = payload.kpi_for_stylists && payload.kpi_for_stylists.rows;

        if (Array.isArray(rawKpiRows)) {
          sections.push('RAW KPI ROWS (' + rawKpiRows.length + ')');
          sections.push(JSON.stringify(rawKpiRows, null, 2));
        }

        if (Array.isArray(normalizedKpiRows)) {
          sections.push('NORMALIZED KPI ROWS (' + normalizedKpiRows.length + ')');
          sections.push(JSON.stringify(normalizedKpiRows, null, 2));
        }

        if (Array.isArray(kpiRenderedRows)) {
          sections.push('KPI REPORT ROWS (' + kpiRenderedRows.length + ')');
          sections.push(JSON.stringify(kpiRenderedRows, null, 2));
        }

        sections.push('FULL DEBUG JSON');
        sections.push(JSON.stringify(payload, null, 2));

        return sections.join('\n\n');
      }

      function renderDebug(data){
        lastDebugPayload = data || null;
        debugMount.textContent = buildDebugText(lastDebugPayload);
      }

      function formatGlobalKpiMetricValue(label, rawValue){
        return formatNumericCell(label, rawValue == null ? '' : String(rawValue));
      }

      function formatGlobalKpiWasteValue(value){
        var numeric = Math.max(0, Number(value || 0) || 0);
        return formatMoney(numeric);
      }

      function normalizeQuarterDisplay(value){
        var text = String(value == null ? '' : value).trim();
        if (!text || text.toLowerCase() === 'all') return 'All';
        if (/^\d{4}$/.test(text)) return text;
        if (/^\d{4}\s+(ytd|total)$/i.test(text)) return text;
        return 'Q' + text;
      }

      function pickPrimaryGlobalKpiRow(rows){
        var period = getSelectedGlobalQuarter();
        var isAnnual = !!(period && /^\d{4}$/.test(String(period.value || '')));
        var quarterNumber = period && !isAnnual ? period.value.split('-Q')[1] : '';
        var candidates = Array.isArray(rows) ? rows.slice() : [];
        if (isAnnual) {
          return candidates.find(function(row){
            return String((row && row['Location name']) || '').trim().toLowerCase() !== 'all';
          }) || candidates.find(function(row){
            return String((row && row['Location name']) || '').trim().toLowerCase() === 'all';
          }) || candidates[0] || null;
        }
        return candidates.find(function(row){
          return String((row && row['SaleDate Quarter']) || '').trim() === quarterNumber
            && String((row && row['Location name']) || '').trim().toLowerCase() !== 'all';
        }) || candidates.find(function(row){
          return String((row && row['SaleDate Quarter']) || '').trim() === quarterNumber;
        }) || candidates.find(function(row){
          return String((row && row['Location name']) || '').trim().toLowerCase() === 'all';
        }) || candidates[0] || null;
      }

      function renderGlobalKpiMetricCard(label, value, subvalue){
        return ''
          + '<div class="global-kpi-card">'
          +   '<div class="global-kpi-label">' + escapeHtml(label) + '</div>'
          +   '<div class="global-kpi-value">' + escapeHtml(formatGlobalKpiMetricValue(label, value)) + '</div>'
          +   (subvalue ? '<div class="global-kpi-subvalue">' + escapeHtml(subvalue) + '</div>' : '')
          + '</div>';
      }

      function formatGlobalKpiDisplayValue(label, value){
        var text = value == null ? '' : String(value);
        return text ? formatGlobalKpiMetricValue(label, text) : '—';
      }

      function normalizeGlobalKpiPercentValue(value){
        var text = value == null ? '' : String(value).trim();
        if (!text) return NaN;
        var numeric = Number(text.replace(/%/g, ''));
        if (!isFinite(numeric)) return NaN;
        if (Math.abs(numeric) <= 1) return numeric * 100;
        return numeric;
      }

      function clampGlobalKpiPercent(value){
        var numeric = normalizeGlobalKpiPercentValue(value);
        if (!isFinite(numeric)) return 0;
        if (numeric < 0) return 0;
        if (numeric > 100) return 100;
        return numeric;
      }

      function renderGlobalKpiSummaryStat(label, value, subvalue, formatLabel){
        return ''
          + '<div class="global-kpi-summaryCard">'
          +   '<div class="global-kpi-summaryLabel">' + escapeHtml(label) + '</div>'
          +   '<div class="global-kpi-summaryValue">' + escapeHtml(formatGlobalKpiDisplayValue(formatLabel || label, value)) + '</div>'
          +   (subvalue ? '<div class="global-kpi-summarySubvalue">' + escapeHtml(subvalue) + '</div>' : '')
          + '</div>';
      }

      function renderGlobalKpiDataRow(label, value, formatLabel){
        return renderGlobalKpiDataRowState(label, value, formatLabel, false);
      }

      function renderGlobalKpiLoadingBadge(text){
        return ''
          + '<span class="global-kpi-loadingBadge">'
          +   '<span class="global-kpi-loadingDot" aria-hidden="true"></span>'
          +   '<span>' + escapeHtml(String(text || 'Updating')) + '</span>'
          + '</span>';
      }

      function renderGlobalKpiDataRowState(label, value, formatLabel, isLoading){
        var valueMarkup = isLoading
          ? renderGlobalKpiLoadingBadge('Updating')
          : escapeHtml(formatGlobalKpiDisplayValue(formatLabel || label, value));
        return ''
          + '<div class="global-kpi-row' + (isLoading ? ' is-loading' : '') + '">'
          +   '<span class="global-kpi-rowLabel">' + escapeHtml(label) + '</span>'
          +   '<strong class="global-kpi-rowValue">' + valueMarkup + '</strong>'
          + '</div>';
      }

      function renderGlobalKpiProgressRow(label, value, subvalue, modifierClass, formatLabel, isLoading){
        var textValue = value == null ? '' : String(value);
        var clamped = clampGlobalKpiPercent(textValue);
        var valueMarkup = isLoading
          ? renderGlobalKpiLoadingBadge('Updating')
          : escapeHtml(formatGlobalKpiDisplayValue(formatLabel || label, textValue));
        return ''
          + '<div class="global-kpi-progressRow' + (modifierClass ? ' ' + modifierClass : '') + (isLoading ? ' is-loading' : '') + '">'
          +   '<div class="global-kpi-progressHead">'
          +     '<span class="global-kpi-rowLabel">' + escapeHtml(label) + '</span>'
          +     '<strong class="global-kpi-rowValue">' + valueMarkup + '</strong>'
          +   '</div>'
          +   '<div class="global-kpi-progressTrack"><span class="global-kpi-progressFill' + (modifierClass ? ' ' + modifierClass : '') + (isLoading ? ' is-loading' : '') + '" style="width:' + escapeHtml(String(isLoading ? 34 : clamped)) + '%"></span></div>'
          +   (subvalue ? '<div class="global-kpi-rowDetail">' + escapeHtml(subvalue) + '</div>' : '')
          + '</div>';
      }

      function renderGlobalKpiSection(sectionTitle, sectionMeta, bodyMarkup, sectionClass){
        return ''
          + '<section class="global-kpi-section' + (sectionClass ? ' ' + sectionClass : '') + '">'
          +   '<div class="global-kpi-sectionHead">'
          +     '<h3>' + escapeHtml(sectionTitle) + '</h3>'
          +     (sectionMeta ? '<span class="global-kpi-sectionMeta">' + escapeHtml(sectionMeta) + '</span>' : '')
          +   '</div>'
          +   bodyMarkup
          + '</section>';
      }

      function normalizeGlobalKpiFieldKey(value){
        return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
      }

      function readGlobalKpiField(row, aliases){
        var safeRow = row && typeof row === 'object' ? row : {};
        var aliasList = Array.isArray(aliases) ? aliases : [aliases];
        var keys = Object.keys(safeRow);
        for (var aliasIndex = 0; aliasIndex < aliasList.length; aliasIndex += 1) {
          var alias = String(aliasList[aliasIndex] || '').trim();
          if (!alias) continue;
          if (Object.prototype.hasOwnProperty.call(safeRow, alias)) {
            return safeRow[alias];
          }
          var normalizedAlias = normalizeGlobalKpiFieldKey(alias);
          for (var keyIndex = 0; keyIndex < keys.length; keyIndex += 1) {
            var key = keys[keyIndex];
            if (normalizeGlobalKpiFieldKey(key) === normalizedAlias) {
              return safeRow[key];
            }
          }
        }
        return '';
      }

      function renderGlobalKpiTable(snapshotPayload, liveSalonMetrics, tfsSalesSummary){
        var headers = snapshotPayload && Array.isArray(snapshotPayload.headers) ? snapshotPayload.headers : [];
        var rows = snapshotPayload && Array.isArray(snapshotPayload.rows) ? snapshotPayload.rows : [];
        if (!globalKpiTableMount) return;
        if (!Array.isArray(headers) || !headers.length || !Array.isArray(rows) || !rows.length) {
          globalKpiTableMount.className = 'empty';
          globalKpiTableMount.innerHTML = 'No global KPI rows are available for that period.';
          return;
        }

        var primaryRow = pickPrimaryGlobalKpiRow(rows);
        if (!primaryRow) {
          globalKpiTableMount.className = 'empty';
          globalKpiTableMount.innerHTML = 'No global KPI rows are available for that period.';
          return;
        }

        var selectedQuarter = getSelectedGlobalQuarter();
        var quarterLabel = selectedQuarter ? selectedQuarter.label : normalizeQuarterDisplay(primaryRow['SaleDate Quarter']);
        var locationLabel = String((primaryRow['Location name']) || 'All Locations').trim() || 'All Locations';
        var derivedMetrics = snapshotPayload && snapshotPayload.derived_metrics && typeof snapshotPayload.derived_metrics === 'object'
          ? snapshotPayload.derived_metrics
          : {};
        var snapshotRetailAttach = derivedMetrics && derivedMetrics.retail_attach && typeof derivedMetrics.retail_attach === 'object'
          ? derivedMetrics.retail_attach
          : null;
        var snapshotColorReweigh = derivedMetrics && derivedMetrics.color_reweigh && typeof derivedMetrics.color_reweigh === 'object'
          ? derivedMetrics.color_reweigh
          : null;
        var snapshotShopifySales = derivedMetrics && derivedMetrics.shopify_sales && typeof derivedMetrics.shopify_sales === 'object'
          ? derivedMetrics.shopify_sales
          : null;
        var snapshotTagCapture = derivedMetrics && derivedMetrics.tag_capture && typeof derivedMetrics.tag_capture === 'object'
          ? derivedMetrics.tag_capture
          : null;
        var liveMetricsLoading = typeof liveSalonMetrics === 'undefined'
          && (!snapshotTagCapture || !snapshotRetailAttach || !snapshotColorReweigh || !snapshotShopifySales);
        var tagCapture = liveSalonMetrics && liveSalonMetrics.tag_capture && typeof liveSalonMetrics.tag_capture === 'object'
          ? liveSalonMetrics.tag_capture
          : snapshotTagCapture;
        var retailAttach = liveSalonMetrics && liveSalonMetrics.retail_attach && typeof liveSalonMetrics.retail_attach === 'object'
          ? liveSalonMetrics.retail_attach
          : snapshotRetailAttach;
        var colorReweigh = liveSalonMetrics && liveSalonMetrics.color_reweigh && typeof liveSalonMetrics.color_reweigh === 'object'
          ? liveSalonMetrics.color_reweigh
          : snapshotColorReweigh;
        var taggedAppointments = tagCapture ? Math.max(0, Number(tagCapture.tagged_appointment_count || 0) || 0) : 0;
        var totalTaggedAppointments = tagCapture ? Math.max(0, Number(tagCapture.total_appointment_count || 0) || 0) : 0;
        var tagCaptureRate = tagCapture ? Math.max(0, Number(tagCapture.tag_capture_rate || 0) || 0) : null;
        var tagCaptureSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (tagCapture && totalTaggedAppointments > 0
          ? formatNumericCell('Appointment Count', String(taggedAppointments)) + ' of ' + formatNumericCell('Appointment Count', String(totalTaggedAppointments)) + ' completed appts tagged'
          : (tagCapture ? 'No stored appointment history for this quarter' : 'Live metric unavailable'));
        var retailAttachRate = retailAttach ? Math.max(0, Number(retailAttach.attach_rate || 0) || 0) : null;
        var retailAttachClosed = retailAttach ? Math.max(0, Number(retailAttach.closed_appointments || 0) || 0) : 0;
        var retailAttachRetail = retailAttach ? Math.max(0, Number(retailAttach.retail_appointments || 0) || 0) : 0;
        var retailAttachSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (retailAttach && retailAttachClosed > 0
          ? formatNumericCell('Appointment Count', String(retailAttachRetail)) + ' of ' + formatNumericCell('Appointment Count', String(retailAttachClosed)) + ' closed appts attached'
          : (retailAttach ? 'No closed appointment retail history for this quarter' : 'Live metric unavailable'));
        var colorReweighRate = colorReweigh ? Math.max(0, Number(colorReweigh.reweigh_rate || 0) || 0) : null;
        var colorReweighServices = colorReweigh ? Math.max(0, Number(colorReweigh.services || 0) || 0) : 0;
        var colorEstimatedWaste = colorReweigh ? Math.max(0, Number(colorReweigh.estimated_waste || 0) || 0) : null;
        var colorEstimatedWastePerService = colorReweigh ? Math.max(0, Number(colorReweigh.estimated_waste_per_service || 0) || 0) : null;
        var colorReweighSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (colorReweigh && colorReweighServices > 0
          ? formatNumericCell('Service Count', String(colorReweighServices)) + ' services in Vish range'
          : (colorReweigh ? 'No Color Discipline coverage for this quarter' : 'Live metric unavailable'));
        var colorWasteValueLabel = colorEstimatedWaste == null ? '' : formatGlobalKpiWasteValue(colorEstimatedWaste);
        var colorWasteSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (colorReweigh && colorReweighServices > 0
          ? 'Estimated from Vish color-discipline rows'
            + (colorEstimatedWastePerService != null ? ' • ' + formatGlobalKpiWasteValue(colorEstimatedWastePerService) + ' per service' : '')
          : (colorReweigh ? 'No Color Discipline coverage for this quarter' : 'Live metric unavailable'));
        var shopifySales = liveSalonMetrics && liveSalonMetrics.shopify_sales && typeof liveSalonMetrics.shopify_sales === 'object'
          ? liveSalonMetrics.shopify_sales
          : snapshotShopifySales;
        var shopifyNetSales = shopifySales ? Math.max(0, Number(shopifySales.net_sales || 0) || 0) : null;
        var shopifyOrderCount = shopifySales ? Math.max(0, Number(shopifySales.order_count || 0) || 0) : 0;
        var shopifyAov = shopifySales ? Math.max(0, Number(shopifySales.average_order_value || 0) || 0) : null;
        var shopifyRefunded = shopifySales ? Math.max(0, Number(shopifySales.refunded_sales || 0) || 0) : 0;
        var serviceSalesValue = Math.max(0, parseNumericCell(readGlobalKpiField(primaryRow, ['Service Sales'])));
        var rawProductSales = parseNumericCell(readGlobalKpiField(primaryRow, ['Product Sales']));
        var grossPackageSales = Math.max(0, parseNumericCell(readGlobalKpiField(primaryRow, ['Gross Package Sales', 'Gross Packages Sales'])));
        var giftCardSales = Math.max(0, parseNumericCell(readGlobalKpiField(primaryRow, ['Giftcard Sales', 'Gift Card Sales'])));
        var displayProductSales = Math.max(0, rawProductSales - grossPackageSales);
        var displayRetailToServiceRate = serviceSalesValue > 0 ? (displayProductSales / serviceSalesValue) : 0;
        var hasGiftCardSales = normalizeGlobalKpiFieldKey(readGlobalKpiField(primaryRow, ['Giftcard Sales', 'Gift Card Sales'])) !== '' || giftCardSales > 0;
        var hasGrossPackageSales = normalizeGlobalKpiFieldKey(readGlobalKpiField(primaryRow, ['Gross Package Sales', 'Gross Packages Sales'])) !== '' || grossPackageSales > 0;
        var shopifySalesSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (shopifySales && shopifyOrderCount > 0
          ? formatNumericCell('Order Count', String(shopifyOrderCount)) + ' online orders • ' + formatNumericCell('Online Sales', String(shopifyRefunded)) + ' refunded'
          : (shopifySales ? 'No Shopify sales in this quarter' : 'Live metric unavailable'));
        var shopifyOrdersSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (shopifySales && shopifyOrderCount > 0
          ? 'Net online orders captured in Shopify'
          : (shopifySales ? 'No Shopify orders in this quarter' : 'Live metric unavailable'));
        var shopifyAovSubvalue = liveMetricsLoading
          ? 'Loading live salon metrics...'
          : (shopifySales && shopifyOrderCount > 0
          ? 'Average net online order value'
          : (shopifySales ? 'No Shopify orders in this quarter' : 'Live metric unavailable'));
        var tfsSales = tfsSalesSummary && typeof tfsSalesSummary === 'object'
          ? tfsSalesSummary
          : null;
        var tfsSalesLoading = typeof tfsSalesSummary === 'undefined';
        var tfsOrderCount = tfsSales ? Math.max(0, Number(tfsSales.order_count || 0) || 0) : 0;
        var tfsNetSales = tfsSales ? Math.max(0, Number(tfsSales.net_sales || 0) || 0) : null;
        var tfsGrossSales = tfsSales ? Math.max(0, Number(tfsSales.gross_sales || 0) || 0) : null;
        var tfsDiscountedSales = tfsSales ? Math.max(0, Number(tfsSales.discounted_sales || 0) || 0) : null;
        var tfsRefundedSales = tfsSales ? Math.max(0, Number(tfsSales.refunded_sales || 0) || 0) : 0;
        var tfsAov = tfsSales ? Math.max(0, Number(tfsSales.average_order_value || 0) || 0) : null;
        var tfsUnits = tfsSales ? Math.max(0, Number(tfsSales.units || 0) || 0) : 0;
        var tfsSalesSubvalue = tfsSalesLoading
          ? 'Loading TFS Shopify sales...'
          : (tfsSales && tfsOrderCount > 0
          ? String(tfsUnits) + ' TFS units across ' + String(tfsOrderCount) + ' Shopify orders'
          : (tfsSales ? 'No TFS Shopify sales in this period' : 'TFS sales unavailable'));
        var todayForRange = startOfLocalDay(new Date());
        var exportDateFrom = selectedQuarter && selectedQuarter.start ? formatShortDate(formatDateInputValue(selectedQuarter.start)) : '';
        var exportEffectiveEnd = selectedQuarter && selectedQuarter.end && selectedQuarter.end.getTime() > todayForRange.getTime()
          ? todayForRange
          : (selectedQuarter ? selectedQuarter.end : null);
        var exportDateTo = exportEffectiveEnd ? formatShortDate(formatDateInputValue(exportEffectiveEnd)) : '';
        var exportUpdatedAt = snapshotPayload && snapshotPayload.exportInfo && snapshotPayload.exportInfo.current_export_at
          ? formatRecaptureDateTime(snapshotPayload.exportInfo.current_export_at)
          : '';
        var snapshotDateFrom = snapshotPayload && snapshotPayload.snapshot && snapshotPayload.snapshot.date_from
          ? formatShortDate(snapshotPayload.snapshot.date_from)
          : '';
        var snapshotDateTo = snapshotPayload && snapshotPayload.snapshot && snapshotPayload.snapshot.date_to
          ? formatShortDate(snapshotPayload.snapshot.date_to)
          : '';
        var snapshotUpdatedAt = snapshotPayload && snapshotPayload.snapshot && snapshotPayload.snapshot.updated_at
          ? formatRecaptureDateTime(snapshotPayload.snapshot.updated_at)
          : '';
        var periodMeta = [snapshotDateFrom || exportDateFrom, snapshotDateTo || exportDateTo].filter(Boolean).join(' - ');
        var updateMeta = snapshotUpdatedAt
          ? ('Updated ' + snapshotUpdatedAt)
          : (exportUpdatedAt ? ('Updated ' + exportUpdatedAt) : '');
        var hasPendingMetrics = liveMetricsLoading || tfsSalesLoading || globalKpiRefreshInFlight;

        var revenueMarkup = ''
          + '<div class="global-kpi-leadRow">'
          +   '<span class="global-kpi-leadLabel">Service Sales</span>'
          +   '<strong class="global-kpi-leadValue">' + escapeHtml(formatGlobalKpiDisplayValue('Service Sales', primaryRow['Service Sales'])) + '</strong>'
          + '</div>'
          + renderGlobalKpiDataRow('Product Sales', String(displayProductSales))
          + renderGlobalKpiProgressRow('Retail to Service %', String(displayRetailToServiceRate), '')
          + '<div class="global-kpi-twoColumnRows">'
          +   renderGlobalKpiDataRow('Gross Package Sales', String(grossPackageSales))
          +   renderGlobalKpiDataRow('Gift Card Sales', String(giftCardSales))
          +   renderGlobalKpiDataRow('Tip Sales', primaryRow['Tip Sales'])
          +   renderGlobalKpiDataRowState('Online Sales', shopifyNetSales == null ? '' : String(shopifyNetSales), null, liveMetricsLoading)
          +   renderGlobalKpiDataRowState('Online Orders', shopifySales ? String(shopifyOrderCount) : '', 'Order Count', liveMetricsLoading)
          +   renderGlobalKpiDataRowState('Online AOV', shopifyAov == null ? '' : String(shopifyAov), null, liveMetricsLoading)
          +   renderGlobalKpiDataRowState('Online Refunds', shopifySales ? String(shopifyRefunded) : '', 'Online Sales', liveMetricsLoading)
          + '</div>';

        var appointmentsMarkup = ''
          + '<div class="global-kpi-leadRow">'
          +   '<span class="global-kpi-leadLabel">Completed Appointments</span>'
          +   '<strong class="global-kpi-leadValue">' + escapeHtml(formatGlobalKpiDisplayValue('Appointment Count', primaryRow['Appointment Count'])) + '</strong>'
          + '</div>'
          + renderGlobalKpiProgressRow('Utilization %', primaryRow['Utilization %'], 'Booked vs scheduled hours')
          + renderGlobalKpiProgressRow('Self-booked %', primaryRow['Self-booked %'], '')
          + '<div class="global-kpi-twoColumnRows">'
          +   renderGlobalKpiDataRow('Hours Booked', primaryRow['Hours Booked'])
          +   renderGlobalKpiDataRow('Hours Scheduled', primaryRow['Hours Scheduled'])
          + '</div>';

        var clientsMarkup = ''
          + '<div class="global-kpi-clientSplit">'
          +   '<div class="global-kpi-clientBlock"><span class="global-kpi-rowLabel">New Client Count</span><strong class="global-kpi-clientValue">' + escapeHtml(formatGlobalKpiDisplayValue('New Client Count', primaryRow['New Client Count'])) + '</strong></div>'
          +   '<div class="global-kpi-clientBlock"><span class="global-kpi-rowLabel">Returning Client Count</span><strong class="global-kpi-clientValue">' + escapeHtml(formatGlobalKpiDisplayValue('Returning Client Count', primaryRow['Returning Client Count'])) + '</strong></div>'
          + '</div>'
          + renderGlobalKpiProgressRow('Prebooked %', primaryRow['Prebooked %'], '')
          + renderGlobalKpiProgressRow('Retail Attach %', retailAttachRate == null ? '' : String(retailAttachRate), retailAttachSubvalue, '', null, liveMetricsLoading);

        var disciplineMarkup = ''
          + renderGlobalKpiProgressRow('Color Reweigh %', colorReweighRate == null ? '' : String(colorReweighRate), colorReweighSubvalue, '', null, liveMetricsLoading)
          + '<div class="global-kpi-twoColumnRows">'
          +   renderGlobalKpiDataRowState('Vish Services in Range', colorReweigh ? String(colorReweighServices) : '', 'Service Count', liveMetricsLoading)
          +   renderGlobalKpiDataRowState('Estimated Waste', colorWasteValueLabel, null, liveMetricsLoading)
          +   renderGlobalKpiDataRowState('Estimated Waste per Service', colorEstimatedWastePerService == null ? '' : formatGlobalKpiWasteValue(colorEstimatedWastePerService), null, liveMetricsLoading)
          + '</div>'
          + renderGlobalKpiProgressRow('Tag Capture %', tagCaptureRate == null ? '' : String(tagCaptureRate), tagCaptureSubvalue, 'alt', null, liveMetricsLoading);

        var tfsMarkup = ''
          + '<div class="global-kpi-bdHead">'
          +   '<span class="global-kpi-pill global-kpi-pill--quiet">' + escapeHtml(tfsSalesLoading ? 'Updating' : 'The Full Story') + '</span>'
          + '</div>'
          + '<div class="global-kpi-bdGrid">'
          +   renderGlobalKpiDataRowState('Orders', tfsSales ? String(tfsOrderCount) : '', null, tfsSalesLoading)
          +   renderGlobalKpiDataRowState('Units Sold', tfsSales ? String(tfsUnits) : '', null, tfsSalesLoading)
          +   renderGlobalKpiDataRowState('Net Sales', tfsNetSales == null ? '' : String(tfsNetSales), null, tfsSalesLoading)
          +   renderGlobalKpiDataRowState('AOV', tfsAov == null ? '' : String(tfsAov), null, tfsSalesLoading)
          + '</div>'
          + renderGlobalKpiDataRowState('Sales Snapshot', tfsNetSales == null ? '' : String(tfsNetSales), null, tfsSalesLoading)
          + (tfsSalesSubvalue ? '<div class="global-kpi-rowDetail">' + escapeHtml(tfsSalesSubvalue) + '</div>' : '')
          + '<div class="global-kpi-twoColumnRows">'
          +   renderGlobalKpiDataRowState('Gross Sales', tfsGrossSales == null ? '' : String(tfsGrossSales), null, tfsSalesLoading)
          +   renderGlobalKpiDataRowState('Discounted Sales', tfsDiscountedSales == null ? '' : String(tfsDiscountedSales), null, tfsSalesLoading)
          +   renderGlobalKpiDataRowState('Refunds', tfsSales ? String(tfsRefundedSales) : '', null, tfsSalesLoading)
          + '</div>';

        globalKpiTableMount.className = 'global-kpi-dashboard' + (hasPendingMetrics ? ' global-kpi-dashboard--refreshing' : '');
        globalKpiTableMount.innerHTML = ''
          + '<div class="global-kpi-shell">'
          +   '<div class="global-kpi-header">'
          +     '<div class="global-kpi-headerCopy">'
          +       '<p class="global-kpi-eyebrow">' + escapeHtml(locationLabel) + '</p>'
          +       '<h2>' + escapeHtml(quarterLabel) + '</h2>'
          +     '</div>'
          +     '<div class="global-kpi-period">'
          +       '<span class="global-kpi-pill">' + escapeHtml(quarterLabel) + '</span>'
          +       (hasPendingMetrics ? renderGlobalKpiLoadingBadge(globalKpiRefreshInFlight ? 'Refreshing now' : 'Still updating') : '')
          +       '<span class="global-kpi-periodMeta">' + escapeHtml([periodMeta, updateMeta].filter(Boolean).join(' · ')) + '</span>'
          +     '</div>'
          +   '</div>'
          +   '<div class="global-kpi-sections">'
          +     renderGlobalKpiSection('Revenue & Sales', '', revenueMarkup)
          +     renderGlobalKpiSection('Appointments & Capacity', '', appointmentsMarkup)
          +     renderGlobalKpiSection('Clients & Retention', '', clientsMarkup)
          +     renderGlobalKpiSection('Color & Data Discipline', '', disciplineMarkup)
          +     renderGlobalKpiSection('TFS Sales Dash', '', tfsMarkup, 'global-kpi-section--full')
          +   '</div>'
          + '</div>';
        syncGlobalKpiRefreshVisualState();
      }

      async function loadGlobalKpis(){
        if (!globalKpiTableMount) return;
        var selectedQuarter = getSelectedGlobalQuarter();
        var loadToken = activeGlobalKpiLoadToken + 1;
        activeGlobalKpiLoadToken = loadToken;
        syncGlobalKpiRefreshYtdButton();
        clearGlobalKpiAnnualRefreshPoll();
        if (!selectedQuarter) {
          setGlobalKpiStatus('Choose a period to load global KPIs.');
          globalKpiTableMount.className = 'empty';
          globalKpiTableMount.innerHTML = 'Choose a period to load global KPIs.';
          return;
        }

        try {
          setGlobalKpiStatus('Pulling global KPIs for ' + selectedQuarter.label + '...');
          globalKpiTableMount.className = 'empty';
          globalKpiTableMount.innerHTML = 'Pulling global KPIs for ' + escapeHtml(selectedQuarter.label) + '...';
          var result = null;
          var liveSalonMetrics;
          var tfsSalesSummary;
          var backgroundTasks = [];
          var useLiveSalonMetrics = false;
          var todayForTfs = startOfLocalDay(new Date());
          var tfsEffectiveEnd = selectedQuarter.end && selectedQuarter.end.getTime() > todayForTfs.getTime()
            ? todayForTfs
            : selectedQuarter.end;
          var tfsDateFrom = selectedQuarter.start ? formatDateInputValue(selectedQuarter.start) : '';
          var tfsDateTo = tfsEffectiveEnd ? formatDateInputValue(tfsEffectiveEnd) : '';
          liveSalonMetrics = useLiveSalonMetrics ? undefined : null;
          tfsSalesSummary = undefined;
          try {
            result = await fetchGlobalKpiSnapshotRows();
          } catch (_error) {
            result = await fetchGlobalKpiRows();
          }
          if (loadToken !== activeGlobalKpiLoadToken) return;
          var derivedMetrics = result && result.snapshot && result.snapshot.derived_metrics && typeof result.snapshot.derived_metrics === 'object'
            ? result.snapshot.derived_metrics
            : (result && result.derived_metrics && typeof result.derived_metrics === 'object' ? result.derived_metrics : {});
          var hasSnapshotLiveMetrics = !!(derivedMetrics
            && derivedMetrics.tag_capture
            && derivedMetrics.retail_attach
            && derivedMetrics.color_reweigh
            && derivedMetrics.shopify_sales);
          useLiveSalonMetrics = !hasSnapshotLiveMetrics && (isGlobalKpiQuarterSelection(selectedQuarter) || isCurrentYearGlobalKpiYtdSelection(selectedQuarter));
          renderGlobalKpiTable(result, liveSalonMetrics, tfsSalesSummary);
          hasLoadedGlobalKpis = true;
          setGlobalKpiStatus('Core KPIs loaded. Finishing supporting metrics for ' + selectedQuarter.label + '...');
          backgroundTasks.push(fetchTfsCollectionSalesSummary({
            collectionHandle: 'the-full-story',
            dateFrom: tfsDateFrom,
            dateTo: tfsDateTo,
            updatedSince: tfsDateFrom,
            maxPages: 25
          }).then(function(summary){
            if (loadToken !== activeGlobalKpiLoadToken) return;
            if (!getSelectedGlobalQuarter() || getSelectedGlobalQuarter().value !== selectedQuarter.value) return;
            tfsSalesSummary = summary;
            renderGlobalKpiTable(result, liveSalonMetrics, tfsSalesSummary);
          }).catch(function(){
            if (loadToken !== activeGlobalKpiLoadToken) return;
            if (!getSelectedGlobalQuarter() || getSelectedGlobalQuarter().value !== selectedQuarter.value) return;
            renderGlobalKpiTable(result, liveSalonMetrics, null);
          }));
          if (useLiveSalonMetrics) {
            backgroundTasks.push(fetchGlobalKpiLiveSalonMetrics().then(function(metrics){
              if (loadToken !== activeGlobalKpiLoadToken) return;
              if (!getSelectedGlobalQuarter() || getSelectedGlobalQuarter().value !== selectedQuarter.value) return;
              liveSalonMetrics = metrics;
              renderGlobalKpiTable(result, liveSalonMetrics, tfsSalesSummary);
            }).catch(function(){
              if (loadToken !== activeGlobalKpiLoadToken) return;
              if (!getSelectedGlobalQuarter() || getSelectedGlobalQuarter().value !== selectedQuarter.value) return;
              liveSalonMetrics = null;
              renderGlobalKpiTable(result, liveSalonMetrics, tfsSalesSummary);
            }));
          }
          if (backgroundTasks.length) {
            await Promise.allSettled(backgroundTasks);
            if (loadToken !== activeGlobalKpiLoadToken) return;
          }
          setGlobalKpiStatus('Global KPIs updated for ' + selectedQuarter.label + '.', 'success');
          if (isCurrentYearGlobalKpiYtdSelection(selectedQuarter)) {
            pollCurrentYearGlobalKpiRefreshStatus(String(selectedQuarter.value || '').trim(), { silent: true, reloadOnComplete: false });
          }
          syncGlobalKpiRefreshVisualState();
        } catch (error) {
          var message = humanizeDashboardErrorMessage(error && error.message ? error.message : 'Could not load global KPIs.');
          setGlobalKpiStatus(message, 'error');
          globalKpiTableMount.className = 'empty';
          globalKpiTableMount.innerHTML = escapeHtml(message);
        }
      }

      function ensureGlobalKpiLoaded(){
        if (!hasLoadedGlobalKpis) {
          loadGlobalKpis();
        }
      }

      function normalizeColorDisciplineRate(value){
        var rawText = String(value == null ? '' : value).trim();
        var hadPercentSymbol = rawText.indexOf('%') >= 0;
        var text = rawText.replace(/%/g, '');
        var numeric = Number(text);
        if (!isFinite(numeric) || numeric < 0) return 0;
        if (hadPercentSymbol) return numeric / 100;
        if (numeric > 1) return numeric / 100;
        return numeric;
      }

      function parseColorDisciplineNumber(value){
        var text = String(value == null ? '' : value).trim();
        if (!text) return 0;
        var normalized = text.replace(/[$,%]/g, '').replace(/,/g, '');
        var numeric = Number(normalized);
        return isFinite(numeric) ? numeric : 0;
      }

      function normalizeColorDisciplineHeaderKey(value){
        return String(value == null ? '' : value)
          .trim()
          .toLowerCase()
          .replace(/[\s_]+/g, '')
          .replace(/[^a-z0-9()%]/g, '');
      }

      function getColorDisciplineField(row, keys){
        var safeRow = row && typeof row === 'object' ? row : {};
        for (var index = 0; index < keys.length; index += 1) {
          var directKey = keys[index];
          if (safeRow[directKey] != null && String(safeRow[directKey]).trim() !== '') {
            return safeRow[directKey];
          }
        }
        var entries = Object.keys(safeRow);
        var wanted = keys.map(normalizeColorDisciplineHeaderKey);
        for (var entryIndex = 0; entryIndex < entries.length; entryIndex += 1) {
          var entryKey = entries[entryIndex];
          if (wanted.indexOf(normalizeColorDisciplineHeaderKey(entryKey)) >= 0) {
            var value = safeRow[entryKey];
            if (value != null && String(value).trim() !== '') {
              return value;
            }
          }
        }
        return '';
      }

      function normalizeColorDisciplineRow(row){
        var safeRow = row && typeof row === 'object' ? row : {};
        return {
          staff_name: String(getColorDisciplineField(safeRow, ['staff_name', 'Staff Name', 'Name'])).trim(),
          services: parseColorDisciplineNumber(getColorDisciplineField(safeRow, ['services', 'Services'])),
          product_dispensed: parseColorDisciplineNumber(getColorDisciplineField(safeRow, ['product_dispensed', 'Product Dispensed'])),
          product_dispensed_ounces: parseColorDisciplineNumber(getColorDisciplineField(safeRow, ['product_dispensed_ounces', 'Product Dispensed (Ounces)', 'Product Dispensed Ounces'])),
          product_dispensed_per_service: parseColorDisciplineNumber(getColorDisciplineField(safeRow, ['product_dispensed_per_service', 'Product Dispensed Per Service'])),
          reweigh_rate: normalizeColorDisciplineRate(getColorDisciplineField(safeRow, ['reweigh_rate', '% Reweighed', 'Reweigh %', 'Reweighed %'])),
          product_waste: parseColorDisciplineNumber(getColorDisciplineField(safeRow, ['product_waste', 'Product Waste'])),
          estimated_waste: parseColorDisciplineNumber(getColorDisciplineField(safeRow, ['estimated_waste', 'Estimated Waste'])),
          estimated_waste_ounces: parseColorDisciplineNumber(getColorDisciplineField(safeRow, ['estimated_waste_ounces', 'Estimated Waste (Ounces)', 'Estimated Waste Ounces'])),
          estimated_waste_per_service: parseColorDisciplineNumber(getColorDisciplineField(safeRow, ['estimated_waste_per_service', 'Estimated Waste Per Service'])),
          product_charges: parseColorDisciplineNumber(getColorDisciplineField(safeRow, ['product_charges', 'Product Charges'])),
          waste_rate: normalizeColorDisciplineRate(getColorDisciplineField(safeRow, ['waste_rate', '% Waste', 'Waste %']))
        };
      }

      function buildColorDisciplineRowsFromPaste(text){
        var parsed = csvRowsToObjects(parseDelimitedGrid(text || ''));
        var rows = Array.isArray(parsed.rows) ? parsed.rows.map(normalizeColorDisciplineRow).filter(function(row){
          return row.staff_name && row.services > 0;
        }) : [];
        if (!rows.length) {
          throw new Error('No Vish Employee Performance rows were found in that upload.');
        }
        return rows;
      }

      function formatCompactNumber(value, digits){
        var numeric = Number(value || 0);
        var precision = Number.isFinite(Number(digits)) ? Number(digits) : 0;
        return numeric.toLocaleString(undefined, {
          minimumFractionDigits: precision,
          maximumFractionDigits: precision
        });
      }

      function formatUsdNumber(value){
        var numeric = Number(value || 0);
        return numeric.toLocaleString(undefined, {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }

      function colorDisciplineTone(row){
        var rate = Number((row && row.reweigh_rate) || 0) || 0;
        if (rate >= 0.8) return 'crown';
        if (rate >= 0.5) return 'surge';
        return 'steady';
      }

      function colorDisciplineProgressWidth(row){
        var value = Math.max(0, Number((row && row.reweigh_rate) || 0) || 0);
        return Math.max(8, Math.min(100, Math.round(value * 100)));
      }

      function colorDisciplineStatusLabel(row){
        var rate = Number((row && row.reweigh_rate) || 0) || 0;
        if (rate >= 0.9) return 'Locked in';
        if (rate >= 0.75) return 'Strong follow-through';
        if (rate >= 0.5) return 'Building';
        return 'Opportunity';
      }

      function colorDisciplineSummaryLine(summary){
        var safeSummary = summary && typeof summary === 'object' ? summary : {};
        return formatPercent(Number(safeSummary.team_reweigh_rate || 0) * 100) + ' team reweigh across ' + String(Number(safeSummary.total_services || 0) || 0) + ' services';
      }

      function colorDisciplineAvailablePeriods(board){
        return board && Array.isArray(board.periods)
          ? board.periods
          : (board && Array.isArray(board.imports) ? board.imports : []);
      }

      function syncColorDisciplineWeekTabs(board){
        if (!colorDisciplineWeekTabs) return;
        var periods = colorDisciplineAvailablePeriods(board);
        if (!activeColorDisciplineImportId && periods.length) {
          activeColorDisciplineImportId = String((periods[0] && periods[0].id) || '');
        }
        colorDisciplineWeekTabs.innerHTML = periods.map(function(period){
          var value = String(period && period.id || '');
          var label = String((period && (period.short_label || period.label)) || '').trim() || formatColorDisciplineCompactRange(period && period.report_start_date, period && period.report_end_date);
          var isActive = value === activeColorDisciplineImportId;
          return '<button class="request-queue-tab' + (isActive ? ' is-active' : '') + '" type="button" data-color-period="' + escapeHtml(value) + '" aria-pressed="' + (isActive ? 'true' : 'false') + '">' + escapeHtml(label) + '</button>';
        }).join('');
      }

      function currentColorDisciplinePeriodLabel(board){
        var periods = colorDisciplineAvailablePeriods(board);
        var matched = periods.find(function(period){
          return String(period && period.id || '') === String(activeColorDisciplineImportId || '');
        }) || null;
        if (matched) {
          return String(matched.label || '').trim() || formatColorDisciplineCompactRange(matched.report_start_date, matched.report_end_date);
        }
        var summary = board && board.summary ? board.summary : null;
        return formatColorDisciplineCompactRange(summary && summary.report_start_date, summary && summary.report_end_date);
      }

      function formatColorDisciplineCompactRange(startValue, endValue){
        var startRaw = String(startValue || '').trim();
        var endRaw = String(endValue || '').trim();
        if (!startRaw && !endRaw) return 'Selected period';
        var start = startRaw ? new Date(startRaw + 'T12:00:00') : null;
        var end = endRaw ? new Date(endRaw + 'T12:00:00') : null;
        if ((start && isNaN(start.getTime())) || (end && isNaN(end.getTime()))) {
          return startRaw || endRaw || 'Selected period';
        }
        if (!start && end) start = new Date(end.getTime());
        if (!end && start) end = new Date(start.getTime());
        var sameYear = start.getFullYear() === end.getFullYear();
        var sameMonth = sameYear && start.getMonth() === end.getMonth();
        var startText = start.toLocaleDateString(undefined, {
          month: 'short',
          day: 'numeric'
        });
        var endText = end.toLocaleDateString(undefined, {
          month: sameMonth ? undefined : 'short',
          day: 'numeric',
          year: sameYear ? undefined : 'numeric'
        });
        return startText + ' - ' + endText;
      }

      function colorDisciplineStatusPrefix(period){
        var kind = String((period && period.period_kind) || 'payroll').trim().toLowerCase();
        if (kind === 'quarter') {
          return period && period.is_live_current ? 'Current quarter QTD' : 'Closed quarter';
        }
        return period && period.is_live_current ? 'Current payroll' : 'Closed payroll';
      }

      function colorDisciplineCardMarkup(row, rank){
        var safeRow = row && typeof row === 'object' ? row : {};
        var serviceCount = Number((safeRow && safeRow.services) || 0) || 0;
        var dispensedOunces = Number((safeRow && safeRow.product_dispensed_ounces) || 0) || 0;
        var dispensedFallback = Number((safeRow && safeRow.product_dispensed) || 0) || 0;
        var estimatedWaste = Number((safeRow && safeRow.estimated_waste) || 0) || 0;
        var dispensedValue = dispensedOunces > 0 ? dispensedOunces : dispensedFallback;
        var dispensedLabel = dispensedOunces > 0 ? 'Oz dispensed' : 'Dispensed';
        var reweighRate = Number((safeRow && safeRow.reweigh_rate) || 0) || 0;
        var wasteRate = Number((safeRow && safeRow.waste_rate) || 0) || 0;
        return ''
          + '<article class="retail-card retail-card--compact retail-successCard retail-successCard--' + escapeHtml(colorDisciplineTone(safeRow)) + '">'
          +   '<div class="retail-cardHead">'
          +     '<div class="retail-cardIdentity">'
          +       '<h3 class="retail-cardTitle">' + escapeHtml(retailTextValue(safeRow && safeRow.staff_name, 'Staff')) + '</h3>'
          +       '<p class="retail-cardMeta">' + escapeHtml('#' + String(rank) + ' on the reweigh board') + '</p>'
          +     '</div>'
          +     '<div class="retail-cardBadges">'
          +       '<span class="retail-chip retail-chip--accent">Reweigh</span>'
          +       '<span class="retail-chip retail-chip--history">' + escapeHtml(colorDisciplineStatusLabel(safeRow)) + '</span>'
          +     '</div>'
          +   '</div>'
          +   '<div class="retail-successCardHero">'
          +     '<div class="retail-successCardValue">' + escapeHtml(formatPercent(reweighRate * 100)) + '</div>'
          +     '<div class="retail-successCardLabel">Reweigh rate</div>'
          +   '</div>'
          +   '<div class="retail-rankTrack retail-rankTrack--success"><span style="width:' + escapeHtml(String(colorDisciplineProgressWidth(safeRow))) + '%"></span></div>'
          +   '<div class="retail-cardFacts">'
          +     '<article class="retail-cardFact"><strong>' + escapeHtml(String(serviceCount)) + '</strong><span class="retail-cardFactLabel">Services</span></article>'
          +     '<article class="retail-cardFact"><strong>' + escapeHtml(formatCompactNumber(dispensedValue, 1)) + '</strong><span class="retail-cardFactLabel">' + escapeHtml(dispensedLabel) + '</span></article>'
          +     '<article class="retail-cardFact"><strong>' + escapeHtml(formatUsdNumber(estimatedWaste)) + '</strong><span class="retail-cardFactLabel">Est. waste</span></article>'
          +   '</div>'
          +   '<div class="retail-reason">' + escapeHtml(formatPercent(wasteRate * 100) + ' waste rate across this payroll view.') + '</div>'
          + '</article>';
      }

      function renderColorDisciplineSummary(board){
        if (!colorDisciplineSummaryMount) return;
        var summary = board && board.summary ? board.summary : null;
        if (!summary) {
          colorDisciplineSummaryMount.className = 'empty';
          colorDisciplineSummaryMount.innerHTML = 'Upload a Vish report to see the team summary.';
          return;
        }
        colorDisciplineSummaryMount.className = '';
        var periodLabel = currentColorDisciplinePeriodLabel(board);
        colorDisciplineSummaryMount.innerHTML = ''
          + '<section class="retail-successLane">'
          +   '<div class="retail-fieldBoardHead">'
          +     '<div>'
          +       '<h3 class="retail-fieldBoardTitle">Team Color Discipline</h3>'
          +       '<p class="retail-fieldBoardMeta">' + escapeHtml(periodLabel + ' · ' + colorDisciplineSummaryLine(summary)) + '</p>'
          +     '</div>'
          +     '<div class="retail-scoreboardStats retail-scoreboardStats--lane">'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(formatPercent((summary.team_reweigh_rate || 0) * 100)) + '</strong><span>team reweigh</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(formatUsdNumber(Number(summary.total_estimated_waste != null ? summary.total_estimated_waste : summary.estimated_waste) || 0)) + '</strong><span>Total estimated waste</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(formatUsdNumber(Number(summary.waste_per_service != null ? summary.waste_per_service : summary.estimated_waste_per_service) || 0)) + '</strong><span>Est. waste / service</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(Number(summary.staff_count || 0) || 0)) + '</strong><span>staff tracked</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(String(Number(summary.total_services || 0) || 0)) + '</strong><span>services</span></div>'
          +       '<div class="retail-scoreboardStat"><strong>' + escapeHtml(summary.imported_at_label || 'Imported now') + '</strong><span>last upload</span></div>'
          +     '</div>'
          +   '</div>'
          + '</section>';
      }

      function renderColorDisciplineLeaderboard(board){
        if (!colorDisciplineLeaderboardMount) return;
        var rows = board && Array.isArray(board.rows) ? board.rows.slice() : [];
        if (!rows.length) {
          colorDisciplineLeaderboardMount.className = 'empty';
          colorDisciplineLeaderboardMount.innerHTML = 'No Color Discipline rows are available yet.';
          return;
        }
        var ranked = rows.slice().sort(function(a, b){
          if (b.reweigh_rate !== a.reweigh_rate) return b.reweigh_rate - a.reweigh_rate;
          return (b.services || 0) - (a.services || 0);
        });
        colorDisciplineLeaderboardMount.className = '';
        colorDisciplineLeaderboardMount.innerHTML = ''
          + '<section class="retail-successLane">'
          +   '<div class="retail-successGrid">'
          +     ranked.map(function(row, index){
                return colorDisciplineCardMarkup(row, index + 1);
              }).join('')
          +   '</div>'
          +   '</div>'
          + '</section>';
      }

      function updateColorDisciplineCoverageHint(board){
        var periods = colorDisciplineAvailablePeriods(board);
        var selected = periods.find(function(period){
          return String(period && period.id || '') === String(activeColorDisciplineImportId || '');
        }) || null;
        var latestCoveredThrough = selected && selected.live_through
          ? String(selected.live_through)
          : (board && board.latest_covered_through ? String(board.latest_covered_through) : '');
        var nextStartDate = board && board.next_recommended_start_date
          ? String(board.next_recommended_start_date)
          : '';
        if (!latestCoveredThrough) {
          setColorDisciplineCoverageHint('No Color Discipline coverage uploaded yet.');
          return;
        }
        var kind = String((selected && selected.period_kind) || 'payroll').trim().toLowerCase();
        var message = selected && selected.is_live_current
          ? ((kind === 'quarter' ? 'Current quarter Vish data through ' : 'Current payroll Vish data through ') + latestCoveredThrough + '.')
          : ('Data loaded through ' + latestCoveredThrough + '.');
        if (nextStartDate && !(selected && selected.is_live_current)) {
          message += ' Next upload can start ' + nextStartDate + '.';
        }
        setColorDisciplineCoverageHint(message, 'success');
      }

      function setColorDisciplineUploadState(fileName){
        var name = String(fileName || '').trim();
        if (colorDisciplineUploadZone) {
          colorDisciplineUploadZone.classList.toggle('is-loaded', !!name);
        }
        if (colorDisciplineUploadTitle) {
          colorDisciplineUploadTitle.textContent = name ? ('Loaded: ' + name) : 'Drop a file here or choose one';
        }
        if (colorDisciplineUploadMeta) {
          colorDisciplineUploadMeta.textContent = name
            ? 'File is loaded locally. Click Upload report to save it.'
            : 'Pick the Vish report start and end dates for this upload, then drop the Employee Performance export. Best today: CSV, TSV, or TXT.';
        }
      }

      function renderColorDisciplineBoard(board){
        colorDisciplineBoard = board || null;
        if (board && board.selected_import_id) {
          activeColorDisciplineImportId = String(board.selected_import_id);
        }
        syncColorDisciplineWeekTabs(colorDisciplineBoard);
        if (colorDisciplineReportStart && board && board.summary && board.summary.report_start_date) {
          colorDisciplineReportStart.value = String(board.summary.report_start_date || '');
        }
        if (colorDisciplineReportEnd && board && board.summary && board.summary.report_end_date) {
          colorDisciplineReportEnd.value = String(board.summary.report_end_date || '');
        }
        updateColorDisciplineCoverageHint(colorDisciplineBoard);
        renderColorDisciplineSummary(colorDisciplineBoard);
        renderColorDisciplineLeaderboard(colorDisciplineBoard);
      }

      async function loadColorDisciplineBoard(selectedImportId){
        var editorId = currentProgressionEditor && currentProgressionEditor.staff_id
          ? currentProgressionEditor.staff_id
          : '';
        if (!editorId) {
          throw new Error('Manager sign-in is required.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'color-discipline-dashboard',
            editor_staff_id: editorId,
            payroll_start: selectedImportId || ''
          })
        });
        var data = await response.json().catch(function(){ return null; });
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || 'Could not load Color Discipline.');
        }
        return data;
      }

      async function ensureColorDisciplineLoaded(forceRefresh){
        if (hasLoadedColorDiscipline && !forceRefresh) return;
        try {
          var requestedPeriodId = String(activeColorDisciplineImportId || '');
          setColorDisciplineStatus('Loading color discipline period...');
          renderColorDisciplineBoard(null);
          var board = await loadColorDisciplineBoard(requestedPeriodId);
          renderColorDisciplineBoard(board);
          var periods = colorDisciplineAvailablePeriods(board);
          var selected = periods.find(function(period){
            return String(period && period.id || '') === String(activeColorDisciplineImportId || '');
          }) || null;
          var statusMessage = colorDisciplineStatusPrefix(selected) + ' · '
            + (selected && selected.is_live_current
              ? ('Vish through ' + String(selected.live_through || selected.date_to || ''))
              : currentColorDisciplinePeriodLabel(board));
          setColorDisciplineStatus(statusMessage, 'success');
          hasLoadedColorDiscipline = true;
        } catch (error) {
          var message = humanizeDashboardErrorMessage(error && error.message ? error.message : 'Could not load Color Discipline.');
          setColorDisciplineStatus(message, 'error');
          if (colorDisciplineSummaryMount) {
            colorDisciplineSummaryMount.className = 'empty';
            colorDisciplineSummaryMount.innerHTML = escapeHtml(message);
          }
          if (colorDisciplineLeaderboardMount) {
            colorDisciplineLeaderboardMount.className = 'empty';
            colorDisciplineLeaderboardMount.innerHTML = 'Upload a Vish report to start tracking reweigh and waste habits.';
          }
        }
      }

      async function importColorDisciplineSnapshot(){
        var editorId = currentProgressionEditor && currentProgressionEditor.staff_id
          ? currentProgressionEditor.staff_id
          : '';
        if (!editorId) {
          setColorDisciplineStatus('Manager sign-in is required before importing.', 'error');
          return;
        }
        try {
          var rows = buildColorDisciplineRowsFromPaste(colorDisciplineImportPayload);
          setColorDisciplineStatus('Uploading Color Discipline report...');
          if (colorDisciplineImportBtn) colorDisciplineImportBtn.disabled = true;
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'color-discipline-import',
              editor_staff_id: editorId,
              report_start_date: colorDisciplineReportStart ? colorDisciplineReportStart.value : '',
              report_end_date: colorDisciplineReportEnd ? colorDisciplineReportEnd.value : '',
              rows: rows
            })
          });
          var data = await response.json().catch(function(){ return null; });
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || 'Could not upload the Color Discipline report.');
          }
          colorDisciplineImportPayload = '';
          activeColorDisciplineImportId = '';
          if (colorDisciplineImportFile) {
            colorDisciplineImportFile.value = '';
          }
          setColorDisciplineUploadState('');
          hasLoadedColorDiscipline = false;
          await ensureColorDisciplineLoaded(true);
          setColorDisciplineStatus('Color Discipline report uploaded.', 'success');
          hasLoadedColorDiscipline = true;
        } catch (error) {
          setColorDisciplineStatus(humanizeDashboardErrorMessage(error && error.message ? error.message : 'Could not upload the Color Discipline report.'), 'error');
        } finally {
          if (colorDisciplineImportBtn) colorDisciplineImportBtn.disabled = false;
        }
      }

      function buildStaffGrowthReportFilters(year){
        var today = startOfLocalDay(new Date());
        var currentYear = today.getFullYear();
        if (year > currentYear) {
          return [];
        }
        var startDate = new Date(year, 0, 1);
        var endDate = year === currentYear ? today : new Date(year, 11, 31);
        var startDiff = diffDaysFromToday(startDate);
        var endDiff = diffDaysFromToday(endDate);
        if (startDiff < 0 || endDiff < 0) {
          return [];
        }
        return [
          {
            attribute_name: 'Sale Date',
            relative_date_query: {
              greater_equal: 'P' + String(startDiff + 1) + 'D'
            }
          },
          {
            attribute_name: 'Sale Date',
            relative_date_query: {
              less_equal: 'P' + String(endDiff) + 'D'
            }
          }
        ];
      }

      function isStaffGrowthYtdYear(year){
        return Number(year) === startOfLocalDay(new Date()).getFullYear();
      }

      async function createStaffGrowthExport(year){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'create-report-export',
            report_id: STAFF_GROWTH_REPORT_ID,
            file_content_type: 'CSV',
            frequency: 'ONCE',
            report_filters: buildStaffGrowthReportFilters(year)
          })
        });
        var data = await response.json().catch(function(){ return null; });
        if (!response.ok || !data || !data.ok || !data.report_export) {
          throw new Error((data && data.error) || 'Could not create staff growth export.');
        }
        return data.report_export;
      }

      async function fetchStaffGrowthRowsForYear(year){
        var created = await createStaffGrowthExport(year);
        var readyExport = await waitForKpiExportReady(created);
        var proxyResponse = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'report-export-rows',
            file_url: readyExport.file_url
          })
        });
        var proxyData = await proxyResponse.json().catch(function(){ return null; });
        if (!proxyResponse.ok || !proxyData || !proxyData.ok) {
          throw new Error((proxyData && proxyData.error) || 'Could not download staff growth CSV.');
        }
        var rows = Array.isArray(proxyData.rows) ? proxyData.rows : [];
        return {
          headers: Array.isArray(proxyData.headers) ? proxyData.headers : [],
          rows: rows.map(function(row){
            var nextRow = Object.assign({}, row);
            nextRow.__staffGrowthYear = String(year);
            nextRow.__staffGrowthIsYtd = isStaffGrowthYtdYear(year) ? 'true' : 'false';
            return nextRow;
          })
        };
      }

      async function fetchStaffGrowthRows(){
        try {
          var response = await fetch(REPORT_PROXY_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'staff-growth-snapshot-get',
              refresh_if_missing: false
            })
          });
          var rawText = await response.text();
          var data = null;
          try {
            data = rawText ? JSON.parse(rawText) : null;
          } catch (_error) {
            data = null;
          }
          if (!response.ok || !data || !data.ok) {
            throw new Error((data && data.error) || rawText || 'Could not load staff growth snapshot.');
          }
          return {
            headers: Array.isArray(data.headers) ? data.headers : [],
            rows: Array.isArray(data.rows) ? data.rows : [],
            directoryStaff: Array.isArray(data.directory_staff) ? data.directory_staff : [],
            snapshot: data && data.snapshot && typeof data.snapshot === 'object' ? data.snapshot : null,
            snapshot_source: 'saved'
          };
        } catch (_error) {
          var yearResults = await Promise.all(STAFF_GROWTH_YEARS.map(function(year){
            return fetchStaffGrowthRowsForYear(year);
          }));
          var headers = [];
          var rows = [];
          yearResults.forEach(function(result){
            if (!headers.length && Array.isArray(result.headers) && result.headers.length) {
              headers = result.headers.slice();
            }
            rows = rows.concat(Array.isArray(result.rows) ? result.rows : []);
          });
          return {
            headers: headers,
            rows: rows,
            directoryStaff: [],
            snapshot: null,
            snapshot_source: 'live'
          };
        }
      }

      function isAllValue(value){
        return String(value == null ? '' : value).trim().toLowerCase() === 'all';
      }

      function detectStaffGrowthYear(row){
        var explicitYear = String((row && row.__staffGrowthYear) || '').trim();
        if (/^\d{4}$/.test(explicitYear)) return explicitYear;
        var candidates = [
          'SaleDate Year',
          'Sale Date Year',
          'Sale Year',
          'Year'
        ];
        for (var index = 0; index < candidates.length; index += 1) {
          var candidate = candidates[index];
          var raw = String((row && row[candidate]) || '').trim();
          if (/^\d{4}$/.test(raw)) return raw;
        }

        var keys = row ? Object.keys(row) : [];
        for (var i = 0; i < keys.length; i += 1) {
          var key = keys[i];
          if (!/year/i.test(key)) continue;
          var value = String((row && row[key]) || '').trim();
          if (/^\d{4}$/.test(value)) return value;
        }

        var dateCandidates = [
          'Sale Date',
          'SaleDate',
          'Date'
        ];
        for (var j = 0; j < dateCandidates.length; j += 1) {
          var dateValue = String((row && row[dateCandidates[j]]) || '').trim();
          var parsed = new Date(dateValue);
          if (!isNaN(parsed.getTime())) return String(parsed.getFullYear());
        }
        return '';
      }

      function detectStaffGrowthIsYtd(row){
        return String((row && row.__staffGrowthIsYtd) || '').trim() === 'true';
      }

      function prepareStaffGrowthRows(rows){
        var validRows = (Array.isArray(rows) ? rows : []).filter(function(row){
          var staffName = String((row && row['Staff Name']) || '').trim();
          if (!staffName || isAllValue(staffName)) return false;
          var yearValue = detectStaffGrowthYear(row);
          if (!yearValue) return false;
          var quarterValue = String((row && row['SaleDate Quarter']) || '').trim();
          if (quarterValue && isAllValue(quarterValue)) return false;
          return true;
        });

        var allLocationRows = validRows.filter(function(row){
          return isAllValue(row && row['Location name']);
        });
        return allLocationRows.length ? allLocationRows : validRows;
      }

      function getStaffGrowthWeekKey(row){
        var dateCandidates = [
          'Sale Date',
          'SaleDate Date',
          'SaleDate',
          'Date'
        ];
        for (var index = 0; index < dateCandidates.length; index += 1) {
          var rawValue = String((row && row[dateCandidates[index]]) || '').trim();
          if (!rawValue) continue;
          var parsed = new Date(rawValue);
          if (isNaN(parsed.getTime())) continue;
          var start = startOfLocalDay(parsed);
          var weekday = start.getDay();
          var offset = weekday === 0 ? -6 : 1 - weekday;
          var weekStart = startOfLocalDay(new Date(start.getFullYear(), start.getMonth(), start.getDate() + offset));
          return [
            String(weekStart.getFullYear()),
            String(weekStart.getMonth() + 1).padStart(2, '0'),
            String(weekStart.getDate()).padStart(2, '0')
          ].join('-');
        }
        return '';
      }

      function aggregateStaffGrowthByYear(rows){
        var map = {};
        rows.forEach(function(row){
          var year = detectStaffGrowthYear(row);
          if (!year) return;
          if (!map[year]) {
            map[year] = {
              year: year,
              serviceSales: 0,
              appointmentCount: 0,
              productSales: 0,
              tipSales: 0,
              newClientCount: 0,
              returningClientCount: 0,
              requestedAppointmentCount: 0,
              hoursBooked: 0,
              hoursScheduled: 0,
              detailHoursScheduled: 0,
              activeWeekKeys: {},
              weightedPrebookedNumerator: 0,
              weightedPrebookedDenominator: 0,
              weightedUtilizationNumerator: 0,
              weightedUtilizationDenominator: 0,
              weightedSelfBookedNumerator: 0,
              weightedSelfBookedDenominator: 0,
              isYtd: false
            };
          }
          var target = map[year];
          if (detectStaffGrowthIsYtd(row)) {
            target.isYtd = true;
          }
          var appointmentCount = parseNumericCell(row['Appointment Count']);
          var serviceSales = parseNumericCell(row['Service Sales']);
          var productSales = parseNumericCell(row['Product Sales']);
          var tipSales = parseNumericCell(row['Tip Sales']);
          var hoursBooked = parseNumericCell(row['Hours Booked']);
          var hoursScheduled = parseNumericCell(row['Hours Scheduled']);
          var newClientCount = parseNumericCell(row['New Client Count']);
          var returningClientCount = parseNumericCell(row['Returning Client Count']);
          var requestedAppointmentCount = parseNumericCell(row['Requested Appointment Count']);
          var prebookedValue = parseNumericCell(row['Prebooked %']);
          var utilizationValue = parseNumericCell(row['Utilization %']);
          var selfBookedValue = parseNumericCell(row['Self-booked %']);
          var activeWeekKey = getStaffGrowthWeekKey(row);
          var isSummaryRow = isAllValue(row && row['SaleDate Date']);
          var prebookedRatio = prebookedValue > 1 ? prebookedValue / 100 : prebookedValue;
          var utilizationRatio = utilizationValue > 1 ? utilizationValue / 100 : utilizationValue;
          var selfBookedRatio = selfBookedValue > 1 ? selfBookedValue / 100 : selfBookedValue;

          target.serviceSales += serviceSales;
          target.appointmentCount += appointmentCount;
          target.productSales += productSales;
          target.tipSales += tipSales;
          target.newClientCount += newClientCount;
          target.returningClientCount += returningClientCount;
          target.requestedAppointmentCount += requestedAppointmentCount;
          target.hoursBooked += hoursBooked;
          target.hoursScheduled += hoursScheduled;
          target.weightedPrebookedNumerator += prebookedRatio * appointmentCount;
          target.weightedPrebookedDenominator += appointmentCount;
          target.weightedUtilizationNumerator += hoursBooked;
          target.weightedUtilizationDenominator += hoursScheduled;
          target.weightedSelfBookedNumerator += selfBookedRatio * appointmentCount;
          target.weightedSelfBookedDenominator += appointmentCount;
          if (!isSummaryRow && hoursScheduled > 0) {
            target.detailHoursScheduled += hoursScheduled;
          }
          if (activeWeekKey && hoursScheduled > 0) {
            target.activeWeekKeys[activeWeekKey] = true;
          }
        });

        return Object.keys(map).sort().map(function(year){
          var row = map[year];
          var productionRate = row.hoursBooked > 0 ? row.serviceSales / row.hoursBooked : 0;
          var activeWeeks = Object.keys(row.activeWeekKeys || {}).length;
          var result = {
            year: year,
            serviceSales: row.serviceSales,
            appointmentCount: row.appointmentCount,
            productSales: row.productSales,
            tipSales: row.tipSales,
            newClientCount: row.newClientCount,
            returningClientCount: row.returningClientCount,
            requestedAppointmentCount: row.requestedAppointmentCount,
            hoursBooked: row.hoursBooked,
            hoursScheduled: row.hoursScheduled,
            detailHoursScheduled: row.detailHoursScheduled,
            activeWeeks: activeWeeks,
            productionRate: productionRate,
            prebookedRate: row.weightedPrebookedDenominator > 0 ? row.weightedPrebookedNumerator / row.weightedPrebookedDenominator : 0,
            utilizationRate: row.weightedUtilizationDenominator > 0 ? row.weightedUtilizationNumerator / row.weightedUtilizationDenominator : 0,
            selfBookedRate: row.weightedSelfBookedDenominator > 0 ? row.weightedSelfBookedNumerator / row.weightedSelfBookedDenominator : 0,
            retailToServiceRate: row.serviceSales > 0 ? row.productSales / row.serviceSales : 0,
            isYtd: !!row.isYtd
          };
          if (result.isYtd) {
            var ytdDate = startOfLocalDay(new Date());
            var yearStart = startOfLocalDay(new Date(Number(year), 0, 1));
            var yearEnd = startOfLocalDay(new Date(Number(year), 11, 31));
            var elapsedDays = Math.max(1, Math.floor((ytdDate.getTime() - yearStart.getTime()) / 86400000) + 1);
            var totalDays = Math.max(elapsedDays, Math.floor((yearEnd.getTime() - yearStart.getTime()) / 86400000) + 1);
            var runRate = totalDays / elapsedDays;
            result.ytdThroughLabel = ytdDate.toLocaleDateString(undefined, {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            });
            result.projectedServiceSales = result.serviceSales * runRate;
            result.projectedAppointmentCount = result.appointmentCount * runRate;
            result.projectedHoursBooked = result.hoursBooked * runRate;
            result.projectedHoursScheduled = result.hoursScheduled * runRate;
          }
          return result;
        });
      }

      function buildStaffGrowthDataset(headers, rows, directoryStaff, options){
        var datasetOptions = options && typeof options === 'object' ? options : {};
        var preparedRows = prepareStaffGrowthRows(rows);
        var normalizedHeaders = Array.isArray(headers) ? headers.map(function(header){
          return String(header || '').trim().toLowerCase();
        }) : [];
        var hasStaffColumn = normalizedHeaders.indexOf('staff name') !== -1;
        if (!hasStaffColumn) {
          return {
            headers: headers,
            rows: preparedRows,
            snapshot: datasetOptions.snapshot || null,
            snapshot_source: String(datasetOptions.snapshot_source || '').trim(),
            staffNames: [],
            byStaff: {},
            issue: 'KPI Staff is not returning a Staff Name column, so this tab cannot build staff-level growth from that report yet.'
          };
        }

        var groups = {};
        var levelsByStaff = {};
        var avatarsByStaff = {};
        preparedRows.forEach(function(row){
          var staffName = String((row && row['Staff Name']) || '').trim();
          if (!staffName) return;
          if (!groups[staffName]) groups[staffName] = [];
          groups[staffName].push(row);
          if (!levelsByStaff[staffName]) {
            var roleName = extractLevelFromRecord(row);
            if (roleName) levelsByStaff[staffName] = roleName;
          }
        });
        (Array.isArray(directoryStaff) ? directoryStaff : []).forEach(function(member){
          var staffName = String((member && member.name) || '').trim();
          var roleName = String((member && member.role) || '').trim();
          var avatar = String((member && member.avatar) || '').trim();
          if (!staffName) return;
          if (!groups[staffName]) groups[staffName] = [];
          if (roleName && !levelsByStaff[staffName]) {
            levelsByStaff[staffName] = roleName;
          }
          if (avatar && !avatarsByStaff[staffName]) {
            avatarsByStaff[staffName] = avatar;
          }
        });

        var staffNames = Object.keys(groups).sort(function(a, b){
          return a.localeCompare(b);
        });

        return {
          headers: headers,
          rows: preparedRows,
          snapshot: datasetOptions.snapshot || null,
          snapshot_source: String(datasetOptions.snapshot_source || '').trim(),
          staffNames: staffNames,
          levelsByStaff: levelsByStaff,
          avatarsByStaff: avatarsByStaff,
          byStaff: staffNames.reduce(function(map, staffName){
            map[staffName] = aggregateStaffGrowthByYear(groups[staffName]);
            return map;
          }, {})
        };
      }

      function buildLevel7ComparisonDataset(dataset){
        if (!dataset || dataset.issue) {
          return {
            issue: dataset && dataset.issue ? dataset.issue : 'No staff growth data is available yet.'
          };
        }
        var staffEntries = getLiveLevel7ComparisonEntries(dataset);
        if (!staffEntries.length) {
          return {
            issue: 'No current staff rows were found in the KPI Staff growth snapshot.'
          };
        }
        return {
          staffEntries: staffEntries,
          byStaff: dataset.byStaff || {},
          levelsByStaff: dataset.levelsByStaff || {},
          periodOptions: LEVEL7_COMPARISON_PERIOD_OPTIONS.slice(),
          levelOptions: buildLevel7ComparisonLevelOptions(staffEntries)
        };
      }

      function buildLevel7ComparisonLevelKey(levelNumber){
        return levelNumber != null ? String(levelNumber) : 'unknown';
      }

      function getLevel7ComparisonEntryLevel(staffName, dataset){
        var levelLabel = getLevelLabel(staffName);
        if (!levelLabel && dataset && dataset.levelsByStaff) {
          levelLabel = String(dataset.levelsByStaff[staffName] || '').trim();
        }
        var levelNumber = parseRoleLevelNumber(levelLabel);
        return {
          levelLabel: levelLabel,
          levelNumber: levelNumber,
          levelKey: buildLevel7ComparisonLevelKey(levelNumber)
        };
      }

      function getLiveLevel7ComparisonEntries(dataset){
        var seen = {};
        var entries = [];

        function pushEntry(staffName){
          var normalizedName = String(staffName || '').trim();
          if (!normalizedName) return;
          var key = normalizedName.toLowerCase();
          if (seen[key]) return;
          seen[key] = true;
          var levelInfo = getLevel7ComparisonEntryLevel(normalizedName, dataset);
          entries.push({
            staffName: normalizedName,
            levelLabel: levelInfo.levelLabel,
            levelNumber: levelInfo.levelNumber,
            levelKey: levelInfo.levelKey
          });
        }

        Object.keys(levelByStaff || {}).forEach(function(staffName){
          pushEntry(staffName);
        });
        (Array.isArray(dataset && dataset.staffNames) ? dataset.staffNames : []).forEach(function(staffName){
          pushEntry(staffName);
        });
        if (!entries.length) {
          LEVEL7_COMPARISON_FALLBACK_NAMES.forEach(function(staffName){
            pushEntry(staffName);
          });
        }
        return entries.sort(function(left, right){
          var leftLevel = left.levelNumber;
          var rightLevel = right.levelNumber;
          if (leftLevel != null && rightLevel != null && leftLevel !== rightLevel) return leftLevel - rightLevel;
          if (leftLevel != null && rightLevel == null) return -1;
          if (leftLevel == null && rightLevel != null) return 1;
          return left.staffName.localeCompare(right.staffName);
        });
      }

      function buildLevel7ComparisonLevelOptions(staffEntries){
        var seen = {};
        var options = [{
          key: 'all',
          label: 'All levels'
        }];
        (Array.isArray(staffEntries) ? staffEntries : []).forEach(function(entry){
          if (!entry || seen[entry.levelKey]) return;
          seen[entry.levelKey] = true;
          options.push({
            key: entry.levelKey,
            label: entry.levelNumber != null ? ('Level ' + entry.levelNumber) : 'No level'
          });
        });
        return options;
      }

      function getLevel7ComparisonPeriodMeta(periodKey){
        var key = String(periodKey || 'all');
        for (var index = 0; index < LEVEL7_COMPARISON_PERIOD_OPTIONS.length; index += 1) {
          if (LEVEL7_COMPARISON_PERIOD_OPTIONS[index].key === key) {
            return LEVEL7_COMPARISON_PERIOD_OPTIONS[index];
          }
        }
        return LEVEL7_COMPARISON_PERIOD_OPTIONS[0];
      }

      function getLevel7ComparisonPeriodKeyForRow(row){
        if (!row) return '';
        return String(row.year || '') + (row.isYtd ? '_ytd' : '');
      }

      function filterLevel7RowsForPeriod(staffRows, periodKey){
        var safeRows = Array.isArray(staffRows) ? staffRows : [];
        if (String(periodKey || '') === 'all') {
          return safeRows.filter(function(row){
            return LEVEL7_COMPARISON_PERIOD_OPTIONS.some(function(option){
              return option.key !== 'all' && option.key === getLevel7ComparisonPeriodKeyForRow(row);
            });
          });
        }
        return safeRows.filter(function(row){
          return getLevel7ComparisonPeriodKeyForRow(row) === String(periodKey || '');
        });
      }

      function aggregateLevel7ComparisonRows(rows){
        var safeRows = Array.isArray(rows) ? rows : [];
        if (!safeRows.length) return null;
        var totals = {
          serviceSales: 0,
          appointmentCount: 0,
          productSales: 0,
          tipSales: 0,
          newClientCount: 0,
          returningClientCount: 0,
          requestedAppointmentCount: 0,
          hoursBooked: 0,
          hoursScheduled: 0,
          detailHoursScheduled: 0,
          weightedPrebookedNumerator: 0,
          weightedPrebookedDenominator: 0,
          weightedSelfBookedNumerator: 0,
          weightedSelfBookedDenominator: 0,
          activeWeeks: 0
        };
        safeRows.forEach(function(row){
          var appointmentCount = Number(row && row.appointmentCount) || 0;
          var hoursBooked = Number(row && row.hoursBooked) || 0;
          var hoursScheduled = Number(row && row.hoursScheduled) || 0;
          var prebookedRate = Number(row && row.prebookedRate) || 0;
          var selfBookedRate = Number(row && row.selfBookedRate) || 0;

          totals.serviceSales += Number(row && row.serviceSales) || 0;
          totals.appointmentCount += appointmentCount;
          totals.productSales += Number(row && row.productSales) || 0;
          totals.tipSales += Number(row && row.tipSales) || 0;
          totals.newClientCount += Number(row && row.newClientCount) || 0;
          totals.returningClientCount += Number(row && row.returningClientCount) || 0;
          totals.requestedAppointmentCount += Number(row && row.requestedAppointmentCount) || 0;
          totals.hoursBooked += hoursBooked;
          totals.hoursScheduled += hoursScheduled;
          totals.detailHoursScheduled += Number(row && row.detailHoursScheduled) || 0;
          totals.activeWeeks += Number(row && row.activeWeeks) || 0;
          totals.weightedPrebookedNumerator += prebookedRate * appointmentCount;
          totals.weightedPrebookedDenominator += appointmentCount;
          totals.weightedSelfBookedNumerator += selfBookedRate * appointmentCount;
          totals.weightedSelfBookedDenominator += appointmentCount;
        });
        return {
          serviceSales: totals.serviceSales,
          appointmentCount: totals.appointmentCount,
          productSales: totals.productSales,
          tipSales: totals.tipSales,
          newClientCount: totals.newClientCount,
          returningClientCount: totals.returningClientCount,
          requestedAppointmentCount: totals.requestedAppointmentCount,
          hoursBooked: totals.hoursBooked,
          hoursScheduled: totals.hoursScheduled,
          detailHoursScheduled: totals.detailHoursScheduled,
          activeWeeks: totals.activeWeeks,
          productionRate: totals.hoursBooked > 0 ? totals.serviceSales / totals.hoursBooked : 0,
          prebookedRate: totals.weightedPrebookedDenominator > 0 ? totals.weightedPrebookedNumerator / totals.weightedPrebookedDenominator : 0,
          utilizationRate: totals.hoursScheduled > 0 ? totals.hoursBooked / totals.hoursScheduled : 0,
          selfBookedRate: totals.weightedSelfBookedDenominator > 0 ? totals.weightedSelfBookedNumerator / totals.weightedSelfBookedDenominator : 0,
          retailToServiceRate: totals.serviceSales > 0 ? totals.productSales / totals.serviceSales : 0,
          isYtd: true
        };
      }

      function createEmptyLevel7ComparisonRow(staffName){
        var levelInfo = getLevel7ComparisonEntryLevel(staffName);
        return {
          staffName: staffName,
          levelLabel: levelInfo.levelLabel || 'No level',
          levelNumber: levelInfo.levelNumber,
          levelKey: levelInfo.levelKey,
          reliabilityScore: null,
          requestsOff: null,
          callOuts: null,
          lateArrivals: null,
          leavingEarly: null,
          serviceSales: null,
          appointmentCount: null,
          productSales: null,
          tipSales: null,
          newClientCount: null,
          returningClientCount: null,
          requestedAppointmentCount: null,
          hoursBooked: null,
          hoursScheduled: null,
          productionRate: null,
          prebookedRate: null,
          utilizationRate: null,
          selfBookedRate: null,
          retailToServiceRate: null,
          attachRate: null,
          attachClosedAppointments: null,
          colorDisciplineReweighRate: null,
          colorDisciplineServices: null,
          hasKpiData: false
        };
      }

      function buildLevel7SupplementalWindow(periodKey){
        var normalizedKey = String(periodKey || '').trim();
        if (!normalizedKey || normalizedKey === 'all') return null;
        var today = startOfLocalDay(new Date());
        if (normalizedKey === '2026_ytd') {
          return {
            date_from: '2026-01-01',
            date_to: formatDateInputValue(today)
          };
        }
        if (/^\d{4}$/.test(normalizedKey)) {
          return {
            date_from: normalizedKey + '-01-01',
            date_to: normalizedKey + '-12-31'
          };
        }
        return null;
      }

      function getLevel7SupplementalMetricsMap(periodKey){
        return level7SupplementalMetricsByPeriod[String(periodKey || '').trim()] || {};
      }

      function hasLevel7SupplementalMetricsLoaded(periodKey){
        return Object.prototype.hasOwnProperty.call(level7SupplementalMetricsByPeriod, String(periodKey || '').trim());
      }

      function isLevel7SupplementalMetricsLoading(periodKey){
        return level7SupplementalMetricsLoading[String(periodKey || '').trim()] === true;
      }

      function createEmptyLevel7SupplementalAggregate(){
        return {
          attachRetailVisitsWeighted: 0,
          attachClosedAppointments: 0,
          colorReweighWeighted: 0,
          colorDisciplineServices: 0
        };
      }

      function aggregateLevel7SupplementalMetricMaps(maps){
        var aggregate = {};
        retailArray(maps).forEach(function(map){
          Object.keys(map || {}).forEach(function(staffName){
            var row = map[staffName] || {};
            if (!aggregate[staffName]) {
              aggregate[staffName] = createEmptyLevel7SupplementalAggregate();
            }
            var target = aggregate[staffName];
            var attachClosed = Math.max(0, Number(row.attachClosedAppointments) || 0);
            var attachRate = Math.max(0, Number(row.attachRate) || 0);
            var colorServices = Math.max(0, Number(row.colorDisciplineServices) || 0);
            var reweighRate = Math.max(0, Number(row.colorDisciplineReweighRate) || 0);
            target.attachClosedAppointments += attachClosed;
            target.attachRetailVisitsWeighted += attachRate * attachClosed;
            target.colorDisciplineServices += colorServices;
            target.colorReweighWeighted += reweighRate * colorServices;
          });
        });
        return Object.keys(aggregate).reduce(function(result, staffName){
          var row = aggregate[staffName];
          result[staffName] = {
            attachRate: row.attachClosedAppointments > 0 ? row.attachRetailVisitsWeighted / row.attachClosedAppointments : null,
            attachClosedAppointments: row.attachClosedAppointments,
            colorDisciplineReweighRate: row.colorDisciplineServices > 0 ? row.colorReweighWeighted / row.colorDisciplineServices : null,
            colorDisciplineServices: row.colorDisciplineServices
          };
          return result;
        }, {});
      }

      function findLevel7SupplementalMetricsForStaff(map, staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName || !map) return null;
        if (Object.prototype.hasOwnProperty.call(map, normalizedName)) {
          return map[normalizedName];
        }
        var keys = Object.keys(map || {});
        for (var index = 0; index < keys.length; index += 1) {
          if (sameStaffName(keys[index], normalizedName) || sameRetailStaffName(keys[index], normalizedName)) {
            return map[keys[index]];
          }
        }
        return null;
      }

      async function fetchLevel7SupplementalMetrics(periodKey){
        var window = buildLevel7SupplementalWindow(periodKey);
        if (!window && String(periodKey || '').trim() !== 'all') return {};
        if (String(periodKey || '').trim() === 'all') {
          var allPeriodKeys = LEVEL7_COMPARISON_PERIOD_OPTIONS.map(function(option){
            return String(option && option.key || '').trim();
          }).filter(function(key){
            return key && key !== 'all';
          });
          var results = await Promise.all(allPeriodKeys.map(function(key){
            return fetchLevel7SupplementalMetrics(key).catch(function(){
              return {};
            });
          }));
          return aggregateLevel7SupplementalMetricMaps(results);
        }
        if (!currentProgressionEditor || !currentProgressionEditor.staff_id) {
          throw new Error('Manager sign-in is required.');
        }
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'staff-kpi-supplemental-metrics',
            editor_staff_id: currentProgressionEditor.staff_id,
            date_from: window.date_from,
            date_to: window.date_to
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load retail attach and color reweigh.');
        }
        var rows = Array.isArray(data.rows) ? data.rows : [];
        return rows.reduce(function(map, row){
          var staffName = String((row && row.staff_name) || '').trim();
          if (!staffName) return map;
          map[staffName] = {
            attachRate: row && row.attach_rate != null ? ((Number(row.attach_rate) || 0) / 100) : null,
            attachClosedAppointments: row && row.attach_closed_appointments != null ? Number(row.attach_closed_appointments) || 0 : null,
            colorDisciplineReweighRate: row && row.color_discipline_reweigh_rate != null ? ((Number(row.color_discipline_reweigh_rate) || 0) / 100) : null,
            colorDisciplineServices: row && row.color_discipline_services != null ? Number(row.color_discipline_services) || 0 : null
          };
          return map;
        }, {});
      }

      function ensureLevel7SupplementalMetrics(periodKey){
        var normalizedKey = String(periodKey || '').trim();
        if (!normalizedKey) return;
        if (hasLevel7SupplementalMetricsLoaded(normalizedKey) || level7SupplementalMetricsLoading[normalizedKey]) return;
        level7SupplementalMetricsLoading[normalizedKey] = true;
        fetchLevel7SupplementalMetrics(normalizedKey).then(function(map){
          level7SupplementalMetricsByPeriod[normalizedKey] = map || {};
          renderLevel7ComparisonView();
        }).catch(function(){
          level7SupplementalMetricsByPeriod[normalizedKey] = {};
        }).finally(function(){
          delete level7SupplementalMetricsLoading[normalizedKey];
        });
      }

      function prefetchLevel7SupplementalMetrics(excludePeriodKey){
        LEVEL7_COMPARISON_PERIOD_OPTIONS.forEach(function(option){
          var key = String(option && option.key || '').trim();
          if (!key || key === String(excludePeriodKey || '').trim()) return;
          ensureLevel7SupplementalMetrics(key);
        });
      }

      function filterLevel7ComparisonEntriesByLevel(staffEntries, levelKey){
        var safeEntries = Array.isArray(staffEntries) ? staffEntries : [];
        if (String(levelKey || 'all') === 'all') return safeEntries.slice();
        return safeEntries.filter(function(entry){
          return entry && entry.levelKey === String(levelKey || '');
        });
      }

      function getLevel7ComparisonActiveLevelMeta(dataset){
        var levelOptions = Array.isArray(dataset && dataset.levelOptions) ? dataset.levelOptions : [];
        var activeKey = String(level7ComparisonActiveLevel || 'all');
        for (var index = 0; index < levelOptions.length; index += 1) {
          if (levelOptions[index].key === activeKey) {
            return levelOptions[index];
          }
        }
        level7ComparisonActiveLevel = 'all';
        return levelOptions[0] || { key: 'all', label: 'All levels' };
      }

      function getLevel7AttendanceCoverageMap(periodKey){
        return level7AttendanceComparison[String(periodKey || '')] || {};
      }

      function getLevel7ComparisonDaysForPeriod(periodKey){
        if (String(periodKey || '') === '2026_ytd') {
          var today = startOfLocalDay(new Date());
          var yearStart = startOfLocalDay(new Date(today.getFullYear(), 0, 1));
          return Math.max(1, Math.floor((today.getTime() - yearStart.getTime()) / 86400000) + 1);
        }
        var year = Number(String(periodKey || '').slice(0, 4));
        if (!isFinite(year)) return 0;
        var start = startOfLocalDay(new Date(year, 0, 1));
        var end = startOfLocalDay(new Date(year, 11, 31));
        return Math.max(1, Math.floor((end.getTime() - start.getTime()) / 86400000) + 1);
      }

      function getLevel7ComparisonTotalDaysForRows(rows, periodKey){
        if (String(periodKey || '') !== 'all') {
          return getLevel7ComparisonDaysForPeriod(periodKey);
        }
        return (Array.isArray(rows) ? rows : []).reduce(function(total, row){
          return total + getLevel7ComparisonDaysForPeriod(getLevel7ComparisonPeriodKeyForRow(row));
        }, 0);
      }

      function renderLevel7ComparisonHeader(shortLabel, fullLabel, subLabel, className){
        var classes = 'level7-compare-header';
        if (className) classes += ' ' + className;
        return ''
          + '<span class="' + escapeHtml(classes) + '" title="' + escapeHtml(fullLabel) + '">'
          +   '<span class="level7-compare-headerMain">' + escapeHtml(shortLabel) + '</span>'
          +   (subLabel ? '<span class="level7-compare-headerSub">' + escapeHtml(subLabel) + '</span>' : '')
          + '</span>';
      }

      function renderLevel7ComparisonSummaryCard(label, value, meta){
        return ''
          + '<article class="level7-compare-summaryCard">'
          +   '<span class="level7-compare-summaryLabel">' + escapeHtml(label) + '</span>'
          +   '<strong class="level7-compare-summaryValue">' + escapeHtml(value) + '</strong>'
          +   (meta ? '<span class="level7-compare-summaryMeta">' + escapeHtml(meta) + '</span>' : '')
          + '</article>';
      }

      function calculateLevel7RevenuePerBookedHour(row){
        if (!row) return null;
        if (row.productionRate != null && isFinite(Number(row.productionRate))) {
          return Number(row.productionRate) || 0;
        }
        var serviceSales = Number(row.serviceSales) || 0;
        var hoursBooked = Number(row.hoursBooked) || 0;
        return hoursBooked > 0 ? serviceSales / hoursBooked : null;
      }

      function summarizeLevel7Period(rows){
        var safeRows = Array.isArray(rows) ? rows.filter(function(row){
          return !!row;
        }) : [];
        var totals = {
          staffCount: safeRows.length,
          serviceSales: 0,
          productSales: 0,
          appointments: 0,
          requestedAppointments: 0,
          hoursBooked: 0,
          hoursScheduled: 0,
          newClients: 0,
          returningClients: 0,
          tipSales: 0,
          weightedPrebookNumerator: 0,
          weightedPrebookDenominator: 0,
          weightedSelfBookedNumerator: 0,
          weightedSelfBookedDenominator: 0,
          reliabilityTotal: 0,
          reliabilityCount: 0,
          utilizationValues: [],
          retailRateValues: [],
          productionValues: []
        };
        safeRows.forEach(function(row){
          var appointmentCount = Number(row.appointmentCount) || 0;
          var hoursScheduled = Number(row.hoursScheduled) || 0;
          var hoursBooked = Number(row.hoursBooked) || 0;
          var serviceSales = Number(row.serviceSales) || 0;
          var productSales = Number(row.productSales) || 0;
          var retailRate = row.retailToServiceRate != null ? Number(row.retailToServiceRate) || 0 : null;
          var productionRate = calculateLevel7RevenuePerBookedHour(row);
          totals.serviceSales += serviceSales;
          totals.productSales += productSales;
          totals.appointments += appointmentCount;
          totals.requestedAppointments += Number(row.requestedAppointmentCount) || 0;
          totals.hoursBooked += hoursBooked;
          totals.hoursScheduled += hoursScheduled;
          totals.newClients += Number(row.newClientCount) || 0;
          totals.returningClients += Number(row.returningClientCount) || 0;
          totals.tipSales += Number(row.tipSales) || 0;
          totals.weightedPrebookNumerator += (Number(row.prebookedRate) || 0) * appointmentCount;
          totals.weightedPrebookDenominator += appointmentCount;
          totals.weightedSelfBookedNumerator += (Number(row.selfBookedRate) || 0) * appointmentCount;
          totals.weightedSelfBookedDenominator += appointmentCount;
          if (row.reliabilityScore != null && row.reliabilityScore !== '' && isFinite(Number(row.reliabilityScore))) {
            totals.reliabilityTotal += Number(row.reliabilityScore) || 0;
            totals.reliabilityCount += 1;
          }
          if (hoursScheduled > 0) {
            totals.utilizationValues.push(hoursBooked / hoursScheduled);
          }
          if (retailRate != null && isFinite(retailRate)) {
            totals.retailRateValues.push(retailRate);
          }
          if (productionRate != null && isFinite(productionRate)) {
            totals.productionValues.push(productionRate);
          }
        });
        return {
          staffCount: totals.staffCount,
          serviceSales: totals.serviceSales,
          productSales: totals.productSales,
          appointmentCount: totals.appointments,
          requestedAppointmentCount: totals.requestedAppointments,
          hoursBooked: totals.hoursBooked,
          hoursScheduled: totals.hoursScheduled,
          utilizationRate: totals.hoursScheduled > 0 ? totals.hoursBooked / totals.hoursScheduled : null,
          prebookedRate: totals.weightedPrebookDenominator > 0 ? totals.weightedPrebookNumerator / totals.weightedPrebookDenominator : null,
          selfBookedRate: totals.weightedSelfBookedDenominator > 0 ? totals.weightedSelfBookedNumerator / totals.weightedSelfBookedDenominator : null,
          revenuePerBookedHour: totals.hoursBooked > 0 ? totals.serviceSales / totals.hoursBooked : null,
          retailToServiceRate: totals.serviceSales > 0 ? totals.productSales / totals.serviceSales : null,
          newClientCount: totals.newClients,
          returningClientCount: totals.returningClients,
          tipSales: totals.tipSales,
          avgReliability: totals.reliabilityCount ? totals.reliabilityTotal / totals.reliabilityCount : null
        };
      }

      function formatLevel7MetricDelta(currentValue, previousValue, metricLabel){
        if (!isFinite(Number(currentValue)) || !isFinite(Number(previousValue))) return 'No comparison yet';
        var current = Number(currentValue) || 0;
        var previous = Number(previousValue) || 0;
        if (metricLabel === 'Service Sales' || metricLabel === 'Product Sales' || metricLabel === 'Appointment Count' || metricLabel === 'Hours Booked' || metricLabel === 'Hours Scheduled') {
          if (!previous) {
            return current ? 'New vs prior period' : 'Flat vs prior period';
          }
          var change = ((current - previous) / Math.abs(previous)) * 100;
          var prefix = change > 0 ? '+' : '';
          return prefix + change.toFixed(1) + '% vs prior period';
        }
        var delta = current - previous;
        var sign = delta > 0 ? '+' : '';
        return sign + formatNumericCell(metricLabel, String(delta)) + ' vs prior period';
      }

      function buildLevel7StrengthOpportunityLists(summary, previousSummary){
        var strengths = [];
        var opportunities = [];
        if (summary.utilizationRate != null) {
          strengths.push({
            label: 'Utilization',
            value: formatNumericCell('Utilization %', String(summary.utilizationRate)),
            note: summary.utilizationRate >= 0.8 ? 'Booked hours are being used efficiently.' : 'There is still room to tighten schedule usage.'
          });
        }
        if (summary.prebookedRate != null) {
          (summary.prebookedRate >= 0.65 ? strengths : opportunities).push({
            label: 'Prebooking',
            value: formatNumericCell('Prebooked %', String(summary.prebookedRate)),
            note: summary.prebookedRate >= 0.65 ? 'Future demand coverage is healthy.' : 'Demand is leaving without the next visit secured.'
          });
        }
        if (summary.retailToServiceRate != null) {
          (summary.retailToServiceRate >= 0.08 ? strengths : opportunities).push({
            label: 'Retail to Service',
            value: formatNumericCell('Retail to Service %', String(summary.retailToServiceRate)),
            note: summary.retailToServiceRate >= 0.08 ? 'Retail is supporting service revenue.' : 'Service demand is outpacing take-home conversion.'
          });
        }
        if (summary.avgReliability != null) {
          (summary.avgReliability >= 95 ? strengths : opportunities).push({
            label: 'Reliability',
            value: String(Math.round(summary.avgReliability)),
            note: summary.avgReliability >= 95 ? 'Attendance drag is limited.' : 'Reliability is costing usable demand.'
          });
        }
        if (previousSummary && previousSummary.serviceSales != null && summary.serviceSales != null) {
          var salesDelta = previousSummary.serviceSales
            ? ((summary.serviceSales - previousSummary.serviceSales) / Math.abs(previousSummary.serviceSales)) * 100
            : 0;
          (salesDelta >= 0 ? strengths : opportunities).push({
            label: 'Service sales trend',
            value: (salesDelta > 0 ? '+' : '') + salesDelta.toFixed(1) + '%',
            note: salesDelta >= 0 ? 'Team revenue is ahead of the previous comparable window.' : 'Revenue has slipped versus the prior comparable window.'
          });
        }
        return {
          strengths: strengths.slice(0, 3),
          opportunities: opportunities.slice(0, 3)
        };
      }

      function renderLevel7TakeawayList(title, items, tone){
        var safeItems = Array.isArray(items) ? items : [];
        return ''
          + '<article class="level7-compare-takeawayCard' + (tone ? ' is-' + tone : '') + '">'
          +   '<div class="level7-compare-takeawayTitle">' + escapeHtml(title) + '</div>'
          +   '<div class="level7-compare-takeawayList">'
          +     safeItems.map(function(item){
                  return ''
                    + '<div class="level7-compare-takeawayItem">'
                    +   '<strong>' + escapeHtml(item.label + ': ' + item.value) + '</strong>'
                    +   '<span>' + escapeHtml(item.note) + '</span>'
                    + '</div>';
                }).join('')
          +   '</div>'
          + '</article>';
      }

      function renderLevel7ComparisonSummary(period, previousPeriod){
        var rows = period && Array.isArray(period.rows) ? period.rows : [];
        if (!rows.length) return '';
        var summary = summarizeLevel7Period(rows);
        var previousSummary = previousPeriod ? summarizeLevel7Period(previousPeriod.rows) : null;
        var rowsWithSales = rows.filter(function(row){
          return row && row.serviceSales != null && isFinite(Number(row.serviceSales));
        });
        var topPerformer = rowsWithSales.slice().sort(function(left, right){
          return (Number(right.serviceSales) || 0) - (Number(left.serviceSales) || 0);
        })[0] || null;
        var takeaways = buildLevel7StrengthOpportunityLists(summary, previousSummary);
        return ''
          + '<section class="level7-compare-overview">'
          +   '<div class="level7-compare-overviewIntro">'
          +     '<div>'
          +       '<p class="eyebrow">Executive Overview</p>'
          +       '<h3>How the team is doing in ' + escapeHtml(period && period.label ? period.label : 'this view') + '</h3>'
          +       '<p>Current salon-wide read built from the live Staff Level KPI rows in this window, using rates where raw totals would be misleading.</p>'
          +     '</div>'
          +     '<div class="level7-compare-overviewMeta">' + escapeHtml(previousSummary ? 'Compared with the previous comparable period when available.' : 'Historical comparison becomes richer as more saved periods are available.') + '</div>'
          +   '</div>'
          +   '<div class="level7-compare-summaryGrid">'
          +     renderLevel7ComparisonSummaryCard('Service Sales', formatNumericCell('Service Sales', String(summary.serviceSales || 0)), previousSummary ? formatLevel7MetricDelta(summary.serviceSales, previousSummary.serviceSales, 'Service Sales') : 'Combined in this view')
          +     renderLevel7ComparisonSummaryCard('Product Sales', formatNumericCell('Product Sales', String(summary.productSales || 0)), previousSummary ? formatLevel7MetricDelta(summary.productSales, previousSummary.productSales, 'Product Sales') : 'Combined in this view')
          +     renderLevel7ComparisonSummaryCard('Utilization', summary.utilizationRate == null ? 'N/A' : formatNumericCell('Utilization %', String(summary.utilizationRate)), summary.hoursScheduled > 0 ? formatNumericCell('Hours Scheduled', String(summary.hoursScheduled)) + ' scheduled hours' : 'No scheduled hours')
          +     renderLevel7ComparisonSummaryCard('Prebooked', summary.prebookedRate == null ? 'N/A' : formatNumericCell('Prebooked %', String(summary.prebookedRate)), String(summary.appointmentCount || 0) + ' appointments')
          +     renderLevel7ComparisonSummaryCard('Revenue / Booked Hr', summary.revenuePerBookedHour == null ? 'N/A' : formatNumericCell('Production Rate', String(summary.revenuePerBookedHour)), summary.hoursBooked > 0 ? formatNumericCell('Hours Booked', String(summary.hoursBooked)) + ' booked hours' : 'No booked hours')
          +     renderLevel7ComparisonSummaryCard('Clients', String((summary.newClientCount || 0) + (summary.returningClientCount || 0)), String(summary.newClientCount || 0) + ' new • ' + String(summary.returningClientCount || 0) + ' returning')
          +     renderLevel7ComparisonSummaryCard('Avg Reliability', summary.avgReliability == null ? 'N/A' : String(Math.round(summary.avgReliability)), summary.avgReliability == null ? 'No attendance history' : 'Across staff with attendance history')
          +     renderLevel7ComparisonSummaryCard('Top Service Sales', topPerformer ? topPerformer.staffName : 'N/A', topPerformer ? formatNumericCell('Service Sales', String(topPerformer.serviceSales || 0)) : 'No KPI row')
          +   '</div>'
          +   '<div class="level7-compare-takeawayGrid">'
          +     renderLevel7TakeawayList('Strongest results', takeaways.strengths.length ? takeaways.strengths : [{ label: 'Coverage', value: 'Building', note: 'More comparable history is needed for a stronger read.' }], 'positive')
          +     renderLevel7TakeawayList('Biggest opportunities', takeaways.opportunities.length ? takeaways.opportunities : [{ label: 'Coverage', value: 'Limited', note: 'No major gap surfaced in this filtered view yet.' }], 'caution')
          +   '</div>'
          + '</section>';
      }

      function getLevel7PreviousRowForPeriod(staffName, periodKey, dataset){
        var rows = ((dataset && dataset.byStaff && dataset.byStaff[staffName]) || []).slice();
        if (!rows.length) return null;
        if (String(periodKey || '') === 'all') {
          return rows.length > 1 ? rows[rows.length - 2] : null;
        }
        var normalizedKey = String(periodKey || '').trim();
        if (normalizedKey === '2026_ytd') {
          return rows.filter(function(row){
            return !row.isYtd;
          }).slice(-1)[0] || null;
        }
        var targetYear = Number(normalizedKey) || 0;
        return rows.find(function(row){
          return Number(row.year) === targetYear - 1;
        }) || null;
      }

      function buildLevel7TrendLabel(row, previousRow){
        if (!row) return 'No comparison yet';
        if (row.isYtd && row.projectedServiceSales != null && previousRow && previousRow.serviceSales != null) {
          var projected = Number(row.projectedServiceSales) || 0;
          var previous = Number(previousRow.serviceSales) || 0;
          if (!previous) return 'Run rate building';
          var delta = ((projected - previous) / Math.abs(previous)) * 100;
          return (delta > 0 ? '+' : '') + delta.toFixed(1) + '% run rate';
        }
        if (!previousRow || previousRow.serviceSales == null || row.serviceSales == null) return 'No comparison yet';
        var current = Number(row.serviceSales) || 0;
        var previousValue = Number(previousRow.serviceSales) || 0;
        if (!previousValue) return current ? 'New vs prior year' : 'Flat vs prior year';
        var ratio = ((current - previousValue) / Math.abs(previousValue)) * 100;
        return (ratio > 0 ? '+' : '') + ratio.toFixed(1) + '% YoY';
      }

      function categorizeLevel7Performance(row, benchmarks){
        var wins = 0;
        var misses = 0;
        var metricsChecked = 0;
        [
          ['utilizationRate', benchmarks.utilizationRate],
          ['prebookedRate', benchmarks.prebookedRate],
          ['retailToServiceRate', benchmarks.retailToServiceRate],
          ['revenuePerBookedHour', benchmarks.revenuePerBookedHour],
          ['reliabilityScore', benchmarks.reliabilityScore]
        ].forEach(function(entry){
          var key = entry[0];
          var benchmark = entry[1];
          var value = key === 'revenuePerBookedHour'
            ? calculateLevel7RevenuePerBookedHour(row)
            : Number(row && row[key]);
          if (!isFinite(Number(value)) || !isFinite(Number(benchmark))) return;
          metricsChecked += 1;
          if (Number(value) >= Number(benchmark)) {
            wins += 1;
          } else {
            misses += 1;
          }
        });
        if (!metricsChecked) return 'Stable';
        if (wins >= 4 && Number(row && row.serviceSales) >= Number(benchmarks.serviceSales || 0)) return 'Leading';
        if (wins >= 3) return 'Strong';
        if (misses >= 4) return 'Needs attention';
        if (misses >= 2) return 'Opportunity';
        return 'Stable';
      }

      function identifyLevel7PrimaryOpportunity(row, benchmarks){
        var candidates = [];
        var revenuePerBookedHour = calculateLevel7RevenuePerBookedHour(row);
        if (isFinite(Number(row && row.utilizationRate)) && isFinite(Number(benchmarks.utilizationRate)) && Number(row.utilizationRate) < Number(benchmarks.utilizationRate)) {
          candidates.push({
            label: 'Use more scheduled hours',
            gap: Number(benchmarks.utilizationRate) - Number(row.utilizationRate)
          });
        }
        if (isFinite(Number(row && row.prebookedRate)) && isFinite(Number(benchmarks.prebookedRate)) && Number(row.prebookedRate) < Number(benchmarks.prebookedRate)) {
          candidates.push({
            label: 'Close more visits with a next booking',
            gap: Number(benchmarks.prebookedRate) - Number(row.prebookedRate)
          });
        }
        if (isFinite(Number(row && row.retailToServiceRate)) && isFinite(Number(benchmarks.retailToServiceRate)) && Number(row.retailToServiceRate) < Number(benchmarks.retailToServiceRate)) {
          candidates.push({
            label: 'Convert more service demand into retail',
            gap: Number(benchmarks.retailToServiceRate) - Number(row.retailToServiceRate)
          });
        }
        if (isFinite(Number(revenuePerBookedHour)) && isFinite(Number(benchmarks.revenuePerBookedHour)) && Number(revenuePerBookedHour) < Number(benchmarks.revenuePerBookedHour)) {
          candidates.push({
            label: 'Lift revenue per booked hour',
            gap: Number(benchmarks.revenuePerBookedHour) - Number(revenuePerBookedHour)
          });
        }
        if (isFinite(Number(row && row.reliabilityScore)) && isFinite(Number(benchmarks.reliabilityScore)) && Number(row.reliabilityScore) < Number(benchmarks.reliabilityScore)) {
          candidates.push({
            label: 'Reduce attendance drag',
            gap: Number(benchmarks.reliabilityScore) - Number(row.reliabilityScore)
          });
        }
        candidates.sort(function(left, right){
          return (Number(right.gap) || 0) - (Number(left.gap) || 0);
        });
        return candidates.length ? candidates[0].label : 'Protect current pace';
      }

      function buildLevel7Benchmarks(rows){
        var summary = summarizeLevel7Period(rows);
        return {
          serviceSales: rows.length ? summary.serviceSales / rows.length : 0,
          utilizationRate: summary.utilizationRate,
          prebookedRate: summary.prebookedRate,
          retailToServiceRate: summary.retailToServiceRate,
          revenuePerBookedHour: summary.revenuePerBookedHour,
          reliabilityScore: summary.avgReliability
        };
      }

      function renderLevel7CategoryBadge(category){
        var normalized = String(category || 'Stable').trim();
        var tone = normalized.toLowerCase().replace(/\s+/g, '-');
        return '<span class="level7-compare-categoryBadge is-' + escapeHtml(tone) + '">' + escapeHtml(normalized) + '</span>';
      }

      function averageLevel7Metric(rows, accessor){
        var values = (Array.isArray(rows) ? rows : []).map(function(row){
          return accessor(row);
        }).filter(function(value){
          return isFinite(Number(value));
        });
        if (!values.length) return null;
        return values.reduce(function(total, value){
          return total + (Number(value) || 0);
        }, 0) / values.length;
      }

      function buildLevel7StaffAnalysisModel(staffName){
        var dataset = buildLevel7ComparisonDataset(staffGrowthDataset);
        if (!dataset || dataset.issue) return null;
        var period = buildLevel7ComparisonPeriod(dataset, getLevel7ComparisonPeriodMeta(level7ComparisonActivePeriod).key);
        var row = (period.rows || []).find(function(item){
          return item && item.staffName === staffName;
        }) || null;
        if (!row) return null;
        var previousRow = getLevel7PreviousRowForPeriod(staffName, period.key, staffGrowthDataset);
        var sameLevelPeers = (period.rows || []).filter(function(item){
          return item && item.staffName !== staffName && item.levelKey === row.levelKey;
        });
        var comparisonPeers = sameLevelPeers.length ? sameLevelPeers : (period.rows || []).filter(function(item){
          return item && item.staffName !== staffName;
        });
        var comparisonRows = comparisonPeers.length ? comparisonPeers : (period.rows || []);
        var teamSummary = summarizeLevel7Period(period.rows || []);
        var peerBenchmarks = {
          serviceSales: averageLevel7Metric(comparisonRows, function(item){ return Number(item && item.serviceSales); }),
          utilizationRate: averageLevel7Metric(comparisonRows, function(item){ return Number(item && item.utilizationRate); }),
          prebookedRate: averageLevel7Metric(comparisonRows, function(item){ return Number(item && item.prebookedRate); }),
          retailToServiceRate: averageLevel7Metric(comparisonRows, function(item){ return Number(item && item.retailToServiceRate); }),
          revenuePerBookedHour: averageLevel7Metric(comparisonRows, calculateLevel7RevenuePerBookedHour),
          reliabilityScore: averageLevel7Metric(comparisonRows, function(item){ return Number(item && item.reliabilityScore); })
        };
        var currentRevenuePerHour = calculateLevel7RevenuePerBookedHour(row);
        var targetUtilization = Math.max(Number(peerBenchmarks.utilizationRate) || 0, Number(teamSummary.utilizationRate) || 0);
        var targetRetailRate = Math.max(Number(peerBenchmarks.retailToServiceRate) || 0, Number(teamSummary.retailToServiceRate) || 0);
        var utilizationUpside = currentRevenuePerHour != null && row.hoursScheduled != null && row.utilizationRate != null
          ? Math.max(0, targetUtilization - (Number(row.utilizationRate) || 0)) * (Number(row.hoursScheduled) || 0) * (Number(currentRevenuePerHour) || 0)
          : 0;
        var retailUpside = row.serviceSales != null && row.retailToServiceRate != null
          ? Math.max(0, targetRetailRate - (Number(row.retailToServiceRate) || 0)) * (Number(row.serviceSales) || 0)
          : 0;
        var opportunity = identifyLevel7PrimaryOpportunity(row, peerBenchmarks);
        var category = categorizeLevel7Performance(row, peerBenchmarks);
        var strengths = [
          {
            label: 'Revenue / Booked Hr',
            metricLabel: 'Production Rate',
            value: currentRevenuePerHour,
            benchmark: peerBenchmarks.revenuePerBookedHour
          },
          {
            label: 'Utilization',
            metricLabel: 'Utilization %',
            value: row.utilizationRate,
            benchmark: peerBenchmarks.utilizationRate
          },
          {
            label: 'Prebooked',
            metricLabel: 'Prebooked %',
            value: row.prebookedRate,
            benchmark: peerBenchmarks.prebookedRate
          },
          {
            label: 'Retail to Service',
            metricLabel: 'Retail to Service %',
            value: row.retailToServiceRate,
            benchmark: peerBenchmarks.retailToServiceRate
          },
          {
            label: 'Reliability',
            metricLabel: 'Utilization %',
            value: row.reliabilityScore,
            benchmark: peerBenchmarks.reliabilityScore
          }
        ].filter(function(item){
          return isFinite(Number(item.value)) && isFinite(Number(item.benchmark)) && Number(item.benchmark) !== 0;
        }).sort(function(left, right){
          return ((Number(right.value) || 0) / Math.abs(Number(right.benchmark) || 1)) - ((Number(left.value) || 0) / Math.abs(Number(left.benchmark) || 1));
        });
        var strongestMetric = strengths.length ? strengths[0] : null;
        var coaching = [];
        if (opportunity === 'Use more scheduled hours') {
          coaching.push('Tighten booking density on underused shifts and track whether additional booked hours hold at the current revenue-per-hour pace.');
          coaching.push('Pair demand-building with schedule edits first so open time is consolidated instead of spread thin.');
        } else if (opportunity === 'Close more visits with a next booking') {
          coaching.push('Coach a consistent checkout script so more guests leave with the next visit already secured.');
          coaching.push('Review missed prebook moments by service type and role-play the close on the most common misses.');
        } else if (opportunity === 'Convert more service demand into retail') {
          coaching.push('Audit the consultation-to-homecare handoff and set a simple one-product recommendation standard per qualifying guest.');
          coaching.push('Use highest-volume services as the first retail coaching target before expanding to every visit type.');
        } else if (opportunity === 'Lift revenue per booked hour') {
          coaching.push('Review pricing mix, timing, and upgrade behavior to raise dollars captured from already-booked demand.');
          coaching.push('Focus on menu mix and add-on attachment before adding more hours to the schedule.');
        } else if (opportunity === 'Reduce attendance drag') {
          coaching.push('Review the attendance formula directly with the staff member so the exact point loss is visible and understood.');
          coaching.push('Set a short-term reliability target and monitor each new request off, callout, late arrival, and early leave immediately.');
        } else {
          coaching.push('Protect the strongest habits in this period and look for one controllable lift area rather than changing too much at once.');
        }
        if (utilizationUpside > 0) {
          coaching.push('If booked-hour utilization reaches the current peer pace, the modeled revenue upside is about ' + formatNumericCell('Service Sales', String(utilizationUpside)) + ' at this staff member’s current production rate.');
        } else if (retailUpside > 0) {
          coaching.push('If retail reaches the current peer pace, the modeled product-sales upside is about ' + formatNumericCell('Product Sales', String(retailUpside)) + '.');
        }
        return {
          period: period,
          row: row,
          previousRow: previousRow,
          teamSummary: teamSummary,
          peerBenchmarks: peerBenchmarks,
          category: category,
          opportunity: opportunity,
          strongestMetric: strongestMetric,
          utilizationUpside: utilizationUpside,
          retailUpside: retailUpside,
          coaching: coaching.slice(0, 3),
          comparisonRows: comparisonRows
        };
      }

      function renderLevel7AnalysisKpiCard(label, value, meta){
        return ''
          + '<article class="staff-growth-analysisKpiCard">'
          +   '<div class="staff-growth-analysisKpiLabel">' + escapeHtml(label) + '</div>'
          +   '<strong class="staff-growth-analysisKpiValue">' + escapeHtml(value) + '</strong>'
          +   (meta ? '<div class="staff-growth-analysisKpiMeta">' + escapeHtml(meta) + '</div>' : '')
          + '</article>';
      }

      function renderLevel7AnalysisComparisonBar(label, metricLabel, currentValue, benchmarkValue, benchmarkLabel){
        if (!isFinite(Number(currentValue)) || !isFinite(Number(benchmarkValue))) return '';
        var current = Number(currentValue) || 0;
        var benchmark = Number(benchmarkValue) || 0;
        var maxValue = Math.max(Math.abs(current), Math.abs(benchmark), 0.0001);
        var currentWidth = Math.max(8, Math.min(100, (Math.abs(current) / maxValue) * 100));
        var benchmarkWidth = Math.max(8, Math.min(100, (Math.abs(benchmark) / maxValue) * 100));
        return ''
          + '<article class="staff-growth-analysisCompareCard">'
          +   '<div class="staff-growth-analysisCompareHead">'
          +     '<strong>' + escapeHtml(label) + '</strong>'
          +     '<span>' + escapeHtml(formatNumericCell(metricLabel, String(current)) + ' vs ' + benchmarkLabel + ' ' + formatNumericCell(metricLabel, String(benchmark))) + '</span>'
          +   '</div>'
          +   '<div class="staff-growth-analysisCompareTrack">'
          +     '<div class="staff-growth-analysisCompareBar is-current" style="width:' + currentWidth.toFixed(1) + '%"></div>'
          +   '</div>'
          +   '<div class="staff-growth-analysisCompareTrack is-benchmark">'
          +     '<div class="staff-growth-analysisCompareBar is-benchmark" style="width:' + benchmarkWidth.toFixed(1) + '%"></div>'
          +   '</div>'
          + '</article>';
      }

      function renderLevel7AnalysisNarrativeCard(title, body, tone){
        return ''
          + '<article class="staff-growth-analysisNarrativeCard' + (tone ? ' is-' + tone : '') + '">'
          +   '<div class="staff-growth-analysisNarrativeTitle">' + escapeHtml(title) + '</div>'
          +   '<p>' + escapeHtml(body) + '</p>'
          + '</article>';
      }

      function renderLevel7AnalysisRecommendations(items){
        var safeItems = Array.isArray(items) ? items : [];
        return ''
          + '<div class="staff-growth-analysisRecommendations">'
          +   safeItems.map(function(item){
                return '<div class="staff-growth-analysisRecommendation">' + escapeHtml(item) + '</div>';
              }).join('')
          + '</div>';
      }

      function calculateLevel7ReliabilityScore(callOuts, lateArrivals, leavingEarly, requestsOff){
        var normalizedCallOuts = Math.max(0, Number(callOuts) || 0);
        var normalizedLateArrivals = Math.max(0, Number(lateArrivals) || 0);
        var normalizedLeavingEarly = Math.max(0, Number(leavingEarly) || 0);
        var normalizedRequestsOff = Math.max(0, Number(requestsOff) || 0);
        var chargeableCallOuts = Math.max(0, normalizedCallOuts - 5);
        var calloutCredit = Math.max(0, 5 - normalizedCallOuts);
        var requestsOffDeduction = normalizedRequestsOff * 0.5;
        var weightedIncidents = chargeableCallOuts * 10
          + normalizedLateArrivals * 0.5
          + normalizedLeavingEarly * 0.5
          + requestsOffDeduction;
        return Math.min(100, Math.max(0, Math.round((100 - weightedIncidents + calloutCredit) * 10) / 10));
      }

      function getLevel7ReliabilityBreakdown(callOuts, lateArrivals, leavingEarly, requestsOff){
        var normalizedCallOuts = Math.max(0, Number(callOuts) || 0);
        var normalizedLateArrivals = Math.max(0, Number(lateArrivals) || 0);
        var normalizedLeavingEarly = Math.max(0, Number(leavingEarly) || 0);
        var normalizedRequestsOff = Math.max(0, Number(requestsOff) || 0);
        var chargeableCallOuts = Math.max(0, normalizedCallOuts - 5);
        var calloutCredit = Math.max(0, 5 - normalizedCallOuts);
        var calloutDeduction = chargeableCallOuts * 10;
        var lateDeduction = normalizedLateArrivals * 0.5;
        var leavingEarlyDeduction = normalizedLeavingEarly * 0.5;
        var requestsOffDeduction = normalizedRequestsOff * 0.5;
        return {
          score: calculateLevel7ReliabilityScore(normalizedCallOuts, normalizedLateArrivals, normalizedLeavingEarly, normalizedRequestsOff),
          callOuts: normalizedCallOuts,
          lateArrivals: normalizedLateArrivals,
          leavingEarly: normalizedLeavingEarly,
          requestsOff: normalizedRequestsOff,
          chargeableCallOuts: chargeableCallOuts,
          calloutCredit: calloutCredit,
          calloutDeduction: calloutDeduction,
          lateDeduction: lateDeduction,
          leavingEarlyDeduction: leavingEarlyDeduction,
          requestsOffDeduction: requestsOffDeduction
        };
      }

      function formatLevel7ReliabilityImpactValue(value){
        var numeric = Number(value) || 0;
        if (Math.abs(numeric - Math.round(numeric)) < 0.001) return String(Math.round(numeric));
        return numeric.toFixed(1);
      }

      function formatLevel7ReliabilitySignedValue(value){
        var numeric = Number(value) || 0;
        return numeric > 0
          ? '+' + formatLevel7ReliabilityImpactValue(numeric)
          : formatLevel7ReliabilityImpactValue(numeric);
      }

      function renderLevel7ReliabilityLine(label, detail, value, tone){
        var lineTone = tone ? ' is-' + tone : '';
        return ''
          + '<div class="level7-compare-reliabilityLine' + lineTone + '">'
          +   '<span class="level7-compare-reliabilityLineLabel">' + escapeHtml(label) + '</span>'
          +   '<span class="level7-compare-reliabilityLineDetail">' + escapeHtml(detail) + '</span>'
          +   '<strong class="level7-compare-reliabilityLineValue">' + escapeHtml(formatLevel7ReliabilitySignedValue(value)) + '</strong>'
          + '</div>';
      }

      function renderLevel7ReliabilitySummary(breakdown){
        var summaryParts = [];
        var combinedLateLeftEarly = breakdown.lateArrivals + breakdown.leavingEarly;
        summaryParts.push(String(breakdown.calloutCredit) + ' of 5 yearly callout credits left');
        if (breakdown.chargeableCallOuts > 0) {
          summaryParts.push(String(breakdown.chargeableCallOuts) + ' callouts charged');
        }
        if (breakdown.requestsOff > 0) {
          summaryParts.push(String(breakdown.requestsOff) + ' requests off');
        }
        if (combinedLateLeftEarly > 0) {
          summaryParts.push(String(combinedLateLeftEarly) + ' late / left early');
        }
        if (
          breakdown.chargeableCallOuts === 0 &&
          breakdown.requestsOff === 0 &&
          combinedLateLeftEarly === 0
        ) {
          summaryParts.push('no deductions');
        }
        return summaryParts.join(' • ');
      }

      function renderLevel7ReliabilityCell(row){
        if (row == null || row.reliabilityScore == null || row.reliabilityScore === '') {
          return '<td class="level7-compare-cellNumeric">N/A</td>';
        }
        var breakdown = getLevel7ReliabilityBreakdown(row.callOuts, row.lateArrivals, row.leavingEarly, row.requestsOff);
        var combinedLateLeftEarly = breakdown.lateArrivals + breakdown.leavingEarly;
        var combinedLateLeftEarlyDeduction = breakdown.lateDeduction + breakdown.leavingEarlyDeduction;
        return ''
          + '<td class="level7-compare-reliabilityCell">'
          +   '<div class="level7-compare-reliabilityScoreWrap">'
          +     '<strong class="level7-compare-reliabilityScore">' + escapeHtml(String(breakdown.score)) + '</strong>'
          +   '</div>'
          +   '<details class="level7-compare-reliabilityDetails">'
          +     '<summary class="level7-compare-reliabilityToggle">How it\'s calculated</summary>'
          +     '<div class="level7-compare-reliabilityRule">We look back 365 days. Your first 5 callouts are free, and every unused free callout adds 1 point back.</div>'
          +     '<div class="level7-compare-reliabilityRule">Requests off and late / left early each subtract 0.5 per offense.</div>'
          +     '<div class="level7-compare-reliabilitySummary">' + escapeHtml(renderLevel7ReliabilitySummary(breakdown)) + '</div>'
          +     '<div class="level7-compare-reliabilityFormula">'
          +       renderLevel7ReliabilityLine('Total callouts', String(breakdown.callOuts), 0, 'neutral')
          +       renderLevel7ReliabilityLine('Free callouts left', String(breakdown.calloutCredit), 0, 'neutral')
          +       renderLevel7ReliabilityLine('Callouts over 5', String(breakdown.chargeableCallOuts) + ' × 10', -breakdown.calloutDeduction, breakdown.calloutDeduction ? 'minus' : 'neutral')
          +       renderLevel7ReliabilityLine('Requests off', String(breakdown.requestsOff) + ' × 0.5', -breakdown.requestsOffDeduction, breakdown.requestsOffDeduction ? 'minus' : 'neutral')
          +       renderLevel7ReliabilityLine('Late / Left Early', String(combinedLateLeftEarly) + ' × 0.5', -combinedLateLeftEarlyDeduction, combinedLateLeftEarlyDeduction ? 'minus' : 'neutral')
          +       renderLevel7ReliabilityLine('Callout credits', String(breakdown.calloutCredit) + ' unused from the yearly 5', breakdown.calloutCredit, breakdown.calloutCredit ? 'plus' : 'neutral')
          +     '</div>'
          +   '</details>'
          + '</td>';
      }

      function renderLevel7LoadingValue(){
        return '<span class="level7-compare-loadingValue"><span class="level7-compare-loadingDot" aria-hidden="true"></span>Loading</span>';
      }

      function renderLevel7StackCell(primaryLabel, primaryValue, secondaryLabel, secondaryValue, primaryMetricLabel, secondaryMetricLabel, options){
        var safeOptions = options && typeof options === 'object' ? options : {};
        var showLoading = safeOptions.loading === true;
        var primaryDisplay = primaryValue == null || primaryValue === ''
          ? (showLoading ? renderLevel7LoadingValue() : 'N/A')
          : escapeHtml(formatNumericCell(primaryMetricLabel, String(primaryValue)));
        var secondaryDisplay = secondaryValue == null || secondaryValue === ''
          ? (showLoading ? renderLevel7LoadingValue() : 'N/A')
          : escapeHtml(formatNumericCell(secondaryMetricLabel, String(secondaryValue)));
        return ''
          + '<td class="level7-compare-stackCell">'
          +   '<div class="level7-compare-stackValue">'
          +     '<span class="level7-compare-stackLabel">' + escapeHtml(primaryLabel) + '</span>'
          +     '<strong class="level7-compare-stackNumber">' + primaryDisplay + '</strong>'
          +   '</div>'
          +   '<div class="level7-compare-stackSubvalue">'
          +     '<span class="level7-compare-stackLabel">' + escapeHtml(secondaryLabel) + '</span>'
          +     '<span class="level7-compare-stackSubnumber">' + secondaryDisplay + '</span>'
          +   '</div>'
          + '</td>';
      }

      function buildLevel7AttendanceForPeriod(staffName, staffRows, periodKey){
        var rowsForPeriod = filterLevel7RowsForPeriod(staffRows, periodKey);
        if (String(periodKey || '') !== 'all') {
          var map = getLevel7AttendanceCoverageMap(periodKey);
          var direct = map[staffName] || null;
          if (direct) return direct;
          if (Object.keys(map).length && rowsForPeriod.length) {
            return {
              reliability_score: 100,
              requests_off: 0,
              call_outs: 0,
              late_arrivals: 0,
              leaving_early: 0
            };
          }
          return null;
        }
        return null;
      }

      function buildLevel7ComparisonPeriod(dataset, periodKey){
        var meta = getLevel7ComparisonPeriodMeta(periodKey);
        var activeLevel = getLevel7ComparisonActiveLevelMeta(dataset);
        var staffEntries = filterLevel7ComparisonEntriesByLevel(dataset && dataset.staffEntries, activeLevel.key);
        var supplementalMetrics = getLevel7SupplementalMetricsMap(periodKey);
        var supplementalLoading = isLevel7SupplementalMetricsLoading(periodKey) || !hasLevel7SupplementalMetricsLoaded(periodKey);
        var rows = staffEntries.map(function(entry){
          var staffName = entry.staffName;
          var staffRows = (dataset && dataset.byStaff && dataset.byStaff[staffName]) || [];
          var kpiRows = filterLevel7RowsForPeriod(staffRows, periodKey);
          var kpi = String(periodKey || '') === 'all'
            ? aggregateLevel7ComparisonRows(kpiRows)
            : (kpiRows[0] || null);
          var attendance = buildLevel7AttendanceForPeriod(staffName, staffRows, periodKey);
          var row = createEmptyLevel7ComparisonRow(staffName);
          row.levelLabel = entry.levelLabel || row.levelLabel;
          row.levelNumber = entry.levelNumber;
          row.levelKey = entry.levelKey;
          if (attendance) {
            row.reliabilityScore = attendance.reliability_score;
            row.requestsOff = attendance.requests_off;
            row.callOuts = attendance.call_outs;
            row.lateArrivals = attendance.late_arrivals;
            row.leavingEarly = attendance.leaving_early;
          }
          if (kpi) {
            row = Object.assign(row, kpi, {
              staffName: staffName,
              levelLabel: entry.levelLabel || row.levelLabel,
              levelNumber: entry.levelNumber,
              levelKey: entry.levelKey,
              hasKpiData: true
            });
          }
          var supplementalRow = findLevel7SupplementalMetricsForStaff(supplementalMetrics, staffName);
          if (supplementalRow) {
            row.attachRate = supplementalRow.attachRate;
            row.attachClosedAppointments = supplementalRow.attachClosedAppointments;
            row.colorDisciplineReweighRate = supplementalRow.colorDisciplineReweighRate;
            row.colorDisciplineServices = supplementalRow.colorDisciplineServices;
          }
          return row;
        }).sort(function(left, right){
          var leftSales = Number(left.serviceSales);
          var rightSales = Number(right.serviceSales);
          var leftHasSales = left.serviceSales != null && isFinite(leftSales);
          var rightHasSales = right.serviceSales != null && isFinite(rightSales);
          if (leftHasSales && rightHasSales && rightSales !== leftSales) return rightSales - leftSales;
          if (rightHasSales && !leftHasSales) return 1;
          if (leftHasSales && !rightHasSales) return -1;
          return left.staffName.localeCompare(right.staffName);
        });
          return {
            key: meta.key,
            year: meta.key,
            isYtd: meta.key === '2026_ytd',
            isAggregate: meta.key === 'all',
            supplementalLoading: supplementalLoading,
            label: meta.summaryLabel,
            description: meta.description,
            levelLabel: activeLevel.label,
            rows: rows
        };
      }

      function renderLevel7ComparisonTable(period){
        var rows = period && Array.isArray(period.rows) ? period.rows : [];
        if (!rows.length) {
          return '<div class="empty">No Staff Level KPI data is available for ' + escapeHtml(period && period.label ? period.label : 'that period') + '.</div>';
        }
        var snapshotUpdatedAt = staffGrowthDataset && staffGrowthDataset.snapshot && staffGrowthDataset.snapshot.updated_at
          ? formatRecaptureDateTime(staffGrowthDataset.snapshot.updated_at)
          : '';
        var snapshotCreatedAt = !snapshotUpdatedAt && staffGrowthDataset && staffGrowthDataset.snapshot && staffGrowthDataset.snapshot.created_at
          ? formatRecaptureDateTime(staffGrowthDataset.snapshot.created_at)
          : '';
        var snapshotMeta = snapshotUpdatedAt || snapshotCreatedAt
          ? 'Snapshot updated ' + String(snapshotUpdatedAt || snapshotCreatedAt)
          : (staffGrowthDataset && staffGrowthDataset.snapshot_source === 'live' ? 'Live report export' : '');
        var isYtd = !!(period && period.isYtd);
        var reliabilityHeader = renderLevel7ComparisonHeader('Rel', isYtd ? 'Reliability (365D)' : 'Reliability', isYtd ? '365D' : '');
        var attendanceWindowNote = '';
        if (period && period.isAggregate) {
          attendanceWindowNote = '<p class="staff-growth-hero-copy">Attendance is not combined in All years. Callouts, credits, and reliability reset by year, so switch to a single year to review attendance.</p>';
        } else if (isYtd) {
          attendanceWindowNote = '<p class="staff-growth-hero-copy">KPI columns are 2026 YTD through Wednesday, August 12, 2026. Attendance counts and reliability use the trailing 365-day window.</p>';
        }
        if (period && period.supplementalLoading) {
          attendanceWindowNote += '<p class="staff-growth-hero-copy"><span class="level7-compare-loadingValue"><span class="level7-compare-loadingDot" aria-hidden="true"></span>Attach and Color are still loading for this period.</span></p>';
        }
        return ''
          + '<div class="level7-compare-period">'
          +   '<div class="level7-compare-periodHead">'
          +     '<div><h2>' + escapeHtml(period.label) + '</h2><p>' + escapeHtml(period.description || '') + '</p>' + (snapshotMeta ? '<p class="staff-growth-hero-copy">' + escapeHtml(snapshotMeta) + '</p>' : '') + '</div>'
          +     '<span class="staff-growth-pill">' + escapeHtml(String(rows.length) + ' stylists · ' + String((period && period.levelLabel) || 'All levels')) + '</span>'
          +   '</div>'
          +   attendanceWindowNote
          +   '<div class="level7-compare-tableWrap">'
          +     '<table class="level7-compare-table">'
          +       '<thead><tr>'
          +         '<th>Stylist</th>'
          +         '<th>Service Sales</th>'
          +         '<th>Trend</th>'
          +         '<th>Demand</th>'
          +         '<th>Hours</th>'
          +         '<th>Revenue</th>'
          +         '<th>Booking</th>'
          +         '<th>Retail</th>'
          +         '<th>Attach</th>'
          +         '<th>Color</th>'
          +         '<th>Clients</th>'
          +         '<th class="level7-compare-col level7-compare-col--reliability">' + reliabilityHeader + '</th>'
          +       '</tr></thead>'
          +       '<tbody>'
          +         rows.map(function(row){
                    var previousRow = getLevel7PreviousRowForPeriod(row.staffName, period && period.key, staffGrowthDataset);
                    var trendLabel = buildLevel7TrendLabel(row, previousRow);
                    var revenuePerBookedHour = calculateLevel7RevenuePerBookedHour(row);
                    return ''
                        + '<tr>'
                        +   '<td class="level7-compare-staff"><div class="level7-compare-staffStatic"><span class="level7-compare-staffName">' + escapeHtml(row.staffName) + '</span><span class="level7-compare-staffMeta">' + escapeHtml(row.levelLabel || 'No level') + '</span></div>' + (row.hasKpiData ? '' : '<span class="level7-compare-note">No KPI row</span>') + '</td>'
                        +   '<td class="level7-compare-cellNumeric">' + escapeHtml(row.serviceSales != null ? formatNumericCell('Service Sales', String(row.serviceSales)) : 'N/A') + '</td>'
                        +   '<td class="level7-compare-trendCell">' + escapeHtml(trendLabel) + (row.isYtd && previousRow ? '<span class="level7-compare-trendMeta">Run rate vs ' + escapeHtml(String(previousRow.year)) + '</span>' : '') + '</td>'
                        +   renderLevel7StackCell('Appts', row.appointmentCount, 'Req', row.requestedAppointmentCount, 'Appointment Count', 'Appointment Count')
                        +   renderLevel7StackCell('Booked', row.hoursBooked, 'Sched', row.hoursScheduled, 'Hours Booked', 'Hours Scheduled')
                        +   renderLevel7StackCell('$/Hr', revenuePerBookedHour, 'Util', row.utilizationRate, 'Production Rate', 'Utilization %')
                        +   renderLevel7StackCell('Prebook', row.prebookedRate, 'Self', row.selfBookedRate, 'Prebooked %', 'Self-booked %')
                        +   renderLevel7StackCell('Product', row.productSales, 'R:S', row.retailToServiceRate, 'Product Sales', 'Retail to Service %')
                        +   renderLevel7StackCell('Attach', row.attachRate, 'Closed', row.attachClosedAppointments, 'Utilization %', 'Appointment Count', { loading: period && period.supplementalLoading })
                        +   renderLevel7StackCell('Reweigh', row.colorDisciplineReweighRate, 'Vish svcs', row.colorDisciplineServices, 'Utilization %', 'Service Count', { loading: period && period.supplementalLoading })
                        +   renderLevel7StackCell('New', row.newClientCount, 'Return', row.returningClientCount, 'New Client Count', 'Returning Client Count')
                        +   renderLevel7ReliabilityCell(row)
                        + '</tr>';
                    }).join('')
          +       '</tbody>'
          +     '</table>'
          +   '</div>'
          + '</div>';
      }

      function renderLevel7ComparisonPeriodTabs(activePeriodKey){
        return ''
          + '<div class="level7-compare-periodTabs">'
          +   LEVEL7_COMPARISON_PERIOD_OPTIONS.map(function(option){
                return ''
                  + '<button type="button" class="level7-compare-periodTab' + (option.key === activePeriodKey ? ' is-active' : '') + '" data-level7-period="' + escapeHtml(option.key) + '">'
                  +   escapeHtml(option.label)
                  + '</button>';
              }).join('')
          + '</div>';
      }

      function renderLevel7ComparisonLevelFilter(activeLevelKey, levelOptions){
        return ''
          + '<div class="controls">'
          +   '<div class="field">'
          +     '<label for="level7ComparisonLevelFilter">Level</label>'
          +     '<select id="level7ComparisonLevelFilter">'
          +       (Array.isArray(levelOptions) ? levelOptions : []).map(function(option){
                    var selected = option && option.key === activeLevelKey ? ' selected' : '';
                    return '<option value="' + escapeHtml(option.key) + '"' + selected + '>' + escapeHtml(option.label) + '</option>';
                  }).join('')
          +     '</select>'
          +   '</div>'
          + '</div>';
      }

      function renderLevel7ComparisonView(){
        if (!level7ComparisonMount) return;
        var dataset = buildLevel7ComparisonDataset(staffGrowthDataset);
        if (!dataset || dataset.issue) {
          level7ComparisonMount.className = 'empty';
          level7ComparisonMount.innerHTML = escapeHtml((dataset && dataset.issue) || 'No staff comparison data is available yet.');
          setLevel7ComparisonStatus((dataset && dataset.issue) || 'Staff level KPI view unavailable.', 'error');
          return;
        }
        var activeMeta = getLevel7ComparisonPeriodMeta(level7ComparisonActivePeriod);
        var activeLevel = getLevel7ComparisonActiveLevelMeta(dataset);
        ensureLevel7SupplementalMetrics(activeMeta.key);
        prefetchLevel7SupplementalMetrics(activeMeta.key);
        var period = buildLevel7ComparisonPeriod(dataset, activeMeta.key);
        level7ComparisonMount.className = 'level7-compare-layout';
        level7ComparisonMount.innerHTML = ''
          + renderLevel7ComparisonPeriodTabs(activeMeta.key)
          + renderLevel7ComparisonLevelFilter(activeLevel.key, dataset.levelOptions)
          + renderLevel7ComparisonTable(period);
        var levelFilter = document.getElementById('level7ComparisonLevelFilter');
        if (levelFilter) {
          levelFilter.addEventListener('change', function(){
            level7ComparisonActiveLevel = String(levelFilter.value || 'all');
            renderLevel7ComparisonView();
          });
        }
        Array.prototype.slice.call(level7ComparisonMount.querySelectorAll('[data-level7-period]')).forEach(function(button){
          button.addEventListener('click', function(){
            var periodKey = String(button.getAttribute('data-level7-period') || '').trim();
            if (!periodKey || periodKey === level7ComparisonActivePeriod) return;
            level7ComparisonActivePeriod = periodKey;
            renderLevel7ComparisonView();
          });
        });
        setLevel7ComparisonStatus(
          (period && period.supplementalLoading ? 'Loading attach and color for ' : 'Staff level KPI updated for ')
          + activeMeta.summaryLabel + ' (' + activeLevel.label + ').',
          period && period.supplementalLoading ? 'loading' : 'success'
        );
      }

      function buildAttendanceCoverageMapFromResponse(data){
        var maps = buildAttendanceMetricMaps(data);
        var names = {};
        [maps.reliabilityScoreByStaff, maps.requestsOffByStaff, maps.callOutsByStaff, maps.lateArrivalsByStaff].forEach(function(map){
          Object.keys(map || {}).forEach(function(name){
            if (name) names[name] = true;
          });
        });
        return Object.keys(names).reduce(function(result, name){
          result[name] = {
            reliability_score: Object.prototype.hasOwnProperty.call(maps.reliabilityScoreByStaff, name) ? maps.reliabilityScoreByStaff[name] : null,
            requests_off: Object.prototype.hasOwnProperty.call(maps.requestsOffByStaff, name) ? maps.requestsOffByStaff[name] : null,
            call_outs: Object.prototype.hasOwnProperty.call(maps.callOutsByStaff, name) ? maps.callOutsByStaff[name] : null,
            late_arrivals: Object.prototype.hasOwnProperty.call(maps.lateArrivalsByStaff, name) ? maps.lateArrivalsByStaff[name] : null
          };
          return result;
        }, {});
      }

      function buildDefaultAttendanceCoverageEntry(){
        return {
          reliability_score: 100,
          requests_off: 0,
          call_outs: 0,
          late_arrivals: 0,
          leaving_early: 0
        };
      }

      function hydrateLevel7AttendanceCoverageForComparisonStaff(dataset){
        var seedNames = {};
        Object.keys(levelByStaff || {}).forEach(function(staffName){
          var normalizedName = String(staffName || '').trim();
          if (normalizedName) seedNames[normalizedName] = true;
        });
        Object.keys((dataset && dataset.byStaff) || {}).forEach(function(staffName){
          var normalizedName = String(staffName || '').trim();
          if (normalizedName) seedNames[normalizedName] = true;
        });

        Object.keys(level7AttendanceComparison || {}).forEach(function(periodKey){
          var map = level7AttendanceComparison[periodKey];
          if (!map || typeof map !== 'object') {
            map = {};
            level7AttendanceComparison[periodKey] = map;
          }
          Object.keys(seedNames).forEach(function(staffName){
            if (Object.prototype.hasOwnProperty.call(map, staffName)) return;
            map[staffName] = buildDefaultAttendanceCoverageEntry();
          });
        });
      }

      async function fetchLevel7AttendanceSnapshotCoverage(snapshotDate, refreshIfMissing){
        var response = await fetch(REPORT_PROXY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'attendance-totals-snapshot-get',
            snapshot_key: 'attendance_ytd',
            snapshot_date: snapshotDate || '',
            refresh_if_missing: refreshIfMissing === true
          })
        });
        var rawText = await response.text();
        var data = null;
        try {
          data = rawText ? JSON.parse(rawText) : null;
        } catch (_error) {
          data = null;
        }
        if (!response.ok || !data || !data.ok) {
          throw new Error((data && data.error) || rawText || 'Could not load attendance YTD snapshot.');
        }
        return buildAttendanceCoverageMapFromResponse(data);
      }

      async function loadLevel7AttendanceComparison(){
        var todayKey = formatDateInputValue(startOfLocalDay(new Date()));
        var periodSnapshotDates = {
          '2021': '2021-12-31',
          '2022': '2022-12-31',
          '2023': '2023-12-31',
          '2024': '2024-12-31',
          '2025': '2025-12-31',
          '2026_ytd': todayKey
        };
        await Promise.all(Object.keys(periodSnapshotDates).map(async function(periodKey){
          try {
            level7AttendanceComparison[periodKey] = await fetchLevel7AttendanceSnapshotCoverage(
              periodSnapshotDates[periodKey],
              periodKey !== '2026_ytd'
            );
          } catch (_error) {
            if (periodKey === '2026_ytd') {
              level7AttendanceComparison[periodKey] = {};
            } else {
              level7AttendanceComparison[periodKey] = LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR[periodKey] || {};
            }
          }
        }));
      }

      function seedLevel7AttendanceComparisonDefaults(){
        var todayKey = formatDateInputValue(startOfLocalDay(new Date()));
        var fallbackMaps = {
          '2021': LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR['2021'] || {},
          '2022': LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR['2022'] || {},
          '2023': LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR['2023'] || {},
          '2024': LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR['2024'] || {},
          '2025': LEVEL7_ANNUAL_ATTENDANCE_BY_YEAR['2025'] || {},
          '2026_ytd': {}
        };
        Object.keys(fallbackMaps).forEach(function(periodKey){
          var source = fallbackMaps[periodKey];
          level7AttendanceComparison[periodKey] = source && typeof source === 'object'
            ? Object.assign({}, source)
            : {};
        });
        return todayKey;
      }

      function formatGrowthDelta(current, previous, kind){
        if (!isFinite(previous) || previous === 0) {
          if (!isFinite(current) || current === 0) return 'No change yet';
          return 'New vs prior year';
        }
        var ratio = ((current - previous) / Math.abs(previous)) * 100;
        var prefix = ratio > 0 ? '+' : '';
        var formatted = prefix + ratio.toFixed(1) + '% YoY';
        if (kind === 'rate') {
          return formatted + ' (' + formatNumericCell('Utilization %', String(current - previous)) + ' pts)';
        }
        return formatted;
      }

      function growthDeltaTone(current, previous){
        if (!isFinite(previous) || previous === 0 || current === previous) return '';
        return current > previous ? 'up' : 'down';
      }

      function buildStaffGrowthChartSvg(points, key, label){
        var values = points.map(function(point){ return Number(point[key]) || 0; });
        var max = Math.max.apply(null, values.concat([0]));
        var min = Math.min.apply(null, values.concat([0]));
        var range = max - min || 1;
        var width = 520;
        var height = 180;
        var padX = 28;
        var padY = 18;
        var usableWidth = width - padX * 2;
        var usableHeight = height - padY * 2;
        var path = values.map(function(value, index){
          var x = padX + (values.length === 1 ? usableWidth / 2 : (usableWidth * index / (values.length - 1)));
          var y = padY + usableHeight - (((value - min) / range) * usableHeight);
          return (index === 0 ? 'M' : 'L') + x.toFixed(2) + ' ' + y.toFixed(2);
        }).join(' ');
        var pointsMarkup = values.map(function(value, index){
          var x = padX + (values.length === 1 ? usableWidth / 2 : (usableWidth * index / (values.length - 1)));
          var y = padY + usableHeight - (((value - min) / range) * usableHeight);
          return '<circle cx="' + x.toFixed(2) + '" cy="' + y.toFixed(2) + '" r="4" fill="#e65a2c"></circle>'
            + '<text x="' + x.toFixed(2) + '" y="' + (height - 8) + '" text-anchor="middle" font-size="10" fill="#6f655d">' + escapeHtml(points[index].year) + '</text>';
        }).join('');
        return ''
          + '<svg class="staff-growth-chart-svg" viewBox="0 0 ' + width + ' ' + height + '" role="img" aria-label="' + escapeHtml(label) + ' trend chart">'
          +   '<line x1="' + padX + '" y1="' + (height - padY) + '" x2="' + (width - padX) + '" y2="' + (height - padY) + '" stroke="#d9cec0" stroke-width="1"></line>'
          +   '<path d="' + path + '" fill="none" stroke="#e65a2c" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>'
          +   pointsMarkup
          + '</svg>';
      }

      function buildStaffGrowthLineChartSvg(points, key, label){
        var values = points.map(function(point){ return Number(point[key]) || 0; });
        var max = Math.max.apply(null, values.concat([0]));
        var min = Math.min.apply(null, values.concat([0]));
        var range = max - min || 1;
        var width = 520;
        var height = 180;
        var padX = 28;
        var padY = 18;
        var usableWidth = width - padX * 2;
        var usableHeight = height - padY * 2;
        var coordinates = values.map(function(value, index){
          return {
            point: points[index],
            x: padX + (values.length === 1 ? usableWidth / 2 : (usableWidth * index / (values.length - 1))),
            y: padY + usableHeight - (((value - min) / range) * usableHeight)
          };
        });
        var solidPoints = coordinates.slice();
        var dashedTail = null;
        if (coordinates.length > 1 && coordinates[coordinates.length - 1] && coordinates[coordinates.length - 1].point && coordinates[coordinates.length - 1].point.isYtd) {
          dashedTail = coordinates.slice(-2);
          solidPoints = coordinates.slice(0, -1);
        }
        var solidPath = solidPoints.map(function(entry, index){
          return (index === 0 ? 'M' : 'L') + entry.x.toFixed(2) + ' ' + entry.y.toFixed(2);
        }).join(' ');
        var dashedPath = dashedTail ? dashedTail.map(function(entry, index){
          return (index === 0 ? 'M' : 'L') + entry.x.toFixed(2) + ' ' + entry.y.toFixed(2);
        }).join(' ') : '';
        var pointsMarkup = coordinates.map(function(entry){
          var isYtdPoint = !!(entry.point && entry.point.isYtd);
          return (isYtdPoint
            ? '<circle cx="' + entry.x.toFixed(2) + '" cy="' + entry.y.toFixed(2) + '" r="5" fill="#fffdf9" stroke="#e65a2c" stroke-width="2"></circle>'
            : '<circle cx="' + entry.x.toFixed(2) + '" cy="' + entry.y.toFixed(2) + '" r="4" fill="#e65a2c"></circle>')
            + '<text x="' + entry.x.toFixed(2) + '" y="' + (height - 8) + '" text-anchor="middle" font-size="10" fill="#6f655d">' + escapeHtml(entry.point.year + (isYtdPoint ? '*' : '')) + '</text>';
        }).join('');
        return ''
          + '<svg class="staff-growth-chart-svg" viewBox="0 0 ' + width + ' ' + height + '" role="img" aria-label="' + escapeHtml(label) + ' trend chart">'
          +   '<line x1="' + padX + '" y1="' + (height - padY) + '" x2="' + (width - padX) + '" y2="' + (height - padY) + '" stroke="#d9cec0" stroke-width="1"></line>'
          +   (solidPath ? '<path d="' + solidPath + '" fill="none" stroke="#e65a2c" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>' : '')
          +   (dashedPath ? '<path d="' + dashedPath + '" fill="none" stroke="#e65a2c" stroke-width="3" stroke-dasharray="7 6" stroke-linecap="round" stroke-linejoin="round"></path>' : '')
          +   pointsMarkup
          + '</svg>';
      }

      function buildStaffGrowthBarChartSvg(points, key, label, projectedKey){
        var width = 520;
        var height = 220;
        var padX = 28;
        var padTop = 18;
        var padBottom = 34;
        var plotHeight = height - padTop - padBottom;
        var values = points.map(function(point){
          var actual = Number(point && point[key]) || 0;
          var projected = projectedKey && point && point.isYtd ? Number(point[projectedKey]) || actual : actual;
          return Math.max(actual, projected);
        });
        var max = Math.max.apply(null, values.concat([0])) || 1;
        var slotWidth = (width - padX * 2) / Math.max(1, points.length);
        var barWidth = Math.min(30, Math.max(14, slotWidth * 0.52));
        return ''
          + '<svg class="staff-growth-chart-svg" viewBox="0 0 ' + width + ' ' + height + '" role="img" aria-label="' + escapeHtml(label) + ' bar chart">'
          +   '<line x1="' + padX + '" y1="' + (height - padBottom) + '" x2="' + (width - padX) + '" y2="' + (height - padBottom) + '" stroke="#d9cec0" stroke-width="1"></line>'
          +   points.map(function(point, index){
                var actual = Number(point && point[key]) || 0;
                var projected = projectedKey && point && point.isYtd ? Number(point[projectedKey]) || actual : actual;
                var x = padX + (slotWidth * index) + ((slotWidth - barWidth) / 2);
                var actualHeight = max > 0 ? (actual / max) * plotHeight : 0;
                var projectedHeight = max > 0 ? (projected / max) * plotHeight : 0;
                var actualY = height - padBottom - actualHeight;
                var projectedY = height - padBottom - projectedHeight;
                return ''
                  + (point && point.isYtd && projected > actual
                    ? '<rect x="' + x.toFixed(2) + '" y="' + projectedY.toFixed(2) + '" width="' + barWidth.toFixed(2) + '" height="' + projectedHeight.toFixed(2) + '" fill="#fff7ee" stroke="#e65a2c" stroke-width="2" stroke-dasharray="5 4" rx="8" ry="8"></rect>'
                    : '')
                  + '<rect x="' + x.toFixed(2) + '" y="' + actualY.toFixed(2) + '" width="' + barWidth.toFixed(2) + '" height="' + actualHeight.toFixed(2) + '" fill="' + (point && point.isYtd ? '#f2a57f' : '#e65a2c') + '" rx="8" ry="8"></rect>'
                  + '<text x="' + (x + (barWidth / 2)).toFixed(2) + '" y="' + (height - 10) + '" text-anchor="middle" font-size="10" fill="#6f655d">' + escapeHtml(point.year + (point && point.isYtd ? '*' : '')) + '</text>';
              }).join('')
          + '</svg>';
      }

      function renderStaffGrowthCard(label, current, previous, metricLabel, deltaOverride){
        var deltaText = deltaOverride || formatGrowthDelta(current, previous, metricLabel === 'Utilization %' || metricLabel === 'Prebooked %' || metricLabel === 'Self-booked %' ? 'rate' : 'value');
        var tone = growthDeltaTone(current, previous);
        return ''
          + '<div class="staff-growth-card">'
          +   '<div class="staff-growth-card-label">' + escapeHtml(label) + '</div>'
          +   '<div class="staff-growth-card-value">' + escapeHtml(formatNumericCell(metricLabel, String(current))) + '</div>'
          +   '<div class="staff-growth-card-delta"' + (tone ? ' data-tone="' + tone + '"' : '') + '>' + escapeHtml(deltaText) + '</div>'
          + '</div>';
      }

      function renderStaffGrowthChartCard(title, points, key, metricLabel){
        var latest = points[points.length - 1] || null;
        return ''
          + '<div class="staff-growth-chart-card">'
          +   '<div class="staff-growth-chart-head">'
          +     '<div class="staff-growth-chart-title">' + escapeHtml(title) + '</div>'
          +     '<div class="staff-growth-chart-meta">' + escapeHtml(latest ? formatNumericCell(metricLabel, String(latest[key])) : '') + '</div>'
          +   '</div>'
          +   buildStaffGrowthChartSvg(points, key, title)
          + '</div>';
      }

      var STAFF_GROWTH_ANALYSIS_METRICS = [
        { key: 'serviceSales', label: 'Service Sales', metricLabel: 'Service Sales', chartTitle: 'Service Sales by Year', family: 'value', chartKind: 'bar', projectedKey: 'projectedServiceSales' },
        { key: 'appointmentCount', label: 'Appointments', metricLabel: 'Appointment Count', chartTitle: 'Appointments by Year', family: 'value', chartKind: 'bar', projectedKey: 'projectedAppointmentCount' },
        { key: 'requestedAppointmentCount', label: 'Requested Appointments', metricLabel: 'Appointment Count', chartTitle: 'Requested Appointments by Year', family: 'value', chartKind: 'bar' },
        { key: 'hoursBooked', label: 'Hours Booked', metricLabel: 'Hours Booked', chartTitle: 'Hours Booked by Year', family: 'value', chartKind: 'bar', projectedKey: 'projectedHoursBooked' },
        { key: 'hoursScheduled', label: 'Hours Scheduled', metricLabel: 'Hours Scheduled', chartTitle: 'Hours Scheduled by Year', family: 'value', chartKind: 'bar', projectedKey: 'projectedHoursScheduled' },
        { key: 'productionRate', label: 'Production Rate', metricLabel: 'Production Rate', chartTitle: 'Production Rate Trend', family: 'value', chartKind: 'line' },
        { key: 'utilizationRate', label: 'Utilization', metricLabel: 'Utilization %', chartTitle: 'Utilization Trend', family: 'rate', chartKind: 'line' },
        { key: 'prebookedRate', label: 'Prebooked', metricLabel: 'Prebooked %', chartTitle: 'Prebooked Trend', family: 'rate', chartKind: 'line' },
        { key: 'selfBookedRate', label: 'Self-booked', metricLabel: 'Self-booked %', chartTitle: 'Self-booked Trend', family: 'rate', chartKind: 'line' },
        { key: 'productSales', label: 'Product Sales', metricLabel: 'Product Sales', chartTitle: 'Product Sales by Year', family: 'value', chartKind: 'bar' },
        { key: 'retailToServiceRate', label: 'Retail to Service', metricLabel: 'Retail to Service %', chartTitle: 'Retail to Service Trend', family: 'rate', chartKind: 'line' },
        { key: 'tipSales', label: 'Tip Sales', metricLabel: 'Tip Sales', chartTitle: 'Tip Sales by Year', family: 'value', chartKind: 'bar' },
        { key: 'newClientCount', label: 'New Clients', metricLabel: 'New Client Count', chartTitle: 'New Clients by Year', family: 'value', chartKind: 'bar' },
        { key: 'returningClientCount', label: 'Returning Clients', metricLabel: 'Returning Client Count', chartTitle: 'Returning Clients by Year', family: 'value', chartKind: 'bar' }
      ];

      function getStaffGrowthAnalysisRows(yearlyRows){
        return Array.isArray(yearlyRows) ? yearlyRows.slice() : [];
      }

      function getStaffGrowthMetricPoints(points, key){
        return (Array.isArray(points) ? points : []).map(function(point){
          return Number(point && point[key]) || 0;
        });
      }

      function buildStaffGrowthMetricInterpretation(points, metric){
        var safePoints = Array.isArray(points) ? points : [];
        if (!safePoints.length) return 'No history available yet.';
        var latest = safePoints[safePoints.length - 1] || null;
        var previous = safePoints.length > 1 ? safePoints[safePoints.length - 2] : null;
        var first = safePoints[0] || null;
        var latestValue = Number(latest && latest[metric.key]) || 0;
        var previousValue = Number(previous && previous[metric.key]) || 0;
        var firstValue = Number(first && first[metric.key]) || 0;
        var values = getStaffGrowthMetricPoints(safePoints, metric.key);
        var peakValue = Math.max.apply(null, values.concat([latestValue]));
        var peakIndex = values.indexOf(peakValue);
        var peakPoint = peakIndex >= 0 ? safePoints[peakIndex] : latest;
        var changeWord = latestValue > firstValue ? 'up' : latestValue < firstValue ? 'down' : 'flat';
        var overallText = first
          ? 'Full-history trend is ' + changeWord + ' from ' + formatNumericCell(metric.metricLabel, String(firstValue)) + ' in ' + first.year + ' to ' + formatNumericCell(metric.metricLabel, String(latestValue)) + ' in ' + latest.year + (latest && latest.isYtd ? ' YTD' : '') + '.'
          : '';
        var yoyText = previous
          ? (latest && latest.isYtd
              ? 'Latest point is partial-year through ' + (latest.ytdThroughLabel || 'the current date') + ', so compare it cautiously with the last full year of ' + previous.year + '.'
              : 'Latest move vs ' + previous.year + ' is ' + formatGrowthDelta(latestValue, previousValue, metric.family === 'rate' ? 'rate' : 'value') + '.')
          : 'This is the first recorded year in the current window.';
        var peakText = peakPoint
          ? 'Peak point in this view is ' + formatNumericCell(metric.metricLabel, String(peakValue)) + ' in ' + peakPoint.year + (peakPoint && peakPoint.isYtd ? ' YTD' : '') + '.'
          : '';
        var ytdProjectionText = latest && latest.isYtd && metric.projectedKey && isFinite(Number(latest[metric.projectedKey]))
          ? 'Current-year run rate projects ' + formatNumericCell(metric.metricLabel, String(latest[metric.projectedKey])) + ' if the pace holds through year end.'
          : '';
        return [overallText, yoyText, peakText, ytdProjectionText].filter(Boolean).join(' ');
      }

      function renderStaffGrowthAnalysisChartCard(metric, points){
        var latest = points[points.length - 1] || null;
        var metaText = latest ? formatNumericCell(metric.metricLabel, String(latest[metric.key] || 0)) : '';
        if (latest && latest.isYtd && metric.projectedKey && isFinite(Number(latest[metric.projectedKey]))) {
          metaText += ' actual · ' + formatNumericCell(metric.metricLabel, String(latest[metric.projectedKey])) + ' run rate';
        }
        return ''
          + '<article class="staff-growth-analysisChartCard">'
          +   '<div class="staff-growth-chart-head">'
          +     '<div class="staff-growth-chart-title">' + escapeHtml(metric.chartTitle) + '</div>'
          +     '<div class="staff-growth-chart-meta">' + escapeHtml(metaText) + '</div>'
          +   '</div>'
          +   (metric.chartKind === 'bar'
                ? buildStaffGrowthBarChartSvg(points, metric.key, metric.chartTitle, metric.projectedKey)
                : buildStaffGrowthLineChartSvg(points, metric.key, metric.chartTitle))
          +   (latest && latest.isYtd ? '<p class="staff-growth-analysisChartFootnote">* ' + escapeHtml(String(latest.year)) + ' is year-to-date through ' + escapeHtml(latest.ytdThroughLabel || 'the current date') + (metric.projectedKey && isFinite(Number(latest[metric.projectedKey])) ? '; dashed outline shows current-year run rate if pace holds.' : '.') + '</p>' : '')
          +   '<p class="staff-growth-analysisChartInsight">' + escapeHtml(buildStaffGrowthMetricInterpretation(points, metric)) + '</p>'
          + '</article>';
      }

      function renderStaffGrowthAnalysisOverviewCard(title, body){
        return ''
          + '<article class="staff-growth-analysisOverviewCard">'
          +   '<div class="staff-growth-analysisOverviewTitle">' + escapeHtml(title) + '</div>'
          +   '<p class="staff-growth-analysisOverviewBody">' + escapeHtml(body) + '</p>'
          + '</article>';
      }

      function buildStaffGrowthBusinessOverview(points){
        var safePoints = Array.isArray(points) ? points : [];
        if (!safePoints.length) return [];
        var latest = safePoints[safePoints.length - 1] || null;
        var previous = safePoints.length > 1 ? safePoints[safePoints.length - 2] : null;
        var first = safePoints[0] || null;
        var revenueBody = latest
          ? 'Service sales are at ' + formatNumericCell('Service Sales', String(latest.serviceSales || 0)) + ' with production at ' + formatNumericCell('Production Rate', String(latest.productionRate || 0)) + '.'
            + (previous ? ' Vs ' + previous.year + ': ' + formatGrowthDelta(Number(latest.serviceSales) || 0, Number(previous.serviceSales) || 0, 'value') + '.' : '')
          : 'No revenue history yet.';
        var demandBody = latest
          ? 'Appointments are at ' + formatNumericCell('Appointment Count', String(latest.appointmentCount || 0)) + ', with prebooked at ' + formatNumericCell('Prebooked %', String(latest.prebookedRate || 0)) + ' and self-booked at ' + formatNumericCell('Self-booked %', String(latest.selfBookedRate || 0)) + '.'
          : 'No demand history yet.';
        var clientBody = latest
          ? 'Client mix is ' + formatNumericCell('New Client Count', String(latest.newClientCount || 0)) + ' new and ' + formatNumericCell('Returning Client Count', String(latest.returningClientCount || 0)) + ' returning, with retail to service at ' + formatNumericCell('Retail to Service %', String(latest.retailToServiceRate || 0)) + '.'
          : 'No client mix history yet.';
        var runwayBody = latest && first
          ? 'This view runs from ' + first.year + ' to ' + latest.year + (latest && latest.isYtd ? ' YTD' : '') + ', so it uses the full KPI history currently available in the dashboard.'
          : 'No five-year window available.';
        return [
          { title: 'Revenue Read', body: revenueBody },
          { title: 'Demand Read', body: demandBody },
          { title: 'Client + Retail Read', body: clientBody },
          { title: 'Window', body: runwayBody }
        ];
      }

      function renderStaffGrowthAnalysisYearRow(row){
        return ''
          + '<div class="staff-growth-year-row staff-growth-year-row--analysis">'
          +   '<div class="staff-growth-year">' + escapeHtml(row.year + (row.isYtd ? ' YTD' : '')) + '</div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Service Sales</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Service Sales', String(row.serviceSales || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Appointments</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Appointment Count', String(row.appointmentCount || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Requested</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Appointment Count', String(row.requestedAppointmentCount || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Hours Booked</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Hours Booked', String(row.hoursBooked || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Hours Scheduled</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Hours Scheduled', String(row.hoursScheduled || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Production</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Production Rate', String(row.productionRate || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Utilization</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Utilization %', String(row.utilizationRate || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Prebooked</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Prebooked %', String(row.prebookedRate || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Self-booked</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Self-booked %', String(row.selfBookedRate || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Product Sales</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Product Sales', String(row.productSales || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Retail:Service</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Retail to Service %', String(row.retailToServiceRate || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Tips</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Tip Sales', String(row.tipSales || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">New Clients</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('New Client Count', String(row.newClientCount || 0))) + '</div></div>'
          +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Returning</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Returning Client Count', String(row.returningClientCount || 0))) + '</div></div>'
          + '</div>';
      }

      function ensureLevel7StaffAnalysisOverlay(){
        if (level7StaffAnalysisOverlay) return level7StaffAnalysisOverlay;
        level7StaffAnalysisOverlay = document.createElement('div');
        level7StaffAnalysisOverlay.className = 'staff-growth-analysisOverlay';
        level7StaffAnalysisOverlay.hidden = true;
        document.body.appendChild(level7StaffAnalysisOverlay);
        level7StaffAnalysisOverlay.addEventListener('click', function(event){
          if (event.target === level7StaffAnalysisOverlay || event.target.getAttribute('data-analysis-close') === 'true') {
            closeLevel7StaffAnalysisOverlay();
          }
        });
        document.addEventListener('keydown', function(event){
          if (event.key === 'Escape' && level7StaffAnalysisOverlay && !level7StaffAnalysisOverlay.hidden) {
            closeLevel7StaffAnalysisOverlay();
          }
        });
        return level7StaffAnalysisOverlay;
      }

      function closeLevel7StaffAnalysisOverlay(){
        if (!level7StaffAnalysisOverlay) return;
        level7StaffAnalysisOverlay.hidden = true;
        level7StaffAnalysisOverlay.innerHTML = '';
        document.body.classList.remove('staff-growth-analysisOpen');
      }

      function openLevel7StaffAnalysisOverlay(staffName){
        var normalizedName = String(staffName || '').trim();
        if (!normalizedName || !staffGrowthDataset || !staffGrowthDataset.byStaff || !staffGrowthDataset.byStaff[normalizedName]) return;
        if (staffGrowthStaff) {
          staffGrowthStaff.value = normalizedName;
          renderStaffGrowthView();
        }
        var overlay = ensureLevel7StaffAnalysisOverlay();
        var analysisRows = getStaffGrowthAnalysisRows(staffGrowthDataset.byStaff[normalizedName] || []);
        if (!analysisRows.length) return;
        var latest = analysisRows[analysisRows.length - 1] || null;
        var first = analysisRows[0] || null;
        var overviewCards = buildStaffGrowthBusinessOverview(analysisRows);
        var analysisModel = buildLevel7StaffAnalysisModel(normalizedName);
        var currentRow = analysisModel ? analysisModel.row : null;
        var previousRow = analysisModel ? analysisModel.previousRow : null;
        var benchmarkLabel = analysisModel && analysisModel.comparisonRows && analysisModel.comparisonRows.length
          ? (analysisModel.comparisonRows.every(function(item){ return item.levelKey === currentRow.levelKey; }) ? 'peer avg' : 'team avg')
          : 'team avg';
        var analysisNarratives = analysisModel ? [
          {
            title: 'Current read',
            body: analysisModel.category + ' right now. Primary opportunity: ' + analysisModel.opportunity + '.'
          },
          {
            title: 'Strongest metric',
            body: analysisModel.strongestMetric
              ? analysisModel.strongestMetric.label + ' is running ahead of the ' + benchmarkLabel + '.'
              : 'More comparison history is needed before a strongest metric can be called.'
          },
          {
            title: 'Estimated upside',
            body: analysisModel.utilizationUpside > 0
              ? 'Matching current benchmark utilization is worth roughly ' + formatNumericCell('Service Sales', String(analysisModel.utilizationUpside)) + ' at the current revenue-per-hour pace.'
              : analysisModel.retailUpside > 0
              ? 'Matching current benchmark retail pace is worth roughly ' + formatNumericCell('Product Sales', String(analysisModel.retailUpside)) + ' in product sales.'
              : 'No clean dollar upside model stands out beyond protecting the current pace.'
          }
        ] : [];
        overlay.innerHTML = ''
          + '<div class="staff-growth-analysisPanel" role="dialog" aria-modal="true" aria-label="' + escapeHtml(normalizedName + ' staff business analysis') + '">'
          +   '<div class="staff-growth-analysisHead">'
          +     '<div class="staff-growth-analysisTitle">'
          +       '<p class="eyebrow">Staff Business Analysis</p>'
          +       '<h2>' + escapeHtml(normalizedName) + '</h2>'
          +       '<p>' + escapeHtml('Current-period scorecard first, then full KPI history across every annual period currently available for this staff member, with YTD context through Wednesday, August 12, 2026.') + '</p>'
          +     '</div>'
          +     '<div class="staff-growth-analysisHeadActions">'
          +       '<span class="staff-growth-pill">' + escapeHtml(first.year + ' - ' + latest.year + (latest && latest.isYtd ? ' YTD' : '')) + '</span>'
          +       '<button type="button" class="staff-growth-analysisClose" data-analysis-close="true" aria-label="Close staff analysis">Close</button>'
          +     '</div>'
          +   '</div>'
          +   '<div class="staff-growth-analysisBody">'
          +     '<div class="staff-growth-analysisOverviewGrid">'
          +       overviewCards.map(function(card){
                    return renderStaffGrowthAnalysisOverviewCard(card.title, card.body);
                  }).join('')
          +     '</div>'
          +     '<div class="staff-growth-card-grid">'
          +       renderStaffGrowthCard('Service Sales' + (latest && latest.isYtd ? ' YTD' : ''), latest.serviceSales, analysisRows.length > 1 ? analysisRows[analysisRows.length - 2].serviceSales : 0, 'Service Sales', latest && latest.isYtd ? 'Partial year through ' + (latest.ytdThroughLabel || 'current date') : '')
          +       renderStaffGrowthCard('Appointments' + (latest && latest.isYtd ? ' YTD' : ''), latest.appointmentCount, analysisRows.length > 1 ? analysisRows[analysisRows.length - 2].appointmentCount : 0, 'Appointment Count', latest && latest.isYtd ? 'Partial year through ' + (latest.ytdThroughLabel || 'current date') : '')
          +       renderStaffGrowthCard('Production Rate' + (latest && latest.isYtd ? ' YTD' : ''), latest.productionRate, analysisRows.length > 1 ? analysisRows[analysisRows.length - 2].productionRate : 0, 'Production Rate', latest && latest.isYtd ? 'Partial year through ' + (latest.ytdThroughLabel || 'current date') : '')
          +       renderStaffGrowthCard('Retail to Service' + (latest && latest.isYtd ? ' YTD' : ''), latest.retailToServiceRate, analysisRows.length > 1 ? analysisRows[analysisRows.length - 2].retailToServiceRate : 0, 'Retail to Service %', latest && latest.isYtd ? 'Partial year through ' + (latest.ytdThroughLabel || 'current date') : '')
          +     '</div>'
          +     (analysisModel
                  ? '<div class="staff-growth-analysisKpiGrid">'
                  +   renderLevel7AnalysisKpiCard('Performance category', analysisModel.category, analysisModel.period.label + ' • ' + (currentRow.levelLabel || 'No level'))
                  +   renderLevel7AnalysisKpiCard('Primary opportunity', analysisModel.opportunity, previousRow ? 'Compared with ' + previousRow.year : 'Current period only')
                  +   renderLevel7AnalysisKpiCard('Service Sales', currentRow && currentRow.serviceSales != null ? formatNumericCell('Service Sales', String(currentRow.serviceSales)) : 'N/A', previousRow && previousRow.serviceSales != null ? formatLevel7MetricDelta(currentRow.serviceSales, previousRow.serviceSales, 'Service Sales') : 'No prior comparison')
                  +   renderLevel7AnalysisKpiCard('Revenue / Booked Hr', currentRow ? formatNumericCell('Production Rate', String(calculateLevel7RevenuePerBookedHour(currentRow) || 0)) : 'N/A', benchmarkLabel + ' ' + (analysisModel.peerBenchmarks.revenuePerBookedHour != null ? formatNumericCell('Production Rate', String(analysisModel.peerBenchmarks.revenuePerBookedHour)) : 'N/A'))
                  +   renderLevel7AnalysisKpiCard('Utilization', currentRow && currentRow.utilizationRate != null ? formatNumericCell('Utilization %', String(currentRow.utilizationRate)) : 'N/A', benchmarkLabel + ' ' + (analysisModel.peerBenchmarks.utilizationRate != null ? formatNumericCell('Utilization %', String(analysisModel.peerBenchmarks.utilizationRate)) : 'N/A'))
                  +   renderLevel7AnalysisKpiCard('Retail to Service', currentRow && currentRow.retailToServiceRate != null ? formatNumericCell('Retail to Service %', String(currentRow.retailToServiceRate)) : 'N/A', benchmarkLabel + ' ' + (analysisModel.peerBenchmarks.retailToServiceRate != null ? formatNumericCell('Retail to Service %', String(analysisModel.peerBenchmarks.retailToServiceRate)) : 'N/A'))
                  + '</div>'
                  + '<div class="staff-growth-analysisCompareGrid">'
                  +   renderLevel7AnalysisComparisonBar('Utilization', 'Utilization %', currentRow.utilizationRate, analysisModel.peerBenchmarks.utilizationRate, benchmarkLabel)
                  +   renderLevel7AnalysisComparisonBar('Revenue / Booked Hr', 'Production Rate', calculateLevel7RevenuePerBookedHour(currentRow), analysisModel.peerBenchmarks.revenuePerBookedHour, benchmarkLabel)
                  +   renderLevel7AnalysisComparisonBar('Prebooked', 'Prebooked %', currentRow.prebookedRate, analysisModel.peerBenchmarks.prebookedRate, benchmarkLabel)
                  +   renderLevel7AnalysisComparisonBar('Retail to Service', 'Retail to Service %', currentRow.retailToServiceRate, analysisModel.peerBenchmarks.retailToServiceRate, benchmarkLabel)
                  +   renderLevel7AnalysisComparisonBar('Reliability', 'Utilization %', currentRow.reliabilityScore, analysisModel.peerBenchmarks.reliabilityScore, benchmarkLabel)
                  + '</div>'
                  + '<div class="staff-growth-analysisNarrativeGrid">'
                  +   analysisNarratives.map(function(card){
                        return renderLevel7AnalysisNarrativeCard(card.title, card.body);
                      }).join('')
                  +   renderLevel7AnalysisNarrativeCard('Coaching next', 'Management should focus on actions that move the current period fastest without overreacting to one short-term fluctuation.', 'quiet')
                  + '</div>'
                  + '<div class="staff-growth-analysisSection">'
                  +   '<div class="staff-growth-analysisSectionHead"><h3>Management priorities</h3><p>Constructive next actions based on current KPI, benchmark gaps, and available historical context.</p></div>'
                  +   renderLevel7AnalysisRecommendations(analysisModel.coaching)
                  + '</div>'
                  + '<div class="staff-growth-analysisSection">'
                  +   '<div class="staff-growth-analysisSectionHead"><h3>Methodology and data limits</h3><p>Directly available here: service sales, product sales, appointments, requested appointments, booked hours, scheduled hours, utilization, revenue per booked hour, prebooked %, self-booked %, new clients, returning clients, retail-to-service %, tips, level/role, and annual attendance snapshots. Calculated here: benchmark comparisons, performance category, revenue upside from utilization, and retail upside from benchmark gaps. Not determined from this Staff KPI layer alone: true client retention, cancellation/no-show rates, compensation structure, exact shift-level capacity by daypart, and color usage waste by staff.</p></div>'
                  + '</div>'
                  : '')
          +     '<div class="staff-growth-analysisChartGrid">'
          +       STAFF_GROWTH_ANALYSIS_METRICS.map(function(metric){
                    return renderStaffGrowthAnalysisChartCard(metric, analysisRows);
                  }).join('')
          +     '</div>'
          +     '<div class="staff-growth-analysisYearGrid">'
          +       analysisRows.slice().reverse().map(renderStaffGrowthAnalysisYearRow).join('')
          +     '</div>'
          +   '</div>'
          + '</div>';
        overlay.hidden = false;
        document.body.classList.add('staff-growth-analysisOpen');
      }

      function populateStaffGrowthSelector(dataset){
        if (!staffGrowthStaff) return;
        var staffNames = dataset && Array.isArray(dataset.staffNames) ? dataset.staffNames : [];
        staffGrowthStaff.innerHTML = staffNames.length
          ? staffNames.map(function(staffName){
              return '<option value="' + escapeHtml(staffName) + '">' + escapeHtml(staffName) + '</option>';
            }).join('')
          : '<option value="">No staff growth data found</option>';
      }

      function renderStaffGrowthView(){
        if (!staffGrowthMount) return;
        if (staffGrowthDataset && staffGrowthDataset.issue) {
          staffGrowthMount.className = 'empty';
          staffGrowthMount.innerHTML = escapeHtml(staffGrowthDataset.issue);
          return;
        }
        if (!staffGrowthDataset || !staffGrowthDataset.staffNames || !staffGrowthDataset.staffNames.length) {
          staffGrowthMount.className = 'empty';
          staffGrowthMount.innerHTML = 'No KPI Staff rows are available for staff growth history.';
          return;
        }

        var selectedStaff = String((staffGrowthStaff && staffGrowthStaff.value) || '').trim();
        if (!selectedStaff || !staffGrowthDataset.byStaff[selectedStaff]) {
          selectedStaff = staffGrowthDataset.staffNames[0] || '';
          if (staffGrowthStaff) {
            staffGrowthStaff.value = selectedStaff;
          }
        }

        var yearlyRows = (staffGrowthDataset.byStaff[selectedStaff] || []).slice();
        if (!yearlyRows.length) {
          staffGrowthMount.className = 'empty';
          staffGrowthMount.innerHTML = 'No KPI Staff history is available for that staff member yet.';
          return;
        }

        var latest = yearlyRows[yearlyRows.length - 1];
        var previous = yearlyRows[yearlyRows.length - 2] || null;
        var currentHeadline = latest && latest.isYtd
          ? latest.year + ' current YTD through ' + (latest.ytdThroughLabel || '')
          : latest.year + ' full year';
        var currentDeltaText = latest && latest.isYtd
          ? 'Current YTD snapshot'
          : '';

        staffGrowthMount.className = 'staff-growth-layout';
        staffGrowthMount.innerHTML = ''
          + '<div class="staff-growth-hero">'
          +   '<div class="staff-growth-hero-head">'
          +     '<div class="staff-growth-hero-title">'
          +       '<h2>' + escapeHtml(selectedStaff) + '</h2>'
          +       '<p class="staff-growth-hero-copy">Current year-to-date KPI view first, followed by historical yearly trends from KPI Staff.</p>'
          +     '</div>'
          +     '<span class="staff-growth-pill">' + escapeHtml(yearlyRows[0].year + ' - ' + latest.year + (latest && latest.isYtd ? ' YTD' : '')) + '</span>'
          +   '</div>'
          +   '<p class="staff-growth-hero-copy">' + escapeHtml(currentHeadline) + '</p>'
          +   '<div class="staff-growth-card-grid">'
          +     renderStaffGrowthCard('Service Sales' + (latest && latest.isYtd ? ' YTD' : ''), latest.serviceSales, previous ? previous.serviceSales : 0, 'Service Sales', currentDeltaText)
          +     renderStaffGrowthCard('Appointments' + (latest && latest.isYtd ? ' YTD' : ''), latest.appointmentCount, previous ? previous.appointmentCount : 0, 'Appointment Count', currentDeltaText)
          +     renderStaffGrowthCard('Hours Booked' + (latest && latest.isYtd ? ' YTD' : ''), latest.hoursBooked, previous ? previous.hoursBooked : 0, 'Hours Booked', currentDeltaText)
          +     renderStaffGrowthCard('Hours Scheduled' + (latest && latest.isYtd ? ' YTD' : ''), latest.hoursScheduled, previous ? previous.hoursScheduled : 0, 'Hours Scheduled', currentDeltaText)
          +     renderStaffGrowthCard('Production Rate' + (latest && latest.isYtd ? ' YTD' : ''), latest.productionRate, previous ? previous.productionRate : 0, 'Production Rate', currentDeltaText)
          +     renderStaffGrowthCard('Utilization' + (latest && latest.isYtd ? ' YTD' : ''), latest.utilizationRate, previous ? previous.utilizationRate : 0, 'Utilization %', currentDeltaText)
          +     renderStaffGrowthCard('Prebooked' + (latest && latest.isYtd ? ' YTD' : ''), latest.prebookedRate, previous ? previous.prebookedRate : 0, 'Prebooked %', currentDeltaText)
          +   '</div>'
          +   (latest && latest.isYtd && latest.ytdThroughLabel ? '<p class="staff-growth-hero-copy">YTD values are shown as current actuals through ' + escapeHtml(latest.ytdThroughLabel) + '.</p>' : '')
          + '</div>'
          + '<div class="staff-growth-chart-grid">'
          +   renderStaffGrowthChartCard('Service Sales Trend', yearlyRows, 'serviceSales', 'Service Sales')
          +   renderStaffGrowthChartCard('Appointment Trend', yearlyRows, 'appointmentCount', 'Appointment Count')
          +   renderStaffGrowthChartCard('Hours Booked Trend', yearlyRows, 'hoursBooked', 'Hours Booked')
          +   renderStaffGrowthChartCard('Production Rate Trend', yearlyRows, 'productionRate', 'Production Rate')
          + '</div>'
          + '<div class="staff-growth-year-grid">'
          +   yearlyRows.slice().reverse().map(function(row){
                return ''
                  + '<div class="staff-growth-year-row">'
                  +   '<div class="staff-growth-year">' + escapeHtml(row.year + (row.isYtd ? ' YTD' : '')) + '</div>'
                  +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Service Sales</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Service Sales', String(row.serviceSales))) + '</div></div>'
                  +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Appointments</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Appointment Count', String(row.appointmentCount))) + '</div></div>'
                  +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Hours Booked</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Hours Booked', String(row.hoursBooked))) + '</div></div>'
                  +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Hours Scheduled</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Hours Scheduled', String(row.hoursScheduled))) + '</div></div>'
                  +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Production Rate</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Production Rate', String(row.productionRate))) + '</div></div>'
                  +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Utilization</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Utilization %', String(row.utilizationRate))) + '</div></div>'
                  +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Prebooked</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Prebooked %', String(row.prebookedRate))) + '</div></div>'
                  +   '<div class="staff-growth-year-metric"><div class="staff-growth-year-label">Product Sales</div><div class="staff-growth-year-value">' + escapeHtml(formatNumericCell('Product Sales', String(row.productSales))) + '</div></div>'
                  + '</div>';
              }).join('')
          + '</div>';
      }

      async function loadStaffGrowth(){
        if (!staffGrowthMount) return;
        try {
          setStaffGrowthStatus('Pulling KPI Staff full-history snapshots...');
          setLevel7ComparisonStatus('Loading staff comparison. Historical attendance is syncing in the background...');
          staffGrowthMount.className = 'empty';
          staffGrowthMount.innerHTML = 'Pulling KPI Staff data across all available years...';
          seedLevel7AttendanceComparisonDefaults();
          var results = await Promise.all([
            fetchStaffGrowthRows(),
            fetchStaffDirectoryInfo()
          ]);
          var result = results[0];
          var staffDirectoryInfo = results[1] || {};
          Object.keys(staffDirectoryInfo).forEach(function(staffName){
            var item = staffDirectoryInfo[staffName] || {};
            if (item.role && !levelByStaff[staffName]) {
              levelByStaff[staffName] = item.role;
            }
            if (item.avatar && !avatarByStaff[staffName]) {
              avatarByStaff[staffName] = item.avatar;
            }
          });
          staffGrowthDataset = buildStaffGrowthDataset(result.headers, result.rows, result.directoryStaff, {
            snapshot: result.snapshot || null,
            snapshot_source: result.snapshot_source || ''
          });
          hydrateLevel7AttendanceCoverageForComparisonStaff(staffGrowthDataset);
          populateStaffGrowthSelector(staffGrowthDataset);
          renderStaffGrowthView();
          renderLevel7ComparisonView();
          if (latestStaffKpiHeaders.length && latestStaffKpiRows.length) {
            renderKpiTable(latestStaffKpiHeaders, latestStaffKpiRows);
          }
          if (staffGrowthDataset && staffGrowthDataset.issue) {
            setStaffGrowthStatus('Staff growth loaded, but the export does not include Staff Name.', 'error');
          } else {
            setStaffGrowthStatus('Staff growth updated across all available years.', 'success');
          }
          hasLoadedStaffGrowth = true;
          loadLevel7AttendanceComparison().then(function(){
            if (!staffGrowthDataset) return;
            hydrateLevel7AttendanceCoverageForComparisonStaff(staffGrowthDataset);
            renderLevel7ComparisonView();
            setLevel7ComparisonStatus('Staff comparison updated with saved attendance history.', 'success');
          }).catch(function(){
          });
        } catch (error) {
          var message = humanizeDashboardErrorMessage(error && error.message ? error.message : 'Could not load staff growth.');
          setStaffGrowthStatus(message, 'error');
          staffGrowthMount.className = 'empty';
          staffGrowthMount.innerHTML = escapeHtml(message);
          if (level7ComparisonMount) {
            level7ComparisonMount.className = 'empty';
            level7ComparisonMount.innerHTML = escapeHtml(message);
          }
          setLevel7ComparisonStatus(message, 'error');
        }
      }

      function ensureStaffGrowthLoaded(){
        if (!hasLoadedStaffGrowth) {
          loadStaffGrowth();
        }
      }

      function escapeHtml(value){
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function updateStats(dataset, leaderboard, mode){
        if (mode === 'call_outs') {
          renderCallOutsTable(Array.isArray(leaderboard) ? leaderboard : []);
          return;
        }

        renderMergedTable(Array.isArray(leaderboard) ? leaderboard : []);
      }

      async function run(){
        try {
          var kpiFilterConfig = buildKpiReportFilters();
          setStatus('Loading saved attendance and KPI snapshots...');
          tableMount.className = 'empty';
          tableMount.innerHTML = 'Loading saved attendance snapshot...';
          kpiTableMount.className = 'empty';
          kpiTableMount.innerHTML = canFetchKpiForSelectedRange(kpiFilterConfig)
            ? 'Loading saved staff KPI snapshot...'
            : 'Choose one of the saved snapshot windows.';
          renderDebug({ loading: true });
          var attendancePromise = fetchAttendanceTotals();
          var staffDirectoryPromise = fetchStaffDirectoryInfo();
          var kpiPromise = canFetchKpiForSelectedRange(kpiFilterConfig)
            ? fetchStaffKpiSnapshotOrLive()
            : Promise.resolve(null);

          var baseResults = await Promise.all([
            attendancePromise,
            staffDirectoryPromise
          ]);
          var remote = baseResults[0];
          var staffDirectoryInfo = baseResults[1] || {};
          var rawKpi = null;
          var kpiError = null;

          if (canFetchKpiForSelectedRange(kpiFilterConfig)) {
            var kpiResult = await Promise.allSettled([kpiPromise]);
            if (kpiResult[0] && kpiResult[0].status === 'fulfilled') {
              rawKpi = kpiResult[0].value;
            } else if (kpiResult[0] && kpiResult[0].status === 'rejected') {
              kpiError = kpiResult[0].reason;
            }
          }

          applyAttendanceMetricMaps(remote);
          levelByStaff = {};
          avatarByStaff = {};
          Object.keys(staffDirectoryInfo).forEach(function(staffName){
            var item = staffDirectoryInfo[staffName] || {};
            if (item.role) {
              levelByStaff[staffName] = item.role;
            }
            if (item.avatar) {
              avatarByStaff[staffName] = item.avatar;
            }
          });
          if (Array.isArray(rawKpi && rawKpi.rows)) {
            rawKpi.rows.forEach(function(row){
              var staffName = String((row && row['Staff Name']) || '').trim();
              var roleName = extractLevelFromRecord(row);
              if (staffName && roleName && !levelByStaff[staffName]) {
                levelByStaff[staffName] = roleName;
              }
            });
          }
          if (remote && remote.debug && remote.debug.normalized_rows) {
            ['call_outs', 'late_arrivals', 'requests_off', 'kpi_for_stylists'].forEach(function(key){
              var rows = remote.debug.normalized_rows[key];
              if (!Array.isArray(rows)) return;
              rows.forEach(function(row){
                var staffName = String((row && row.staff_name) || '').trim();
                var roleName = extractLevelFromRecord(row);
                if (staffName && roleName && !levelByStaff[staffName]) {
                  levelByStaff[staffName] = roleName;
                }
              });
            });
          }
          if (remote && remote.debug && remote.debug.raw_rows) {
            ['call_outs', 'late_arrivals', 'requests_off', 'kpi_for_stylists'].forEach(function(key){
              var rows = remote.debug.raw_rows[key];
              if (!Array.isArray(rows)) return;
              rows.forEach(function(row){
                var staffName = String((row && (row.staff_name || row['Staff Name'] || row['staff name'])) || '').trim();
                var roleName = extractLevelFromRecord(row);
                if (staffName && roleName && !levelByStaff[staffName]) {
                  levelByStaff[staffName] = roleName;
                }
              });
            });
          }
          var callOutsData = remote && remote.debug && remote.debug.leaderboards
            ? remote.debug.leaderboards.call_outs
            : null;
          var hasMergedRows = Array.isArray(remote && remote.leaderboard) && remote.leaderboard.length > 0;
          var hasCallOutRows = !!(callOutsData && Array.isArray(callOutsData.leaderboard) && callOutsData.leaderboard.length > 0);
          var hasKpiRows = !!(rawKpi && Array.isArray(rawKpi.rows) && rawKpi.rows.length > 0);
          latestStaffKpiHeaders = hasKpiRows ? rawKpi.headers.slice() : [];
          latestStaffKpiRows = hasKpiRows ? rawKpi.rows.slice() : [];

          if (hasMergedRows) {
            updateStats(remote, remote.leaderboard, 'merged');
          } else if (hasCallOutRows) {
            updateStats(callOutsData, callOutsData.leaderboard, 'call_outs');
          } else {
            updateStats(remote, [], 'merged');
          }

          if (canFetchKpiForSelectedRange(kpiFilterConfig) && !kpiError) {
            renderKpiTable(hasKpiRows ? rawKpi.headers : [], hasKpiRows ? rawKpi.rows : []);
          } else if (canFetchKpiForSelectedRange(kpiFilterConfig) && kpiError) {
            kpiTableMount.className = 'empty';
            kpiTableMount.innerHTML = escapeHtml(humanizeDashboardErrorMessage(
              kpiError && kpiError.message
                ? kpiError.message
                : 'Staff KPI snapshot is unavailable. Attendance totals are ready.'
            ));
          } else {
            kpiTableMount.className = 'empty';
            kpiTableMount.innerHTML = 'Choose one of the saved snapshot windows to load staff KPI.';
          }

          var attendanceStatusPrefix = remote && remote.snapshot_source === 'saved'
            ? 'Attendance totals updated from daily snapshot.'
            : 'Attendance totals updated.';
          var kpiStatusSuffix = rawKpi && rawKpi.snapshot_source === 'saved'
            ? ' Staff KPI updated from daily snapshot.'
            : hasKpiRows
            ? ' Staff KPI updated.'
            : '';
          if (!canFetchKpiForSelectedRange(kpiFilterConfig)) {
            setStatus(attendanceStatusPrefix + ' Staff KPI is only available for saved snapshot windows.');
          } else if (kpiError) {
            setStatus(attendanceStatusPrefix + ' ' + humanizeDashboardErrorMessage(
              kpiError && kpiError.message ? kpiError.message : 'Staff KPI snapshot is unavailable.'
            ));
          } else if (!hasMergedRows && hasCallOutRows) {
            setStatus(
              remote && remote.snapshot_source === 'saved'
                ? (hasKpiRows ? 'Call-out totals updated from daily snapshot.' + kpiStatusSuffix : 'Call-out totals updated from daily snapshot.')
                : (hasKpiRows ? 'Call-out totals updated.' + kpiStatusSuffix : 'Call-out totals updated.')
            );
          } else {
            setStatus(attendanceStatusPrefix + kpiStatusSuffix);
          }
          renderDebug({
            filters: remote.filters || {},
            warning: remote.warning || '',
            filter_mode: remote.filter_mode || '',
            exports: remote.exports || {},
            merged_totals: {
              rows_analyzed: remote.rows_analyzed || 0,
              staff_ranked: remote.staff_ranked || 0,
              total_call_outs: remote.total_call_outs || 0,
              total_late_arrivals: remote.total_late_arrivals || 0,
              total_leaving_early: remote.total_leaving_early || 0,
              total_requests_off: remote.total_requests_off || 0,
              total_events: remote.total_events || 0,
              location_count: remote.location_count || 0
            },
            call_outs: remote.debug && remote.debug.leaderboards ? remote.debug.leaderboards.call_outs : null,
            requests_off: remote.debug && remote.debug.leaderboards ? remote.debug.leaderboards.requests_off : null,
            kpi_for_stylists: {
              period_mode: rawKpi && rawKpi.filterConfig ? rawKpi.filterConfig.mode : '',
              requested_report_filters: rawKpi && rawKpi.filterConfig ? rawKpi.filterConfig.report_filters : [],
              warning: rawKpi && rawKpi.filterConfig ? rawKpi.filterConfig.warning || '' : '',
              error: kpiError && kpiError.message ? kpiError.message : '',
              export: rawKpi ? rawKpi.exportInfo : null,
              headers: rawKpi ? rawKpi.headers : [],
              rows: rawKpi ? rawKpi.rows : [],
              raw_rows: rawKpi ? rawKpi.rows : []
            },
            normalized_rows: remote.debug ? remote.debug.normalized_rows : null,
            raw_rows: remote.debug ? remote.debug.raw_rows : null,
            merged_leaderboard: remote.leaderboard || []
          });
        } catch (error) {
          reliabilityScoreByStaff = {};
          requestsOffByStaff = {};
          callOutsByStaff = {};
          lateArrivalsByStaff = {};
          levelByStaff = {};
          avatarByStaff = {};
          var friendlyErrorMessage = humanizeDashboardErrorMessage(error && error.message ? error.message : 'Could not build totals.');
          setStatus(friendlyErrorMessage);
          tableMount.className = 'empty';
          tableMount.innerHTML = escapeHtml(friendlyErrorMessage);
          kpiTableMount.className = 'empty';
          kpiTableMount.innerHTML = escapeHtml(friendlyErrorMessage);
          renderDebug({
            error: friendlyErrorMessage
          });
        } finally {
        }
      }
      if (pinSubmitBtn) {
        pinSubmitBtn.addEventListener('click', unlockWithPin);
      }
      if (pinInput) {
        pinInput.addEventListener('keydown', function(event){
          if (event && event.key === 'Enter') {
            event.preventDefault();
            unlockWithPin();
          }
        });
      }
      bindIdleTracking();
      syncBonusWindowModeUi();
      renderBonusWeightMix();
      document.body.classList.add('pin-locked');
      try {
        if (window.localStorage.getItem(STAFF_OPERATIONS_PIN_STORAGE_KEY) === '1') {
          var hasValidatedStoredSession = await validateRestoredStaffOpsSession();
          if (hasValidatedStoredSession) {
            finishStaffOpsUnlock();
          } else if (pinInput) {
            pinInput.focus();
          }
        } else if (restoreSharedManagerAccessSession()) {
          var hasValidatedSharedSession = await validateRestoredStaffOpsSession();
          if (!hasValidatedSharedSession) {
            if (pinInput) {
              pinInput.focus();
            }
            return;
          }
          try {
            window.localStorage.setItem(STAFF_OPERATIONS_PIN_STORAGE_KEY, '1');
          } catch (_error) {
          }
          persistStaffOpsAccessSession();
          if (currentProgressionEditor && currentProgressionEditorPermission) {
            persistProgressionEditorSession();
          }
          finishStaffOpsUnlock();
        } else if (pinInput) {
          pinInput.focus();
        }
      } catch (_error) {
        if (pinInput) {
          pinInput.focus();
        }
      }
    })();
  
